webpackJsonp([4],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(1559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(110);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Line */],
  mixins: [reactiveProp],
  mounted: function mounted() {
    if (this.chartData) {
      this.renderChart(this.chartData, {
        scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        scaleFontColor: '#999',
        scaleFontStyle: '600',
        tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        tooltipCornerRadius: 3,
        maintainAspectRatio: false,
        responsive: true,
        maxHeight: '100',
        animation: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            stacked: false,
            type: 'linear',
            position: 'left',
            id: "y-axis-0"
          }]
        }
      });
    }
  }
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1215)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(1516),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(110);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Bar */],
  mixins: [reactiveProp],
  mounted: function mounted() {
    if (this.chartData) {
      this.renderChart(this.chartData, {
        scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        scaleFontColor: '#999',
        scaleFontStyle: '600',
        tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        tooltipCornerRadius: 3,
        maintainAspectRatio: false,
        responsive: true,
        maxHeight: '100px',
        animation: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }

      });
    }
  }
});

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aws_sdk__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aws_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_Cookies_js__ = __webpack_require__(1063);










function toUsername(email) {
  var email2 = email.replace('.', '-dot-');
  email = email2.replace('.', '-dot-');
  email2 = email.replace('.', '-dot-');
  return email2.replace('@', '-at-');
}

var sessionStore = {
  namespaced: true,
  state: {
    profileId: '',
    profileData: {
      'profileInfo': {
        'profile_type': { 'adminUserCode': '000' },
        'firstName': '',
        'policyAgreement': { 'agreeFlag': true }
      },
      'rights': {
        'rights': {
          'dashboardEvLogFlag': false,
          'dashboardDataTableFlag': false,
          'emailMultipleRecipientFlag': false
        }
      },
      'sharingInvitations': []
    },
    dashboardFlags: {
      'evsensAdminFlag': false,
      'evsensMasterFlag': false
    },
    profileDataReceivedFlag: false,
    groupArborescence: [{ 'group_name': '' }],
    navIndex: { 'GU': [0], 'GS': [0], 'groupParentId': '', 'bundleParentId': '' },
    actualGroup: { 'permissions': { 'GrpLinkedProfileRead': [false] },
      'group_id': '!!NONE!!' },
    actualBundle: { 'bundle_id': '!!NONE!!' },
    parentContainer: 'NONE',
    actualBundleChannelMaximums: { '5min': 0, 'MA_001H': 0, 'MA_004H': 0, 'MA_006H': 0, 'MA_012H': 0, 'MA_024H': 0, 'MA_072H': 0, 'MA_168H': 0, 'MA_336H': 0, 'MA_720H': 0 },
    displayAllChannelGraphFlag: true,
    authToken: '',
    idToken: '',
    bindingCode: '',
    userEmail: '',
    userName: '',
    userLastName: '',
    actualLanguage: "FR",

    labelFieldConfirmationCode: { FR: 'Entrez le code de confirmation', EN: 'Enter confirmation code' },
    labelFieldNewPassword: { FR: 'Entrez un nouveau mot de passe', EN: 'Enter a new password' },

    pool: new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({
      UserPoolId: "us-east-1_sCd336dHu",
      ClientId: "71p7s0emaale6949vqgbgg3cgg",
      Storage: new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["b" /* CookieStorage */]({ domain: ".energisys.cloud", secure: false })
    }),
    planTransactionData: {
      'transactionStatusCode': '000',
      'organizationId': 'TBD',
      'organizationSubscription': [],
      'planCode': '000',
      'planName': 'none',
      'yearSinglePaymentFlag': false,
      'preAuthorizedPaymentFlag': true,
      'automaticRenewFlag': true,
      'renewalPrice': '0.00',
      'firstPaymentRebate': '0.00',
      'cardToken': '000',
      'postAction': 'NewSubscription',
      'options': []
    }
  },

  mutations: {
    SAVE_AUTH_TOKEN: function SAVE_AUTH_TOKEN(state, authToken) {
      state.authToken = authToken;
    },
    SAVE_USER_EMAIL: function SAVE_USER_EMAIL(state, email) {
      state.userEmail = email;
    },
    SAVE_USER_NAME: function SAVE_USER_NAME(state, name) {
      state.userName = name;
    },
    SAVE_USER_LASTNAME: function SAVE_USER_LASTNAME(state, lastName) {
      state.userLastName = lastName;
    },
    SAVE_ID_TOKEN: function SAVE_ID_TOKEN(state, idToken) {
      state.idToken = idToken;
    },
    SET_PROFILE_ID: function SET_PROFILE_ID(state, profileId) {
      state.profileId = profileId;
    },
    SET_PROFILE_DATA: function SET_PROFILE_DATA(state, profileData) {
      state.profileData = profileData;

      state.dashboardFlags.evsensAdminFlag = profileData.licences.length > 0;
      state.dashboardFlags.evsensMasterFlag = profileData.profileInfo.profile_type.masterUserCode.includes('EVSensAdmin');
    },
    SET_GROUP_ARBORESCENCE: function SET_GROUP_ARBORESCENCE(state, groupData) {
      state.groupArborescence = groupData;
      state.profileDataReceivedFlag = true;
    },
    SET_ACTUAL_GROUP: function SET_ACTUAL_GROUP(state, group) {
      state.actualGroup = group;
    },
    SET_ACTUAL_BUNDLE: function SET_ACTUAL_BUNDLE(state, bundle) {
      state.actualBundle = bundle;
    },
    SET_ACTUAL_BUNDLE_CHANNEL_MAXIMUMS: function SET_ACTUAL_BUNDLE_CHANNEL_MAXIMUMS(state, data) {
      state.actualBundleChannelMaximums = data;
    },
    SET_BINDING_CODE: function SET_BINDING_CODE(state, code) {
      state.bindingCode = code;
    },
    SET_LANGUAGE: function SET_LANGUAGE(state, language) {
      state.actualLanguage = language;
      localStorage.language = language;
    },
    SET_NAV_INDEX_GU: function SET_NAV_INDEX_GU(state, data) {
      state.navIndexGU = data;
    },
    SET_NAV_INDEX: function SET_NAV_INDEX(state, data) {
      state.navIndex = data;
    },
    SET_PLAN_TRANSACTION: function SET_PLAN_TRANSACTION(state, planTransactionData) {
      state.planTransactionData = planTransactionData;
    },
    SET_DISPLAY_ALL_CHANNEL_FLAG: function SET_DISPLAY_ALL_CHANNEL_FLAG(state, value) {
      state.displayAllChannelGraphFlag = value;
    },
    SET_PARENT_CONTAINER: function SET_PARENT_CONTAINER(state, value) {
      state.parentContainer = value;
    }
  },

  actions: {
    authTest: function authTest(_ref, userInfos) {
      var commit = _ref.commit,
          state = _ref.state,
          dispatch = _ref.dispatch;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default()(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('/rest/authTest').then(function (response) {}).catch(function (e) {});
      });
    },
    checkLocalStorageForKeys: function checkLocalStorageForKeys(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var cognitoUser = state.pool.getCurrentUser();
        if (cognitoUser != null) {

          cognitoUser.getSession(function (err, session) {
            if (err) {
              reject();
              return;
            }

            var authToken = session.getIdToken().getJwtToken();
            var idToken = session.getAccessToken().getJwtToken();

            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['Authorization'] = authToken;
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['idToken'] = idToken;

            commit('SET_PROFILE_ID', cognitoUser.username);
            commit('SAVE_AUTH_TOKEN', authToken);
            commit('SAVE_ID_TOKEN', idToken);
            resolve();
          });
        } else {
          reject();
        }
      });
    },
    reset: function reset(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state,
          dispatch = _ref3.dispatch;

      commit('SAVE_AUTH_TOKEN', '');
      commit('SAVE_ID_TOKEN', '');
      commit('SET_PROFILE_ID', '');
      commit('SET_BINDING_CODE', '');
      commit('SAVE_USER_EMAIL', '');
      commit('SAVE_USER_NAME', '');
      commit('SAVE_USER_LASTNAME', '');
      commit('SET_PLAN_TRANSACTION', {
        'transactionStatusCode': '000',
        'organizationId': 'TBD',
        'organizationSubscription': [],
        'planCode': '000',
        'planName': 'none',
        'yearSinglePaymentFlag': false,
        'preAuthorizedPaymentFlag': true,
        'automaticRenewFlag': true,
        'renewalPrice': '0.00',
        'firstPaymentRebate': '0.00',
        'cardToken': '000',
        'postAction': 'NewSubscription',
        'taxRateData': { 'countrySortKey': 'Canada',
          'stateNames': { 'FR': 'Quebec', 'EN': 'Quebec' } }
      });
    },
    logOut: function logOut(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state,
          dispatch = _ref4.dispatch;

      dispatch('resetStates', {}, { root: true });
      var cognitoUser = state.pool.getCurrentUser();
      cognitoUser.signOut();
    },
    signIn: function signIn(_ref5, userInfos) {
      var commit = _ref5.commit,
          state = _ref5.state,
          dispatch = _ref5.dispatch;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        if (state.authToken != '' && state.idToken != '') {
          return dispatch('authTest');
        }

        var userName = toUsername(userInfos.email);

        var authenticationDetails = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["c" /* AuthenticationDetails */]({
          USERNAME: toUsername(userInfos.email),
          Password: userInfos.password
        });

        var pool = state.pool;

        var userData = {
          Username: userName,
          Pool: pool,
          Storage: new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["b" /* CookieStorage */]({ domain: ".energisys.cloud", secure: false })
        };

        var cognitoUser = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["d" /* CognitoUser */](userData);

        cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: function onSuccess(session) {

            var authToken = session.getIdToken().getJwtToken();
            var idToken = session.getAccessToken().getJwtToken();

            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['Authorization'] = authToken;
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['idToken'] = idToken;

            commit('SET_PROFILE_ID', userName);
            commit('SAVE_AUTH_TOKEN', authToken);
            commit('SAVE_ID_TOKEN', idToken);
            commit('SAVE_USER_EMAIL', userInfos.email);

            localStorage.actualUserName = userName;

            var payload = {
              "firstName": userInfos.name,
              "email": userInfos.email,
              "lastName": userInfos.lastName,
              "language": userInfos.language,
              "frontEndVersion": "EVSENS"
            };
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + userName + '/login', payload).then(function (response) {
              commit('SET_PROFILE_DATA', response.data.userData);
              resolve();
            }).catch(function (e) {
              reject(e);
            });
          },
          onFailure: function onFailure(e) {
            reject(e);
          }
        });
      });
    },
    register: function register(_ref6, userInfos) {
      var commit = _ref6.commit,
          state = _ref6.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var attributeList = [];
        var dataEmail = { Name: 'email', Value: userInfos.email };
        var attributeEmail = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["e" /* CognitoUserAttribute */](dataEmail);
        var userPool = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({
          UserPoolId: "us-east-1_sCd336dHu",
          ClientId: "71p7s0emaale6949vqgbgg3cgg"
        });
        var userName = toUsername(userInfos.email);
        attributeList.push(attributeEmail);

        userPool.signUp(userName, userInfos.password, attributeList, null, function (err, result) {
          if (err) {
            reject(err);
            return;
          }

          commit('SAVE_USER_EMAIL', userInfos.email);
          commit('SAVE_USER_NAME', userInfos.name);
          commit('SAVE_USER_LASTNAME', userInfos.lastName);
          resolve(result);
        });
      });
    },
    forgotPassword: function forgotPassword(_ref7, data) {
      var commit = _ref7.commit,
          state = _ref7.state;

      state.actualLanguage = data.language;

      var userPool = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({
        UserPoolId: "us-east-1_sCd336dHu",
        ClientId: "71p7s0emaale6949vqgbgg3cgg"
      });
      var userData = {
        Username: toUsername(data.email),
        Pool: userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["d" /* CognitoUser */](userData);

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.forgotPassword({
          onSuccess: function onSuccess(data) {},
          onFailure: function onFailure(err) {
            alert(err);

            reject(err);
          },
          inputVerificationCode: function inputVerificationCode() {
            var verificationCode = prompt(state.labelFieldConfirmationCode[state.actualLanguage], '');
            var newPassword = prompt(state.labelFieldNewPassword[state.actualLanguage], '');
            cognitoUser.confirmPassword(verificationCode, newPassword, this);
            resolve();
          }
        });
      });
    },
    forgotPasswordStep01: function forgotPasswordStep01(_ref8, data) {
      var commit = _ref8.commit,
          state = _ref8.state;

      state.actualLanguage = data.language;

      var userPool = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({
        UserPoolId: "us-east-1_sCd336dHu",
        ClientId: "71p7s0emaale6949vqgbgg3cgg"
      });
      var userData = {
        Username: toUsername(data.email),
        Pool: userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["d" /* CognitoUser */](userData);

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.forgotPassword({
          onSuccess: function onSuccess(data) {
            resolve();
          },
          onFailure: function onFailure(err) {
            alert(err);

            reject(err);
          }
        });
      });
    },
    forgotPasswordStep02: function forgotPasswordStep02(_ref9, data) {
      var commit = _ref9.commit,
          state = _ref9.state;

      state.actualLanguage = data.language;
      var userPool = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({
        UserPoolId: "us-east-1_sCd336dHu",
        ClientId: "71p7s0emaale6949vqgbgg3cgg"
      });
      var userData = {
        Username: toUsername(data.email),
        Pool: userPool
      };
      var cognitoUser = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["d" /* CognitoUser */](userData);

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        cognitoUser.confirmPassword(data.verificationCode, data.newPassword, {
          onSuccess: function onSuccess(data) {
            resolve();
          },
          onFailure: function onFailure(err) {
            alert(err);
            reject(err);
          }
        });
      });
    },
    verify: function verify(_ref10, userInfos) {
      var commit = _ref10.commit,
          state = _ref10.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var userName = toUsername(userInfos.email);

        var userData = {
          Username: userName,
          Pool: new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({ UserPoolId: "us-east-1_sCd336dHu", ClientId: "71p7s0emaale6949vqgbgg3cgg" })
        };
        var cognitoUser = new __WEBPACK_IMPORTED_MODULE_6_amazon_cognito_identity_js__["d" /* CognitoUser */](userData);

        cognitoUser.confirmRegistration(userInfos.verifyCode, true, function (err, result) {
          if (!err) {
            resolve(result);
          } else {
            reject(err);
          }
        });
      });
    },
    bind: function bind(_ref11, deviceId) {
      var commit = _ref11.commit,
          state = _ref11.state;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('/rest/profile/' + state.profileId + '/bind').then(function (response) {
          commit('SET_BINDING_CODE', response.data.bindingCode);
          resolve(response.data.bindingCode);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    updatelanguage: function updatelanguage(_ref12, data) {
      var commit = _ref12.commit,
          state = _ref12.state;

      commit('SET_LANGUAGE', data.language);

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/updatelanguage', data).then(function (response) {
          location.reload();
        }).catch(function (error) {
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
        });
      });
    },
    refreshProfileData: function refreshProfileData(_ref13) {
      var commit = _ref13.commit,
          state = _ref13.state;


      var payload = { "firstName": 'John', "email": 'Bidon', "lastName": 'Doe' };
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + localStorage.actualUserName + '/login', payload).then(function (response) {

        commit('SET_PROFILE_DATA', response.data.userData);
        commit('SET_LANGUAGE', response.data.userData.profileInfo.language);

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
      }).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    getGroupArborescence: function getGroupArborescence(_ref14) {
      var commit = _ref14.commit,
          state = _ref14.state;


      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('/rest/profile/' + localStorage.actualUserName + '/readgrouparborescence').then(function (response) {
        if (response.data.Code == 'OK') {
          commit('SET_GROUP_ARBORESCENCE', response.data.userArborescence);
          commit('SET_ACTUAL_GROUP', response.data.userArborescence[0]);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
        } else {
          window.alert("La lecture a échouée. / Reading fail. Error:" + response.data.Error);
        }
      }).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    reloadActualBundle: function reloadActualBundle(_ref15) {
      var commit = _ref15.commit,
          state = _ref15.state;

      var requestData = { 'postAction': 'ReadBundleData',
        'bundleId': state.actualBundle.bundle_id,
        'parentContainer': state.parentContainer };

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/bundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          commit('SET_ACTUAL_BUNDLE', response.data.BundleData);
        } else {
          window.alert("La lecture a échouée. / Reading fail. Error:" + response.data.Error);
        }
      }).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    validateUserExist: function validateUserExist(_ref16, data) {
      var commit = _ref16.commit,
          state = _ref16.state;

      var userName = toUsername(data);
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('/rest/profile/' + state.profileId + '/validateuserexist?username=' + userName).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
      }).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    getEventsLog: function getEventsLog(_ref17, data) {
      var commit = _ref17.commit,
          state = _ref17.state;

      var userName = toUsername(data.profileid);
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('/rest/profile/' + state.profileId + '/getusereventlogs?username=' + userName + '&startdate=' + data.startDate).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
      }).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    getAlertsHistory: function getAlertsHistory(_ref18, data) {
      var _this = this;

      var commit = _ref18.commit,
          state = _ref18.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.get('/rest/profile/' + state.profileId + '/getalertshistory?startdate=' + data.startDate + '&enddate=' + data.endDate).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
      }).catch(function (error) {
        _this.refreshProfileData();
      }).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    updateProfile: function updateProfile(_ref19, data) {
      var commit = _ref19.commit,
          state = _ref19.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.put('/rest/profile/' + state.profileId + '/updateprofile', data);
    },
    processSubscription: function processSubscription(_ref20, data) {
      var commit = _ref20.commit,
          state = _ref20.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/subscription', data).catch(function (e) {
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      });
    },
    setActualGroup: function setActualGroup(_ref21, data) {
      var commit = _ref21.commit,
          state = _ref21.state;

      commit('SET_ACTUAL_GROUP', data);
    },
    setActualBundle: function setActualBundle(_ref22, data) {
      var commit = _ref22.commit,
          state = _ref22.state;

      commit('SET_ACTUAL_BUNDLE', data);
    },
    setParentContainer: function setParentContainer(_ref23, data) {
      var commit = _ref23.commit,
          state = _ref23.state;

      commit('SET_PARENT_CONTAINER', data);
    },
    setActualBundleChannelMaximums: function setActualBundleChannelMaximums(_ref24, data) {
      var commit = _ref24.commit,
          state = _ref24.state;

      commit('SET_ACTUAL_BUNDLE_CHANNEL_MAXIMUMS', data);
    },
    setActualNavIndex: function setActualNavIndex(_ref25, data) {
      var commit = _ref25.commit,
          state = _ref25.state;

      commit('SET_NAV_INDEX', data);
    },
    displayMessageSessionMustBeReload: function displayMessageSessionMustBeReload(_ref26) {
      var commit = _ref26.commit,
          state = _ref26.state;

      if (localStorage.lastReloadMessageTime) {
        if (localStorage.lastReloadMessageTime != Math.floor(moment().unix() / 60) * 60) {
          localStorage.lastReloadMessageTime = Math.floor(moment().unix() / 60) * 60;
          window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
        }
      } else {
        localStorage.lastReloadMessageTime = Math.floor(moment().unix() / 60) * 60;
        window.alert("Votre session est expirée, vous devez rafraichir la page. The session is expired, you must refresh the page.");
      }
    },
    postGroup: function postGroup(_ref27, data) {
      var dispatch = _ref27.dispatch,
          commit = _ref27.commit,
          state = _ref27.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/group', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postBundle: function postBundle(_ref28, data) {
      var dispatch = _ref28.dispatch,
          commit = _ref28.commit,
          state = _ref28.state;


      data.parentContainer = state.parentContainer;
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/bundle', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    setDisplayAllChannelGraphFlag: function setDisplayAllChannelGraphFlag(_ref29, data) {
      var commit = _ref29.commit,
          state = _ref29.state;

      commit('SET_DISPLAY_ALL_CHANNEL_FLAG', data);
    },
    postBundleReadChannelReadings: function postBundleReadChannelReadings(_ref30, data) {
      var dispatch = _ref30.dispatch,
          commit = _ref30.commit,
          state = _ref30.state;

      data.parentContainer = state.parentContainer;
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/bundle', data).then(function (response) {
        if (response.data.Code == 'OK') {
          var channelIndex;
          var sumCost;
          var sumKwh;
          var peakCurrent;

          var actualBundleTempo = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.actualBundle));
          for (var i = 0; i < response.data.ChannelsReadings.length; i++) {
            channelIndex = response.data.ChannelsReadings[i].channelBundleIndex;
            actualBundleTempo.channels[channelIndex].ChannelData.DisplayOpenFlag = true;
            actualBundleTempo.channels[channelIndex].ChannelData.Readings = response.data.ChannelsReadings[i].readings;

            sumCost = 0;
            sumKwh = 0;
            peakCurrent = 0;
            for (var j = 0; j < actualBundleTempo.channels[channelIndex].ChannelData.Readings.length; j++) {
              sumCost += actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].cost;
              sumKwh += actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].kwr;
              if (actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].peakCurrent > peakCurrent) {
                peakCurrent = actualBundleTempo.channels[channelIndex].ChannelData.Readings[j].peakCurrent;
              }
            }
            actualBundleTempo.channels[channelIndex].ChannelData.sumCost = sumCost;
            actualBundleTempo.channels[channelIndex].ChannelData.sumKwh = sumKwh;
            actualBundleTempo.channels[channelIndex].ChannelData.peakCurrent = peakCurrent;

            if (response.data.ChannelsReadings[i].hasOwnProperty('channelComponentData')) {
              actualBundleTempo.channels[channelIndex].ChannelData.Readings = response.data.ChannelsReadings[i].channelComponentData;
            }
          }

          commit('SET_ACTUAL_BUNDLE', actualBundleTempo);
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
      }).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postDevice: function postDevice(_ref31, data) {
      var dispatch = _ref31.dispatch,
          commit = _ref31.commit,
          state = _ref31.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/device', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postChannel: function postChannel(_ref32, data) {
      var dispatch = _ref32.dispatch,
          commit = _ref32.commit,
          state = _ref32.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/channel', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postAlert: function postAlert(_ref33, data) {
      var dispatch = _ref33.dispatch,
          commit = _ref33.commit,
          state = _ref33.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/alert', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postCar: function postCar(_ref34, data) {
      var dispatch = _ref34.dispatch,
          commit = _ref34.commit,
          state = _ref34.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/car', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postProfile: function postProfile(_ref35, data) {
      var dispatch = _ref35.dispatch,
          commit = _ref35.commit,
          state = _ref35.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/profile', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postOrganization: function postOrganization(_ref36, data) {
      var dispatch = _ref36.dispatch,
          commit = _ref36.commit,
          state = _ref36.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/organization', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postRule: function postRule(_ref37, data) {
      var dispatch = _ref37.dispatch,
          commit = _ref37.commit,
          state = _ref37.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/rule', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postFrontEndTemplates: function postFrontEndTemplates(_ref38, data) {
      var dispatch = _ref38.dispatch,
          commit = _ref38.commit,
          state = _ref38.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/frontendtemplates', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postElectricalPlan: function postElectricalPlan(_ref39, data) {
      var dispatch = _ref39.dispatch,
          commit = _ref39.commit,
          state = _ref39.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/electricalplan', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postSupport: function postSupport(_ref40, data) {
      var dispatch = _ref40.dispatch,
          commit = _ref40.commit,
          state = _ref40.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/support', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    },
    postTest: function postTest(_ref41, data) {
      var dispatch = _ref41.dispatch,
          commit = _ref41.commit,
          state = _ref41.state;

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('/rest/profile/' + state.profileId + '/postdata', data).catch(function (e) {
        dispatch('displayMessageSessionMustBeReload');
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (sessionStore);

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-login.16b987d.png";

/***/ }),
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1022),
  /* template */
  __webpack_require__(1510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1254)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1024),
  /* template */
  __webpack_require__(1589),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_device__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_charges__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_overlay__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores_session__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_cars__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stores_group__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stores_appliances__ = __webpack_require__(1066);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    devicesStore: __WEBPACK_IMPORTED_MODULE_2__stores_device__["a" /* default */],
    chargesStore: __WEBPACK_IMPORTED_MODULE_3__stores_charges__["a" /* default */],
    overlayStore: __WEBPACK_IMPORTED_MODULE_4__stores_overlay__["a" /* default */],
    sessionStore: __WEBPACK_IMPORTED_MODULE_5__stores_session__["a" /* default */],
    groupStore: __WEBPACK_IMPORTED_MODULE_7__stores_group__["a" /* default */],
    carsStore: __WEBPACK_IMPORTED_MODULE_6__stores_cars__["a" /* default */],
    appliancesStore: __WEBPACK_IMPORTED_MODULE_8__stores_appliances__["a" /* default */]
  },
  actions: {
    resetStates: function resetStates(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      dispatch('devicesStore/reset');
      dispatch('chargesStore/reset');

      dispatch('sessionStore/reset');
      dispatch('carsStore/reset');
      dispatch('appliancesStore/reset');
    }
  }
}));

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(110);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Pie */],
  mixins: [reactiveProp],
  mounted: function mounted() {
    if (this.chartData) {
      this.renderChart(this.chartData, {
        scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        scaleFontColor: '#999',
        scaleFontStyle: '600',
        tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        tooltipCornerRadius: 3,
        maintainAspectRatio: true,
        responsive: true,
        maxHeight: '50',
        legend: {
          display: false
        }

      });
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);



var t = null;

var overlayStore = {
  namespaced: true,
  state: {
    showModal: false,
    showProgress: false,
    currentModalView: '',
    notifications: [],
    loading: '',
    overlayParameters: {},
    confirmation: {
      msg: '',
      callback: null
    }
  },
  mutations: {
    SET_CURRENT_MODAL_VIEW: function SET_CURRENT_MODAL_VIEW(state, value) {
      state.currentModalView = value;
    },
    SET_SHOW_MODAL_OVERLAY: function SET_SHOW_MODAL_OVERLAY(state, value) {
      state.showModal = value;
    },
    SET_SHOW_PROGRESS_OVERLAY: function SET_SHOW_PROGRESS_OVERLAY(state, value) {
      state.showProgress = value;
    },
    PUSH_CONFIRMATION: function PUSH_CONFIRMATION(state, object) {
      if (object.hasOwnProperty('msg')) state.confirmation.msg = object.msg;
      if (object.hasOwnProperty('callback')) state.confirmation.callback = object.callback;
    },
    CLEAR_CONFIRMATION: function CLEAR_CONFIRMATION(state) {
      state.confirmation.msg = '';
      state.confirmation.callback = null;
    },
    PUSH_NOTIFICATION: function PUSH_NOTIFICATION(state, object) {
      state.notifications.push(object);
    },
    POP_NOTIFICATION: function POP_NOTIFICATION(state) {
      state.notifications.pop();
    },
    SET_LOADING_STATUE: function SET_LOADING_STATUE(state, value) {
      state.loading = value;
    },
    SET_PARAMETERS: function SET_PARAMETERS(state, value) {
      state.overlayParameters = value;
    }
  },
  actions: {
    toggleModal: function toggleModal(_ref, value) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('SET_SHOW_MODAL_OVERLAY', value);
    },
    showModal: function showModal(_ref2, templateName) {
      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;

      commit('SET_CURRENT_MODAL_VIEW', templateName);
      dispatch('toggleModal', true);
    },
    showProgressOverlay: function showProgressOverlay(_ref3, value) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('SET_SHOW_PROGRESS_OVERLAY', value);
    },
    pushNotification: function pushNotification(_ref4, notificationObject) {
      var commit = _ref4.commit,
          state = _ref4.state;

      commit('PUSH_NOTIFICATION', notificationObject);
      var t = setTimeout(function () {
        commit('POP_NOTIFICATION');
      }, 2000);
    },
    pushConfirmation: function pushConfirmation(_ref5, confirmationObject) {
      var commit = _ref5.commit,
          state = _ref5.state;

      commit('PUSH_CONFIRMATION', confirmationObject);
    },
    clearConfirmation: function clearConfirmation(_ref6) {
      var commit = _ref6.commit;

      commit('CLEAR_CONFIRMATION');
    },
    appIsLoading: function appIsLoading(_ref7) {
      var commit = _ref7.commit;

      commit('SET_LOADING_STATUE', 'loading');
    },
    appCompletedLoading: function appCompletedLoading(_ref8) {
      var commit = _ref8.commit;

      clearTimeout(t);
      commit('SET_LOADING_STATUE', 'completed');
      t = setTimeout(function () {
        commit('SET_LOADING_STATUE', '');
      }, 400);
    },
    setParameters: function setParameters(_ref9, value) {
      var commit = _ref9.commit,
          state = _ref9.state;

      commit('SET_PARAMETERS', value);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (overlayStore);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = [{ planId: 'Hydro_D',
    planTitle: { FR: 'Hydro-Quebec résidentiel (Tarif D)', EN: 'Hydro-Québec residential (D Rate)' },
    plan: [{ type: '0', tempCondition: '0.0', tempThreshold: -14, startMonth: 1, endMonth: 12, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.0938 }]
}, { planId: 'Hydro_D_Flex',
    planTitle: { FR: 'Hydro-Quebec résidentiel (Flex D)', EN: 'Hydro-Québec residential (D Flex)' },
    plan: [{ type: '0', tempCondition: '0', tempThreshold: -14, startMonth: 4, endMonth: 11, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.0938 }, { type: '0', tempCondition: '0', tempThreshold: -14, startMonth: 1, endMonth: 3, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.0736 }, { type: '0', tempCondition: '0', tempThreshold: -14, startMonth: 12, endMonth: 12, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.0736 }]
}, { planId: 'Hydro_DT',
    planTitle: { FR: 'Hydro-Quebec bi-énergie (Tarif DT)', EN: 'Hydro-Québec bi-energy (DT Rate)' },
    plan: [{ type: '0', tempCondition: '0', tempThreshold: -14, startMonth: 4, endMonth: 11, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.0437 }, { type: '1', tempCondition: '0', tempThreshold: -15, startMonth: 1, endMonth: 12, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.2555 }]
}];
/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1257)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(1594),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(1542),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(1562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(1508),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1055),
  /* template */
  __webpack_require__(1517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */,
/* 176 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 177 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true,"xmlNoDefaultLists":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay","cors":true},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect","cors":true},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics","cors":true},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService","cors":true},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService","cors":true},"qldb":{"name":"QLDB"},"qldbsession":{"prefix":"qldb-session","name":"QLDBSession"},"workmailmessageflow":{"name":"WorkMailMessageFlow"},"codestarnotifications":{"prefix":"codestar-notifications","name":"CodeStarNotifications"},"savingsplans":{"name":"SavingsPlans"},"sso":{"name":"SSO"},"ssooidc":{"prefix":"sso-oidc","name":"SSOOIDC"},"marketplacecatalog":{"prefix":"marketplace-catalog","name":"MarketplaceCatalog"},"dataexchange":{"name":"DataExchange"},"sesv2":{"name":"SESV2"},"migrationhubconfig":{"prefix":"migrationhub-config","name":"MigrationHubConfig"},"connectparticipant":{"name":"ConnectParticipant"},"appconfig":{"name":"AppConfig"},"iotsecuretunneling":{"name":"IoTSecureTunneling"},"wafv2":{"name":"WAFV2"},"elasticinference":{"prefix":"elastic-inference","name":"ElasticInference"},"imagebuilder":{"name":"Imagebuilder"},"schemas":{"name":"Schemas"},"accessanalyzer":{"name":"AccessAnalyzer"},"codegurureviewer":{"prefix":"codeguru-reviewer","name":"CodeGuruReviewer"},"codeguruprofiler":{"name":"CodeGuruProfiler"},"computeoptimizer":{"prefix":"compute-optimizer","name":"ComputeOptimizer"},"frauddetector":{"name":"FraudDetector"},"kendra":{"name":"Kendra"},"networkmanager":{"name":"NetworkManager"},"outposts":{"name":"Outposts"},"augmentedairuntime":{"prefix":"sagemaker-a2i-runtime","name":"AugmentedAIRuntime"},"ebs":{"name":"EBS"},"kinesisvideosignalingchannels":{"prefix":"kinesis-video-signaling","name":"KinesisVideoSignalingChannels","cors":true},"detective":{"name":"Detective"},"codestarconnections":{"prefix":"codestar-connections","name":"CodeStarconnections"},"synthetics":{"name":"Synthetics"},"iotsitewise":{"name":"IoTSiteWise"},"macie2":{"name":"Macie2"},"codeartifact":{"name":"CodeArtifact"},"honeycode":{"name":"Honeycode"}}

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_session__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_overlay__ = __webpack_require__(124);







var deviceStore = {
  namespaced: true,
  state: {
    charges: [],
    chargesSummary: {},
    startDate: moment().unix(),
    endDate: moment().add(1, 'days').unix()
  },
  mutations: {
    RESET_CHARGES: function RESET_CHARGES(state, chargesObject) {
      state.charges = [];
    },
    SET_CHARGES: function SET_CHARGES(state, chargesObject) {
      state.charges.push(chargesObject);
    },
    SET_CHARGES_SUMMARY: function SET_CHARGES_SUMMARY(state, chargesObject) {
      state.chargesSummary = chargesObject;
    },
    SET_START_DATE: function SET_START_DATE(state, value) {
      state.startDate = value;
    },
    SET_END_DATE: function SET_END_DATE(state, value) {
      state.endDate = value;
    }
  },
  actions: {
    reset: function reset(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('RESET_CHARGES');
      commit('SET_CHARGES_SUMMARY', {});
      commit('SET_START_DATE', moment().unix());
      commit('SET_END_DATE', moment().add(1, 'days').unix());
    },
    setStartDate: function setStartDate(_ref2, date) {
      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;

      commit('SET_START_DATE', date);
    },
    setEndDate: function setEndDate(_ref3, date) {
      var commit = _ref3.commit,
          state = _ref3.state,
          dispatch = _ref3.dispatch;

      commit('SET_END_DATE', date);
    },
    fetch: function fetch(_ref4, deviceId) {
      var commit = _ref4.commit,
          state = _ref4.state,
          getters = _ref4.getters;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (getters.chargesForDevice(deviceId) == undefined) {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/device/' + deviceId + '/charges').then(function (response) {
            var data = response.data;
            data.deviceId = deviceId;
            commit('SET_CHARGES', data);
            resolve();
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        } else {
          resolve();
        }
      });
    }
  }

};

/* harmony default export */ __webpack_exports__["a"] = (deviceStore);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = [{ alertType: '001-1-01',
    alertLevel: 'AlrtL1',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si arrêt (Niveau 1)', EN: 'Alert if stop (Level 1)' },
    description: 'description',
    icon: { FR: '001_1_FR.png', EN: '001_1_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'PowerThreshold', dataType: 'Numeric', value: '100', parameterTitle: { FR: 'Seuil de puissance (W)', EN: 'Power Threshold (W)' } }],
    variables: [{ variableId: 'LastReading', dataType: 'Numeric', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '001-2-01',
    alertLevel: 'AlrtL1',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte de démarrage (Niveau 1)', EN: 'Alert if start (Level 1)' },
    description: 'description',
    icon: { FR: '001_2_FR.png', EN: '001_2_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'PowerThreshold', dataType: 'Numeric', value: '100', parameterTitle: { FR: 'Seuil de puissance (W)', EN: 'Power Threshold (W)' } }],
    variables: [{ variableId: 'LastReading', dataType: 'Numeric', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '002-1-01',
    alertLevel: 'AlrtL1',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si en fonction depuis x minutes (Niveau 1)', EN: 'Alert if ON since x minutes (Level 1)' },
    description: 'description',
    icon: { FR: '002_1_FR.png', EN: '002_1_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'PowerThreshold', dataType: 'Numeric', value: '100', parameterTitle: { FR: 'Seuil de puissance (W)', EN: 'Power Threshold (W)' } }, { parameterId: 'Delay', dataType: 'Numeric', value: '10', parameterTitle: { FR: 'Délai (minutes)', EN: 'Delay (minute)' } }],
    variables: [{ variableId: 'Timer', dataType: 'Numeric', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }, { variableId: 'AlertLatchFlag', dataType: 'Bool', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '002-2-01',
    alertLevel: 'AlrtL1',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si en arrêt depuis x minutes (Niveau 1)', EN: 'Alert if OFF since x minutes (Level 1)' },
    description: 'description',
    icon: { FR: '002_2_FR.png', EN: '002_2_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'PowerThreshold', dataType: 'Numeric', value: '100', parameterTitle: { FR: 'Seuil de puissance (W)', EN: 'Power Threshold (W)' } }, { parameterId: 'Delay', dataType: 'Numeric', value: '10', parameterTitle: { FR: 'Délai (minutes)', EN: 'Delay (minute)' } }],
    variables: [{ variableId: 'Timer', dataType: 'Numeric', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }, { variableId: 'AlertLatchFlag', dataType: 'Bool', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '003-1-01',
    alertLevel: 'AlrtL2',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si consommation journalière dépasse X kWr (Niveau 2)', EN: 'Alert if daily consumption exceed X kWr (Level 2)' },
    description: 'description',
    icon: { FR: '003_1_FR.png', EN: '003_1_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'EnergyLimit', dataType: 'Numeric', value: '10', parameterTitle: { FR: 'Limite de kWr (kWr)', EN: 'kWr Limit (kWr)' } }],
    variables: [{ variableId: 'AlertLatchFlag', dataType: 'Bool', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '003-2-01',
    alertLevel: 'AlrtL2',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si consommation journalière inférieur à X kWr (Niveau 2)', EN: 'Alert if daily consumption under X kWr (Level 2)' },
    description: 'description',
    icon: { FR: '003_2_FR.png', EN: '003_2_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'EnergyLimit', dataType: 'Numeric', value: '10', parameterTitle: { FR: 'kWr minimum (kWr)', EN: 'Minimum (kWr)' } }],
    variables: [{ variableId: 'AlertLatchFlag', dataType: 'Bool', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '004-1-01',
    alertLevel: 'AlrtL2',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si consommation consommation supérieure à X % la moyenne des derniers jours (Niveau 2)', EN: 'Alert if consumption exceed X % the average of last days (Level 2)' },
    description: 'description',
    icon: { FR: '004_1_FR.png', EN: '004_1_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'Pourcentage', dataType: 'Numeric', value: '10', parameterTitle: { FR: 'Pourcentage (%)', EN: 'Pourcentage (%)' } }, { parameterId: 'AverageDays', dataType: 'Numeric', value: '5', parameterTitle: { FR: 'Nombre jour', EN: 'Average days' } }],
    variables: [{ variableId: 'LastDailyAverageValue', dataType: 'Numeric', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}, { alertType: '004-2-01',
    alertLevel: 'AlrtL2',
    alertId: 'ND',
    alertTitle: { FR: 'Alerte si consommation consommation inférieure à X % la moyenne des derniers jours (Niveau 2)', EN: 'Alert if consumption is under X % the average of last days (Level 2)' },
    description: 'description',
    icon: { FR: '004_2_FR.png', EN: '004_2_EN.png' },
    message: 'Message',
    parameters: [{ parameterId: 'Pourcentage', dataType: 'Numeric', value: '10', parameterTitle: { FR: 'Pourcentage (%)', EN: 'Pourcentage (%)' } }, { parameterId: 'AverageDays', dataType: 'Numeric', value: '5', parameterTitle: { FR: 'Nombre jour', EN: 'Average days' } }],
    variables: [{ variableId: 'LastDailyAverageValue', dataType: 'Numeric', value: 'NA', variableTitle: { FR: 'TBD', EN: 'TBD' } }],
    emailRecipient: ['TBD'],
    phoneRecipient: []
}];
/* unused harmony default export */ var _unused_webpack_default_export = (data);

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 436 */,
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(1530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1224)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(1533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(1520),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(1573),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(962),
  /* template */
  __webpack_require__(1488),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(1553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1191)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(1477),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(1563),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(981),
  /* template */
  __webpack_require__(1550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(997),
  /* template */
  __webpack_require__(1590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(1495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(1568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1011),
  /* template */
  __webpack_require__(1537),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1228)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1012),
  /* template */
  __webpack_require__(1546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1015),
  /* template */
  __webpack_require__(1570),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1017),
  /* template */
  __webpack_require__(1498),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1214)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1020),
  /* template */
  __webpack_require__(1515),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1236)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1029),
  /* template */
  __webpack_require__(1558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1253)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1031),
  /* template */
  __webpack_require__(1586),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1045),
  /* template */
  __webpack_require__(1509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1220)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1054),
  /* template */
  __webpack_require__(1528),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1057),
  /* template */
  __webpack_require__(1588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
var moment = __webpack_require__(0);
var accounting = __webpack_require__(1070);


accounting.settings = {
  currency: {
    symbol: "$",
    format: "%v %s",
    decimal: ",",
    thousand: " ",
    precision: 2 },
  number: {
    precision: 0,
    thousand: ",",
    decimal: "."
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  return moment.unix(value).format('YYYY-MM-DD');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('round', function (value) {
  return accounting.formatMoney(value, { symbol: '' });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toCurrency', function (value) {
  return accounting.formatMoney(value);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('dateFormat', function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

  return moment.unix(value).format(format);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('s3Image', function (path) {
  return "https://s3.amazonaws.com/evsenscloud.com/img" + '/' + path;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toMinutes', function (minutes) {
  var sign = minutes < 0 ? "-" : "";
  var min = Math.floor(Math.abs(minutes));
  var sec = Math.floor(Math.abs(minutes) * 60 % 60);
  return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_session_Login__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_session_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_session_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_session_Register__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_session_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_session_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_session_Verify__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_session_Verify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_session_Verify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_errors_404__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_errors_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_errors_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_errors_500__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_errors_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_errors_500__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dashboard__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_session_ForgotPW__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_session_ForgotPW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_session_ForgotPW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_dashboard__ = __webpack_require__(1065);


















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    meta: { auth: false },
    redirect: '/dashboard'
  }, {
    path: '/connexion',
    name: 'login',
    meta: { auth: false },
    component: __WEBPACK_IMPORTED_MODULE_5__views_session_Login___default.a
  }, {
    path: '/inscription',
    name: 'register',
    meta: { auth: false },
    component: __WEBPACK_IMPORTED_MODULE_6__views_session_Register___default.a
  }, {
    path: '/verifier',
    name: 'verify',
    meta: { auth: false },
    component: __WEBPACK_IMPORTED_MODULE_7__views_session_Verify___default.a
  }, {
    path: '/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_10__Dashboard___default.a,
    children: __WEBPACK_IMPORTED_MODULE_12__router_dashboard__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/forgotPW',
    name: 'forgotPW',
    meta: { auth: false },
    component: __WEBPACK_IMPORTED_MODULE_11__views_session_ForgotPW___default.a
  }, { path: "/500", component: __WEBPACK_IMPORTED_MODULE_9__views_errors_500___default.a, meta: { auth: false } }, { path: "/404", component: __WEBPACK_IMPORTED_MODULE_8__views_errors_404___default.a, meta: { auth: false } }, { path: "*", component: __WEBPACK_IMPORTED_MODULE_8__views_errors_404___default.a, meta: { auth: false } }]
});

router.onError(function (error) {
  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log('Error', error.message);
  }
});

var checkDevices = function checkDevices() {
  __WEBPACK_IMPORTED_MODULE_3__stores__["a" /* default */].dispatch('devicesStore/devices').then(function (response) {
    if (response.data && response.data.length > 0) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
    }
  });
};

router.beforeEach(function (to, from, next) {
  if (to.meta.auth && __WEBPACK_IMPORTED_MODULE_3__stores__["a" /* default */].state.sessionStore.authToken == '' && __WEBPACK_IMPORTED_MODULE_3__stores__["a" /* default */].state.sessionStore.idToken == '') {
    __WEBPACK_IMPORTED_MODULE_3__stores__["a" /* default */].dispatch('sessionStore/checkLocalStorageForKeys').then(next).catch(function () {
      next({ path: '/connexion' });
    });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

(function (factory) {
	if (typeof define === "function" && __webpack_require__(67)) {
		define(["jquery"], factory);
	} else if ((typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) === 'object') {
		factory(__webpack_require__(147));
	} else {
		factory(jQuery);
	}
})(function ($, undefined) {

	function UTCDate() {
		return new Date(Date.UTC.apply(Date, arguments));
	}
	function UTCToday() {
		var today = new Date();
		return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
	}
	function isUTCEquals(date1, date2) {
		return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCDate() === date2.getUTCDate();
	}
	function alias(method) {
		return function () {
			return this[method].apply(this, arguments);
		};
	}
	function isValidDate(d) {
		return d && !isNaN(d.getTime());
	}

	var DateArray = function () {
		var extras = {
			get: function get(i) {
				return this.slice(i)[0];
			},
			contains: function contains(d) {
				var val = d && d.valueOf();
				for (var i = 0, l = this.length; i < l; i++) {
					if (this[i].valueOf() === val) return i;
				}return -1;
			},
			remove: function remove(i) {
				this.splice(i, 1);
			},
			replace: function replace(new_array) {
				if (!new_array) return;
				if (!$.isArray(new_array)) new_array = [new_array];
				this.clear();
				this.push.apply(this, new_array);
			},
			clear: function clear() {
				this.length = 0;
			},
			copy: function copy() {
				var a = new DateArray();
				a.replace(this);
				return a;
			}
		};

		return function () {
			var a = [];
			a.push.apply(a, arguments);
			$.extend(a, extras);
			return a;
		};
	}();

	var Datepicker = function Datepicker(element, options) {
		$(element).data('datepicker', this);
		this._process_options(options);

		this.dates = new DateArray();
		this.viewDate = this.o.defaultViewDate;
		this.focusDate = null;

		this.element = $(element);
		this.isInput = this.element.is('input');
		this.inputField = this.isInput ? this.element : this.element.find('input');
		this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
		this.hasInput = this.component && this.inputField.length;
		if (this.component && this.component.length === 0) this.component = false;
		this.isInline = !this.component && this.element.is('div');

		this.picker = $(DPGlobal.template);

		if (this._check_template(this.o.templates.leftArrow)) {
			this.picker.find('.prev').html(this.o.templates.leftArrow);
		}
		if (this._check_template(this.o.templates.rightArrow)) {
			this.picker.find('.next').html(this.o.templates.rightArrow);
		}

		this._buildEvents();
		this._attachEvents();

		if (this.isInline) {
			this.picker.addClass('datepicker-inline').appendTo(this.element);
		} else {
			this.picker.addClass('datepicker-dropdown dropdown-menu');
		}

		if (this.o.rtl) {
			this.picker.addClass('datepicker-rtl');
		}

		this.viewMode = this.o.startView;

		if (this.o.calendarWeeks) this.picker.find('thead .datepicker-title, tfoot .today, tfoot .clear').attr('colspan', function (i, val) {
			return parseInt(val) + 1;
		});

		this._allow_update = false;

		this.setStartDate(this._o.startDate);
		this.setEndDate(this._o.endDate);
		this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);
		this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted);
		this.setDatesDisabled(this.o.datesDisabled);

		this.fillDow();
		this.fillMonths();

		this._allow_update = true;

		this.update();
		this.showMode();

		if (this.isInline) {
			this.show();
		}
	};

	Datepicker.prototype = {
		constructor: Datepicker,

		_resolveViewName: function _resolveViewName(view, default_value) {
			if (view === 0 || view === 'days' || view === 'month') {
				return 0;
			}
			if (view === 1 || view === 'months' || view === 'year') {
				return 1;
			}
			if (view === 2 || view === 'years' || view === 'decade') {
				return 2;
			}
			if (view === 3 || view === 'decades' || view === 'century') {
				return 3;
			}
			if (view === 4 || view === 'centuries' || view === 'millennium') {
				return 4;
			}
			return default_value === undefined ? false : default_value;
		},

		_check_template: function _check_template(tmp) {
			try {
				if (tmp === undefined || tmp === "") {
					return false;
				}

				if ((tmp.match(/[<>]/g) || []).length <= 0) {
					return true;
				}

				var jDom = $(tmp);
				return jDom.length > 0;
			} catch (ex) {
				return false;
			}
		},

		_process_options: function _process_options(opts) {
			this._o = $.extend({}, this._o, opts);

			var o = this.o = $.extend({}, this._o);

			var lang = o.language;
			if (!dates[lang]) {
				lang = lang.split('-')[0];
				if (!dates[lang]) lang = defaults.language;
			}
			o.language = lang;

			o.startView = this._resolveViewName(o.startView, 0);
			o.minViewMode = this._resolveViewName(o.minViewMode, 0);
			o.maxViewMode = this._resolveViewName(o.maxViewMode, 4);

			o.startView = Math.min(o.startView, o.maxViewMode);
			o.startView = Math.max(o.startView, o.minViewMode);

			if (o.multidate !== true) {
				o.multidate = Number(o.multidate) || false;
				if (o.multidate !== false) o.multidate = Math.max(0, o.multidate);
			}
			o.multidateSeparator = String(o.multidateSeparator);

			o.weekStart %= 7;
			o.weekEnd = (o.weekStart + 6) % 7;

			var format = DPGlobal.parseFormat(o.format);
			if (o.startDate !== -Infinity) {
				if (!!o.startDate) {
					if (o.startDate instanceof Date) o.startDate = this._local_to_utc(this._zero_time(o.startDate));else o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
				} else {
					o.startDate = -Infinity;
				}
			}
			if (o.endDate !== Infinity) {
				if (!!o.endDate) {
					if (o.endDate instanceof Date) o.endDate = this._local_to_utc(this._zero_time(o.endDate));else o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
				} else {
					o.endDate = Infinity;
				}
			}

			o.daysOfWeekDisabled = o.daysOfWeekDisabled || [];
			if (!$.isArray(o.daysOfWeekDisabled)) o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
			o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function (d) {
				return parseInt(d, 10);
			});

			o.daysOfWeekHighlighted = o.daysOfWeekHighlighted || [];
			if (!$.isArray(o.daysOfWeekHighlighted)) o.daysOfWeekHighlighted = o.daysOfWeekHighlighted.split(/[,\s]*/);
			o.daysOfWeekHighlighted = $.map(o.daysOfWeekHighlighted, function (d) {
				return parseInt(d, 10);
			});

			o.datesDisabled = o.datesDisabled || [];
			if (!$.isArray(o.datesDisabled)) {
				o.datesDisabled = [o.datesDisabled];
			}
			o.datesDisabled = $.map(o.datesDisabled, function (d) {
				return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
			});

			var plc = String(o.orientation).toLowerCase().split(/\s+/g),
			    _plc = o.orientation.toLowerCase();
			plc = $.grep(plc, function (word) {
				return (/^auto|left|right|top|bottom$/.test(word)
				);
			});
			o.orientation = { x: 'auto', y: 'auto' };
			if (!_plc || _plc === 'auto') ;else if (plc.length === 1) {
					switch (plc[0]) {
						case 'top':
						case 'bottom':
							o.orientation.y = plc[0];
							break;
						case 'left':
						case 'right':
							o.orientation.x = plc[0];
							break;
					}
				} else {
					_plc = $.grep(plc, function (word) {
						return (/^left|right$/.test(word)
						);
					});
					o.orientation.x = _plc[0] || 'auto';

					_plc = $.grep(plc, function (word) {
						return (/^top|bottom$/.test(word)
						);
					});
					o.orientation.y = _plc[0] || 'auto';
				}
			if (o.defaultViewDate) {
				var year = o.defaultViewDate.year || new Date().getFullYear();
				var month = o.defaultViewDate.month || 0;
				var day = o.defaultViewDate.day || 1;
				o.defaultViewDate = UTCDate(year, month, day);
			} else {
				o.defaultViewDate = UTCToday();
			}
		},
		_events: [],
		_secondaryEvents: [],
		_applyEvents: function _applyEvents(evs) {
			for (var i = 0, el, ch, ev; i < evs.length; i++) {
				el = evs[i][0];
				if (evs[i].length === 2) {
					ch = undefined;
					ev = evs[i][1];
				} else if (evs[i].length === 3) {
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.on(ev, ch);
			}
		},
		_unapplyEvents: function _unapplyEvents(evs) {
			for (var i = 0, el, ev, ch; i < evs.length; i++) {
				el = evs[i][0];
				if (evs[i].length === 2) {
					ch = undefined;
					ev = evs[i][1];
				} else if (evs[i].length === 3) {
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.off(ev, ch);
			}
		},
		_buildEvents: function _buildEvents() {
			var events = {
				keyup: $.proxy(function (e) {
					if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1) this.update();
				}, this),
				keydown: $.proxy(this.keydown, this),
				paste: $.proxy(this.paste, this)
			};

			if (this.o.showOnFocus === true) {
				events.focus = $.proxy(this.show, this);
			}

			if (this.isInput) {
				this._events = [[this.element, events]];
			} else if (this.component && this.hasInput) {
				this._events = [[this.inputField, events], [this.component, {
					click: $.proxy(this.show, this)
				}]];
			} else {
				this._events = [[this.element, {
					click: $.proxy(this.show, this),
					keydown: $.proxy(this.keydown, this)
				}]];
			}
			this._events.push([this.element, '*', {
				blur: $.proxy(function (e) {
					this._focused_from = e.target;
				}, this)
			}], [this.element, {
				blur: $.proxy(function (e) {
					this._focused_from = e.target;
				}, this)
			}]);

			if (this.o.immediateUpdates) {
				this._events.push([this.element, {
					'changeYear changeMonth': $.proxy(function (e) {
						this.update(e.date);
					}, this)
				}]);
			}

			this._secondaryEvents = [[this.picker, {
				click: $.proxy(this.click, this)
			}], [$(window), {
				resize: $.proxy(this.place, this)
			}], [$(document), {
				mousedown: $.proxy(function (e) {
					if (!(this.element.is(e.target) || this.element.find(e.target).length || this.picker.is(e.target) || this.picker.find(e.target).length || this.isInline)) {
						this.hide();
					}
				}, this)
			}]];
		},
		_attachEvents: function _attachEvents() {
			this._detachEvents();
			this._applyEvents(this._events);
		},
		_detachEvents: function _detachEvents() {
			this._unapplyEvents(this._events);
		},
		_attachSecondaryEvents: function _attachSecondaryEvents() {
			this._detachSecondaryEvents();
			this._applyEvents(this._secondaryEvents);
		},
		_detachSecondaryEvents: function _detachSecondaryEvents() {
			this._unapplyEvents(this._secondaryEvents);
		},
		_trigger: function _trigger(event, altdate) {
			var date = altdate || this.dates.get(-1),
			    local_date = this._utc_to_local(date);

			this.element.trigger({
				type: event,
				date: local_date,
				dates: $.map(this.dates, this._utc_to_local),
				format: $.proxy(function (ix, format) {
					if (arguments.length === 0) {
						ix = this.dates.length - 1;
						format = this.o.format;
					} else if (typeof ix === 'string') {
						format = ix;
						ix = this.dates.length - 1;
					}
					format = format || this.o.format;
					var date = this.dates.get(ix);
					return DPGlobal.formatDate(date, format, this.o.language);
				}, this)
			});
		},

		show: function show() {
			if (this.inputField.prop('disabled') || this.inputField.prop('readonly') && this.o.enableOnReadonly === false) return;
			if (!this.isInline) this.picker.appendTo(this.o.container);
			this.place();
			this.picker.show();
			this._attachSecondaryEvents();
			this._trigger('show');
			if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
				$(this.element).blur();
			}
			return this;
		},

		hide: function hide() {
			if (this.isInline || !this.picker.is(':visible')) return this;
			this.focusDate = null;
			this.picker.hide().detach();
			this._detachSecondaryEvents();
			this.viewMode = this.o.startView;
			this.showMode();

			if (this.o.forceParse && this.inputField.val()) this.setValue();
			this._trigger('hide');
			return this;
		},

		destroy: function destroy() {
			this.hide();
			this._detachEvents();
			this._detachSecondaryEvents();
			this.picker.remove();
			delete this.element.data().datepicker;
			if (!this.isInput) {
				delete this.element.data().date;
			}
			return this;
		},

		paste: function paste(evt) {
			var dateString;
			if (evt.originalEvent.clipboardData && evt.originalEvent.clipboardData.types && $.inArray('text/plain', evt.originalEvent.clipboardData.types) !== -1) {
				dateString = evt.originalEvent.clipboardData.getData('text/plain');
			} else if (window.clipboardData) {
				dateString = window.clipboardData.getData('Text');
			} else {
				return;
			}
			this.setDate(dateString);
			this.update();
			evt.preventDefault();
		},

		_utc_to_local: function _utc_to_local(utc) {
			return utc && new Date(utc.getTime() + utc.getTimezoneOffset() * 60000);
		},
		_local_to_utc: function _local_to_utc(local) {
			return local && new Date(local.getTime() - local.getTimezoneOffset() * 60000);
		},
		_zero_time: function _zero_time(local) {
			return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
		},
		_zero_utc_time: function _zero_utc_time(utc) {
			return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
		},

		getDates: function getDates() {
			return $.map(this.dates, this._utc_to_local);
		},

		getUTCDates: function getUTCDates() {
			return $.map(this.dates, function (d) {
				return new Date(d);
			});
		},

		getDate: function getDate() {
			return this._utc_to_local(this.getUTCDate());
		},

		getUTCDate: function getUTCDate() {
			var selected_date = this.dates.get(-1);
			if (typeof selected_date !== 'undefined') {
				return new Date(selected_date);
			} else {
				return null;
			}
		},

		clearDates: function clearDates() {
			if (this.inputField) {
				this.inputField.val('');
			}

			this.update();
			this._trigger('changeDate');

			if (this.o.autoclose) {
				this.hide();
			}
		},
		setDates: function setDates() {
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, args);
			this._trigger('changeDate');
			this.setValue();
			return this;
		},

		setUTCDates: function setUTCDates() {
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, $.map(args, this._utc_to_local));
			this._trigger('changeDate');
			this.setValue();
			return this;
		},

		setDate: alias('setDates'),
		setUTCDate: alias('setUTCDates'),
		remove: alias('destroy'),

		setValue: function setValue() {
			var formatted = this.getFormattedDate();
			this.inputField.val(formatted);
			return this;
		},

		getFormattedDate: function getFormattedDate(format) {
			if (format === undefined) format = this.o.format;

			var lang = this.o.language;
			return $.map(this.dates, function (d) {
				return DPGlobal.formatDate(d, format, lang);
			}).join(this.o.multidateSeparator);
		},

		getStartDate: function getStartDate() {
			return this.o.startDate;
		},

		setStartDate: function setStartDate(startDate) {
			this._process_options({ startDate: startDate });
			this.update();
			this.updateNavArrows();
			return this;
		},

		getEndDate: function getEndDate() {
			return this.o.endDate;
		},

		setEndDate: function setEndDate(endDate) {
			this._process_options({ endDate: endDate });
			this.update();
			this.updateNavArrows();
			return this;
		},

		setDaysOfWeekDisabled: function setDaysOfWeekDisabled(daysOfWeekDisabled) {
			this._process_options({ daysOfWeekDisabled: daysOfWeekDisabled });
			this.update();
			this.updateNavArrows();
			return this;
		},

		setDaysOfWeekHighlighted: function setDaysOfWeekHighlighted(daysOfWeekHighlighted) {
			this._process_options({ daysOfWeekHighlighted: daysOfWeekHighlighted });
			this.update();
			return this;
		},

		setDatesDisabled: function setDatesDisabled(datesDisabled) {
			this._process_options({ datesDisabled: datesDisabled });
			this.update();
			this.updateNavArrows();
		},

		place: function place() {
			if (this.isInline) return this;
			var calendarWidth = this.picker.outerWidth(),
			    calendarHeight = this.picker.outerHeight(),
			    visualPadding = 10,
			    container = $(this.o.container),
			    windowWidth = container.width(),
			    scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
			    appendOffset = container.offset();

			var parentsZindex = [];
			this.element.parents().each(function () {
				var itemZIndex = $(this).css('z-index');
				if (itemZIndex !== 'auto' && itemZIndex !== 0) parentsZindex.push(parseInt(itemZIndex));
			});
			var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
			var offset = this.component ? this.component.parent().offset() : this.element.offset();
			var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
			var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
			var left = offset.left - appendOffset.left,
			    top = offset.top - appendOffset.top;

			if (this.o.container !== 'body') {
				top += scrollTop;
			}

			this.picker.removeClass('datepicker-orient-top datepicker-orient-bottom ' + 'datepicker-orient-right datepicker-orient-left');

			if (this.o.orientation.x !== 'auto') {
				this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
				if (this.o.orientation.x === 'right') left -= calendarWidth - width;
			} else {
					if (offset.left < 0) {
						this.picker.addClass('datepicker-orient-left');
						left -= offset.left - visualPadding;
					} else if (left + calendarWidth > windowWidth) {
						this.picker.addClass('datepicker-orient-right');
						left += width - calendarWidth;
					} else {
						this.picker.addClass('datepicker-orient-left');
					}
				}

			var yorient = this.o.orientation.y,
			    top_overflow;
			if (yorient === 'auto') {
				top_overflow = -scrollTop + top - calendarHeight;
				yorient = top_overflow < 0 ? 'bottom' : 'top';
			}

			this.picker.addClass('datepicker-orient-' + yorient);
			if (yorient === 'top') top -= calendarHeight + parseInt(this.picker.css('padding-top'));else top += height;

			if (this.o.rtl) {
				var right = windowWidth - (left + width);
				this.picker.css({
					top: top,
					right: right,
					zIndex: zIndex
				});
			} else {
				this.picker.css({
					top: top,
					left: left,
					zIndex: zIndex
				});
			}
			return this;
		},

		_allow_update: true,
		update: function update() {
			if (!this._allow_update) return this;

			var oldDates = this.dates.copy(),
			    dates = [],
			    fromArgs = false;
			if (arguments.length) {
				$.each(arguments, $.proxy(function (i, date) {
					if (date instanceof Date) date = this._local_to_utc(date);
					dates.push(date);
				}, this));
				fromArgs = true;
			} else {
				dates = this.isInput ? this.element.val() : this.element.data('date') || this.inputField.val();
				if (dates && this.o.multidate) dates = dates.split(this.o.multidateSeparator);else dates = [dates];
				delete this.element.data().date;
			}

			dates = $.map(dates, $.proxy(function (date) {
				return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
			}, this));
			dates = $.grep(dates, $.proxy(function (date) {
				return !this.dateWithinRange(date) || !date;
			}, this), true);
			this.dates.replace(dates);

			if (this.dates.length) this.viewDate = new Date(this.dates.get(-1));else if (this.viewDate < this.o.startDate) this.viewDate = new Date(this.o.startDate);else if (this.viewDate > this.o.endDate) this.viewDate = new Date(this.o.endDate);else this.viewDate = this.o.defaultViewDate;

			if (fromArgs) {
				this.setValue();
			} else if (dates.length) {
				if (String(oldDates) !== String(this.dates)) this._trigger('changeDate');
			}
			if (!this.dates.length && oldDates.length) this._trigger('clearDate');

			this.fill();
			this.element.change();
			return this;
		},

		fillDow: function fillDow() {
			var dowCnt = this.o.weekStart,
			    html = '<tr>';
			if (this.o.calendarWeeks) {
				this.picker.find('.datepicker-days .datepicker-switch').attr('colspan', function (i, val) {
					return parseInt(val) + 1;
				});
				html += '<th class="cw">&#160;</th>';
			}
			while (dowCnt < this.o.weekStart + 7) {
				html += '<th class="dow';
				if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) > -1) html += ' disabled';
				html += '">' + dates[this.o.language].daysMin[dowCnt++ % 7] + '</th>';
			}
			html += '</tr>';
			this.picker.find('.datepicker-days thead').append(html);
		},

		fillMonths: function fillMonths() {
			var localDate = this._utc_to_local(this.viewDate);
			var html = '',
			    i = 0;
			while (i < 12) {
				var focused = localDate && localDate.getMonth() === i ? ' focused' : '';
				html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i++] + '</span>';
			}
			this.picker.find('.datepicker-months td').html(html);
		},

		setRange: function setRange(range) {
			if (!range || !range.length) delete this.range;else this.range = $.map(range, function (d) {
				return d.valueOf();
			});
			this.fill();
		},

		getClassNames: function getClassNames(date) {
			var cls = [],
			    year = this.viewDate.getUTCFullYear(),
			    month = this.viewDate.getUTCMonth(),
			    today = new Date();
			if (date.getUTCFullYear() < year || date.getUTCFullYear() === year && date.getUTCMonth() < month) {
				cls.push('old');
			} else if (date.getUTCFullYear() > year || date.getUTCFullYear() === year && date.getUTCMonth() > month) {
				cls.push('new');
			}
			if (this.focusDate && date.valueOf() === this.focusDate.valueOf()) cls.push('focused');

			if (this.o.todayHighlight && date.getUTCFullYear() === today.getFullYear() && date.getUTCMonth() === today.getMonth() && date.getUTCDate() === today.getDate()) {
				cls.push('today');
			}
			if (this.dates.contains(date) !== -1) cls.push('active');
			if (!this.dateWithinRange(date)) {
				cls.push('disabled');
			}
			if (this.dateIsDisabled(date)) {
				cls.push('disabled', 'disabled-date');
			}
			if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1) {
				cls.push('highlighted');
			}

			if (this.range) {
				if (date > this.range[0] && date < this.range[this.range.length - 1]) {
					cls.push('range');
				}
				if ($.inArray(date.valueOf(), this.range) !== -1) {
					cls.push('selected');
				}
				if (date.valueOf() === this.range[0]) {
					cls.push('range-start');
				}
				if (date.valueOf() === this.range[this.range.length - 1]) {
					cls.push('range-end');
				}
			}
			return cls;
		},

		_fill_yearsView: function _fill_yearsView(selector, cssClass, factor, step, currentYear, startYear, endYear, callback) {
			var html, view, year, steps, startStep, endStep, thisYear, i, classes, tooltip, before;

			html = '';
			view = this.picker.find(selector);
			year = parseInt(currentYear / factor, 10) * factor;
			startStep = parseInt(startYear / step, 10) * step;
			endStep = parseInt(endYear / step, 10) * step;
			steps = $.map(this.dates, function (d) {
				return parseInt(d.getUTCFullYear() / step, 10) * step;
			});

			view.find('.datepicker-switch').text(year + '-' + (year + step * 9));

			thisYear = year - step;
			for (i = -1; i < 11; i += 1) {
				classes = [cssClass];
				tooltip = null;

				if (i === -1) {
					classes.push('old');
				} else if (i === 10) {
					classes.push('new');
				}
				if ($.inArray(thisYear, steps) !== -1) {
					classes.push('active');
				}
				if (thisYear < startStep || thisYear > endStep) {
					classes.push('disabled');
				}
				if (thisYear === this.viewDate.getFullYear()) {
					classes.push('focused');
				}

				if (callback !== $.noop) {
					before = callback(new Date(thisYear, 0, 1));
					if (before === undefined) {
						before = {};
					} else if (typeof before === 'boolean') {
						before = { enabled: before };
					} else if (typeof before === 'string') {
						before = { classes: before };
					}
					if (before.enabled === false) {
						classes.push('disabled');
					}
					if (before.classes) {
						classes = classes.concat(before.classes.split(/\s+/));
					}
					if (before.tooltip) {
						tooltip = before.tooltip;
					}
				}

				html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + thisYear + '</span>';
				thisYear += step;
			}
			view.find('td').html(html);
		},

		fill: function fill() {
			var d = new Date(this.viewDate),
			    year = d.getUTCFullYear(),
			    month = d.getUTCMonth(),
			    startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
			    startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
			    endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
			    endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
			    todaytxt = dates[this.o.language].today || dates['en'].today || '',
			    cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
			    titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
			    tooltip,
			    before;
			if (isNaN(year) || isNaN(month)) return;
			this.picker.find('.datepicker-days .datepicker-switch').text(DPGlobal.formatDate(d, titleFormat, this.o.language));
			this.picker.find('tfoot .today').text(todaytxt).toggle(this.o.todayBtn !== false);
			this.picker.find('tfoot .clear').text(cleartxt).toggle(this.o.clearBtn !== false);
			this.picker.find('thead .datepicker-title').text(this.o.title).toggle(this.o.title !== '');
			this.updateNavArrows();
			this.fillMonths();
			var prevMonth = UTCDate(year, month - 1, 28),
			    day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
			prevMonth.setUTCDate(day);
			prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7) % 7);
			var nextMonth = new Date(prevMonth);
			if (prevMonth.getUTCFullYear() < 100) {
				nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
			}
			nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
			nextMonth = nextMonth.valueOf();
			var html = [];
			var clsName;
			while (prevMonth.valueOf() < nextMonth) {
				if (prevMonth.getUTCDay() === this.o.weekStart) {
					html.push('<tr>');
					if (this.o.calendarWeeks) {
						var ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
						    th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
						    yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 864e5),
						    calWeek = (th - yth) / 864e5 / 7 + 1;
						html.push('<td class="cw">' + calWeek + '</td>');
					}
				}
				clsName = this.getClassNames(prevMonth);
				clsName.push('day');

				if (this.o.beforeShowDay !== $.noop) {
					before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
					if (before === undefined) before = {};else if (typeof before === 'boolean') before = { enabled: before };else if (typeof before === 'string') before = { classes: before };
					if (before.enabled === false) clsName.push('disabled');
					if (before.classes) clsName = clsName.concat(before.classes.split(/\s+/));
					if (before.tooltip) tooltip = before.tooltip;
				}

				if ($.isFunction($.uniqueSort)) {
					clsName = $.uniqueSort(clsName);
				} else {
					clsName = $.unique(clsName);
				}

				html.push('<td class="' + clsName.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + prevMonth.getUTCDate() + '</td>');
				tooltip = null;
				if (prevMonth.getUTCDay() === this.o.weekEnd) {
					html.push('</tr>');
				}
				prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
			}
			this.picker.find('.datepicker-days tbody').empty().append(html.join(''));

			var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
			var months = this.picker.find('.datepicker-months').find('.datepicker-switch').text(this.o.maxViewMode < 2 ? monthsTitle : year).end().find('span').removeClass('active');

			$.each(this.dates, function (i, d) {
				if (d.getUTCFullYear() === year) months.eq(d.getUTCMonth()).addClass('active');
			});

			if (year < startYear || year > endYear) {
				months.addClass('disabled');
			}
			if (year === startYear) {
				months.slice(0, startMonth).addClass('disabled');
			}
			if (year === endYear) {
				months.slice(endMonth + 1).addClass('disabled');
			}

			if (this.o.beforeShowMonth !== $.noop) {
				var that = this;
				$.each(months, function (i, month) {
					var moDate = new Date(year, i, 1);
					var before = that.o.beforeShowMonth(moDate);
					if (before === undefined) before = {};else if (typeof before === 'boolean') before = { enabled: before };else if (typeof before === 'string') before = { classes: before };
					if (before.enabled === false && !$(month).hasClass('disabled')) $(month).addClass('disabled');
					if (before.classes) $(month).addClass(before.classes);
					if (before.tooltip) $(month).prop('title', before.tooltip);
				});
			}

			this._fill_yearsView('.datepicker-years', 'year', 10, 1, year, startYear, endYear, this.o.beforeShowYear);

			this._fill_yearsView('.datepicker-decades', 'decade', 100, 10, year, startYear, endYear, this.o.beforeShowDecade);

			this._fill_yearsView('.datepicker-centuries', 'century', 1000, 100, year, startYear, endYear, this.o.beforeShowCentury);
		},

		updateNavArrows: function updateNavArrows() {
			if (!this._allow_update) return;

			var d = new Date(this.viewDate),
			    year = d.getUTCFullYear(),
			    month = d.getUTCMonth();
			switch (this.viewMode) {
				case 0:
					if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()) {
						this.picker.find('.prev').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.prev').css({ visibility: 'visible' });
					}
					if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()) {
						this.picker.find('.next').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.next').css({ visibility: 'visible' });
					}
					break;
				case 1:
				case 2:
				case 3:
				case 4:
					if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2) {
						this.picker.find('.prev').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.prev').css({ visibility: 'visible' });
					}
					if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2) {
						this.picker.find('.next').css({ visibility: 'hidden' });
					} else {
						this.picker.find('.next').css({ visibility: 'visible' });
					}
					break;
			}
		},

		click: function click(e) {
			e.preventDefault();
			e.stopPropagation();

			var target, dir, day, year, month, monthChanged, yearChanged;
			target = $(e.target);

			if (target.hasClass('datepicker-switch')) {
				this.showMode(1);
			}

			var navArrow = target.closest('.prev, .next');
			if (navArrow.length > 0) {
				dir = DPGlobal.modes[this.viewMode].navStep * (navArrow.hasClass('prev') ? -1 : 1);
				if (this.viewMode === 0) {
					this.viewDate = this.moveMonth(this.viewDate, dir);
					this._trigger('changeMonth', this.viewDate);
				} else {
					this.viewDate = this.moveYear(this.viewDate, dir);
					if (this.viewMode === 1) {
						this._trigger('changeYear', this.viewDate);
					}
				}
				this.fill();
			}

			if (target.hasClass('today') && !target.hasClass('day')) {
				this.showMode(-2);
				this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
			}

			if (target.hasClass('clear')) {
				this.clearDates();
			}

			if (!target.hasClass('disabled')) {
				if (target.hasClass('day')) {
					day = parseInt(target.text(), 10) || 1;
					year = this.viewDate.getUTCFullYear();
					month = this.viewDate.getUTCMonth();

					if (target.hasClass('old')) {
						if (month === 0) {
							month = 11;
							year = year - 1;
							monthChanged = true;
							yearChanged = true;
						} else {
							month = month - 1;
							monthChanged = true;
						}
					}

					if (target.hasClass('new')) {
						if (month === 11) {
							month = 0;
							year = year + 1;
							monthChanged = true;
							yearChanged = true;
						} else {
							month = month + 1;
							monthChanged = true;
						}
					}
					this._setDate(UTCDate(year, month, day));
					if (yearChanged) {
						this._trigger('changeYear', this.viewDate);
					}
					if (monthChanged) {
						this._trigger('changeMonth', this.viewDate);
					}
				}

				if (target.hasClass('month')) {
					this.viewDate.setUTCDate(1);
					day = 1;
					month = target.parent().find('span').index(target);
					year = this.viewDate.getUTCFullYear();
					this.viewDate.setUTCMonth(month);
					this._trigger('changeMonth', this.viewDate);
					if (this.o.minViewMode === 1) {
						this._setDate(UTCDate(year, month, day));
						this.showMode();
					} else {
						this.showMode(-1);
					}
					this.fill();
				}

				if (target.hasClass('year') || target.hasClass('decade') || target.hasClass('century')) {
					this.viewDate.setUTCDate(1);

					day = 1;
					month = 0;
					year = parseInt(target.text(), 10) || 0;
					this.viewDate.setUTCFullYear(year);

					if (target.hasClass('year')) {
						this._trigger('changeYear', this.viewDate);
						if (this.o.minViewMode === 2) {
							this._setDate(UTCDate(year, month, day));
						}
					}
					if (target.hasClass('decade')) {
						this._trigger('changeDecade', this.viewDate);
						if (this.o.minViewMode === 3) {
							this._setDate(UTCDate(year, month, day));
						}
					}
					if (target.hasClass('century')) {
						this._trigger('changeCentury', this.viewDate);
						if (this.o.minViewMode === 4) {
							this._setDate(UTCDate(year, month, day));
						}
					}

					this.showMode(-1);
					this.fill();
				}
			}

			if (this.picker.is(':visible') && this._focused_from) {
				$(this._focused_from).focus();
			}
			delete this._focused_from;
		},

		_toggle_multidate: function _toggle_multidate(date) {
			var ix = this.dates.contains(date);
			if (!date) {
				this.dates.clear();
			}

			if (ix !== -1) {
				if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive) {
					this.dates.remove(ix);
				}
			} else if (this.o.multidate === false) {
				this.dates.clear();
				this.dates.push(date);
			} else {
				this.dates.push(date);
			}

			if (typeof this.o.multidate === 'number') while (this.dates.length > this.o.multidate) {
				this.dates.remove(0);
			}
		},

		_setDate: function _setDate(date, which) {
			if (!which || which === 'date') this._toggle_multidate(date && new Date(date));
			if (!which || which === 'view') this.viewDate = date && new Date(date);

			this.fill();
			this.setValue();
			if (!which || which !== 'view') {
				this._trigger('changeDate');
			}
			if (this.inputField) {
				this.inputField.change();
			}
			if (this.o.autoclose && (!which || which === 'date')) {
				this.hide();
			}
		},

		moveDay: function moveDay(date, dir) {
			var newDate = new Date(date);
			newDate.setUTCDate(date.getUTCDate() + dir);

			return newDate;
		},

		moveWeek: function moveWeek(date, dir) {
			return this.moveDay(date, dir * 7);
		},

		moveMonth: function moveMonth(date, dir) {
			if (!isValidDate(date)) return this.o.defaultViewDate;
			if (!dir) return date;
			var new_date = new Date(date.valueOf()),
			    day = new_date.getUTCDate(),
			    month = new_date.getUTCMonth(),
			    mag = Math.abs(dir),
			    new_month,
			    test;
			dir = dir > 0 ? 1 : -1;
			if (mag === 1) {
				test = dir === -1 ? function () {
					return new_date.getUTCMonth() === month;
				} : function () {
					return new_date.getUTCMonth() !== new_month;
				};
				new_month = month + dir;
				new_date.setUTCMonth(new_month);

				if (new_month < 0 || new_month > 11) new_month = (new_month + 12) % 12;
			} else {
				for (var i = 0; i < mag; i++) {
					new_date = this.moveMonth(new_date, dir);
				}
				new_month = new_date.getUTCMonth();
				new_date.setUTCDate(day);
				test = function test() {
					return new_month !== new_date.getUTCMonth();
				};
			}

			while (test()) {
				new_date.setUTCDate(--day);
				new_date.setUTCMonth(new_month);
			}
			return new_date;
		},

		moveYear: function moveYear(date, dir) {
			return this.moveMonth(date, dir * 12);
		},

		moveAvailableDate: function moveAvailableDate(date, dir, fn) {
			do {
				date = this[fn](date, dir);

				if (!this.dateWithinRange(date)) return false;

				fn = 'moveDay';
			} while (this.dateIsDisabled(date));

			return date;
		},

		weekOfDateIsDisabled: function weekOfDateIsDisabled(date) {
			return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
		},

		dateIsDisabled: function dateIsDisabled(date) {
			return this.weekOfDateIsDisabled(date) || $.grep(this.o.datesDisabled, function (d) {
				return isUTCEquals(date, d);
			}).length > 0;
		},

		dateWithinRange: function dateWithinRange(date) {
			return date >= this.o.startDate && date <= this.o.endDate;
		},

		keydown: function keydown(e) {
			if (!this.picker.is(':visible')) {
				if (e.keyCode === 40 || e.keyCode === 27) {
					this.show();
					e.stopPropagation();
				}
				return;
			}
			var dateChanged = false,
			    dir,
			    newViewDate,
			    focusDate = this.focusDate || this.viewDate;
			switch (e.keyCode) {
				case 27:
					if (this.focusDate) {
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
					} else this.hide();
					e.preventDefault();
					e.stopPropagation();
					break;
				case 37:
				case 38:
				case 39:
				case 40:
					if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7) break;
					dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
					if (this.viewMode === 0) {
						if (e.ctrlKey) {
							newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');

							if (newViewDate) this._trigger('changeYear', this.viewDate);
						} else if (e.shiftKey) {
							newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');

							if (newViewDate) this._trigger('changeMonth', this.viewDate);
						} else if (e.keyCode === 37 || e.keyCode === 39) {
							newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
						} else if (!this.weekOfDateIsDisabled(focusDate)) {
							newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
						}
					} else if (this.viewMode === 1) {
						if (e.keyCode === 38 || e.keyCode === 40) {
							dir = dir * 4;
						}
						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
					} else if (this.viewMode === 2) {
						if (e.keyCode === 38 || e.keyCode === 40) {
							dir = dir * 4;
						}
						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
					}
					if (newViewDate) {
						this.focusDate = this.viewDate = newViewDate;
						this.setValue();
						this.fill();
						e.preventDefault();
					}
					break;
				case 13:
					if (!this.o.forceParse) break;
					focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
					if (this.o.keyboardNavigation) {
						this._toggle_multidate(focusDate);
						dateChanged = true;
					}
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.setValue();
					this.fill();
					if (this.picker.is(':visible')) {
						e.preventDefault();
						e.stopPropagation();
						if (this.o.autoclose) this.hide();
					}
					break;
				case 9:
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.fill();
					this.hide();
					break;
			}
			if (dateChanged) {
				if (this.dates.length) this._trigger('changeDate');else this._trigger('clearDate');
				if (this.inputField) {
					this.inputField.change();
				}
			}
		},

		showMode: function showMode(dir) {
			if (dir) {
				this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + dir));
			}
			this.picker.children('div').hide().filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName).show();
			this.updateNavArrows();
		}
	};

	var DateRangePicker = function DateRangePicker(element, options) {
		$(element).data('datepicker', this);
		this.element = $(element);
		this.inputs = $.map(options.inputs, function (i) {
			return i.jquery ? i[0] : i;
		});
		delete options.inputs;

		datepickerPlugin.call($(this.inputs), options).on('changeDate', $.proxy(this.dateUpdated, this));

		this.pickers = $.map(this.inputs, function (i) {
			return $(i).data('datepicker');
		});
		this.updateDates();
	};
	DateRangePicker.prototype = {
		updateDates: function updateDates() {
			this.dates = $.map(this.pickers, function (i) {
				return i.getUTCDate();
			});
			this.updateRanges();
		},
		updateRanges: function updateRanges() {
			var range = $.map(this.dates, function (d) {
				return d.valueOf();
			});
			$.each(this.pickers, function (i, p) {
				p.setRange(range);
			});
		},
		dateUpdated: function dateUpdated(e) {
			if (this.updating) return;
			this.updating = true;

			var dp = $(e.target).data('datepicker');

			if (typeof dp === "undefined") {
				return;
			}

			var new_date = dp.getUTCDate(),
			    i = $.inArray(e.target, this.inputs),
			    j = i - 1,
			    k = i + 1,
			    l = this.inputs.length;
			if (i === -1) return;

			$.each(this.pickers, function (i, p) {
				if (!p.getUTCDate()) p.setUTCDate(new_date);
			});

			if (new_date < this.dates[j]) {
				while (j >= 0 && new_date < this.dates[j]) {
					this.pickers[j--].setUTCDate(new_date);
				}
			} else if (new_date > this.dates[k]) {
				while (k < l && new_date > this.dates[k]) {
					this.pickers[k++].setUTCDate(new_date);
				}
			}
			this.updateDates();

			delete this.updating;
		},
		remove: function remove() {
			$.map(this.pickers, function (p) {
				p.remove();
			});
			delete this.element.data().datepicker;
		}
	};

	function opts_from_el(el, prefix) {
		var data = $(el).data(),
		    out = {},
		    inkey,
		    replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
		prefix = new RegExp('^' + prefix.toLowerCase());
		function re_lower(_, a) {
			return a.toLowerCase();
		}
		for (var key in data) {
			if (prefix.test(key)) {
				inkey = key.replace(replace, re_lower);
				out[inkey] = data[key];
			}
		}return out;
	}

	function opts_from_locale(lang) {
		var out = {};

		if (!dates[lang]) {
			lang = lang.split('-')[0];
			if (!dates[lang]) return;
		}
		var d = dates[lang];
		$.each(locale_opts, function (i, k) {
			if (k in d) out[k] = d[k];
		});
		return out;
	}

	var old = $.fn.datepicker;
	var datepickerPlugin = function datepickerPlugin(option) {
		var args = Array.apply(null, arguments);
		args.shift();
		var internal_return;
		this.each(function () {
			var $this = $(this),
			    data = $this.data('datepicker'),
			    options = (typeof option === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === 'object' && option;
			if (!data) {
				var elopts = opts_from_el(this, 'date'),
				    xopts = $.extend({}, defaults, elopts, options),
				    locopts = opts_from_locale(xopts.language),
				    opts = $.extend({}, defaults, locopts, elopts, options);
				if ($this.hasClass('input-daterange') || opts.inputs) {
					$.extend(opts, {
						inputs: opts.inputs || $this.find('input').toArray()
					});
					data = new DateRangePicker(this, opts);
				} else {
					data = new Datepicker(this, opts);
				}
				$this.data('datepicker', data);
			}
			if (typeof option === 'string' && typeof data[option] === 'function') {
				internal_return = data[option].apply(data, args);
			}
		});

		if (internal_return === undefined || internal_return instanceof Datepicker || internal_return instanceof DateRangePicker) return this;

		if (this.length > 1) throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');else return internal_return;
	};
	$.fn.datepicker = datepickerPlugin;

	var defaults = $.fn.datepicker.defaults = {
		assumeNearbyYear: false,
		autoclose: false,
		beforeShowDay: $.noop,
		beforeShowMonth: $.noop,
		beforeShowYear: $.noop,
		beforeShowDecade: $.noop,
		beforeShowCentury: $.noop,
		calendarWeeks: false,
		clearBtn: false,
		toggleActive: false,
		daysOfWeekDisabled: [],
		daysOfWeekHighlighted: [],
		datesDisabled: [],
		endDate: Infinity,
		forceParse: true,
		format: 'mm/dd/yyyy',
		keyboardNavigation: true,
		language: 'en',
		minViewMode: 0,
		maxViewMode: 4,
		multidate: false,
		multidateSeparator: ',',
		orientation: "auto",
		rtl: false,
		startDate: -Infinity,
		startView: 0,
		todayBtn: false,
		todayHighlight: false,
		weekStart: 0,
		disableTouchKeyboard: false,
		enableOnReadonly: true,
		showOnFocus: true,
		zIndexOffset: 10,
		container: 'body',
		immediateUpdates: false,
		title: '',
		templates: {
			leftArrow: '&laquo;',
			rightArrow: '&raquo;'
		}
	};
	var locale_opts = $.fn.datepicker.locale_opts = ['format', 'rtl', 'weekStart'];
	$.fn.datepicker.Constructor = Datepicker;
	var dates = $.fn.datepicker.dates = {
		en: {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			today: "Today",
			clear: "Clear",
			titleFormat: "MM yyyy"
		}
	};

	var DPGlobal = {
		modes: [{
			clsName: 'days',
			navFnc: 'Month',
			navStep: 1
		}, {
			clsName: 'months',
			navFnc: 'FullYear',
			navStep: 1
		}, {
			clsName: 'years',
			navFnc: 'FullYear',
			navStep: 10
		}, {
			clsName: 'decades',
			navFnc: 'FullDecade',
			navStep: 100
		}, {
			clsName: 'centuries',
			navFnc: 'FullCentury',
			navStep: 1000
		}],
		isLeapYear: function isLeapYear(year) {
			return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
		},
		getDaysInMonth: function getDaysInMonth(year, month) {
			return [31, DPGlobal.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
		},
		validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
		nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
		parseFormat: function parseFormat(format) {
			if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function') return format;

			var separators = format.replace(this.validParts, '\0').split('\0'),
			    parts = format.match(this.validParts);
			if (!separators || !separators.length || !parts || parts.length === 0) {
				throw new Error("Invalid date format.");
			}
			return { separators: separators, parts: parts };
		},
		parseDate: function parseDate(date, format, language, assumeNearby) {
			if (!date) return undefined;
			if (date instanceof Date) return date;
			if (typeof format === 'string') format = DPGlobal.parseFormat(format);
			if (format.toValue) return format.toValue(date, format, language);
			var part_re = /([\-+]\d+)([dmwy])/,
			    parts = date.match(/([\-+]\d+)([dmwy])/g),
			    fn_map = {
				d: 'moveDay',
				m: 'moveMonth',
				w: 'moveWeek',
				y: 'moveYear'
			},
			    dateAliases = {
				yesterday: '-1d',
				today: '+0d',
				tomorrow: '+1d'
			},
			    part,
			    dir,
			    i,
			    fn;
			if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)) {
				date = new Date();
				for (i = 0; i < parts.length; i++) {
					part = part_re.exec(parts[i]);
					dir = parseInt(part[1]);
					fn = fn_map[part[2]];
					date = Datepicker.prototype[fn](date, dir);
				}
				return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
			}

			if (typeof dateAliases[date] !== 'undefined') {
				date = dateAliases[date];
				parts = date.match(/([\-+]\d+)([dmwy])/g);

				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)) {
					date = new Date();
					for (i = 0; i < parts.length; i++) {
						part = part_re.exec(parts[i]);
						dir = parseInt(part[1]);
						fn = fn_map[part[2]];
						date = Datepicker.prototype[fn](date, dir);
					}

					return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
				}
			}

			parts = date && date.match(this.nonpunctuation) || [];
			date = new Date();

			function applyNearbyYear(year, threshold) {
				if (threshold === true) threshold = 10;

				if (year < 100) {
					year += 2000;

					if (year > new Date().getFullYear() + threshold) {
						year -= 100;
					}
				}

				return year;
			}

			var parsed = {},
			    setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
			    setters_map = {
				yyyy: function yyyy(d, v) {
					return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
				},
				yy: function yy(d, v) {
					return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
				},
				m: function m(d, v) {
					if (isNaN(d)) return d;
					v -= 1;
					while (v < 0) {
						v += 12;
					}v %= 12;
					d.setUTCMonth(v);
					while (d.getUTCMonth() !== v) {
						d.setUTCDate(d.getUTCDate() - 1);
					}return d;
				},
				d: function d(_d, v) {
					return _d.setUTCDate(v);
				}
			},
			    val,
			    filtered;
			setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
			setters_map['dd'] = setters_map['d'];
			date = UTCToday();
			var fparts = format.parts.slice();

			if (parts.length !== fparts.length) {
				fparts = $(fparts).filter(function (i, p) {
					return $.inArray(p, setters_order) !== -1;
				}).toArray();
			}

			function match_part() {
				var m = this.slice(0, parts[i].length),
				    p = parts[i].slice(0, m.length);
				return m.toLowerCase() === p.toLowerCase();
			}
			if (parts.length === fparts.length) {
				var cnt;
				for (i = 0, cnt = fparts.length; i < cnt; i++) {
					val = parseInt(parts[i], 10);
					part = fparts[i];
					if (isNaN(val)) {
						switch (part) {
							case 'MM':
								filtered = $(dates[language].months).filter(match_part);
								val = $.inArray(filtered[0], dates[language].months) + 1;
								break;
							case 'M':
								filtered = $(dates[language].monthsShort).filter(match_part);
								val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
								break;
						}
					}
					parsed[part] = val;
				}
				var _date, s;
				for (i = 0; i < setters_order.length; i++) {
					s = setters_order[i];
					if (s in parsed && !isNaN(parsed[s])) {
						_date = new Date(date);
						setters_map[s](_date, parsed[s]);
						if (!isNaN(_date)) date = _date;
					}
				}
			}
			return date;
		},
		formatDate: function formatDate(date, format, language) {
			if (!date) return '';
			if (typeof format === 'string') format = DPGlobal.parseFormat(format);
			if (format.toDisplay) return format.toDisplay(date, format, language);
			var val = {
				d: date.getUTCDate(),
				D: dates[language].daysShort[date.getUTCDay()],
				DD: dates[language].days[date.getUTCDay()],
				m: date.getUTCMonth() + 1,
				M: dates[language].monthsShort[date.getUTCMonth()],
				MM: dates[language].months[date.getUTCMonth()],
				yy: date.getUTCFullYear().toString().substring(2),
				yyyy: date.getUTCFullYear()
			};
			val.dd = (val.d < 10 ? '0' : '') + val.d;
			val.mm = (val.m < 10 ? '0' : '') + val.m;
			date = [];
			var seps = $.extend([], format.separators);
			for (var i = 0, cnt = format.parts.length; i <= cnt; i++) {
				if (seps.length) date.push(seps.shift());
				date.push(val[format.parts[i]]);
			}
			return date.join('');
		},
		headTemplate: '<thead>' + '<tr>' + '<th colspan="7" class="datepicker-title"></th>' + '</tr>' + '<tr>' + '<th class="prev">&laquo;</th>' + '<th colspan="5" class="datepicker-switch"></th>' + '<th class="next">&raquo;</th>' + '</tr>' + '</thead>',
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot>' + '<tr>' + '<th colspan="7" class="today"></th>' + '</tr>' + '<tr>' + '<th colspan="7" class="clear"></th>' + '</tr>' + '</tfoot>'
	};
	DPGlobal.template = '<div class="datepicker">' + '<div class="datepicker-days">' + '<table class="table-condensed">' + DPGlobal.headTemplate + '<tbody></tbody>' + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-months">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-years">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-decades">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-centuries">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '</div>';

	$.fn.datepicker.DPGlobal = DPGlobal;

	$.fn.datepicker.noConflict = function () {
		$.fn.datepicker = old;
		return this;
	};

	$.fn.datepicker.version = '1.6.4';


	$(document).on('focus.datepicker.data-api click.datepicker.data-api', '[data-provide="datepicker"]', function (e) {
		var $this = $(this);
		if ($this.data('datepicker')) return;
		e.preventDefault();

		datepickerPlugin.call($this, 'show');
	});
	$(function () {
		datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
	});
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var frCa = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.defineLocale('fr-ca', {
    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact: true,
    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Aujourd’hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        ss: '%d secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal: function ordinal(number, period) {
        switch (period) {
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});
__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('fr-ca');
window.moment = __WEBPACK_IMPORTED_MODULE_0_moment___default.a;

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);






if (!function (a, b) {
  "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(module)) && "object" == __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(module.exports) ? module.exports = a.document ? b(a, !0) : function (a) {
    if (!a.document) throw new Error("jQuery requires a window with a document");return b(a);
  } : b(a);
}("undefined" != typeof window ? window : this, function (a, b) {
  function c(a) {
    var b = !!a && "length" in a && a.length,
        c = fa.type(a);return "function" !== c && !fa.isWindow(a) && ("array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a);
  }function d(a, b, c) {
    if (fa.isFunction(b)) return fa.grep(a, function (a, d) {
      return !!b.call(a, d, a) !== c;
    });if (b.nodeType) return fa.grep(a, function (a) {
      return a === b !== c;
    });if ("string" == typeof b) {
      if (pa.test(b)) return fa.filter(b, a, c);b = fa.filter(b, a);
    }return fa.grep(a, function (a) {
      return _.call(b, a) > -1 !== c;
    });
  }function e(a, b) {
    for (; (a = a[b]) && 1 !== a.nodeType;) {}return a;
  }function f(a) {
    var b = {};return fa.each(a.match(va) || [], function (a, c) {
      b[c] = !0;
    }), b;
  }function g() {
    X.removeEventListener("DOMContentLoaded", g), a.removeEventListener("load", g), fa.ready();
  }function h() {
    this.expando = fa.expando + h.uid++;
  }function i(a, b, c) {
    var d;if (void 0 === c && 1 === a.nodeType) if (d = "data-" + b.replace(Ca, "-$&").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
      try {
        c = "true" === c || "false" !== c && ("null" === c ? null : +c + "" === c ? +c : Ba.test(c) ? fa.parseJSON(c) : c);
      } catch (a) {}Aa.set(a, b, c);
    } else c = void 0;return c;
  }function j(a, b, c, d) {
    var e,
        f = 1,
        g = 20,
        h = d ? function () {
      return d.cur();
    } : function () {
      return fa.css(a, b, "");
    },
        i = h(),
        j = c && c[3] || (fa.cssNumber[b] ? "" : "px"),
        k = (fa.cssNumber[b] || "px" !== j && +i) && Ea.exec(fa.css(a, b));if (k && k[3] !== j) {
      j = j || k[3], c = c || [], k = +i || 1;do {
        f = f || ".5", k /= f, fa.style(a, b, k + j);
      } while (f !== (f = h() / i) && 1 !== f && --g);
    }return c && (k = +k || +i || 0, e = c[1] ? k + (c[1] + 1) * c[2] : +c[2], d && (d.unit = j, d.start = k, d.end = e)), e;
  }function k(a, b) {
    var c = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : [];return void 0 === b || b && fa.nodeName(a, b) ? fa.merge([a], c) : c;
  }function l(a, b) {
    for (var c = 0, d = a.length; d > c; c++) {
      za.set(a[c], "globalEval", !b || za.get(b[c], "globalEval"));
    }
  }function m(a, b, c, d, e) {
    for (var f, g, h, i, j, m, n = b.createDocumentFragment(), o = [], p = 0, q = a.length; q > p; p++) {
      if (f = a[p], f || 0 === f) if ("object" === fa.type(f)) fa.merge(o, f.nodeType ? [f] : f);else if (La.test(f)) {
        for (g = g || n.appendChild(b.createElement("div")), h = (Ia.exec(f) || ["", ""])[1].toLowerCase(), i = Ka[h] || Ka._default, g.innerHTML = i[1] + fa.htmlPrefilter(f) + i[2], m = i[0]; m--;) {
          g = g.lastChild;
        }fa.merge(o, g.childNodes), g = n.firstChild, g.textContent = "";
      } else o.push(b.createTextNode(f));
    }for (n.textContent = "", p = 0; f = o[p++];) {
      if (d && fa.inArray(f, d) > -1) e && e.push(f);else if (j = fa.contains(f.ownerDocument, f), g = k(n.appendChild(f), "script"), j && l(g), c) for (m = 0; f = g[m++];) {
        Ja.test(f.type || "") && c.push(f);
      }
    }return n;
  }function n() {
    return !0;
  }function o() {
    return !1;
  }function p() {
    try {
      return X.activeElement;
    } catch (a) {}
  }function q(a, b, c, d, e, f) {
    var g, h;if ("object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b))) {
      "string" != typeof c && (d = d || c, c = void 0);for (h in b) {
        q(a, h, c, d, b[h], f);
      }return a;
    }if (null == d && null == e ? (e = c, d = c = void 0) : null == e && ("string" == typeof c ? (e = d, d = void 0) : (e = d, d = c, c = void 0)), e === !1) e = o;else if (!e) return a;return 1 === f && (g = e, e = function e(a) {
      return fa().off(a), g.apply(this, arguments);
    }, e.guid = g.guid || (g.guid = fa.guid++)), a.each(function () {
      fa.event.add(this, b, e, d, c);
    });
  }function r(a, b) {
    return fa.nodeName(a, "table") && fa.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a;
  }function s(a) {
    return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a;
  }function t(a) {
    var b = Sa.exec(a.type);return b ? a.type = b[1] : a.removeAttribute("type"), a;
  }function u(a, b) {
    var c, d, e, f, g, h, i, j;if (1 === b.nodeType) {
      if (za.hasData(a) && (f = za.access(a), g = za.set(b, f), j = f.events)) {
        delete g.handle, g.events = {};for (e in j) {
          for (c = 0, d = j[e].length; d > c; c++) {
            fa.event.add(b, e, j[e][c]);
          }
        }
      }Aa.hasData(a) && (h = Aa.access(a), i = fa.extend({}, h), Aa.set(b, i));
    }
  }function v(a, b) {
    var c = b.nodeName.toLowerCase();"input" === c && Ha.test(a.type) ? b.checked = a.checked : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue);
  }function w(a, b, c, d) {
    b = Z.apply([], b);var e,
        f,
        g,
        h,
        i,
        j,
        l = 0,
        n = a.length,
        o = n - 1,
        p = b[0],
        q = fa.isFunction(p);if (q || n > 1 && "string" == typeof p && !da.checkClone && Ra.test(p)) return a.each(function (e) {
      var f = a.eq(e);q && (b[0] = p.call(this, e, f.html())), w(f, b, c, d);
    });if (n && (e = m(b, a[0].ownerDocument, !1, a, d), f = e.firstChild, 1 === e.childNodes.length && (e = f), f || d)) {
      for (g = fa.map(k(e, "script"), s), h = g.length; n > l; l++) {
        i = e, l !== o && (i = fa.clone(i, !0, !0), h && fa.merge(g, k(i, "script"))), c.call(a[l], i, l);
      }if (h) for (j = g[g.length - 1].ownerDocument, fa.map(g, t), l = 0; h > l; l++) {
        i = g[l], Ja.test(i.type || "") && !za.access(i, "globalEval") && fa.contains(j, i) && (i.src ? fa._evalUrl && fa._evalUrl(i.src) : fa.globalEval(i.textContent.replace(Ta, "")));
      }
    }return a;
  }function x(a, b, c) {
    for (var d, e = b ? fa.filter(b, a) : a, f = 0; null != (d = e[f]); f++) {
      c || 1 !== d.nodeType || fa.cleanData(k(d)), d.parentNode && (c && fa.contains(d.ownerDocument, d) && l(k(d, "script")), d.parentNode.removeChild(d));
    }return a;
  }function y(a, b) {
    var c = fa(b.createElement(a)).appendTo(b.body),
        d = fa.css(c[0], "display");return c.detach(), d;
  }function z(a) {
    var b = X,
        c = Va[a];return c || (c = y(a, b), "none" !== c && c || (Ua = (Ua || fa("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = Ua[0].contentDocument, b.write(), b.close(), c = y(a, b), Ua.detach()), Va[a] = c), c;
  }function A(a, b, c) {
    var d,
        e,
        f,
        g,
        h = a.style;return c = c || Ya(a), g = c ? c.getPropertyValue(b) || c[b] : void 0, "" !== g && void 0 !== g || fa.contains(a.ownerDocument, a) || (g = fa.style(a, b)), c && !da.pixelMarginRight() && Xa.test(g) && Wa.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f), void 0 !== g ? g + "" : g;
  }function B(a, b) {
    return { get: function get() {
        return a() ? void delete this.get : (this.get = b).apply(this, arguments);
      } };
  }function C(a) {
    if (a in db) return a;for (var b = a[0].toUpperCase() + a.slice(1), c = cb.length; c--;) {
      if (a = cb[c] + b, a in db) return a;
    }
  }function D(a, b, c) {
    var d = Ea.exec(b);return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || "px") : b;
  }function E(a, b, c, d, e) {
    for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2) {
      "margin" === c && (g += fa.css(a, c + Fa[f], !0, e)), d ? ("content" === c && (g -= fa.css(a, "padding" + Fa[f], !0, e)), "margin" !== c && (g -= fa.css(a, "border" + Fa[f] + "Width", !0, e))) : (g += fa.css(a, "padding" + Fa[f], !0, e), "padding" !== c && (g += fa.css(a, "border" + Fa[f] + "Width", !0, e)));
    }return g;
  }function F(a, b, c) {
    var d = !0,
        e = "width" === b ? a.offsetWidth : a.offsetHeight,
        f = Ya(a),
        g = "border-box" === fa.css(a, "boxSizing", !1, f);if (0 >= e || null == e) {
      if (e = A(a, b, f), (0 > e || null == e) && (e = a.style[b]), Xa.test(e)) return e;d = g && (da.boxSizingReliable() || e === a.style[b]), e = parseFloat(e) || 0;
    }return e + E(a, b, c || (g ? "border" : "content"), d, f) + "px";
  }function G(a, b) {
    for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++) {
      d = a[g], d.style && (f[g] = za.get(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && Ga(d) && (f[g] = za.access(d, "olddisplay", z(d.nodeName)))) : (e = Ga(d), "none" === c && e || za.set(d, "olddisplay", e ? c : fa.css(d, "display"))));
    }for (g = 0; h > g; g++) {
      d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none"));
    }return a;
  }function H(a, b, c, d, e) {
    return new H.prototype.init(a, b, c, d, e);
  }function I() {
    return a.setTimeout(function () {
      eb = void 0;
    }), eb = fa.now();
  }function J(a, b) {
    var c,
        d = 0,
        e = { height: a };for (b = b ? 1 : 0; 4 > d; d += 2 - b) {
      c = Fa[d], e["margin" + c] = e["padding" + c] = a;
    }return b && (e.opacity = e.width = a), e;
  }function K(a, b, c) {
    for (var d, e = (N.tweeners[b] || []).concat(N.tweeners["*"]), f = 0, g = e.length; g > f; f++) {
      if (d = e[f].call(c, b, a)) return d;
    }
  }function L(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l = this,
        m = {},
        n = a.style,
        o = a.nodeType && Ga(a),
        p = za.get(a, "fxshow");c.queue || (h = fa._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function () {
      h.unqueued || i();
    }), h.unqueued++, l.always(function () {
      l.always(function () {
        h.unqueued--, fa.queue(a, "fx").length || h.empty.fire();
      });
    })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [n.overflow, n.overflowX, n.overflowY], j = fa.css(a, "display"), k = "none" === j ? za.get(a, "olddisplay") || z(a.nodeName) : j, "inline" === k && "none" === fa.css(a, "float") && (n.display = "inline-block")), c.overflow && (n.overflow = "hidden", l.always(function () {
      n.overflow = c.overflow[0], n.overflowX = c.overflow[1], n.overflowY = c.overflow[2];
    }));for (d in b) {
      if (e = b[d], gb.exec(e)) {
        if (delete b[d], f = f || "toggle" === e, e === (o ? "hide" : "show")) {
          if ("show" !== e || !p || void 0 === p[d]) continue;o = !0;
        }m[d] = p && p[d] || fa.style(a, d);
      } else j = void 0;
    }if (fa.isEmptyObject(m)) "inline" === ("none" === j ? z(a.nodeName) : j) && (n.display = j);else {
      p ? "hidden" in p && (o = p.hidden) : p = za.access(a, "fxshow", {}), f && (p.hidden = !o), o ? fa(a).show() : l.done(function () {
        fa(a).hide();
      }), l.done(function () {
        var b;za.remove(a, "fxshow");for (b in m) {
          fa.style(a, b, m[b]);
        }
      });for (d in m) {
        g = K(o ? p[d] : 0, d, l), d in p || (p[d] = g.start, o && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0));
      }
    }
  }function M(a, b) {
    var c, d, e, f, g;for (c in a) {
      if (d = fa.camelCase(c), e = b[d], f = a[c], fa.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = fa.cssHooks[d], g && "expand" in g) {
        f = g.expand(f), delete a[d];for (c in f) {
          c in a || (a[c] = f[c], b[c] = e);
        }
      } else b[d] = e;
    }
  }function N(a, b, c) {
    var d,
        e,
        f = 0,
        g = N.prefilters.length,
        h = fa.Deferred().always(function () {
      delete i.elem;
    }),
        i = function i() {
      if (e) return !1;for (var b = eb || I(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++) {
        j.tweens[g].run(f);
      }return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1);
    },
        j = h.promise({ elem: a, props: fa.extend({}, b), opts: fa.extend(!0, { specialEasing: {}, easing: fa.easing._default }, c), originalProperties: b, originalOptions: c, startTime: eb || I(), duration: c.duration, tweens: [], createTween: function createTween(b, c) {
        var d = fa.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);return j.tweens.push(d), d;
      }, stop: function stop(b) {
        var c = 0,
            d = b ? j.tweens.length : 0;if (e) return this;for (e = !0; d > c; c++) {
          j.tweens[c].run(1);
        }return b ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]), this;
      } }),
        k = j.props;for (M(k, j.opts.specialEasing); g > f; f++) {
      if (d = N.prefilters[f].call(j, a, k, j.opts)) return fa.isFunction(d.stop) && (fa._queueHooks(j.elem, j.opts.queue).stop = fa.proxy(d.stop, d)), d;
    }return fa.map(k, K, j), fa.isFunction(j.opts.start) && j.opts.start.call(a, j), fa.fx.timer(fa.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always);
  }function O(a) {
    return a.getAttribute && a.getAttribute("class") || "";
  }function P(a) {
    return function (b, c) {
      "string" != typeof b && (c = b, b = "*");var d,
          e = 0,
          f = b.toLowerCase().match(va) || [];if (fa.isFunction(c)) for (; d = f[e++];) {
        "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
      }
    };
  }function Q(a, b, c, d) {
    function e(h) {
      var i;return f[h] = !0, fa.each(a[h] || [], function (a, h) {
        var j = h(b, c, d);return "string" != typeof j || g || f[j] ? g ? !(i = j) : void 0 : (b.dataTypes.unshift(j), e(j), !1);
      }), i;
    }var f = {},
        g = a === Ab;return e(b.dataTypes[0]) || !f["*"] && e("*");
  }function R(a, b) {
    var c,
        d,
        e = fa.ajaxSettings.flatOptions || {};for (c in b) {
      void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
    }return d && fa.extend(!0, a, d), a;
  }function S(a, b, c) {
    for (var d, e, f, g, h = a.contents, i = a.dataTypes; "*" === i[0];) {
      i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
    }if (d) for (e in h) {
      if (h[e] && h[e].test(d)) {
        i.unshift(e);break;
      }
    }if (i[0] in c) f = i[0];else {
      for (e in c) {
        if (!i[0] || a.converters[e + " " + i[0]]) {
          f = e;break;
        }g || (g = e);
      }f = f || g;
    }return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
  }function T(a, b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j = {},
        k = a.dataTypes.slice();if (k[1]) for (g in a.converters) {
      j[g.toLowerCase()] = a.converters[g];
    }for (f = k.shift(); f;) {
      if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) if ("*" === f) f = i;else if ("*" !== i && i !== f) {
        if (g = j[i + " " + f] || j["* " + f], !g) for (e in j) {
          if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
            g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));break;
          }
        }if (g !== !0) if (g && a.throws) b = g(b);else try {
          b = g(b);
        } catch (a) {
          return { state: "parsererror", error: g ? a : "No conversion from " + i + " to " + f };
        }
      }
    }return { state: "success", data: b };
  }function U(a, b, c, d) {
    var e;if (fa.isArray(b)) fa.each(b, function (b, e) {
      c || Eb.test(a) ? d(a, e) : U(a + "[" + ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(e)) && null != e ? b : "") + "]", e, c, d);
    });else if (c || "object" !== fa.type(b)) d(a, b);else for (e in b) {
      U(a + "[" + e + "]", b[e], c, d);
    }
  }function V(a) {
    return fa.isWindow(a) ? a : 9 === a.nodeType && a.defaultView;
  }var W = [],
      X = a.document,
      Y = W.slice,
      Z = W.concat,
      $ = W.push,
      _ = W.indexOf,
      aa = {},
      ba = aa.toString,
      ca = aa.hasOwnProperty,
      da = {},
      ea = "2.2.4",
      fa = function fa(a, b) {
    return new fa.fn.init(a, b);
  },
      ga = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      ha = /^-ms-/,
      ia = /-([\da-z])/gi,
      ja = function ja(a, b) {
    return b.toUpperCase();
  };fa.fn = fa.prototype = { jquery: ea, constructor: fa, selector: "", length: 0, toArray: function toArray() {
      return Y.call(this);
    }, get: function get(a) {
      return null != a ? 0 > a ? this[a + this.length] : this[a] : Y.call(this);
    }, pushStack: function pushStack(a) {
      var b = fa.merge(this.constructor(), a);return b.prevObject = this, b.context = this.context, b;
    }, each: function each(a) {
      return fa.each(this, a);
    }, map: function map(a) {
      return this.pushStack(fa.map(this, function (b, c) {
        return a.call(b, c, b);
      }));
    }, slice: function slice() {
      return this.pushStack(Y.apply(this, arguments));
    }, first: function first() {
      return this.eq(0);
    }, last: function last() {
      return this.eq(-1);
    }, eq: function eq(a) {
      var b = this.length,
          c = +a + (0 > a ? b : 0);return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
    }, end: function end() {
      return this.prevObject || this.constructor();
    }, push: $, sort: W.sort, splice: W.splice }, fa.extend = fa.fn.extend = function () {
    var a,
        b,
        c,
        d,
        e,
        f,
        g = arguments[0] || {},
        h = 1,
        i = arguments.length,
        j = !1;for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(g)) || fa.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++) {
      if (null != (a = arguments[h])) for (b in a) {
        c = g[b], d = a[b], g !== d && (j && d && (fa.isPlainObject(d) || (e = fa.isArray(d))) ? (e ? (e = !1, f = c && fa.isArray(c) ? c : []) : f = c && fa.isPlainObject(c) ? c : {}, g[b] = fa.extend(j, f, d)) : void 0 !== d && (g[b] = d));
      }
    }return g;
  }, fa.extend({ expando: "jQuery" + (ea + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(a) {
      throw new Error(a);
    }, noop: function noop() {}, isFunction: function isFunction(a) {
      return "function" === fa.type(a);
    }, isArray: Array.isArray, isWindow: function isWindow(a) {
      return null != a && a === a.window;
    }, isNumeric: function isNumeric(a) {
      var b = a && a.toString();return !fa.isArray(a) && b - parseFloat(b) + 1 >= 0;
    }, isPlainObject: function isPlainObject(a) {
      var b;if ("object" !== fa.type(a) || a.nodeType || fa.isWindow(a)) return !1;if (a.constructor && !ca.call(a, "constructor") && !ca.call(a.constructor.prototype || {}, "isPrototypeOf")) return !1;for (b in a) {}return void 0 === b || ca.call(a, b);
    }, isEmptyObject: function isEmptyObject(a) {
      var b;for (b in a) {
        return !1;
      }return !0;
    }, type: function type(a) {
      return null == a ? a + "" : "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(a)) || "function" == typeof a ? aa[ba.call(a)] || "object" : typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(a);
    }, globalEval: function globalEval(a) {
      var b,
          c = eval;a = fa.trim(a), a && (1 === a.indexOf("use strict") ? (b = X.createElement("script"), b.text = a, X.head.appendChild(b).parentNode.removeChild(b)) : c(a));
    }, camelCase: function camelCase(a) {
      return a.replace(ha, "ms-").replace(ia, ja);
    }, nodeName: function nodeName(a, b) {
      return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
    }, each: function each(a, b) {
      var d,
          e = 0;if (c(a)) for (d = a.length; d > e && b.call(a[e], e, a[e]) !== !1; e++) {} else for (e in a) {
        if (b.call(a[e], e, a[e]) === !1) break;
      }return a;
    }, trim: function trim(a) {
      return null == a ? "" : (a + "").replace(ga, "");
    }, makeArray: function makeArray(a, b) {
      var d = b || [];return null != a && (c(Object(a)) ? fa.merge(d, "string" == typeof a ? [a] : a) : $.call(d, a)), d;
    }, inArray: function inArray(a, b, c) {
      return null == b ? -1 : _.call(b, a, c);
    }, merge: function merge(a, b) {
      for (var c = +b.length, d = 0, e = a.length; c > d; d++) {
        a[e++] = b[d];
      }return a.length = e, a;
    }, grep: function grep(a, b, c) {
      for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) {
        d = !b(a[f], f), d !== h && e.push(a[f]);
      }return e;
    }, map: function map(a, b, d) {
      var e,
          f,
          g = 0,
          h = [];if (c(a)) for (e = a.length; e > g; g++) {
        f = b(a[g], g, d), null != f && h.push(f);
      } else for (g in a) {
        f = b(a[g], g, d), null != f && h.push(f);
      }return Z.apply([], h);
    }, guid: 1, proxy: function proxy(a, b) {
      var c, d, e;return "string" == typeof b && (c = a[b], b = a, a = c), fa.isFunction(a) ? (d = Y.call(arguments, 2), e = function e() {
        return a.apply(b || this, d.concat(Y.call(arguments)));
      }, e.guid = a.guid = a.guid || fa.guid++, e) : void 0;
    }, now: Date.now, support: da }), "function" == typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a && (fa.fn[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a] = W[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a]), fa.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (a, b) {
    aa["[object " + b + "]"] = b.toLowerCase();
  });var ka = function (a) {
    function b(a, b, c, d) {
      var e,
          f,
          g,
          h,
          i,
          j,
          l,
          n,
          o = b && b.ownerDocument,
          p = b ? b.nodeType : 9;if (c = c || [], "string" != typeof a || !a || 1 !== p && 9 !== p && 11 !== p) return c;if (!d && ((b ? b.ownerDocument || b : O) !== G && F(b), b = b || G, I)) {
        if (11 !== p && (j = ra.exec(a))) if (e = j[1]) {
          if (9 === p) {
            if (!(g = b.getElementById(e))) return c;if (g.id === e) return c.push(g), c;
          } else if (o && (g = o.getElementById(e)) && M(b, g) && g.id === e) return c.push(g), c;
        } else {
          if (j[2]) return $.apply(c, b.getElementsByTagName(a)), c;if ((e = j[3]) && v.getElementsByClassName && b.getElementsByClassName) return $.apply(c, b.getElementsByClassName(e)), c;
        }if (v.qsa && !T[a + " "] && (!J || !J.test(a))) {
          if (1 !== p) o = b, n = a;else if ("object" !== b.nodeName.toLowerCase()) {
            for ((h = b.getAttribute("id")) ? h = h.replace(ta, "\\$&") : b.setAttribute("id", h = N), l = z(a), f = l.length, i = ma.test(h) ? "#" + h : "[id='" + h + "']"; f--;) {
              l[f] = i + " " + m(l[f]);
            }n = l.join(","), o = sa.test(a) && k(b.parentNode) || b;
          }if (n) try {
            return $.apply(c, o.querySelectorAll(n)), c;
          } catch (a) {} finally {
            h === N && b.removeAttribute("id");
          }
        }
      }return B(a.replace(ha, "$1"), b, c, d);
    }function c() {
      function a(c, d) {
        return b.push(c + " ") > w.cacheLength && delete a[b.shift()], a[c + " "] = d;
      }var b = [];return a;
    }function d(a) {
      return a[N] = !0, a;
    }function e(a) {
      var b = G.createElement("div");try {
        return !!a(b);
      } catch (a) {
        return !1;
      } finally {
        b.parentNode && b.parentNode.removeChild(b), b = null;
      }
    }function f(a, b) {
      for (var c = a.split("|"), d = c.length; d--;) {
        w.attrHandle[c[d]] = b;
      }
    }function g(a, b) {
      var c = b && a,
          d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || V) - (~a.sourceIndex || V);if (d) return d;if (c) for (; c = c.nextSibling;) {
        if (c === b) return -1;
      }return a ? 1 : -1;
    }function h(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();return "input" === c && b.type === a;
      };
    }function i(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();return ("input" === c || "button" === c) && b.type === a;
      };
    }function j(a) {
      return d(function (b) {
        return b = +b, d(function (c, d) {
          for (var e, f = a([], c.length, b), g = f.length; g--;) {
            c[e = f[g]] && (c[e] = !(d[e] = c[e]));
          }
        });
      });
    }function k(a) {
      return a && "undefined" != typeof a.getElementsByTagName && a;
    }function l() {}function m(a) {
      for (var b = 0, c = a.length, d = ""; c > b; b++) {
        d += a[b].value;
      }return d;
    }function n(a, b, c) {
      var d = b.dir,
          e = c && "parentNode" === d,
          f = Q++;return b.first ? function (b, c, f) {
        for (; b = b[d];) {
          if (1 === b.nodeType || e) return a(b, c, f);
        }
      } : function (b, c, g) {
        var h,
            i,
            j,
            k = [P, f];if (g) {
          for (; b = b[d];) {
            if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
          }
        } else for (; b = b[d];) {
          if (1 === b.nodeType || e) {
            if (j = b[N] || (b[N] = {}), i = j[b.uniqueID] || (j[b.uniqueID] = {}), (h = i[d]) && h[0] === P && h[1] === f) return k[2] = h[2];if (i[d] = k, k[2] = a(b, c, g)) return !0;
          }
        }
      };
    }function o(a) {
      return a.length > 1 ? function (b, c, d) {
        for (var e = a.length; e--;) {
          if (!a[e](b, c, d)) return !1;
        }return !0;
      } : a[0];
    }function p(a, c, d) {
      for (var e = 0, f = c.length; f > e; e++) {
        b(a, c[e], d);
      }return d;
    }function q(a, b, c, d, e) {
      for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++) {
        (f = a[h]) && (c && !c(f, d, e) || (g.push(f), j && b.push(h)));
      }return g;
    }function r(a, b, c, e, f, g) {
      return e && !e[N] && (e = r(e)), f && !f[N] && (f = r(f, g)), d(function (d, g, h, i) {
        var j,
            k,
            l,
            m = [],
            n = [],
            o = g.length,
            r = d || p(b || "*", h.nodeType ? [h] : h, []),
            s = !a || !d && b ? r : q(r, m, a, h, i),
            t = c ? f || (d ? a : o || e) ? [] : g : s;if (c && c(s, t, h, i), e) for (j = q(t, n), e(j, [], h, i), k = j.length; k--;) {
          (l = j[k]) && (t[n[k]] = !(s[n[k]] = l));
        }if (d) {
          if (f || a) {
            if (f) {
              for (j = [], k = t.length; k--;) {
                (l = t[k]) && j.push(s[k] = l);
              }f(null, t = [], j, i);
            }for (k = t.length; k--;) {
              (l = t[k]) && (j = f ? aa(d, l) : m[k]) > -1 && (d[j] = !(g[j] = l));
            }
          }
        } else t = q(t === g ? t.splice(o, t.length) : t), f ? f(null, g, t, i) : $.apply(g, t);
      });
    }function s(a) {
      for (var b, c, d, e = a.length, f = w.relative[a[0].type], g = f || w.relative[" "], h = f ? 1 : 0, i = n(function (a) {
        return a === b;
      }, g, !0), j = n(function (a) {
        return aa(b, a) > -1;
      }, g, !0), k = [function (a, c, d) {
        var e = !f && (d || c !== C) || ((b = c).nodeType ? i(a, c, d) : j(a, c, d));return b = null, e;
      }]; e > h; h++) {
        if (c = w.relative[a[h].type]) k = [n(o(k), c)];else {
          if (c = w.filter[a[h].type].apply(null, a[h].matches), c[N]) {
            for (d = ++h; e > d && !w.relative[a[d].type]; d++) {}return r(h > 1 && o(k), h > 1 && m(a.slice(0, h - 1).concat({ value: " " === a[h - 2].type ? "*" : "" })).replace(ha, "$1"), c, d > h && s(a.slice(h, d)), e > d && s(a = a.slice(d)), e > d && m(a));
          }k.push(c);
        }
      }return o(k);
    }function t(a, c) {
      var e = c.length > 0,
          f = a.length > 0,
          g = function g(d, _g, h, i, j) {
        var k,
            l,
            m,
            n = 0,
            o = "0",
            p = d && [],
            r = [],
            s = C,
            t = d || f && w.find.TAG("*", j),
            u = P += null == s ? 1 : Math.random() || .1,
            v = t.length;for (j && (C = _g === G || _g || j); o !== v && null != (k = t[o]); o++) {
          if (f && k) {
            for (l = 0, _g || k.ownerDocument === G || (F(k), h = !I); m = a[l++];) {
              if (m(k, _g || G, h)) {
                i.push(k);break;
              }
            }j && (P = u);
          }e && ((k = !m && k) && n--, d && p.push(k));
        }if (n += o, e && o !== n) {
          for (l = 0; m = c[l++];) {
            m(p, r, _g, h);
          }if (d) {
            if (n > 0) for (; o--;) {
              p[o] || r[o] || (r[o] = Y.call(i));
            }r = q(r);
          }$.apply(i, r), j && !d && r.length > 0 && n + c.length > 1 && b.uniqueSort(i);
        }return j && (P = u, C = s), p;
      };return e ? d(g) : g;
    }var u,
        v,
        w,
        x,
        y,
        z,
        A,
        B,
        C,
        D,
        E,
        F,
        G,
        H,
        I,
        J,
        K,
        L,
        M,
        N = "sizzle" + 1 * new Date(),
        O = a.document,
        P = 0,
        Q = 0,
        R = c(),
        S = c(),
        T = c(),
        U = function U(a, b) {
      return a === b && (E = !0), 0;
    },
        V = 1 << 31,
        W = {}.hasOwnProperty,
        X = [],
        Y = X.pop,
        Z = X.push,
        $ = X.push,
        _ = X.slice,
        aa = function aa(a, b) {
      for (var c = 0, d = a.length; d > c; c++) {
        if (a[c] === b) return c;
      }return -1;
    },
        ba = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        ca = "[\\x20\\t\\r\\n\\f]",
        da = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        ea = "\\[" + ca + "*(" + da + ")(?:" + ca + "*([*^$|!~]?=)" + ca + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + da + "))|)" + ca + "*\\]",
        fa = ":(" + da + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ea + ")*)|.*)\\)|)",
        ga = new RegExp(ca + "+", "g"),
        ha = new RegExp("^" + ca + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ca + "+$", "g"),
        ia = new RegExp("^" + ca + "*," + ca + "*"),
        ja = new RegExp("^" + ca + "*([>+~]|" + ca + ")" + ca + "*"),
        ka = new RegExp("=" + ca + "*([^\\]'\"]*?)" + ca + "*\\]", "g"),
        la = new RegExp(fa),
        ma = new RegExp("^" + da + "$"),
        na = { ID: new RegExp("^#(" + da + ")"), CLASS: new RegExp("^\\.(" + da + ")"), TAG: new RegExp("^(" + da + "|[*])"), ATTR: new RegExp("^" + ea), PSEUDO: new RegExp("^" + fa), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ca + "*(even|odd|(([+-]|)(\\d*)n|)" + ca + "*(?:([+-]|)" + ca + "*(\\d+)|))" + ca + "*\\)|)", "i"), bool: new RegExp("^(?:" + ba + ")$", "i"), needsContext: new RegExp("^" + ca + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ca + "*((?:-\\d)?\\d*)" + ca + "*\\)|)(?=[^-]|$)", "i") },
        oa = /^(?:input|select|textarea|button)$/i,
        pa = /^h\d$/i,
        qa = /^[^{]+\{\s*\[native \w/,
        ra = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        sa = /[+~]/,
        ta = /'|\\/g,
        ua = new RegExp("\\\\([\\da-f]{1,6}" + ca + "?|(" + ca + ")|.)", "ig"),
        va = function va(a, b, c) {
      var d = "0x" + b - 65536;return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320);
    },
        wa = function wa() {
      F();
    };try {
      $.apply(X = _.call(O.childNodes), O.childNodes), X[O.childNodes.length].nodeType;
    } catch (a) {
      $ = { apply: X.length ? function (a, b) {
          Z.apply(a, _.call(b));
        } : function (a, b) {
          for (var c = a.length, d = 0; a[c++] = b[d++];) {}a.length = c - 1;
        } };
    }v = b.support = {}, y = b.isXML = function (a) {
      var b = a && (a.ownerDocument || a).documentElement;return !!b && "HTML" !== b.nodeName;
    }, F = b.setDocument = function (a) {
      var b,
          c,
          d = a ? a.ownerDocument || a : O;return d !== G && 9 === d.nodeType && d.documentElement ? (G = d, H = G.documentElement, I = !y(G), (c = G.defaultView) && c.top !== c && (c.addEventListener ? c.addEventListener("unload", wa, !1) : c.attachEvent && c.attachEvent("onunload", wa)), v.attributes = e(function (a) {
        return a.className = "i", !a.getAttribute("className");
      }), v.getElementsByTagName = e(function (a) {
        return a.appendChild(G.createComment("")), !a.getElementsByTagName("*").length;
      }), v.getElementsByClassName = qa.test(G.getElementsByClassName), v.getById = e(function (a) {
        return H.appendChild(a).id = N, !G.getElementsByName || !G.getElementsByName(N).length;
      }), v.getById ? (w.find.ID = function (a, b) {
        if ("undefined" != typeof b.getElementById && I) {
          var c = b.getElementById(a);return c ? [c] : [];
        }
      }, w.filter.ID = function (a) {
        var b = a.replace(ua, va);return function (a) {
          return a.getAttribute("id") === b;
        };
      }) : (delete w.find.ID, w.filter.ID = function (a) {
        var b = a.replace(ua, va);return function (a) {
          var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");return c && c.value === b;
        };
      }), w.find.TAG = v.getElementsByTagName ? function (a, b) {
        return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : v.qsa ? b.querySelectorAll(a) : void 0;
      } : function (a, b) {
        var c,
            d = [],
            e = 0,
            f = b.getElementsByTagName(a);if ("*" === a) {
          for (; c = f[e++];) {
            1 === c.nodeType && d.push(c);
          }return d;
        }return f;
      }, w.find.CLASS = v.getElementsByClassName && function (a, b) {
        return "undefined" != typeof b.getElementsByClassName && I ? b.getElementsByClassName(a) : void 0;
      }, K = [], J = [], (v.qsa = qa.test(G.querySelectorAll)) && (e(function (a) {
        H.appendChild(a).innerHTML = "<a id='" + N + "'></a><select id='" + N + "-\r\\' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && J.push("[*^$]=" + ca + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || J.push("\\[" + ca + "*(?:value|" + ba + ")"), a.querySelectorAll("[id~=" + N + "-]").length || J.push("~="), a.querySelectorAll(":checked").length || J.push(":checked"), a.querySelectorAll("a#" + N + "+*").length || J.push(".#.+[+~]");
      }), e(function (a) {
        var b = G.createElement("input");b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && J.push("name" + ca + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || J.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), J.push(",.*:");
      })), (v.matchesSelector = qa.test(L = H.matches || H.webkitMatchesSelector || H.mozMatchesSelector || H.oMatchesSelector || H.msMatchesSelector)) && e(function (a) {
        v.disconnectedMatch = L.call(a, "div"), L.call(a, "[s!='']:x"), K.push("!=", fa);
      }), J = J.length && new RegExp(J.join("|")), K = K.length && new RegExp(K.join("|")), b = qa.test(H.compareDocumentPosition), M = b || qa.test(H.contains) ? function (a, b) {
        var c = 9 === a.nodeType ? a.documentElement : a,
            d = b && b.parentNode;return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)));
      } : function (a, b) {
        if (b) for (; b = b.parentNode;) {
          if (b === a) return !0;
        }return !1;
      }, U = b ? function (a, b) {
        if (a === b) return E = !0, 0;var c = !a.compareDocumentPosition - !b.compareDocumentPosition;return c ? c : (c = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & c || !v.sortDetached && b.compareDocumentPosition(a) === c ? a === G || a.ownerDocument === O && M(O, a) ? -1 : b === G || b.ownerDocument === O && M(O, b) ? 1 : D ? aa(D, a) - aa(D, b) : 0 : 4 & c ? -1 : 1);
      } : function (a, b) {
        if (a === b) return E = !0, 0;var c,
            d = 0,
            e = a.parentNode,
            f = b.parentNode,
            h = [a],
            i = [b];if (!e || !f) return a === G ? -1 : b === G ? 1 : e ? -1 : f ? 1 : D ? aa(D, a) - aa(D, b) : 0;if (e === f) return g(a, b);for (c = a; c = c.parentNode;) {
          h.unshift(c);
        }for (c = b; c = c.parentNode;) {
          i.unshift(c);
        }for (; h[d] === i[d];) {
          d++;
        }return d ? g(h[d], i[d]) : h[d] === O ? -1 : i[d] === O ? 1 : 0;
      }, G) : G;
    }, b.matches = function (a, c) {
      return b(a, null, null, c);
    }, b.matchesSelector = function (a, c) {
      if ((a.ownerDocument || a) !== G && F(a), c = c.replace(ka, "='$1']"), v.matchesSelector && I && !T[c + " "] && (!K || !K.test(c)) && (!J || !J.test(c))) try {
        var d = L.call(a, c);if (d || v.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d;
      } catch (a) {}return b(c, G, null, [a]).length > 0;
    }, b.contains = function (a, b) {
      return (a.ownerDocument || a) !== G && F(a), M(a, b);
    }, b.attr = function (a, b) {
      (a.ownerDocument || a) !== G && F(a);var c = w.attrHandle[b.toLowerCase()],
          d = c && W.call(w.attrHandle, b.toLowerCase()) ? c(a, b, !I) : void 0;return void 0 !== d ? d : v.attributes || !I ? a.getAttribute(b) : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
    }, b.error = function (a) {
      throw new Error("Syntax error, unrecognized expression: " + a);
    }, b.uniqueSort = function (a) {
      var b,
          c = [],
          d = 0,
          e = 0;if (E = !v.detectDuplicates, D = !v.sortStable && a.slice(0), a.sort(U), E) {
        for (; b = a[e++];) {
          b === a[e] && (d = c.push(e));
        }for (; d--;) {
          a.splice(c[d], 1);
        }
      }return D = null, a;
    }, x = b.getText = function (a) {
      var b,
          c = "",
          d = 0,
          e = a.nodeType;if (e) {
        if (1 === e || 9 === e || 11 === e) {
          if ("string" == typeof a.textContent) return a.textContent;for (a = a.firstChild; a; a = a.nextSibling) {
            c += x(a);
          }
        } else if (3 === e || 4 === e) return a.nodeValue;
      } else for (; b = a[d++];) {
        c += x(b);
      }return c;
    }, w = b.selectors = { cacheLength: 50, createPseudo: d, match: na, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(a) {
          return a[1] = a[1].replace(ua, va), a[3] = (a[3] || a[4] || a[5] || "").replace(ua, va), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4);
        }, CHILD: function CHILD(a) {
          return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || b.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && b.error(a[0]), a;
        }, PSEUDO: function PSEUDO(a) {
          var b,
              c = !a[6] && a[2];return na.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && la.test(c) && (b = z(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3));
        } }, filter: { TAG: function TAG(a) {
          var b = a.replace(ua, va).toLowerCase();return "*" === a ? function () {
            return !0;
          } : function (a) {
            return a.nodeName && a.nodeName.toLowerCase() === b;
          };
        }, CLASS: function CLASS(a) {
          var b = R[a + " "];return b || (b = new RegExp("(^|" + ca + ")" + a + "(" + ca + "|$)")) && R(a, function (a) {
            return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "");
          });
        }, ATTR: function ATTR(a, c, d) {
          return function (e) {
            var f = b.attr(e, a);return null == f ? "!=" === c : !c || (f += "", "=" === c ? f === d : "!=" === c ? f !== d : "^=" === c ? d && 0 === f.indexOf(d) : "*=" === c ? d && f.indexOf(d) > -1 : "$=" === c ? d && f.slice(-d.length) === d : "~=" === c ? (" " + f.replace(ga, " ") + " ").indexOf(d) > -1 : "|=" === c && (f === d || f.slice(0, d.length + 1) === d + "-"));
          };
        }, CHILD: function CHILD(a, b, c, d, e) {
          var f = "nth" !== a.slice(0, 3),
              g = "last" !== a.slice(-4),
              h = "of-type" === b;return 1 === d && 0 === e ? function (a) {
            return !!a.parentNode;
          } : function (b, c, i) {
            var j,
                k,
                l,
                m,
                n,
                o,
                p = f !== g ? "nextSibling" : "previousSibling",
                q = b.parentNode,
                r = h && b.nodeName.toLowerCase(),
                s = !i && !h,
                t = !1;if (q) {
              if (f) {
                for (; p;) {
                  for (m = b; m = m[p];) {
                    if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1;
                  }o = p = "only" === a && !o && "nextSibling";
                }return !0;
              }if (o = [g ? q.firstChild : q.lastChild], g && s) {
                for (m = q, l = m[N] || (m[N] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === P && j[1], t = n && j[2], m = n && q.childNodes[n]; m = ++n && m && m[p] || (t = n = 0) || o.pop();) {
                  if (1 === m.nodeType && ++t && m === b) {
                    k[a] = [P, n, t];break;
                  }
                }
              } else if (s && (m = b, l = m[N] || (m[N] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === P && j[1], t = n), t === !1) for (; (m = ++n && m && m[p] || (t = n = 0) || o.pop()) && ((h ? m.nodeName.toLowerCase() !== r : 1 !== m.nodeType) || !++t || (s && (l = m[N] || (m[N] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), k[a] = [P, t]), m !== b));) {}return t -= e, t === d || t % d === 0 && t / d >= 0;
            }
          };
        }, PSEUDO: function PSEUDO(a, c) {
          var e,
              f = w.pseudos[a] || w.setFilters[a.toLowerCase()] || b.error("unsupported pseudo: " + a);return f[N] ? f(c) : f.length > 1 ? (e = [a, a, "", c], w.setFilters.hasOwnProperty(a.toLowerCase()) ? d(function (a, b) {
            for (var d, e = f(a, c), g = e.length; g--;) {
              d = aa(a, e[g]), a[d] = !(b[d] = e[g]);
            }
          }) : function (a) {
            return f(a, 0, e);
          }) : f;
        } }, pseudos: { not: d(function (a) {
          var b = [],
              c = [],
              e = A(a.replace(ha, "$1"));return e[N] ? d(function (a, b, c, d) {
            for (var f, g = e(a, null, d, []), h = a.length; h--;) {
              (f = g[h]) && (a[h] = !(b[h] = f));
            }
          }) : function (a, d, f) {
            return b[0] = a, e(b, null, f, c), b[0] = null, !c.pop();
          };
        }), has: d(function (a) {
          return function (c) {
            return b(a, c).length > 0;
          };
        }), contains: d(function (a) {
          return a = a.replace(ua, va), function (b) {
            return (b.textContent || b.innerText || x(b)).indexOf(a) > -1;
          };
        }), lang: d(function (a) {
          return ma.test(a || "") || b.error("unsupported lang: " + a), a = a.replace(ua, va).toLowerCase(), function (b) {
            var c;do {
              if (c = I ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-");
            } while ((b = b.parentNode) && 1 === b.nodeType);return !1;
          };
        }), target: function target(b) {
          var c = a.location && a.location.hash;return c && c.slice(1) === b.id;
        }, root: function root(a) {
          return a === H;
        }, focus: function focus(a) {
          return a === G.activeElement && (!G.hasFocus || G.hasFocus()) && !!(a.type || a.href || ~a.tabIndex);
        }, enabled: function enabled(a) {
          return a.disabled === !1;
        }, disabled: function disabled(a) {
          return a.disabled === !0;
        }, checked: function checked(a) {
          var b = a.nodeName.toLowerCase();return "input" === b && !!a.checked || "option" === b && !!a.selected;
        }, selected: function selected(a) {
          return a.parentNode && a.parentNode.selectedIndex, a.selected === !0;
        }, empty: function empty(a) {
          for (a = a.firstChild; a; a = a.nextSibling) {
            if (a.nodeType < 6) return !1;
          }return !0;
        }, parent: function parent(a) {
          return !w.pseudos.empty(a);
        }, header: function header(a) {
          return pa.test(a.nodeName);
        }, input: function input(a) {
          return oa.test(a.nodeName);
        }, button: function button(a) {
          var b = a.nodeName.toLowerCase();return "input" === b && "button" === a.type || "button" === b;
        }, text: function text(a) {
          var b;return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase());
        }, first: j(function () {
          return [0];
        }), last: j(function (a, b) {
          return [b - 1];
        }), eq: j(function (a, b, c) {
          return [0 > c ? c + b : c];
        }), even: j(function (a, b) {
          for (var c = 0; b > c; c += 2) {
            a.push(c);
          }return a;
        }), odd: j(function (a, b) {
          for (var c = 1; b > c; c += 2) {
            a.push(c);
          }return a;
        }), lt: j(function (a, b, c) {
          for (var d = 0 > c ? c + b : c; --d >= 0;) {
            a.push(d);
          }return a;
        }), gt: j(function (a, b, c) {
          for (var d = 0 > c ? c + b : c; ++d < b;) {
            a.push(d);
          }return a;
        }) } }, w.pseudos.nth = w.pseudos.eq;for (u in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
      w.pseudos[u] = h(u);
    }for (u in { submit: !0, reset: !0 }) {
      w.pseudos[u] = i(u);
    }return l.prototype = w.filters = w.pseudos, w.setFilters = new l(), z = b.tokenize = function (a, c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = S[a + " "];if (k) return c ? 0 : k.slice(0);for (h = a, i = [], j = w.preFilter; h;) {
        d && !(e = ia.exec(h)) || (e && (h = h.slice(e[0].length) || h), i.push(f = [])), d = !1, (e = ja.exec(h)) && (d = e.shift(), f.push({ value: d, type: e[0].replace(ha, " ") }), h = h.slice(d.length));for (g in w.filter) {
          !(e = na[g].exec(h)) || j[g] && !(e = j[g](e)) || (d = e.shift(), f.push({ value: d, type: g, matches: e }), h = h.slice(d.length));
        }if (!d) break;
      }return c ? h.length : h ? b.error(a) : S(a, i).slice(0);
    }, A = b.compile = function (a, b) {
      var c,
          d = [],
          e = [],
          f = T[a + " "];if (!f) {
        for (b || (b = z(a)), c = b.length; c--;) {
          f = s(b[c]), f[N] ? d.push(f) : e.push(f);
        }f = T(a, t(e, d)), f.selector = a;
      }return f;
    }, B = b.select = function (a, b, c, d) {
      var e,
          f,
          g,
          h,
          i,
          j = "function" == typeof a && a,
          l = !d && z(a = j.selector || a);if (c = c || [], 1 === l.length) {
        if (f = l[0] = l[0].slice(0), f.length > 2 && "ID" === (g = f[0]).type && v.getById && 9 === b.nodeType && I && w.relative[f[1].type]) {
          if (b = (w.find.ID(g.matches[0].replace(ua, va), b) || [])[0], !b) return c;j && (b = b.parentNode), a = a.slice(f.shift().value.length);
        }for (e = na.needsContext.test(a) ? 0 : f.length; e-- && (g = f[e], !w.relative[h = g.type]);) {
          if ((i = w.find[h]) && (d = i(g.matches[0].replace(ua, va), sa.test(f[0].type) && k(b.parentNode) || b))) {
            if (f.splice(e, 1), a = d.length && m(f), !a) return $.apply(c, d), c;break;
          }
        }
      }return (j || A(a, l))(d, b, !I, c, !b || sa.test(a) && k(b.parentNode) || b), c;
    }, v.sortStable = N.split("").sort(U).join("") === N, v.detectDuplicates = !!E, F(), v.sortDetached = e(function (a) {
      return 1 & a.compareDocumentPosition(G.createElement("div"));
    }), e(function (a) {
      return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href");
    }) || f("type|href|height|width", function (a, b, c) {
      return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
    }), v.attributes && e(function (a) {
      return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value");
    }) || f("value", function (a, b, c) {
      return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue;
    }), e(function (a) {
      return null == a.getAttribute("disabled");
    }) || f(ba, function (a, b, c) {
      var d;return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
    }), b;
  }(a);fa.find = ka, fa.expr = ka.selectors, fa.expr[":"] = fa.expr.pseudos, fa.uniqueSort = fa.unique = ka.uniqueSort, fa.text = ka.getText, fa.isXMLDoc = ka.isXML, fa.contains = ka.contains;var la = function la(a, b, c) {
    for (var d = [], e = void 0 !== c; (a = a[b]) && 9 !== a.nodeType;) {
      if (1 === a.nodeType) {
        if (e && fa(a).is(c)) break;d.push(a);
      }
    }return d;
  },
      ma = function ma(a, b) {
    for (var c = []; a; a = a.nextSibling) {
      1 === a.nodeType && a !== b && c.push(a);
    }return c;
  },
      na = fa.expr.match.needsContext,
      oa = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      pa = /^.[^:#\[\.,]*$/;fa.filter = function (a, b, c) {
    var d = b[0];return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? fa.find.matchesSelector(d, a) ? [d] : [] : fa.find.matches(a, fa.grep(b, function (a) {
      return 1 === a.nodeType;
    }));
  }, fa.fn.extend({ find: function find(a) {
      var b,
          c = this.length,
          d = [],
          e = this;if ("string" != typeof a) return this.pushStack(fa(a).filter(function () {
        for (b = 0; c > b; b++) {
          if (fa.contains(e[b], this)) return !0;
        }
      }));for (b = 0; c > b; b++) {
        fa.find(a, e[b], d);
      }return d = this.pushStack(c > 1 ? fa.unique(d) : d), d.selector = this.selector ? this.selector + " " + a : a, d;
    }, filter: function filter(a) {
      return this.pushStack(d(this, a || [], !1));
    }, not: function not(a) {
      return this.pushStack(d(this, a || [], !0));
    }, is: function is(a) {
      return !!d(this, "string" == typeof a && na.test(a) ? fa(a) : a || [], !1).length;
    } });var qa,
      ra = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      sa = fa.fn.init = function (a, b, c) {
    var d, e;if (!a) return this;if (c = c || qa, "string" == typeof a) {
      if (d = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : ra.exec(a), !d || !d[1] && b) return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);if (d[1]) {
        if (b = b instanceof fa ? b[0] : b, fa.merge(this, fa.parseHTML(d[1], b && b.nodeType ? b.ownerDocument || b : X, !0)), oa.test(d[1]) && fa.isPlainObject(b)) for (d in b) {
          fa.isFunction(this[d]) ? this[d](b[d]) : this.attr(d, b[d]);
        }return this;
      }return e = X.getElementById(d[2]), e && e.parentNode && (this.length = 1, this[0] = e), this.context = X, this.selector = a, this;
    }return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : fa.isFunction(a) ? void 0 !== c.ready ? c.ready(a) : a(fa) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), fa.makeArray(a, this));
  };sa.prototype = fa.fn, qa = fa(X);var ta = /^(?:parents|prev(?:Until|All))/,
      ua = { children: !0, contents: !0, next: !0, prev: !0 };fa.fn.extend({ has: function has(a) {
      var b = fa(a, this),
          c = b.length;return this.filter(function () {
        for (var a = 0; c > a; a++) {
          if (fa.contains(this, b[a])) return !0;
        }
      });
    }, closest: function closest(a, b) {
      for (var c, d = 0, e = this.length, f = [], g = na.test(a) || "string" != typeof a ? fa(a, b || this.context) : 0; e > d; d++) {
        for (c = this[d]; c && c !== b; c = c.parentNode) {
          if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && fa.find.matchesSelector(c, a))) {
            f.push(c);break;
          }
        }
      }return this.pushStack(f.length > 1 ? fa.uniqueSort(f) : f);
    }, index: function index(a) {
      return a ? "string" == typeof a ? _.call(fa(a), this[0]) : _.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function add(a, b) {
      return this.pushStack(fa.uniqueSort(fa.merge(this.get(), fa(a, b))));
    }, addBack: function addBack(a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
    } }), fa.each({ parent: function parent(a) {
      var b = a.parentNode;return b && 11 !== b.nodeType ? b : null;
    }, parents: function parents(a) {
      return la(a, "parentNode");
    }, parentsUntil: function parentsUntil(a, b, c) {
      return la(a, "parentNode", c);
    }, next: function next(a) {
      return e(a, "nextSibling");
    }, prev: function prev(a) {
      return e(a, "previousSibling");
    }, nextAll: function nextAll(a) {
      return la(a, "nextSibling");
    }, prevAll: function prevAll(a) {
      return la(a, "previousSibling");
    }, nextUntil: function nextUntil(a, b, c) {
      return la(a, "nextSibling", c);
    }, prevUntil: function prevUntil(a, b, c) {
      return la(a, "previousSibling", c);
    }, siblings: function siblings(a) {
      return ma((a.parentNode || {}).firstChild, a);
    }, children: function children(a) {
      return ma(a.firstChild);
    }, contents: function contents(a) {
      return a.contentDocument || fa.merge([], a.childNodes);
    } }, function (a, b) {
    fa.fn[a] = function (c, d) {
      var e = fa.map(this, b, c);return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = fa.filter(d, e)), this.length > 1 && (ua[a] || fa.uniqueSort(e), ta.test(a) && e.reverse()), this.pushStack(e);
    };
  });var va = /\S+/g;fa.Callbacks = function (a) {
    a = "string" == typeof a ? f(a) : fa.extend({}, a);var b,
        c,
        d,
        e,
        g = [],
        h = [],
        i = -1,
        j = function j() {
      for (e = a.once, d = b = !0; h.length; i = -1) {
        for (c = h.shift(); ++i < g.length;) {
          g[i].apply(c[0], c[1]) === !1 && a.stopOnFalse && (i = g.length, c = !1);
        }
      }a.memory || (c = !1), b = !1, e && (g = c ? [] : "");
    },
        k = { add: function add() {
        return g && (c && !b && (i = g.length - 1, h.push(c)), function b(c) {
          fa.each(c, function (c, d) {
            fa.isFunction(d) ? a.unique && k.has(d) || g.push(d) : d && d.length && "string" !== fa.type(d) && b(d);
          });
        }(arguments), c && !b && j()), this;
      }, remove: function remove() {
        return fa.each(arguments, function (a, b) {
          for (var c; (c = fa.inArray(b, g, c)) > -1;) {
            g.splice(c, 1), i >= c && i--;
          }
        }), this;
      }, has: function has(a) {
        return a ? fa.inArray(a, g) > -1 : g.length > 0;
      }, empty: function empty() {
        return g && (g = []), this;
      }, disable: function disable() {
        return e = h = [], g = c = "", this;
      }, disabled: function disabled() {
        return !g;
      }, lock: function lock() {
        return e = h = [], c || (g = c = ""), this;
      }, locked: function locked() {
        return !!e;
      }, fireWith: function fireWith(a, c) {
        return e || (c = c || [], c = [a, c.slice ? c.slice() : c], h.push(c), b || j()), this;
      }, fire: function fire() {
        return k.fireWith(this, arguments), this;
      }, fired: function fired() {
        return !!d;
      } };return k;
  }, fa.extend({ Deferred: function Deferred(a) {
      var b = [["resolve", "done", fa.Callbacks("once memory"), "resolved"], ["reject", "fail", fa.Callbacks("once memory"), "rejected"], ["notify", "progress", fa.Callbacks("memory")]],
          c = "pending",
          d = { state: function state() {
          return c;
        }, always: function always() {
          return e.done(arguments).fail(arguments), this;
        }, then: function then() {
          var a = arguments;return fa.Deferred(function (c) {
            fa.each(b, function (b, f) {
              var g = fa.isFunction(a[b]) && a[b];e[f[1]](function () {
                var a = g && g.apply(this, arguments);a && fa.isFunction(a.promise) ? a.promise().progress(c.notify).done(c.resolve).fail(c.reject) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments);
              });
            }), a = null;
          }).promise();
        }, promise: function promise(a) {
          return null != a ? fa.extend(a, d) : d;
        } },
          e = {};return d.pipe = d.then, fa.each(b, function (a, f) {
        var g = f[2],
            h = f[3];d[f[1]] = g.add, h && g.add(function () {
          c = h;
        }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function () {
          return e[f[0] + "With"](this === e ? d : this, arguments), this;
        }, e[f[0] + "With"] = g.fireWith;
      }), d.promise(e), a && a.call(e, e), e;
    }, when: function when(a) {
      var b,
          c,
          d,
          e = 0,
          f = Y.call(arguments),
          g = f.length,
          h = 1 !== g || a && fa.isFunction(a.promise) ? g : 0,
          i = 1 === h ? a : fa.Deferred(),
          j = function j(a, c, d) {
        return function (e) {
          c[a] = this, d[a] = arguments.length > 1 ? Y.call(arguments) : e, d === b ? i.notifyWith(c, d) : --h || i.resolveWith(c, d);
        };
      };if (g > 1) for (b = new Array(g), c = new Array(g), d = new Array(g); g > e; e++) {
        f[e] && fa.isFunction(f[e].promise) ? f[e].promise().progress(j(e, c, b)).done(j(e, d, f)).fail(i.reject) : --h;
      }return h || i.resolveWith(d, f), i.promise();
    } });var wa;fa.fn.ready = function (a) {
    return fa.ready.promise().done(a), this;
  }, fa.extend({ isReady: !1, readyWait: 1, holdReady: function holdReady(a) {
      a ? fa.readyWait++ : fa.ready(!0);
    }, ready: function ready(a) {
      (a === !0 ? --fa.readyWait : fa.isReady) || (fa.isReady = !0, a !== !0 && --fa.readyWait > 0 || (wa.resolveWith(X, [fa]), fa.fn.triggerHandler && (fa(X).triggerHandler("ready"), fa(X).off("ready"))));
    } }), fa.ready.promise = function (b) {
    return wa || (wa = fa.Deferred(), "complete" === X.readyState || "loading" !== X.readyState && !X.documentElement.doScroll ? a.setTimeout(fa.ready) : (X.addEventListener("DOMContentLoaded", g), a.addEventListener("load", g))), wa.promise(b);
  }, fa.ready.promise();var xa = function xa(a, b, c, d, e, f, g) {
    var h = 0,
        i = a.length,
        j = null == c;if ("object" === fa.type(c)) {
      e = !0;for (h in c) {
        xa(a, b, h, c[h], !0, f, g);
      }
    } else if (void 0 !== d && (e = !0, fa.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function b(a, _b, c) {
      return j.call(fa(a), c);
    })), b)) for (; i > h; h++) {
      b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
    }return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
  },
      ya = function ya(a) {
    return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType;
  };h.uid = 1, h.prototype = { register: function register(a, b) {
      var c = b || {};return a.nodeType ? a[this.expando] = c : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(a, this.expando, { value: c, writable: !0, configurable: !0 }), a[this.expando];
    }, cache: function cache(a) {
      if (!ya(a)) return {};var b = a[this.expando];return b || (b = {}, ya(a) && (a.nodeType ? a[this.expando] = b : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_property___default()(a, this.expando, { value: b, configurable: !0 }))), b;
    }, set: function set(a, b, c) {
      var d,
          e = this.cache(a);if ("string" == typeof b) e[b] = c;else for (d in b) {
        e[d] = b[d];
      }return e;
    }, get: function get(a, b) {
      return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][b];
    }, access: function access(a, b, c) {
      var d;return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b), void 0 !== d ? d : this.get(a, fa.camelCase(b))) : (this.set(a, b, c), void 0 !== c ? c : b);
    }, remove: function remove(a, b) {
      var c,
          d,
          e,
          f = a[this.expando];if (void 0 !== f) {
        if (void 0 === b) this.register(a);else {
          fa.isArray(b) ? d = b.concat(b.map(fa.camelCase)) : (e = fa.camelCase(b), b in f ? d = [b, e] : (d = e, d = d in f ? [d] : d.match(va) || [])), c = d.length;for (; c--;) {
            delete f[d[c]];
          }
        }(void 0 === b || fa.isEmptyObject(f)) && (a.nodeType ? a[this.expando] = void 0 : delete a[this.expando]);
      }
    }, hasData: function hasData(a) {
      var b = a[this.expando];return void 0 !== b && !fa.isEmptyObject(b);
    } };var za = new h(),
      Aa = new h(),
      Ba = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      Ca = /[A-Z]/g;fa.extend({ hasData: function hasData(a) {
      return Aa.hasData(a) || za.hasData(a);
    }, data: function data(a, b, c) {
      return Aa.access(a, b, c);
    }, removeData: function removeData(a, b) {
      Aa.remove(a, b);
    }, _data: function _data(a, b, c) {
      return za.access(a, b, c);
    }, _removeData: function _removeData(a, b) {
      za.remove(a, b);
    } }), fa.fn.extend({ data: function data(a, b) {
      var c,
          d,
          e,
          f = this[0],
          g = f && f.attributes;if (void 0 === a) {
        if (this.length && (e = Aa.get(f), 1 === f.nodeType && !za.get(f, "hasDataAttrs"))) {
          for (c = g.length; c--;) {
            g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = fa.camelCase(d.slice(5)), i(f, d, e[d])));
          }za.set(f, "hasDataAttrs", !0);
        }return e;
      }return "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(a)) ? this.each(function () {
        Aa.set(this, a);
      }) : xa(this, function (b) {
        var c, d;if (f && void 0 === b) {
          if (c = Aa.get(f, a) || Aa.get(f, a.replace(Ca, "-$&").toLowerCase()), void 0 !== c) return c;if (d = fa.camelCase(a), c = Aa.get(f, d), void 0 !== c) return c;if (c = i(f, d, void 0), void 0 !== c) return c;
        } else d = fa.camelCase(a), this.each(function () {
          var c = Aa.get(this, d);Aa.set(this, d, b), a.indexOf("-") > -1 && void 0 !== c && Aa.set(this, a, b);
        });
      }, null, b, arguments.length > 1, null, !0);
    }, removeData: function removeData(a) {
      return this.each(function () {
        Aa.remove(this, a);
      });
    } }), fa.extend({ queue: function queue(a, b, c) {
      var d;return a ? (b = (b || "fx") + "queue", d = za.get(a, b), c && (!d || fa.isArray(c) ? d = za.access(a, b, fa.makeArray(c)) : d.push(c)), d || []) : void 0;
    }, dequeue: function dequeue(a, b) {
      b = b || "fx";var c = fa.queue(a, b),
          d = c.length,
          e = c.shift(),
          f = fa._queueHooks(a, b),
          g = function g() {
        fa.dequeue(a, b);
      };"inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire();
    }, _queueHooks: function _queueHooks(a, b) {
      var c = b + "queueHooks";return za.get(a, c) || za.access(a, c, { empty: fa.Callbacks("once memory").add(function () {
          za.remove(a, [b + "queue", c]);
        }) });
    } }), fa.fn.extend({ queue: function queue(a, b) {
      var c = 2;return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? fa.queue(this[0], a) : void 0 === b ? this : this.each(function () {
        var c = fa.queue(this, a, b);fa._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && fa.dequeue(this, a);
      });
    }, dequeue: function dequeue(a) {
      return this.each(function () {
        fa.dequeue(this, a);
      });
    }, clearQueue: function clearQueue(a) {
      return this.queue(a || "fx", []);
    }, promise: function promise(a, b) {
      var c,
          d = 1,
          e = fa.Deferred(),
          f = this,
          g = this.length,
          h = function h() {
        --d || e.resolveWith(f, [f]);
      };for ("string" != typeof a && (b = a, a = void 0), a = a || "fx"; g--;) {
        c = za.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
      }return h(), e.promise(b);
    } });var Da = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Ea = new RegExp("^(?:([+-])=|)(" + Da + ")([a-z%]*)$", "i"),
      Fa = ["Top", "Right", "Bottom", "Left"],
      Ga = function Ga(a, b) {
    return a = b || a, "none" === fa.css(a, "display") || !fa.contains(a.ownerDocument, a);
  },
      Ha = /^(?:checkbox|radio)$/i,
      Ia = /<([\w:-]+)/,
      Ja = /^$|\/(?:java|ecma)script/i,
      Ka = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };Ka.optgroup = Ka.option, Ka.tbody = Ka.tfoot = Ka.colgroup = Ka.caption = Ka.thead, Ka.th = Ka.td;var La = /<|&#?\w+;/;!function () {
    var a = X.createDocumentFragment(),
        b = a.appendChild(X.createElement("div")),
        c = X.createElement("input");c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), da.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", da.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue;
  }();var Ma = /^key/,
      Na = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Oa = /^([^.]*)(?:\.(.+)|)/;fa.event = { global: {}, add: function add(a, b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q = za.get(a);if (q) for (c.handler && (f = c, c = f.handler, e = f.selector), c.guid || (c.guid = fa.guid++), (i = q.events) || (i = q.events = {}), (g = q.handle) || (g = q.handle = function (b) {
        return "undefined" != typeof fa && fa.event.triggered !== b.type ? fa.event.dispatch.apply(a, arguments) : void 0;
      }), b = (b || "").match(va) || [""], j = b.length; j--;) {
        h = Oa.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n && (l = fa.event.special[n] || {}, n = (e ? l.delegateType : l.bindType) || n, l = fa.event.special[n] || {}, k = fa.extend({ type: n, origType: p, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && fa.expr.match.needsContext.test(e), namespace: o.join(".") }, f), (m = i[n]) || (m = i[n] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, o, g) !== !1 || a.addEventListener && a.addEventListener(n, g)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), fa.event.global[n] = !0);
      }
    }, remove: function remove(a, b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q = za.hasData(a) && za.get(a);if (q && (i = q.events)) {
        for (b = (b || "").match(va) || [""], j = b.length; j--;) {
          if (h = Oa.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n) {
            for (l = fa.event.special[n] || {}, n = (d ? l.delegateType : l.bindType) || n, m = i[n] || [], h = h[2] && new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length; f--;) {
              k = m[f], !e && p !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
            }g && !m.length && (l.teardown && l.teardown.call(a, o, q.handle) !== !1 || fa.removeEvent(a, n, q.handle), delete i[n]);
          } else for (n in i) {
            fa.event.remove(a, n + b[j], c, d, !0);
          }
        }fa.isEmptyObject(i) && za.remove(a, "handle events");
      }
    }, dispatch: function dispatch(a) {
      a = fa.event.fix(a);var b,
          c,
          d,
          e,
          f,
          g = [],
          h = Y.call(arguments),
          i = (za.get(this, "events") || {})[a.type] || [],
          j = fa.event.special[a.type] || {};if (h[0] = a, a.delegateTarget = this, !j.preDispatch || j.preDispatch.call(this, a) !== !1) {
        for (g = fa.event.handlers.call(this, a, i), b = 0; (e = g[b++]) && !a.isPropagationStopped();) {
          for (a.currentTarget = e.elem, c = 0; (f = e.handlers[c++]) && !a.isImmediatePropagationStopped();) {
            a.rnamespace && !a.rnamespace.test(f.namespace) || (a.handleObj = f, a.data = f.data, d = ((fa.event.special[f.origType] || {}).handle || f.handler).apply(e.elem, h), void 0 !== d && (a.result = d) === !1 && (a.preventDefault(), a.stopPropagation()));
          }
        }return j.postDispatch && j.postDispatch.call(this, a), a.result;
      }
    }, handlers: function handlers(a, b) {
      var c,
          d,
          e,
          f,
          g = [],
          h = b.delegateCount,
          i = a.target;if (h && i.nodeType && ("click" !== a.type || isNaN(a.button) || a.button < 1)) for (; i !== this; i = i.parentNode || this) {
        if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
          for (d = [], c = 0; h > c; c++) {
            f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? fa(e, this).index(i) > -1 : fa.find(e, this, null, [i]).length), d[e] && d.push(f);
          }d.length && g.push({ elem: i, handlers: d });
        }
      }return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
    }, props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(a, b) {
        return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a;
      } }, mouseHooks: { props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(a, b) {
        var c,
            d,
            e,
            f = b.button;return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || X, d = c.documentElement, e = c.body, a.pageX = b.clientX + (d && d.scrollLeft || e && e.scrollLeft || 0) - (d && d.clientLeft || e && e.clientLeft || 0), a.pageY = b.clientY + (d && d.scrollTop || e && e.scrollTop || 0) - (d && d.clientTop || e && e.clientTop || 0)), a.which || void 0 === f || (a.which = 1 & f ? 1 : 2 & f ? 3 : 4 & f ? 2 : 0), a;
      } }, fix: function fix(a) {
      if (a[fa.expando]) return a;var b,
          c,
          d,
          e = a.type,
          f = a,
          g = this.fixHooks[e];for (g || (this.fixHooks[e] = g = Na.test(e) ? this.mouseHooks : Ma.test(e) ? this.keyHooks : {}), d = g.props ? this.props.concat(g.props) : this.props, a = new fa.Event(f), b = d.length; b--;) {
        c = d[b], a[c] = f[c];
      }return a.target || (a.target = X), 3 === a.target.nodeType && (a.target = a.target.parentNode), g.filter ? g.filter(a, f) : a;
    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
          return this !== p() && this.focus ? (this.focus(), !1) : void 0;
        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
          return this === p() && this.blur ? (this.blur(), !1) : void 0;
        }, delegateType: "focusout" }, click: { trigger: function trigger() {
          return "checkbox" === this.type && this.click && fa.nodeName(this, "input") ? (this.click(), !1) : void 0;
        }, _default: function _default(a) {
          return fa.nodeName(a.target, "a");
        } }, beforeunload: { postDispatch: function postDispatch(a) {
          void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
        } } } }, fa.removeEvent = function (a, b, c) {
    a.removeEventListener && a.removeEventListener(b, c);
  }, fa.Event = function (a, b) {
    return this instanceof fa.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? n : o) : this.type = a, b && fa.extend(this, b), this.timeStamp = a && a.timeStamp || fa.now(), void (this[fa.expando] = !0)) : new fa.Event(a, b);
  }, fa.Event.prototype = { constructor: fa.Event, isDefaultPrevented: o, isPropagationStopped: o, isImmediatePropagationStopped: o, isSimulated: !1, preventDefault: function preventDefault() {
      var a = this.originalEvent;this.isDefaultPrevented = n, a && !this.isSimulated && a.preventDefault();
    }, stopPropagation: function stopPropagation() {
      var a = this.originalEvent;this.isPropagationStopped = n, a && !this.isSimulated && a.stopPropagation();
    }, stopImmediatePropagation: function stopImmediatePropagation() {
      var a = this.originalEvent;this.isImmediatePropagationStopped = n, a && !this.isSimulated && a.stopImmediatePropagation(), this.stopPropagation();
    } }, fa.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (a, b) {
    fa.event.special[a] = { delegateType: b, bindType: b, handle: function handle(a) {
        var c,
            d = this,
            e = a.relatedTarget,
            f = a.handleObj;return e && (e === d || fa.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
      } };
  }), fa.fn.extend({ on: function on(a, b, c, d) {
      return q(this, a, b, c, d);
    }, one: function one(a, b, c, d) {
      return q(this, a, b, c, d, 1);
    }, off: function off(a, b, c) {
      var d, e;if (a && a.preventDefault && a.handleObj) return d = a.handleObj, fa(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;if ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(a))) {
        for (e in a) {
          this.off(e, b, a[e]);
        }return this;
      }return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = o), this.each(function () {
        fa.event.remove(this, a, c, b);
      });
    } });var Pa = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      Qa = /<script|<style|<link/i,
      Ra = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Sa = /^true\/(.*)/,
      Ta = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;fa.extend({ htmlPrefilter: function htmlPrefilter(a) {
      return a.replace(Pa, "<$1></$2>");
    }, clone: function clone(a, b, c) {
      var d,
          e,
          f,
          g,
          h = a.cloneNode(!0),
          i = fa.contains(a.ownerDocument, a);if (!(da.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || fa.isXMLDoc(a))) for (g = k(h), f = k(a), d = 0, e = f.length; e > d; d++) {
        v(f[d], g[d]);
      }if (b) if (c) for (f = f || k(a), g = g || k(h), d = 0, e = f.length; e > d; d++) {
        u(f[d], g[d]);
      } else u(a, h);return g = k(h, "script"), g.length > 0 && l(g, !i && k(a, "script")), h;
    }, cleanData: function cleanData(a) {
      for (var b, c, d, e = fa.event.special, f = 0; void 0 !== (c = a[f]); f++) {
        if (ya(c)) {
          if (b = c[za.expando]) {
            if (b.events) for (d in b.events) {
              e[d] ? fa.event.remove(c, d) : fa.removeEvent(c, d, b.handle);
            }c[za.expando] = void 0;
          }c[Aa.expando] && (c[Aa.expando] = void 0);
        }
      }
    } }), fa.fn.extend({ domManip: w, detach: function detach(a) {
      return x(this, a, !0);
    }, remove: function remove(a) {
      return x(this, a);
    }, text: function text(a) {
      return xa(this, function (a) {
        return void 0 === a ? fa.text(this) : this.empty().each(function () {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = a);
        });
      }, null, a, arguments.length);
    }, append: function append() {
      return w(this, arguments, function (a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = r(this, a);b.appendChild(a);
        }
      });
    }, prepend: function prepend() {
      return w(this, arguments, function (a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = r(this, a);b.insertBefore(a, b.firstChild);
        }
      });
    }, before: function before() {
      return w(this, arguments, function (a) {
        this.parentNode && this.parentNode.insertBefore(a, this);
      });
    }, after: function after() {
      return w(this, arguments, function (a) {
        this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
      });
    }, empty: function empty() {
      for (var a, b = 0; null != (a = this[b]); b++) {
        1 === a.nodeType && (fa.cleanData(k(a, !1)), a.textContent = "");
      }return this;
    }, clone: function clone(a, b) {
      return a = null != a && a, b = null == b ? a : b, this.map(function () {
        return fa.clone(this, a, b);
      });
    }, html: function html(a) {
      return xa(this, function (a) {
        var b = this[0] || {},
            c = 0,
            d = this.length;if (void 0 === a && 1 === b.nodeType) return b.innerHTML;if ("string" == typeof a && !Qa.test(a) && !Ka[(Ia.exec(a) || ["", ""])[1].toLowerCase()]) {
          a = fa.htmlPrefilter(a);try {
            for (; d > c; c++) {
              b = this[c] || {}, 1 === b.nodeType && (fa.cleanData(k(b, !1)), b.innerHTML = a);
            }b = 0;
          } catch (a) {}
        }b && this.empty().append(a);
      }, null, a, arguments.length);
    }, replaceWith: function replaceWith() {
      var a = [];return w(this, arguments, function (b) {
        var c = this.parentNode;fa.inArray(this, a) < 0 && (fa.cleanData(k(this)), c && c.replaceChild(b, this));
      }, a);
    } }), fa.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (a, b) {
    fa.fn[a] = function (a) {
      for (var c, d = [], e = fa(a), f = e.length - 1, g = 0; f >= g; g++) {
        c = g === f ? this : this.clone(!0), fa(e[g])[b](c), $.apply(d, c.get());
      }return this.pushStack(d);
    };
  });var Ua,
      Va = { HTML: "block", BODY: "block" },
      Wa = /^margin/,
      Xa = new RegExp("^(" + Da + ")(?!px)[a-z%]+$", "i"),
      Ya = function Ya(b) {
    var c = b.ownerDocument.defaultView;return c && c.opener || (c = a), c.getComputedStyle(b);
  },
      Za = function Za(a, b, c, d) {
    var e,
        f,
        g = {};for (f in b) {
      g[f] = a.style[f], a.style[f] = b[f];
    }e = c.apply(a, d || []);for (f in b) {
      a.style[f] = g[f];
    }return e;
  },
      $a = X.documentElement;!function () {
    function b() {
      h.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", h.innerHTML = "", $a.appendChild(g);var b = a.getComputedStyle(h);c = "1%" !== b.top, f = "2px" === b.marginLeft, d = "4px" === b.width, h.style.marginRight = "50%", e = "4px" === b.marginRight, $a.removeChild(g);
    }var c,
        d,
        e,
        f,
        g = X.createElement("div"),
        h = X.createElement("div");h.style && (h.style.backgroundClip = "content-box", h.cloneNode(!0).style.backgroundClip = "", da.clearCloneStyle = "content-box" === h.style.backgroundClip, g.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", g.appendChild(h), fa.extend(da, { pixelPosition: function pixelPosition() {
        return b(), c;
      }, boxSizingReliable: function boxSizingReliable() {
        return null == d && b(), d;
      }, pixelMarginRight: function pixelMarginRight() {
        return null == d && b(), e;
      }, reliableMarginLeft: function reliableMarginLeft() {
        return null == d && b(), f;
      }, reliableMarginRight: function reliableMarginRight() {
        var b,
            c = h.appendChild(X.createElement("div"));return c.style.cssText = h.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", c.style.marginRight = c.style.width = "0", h.style.width = "1px", $a.appendChild(g), b = !parseFloat(a.getComputedStyle(c).marginRight), $a.removeChild(g), h.removeChild(c), b;
      } }));
  }();var _a = /^(none|table(?!-c[ea]).+)/,
      ab = { position: "absolute", visibility: "hidden", display: "block" },
      bb = { letterSpacing: "0", fontWeight: "400" },
      cb = ["Webkit", "O", "Moz", "ms"],
      db = X.createElement("div").style;fa.extend({ cssHooks: { opacity: { get: function get(a, b) {
          if (b) {
            var c = A(a, "opacity");return "" === c ? "1" : c;
          }
        } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { float: "cssFloat" }, style: function style(a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e,
            f,
            g,
            h = fa.camelCase(b),
            i = a.style;return b = fa.cssProps[h] || (fa.cssProps[h] = C(h) || h), g = fa.cssHooks[b] || fa.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b] : (f = typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(c), "string" === f && (e = Ea.exec(c)) && e[1] && (c = j(a, b, e), f = "number"), void (null != c && c === c && ("number" === f && (c += e && e[3] || (fa.cssNumber[h] ? "" : "px")), da.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i[b] = c))));
      }
    }, css: function css(a, b, c, d) {
      var e,
          f,
          g,
          h = fa.camelCase(b);return b = fa.cssProps[h] || (fa.cssProps[h] = C(h) || h), g = fa.cssHooks[b] || fa.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = A(a, b, d)), "normal" === e && b in bb && (e = bb[b]), "" === c || c ? (f = parseFloat(e), c === !0 || isFinite(f) ? f || 0 : e) : e;
    } }), fa.each(["height", "width"], function (a, b) {
    fa.cssHooks[b] = { get: function get(a, c, d) {
        return c ? _a.test(fa.css(a, "display")) && 0 === a.offsetWidth ? Za(a, ab, function () {
          return F(a, b, d);
        }) : F(a, b, d) : void 0;
      }, set: function set(a, c, d) {
        var e,
            f = d && Ya(a),
            g = d && E(a, b, d, "border-box" === fa.css(a, "boxSizing", !1, f), f);return g && (e = Ea.exec(c)) && "px" !== (e[3] || "px") && (a.style[b] = c, c = fa.css(a, b)), D(a, c, g);
      } };
  }), fa.cssHooks.marginLeft = B(da.reliableMarginLeft, function (a, b) {
    return b ? (parseFloat(A(a, "marginLeft")) || a.getBoundingClientRect().left - Za(a, { marginLeft: 0 }, function () {
      return a.getBoundingClientRect().left;
    })) + "px" : void 0;
  }), fa.cssHooks.marginRight = B(da.reliableMarginRight, function (a, b) {
    return b ? Za(a, { display: "inline-block" }, A, [a, "marginRight"]) : void 0;
  }), fa.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
    fa.cssHooks[a + b] = { expand: function expand(c) {
        for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++) {
          e[a + Fa[d] + b] = f[d] || f[d - 2] || f[0];
        }return e;
      } }, Wa.test(a) || (fa.cssHooks[a + b].set = D);
  }), fa.fn.extend({ css: function css(a, b) {
      return xa(this, function (a, b, c) {
        var d,
            e,
            f = {},
            g = 0;if (fa.isArray(b)) {
          for (d = Ya(a), e = b.length; e > g; g++) {
            f[b[g]] = fa.css(a, b[g], !1, d);
          }return f;
        }return void 0 !== c ? fa.style(a, b, c) : fa.css(a, b);
      }, a, b, arguments.length > 1);
    }, show: function show() {
      return G(this, !0);
    }, hide: function hide() {
      return G(this);
    }, toggle: function toggle(a) {
      return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function () {
        Ga(this) ? fa(this).show() : fa(this).hide();
      });
    } }), fa.Tween = H, H.prototype = { constructor: H, init: function init(a, b, c, d, e, f) {
      this.elem = a, this.prop = c, this.easing = e || fa.easing._default, this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (fa.cssNumber[c] ? "" : "px");
    }, cur: function cur() {
      var a = H.propHooks[this.prop];return a && a.get ? a.get(this) : H.propHooks._default.get(this);
    }, run: function run(a) {
      var b,
          c = H.propHooks[this.prop];return this.options.duration ? this.pos = b = fa.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : H.propHooks._default.set(this), this;
    } }, H.prototype.init.prototype = H.prototype, H.propHooks = { _default: { get: function get(a) {
        var b;return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = fa.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0);
      }, set: function set(a) {
        fa.fx.step[a.prop] ? fa.fx.step[a.prop](a) : 1 !== a.elem.nodeType || null == a.elem.style[fa.cssProps[a.prop]] && !fa.cssHooks[a.prop] ? a.elem[a.prop] = a.now : fa.style(a.elem, a.prop, a.now + a.unit);
      } } }, H.propHooks.scrollTop = H.propHooks.scrollLeft = { set: function set(a) {
      a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
    } }, fa.easing = { linear: function linear(a) {
      return a;
    }, swing: function swing(a) {
      return .5 - Math.cos(a * Math.PI) / 2;
    }, _default: "swing" }, fa.fx = H.prototype.init, fa.fx.step = {};var eb,
      fb,
      gb = /^(?:toggle|show|hide)$/,
      hb = /queueHooks$/;fa.Animation = fa.extend(N, { tweeners: { "*": [function (a, b) {
        var c = this.createTween(a, b);return j(c.elem, a, Ea.exec(b), c), c;
      }] }, tweener: function tweener(a, b) {
      fa.isFunction(a) ? (b = a, a = ["*"]) : a = a.match(va);for (var c, d = 0, e = a.length; e > d; d++) {
        c = a[d], N.tweeners[c] = N.tweeners[c] || [], N.tweeners[c].unshift(b);
      }
    }, prefilters: [L], prefilter: function prefilter(a, b) {
      b ? N.prefilters.unshift(a) : N.prefilters.push(a);
    } }), fa.speed = function (a, b, c) {
    var d = a && "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(a)) ? fa.extend({}, a) : { complete: c || !c && b || fa.isFunction(a) && a, duration: a, easing: c && b || b && !fa.isFunction(b) && b };return d.duration = fa.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in fa.fx.speeds ? fa.fx.speeds[d.duration] : fa.fx.speeds._default, null != d.queue && d.queue !== !0 || (d.queue = "fx"), d.old = d.complete, d.complete = function () {
      fa.isFunction(d.old) && d.old.call(this), d.queue && fa.dequeue(this, d.queue);
    }, d;
  }, fa.fn.extend({ fadeTo: function fadeTo(a, b, c, d) {
      return this.filter(Ga).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d);
    }, animate: function animate(a, b, c, d) {
      var e = fa.isEmptyObject(a),
          f = fa.speed(b, c, d),
          g = function g() {
        var b = N(this, fa.extend({}, a), f);(e || za.get(this, "finish")) && b.stop(!0);
      };return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g);
    }, stop: function stop(a, b, c) {
      var d = function d(a) {
        var b = a.stop;delete a.stop, b(c);
      };return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function () {
        var b = !0,
            e = null != a && a + "queueHooks",
            f = fa.timers,
            g = za.get(this);if (e) g[e] && g[e].stop && d(g[e]);else for (e in g) {
          g[e] && g[e].stop && hb.test(e) && d(g[e]);
        }for (e = f.length; e--;) {
          f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
        }!b && c || fa.dequeue(this, a);
      });
    }, finish: function finish(a) {
      return a !== !1 && (a = a || "fx"), this.each(function () {
        var b,
            c = za.get(this),
            d = c[a + "queue"],
            e = c[a + "queueHooks"],
            f = fa.timers,
            g = d ? d.length : 0;for (c.finish = !0, fa.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) {
          f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
        }for (b = 0; g > b; b++) {
          d[b] && d[b].finish && d[b].finish.call(this);
        }delete c.finish;
      });
    } }), fa.each(["toggle", "show", "hide"], function (a, b) {
    var c = fa.fn[b];fa.fn[b] = function (a, d, e) {
      return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(J(b, !0), a, d, e);
    };
  }), fa.each({ slideDown: J("show"), slideUp: J("hide"), slideToggle: J("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (a, b) {
    fa.fn[a] = function (a, c, d) {
      return this.animate(b, a, c, d);
    };
  }), fa.timers = [], fa.fx.tick = function () {
    var a,
        b = 0,
        c = fa.timers;for (eb = fa.now(); b < c.length; b++) {
      a = c[b], a() || c[b] !== a || c.splice(b--, 1);
    }c.length || fa.fx.stop(), eb = void 0;
  }, fa.fx.timer = function (a) {
    fa.timers.push(a), a() ? fa.fx.start() : fa.timers.pop();
  }, fa.fx.interval = 13, fa.fx.start = function () {
    fb || (fb = a.setInterval(fa.fx.tick, fa.fx.interval));
  }, fa.fx.stop = function () {
    a.clearInterval(fb), fb = null;
  }, fa.fx.speeds = { slow: 600, fast: 200, _default: 400 }, fa.fn.delay = function (b, c) {
    return b = fa.fx ? fa.fx.speeds[b] || b : b, c = c || "fx", this.queue(c, function (c, d) {
      var e = a.setTimeout(c, b);d.stop = function () {
        a.clearTimeout(e);
      };
    });
  }, function () {
    var a = X.createElement("input"),
        b = X.createElement("select"),
        c = b.appendChild(X.createElement("option"));a.type = "checkbox", da.checkOn = "" !== a.value, da.optSelected = c.selected, b.disabled = !0, da.optDisabled = !c.disabled, a = X.createElement("input"), a.value = "t", a.type = "radio", da.radioValue = "t" === a.value;
  }();var ib,
      jb = fa.expr.attrHandle;fa.fn.extend({ attr: function attr(a, b) {
      return xa(this, fa.attr, a, b, arguments.length > 1);
    }, removeAttr: function removeAttr(a) {
      return this.each(function () {
        fa.removeAttr(this, a);
      });
    } }), fa.extend({ attr: function attr(a, b, c) {
      var d,
          e,
          f = a.nodeType;if (3 !== f && 8 !== f && 2 !== f) return "undefined" == typeof a.getAttribute ? fa.prop(a, b, c) : (1 === f && fa.isXMLDoc(a) || (b = b.toLowerCase(), e = fa.attrHooks[b] || (fa.expr.match.bool.test(b) ? ib : void 0)), void 0 !== c ? null === c ? void fa.removeAttr(a, b) : e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""), c) : e && "get" in e && null !== (d = e.get(a, b)) ? d : (d = fa.find.attr(a, b), null == d ? void 0 : d));
    }, attrHooks: { type: { set: function set(a, b) {
          if (!da.radioValue && "radio" === b && fa.nodeName(a, "input")) {
            var c = a.value;return a.setAttribute("type", b), c && (a.value = c), b;
          }
        } } }, removeAttr: function removeAttr(a, b) {
      var c,
          d,
          e = 0,
          f = b && b.match(va);if (f && 1 === a.nodeType) for (; c = f[e++];) {
        d = fa.propFix[c] || c, fa.expr.match.bool.test(c) && (a[d] = !1), a.removeAttribute(c);
      }
    } }), ib = { set: function set(a, b, c) {
      return b === !1 ? fa.removeAttr(a, c) : a.setAttribute(c, c), c;
    } }, fa.each(fa.expr.match.bool.source.match(/\w+/g), function (a, b) {
    var c = jb[b] || fa.find.attr;jb[b] = function (a, b, d) {
      var e, f;return d || (f = jb[b], jb[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, jb[b] = f), e;
    };
  });var kb = /^(?:input|select|textarea|button)$/i,
      lb = /^(?:a|area)$/i;fa.fn.extend({ prop: function prop(a, b) {
      return xa(this, fa.prop, a, b, arguments.length > 1);
    }, removeProp: function removeProp(a) {
      return this.each(function () {
        delete this[fa.propFix[a] || a];
      });
    } }), fa.extend({ prop: function prop(a, b, c) {
      var d,
          e,
          f = a.nodeType;if (3 !== f && 8 !== f && 2 !== f) return 1 === f && fa.isXMLDoc(a) || (b = fa.propFix[b] || b, e = fa.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b];
    }, propHooks: { tabIndex: { get: function get(a) {
          var b = fa.find.attr(a, "tabindex");return b ? parseInt(b, 10) : kb.test(a.nodeName) || lb.test(a.nodeName) && a.href ? 0 : -1;
        } } }, propFix: { for: "htmlFor", class: "className" } }), da.optSelected || (fa.propHooks.selected = { get: function get(a) {
      var b = a.parentNode;return b && b.parentNode && b.parentNode.selectedIndex, null;
    }, set: function set(a) {
      var b = a.parentNode;b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
    } }), fa.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    fa.propFix[this.toLowerCase()] = this;
  });var mb = /[\t\r\n\f]/g;fa.fn.extend({ addClass: function addClass(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = 0;if (fa.isFunction(a)) return this.each(function (b) {
        fa(this).addClass(a.call(this, b, O(this)));
      });if ("string" == typeof a && a) for (b = a.match(va) || []; c = this[i++];) {
        if (e = O(c), d = 1 === c.nodeType && (" " + e + " ").replace(mb, " ")) {
          for (g = 0; f = b[g++];) {
            d.indexOf(" " + f + " ") < 0 && (d += f + " ");
          }h = fa.trim(d), e !== h && c.setAttribute("class", h);
        }
      }return this;
    }, removeClass: function removeClass(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i = 0;if (fa.isFunction(a)) return this.each(function (b) {
        fa(this).removeClass(a.call(this, b, O(this)));
      });if (!arguments.length) return this.attr("class", "");if ("string" == typeof a && a) for (b = a.match(va) || []; c = this[i++];) {
        if (e = O(c), d = 1 === c.nodeType && (" " + e + " ").replace(mb, " ")) {
          for (g = 0; f = b[g++];) {
            for (; d.indexOf(" " + f + " ") > -1;) {
              d = d.replace(" " + f + " ", " ");
            }
          }h = fa.trim(d), e !== h && c.setAttribute("class", h);
        }
      }return this;
    }, toggleClass: function toggleClass(a, b) {
      var c = typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(a);return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : fa.isFunction(a) ? this.each(function (c) {
        fa(this).toggleClass(a.call(this, c, O(this), b), b);
      }) : this.each(function () {
        var b, d, e, f;if ("string" === c) for (d = 0, e = fa(this), f = a.match(va) || []; b = f[d++];) {
          e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
        } else void 0 !== a && "boolean" !== c || (b = O(this), b && za.set(this, "__className__", b), this.setAttribute && this.setAttribute("class", b || a === !1 ? "" : za.get(this, "__className__") || ""));
      });
    }, hasClass: function hasClass(a) {
      var b,
          c,
          d = 0;for (b = " " + a + " "; c = this[d++];) {
        if (1 === c.nodeType && (" " + O(c) + " ").replace(mb, " ").indexOf(b) > -1) return !0;
      }return !1;
    } });var nb = /\r/g,
      ob = /[\x20\t\r\n\f]+/g;fa.fn.extend({ val: function val(a) {
      var b,
          c,
          d,
          e = this[0];return arguments.length ? (d = fa.isFunction(a), this.each(function (c) {
        var e;1 === this.nodeType && (e = d ? a.call(this, c, fa(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : fa.isArray(e) && (e = fa.map(e, function (a) {
          return null == a ? "" : a + "";
        })), b = fa.valHooks[this.type] || fa.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e));
      })) : e ? (b = fa.valHooks[e.type] || fa.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(nb, "") : null == c ? "" : c)) : void 0;
    } }), fa.extend({ valHooks: { option: { get: function get(a) {
          var b = fa.find.attr(a, "value");return null != b ? b : fa.trim(fa.text(a)).replace(ob, " ");
        } }, select: { get: function get(a) {
          for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++) {
            if (c = d[i], (c.selected || i === e) && (da.optDisabled ? !c.disabled : null === c.getAttribute("disabled")) && (!c.parentNode.disabled || !fa.nodeName(c.parentNode, "optgroup"))) {
              if (b = fa(c).val(), f) return b;g.push(b);
            }
          }return g;
        }, set: function set(a, b) {
          for (var c, d, e = a.options, f = fa.makeArray(b), g = e.length; g--;) {
            d = e[g], (d.selected = fa.inArray(fa.valHooks.option.get(d), f) > -1) && (c = !0);
          }return c || (a.selectedIndex = -1), f;
        } } } }), fa.each(["radio", "checkbox"], function () {
    fa.valHooks[this] = { set: function set(a, b) {
        return fa.isArray(b) ? a.checked = fa.inArray(fa(a).val(), b) > -1 : void 0;
      } }, da.checkOn || (fa.valHooks[this].get = function (a) {
      return null === a.getAttribute("value") ? "on" : a.value;
    });
  });var pb = /^(?:focusinfocus|focusoutblur)$/;fa.extend(fa.event, { trigger: function trigger(b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m = [d || X],
          n = ca.call(b, "type") ? b.type : b,
          o = ca.call(b, "namespace") ? b.namespace.split(".") : [];if (g = h = d = d || X, 3 !== d.nodeType && 8 !== d.nodeType && !pb.test(n + fa.event.triggered) && (n.indexOf(".") > -1 && (o = n.split("."), n = o.shift(), o.sort()), j = n.indexOf(":") < 0 && "on" + n, b = b[fa.expando] ? b : new fa.Event(n, "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b), b.isTrigger = e ? 2 : 3, b.namespace = o.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = d), c = null == c ? [b] : fa.makeArray(c, [b]), l = fa.event.special[n] || {}, e || !l.trigger || l.trigger.apply(d, c) !== !1)) {
        if (!e && !l.noBubble && !fa.isWindow(d)) {
          for (i = l.delegateType || n, pb.test(i + n) || (g = g.parentNode); g; g = g.parentNode) {
            m.push(g), h = g;
          }h === (d.ownerDocument || X) && m.push(h.defaultView || h.parentWindow || a);
        }for (f = 0; (g = m[f++]) && !b.isPropagationStopped();) {
          b.type = f > 1 ? i : l.bindType || n, k = (za.get(g, "events") || {})[b.type] && za.get(g, "handle"), k && k.apply(g, c), k = j && g[j], k && k.apply && ya(g) && (b.result = k.apply(g, c), b.result === !1 && b.preventDefault());
        }return b.type = n, e || b.isDefaultPrevented() || l._default && l._default.apply(m.pop(), c) !== !1 || !ya(d) || j && fa.isFunction(d[n]) && !fa.isWindow(d) && (h = d[j], h && (d[j] = null), fa.event.triggered = n, d[n](), fa.event.triggered = void 0, h && (d[j] = h)), b.result;
      }
    }, simulate: function simulate(a, b, c) {
      var d = fa.extend(new fa.Event(), c, { type: a, isSimulated: !0 });fa.event.trigger(d, null, b);
    } }), fa.fn.extend({ trigger: function trigger(a, b) {
      return this.each(function () {
        fa.event.trigger(a, b, this);
      });
    }, triggerHandler: function triggerHandler(a, b) {
      var c = this[0];return c ? fa.event.trigger(a, b, c, !0) : void 0;
    } }), fa.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (a, b) {
    fa.fn[b] = function (a, c) {
      return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b);
    };
  }), fa.fn.extend({ hover: function hover(a, b) {
      return this.mouseenter(a).mouseleave(b || a);
    } }), da.focusin = "onfocusin" in a, da.focusin || fa.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
    var c = function c(a) {
      fa.event.simulate(b, a.target, fa.event.fix(a));
    };fa.event.special[b] = { setup: function setup() {
        var d = this.ownerDocument || this,
            e = za.access(d, b);e || d.addEventListener(a, c, !0), za.access(d, b, (e || 0) + 1);
      }, teardown: function teardown() {
        var d = this.ownerDocument || this,
            e = za.access(d, b) - 1;e ? za.access(d, b, e) : (d.removeEventListener(a, c, !0), za.remove(d, b));
      } };
  });var qb = a.location,
      rb = fa.now(),
      sb = /\?/;fa.parseJSON = function (a) {
    return JSON.parse(a + "");
  }, fa.parseXML = function (b) {
    var c;if (!b || "string" != typeof b) return null;try {
      c = new a.DOMParser().parseFromString(b, "text/xml");
    } catch (a) {
      c = void 0;
    }return c && !c.getElementsByTagName("parsererror").length || fa.error("Invalid XML: " + b), c;
  };var tb = /#.*$/,
      ub = /([?&])_=[^&]*/,
      vb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      wb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      xb = /^(?:GET|HEAD)$/,
      yb = /^\/\//,
      zb = {},
      Ab = {},
      Bb = "*/".concat("*"),
      Cb = X.createElement("a");Cb.href = qb.href, fa.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: qb.href, type: "GET", isLocal: wb.test(qb.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Bb, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": fa.parseJSON, "text xml": fa.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(a, b) {
      return b ? R(R(a, fa.ajaxSettings), b) : R(fa.ajaxSettings, a);
    }, ajaxPrefilter: P(zb), ajaxTransport: P(Ab), ajax: function ajax(b, c) {
      function d(b, c, d, h) {
        var j,
            l,
            s,
            t,
            v,
            x = c;2 !== u && (u = 2, i && a.clearTimeout(i), e = void 0, g = h || "", w.readyState = b > 0 ? 4 : 0, j = b >= 200 && 300 > b || 304 === b, d && (t = S(m, w, d)), t = T(m, t, w, j), j ? (m.ifModified && (v = w.getResponseHeader("Last-Modified"), v && (fa.lastModified[f] = v), v = w.getResponseHeader("etag"), v && (fa.etag[f] = v)), 204 === b || "HEAD" === m.type ? x = "nocontent" : 304 === b ? x = "notmodified" : (x = t.state, l = t.data, s = t.error, j = !s)) : (s = x, !b && x || (x = "error", 0 > b && (b = 0))), w.status = b, w.statusText = (c || x) + "", j ? p.resolveWith(n, [l, x, w]) : p.rejectWith(n, [w, x, s]), w.statusCode(r), r = void 0, k && o.trigger(j ? "ajaxSuccess" : "ajaxError", [w, m, j ? l : s]), q.fireWith(n, [w, x]), k && (o.trigger("ajaxComplete", [w, m]), --fa.active || fa.event.trigger("ajaxStop")));
      }"object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && (c = b, b = void 0), c = c || {};var e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m = fa.ajaxSetup({}, c),
          n = m.context || m,
          o = m.context && (n.nodeType || n.jquery) ? fa(n) : fa.event,
          p = fa.Deferred(),
          q = fa.Callbacks("once memory"),
          r = m.statusCode || {},
          s = {},
          t = {},
          u = 0,
          v = "canceled",
          w = { readyState: 0, getResponseHeader: function getResponseHeader(a) {
          var b;if (2 === u) {
            if (!h) for (h = {}; b = vb.exec(g);) {
              h[b[1].toLowerCase()] = b[2];
            }b = h[a.toLowerCase()];
          }return null == b ? null : b;
        }, getAllResponseHeaders: function getAllResponseHeaders() {
          return 2 === u ? g : null;
        }, setRequestHeader: function setRequestHeader(a, b) {
          var c = a.toLowerCase();return u || (a = t[c] = t[c] || a, s[a] = b), this;
        }, overrideMimeType: function overrideMimeType(a) {
          return u || (m.mimeType = a), this;
        }, statusCode: function statusCode(a) {
          var b;if (a) if (2 > u) for (b in a) {
            r[b] = [r[b], a[b]];
          } else w.always(a[w.status]);return this;
        }, abort: function abort(a) {
          var b = a || v;return e && e.abort(b), d(0, b), this;
        } };if (p.promise(w).complete = q.add, w.success = w.done, w.error = w.fail, m.url = ((b || m.url || qb.href) + "").replace(tb, "").replace(yb, qb.protocol + "//"), m.type = c.method || c.type || m.method || m.type, m.dataTypes = fa.trim(m.dataType || "*").toLowerCase().match(va) || [""], null == m.crossDomain) {
        j = X.createElement("a");try {
          j.href = m.url, j.href = j.href, m.crossDomain = Cb.protocol + "//" + Cb.host != j.protocol + "//" + j.host;
        } catch (a) {
          m.crossDomain = !0;
        }
      }if (m.data && m.processData && "string" != typeof m.data && (m.data = fa.param(m.data, m.traditional)), Q(zb, m, c, w), 2 === u) return w;k = fa.event && m.global, k && 0 === fa.active++ && fa.event.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !xb.test(m.type), f = m.url, m.hasContent || (m.data && (f = m.url += (sb.test(f) ? "&" : "?") + m.data, delete m.data), m.cache === !1 && (m.url = ub.test(f) ? f.replace(ub, "$1_=" + rb++) : f + (sb.test(f) ? "&" : "?") + "_=" + rb++)), m.ifModified && (fa.lastModified[f] && w.setRequestHeader("If-Modified-Since", fa.lastModified[f]), fa.etag[f] && w.setRequestHeader("If-None-Match", fa.etag[f])), (m.data && m.hasContent && m.contentType !== !1 || c.contentType) && w.setRequestHeader("Content-Type", m.contentType), w.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + Bb + "; q=0.01" : "") : m.accepts["*"]);for (l in m.headers) {
        w.setRequestHeader(l, m.headers[l]);
      }if (m.beforeSend && (m.beforeSend.call(n, w, m) === !1 || 2 === u)) return w.abort();v = "abort";for (l in { success: 1, error: 1, complete: 1 }) {
        w[l](m[l]);
      }if (e = Q(Ab, m, c, w)) {
        if (w.readyState = 1, k && o.trigger("ajaxSend", [w, m]), 2 === u) return w;m.async && m.timeout > 0 && (i = a.setTimeout(function () {
          w.abort("timeout");
        }, m.timeout));try {
          u = 1, e.send(s, d);
        } catch (a) {
          if (!(2 > u)) throw a;d(-1, a);
        }
      } else d(-1, "No Transport");return w;
    }, getJSON: function getJSON(a, b, c) {
      return fa.get(a, b, c, "json");
    }, getScript: function getScript(a, b) {
      return fa.get(a, void 0, b, "script");
    } }), fa.each(["get", "post"], function (a, b) {
    fa[b] = function (a, c, d, e) {
      return fa.isFunction(c) && (e = e || d, d = c, c = void 0), fa.ajax(fa.extend({ url: a, type: b, dataType: e, data: c, success: d }, fa.isPlainObject(a) && a));
    };
  }), fa._evalUrl = function (a) {
    return fa.ajax({ url: a, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 });
  }, fa.fn.extend({ wrapAll: function wrapAll(a) {
      var b;return fa.isFunction(a) ? this.each(function (b) {
        fa(this).wrapAll(a.call(this, b));
      }) : (this[0] && (b = fa(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function () {
        for (var a = this; a.firstElementChild;) {
          a = a.firstElementChild;
        }return a;
      }).append(this)), this);
    }, wrapInner: function wrapInner(a) {
      return fa.isFunction(a) ? this.each(function (b) {
        fa(this).wrapInner(a.call(this, b));
      }) : this.each(function () {
        var b = fa(this),
            c = b.contents();c.length ? c.wrapAll(a) : b.append(a);
      });
    }, wrap: function wrap(a) {
      var b = fa.isFunction(a);return this.each(function (c) {
        fa(this).wrapAll(b ? a.call(this, c) : a);
      });
    }, unwrap: function unwrap() {
      return this.parent().each(function () {
        fa.nodeName(this, "body") || fa(this).replaceWith(this.childNodes);
      }).end();
    } }), fa.expr.filters.hidden = function (a) {
    return !fa.expr.filters.visible(a);
  }, fa.expr.filters.visible = function (a) {
    return a.offsetWidth > 0 || a.offsetHeight > 0 || a.getClientRects().length > 0;
  };var Db = /%20/g,
      Eb = /\[\]$/,
      Fb = /\r?\n/g,
      Gb = /^(?:submit|button|image|reset|file)$/i,
      Hb = /^(?:input|select|textarea|keygen)/i;fa.param = function (a, b) {
    var c,
        d = [],
        e = function e(a, b) {
      b = fa.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b);
    };if (void 0 === b && (b = fa.ajaxSettings && fa.ajaxSettings.traditional), fa.isArray(a) || a.jquery && !fa.isPlainObject(a)) fa.each(a, function () {
      e(this.name, this.value);
    });else for (c in a) {
      U(c, a[c], b, e);
    }return d.join("&").replace(Db, "+");
  }, fa.fn.extend({ serialize: function serialize() {
      return fa.param(this.serializeArray());
    }, serializeArray: function serializeArray() {
      return this.map(function () {
        var a = fa.prop(this, "elements");return a ? fa.makeArray(a) : this;
      }).filter(function () {
        var a = this.type;return this.name && !fa(this).is(":disabled") && Hb.test(this.nodeName) && !Gb.test(a) && (this.checked || !Ha.test(a));
      }).map(function (a, b) {
        var c = fa(this).val();return null == c ? null : fa.isArray(c) ? fa.map(c, function (a) {
          return { name: b.name, value: a.replace(Fb, "\r\n") };
        }) : { name: b.name, value: c.replace(Fb, "\r\n") };
      }).get();
    } }), fa.ajaxSettings.xhr = function () {
    try {
      return new a.XMLHttpRequest();
    } catch (a) {}
  };var Ib = { 0: 200, 1223: 204 },
      Jb = fa.ajaxSettings.xhr();da.cors = !!Jb && "withCredentials" in Jb, da.ajax = Jb = !!Jb, fa.ajaxTransport(function (b) {
    var _c, d;return da.cors || Jb && !b.crossDomain ? { send: function send(e, f) {
        var g,
            h = b.xhr();if (h.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields) for (g in b.xhrFields) {
          h[g] = b.xhrFields[g];
        }b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType), b.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest");for (g in e) {
          h.setRequestHeader(g, e[g]);
        }_c = function c(a) {
          return function () {
            _c && (_c = d = h.onload = h.onerror = h.onabort = h.onreadystatechange = null, "abort" === a ? h.abort() : "error" === a ? "number" != typeof h.status ? f(0, "error") : f(h.status, h.statusText) : f(Ib[h.status] || h.status, h.statusText, "text" !== (h.responseType || "text") || "string" != typeof h.responseText ? { binary: h.response } : { text: h.responseText }, h.getAllResponseHeaders()));
          };
        }, h.onload = _c(), d = h.onerror = _c("error"), void 0 !== h.onabort ? h.onabort = d : h.onreadystatechange = function () {
          4 === h.readyState && a.setTimeout(function () {
            _c && d();
          });
        }, _c = _c("abort");try {
          h.send(b.hasContent && b.data || null);
        } catch (a) {
          if (_c) throw a;
        }
      }, abort: function abort() {
        _c && _c();
      } } : void 0;
  }), fa.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function textScript(a) {
        return fa.globalEval(a), a;
      } } }), fa.ajaxPrefilter("script", function (a) {
    void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
  }), fa.ajaxTransport("script", function (a) {
    if (a.crossDomain) {
      var b, _c2;return { send: function send(d, e) {
          b = fa("<script>").prop({ charset: a.scriptCharset, src: a.url }).on("load error", _c2 = function c(a) {
            b.remove(), _c2 = null, a && e("error" === a.type ? 404 : 200, a.type);
          }), X.head.appendChild(b[0]);
        }, abort: function abort() {
          _c2 && _c2();
        } };
    }
  });var Kb = [],
      Lb = /(=)\?(?=&|$)|\?\?/;fa.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
      var a = Kb.pop() || fa.expando + "_" + rb++;return this[a] = !0, a;
    } }), fa.ajaxPrefilter("json jsonp", function (b, c, d) {
    var e,
        f,
        g,
        h = b.jsonp !== !1 && (Lb.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && Lb.test(b.data) && "data");return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = fa.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(Lb, "$1" + e) : b.jsonp !== !1 && (b.url += (sb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
      return g || fa.error(e + " was not called"), g[0];
    }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
      g = arguments;
    }, d.always(function () {
      void 0 === f ? fa(a).removeProp(e) : a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, Kb.push(e)), g && fa.isFunction(f) && f(g[0]), g = f = void 0;
    }), "script") : void 0;
  }), fa.parseHTML = function (a, b, c) {
    if (!a || "string" != typeof a) return null;"boolean" == typeof b && (c = b, b = !1), b = b || X;var d = oa.exec(a),
        e = !c && [];return d ? [b.createElement(d[1])] : (d = m([a], b, e), e && e.length && fa(e).remove(), fa.merge([], d.childNodes));
  };var Mb = fa.fn.load;fa.fn.load = function (a, b, c) {
    if ("string" != typeof a && Mb) return Mb.apply(this, arguments);var d,
        e,
        f,
        g = this,
        h = a.indexOf(" ");return h > -1 && (d = fa.trim(a.slice(h)), a = a.slice(0, h)), fa.isFunction(b) ? (c = b, b = void 0) : b && "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && (e = "POST"), g.length > 0 && fa.ajax({ url: a, type: e || "GET", dataType: "html", data: b }).done(function (a) {
      f = arguments, g.html(d ? fa("<div>").append(fa.parseHTML(a)).find(d) : a);
    }).always(c && function (a, b) {
      g.each(function () {
        c.apply(this, f || [a.responseText, b, a]);
      });
    }), this;
  }, fa.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
    fa.fn[b] = function (a) {
      return this.on(b, a);
    };
  }), fa.expr.filters.animated = function (a) {
    return fa.grep(fa.timers, function (b) {
      return a === b.elem;
    }).length;
  }, fa.offset = { setOffset: function setOffset(a, b, c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = fa.css(a, "position"),
          l = fa(a),
          m = {};"static" === k && (a.style.position = "relative"), h = l.offset(), f = fa.css(a, "top"), i = fa.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), fa.isFunction(b) && (b = b.call(a, c, fa.extend({}, h))), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m);
    } }, fa.fn.extend({ offset: function offset(a) {
      if (arguments.length) return void 0 === a ? this : this.each(function (b) {
        fa.offset.setOffset(this, a, b);
      });var b,
          c,
          d = this[0],
          e = { top: 0, left: 0 },
          f = d && d.ownerDocument;return f ? (b = f.documentElement, fa.contains(b, d) ? (e = d.getBoundingClientRect(), c = V(f), { top: e.top + c.pageYOffset - b.clientTop, left: e.left + c.pageXOffset - b.clientLeft }) : e) : void 0;
    }, position: function position() {
      if (this[0]) {
        var a,
            b,
            c = this[0],
            d = { top: 0, left: 0 };return "fixed" === fa.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), fa.nodeName(a[0], "html") || (d = a.offset()), d.top += fa.css(a[0], "borderTopWidth", !0), d.left += fa.css(a[0], "borderLeftWidth", !0)), { top: b.top - d.top - fa.css(c, "marginTop", !0), left: b.left - d.left - fa.css(c, "marginLeft", !0) };
      }
    }, offsetParent: function offsetParent() {
      return this.map(function () {
        for (var a = this.offsetParent; a && "static" === fa.css(a, "position");) {
          a = a.offsetParent;
        }return a || $a;
      });
    } }), fa.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (a, b) {
    var c = "pageYOffset" === b;fa.fn[a] = function (d) {
      return xa(this, function (a, d, e) {
        var f = V(a);return void 0 === e ? f ? f[b] : a[d] : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : a[d] = e);
      }, a, d, arguments.length);
    };
  }), fa.each(["top", "left"], function (a, b) {
    fa.cssHooks[b] = B(da.pixelPosition, function (a, c) {
      return c ? (c = A(a, b), Xa.test(c) ? fa(a).position()[b] + "px" : c) : void 0;
    });
  }), fa.each({ Height: "height", Width: "width" }, function (a, b) {
    fa.each({ padding: "inner" + a, content: b, "": "outer" + a }, function (c, d) {
      fa.fn[d] = function (d, e) {
        var f = arguments.length && (c || "boolean" != typeof d),
            g = c || (d === !0 || e === !0 ? "margin" : "border");return xa(this, function (b, c, d) {
          var e;return fa.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? fa.css(b, c, g) : fa.style(b, c, d, g);
        }, b, f ? d : void 0, f, null);
      };
    });
  }), fa.fn.extend({ bind: function bind(a, b, c) {
      return this.on(a, null, b, c);
    }, unbind: function unbind(a, b) {
      return this.off(a, null, b);
    }, delegate: function delegate(a, b, c, d) {
      return this.on(b, a, c, d);
    }, undelegate: function undelegate(a, b, c) {
      return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c);
    }, size: function size() {
      return this.length;
    } }), fa.fn.andSelf = fa.fn.addBack, "function" == typeof define && __webpack_require__(67) && define("jquery", [], function () {
    return fa;
  });var Nb = a.jQuery,
      Ob = a.$;return fa.noConflict = function (b) {
    return a.$ === fa && (a.$ = Ob), b && a.jQuery === fa && (a.jQuery = Nb), fa;
  }, b || (a.jQuery = a.$ = fa), fa;
}), "undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");+function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1 || b[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
}(jQuery), +function (a) {
  "use strict";
  function b() {
    var a = document.createElement("bootstrap"),
        b = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };for (var c in b) {
      if (void 0 !== a.style[c]) return { end: b[c] };
    }return !1;
  }a.fn.emulateTransitionEnd = function (b) {
    var c = !1,
        d = this;a(this).one("bsTransitionEnd", function () {
      c = !0;
    });var e = function e() {
      c || a(d).trigger(a.support.transition.end);
    };return setTimeout(e, b), this;
  }, a(function () {
    a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = { bindType: a.support.transition.end, delegateType: a.support.transition.end, handle: function handle(b) {
        if (a(b.target).is(this)) return b.handleObj.handler.apply(this, arguments);
      } });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.alert");e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c);
    });
  }var c = '[data-dismiss="alert"]',
      d = function d(b) {
    a(b).on("click", c, this.close);
  };d.VERSION = "3.3.7", d.TRANSITION_DURATION = 150, d.prototype.close = function (b) {
    function c() {
      g.detach().trigger("closed.bs.alert").remove();
    }var e = a(this),
        f = e.attr("data-target");f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));var g = a("#" === f ? [] : f);b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c());
  };var e = a.fn.alert;a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function () {
    return a.fn.alert = e, this;
  }, a(document).on("click.bs.alert.data-api", c, d.prototype.close);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.button"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b);
    });
  }var c = function c(b, d) {
    this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1;
  };c.VERSION = "3.3.7", c.DEFAULTS = { loadingText: "loading..." }, c.prototype.setState = function (b) {
    var c = "disabled",
        d = this.$element,
        e = d.is("input") ? "val" : "html",
        f = d.data();b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function () {
      d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c).prop(c, !0)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c).prop(c, !1));
    }, this), 0);
  }, c.prototype.toggle = function () {
    var a = !0,
        b = this.$element.closest('[data-toggle="buttons"]');if (b.length) {
      var c = this.$element.find("input");"radio" == c.prop("type") ? (c.prop("checked") && (a = !1), b.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == c.prop("type") && (c.prop("checked") !== this.$element.hasClass("active") && (a = !1), this.$element.toggleClass("active")), c.prop("checked", this.$element.hasClass("active")), a && c.trigger("change");
    } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active");
  };var d = a.fn.button;a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function () {
    return a.fn.button = d, this;
  }, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function (c) {
    var d = a(c.target).closest(".btn");b.call(d, "toggle"), a(c.target).is('input[type="radio"], input[type="checkbox"]') || (c.preventDefault(), d.is("input,button") ? d.trigger("focus") : d.find("input:visible,button:visible").first().trigger("focus"));
  }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function (b) {
    a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type));
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b),
          g = "string" == typeof b ? b : f.slide;e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle();
    });
  }var c = function c(b, _c3) {
    this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = _c3, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 600, c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }, c.prototype.keydown = function (a) {
    if (!/input|textarea/i.test(a.target.tagName)) {
      switch (a.which) {case 37:
          this.prev();break;case 39:
          this.next();break;default:
          return;}a.preventDefault();
    }
  }, c.prototype.cycle = function (b) {
    return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this;
  }, c.prototype.getItemIndex = function (a) {
    return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active);
  }, c.prototype.getItemForDirection = function (a, b) {
    var c = this.getItemIndex(b),
        d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;if (d && !this.options.wrap) return b;var e = "prev" == a ? -1 : 1,
        f = (c + e) % this.$items.length;return this.$items.eq(f);
  }, c.prototype.to = function (a) {
    var b = this,
        c = this.getItemIndex(this.$active = this.$element.find(".item.active"));if (!(a > this.$items.length - 1 || a < 0)) return this.sliding ? this.$element.one("slid.bs.carousel", function () {
      b.to(a);
    }) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
  }, c.prototype.pause = function (b) {
    return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this;
  }, c.prototype.next = function () {
    if (!this.sliding) return this.slide("next");
  }, c.prototype.prev = function () {
    if (!this.sliding) return this.slide("prev");
  }, c.prototype.slide = function (b, d) {
    var e = this.$element.find(".item.active"),
        f = d || this.getItemForDirection(b, e),
        g = this.interval,
        h = "next" == b ? "left" : "right",
        i = this;if (f.hasClass("active")) return this.sliding = !1;var j = f[0],
        k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });if (this.$element.trigger(k), !k.isDefaultPrevented()) {
      if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
        this.$indicators.find(".active").removeClass("active");var l = a(this.$indicators.children()[this.getItemIndex(f)]);l && l.addClass("active");
      }var m = a.Event("slid.bs.carousel", { relatedTarget: j, direction: h });return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function () {
        f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function () {
          i.$element.trigger(m);
        }, 0);
      }).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this;
    }
  };var d = a.fn.carousel;a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function () {
    return a.fn.carousel = d, this;
  };var e = function e(c) {
    var d,
        e = a(this),
        f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));if (f.hasClass("carousel")) {
      var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault();
    }
  };a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function () {
    a('[data-ride="carousel"]').each(function () {
      var c = a(this);b.call(c, c.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c,
        d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");return a(d);
  }function c(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b);!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]();
    });
  }var d = function d(b, c) {
    this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle();
  };d.VERSION = "3.3.7", d.TRANSITION_DURATION = 350, d.DEFAULTS = { toggle: !0 }, d.prototype.dimension = function () {
    var a = this.$element.hasClass("width");return a ? "width" : "height";
  }, d.prototype.show = function () {
    if (!this.transitioning && !this.$element.hasClass("in")) {
      var b,
          e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
        var f = a.Event("show.bs.collapse");if (this.$element.trigger(f), !f.isDefaultPrevented()) {
          e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));var g = this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;var h = function h() {
            this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse");
          };if (!a.support.transition) return h.call(this);var i = a.camelCase(["scroll", g].join("-"));this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i]);
        }
      }
    }
  }, d.prototype.hide = function () {
    if (!this.transitioning && this.$element.hasClass("in")) {
      var b = a.Event("hide.bs.collapse");
      if (this.$element.trigger(b), !b.isDefaultPrevented()) {
        var c = this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;var e = function e() {
          this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
        };return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this);
      }
    }
  }, d.prototype.toggle = function () {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  }, d.prototype.getParent = function () {
    return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function (c, d) {
      var e = a(d);this.addAriaAndCollapsedClass(b(e), e);
    }, this)).end();
  }, d.prototype.addAriaAndCollapsedClass = function (a, b) {
    var c = a.hasClass("in");a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c);
  };var e = a.fn.collapse;a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function () {
    return a.fn.collapse = e, this;
  }, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (d) {
    var e = a(this);e.attr("data-target") || d.preventDefault();var f = b(e),
        g = f.data("bs.collapse"),
        h = g ? "toggle" : e.data();c.call(f, h);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c = b.attr("data-target");c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));var d = c && a(c);return d && d.length ? d : b.parent();
  }function c(c) {
    c && 3 === c.which || (a(e).remove(), a(f).each(function () {
      var d = a(this),
          e = b(d),
          f = { relatedTarget: this };e.hasClass("open") && (c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target) || (e.trigger(c = a.Event("hide.bs.dropdown", f)), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))));
    }));
  }function d(b) {
    return this.each(function () {
      var c = a(this),
          d = c.data("bs.dropdown");d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c);
    });
  }var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function g(b) {
    a(b).on("click.bs.dropdown", this.toggle);
  };g.VERSION = "3.3.7", g.prototype.toggle = function (d) {
    var e = a(this);if (!e.is(".disabled, :disabled")) {
      var f = b(e),
          g = f.hasClass("open");if (c(), !g) {
        "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);var h = { relatedTarget: this };if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
      }return !1;
    }
  }, g.prototype.keydown = function (c) {
    if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
      var d = a(this);if (c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled")) {
        var e = b(d),
            g = e.hasClass("open");if (!g && 27 != c.which || g && 27 == c.which) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");var h = " li:not(.disabled):visible a",
            i = e.find(".dropdown-menu" + h);if (i.length) {
          var j = i.index(c.target);38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus");
        }
      }
    }
  };var h = a.fn.dropdown;a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function () {
    return a.fn.dropdown = h, this;
  }, a(document).on("click.bs.dropdown.data-api", c).on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
    a.stopPropagation();
  }).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown);
}(jQuery), +function (a) {
  "use strict";
  function b(b, d) {
    return this.each(function () {
      var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b);f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d);
    });
  }var c = function c(b, _c4) {
    this.options = _c4, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function () {
      this.$element.trigger("loaded.bs.modal");
    }, this));
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }, c.prototype.toggle = function (a) {
    return this.isShown ? this.hide() : this.show(a);
  }, c.prototype.show = function (b) {
    var d = this,
        e = a.Event("show.bs.modal", { relatedTarget: b });this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function () {
      d.$element.one("mouseup.dismiss.bs.modal", function (b) {
        a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
      });
    }), this.backdrop(function () {
      var e = a.support.transition && d.$element.hasClass("fade");d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();var f = a.Event("shown.bs.modal", { relatedTarget: b });e ? d.$dialog.one("bsTransitionEnd", function () {
        d.$element.trigger("focus").trigger(f);
      }).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f);
    }));
  }, c.prototype.hide = function (b) {
    b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal());
  }, c.prototype.enforceFocus = function () {
    a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function (a) {
      document === a.target || this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus");
    }, this));
  }, c.prototype.escape = function () {
    this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function (a) {
      27 == a.which && this.hide();
    }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
  }, c.prototype.resize = function () {
    this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
  }, c.prototype.hideModal = function () {
    var a = this;this.$element.hide(), this.backdrop(function () {
      a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal");
    });
  }, c.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove(), this.$backdrop = null;
  }, c.prototype.backdrop = function (b) {
    var d = this,
        e = this.$element.hasClass("fade") ? "fade" : "";if (this.isShown && this.options.backdrop) {
      var f = a.support.transition && e;if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + e).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function (a) {
        return this.ignoreBackdropClick ? void (this.ignoreBackdropClick = !1) : void (a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()));
      }, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b();
    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass("in");var g = function g() {
        d.removeBackdrop(), b && b();
      };a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g();
    } else b && b();
  }, c.prototype.handleUpdate = function () {
    this.adjustDialog();
  }, c.prototype.adjustDialog = function () {
    var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;this.$element.css({ paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "" });
  }, c.prototype.resetAdjustments = function () {
    this.$element.css({ paddingLeft: "", paddingRight: "" });
  }, c.prototype.checkScrollbar = function () {
    var a = window.innerWidth;if (!a) {
      var b = document.documentElement.getBoundingClientRect();a = b.right - Math.abs(b.left);
    }this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar();
  }, c.prototype.setScrollbar = function () {
    var a = parseInt(this.$body.css("padding-right") || 0, 10);this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
  }, c.prototype.resetScrollbar = function () {
    this.$body.css("padding-right", this.originalBodyPad);
  }, c.prototype.measureScrollbar = function () {
    var a = document.createElement("div");a.className = "modal-scrollbar-measure", this.$body.append(a);var b = a.offsetWidth - a.clientWidth;return this.$body[0].removeChild(a), b;
  };var d = a.fn.modal;a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function () {
    return a.fn.modal = d, this;
  }, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
    var d = a(this),
        e = d.attr("href"),
        f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
        g = f.data("bs.modal") ? "toggle" : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());d.is("a") && c.preventDefault(), f.one("show.bs.modal", function (a) {
      a.isDefaultPrevented() || f.one("hidden.bs.modal", function () {
        d.is(":visible") && d.trigger("focus");
      });
    }), b.call(f, g, this);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b;!e && /destroy|hide/.test(b) || (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", a, b);
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 150, c.DEFAULTS = { animation: !0, placement: "top", selector: !1, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: "hover focus", title: "", delay: 0, html: !1, container: !1, viewport: { selector: "body", padding: 0 } }, c.prototype.init = function (b, c, d) {
    if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = { click: !1, hover: !1, focus: !1 }, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
      var g = e[f];if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));else if ("manual" != g) {
        var h = "hover" == g ? "mouseenter" : "focusin",
            i = "hover" == g ? "mouseleave" : "focusout";this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this));
      }
    }this.options.selector ? this._options = a.extend({}, this.options, { trigger: "manual", selector: "" }) : this.fixTitle();
  }, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.getOptions = function (b) {
    return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }), b;
  }, c.prototype.getDelegateOptions = function () {
    var b = {},
        c = this.getDefaults();return this._options && a.each(this._options, function (a, d) {
      c[a] != d && (b[a] = d);
    }), b;
  }, c.prototype.enter = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0), c.tip().hasClass("in") || "in" == c.hoverState ? void (c.hoverState = "in") : (clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void (c.timeout = setTimeout(function () {
      "in" == c.hoverState && c.show();
    }, c.options.delay.show)) : c.show());
  }, c.prototype.isInStateTrue = function () {
    for (var a in this.inState) {
      if (this.inState[a]) return !0;
    }return !1;
  }, c.prototype.leave = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);if (c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1), !c.isInStateTrue()) return clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void (c.timeout = setTimeout(function () {
      "out" == c.hoverState && c.hide();
    }, c.options.delay.hide)) : c.hide();
  }, c.prototype.show = function () {
    var b = a.Event("show.bs." + this.type);if (this.hasContent() && this.enabled) {
      this.$element.trigger(b);var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);if (b.isDefaultPrevented() || !d) return;var e = this,
          f = this.tip(),
          g = this.getUID(this.type);this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
          i = /\s?auto?\s?/i,
          j = i.test(h);j && (h = h.replace(i, "") || "top"), f.detach().css({ top: 0, left: 0, display: "block" }).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);var k = this.getPosition(),
          l = f[0].offsetWidth,
          m = f[0].offsetHeight;if (j) {
        var n = h,
            o = this.getPosition(this.$viewport);h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h, f.removeClass(n).addClass(h);
      }var p = this.getCalculatedOffset(h, k, l, m);this.applyPlacement(p, h);var q = function q() {
        var a = e.hoverState;e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e);
      };a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q();
    }
  }, c.prototype.applyPlacement = function (b, c) {
    var d = this.tip(),
        e = d[0].offsetWidth,
        f = d[0].offsetHeight,
        g = parseInt(d.css("margin-top"), 10),
        h = parseInt(d.css("margin-left"), 10);isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top += g, b.left += h, a.offset.setOffset(d[0], a.extend({ using: function using(a) {
        d.css({ top: Math.round(a.top), left: Math.round(a.left) });
      } }, b), 0), d.addClass("in");var i = d[0].offsetWidth,
        j = d[0].offsetHeight;"top" == c && j != f && (b.top = b.top + f - j);var k = this.getViewportAdjustedDelta(c, b, i, j);k.left ? b.left += k.left : b.top += k.top;var l = /top|bottom/.test(c),
        m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
        n = l ? "offsetWidth" : "offsetHeight";d.offset(b), this.replaceArrow(m, d[0][n], l);
  }, c.prototype.replaceArrow = function (a, b, c) {
    this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "");
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle();a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right");
  }, c.prototype.hide = function (b) {
    function d() {
      "in" != e.hoverState && f.detach(), e.$element && e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b();
    }var e = this,
        f = a(this.$tip),
        g = a.Event("hide.bs." + this.type);if (this.$element.trigger(g), !g.isDefaultPrevented()) return f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this;
  }, c.prototype.fixTitle = function () {
    var a = this.$element;(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "");
  }, c.prototype.hasContent = function () {
    return this.getTitle();
  }, c.prototype.getPosition = function (b) {
    b = b || this.$element;var c = b[0],
        d = "BODY" == c.tagName,
        e = c.getBoundingClientRect();null == e.width && (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));var f = window.SVGElement && c instanceof window.SVGElement,
        g = d ? { top: 0, left: 0 } : f ? null : b.offset(),
        h = { scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop() },
        i = d ? { width: a(window).width(), height: a(window).height() } : null;return a.extend({}, e, h, i, g);
  }, c.prototype.getCalculatedOffset = function (a, b, c, d) {
    return "bottom" == a ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 } : "top" == a ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 } : "left" == a ? { top: b.top + b.height / 2 - d / 2, left: b.left - c } : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
  }, c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
    var e = { top: 0, left: 0 };if (!this.$viewport) return e;var f = this.options.viewport && this.options.viewport.padding || 0,
        g = this.getPosition(this.$viewport);if (/right|left/.test(a)) {
      var h = b.top - f - g.scroll,
          i = b.top + f - g.scroll + d;h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i);
    } else {
      var j = b.left - f,
          k = b.left + f + c;j < g.left ? e.left = g.left - j : k > g.right && (e.left = g.left + g.width - k);
    }return e;
  }, c.prototype.getTitle = function () {
    var a,
        b = this.$element,
        c = this.options;return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title);
  }, c.prototype.getUID = function (a) {
    do {
      a += ~~(1e6 * Math.random());
    } while (document.getElementById(a));return a;
  }, c.prototype.tip = function () {
    if (!this.$tip && (this.$tip = a(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");return this.$tip;
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
  }, c.prototype.enable = function () {
    this.enabled = !0;
  }, c.prototype.disable = function () {
    this.enabled = !1;
  }, c.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  }, c.prototype.toggle = function (b) {
    var c = this;b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), b ? (c.inState.click = !c.inState.click, c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c);
  }, c.prototype.destroy = function () {
    var a = this;clearTimeout(this.timeout), this.hide(function () {
      a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), a.$tip = null, a.$arrow = null, a.$viewport = null, a.$element = null;
    });
  };var d = a.fn.tooltip;a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function () {
    return a.fn.tooltip = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b;!e && /destroy|hide/.test(b) || (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.init("popover", a, b);
  };if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");c.VERSION = "3.3.7", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, { placement: "right", trigger: "click", content: "", template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>' }), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle(),
        c = this.getContent();a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide();
  }, c.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  }, c.prototype.getContent = function () {
    var a = this.$element,
        b = this.options;return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content);
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".arrow");
  };var d = a.fn.popover;a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function () {
    return a.fn.popover = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(c, d) {
    this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process();
  }function c(c) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(c)) && c;e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]();
    });
  }b.VERSION = "3.3.7", b.DEFAULTS = { offset: 10 }, b.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
  }, b.prototype.refresh = function () {
    var b = this,
        c = "offset",
        d = 0;this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function () {
      var b = a(this),
          e = b.data("target") || b.attr("href"),
          f = /^#./.test(e) && a(e);return f && f.length && f.is(":visible") && [[f[c]().top + d, e]] || null;
    }).sort(function (a, b) {
      return a[0] - b[0];
    }).each(function () {
      b.offsets.push(this[0]), b.targets.push(this[1]);
    });
  }, b.prototype.process = function () {
    var a,
        b = this.$scrollElement.scrollTop() + this.options.offset,
        c = this.getScrollHeight(),
        d = this.options.offset + c - this.$scrollElement.height(),
        e = this.offsets,
        f = this.targets,
        g = this.activeTarget;if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);if (g && b < e[0]) return this.activeTarget = null, this.clear();for (a = e.length; a--;) {
      g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a]);
    }
  }, b.prototype.activate = function (b) {
    this.activeTarget = b, this.clear();var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
        d = a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy");
  }, b.prototype.clear = function () {
    a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
  };var d = a.fn.scrollspy;a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function () {
    return a.fn.scrollspy = d, this;
  }, a(window).on("load.bs.scrollspy.data-api", function () {
    a('[data-spy="scroll"]').each(function () {
      var b = a(this);c.call(b, b.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tab");e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]();
    });
  }var c = function c(b) {
    this.element = a(b);
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 150, c.prototype.show = function () {
    var b = this.element,
        c = b.closest("ul:not(.dropdown-menu)"),
        d = b.data("target");if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
      var e = c.find(".active:last a"),
          f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
          g = a.Event("show.bs.tab", { relatedTarget: e[0] });if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
        var h = a(d);this.activate(b.closest("li"), c), this.activate(h, h.parent(), function () {
          e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }), b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
        });
      }
    }
  }, c.prototype.activate = function (b, d, e) {
    function f() {
      g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e();
    }var g = d.find("> .active"),
        h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in");
  };var d = a.fn.tab;a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function () {
    return a.fn.tab = d, this;
  };var e = function e(c) {
    c.preventDefault(), b.call(a(this), "show");
  };a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]();
    });
  }var c = function c(b, d) {
    this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition();
  };c.VERSION = "3.3.7", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = { offset: 0, target: window }, c.prototype.getState = function (a, b, c, d) {
    var e = this.$target.scrollTop(),
        f = this.$element.offset(),
        g = this.$target.height();if (null != c && "top" == this.affixed) return e < c && "top";if ("bottom" == this.affixed) return null != c ? !(e + this.unpin <= f.top) && "bottom" : !(e + g <= a - d) && "bottom";var h = null == this.affixed,
        i = h ? e : f.top,
        j = h ? g : b;return null != c && e <= c ? "top" : null != d && i + j >= a - d && "bottom";
  }, c.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a = this.$target.scrollTop(),
        b = this.$element.offset();return this.pinnedOffset = b.top - a;
  }, c.prototype.checkPositionWithEventLoop = function () {
    setTimeout(a.proxy(this.checkPosition, this), 1);
  }, c.prototype.checkPosition = function () {
    if (this.$element.is(":visible")) {
      var b = this.$element.height(),
          d = this.options.offset,
          e = d.top,
          f = d.bottom,
          g = Math.max(a(document).height(), a(document.body).height());"object" != (typeof d === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(d)) && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));var h = this.getState(g, b, e, f);if (this.affixed != h) {
        null != this.unpin && this.$element.css("top", "");var i = "affix" + (h ? "-" + h : ""),
            j = a.Event(i + ".bs.affix");if (this.$element.trigger(j), j.isDefaultPrevented()) return;this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix");
      }"bottom" == h && this.$element.offset({ top: g - b - f });
    }
  };var d = a.fn.affix;a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function () {
    return a.fn.affix = d, this;
  }, a(window).on("load", function () {
    a('[data-spy="affix"]').each(function () {
      var c = a(this),
          d = c.data();d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d);
    });
  });
}(jQuery), function (a) {
  a.fn.extend({ slimScroll: function slimScroll(b) {
      var c = a.extend({ width: "auto", height: "250px", size: "7px", color: "#000", position: "right", distance: "1px", start: "top", opacity: .4, alwaysVisible: !1, disableFadeOut: !1, railVisible: !1, railColor: "#333", railOpacity: .2, railDraggable: !0, railClass: "slimScrollRail", barClass: "slimScrollBar", wrapperClass: "slimScrollDiv", allowPageScroll: !1, wheelStep: 20, touchScrollStep: 200, borderRadius: "7px", railBorderRadius: "7px" }, b);return this.each(function () {
        function d(b) {
          if (i) {
            b = b || window.event;var d = 0;b.wheelDelta && (d = -b.wheelDelta / 120), b.detail && (d = b.detail / 3), a(b.target || b.srcTarget || b.srcElement).closest("." + c.wrapperClass).is(r.parent()) && e(d, !0), b.preventDefault && !q && b.preventDefault(), q || (b.returnValue = !1);
          }
        }function e(a, b, d) {
          q = !1;var e = a,
              f = r.outerHeight() - u.outerHeight();b && (e = parseInt(u.css("top")) + a * parseInt(c.wheelStep) / 100 * u.outerHeight(), e = Math.min(Math.max(e, 0), f), e = 0 < a ? Math.ceil(e) : Math.floor(e), u.css({ top: e + "px" })), o = parseInt(u.css("top")) / (r.outerHeight() - u.outerHeight()), e = o * (r[0].scrollHeight - r.outerHeight()), d && (e = a, a = e / r[0].scrollHeight * r.outerHeight(), a = Math.min(Math.max(a, 0), f), u.css({ top: a + "px" })), r.scrollTop(e), r.trigger("slimscrolling", ~~e), g(), h();
        }function f() {
          n = Math.max(r.outerHeight() / r[0].scrollHeight * r.outerHeight(), 30), u.css({ height: n + "px" });var a = n == r.outerHeight() ? "none" : "block";u.css({ display: a });
        }function g() {
          f(), clearTimeout(l), o == ~~o ? (q = c.allowPageScroll, p != o && r.trigger("slimscroll", 0 == ~~o ? "top" : "bottom")) : q = !1, p = o, n >= r.outerHeight() ? q = !0 : (u.stop(!0, !0).fadeIn("fast"), c.railVisible && v.stop(!0, !0).fadeIn("fast"));
        }function h() {
          c.alwaysVisible || (l = setTimeout(function () {
            c.disableFadeOut && i || j || k || (u.fadeOut("slow"), v.fadeOut("slow"));
          }, 1e3));
        }var i,
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q = !1,
            r = a(this);if (r.parent().hasClass(c.wrapperClass)) {
          var s = r.scrollTop(),
              u = r.siblings("." + c.barClass),
              v = r.siblings("." + c.railClass);if (f(), a.isPlainObject(b)) {
            if ("height" in b && "auto" == b.height) {
              r.parent().css("height", "auto"), r.css("height", "auto");var w = r.parent().parent().height();r.parent().css("height", w), r.css("height", w);
            } else "height" in b && (w = b.height, r.parent().css("height", w), r.css("height", w));if ("scrollTo" in b) s = parseInt(c.scrollTo);else if ("scrollBy" in b) s += parseInt(c.scrollBy);else if ("destroy" in b) return u.remove(), v.remove(), void r.unwrap();e(s, !1, !0);
          }
        } else if (!(a.isPlainObject(b) && "destroy" in b)) {
          c.height = "auto" == c.height ? r.parent().height() : c.height, s = a("<div></div>").addClass(c.wrapperClass).css({ position: "relative", overflow: "hidden", width: c.width, height: c.height }), r.css({ overflow: "hidden", width: c.width, height: c.height });var v = a("<div></div>").addClass(c.railClass).css({ width: c.size, height: "100%", position: "absolute", top: 0, display: c.alwaysVisible && c.railVisible ? "block" : "none", "border-radius": c.railBorderRadius, background: c.railColor, opacity: c.railOpacity, zIndex: 90 }),
              u = a("<div></div>").addClass(c.barClass).css({ background: c.color, width: c.size, position: "absolute", top: 0, opacity: c.opacity, display: c.alwaysVisible ? "block" : "none", "border-radius": c.borderRadius, BorderRadius: c.borderRadius, MozBorderRadius: c.borderRadius, WebkitBorderRadius: c.borderRadius, zIndex: 99 }),
              w = "right" == c.position ? { right: c.distance } : { left: c.distance };v.css(w), u.css(w), r.wrap(s), r.parent().append(u), r.parent().append(v), c.railDraggable && u.bind("mousedown", function (b) {
            var c = a(document);return k = !0, t = parseFloat(u.css("top")), pageY = b.pageY, c.bind("mousemove.slimscroll", function (a) {
              currTop = t + a.pageY - pageY, u.css("top", currTop), e(0, u.position().top, !1);
            }), c.bind("mouseup.slimscroll", function (a) {
              k = !1, h(), c.unbind(".slimscroll");
            }), !1;
          }).bind("selectstart.slimscroll", function (a) {
            return a.stopPropagation(), a.preventDefault(), !1;
          }), v.hover(function () {
            g();
          }, function () {
            h();
          }), u.hover(function () {
            j = !0;
          }, function () {
            j = !1;
          }), r.hover(function () {
            i = !0, g(), h();
          }, function () {
            i = !1, h();
          }), r.bind("touchstart", function (a, b) {
            a.originalEvent.touches.length && (m = a.originalEvent.touches[0].pageY);
          }), r.bind("touchmove", function (a) {
            q || a.originalEvent.preventDefault(), a.originalEvent.touches.length && (e((m - a.originalEvent.touches[0].pageY) / c.touchScrollStep, !0), m = a.originalEvent.touches[0].pageY);
          }), f(), "bottom" === c.start ? (u.css({ top: r.outerHeight() - u.outerHeight() }), e(0, !0)) : "top" !== c.start && (e(a(c.start).position().top, null, !0), c.alwaysVisible || u.hide()), window.addEventListener ? (this.addEventListener("DOMMouseScroll", d, !1), this.addEventListener("mousewheel", d, !1)) : document.attachEvent("onmousewheel", d);
        }
      }), this;
    } }), a.fn.extend({ slimscroll: a.fn.slimScroll });
}(jQuery), function (a) {
  "function" == typeof define && __webpack_require__(67) ? define(["jquery"], a) : a(jQuery);
}(function (a) {
  "use strict";
  var b,
      c = function c(b, d) {
    this.$element = b, this.options = a.extend({}, c.DEFAULTS, this.$element.data(), d), this.enabled = !0, this.startClientY = 0, this.$element.on(c.CORE.wheelEventName + c.NAMESPACE, this.options.selector, a.proxy(c.CORE.handler, this)), this.options.touch && (this.$element.on("touchstart" + c.NAMESPACE, this.options.selector, a.proxy(c.CORE.touchHandler, this)), this.$element.on("touchmove" + c.NAMESPACE, this.options.selector, a.proxy(c.CORE.handler, this)));
  };c.NAME = "ScrollLock", c.VERSION = "2.1.0", c.NAMESPACE = ".scrollLock", c.ANIMATION_NAMESPACE = c.NAMESPACE + ".effect", c.DEFAULTS = { strict: !1, strictFn: function strictFn(a) {
      return a.prop("scrollHeight") > a.prop("clientHeight");
    }, selector: !1, animation: !1, touch: "ontouchstart" in window }, c.CORE = { wheelEventName: "onmousewheel" in window ? "ActiveXObject" in window ? "wheel" : "mousewheel" : "DOMMouseScroll", animationEventName: ["webkitAnimationEnd", "mozAnimationEnd", "MSAnimationEnd", "oanimationend", "animationend"].join(c.ANIMATION_NAMESPACE + " ") + c.ANIMATION_NAMESPACE, handler: function handler(b) {
      var d, e, f, g;if (this.enabled && !b.ctrlKey && (d = a(b.currentTarget), this.options.strict !== !0 || this.options.strictFn(d))) {
        b.stopPropagation();var h = d.scrollTop(),
            i = d.prop("scrollHeight"),
            j = d.prop("clientHeight"),
            k = b.originalEvent.wheelDelta || -1 * b.originalEvent.detail || -1 * b.originalEvent.deltaY,
            l = 0;"wheel" === b.type ? (e = d.height() / a(window).height(), l = b.originalEvent.deltaY * e) : this.options.touch && "touchmove" === b.type && (k = b.originalEvent.changedTouches[0].clientY - this.startClientY), ((f = k > 0 && h + l <= 0) || k < 0 && h + l >= i - j) && (b.preventDefault(), l && d.scrollTop(h + l), g = f ? "top" : "bottom", this.options.animation && setTimeout(c.CORE.animationHandler.bind(this, d, g), 0), d.trigger(a.Event(g + c.NAMESPACE)));
      }
    }, touchHandler: function touchHandler(a) {
      this.startClientY = a.originalEvent.touches[0].clientY;
    }, animationHandler: function animationHandler(a, b) {
      var d = this.options.animation[b],
          e = this.options.animation.top + " " + this.options.animation.bottom;a.off(c.ANIMATION_NAMESPACE).removeClass(e).addClass(d).one(c.CORE.animationEventName, function () {
        a.removeClass(d);
      });
    } }, c.prototype.toggleStrict = function () {
    this.options.strict = !this.options.strict;
  }, c.prototype.enable = function () {
    this.enabled = !0;
  }, c.prototype.disable = function () {
    this.enabled = !1;
  }, c.prototype.destroy = function () {
    this.disable(), this.$element.off(c.NAMESPACE), this.$element = null, this.options = null;
  }, b = a.fn.scrollLock, a.fn.scrollLock = function (b) {
    return this.each(function () {
      var d = a(this),
          e = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) && b,
          f = d.data(c.NAME);(f || "destroy" !== b) && (f || d.data(c.NAME, f = new c(d, e)), "string" == typeof b && f[b]());
    });
  }, a.fn.scrollLock.defaults = c.DEFAULTS, a.fn.scrollLock.noConflict = function () {
    return a.fn.scrollLock = b, this;
  };
}), !function (a) {
  a.fn.appear = function (b, c) {
    var d = a.extend({ data: void 0, one: !0, accX: 0, accY: 0 }, c);return this.each(function () {
      var c = a(this);if (c.appeared = !1, !b) return void c.trigger("appear", d.data);var e = a(window),
          f = function f() {
        if (!c.is(":visible")) return void (c.appeared = !1);var a = e.scrollLeft(),
            b = e.scrollTop(),
            f = c.offset(),
            g = f.left,
            h = f.top,
            i = d.accX,
            j = d.accY,
            k = c.height(),
            l = e.height(),
            m = c.width(),
            n = e.width();h + k + j >= b && b + l + j >= h && g + m + i >= a && a + n + i >= g ? c.appeared || c.trigger("appear", d.data) : c.appeared = !1;
      },
          g = function g() {
        if (c.appeared = !0, d.one) {
          e.unbind("scroll", f);var g = a.inArray(f, a.fn.appear.checks);g >= 0 && a.fn.appear.checks.splice(g, 1);
        }b.apply(this, arguments);
      };d.one ? c.one("appear", d.data, g) : c.bind("appear", d.data, g), e.scroll(f), a.fn.appear.checks.push(f), f();
    });
  }, a.extend(a.fn.appear, { checks: [], timeout: null, checkAll: function checkAll() {
      var b = a.fn.appear.checks.length;if (b > 0) for (; b--;) {
        a.fn.appear.checks[b]();
      }
    }, run: function run() {
      a.fn.appear.timeout && clearTimeout(a.fn.appear.timeout), a.fn.appear.timeout = setTimeout(a.fn.appear.checkAll, 20);
    } }), a.each(["append", "prepend", "after", "before", "attr", "removeAttr", "addClass", "removeClass", "toggleClass", "remove", "css", "show", "hide"], function (b, c) {
    var d = a.fn[c];d && (a.fn[c] = function () {
      var b = d.apply(this, arguments);return a.fn.appear.run(), b;
    });
  });
}(jQuery), !function (a) {
  "function" == typeof define && __webpack_require__(67) ? define(["jquery"], a) : a("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(exports)) ? __webpack_require__(147) : jQuery);
}(function (a) {
  function b(a, b) {
    return a.toFixed(b.decimals);
  }var c = function c(b, d) {
    this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, this.dataOptions(), d), this.init();
  };c.DEFAULTS = { from: 0, to: 0, speed: 1e3, refreshInterval: 100, decimals: 0, formatter: b, onUpdate: null, onComplete: null }, c.prototype.init = function () {
    this.value = this.options.from, this.loops = Math.ceil(this.options.speed / this.options.refreshInterval), this.loopCount = 0, this.increment = (this.options.to - this.options.from) / this.loops;
  }, c.prototype.dataOptions = function () {
    var a = { from: this.$element.data("from"), to: this.$element.data("to"), speed: this.$element.data("speed"), refreshInterval: this.$element.data("refresh-interval"), decimals: this.$element.data("decimals") },
        b = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(a);for (var c in b) {
      var d = b[c];"undefined" == typeof a[d] && delete a[d];
    }return a;
  }, c.prototype.update = function () {
    this.value += this.increment, this.loopCount++, this.render(), "function" == typeof this.options.onUpdate && this.options.onUpdate.call(this.$element, this.value), this.loopCount >= this.loops && (clearInterval(this.interval), this.value = this.options.to, "function" == typeof this.options.onComplete && this.options.onComplete.call(this.$element, this.value));
  }, c.prototype.render = function () {
    var a = this.options.formatter.call(this.$element, this.value, this.options);this.$element.text(a);
  }, c.prototype.restart = function () {
    this.stop(), this.init(), this.start();
  }, c.prototype.start = function () {
    this.stop(), this.render(), this.interval = setInterval(this.update.bind(this), this.options.refreshInterval);
  }, c.prototype.stop = function () {
    this.interval && clearInterval(this.interval);
  }, c.prototype.toggle = function () {
    this.interval ? this.stop() : this.start();
  }, a.fn.countTo = function (b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("countTo"),
          f = !e || "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)),
          g = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(b)) ? b : {},
          h = "string" == typeof b ? b : "start";f && (e && e.stop(), d.data("countTo", e = new c(this, g))), e[h].call(e);
    });
  };
}), !function (a) {
  "function" == typeof define && __webpack_require__(67) ? define(["jquery"], a) : a("object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(module)) && module.exports ? __webpack_require__(147) : jQuery);
}(function (a) {
  function b(b) {
    var c = {},
        d = /^jQuery\d+$/;return a.each(b.attributes, function (a, b) {
      b.specified && !d.test(b.name) && (c[b.name] = b.value);
    }), c;
  }function c(b, c) {
    var d = this,
        f = a(this);if (d.value === f.attr(h ? "placeholder-x" : "placeholder") && f.hasClass(n.customClass)) if (d.value = "", f.removeClass(n.customClass), f.data("placeholder-password")) {
      if (f = f.hide().nextAll('input[type="password"]:first').show().attr("id", f.removeAttr("id").data("placeholder-id")), b === !0) return f[0].value = c, c;f.focus();
    } else d == e() && d.select();
  }function d(d) {
    var e,
        f = this,
        g = a(this),
        i = f.id;if (!d || "blur" !== d.type || !g.hasClass(n.customClass)) if ("" === f.value) {
      if ("password" === f.type) {
        if (!g.data("placeholder-textinput")) {
          try {
            e = g.clone().prop({ type: "text" });
          } catch (c) {
            e = a("<input>").attr(a.extend(b(this), { type: "text" }));
          }e.removeAttr("name").data({ "placeholder-enabled": !0, "placeholder-password": g, "placeholder-id": i }).bind("focus.placeholder", c), g.data({ "placeholder-textinput": e, "placeholder-id": i }).before(e);
        }f.value = "", g = g.removeAttr("id").hide().prevAll('input[type="text"]:first').attr("id", g.data("placeholder-id")).show();
      } else {
        var j = g.data("placeholder-password");j && (j[0].value = "", g.attr("id", g.data("placeholder-id")).show().nextAll('input[type="password"]:last').hide().removeAttr("id"));
      }g.addClass(n.customClass), g[0].value = g.attr(h ? "placeholder-x" : "placeholder");
    } else g.removeClass(n.customClass);
  }function e() {
    try {
      return document.activeElement;
    } catch (a) {}
  }var f,
      g,
      h = !1,
      i = "[object OperaMini]" === Object.prototype.toString.call(window.operamini),
      j = "placeholder" in document.createElement("input") && !i && !h,
      k = "placeholder" in document.createElement("textarea") && !i && !h,
      l = a.valHooks,
      m = a.propHooks,
      n = {};j && k ? (g = a.fn.placeholder = function () {
    return this;
  }, g.input = !0, g.textarea = !0) : (g = a.fn.placeholder = function (b) {
    var e = { customClass: "placeholder" };return n = a.extend({}, e, b), this.filter((j ? "textarea" : ":input") + "[" + (h ? "placeholder-x" : "placeholder") + "]").not("." + n.customClass).not(":radio, :checkbox, [type=hidden]").bind({ "focus.placeholder": c, "blur.placeholder": d }).data("placeholder-enabled", !0).trigger("blur.placeholder");
  }, g.input = j, g.textarea = k, f = { get: function get(b) {
      var c = a(b),
          d = c.data("placeholder-password");return d ? d[0].value : c.data("placeholder-enabled") && c.hasClass(n.customClass) ? "" : b.value;
    }, set: function set(b, f) {
      var g,
          h,
          i = a(b);return "" !== f && (g = i.data("placeholder-textinput"), h = i.data("placeholder-password"), g ? (c.call(g[0], !0, f) || (b.value = f), g[0].value = f) : h && (c.call(b, !0, f) || (h[0].value = f), b.value = f)), i.data("placeholder-enabled") ? ("" === f ? (b.value = f, b != e() && d.call(b)) : (i.hasClass(n.customClass) && c.call(b), b.value = f), i) : (b.value = f, i);
    } }, j || (l.input = f, m.value = f), k || (l.textarea = f, m.value = f), a(function () {
    a(document).delegate("form", "submit.placeholder", function () {
      var b = a("." + n.customClass, this).each(function () {
        c.call(this, !0, "");
      });setTimeout(function () {
        b.each(d);
      }, 10);
    });
  }), a(window).bind("beforeunload.placeholder", function () {
    var b = !0;try {
      "javascript:void(0)" === document.activeElement.toString() && (b = !1);
    } catch (a) {}b && a("." + n.customClass).each(function () {
      this.value = "";
    });
  }));
}), !function (a) {
  var b = !1;if ("function" == typeof define && __webpack_require__(67) && (define(a), b = !0), "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(exports)) && (module.exports = a(), b = !0), !b) {
    var c = window.Cookies,
        d = window.Cookies = a();d.noConflict = function () {
      return window.Cookies = c, d;
    };
  }
}(function () {
  function a() {
    for (var a = 0, b = {}; a < arguments.length; a++) {
      var c = arguments[a];for (var d in c) {
        b[d] = c[d];
      }
    }return b;
  }function b(c) {
    function d(b, e, f) {
      var g;if ("undefined" != typeof document) {
        if (arguments.length > 1) {
          if (f = a({ path: "/" }, d.defaults, f), "number" == typeof f.expires) {
            var h = new Date();h.setMilliseconds(h.getMilliseconds() + 864e5 * f.expires), f.expires = h;
          }try {
            g = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e), /^[\{\[]/.test(g) && (e = g);
          } catch (a) {}return e = c.write ? c.write(e, b) : encodeURIComponent(e + "").replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), b = encodeURIComponent(b + ""), b = b.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), b = b.replace(/[\(\)]/g, escape), document.cookie = b + "=" + e + (f.expires ? "; expires=" + f.expires.toUTCString() : "") + (f.path ? "; path=" + f.path : "") + (f.domain ? "; domain=" + f.domain : "") + (f.secure ? "; secure" : "");
        }b || (g = {});for (var i = document.cookie ? document.cookie.split("; ") : [], j = /(%[0-9A-Z]{2})+/g, k = 0; k < i.length; k++) {
          var l = i[k].split("="),
              m = l.slice(1).join("=");'"' === m.charAt(0) && (m = m.slice(1, -1));try {
            var n = l[0].replace(j, decodeURIComponent);if (m = c.read ? c.read(m, n) : c(m, n) || m.replace(j, decodeURIComponent), this.json) try {
              m = JSON.parse(m);
            } catch (a) {}if (b === n) {
              g = m;break;
            }b || (g[n] = m);
          } catch (a) {}
        }return g;
      }
    }return d.set = d, d.get = function (a) {
      return d.call(d, a);
    }, d.getJSON = function () {
      return d.apply({ json: !0 }, [].slice.call(arguments));
    }, d.defaults = {}, d.remove = function (b, c) {
      d(b, "", a(c, { expires: -1 }));
    }, d.withConverter = b, d;
  }return b(function () {});
});var App = function () {
  var a,
      b,
      c,
      d,
      e,
      f,
      g,
      h,
      i,
      j,
      k = function k() {
    a = jQuery("html"), b = jQuery("body"), c = jQuery("#page-container"), d = jQuery("#sidebar"), e = jQuery("#sidebar-scroll"), f = jQuery("#side-overlay"), g = jQuery("#side-overlay-scroll"), h = jQuery("#header-navbar"), i = jQuery("#main-container"), j = jQuery("#page-footer"), jQuery('[data-toggle="tooltip"], .js-tooltip').tooltip({ container: "body", animation: !1 }), jQuery('[data-toggle="popover"], .js-popover').popover({ container: "body", animation: !0, trigger: "hover" }), jQuery('[data-toggle="tabs"] a, .js-tabs a').click(function (a) {
      a.preventDefault(), jQuery(this).tab("show");
    }), jQuery(".form-control").placeholder();
  },
      l = function l() {
    var b;i.length && (m(), jQuery(window).on("resize orientationchange", function () {
      clearTimeout(b), b = setTimeout(function () {
        m();
      }, 150);
    })), n("init"), c.hasClass("header-navbar-fixed") && c.hasClass("header-navbar-transparent") && jQuery(window).on("scroll", function () {
      jQuery(this).scrollTop() > 20 ? c.addClass("header-navbar-scroll") : c.removeClass("header-navbar-scroll");
    }), jQuery('[data-toggle="layout"]').on("click", function () {
      var b = jQuery(this);o(b.data("action")), a.hasClass("no-focus") && b.blur();
    });
  },
      m = function m() {
    var a = jQuery(window).height(),
        b = h.outerHeight(),
        d = j.outerHeight();c.hasClass("header-navbar-fixed") ? i.css("min-height", a - d) : i.css("min-height", a - (b + d));
  },
      n = function n(a) {
    var b = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;if ("init" === a) {
      n();var h;jQuery(window).on("resize orientationchange", function () {
        clearTimeout(h), h = setTimeout(function () {
          n();
        }, 150);
      });
    } else b > 991 && c.hasClass("side-scroll") ? (jQuery(d).scrollLock("disable"), jQuery(f).scrollLock("disable"), e.length && !e.parent(".slimScrollDiv").length ? e.slimScroll({ height: d.outerHeight(), color: "#fff", size: "5px", opacity: .35, wheelStep: 15, distance: "2px", railVisible: !1, railOpacity: 1 }) : e.add(e.parent()).css("height", d.outerHeight()), g.length && !g.parent(".slimScrollDiv").length ? g.slimScroll({ height: f.outerHeight(), color: "#000", size: "5px", opacity: .35, wheelStep: 15, distance: "2px", railVisible: !1, railOpacity: 1 }) : g.add(g.parent()).css("height", f.outerHeight())) : (jQuery(d).scrollLock("enable"), jQuery(f).scrollLock("enable"), e.length && e.parent(".slimScrollDiv").length && (e.slimScroll({ destroy: !0 }), e.attr("style", "")), g.length && g.parent(".slimScrollDiv").length && (g.slimScroll({ destroy: !0 }), g.attr("style", "")));
  },
      o = function o(a) {
    var b = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;switch (a) {case "sidebar_pos_toggle":
        c.toggleClass("sidebar-l sidebar-r");break;case "sidebar_pos_left":
        c.removeClass("sidebar-r").addClass("sidebar-l");break;case "sidebar_pos_right":
        c.removeClass("sidebar-l").addClass("sidebar-r");break;case "sidebar_toggle":
        b > 991 ? c.toggleClass("sidebar-o") : c.toggleClass("sidebar-o-xs");break;case "sidebar_open":
        b > 991 ? c.addClass("sidebar-o") : c.addClass("sidebar-o-xs");break;case "sidebar_close":
        b > 991 ? c.removeClass("sidebar-o") : c.removeClass("sidebar-o-xs");break;case "sidebar_mini_toggle":
        b > 991 && c.toggleClass("sidebar-mini");break;case "sidebar_mini_on":
        b > 991 && c.addClass("sidebar-mini");break;case "sidebar_mini_off":
        b > 991 && c.removeClass("sidebar-mini");break;case "side_overlay_toggle":
        c.toggleClass("side-overlay-o");break;case "side_overlay_open":
        c.addClass("side-overlay-o");break;case "side_overlay_close":
        c.removeClass("side-overlay-o");break;case "side_overlay_hoverable_toggle":
        c.toggleClass("side-overlay-hover");break;case "side_overlay_hoverable_on":
        c.addClass("side-overlay-hover");break;case "side_overlay_hoverable_off":
        c.removeClass("side-overlay-hover");break;case "header_fixed_toggle":
        c.toggleClass("header-navbar-fixed");break;case "header_fixed_on":
        c.addClass("header-navbar-fixed");break;case "header_fixed_off":
        c.removeClass("header-navbar-fixed");break;case "side_scroll_toggle":
        c.toggleClass("side-scroll"), n();break;case "side_scroll_on":
        c.addClass("side-scroll"), n();break;case "side_scroll_off":
        c.removeClass("side-scroll"), n();break;default:
        return !1;}
  },
      p = function p() {
    jQuery('[data-toggle="nav-submenu"]').on("click", function (b) {
      var c = jQuery(this),
          d = c.parent("li");return d.hasClass("open") ? d.removeClass("open") : (c.closest("ul").find("> li").removeClass("open"), d.addClass("open")), a.hasClass("no-focus") && c.blur(), !1;
    });
  },
      q = function q() {
    r(!1, "init"), jQuery('[data-toggle="block-option"]').on("click", function () {
      r(jQuery(this).closest(".block"), jQuery(this).data("action"));
    });
  },
      r = function r(a, b) {
    var c = "si si-size-fullscreen",
        d = "si si-size-actual",
        e = "si si-arrow-up",
        f = "si si-arrow-down";if ("init" === b) jQuery('[data-toggle="block-option"][data-action="fullscreen_toggle"]').each(function () {
      var a = jQuery(this);a.html('<i class="' + (jQuery(this).closest(".block").hasClass("block-opt-fullscreen") ? d : c) + '"></i>');
    }), jQuery('[data-toggle="block-option"][data-action="content_toggle"]').each(function () {
      var a = jQuery(this);a.html('<i class="' + (a.closest(".block").hasClass("block-opt-hidden") ? f : e) + '"></i>');
    });else {
      var g = a instanceof jQuery ? a : jQuery(a);if (g.length) {
        var h = jQuery('[data-toggle="block-option"][data-action="fullscreen_toggle"]', g),
            i = jQuery('[data-toggle="block-option"][data-action="content_toggle"]', g);switch (b) {case "fullscreen_toggle":
            g.toggleClass("block-opt-fullscreen"), g.hasClass("block-opt-fullscreen") ? jQuery(g).scrollLock("enable") : jQuery(g).scrollLock("disable"), h.length && (g.hasClass("block-opt-fullscreen") ? jQuery("i", h).removeClass(c).addClass(d) : jQuery("i", h).removeClass(d).addClass(c));break;case "fullscreen_on":
            g.addClass("block-opt-fullscreen"), jQuery(g).scrollLock("enable"), h.length && jQuery("i", h).removeClass(c).addClass(d);break;case "fullscreen_off":
            g.removeClass("block-opt-fullscreen"), jQuery(g).scrollLock("disable"), h.length && jQuery("i", h).removeClass(d).addClass(c);break;case "content_toggle":
            g.toggleClass("block-opt-hidden"), i.length && (g.hasClass("block-opt-hidden") ? jQuery("i", i).removeClass(e).addClass(f) : jQuery("i", i).removeClass(f).addClass(e));break;case "content_hide":
            g.addClass("block-opt-hidden"), i.length && jQuery("i", i).removeClass(e).addClass(f);break;case "content_show":
            g.removeClass("block-opt-hidden"), i.length && jQuery("i", i).removeClass(f).addClass(e);break;case "refresh_toggle":
            g.toggleClass("block-opt-refresh"), jQuery('[data-toggle="block-option"][data-action="refresh_toggle"][data-action-mode="demo"]', g).length && setTimeout(function () {
              g.removeClass("block-opt-refresh");
            }, 2e3);break;case "state_loading":
            g.addClass("block-opt-refresh");break;case "state_normal":
            g.removeClass("block-opt-refresh");break;case "close":
            g.hide();break;case "open":
            g.show();break;default:
            return !1;}
      }
    }
  },
      s = function s() {
    jQuery(".form-material.floating > .form-control").each(function () {
      var a = jQuery(this),
          b = a.parent(".form-material");setTimeout(function () {
        a.val() && b.addClass("open");
      }, 150), a.on("change", function () {
        a.val() ? b.addClass("open") : b.removeClass("open");
      });
    });
  },
      t = function t() {
    var a = jQuery("#css-theme"),
        b = !!c.hasClass("enable-cookies");if (b) {
      var d = !!Cookies.get("colorTheme") && Cookies.get("colorTheme");d && ("default" === d ? a.length && a.remove() : a.length ? a.attr("href", d) : jQuery("#css-main").after('<link rel="stylesheet" id="css-theme" href="' + d + '">')), a = jQuery("#css-theme");
    }jQuery('[data-toggle="theme"][data-theme="' + (a.length ? a.attr("href") : "default") + '"]').parent("li").addClass("active"), jQuery('[data-toggle="theme"]').on("click", function () {
      var c = jQuery(this),
          d = c.data("theme");jQuery('[data-toggle="theme"]').parent("li").removeClass("active"), jQuery('[data-toggle="theme"][data-theme="' + d + '"]').parent("li").addClass("active"), "default" === d ? a.length && a.remove() : a.length ? a.attr("href", d) : jQuery("#css-main").after('<link rel="stylesheet" id="css-theme" href="' + d + '">'), a = jQuery("#css-theme"), b && Cookies.set("colorTheme", d, { expires: 7 });
    });
  },
      u = function u() {
    jQuery('[data-toggle="scroll-to"]').on("click", function () {
      var a = jQuery(this),
          b = a.data("target"),
          d = a.data("speed") ? a.data("speed") : 1e3,
          e = h.length && c.hasClass("header-navbar-fixed") ? h.outerHeight() : 0;jQuery("html, body").animate({ scrollTop: jQuery(b).offset().top - e }, d);
    });
  },
      v = function v() {
    jQuery('[data-toggle="class-toggle"]').on("click", function () {
      var b = jQuery(this);jQuery(b.data("target").toString()).toggleClass(b.data("class").toString()), a.hasClass("no-focus") && b.blur();
    });
  },
      w = function w() {
    var a = new Date(),
        b = jQuery(".js-year-copy");2015 === a.getFullYear() ? b.html("2015") : b.html("2015-" + a.getFullYear().toString().substr(2, 2));
  },
      x = function x(a) {
    var c = jQuery("#page-loader");return "show" === a ? c.length ? c.fadeIn(250) : b.prepend('<div id="page-loader"></div>') : "hide" === a && c.length && c.fadeOut(250), !1;
  },
      y = function y() {
    var a = c.prop("class");c.prop("class", ""), window.print(), c.prop("class", a);
  },
      z = function z() {
    jQuery(".js-table-sections").each(function () {
      var a = jQuery(this);jQuery(".js-table-sections-header > tr", a).on("click", function (b) {
        var c = jQuery(this),
            d = c.parent("tbody");d.hasClass("open") || jQuery("tbody", a).removeClass("open"), d.toggleClass("open");
      });
    });
  },
      A = function A() {
    jQuery(".js-table-checkable").each(function () {
      var a = jQuery(this);jQuery("thead input:checkbox", a).on("click", function () {
        var b = jQuery(this).prop("checked");jQuery("tbody input:checkbox", a).each(function () {
          var a = jQuery(this);a.prop("checked", b), B(a, b);
        });
      }), jQuery("tbody input:checkbox", a).on("click", function () {
        var a = jQuery(this);B(a, a.prop("checked"));
      }), jQuery("tbody > tr", a).on("click", function (a) {
        if ("checkbox" !== a.target.type && "button" !== a.target.type && "a" !== a.target.tagName.toLowerCase() && !jQuery(a.target).parent("label").length) {
          var b = jQuery("input:checkbox", this),
              c = b.prop("checked");b.prop("checked", !c), B(b, !c);
        }
      });
    });
  },
      B = function B(a, b) {
    b ? a.closest("tr").addClass("active") : a.closest("tr").removeClass("active");
  },
      C = function C() {
    jQuery('[data-toggle="appear"]').each(function () {
      var b = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
          c = jQuery(this),
          d = c.data("class") ? c.data("class") : "animated fadeIn",
          e = c.data("offset") ? c.data("offset") : 0,
          f = a.hasClass("ie9") || b < 992 ? 0 : c.data("timeout") ? c.data("timeout") : 0;c.appear(function () {
        setTimeout(function () {
          c.removeClass("visibility-hidden").addClass(d);
        }, f);
      }, { accY: e });
    });
  },
      D = function D() {
    jQuery('[data-toggle="countTo"]').each(function () {
      var a = jQuery(this),
          b = a.data("after"),
          c = a.data("before"),
          d = a.data("speed") ? a.data("speed") : 1500,
          e = a.data("interval") ? a.data("interval") : 15;a.appear(function () {
        a.countTo({ speed: d, refreshInterval: e, onComplete: function onComplete() {
            b ? a.html(a.html() + b) : c && a.html(c + a.html());
          } });
      });
    });
  },
      E = function E() {
    jQuery('[data-toggle="slimscroll"]').each(function () {
      var a = jQuery(this),
          b = a.data("height") ? a.data("height") : "200px",
          c = a.data("size") ? a.data("size") : "5px",
          d = a.data("position") ? a.data("position") : "right",
          e = a.data("color") ? a.data("color") : "#000",
          f = !!a.data("always-visible"),
          g = !!a.data("rail-visible"),
          h = a.data("rail-color") ? a.data("rail-color") : "#999",
          i = a.data("rail-opacity") ? a.data("rail-opacity") : .3;a.slimScroll({ height: b, size: c, position: d, color: e, alwaysVisible: f, railVisible: g, railColor: h, railOpacity: i });
    });
  },
      F = function F() {
    jQuery(".js-gallery").each(function () {
      jQuery(this).magnificPopup({ delegate: "a.img-link", type: "image", gallery: { enabled: !0 } });
    }), jQuery(".js-gallery-advanced").each(function () {
      jQuery(this).magnificPopup({ delegate: "a.img-lightbox", type: "image", gallery: { enabled: !0 } });
    });
  },
      G = function G() {
    CKEDITOR.disableAutoInline = !0, jQuery("#js-ckeditor-inline").length && CKEDITOR.inline("js-ckeditor-inline"), jQuery("#js-ckeditor").length && CKEDITOR.replace("js-ckeditor");
  },
      H = function H() {
    jQuery(".js-summernote-air").summernote({ airMode: !0 }), jQuery(".js-summernote").summernote({ height: 350, minHeight: null, maxHeight: null });
  },
      I = function I() {
    jQuery(".js-slider").each(function () {
      var a = jQuery(this),
          b = !!a.data("slider-arrows") && a.data("slider-arrows"),
          c = !!a.data("slider-dots") && a.data("slider-dots"),
          d = a.data("slider-num") ? a.data("slider-num") : 1,
          e = !!a.data("slider-autoplay") && a.data("slider-autoplay"),
          f = a.data("slider-autoplay-speed") ? a.data("slider-autoplay-speed") : 3e3;a.slick({ arrows: b, dots: c, slidesToShow: d, autoplay: e, autoplaySpeed: f });
    });
  },
      J = function J() {
    jQuery(".js-datepicker").add(".input-daterange").datepicker({ weekStart: 1, autoclose: !0, todayHighlight: !0 });
  },
      K = function K() {
    jQuery(".js-colorpicker").each(function () {
      var a = jQuery(this),
          b = a.data("colorpicker-mode") ? a.data("colorpicker-mode") : "hex",
          c = !!a.data("colorpicker-inline");a.colorpicker({ format: b, inline: c });
    });
  },
      L = function L() {
    jQuery(".js-masked-date").mask("99/99/9999"), jQuery(".js-masked-date-dash").mask("99-99-9999"), jQuery(".js-masked-phone").mask("(999) 999-9999"), jQuery(".js-masked-phone-ext").mask("(999) 999-9999? x99999"), jQuery(".js-masked-taxid").mask("99-9999999"), jQuery(".js-masked-ssn").mask("999-99-9999"), jQuery(".js-masked-pkey").mask("a*-999-a999"), jQuery(".js-masked-time").mask("99:99");
  },
      M = function M() {
    jQuery(".js-tags-input").tagsInput({ height: "36px", width: "100%", defaultText: "Add tag", removeWithBackspace: !0, delimiter: [","] });
  },
      N = function N() {
    jQuery(".js-select2").select2();
  },
      O = function O() {
    hljs.initHighlightingOnLoad();
  },
      P = function P() {
    jQuery(".js-notify").on("click", function () {
      var a = jQuery(this),
          b = a.data("notify-message"),
          c = a.data("notify-type") ? a.data("notify-type") : "info",
          d = a.data("notify-from") ? a.data("notify-from") : "top",
          e = a.data("notify-align") ? a.data("notify-align") : "right",
          f = a.data("notify-icon") ? a.data("notify-icon") : "",
          g = a.data("notify-url") ? a.data("notify-url") : "";jQuery.notify({ icon: f, message: b, url: g }, { element: "body", type: c, allow_dismiss: !0, newest_on_top: !0, showProgressbar: !1, placement: { from: d, align: e }, offset: 20, spacing: 10, z_index: 1033, delay: 5e3, timer: 1e3, animate: { enter: "animated fadeIn", exit: "animated fadeOutDown" } });
    });
  },
      Q = function Q() {
    jQuery(".js-draggable-items > .draggable-column").sortable({ connectWith: ".draggable-column", items: ".draggable-item", dropOnEmpty: !0, opacity: .75, handle: ".draggable-handler", placeholder: "draggable-placeholder", tolerance: "pointer", start: function start(a, b) {
        b.placeholder.css({ height: b.item.outerHeight(), "margin-bottom": b.item.css("margin-bottom") });
      } });
  },
      R = function R() {
    jQuery(".js-pie-chart").easyPieChart({ barColor: jQuery(this).data("bar-color") ? jQuery(this).data("bar-color") : "#777777", trackColor: jQuery(this).data("track-color") ? jQuery(this).data("track-color") : "#eeeeee", lineWidth: jQuery(this).data("line-width") ? jQuery(this).data("line-width") : 3, size: jQuery(this).data("size") ? jQuery(this).data("size") : "80", animate: 750, scaleColor: !!jQuery(this).data("scale-color") && jQuery(this).data("scale-color") });
  },
      S = function S() {
    jQuery(".js-maxlength").each(function () {
      var a = jQuery(this);a.maxlength({ alwaysShow: !!a.data("always-show"), threshold: a.data("threshold") ? a.data("threshold") : 10, warningClass: a.data("warning-class") ? a.data("warning-class") : "label label-warning", limitReachedClass: a.data("limit-reached-class") ? a.data("limit-reached-class") : "label label-danger", placement: a.data("placement") ? a.data("placement") : "bottom", preText: a.data("pre-text") ? a.data("pre-text") : "", separator: a.data("separator") ? a.data("separator") : "/", postText: a.data("post-text") ? a.data("post-text") : "" });
    });
  },
      T = function T() {
    jQuery(".js-datetimepicker").each(function () {
      var a = jQuery(this);a.datetimepicker({ format: !!a.data("format") && a.data("format"), useCurrent: !!a.data("use-current") && a.data("use-current"), locale: moment.locale("" + (a.data("locale") ? a.data("locale") : "")), showTodayButton: !!a.data("show-today-button") && a.data("show-today-button"), showClear: !!a.data("show-clear") && a.data("show-clear"), showClose: !!a.data("show-close") && a.data("show-close"), sideBySide: !!a.data("side-by-side") && a.data("side-by-side"), inline: !!a.data("inline") && a.data("inline"), icons: { time: "si si-clock", date: "si si-calendar", up: "si si-arrow-up", down: "si si-arrow-down", previous: "si si-arrow-left", next: "si si-arrow-right", today: "si si-size-actual", clear: "si si-trash", close: "si si-close" } });
    });
  },
      U = function U() {
    jQuery(".js-rangeslider").each(function () {
      var a = jQuery(this);a.ionRangeSlider({ input_values_separator: ";" });
    });
  },
      V = function V() {
    jQuery(".js-simplemde").each(function () {
      var a = jQuery(this);new SimpleMDE({ element: a[0] });
    });
  };return { init: function init(a) {
      switch (a) {case "uiInit":
          k();break;case "uiLayout":
          l();break;case "uiNav":
          p();break;case "uiBlocks":
          q();break;case "uiForms":
          s();break;case "uiHandleTheme":
          t();break;case "uiToggleClass":
          v();break;case "uiScrollTo":
          u();break;case "uiYearCopy":
          w();break;case "uiLoader":
          x("hide");break;default:
          k(), l(), p(), q(), s(), t(), v(), u(), w(), x("hide");}
    }, layout: function layout(a) {
      o(a);
    }, loader: function loader(a) {
      x(a);
    }, blocks: function blocks(a, b) {
      r(a, b);
    }, initHelper: function initHelper(a) {
      switch (a) {case "print-page":
          y();break;case "table-tools":
          z(), A();break;case "appear":
          C();break;case "appear-countTo":
          D();break;case "slimscroll":
          E();break;case "magnific-popup":
          F();break;case "ckeditor":
          G();break;case "summernote":
          H();break;case "slick":
          I();break;case "datepicker":
          J();break;case "colorpicker":
          K();break;case "tags-inputs":
          M();break;case "masked-inputs":
          L();break;case "select2":
          N();break;case "highlightjs":
          O();break;case "notify":
          P();break;case "draggable-items":
          Q();break;case "easy-pie-chart":
          R();break;case "maxlength":
          S();break;case "datetimepicker":
          T();break;case "rangeslider":
          U();break;case "simplemde":
          V();break;default:
          return !1;}
    }, initHelpers: function initHelpers(a) {
      if (a instanceof Array) for (var b in a) {
        App.initHelper(a[b]);
      } else App.initHelper(a);
    } };
}(),
    OneUI = App;jQuery(function () {
  "undefined" == typeof angular && App.init();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1603)(module)))

/***/ }),
/* 472 */,
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */,
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1243)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1571),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"output":{"shape":"Sg"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sr"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sg"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sw"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S18"},"RoleMappings":{"shape":"S1a"}}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sw"},"LoginsToRemove":{"shape":"Ss"}}}},"UpdateIdentityPool":{"input":{"shape":"Sg"},"output":{"shape":"Sg"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"}}},"Sr":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Ss"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Ss":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1a":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2x"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"Schema":{"shape":"S5h"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5l"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"ClientId":{"shape":"S1i"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4f"}},"NextToken":{}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4j"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1i"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9c"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"UserContextData":{"shape":"S3r"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7p"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1i"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2x"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6r"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S81"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8b"},"SoftwareTokenMfaConfiguration":{"shape":"S8c"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3p"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3r"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S7p"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4j"}}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S46"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4f"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S7p"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"AutoVerifiedAttributes":{"shape":"S4v"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S67"}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1d"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2x":{"type":"map","key":{},"value":{}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3p":{"type":"string","sensitive":true},"S3r":{"type":"structure","members":{"EncodedData":{}}},"S40":{"type":"map","key":{},"value":{}},"S41":{"type":"map","key":{},"value":{}},"S43":{"type":"list","member":{}},"S46":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S40"},"AttributeMapping":{"shape":"S41"},"IdpIdentifiers":{"shape":"S43"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4a":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4f":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4a"}}},"S4j":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4r":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"}}}}},"S4u":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{}}},"S4v":{"type":"list","member":{}},"S4x":{"type":"list","member":{}},"S4z":{"type":"list","member":{}},"S54":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S59":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5a":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{}}},"S5c":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5d":{"type":"map","key":{},"value":{}},"S5e":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5h":{"type":"list","member":{"shape":"S4"}},"S5i":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5l":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4r"},"LambdaConfig":{"shape":"S4u"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5h"},"AutoVerifiedAttributes":{"shape":"S4v"},"AliasAttributes":{"shape":"S4x"},"UsernameAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S54"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S59"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5a"},"SmsConfiguration":{"shape":"S5c"},"UserPoolTags":{"shape":"S5d"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"AdminCreateUserConfig":{"shape":"S5e"},"UserPoolAddOns":{"shape":"S5i"}}},"S5s":{"type":"list","member":{}},"S5u":{"type":"list","member":{}},"S5w":{"type":"list","member":{}},"S5x":{"type":"list","member":{}},"S5z":{"type":"list","member":{}},"S60":{"type":"list","member":{}},"S62":{"type":"list","member":{}},"S64":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S67":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1i"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5s"},"WriteAttributes":{"shape":"S5s"},"ExplicitAuthFlows":{"shape":"S5u"},"SupportedIdentityProviders":{"shape":"S5w"},"CallbackURLs":{"shape":"S5x"},"LogoutURLs":{"shape":"S5z"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S60"},"AllowedOAuthScopes":{"shape":"S62"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S64"}}},"S6r":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6s"},"AccountTakeoverRiskConfiguration":{"shape":"S6x"},"RiskExceptionConfiguration":{"shape":"S76"},"LastModifiedDate":{"type":"timestamp"}}},"S6s":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S6x":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S6z"},"NoActionEmail":{"shape":"S6z"},"MfaEmail":{"shape":"S6z"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S73"},"MediumAction":{"shape":"S73"},"HighAction":{"shape":"S73"}}}}},"S6z":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S73":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S76":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S7p":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S81":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8b":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5c"}}},"S8c":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9c":{"type":"list","member":{"shape":"Ss"}}}}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory"},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild"},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM"},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing"},"costexplorer":{"prefix":"ce","name":"CostExplorer"},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData"},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend"},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia"},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia"},"kinesisvideo":{"name":"KinesisVideo"},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate"},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups"},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"}}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sf"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-08","endpointPrefix":"acm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM","serviceFullName":"AWS Certificate Manager","serviceId":"ACM","signatureVersion":"v4","targetPrefix":"CertificateManager","uid":"acm-2015-12-08"},"operations":{"AddTagsToCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"DescribeCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"DomainValidationOptions":{"shape":"Sd"},"Serial":{},"Subject":{},"Issuer":{},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"Status":{},"RevokedAt":{"type":"timestamp"},"RevocationReason":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"KeyAlgorithm":{},"SignatureAlgorithm":{},"InUseBy":{"type":"list","member":{}},"FailureReason":{},"Type":{},"RenewalSummary":{"type":"structure","required":["RenewalStatus","DomainValidationOptions","UpdatedAt"],"members":{"RenewalStatus":{},"DomainValidationOptions":{"shape":"Sd"},"RenewalStatusReason":{},"UpdatedAt":{"type":"timestamp"}}},"KeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"ExtendedKeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{},"OID":{}}}},"CertificateAuthorityArn":{},"RenewalEligibility":{},"Options":{"shape":"S11"}}}}}},"ExportCertificate":{"input":{"type":"structure","required":["CertificateArn","Passphrase"],"members":{"CertificateArn":{},"Passphrase":{"type":"blob","sensitive":true}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{},"PrivateKey":{"type":"string","sensitive":true}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"CertificateArn":{},"Certificate":{"type":"blob"},"PrivateKey":{"type":"blob","sensitive":true},"CertificateChain":{"type":"blob"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ListCertificates":{"input":{"type":"structure","members":{"CertificateStatuses":{"type":"list","member":{}},"Includes":{"type":"structure","members":{"extendedKeyUsage":{"type":"list","member":{}},"keyUsage":{"type":"list","member":{}},"keyTypes":{"type":"list","member":{}}}},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CertificateSummaryList":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"DomainName":{}}}}}}},"ListTagsForCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"RemoveTagsFromCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"RenewCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"RequestCertificate":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationMethod":{},"SubjectAlternativeNames":{"shape":"Sc"},"IdempotencyToken":{},"DomainValidationOptions":{"type":"list","member":{"type":"structure","required":["DomainName","ValidationDomain"],"members":{"DomainName":{},"ValidationDomain":{}}}},"Options":{"shape":"S11"},"CertificateAuthorityArn":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ResendValidationEmail":{"input":{"type":"structure","required":["CertificateArn","Domain","ValidationDomain"],"members":{"CertificateArn":{},"Domain":{},"ValidationDomain":{}}}},"UpdateCertificateOptions":{"input":{"type":"structure","required":["CertificateArn","Options"],"members":{"CertificateArn":{},"Options":{"shape":"S11"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationEmails":{"type":"list","member":{}},"ValidationDomain":{},"ValidationStatus":{},"ResourceRecord":{"type":"structure","required":["Name","Type","Value"],"members":{"Name":{},"Type":{},"Value":{}}},"ValidationMethod":{}}}},"S11":{"type":"structure","members":{"CertificateTransparencyLoggingPreference":{}}}}}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CertificateValidated":{"delay":60,"maxAttempts":40,"operation":"DescribeCertificate","acceptors":[{"matcher":"pathAll","expected":"SUCCESS","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"success"},{"matcher":"pathAny","expected":"PENDING_VALIDATION","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"retry"},{"matcher":"path","expected":"FAILED","argument":"Certificate.Status","state":"failure"},{"matcher":"error","expected":"ResourceNotFoundException","state":"failure"}]}}}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"apigateway","protocol":"rest-json","serviceFullName":"Amazon API Gateway","serviceId":"API Gateway","signatureVersion":"v4","uid":"apigateway-2015-07-09"},"operations":{"CreateApiKey":{"http":{"requestUri":"/apikeys","responseCode":201},"input":{"type":"structure","members":{"name":{},"description":{},"enabled":{"type":"boolean"},"generateDistinctId":{"type":"boolean"},"value":{},"stageKeys":{"type":"list","member":{"type":"structure","members":{"restApiId":{},"stageName":{}}}},"customerId":{},"tags":{"shape":"S6"}}},"output":{"shape":"S7"}},"CreateAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers","responseCode":201},"input":{"type":"structure","required":["restApiId","name","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"output":{"shape":"Sf"}},"CreateBasePathMapping":{"http":{"requestUri":"/domainnames/{domain_name}/basepathmappings","responseCode":201},"input":{"type":"structure","required":["domainName","restApiId"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{},"restApiId":{},"stage":{}}},"output":{"shape":"Sh"}},"CreateDeployment":{"http":{"requestUri":"/restapis/{restapi_id}/deployments","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"stageDescription":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"canarySettings":{"type":"structure","members":{"percentTraffic":{"type":"double"},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"tracingEnabled":{"type":"boolean"}}},"output":{"shape":"Sn"}},"CreateDocumentationPart":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/parts","responseCode":201},"input":{"type":"structure","required":["restApiId","location","properties"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"location":{"shape":"Ss"},"properties":{}}},"output":{"shape":"Sv"}},"CreateDocumentationVersion":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/versions","responseCode":201},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{},"stageName":{},"description":{}}},"output":{"shape":"Sx"}},"CreateDomainName":{"http":{"requestUri":"/domainnames","responseCode":201},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"certificateName":{},"certificateBody":{},"certificatePrivateKey":{},"certificateChain":{},"certificateArn":{},"regionalCertificateName":{},"regionalCertificateArn":{},"endpointConfiguration":{"shape":"Sz"},"tags":{"shape":"S6"},"securityPolicy":{}}},"output":{"shape":"S13"}},"CreateModel":{"http":{"requestUri":"/restapis/{restapi_id}/models","responseCode":201},"input":{"type":"structure","required":["restApiId","name","contentType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"description":{},"schema":{},"contentType":{}}},"output":{"shape":"S16"}},"CreateRequestValidator":{"http":{"requestUri":"/restapis/{restapi_id}/requestvalidators","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"output":{"shape":"S18"}},"CreateResource":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{parent_id}","responseCode":201},"input":{"type":"structure","required":["restApiId","parentId","pathPart"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"parentId":{"location":"uri","locationName":"parent_id"},"pathPart":{}}},"output":{"shape":"S1a"}},"CreateRestApi":{"http":{"requestUri":"/restapis","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"version":{},"cloneFrom":{},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"}}},"output":{"shape":"S1r"}},"CreateStage":{"http":{"requestUri":"/restapis/{restapi_id}/stages","responseCode":201},"input":{"type":"structure","required":["restApiId","stageName","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"deploymentId":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"documentationVersion":{},"canarySettings":{"shape":"S1t"},"tracingEnabled":{"type":"boolean"},"tags":{"shape":"S6"}}},"output":{"shape":"S1u"}},"CreateUsagePlan":{"http":{"requestUri":"/usageplans","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"apiStages":{"shape":"S21"},"throttle":{"shape":"S24"},"quota":{"shape":"S25"},"tags":{"shape":"S6"}}},"output":{"shape":"S27"}},"CreateUsagePlanKey":{"http":{"requestUri":"/usageplans/{usageplanId}/keys","responseCode":201},"input":{"type":"structure","required":["usagePlanId","keyId","keyType"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{},"keyType":{}}},"output":{"shape":"S29"}},"CreateVpcLink":{"http":{"requestUri":"/vpclinks","responseCode":202},"input":{"type":"structure","required":["name","targetArns"],"members":{"name":{},"description":{},"targetArns":{"shape":"S9"},"tags":{"shape":"S6"}}},"output":{"shape":"S2b"}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/apikeys/{api_Key}","responseCode":202},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"}}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}}},"DeleteBasePathMapping":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}","responseCode":202},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}}},"DeleteClientCertificate":{"http":{"method":"DELETE","requestUri":"/clientcertificates/{clientcertificate_id}","responseCode":202},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"}}}},"DeleteDocumentationPart":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}}},"DeleteDocumentationVersion":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}","responseCode":202},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}}},"DeleteGatewayResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":202},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteMethod":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteMethodResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/models/{model_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}}},"DeleteRequestValidator":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}}},"DeleteResource":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"}}}},"DeleteRestApi":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}","responseCode":202},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"DeleteUsagePlan":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}}},"DeleteUsagePlanKey":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}}},"DeleteVpcLink":{"http":{"method":"DELETE","requestUri":"/vpclinks/{vpclink_id}","responseCode":202},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}}},"FlushStageAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"FlushStageCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/data","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"GenerateClientCertificate":{"http":{"requestUri":"/clientcertificates","responseCode":201},"input":{"type":"structure","members":{"description":{},"tags":{"shape":"S6"}}},"output":{"shape":"S32"}},"GetAccount":{"http":{"method":"GET","requestUri":"/account"},"input":{"type":"structure","members":{}},"output":{"shape":"S34"}},"GetApiKey":{"http":{"method":"GET","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"includeValue":{"location":"querystring","locationName":"includeValue","type":"boolean"}}},"output":{"shape":"S7"}},"GetApiKeys":{"http":{"method":"GET","requestUri":"/apikeys"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"},"customerId":{"location":"querystring","locationName":"customerId"},"includeValues":{"location":"querystring","locationName":"includeValues","type":"boolean"}}},"output":{"type":"structure","members":{"warnings":{"shape":"S9"},"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S7"}}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}},"output":{"shape":"Sf"}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sf"}}}}},"GetBasePathMapping":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}},"output":{"shape":"Sh"}},"GetBasePathMappings":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sh"}}}}},"GetClientCertificate":{"http":{"method":"GET","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}},"output":{"shape":"S32"}},"GetClientCertificates":{"http":{"method":"GET","requestUri":"/clientcertificates"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S32"}}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"Sn"}},"GetDeployments":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sn"}}}}},"GetDocumentationPart":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}},"output":{"shape":"Sv"}},"GetDocumentationParts":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"type":{"location":"querystring","locationName":"type"},"nameQuery":{"location":"querystring","locationName":"name"},"path":{"location":"querystring","locationName":"path"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"locationStatus":{"location":"querystring","locationName":"locationStatus"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sv"}}}}},"GetDocumentationVersion":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}},"output":{"shape":"Sx"}},"GetDocumentationVersions":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sx"}}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}},"output":{"shape":"S13"}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/domainnames"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S13"}}}}},"GetExport":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","exportType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"exportType":{"location":"uri","locationName":"export_type"},"parameters":{"shape":"S6","location":"querystring"},"accepts":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetGatewayResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}},"output":{"shape":"S46"}},"GetGatewayResponses":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S46"}}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1h"}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1n"}},"GetMethod":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1c"}},"GetMethodResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1f"}},"GetModel":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"flatten":{"location":"querystring","locationName":"flatten","type":"boolean"}}},"output":{"shape":"S16"}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}/default_template"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}},"output":{"type":"structure","members":{"value":{}}}},"GetModels":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S16"}}}}},"GetRequestValidator":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}},"output":{"shape":"S18"}},"GetRequestValidators":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S18"}}}}},"GetResource":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"S1a"}},"GetResources":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1a"}}}}},"GetRestApi":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}},"output":{"shape":"S1r"}},"GetRestApis":{"http":{"method":"GET","requestUri":"/restapis"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1r"}}}}},"GetSdk":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","sdkType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"sdkType":{"location":"uri","locationName":"sdk_type"},"parameters":{"shape":"S6","location":"querystring"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetSdkType":{"http":{"method":"GET","requestUri":"/sdktypes/{sdktype_id}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"sdktype_id"}}},"output":{"shape":"S4z"}},"GetSdkTypes":{"http":{"method":"GET","requestUri":"/sdktypes"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S4z"}}}}},"GetStage":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}},"output":{"shape":"S1u"}},"GetStages":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"querystring","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"item":{"type":"list","member":{"shape":"S1u"}}}}},"GetTags":{"http":{"method":"GET","requestUri":"/tags/{resource_arn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"S6"}}}},"GetUsage":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/usage"},"input":{"type":"structure","required":["usagePlanId","startDate","endDate"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"querystring","locationName":"keyId"},"startDate":{"location":"querystring","locationName":"startDate"},"endDate":{"location":"querystring","locationName":"endDate"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"shape":"S5c"}},"GetUsagePlan":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}},"output":{"shape":"S27"}},"GetUsagePlanKey":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":200},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}},"output":{"shape":"S29"}},"GetUsagePlanKeys":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S29"}}}}},"GetUsagePlans":{"http":{"method":"GET","requestUri":"/usageplans"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"keyId":{"location":"querystring","locationName":"keyId"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S27"}}}}},"GetVpcLink":{"http":{"method":"GET","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}},"output":{"shape":"S2b"}},"GetVpcLinks":{"http":{"method":"GET","requestUri":"/vpclinks"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2b"}}}}},"ImportApiKeys":{"http":{"requestUri":"/apikeys?mode=import","responseCode":201},"input":{"type":"structure","required":["body","format"],"members":{"body":{"type":"blob"},"format":{"location":"querystring","locationName":"format"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportDocumentationParts":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"body":{"type":"blob"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportRestApi":{"http":{"requestUri":"/restapis?mode=import","responseCode":201},"input":{"type":"structure","required":["body"],"members":{"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1r"}},"PutGatewayResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":201},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"}}},"output":{"shape":"S46"}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"type":{},"integrationHttpMethod":{"locationName":"httpMethod"},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"tlsConfig":{"shape":"S1o"}}},"output":{"shape":"S1h"}},"PutIntegrationResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"output":{"shape":"S1n"}},"PutMethod":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","authorizationType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"operationName":{},"requestParameters":{"shape":"S1d"},"requestModels":{"shape":"S6"},"requestValidatorId":{},"authorizationScopes":{"shape":"S9"}}},"output":{"shape":"S1c"}},"PutMethodResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"responseParameters":{"shape":"S1d"},"responseModels":{"shape":"S6"}}},"output":{"shape":"S1f"}},"PutRestApi":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1r"}},"TagResource":{"http":{"method":"PUT","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tags":{"shape":"S6"}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S68"},"pathWithQueryString":{},"body":{},"stageVariables":{"shape":"S6"},"additionalContext":{"shape":"S6"}}},"output":{"type":"structure","members":{"clientStatus":{"type":"integer"},"log":{},"latency":{"type":"long"},"principalId":{},"policy":{},"authorization":{"shape":"S68"},"claims":{"shape":"S6"}}}},"TestInvokeMethod":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"pathWithQueryString":{},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S68"},"clientCertificateId":{},"stageVariables":{"shape":"S6"}}},"output":{"type":"structure","members":{"status":{"type":"integer"},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S68"},"log":{},"latency":{"type":"long"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tagKeys":{"shape":"S9","location":"querystring","locationName":"tagKeys"}}}},"UpdateAccount":{"http":{"method":"PATCH","requestUri":"/account"},"input":{"type":"structure","members":{"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S34"}},"UpdateApiKey":{"http":{"method":"PATCH","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S7"}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"Sf"}},"UpdateBasePathMapping":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"Sh"}},"UpdateClientCertificate":{"http":{"method":"PATCH","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S32"}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"Sn"}},"UpdateDocumentationPart":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"Sv"}},"UpdateDocumentationVersion":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"Sx"}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S13"}},"UpdateGatewayResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S46"}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1h"}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1n"}},"UpdateMethod":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1c"}},"UpdateMethodResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1f"}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S16"}},"UpdateRequestValidator":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S18"}},"UpdateResource":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1a"}},"UpdateRestApi":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1r"}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S1u"}},"UpdateUsage":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}/keys/{keyId}/usage"},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S5c"}},"UpdateUsagePlan":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S27"}},"UpdateVpcLink":{"http":{"method":"PATCH","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"},"patchOperations":{"shape":"S6e"}}},"output":{"shape":"S2b"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"id":{},"value":{},"name":{},"customerId":{},"description":{},"enabled":{"type":"boolean"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"stageKeys":{"shape":"S9"},"tags":{"shape":"S6"}}},"S9":{"type":"list","member":{}},"Sc":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"id":{},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"Sh":{"type":"structure","members":{"basePath":{},"restApiId":{},"stage":{}}},"Sn":{"type":"structure","members":{"id":{},"description":{},"createdDate":{"type":"timestamp"},"apiSummary":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","members":{"authorizationType":{},"apiKeyRequired":{"type":"boolean"}}}}}}},"Ss":{"type":"structure","required":["type"],"members":{"type":{},"path":{},"method":{},"statusCode":{},"name":{}}},"Sv":{"type":"structure","members":{"id":{},"location":{"shape":"Ss"},"properties":{}}},"Sx":{"type":"structure","members":{"version":{},"createdDate":{"type":"timestamp"},"description":{}}},"Sz":{"type":"structure","members":{"types":{"type":"list","member":{}},"vpcEndpointIds":{"shape":"S9"}}},"S13":{"type":"structure","members":{"domainName":{},"certificateName":{},"certificateArn":{},"certificateUploadDate":{"type":"timestamp"},"regionalDomainName":{},"regionalHostedZoneId":{},"regionalCertificateName":{},"regionalCertificateArn":{},"distributionDomainName":{},"distributionHostedZoneId":{},"endpointConfiguration":{"shape":"Sz"},"domainNameStatus":{},"domainNameStatusMessage":{},"securityPolicy":{},"tags":{"shape":"S6"}}},"S16":{"type":"structure","members":{"id":{},"name":{},"description":{},"schema":{},"contentType":{}}},"S18":{"type":"structure","members":{"id":{},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"S1a":{"type":"structure","members":{"id":{},"parentId":{},"pathPart":{},"path":{},"resourceMethods":{"type":"map","key":{},"value":{"shape":"S1c"}}}},"S1c":{"type":"structure","members":{"httpMethod":{},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"requestValidatorId":{},"operationName":{},"requestParameters":{"shape":"S1d"},"requestModels":{"shape":"S6"},"methodResponses":{"type":"map","key":{},"value":{"shape":"S1f"}},"methodIntegration":{"shape":"S1h"},"authorizationScopes":{"shape":"S9"}}},"S1d":{"type":"map","key":{},"value":{"type":"boolean"}},"S1f":{"type":"structure","members":{"statusCode":{},"responseParameters":{"shape":"S1d"},"responseModels":{"shape":"S6"}}},"S1h":{"type":"structure","members":{"type":{},"httpMethod":{},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"integrationResponses":{"type":"map","key":{},"value":{"shape":"S1n"}},"tlsConfig":{"shape":"S1o"}}},"S1n":{"type":"structure","members":{"statusCode":{},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"S1o":{"type":"structure","members":{"insecureSkipVerification":{"type":"boolean"}}},"S1r":{"type":"structure","members":{"id":{},"name":{},"description":{},"createdDate":{"type":"timestamp"},"version":{},"warnings":{"shape":"S9"},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"}}},"S1t":{"type":"structure","members":{"percentTraffic":{"type":"double"},"deploymentId":{},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"S1u":{"type":"structure","members":{"deploymentId":{},"clientCertificateId":{},"stageName":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"cacheClusterStatus":{},"methodSettings":{"type":"map","key":{},"value":{"type":"structure","members":{"metricsEnabled":{"type":"boolean"},"loggingLevel":{},"dataTraceEnabled":{"type":"boolean"},"throttlingBurstLimit":{"type":"integer"},"throttlingRateLimit":{"type":"double"},"cachingEnabled":{"type":"boolean"},"cacheTtlInSeconds":{"type":"integer"},"cacheDataEncrypted":{"type":"boolean"},"requireAuthorizationForCacheControl":{"type":"boolean"},"unauthorizedCacheControlHeaderStrategy":{}}}},"variables":{"shape":"S6"},"documentationVersion":{},"accessLogSettings":{"type":"structure","members":{"format":{},"destinationArn":{}}},"canarySettings":{"shape":"S1t"},"tracingEnabled":{"type":"boolean"},"webAclArn":{},"tags":{"shape":"S6"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"}}},"S21":{"type":"list","member":{"type":"structure","members":{"apiId":{},"stage":{},"throttle":{"type":"map","key":{},"value":{"shape":"S24"}}}}},"S24":{"type":"structure","members":{"burstLimit":{"type":"integer"},"rateLimit":{"type":"double"}}},"S25":{"type":"structure","members":{"limit":{"type":"integer"},"offset":{"type":"integer"},"period":{}}},"S27":{"type":"structure","members":{"id":{},"name":{},"description":{},"apiStages":{"shape":"S21"},"throttle":{"shape":"S24"},"quota":{"shape":"S25"},"productCode":{},"tags":{"shape":"S6"}}},"S29":{"type":"structure","members":{"id":{},"type":{},"value":{},"name":{}}},"S2b":{"type":"structure","members":{"id":{},"name":{},"description":{},"targetArns":{"shape":"S9"},"status":{},"statusMessage":{},"tags":{"shape":"S6"}}},"S32":{"type":"structure","members":{"clientCertificateId":{},"description":{},"pemEncodedCertificate":{},"createdDate":{"type":"timestamp"},"expirationDate":{"type":"timestamp"},"tags":{"shape":"S6"}}},"S34":{"type":"structure","members":{"cloudwatchRoleArn":{},"throttleSettings":{"shape":"S24"},"features":{"shape":"S9"},"apiKeyVersion":{}}},"S46":{"type":"structure","members":{"responseType":{},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"defaultResponse":{"type":"boolean"}}},"S4z":{"type":"structure","members":{"id":{},"friendlyName":{},"description":{},"configurationProperties":{"type":"list","member":{"type":"structure","members":{"name":{},"friendlyName":{},"description":{},"required":{"type":"boolean"},"defaultValue":{}}}}}},"S5c":{"type":"structure","members":{"usagePlanId":{},"startDate":{},"endDate":{},"position":{},"items":{"locationName":"values","type":"map","key":{},"value":{"type":"list","member":{"type":"list","member":{"type":"long"}}}}}},"S68":{"type":"map","key":{},"value":{"shape":"S9"}},"S6e":{"type":"list","member":{"type":"structure","members":{"op":{},"path":{},"value":{},"from":{}}}}}}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetApiKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetBasePathMappings":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetClientCertificates":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDeployments":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDomainNames":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetModels":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetResources":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetRestApis":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsage":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlanKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlans":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetVpcLinks":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"}}}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-06","endpointPrefix":"application-autoscaling","jsonVersion":"1.1","protocol":"json","serviceFullName":"Application Auto Scaling","serviceId":"Application Auto Scaling","signatureVersion":"v4","signingName":"application-autoscaling","targetPrefix":"AnyScaleFrontendService","uid":"application-autoscaling-2016-02-06"},"operations":{"DeleteScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeregisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DescribeScalableTargets":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceIds":{"shape":"Sb"},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalableTargets":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","RoleARN","CreationTime"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"CreationTime":{"type":"timestamp"},"SuspendedState":{"shape":"Sj"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingActivities":{"type":"list","member":{"type":"structure","required":["ActivityId","ServiceNamespace","ResourceId","ScalableDimension","Description","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Details":{}}}},"NextToken":{}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"PolicyNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyARN","PolicyName","ServiceNamespace","ResourceId","ScalableDimension","PolicyType","CreationTime"],"members":{"PolicyARN":{},"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sx"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S16"},"Alarms":{"shape":"S1k"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScheduledActions":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ScheduledActionNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName","ScheduledActionARN","ServiceNamespace","Schedule","ResourceId","CreationTime"],"members":{"ScheduledActionName":{},"ScheduledActionARN":{},"ServiceNamespace":{},"Schedule":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1r"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sx"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S16"}}},"output":{"type":"structure","required":["PolicyARN"],"members":{"PolicyARN":{},"Alarms":{"shape":"S1k"}}}},"PutScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"Schedule":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1r"}}},"output":{"type":"structure","members":{}}},"RegisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"SuspendedState":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sb":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"DynamicScalingInSuspended":{"type":"boolean"},"DynamicScalingOutSuspended":{"type":"boolean"},"ScheduledScalingSuspended":{"type":"boolean"}}},"Sx":{"type":"structure","members":{"AdjustmentType":{},"StepAdjustments":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"MinAdjustmentMagnitude":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{}}},"S16":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"DisableScaleIn":{"type":"boolean"}}},"S1k":{"type":"list","member":{"type":"structure","required":["AlarmName","AlarmARN"],"members":{"AlarmName":{},"AlarmARN":{}}}},"S1r":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}}}}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeScalableTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalableTargets"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingActivities"},"DescribeScalingPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledActions"}}}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-01-01","endpointPrefix":"autoscaling","protocol":"query","serviceFullName":"Auto Scaling","serviceId":"Auto Scaling","signatureVersion":"v4","uid":"autoscaling-2011-01-01","xmlNamespace":"http://autoscaling.amazonaws.com/doc/2011-01-01/"},"operations":{"AttachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}}},"AttachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"AttachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"AttachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"AttachLoadBalancersResult","type":"structure","members":{}}},"BatchDeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionNames"],"members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Se"}}},"output":{"resultWrapper":"BatchDeleteScheduledActionResult","type":"structure","members":{"FailedScheduledActions":{"shape":"Sg"}}}},"BatchPutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledUpdateGroupActions"],"members":{"AutoScalingGroupName":{},"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}}}},"output":{"resultWrapper":"BatchPutScheduledUpdateGroupActionResult","type":"structure","members":{"FailedScheduledUpdateGroupActions":{"shape":"Sg"}}}},"CancelInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{}}},"output":{"resultWrapper":"CancelInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"CompleteLifecycleAction":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName","LifecycleActionResult"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"LifecycleActionResult":{},"InstanceId":{}}},"output":{"resultWrapper":"CompleteLifecycleActionResult","type":"structure","members":{}}},"CreateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"},"InstanceId":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S1d"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S1g"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"LifecycleHookSpecificationList":{"type":"list","member":{"type":"structure","required":["LifecycleHookName","LifecycleTransition"],"members":{"LifecycleHookName":{},"LifecycleTransition":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{},"NotificationTargetARN":{},"RoleARN":{}}}},"Tags":{"shape":"S1p"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"}}}},"CreateLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S1w"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S1x"},"UserData":{},"InstanceId":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1z"},"InstanceMonitoring":{"shape":"S28"},"SpotPrice":{},"IamInstanceProfile":{},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"CreateOrUpdateTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S1p"}}}},"DeleteAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}}},"DeleteLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{}}}},"DeleteLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"DeleteLifecycleHookResult","type":"structure","members":{}}},"DeleteNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN"],"members":{"AutoScalingGroupName":{},"TopicARN":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S1p"}}}},"DescribeAccountLimits":{"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"MaxNumberOfAutoScalingGroups":{"type":"integer"},"MaxNumberOfLaunchConfigurations":{"type":"integer"},"NumberOfAutoScalingGroups":{"type":"integer"},"NumberOfLaunchConfigurations":{"type":"integer"}}}},"DescribeAdjustmentTypes":{"output":{"resultWrapper":"DescribeAdjustmentTypesResult","type":"structure","members":{"AdjustmentTypes":{"type":"list","member":{"type":"structure","members":{"AdjustmentType":{}}}}}}},"DescribeAutoScalingGroups":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S2w"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAutoScalingGroupsResult","type":"structure","required":["AutoScalingGroups"],"members":{"AutoScalingGroups":{"type":"list","member":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize","DesiredCapacity","DefaultCooldown","AvailabilityZones","HealthCheckType","CreatedTime"],"members":{"AutoScalingGroupName":{},"AutoScalingGroupARN":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S1d"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"Instances":{"type":"list","member":{"type":"structure","required":["InstanceId","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"InstanceType":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"ProtectedFromScaleIn":{"type":"boolean"},"WeightedCapacity":{}}}},"CreatedTime":{"type":"timestamp"},"SuspendedProcesses":{"type":"list","member":{"type":"structure","members":{"ProcessName":{},"SuspensionReason":{}}}},"PlacementGroup":{},"VPCZoneIdentifier":{},"EnabledMetrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Granularity":{}}}},"Status":{},"Tags":{"shape":"S38"},"TerminationPolicies":{"shape":"S1g"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"}}}},"NextToken":{}}}},"DescribeAutoScalingInstances":{"input":{"type":"structure","members":{"InstanceIds":{"shape":"S2"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAutoScalingInstancesResult","type":"structure","members":{"AutoScalingInstances":{"type":"list","member":{"type":"structure","required":["InstanceId","AutoScalingGroupName","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"InstanceType":{},"AutoScalingGroupName":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"ProtectedFromScaleIn":{"type":"boolean"},"WeightedCapacity":{}}}},"NextToken":{}}}},"DescribeAutoScalingNotificationTypes":{"output":{"resultWrapper":"DescribeAutoScalingNotificationTypesResult","type":"structure","members":{"AutoScalingNotificationTypes":{"shape":"S3f"}}}},"DescribeInstanceRefreshes":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"InstanceRefreshIds":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeInstanceRefreshesResult","type":"structure","members":{"InstanceRefreshes":{"type":"list","member":{"type":"structure","members":{"InstanceRefreshId":{},"AutoScalingGroupName":{},"Status":{},"StatusReason":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"}}}},"NextToken":{}}}},"DescribeLaunchConfigurations":{"input":{"type":"structure","members":{"LaunchConfigurationNames":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLaunchConfigurationsResult","type":"structure","required":["LaunchConfigurations"],"members":{"LaunchConfigurations":{"type":"list","member":{"type":"structure","required":["LaunchConfigurationName","ImageId","InstanceType","CreatedTime"],"members":{"LaunchConfigurationName":{},"LaunchConfigurationARN":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S1w"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S1x"},"UserData":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1z"},"InstanceMonitoring":{"shape":"S28"},"SpotPrice":{},"IamInstanceProfile":{},"CreatedTime":{"type":"timestamp"},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"NextToken":{}}}},"DescribeLifecycleHookTypes":{"output":{"resultWrapper":"DescribeLifecycleHookTypesResult","type":"structure","members":{"LifecycleHookTypes":{"shape":"S3f"}}}},"DescribeLifecycleHooks":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LifecycleHookNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLifecycleHooksResult","type":"structure","members":{"LifecycleHooks":{"type":"list","member":{"type":"structure","members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"NotificationTargetARN":{},"RoleARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"GlobalTimeout":{"type":"integer"},"DefaultResult":{}}}}}}},"DescribeLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancerTargetGroupsResult","type":"structure","members":{"LoadBalancerTargetGroups":{"type":"list","member":{"type":"structure","members":{"LoadBalancerTargetGroupARN":{},"State":{}}}},"NextToken":{}}}},"DescribeLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"State":{}}}},"NextToken":{}}}},"DescribeMetricCollectionTypes":{"output":{"resultWrapper":"DescribeMetricCollectionTypesResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{}}}},"Granularities":{"type":"list","member":{"type":"structure","members":{"Granularity":{}}}}}}},"DescribeNotificationConfigurations":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S2w"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNotificationConfigurationsResult","type":"structure","required":["NotificationConfigurations"],"members":{"NotificationConfigurations":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationType":{}}}},"NextToken":{}}}},"DescribePolicies":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyNames":{"type":"list","member":{}},"PolicyTypes":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePoliciesResult","type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyARN":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S4n"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"StepAdjustments":{"shape":"S4q"},"MetricAggregationType":{},"EstimatedInstanceWarmup":{"type":"integer"},"Alarms":{"shape":"S4u"},"TargetTrackingConfiguration":{"shape":"S4w"},"Enabled":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","members":{"ActivityIds":{"type":"list","member":{}},"AutoScalingGroupName":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeScalingActivitiesResult","type":"structure","required":["Activities"],"members":{"Activities":{"shape":"S5d"},"NextToken":{}}}},"DescribeScalingProcessTypes":{"output":{"resultWrapper":"DescribeScalingProcessTypesResult","type":"structure","members":{"Processes":{"type":"list","member":{"type":"structure","required":["ProcessName"],"members":{"ProcessName":{}}}}}}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Se"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"ScheduledActionARN":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"Tags":{"shape":"S38"},"NextToken":{}}}},"DescribeTerminationPolicyTypes":{"output":{"resultWrapper":"DescribeTerminationPolicyTypesResult","type":"structure","members":{"TerminationPolicyTypes":{"shape":"S1g"}}}},"DetachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"DetachInstancesResult","type":"structure","members":{"Activities":{"shape":"S5d"}}}},"DetachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"DetachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"DetachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"DetachLoadBalancersResult","type":"structure","members":{}}},"DisableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S62"}}}},"EnableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName","Granularity"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S62"},"Granularity":{}}}},"EnterStandby":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"EnterStandbyResult","type":"structure","members":{"Activities":{"shape":"S5d"}}}},"ExecutePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"HonorCooldown":{"type":"boolean"},"MetricValue":{"type":"double"},"BreachThreshold":{"type":"double"}}}},"ExitStandby":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"ExitStandbyResult","type":"structure","members":{"Activities":{"shape":"S5d"}}}},"PutLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"RoleARN":{},"NotificationTargetARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{}}},"output":{"resultWrapper":"PutLifecycleHookResult","type":"structure","members":{}}},"PutNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN","NotificationTypes"],"members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationTypes":{"shape":"S3f"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S4n"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{},"StepAdjustments":{"shape":"S4q"},"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"shape":"S4w"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"PutScalingPolicyResult","type":"structure","members":{"PolicyARN":{},"Alarms":{"shape":"S4u"}}}},"PutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"RecordLifecycleActionHeartbeat":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"InstanceId":{}}},"output":{"resultWrapper":"RecordLifecycleActionHeartbeatResult","type":"structure","members":{}}},"ResumeProcesses":{"input":{"shape":"S6i"}},"SetDesiredCapacity":{"input":{"type":"structure","required":["AutoScalingGroupName","DesiredCapacity"],"members":{"AutoScalingGroupName":{},"DesiredCapacity":{"type":"integer"},"HonorCooldown":{"type":"boolean"}}}},"SetInstanceHealth":{"input":{"type":"structure","required":["InstanceId","HealthStatus"],"members":{"InstanceId":{},"HealthStatus":{},"ShouldRespectGracePeriod":{"type":"boolean"}}}},"SetInstanceProtection":{"input":{"type":"structure","required":["InstanceIds","AutoScalingGroupName","ProtectedFromScaleIn"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ProtectedFromScaleIn":{"type":"boolean"}}},"output":{"resultWrapper":"SetInstanceProtectionResult","type":"structure","members":{}}},"StartInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Strategy":{},"Preferences":{"type":"structure","members":{"MinHealthyPercentage":{"type":"integer"},"InstanceWarmup":{"type":"integer"}}}}},"output":{"resultWrapper":"StartInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"SuspendProcesses":{"input":{"shape":"S6i"}},"TerminateInstanceInAutoScalingGroup":{"input":{"type":"structure","required":["InstanceId","ShouldDecrementDesiredCapacity"],"members":{"InstanceId":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"TerminateInstanceInAutoScalingGroupResult","type":"structure","members":{"Activity":{"shape":"S5e"}}}},"UpdateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S1d"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S1g"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sg":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"ErrorCode":{},"ErrorMessage":{}}}},"S10":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"S12":{"type":"structure","members":{"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S10"},"Overrides":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{}}}}}},"InstancesDistribution":{"type":"structure","members":{"OnDemandAllocationStrategy":{},"OnDemandBaseCapacity":{"type":"integer"},"OnDemandPercentageAboveBaseCapacity":{"type":"integer"},"SpotAllocationStrategy":{},"SpotInstancePools":{"type":"integer"},"SpotMaxPrice":{}}}}},"S1d":{"type":"list","member":{}},"S1g":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S1w":{"type":"list","member":{}},"S1x":{"type":"list","member":{}},"S1z":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"VirtualName":{},"DeviceName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}},"NoDevice":{"type":"boolean"}}}},"S28":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S2w":{"type":"list","member":{}},"S38":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S3f":{"type":"list","member":{}},"S4n":{"type":"integer","deprecated":true},"S4q":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"S4u":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmARN":{}}}},"S4w":{"type":"structure","required":["TargetValue"],"members":{"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"}}},"S5d":{"type":"list","member":{"shape":"S5e"}},"S5e":{"type":"structure","required":["ActivityId","AutoScalingGroupName","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"AutoScalingGroupName":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Progress":{"type":"integer"},"Details":{}}},"S62":{"type":"list","member":{}},"S6i":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ScalingProcesses":{"type":"list","member":{}}}}}}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAutoScalingGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingGroups"},"DescribeAutoScalingInstances":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingInstances"},"DescribeLaunchConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"LaunchConfigurations"},"DescribeNotificationConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"NotificationConfigurations"},"DescribePolicies":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Activities"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScheduledUpdateGroupActions"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-25","endpointPrefix":"ce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Cost Explorer","serviceFullName":"AWS Cost Explorer Service","serviceId":"Cost Explorer","signatureVersion":"v4","signingName":"ce","targetPrefix":"AWSInsightsIndexService","uid":"ce-2017-10-25"},"operations":{"CreateCostCategoryDefinition":{"input":{"type":"structure","required":["Name","RuleVersion","Rules"],"members":{"Name":{},"RuleVersion":{},"Rules":{"shape":"S4"}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveStart":{}}}},"DeleteCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn"],"members":{"CostCategoryArn":{}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveEnd":{}}}},"DescribeCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn"],"members":{"CostCategoryArn":{},"EffectiveOn":{}}},"output":{"type":"structure","members":{"CostCategory":{"type":"structure","required":["CostCategoryArn","EffectiveStart","Name","RuleVersion","Rules"],"members":{"CostCategoryArn":{},"EffectiveStart":{},"EffectiveEnd":{},"Name":{},"RuleVersion":{},"Rules":{"shape":"S4"}}}}}},"GetCostAndUsage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"Su"},"GroupBy":{"shape":"Sw"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"Sw"},"ResultsByTime":{"shape":"S12"}}}},"GetCostAndUsageWithResources":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"Su"},"GroupBy":{"shape":"Sw"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"Sw"},"ResultsByTime":{"shape":"S12"}}}},"GetCostForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"Sr"},"Metric":{},"Granularity":{},"Filter":{"shape":"S7"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"S15"},"ForecastResultsByTime":{"shape":"S1j"}}}},"GetDimensionValues":{"input":{"type":"structure","required":["TimePeriod","Dimension"],"members":{"SearchString":{},"TimePeriod":{"shape":"Sr"},"Dimension":{},"Context":{},"NextPageToken":{}}},"output":{"type":"structure","required":["DimensionValues","ReturnSize","TotalSize"],"members":{"DimensionValues":{"type":"list","member":{"type":"structure","members":{"Value":{},"Attributes":{"shape":"S1s"}}}},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"},"NextPageToken":{}}}},"GetReservationCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"GroupBy":{"shape":"Sw"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"Su"},"NextPageToken":{}}},"output":{"type":"structure","required":["CoveragesByTime"],"members":{"CoveragesByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"Sr"},"Groups":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S1s"},"Coverage":{"shape":"S22"}}}},"Total":{"shape":"S22"}}}},"Total":{"shape":"S22"},"NextPageToken":{}}}},"GetReservationPurchaseRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"AccountId":{},"Service":{},"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S2k"},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{}}},"Recommendations":{"type":"list","member":{"type":"structure","members":{"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S2k"},"RecommendationDetails":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"InstanceDetails":{"type":"structure","members":{"EC2InstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"AvailabilityZone":{},"Platform":{},"Tenancy":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RDSInstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"DatabaseEngine":{},"DatabaseEdition":{},"DeploymentOption":{},"LicenseModel":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RedshiftInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ElastiCacheInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"ProductDescription":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ESInstanceDetails":{"type":"structure","members":{"InstanceClass":{},"InstanceSize":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}}}},"RecommendedNumberOfInstancesToPurchase":{},"RecommendedNormalizedUnitsToPurchase":{},"MinimumNumberOfInstancesUsedPerHour":{},"MinimumNormalizedUnitsUsedPerHour":{},"MaximumNumberOfInstancesUsedPerHour":{},"MaximumNormalizedUnitsUsedPerHour":{},"AverageNumberOfInstancesUsedPerHour":{},"AverageNormalizedUnitsUsedPerHour":{},"AverageUtilization":{},"EstimatedBreakEvenInMonths":{},"CurrencyCode":{},"EstimatedMonthlySavingsAmount":{},"EstimatedMonthlySavingsPercentage":{},"EstimatedMonthlyOnDemandCost":{},"EstimatedReservationCostForLookbackPeriod":{},"UpfrontCost":{},"RecurringStandardMonthlyCost":{}}}},"RecommendationSummary":{"type":"structure","members":{"TotalEstimatedMonthlySavingsAmount":{},"TotalEstimatedMonthlySavingsPercentage":{},"CurrencyCode":{}}}}}},"NextPageToken":{}}}},"GetReservationUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"GroupBy":{"shape":"Sw"},"Granularity":{},"Filter":{"shape":"S7"},"NextPageToken":{}}},"output":{"type":"structure","required":["UtilizationsByTime"],"members":{"UtilizationsByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"Sr"},"Groups":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Attributes":{"shape":"S1s"},"Utilization":{"shape":"S3a"}}}},"Total":{"shape":"S3a"}}}},"Total":{"shape":"S3a"},"NextPageToken":{}}}},"GetRightsizingRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"Filter":{"shape":"S7"},"Configuration":{"shape":"S3q"},"Service":{},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"LookbackPeriodInDays":{}}},"Summary":{"type":"structure","members":{"TotalRecommendationCount":{},"EstimatedTotalMonthlySavingsAmount":{},"SavingsCurrencyCode":{},"SavingsPercentage":{}}},"RightsizingRecommendations":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"CurrentInstance":{"type":"structure","members":{"ResourceId":{},"Tags":{"type":"list","member":{"shape":"Sf"}},"ResourceDetails":{"shape":"S3z"},"ResourceUtilization":{"shape":"S41"},"ReservationCoveredHoursInLookbackPeriod":{},"SavingsPlansCoveredHoursInLookbackPeriod":{},"OnDemandHoursInLookbackPeriod":{},"TotalRunningHoursInLookbackPeriod":{},"MonthlyCost":{},"CurrencyCode":{}}},"RightsizingType":{},"ModifyRecommendationDetail":{"type":"structure","members":{"TargetInstances":{"type":"list","member":{"type":"structure","members":{"EstimatedMonthlyCost":{},"EstimatedMonthlySavings":{},"CurrencyCode":{},"DefaultTargetInstance":{"type":"boolean"},"ResourceDetails":{"shape":"S3z"},"ExpectedResourceUtilization":{"shape":"S41"}}}}}},"TerminateRecommendationDetail":{"type":"structure","members":{"EstimatedMonthlySavings":{},"CurrencyCode":{}}}}}},"NextPageToken":{},"Configuration":{"shape":"S3q"}}}},"GetSavingsPlansCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"GroupBy":{"shape":"Sw"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"Su"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["SavingsPlansCoverages"],"members":{"SavingsPlansCoverages":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S1s"},"Coverage":{"type":"structure","members":{"SpendCoveredBySavingsPlans":{},"OnDemandCost":{},"TotalCost":{},"CoveragePercentage":{}}},"TimePeriod":{"shape":"Sr"}}}},"NextToken":{}}}},"GetSavingsPlansPurchaseRecommendation":{"input":{"type":"structure","required":["SavingsPlansType","TermInYears","PaymentOption","LookbackPeriodInDays"],"members":{"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"AccountScope":{},"NextPageToken":{},"PageSize":{"type":"integer"},"LookbackPeriodInDays":{},"Filter":{"shape":"S7"}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{}}},"SavingsPlansPurchaseRecommendation":{"type":"structure","members":{"AccountScope":{},"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"LookbackPeriodInDays":{},"SavingsPlansPurchaseRecommendationDetails":{"type":"list","member":{"type":"structure","members":{"SavingsPlansDetails":{"type":"structure","members":{"Region":{},"InstanceFamily":{},"OfferingId":{}}},"AccountId":{},"UpfrontCost":{},"EstimatedROI":{},"CurrencyCode":{},"EstimatedSPCost":{},"EstimatedOnDemandCost":{},"EstimatedOnDemandCostWithCurrentCommitment":{},"EstimatedSavingsAmount":{},"EstimatedSavingsPercentage":{},"HourlyCommitmentToPurchase":{},"EstimatedAverageUtilization":{},"EstimatedMonthlySavingsAmount":{},"CurrentMinimumHourlyOnDemandSpend":{},"CurrentMaximumHourlyOnDemandSpend":{},"CurrentAverageHourlyOnDemandSpend":{}}}},"SavingsPlansPurchaseRecommendationSummary":{"type":"structure","members":{"EstimatedROI":{},"CurrencyCode":{},"EstimatedTotalCost":{},"CurrentOnDemandSpend":{},"EstimatedSavingsAmount":{},"TotalRecommendationCount":{},"DailyCommitmentToPurchase":{},"HourlyCommitmentToPurchase":{},"EstimatedSavingsPercentage":{},"EstimatedMonthlySavingsAmount":{},"EstimatedOnDemandCostWithCurrentCommitment":{}}}}},"NextPageToken":{}}}},"GetSavingsPlansUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"Granularity":{},"Filter":{"shape":"S7"}}},"output":{"type":"structure","required":["Total"],"members":{"SavingsPlansUtilizationsByTime":{"type":"list","member":{"type":"structure","required":["TimePeriod","Utilization"],"members":{"TimePeriod":{"shape":"Sr"},"Utilization":{"shape":"S4r"},"Savings":{"shape":"S4s"},"AmortizedCommitment":{"shape":"S4t"}}}},"Total":{"shape":"S4u"}}}},"GetSavingsPlansUtilizationDetails":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"Sr"},"Filter":{"shape":"S7"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["SavingsPlansUtilizationDetails","TimePeriod"],"members":{"SavingsPlansUtilizationDetails":{"type":"list","member":{"type":"structure","members":{"SavingsPlanArn":{},"Attributes":{"shape":"S1s"},"Utilization":{"shape":"S4r"},"Savings":{"shape":"S4s"},"AmortizedCommitment":{"shape":"S4t"}}}},"Total":{"shape":"S4u"},"TimePeriod":{"shape":"Sr"},"NextToken":{}}}},"GetTags":{"input":{"type":"structure","required":["TimePeriod"],"members":{"SearchString":{},"TimePeriod":{"shape":"Sr"},"TagKey":{},"NextPageToken":{}}},"output":{"type":"structure","required":["Tags","ReturnSize","TotalSize"],"members":{"NextPageToken":{},"Tags":{"type":"list","member":{}},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"}}}},"GetUsageForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"Sr"},"Metric":{},"Granularity":{},"Filter":{"shape":"S7"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"S15"},"ForecastResultsByTime":{"shape":"S1j"}}}},"ListCostCategoryDefinitions":{"input":{"type":"structure","members":{"EffectiveOn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CostCategoryReferences":{"type":"list","member":{"type":"structure","members":{"CostCategoryArn":{},"Name":{},"EffectiveStart":{},"EffectiveEnd":{},"NumberOfRules":{"type":"integer"}}}},"NextToken":{}}}},"UpdateCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn","RuleVersion","Rules"],"members":{"CostCategoryArn":{},"RuleVersion":{},"Rules":{"shape":"S4"}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveStart":{}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Value","Rule"],"members":{"Value":{},"Rule":{"shape":"S7"}}}},"S7":{"type":"structure","members":{"Or":{"shape":"S8"},"And":{"shape":"S8"},"Not":{"shape":"S7"},"Dimensions":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}},"Tags":{"shape":"Sf"},"CostCategories":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"}}}}},"S8":{"type":"list","member":{"shape":"S7"}},"Sb":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}},"Sr":{"type":"structure","required":["Start","End"],"members":{"Start":{},"End":{}}},"Su":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","members":{"Type":{},"Key":{}}}},"S12":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"Sr"},"Total":{"shape":"S14"},"Groups":{"type":"list","member":{"type":"structure","members":{"Keys":{"type":"list","member":{}},"Metrics":{"shape":"S14"}}}},"Estimated":{"type":"boolean"}}}},"S14":{"type":"map","key":{},"value":{"shape":"S15"}},"S15":{"type":"structure","members":{"Amount":{},"Unit":{}}},"S1j":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"Sr"},"MeanValue":{},"PredictionIntervalLowerBound":{},"PredictionIntervalUpperBound":{}}}},"S1s":{"type":"map","key":{},"value":{}},"S22":{"type":"structure","members":{"CoverageHours":{"type":"structure","members":{"OnDemandHours":{},"ReservedHours":{},"TotalRunningHours":{},"CoverageHoursPercentage":{}}},"CoverageNormalizedUnits":{"type":"structure","members":{"OnDemandNormalizedUnits":{},"ReservedNormalizedUnits":{},"TotalRunningNormalizedUnits":{},"CoverageNormalizedUnitsPercentage":{}}},"CoverageCost":{"type":"structure","members":{"OnDemandCost":{}}}}},"S2k":{"type":"structure","members":{"EC2Specification":{"type":"structure","members":{"OfferingClass":{}}}}},"S3a":{"type":"structure","members":{"UtilizationPercentage":{},"UtilizationPercentageInUnits":{},"PurchasedHours":{},"PurchasedUnits":{},"TotalActualHours":{},"TotalActualUnits":{},"UnusedHours":{},"UnusedUnits":{},"OnDemandCostOfRIHoursUsed":{},"NetRISavings":{},"TotalPotentialRISavings":{},"AmortizedUpfrontFee":{},"AmortizedRecurringFee":{},"TotalAmortizedFee":{}}},"S3q":{"type":"structure","required":["RecommendationTarget","BenefitsConsidered"],"members":{"RecommendationTarget":{},"BenefitsConsidered":{"type":"boolean"}}},"S3z":{"type":"structure","members":{"EC2ResourceDetails":{"type":"structure","members":{"HourlyOnDemandRate":{},"InstanceType":{},"Platform":{},"Region":{},"Sku":{},"Memory":{},"NetworkPerformance":{},"Storage":{},"Vcpu":{}}}}},"S41":{"type":"structure","members":{"EC2ResourceUtilization":{"type":"structure","members":{"MaxCpuUtilizationPercentage":{},"MaxMemoryUtilizationPercentage":{},"MaxStorageUtilizationPercentage":{}}}}},"S4r":{"type":"structure","members":{"TotalCommitment":{},"UsedCommitment":{},"UnusedCommitment":{},"UtilizationPercentage":{}}},"S4s":{"type":"structure","members":{"NetSavings":{},"OnDemandCostEquivalent":{}}},"S4t":{"type":"structure","members":{"AmortizedRecurringCommitment":{},"AmortizedUpfrontCommitment":{},"TotalAmortizedCommitment":{}}},"S4u":{"type":"structure","required":["Utilization"],"members":{"Utilization":{"shape":"S4r"},"Savings":{"shape":"S4s"},"AmortizedCommitment":{"shape":"S4t"}}}}}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetSavingsPlansCoverage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetSavingsPlansUtilizationDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCostCategoryDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-15","endpointPrefix":"cloudformation","protocol":"query","serviceFullName":"AWS CloudFormation","serviceId":"CloudFormation","signatureVersion":"v4","uid":"cloudformation-2010-05-15","xmlNamespace":"http://cloudformation.amazonaws.com/doc/2010-05-15/"},"operations":{"CancelUpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"ClientRequestToken":{}}}},"ContinueUpdateRollback":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ResourcesToSkip":{"type":"list","member":{}},"ClientRequestToken":{}}},"output":{"resultWrapper":"ContinueUpdateRollbackResult","type":"structure","members":{}}},"CreateChangeSet":{"input":{"type":"structure","required":["StackName","ChangeSetName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ChangeSetName":{},"ClientToken":{},"Description":{},"ChangeSetType":{},"ResourcesToImport":{"type":"list","member":{"type":"structure","required":["ResourceType","LogicalResourceId","ResourceIdentifier"],"members":{"ResourceType":{},"LogicalResourceId":{},"ResourceIdentifier":{"type":"map","key":{},"value":{}}}}}}},"output":{"resultWrapper":"CreateChangeSetResult","type":"structure","members":{"Id":{},"StackId":{}}}},"CreateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"DisableRollback":{"type":"boolean"},"RollbackConfiguration":{"shape":"Sn"},"TimeoutInMinutes":{"type":"integer"},"NotificationARNs":{"shape":"St"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"OnFailure":{},"StackPolicyBody":{},"StackPolicyURL":{},"Tags":{"shape":"Sv"},"ClientRequestToken":{},"EnableTerminationProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateStackResult","type":"structure","members":{"StackId":{}}}},"CreateStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1m"},"DeploymentTargets":{"shape":"S1o"},"Regions":{"shape":"S1r"},"ParameterOverrides":{"shape":"Se"},"OperationPreferences":{"shape":"S1t"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"CreateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"PermissionModel":{},"AutoDeployment":{"shape":"S22"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackSetResult","type":"structure","members":{"StackSetId":{}}}},"DeleteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{}}},"output":{"resultWrapper":"DeleteChangeSetResult","type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RetainResources":{"type":"list","member":{}},"RoleARN":{},"ClientRequestToken":{}}}},"DeleteStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions","RetainStacks"],"members":{"StackSetName":{},"Accounts":{"shape":"S1m"},"DeploymentTargets":{"shape":"S1o"},"Regions":{"shape":"S1r"},"OperationPreferences":{"shape":"S1t"},"RetainStacks":{"type":"boolean"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"DeleteStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"DeleteStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DeleteStackSetResult","type":"structure","members":{}}},"DeregisterType":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{}}},"output":{"resultWrapper":"DeregisterTypeResult","type":"structure","members":{}},"idempotent":true},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"integer"}}}},"NextToken":{}}}},"DescribeChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeChangeSetResult","type":"structure","members":{"ChangeSetName":{},"ChangeSetId":{},"StackId":{},"StackName":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"ExecutionStatus":{},"Status":{},"StatusReason":{},"NotificationARNs":{"shape":"St"},"RollbackConfiguration":{"shape":"Sn"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"Changes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ResourceChange":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"ChangeSource":{},"CausingEntity":{}}}}}}}}},"NextToken":{}}}},"DescribeStackDriftDetectionStatus":{"input":{"type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}},"output":{"resultWrapper":"DescribeStackDriftDetectionStatusResult","type":"structure","required":["StackId","StackDriftDetectionId","DetectionStatus","Timestamp"],"members":{"StackId":{},"StackDriftDetectionId":{},"StackDriftStatus":{},"DetectionStatus":{},"DetectionStatusReason":{},"DriftedStackResourceCount":{"type":"integer"},"Timestamp":{"type":"timestamp"}}}},"DescribeStackEvents":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStackEventsResult","type":"structure","members":{"StackEvents":{"type":"list","member":{"type":"structure","required":["StackId","EventId","StackName","Timestamp"],"members":{"StackId":{},"EventId":{},"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"ResourceProperties":{},"ClientRequestToken":{}}}},"NextToken":{}}}},"DescribeStackInstance":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion"],"members":{"StackSetName":{},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"DescribeStackInstanceResult","type":"structure","members":{"StackInstance":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"ParameterOverrides":{"shape":"Se"},"Status":{},"StatusReason":{},"OrganizationalUnitId":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"}}}}}},"DescribeStackResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourceResult","type":"structure","members":{"StackResourceDetail":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"Metadata":{},"DriftInformation":{"shape":"S46"}}}}}},"DescribeStackResourceDrifts":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackResourceDriftStatusFilters":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeStackResourceDriftsResult","type":"structure","required":["StackResourceDrifts"],"members":{"StackResourceDrifts":{"type":"list","member":{"shape":"S4d"}},"NextToken":{}}}},"DescribeStackResources":{"input":{"type":"structure","members":{"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourcesResult","type":"structure","members":{"StackResources":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","Timestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"DriftInformation":{"shape":"S46"}}}}}}},"DescribeStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DescribeStackSetResult","type":"structure","members":{"StackSet":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"TemplateBody":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"StackSetARN":{},"AdministrationRoleARN":{},"ExecutionRoleName":{},"StackSetDriftDetectionDetails":{"shape":"S4x"},"AutoDeployment":{"shape":"S22"},"PermissionModel":{},"OrganizationalUnitIds":{"shape":"S1p"}}}}}},"DescribeStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"DescribeStackSetOperationResult","type":"structure","members":{"StackSetOperation":{"type":"structure","members":{"OperationId":{},"StackSetId":{},"Action":{},"Status":{},"OperationPreferences":{"shape":"S1t"},"RetainStacks":{"type":"boolean"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"},"DeploymentTargets":{"shape":"S1o"},"StackSetDriftDetectionDetails":{"shape":"S4x"}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStacksResult","type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"ChangeSetId":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RollbackConfiguration":{"shape":"Sn"},"StackStatus":{},"StackStatusReason":{},"DisableRollback":{"type":"boolean"},"NotificationARNs":{"shape":"St"},"TimeoutInMinutes":{"type":"integer"},"Capabilities":{"shape":"Sj"},"Outputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{},"ExportName":{}}}},"RoleARN":{},"Tags":{"shape":"Sv"},"EnableTerminationProtection":{"type":"boolean"},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeType":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"Arn":{},"VersionId":{}}},"output":{"resultWrapper":"DescribeTypeResult","type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"DefaultVersionId":{},"IsDefaultVersion":{"type":"boolean"},"Description":{},"Schema":{},"ProvisioningType":{},"DeprecatedStatus":{},"LoggingConfig":{"shape":"S5w"},"ExecutionRoleArn":{},"Visibility":{},"SourceUrl":{},"DocumentationUrl":{},"LastUpdated":{"type":"timestamp"},"TimeCreated":{"type":"timestamp"}}},"idempotent":true},"DescribeTypeRegistration":{"input":{"type":"structure","required":["RegistrationToken"],"members":{"RegistrationToken":{}}},"output":{"resultWrapper":"DescribeTypeRegistrationResult","type":"structure","members":{"ProgressStatus":{},"Description":{},"TypeArn":{},"TypeVersionArn":{}}},"idempotent":true},"DetectStackDrift":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"LogicalResourceIds":{"shape":"S66"}}},"output":{"resultWrapper":"DetectStackDriftResult","type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}}},"DetectStackResourceDrift":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DetectStackResourceDriftResult","type":"structure","required":["StackResourceDrift"],"members":{"StackResourceDrift":{"shape":"S4d"}}}},"DetectStackSetDrift":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"OperationPreferences":{"shape":"S1t"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"DetectStackSetDriftResult","type":"structure","members":{"OperationId":{}}}},"EstimateTemplateCost":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"}}},"output":{"resultWrapper":"EstimateTemplateCostResult","type":"structure","members":{"Url":{}}}},"ExecuteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"ExecuteChangeSetResult","type":"structure","members":{}}},"GetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{}}},"output":{"resultWrapper":"GetStackPolicyResult","type":"structure","members":{"StackPolicyBody":{}}}},"GetTemplate":{"input":{"type":"structure","members":{"StackName":{},"ChangeSetName":{},"TemplateStage":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"TemplateBody":{},"StagesAvailable":{"type":"list","member":{}}}}},"GetTemplateSummary":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"StackName":{},"StackSetName":{}}},"output":{"resultWrapper":"GetTemplateSummaryResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"NoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"ResourceTypes":{"shape":"Sl"},"Version":{},"Metadata":{},"DeclaredTransforms":{"shape":"S6z"},"ResourceIdentifierSummaries":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"LogicalResourceIds":{"shape":"S66"},"ResourceIdentifiers":{"type":"list","member":{}}}}}}}},"ListChangeSets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListChangeSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackId":{},"StackName":{},"ChangeSetId":{},"ChangeSetName":{},"ExecutionStatus":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListExportsResult","type":"structure","members":{"Exports":{"type":"list","member":{"type":"structure","members":{"ExportingStackId":{},"Name":{},"Value":{}}}},"NextToken":{}}}},"ListImports":{"input":{"type":"structure","required":["ExportName"],"members":{"ExportName":{},"NextToken":{}}},"output":{"resultWrapper":"ListImportsResult","type":"structure","members":{"Imports":{"type":"list","member":{}},"NextToken":{}}}},"ListStackInstances":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"ListStackInstancesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{},"OrganizationalUnitId":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackResources":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListStackResourcesResult","type":"structure","members":{"StackResourceSummaries":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"DriftInformation":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"ListStackSetOperationResults":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationResultsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"Status":{},"StatusReason":{},"AccountGateResult":{"type":"structure","members":{"Status":{},"StatusReason":{}}},"OrganizationalUnitId":{}}}},"NextToken":{}}}},"ListStackSetOperations":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Action":{},"Status":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{}}},"output":{"resultWrapper":"ListStackSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"AutoDeployment":{"shape":"S22"},"PermissionModel":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStacks":{"input":{"type":"structure","members":{"NextToken":{},"StackStatusFilter":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListStacksResult","type":"structure","members":{"StackSummaries":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"TemplateDescription":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"StackStatus":{},"StackStatusReason":{},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"ListTypeRegistrations":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"TypeArn":{},"RegistrationStatusFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListTypeRegistrationsResult","type":"structure","members":{"RegistrationTokenList":{"type":"list","member":{}},"NextToken":{}}},"idempotent":true},"ListTypeVersions":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"Arn":{},"MaxResults":{"type":"integer"},"NextToken":{},"DeprecatedStatus":{}}},"output":{"resultWrapper":"ListTypeVersionsResult","type":"structure","members":{"TypeVersionSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"TypeName":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"Arn":{},"TimeCreated":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}},"idempotent":true},"ListTypes":{"input":{"type":"structure","members":{"Visibility":{},"ProvisioningType":{},"DeprecatedStatus":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListTypesResult","type":"structure","members":{"TypeSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"TypeName":{},"DefaultVersionId":{},"TypeArn":{},"LastUpdated":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}},"idempotent":true},"RecordHandlerProgress":{"input":{"type":"structure","required":["BearerToken","OperationStatus"],"members":{"BearerToken":{},"OperationStatus":{},"CurrentOperationStatus":{},"StatusMessage":{},"ErrorCode":{},"ResourceModel":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RecordHandlerProgressResult","type":"structure","members":{}},"idempotent":true},"RegisterType":{"input":{"type":"structure","required":["TypeName","SchemaHandlerPackage"],"members":{"Type":{},"TypeName":{},"SchemaHandlerPackage":{},"LoggingConfig":{"shape":"S5w"},"ExecutionRoleArn":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RegisterTypeResult","type":"structure","members":{"RegistrationToken":{}}},"idempotent":true},"SetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackPolicyBody":{},"StackPolicyURL":{}}}},"SetTypeDefaultVersion":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{}}},"output":{"resultWrapper":"SetTypeDefaultVersionResult","type":"structure","members":{}},"idempotent":true},"SignalResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId","UniqueId","Status"],"members":{"StackName":{},"LogicalResourceId":{},"UniqueId":{},"Status":{}}}},"StopStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"StopStackSetOperationResult","type":"structure","members":{}}},"UpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"StackPolicyDuringUpdateBody":{},"StackPolicyDuringUpdateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"StackPolicyBody":{},"StackPolicyURL":{},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ClientRequestToken":{}}},"output":{"resultWrapper":"UpdateStackResult","type":"structure","members":{"StackId":{}}}},"UpdateStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1m"},"DeploymentTargets":{"shape":"S1o"},"Regions":{"shape":"S1r"},"ParameterOverrides":{"shape":"Se"},"OperationPreferences":{"shape":"S1t"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"UpdateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"UpdateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"OperationPreferences":{"shape":"S1t"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"DeploymentTargets":{"shape":"S1o"},"PermissionModel":{},"AutoDeployment":{"shape":"S22"},"OperationId":{"idempotencyToken":true},"Accounts":{"shape":"S1m"},"Regions":{"shape":"S1r"}}},"output":{"resultWrapper":"UpdateStackSetResult","type":"structure","members":{"OperationId":{}}}},"UpdateTerminationProtection":{"input":{"type":"structure","required":["EnableTerminationProtection","StackName"],"members":{"EnableTerminationProtection":{"type":"boolean"},"StackName":{}}},"output":{"resultWrapper":"UpdateTerminationProtectionResult","type":"structure","members":{"StackId":{}}}},"ValidateTemplate":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{}}},"output":{"resultWrapper":"ValidateTemplateResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"NoEcho":{"type":"boolean"},"Description":{}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"DeclaredTransforms":{"shape":"S6z"}}}}},"shapes":{"Se":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"ParameterValue":{},"UsePreviousValue":{"type":"boolean"},"ResolvedValue":{}}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"RollbackTriggers":{"type":"list","member":{"type":"structure","required":["Arn","Type"],"members":{"Arn":{},"Type":{}}}},"MonitoringTimeInMinutes":{"type":"integer"}}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1m":{"type":"list","member":{}},"S1o":{"type":"structure","members":{"Accounts":{"shape":"S1m"},"OrganizationalUnitIds":{"shape":"S1p"}}},"S1p":{"type":"list","member":{}},"S1r":{"type":"list","member":{}},"S1t":{"type":"structure","members":{"RegionOrder":{"shape":"S1r"},"FailureToleranceCount":{"type":"integer"},"FailureTolerancePercentage":{"type":"integer"},"MaxConcurrentCount":{"type":"integer"},"MaxConcurrentPercentage":{"type":"integer"}}},"S22":{"type":"structure","members":{"Enabled":{"type":"boolean"},"RetainStacksOnAccountRemoval":{"type":"boolean"}}},"S46":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"S4d":{"type":"structure","required":["StackId","LogicalResourceId","ResourceType","StackResourceDriftStatus","Timestamp"],"members":{"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"PhysicalResourceIdContext":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"ResourceType":{},"ExpectedProperties":{},"ActualProperties":{},"PropertyDifferences":{"type":"list","member":{"type":"structure","required":["PropertyPath","ExpectedValue","ActualValue","DifferenceType"],"members":{"PropertyPath":{},"ExpectedValue":{},"ActualValue":{},"DifferenceType":{}}}},"StackResourceDriftStatus":{},"Timestamp":{"type":"timestamp"}}},"S4x":{"type":"structure","members":{"DriftStatus":{},"DriftDetectionStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"TotalStackInstancesCount":{"type":"integer"},"DriftedStackInstancesCount":{"type":"integer"},"InSyncStackInstancesCount":{"type":"integer"},"InProgressStackInstancesCount":{"type":"integer"},"FailedStackInstancesCount":{"type":"integer"}}},"S5w":{"type":"structure","required":["LogRoleArn","LogGroupName"],"members":{"LogRoleArn":{},"LogGroupName":{}}},"S66":{"type":"list","member":{}},"S6z":{"type":"list","member":{}}}}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccountLimits":{"input_token":"NextToken","output_token":"NextToken","result_key":"AccountLimits"},"DescribeStackEvents":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackEvents"},"DescribeStackResourceDrifts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribeStackResources":{"result_key":"StackResources"},"DescribeStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"Stacks"},"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","result_key":"Summaries"},"ListExports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Exports"},"ListImports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Imports"},"ListStackInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackResources":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackResourceSummaries"},"ListStackSetOperationResults":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackSetOperations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackSets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackSummaries"},"ListTypeRegistrations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTypeVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StackExists":{"delay":5,"operation":"DescribeStacks","maxAttempts":20,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"ValidationError","state":"retry"}]},"StackCreateComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is CREATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"CREATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackDeleteComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is DELETE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ValidationError","matcher":"error","state":"success"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"}]},"StackUpdateComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is UPDATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackImportComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is IMPORT_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"IMPORT_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"IMPORT_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"IMPORT_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"IMPORT_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackRollbackComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is UPDATE_ROLLBACK_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"ChangeSetCreateComplete":{"delay":30,"operation":"DescribeChangeSet","maxAttempts":120,"description":"Wait until change set status is CREATE_COMPLETE.","acceptors":[{"argument":"Status","expected":"CREATE_COMPLETE","matcher":"path","state":"success"},{"argument":"Status","expected":"FAILED","matcher":"path","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"TypeRegistrationComplete":{"delay":30,"operation":"DescribeTypeRegistration","maxAttempts":120,"description":"Wait until type registration is COMPLETE.","acceptors":[{"argument":"ProgressStatus","expected":"COMPLETE","matcher":"path","state":"success"},{"argument":"ProgressStatus","expected":"FAILED","matcher":"path","state":"failure"}]}}}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2016-11-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2016-11-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2016-11-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2016-11-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2016-11-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2016-11-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2016-11-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2016-11-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","output_token":"DistributionList.NextMarker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","output_token":"InvalidationList.NextMarker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","output_token":"StreamingDistributionList.NextMarker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-03-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-03-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-03-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-03-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-03-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-03-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteServiceLinkedRole":{"http":{"method":"DELETE","requestUri":"/2017-03-25/service-linked-role/{RoleName}","responseCode":204},"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{"location":"uri","locationName":"RoleName"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-03-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-03-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3b":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-30","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-10-30"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-10-30/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-10-30/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-10-30/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2017-10-30/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2017-10-30/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2017-10-30/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-10-30/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-10-30/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2017-10-30/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-10-30/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-10-30/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-18","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-06-18"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-06-18/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-06-18/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-06-18/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-06-18/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-06-18/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-06-18/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-06-18/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-06-18/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-06-18/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-06-18/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-06-18/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-05","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-11-05"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-11-05/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-11-05/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-11-05/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2b"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-11-05/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-11-05/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S34","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-11-05/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-11-05/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-11-05/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3e"},"Tags":{"shape":"S2b"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-11-05/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3a"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-11-05/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2w"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-11-05/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2b"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2b","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1s":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1w":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S22":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"DistributionConfig":{"shape":"S7"}}},"S24":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2b":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2i":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}},"S2j":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2n":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2i"}}},"S2v":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2w"}}},"S2w":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S32":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2v"}}},"S34":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S38":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S34"}}},"S3a":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3c":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3a"}}},"S3e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"StreamingDistributionConfig":{"shape":"S3e"}}},"S4p":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-03-26","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2019-03-26"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2019-03-26/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2019-03-26/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2019-03-26/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2f"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2019-03-26/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2019-03-26/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S38","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2019-03-26/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2019-03-26/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2019-03-26/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3i"},"Tags":{"shape":"S2f"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2019-03-26/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2019-03-26/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S30"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2019-03-26/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2f"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2f","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{"type":"string","sensitive":true},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}},"ConnectionAttempts":{"type":"integer"},"ConnectionTimeout":{"type":"integer"}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1t":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1x":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S23":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"DistributionConfig":{"shape":"S7"},"AliasICPRecordals":{"shape":"S2a"}}},"S25":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2a":{"type":"list","member":{"locationName":"AliasICPRecordal","type":"structure","members":{"CNAME":{},"ICPRecordalStatus":{}}}},"S2f":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2m":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}},"S2n":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2r":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2x":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2m"}}},"S2z":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S30"}}},"S30":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S36":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2z"}}},"S38":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S3c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S38"}}},"S3e":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3g":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3e"}}},"S3i":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3j":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3m":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"StreamingDistributionConfig":{"shape":"S3i"}}},"S4t":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"AliasICPRecordals":{"shape":"S2a"}}}}}}}}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":35,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-30","endpointPrefix":"cloudhsm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM","serviceFullName":"Amazon CloudHSM","serviceId":"CloudHSM","signatureVersion":"v4","targetPrefix":"CloudHsmFrontendService","uid":"cloudhsm-2014-05-30"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S3"}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"CreateHapg":{"input":{"type":"structure","required":["Label"],"members":{"Label":{}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"CreateHsm":{"input":{"type":"structure","required":["SubnetId","SshKey","IamRoleArn","SubscriptionType"],"members":{"SubnetId":{"locationName":"SubnetId"},"SshKey":{"locationName":"SshKey"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SubscriptionType":{"locationName":"SubscriptionType"},"ClientToken":{"locationName":"ClientToken"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"CreateHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"CreateLunaClient":{"input":{"type":"structure","required":["Certificate"],"members":{"Label":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"DeleteHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"}},"locationName":"DeleteHsmRequest"},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteLunaClient":{"input":{"type":"structure","required":["ClientArn"],"members":{"ClientArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DescribeHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","members":{"HapgArn":{},"HapgSerial":{},"HsmsLastActionFailed":{"shape":"Sz"},"HsmsPendingDeletion":{"shape":"Sz"},"HsmsPendingRegistration":{"shape":"Sz"},"Label":{},"LastModifiedTimestamp":{},"PartitionSerialList":{"shape":"S11"},"State":{}}}},"DescribeHsm":{"input":{"type":"structure","members":{"HsmArn":{},"HsmSerialNumber":{}}},"output":{"type":"structure","members":{"HsmArn":{},"Status":{},"StatusDetails":{},"AvailabilityZone":{},"EniId":{},"EniIp":{},"SubscriptionType":{},"SubscriptionStartDate":{},"SubscriptionEndDate":{},"VpcId":{},"SubnetId":{},"IamRoleArn":{},"SerialNumber":{},"VendorName":{},"HsmType":{},"SoftwareVersion":{},"SshPublicKey":{},"SshKeyLastUpdated":{},"ServerCertUri":{},"ServerCertLastUpdated":{},"Partitions":{"type":"list","member":{}}}}},"DescribeLunaClient":{"input":{"type":"structure","members":{"ClientArn":{},"CertificateFingerprint":{}}},"output":{"type":"structure","members":{"ClientArn":{},"Certificate":{},"CertificateFingerprint":{},"LastModifiedTimestamp":{},"Label":{}}}},"GetConfig":{"input":{"type":"structure","required":["ClientArn","ClientVersion","HapgList"],"members":{"ClientArn":{},"ClientVersion":{},"HapgList":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ConfigType":{},"ConfigFile":{},"ConfigCred":{}}}},"ListAvailableZones":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AZList":{"type":"list","member":{}}}}},"ListHapgs":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["HapgList"],"members":{"HapgList":{"shape":"S1i"},"NextToken":{}}}},"ListHsms":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"HsmList":{"shape":"Sz"},"NextToken":{}}}},"ListLunaClients":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["ClientList"],"members":{"ClientList":{"type":"list","member":{}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S3"}}}},"ModifyHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{},"Label":{},"PartitionSerialList":{"shape":"S11"}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"ModifyHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"},"SubnetId":{"locationName":"SubnetId"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"ModifyHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"ModifyLunaClient":{"input":{"type":"structure","required":["ClientArn","Certificate"],"members":{"ClientArn":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1i":{"type":"list","member":{}}}}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-11-01","endpointPrefix":"cloudtrail","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudTrail","serviceFullName":"AWS CloudTrail","serviceId":"CloudTrail","signatureVersion":"v4","targetPrefix":"com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101","uid":"cloudtrail-2013-11-01"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateTrail":{"input":{"type":"structure","required":["Name","S3BucketName"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true},"DeleteTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeTrails":{"input":{"type":"structure","members":{"trailNameList":{"type":"list","member":{}},"includeShadowTrails":{"type":"boolean"}}},"output":{"type":"structure","members":{"trailList":{"type":"list","member":{"shape":"Sf"}}}},"idempotent":true},"GetEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"GetInsightSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"InsightSelectors":{"shape":"Sr"}}},"idempotent":true},"GetTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Trail":{"shape":"Sf"}}},"idempotent":true},"GetTrailStatus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"IsLogging":{"type":"boolean"},"LatestDeliveryError":{},"LatestNotificationError":{},"LatestDeliveryTime":{"type":"timestamp"},"LatestNotificationTime":{"type":"timestamp"},"StartLoggingTime":{"type":"timestamp"},"StopLoggingTime":{"type":"timestamp"},"LatestCloudWatchLogsDeliveryError":{},"LatestCloudWatchLogsDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryError":{},"LatestDeliveryAttemptTime":{},"LatestNotificationAttemptTime":{},"LatestNotificationAttemptSucceeded":{},"LatestDeliveryAttemptSucceeded":{},"TimeLoggingStarted":{},"TimeLoggingStopped":{}}},"idempotent":true},"ListPublicKeys":{"input":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"blob"},"ValidityStartTime":{"type":"timestamp"},"ValidityEndTime":{"type":"timestamp"},"Fingerprint":{}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"input":{"type":"structure","required":["ResourceIdList"],"members":{"ResourceIdList":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceTagList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"TagsList":{"shape":"S3"}}}},"NextToken":{}}},"idempotent":true},"ListTrails":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Trails":{"type":"list","member":{"type":"structure","members":{"TrailARN":{},"Name":{},"HomeRegion":{}}}},"NextToken":{}}},"idempotent":true},"LookupEvents":{"input":{"type":"structure","members":{"LookupAttributes":{"type":"list","member":{"type":"structure","required":["AttributeKey","AttributeValue"],"members":{"AttributeKey":{},"AttributeValue":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EventCategory":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventName":{},"ReadOnly":{},"AccessKeyId":{},"EventTime":{"type":"timestamp"},"EventSource":{},"Username":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceName":{}}}},"CloudTrailEvent":{}}}},"NextToken":{}}},"idempotent":true},"PutEventSelectors":{"input":{"type":"structure","required":["TrailName","EventSelectors"],"members":{"TrailName":{},"EventSelectors":{"shape":"Si"}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"PutInsightSelectors":{"input":{"type":"structure","required":["TrailName","InsightSelectors"],"members":{"TrailName":{},"InsightSelectors":{"shape":"Sr"}}},"output":{"type":"structure","members":{"TrailARN":{},"InsightSelectors":{"shape":"Sr"}}},"idempotent":true},"RemoveTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"StopLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"HomeRegion":{},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"HasCustomEventSelectors":{"type":"boolean"},"HasInsightSelectors":{"type":"boolean"},"IsOrganizationTrail":{"type":"boolean"}}},"Si":{"type":"list","member":{"type":"structure","members":{"ReadWriteType":{},"IncludeManagementEvents":{"type":"boolean"},"DataResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Values":{"type":"list","member":{}}}}},"ExcludeManagementEventSources":{"type":"list","member":{}}}}},"Sr":{"type":"list","member":{"type":"structure","members":{"InsightType":{}}}}}}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeTrails":{"result_key":"trailList"},"ListPublicKeys":{"input_token":"NextToken","output_token":"NextToken","result_key":"PublicKeyList"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","result_key":"ResourceTagList"},"ListTrails":{"input_token":"NextToken","output_token":"NextToken","result_key":"Trails"},"LookupEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"}}}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-10-06","endpointPrefix":"codebuild","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS CodeBuild","serviceId":"CodeBuild","signatureVersion":"v4","targetPrefix":"CodeBuild_20161006","uid":"codebuild-2016-10-06"},"operations":{"BatchDeleteBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"buildsDeleted":{"shape":"S2"},"buildsNotDeleted":{"type":"list","member":{"type":"structure","members":{"id":{},"statusCode":{}}}}}}},"BatchGetBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"builds":{"type":"list","member":{"shape":"Sb"}},"buildsNotFound":{"shape":"S2"}}}},"BatchGetProjects":{"input":{"type":"structure","required":["names"],"members":{"names":{"shape":"S1q"}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"S1t"}},"projectsNotFound":{"shape":"S1q"}}}},"BatchGetReportGroups":{"input":{"type":"structure","required":["reportGroupArns"],"members":{"reportGroupArns":{"shape":"S2e"}}},"output":{"type":"structure","members":{"reportGroups":{"type":"list","member":{"shape":"S2h"}},"reportGroupsNotFound":{"shape":"S2e"}}}},"BatchGetReports":{"input":{"type":"structure","required":["reportArns"],"members":{"reportArns":{"shape":"S2p"}}},"output":{"type":"structure","members":{"reports":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"name":{},"reportGroupArn":{},"executionId":{},"status":{},"created":{"type":"timestamp"},"expired":{"type":"timestamp"},"exportConfig":{"shape":"S2k"},"truncated":{"type":"boolean"},"testSummary":{"type":"structure","required":["total","statusCounts","durationInNanoSeconds"],"members":{"total":{"type":"integer"},"statusCounts":{"type":"map","key":{},"value":{"type":"integer"}},"durationInNanoSeconds":{"type":"long"}}}}}},"reportsNotFound":{"shape":"S2p"}}}},"CreateProject":{"input":{"type":"structure","required":["name","source","artifacts","environment","serviceRole"],"members":{"name":{},"description":{},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"S1w"},"secondaryArtifacts":{"shape":"S20"},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S22"},"vpcConfig":{"shape":"S1f"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S2c"},"fileSystemLocations":{"shape":"S1m"}}},"output":{"type":"structure","members":{"project":{"shape":"S1t"}}}},"CreateReportGroup":{"input":{"type":"structure","required":["name","type","exportConfig"],"members":{"name":{},"type":{},"exportConfig":{"shape":"S2k"},"tags":{"shape":"S22"}}},"output":{"type":"structure","members":{"reportGroup":{"shape":"S2h"}}}},"CreateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"filterGroups":{"shape":"S27"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S26"}}}},"DeleteProject":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteReport":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteReportGroup":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteSourceCredentials":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"arn":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"DescribeTestCases":{"input":{"type":"structure","required":["reportArn"],"members":{"reportArn":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"status":{}}}}},"output":{"type":"structure","members":{"nextToken":{},"testCases":{"type":"list","member":{"type":"structure","members":{"reportArn":{},"testRawDataPath":{},"prefix":{},"name":{},"status":{},"durationInNanoSeconds":{"type":"long"},"message":{},"expired":{"type":"timestamp"}}}}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"policy":{}}}},"ImportSourceCredentials":{"input":{"type":"structure","required":["token","serverType","authType"],"members":{"username":{},"token":{"type":"string","sensitive":true},"serverType":{},"authType":{},"shouldOverwrite":{"type":"boolean"}}},"output":{"type":"structure","members":{"arn":{}}}},"InvalidateProjectCache":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"ListBuilds":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListBuildsForProject":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListCuratedEnvironmentImages":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"platforms":{"type":"list","member":{"type":"structure","members":{"platform":{},"languages":{"type":"list","member":{"type":"structure","members":{"language":{},"images":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"versions":{"type":"list","member":{}}}}}}}}}}}}}},"ListProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"shape":"S1q"}}}},"ListReportGroups":{"input":{"type":"structure","members":{"sortOrder":{},"sortBy":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"reportGroups":{"shape":"S2e"}}}},"ListReports":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"shape":"S4g"}}},"output":{"type":"structure","members":{"nextToken":{},"reports":{"shape":"S2p"}}}},"ListReportsForReportGroup":{"input":{"type":"structure","required":["reportGroupArn"],"members":{"reportGroupArn":{},"nextToken":{},"sortOrder":{},"maxResults":{"type":"integer"},"filter":{"shape":"S4g"}}},"output":{"type":"structure","members":{"nextToken":{},"reports":{"shape":"S2p"}}}},"ListSharedProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"type":"list","member":{}}}}},"ListSharedReportGroups":{"input":{"type":"structure","members":{"sortOrder":{},"sortBy":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"reportGroups":{"shape":"S2e"}}}},"ListSourceCredentials":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"sourceCredentialsInfos":{"type":"list","member":{"type":"structure","members":{"arn":{},"serverType":{},"authType":{}}}}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["policy","resourceArn"],"members":{"policy":{},"resourceArn":{}}},"output":{"type":"structure","members":{"resourceArn":{}}}},"StartBuild":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"secondarySourcesOverride":{"shape":"Sr"},"secondarySourcesVersionOverride":{"shape":"Ss"},"sourceVersion":{},"artifactsOverride":{"shape":"S1w"},"secondaryArtifactsOverride":{"shape":"S20"},"environmentVariablesOverride":{"shape":"S13"},"sourceTypeOverride":{},"sourceLocationOverride":{},"sourceAuthOverride":{"shape":"Sp"},"gitCloneDepthOverride":{"type":"integer"},"gitSubmodulesConfigOverride":{"shape":"Sn"},"buildspecOverride":{},"insecureSslOverride":{"type":"boolean"},"reportBuildStatusOverride":{"type":"boolean"},"environmentTypeOverride":{},"imageOverride":{},"computeTypeOverride":{},"certificateOverride":{},"cacheOverride":{"shape":"Sw"},"serviceRoleOverride":{},"privilegedModeOverride":{"type":"boolean"},"timeoutInMinutesOverride":{"type":"integer"},"queuedTimeoutInMinutesOverride":{"type":"integer"},"encryptionKeyOverride":{},"idempotencyToken":{},"logsConfigOverride":{"shape":"S2c"},"registryCredentialOverride":{"shape":"S16"},"imagePullCredentialsTypeOverride":{}}},"output":{"type":"structure","members":{"build":{"shape":"Sb"}}}},"StopBuild":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"build":{"shape":"Sb"}}}},"UpdateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"S1w"},"secondaryArtifacts":{"shape":"S20"},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S22"},"vpcConfig":{"shape":"S1f"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S2c"},"fileSystemLocations":{"shape":"S1m"}}},"output":{"type":"structure","members":{"project":{"shape":"S1t"}}}},"UpdateReportGroup":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"exportConfig":{"shape":"S2k"},"tags":{"shape":"S22"}}},"output":{"type":"structure","members":{"reportGroup":{"shape":"S2h"}}}},"UpdateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"rotateSecret":{"type":"boolean"},"filterGroups":{"shape":"S27"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S26"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Sb":{"type":"structure","members":{"id":{},"arn":{},"buildNumber":{"type":"long"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"currentPhase":{},"buildStatus":{},"sourceVersion":{},"resolvedSourceVersion":{},"projectName":{},"phases":{"type":"list","member":{"type":"structure","members":{"phaseType":{},"phaseStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"durationInSeconds":{"type":"long"},"contexts":{"type":"list","member":{"type":"structure","members":{"statusCode":{},"message":{}}}}}}},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"Su"},"secondaryArtifacts":{"type":"list","member":{"shape":"Su"}},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"logs":{"type":"structure","members":{"groupName":{},"streamName":{},"deepLink":{},"s3DeepLink":{},"cloudWatchLogsArn":{},"s3LogsArn":{},"cloudWatchLogs":{"shape":"S1a"},"s3Logs":{"shape":"S1c"}}},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"buildComplete":{"type":"boolean"},"initiator":{},"vpcConfig":{"shape":"S1f"},"networkInterface":{"type":"structure","members":{"subnetId":{},"networkInterfaceId":{}}},"encryptionKey":{},"exportedEnvironmentVariables":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"reportArns":{"type":"list","member":{}},"fileSystemLocations":{"shape":"S1m"}}},"Sk":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"gitCloneDepth":{"type":"integer"},"gitSubmodulesConfig":{"shape":"Sn"},"buildspec":{},"auth":{"shape":"Sp"},"reportBuildStatus":{"type":"boolean"},"insecureSsl":{"type":"boolean"},"sourceIdentifier":{}}},"Sn":{"type":"structure","required":["fetchSubmodules"],"members":{"fetchSubmodules":{"type":"boolean"}}},"Sp":{"type":"structure","required":["type"],"members":{"type":{},"resource":{}}},"Sr":{"type":"list","member":{"shape":"Sk"}},"Ss":{"type":"list","member":{"type":"structure","required":["sourceIdentifier","sourceVersion"],"members":{"sourceIdentifier":{},"sourceVersion":{}}}},"Su":{"type":"structure","members":{"location":{},"sha256sum":{},"md5sum":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{}}},"Sw":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"modes":{"type":"list","member":{}}}},"S10":{"type":"structure","required":["type","image","computeType"],"members":{"type":{},"image":{},"computeType":{},"environmentVariables":{"shape":"S13"},"privilegedMode":{"type":"boolean"},"certificate":{},"registryCredential":{"shape":"S16"},"imagePullCredentialsType":{}}},"S13":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"type":{}}}},"S16":{"type":"structure","required":["credential","credentialProvider"],"members":{"credential":{},"credentialProvider":{}}},"S1a":{"type":"structure","required":["status"],"members":{"status":{},"groupName":{},"streamName":{}}},"S1c":{"type":"structure","required":["status"],"members":{"status":{},"location":{},"encryptionDisabled":{"type":"boolean"}}},"S1f":{"type":"structure","members":{"vpcId":{},"subnets":{"type":"list","member":{}},"securityGroupIds":{"type":"list","member":{}}}},"S1m":{"type":"list","member":{"type":"structure","members":{"type":{},"location":{},"mountPoint":{},"identifier":{},"mountOptions":{}}}},"S1q":{"type":"list","member":{}},"S1t":{"type":"structure","members":{"name":{},"arn":{},"description":{},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"S1w"},"secondaryArtifacts":{"shape":"S20"},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S22"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"webhook":{"shape":"S26"},"vpcConfig":{"shape":"S1f"},"badge":{"type":"structure","members":{"badgeEnabled":{"type":"boolean"},"badgeRequestUrl":{}}},"logsConfig":{"shape":"S2c"},"fileSystemLocations":{"shape":"S1m"}}},"S1w":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"path":{},"namespaceType":{},"name":{},"packaging":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{}}},"S20":{"type":"list","member":{"shape":"S1w"}},"S22":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S26":{"type":"structure","members":{"url":{},"payloadUrl":{},"secret":{},"branchFilter":{},"filterGroups":{"shape":"S27"},"lastModifiedSecret":{"type":"timestamp"}}},"S27":{"type":"list","member":{"type":"list","member":{"type":"structure","required":["type","pattern"],"members":{"type":{},"pattern":{},"excludeMatchedPattern":{"type":"boolean"}}}}},"S2c":{"type":"structure","members":{"cloudWatchLogs":{"shape":"S1a"},"s3Logs":{"shape":"S1c"}}},"S2e":{"type":"list","member":{}},"S2h":{"type":"structure","members":{"arn":{},"name":{},"type":{},"exportConfig":{"shape":"S2k"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"tags":{"shape":"S22"}}},"S2k":{"type":"structure","members":{"exportConfigType":{},"s3Destination":{"type":"structure","members":{"bucket":{},"path":{},"packaging":{},"encryptionKey":{},"encryptionDisabled":{"type":"boolean"}}}}},"S2p":{"type":"list","member":{}},"S4g":{"type":"structure","members":{"status":{}}}}}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeTestCases":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"testCases"},"ListBuilds":{"input_token":"nextToken","output_token":"nextToken","result_key":"ids"},"ListBuildsForProject":{"input_token":"nextToken","output_token":"nextToken","result_key":"ids"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListReportGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reportGroups"},"ListReports":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reports"},"ListReportsForReportGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reports"},"ListSharedProjects":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"projects"},"ListSharedReportGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reportGroups"}}}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-13","endpointPrefix":"codecommit","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeCommit","serviceFullName":"AWS CodeCommit","serviceId":"CodeCommit","signatureVersion":"v4","targetPrefix":"CodeCommit_20150413","uid":"codecommit-2015-04-13"},"operations":{"AssociateApprovalRuleTemplateWithRepository":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryName"],"members":{"approvalRuleTemplateName":{},"repositoryName":{}}}},"BatchAssociateApprovalRuleTemplateWithRepositories":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryNames"],"members":{"approvalRuleTemplateName":{},"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","required":["associatedRepositoryNames","errors"],"members":{"associatedRepositoryNames":{"shape":"S5"},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchDescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"maxConflictFiles":{"type":"integer"},"filePaths":{"type":"list","member":{}},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflicts","destinationCommitId","sourceCommitId"],"members":{"conflicts":{"type":"list","member":{"type":"structure","members":{"conflictMetadata":{"shape":"Sn"},"mergeHunks":{"shape":"S12"}}}},"nextToken":{},"errors":{"type":"list","member":{"type":"structure","required":["filePath","exceptionName","message"],"members":{"filePath":{},"exceptionName":{},"message":{}}}},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"BatchDisassociateApprovalRuleTemplateFromRepositories":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryNames"],"members":{"approvalRuleTemplateName":{},"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","required":["disassociatedRepositoryNames","errors"],"members":{"disassociatedRepositoryNames":{"shape":"S5"},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetCommits":{"input":{"type":"structure","required":["commitIds","repositoryName"],"members":{"commitIds":{"type":"list","member":{}},"repositoryName":{}}},"output":{"type":"structure","members":{"commits":{"type":"list","member":{"shape":"S1l"}},"errors":{"type":"list","member":{"type":"structure","members":{"commitId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetRepositories":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1x"}},"repositoriesNotFound":{"type":"list","member":{}}}}},"CreateApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName","approvalRuleTemplateContent"],"members":{"approvalRuleTemplateName":{},"approvalRuleTemplateContent":{},"approvalRuleTemplateDescription":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"CreateBranch":{"input":{"type":"structure","required":["repositoryName","branchName","commitId"],"members":{"repositoryName":{},"branchName":{},"commitId":{}}}},"CreateCommit":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{},"parentCommitId":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"putFiles":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{},"fileMode":{},"fileContent":{"type":"blob"},"sourceFile":{"type":"structure","required":["filePath"],"members":{"filePath":{},"isMove":{"type":"boolean"}}}}}},"deleteFiles":{"shape":"S2o"},"setFileModes":{"shape":"S2q"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{},"filesAdded":{"shape":"S2t"},"filesUpdated":{"shape":"S2t"},"filesDeleted":{"shape":"S2t"}}}},"CreatePullRequest":{"input":{"type":"structure","required":["title","targets"],"members":{"title":{},"description":{},"targets":{"type":"list","member":{"type":"structure","required":["repositoryName","sourceReference"],"members":{"repositoryName":{},"sourceReference":{},"destinationReference":{}}}},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"CreatePullRequestApprovalRule":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName","approvalRuleContent"],"members":{"pullRequestId":{},"approvalRuleName":{},"approvalRuleContent":{}}},"output":{"type":"structure","required":["approvalRule"],"members":{"approvalRule":{"shape":"S3c"}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{},"tags":{"shape":"S3k"}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1x"}}}},"CreateUnreferencedMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"DeleteApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplateId"],"members":{"approvalRuleTemplateId":{}}}},"DeleteBranch":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"deletedBranch":{"shape":"S3y"}}}},"DeleteCommentContent":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}}},"DeleteFile":{"input":{"type":"structure","required":["repositoryName","branchName","filePath","parentCommitId"],"members":{"repositoryName":{},"branchName":{},"filePath":{},"parentCommitId":{},"keepEmptyFolders":{"type":"boolean"},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId","filePath"],"members":{"commitId":{},"blobId":{},"treeId":{},"filePath":{}}}},"DeletePullRequestApprovalRule":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName"],"members":{"pullRequestId":{},"approvalRuleName":{}}},"output":{"type":"structure","required":["approvalRuleId"],"members":{"approvalRuleId":{}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryId":{}}}},"DescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption","filePath"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"filePath":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflictMetadata","mergeHunks","destinationCommitId","sourceCommitId"],"members":{"conflictMetadata":{"shape":"Sn"},"mergeHunks":{"shape":"S12"},"nextToken":{},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"DescribePullRequestEvents":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"pullRequestEventType":{},"actorArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestEvents"],"members":{"pullRequestEvents":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"eventDate":{"type":"timestamp"},"pullRequestEventType":{},"actorArn":{},"pullRequestCreatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"sourceCommitId":{},"destinationCommitId":{},"mergeBase":{}}},"pullRequestStatusChangedEventMetadata":{"type":"structure","members":{"pullRequestStatus":{}}},"pullRequestSourceReferenceUpdatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"mergeBase":{}}},"pullRequestMergedStateChangedEventMetadata":{"type":"structure","members":{"repositoryName":{},"destinationReference":{},"mergeMetadata":{"shape":"S38"}}},"approvalRuleEventMetadata":{"type":"structure","members":{"approvalRuleName":{},"approvalRuleId":{},"approvalRuleContent":{}}},"approvalStateChangedEventMetadata":{"type":"structure","members":{"revisionId":{},"approvalStatus":{}}},"approvalRuleOverriddenEventMetadata":{"type":"structure","members":{"revisionId":{},"overrideStatus":{}}}}}},"nextToken":{}}}},"DisassociateApprovalRuleTemplateFromRepository":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryName"],"members":{"approvalRuleTemplateName":{},"repositoryName":{}}}},"EvaluatePullRequestApprovalRules":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","required":["evaluation"],"members":{"evaluation":{"type":"structure","members":{"approved":{"type":"boolean"},"overridden":{"type":"boolean"},"approvalRulesSatisfied":{"type":"list","member":{}},"approvalRulesNotSatisfied":{"type":"list","member":{}}}}}}},"GetApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"GetBlob":{"input":{"type":"structure","required":["repositoryName","blobId"],"members":{"repositoryName":{},"blobId":{}}},"output":{"type":"structure","required":["content"],"members":{"content":{"type":"blob"}}}},"GetBranch":{"input":{"type":"structure","members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"branch":{"shape":"S3y"}}}},"GetComment":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}}},"GetCommentReactions":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{},"reactionUserArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["reactionsForComment"],"members":{"reactionsForComment":{"type":"list","member":{"type":"structure","members":{"reaction":{"type":"structure","members":{"emoji":{},"shortCode":{},"unicode":{}}},"reactionUsers":{"type":"list","member":{}},"reactionsFromDeletedUsersCount":{"type":"integer"}}}},"nextToken":{}}}},"GetCommentsForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForComparedCommitData":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comments":{"shape":"S5t"}}}},"nextToken":{}}}},"GetCommentsForPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForPullRequestData":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comments":{"shape":"S5t"}}}},"nextToken":{}}}},"GetCommit":{"input":{"type":"structure","required":["repositoryName","commitId"],"members":{"repositoryName":{},"commitId":{}}},"output":{"type":"structure","required":["commit"],"members":{"commit":{"shape":"S1l"}}}},"GetDifferences":{"input":{"type":"structure","required":["repositoryName","afterCommitSpecifier"],"members":{"repositoryName":{},"beforeCommitSpecifier":{},"afterCommitSpecifier":{},"beforePath":{},"afterPath":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"differences":{"type":"list","member":{"type":"structure","members":{"beforeBlob":{"shape":"S65"},"afterBlob":{"shape":"S65"},"changeType":{}}}},"NextToken":{}}}},"GetFile":{"input":{"type":"structure","required":["repositoryName","filePath"],"members":{"repositoryName":{},"commitSpecifier":{},"filePath":{}}},"output":{"type":"structure","required":["commitId","blobId","filePath","fileMode","fileSize","fileContent"],"members":{"commitId":{},"blobId":{},"filePath":{},"fileMode":{},"fileSize":{"type":"long"},"fileContent":{"type":"blob"}}}},"GetFolder":{"input":{"type":"structure","required":["repositoryName","folderPath"],"members":{"repositoryName":{},"commitSpecifier":{},"folderPath":{}}},"output":{"type":"structure","required":["commitId","folderPath"],"members":{"commitId":{},"folderPath":{},"treeId":{},"subFolders":{"type":"list","member":{"type":"structure","members":{"treeId":{},"absolutePath":{},"relativePath":{}}}},"files":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"symbolicLinks":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"subModules":{"type":"list","member":{"type":"structure","members":{"commitId":{},"absolutePath":{},"relativePath":{}}}}}}},"GetMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","members":{"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{},"mergedCommitId":{}}}},"GetMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"maxConflictFiles":{"type":"integer"},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["mergeable","destinationCommitId","sourceCommitId","conflictMetadataList"],"members":{"mergeable":{"type":"boolean"},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{},"conflictMetadataList":{"type":"list","member":{"shape":"Sn"}},"nextToken":{}}}},"GetMergeOptions":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","required":["mergeOptions","sourceCommitId","destinationCommitId","baseCommitId"],"members":{"mergeOptions":{"type":"list","member":{}},"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{}}}},"GetPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"GetPullRequestApprovalStates":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","members":{"approvals":{"type":"list","member":{"type":"structure","members":{"userArn":{},"approvalState":{}}}}}}},"GetPullRequestOverrideState":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","members":{"overridden":{"type":"boolean"},"overrider":{}}}},"GetRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1x"}}}},"GetRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"configurationId":{},"triggers":{"shape":"S76"}}}},"ListApprovalRuleTemplates":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"approvalRuleTemplateNames":{"shape":"S7f"},"nextToken":{}}}},"ListAssociatedApprovalRuleTemplatesForRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"approvalRuleTemplateNames":{"shape":"S7f"},"nextToken":{}}}},"ListBranches":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{}}},"output":{"type":"structure","members":{"branches":{"shape":"S7a"},"nextToken":{}}}},"ListPullRequests":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"authorArn":{},"pullRequestStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestIds"],"members":{"pullRequestIds":{"type":"list","member":{}},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"nextToken":{},"sortBy":{},"order":{}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"repositoryId":{}}}},"nextToken":{}}}},"ListRepositoriesForApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositoryNames":{"shape":"S5"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S3k"},"nextToken":{}}}},"MergeBranchesByFastForward":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesBySquash":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesByThreeWay":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergePullRequestByFastForward":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S33"}}}},"MergePullRequestBySquash":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S33"}}}},"MergePullRequestByThreeWay":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S33"}}}},"OverridePullRequestApprovalRules":{"input":{"type":"structure","required":["pullRequestId","revisionId","overrideStatus"],"members":{"pullRequestId":{},"revisionId":{},"overrideStatus":{}}}},"PostCommentForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId","content"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S5q"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comment":{"shape":"S42"}}},"idempotent":true},"PostCommentForPullRequest":{"input":{"type":"structure","required":["pullRequestId","repositoryName","beforeCommitId","afterCommitId","content"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S5q"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"pullRequestId":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comment":{"shape":"S42"}}},"idempotent":true},"PostCommentReply":{"input":{"type":"structure","required":["inReplyTo","content"],"members":{"inReplyTo":{},"clientRequestToken":{"idempotencyToken":true},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}},"idempotent":true},"PutCommentReaction":{"input":{"type":"structure","required":["commentId","reactionValue"],"members":{"commentId":{},"reactionValue":{}}}},"PutFile":{"input":{"type":"structure","required":["repositoryName","branchName","fileContent","filePath"],"members":{"repositoryName":{},"branchName":{},"fileContent":{"type":"blob"},"filePath":{},"fileMode":{},"parentCommitId":{},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId"],"members":{"commitId":{},"blobId":{},"treeId":{}}}},"PutRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S76"}}},"output":{"type":"structure","members":{"configurationId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3k"}}}},"TestRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S76"}}},"output":{"type":"structure","members":{"successfulExecutions":{"type":"list","member":{}},"failedExecutions":{"type":"list","member":{"type":"structure","members":{"trigger":{},"failureMessage":{}}}}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}},"UpdateApprovalRuleTemplateContent":{"input":{"type":"structure","required":["approvalRuleTemplateName","newRuleContent"],"members":{"approvalRuleTemplateName":{},"newRuleContent":{},"existingRuleContentSha256":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"UpdateApprovalRuleTemplateDescription":{"input":{"type":"structure","required":["approvalRuleTemplateName","approvalRuleTemplateDescription"],"members":{"approvalRuleTemplateName":{},"approvalRuleTemplateDescription":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"UpdateApprovalRuleTemplateName":{"input":{"type":"structure","required":["oldApprovalRuleTemplateName","newApprovalRuleTemplateName"],"members":{"oldApprovalRuleTemplateName":{},"newApprovalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"UpdateComment":{"input":{"type":"structure","required":["commentId","content"],"members":{"commentId":{},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}}},"UpdateDefaultBranch":{"input":{"type":"structure","required":["repositoryName","defaultBranchName"],"members":{"repositoryName":{},"defaultBranchName":{}}}},"UpdatePullRequestApprovalRuleContent":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName","newRuleContent"],"members":{"pullRequestId":{},"approvalRuleName":{},"existingRuleContentSha256":{},"newRuleContent":{}}},"output":{"type":"structure","required":["approvalRule"],"members":{"approvalRule":{"shape":"S3c"}}}},"UpdatePullRequestApprovalState":{"input":{"type":"structure","required":["pullRequestId","revisionId","approvalState"],"members":{"pullRequestId":{},"revisionId":{},"approvalState":{}}}},"UpdatePullRequestDescription":{"input":{"type":"structure","required":["pullRequestId","description"],"members":{"pullRequestId":{},"description":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"UpdatePullRequestStatus":{"input":{"type":"structure","required":["pullRequestId","pullRequestStatus"],"members":{"pullRequestId":{},"pullRequestStatus":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"UpdatePullRequestTitle":{"input":{"type":"structure","required":["pullRequestId","title"],"members":{"pullRequestId":{},"title":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"UpdateRepositoryDescription":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}}},"UpdateRepositoryName":{"input":{"type":"structure","required":["oldName","newName"],"members":{"oldName":{},"newName":{}}}}},"shapes":{"S5":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"filePath":{},"fileSizes":{"type":"structure","members":{"source":{"type":"long"},"destination":{"type":"long"},"base":{"type":"long"}}},"fileModes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"objectTypes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"numberOfConflicts":{"type":"integer"},"isBinaryFile":{"type":"structure","members":{"source":{"type":"boolean"},"destination":{"type":"boolean"},"base":{"type":"boolean"}}},"contentConflict":{"type":"boolean"},"fileModeConflict":{"type":"boolean"},"objectTypeConflict":{"type":"boolean"},"mergeOperations":{"type":"structure","members":{"source":{},"destination":{}}}}},"S12":{"type":"list","member":{"type":"structure","members":{"isConflict":{"type":"boolean"},"source":{"shape":"S15"},"destination":{"shape":"S15"},"base":{"shape":"S15"}}}},"S15":{"type":"structure","members":{"startLine":{"type":"integer"},"endLine":{"type":"integer"},"hunkContent":{}}},"S1l":{"type":"structure","members":{"commitId":{},"treeId":{},"parents":{"type":"list","member":{}},"message":{},"author":{"shape":"S1n"},"committer":{"shape":"S1n"},"additionalData":{}}},"S1n":{"type":"structure","members":{"name":{},"email":{},"date":{}}},"S1x":{"type":"structure","members":{"accountId":{},"repositoryId":{},"repositoryName":{},"repositoryDescription":{},"defaultBranch":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"cloneUrlHttp":{},"cloneUrlSsh":{},"Arn":{}}},"S2c":{"type":"structure","members":{"approvalRuleTemplateId":{},"approvalRuleTemplateName":{},"approvalRuleTemplateDescription":{},"approvalRuleTemplateContent":{},"ruleContentSha256":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"lastModifiedUser":{}}},"S2o":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{}}}},"S2q":{"type":"list","member":{"type":"structure","required":["filePath","fileMode"],"members":{"filePath":{},"fileMode":{}}}},"S2t":{"type":"list","member":{"type":"structure","members":{"absolutePath":{},"blobId":{},"fileMode":{}}}},"S33":{"type":"structure","members":{"pullRequestId":{},"title":{},"description":{},"lastActivityDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"pullRequestStatus":{},"authorArn":{},"pullRequestTargets":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"sourceReference":{},"destinationReference":{},"destinationCommit":{},"sourceCommit":{},"mergeBase":{},"mergeMetadata":{"shape":"S38"}}}},"clientRequestToken":{},"revisionId":{},"approvalRules":{"type":"list","member":{"shape":"S3c"}}}},"S38":{"type":"structure","members":{"isMerged":{"type":"boolean"},"mergedBy":{},"mergeCommitId":{},"mergeOption":{}}},"S3c":{"type":"structure","members":{"approvalRuleId":{},"approvalRuleName":{},"approvalRuleContent":{},"ruleContentSha256":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"lastModifiedUser":{},"originApprovalRuleTemplate":{"type":"structure","members":{"approvalRuleTemplateId":{},"approvalRuleTemplateName":{}}}}},"S3k":{"type":"map","key":{},"value":{}},"S3p":{"type":"structure","members":{"replaceContents":{"type":"list","member":{"type":"structure","required":["filePath","replacementType"],"members":{"filePath":{},"replacementType":{},"content":{"type":"blob"},"fileMode":{}}}},"deleteFiles":{"shape":"S2o"},"setFileModes":{"shape":"S2q"}}},"S3y":{"type":"structure","members":{"branchName":{},"commitId":{}}},"S42":{"type":"structure","members":{"commentId":{},"content":{},"inReplyTo":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"authorArn":{},"deleted":{"type":"boolean"},"clientRequestToken":{},"callerReactions":{"type":"list","member":{}},"reactionCounts":{"type":"map","key":{},"value":{"type":"integer"}}}},"S5q":{"type":"structure","members":{"filePath":{},"filePosition":{"type":"long"},"relativeFileVersion":{}}},"S5t":{"type":"list","member":{"shape":"S42"}},"S65":{"type":"structure","members":{"blobId":{},"path":{},"mode":{}}},"S76":{"type":"list","member":{"type":"structure","required":["name","destinationArn","events"],"members":{"name":{},"destinationArn":{},"customData":{},"branches":{"shape":"S7a"},"events":{"type":"list","member":{}}}}},"S7a":{"type":"list","member":{}},"S7f":{"type":"list","member":{}}}}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeMergeConflicts":{"input_token":"nextToken","limit_key":"maxMergeHunks","output_token":"nextToken"},"DescribePullRequestEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentReactions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForComparedCommit":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForPullRequest":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetDifferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMergeConflicts":{"input_token":"nextToken","limit_key":"maxConflictFiles","output_token":"nextToken"},"ListApprovalRuleTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListAssociatedApprovalRuleTemplatesForRepository":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListBranches":{"input_token":"nextToken","output_token":"nextToken","result_key":"branches"},"ListPullRequests":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","result_key":"repositories"},"ListRepositoriesForApprovalRuleTemplate":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"}}}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-06","endpointPrefix":"codedeploy","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeDeploy","serviceFullName":"AWS CodeDeploy","serviceId":"CodeDeploy","signatureVersion":"v4","targetPrefix":"CodeDeploy_20141006","uid":"codedeploy-2014-10-06"},"operations":{"AddTagsToOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"BatchGetApplicationRevisions":{"input":{"type":"structure","required":["applicationName","revisions"],"members":{"applicationName":{},"revisions":{"shape":"Sa"}}},"output":{"type":"structure","members":{"applicationName":{},"errorMessage":{},"revisions":{"type":"list","member":{"type":"structure","members":{"revisionLocation":{"shape":"Sb"},"genericRevisionInfo":{"shape":"Su"}}}}}}},"BatchGetApplications":{"input":{"type":"structure","required":["applicationNames"],"members":{"applicationNames":{"shape":"S10"}}},"output":{"type":"structure","members":{"applicationsInfo":{"type":"list","member":{"shape":"S13"}}}}},"BatchGetDeploymentGroups":{"input":{"type":"structure","required":["applicationName","deploymentGroupNames"],"members":{"applicationName":{},"deploymentGroupNames":{"shape":"Sw"}}},"output":{"type":"structure","members":{"deploymentGroupsInfo":{"type":"list","member":{"shape":"S1b"}},"errorMessage":{}}}},"BatchGetDeploymentInstances":{"input":{"type":"structure","required":["deploymentId","instanceIds"],"members":{"deploymentId":{},"instanceIds":{"shape":"S31"}}},"output":{"type":"structure","members":{"instancesSummary":{"type":"list","member":{"shape":"S35"}},"errorMessage":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use BatchGetDeploymentTargets instead."},"BatchGetDeploymentTargets":{"input":{"type":"structure","members":{"deploymentId":{},"targetIds":{"shape":"S3i"}}},"output":{"type":"structure","members":{"deploymentTargets":{"type":"list","member":{"shape":"S3m"}}}}},"BatchGetDeployments":{"input":{"type":"structure","required":["deploymentIds"],"members":{"deploymentIds":{"shape":"S48"}}},"output":{"type":"structure","members":{"deploymentsInfo":{"type":"list","member":{"shape":"S4b"}}}}},"BatchGetOnPremisesInstances":{"input":{"type":"structure","required":["instanceNames"],"members":{"instanceNames":{"shape":"S6"}}},"output":{"type":"structure","members":{"instanceInfos":{"type":"list","member":{"shape":"S4r"}}}}},"ContinueDeployment":{"input":{"type":"structure","members":{"deploymentId":{},"deploymentWaitType":{}}}},"CreateApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"computePlatform":{},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"applicationId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"deploymentGroupName":{},"revision":{"shape":"Sb"},"deploymentConfigName":{},"description":{},"ignoreApplicationStopFailures":{"type":"boolean"},"targetInstances":{"shape":"S4i"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"fileExistsBehavior":{}}},"output":{"type":"structure","members":{"deploymentId":{}}}},"CreateDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S52"},"trafficRoutingConfig":{"shape":"S55"},"computePlatform":{}}},"output":{"type":"structure","members":{"deploymentConfigId":{}}}},"CreateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName","serviceRoleArn"],"members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4j"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"ec2TagSet":{"shape":"S2s"},"ecsServices":{"shape":"S2w"},"onPremisesTagSet":{"shape":"S2u"},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"deploymentGroupId":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}}},"DeleteDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}}},"DeleteDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}},"DeleteGitHubAccountToken":{"input":{"type":"structure","members":{"tokenName":{}}},"output":{"type":"structure","members":{"tokenName":{}}}},"DeleteResourcesByExternalId":{"input":{"type":"structure","members":{"externalId":{}}},"output":{"type":"structure","members":{}}},"DeregisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}}},"GetApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"application":{"shape":"S13"}}}},"GetApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"revision":{"shape":"Sb"}}},"output":{"type":"structure","members":{"applicationName":{},"revision":{"shape":"Sb"},"revisionInfo":{"shape":"Su"}}}},"GetDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{}}},"output":{"type":"structure","members":{"deploymentInfo":{"shape":"S4b"}}}},"GetDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}},"output":{"type":"structure","members":{"deploymentConfigInfo":{"type":"structure","members":{"deploymentConfigId":{},"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S52"},"createTime":{"type":"timestamp"},"computePlatform":{},"trafficRoutingConfig":{"shape":"S55"}}}}}},"GetDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"deploymentGroupInfo":{"shape":"S1b"}}}},"GetDeploymentInstance":{"input":{"type":"structure","required":["deploymentId","instanceId"],"members":{"deploymentId":{},"instanceId":{}}},"output":{"type":"structure","members":{"instanceSummary":{"shape":"S35"}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use GetDeploymentTarget instead."},"GetDeploymentTarget":{"input":{"type":"structure","members":{"deploymentId":{},"targetId":{}}},"output":{"type":"structure","members":{"deploymentTarget":{"shape":"S3m"}}}},"GetOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instanceInfo":{"shape":"S4r"}}}},"ListApplicationRevisions":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"sortBy":{},"sortOrder":{},"s3Bucket":{},"s3KeyPrefix":{},"deployed":{},"nextToken":{}}},"output":{"type":"structure","members":{"revisions":{"shape":"Sa"},"nextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"applications":{"shape":"S10"},"nextToken":{}}}},"ListDeploymentConfigs":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"deploymentConfigsList":{"type":"list","member":{}},"nextToken":{}}}},"ListDeploymentGroups":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"nextToken":{}}},"output":{"type":"structure","members":{"applicationName":{},"deploymentGroups":{"shape":"Sw"},"nextToken":{}}}},"ListDeploymentInstances":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"instanceStatusFilter":{"type":"list","member":{"shape":"S36"}},"instanceTypeFilter":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"instancesList":{"shape":"S31"},"nextToken":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ListDeploymentTargets instead."},"ListDeploymentTargets":{"input":{"type":"structure","members":{"deploymentId":{},"nextToken":{},"targetFilters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"targetIds":{"shape":"S3i"},"nextToken":{}}}},"ListDeployments":{"input":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"externalId":{},"includeOnlyStatuses":{"type":"list","member":{}},"createTimeRange":{"type":"structure","members":{"start":{"type":"timestamp"},"end":{"type":"timestamp"}}},"nextToken":{}}},"output":{"type":"structure","members":{"deployments":{"shape":"S48"},"nextToken":{}}}},"ListGitHubAccountTokenNames":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"tokenNameList":{"type":"list","member":{}},"nextToken":{}}}},"ListOnPremisesInstances":{"input":{"type":"structure","members":{"registrationStatus":{},"tagFilters":{"shape":"S1h"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceNames":{"shape":"S6"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2"},"NextToken":{}}}},"PutLifecycleEventHookExecutionStatus":{"input":{"type":"structure","members":{"deploymentId":{},"lifecycleEventHookExecutionId":{},"status":{}}},"output":{"type":"structure","members":{"lifecycleEventHookExecutionId":{}}}},"RegisterApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"description":{},"revision":{"shape":"Sb"}}}},"RegisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{}}}},"RemoveTagsFromOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"SkipWaitTimeForInstanceTermination":{"input":{"type":"structure","members":{"deploymentId":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ContinueDeployment with DeploymentWaitType instead."},"StopDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"autoRollbackEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusMessage":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S2"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","members":{"applicationName":{},"newApplicationName":{}}}},"UpdateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","currentDeploymentGroupName"],"members":{"applicationName":{},"currentDeploymentGroupName":{},"newDeploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4j"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"ec2TagSet":{"shape":"S2s"},"ecsServices":{"shape":"S2w"},"onPremisesTagSet":{"shape":"S2u"}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"revisionType":{},"s3Location":{"type":"structure","members":{"bucket":{},"key":{},"bundleType":{},"version":{},"eTag":{}}},"gitHubLocation":{"type":"structure","members":{"repository":{},"commitId":{}}},"string":{"type":"structure","members":{"content":{},"sha256":{}},"deprecated":true,"deprecatedMessage":"RawString and String revision type are deprecated, use AppSpecContent type instead."},"appSpecContent":{"type":"structure","members":{"content":{},"sha256":{}}}}},"Su":{"type":"structure","members":{"description":{},"deploymentGroups":{"shape":"Sw"},"firstUsedTime":{"type":"timestamp"},"lastUsedTime":{"type":"timestamp"},"registerTime":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"applicationId":{},"applicationName":{},"createTime":{"type":"timestamp"},"linkedToGitHub":{"type":"boolean"},"gitHubAccountName":{},"computePlatform":{}}},"S1b":{"type":"structure","members":{"applicationName":{},"deploymentGroupId":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S1k"},"serviceRoleArn":{},"targetRevision":{"shape":"Sb"},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"lastSuccessfulDeployment":{"shape":"S2p"},"lastAttemptedDeployment":{"shape":"S2p"},"ec2TagSet":{"shape":"S2s"},"onPremisesTagSet":{"shape":"S2u"},"computePlatform":{},"ecsServices":{"shape":"S2w"}}},"S1e":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"name":{},"hook":{}}}},"S1p":{"type":"list","member":{"type":"structure","members":{"triggerName":{},"triggerTargetArn":{},"triggerEvents":{"type":"list","member":{}}}}},"S1v":{"type":"structure","members":{"enabled":{"type":"boolean"},"ignorePollAlarmFailure":{"type":"boolean"},"alarms":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S1z":{"type":"structure","members":{"enabled":{"type":"boolean"},"events":{"type":"list","member":{}}}},"S22":{"type":"structure","members":{"deploymentType":{},"deploymentOption":{}}},"S25":{"type":"structure","members":{"terminateBlueInstancesOnDeploymentSuccess":{"type":"structure","members":{"action":{},"terminationWaitTimeInMinutes":{"type":"integer"}}},"deploymentReadyOption":{"type":"structure","members":{"actionOnTimeout":{},"waitTimeInMinutes":{"type":"integer"}}},"greenFleetProvisioningOption":{"type":"structure","members":{"action":{}}}}},"S2d":{"type":"structure","members":{"elbInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"targetGroupInfoList":{"shape":"S2h"},"targetGroupPairInfoList":{"type":"list","member":{"type":"structure","members":{"targetGroups":{"shape":"S2h"},"prodTrafficRoute":{"shape":"S2m"},"testTrafficRoute":{"shape":"S2m"}}}}}},"S2h":{"type":"list","member":{"shape":"S2i"}},"S2i":{"type":"structure","members":{"name":{}}},"S2m":{"type":"structure","members":{"listenerArns":{"type":"list","member":{}}}},"S2p":{"type":"structure","members":{"deploymentId":{},"status":{},"endTime":{"type":"timestamp"},"createTime":{"type":"timestamp"}}},"S2s":{"type":"structure","members":{"ec2TagSetList":{"type":"list","member":{"shape":"S1e"}}}},"S2u":{"type":"structure","members":{"onPremisesTagSetList":{"type":"list","member":{"shape":"S1h"}}}},"S2w":{"type":"list","member":{"type":"structure","members":{"serviceName":{},"clusterName":{}}}},"S31":{"type":"list","member":{}},"S35":{"type":"structure","members":{"deploymentId":{},"instanceId":{},"status":{"shape":"S36"},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"instanceType":{}},"deprecated":true,"deprecatedMessage":"InstanceSummary is deprecated, use DeploymentTarget instead."},"S36":{"type":"string","deprecated":true,"deprecatedMessage":"InstanceStatus is deprecated, use TargetStatus instead."},"S37":{"type":"list","member":{"type":"structure","members":{"lifecycleEventName":{},"diagnostics":{"type":"structure","members":{"errorCode":{},"scriptName":{},"message":{},"logTail":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{}}}},"S3i":{"type":"list","member":{}},"S3m":{"type":"structure","members":{"deploymentTargetType":{},"instanceTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"instanceLabel":{}}},"lambdaTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"lambdaFunctionInfo":{"type":"structure","members":{"functionName":{},"functionAlias":{},"currentVersion":{},"targetVersion":{},"targetVersionWeight":{"type":"double"}}}}},"ecsTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"status":{},"taskSetsInfo":{"type":"list","member":{"type":"structure","members":{"identifer":{},"desiredCount":{"type":"long"},"pendingCount":{"type":"long"},"runningCount":{"type":"long"},"status":{},"trafficWeight":{"type":"double"},"targetGroup":{"shape":"S2i"},"taskSetLabel":{}}}}}},"cloudFormationTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"status":{},"resourceType":{},"targetVersionWeight":{"type":"double"}}}}},"S48":{"type":"list","member":{}},"S4b":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"deploymentId":{},"previousRevision":{"shape":"Sb"},"revision":{"shape":"Sb"},"status":{},"errorInformation":{"type":"structure","members":{"code":{},"message":{}}},"createTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"completeTime":{"type":"timestamp"},"deploymentOverview":{"type":"structure","members":{"Pending":{"type":"long"},"InProgress":{"type":"long"},"Succeeded":{"type":"long"},"Failed":{"type":"long"},"Skipped":{"type":"long"},"Ready":{"type":"long"}}},"description":{},"creator":{},"ignoreApplicationStopFailures":{"type":"boolean"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"rollbackInfo":{"type":"structure","members":{"rollbackDeploymentId":{},"rollbackTriggeringDeploymentId":{},"rollbackMessage":{}}},"deploymentStyle":{"shape":"S22"},"targetInstances":{"shape":"S4i"},"instanceTerminationWaitTimeStarted":{"type":"boolean"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"additionalDeploymentStatusInfo":{"type":"string","deprecated":true,"deprecatedMessage":"AdditionalDeploymentStatusInfo is deprecated, use DeploymentStatusMessageList instead."},"fileExistsBehavior":{},"deploymentStatusMessages":{"type":"list","member":{}},"computePlatform":{},"externalId":{}}},"S4i":{"type":"structure","members":{"tagFilters":{"shape":"S1e"},"autoScalingGroups":{"shape":"S4j"},"ec2TagSet":{"shape":"S2s"}}},"S4j":{"type":"list","member":{}},"S4r":{"type":"structure","members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{},"instanceArn":{},"registerTime":{"type":"timestamp"},"deregisterTime":{"type":"timestamp"},"tags":{"shape":"S2"}}},"S52":{"type":"structure","members":{"value":{"type":"integer"},"type":{}}},"S55":{"type":"structure","members":{"type":{},"timeBasedCanary":{"type":"structure","members":{"canaryPercentage":{"type":"integer"},"canaryInterval":{"type":"integer"}}},"timeBasedLinear":{"type":"structure","members":{"linearPercentage":{"type":"integer"},"linearInterval":{"type":"integer"}}}}}}}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListApplicationRevisions":{"input_token":"nextToken","output_token":"nextToken","result_key":"revisions"},"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applications"},"ListDeploymentConfigs":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentConfigsList"},"ListDeploymentGroups":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentGroups"},"ListDeploymentInstances":{"input_token":"nextToken","output_token":"nextToken","result_key":"instancesList"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","result_key":"deployments"}}}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DeploymentSuccessful":{"delay":15,"operation":"GetDeployment","maxAttempts":120,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"deploymentInfo.status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"deploymentInfo.status"},{"expected":"Stopped","matcher":"path","state":"failure","argument":"deploymentInfo.status"}]}}}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"codepipeline","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodePipeline","serviceFullName":"AWS CodePipeline","serviceId":"CodePipeline","signatureVersion":"v4","targetPrefix":"CodePipeline_20150709","uid":"codepipeline-2015-07-09"},"operations":{"AcknowledgeJob":{"input":{"type":"structure","required":["jobId","nonce"],"members":{"jobId":{},"nonce":{}}},"output":{"type":"structure","members":{"status":{}}}},"AcknowledgeThirdPartyJob":{"input":{"type":"structure","required":["jobId","nonce","clientToken"],"members":{"jobId":{},"nonce":{},"clientToken":{}}},"output":{"type":"structure","members":{"status":{}}}},"CreateCustomActionType":{"input":{"type":"structure","required":["category","provider","version","inputArtifactDetails","outputArtifactDetails"],"members":{"category":{},"provider":{},"version":{},"settings":{"shape":"Se"},"configurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"Sv"},"tags":{"shape":"Sq"}}}},"CreatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}}},"DeleteCustomActionType":{"input":{"type":"structure","required":["category","provider","version"],"members":{"category":{},"provider":{},"version":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeregisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"DisableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType","reason"],"members":{"pipelineName":{},"stageName":{},"transitionType":{},"reason":{}}}},"EnableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType"],"members":{"pipelineName":{},"stageName":{},"transitionType":{}}}},"GetJobDetails":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"shape":"S29"},"accountId":{}}}}}},"GetPipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{},"version":{"type":"integer"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"metadata":{"type":"structure","members":{"pipelineArn":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}}}},"GetPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{}}},"output":{"type":"structure","members":{"pipelineExecution":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"pipelineExecutionId":{},"status":{},"artifactRevisions":{"type":"list","member":{"type":"structure","members":{"name":{},"revisionId":{},"revisionChangeIdentifier":{},"revisionSummary":{},"created":{"type":"timestamp"},"revisionUrl":{}}}}}}}}},"GetPipelineState":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"stageStates":{"type":"list","member":{"type":"structure","members":{"stageName":{},"inboundTransitionState":{"type":"structure","members":{"enabled":{"type":"boolean"},"lastChangedBy":{},"lastChangedAt":{"type":"timestamp"},"disabledReason":{}}},"actionStates":{"type":"list","member":{"type":"structure","members":{"actionName":{},"currentRevision":{"shape":"S3h"},"latestExecution":{"type":"structure","members":{"status":{},"summary":{},"lastStatusChange":{"type":"timestamp"},"token":{},"lastUpdatedBy":{},"externalExecutionId":{},"externalExecutionUrl":{},"percentComplete":{"type":"integer"},"errorDetails":{"type":"structure","members":{"code":{},"message":{}}}}},"entityUrl":{},"revisionUrl":{}}}},"latestExecution":{"type":"structure","required":["pipelineExecutionId","status"],"members":{"pipelineExecutionId":{},"status":{}}}}}},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"GetThirdPartyJobDetails":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S2a"},"pipelineContext":{"shape":"S2b"},"inputArtifacts":{"shape":"S2h"},"outputArtifacts":{"shape":"S2h"},"artifactCredentials":{"shape":"S2p"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"nonce":{}}}}}},"ListActionExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"filter":{"type":"structure","members":{"pipelineExecutionId":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actionExecutionDetails":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"actionExecutionId":{},"pipelineVersion":{"type":"integer"},"stageName":{},"actionName":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"input":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"configuration":{"shape":"S1l"},"resolvedConfiguration":{"type":"map","key":{},"value":{}},"roleArn":{},"region":{},"inputArtifacts":{"shape":"S48"},"namespace":{}}},"output":{"type":"structure","members":{"outputArtifacts":{"shape":"S48"},"executionResult":{"type":"structure","members":{"externalExecutionId":{},"externalExecutionSummary":{},"externalExecutionUrl":{}}},"outputVariables":{"shape":"S4h"}}}}}},"nextToken":{}}}},"ListActionTypes":{"input":{"type":"structure","members":{"actionOwnerFilter":{},"nextToken":{}}},"output":{"type":"structure","required":["actionTypes"],"members":{"actionTypes":{"type":"list","member":{"shape":"Sv"}},"nextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"pipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"status":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"sourceRevisions":{"type":"list","member":{"type":"structure","required":["actionName"],"members":{"actionName":{},"revisionId":{},"revisionSummary":{},"revisionUrl":{}}}},"trigger":{"type":"structure","members":{"triggerType":{},"triggerDetail":{}}},"stopTrigger":{"type":"structure","members":{"reason":{}}}}}},"nextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"pipelines":{"type":"list","member":{"type":"structure","members":{"name":{},"version":{"type":"integer"},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"},"nextToken":{}}}},"ListWebhooks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"webhooks":{"type":"list","member":{"shape":"S58"}},"NextToken":{}}}},"PollForJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"},"queryParam":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"id":{},"data":{"shape":"S29"},"nonce":{},"accountId":{}}}}}}},"PollForThirdPartyJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"clientId":{},"jobId":{}}}}}}},"PutActionRevision":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","actionRevision"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"actionRevision":{"shape":"S3h"}}},"output":{"type":"structure","members":{"newRevision":{"type":"boolean"},"pipelineExecutionId":{}}}},"PutApprovalResult":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","result","token"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"result":{"type":"structure","required":["summary","status"],"members":{"summary":{},"status":{}}},"token":{}}},"output":{"type":"structure","members":{"approvedAt":{"type":"timestamp"}}}},"PutJobFailureResult":{"input":{"type":"structure","required":["jobId","failureDetails"],"members":{"jobId":{},"failureDetails":{"shape":"S68"}}}},"PutJobSuccessResult":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{},"currentRevision":{"shape":"S6b"},"continuationToken":{},"executionDetails":{"shape":"S6d"},"outputVariables":{"shape":"S4h"}}}},"PutThirdPartyJobFailureResult":{"input":{"type":"structure","required":["jobId","clientToken","failureDetails"],"members":{"jobId":{},"clientToken":{},"failureDetails":{"shape":"S68"}}}},"PutThirdPartyJobSuccessResult":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{},"currentRevision":{"shape":"S6b"},"continuationToken":{},"executionDetails":{"shape":"S6d"}}}},"PutWebhook":{"input":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S59"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S58"}}}},"RegisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"RetryStageExecution":{"input":{"type":"structure","required":["pipelineName","stageName","pipelineExecutionId","retryMode"],"members":{"pipelineName":{},"stageName":{},"pipelineExecutionId":{},"retryMode":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["name"],"members":{"name":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StopPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{},"abandon":{"type":"boolean"},"reason":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"}}}}},"shapes":{"Se":{"type":"structure","members":{"thirdPartyConfigurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}},"Sh":{"type":"list","member":{"type":"structure","required":["name","required","key","secret"],"members":{"name":{},"required":{"type":"boolean"},"key":{"type":"boolean"},"secret":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{},"type":{}}}},"Sn":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sv":{"type":"structure","required":["id","inputArtifactDetails","outputArtifactDetails"],"members":{"id":{"shape":"Sw"},"settings":{"shape":"Se"},"actionConfigurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"Sw":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"Sz":{"type":"structure","required":["name","roleArn","stages"],"members":{"name":{},"roleArn":{},"artifactStore":{"shape":"S12"},"artifactStores":{"type":"map","key":{},"value":{"shape":"S12"}},"stages":{"type":"list","member":{"type":"structure","required":["name","actions"],"members":{"name":{},"blockers":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"actions":{"type":"list","member":{"type":"structure","required":["name","actionTypeId"],"members":{"name":{},"actionTypeId":{"shape":"Sw"},"runOrder":{"type":"integer"},"configuration":{"shape":"S1l"},"outputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"inputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"roleArn":{},"region":{},"namespace":{}}}}}}},"version":{"type":"integer"}}},"S12":{"type":"structure","required":["type","location"],"members":{"type":{},"location":{},"encryptionKey":{"shape":"S15"}}},"S15":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S1l":{"type":"map","key":{},"value":{}},"S29":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S2a"},"pipelineContext":{"shape":"S2b"},"inputArtifacts":{"shape":"S2h"},"outputArtifacts":{"shape":"S2h"},"artifactCredentials":{"shape":"S2p"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"S2a":{"type":"structure","members":{"configuration":{"shape":"S1l"}}},"S2b":{"type":"structure","members":{"pipelineName":{},"stage":{"type":"structure","members":{"name":{}}},"action":{"type":"structure","members":{"name":{},"actionExecutionId":{}}},"pipelineArn":{},"pipelineExecutionId":{}}},"S2h":{"type":"list","member":{"type":"structure","members":{"name":{},"revision":{},"location":{"type":"structure","members":{"type":{},"s3Location":{"type":"structure","required":["bucketName","objectKey"],"members":{"bucketName":{},"objectKey":{}}}}}}}},"S2p":{"type":"structure","required":["accessKeyId","secretAccessKey","sessionToken"],"members":{"accessKeyId":{},"secretAccessKey":{},"sessionToken":{}},"sensitive":true},"S3h":{"type":"structure","required":["revisionId","revisionChangeId","created"],"members":{"revisionId":{},"revisionChangeId":{},"created":{"type":"timestamp"}}},"S48":{"type":"list","member":{"type":"structure","members":{"name":{},"s3location":{"type":"structure","members":{"bucket":{},"key":{}}}}}},"S4h":{"type":"map","key":{},"value":{}},"S58":{"type":"structure","required":["definition","url"],"members":{"definition":{"shape":"S59"},"url":{},"errorMessage":{},"errorCode":{},"lastTriggered":{"type":"timestamp"},"arn":{},"tags":{"shape":"Sq"}}},"S59":{"type":"structure","required":["name","targetPipeline","targetAction","filters","authentication","authenticationConfiguration"],"members":{"name":{},"targetPipeline":{},"targetAction":{},"filters":{"type":"list","member":{"type":"structure","required":["jsonPath"],"members":{"jsonPath":{},"matchEquals":{}}}},"authentication":{},"authenticationConfiguration":{"type":"structure","members":{"AllowedIPRange":{},"SecretToken":{}}}}},"S68":{"type":"structure","required":["type","message"],"members":{"type":{},"message":{},"externalExecutionId":{}}},"S6b":{"type":"structure","required":["revision","changeIdentifier"],"members":{"revision":{},"changeIdentifier":{},"created":{"type":"timestamp"},"revisionSummary":{}}},"S6d":{"type":"structure","members":{"summary":{},"externalExecutionId":{},"percentComplete":{"type":"integer"}}}}}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListActionExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"actionExecutionDetails"},"ListActionTypes":{"input_token":"nextToken","output_token":"nextToken","result_key":"actionTypes"},"ListPipelineExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"pipelineExecutionSummaries"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","result_key":"pipelines"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tags"},"ListWebhooks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"webhooks"}}}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"output":{"shape":"Sk"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sv"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sk"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"S10"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"LoginsToRemove":{"shape":"Sw"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sk"},"output":{"shape":"Sk"}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sg":{"type":"list","member":{}},"Sh":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"Sv":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"map","key":{},"value":{}},"S1c":{"type":"map","key":{},"value":{}},"S1e":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","serviceId":"Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"ValidationData":{"shape":"Sj"},"TemporaryPassword":{"shape":"Sn"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"User":{"shape":"St"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1e"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sw"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1h"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"AuthFlow":{},"AuthParameters":{"shape":"S1l"},"ClientMetadata":{"shape":"Sg"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S13"},"SourceUser":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{},"CompromisedCredentialsDetected":{"type":"boolean"}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2y"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S31"},"SoftwareTokenMfaSettings":{"shape":"S32"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username","Password"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Password":{"shape":"Sn"},"Permanent":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sn"},"ProposedPassword":{"shape":"Sn"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sn"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4u"},"LambdaConfig":{"shape":"S4y"},"AutoVerifiedAttributes":{"shape":"S4z"},"AliasAttributes":{"shape":"S51"},"UsernameAttributes":{"shape":"S53"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S58"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5d"},"EmailConfiguration":{"shape":"S5e"},"SmsConfiguration":{"shape":"S5i"},"UserPoolTags":{"shape":"S5j"},"AdminCreateUserConfig":{"shape":"S5m"},"Schema":{"shape":"S5p"},"UserPoolAddOns":{"shape":"S5q"},"UsernameConfiguration":{"shape":"S5s"},"AccountRecoverySetting":{"shape":"S5t"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5z"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S66"},"WriteAttributes":{"shape":"S66"},"ExplicitAuthFlows":{"shape":"S68"},"SupportedIdentityProviders":{"shape":"S6a"},"CallbackURLs":{"shape":"S6b"},"LogoutURLs":{"shape":"S6d"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6e"},"AllowedOAuthScopes":{"shape":"S6g"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6i"},"PreventUserExistenceErrors":{}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6m"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S6p"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"S10"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S77"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5z"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6m"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{},"CustomDomainConfig":{"shape":"S6p"}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"UserContextData":{"shape":"S3u"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S85"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1e"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"GetSigningCertificate":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"Certificate":{}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S8j"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"MFAOptions":{"shape":"Sw"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1h"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S85"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8t"},"SoftwareTokenMfaConfiguration":{"shape":"S8u"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1l"},"ClientMetadata":{"shape":"Sg"},"ClientId":{"shape":"S1j"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4i"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5j"}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4m"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1j"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4y"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9w"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9w"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"UserContextData":{"shape":"S3u"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S85"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1j"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2y"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CompromisedCredentialsRiskConfiguration":{"shape":"S78"},"AccountTakeoverRiskConfiguration":{"shape":"S7d"},"RiskExceptionConfiguration":{"shape":"S7m"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S77"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S8j"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S31"},"SoftwareTokenMfaSettings":{"shape":"S32"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8t"},"SoftwareTokenMfaConfiguration":{"shape":"S8u"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8t"},"SoftwareTokenMfaConfiguration":{"shape":"S8u"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sw"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"Password":{"shape":"Sn"},"UserAttributes":{"shape":"Sj"},"ValidationData":{"shape":"Sj"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S85"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S5j"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Sj"},"AccessToken":{"shape":"S1v"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S85"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4u"},"LambdaConfig":{"shape":"S4y"},"AutoVerifiedAttributes":{"shape":"S4z"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S58"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5d"},"EmailConfiguration":{"shape":"S5e"},"SmsConfiguration":{"shape":"S5i"},"UserPoolTags":{"shape":"S5j"},"AdminCreateUserConfig":{"shape":"S5m"},"UserPoolAddOns":{"shape":"S5q"},"AccountRecoverySetting":{"shape":"S5t"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S66"},"WriteAttributes":{"shape":"S66"},"ExplicitAuthFlows":{"shape":"S68"},"SupportedIdentityProviders":{"shape":"S6a"},"CallbackURLs":{"shape":"S6b"},"LogoutURLs":{"shape":"S6d"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6e"},"AllowedOAuthScopes":{"shape":"S6g"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6i"},"PreventUserExistenceErrors":{}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6m"}}}},"UpdateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId","CustomDomainConfig"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S6p"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sn":{"type":"string","sensitive":true},"St":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Sj"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sw"}}},"Sw":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1e":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Sj"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1h":{"type":"list","member":{}},"S1j":{"type":"string","sensitive":true},"S1l":{"type":"map","key":{},"value":{},"sensitive":true},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1e"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2y":{"type":"map","key":{},"value":{}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S32":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3s":{"type":"string","sensitive":true},"S3u":{"type":"structure","members":{"EncodedData":{}}},"S43":{"type":"map","key":{},"value":{}},"S44":{"type":"map","key":{},"value":{}},"S46":{"type":"list","member":{}},"S49":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4d":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4i":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"S4m":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4u":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"},"TemporaryPasswordValidityDays":{"type":"integer"}}}}},"S4y":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{},"UserMigration":{}}},"S4z":{"type":"list","member":{}},"S51":{"type":"list","member":{}},"S53":{"type":"list","member":{}},"S58":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S5d":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5e":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{},"EmailSendingAccount":{},"From":{},"ConfigurationSet":{}}},"S5i":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5j":{"type":"map","key":{},"value":{}},"S5m":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5p":{"type":"list","member":{"shape":"S4"}},"S5q":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5s":{"type":"structure","required":["CaseSensitive"],"members":{"CaseSensitive":{"type":"boolean"}}},"S5t":{"type":"structure","members":{"RecoveryMechanisms":{"type":"list","member":{"type":"structure","required":["Priority","Name"],"members":{"Priority":{"type":"integer"},"Name":{}}}}}},"S5z":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4u"},"LambdaConfig":{"shape":"S4y"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5p"},"AutoVerifiedAttributes":{"shape":"S4z"},"AliasAttributes":{"shape":"S51"},"UsernameAttributes":{"shape":"S53"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S58"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5d"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5e"},"SmsConfiguration":{"shape":"S5i"},"UserPoolTags":{"shape":"S5j"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"CustomDomain":{},"AdminCreateUserConfig":{"shape":"S5m"},"UserPoolAddOns":{"shape":"S5q"},"UsernameConfiguration":{"shape":"S5s"},"Arn":{},"AccountRecoverySetting":{"shape":"S5t"}}},"S66":{"type":"list","member":{}},"S68":{"type":"list","member":{}},"S6a":{"type":"list","member":{}},"S6b":{"type":"list","member":{}},"S6d":{"type":"list","member":{}},"S6e":{"type":"list","member":{}},"S6g":{"type":"list","member":{}},"S6i":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S6m":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1j"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S66"},"WriteAttributes":{"shape":"S66"},"ExplicitAuthFlows":{"shape":"S68"},"SupportedIdentityProviders":{"shape":"S6a"},"CallbackURLs":{"shape":"S6b"},"LogoutURLs":{"shape":"S6d"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6e"},"AllowedOAuthScopes":{"shape":"S6g"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6i"},"PreventUserExistenceErrors":{}}},"S6p":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"S77":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CompromisedCredentialsRiskConfiguration":{"shape":"S78"},"AccountTakeoverRiskConfiguration":{"shape":"S7d"},"RiskExceptionConfiguration":{"shape":"S7m"},"LastModifiedDate":{"type":"timestamp"}}},"S78":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S7d":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S7f"},"NoActionEmail":{"shape":"S7f"},"MfaEmail":{"shape":"S7f"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S7j"},"MediumAction":{"shape":"S7j"},"HighAction":{"shape":"S7j"}}}}},"S7f":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S7j":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S7m":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S85":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S8j":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8t":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5i"}}},"S8u":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9w":{"type":"list","member":{"shape":"St"}}}}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"AdminListGroupsForUser":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"AdminListUserAuthEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthEvents"},"ListGroups":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"ListIdentityProviders":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Providers"},"ListResourceServers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceServers"},"ListUserPoolClients":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPoolClients"},"ListUserPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPools"},"ListUsers":{"input_token":"PaginationToken","limit_key":"Limit","output_token":"PaginationToken","result_key":"Users"},"ListUsersInGroup":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Users"}}}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-sync","jsonVersion":"1.1","serviceFullName":"Amazon Cognito Sync","serviceId":"Cognito Sync","signatureVersion":"v4","protocol":"rest-json","uid":"cognito-sync-2014-06-30"},"operations":{"BulkPublish":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/bulkpublish","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolUsage":{"shape":"Sg"}}}},"DescribeIdentityUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"}}},"output":{"type":"structure","members":{"IdentityUsage":{"type":"structure","members":{"IdentityId":{},"IdentityPoolId":{},"LastModifiedDate":{"type":"timestamp"},"DatasetCount":{"type":"integer"},"DataStorage":{"type":"long"}}}}}},"GetBulkPublishDetails":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/getBulkPublishDetails","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"BulkPublishStartTime":{"type":"timestamp"},"BulkPublishCompleteTime":{"type":"timestamp"},"BulkPublishStatus":{},"FailureMessage":{}}}},"GetCognitoEvents":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"Events":{"shape":"Sq"}}}},"GetIdentityPoolConfiguration":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets","responseCode":200},"input":{"type":"structure","required":["IdentityId","IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"shape":"S8"}},"Count":{"type":"integer"},"NextToken":{}}}},"ListIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IdentityPoolUsages":{"type":"list","member":{"shape":"Sg"}},"MaxResults":{"type":"integer"},"Count":{"type":"integer"},"NextToken":{}}}},"ListRecords":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"LastSyncCount":{"location":"querystring","locationName":"lastSyncCount","type":"long"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SyncSessionToken":{"location":"querystring","locationName":"syncSessionToken"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"},"NextToken":{},"Count":{"type":"integer"},"DatasetSyncCount":{"type":"long"},"LastModifiedBy":{},"MergedDatasetNames":{"type":"list","member":{}},"DatasetExists":{"type":"boolean"},"DatasetDeletedAfterRequestedSyncCount":{"type":"boolean"},"SyncSessionToken":{}}}},"RegisterDevice":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identity/{IdentityId}/device","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","Platform","Token"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"Platform":{},"Token":{}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"SetCognitoEvents":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","Events"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"Events":{"shape":"Sq"}}}},"SetIdentityPoolConfiguration":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"SubscribeToDataset":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UnsubscribeFromDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UpdateRecords":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","SyncSessionToken"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{},"RecordPatches":{"type":"list","member":{"type":"structure","required":["Op","Key","SyncCount"],"members":{"Op":{},"Key":{},"Value":{},"SyncCount":{"type":"long"},"DeviceLastModifiedDate":{"type":"timestamp"}}}},"SyncSessionToken":{},"ClientContext":{"location":"header","locationName":"x-amz-Client-Context"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"}}}}},"shapes":{"S8":{"type":"structure","members":{"IdentityId":{},"DatasetName":{},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DataStorage":{"type":"long"},"NumRecords":{"type":"long"}}},"Sg":{"type":"structure","members":{"IdentityPoolId":{},"SyncSessionsCount":{"type":"long"},"DataStorage":{"type":"long"},"LastModifiedDate":{"type":"timestamp"}}},"Sq":{"type":"map","key":{},"value":{}},"Sv":{"type":"structure","members":{"ApplicationArns":{"type":"list","member":{}},"RoleArn":{}}},"Sz":{"type":"structure","members":{"StreamName":{},"RoleArn":{},"StreamingStatus":{}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"SyncCount":{"type":"long"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DeviceLastModifiedDate":{"type":"timestamp"}}}}},"examples":{}}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"comprehend","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Comprehend","serviceId":"Comprehend","signatureVersion":"v4","signingName":"comprehend","targetPrefix":"Comprehend_20171127","uid":"comprehend-2017-11-27"},"operations":{"BatchDetectDominantLanguage":{"input":{"type":"structure","required":["TextList"],"members":{"TextList":{"shape":"S2"}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Languages":{"shape":"S8"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectEntities":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Entities":{"shape":"Si"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectKeyPhrases":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"KeyPhrases":{"shape":"Sp"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectSentiment":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Sentiment":{},"SentimentScore":{"shape":"Sw"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectSyntax":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"SyntaxTokens":{"shape":"S12"}}}},"ErrorList":{"shape":"Sb"}}}},"ClassifyDocument":{"input":{"type":"structure","required":["Text","EndpointArn"],"members":{"Text":{},"EndpointArn":{}}},"output":{"type":"structure","members":{"Classes":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}}}}},"CreateDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"DocumentClassifierName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S1g"},"InputDataConfig":{"shape":"S1k"},"OutputDataConfig":{"shape":"S1n"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"},"Mode":{}}},"output":{"type":"structure","members":{"DocumentClassifierArn":{}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointName","ModelArn","DesiredInferenceUnits"],"members":{"EndpointName":{},"ModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S1g"}}},"output":{"type":"structure","members":{"EndpointArn":{}}}},"CreateEntityRecognizer":{"input":{"type":"structure","required":["RecognizerName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"RecognizerName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S1g"},"InputDataConfig":{"shape":"S25"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"EntityRecognizerArn":{}}}},"DeleteDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"DescribeDocumentClassificationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DocumentClassificationJobProperties":{"shape":"S2n"}}}},"DescribeDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{"DocumentClassifierProperties":{"shape":"S2x"}}}},"DescribeDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobProperties":{"shape":"S34"}}}},"DescribeEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"EndpointProperties":{"shape":"S37"}}}},"DescribeEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"EntitiesDetectionJobProperties":{"shape":"S3b"}}}},"DescribeEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{"EntityRecognizerProperties":{"shape":"S3e"}}}},"DescribeKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobProperties":{"shape":"S3m"}}}},"DescribeSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"SentimentDetectionJobProperties":{"shape":"S3p"}}}},"DescribeTopicsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TopicsDetectionJobProperties":{"shape":"S3s"}}}},"DetectDominantLanguage":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","members":{"Languages":{"shape":"S8"}}}},"DetectEntities":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Entities":{"shape":"Si"}}}},"DetectKeyPhrases":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"KeyPhrases":{"shape":"Sp"}}}},"DetectSentiment":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Sentiment":{},"SentimentScore":{"shape":"Sw"}}}},"DetectSyntax":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"SyntaxTokens":{"shape":"S12"}}}},"ListDocumentClassificationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassificationJobPropertiesList":{"type":"list","member":{"shape":"S2n"}},"NextToken":{}}}},"ListDocumentClassifiers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassifierPropertiesList":{"type":"list","member":{"shape":"S2x"}},"NextToken":{}}}},"ListDominantLanguageDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobPropertiesList":{"type":"list","member":{"shape":"S34"}},"NextToken":{}}}},"ListEndpoints":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"ModelArn":{},"Status":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EndpointPropertiesList":{"type":"list","member":{"shape":"S37"}},"NextToken":{}}}},"ListEntitiesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntitiesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S3b"}},"NextToken":{}}}},"ListEntityRecognizers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntityRecognizerPropertiesList":{"type":"list","member":{"shape":"S3e"}},"NextToken":{}}}},"ListKeyPhrasesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S3m"}},"NextToken":{}}}},"ListSentimentDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SentimentDetectionJobPropertiesList":{"type":"list","member":{"shape":"S3p"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"S1g"}}}},"ListTopicsDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TopicsDetectionJobPropertiesList":{"type":"list","member":{"shape":"S3s"}},"NextToken":{}}}},"StartDocumentClassificationJob":{"input":{"type":"structure","required":["DocumentClassifierArn","InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"JobName":{},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartDominantLanguageDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartEntitiesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"JobName":{},"EntityRecognizerArn":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartSentimentDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartTopicsDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"JobName":{},"NumberOfTopics":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTrainingDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"StopTrainingEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S1g"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateEndpoint":{"input":{"type":"structure","required":["EndpointArn","DesiredInferenceUnits"],"members":{"EndpointArn":{},"DesiredInferenceUnits":{"type":"integer"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S8":{"type":"list","member":{"type":"structure","members":{"LanguageCode":{},"Score":{"type":"float"}}}},"Sb":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}},"Si":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Type":{},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"Sp":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"Sw":{"type":"structure","members":{"Positive":{"type":"float"},"Negative":{"type":"float"},"Neutral":{"type":"float"},"Mixed":{"type":"float"}}},"S12":{"type":"list","member":{"type":"structure","members":{"TokenId":{"type":"integer"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"PartOfSpeech":{"type":"structure","members":{"Tag":{},"Score":{"type":"float"}}}}}},"S1g":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1k":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"LabelDelimiter":{}}},"S1n":{"type":"structure","members":{"S3Uri":{},"KmsKeyId":{}}},"S1q":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"type":"list","member":{}}}},"S25":{"type":"structure","required":["EntityTypes","Documents"],"members":{"EntityTypes":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{}}}},"Documents":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"Annotations":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"EntityList":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}}}},"S2n":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"S2s":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"InputFormat":{}}},"S2u":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{}}},"S2x":{"type":"structure","members":{"DocumentClassifierArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S1k"},"OutputDataConfig":{"shape":"S1n"},"ClassifierMetadata":{"type":"structure","members":{"NumberOfLabels":{"type":"integer"},"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Accuracy":{"type":"double"},"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"},"MicroPrecision":{"type":"double"},"MicroRecall":{"type":"double"},"MicroF1Score":{"type":"double"},"HammingLoss":{"type":"double"}}}}},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"},"Mode":{}}},"S34":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"S37":{"type":"structure","members":{"EndpointArn":{},"Status":{},"Message":{},"ModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"CurrentInferenceUnits":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}},"S3b":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EntityRecognizerArn":{},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"S3e":{"type":"structure","members":{"EntityRecognizerArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S25"},"RecognizerMetadata":{"type":"structure","members":{"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"EntityTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"NumberOfTrainMentions":{"type":"integer"}}}}}},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"S3m":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"S3p":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}},"S3s":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2s"},"OutputDataConfig":{"shape":"S2u"},"NumberOfTopics":{"type":"integer"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1q"}}}}}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDocumentClassificationJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDocumentClassifiers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDominantLanguageDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntitiesDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntityRecognizers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListKeyPhrasesDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSentimentDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTopicsDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-30","endpointPrefix":"comprehendmedical","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ComprehendMedical","serviceFullName":"AWS Comprehend Medical","serviceId":"ComprehendMedical","signatureVersion":"v4","signingName":"comprehendmedical","targetPrefix":"ComprehendMedical_20181030","uid":"comprehendmedical-2018-10-30"},"operations":{"DescribeEntitiesDetectionV2Job":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeICD10CMInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribePHIDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeRxNormInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DetectEntities":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"Sr"},"UnmappedAttributes":{"shape":"S14"},"PaginationToken":{},"ModelVersion":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use DetectEntitiesV2 instead."},"DetectEntitiesV2":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"Sr"},"UnmappedAttributes":{"shape":"S14"},"PaginationToken":{},"ModelVersion":{}}}},"DetectPHI":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"Sr"},"PaginationToken":{},"ModelVersion":{}}}},"InferICD10CM":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S1k"}}}},"Traits":{"shape":"S1k"},"ICD10CMConcepts":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}}}}},"PaginationToken":{},"ModelVersion":{}}}},"InferRxNorm":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S1y"}}}},"Traits":{"shape":"S1y"},"RxNormConcepts":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}}}}},"PaginationToken":{},"ModelVersion":{}}}},"ListEntitiesDetectionV2Jobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S24"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S27"},"NextToken":{}}}},"ListICD10CMInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S24"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S27"},"NextToken":{}}}},"ListPHIDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S24"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S27"},"NextToken":{}}}},"ListRxNormInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S24"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S27"},"NextToken":{}}}},"StartEntitiesDetectionV2Job":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartICD10CMInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartPHIDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartRxNormInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopEntitiesDetectionV2Job":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopICD10CMInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopPHIDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopRxNormInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}}},"shapes":{"S4":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"LanguageCode":{},"DataAccessRoleArn":{},"ManifestFilePath":{},"KMSKey":{},"ModelVersion":{}}},"S9":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Key":{}}},"Sc":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Key":{}}},"Sr":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Score":{"type":"float"},"Text":{},"Category":{},"Type":{},"Traits":{"shape":"Sy"},"Attributes":{"type":"list","member":{"shape":"S12"}}}}},"Sy":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S12":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"RelationshipType":{},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Category":{},"Traits":{"shape":"Sy"}}},"S14":{"type":"list","member":{"type":"structure","members":{"Type":{},"Attribute":{"shape":"S12"}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S1y":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S24":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"S27":{"type":"list","member":{"shape":"S4"}}}}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-12","endpointPrefix":"config","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Config Service","serviceFullName":"AWS Config","serviceId":"Config Service","signatureVersion":"v4","targetPrefix":"StarlingDoveService","uid":"config-2014-11-12"},"operations":{"BatchGetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifiers"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"BaseConfigurationItems":{"shape":"Sb"},"UnprocessedResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}}},"BatchGetResourceConfig":{"input":{"type":"structure","required":["resourceKeys"],"members":{"resourceKeys":{"shape":"Sq"}}},"output":{"type":"structure","members":{"baseConfigurationItems":{"shape":"Sb"},"unprocessedResourceKeys":{"shape":"Sq"}}}},"DeleteAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{}}}},"DeleteConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}}},"DeleteConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{}}}},"DeleteConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"DeleteConformancePack":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{}}}},"DeleteDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannelName"],"members":{"DeliveryChannelName":{}}}},"DeleteEvaluationResults":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{}}},"DeleteOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{}}}},"DeleteOrganizationConformancePack":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{}}}},"DeletePendingAggregationRequest":{"input":{"type":"structure","required":["RequesterAccountId","RequesterAwsRegion"],"members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"DeleteRemediationConfiguration":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceType":{}}},"output":{"type":"structure","members":{}}},"DeleteRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1f"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S1f"}}}}}}},"DeleteResourceConfig":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}}},"DeleteRetentionConfiguration":{"input":{"type":"structure","required":["RetentionConfigurationName"],"members":{"RetentionConfigurationName":{}}}},"DeliverConfigSnapshot":{"input":{"type":"structure","required":["deliveryChannelName"],"members":{"deliveryChannelName":{}}},"output":{"type":"structure","members":{"configSnapshotId":{}}}},"DescribeAggregateComplianceByConfigRules":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{},"AccountId":{},"AwsRegion":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S20"},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"DescribeAggregationAuthorizations":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregationAuthorizations":{"type":"list","member":{"shape":"S28"}},"NextToken":{}}}},"DescribeComplianceByConfigRule":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2b"},"ComplianceTypes":{"shape":"S2c"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S20"}}}},"NextToken":{}}}},"DescribeComplianceByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S2c"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByResources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Compliance":{"shape":"S20"}}}},"NextToken":{}}}},"DescribeConfigRuleEvaluationStatus":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2b"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigRulesEvaluationStatus":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"LastSuccessfulInvocationTime":{"type":"timestamp"},"LastFailedInvocationTime":{"type":"timestamp"},"LastSuccessfulEvaluationTime":{"type":"timestamp"},"LastFailedEvaluationTime":{"type":"timestamp"},"FirstActivatedTime":{"type":"timestamp"},"LastDeactivatedTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{},"FirstEvaluationStarted":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeConfigRules":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2b"},"NextToken":{}}},"output":{"type":"structure","members":{"ConfigRules":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"DescribeConfigurationAggregatorSourcesStatus":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"UpdateStatus":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"AggregatedSourceStatusList":{"type":"list","member":{"type":"structure","members":{"SourceId":{},"SourceType":{},"AwsRegion":{},"LastUpdateStatus":{},"LastUpdateTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{}}}},"NextToken":{}}}},"DescribeConfigurationAggregators":{"input":{"type":"structure","members":{"ConfigurationAggregatorNames":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationAggregators":{"type":"list","member":{"shape":"S3h"}},"NextToken":{}}}},"DescribeConfigurationRecorderStatus":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S3p"}}},"output":{"type":"structure","members":{"ConfigurationRecordersStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"lastStartTime":{"type":"timestamp"},"lastStopTime":{"type":"timestamp"},"recording":{"type":"boolean"},"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}},"DescribeConfigurationRecorders":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S3p"}}},"output":{"type":"structure","members":{"ConfigurationRecorders":{"type":"list","member":{"shape":"S3x"}}}}},"DescribeConformancePackCompliance":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"Filters":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S44"},"ComplianceType":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackName","ConformancePackRuleComplianceList"],"members":{"ConformancePackName":{},"ConformancePackRuleComplianceList":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{}}}},"NextToken":{}}}},"DescribeConformancePackStatus":{"input":{"type":"structure","members":{"ConformancePackNames":{"shape":"S4b"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackStatusDetails":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackId","ConformancePackArn","ConformancePackState","StackArn","LastUpdateRequestedTime"],"members":{"ConformancePackName":{},"ConformancePackId":{},"ConformancePackArn":{},"ConformancePackState":{},"StackArn":{},"ConformancePackStatusReason":{},"LastUpdateRequestedTime":{"type":"timestamp"},"LastUpdateCompletedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeConformancePacks":{"input":{"type":"structure","members":{"ConformancePackNames":{"shape":"S4b"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackDetails":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackArn","ConformancePackId","DeliveryS3Bucket"],"members":{"ConformancePackName":{},"ConformancePackArn":{},"ConformancePackId":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S4r"},"LastUpdateRequestedTime":{"type":"timestamp"},"CreatedBy":{}}}},"NextToken":{}}}},"DescribeDeliveryChannelStatus":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S4w"}}},"output":{"type":"structure","members":{"DeliveryChannelsStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"configSnapshotDeliveryInfo":{"shape":"S50"},"configHistoryDeliveryInfo":{"shape":"S50"},"configStreamDeliveryInfo":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}}}},"DescribeDeliveryChannels":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S4w"}}},"output":{"type":"structure","members":{"DeliveryChannels":{"type":"list","member":{"shape":"S56"}}}}},"DescribeOrganizationConfigRuleStatuses":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S59"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationRuleStatus"],"members":{"OrganizationConfigRuleName":{},"OrganizationRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConfigRules":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S59"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRules":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationConfigRuleArn"],"members":{"OrganizationConfigRuleName":{},"OrganizationConfigRuleArn":{},"OrganizationManagedRuleMetadata":{"shape":"S5j"},"OrganizationCustomRuleMetadata":{"shape":"S5o"},"ExcludedAccounts":{"shape":"S5r"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConformancePackStatuses":{"input":{"type":"structure","members":{"OrganizationConformancePackNames":{"shape":"S5t"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePackStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConformancePackName","Status"],"members":{"OrganizationConformancePackName":{},"Status":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConformancePacks":{"input":{"type":"structure","members":{"OrganizationConformancePackNames":{"shape":"S5t"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePacks":{"type":"list","member":{"type":"structure","required":["OrganizationConformancePackName","OrganizationConformancePackArn","DeliveryS3Bucket","LastUpdateTime"],"members":{"OrganizationConformancePackName":{},"OrganizationConformancePackArn":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S4r"},"ExcludedAccounts":{"shape":"S5r"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribePendingAggregationRequests":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PendingAggregationRequests":{"type":"list","member":{"type":"structure","members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"NextToken":{}}}},"DescribeRemediationConfigurations":{"input":{"type":"structure","required":["ConfigRuleNames"],"members":{"ConfigRuleNames":{"shape":"S2b"}}},"output":{"type":"structure","members":{"RemediationConfigurations":{"shape":"S69"}}}},"DescribeRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1f"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExceptions":{"shape":"S6p"},"NextToken":{}}}},"DescribeRemediationExecutionStatus":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Sq"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExecutionStatuses":{"type":"list","member":{"type":"structure","members":{"ResourceKey":{"shape":"Sr"},"State":{},"StepDetails":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"ErrorMessage":{},"StartTime":{"type":"timestamp"},"StopTime":{"type":"timestamp"}}}},"InvocationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeRetentionConfigurations":{"input":{"type":"structure","members":{"RetentionConfigurationNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"RetentionConfigurations":{"type":"list","member":{"shape":"S73"}},"NextToken":{}}}},"GetAggregateComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ConfigRuleName","AccountId","AwsRegion"],"members":{"ConfigurationAggregatorName":{},"ConfigRuleName":{},"AccountId":{},"AwsRegion":{},"ComplianceType":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateEvaluationResults":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S79"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"GetAggregateConfigRuleComplianceSummary":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"AccountId":{},"AwsRegion":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GroupByKey":{},"AggregateComplianceCounts":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"ComplianceSummary":{"shape":"S7h"}}}},"NextToken":{}}}},"GetAggregateDiscoveredResourceCounts":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ResourceType":{},"AccountId":{},"Region":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["TotalDiscoveredResources"],"members":{"TotalDiscoveredResources":{"type":"long"},"GroupByKey":{},"GroupedResourceCounts":{"type":"list","member":{"type":"structure","required":["GroupName","ResourceCount"],"members":{"GroupName":{},"ResourceCount":{"type":"long"}}}},"NextToken":{}}}},"GetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifier"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifier":{"shape":"S4"}}},"output":{"type":"structure","members":{"ConfigurationItem":{"shape":"S7r"}}}},"GetComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ComplianceTypes":{"shape":"S2c"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S83"},"NextToken":{}}}},"GetComplianceDetailsByResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S2c"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S83"},"NextToken":{}}}},"GetComplianceSummaryByConfigRule":{"output":{"type":"structure","members":{"ComplianceSummary":{"shape":"S7h"}}}},"GetComplianceSummaryByResourceType":{"input":{"type":"structure","members":{"ResourceTypes":{"shape":"S89"}}},"output":{"type":"structure","members":{"ComplianceSummariesByResourceType":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ComplianceSummary":{"shape":"S7h"}}}}}}},"GetConformancePackComplianceDetails":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"Filters":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S44"},"ComplianceType":{},"ResourceType":{},"ResourceIds":{"type":"list","member":{}}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"ConformancePackRuleEvaluationResults":{"type":"list","member":{"type":"structure","required":["ComplianceType","EvaluationResultIdentifier","ConfigRuleInvokedTime","ResultRecordedTime"],"members":{"ComplianceType":{},"EvaluationResultIdentifier":{"shape":"S79"},"ConfigRuleInvokedTime":{"type":"timestamp"},"ResultRecordedTime":{"type":"timestamp"},"Annotation":{}}}},"NextToken":{}}}},"GetConformancePackComplianceSummary":{"input":{"type":"structure","required":["ConformancePackNames"],"members":{"ConformancePackNames":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackComplianceSummaryList":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackComplianceStatus"],"members":{"ConformancePackName":{},"ConformancePackComplianceStatus":{}}}},"NextToken":{}}}},"GetDiscoveredResourceCounts":{"input":{"type":"structure","members":{"resourceTypes":{"shape":"S89"},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"totalDiscoveredResources":{"type":"long"},"resourceCounts":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"count":{"type":"long"}}}},"nextToken":{}}}},"GetOrganizationConfigRuleDetailedStatus":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"Filters":{"type":"structure","members":{"AccountId":{},"MemberAccountRuleStatus":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleDetailedStatus":{"type":"list","member":{"type":"structure","required":["AccountId","ConfigRuleName","MemberAccountRuleStatus"],"members":{"AccountId":{},"ConfigRuleName":{},"MemberAccountRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetOrganizationConformancePackDetailedStatus":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{},"Filters":{"type":"structure","members":{"AccountId":{},"Status":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePackDetailedStatuses":{"type":"list","member":{"type":"structure","required":["AccountId","ConformancePackName","Status"],"members":{"AccountId":{},"ConformancePackName":{},"Status":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetResourceConfigHistory":{"input":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{},"laterTime":{"type":"timestamp"},"earlierTime":{"type":"timestamp"},"chronologicalOrder":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"configurationItems":{"type":"list","member":{"shape":"S7r"}},"nextToken":{}}}},"ListAggregateDiscoveredResources":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceType"],"members":{"ConfigurationAggregatorName":{},"ResourceType":{},"Filters":{"type":"structure","members":{"AccountId":{},"ResourceId":{},"ResourceName":{},"Region":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"resourceIds":{"type":"list","member":{}},"resourceName":{},"limit":{"type":"integer"},"includeDeletedResources":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","members":{"resourceIdentifiers":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"resourceDeletionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S9p"},"NextToken":{}}}},"PutAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"Tags":{"shape":"S9u"}}},"output":{"type":"structure","members":{"AggregationAuthorization":{"shape":"S28"}}}},"PutConfigRule":{"input":{"type":"structure","required":["ConfigRule"],"members":{"ConfigRule":{"shape":"S2t"},"Tags":{"shape":"S9u"}}}},"PutConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"AccountAggregationSources":{"shape":"S3j"},"OrganizationAggregationSource":{"shape":"S3n"},"Tags":{"shape":"S9u"}}},"output":{"type":"structure","members":{"ConfigurationAggregator":{"shape":"S3h"}}}},"PutConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorder"],"members":{"ConfigurationRecorder":{"shape":"S3x"}}}},"PutConformancePack":{"input":{"type":"structure","required":["ConformancePackName","DeliveryS3Bucket"],"members":{"ConformancePackName":{},"TemplateS3Uri":{},"TemplateBody":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S4r"}}},"output":{"type":"structure","members":{"ConformancePackArn":{}}}},"PutDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannel"],"members":{"DeliveryChannel":{"shape":"S56"}}}},"PutEvaluations":{"input":{"type":"structure","required":["ResultToken"],"members":{"Evaluations":{"shape":"Sa6"},"ResultToken":{},"TestMode":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEvaluations":{"shape":"Sa6"}}}},"PutOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"OrganizationManagedRuleMetadata":{"shape":"S5j"},"OrganizationCustomRuleMetadata":{"shape":"S5o"},"ExcludedAccounts":{"shape":"S5r"}}},"output":{"type":"structure","members":{"OrganizationConfigRuleArn":{}}}},"PutOrganizationConformancePack":{"input":{"type":"structure","required":["OrganizationConformancePackName","DeliveryS3Bucket"],"members":{"OrganizationConformancePackName":{},"TemplateS3Uri":{},"TemplateBody":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S4r"},"ExcludedAccounts":{"shape":"S5r"}}},"output":{"type":"structure","members":{"OrganizationConformancePackArn":{}}}},"PutRemediationConfigurations":{"input":{"type":"structure","required":["RemediationConfigurations"],"members":{"RemediationConfigurations":{"shape":"S69"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S69"}}}}}}},"PutRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1f"},"Message":{},"ExpirationTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S6p"}}}}}}},"PutResourceConfig":{"input":{"type":"structure","required":["ResourceType","SchemaVersionId","ResourceId","Configuration"],"members":{"ResourceType":{},"SchemaVersionId":{},"ResourceId":{},"ResourceName":{},"Configuration":{},"Tags":{"shape":"S7t"}}}},"PutRetentionConfiguration":{"input":{"type":"structure","required":["RetentionPeriodInDays"],"members":{"RetentionPeriodInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"RetentionConfiguration":{"shape":"S73"}}}},"SelectAggregateResourceConfig":{"input":{"type":"structure","required":["Expression","ConfigurationAggregatorName"],"members":{"Expression":{},"ConfigurationAggregatorName":{},"Limit":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"shape":"Sat"},"QueryInfo":{"shape":"Sau"},"NextToken":{}}}},"SelectResourceConfig":{"input":{"type":"structure","required":["Expression"],"members":{"Expression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"shape":"Sat"},"QueryInfo":{"shape":"Sau"},"NextToken":{}}}},"StartConfigRulesEvaluation":{"input":{"type":"structure","members":{"ConfigRuleNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"StartRemediationExecution":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Sq"}}},"output":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"Sq"}}}},"StopConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S9p"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}}},"shapes":{"S4":{"type":"structure","required":["SourceAccountId","SourceRegion","ResourceId","ResourceType"],"members":{"SourceAccountId":{},"SourceRegion":{},"ResourceId":{},"ResourceType":{},"ResourceName":{}}},"Sb":{"type":"list","member":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"}}}},"Sl":{"type":"map","key":{},"value":{}},"Sq":{"type":"list","member":{"shape":"Sr"}},"Sr":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{}}},"S1f":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{}}}},"S20":{"type":"structure","members":{"ComplianceType":{},"ComplianceContributorCount":{"shape":"S21"}}},"S21":{"type":"structure","members":{"CappedCount":{"type":"integer"},"CapExceeded":{"type":"boolean"}}},"S28":{"type":"structure","members":{"AggregationAuthorizationArn":{},"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"CreationTime":{"type":"timestamp"}}},"S2b":{"type":"list","member":{}},"S2c":{"type":"list","member":{}},"S2t":{"type":"structure","required":["Source"],"members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"Description":{},"Scope":{"type":"structure","members":{"ComplianceResourceTypes":{"type":"list","member":{}},"TagKey":{},"TagValue":{},"ComplianceResourceId":{}}},"Source":{"type":"structure","required":["Owner","SourceIdentifier"],"members":{"Owner":{},"SourceIdentifier":{},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"EventSource":{},"MessageType":{},"MaximumExecutionFrequency":{}}}}}},"InputParameters":{},"MaximumExecutionFrequency":{},"ConfigRuleState":{},"CreatedBy":{}}},"S3h":{"type":"structure","members":{"ConfigurationAggregatorName":{},"ConfigurationAggregatorArn":{},"AccountAggregationSources":{"shape":"S3j"},"OrganizationAggregationSource":{"shape":"S3n"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S3j":{"type":"list","member":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"type":"list","member":{}},"AllAwsRegions":{"type":"boolean"},"AwsRegions":{"shape":"S3m"}}}},"S3m":{"type":"list","member":{}},"S3n":{"type":"structure","required":["RoleArn"],"members":{"RoleArn":{},"AwsRegions":{"shape":"S3m"},"AllAwsRegions":{"type":"boolean"}}},"S3p":{"type":"list","member":{}},"S3x":{"type":"structure","members":{"name":{},"roleARN":{},"recordingGroup":{"type":"structure","members":{"allSupported":{"type":"boolean"},"includeGlobalResourceTypes":{"type":"boolean"},"resourceTypes":{"type":"list","member":{}}}}}},"S44":{"type":"list","member":{}},"S4b":{"type":"list","member":{}},"S4r":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}},"S4w":{"type":"list","member":{}},"S50":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastAttemptTime":{"type":"timestamp"},"lastSuccessfulTime":{"type":"timestamp"},"nextDeliveryTime":{"type":"timestamp"}}},"S56":{"type":"structure","members":{"name":{},"s3BucketName":{},"s3KeyPrefix":{},"snsTopicARN":{},"configSnapshotDeliveryProperties":{"type":"structure","members":{"deliveryFrequency":{}}}}},"S59":{"type":"list","member":{}},"S5j":{"type":"structure","required":["RuleIdentifier"],"members":{"Description":{},"RuleIdentifier":{},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S5m"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S5m":{"type":"list","member":{}},"S5o":{"type":"structure","required":["LambdaFunctionArn","OrganizationConfigRuleTriggerTypes"],"members":{"Description":{},"LambdaFunctionArn":{},"OrganizationConfigRuleTriggerTypes":{"type":"list","member":{}},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S5m"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S5r":{"type":"list","member":{}},"S5t":{"type":"list","member":{}},"S69":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","TargetType","TargetId"],"members":{"ConfigRuleName":{},"TargetType":{},"TargetId":{},"TargetVersion":{},"Parameters":{"type":"map","key":{},"value":{"type":"structure","members":{"ResourceValue":{"type":"structure","required":["Value"],"members":{"Value":{}}},"StaticValue":{"type":"structure","required":["Values"],"members":{"Values":{"type":"list","member":{}}}}}}},"ResourceType":{},"Automatic":{"type":"boolean"},"ExecutionControls":{"type":"structure","members":{"SsmControls":{"type":"structure","members":{"ConcurrentExecutionRatePercentage":{"type":"integer"},"ErrorPercentage":{"type":"integer"}}}}},"MaximumAutomaticAttempts":{"type":"integer"},"RetryAttemptSeconds":{"type":"long"},"Arn":{},"CreatedByService":{}}}},"S6p":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","ResourceType","ResourceId"],"members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{},"Message":{},"ExpirationTime":{"type":"timestamp"}}}},"S73":{"type":"structure","required":["Name","RetentionPeriodInDays"],"members":{"Name":{},"RetentionPeriodInDays":{"type":"integer"}}},"S79":{"type":"structure","members":{"EvaluationResultQualifier":{"type":"structure","members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{}}},"OrderingTimestamp":{"type":"timestamp"}}},"S7h":{"type":"structure","members":{"CompliantResourceCount":{"shape":"S21"},"NonCompliantResourceCount":{"shape":"S21"},"ComplianceSummaryTimestamp":{"type":"timestamp"}}},"S7r":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"configurationItemMD5Hash":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"tags":{"shape":"S7t"},"relatedEvents":{"type":"list","member":{}},"relationships":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"relationshipName":{}}}},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"}}},"S7t":{"type":"map","key":{},"value":{}},"S83":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S79"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"ResultToken":{}}}},"S89":{"type":"list","member":{}},"S9p":{"type":"list","member":{"shape":"S9q"}},"S9q":{"type":"structure","members":{"Key":{},"Value":{}}},"S9u":{"type":"list","member":{"shape":"S9q"}},"Sa6":{"type":"list","member":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}},"Sat":{"type":"list","member":{}},"Sau":{"type":"structure","members":{"SelectFields":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}}}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeRemediationExceptions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeRemediationExecutionStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"RemediationExecutionStatuses"},"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"},"SelectAggregateResourceConfig":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-08-08","endpointPrefix":"connect","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon Connect","serviceFullName":"Amazon Connect Service","serviceId":"Connect","signatureVersion":"v4","signingName":"connect","uid":"connect-2017-08-08"},"operations":{"CreateUser":{"http":{"method":"PUT","requestUri":"/users/{InstanceId}"},"input":{"type":"structure","required":["Username","PhoneConfig","SecurityProfileIds","RoutingProfileId","InstanceId"],"members":{"Username":{},"Password":{},"IdentityInfo":{"shape":"S4"},"PhoneConfig":{"shape":"S8"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"Se"},"RoutingProfileId":{},"HierarchyGroupId":{},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"UserId":{},"UserArn":{}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["InstanceId","UserId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"User":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{},"IdentityInfo":{"shape":"S4"},"PhoneConfig":{"shape":"S8"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"Se"},"RoutingProfileId":{},"HierarchyGroupId":{},"Tags":{"shape":"Sj"}}}}}},"DescribeUserHierarchyGroup":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"},"input":{"type":"structure","required":["HierarchyGroupId","InstanceId"],"members":{"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyGroup":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LevelId":{},"HierarchyPath":{"type":"structure","members":{"LevelOne":{"shape":"Sz"},"LevelTwo":{"shape":"Sz"},"LevelThree":{"shape":"Sz"},"LevelFour":{"shape":"Sz"},"LevelFive":{"shape":"Sz"}}}}}}}},"DescribeUserHierarchyStructure":{"http":{"method":"GET","requestUri":"/user-hierarchy-structure/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyStructure":{"type":"structure","members":{"LevelOne":{"shape":"S13"},"LevelTwo":{"shape":"S13"},"LevelThree":{"shape":"S13"},"LevelFour":{"shape":"S13"},"LevelFive":{"shape":"S13"}}}}}},"GetContactAttributes":{"http":{"method":"GET","requestUri":"/contact/attributes/{InstanceId}/{InitialContactId}"},"input":{"type":"structure","required":["InstanceId","InitialContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"InitialContactId":{"location":"uri","locationName":"InitialContactId"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S18"}}}},"GetCurrentMetricData":{"http":{"requestUri":"/metrics/current/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Filters","CurrentMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Filters":{"shape":"S1c"},"Groupings":{"shape":"S1h"},"CurrentMetrics":{"type":"list","member":{"shape":"S1k"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"S1s"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"S1k"},"Value":{"type":"double"}}}}}}},"DataSnapshotTime":{"type":"timestamp"}}}},"GetFederationToken":{"http":{"method":"GET","requestUri":"/user/federate/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"Credentials":{"type":"structure","members":{"AccessToken":{"shape":"S21"},"AccessTokenExpiration":{"type":"timestamp"},"RefreshToken":{"shape":"S21"},"RefreshTokenExpiration":{"type":"timestamp"}}}}}},"GetMetricData":{"http":{"requestUri":"/metrics/historical/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","StartTime","EndTime","Filters","HistoricalMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Filters":{"shape":"S1c"},"Groupings":{"shape":"S1h"},"HistoricalMetrics":{"type":"list","member":{"shape":"S24"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"S1s"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"S24"},"Value":{"type":"double"}}}}}}}}}},"ListContactFlows":{"http":{"method":"GET","requestUri":"/contact-flows-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowTypes":{"location":"querystring","locationName":"contactFlowTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ContactFlowSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"ContactFlowType":{}}}},"NextToken":{}}}},"ListHoursOfOperations":{"http":{"method":"GET","requestUri":"/hours-of-operations-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"HoursOfOperationSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListPhoneNumbers":{"http":{"method":"GET","requestUri":"/phone-numbers-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PhoneNumberTypes":{"location":"querystring","locationName":"phoneNumberTypes","type":"list","member":{}},"PhoneNumberCountryCodes":{"location":"querystring","locationName":"phoneNumberCountryCodes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"PhoneNumberSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"PhoneNumber":{},"PhoneNumberType":{},"PhoneNumberCountryCode":{}}}},"NextToken":{}}}},"ListQueues":{"http":{"method":"GET","requestUri":"/queues-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueTypes":{"location":"querystring","locationName":"queueTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"QueueSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"QueueType":{}}}},"NextToken":{}}}},"ListRoutingProfiles":{"http":{"method":"GET","requestUri":"/routing-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"RoutingProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"SecurityProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sj"}}}},"ListUserHierarchyGroups":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserHierarchyGroupSummaryList":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/users-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{}}}},"NextToken":{}}}},"StartChatContact":{"http":{"method":"PUT","requestUri":"/contact/chat"},"input":{"type":"structure","required":["InstanceId","ContactFlowId","ParticipantDetails"],"members":{"InstanceId":{},"ContactFlowId":{},"Attributes":{"shape":"S18"},"ParticipantDetails":{"type":"structure","required":["DisplayName"],"members":{"DisplayName":{}}},"InitialMessage":{"type":"structure","required":["ContentType","Content"],"members":{"ContentType":{},"Content":{}}},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ContactId":{},"ParticipantId":{},"ParticipantToken":{}}}},"StartOutboundVoiceContact":{"http":{"method":"PUT","requestUri":"/contact/outbound-voice"},"input":{"type":"structure","required":["DestinationPhoneNumber","ContactFlowId","InstanceId"],"members":{"DestinationPhoneNumber":{},"ContactFlowId":{},"InstanceId":{},"ClientToken":{"idempotencyToken":true},"SourcePhoneNumber":{},"QueueId":{},"Attributes":{"shape":"S18"}}},"output":{"type":"structure","members":{"ContactId":{}}}},"StopContact":{"http":{"requestUri":"/contact/stop"},"input":{"type":"structure","required":["ContactId","InstanceId"],"members":{"ContactId":{},"InstanceId":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sj"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateContactAttributes":{"http":{"requestUri":"/contact/attributes"},"input":{"type":"structure","required":["InitialContactId","InstanceId","Attributes"],"members":{"InitialContactId":{},"InstanceId":{},"Attributes":{"shape":"S18"}}},"output":{"type":"structure","members":{}}},"UpdateUserHierarchy":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/hierarchy"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"HierarchyGroupId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserIdentityInfo":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/identity-info"},"input":{"type":"structure","required":["IdentityInfo","UserId","InstanceId"],"members":{"IdentityInfo":{"shape":"S4"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserPhoneConfig":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/phone-config"},"input":{"type":"structure","required":["PhoneConfig","UserId","InstanceId"],"members":{"PhoneConfig":{"shape":"S8"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserRoutingProfile":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/routing-profile"},"input":{"type":"structure","required":["RoutingProfileId","UserId","InstanceId"],"members":{"RoutingProfileId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserSecurityProfiles":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/security-profiles"},"input":{"type":"structure","required":["SecurityProfileIds","UserId","InstanceId"],"members":{"SecurityProfileIds":{"shape":"Se"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}}},"shapes":{"S4":{"type":"structure","members":{"FirstName":{},"LastName":{},"Email":{}}},"S8":{"type":"structure","required":["PhoneType"],"members":{"PhoneType":{},"AutoAccept":{"type":"boolean"},"AfterContactWorkTimeLimit":{"type":"integer"},"DeskPhoneNumber":{}}},"Se":{"type":"list","member":{}},"Sj":{"type":"map","key":{},"value":{}},"Sz":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S13":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S18":{"type":"map","key":{},"value":{}},"S1c":{"type":"structure","members":{"Queues":{"type":"list","member":{}},"Channels":{"type":"list","member":{}}}},"S1h":{"type":"list","member":{}},"S1k":{"type":"structure","members":{"Name":{},"Unit":{}}},"S1s":{"type":"structure","members":{"Queue":{"type":"structure","members":{"Id":{},"Arn":{}}},"Channel":{}}},"S21":{"type":"string","sensitive":true},"S24":{"type":"structure","members":{"Name":{},"Threshold":{"type":"structure","members":{"Comparison":{},"ThresholdValue":{"type":"double"}}},"Statistic":{},"Unit":{}}}}}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetCurrentMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListContactFlows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ContactFlowSummaryList"},"ListHoursOfOperations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HoursOfOperationSummaryList"},"ListPhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumberSummaryList"},"ListQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueueSummaryList"},"ListRoutingProfiles":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RoutingProfileSummaryList"},"ListSecurityProfiles":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityProfileSummaryList"},"ListUserHierarchyGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserHierarchyGroupSummaryList"},"ListUsers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserSummaryList"}}}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-06","endpointPrefix":"cur","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cost and Usage Report Service","serviceId":"Cost and Usage Report Service","signatureVersion":"v4","signingName":"cur","targetPrefix":"AWSOrigamiServiceGatewayService","uid":"cur-2017-01-06"},"operations":{"DeleteReportDefinition":{"input":{"type":"structure","members":{"ReportName":{}}},"output":{"type":"structure","members":{"ResponseMessage":{}}}},"DescribeReportDefinitions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ReportDefinitions":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"ModifyReportDefinition":{"input":{"type":"structure","required":["ReportName","ReportDefinition"],"members":{"ReportName":{},"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"PutReportDefinition":{"input":{"type":"structure","required":["ReportDefinition"],"members":{"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","required":["ReportName","TimeUnit","Format","Compression","AdditionalSchemaElements","S3Bucket","S3Prefix","S3Region"],"members":{"ReportName":{},"TimeUnit":{},"Format":{},"Compression":{},"AdditionalSchemaElements":{"type":"list","member":{}},"S3Bucket":{},"S3Prefix":{},"S3Region":{},"AdditionalArtifacts":{"type":"list","member":{}},"RefreshClosedReports":{"type":"boolean"},"ReportVersioning":{}}}}}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeReportDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-06-23","endpointPrefix":"devicefarm","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Device Farm","serviceId":"Device Farm","signatureVersion":"v4","targetPrefix":"DeviceFarm_20150623","uid":"devicefarm-2015-06-23"},"operations":{"CreateDevicePool":{"input":{"type":"structure","required":["projectArn","name","rules"],"members":{"projectArn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["projectArn","name"],"members":{"projectArn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"CreateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"CreateRemoteAccessSession":{"input":{"type":"structure","required":["projectArn","deviceArn"],"members":{"projectArn":{},"deviceArn":{},"instanceArn":{},"sshPublicKey":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"name":{},"clientId":{},"configuration":{"type":"structure","members":{"billingMethod":{},"vpceConfigurationArns":{"shape":"Sz"}}},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"CreateTestGridProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1n"}}}},"CreateTestGridUrl":{"input":{"type":"structure","required":["projectArn","expiresInSeconds"],"members":{"projectArn":{},"expiresInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"url":{},"expires":{"type":"timestamp"}}}},"CreateUpload":{"input":{"type":"structure","required":["projectArn","name","type"],"members":{"projectArn":{},"name":{},"type":{},"contentType":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1w"}}}},"CreateVPCEConfiguration":{"input":{"type":"structure","required":["vpceConfigurationName","vpceServiceName","serviceDnsName"],"members":{"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S27"}}}},"DeleteDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{}}},"output":{"type":"structure","members":{}}},"DeleteUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"type":"structure","members":{"awsAccountNumber":{},"unmeteredDevices":{"shape":"S2u"},"unmeteredRemoteAccessDevices":{"shape":"S2u"},"maxJobTimeoutMinutes":{"type":"integer"},"trialMinutes":{"type":"structure","members":{"total":{"type":"double"},"remaining":{"type":"double"}}},"maxSlots":{"type":"map","key":{},"value":{"type":"integer"}},"defaultJobTimeoutMinutes":{"type":"integer"},"skipAppResign":{"type":"boolean"}}}}}},"GetDevice":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"device":{"shape":"S15"}}}},"GetDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1c"}}}},"GetDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"GetDevicePoolCompatibility":{"input":{"type":"structure","required":["devicePoolArn"],"members":{"devicePoolArn":{},"appArn":{},"testType":{},"test":{"shape":"S35"},"configuration":{"shape":"S38"}}},"output":{"type":"structure","members":{"compatibleDevices":{"shape":"S3g"},"incompatibleDevices":{"shape":"S3g"}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"GetJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3o"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"GetOfferingStatus":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"current":{"shape":"S3w"},"nextPeriod":{"shape":"S3w"},"nextToken":{}}}},"GetProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"GetRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"GetRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S4d"}}}},"GetSuite":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"suite":{"shape":"S4m"}}}},"GetTest":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"test":{"shape":"S4p"}}}},"GetTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1n"}}}},"GetTestGridSession":{"input":{"type":"structure","members":{"projectArn":{},"sessionId":{},"sessionArn":{}}},"output":{"type":"structure","members":{"testGridSession":{"shape":"S4v"}}}},"GetUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1w"}}}},"GetVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S27"}}}},"InstallToRemoteAccessSession":{"input":{"type":"structure","required":["remoteAccessSessionArn","appArn"],"members":{"remoteAccessSessionArn":{},"appArn":{}}},"output":{"type":"structure","members":{"appUpload":{"shape":"S1w"}}}},"ListArtifacts":{"input":{"type":"structure","required":["arn","type"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"extension":{},"url":{}}}},"nextToken":{}}}},"ListDeviceInstances":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"deviceInstances":{"shape":"S1b"},"nextToken":{}}}},"ListDevicePools":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"devicePools":{"type":"list","member":{"shape":"Sc"}},"nextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"arn":{},"nextToken":{},"filters":{"shape":"S4g"}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"shape":"S15"}},"nextToken":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceProfiles":{"type":"list","member":{"shape":"Si"}},"nextToken":{}}}},"ListJobs":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"shape":"S3o"}},"nextToken":{}}}},"ListNetworkProfiles":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"networkProfiles":{"type":"list","member":{"shape":"So"}},"nextToken":{}}}},"ListOfferingPromotions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringPromotions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{}}}},"nextToken":{}}}},"ListOfferingTransactions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringTransactions":{"type":"list","member":{"shape":"S5y"}},"nextToken":{}}}},"ListOfferings":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offerings":{"type":"list","member":{"shape":"S40"}},"nextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"Ss"}},"nextToken":{}}}},"ListRemoteAccessSessions":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"remoteAccessSessions":{"type":"list","member":{"shape":"S12"}},"nextToken":{}}}},"ListRuns":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"runs":{"type":"list","member":{"shape":"S4d"}},"nextToken":{}}}},"ListSamples":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"samples":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListSuites":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"suites":{"type":"list","member":{"shape":"S4m"}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6m"}}}},"ListTestGridProjects":{"input":{"type":"structure","members":{"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"testGridProjects":{"type":"list","member":{"shape":"S1n"}},"nextToken":{}}}},"ListTestGridSessionActions":{"input":{"type":"structure","required":["sessionArn"],"members":{"sessionArn":{},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actions":{"type":"list","member":{"type":"structure","members":{"action":{},"started":{"type":"timestamp"},"duration":{"type":"long"},"statusCode":{},"requestMethod":{}}}},"nextToken":{}}}},"ListTestGridSessionArtifacts":{"input":{"type":"structure","required":["sessionArn"],"members":{"sessionArn":{},"type":{},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"filename":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListTestGridSessions":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{},"status":{},"creationTimeAfter":{"type":"timestamp"},"creationTimeBefore":{"type":"timestamp"},"endTimeAfter":{"type":"timestamp"},"endTimeBefore":{"type":"timestamp"},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"testGridSessions":{"type":"list","member":{"shape":"S4v"}},"nextToken":{}}}},"ListTests":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tests":{"type":"list","member":{"shape":"S4p"}},"nextToken":{}}}},"ListUniqueProblems":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uniqueProblems":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"message":{},"problems":{"type":"list","member":{"type":"structure","members":{"run":{"shape":"S7h"},"job":{"shape":"S7h"},"suite":{"shape":"S7h"},"test":{"shape":"S7h"},"device":{"shape":"S15"},"result":{},"message":{}}}}}}}},"nextToken":{}}}},"ListUploads":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"uploads":{"type":"list","member":{"shape":"S1w"}},"nextToken":{}}}},"ListVPCEConfigurations":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"vpceConfigurations":{"type":"list","member":{"shape":"S27"}},"nextToken":{}}}},"PurchaseOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"},"offeringPromotionId":{}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S5y"}}}},"RenewOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S5y"}}}},"ScheduleRun":{"input":{"type":"structure","required":["projectArn","test"],"members":{"projectArn":{},"appArn":{},"devicePoolArn":{},"deviceSelectionConfiguration":{"type":"structure","required":["filters","maxDevices"],"members":{"filters":{"shape":"S4g"},"maxDevices":{"type":"integer"}}},"name":{},"test":{"shape":"S35"},"configuration":{"shape":"S38"},"executionConfiguration":{"type":"structure","members":{"jobTimeoutMinutes":{"type":"integer"},"accountsCleanup":{"type":"boolean"},"appPackagesCleanup":{"type":"boolean"},"videoCapture":{"type":"boolean"},"skipAppResign":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"run":{"shape":"S4d"}}}},"StopJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3o"}}}},"StopRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"StopRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S4d"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S6m"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"profileArn":{},"labels":{"shape":"S1d"}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1c"}}}},"UpdateDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"},"clearMaxDevices":{"type":"boolean"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"UpdateInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"UpdateProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"UpdateTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{},"name":{},"description":{}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1n"}}}},"UpdateUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"contentType":{},"editContent":{"type":"boolean"}}},"output":{"type":"structure","members":{"upload":{"shape":"S1w"}}}},"UpdateVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S27"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"value":{}}}},"Sc":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"Sg":{"type":"list","member":{}},"Si":{"type":"structure","members":{"arn":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"},"name":{},"description":{}}},"So":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"Ss":{"type":"structure","members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"created":{"type":"timestamp"}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"status":{},"result":{},"message":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"device":{"shape":"S15"},"instanceArn":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"hostAddress":{},"clientId":{},"billingMethod":{},"deviceMinutes":{"shape":"S1h"},"endpoint":{},"deviceUdid":{},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"S15":{"type":"structure","members":{"arn":{},"name":{},"manufacturer":{},"model":{},"modelId":{},"formFactor":{},"platform":{},"os":{},"cpu":{"type":"structure","members":{"frequency":{},"architecture":{},"clock":{"type":"double"}}},"resolution":{"type":"structure","members":{"width":{"type":"integer"},"height":{"type":"integer"}}},"heapSize":{"type":"long"},"memory":{"type":"long"},"image":{},"carrier":{},"radio":{},"remoteAccessEnabled":{"type":"boolean"},"remoteDebugEnabled":{"type":"boolean"},"fleetType":{},"fleetName":{},"instances":{"shape":"S1b"},"availability":{}}},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","members":{"arn":{},"deviceArn":{},"labels":{"shape":"S1d"},"status":{},"udid":{},"instanceProfile":{"shape":"Si"}}},"S1d":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"total":{"type":"double"},"metered":{"type":"double"},"unmetered":{"type":"double"}}},"S1n":{"type":"structure","members":{"arn":{},"name":{},"description":{},"created":{"type":"timestamp"}}},"S1w":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"type":{},"status":{},"url":{},"metadata":{},"contentType":{},"message":{},"category":{}}},"S27":{"type":"structure","members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"S2u":{"type":"map","key":{},"value":{"type":"integer"}},"S35":{"type":"structure","required":["type"],"members":{"type":{},"testPackageArn":{},"testSpecArn":{},"filter":{},"parameters":{"type":"map","key":{},"value":{}}}},"S38":{"type":"structure","members":{"extraDataPackageArn":{},"networkProfileArn":{},"locale":{},"location":{"shape":"S39"},"vpceConfigurationArns":{"shape":"Sz"},"customerArtifactPaths":{"shape":"S3a"},"radios":{"shape":"S3e"},"auxiliaryApps":{"shape":"Sz"},"billingMethod":{}}},"S39":{"type":"structure","required":["latitude","longitude"],"members":{"latitude":{"type":"double"},"longitude":{"type":"double"}}},"S3a":{"type":"structure","members":{"iosPaths":{"type":"list","member":{}},"androidPaths":{"type":"list","member":{}},"deviceHostPaths":{"type":"list","member":{}}}},"S3e":{"type":"structure","members":{"wifi":{"type":"boolean"},"bluetooth":{"type":"boolean"},"nfc":{"type":"boolean"},"gps":{"type":"boolean"}}},"S3g":{"type":"list","member":{"type":"structure","members":{"device":{"shape":"S15"},"compatible":{"type":"boolean"},"incompatibilityMessages":{"type":"list","member":{"type":"structure","members":{"message":{},"type":{}}}}}}},"S3o":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3p"},"message":{},"device":{"shape":"S15"},"instanceArn":{},"deviceMinutes":{"shape":"S1h"},"videoEndpoint":{},"videoCapture":{"type":"boolean"}}},"S3p":{"type":"structure","members":{"total":{"type":"integer"},"passed":{"type":"integer"},"failed":{"type":"integer"},"warned":{"type":"integer"},"errored":{"type":"integer"},"stopped":{"type":"integer"},"skipped":{"type":"integer"}}},"S3w":{"type":"map","key":{},"value":{"shape":"S3y"}},"S3y":{"type":"structure","members":{"type":{},"offering":{"shape":"S40"},"quantity":{"type":"integer"},"effectiveOn":{"type":"timestamp"}}},"S40":{"type":"structure","members":{"id":{},"description":{},"type":{},"platform":{},"recurringCharges":{"type":"list","member":{"type":"structure","members":{"cost":{"shape":"S44"},"frequency":{}}}}}},"S44":{"type":"structure","members":{"amount":{"type":"double"},"currencyCode":{}}},"S4d":{"type":"structure","members":{"arn":{},"name":{},"type":{},"platform":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3p"},"message":{},"totalJobs":{"type":"integer"},"completedJobs":{"type":"integer"},"billingMethod":{},"deviceMinutes":{"shape":"S1h"},"networkProfile":{"shape":"So"},"parsingResultUrl":{},"resultCode":{},"seed":{"type":"integer"},"appUpload":{},"eventCount":{"type":"integer"},"jobTimeoutMinutes":{"type":"integer"},"devicePoolArn":{},"locale":{},"radios":{"shape":"S3e"},"location":{"shape":"S39"},"customerArtifactPaths":{"shape":"S3a"},"webUrl":{},"skipAppResign":{"type":"boolean"},"testSpecArn":{},"deviceSelectionResult":{"type":"structure","members":{"filters":{"shape":"S4g"},"matchedDevicesCount":{"type":"integer"},"maxDevices":{"type":"integer"}}}}},"S4g":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"values":{"type":"list","member":{}}}}},"S4m":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3p"},"message":{},"deviceMinutes":{"shape":"S1h"}}},"S4p":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3p"},"message":{},"deviceMinutes":{"shape":"S1h"}}},"S4v":{"type":"structure","members":{"arn":{},"status":{},"created":{"type":"timestamp"},"ended":{"type":"timestamp"},"billingMinutes":{"type":"double"},"seleniumProperties":{}}},"S5y":{"type":"structure","members":{"offeringStatus":{"shape":"S3y"},"transactionId":{},"offeringPromotionId":{},"createdOn":{"type":"timestamp"},"cost":{"shape":"S44"}}},"S6m":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S7h":{"type":"structure","members":{"arn":{},"name":{}}}}}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetOfferingStatus":{"input_token":"nextToken","output_token":"nextToken","result_key":["current","nextPeriod"]},"ListArtifacts":{"input_token":"nextToken","output_token":"nextToken","result_key":"artifacts"},"ListDevicePools":{"input_token":"nextToken","output_token":"nextToken","result_key":"devicePools"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","result_key":"devices"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","result_key":"jobs"},"ListOfferingTransactions":{"input_token":"nextToken","output_token":"nextToken","result_key":"offeringTransactions"},"ListOfferings":{"input_token":"nextToken","output_token":"nextToken","result_key":"offerings"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListRuns":{"input_token":"nextToken","output_token":"nextToken","result_key":"runs"},"ListSamples":{"input_token":"nextToken","output_token":"nextToken","result_key":"samples"},"ListSuites":{"input_token":"nextToken","output_token":"nextToken","result_key":"suites"},"ListTestGridProjects":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessionActions":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessionArtifacts":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessions":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTests":{"input_token":"nextToken","output_token":"nextToken","result_key":"tests"},"ListUniqueProblems":{"input_token":"nextToken","output_token":"nextToken","result_key":"uniqueProblems"},"ListUploads":{"input_token":"nextToken","output_token":"nextToken","result_key":"uploads"}}}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-10-25","endpointPrefix":"directconnect","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Direct Connect","serviceId":"Direct Connect","signatureVersion":"v4","targetPrefix":"OvertureService","uid":"directconnect-2012-10-25"},"operations":{"AcceptDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","proposalId","associatedGatewayOwnerAccount"],"members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayOwnerAccount":{},"overrideAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"AllocateConnectionOnInterconnect":{"input":{"type":"structure","required":["bandwidth","connectionName","ownerAccount","interconnectId","vlan"],"members":{"bandwidth":{},"connectionName":{},"ownerAccount":{},"interconnectId":{},"vlan":{"type":"integer"}}},"output":{"shape":"So"},"deprecated":true},"AllocateHostedConnection":{"input":{"type":"structure","required":["connectionId","ownerAccount","bandwidth","connectionName","vlan"],"members":{"connectionId":{},"ownerAccount":{},"bandwidth":{},"connectionName":{},"vlan":{"type":"integer"},"tags":{"shape":"Sz"}}},"output":{"shape":"So"}},"AllocatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPrivateVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPrivateVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"addressFamily":{},"customerAddress":{},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1e"}},"AllocatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPublicVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPublicVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1e"}},"AllocateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newTransitVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newTransitVirtualInterfaceAllocation":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"tags":{"shape":"Sz"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1e"}}}},"AssociateConnectionWithLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"AssociateHostedConnection":{"input":{"type":"structure","required":["connectionId","parentConnectionId"],"members":{"connectionId":{},"parentConnectionId":{}}},"output":{"shape":"So"}},"AssociateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","connectionId"],"members":{"virtualInterfaceId":{},"connectionId":{}}},"output":{"shape":"S1e"}},"ConfirmConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"type":"structure","members":{"connectionState":{}}}},"ConfirmPrivateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"virtualGatewayId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmPublicVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmTransitVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","directConnectGatewayId"],"members":{"virtualInterfaceId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"CreateBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"newBGPPeer":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1e"}}}},"CreateConnection":{"input":{"type":"structure","required":["location","bandwidth","connectionName"],"members":{"location":{},"bandwidth":{},"connectionName":{},"lagId":{},"tags":{"shape":"Sz"},"providerName":{}}},"output":{"shape":"So"}},"CreateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayName"],"members":{"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2c"}}}},"CreateDirectConnectGatewayAssociation":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"CreateDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","directConnectGatewayOwnerAccount","gatewayId"],"members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S2j"}}}},"CreateInterconnect":{"input":{"type":"structure","required":["interconnectName","bandwidth","location"],"members":{"interconnectName":{},"bandwidth":{},"location":{},"lagId":{},"tags":{"shape":"Sz"},"providerName":{}}},"output":{"shape":"S2n"}},"CreateLag":{"input":{"type":"structure","required":["numberOfConnections","location","connectionsBandwidth","lagName"],"members":{"numberOfConnections":{"type":"integer"},"location":{},"connectionsBandwidth":{},"lagName":{},"connectionId":{},"tags":{"shape":"Sz"},"childConnectionTags":{"shape":"Sz"},"providerName":{}}},"output":{"shape":"S2s"}},"CreatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPrivateVirtualInterface"],"members":{"connectionId":{},"newPrivateVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualGatewayId":{},"directConnectGatewayId":{},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1e"}},"CreatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPublicVirtualInterface"],"members":{"connectionId":{},"newPublicVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1e"}},"CreateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","newTransitVirtualInterface"],"members":{"connectionId":{},"newTransitVirtualInterface":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"directConnectGatewayId":{},"tags":{"shape":"Sz"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1e"}}}},"DeleteBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"asn":{"type":"integer"},"customerAddress":{},"bgpPeerId":{}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1e"}}}},"DeleteConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"So"}},"DeleteDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2c"}}}},"DeleteDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"directConnectGatewayId":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"DeleteDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["proposalId"],"members":{"proposalId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S2j"}}}},"DeleteInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnectState":{}}}},"DeleteLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{}}},"output":{"shape":"S2s"}},"DeleteVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"DescribeConnectionLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S3k"}}},"deprecated":true},"DescribeConnections":{"input":{"type":"structure","members":{"connectionId":{}}},"output":{"shape":"S3n"}},"DescribeConnectionsOnInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"shape":"S3n"},"deprecated":true},"DescribeDirectConnectGatewayAssociationProposals":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposals":{"type":"list","member":{"shape":"S2j"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAssociations":{"input":{"type":"structure","members":{"associationId":{},"associatedGatewayId":{},"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociations":{"type":"list","member":{"shape":"S9"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAttachments":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAttachments":{"type":"list","member":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"virtualInterfaceRegion":{},"virtualInterfaceOwnerAccount":{},"attachmentState":{},"attachmentType":{},"stateChangeError":{}}}},"nextToken":{}}}},"DescribeDirectConnectGateways":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGateways":{"type":"list","member":{"shape":"S2c"}},"nextToken":{}}}},"DescribeHostedConnections":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S3n"}},"DescribeInterconnectLoa":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S3k"}}},"deprecated":true},"DescribeInterconnects":{"input":{"type":"structure","members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnects":{"type":"list","member":{"shape":"S2n"}}}}},"DescribeLags":{"input":{"type":"structure","members":{"lagId":{}}},"output":{"type":"structure","members":{"lags":{"type":"list","member":{"shape":"S2s"}}}}},"DescribeLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"shape":"S3k"}},"DescribeLocations":{"output":{"type":"structure","members":{"locations":{"type":"list","member":{"type":"structure","members":{"locationCode":{},"locationName":{},"region":{},"availablePortSpeeds":{"type":"list","member":{}},"availableProviders":{"type":"list","member":{}}}}}}}},"DescribeTags":{"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceTags":{"type":"list","member":{"type":"structure","members":{"resourceArn":{},"tags":{"shape":"Sz"}}}}}}},"DescribeVirtualGateways":{"output":{"type":"structure","members":{"virtualGateways":{"type":"list","member":{"type":"structure","members":{"virtualGatewayId":{},"virtualGatewayState":{}}}}}}},"DescribeVirtualInterfaces":{"input":{"type":"structure","members":{"connectionId":{},"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaces":{"type":"list","member":{"shape":"S1e"}}}}},"DisassociateConnectionFromLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"ListVirtualInterfaceTestHistory":{"input":{"type":"structure","members":{"testId":{},"virtualInterfaceId":{},"bgpPeers":{"shape":"S55"},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"virtualInterfaceTestHistory":{"type":"list","member":{"shape":"S59"}},"nextToken":{}}}},"StartBgpFailoverTest":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"bgpPeers":{"shape":"S55"},"testDurationInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"virtualInterfaceTest":{"shape":"S59"}}}},"StopBgpFailoverTest":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceTest":{"shape":"S59"}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"UpdateLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{},"lagName":{},"minimumLinks":{"type":"integer"}}},"output":{"shape":"S2s"}},"UpdateVirtualInterfaceAttributes":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"mtu":{"type":"integer"}}},"output":{"shape":"S1e"}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"cidr":{}}}},"S9":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"associationState":{},"stateChangeError":{},"associatedGateway":{"shape":"Sc"},"associationId":{},"allowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{},"virtualGatewayRegion":{"type":"string","deprecated":true},"virtualGatewayOwnerAccount":{}}},"Sc":{"type":"structure","members":{"id":{},"type":{},"ownerAccount":{},"region":{}}},"So":{"type":"structure","members":{"ownerAccount":{},"connectionId":{},"connectionName":{},"connectionState":{},"region":{},"location":{},"bandwidth":{},"vlan":{"type":"integer"},"partnerName":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"hasLogicalRedundancy":{},"tags":{"shape":"Sz"},"providerName":{}}},"Sv":{"type":"string","deprecated":true},"Sz":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"S1e":{"type":"structure","members":{"ownerAccount":{},"virtualInterfaceId":{},"location":{},"connectionId":{},"virtualInterfaceType":{},"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"amazonSideAsn":{"type":"long"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualInterfaceState":{},"customerRouterConfig":{},"mtu":{"type":"integer"},"jumboFrameCapable":{"type":"boolean"},"virtualGatewayId":{},"directConnectGatewayId":{},"routeFilterPrefixes":{"shape":"S5"},"bgpPeers":{"type":"list","member":{"type":"structure","members":{"bgpPeerId":{},"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{},"bgpPeerState":{},"bgpStatus":{},"awsDeviceV2":{}}}},"region":{},"awsDeviceV2":{},"tags":{"shape":"Sz"}}},"S2c":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"},"ownerAccount":{},"directConnectGatewayState":{},"stateChangeError":{}}},"S2j":{"type":"structure","members":{"proposalId":{},"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"proposalState":{},"associatedGateway":{"shape":"Sc"},"existingAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"requestedAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"S2n":{"type":"structure","members":{"interconnectId":{},"interconnectName":{},"interconnectState":{},"region":{},"location":{},"bandwidth":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"hasLogicalRedundancy":{},"tags":{"shape":"Sz"},"providerName":{}}},"S2s":{"type":"structure","members":{"connectionsBandwidth":{},"numberOfConnections":{"type":"integer"},"lagId":{},"ownerAccount":{},"lagName":{},"lagState":{},"location":{},"region":{},"minimumLinks":{"type":"integer"},"awsDevice":{"shape":"Sv"},"awsDeviceV2":{},"connections":{"shape":"S2u"},"allowsHostedConnections":{"type":"boolean"},"jumboFrameCapable":{"type":"boolean"},"hasLogicalRedundancy":{},"tags":{"shape":"Sz"},"providerName":{}}},"S2u":{"type":"list","member":{"shape":"So"}},"S3k":{"type":"structure","members":{"loaContent":{"type":"blob"},"loaContentType":{}}},"S3n":{"type":"structure","members":{"connections":{"shape":"S2u"}}},"S55":{"type":"list","member":{}},"S59":{"type":"structure","members":{"testId":{},"virtualInterfaceId":{},"bgpPeers":{"shape":"S55"},"status":{},"ownerAccount":{},"testDurationInMinutes":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}}}}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeConnections":{"result_key":"connections"},"DescribeConnectionsOnInterconnect":{"result_key":"connections"},"DescribeInterconnects":{"result_key":"interconnects"},"DescribeLocations":{"result_key":"locations"},"DescribeVirtualGateways":{"result_key":"virtualGateways"},"DescribeVirtualInterfaces":{"result_key":"virtualInterfaces"}}}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-12-05","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20111205","uid":"dynamodb-2011-12-05"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"Items":{"shape":"Sk"},"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedKeys":{"shape":"S2"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"So"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedItems":{"shape":"So"}}}},"CreateTable":{"input":{"type":"structure","required":["TableName","KeySchema","ProvisionedThroughput"],"members":{"TableName":{},"KeySchema":{"shape":"Sy"},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S15"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"Ss"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"Query":{"input":{"type":"structure","required":["TableName","HashKeyValue"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"Count":{"type":"boolean"},"HashKeyValue":{"shape":"S7"},"RangeKeyCondition":{"shape":"S1u"},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"Count":{"type":"boolean"},"ScanFilter":{"type":"map","key":{},"value":{"shape":"S1u"}},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key","AttributeUpdates"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Action":{}}}},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName","ProvisionedThroughput"],"members":{"TableName":{},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}}},"S6":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"S7"},"RangeKeyElement":{"shape":"S7"}}},"S7":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}}}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"shape":"Sl"}},"Sl":{"type":"map","key":{},"value":{"shape":"S7"}},"So":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"Ss"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"Ss":{"type":"map","key":{},"value":{"shape":"S7"}},"Sy":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"Sz"},"RangeKeyElement":{"shape":"Sz"}}},"Sz":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}},"S12":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S15":{"type":"structure","members":{"TableName":{},"KeySchema":{"shape":"Sy"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S1b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Exists":{"type":"boolean"}}}},"S1u":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"type":"list","member":{"shape":"S7"}},"ComparisonOperator":{}}}}}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20120810","uid":"dynamodb-2012-08-10"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"shape":"Sr"}},"UnprocessedKeys":{"shape":"S2"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S10"},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{}}},"output":{"type":"structure","members":{"UnprocessedItems":{"shape":"S10"},"ItemCollectionMetrics":{"shape":"S18"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"CreateBackup":{"input":{"type":"structure","required":["TableName","BackupName"],"members":{"TableName":{},"BackupName":{}}},"output":{"type":"structure","members":{"BackupDetails":{"shape":"S1h"}}},"endpointdiscovery":{}},"CreateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicationGroup"],"members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S1p"}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1t"}}},"endpointdiscovery":{}},"CreateTable":{"input":{"type":"structure","required":["AttributeDefinitions","TableName","KeySchema"],"members":{"AttributeDefinitions":{"shape":"S27"},"TableName":{},"KeySchema":{"shape":"S2b"},"LocalSecondaryIndexes":{"shape":"S2e"},"GlobalSecondaryIndexes":{"shape":"S2k"},"BillingMode":{},"ProvisionedThroughput":{"shape":"S2m"},"StreamSpecification":{"shape":"S2o"},"SSESpecification":{"shape":"S2r"},"Tags":{"shape":"S2u"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2z"}}},"endpointdiscovery":{}},"DeleteBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S3o"}}},"endpointdiscovery":{}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S41"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}},"endpointdiscovery":{}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2z"}}},"endpointdiscovery":{}},"DescribeBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S3o"}}},"endpointdiscovery":{}},"DescribeContinuousBackups":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S4i"}}},"endpointdiscovery":{}},"DescribeContributorInsights":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{}}},"output":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsRuleList":{"type":"list","member":{}},"ContributorInsightsStatus":{},"LastUpdateDateTime":{"type":"timestamp"},"FailureException":{"type":"structure","members":{"ExceptionName":{},"ExceptionDescription":{}}}}}},"DescribeEndpoints":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["Address","CachePeriodInMinutes"],"members":{"Address":{},"CachePeriodInMinutes":{"type":"long"}}}}}},"endpointoperation":true},"DescribeGlobalTable":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1t"}}},"endpointdiscovery":{}},"DescribeGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S53"}}},"endpointdiscovery":{}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountMaxReadCapacityUnits":{"type":"long"},"AccountMaxWriteCapacityUnits":{"type":"long"},"TableMaxReadCapacityUnits":{"type":"long"},"TableMaxWriteCapacityUnits":{"type":"long"}}},"endpointdiscovery":{}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S2z"}}},"endpointdiscovery":{}},"DescribeTableReplicaAutoScaling":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableAutoScalingDescription":{"shape":"S5k"}}}},"DescribeTimeToLive":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TimeToLiveDescription":{"shape":"S3x"}}},"endpointdiscovery":{}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}},"output":{"type":"structure","members":{"Item":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"ListBackups":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"TimeRangeLowerBound":{"type":"timestamp"},"TimeRangeUpperBound":{"type":"timestamp"},"ExclusiveStartBackupArn":{},"BackupType":{}}},"output":{"type":"structure","members":{"BackupSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"TableId":{},"TableArn":{},"BackupArn":{},"BackupName":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"},"BackupStatus":{},"BackupType":{},"BackupSizeBytes":{"type":"long"}}}},"LastEvaluatedBackupArn":{}}},"endpointdiscovery":{}},"ListContributorInsights":{"input":{"type":"structure","members":{"TableName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ContributorInsightsSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsStatus":{}}}},"NextToken":{}}}},"ListGlobalTables":{"input":{"type":"structure","members":{"ExclusiveStartGlobalTableName":{},"Limit":{"type":"integer"},"RegionName":{}}},"output":{"type":"structure","members":{"GlobalTables":{"type":"list","member":{"type":"structure","members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S1p"}}}},"LastEvaluatedGlobalTableName":{}}},"endpointdiscovery":{}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}},"endpointdiscovery":{}},"ListTagsOfResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2u"},"NextToken":{}}},"endpointdiscovery":{}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"S14"},"Expected":{"shape":"S41"},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionalOperator":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}},"endpointdiscovery":{}},"Query":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"Select":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"KeyConditions":{"type":"map","key":{},"value":{"shape":"S6o"}},"QueryFilter":{"shape":"S6p"},"ConditionalOperator":{},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"FilterExpression":{},"KeyConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"RestoreTableFromBackup":{"input":{"type":"structure","required":["TargetTableName","BackupArn"],"members":{"TargetTableName":{},"BackupArn":{},"BillingModeOverride":{},"GlobalSecondaryIndexOverride":{"shape":"S2k"},"LocalSecondaryIndexOverride":{"shape":"S2e"},"ProvisionedThroughputOverride":{"shape":"S2m"},"SSESpecificationOverride":{"shape":"S2r"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2z"}}},"endpointdiscovery":{}},"RestoreTableToPointInTime":{"input":{"type":"structure","required":["TargetTableName"],"members":{"SourceTableArn":{},"SourceTableName":{},"TargetTableName":{},"UseLatestRestorableTime":{"type":"boolean"},"RestoreDateTime":{"type":"timestamp"},"BillingModeOverride":{},"GlobalSecondaryIndexOverride":{"shape":"S2k"},"LocalSecondaryIndexOverride":{"shape":"S2e"},"ProvisionedThroughputOverride":{"shape":"S2m"},"SSESpecificationOverride":{"shape":"S2r"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2z"}}},"endpointdiscovery":{}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"Select":{},"ScanFilter":{"shape":"S6p"},"ConditionalOperator":{},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"TotalSegments":{"type":"integer"},"Segment":{"type":"integer"},"ProjectionExpression":{},"FilterExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S2u"}}},"endpointdiscovery":{}},"TransactGetItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","required":["Get"],"members":{"Get":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S6"},"TableName":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}}}}},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"St"},"Responses":{"type":"list","member":{"type":"structure","members":{"Item":{"shape":"Ss"}}}}}},"endpointdiscovery":{}},"TransactWriteItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","members":{"ConditionCheck":{"type":"structure","required":["Key","TableName","ConditionExpression"],"members":{"Key":{"shape":"S6"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"},"ReturnValuesOnConditionCheckFailure":{}}},"Put":{"type":"structure","required":["Item","TableName"],"members":{"Item":{"shape":"S14"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"},"ReturnValuesOnConditionCheckFailure":{}}},"Delete":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S6"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"},"ReturnValuesOnConditionCheckFailure":{}}},"Update":{"type":"structure","required":["Key","UpdateExpression","TableName"],"members":{"Key":{"shape":"S6"},"UpdateExpression":{},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"},"ReturnValuesOnConditionCheckFailure":{}}}}}},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"St"},"ItemCollectionMetrics":{"shape":"S18"}}},"endpointdiscovery":{}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"endpointdiscovery":{}},"UpdateContinuousBackups":{"input":{"type":"structure","required":["TableName","PointInTimeRecoverySpecification"],"members":{"TableName":{},"PointInTimeRecoverySpecification":{"type":"structure","required":["PointInTimeRecoveryEnabled"],"members":{"PointInTimeRecoveryEnabled":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S4i"}}},"endpointdiscovery":{}},"UpdateContributorInsights":{"input":{"type":"structure","required":["TableName","ContributorInsightsAction"],"members":{"TableName":{},"IndexName":{},"ContributorInsightsAction":{}}},"output":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsStatus":{}}}},"UpdateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicaUpdates"],"members":{"GlobalTableName":{},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1t"}}},"endpointdiscovery":{}},"UpdateGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{},"GlobalTableBillingMode":{},"GlobalTableProvisionedWriteCapacityUnits":{"type":"long"},"GlobalTableProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"S7z"},"GlobalTableGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"S7z"}}}},"ReplicaSettingsUpdate":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"S7z"},"ReplicaGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"S7z"}}}}}}}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S53"}}},"endpointdiscovery":{}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Action":{}}}},"Expected":{"shape":"S41"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"UpdateExpression":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S49"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}},"endpointdiscovery":{}},"UpdateTable":{"input":{"type":"structure","required":["TableName"],"members":{"AttributeDefinitions":{"shape":"S27"},"TableName":{},"BillingMode":{},"ProvisionedThroughput":{"shape":"S2m"},"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"Update":{"type":"structure","required":["IndexName","ProvisionedThroughput"],"members":{"IndexName":{},"ProvisionedThroughput":{"shape":"S2m"}}},"Create":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"},"ProvisionedThroughput":{"shape":"S2m"}}},"Delete":{"type":"structure","required":["IndexName"],"members":{"IndexName":{}}}}}},"StreamSpecification":{"shape":"S2o"},"SSESpecification":{"shape":"S2r"},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S20"},"GlobalSecondaryIndexes":{"shape":"S8o"}}},"Update":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S20"},"GlobalSecondaryIndexes":{"shape":"S8o"}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2z"}}},"endpointdiscovery":{}},"UpdateTableReplicaAutoScaling":{"input":{"type":"structure","required":["TableName"],"members":{"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedWriteCapacityAutoScalingUpdate":{"shape":"S7z"}}}},"TableName":{},"ProvisionedWriteCapacityAutoScalingUpdate":{"shape":"S7z"},"ReplicaUpdates":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaGlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedReadCapacityAutoScalingUpdate":{"shape":"S7z"}}}},"ReplicaProvisionedReadCapacityAutoScalingUpdate":{"shape":"S7z"}}}}}},"output":{"type":"structure","members":{"TableAutoScalingDescription":{"shape":"S5k"}}}},"UpdateTimeToLive":{"input":{"type":"structure","required":["TableName","TimeToLiveSpecification"],"members":{"TableName":{},"TimeToLiveSpecification":{"shape":"S92"}}},"output":{"type":"structure","members":{"TimeToLiveSpecification":{"shape":"S92"}}},"endpointdiscovery":{}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}}},"S6":{"type":"map","key":{},"value":{"shape":"S8"}},"S8":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"S8"}},"L":{"type":"list","member":{"shape":"S8"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}},"Sj":{"type":"list","member":{}},"Sm":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{"shape":"Ss"}},"Ss":{"type":"map","key":{},"value":{"shape":"S8"}},"St":{"type":"list","member":{"shape":"Su"}},"Su":{"type":"structure","members":{"TableName":{},"CapacityUnits":{"type":"double"},"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"Table":{"shape":"Sw"},"LocalSecondaryIndexes":{"shape":"Sx"},"GlobalSecondaryIndexes":{"shape":"Sx"}}},"Sw":{"type":"structure","members":{"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"CapacityUnits":{"type":"double"}}},"Sx":{"type":"map","key":{},"value":{"shape":"Sw"}},"S10":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"S14"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"S14":{"type":"map","key":{},"value":{"shape":"S8"}},"S18":{"type":"map","key":{},"value":{"type":"list","member":{"shape":"S1a"}}},"S1a":{"type":"structure","members":{"ItemCollectionKey":{"type":"map","key":{},"value":{"shape":"S8"}},"SizeEstimateRangeGB":{"type":"list","member":{"type":"double"}}}},"S1h":{"type":"structure","required":["BackupArn","BackupName","BackupStatus","BackupType","BackupCreationDateTime"],"members":{"BackupArn":{},"BackupName":{},"BackupSizeBytes":{"type":"long"},"BackupStatus":{},"BackupType":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"}}},"S1p":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"S1t":{"type":"structure","members":{"ReplicationGroup":{"shape":"S1u"},"GlobalTableArn":{},"CreationDateTime":{"type":"timestamp"},"GlobalTableStatus":{},"GlobalTableName":{}}},"S1u":{"type":"list","member":{"type":"structure","members":{"RegionName":{},"ReplicaStatus":{},"ReplicaStatusDescription":{},"ReplicaStatusPercentProgress":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S20"},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S20"}}}}}}},"S20":{"type":"structure","members":{"ReadCapacityUnits":{"type":"long"}}},"S27":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}}},"S2b":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"S2e":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"}}}},"S2g":{"type":"structure","members":{"ProjectionType":{},"NonKeyAttributes":{"type":"list","member":{}}}},"S2k":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"},"ProvisionedThroughput":{"shape":"S2m"}}}},"S2m":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S2o":{"type":"structure","required":["StreamEnabled"],"members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"S2r":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SSEType":{},"KMSMasterKeyId":{}}},"S2u":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S2z":{"type":"structure","members":{"AttributeDefinitions":{"shape":"S27"},"TableName":{},"KeySchema":{"shape":"S2b"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S31"},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"TableArn":{},"TableId":{},"BillingModeSummary":{"shape":"S36"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"},"IndexStatus":{},"Backfilling":{"type":"boolean"},"ProvisionedThroughput":{"shape":"S31"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"StreamSpecification":{"shape":"S2o"},"LatestStreamLabel":{},"LatestStreamArn":{},"GlobalTableVersion":{},"Replicas":{"shape":"S1u"},"RestoreSummary":{"type":"structure","required":["RestoreDateTime","RestoreInProgress"],"members":{"SourceBackupArn":{},"SourceTableArn":{},"RestoreDateTime":{"type":"timestamp"},"RestoreInProgress":{"type":"boolean"}}},"SSEDescription":{"shape":"S3h"},"ArchivalSummary":{"type":"structure","members":{"ArchivalDateTime":{"type":"timestamp"},"ArchivalReason":{},"ArchivalBackupArn":{}}}}},"S31":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S36":{"type":"structure","members":{"BillingMode":{},"LastUpdateToPayPerRequestDateTime":{"type":"timestamp"}}},"S3h":{"type":"structure","members":{"Status":{},"SSEType":{},"KMSMasterKeyArn":{},"InaccessibleEncryptionDateTime":{"type":"timestamp"}}},"S3o":{"type":"structure","members":{"BackupDetails":{"shape":"S1h"},"SourceTableDetails":{"type":"structure","required":["TableName","TableId","KeySchema","TableCreationDateTime","ProvisionedThroughput"],"members":{"TableName":{},"TableId":{},"TableArn":{},"TableSizeBytes":{"type":"long"},"KeySchema":{"shape":"S2b"},"TableCreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S2m"},"ItemCount":{"type":"long"},"BillingMode":{}}},"SourceTableFeatureDetails":{"type":"structure","members":{"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2b"},"Projection":{"shape":"S2g"},"ProvisionedThroughput":{"shape":"S2m"}}}},"StreamDescription":{"shape":"S2o"},"TimeToLiveDescription":{"shape":"S3x"},"SSEDescription":{"shape":"S3h"}}}}},"S3x":{"type":"structure","members":{"TimeToLiveStatus":{},"AttributeName":{}}},"S41":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Exists":{"type":"boolean"},"ComparisonOperator":{},"AttributeValueList":{"shape":"S45"}}}},"S45":{"type":"list","member":{"shape":"S8"}},"S49":{"type":"map","key":{},"value":{"shape":"S8"}},"S4i":{"type":"structure","required":["ContinuousBackupsStatus"],"members":{"ContinuousBackupsStatus":{},"PointInTimeRecoveryDescription":{"type":"structure","members":{"PointInTimeRecoveryStatus":{},"EarliestRestorableDateTime":{"type":"timestamp"},"LatestRestorableDateTime":{"type":"timestamp"}}}}},"S53":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaStatus":{},"ReplicaBillingModeSummary":{"shape":"S36"},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S55"},"ReplicaProvisionedWriteCapacityUnits":{"type":"long"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S55"},"ReplicaGlobalSecondaryIndexSettings":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S55"},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S55"}}}}}}},"S55":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}}},"S5k":{"type":"structure","members":{"TableName":{},"TableStatus":{},"Replicas":{"type":"list","member":{"type":"structure","members":{"RegionName":{},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S55"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S55"}}}},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S55"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S55"},"ReplicaStatus":{}}}}}},"S6o":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"shape":"S45"},"ComparisonOperator":{}}},"S6p":{"type":"map","key":{},"value":{"shape":"S6o"}},"S7z":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicyUpdate":{"type":"structure","required":["TargetTrackingScalingPolicyConfiguration"],"members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}},"S8o":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S20"}}}},"S92":{"type":"structure","required":["Enabled","AttributeName"],"members":{"Enabled":{"type":"boolean"},"AttributeName":{}}}}}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListContributorInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-15","endpointPrefix":"ec2","protocol":"ec2","serviceAbbreviation":"Amazon EC2","serviceFullName":"Amazon Elastic Compute Cloud","serviceId":"EC2","signatureVersion":"v4","uid":"ec2-2016-11-15","xmlNamespace":"http://ec2.amazonaws.com/doc/2016-11-15"},"operations":{"AcceptReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"ExchangeId":{"locationName":"exchangeId"}}}},"AcceptTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Se","locationName":"transitGatewayPeeringAttachment"}}}},"AcceptTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sn","locationName":"transitGatewayVpcAttachment"}}}},"AcceptVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"Su","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"AcceptVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"S13","locationName":"vpcPeeringConnection"}}}},"AdvertiseByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1e","locationName":"byoipCidr"}}}},"AllocateAddress":{"input":{"type":"structure","members":{"Domain":{},"Address":{},"PublicIpv4Pool":{},"NetworkBorderGroup":{},"CustomerOwnedIpv4Pool":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Domain":{"locationName":"domain"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"}}}},"AllocateHosts":{"input":{"type":"structure","required":["AvailabilityZone","Quantity"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"ClientToken":{"locationName":"clientToken"},"InstanceType":{"locationName":"instanceType"},"InstanceFamily":{},"Quantity":{"locationName":"quantity","type":"integer"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"HostRecovery":{}}},"output":{"type":"structure","members":{"HostIds":{"shape":"S1q","locationName":"hostIdSet"}}}},"ApplySecurityGroupsToClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","VpcId","SecurityGroupIds"],"members":{"ClientVpnEndpointId":{},"VpcId":{},"SecurityGroupIds":{"shape":"S1u","locationName":"SecurityGroupId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S1u","locationName":"securityGroupIds"}}}},"AssignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S1y","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AssignedIpv6Addresses":{"shape":"S1y","locationName":"assignedIpv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"AssignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"AllowReassignment":{"locationName":"allowReassignment","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S22","locationName":"privateIpAddress"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AssignedPrivateIpAddresses":{"locationName":"assignedPrivateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrivateIpAddress":{"locationName":"privateIpAddress"}}}}}}},"AssociateAddress":{"input":{"type":"structure","members":{"AllocationId":{},"InstanceId":{},"PublicIp":{},"AllowReassociation":{"locationName":"allowReassociation","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","SubnetId"],"members":{"ClientVpnEndpointId":{},"SubnetId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S2d","locationName":"status"}}}},"AssociateDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId","VpcId"],"members":{"DhcpOptionsId":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"AssociateIamInstanceProfile":{"input":{"type":"structure","required":["IamInstanceProfile","InstanceId"],"members":{"IamInstanceProfile":{"shape":"S2i"},"InstanceId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S2k","locationName":"iamInstanceProfileAssociation"}}}},"AssociateRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"},"GatewayId":{}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"AssociationState":{"shape":"S2r","locationName":"associationState"}}}},"AssociateSubnetCidrBlock":{"input":{"type":"structure","required":["Ipv6CidrBlock","SubnetId"],"members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S2v","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"AssociateTransitGatewayMulticastDomain":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"So"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"S31","locationName":"associations"}}}},"AssociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S39","locationName":"association"}}}},"AssociateVpcCidrBlock":{"input":{"type":"structure","required":["VpcId"],"members":{"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"CidrBlock":{},"VpcId":{"locationName":"vpcId"},"Ipv6CidrBlockNetworkBorderGroup":{},"Ipv6Pool":{},"Ipv6CidrBlock":{}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S3e","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S3h","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"AttachClassicLinkVpc":{"input":{"type":"structure","required":["Groups","InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S3j","locationName":"SecurityGroupId"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"AttachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"AttachNetworkInterface":{"input":{"type":"structure","required":["DeviceIndex","InstanceId","NetworkInterfaceId"],"members":{"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"}}}},"AttachVolume":{"input":{"type":"structure","required":["Device","InstanceId","VolumeId"],"members":{"Device":{},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S3r"}},"AttachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S3w","locationName":"attachment"}}}},"AuthorizeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"AuthorizeAllGroups":{"type":"boolean"},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S40","locationName":"status"}}}},"AuthorizeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S43","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"AuthorizeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S43"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"BundleInstance":{"input":{"type":"structure","required":["InstanceId","Storage"],"members":{"InstanceId":{},"Storage":{"shape":"S4g"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S4k","locationName":"bundleInstanceTask"}}}},"CancelBundleTask":{"input":{"type":"structure","required":["BundleId"],"members":{"BundleId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S4k","locationName":"bundleInstanceTask"}}}},"CancelCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CancelConversionTask":{"input":{"type":"structure","required":["ConversionTaskId"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"ReasonMessage":{"locationName":"reasonMessage"}}}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskId"],"members":{"ExportTaskId":{"locationName":"exportTaskId"}}}},"CancelImportTask":{"input":{"type":"structure","members":{"CancelReason":{},"DryRun":{"type":"boolean"},"ImportTaskId":{}}},"output":{"type":"structure","members":{"ImportTaskId":{"locationName":"importTaskId"},"PreviousState":{"locationName":"previousState"},"State":{"locationName":"state"}}}},"CancelReservedInstancesListing":{"input":{"type":"structure","required":["ReservedInstancesListingId"],"members":{"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S53","locationName":"reservedInstancesListingsSet"}}}},"CancelSpotFleetRequests":{"input":{"type":"structure","required":["SpotFleetRequestIds","TerminateInstances"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestIds":{"shape":"S5f","locationName":"spotFleetRequestId"},"TerminateInstances":{"locationName":"terminateInstances","type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetRequests":{"locationName":"successfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentSpotFleetRequestState":{"locationName":"currentSpotFleetRequestState"},"PreviousSpotFleetRequestState":{"locationName":"previousSpotFleetRequestState"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"UnsuccessfulFleetRequests":{"locationName":"unsuccessfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}}}}},"CancelSpotInstanceRequests":{"input":{"type":"structure","required":["SpotInstanceRequestIds"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S5q","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"CancelledSpotInstanceRequests":{"locationName":"spotInstanceRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"State":{"locationName":"state"}}}}}}},"ConfirmProductInstance":{"input":{"type":"structure","required":["InstanceId","ProductCode"],"members":{"InstanceId":{},"ProductCode":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"Return":{"locationName":"return","type":"boolean"}}}},"CopyFpgaImage":{"input":{"type":"structure","required":["SourceFpgaImageId","SourceRegion"],"members":{"DryRun":{"type":"boolean"},"SourceFpgaImageId":{},"Description":{},"Name":{},"SourceRegion":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"}}}},"CopyImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"ClientToken":{},"Description":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Name":{},"SourceImageId":{},"SourceRegion":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceRegion","SourceSnapshotId"],"members":{"Description":{},"DestinationRegion":{"locationName":"destinationRegion"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"PresignedUrl":{"locationName":"presignedUrl"},"SourceRegion":{},"SourceSnapshotId":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"CreateCapacityReservation":{"input":{"type":"structure","required":["InstanceType","InstancePlatform","InstanceCount"],"members":{"ClientToken":{},"InstanceType":{},"InstancePlatform":{},"AvailabilityZone":{},"AvailabilityZoneId":{},"Tenancy":{},"InstanceCount":{"type":"integer"},"EbsOptimized":{"type":"boolean"},"EphemeralStorage":{"type":"boolean"},"EndDate":{"type":"timestamp"},"EndDateType":{},"InstanceMatchCriteria":{},"TagSpecifications":{"shape":"S1l"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CapacityReservation":{"shape":"S6c","locationName":"capacityReservation"}}}},"CreateClientVpnEndpoint":{"input":{"type":"structure","required":["ClientCidrBlock","ServerCertificateArn","AuthenticationOptions","ConnectionLogOptions"],"members":{"ClientCidrBlock":{},"ServerCertificateArn":{},"AuthenticationOptions":{"locationName":"Authentication","type":"list","member":{"type":"structure","members":{"Type":{},"ActiveDirectory":{"type":"structure","members":{"DirectoryId":{}}},"MutualAuthentication":{"type":"structure","members":{"ClientRootCertificateChainArn":{}}},"FederatedAuthentication":{"type":"structure","members":{"SAMLProviderArn":{}}}}}},"ConnectionLogOptions":{"shape":"S6l"},"DnsServers":{"shape":"So"},"TransportProtocol":{},"VpnPort":{"type":"integer"},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"SecurityGroupIds":{"shape":"S1u","locationName":"SecurityGroupId"},"VpcId":{}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S6o","locationName":"status"},"DnsName":{"locationName":"dnsName"}}}},"CreateClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock","TargetVpcSubnetId"],"members":{"ClientVpnEndpointId":{},"DestinationCidrBlock":{},"TargetVpcSubnetId":{},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S6s","locationName":"status"}}}},"CreateCustomerGateway":{"input":{"type":"structure","required":["BgpAsn","Type"],"members":{"BgpAsn":{"type":"integer"},"PublicIp":{"locationName":"IpAddress"},"CertificateArn":{},"Type":{},"DeviceName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateway":{"shape":"S6x","locationName":"customerGateway"}}}},"CreateDefaultSubnet":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S70","locationName":"subnet"}}}},"CreateDefaultVpc":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S76","locationName":"vpc"}}}},"CreateDhcpOptions":{"input":{"type":"structure","required":["DhcpConfigurations"],"members":{"DhcpConfigurations":{"locationName":"dhcpConfiguration","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"shape":"So","locationName":"Value"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"shape":"S7f","locationName":"dhcpOptions"}}}},"CreateEgressOnlyInternetGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"VpcId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"EgressOnlyInternetGateway":{"shape":"S7m","locationName":"egressOnlyInternetGateway"}}}},"CreateFleet":{"input":{"type":"structure","required":["LaunchTemplateConfigs","TargetCapacitySpecification"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"SpotOptions":{"type":"structure","members":{"AllocationStrategy":{},"InstanceInterruptionBehavior":{},"InstancePoolsToUseCount":{"type":"integer"},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"OnDemandOptions":{"type":"structure","members":{"AllocationStrategy":{},"CapacityReservationOptions":{"type":"structure","members":{"UsageStrategy":{}}},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"ExcessCapacityTerminationPolicy":{},"LaunchTemplateConfigs":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"Overrides":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{},"MaxPrice":{},"SubnetId":{},"AvailabilityZone":{},"WeightedCapacity":{"type":"double"},"Priority":{"type":"double"},"Placement":{"shape":"S87"}}}}}}},"TargetCapacitySpecification":{"shape":"S88"},"TerminateInstancesWithExpiration":{"type":"boolean"},"Type":{},"ValidFrom":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"},"ReplaceUnhealthyInstances":{"type":"boolean"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"FleetId":{"locationName":"fleetId"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S8f","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S8f","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"S8m","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}}}}},"CreateFlowLogs":{"input":{"type":"structure","required":["ResourceIds","ResourceType","TrafficType"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"DeliverLogsPermissionArn":{},"LogGroupName":{},"ResourceIds":{"locationName":"ResourceId","type":"list","member":{"locationName":"item"}},"ResourceType":{},"TrafficType":{},"LogDestinationType":{},"LogDestination":{},"LogFormat":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"MaxAggregationInterval":{"type":"integer"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"FlowLogIds":{"shape":"So","locationName":"flowLogIdSet"},"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"CreateFpgaImage":{"input":{"type":"structure","required":["InputStorageLocation"],"members":{"DryRun":{"type":"boolean"},"InputStorageLocation":{"shape":"S8w"},"LogsStorageLocation":{"shape":"S8w"},"Description":{},"Name":{},"ClientToken":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"}}}},"CreateImage":{"input":{"type":"structure","required":["InstanceId","Name"],"members":{"BlockDeviceMappings":{"shape":"S8z","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"Name":{"locationName":"name"},"NoReboot":{"locationName":"noReboot","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateInstanceExportTask":{"input":{"type":"structure","required":["InstanceId"],"members":{"Description":{"locationName":"description"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ExportTask":{"shape":"S9a","locationName":"exportTask"}}}},"CreateInternetGateway":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InternetGateway":{"shape":"S9g","locationName":"internetGateway"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyMaterial":{"locationName":"keyMaterial","type":"string","sensitive":true},"KeyName":{"locationName":"keyName"},"KeyPairId":{"locationName":"keyPairId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"CreateLaunchTemplate":{"input":{"type":"structure","required":["LaunchTemplateName","LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateName":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"S9m"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sax","locationName":"launchTemplate"},"Warning":{"shape":"Say","locationName":"warning"}}}},"CreateLaunchTemplateVersion":{"input":{"type":"structure","required":["LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"SourceVersion":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"S9m"}}},"output":{"type":"structure","members":{"LaunchTemplateVersion":{"shape":"Sb3","locationName":"launchTemplateVersion"},"Warning":{"shape":"Say","locationName":"warning"}}}},"CreateLocalGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","LocalGatewayRouteTableId","LocalGatewayVirtualInterfaceGroupId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"LocalGatewayVirtualInterfaceGroupId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sc0","locationName":"route"}}}},"CreateLocalGatewayRouteTableVpcAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableId","VpcId"],"members":{"LocalGatewayRouteTableId":{},"VpcId":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociation":{"shape":"Sc5","locationName":"localGatewayRouteTableVpcAssociation"}}}},"CreateNatGateway":{"input":{"type":"structure","required":["AllocationId","SubnetId"],"members":{"AllocationId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SubnetId":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"NatGateway":{"shape":"Sc9","locationName":"natGateway"}}}},"CreateNetworkAcl":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"NetworkAcl":{"shape":"Scg","locationName":"networkAcl"}}}},"CreateNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Scl","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Scm","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"CreateNetworkInterface":{"input":{"type":"structure","required":["SubnetId"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S9v","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sbb","locationName":"ipv6Addresses"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S9y","locationName":"privateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"InterfaceType":{},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"NetworkInterface":{"shape":"Sct","locationName":"networkInterface"}}}},"CreateNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfaceId","Permission"],"members":{"NetworkInterfaceId":{},"AwsAccountId":{},"AwsService":{},"Permission":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfacePermission":{"shape":"Sd7","locationName":"interfacePermission"}}}},"CreatePlacementGroup":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"type":"integer"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"PlacementGroup":{"shape":"Sdd","locationName":"placementGroup"}}}},"CreateReservedInstancesListing":{"input":{"type":"structure","required":["ClientToken","InstanceCount","PriceSchedules","ReservedInstancesId"],"members":{"ClientToken":{"locationName":"clientToken"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S53","locationName":"reservedInstancesListingsSet"}}}},"CreateRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"LocalGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CreateRouteTable":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"RouteTable":{"shape":"Sdq","locationName":"routeTable"}}}},"CreateSecurityGroup":{"input":{"type":"structure","required":["Description","GroupName"],"members":{"Description":{"locationName":"GroupDescription"},"GroupName":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"GroupId":{"locationName":"groupId"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeId"],"members":{"Description":{},"VolumeId":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"Se2"}},"CreateSnapshots":{"input":{"type":"structure","required":["InstanceSpecification"],"members":{"Description":{},"InstanceSpecification":{"type":"structure","members":{"InstanceId":{},"ExcludeBootVolume":{"type":"boolean"}}},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"CopyTagsFromSource":{}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"Tags":{"shape":"Sj","locationName":"tagSet"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"VolumeId":{"locationName":"volumeId"},"State":{"locationName":"state"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"StartTime":{"locationName":"startTime","type":"timestamp"},"Progress":{"locationName":"progress"},"OwnerId":{"locationName":"ownerId"},"SnapshotId":{"locationName":"snapshotId"}}}}}}},"CreateSpotDatafeedSubscription":{"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"locationName":"bucket"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Prefix":{"locationName":"prefix"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Sed","locationName":"spotDatafeedSubscription"}}}},"CreateSubnet":{"input":{"type":"structure","required":["CidrBlock","VpcId"],"members":{"AvailabilityZone":{},"AvailabilityZoneId":{},"CidrBlock":{},"Ipv6CidrBlock":{},"OutpostArn":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S70","locationName":"subnet"}}}},"CreateTags":{"input":{"type":"structure","required":["Resources","Tags"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"Sej","locationName":"ResourceId"},"Tags":{"shape":"Sj","locationName":"Tag"}}}},"CreateTrafficMirrorFilter":{"input":{"type":"structure","members":{"Description":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sen","locationName":"trafficMirrorFilter"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterId","TrafficDirection","RuleNumber","RuleAction","DestinationCidrBlock","SourceCidrBlock"],"members":{"TrafficMirrorFilterId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Sex"},"SourcePortRange":{"shape":"Sex"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sep","locationName":"trafficMirrorFilterRule"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorSession":{"input":{"type":"structure","required":["NetworkInterfaceId","TrafficMirrorTargetId","TrafficMirrorFilterId","SessionNumber"],"members":{"NetworkInterfaceId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sf2","locationName":"trafficMirrorSession"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorTarget":{"input":{"type":"structure","members":{"NetworkInterfaceId":{},"NetworkLoadBalancerArn":{},"Description":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorTarget":{"shape":"Sf5","locationName":"trafficMirrorTarget"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTransitGateway":{"input":{"type":"structure","members":{"Description":{},"Options":{"type":"structure","members":{"AmazonSideAsn":{"type":"long"},"AutoAcceptSharedAttachments":{},"DefaultRouteTableAssociation":{},"DefaultRouteTablePropagation":{},"VpnEcmpSupport":{},"DnsSupport":{},"MulticastSupport":{}}},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Sff","locationName":"transitGateway"}}}},"CreateTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomain":{"shape":"Sfk","locationName":"transitGatewayMulticastDomain"}}}},"CreateTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayId","PeerTransitGatewayId","PeerAccountId","PeerRegion"],"members":{"TransitGatewayId":{},"PeerTransitGatewayId":{},"PeerAccountId":{},"PeerRegion":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Se","locationName":"transitGatewayPeeringAttachment"}}}},"CreateTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sfr","locationName":"route"}}}},"CreateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"TagSpecifications":{"shape":"S1l"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sfy","locationName":"transitGatewayRouteTable"}}}},"CreateTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayId","VpcId","SubnetIds"],"members":{"TransitGatewayId":{},"VpcId":{},"SubnetIds":{"shape":"Sg1"},"Options":{"type":"structure","members":{"DnsSupport":{},"Ipv6Support":{}}},"TagSpecifications":{"shape":"S1l"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sn","locationName":"transitGatewayVpcAttachment"}}}},"CreateVolume":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"OutpostArn":{},"Size":{"type":"integer"},"SnapshotId":{},"VolumeType":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"MultiAttachEnabled":{"type":"boolean"}}},"output":{"shape":"Sg5"}},"CreateVpc":{"input":{"type":"structure","required":["CidrBlock"],"members":{"CidrBlock":{},"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"Ipv6Pool":{},"Ipv6CidrBlock":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockNetworkBorderGroup":{}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S76","locationName":"vpc"}}}},"CreateVpcEndpoint":{"input":{"type":"structure","required":["VpcId","ServiceName"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointType":{},"VpcId":{},"ServiceName":{},"PolicyDocument":{},"RouteTableIds":{"shape":"Sgc","locationName":"RouteTableId"},"SubnetIds":{"shape":"Sgd","locationName":"SubnetId"},"SecurityGroupIds":{"shape":"Sge","locationName":"SecurityGroupId"},"ClientToken":{},"PrivateDnsEnabled":{"type":"boolean"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"VpcEndpoint":{"shape":"Sgg","locationName":"vpcEndpoint"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationArn","ConnectionEvents"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"So"},"ClientToken":{}}},"output":{"type":"structure","members":{"ConnectionNotification":{"shape":"Sgp","locationName":"connectionNotification"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["NetworkLoadBalancerArns"],"members":{"DryRun":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"PrivateDnsName":{},"NetworkLoadBalancerArns":{"shape":"So","locationName":"NetworkLoadBalancerArn"},"ClientToken":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ServiceConfiguration":{"shape":"Sgu","locationName":"serviceConfiguration"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PeerOwnerId":{"locationName":"peerOwnerId"},"PeerVpcId":{"locationName":"peerVpcId"},"VpcId":{"locationName":"vpcId"},"PeerRegion":{}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"S13","locationName":"vpcPeeringConnection"}}}},"CreateVpnConnection":{"input":{"type":"structure","required":["CustomerGatewayId","Type"],"members":{"CustomerGatewayId":{},"Type":{},"VpnGatewayId":{},"TransitGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Options":{"locationName":"options","type":"structure","members":{"EnableAcceleration":{"type":"boolean"},"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelOptions":{"type":"list","member":{"type":"structure","members":{"TunnelInsideCidr":{},"PreSharedKey":{},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2LifetimeSeconds":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"RekeyFuzzPercentage":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"DPDTimeoutSeconds":{"type":"integer"},"Phase1EncryptionAlgorithms":{"shape":"Sh8","locationName":"Phase1EncryptionAlgorithm"},"Phase2EncryptionAlgorithms":{"shape":"Sha","locationName":"Phase2EncryptionAlgorithm"},"Phase1IntegrityAlgorithms":{"shape":"Shc","locationName":"Phase1IntegrityAlgorithm"},"Phase2IntegrityAlgorithms":{"shape":"She","locationName":"Phase2IntegrityAlgorithm"},"Phase1DHGroupNumbers":{"shape":"Shg","locationName":"Phase1DHGroupNumber"},"Phase2DHGroupNumbers":{"shape":"Shi","locationName":"Phase2DHGroupNumber"},"IKEVersions":{"shape":"Shk","locationName":"IKEVersion"}}}}}}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Shn","locationName":"vpnConnection"}}}},"CreateVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"CreateVpnGateway":{"input":{"type":"structure","required":["Type"],"members":{"AvailabilityZone":{},"Type":{},"AmazonSideAsn":{"type":"long"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateway":{"shape":"Sig","locationName":"vpnGateway"}}}},"DeleteClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S6o","locationName":"status"}}}},"DeleteClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock"],"members":{"ClientVpnEndpointId":{},"TargetVpcSubnetId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S6s","locationName":"status"}}}},"DeleteCustomerGateway":{"input":{"type":"structure","required":["CustomerGatewayId"],"members":{"CustomerGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId"],"members":{"DhcpOptionsId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteEgressOnlyInternetGateway":{"input":{"type":"structure","required":["EgressOnlyInternetGatewayId"],"members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayId":{}}},"output":{"type":"structure","members":{"ReturnCode":{"locationName":"returnCode","type":"boolean"}}}},"DeleteFleets":{"input":{"type":"structure","required":["FleetIds","TerminateInstances"],"members":{"DryRun":{"type":"boolean"},"FleetIds":{"shape":"Sis","locationName":"FleetId"},"TerminateInstances":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetDeletions":{"locationName":"successfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentFleetState":{"locationName":"currentFleetState"},"PreviousFleetState":{"locationName":"previousFleetState"},"FleetId":{"locationName":"fleetId"}}}},"UnsuccessfulFleetDeletions":{"locationName":"unsuccessfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"FleetId":{"locationName":"fleetId"}}}}}}},"DeleteFlowLogs":{"input":{"type":"structure","required":["FlowLogIds"],"members":{"DryRun":{"type":"boolean"},"FlowLogIds":{"shape":"Sj2","locationName":"FlowLogId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"DeleteFpgaImage":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"}}}},"DeleteKeyPair":{"input":{"type":"structure","members":{"KeyName":{},"KeyPairId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sax","locationName":"launchTemplate"}}}},"DeleteLaunchTemplateVersions":{"input":{"type":"structure","required":["Versions"],"members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sjd","locationName":"LaunchTemplateVersion"}}},"output":{"type":"structure","members":{"SuccessfullyDeletedLaunchTemplateVersions":{"locationName":"successfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"}}}},"UnsuccessfullyDeletedLaunchTemplateVersions":{"locationName":"unsuccessfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"ResponseError":{"locationName":"responseError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"DeleteLocalGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","LocalGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sc0","locationName":"route"}}}},"DeleteLocalGatewayRouteTableVpcAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableVpcAssociationId"],"members":{"LocalGatewayRouteTableVpcAssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociation":{"shape":"Sc5","locationName":"localGatewayRouteTableVpcAssociation"}}}},"DeleteNatGateway":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"DryRun":{"type":"boolean"},"NatGatewayId":{}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"}}}},"DeleteNetworkAcl":{"input":{"type":"structure","required":["NetworkAclId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}}},"DeleteNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","RuleNumber"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"DeleteNetworkInterface":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"DeleteNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfacePermissionId"],"members":{"NetworkInterfacePermissionId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeletePlacementGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"}}}},"DeleteQueuedReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstancesIds":{"locationName":"ReservedInstancesId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SuccessfulQueuedPurchaseDeletions":{"locationName":"successfulQueuedPurchaseDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"FailedQueuedPurchaseDeletions":{"locationName":"failedQueuedPurchaseDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}}}}},"DeleteRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteSecurityGroup":{"input":{"type":"structure","members":{"GroupId":{},"GroupName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnet":{"input":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteTags":{"input":{"type":"structure","required":["Resources"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"Sej","locationName":"resourceId"},"Tags":{"shape":"Sj","locationName":"tag"}}}},"DeleteTrafficMirrorFilter":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"}}}},"DeleteTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"}}}},"DeleteTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"}}}},"DeleteTrafficMirrorTarget":{"input":{"type":"structure","required":["TrafficMirrorTargetId"],"members":{"TrafficMirrorTargetId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"}}}},"DeleteTransitGateway":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Sff","locationName":"transitGateway"}}}},"DeleteTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId"],"members":{"TransitGatewayMulticastDomainId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomain":{"shape":"Sfk","locationName":"transitGatewayMulticastDomain"}}}},"DeleteTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Se","locationName":"transitGatewayPeeringAttachment"}}}},"DeleteTransitGatewayRoute":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","DestinationCidrBlock"],"members":{"TransitGatewayRouteTableId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sfr","locationName":"route"}}}},"DeleteTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sfy","locationName":"transitGatewayRouteTable"}}}},"DeleteTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sn","locationName":"transitGatewayVpcAttachment"}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpcEndpointConnectionNotifications":{"input":{"type":"structure","required":["ConnectionNotificationIds"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationIds":{"shape":"So","locationName":"ConnectionNotificationId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"DeleteVpcEndpointServiceConfigurations":{"input":{"type":"structure","required":["ServiceIds"],"members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sl5","locationName":"ServiceId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"DeleteVpcEndpoints":{"input":{"type":"structure","required":["VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"Su","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"DeleteVpnGateway":{"input":{"type":"structure","required":["VpnGatewayId"],"members":{"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeprovisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1e","locationName":"byoipCidr"}}}},"DeregisterImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeregisterInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTagAttribute":{"type":"structure","members":{"IncludeAllTagsOfInstance":{"type":"boolean"},"InstanceTagKeys":{"shape":"Slj","locationName":"InstanceTagKey"}}}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Sll","locationName":"instanceTagAttribute"}}}},"DeregisterTransitGatewayMulticastGroupMembers":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Sln"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeregisteredMulticastGroupMembers":{"locationName":"deregisteredMulticastGroupMembers","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"DeregisteredNetworkInterfaceIds":{"shape":"So","locationName":"deregisteredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"DeregisterTransitGatewayMulticastGroupSources":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Sln"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeregisteredMulticastGroupSources":{"locationName":"deregisteredMulticastGroupSources","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"DeregisteredNetworkInterfaceIds":{"shape":"So","locationName":"deregisteredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"locationName":"attributeName","type":"list","member":{"locationName":"attributeName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AccountAttributes":{"locationName":"accountAttributeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"AttributeValues":{"locationName":"attributeValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeValue":{"locationName":"attributeValue"}}}}}}}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"PublicIps":{"locationName":"PublicIp","type":"list","member":{"locationName":"PublicIp"}},"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"AllocationId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"Domain":{"locationName":"domain"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceOwnerId":{"locationName":"networkInterfaceOwnerId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"Tags":{"shape":"Sj","locationName":"tagSet"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"}}}}}}},"DescribeAggregateIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UseLongIdsAggregated":{"locationName":"useLongIdsAggregated","type":"boolean"},"Statuses":{"shape":"Smb","locationName":"statusSet"}}}},"DescribeAvailabilityZones":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"ZoneNames":{"locationName":"ZoneName","type":"list","member":{"locationName":"ZoneName"}},"ZoneIds":{"locationName":"ZoneId","type":"list","member":{"locationName":"ZoneId"}},"AllAvailabilityZones":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZoneInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"zoneState"},"OptInStatus":{"locationName":"optInStatus"},"Messages":{"locationName":"messageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Message":{"locationName":"message"}}}},"RegionName":{"locationName":"regionName"},"ZoneName":{"locationName":"zoneName"},"ZoneId":{"locationName":"zoneId"},"GroupName":{"locationName":"groupName"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"}}}}}}},"DescribeBundleTasks":{"input":{"type":"structure","members":{"BundleIds":{"locationName":"BundleId","type":"list","member":{"locationName":"BundleId"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTasks":{"locationName":"bundleInstanceTasksSet","type":"list","member":{"shape":"S4k","locationName":"item"}}}}},"DescribeByoipCidrs":{"input":{"type":"structure","required":["MaxResults"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ByoipCidrs":{"locationName":"byoipCidrSet","type":"list","member":{"shape":"S1e","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityReservations":{"input":{"type":"structure","members":{"CapacityReservationIds":{"locationName":"CapacityReservationId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservations":{"locationName":"capacityReservationSet","type":"list","member":{"shape":"S6c","locationName":"item"}}}}},"DescribeClassicLinkInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Groups":{"shape":"Scw","locationName":"groupSet"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnAuthorizationRules":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"},"NextToken":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizationRules":{"locationName":"authorizationRule","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"AccessAll":{"locationName":"accessAll","type":"boolean"},"DestinationCidr":{"locationName":"destinationCidr"},"Status":{"shape":"S40","locationName":"status"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Connections":{"locationName":"connections","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Timestamp":{"locationName":"timestamp"},"ConnectionId":{"locationName":"connectionId"},"Username":{"locationName":"username"},"ConnectionEstablishedTime":{"locationName":"connectionEstablishedTime"},"IngressBytes":{"locationName":"ingressBytes"},"EgressBytes":{"locationName":"egressBytes"},"IngressPackets":{"locationName":"ingressPackets"},"EgressPackets":{"locationName":"egressPackets"},"ClientIp":{"locationName":"clientIp"},"CommonName":{"locationName":"commonName"},"Status":{"shape":"Snh","locationName":"status"},"ConnectionEndTime":{"locationName":"connectionEndTime"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnEndpoints":{"input":{"type":"structure","members":{"ClientVpnEndpointIds":{"locationName":"ClientVpnEndpointId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpoints":{"locationName":"clientVpnEndpoint","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"Status":{"shape":"S6o","locationName":"status"},"CreationTime":{"locationName":"creationTime"},"DeletionTime":{"locationName":"deletionTime"},"DnsName":{"locationName":"dnsName"},"ClientCidrBlock":{"locationName":"clientCidrBlock"},"DnsServers":{"shape":"So","locationName":"dnsServer"},"SplitTunnel":{"locationName":"splitTunnel","type":"boolean"},"VpnProtocol":{"locationName":"vpnProtocol"},"TransportProtocol":{"locationName":"transportProtocol"},"VpnPort":{"locationName":"vpnPort","type":"integer"},"AssociatedTargetNetworks":{"deprecated":true,"deprecatedMessage":"This property is deprecated. To view the target networks associated with a Client VPN endpoint, call DescribeClientVpnTargetNetworks and inspect the clientVpnTargetNetworks response element.","locationName":"associatedTargetNetwork","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkId":{"locationName":"networkId"},"NetworkType":{"locationName":"networkType"}}}},"ServerCertificateArn":{"locationName":"serverCertificateArn"},"AuthenticationOptions":{"locationName":"authenticationOptions","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"ActiveDirectory":{"locationName":"activeDirectory","type":"structure","members":{"DirectoryId":{"locationName":"directoryId"}}},"MutualAuthentication":{"locationName":"mutualAuthentication","type":"structure","members":{"ClientRootCertificateChain":{"locationName":"clientRootCertificateChain"}}},"FederatedAuthentication":{"locationName":"federatedAuthentication","type":"structure","members":{"SamlProviderArn":{"locationName":"samlProviderArn"}}}}}},"ConnectionLogOptions":{"locationName":"connectionLogOptions","type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"Tags":{"shape":"Sj","locationName":"tagSet"},"SecurityGroupIds":{"shape":"S1u","locationName":"securityGroupIdSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnRoutes":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"DestinationCidr":{"locationName":"destinationCidr"},"TargetSubnet":{"locationName":"targetSubnet"},"Type":{"locationName":"type"},"Origin":{"locationName":"origin"},"Status":{"shape":"S6s","locationName":"status"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnTargetNetworks":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"AssociationIds":{"shape":"So"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnTargetNetworks":{"locationName":"clientVpnTargetNetworks","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociationId":{"locationName":"associationId"},"VpcId":{"locationName":"vpcId"},"TargetNetworkId":{"locationName":"targetNetworkId"},"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S2d","locationName":"status"},"SecurityGroups":{"shape":"So","locationName":"securityGroups"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCoipPools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPools":{"locationName":"coipPoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"PoolCidrs":{"shape":"So","locationName":"poolCidrSet"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeConversionTasks":{"input":{"type":"structure","members":{"ConversionTaskIds":{"locationName":"conversionTaskId","type":"list","member":{"locationName":"item"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ConversionTasks":{"locationName":"conversionTasks","type":"list","member":{"shape":"Soj","locationName":"item"}}}}},"DescribeCustomerGateways":{"input":{"type":"structure","members":{"CustomerGatewayIds":{"locationName":"CustomerGatewayId","type":"list","member":{"locationName":"CustomerGatewayId"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateways":{"locationName":"customerGatewaySet","type":"list","member":{"shape":"S6x","locationName":"item"}}}}},"DescribeDhcpOptions":{"input":{"type":"structure","members":{"DhcpOptionsIds":{"locationName":"DhcpOptionsId","type":"list","member":{"locationName":"DhcpOptionsId"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DhcpOptions":{"locationName":"dhcpOptionsSet","type":"list","member":{"shape":"S7f","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeEgressOnlyInternetGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayIds":{"locationName":"EgressOnlyInternetGatewayId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"EgressOnlyInternetGateways":{"locationName":"egressOnlyInternetGatewaySet","type":"list","member":{"shape":"S7m","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeElasticGpus":{"input":{"type":"structure","members":{"ElasticGpuIds":{"locationName":"ElasticGpuId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ElasticGpuSet":{"locationName":"elasticGpuSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"AvailabilityZone":{"locationName":"availabilityZone"},"ElasticGpuType":{"locationName":"elasticGpuType"},"ElasticGpuHealth":{"locationName":"elasticGpuHealth","type":"structure","members":{"Status":{"locationName":"status"}}},"ElasticGpuState":{"locationName":"elasticGpuState"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"ExportImageTaskIds":{"locationName":"ExportImageTaskId","type":"list","member":{"locationName":"ExportImageTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExportImageTasks":{"locationName":"exportImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"Spm","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIds":{"locationName":"exportTaskId","type":"list","member":{"locationName":"ExportTaskId"}},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"ExportTasks":{"locationName":"exportTaskSet","type":"list","member":{"shape":"S9a","locationName":"item"}}}}},"DescribeFastSnapshotRestores":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"FastSnapshotRestores":{"locationName":"fastSnapshotRestoreSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFleetHistory":{"input":{"type":"structure","required":["FleetId","StartTime"],"members":{"DryRun":{"type":"boolean"},"EventType":{},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"StartTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"Sq3","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeFleetInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"Sq6","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"}}}},"DescribeFleets":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetIds":{"shape":"Sis","locationName":"FleetId"},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Fleets":{"locationName":"fleetSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"FleetId":{"locationName":"fleetId"},"FleetState":{"locationName":"fleetState"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"FulfilledOnDemandCapacity":{"locationName":"fulfilledOnDemandCapacity","type":"double"},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S8g","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"shape":"S8h","locationName":"item"}}}}},"TargetCapacitySpecification":{"locationName":"targetCapacitySpecification","type":"structure","members":{"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"SpotTargetCapacity":{"locationName":"spotTargetCapacity","type":"integer"},"DefaultTargetCapacityType":{"locationName":"defaultTargetCapacityType"}}},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"OnDemandOptions":{"locationName":"onDemandOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"CapacityReservationOptions":{"locationName":"capacityReservationOptions","type":"structure","members":{"UsageStrategy":{"locationName":"usageStrategy"}}},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"Tags":{"shape":"Sj","locationName":"tagSet"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S8f","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S8f","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"S8m","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}}}}}}}},"DescribeFlowLogs":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"Sm2"},"FlowLogIds":{"shape":"Sj2","locationName":"FlowLogId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FlowLogs":{"locationName":"flowLogSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CreationTime":{"locationName":"creationTime","type":"timestamp"},"DeliverLogsErrorMessage":{"locationName":"deliverLogsErrorMessage"},"DeliverLogsPermissionArn":{"locationName":"deliverLogsPermissionArn"},"DeliverLogsStatus":{"locationName":"deliverLogsStatus"},"FlowLogId":{"locationName":"flowLogId"},"FlowLogStatus":{"locationName":"flowLogStatus"},"LogGroupName":{"locationName":"logGroupName"},"ResourceId":{"locationName":"resourceId"},"TrafficType":{"locationName":"trafficType"},"LogDestinationType":{"locationName":"logDestinationType"},"LogDestination":{"locationName":"logDestination"},"LogFormat":{"locationName":"logFormat"},"Tags":{"shape":"Sj","locationName":"tagSet"},"MaxAggregationInterval":{"locationName":"maxAggregationInterval","type":"integer"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId","Attribute"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Sqw","locationName":"fpgaImageAttribute"}}}},"DescribeFpgaImages":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"FpgaImageIds":{"locationName":"FpgaImageId","type":"list","member":{"locationName":"item"}},"Owners":{"shape":"Sr5","locationName":"Owner"},"Filters":{"shape":"Sm2","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FpgaImages":{"locationName":"fpgaImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"ShellVersion":{"locationName":"shellVersion"},"PciId":{"locationName":"pciId","type":"structure","members":{"DeviceId":{},"VendorId":{},"SubsystemId":{},"SubsystemVendorId":{}}},"State":{"locationName":"state","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"CreateTime":{"locationName":"createTime","type":"timestamp"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"Tags":{"shape":"Sj","locationName":"tags"},"Public":{"locationName":"public","type":"boolean"},"DataRetentionSupport":{"locationName":"dataRetentionSupport","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHostReservationOfferings":{"input":{"type":"structure","members":{"Filter":{"shape":"Sm2"},"MaxDuration":{"type":"integer"},"MaxResults":{"type":"integer"},"MinDuration":{"type":"integer"},"NextToken":{},"OfferingId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"OfferingSet":{"locationName":"offeringSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}}}}},"DescribeHostReservations":{"input":{"type":"structure","members":{"Filter":{"shape":"Sm2"},"HostReservationIdSet":{"type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HostReservationSet":{"locationName":"hostReservationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"End":{"locationName":"end","type":"timestamp"},"HostIdSet":{"shape":"Srq","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UpfrontPrice":{"locationName":"upfrontPrice"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHosts":{"input":{"type":"structure","members":{"Filter":{"shape":"Sm2","locationName":"filter"},"HostIds":{"shape":"Srt","locationName":"hostId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Hosts":{"locationName":"hostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableCapacity":{"locationName":"availableCapacity","type":"structure","members":{"AvailableInstanceCapacity":{"locationName":"availableInstanceCapacity","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailableCapacity":{"locationName":"availableCapacity","type":"integer"},"InstanceType":{"locationName":"instanceType"},"TotalCapacity":{"locationName":"totalCapacity","type":"integer"}}}},"AvailableVCpus":{"locationName":"availableVCpus","type":"integer"}}},"ClientToken":{"locationName":"clientToken"},"HostId":{"locationName":"hostId"},"HostProperties":{"locationName":"hostProperties","type":"structure","members":{"Cores":{"locationName":"cores","type":"integer"},"InstanceType":{"locationName":"instanceType"},"InstanceFamily":{"locationName":"instanceFamily"},"Sockets":{"locationName":"sockets","type":"integer"},"TotalVCpus":{"locationName":"totalVCpus","type":"integer"}}},"HostReservationId":{"locationName":"hostReservationId"},"Instances":{"locationName":"instances","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"OwnerId":{"locationName":"ownerId"}}}},"State":{"locationName":"state"},"AllocationTime":{"locationName":"allocationTime","type":"timestamp"},"ReleaseTime":{"locationName":"releaseTime","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"},"HostRecovery":{"locationName":"hostRecovery"},"AllowsMultipleInstanceTypes":{"locationName":"allowsMultipleInstanceTypes"},"OwnerId":{"locationName":"ownerId"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"MemberOfServiceLinkedResourceGroup":{"locationName":"memberOfServiceLinkedResourceGroup","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIamInstanceProfileAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"AssociationId"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociations":{"locationName":"iamInstanceProfileAssociationSet","type":"list","member":{"shape":"S2k","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIdFormat":{"input":{"type":"structure","members":{"Resource":{}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Smb","locationName":"statusSet"}}}},"DescribeIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Smb","locationName":"statusSet"}}}},"DescribeImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BlockDeviceMappings":{"shape":"Ssi","locationName":"blockDeviceMapping"},"ImageId":{"locationName":"imageId"},"LaunchPermissions":{"shape":"Ssj","locationName":"launchPermission"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"Description":{"shape":"S7j","locationName":"description"},"KernelId":{"shape":"S7j","locationName":"kernel"},"RamdiskId":{"shape":"S7j","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S7j","locationName":"sriovNetSupport"}}}},"DescribeImages":{"input":{"type":"structure","members":{"ExecutableUsers":{"locationName":"ExecutableBy","type":"list","member":{"locationName":"ExecutableBy"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"ImageId"}},"Owners":{"shape":"Sr5","locationName":"Owner"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imagesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"CreationDate":{"locationName":"creationDate"},"ImageId":{"locationName":"imageId"},"ImageLocation":{"locationName":"imageLocation"},"ImageType":{"locationName":"imageType"},"Public":{"locationName":"isPublic","type":"boolean"},"KernelId":{"locationName":"kernelId"},"OwnerId":{"locationName":"imageOwnerId"},"Platform":{"locationName":"platform"},"PlatformDetails":{"locationName":"platformDetails"},"UsageOperation":{"locationName":"usageOperation"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"locationName":"imageState"},"BlockDeviceMappings":{"shape":"Ssi","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageOwnerAlias":{"locationName":"imageOwnerAlias"},"Name":{"locationName":"name"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Ssw","locationName":"stateReason"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"}}}}}}},"DescribeImportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2"},"ImportTaskIds":{"locationName":"ImportTaskId","type":"list","member":{"locationName":"ImportTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportImageTasks":{"locationName":"importImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"St4","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sj","locationName":"tagSet"},"LicenseSpecifications":{"shape":"St7","locationName":"licenseSpecifications"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportSnapshotTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2"},"ImportTaskIds":{"locationName":"ImportTaskId","type":"list","member":{"locationName":"ImportTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSnapshotTasks":{"locationName":"importSnapshotTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Stf","locationName":"snapshotTaskDetail"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}},"output":{"type":"structure","members":{"Groups":{"shape":"Scw","locationName":"groupSet"},"BlockDeviceMappings":{"shape":"Stj","locationName":"blockDeviceMapping"},"DisableApiTermination":{"shape":"Stm","locationName":"disableApiTermination"},"EnaSupport":{"shape":"Stm","locationName":"enaSupport"},"EbsOptimized":{"shape":"Stm","locationName":"ebsOptimized"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S7j","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S7j","locationName":"instanceType"},"KernelId":{"shape":"S7j","locationName":"kernel"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"RamdiskId":{"shape":"S7j","locationName":"ramdisk"},"RootDeviceName":{"shape":"S7j","locationName":"rootDeviceName"},"SourceDestCheck":{"shape":"Stm","locationName":"sourceDestCheck"},"SriovNetSupport":{"shape":"S7j","locationName":"sriovNetSupport"},"UserData":{"shape":"S7j","locationName":"userData"}}}},"DescribeInstanceCreditSpecifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceCreditSpecifications":{"locationName":"instanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"CpuCredits":{"locationName":"cpuCredits"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Sll","locationName":"instanceTagAttribute"}}}},"DescribeInstanceStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludeAllInstances":{"locationName":"includeAllInstances","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceStatuses":{"locationName":"instanceStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"OutpostArn":{"locationName":"outpostArn"},"Events":{"locationName":"eventsSet","type":"list","member":{"shape":"Stz","locationName":"item"}},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"shape":"Su2","locationName":"instanceState"},"InstanceStatus":{"shape":"Su4","locationName":"instanceStatus"},"SystemStatus":{"shape":"Su4","locationName":"systemStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTypeOfferings":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LocationType":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypeOfferings":{"locationName":"instanceTypeOfferingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"LocationType":{"locationName":"locationType"},"Location":{"locationName":"location"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTypes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypes":{"locationName":"instanceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"CurrentGeneration":{"locationName":"currentGeneration","type":"boolean"},"FreeTierEligible":{"locationName":"freeTierEligible","type":"boolean"},"SupportedUsageClasses":{"locationName":"supportedUsageClasses","type":"list","member":{"locationName":"item"}},"SupportedRootDeviceTypes":{"locationName":"supportedRootDeviceTypes","type":"list","member":{"locationName":"item"}},"SupportedVirtualizationTypes":{"locationName":"supportedVirtualizationTypes","type":"list","member":{"locationName":"item"}},"BareMetal":{"locationName":"bareMetal","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ProcessorInfo":{"locationName":"processorInfo","type":"structure","members":{"SupportedArchitectures":{"locationName":"supportedArchitectures","type":"list","member":{"locationName":"item"}},"SustainedClockSpeedInGhz":{"locationName":"sustainedClockSpeedInGhz","type":"double"}}},"VCpuInfo":{"locationName":"vCpuInfo","type":"structure","members":{"DefaultVCpus":{"locationName":"defaultVCpus","type":"integer"},"DefaultCores":{"locationName":"defaultCores","type":"integer"},"DefaultThreadsPerCore":{"locationName":"defaultThreadsPerCore","type":"integer"},"ValidCores":{"locationName":"validCores","type":"list","member":{"locationName":"item","type":"integer"}},"ValidThreadsPerCore":{"locationName":"validThreadsPerCore","type":"list","member":{"locationName":"item","type":"integer"}}}},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"long"}}},"InstanceStorageSupported":{"locationName":"instanceStorageSupported","type":"boolean"},"InstanceStorageInfo":{"locationName":"instanceStorageInfo","type":"structure","members":{"TotalSizeInGB":{"locationName":"totalSizeInGB","type":"long"},"Disks":{"locationName":"disks","type":"list","member":{"locationName":"item","type":"structure","members":{"SizeInGB":{"locationName":"sizeInGB","type":"long"},"Count":{"locationName":"count","type":"integer"},"Type":{"locationName":"type"}}}}}},"EbsInfo":{"locationName":"ebsInfo","type":"structure","members":{"EbsOptimizedSupport":{"locationName":"ebsOptimizedSupport"},"EncryptionSupport":{"locationName":"encryptionSupport"},"EbsOptimizedInfo":{"locationName":"ebsOptimizedInfo","type":"structure","members":{"BaselineBandwidthInMbps":{"locationName":"baselineBandwidthInMbps","type":"integer"},"BaselineThroughputInMBps":{"locationName":"baselineThroughputInMBps","type":"double"},"BaselineIops":{"locationName":"baselineIops","type":"integer"},"MaximumBandwidthInMbps":{"locationName":"maximumBandwidthInMbps","type":"integer"},"MaximumThroughputInMBps":{"locationName":"maximumThroughputInMBps","type":"double"},"MaximumIops":{"locationName":"maximumIops","type":"integer"}}},"NvmeSupport":{"locationName":"nvmeSupport"}}},"NetworkInfo":{"locationName":"networkInfo","type":"structure","members":{"NetworkPerformance":{"locationName":"networkPerformance"},"MaximumNetworkInterfaces":{"locationName":"maximumNetworkInterfaces","type":"integer"},"Ipv4AddressesPerInterface":{"locationName":"ipv4AddressesPerInterface","type":"integer"},"Ipv6AddressesPerInterface":{"locationName":"ipv6AddressesPerInterface","type":"integer"},"Ipv6Supported":{"locationName":"ipv6Supported","type":"boolean"},"EnaSupport":{"locationName":"enaSupport"},"EfaSupported":{"locationName":"efaSupported","type":"boolean"}}},"GpuInfo":{"locationName":"gpuInfo","type":"structure","members":{"Gpus":{"locationName":"gpus","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"Count":{"locationName":"count","type":"integer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalGpuMemoryInMiB":{"locationName":"totalGpuMemoryInMiB","type":"integer"}}},"FpgaInfo":{"locationName":"fpgaInfo","type":"structure","members":{"Fpgas":{"locationName":"fpgas","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"Count":{"locationName":"count","type":"integer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalFpgaMemoryInMiB":{"locationName":"totalFpgaMemoryInMiB","type":"integer"}}},"PlacementGroupInfo":{"locationName":"placementGroupInfo","type":"structure","members":{"SupportedStrategies":{"locationName":"supportedStrategies","type":"list","member":{"locationName":"item"}}}},"InferenceAcceleratorInfo":{"locationName":"inferenceAcceleratorInfo","type":"structure","members":{"Accelerators":{"locationName":"item","type":"list","member":{"type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"}}}}}},"HibernationSupported":{"locationName":"hibernationSupported","type":"boolean"},"BurstablePerformanceSupported":{"locationName":"burstablePerformanceSupported","type":"boolean"},"DedicatedHostsSupported":{"locationName":"dedicatedHostsSupported","type":"boolean"},"AutoRecoverySupported":{"locationName":"autoRecoverySupported","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Reservations":{"locationName":"reservationSet","type":"list","member":{"shape":"Sww","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInternetGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayIds":{"locationName":"internetGatewayId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InternetGateways":{"locationName":"internetGatewaySet","type":"list","member":{"shape":"S9g","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIpv6Pools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"Ipv6Pools":{"locationName":"ipv6PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolCidrBlocks":{"locationName":"poolCidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidr":{"locationName":"poolCidrBlock"}}}},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeKeyPairs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"KeyNames":{"locationName":"KeyName","type":"list","member":{"locationName":"KeyName"}},"KeyPairIds":{"locationName":"KeyPairId","type":"list","member":{"locationName":"KeyPairId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyPairs":{"locationName":"keySet","type":"list","member":{"locationName":"item","type":"structure","members":{"KeyPairId":{"locationName":"keyPairId"},"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}}}}},"DescribeLaunchTemplateVersions":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sjd","locationName":"LaunchTemplateVersion"},"MinVersion":{},"MaxVersion":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"LaunchTemplateVersions":{"locationName":"launchTemplateVersionSet","type":"list","member":{"shape":"Sb3","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLaunchTemplates":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateIds":{"locationName":"LaunchTemplateId","type":"list","member":{"locationName":"item"}},"LaunchTemplateNames":{"locationName":"LaunchTemplateName","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"LaunchTemplates":{"locationName":"launchTemplates","type":"list","member":{"shape":"Sax","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"input":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationIds":{"locationName":"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId":{"locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociationId"},"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"LocalGatewayId":{"locationName":"localGatewayId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"State":{"locationName":"state"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTableVpcAssociations":{"input":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociationIds":{"locationName":"LocalGatewayRouteTableVpcAssociationId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociations":{"locationName":"localGatewayRouteTableVpcAssociationSet","type":"list","member":{"shape":"Sc5","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTables":{"input":{"type":"structure","members":{"LocalGatewayRouteTableIds":{"locationName":"LocalGatewayRouteTableId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTables":{"locationName":"localGatewayRouteTableSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayId":{"locationName":"localGatewayId"},"OutpostArn":{"locationName":"outpostArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayVirtualInterfaceGroups":{"input":{"type":"structure","members":{"LocalGatewayVirtualInterfaceGroupIds":{"locationName":"LocalGatewayVirtualInterfaceGroupId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayVirtualInterfaceGroups":{"locationName":"localGatewayVirtualInterfaceGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"LocalGatewayVirtualInterfaceIds":{"shape":"Syy","locationName":"localGatewayVirtualInterfaceIdSet"},"LocalGatewayId":{"locationName":"localGatewayId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayVirtualInterfaces":{"input":{"type":"structure","members":{"LocalGatewayVirtualInterfaceIds":{"shape":"Syy","locationName":"LocalGatewayVirtualInterfaceId"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayVirtualInterfaces":{"locationName":"localGatewayVirtualInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayVirtualInterfaceId":{"locationName":"localGatewayVirtualInterfaceId"},"LocalGatewayId":{"locationName":"localGatewayId"},"Vlan":{"locationName":"vlan","type":"integer"},"LocalAddress":{"locationName":"localAddress"},"PeerAddress":{"locationName":"peerAddress"},"LocalBgpAsn":{"locationName":"localBgpAsn","type":"integer"},"PeerBgpAsn":{"locationName":"peerBgpAsn","type":"integer"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGateways":{"input":{"type":"structure","members":{"LocalGatewayIds":{"locationName":"LocalGatewayId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGateways":{"locationName":"localGatewaySet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayId":{"locationName":"localGatewayId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeMovingAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"PublicIps":{"shape":"So","locationName":"publicIp"}}},"output":{"type":"structure","members":{"MovingAddressStatuses":{"locationName":"movingAddressStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"MoveStatus":{"locationName":"moveStatus"},"PublicIp":{"locationName":"publicIp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNatGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"Sm2"},"MaxResults":{"type":"integer"},"NatGatewayIds":{"locationName":"NatGatewayId","type":"list","member":{"locationName":"item"}},"NextToken":{}}},"output":{"type":"structure","members":{"NatGateways":{"locationName":"natGatewaySet","type":"list","member":{"shape":"Sc9","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkAcls":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclIds":{"locationName":"NetworkAclId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkAcls":{"locationName":"networkAclSet","type":"list","member":{"shape":"Scg","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"Scv","locationName":"attachment"},"Description":{"shape":"S7j","locationName":"description"},"Groups":{"shape":"Scw","locationName":"groupSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Stm","locationName":"sourceDestCheck"}}}},"DescribeNetworkInterfacePermissions":{"input":{"type":"structure","members":{"NetworkInterfacePermissionIds":{"locationName":"NetworkInterfacePermissionId","type":"list","member":{}},"Filters":{"shape":"Sm2","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfacePermissions":{"locationName":"networkInterfacePermissions","type":"list","member":{"shape":"Sd7","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaces":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceIds":{"locationName":"NetworkInterfaceId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"shape":"Sct","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribePlacementGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupNames":{"locationName":"groupName","type":"list","member":{}},"GroupIds":{"locationName":"GroupId","type":"list","member":{"locationName":"GroupId"}}}},"output":{"type":"structure","members":{"PlacementGroups":{"locationName":"placementGroupSet","type":"list","member":{"shape":"Sdd","locationName":"item"}}}}},"DescribePrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"locationName":"PrefixListId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidrs":{"shape":"So","locationName":"cidrSet"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListName":{"locationName":"prefixListName"}}}}}}},"DescribePrincipalIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Resources":{"locationName":"Resource","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Principals":{"locationName":"principalSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"},"Statuses":{"shape":"Smb","locationName":"statusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribePublicIpv4Pools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sm2","locationName":"Filter"}}},"output":{"type":"structure","members":{"PublicIpv4Pools":{"locationName":"publicIpv4PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolAddressRanges":{"locationName":"poolAddressRangeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FirstAddress":{"locationName":"firstAddress"},"LastAddress":{"locationName":"lastAddress"},"AddressCount":{"locationName":"addressCount","type":"integer"},"AvailableAddressCount":{"locationName":"availableAddressCount","type":"integer"}}}},"TotalAddressCount":{"locationName":"totalAddressCount","type":"integer"},"TotalAvailableAddressCount":{"locationName":"totalAvailableAddressCount","type":"integer"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRegions":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"RegionNames":{"locationName":"RegionName","type":"list","member":{"locationName":"RegionName"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"AllRegions":{"type":"boolean"}}},"output":{"type":"structure","members":{"Regions":{"locationName":"regionInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Endpoint":{"locationName":"regionEndpoint"},"RegionName":{"locationName":"regionName"},"OptInStatus":{"locationName":"optInStatus"}}}}}}},"DescribeReservedInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"OfferingClass":{},"ReservedInstancesIds":{"shape":"S110","locationName":"ReservedInstancesId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstances":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"End":{"locationName":"end","type":"timestamp"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"RecurringCharges":{"shape":"S118","locationName":"recurringCharges"},"Scope":{"locationName":"scope"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}}}}},"DescribeReservedInstancesListings":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S53","locationName":"reservedInstancesListingsSet"}}}},"DescribeReservedInstancesModifications":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"ReservedInstancesModificationIds":{"locationName":"ReservedInstancesModificationId","type":"list","member":{"locationName":"ReservedInstancesModificationId"}},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReservedInstancesModifications":{"locationName":"reservedInstancesModificationsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"EffectiveDate":{"locationName":"effectiveDate","type":"timestamp"},"ModificationResults":{"locationName":"modificationResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"},"TargetConfiguration":{"shape":"S11m","locationName":"targetConfiguration"}}}},"ReservedInstancesIds":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}}}}},"DescribeReservedInstancesOfferings":{"input":{"type":"structure","members":{"AvailabilityZone":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"IncludeMarketplace":{"type":"boolean"},"InstanceType":{},"MaxDuration":{"type":"long"},"MaxInstanceCount":{"type":"integer"},"MinDuration":{"type":"long"},"OfferingClass":{},"ProductDescription":{},"ReservedInstancesOfferingIds":{"locationName":"ReservedInstancesOfferingId","type":"list","member":{}},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstancesOfferings":{"locationName":"reservedInstancesOfferingsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesOfferingId":{"locationName":"reservedInstancesOfferingId"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Marketplace":{"locationName":"marketplace","type":"boolean"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"PricingDetails":{"locationName":"pricingDetailsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Price":{"locationName":"price","type":"double"}}}},"RecurringCharges":{"shape":"S118","locationName":"recurringCharges"},"Scope":{"locationName":"scope"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRouteTables":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableIds":{"locationName":"RouteTableId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"RouteTables":{"locationName":"routeTableSet","type":"list","member":{"shape":"Sdq","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeScheduledInstanceAvailability":{"input":{"type":"structure","required":["FirstSlotStartTimeRange","Recurrence"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"FirstSlotStartTimeRange":{"type":"structure","required":["EarliestTime","LatestTime"],"members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"MaxResults":{"type":"integer"},"MaxSlotDurationInHours":{"type":"integer"},"MinSlotDurationInHours":{"type":"integer"},"NextToken":{},"Recurrence":{"type":"structure","members":{"Frequency":{},"Interval":{"type":"integer"},"OccurrenceDays":{"locationName":"OccurrenceDay","type":"list","member":{"locationName":"OccurenceDay","type":"integer"}},"OccurrenceRelativeToEnd":{"type":"boolean"},"OccurrenceUnit":{}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceAvailabilitySet":{"locationName":"scheduledInstanceAvailabilitySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"FirstSlotStartTime":{"locationName":"firstSlotStartTime","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceType":{"locationName":"instanceType"},"MaxTermDurationInDays":{"locationName":"maxTermDurationInDays","type":"integer"},"MinTermDurationInDays":{"locationName":"minTermDurationInDays","type":"integer"},"NetworkPlatform":{"locationName":"networkPlatform"},"Platform":{"locationName":"platform"},"PurchaseToken":{"locationName":"purchaseToken"},"Recurrence":{"shape":"S129","locationName":"recurrence"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}}}}}},"DescribeScheduledInstances":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"ScheduledInstanceIds":{"locationName":"ScheduledInstanceId","type":"list","member":{"locationName":"ScheduledInstanceId"}},"SlotStartTimeRange":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"S12h","locationName":"item"}}}}},"DescribeSecurityGroupReferences":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"type":"boolean"},"GroupId":{"type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SecurityGroupReferenceSet":{"locationName":"securityGroupReferenceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"ReferencingVpcId":{"locationName":"referencingVpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}}}}},"DescribeSecurityGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"GroupIds":{"shape":"S3j","locationName":"GroupId"},"GroupNames":{"shape":"S12o","locationName":"GroupName"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroups":{"locationName":"securityGroupInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"groupDescription"},"GroupName":{"locationName":"groupName"},"IpPermissions":{"shape":"S43","locationName":"ipPermissions"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"IpPermissionsEgress":{"shape":"S43","locationName":"ipPermissionsEgress"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CreateVolumePermissions":{"shape":"S12w","locationName":"createVolumePermission"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"SnapshotId":{"locationName":"snapshotId"}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"OwnerIds":{"shape":"Sr5","locationName":"Owner"},"RestorableByUserIds":{"locationName":"RestorableBy","type":"list","member":{}},"SnapshotIds":{"shape":"S130","locationName":"SnapshotId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"shape":"Se2","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Sed","locationName":"spotDatafeedSubscription"}}}},"DescribeSpotFleetInstances":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"Sq6","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"DescribeSpotFleetRequestHistory":{"input":{"type":"structure","required":["SpotFleetRequestId","StartTime"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"EventType":{"locationName":"eventType"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"Sq3","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeSpotFleetRequests":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestIds":{"shape":"S5f","locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotFleetRequestConfigs":{"locationName":"spotFleetRequestConfigSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"SpotFleetRequestConfig":{"shape":"S13j","locationName":"spotFleetRequestConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"SpotFleetRequestState":{"locationName":"spotFleetRequestState"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}}}}},"DescribeSpotInstanceRequests":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S5q","locationName":"SpotInstanceRequestId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"S148","locationName":"spotInstanceRequestSet"},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotPriceHistory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"AvailabilityZone":{"locationName":"availabilityZone"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"ProductDescriptions":{"locationName":"ProductDescription","type":"list","member":{}},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotPriceHistory":{"locationName":"spotPriceHistorySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"SpotPrice":{"locationName":"spotPrice"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}}}}},"DescribeStaleSecurityGroups":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"StaleSecurityGroupSet":{"locationName":"staleSecurityGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"StaleIpPermissions":{"shape":"S14q","locationName":"staleIpPermissions"},"StaleIpPermissionsEgress":{"shape":"S14q","locationName":"staleIpPermissionsEgress"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeSubnets":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"SubnetId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Subnets":{"locationName":"subnetSet","type":"list","member":{"shape":"S70","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTags":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Tags":{"locationName":"tagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Value":{"locationName":"value"}}}}}}},"DescribeTrafficMirrorFilters":{"input":{"type":"structure","members":{"TrafficMirrorFilterIds":{"locationName":"TrafficMirrorFilterId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorFilters":{"locationName":"trafficMirrorFilterSet","type":"list","member":{"shape":"Sen","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorSessions":{"input":{"type":"structure","members":{"TrafficMirrorSessionIds":{"locationName":"TrafficMirrorSessionId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorSessions":{"locationName":"trafficMirrorSessionSet","type":"list","member":{"shape":"Sf2","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorTargets":{"input":{"type":"structure","members":{"TrafficMirrorTargetIds":{"locationName":"TrafficMirrorTargetId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorTargets":{"locationName":"trafficMirrorTargetSet","type":"list","member":{"shape":"Sf5","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S15i"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayOwnerId":{"locationName":"transitGatewayOwnerId"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"},"State":{"locationName":"state"},"Association":{"locationName":"association","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayMulticastDomains":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomains":{"locationName":"transitGatewayMulticastDomains","type":"list","member":{"shape":"Sfk","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayPeeringAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S15i"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachments":{"locationName":"transitGatewayPeeringAttachments","type":"list","member":{"shape":"Se","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayRouteTables":{"input":{"type":"structure","members":{"TransitGatewayRouteTableIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTables":{"locationName":"transitGatewayRouteTables","type":"list","member":{"shape":"Sfy","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayVpcAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S15i"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachments":{"locationName":"transitGatewayVpcAttachments","type":"list","member":{"shape":"Sn","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGateways":{"input":{"type":"structure","members":{"TransitGatewayIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateways":{"locationName":"transitGatewaySet","type":"list","member":{"shape":"Sff","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumeAttribute":{"input":{"type":"structure","required":["Attribute","VolumeId"],"members":{"Attribute":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AutoEnableIO":{"shape":"Stm","locationName":"autoEnableIO"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"VolumeId":{"locationName":"volumeId"}}}},"DescribeVolumeStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VolumeIds":{"shape":"S16a","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VolumeStatuses":{"locationName":"volumeStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Actions":{"locationName":"actionsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"}}}},"AvailabilityZone":{"locationName":"availabilityZone"},"OutpostArn":{"locationName":"outpostArn"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"InstanceId":{"locationName":"instanceId"}}}},"VolumeId":{"locationName":"volumeId"},"VolumeStatus":{"locationName":"volumeStatus","type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"AttachmentStatuses":{"locationName":"attachmentStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"IoPerformance":{"locationName":"ioPerformance"},"InstanceId":{"locationName":"instanceId"}}}}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"VolumeIds":{"shape":"S16a","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Volumes":{"locationName":"volumeSet","type":"list","member":{"shape":"Sg5","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumesModifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VolumeIds":{"shape":"S16a","locationName":"VolumeId"},"Filters":{"shape":"Sm2","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumesModifications":{"locationName":"volumeModificationSet","type":"list","member":{"shape":"S16v","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcAttribute":{"input":{"type":"structure","required":["Attribute","VpcId"],"members":{"Attribute":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcId":{"locationName":"vpcId"},"EnableDnsHostnames":{"shape":"Stm","locationName":"enableDnsHostnames"},"EnableDnsSupport":{"shape":"Stm","locationName":"enableDnsSupport"}}}},"DescribeVpcClassicLink":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcIds":{"shape":"S171","locationName":"VpcId"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkEnabled":{"locationName":"classicLinkEnabled","type":"boolean"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"VpcIds":{"shape":"S171"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Vpcs":{"locationName":"vpcs","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkDnsSupported":{"locationName":"classicLinkDnsSupported","type":"boolean"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcEndpointConnectionNotifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConnectionNotificationSet":{"locationName":"connectionNotificationSet","type":"list","member":{"shape":"Sgp","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointConnections":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpointConnections":{"locationName":"vpcEndpointConnectionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointOwner":{"locationName":"vpcEndpointOwner"},"VpcEndpointState":{"locationName":"vpcEndpointState"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"DnsEntries":{"shape":"Sgk","locationName":"dnsEntrySet"},"NetworkLoadBalancerArns":{"shape":"So","locationName":"networkLoadBalancerArnSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServiceConfigurations":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sl5","locationName":"ServiceId"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceConfigurations":{"locationName":"serviceConfigurationSet","type":"list","member":{"shape":"Sgu","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AllowedPrincipals":{"locationName":"allowedPrincipals","type":"list","member":{"locationName":"item","type":"structure","members":{"PrincipalType":{"locationName":"principalType"},"Principal":{"locationName":"principal"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServices":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceNames":{"shape":"So","locationName":"ServiceName"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceNames":{"shape":"So","locationName":"serviceNameSet"},"ServiceDetails":{"locationName":"serviceDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceName":{"locationName":"serviceName"},"ServiceId":{"locationName":"serviceId"},"ServiceType":{"shape":"Sgv","locationName":"serviceType"},"AvailabilityZones":{"shape":"So","locationName":"availabilityZoneSet"},"Owner":{"locationName":"owner"},"BaseEndpointDnsNames":{"shape":"So","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"VpcEndpointPolicySupported":{"locationName":"vpcEndpointPolicySupported","type":"boolean"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"Tags":{"shape":"Sj","locationName":"tagSet"},"PrivateDnsNameVerificationState":{"locationName":"privateDnsNameVerificationState"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"Su","locationName":"VpcEndpointId"},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpoints":{"locationName":"vpcEndpointSet","type":"list","member":{"shape":"Sgg","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionIds":{"locationName":"VpcPeeringConnectionId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"locationName":"vpcPeeringConnectionSet","type":"list","member":{"shape":"S13","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"VpcIds":{"locationName":"VpcId","type":"list","member":{"locationName":"VpcId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"shape":"S76","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpnConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"VpnConnectionIds":{"locationName":"VpnConnectionId","type":"list","member":{"locationName":"VpnConnectionId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnections":{"locationName":"vpnConnectionSet","type":"list","member":{"shape":"Shn","locationName":"item"}}}}},"DescribeVpnGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sm2","locationName":"Filter"},"VpnGatewayIds":{"locationName":"VpnGatewayId","type":"list","member":{"locationName":"VpnGatewayId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateways":{"locationName":"vpnGatewaySet","type":"list","member":{"shape":"Sig","locationName":"item"}}}}},"DetachClassicLinkVpc":{"input":{"type":"structure","required":["InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DetachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"DetachNetworkInterface":{"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"locationName":"attachmentId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"Device":{},"Force":{"type":"boolean"},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S3r"}},"DetachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"DisableFastSnapshotRestores":{"input":{"type":"structure","required":["AvailabilityZones","SourceSnapshotIds"],"members":{"AvailabilityZones":{"shape":"S18q","locationName":"AvailabilityZone"},"SourceSnapshotIds":{"shape":"S130","locationName":"SourceSnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Successful":{"locationName":"successful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"Unsuccessful":{"locationName":"unsuccessful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"FastSnapshotRestoreStateErrors":{"locationName":"fastSnapshotRestoreStateErrorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}}}}},"DisableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Propagation":{"shape":"S191","locationName":"propagation"}}}},"DisableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{},"DryRun":{"type":"boolean"}}}},"DisableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateAddress":{"input":{"type":"structure","members":{"AssociationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","AssociationId"],"members":{"ClientVpnEndpointId":{},"AssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S2d","locationName":"status"}}}},"DisassociateIamInstanceProfile":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S2k","locationName":"iamInstanceProfileAssociation"}}}},"DisassociateRouteTable":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateSubnetCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S2v","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"DisassociateTransitGatewayMulticastDomain":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"So"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"S31","locationName":"associations"}}}},"DisassociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S39","locationName":"association"}}}},"DisassociateVpcCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S3e","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S3h","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"EnableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"EnableFastSnapshotRestores":{"input":{"type":"structure","required":["AvailabilityZones","SourceSnapshotIds"],"members":{"AvailabilityZones":{"shape":"S18q","locationName":"AvailabilityZone"},"SourceSnapshotIds":{"shape":"S130","locationName":"SourceSnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Successful":{"locationName":"successful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"Unsuccessful":{"locationName":"unsuccessful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"FastSnapshotRestoreStateErrors":{"locationName":"fastSnapshotRestoreStateErrorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}}}}},"EnableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Propagation":{"shape":"S191","locationName":"propagation"}}}},"EnableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{},"DryRun":{"type":"boolean"}}}},"EnableVolumeIO":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}}},"EnableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ExportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CertificateRevocationList":{"locationName":"certificateRevocationList"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"ExportClientVpnClientConfiguration":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientConfiguration":{"locationName":"clientConfiguration"}}}},"ExportImage":{"input":{"type":"structure","required":["DiskImageFormat","ImageId","S3ExportLocation"],"members":{"ClientToken":{"idempotencyToken":true},"Description":{},"DiskImageFormat":{},"DryRun":{"type":"boolean"},"ImageId":{},"S3ExportLocation":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Prefix":{}}},"RoleName":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageFormat":{"locationName":"diskImageFormat"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"RoleName":{"locationName":"roleName"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"Spm","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"ExportTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","S3Bucket"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"S3Bucket":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"S3Location":{"locationName":"s3Location"}}}},"GetAssociatedIpv6PoolCidrs":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Ipv6CidrAssociations":{"locationName":"ipv6CidrAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Cidr":{"locationName":"ipv6Cidr"},"AssociatedResource":{"locationName":"associatedResource"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetCapacityReservationUsage":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservationId":{"locationName":"capacityReservationId"},"InstanceType":{"locationName":"instanceType"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"State":{"locationName":"state"},"InstanceUsages":{"locationName":"instanceUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AccountId":{"locationName":"accountId"},"UsedInstanceCount":{"locationName":"usedInstanceCount","type":"integer"}}}}}}},"GetCoipPoolUsage":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPoolId":{"locationName":"coipPoolId"},"CoipAddressUsages":{"locationName":"coipAddressUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"CoIp":{"locationName":"coIp"}}}},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"}}}},"GetConsoleOutput":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Latest":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Output":{"locationName":"output"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetConsoleScreenshot":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"WakeUp":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageData":{"locationName":"imageData"},"InstanceId":{"locationName":"instanceId"}}}},"GetDefaultCreditSpecification":{"input":{"type":"structure","required":["InstanceFamily"],"members":{"DryRun":{"type":"boolean"},"InstanceFamily":{}}},"output":{"type":"structure","members":{"InstanceFamilyCreditSpecification":{"shape":"S1b5","locationName":"instanceFamilyCreditSpecification"}}}},"GetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"GetEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"GetHostReservationPurchasePreview":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"HostIdSet":{"shape":"S1bb"},"OfferingId":{}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S1bd","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"GetLaunchTemplateData":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{}}},"output":{"type":"structure","members":{"LaunchTemplateData":{"shape":"Sb4","locationName":"launchTemplateData"}}}},"GetPasswordData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PasswordData":{"locationName":"passwordData"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"IsValidExchange":{"locationName":"isValidExchange","type":"boolean"},"OutputReservedInstancesWillExpireAt":{"locationName":"outputReservedInstancesWillExpireAt","type":"timestamp"},"PaymentDue":{"locationName":"paymentDue"},"ReservedInstanceValueRollup":{"shape":"S1bl","locationName":"reservedInstanceValueRollup"},"ReservedInstanceValueSet":{"locationName":"reservedInstanceValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S1bl","locationName":"reservationValue"},"ReservedInstanceId":{"locationName":"reservedInstanceId"}}}},"TargetConfigurationValueRollup":{"shape":"S1bl","locationName":"targetConfigurationValueRollup"},"TargetConfigurationValueSet":{"locationName":"targetConfigurationValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S1bl","locationName":"reservationValue"},"TargetConfiguration":{"locationName":"targetConfiguration","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"OfferingId":{"locationName":"offeringId"}}}}}},"ValidationFailureReason":{"locationName":"validationFailureReason"}}}},"GetTransitGatewayAttachmentPropagations":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachmentPropagations":{"locationName":"transitGatewayAttachmentPropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MulticastDomainAssociations":{"locationName":"multicastDomainAssociations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Subnet":{"shape":"S34","locationName":"subnet"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTableAssociations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"locationName":"associations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTablePropagations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTablePropagations":{"locationName":"transitGatewayRouteTablePropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"ImportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId","CertificateRevocationList"],"members":{"ClientVpnEndpointId":{},"CertificateRevocationList":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ImportImage":{"input":{"type":"structure","members":{"Architecture":{},"ClientData":{"shape":"S1ca"},"ClientToken":{},"Description":{},"DiskContainers":{"locationName":"DiskContainer","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{},"DeviceName":{},"Format":{},"SnapshotId":{},"Url":{},"UserBucket":{"shape":"S1cd"}}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Hypervisor":{},"KmsKeyId":{},"LicenseType":{},"Platform":{},"RoleName":{},"LicenseSpecifications":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"St4","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"LicenseSpecifications":{"shape":"St7","locationName":"licenseSpecifications"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"ImportInstance":{"input":{"type":"structure","required":["Platform"],"members":{"Description":{"locationName":"description"},"DiskImages":{"locationName":"diskImage","type":"list","member":{"type":"structure","members":{"Description":{},"Image":{"shape":"S1ck"},"Volume":{"shape":"S1cl"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"AdditionalInfo":{"locationName":"additionalInfo"},"Architecture":{"locationName":"architecture"},"GroupIds":{"shape":"S9v","locationName":"GroupId"},"GroupNames":{"shape":"Saf","locationName":"GroupName"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"locationName":"instanceType"},"Monitoring":{"locationName":"monitoring","type":"boolean"},"Placement":{"shape":"S87","locationName":"placement"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData","type":"structure","members":{"Data":{"locationName":"data"}},"sensitive":true}}},"Platform":{"locationName":"platform"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Soj","locationName":"conversionTask"}}}},"ImportKeyPair":{"input":{"type":"structure","required":["KeyName","PublicKeyMaterial"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyName":{"locationName":"keyName"},"PublicKeyMaterial":{"locationName":"publicKeyMaterial","type":"blob"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"},"KeyPairId":{"locationName":"keyPairId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"ImportSnapshot":{"input":{"type":"structure","members":{"ClientData":{"shape":"S1ca"},"ClientToken":{},"Description":{},"DiskContainer":{"type":"structure","members":{"Description":{},"Format":{},"Url":{},"UserBucket":{"shape":"S1cd"}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"RoleName":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Stf","locationName":"snapshotTaskDetail"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"ImportVolume":{"input":{"type":"structure","required":["AvailabilityZone","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Image":{"shape":"S1ck","locationName":"image"},"Volume":{"shape":"S1cl","locationName":"volume"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Soj","locationName":"conversionTask"}}}},"ModifyAvailabilityZoneGroup":{"input":{"type":"structure","required":["GroupName","OptInStatus"],"members":{"GroupName":{},"OptInStatus":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"InstanceCount":{"type":"integer"},"EndDate":{"type":"timestamp"},"EndDateType":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ServerCertificateArn":{},"ConnectionLogOptions":{"shape":"S6l"},"DnsServers":{"type":"structure","members":{"CustomDnsServers":{"shape":"So"},"Enabled":{"type":"boolean"}}},"VpnPort":{"type":"integer"},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"SecurityGroupIds":{"shape":"S1u","locationName":"SecurityGroupId"},"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyDefaultCreditSpecification":{"input":{"type":"structure","required":["InstanceFamily","CpuCredits"],"members":{"DryRun":{"type":"boolean"},"InstanceFamily":{},"CpuCredits":{}}},"output":{"type":"structure","members":{"InstanceFamilyCreditSpecification":{"shape":"S1b5","locationName":"instanceFamilyCreditSpecification"}}}},"ModifyEbsDefaultKmsKeyId":{"input":{"type":"structure","required":["KmsKeyId"],"members":{"KmsKeyId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ModifyFleet":{"input":{"type":"structure","required":["FleetId","TargetCapacitySpecification"],"members":{"DryRun":{"type":"boolean"},"ExcessCapacityTerminationPolicy":{},"FleetId":{},"TargetCapacitySpecification":{"shape":"S88"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{},"OperationType":{},"UserIds":{"shape":"S1dc","locationName":"UserId"},"UserGroups":{"shape":"S1dd","locationName":"UserGroup"},"ProductCodes":{"shape":"S1de","locationName":"ProductCode"},"LoadPermission":{"type":"structure","members":{"Add":{"shape":"S1dg"},"Remove":{"shape":"S1dg"}}},"Description":{},"Name":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Sqw","locationName":"fpgaImageAttribute"}}}},"ModifyHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"HostIds":{"shape":"Srt","locationName":"hostId"},"HostRecovery":{},"InstanceType":{},"InstanceFamily":{}}},"output":{"type":"structure","members":{"Successful":{"shape":"S1q","locationName":"successful"},"Unsuccessful":{"shape":"S1dl","locationName":"unsuccessful"}}}},"ModifyIdFormat":{"input":{"type":"structure","required":["Resource","UseLongIds"],"members":{"Resource":{},"UseLongIds":{"type":"boolean"}}}},"ModifyIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn","Resource","UseLongIds"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"ModifyImageAttribute":{"input":{"type":"structure","required":["ImageId"],"members":{"Attribute":{},"Description":{"shape":"S7j"},"ImageId":{},"LaunchPermission":{"type":"structure","members":{"Add":{"shape":"Ssj"},"Remove":{"shape":"Ssj"}}},"OperationType":{},"ProductCodes":{"shape":"S1de","locationName":"ProductCode"},"UserGroups":{"shape":"S1dd","locationName":"UserGroup"},"UserIds":{"shape":"S1dc","locationName":"UserId"},"Value":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyInstanceAttribute":{"input":{"type":"structure","required":["InstanceId"],"members":{"SourceDestCheck":{"shape":"Stm"},"Attribute":{"locationName":"attribute"},"BlockDeviceMappings":{"locationName":"blockDeviceMapping","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}},"NoDevice":{"locationName":"noDevice"},"VirtualName":{"locationName":"virtualName"}}}},"DisableApiTermination":{"shape":"Stm","locationName":"disableApiTermination"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"shape":"Stm","locationName":"ebsOptimized"},"EnaSupport":{"shape":"Stm","locationName":"enaSupport"},"Groups":{"shape":"S3j","locationName":"GroupId"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S7j","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S7j","locationName":"instanceType"},"Kernel":{"shape":"S7j","locationName":"kernel"},"Ramdisk":{"shape":"S7j","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S7j","locationName":"sriovNetSupport"},"UserData":{"locationName":"userData","type":"structure","members":{"Value":{"locationName":"value","type":"blob"}}},"Value":{"locationName":"value"}}}},"ModifyInstanceCapacityReservationAttributes":{"input":{"type":"structure","required":["InstanceId","CapacityReservationSpecification"],"members":{"InstanceId":{},"CapacityReservationSpecification":{"shape":"S1dw"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyInstanceCreditSpecification":{"input":{"type":"structure","required":["InstanceCreditSpecifications"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"InstanceCreditSpecifications":{"locationName":"InstanceCreditSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{},"CpuCredits":{}}}}}},"output":{"type":"structure","members":{"SuccessfulInstanceCreditSpecifications":{"locationName":"successfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"}}}},"UnsuccessfulInstanceCreditSpecifications":{"locationName":"unsuccessfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"ModifyInstanceEventStartTime":{"input":{"type":"structure","required":["InstanceId","InstanceEventId","NotBefore"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"InstanceEventId":{},"NotBefore":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Event":{"shape":"Stz","locationName":"event"}}}},"ModifyInstanceMetadataOptions":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceMetadataOptions":{"shape":"Sxh","locationName":"instanceMetadataOptions"}}}},"ModifyInstancePlacement":{"input":{"type":"structure","required":["InstanceId"],"members":{"Affinity":{"locationName":"affinity"},"GroupName":{},"HostId":{"locationName":"hostId"},"InstanceId":{"locationName":"instanceId"},"Tenancy":{"locationName":"tenancy"},"PartitionNumber":{"type":"integer"},"HostResourceGroupArn":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"DefaultVersion":{"locationName":"SetDefaultVersion"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sax","locationName":"launchTemplate"}}}},"ModifyNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"Description":{"shape":"S7j","locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S9v","locationName":"SecurityGroupId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Stm","locationName":"sourceDestCheck"}}}},"ModifyReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds","TargetConfigurations"],"members":{"ReservedInstancesIds":{"shape":"S110","locationName":"ReservedInstancesId"},"ClientToken":{"locationName":"clientToken"},"TargetConfigurations":{"locationName":"ReservedInstancesConfigurationSetItemType","type":"list","member":{"shape":"S11m","locationName":"item"}}}},"output":{"type":"structure","members":{"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"}}}},"ModifySnapshotAttribute":{"input":{"type":"structure","required":["SnapshotId"],"members":{"Attribute":{},"CreateVolumePermission":{"type":"structure","members":{"Add":{"shape":"S12w"},"Remove":{"shape":"S12w"}}},"GroupNames":{"shape":"S12o","locationName":"UserGroup"},"OperationType":{},"SnapshotId":{},"UserIds":{"shape":"S1dc","locationName":"UserId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifySpotFleetRequest":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"type":"integer"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySubnetAttribute":{"input":{"type":"structure","required":["SubnetId"],"members":{"AssignIpv6AddressOnCreation":{"shape":"Stm"},"MapPublicIpOnLaunch":{"shape":"Stm"},"SubnetId":{"locationName":"subnetId"},"MapCustomerOwnedIpOnLaunch":{"shape":"Stm"},"CustomerOwnedIpv4Pool":{}}}},"ModifyTrafficMirrorFilterNetworkServices":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"AddNetworkServices":{"shape":"Set","locationName":"AddNetworkService"},"RemoveNetworkServices":{"shape":"Set","locationName":"RemoveNetworkService"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sen","locationName":"trafficMirrorFilter"}}}},"ModifyTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Sex"},"SourcePortRange":{"shape":"Sex"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sep","locationName":"trafficMirrorFilterRule"}}}},"ModifyTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sf2","locationName":"trafficMirrorSession"}}}},"ModifyTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"AddSubnetIds":{"shape":"Sg1"},"RemoveSubnetIds":{"shape":"Sg1"},"Options":{"type":"structure","members":{"DnsSupport":{},"Ipv6Support":{}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sn","locationName":"transitGatewayVpcAttachment"}}}},"ModifyVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"type":"boolean"},"VolumeId":{},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumeModification":{"shape":"S16v","locationName":"volumeModification"}}}},"ModifyVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"AutoEnableIO":{"shape":"Stm"},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyVpcAttribute":{"input":{"type":"structure","required":["VpcId"],"members":{"EnableDnsHostnames":{"shape":"Stm"},"EnableDnsSupport":{"shape":"Stm"},"VpcId":{"locationName":"vpcId"}}}},"ModifyVpcEndpoint":{"input":{"type":"structure","required":["VpcEndpointId"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointId":{},"ResetPolicy":{"type":"boolean"},"PolicyDocument":{},"AddRouteTableIds":{"shape":"Sgc","locationName":"AddRouteTableId"},"RemoveRouteTableIds":{"shape":"Sgc","locationName":"RemoveRouteTableId"},"AddSubnetIds":{"shape":"Sgd","locationName":"AddSubnetId"},"RemoveSubnetIds":{"shape":"Sgd","locationName":"RemoveSubnetId"},"AddSecurityGroupIds":{"shape":"Sge","locationName":"AddSecurityGroupId"},"RemoveSecurityGroupIds":{"shape":"Sge","locationName":"RemoveSecurityGroupId"},"PrivateDnsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationId"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"So"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"PrivateDnsName":{},"RemovePrivateDnsName":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"AddNetworkLoadBalancerArns":{"shape":"So","locationName":"AddNetworkLoadBalancerArn"},"RemoveNetworkLoadBalancerArns":{"shape":"So","locationName":"RemoveNetworkLoadBalancerArn"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AddAllowedPrincipals":{"shape":"So"},"RemoveAllowedPrincipals":{"shape":"So"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcPeeringConnectionOptions":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"AccepterPeeringConnectionOptions":{"shape":"S1fi"},"DryRun":{"type":"boolean"},"RequesterPeeringConnectionOptions":{"shape":"S1fi"},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{"AccepterPeeringConnectionOptions":{"shape":"S1fk","locationName":"accepterPeeringConnectionOptions"},"RequesterPeeringConnectionOptions":{"shape":"S1fk","locationName":"requesterPeeringConnectionOptions"}}}},"ModifyVpcTenancy":{"input":{"type":"structure","required":["VpcId","InstanceTenancy"],"members":{"VpcId":{},"InstanceTenancy":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"TransitGatewayId":{},"CustomerGatewayId":{},"VpnGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Shn","locationName":"vpnConnection"}}}},"ModifyVpnTunnelCertificate":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Shn","locationName":"vpnConnection"}}}},"ModifyVpnTunnelOptions":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress","TunnelOptions"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"TunnelOptions":{"type":"structure","members":{"TunnelInsideCidr":{},"PreSharedKey":{},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2LifetimeSeconds":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"RekeyFuzzPercentage":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"DPDTimeoutSeconds":{"type":"integer"},"Phase1EncryptionAlgorithms":{"shape":"Sh8","locationName":"Phase1EncryptionAlgorithm"},"Phase2EncryptionAlgorithms":{"shape":"Sha","locationName":"Phase2EncryptionAlgorithm"},"Phase1IntegrityAlgorithms":{"shape":"Shc","locationName":"Phase1IntegrityAlgorithm"},"Phase2IntegrityAlgorithms":{"shape":"She","locationName":"Phase2IntegrityAlgorithm"},"Phase1DHGroupNumbers":{"shape":"Shg","locationName":"Phase1DHGroupNumber"},"Phase2DHGroupNumbers":{"shape":"Shi","locationName":"Phase2DHGroupNumber"},"IKEVersions":{"shape":"Shk","locationName":"IKEVersion"}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Shn","locationName":"vpnConnection"}}}},"MonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S1fx","locationName":"instancesSet"}}}},"MoveAddressToVpc":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"Status":{"locationName":"status"}}}},"ProvisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"CidrAuthorizationContext":{"type":"structure","required":["Message","Signature"],"members":{"Message":{},"Signature":{}}},"PubliclyAdvertisable":{"type":"boolean"},"Description":{},"DryRun":{"type":"boolean"},"PoolTagSpecifications":{"shape":"S1l","locationName":"PoolTagSpecification"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1e","locationName":"byoipCidr"}}}},"PurchaseHostReservation":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"ClientToken":{},"CurrencyCode":{},"HostIdSet":{"shape":"S1bb"},"LimitPrice":{},"OfferingId":{},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S1bd","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"PurchaseReservedInstancesOffering":{"input":{"type":"structure","required":["InstanceCount","ReservedInstancesOfferingId"],"members":{"InstanceCount":{"type":"integer"},"ReservedInstancesOfferingId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"LimitPrice":{"locationName":"limitPrice","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"CurrencyCode":{"locationName":"currencyCode"}}},"PurchaseTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"PurchaseScheduledInstances":{"input":{"type":"structure","required":["PurchaseRequests"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"PurchaseRequests":{"locationName":"PurchaseRequest","type":"list","member":{"locationName":"PurchaseRequest","type":"structure","required":["InstanceCount","PurchaseToken"],"members":{"InstanceCount":{"type":"integer"},"PurchaseToken":{}}}}}},"output":{"type":"structure","members":{"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"S12h","locationName":"item"}}}}},"RebootInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RegisterImage":{"input":{"type":"structure","required":["Name"],"members":{"ImageLocation":{},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"S8z","locationName":"BlockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"KernelId":{"locationName":"kernelId"},"Name":{"locationName":"name"},"BillingProducts":{"locationName":"BillingProduct","type":"list","member":{"locationName":"item"}},"RamdiskId":{"locationName":"ramdiskId"},"RootDeviceName":{"locationName":"rootDeviceName"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"VirtualizationType":{"locationName":"virtualizationType"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"RegisterInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTagAttribute":{"type":"structure","members":{"IncludeAllTagsOfInstance":{"type":"boolean"},"InstanceTagKeys":{"shape":"Slj","locationName":"InstanceTagKey"}}}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Sll","locationName":"instanceTagAttribute"}}}},"RegisterTransitGatewayMulticastGroupMembers":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Sln"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"RegisteredMulticastGroupMembers":{"locationName":"registeredMulticastGroupMembers","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"RegisteredNetworkInterfaceIds":{"shape":"So","locationName":"registeredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"RegisterTransitGatewayMulticastGroupSources":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Sln"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"RegisteredMulticastGroupSources":{"locationName":"registeredMulticastGroupSources","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"RegisteredNetworkInterfaceIds":{"shape":"So","locationName":"registeredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"RejectTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Se","locationName":"transitGatewayPeeringAttachment"}}}},"RejectTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sn","locationName":"transitGatewayVpcAttachment"}}}},"RejectVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"Su","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sx","locationName":"unsuccessful"}}}},"RejectVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReleaseAddress":{"input":{"type":"structure","members":{"AllocationId":{},"PublicIp":{},"NetworkBorderGroup":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ReleaseHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"HostIds":{"shape":"Srt","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"S1q","locationName":"successful"},"Unsuccessful":{"shape":"S1dl","locationName":"unsuccessful"}}}},"ReplaceIamInstanceProfileAssociation":{"input":{"type":"structure","required":["IamInstanceProfile","AssociationId"],"members":{"IamInstanceProfile":{"shape":"S2i"},"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S2k","locationName":"iamInstanceProfileAssociation"}}}},"ReplaceNetworkAclAssociation":{"input":{"type":"structure","required":["AssociationId","NetworkAclId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Scl","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Scm","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"ReplaceRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"LocalTarget":{"type":"boolean"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"LocalGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"ReplaceRouteTableAssociation":{"input":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"},"AssociationState":{"shape":"S2r","locationName":"associationState"}}}},"ReplaceTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sfr","locationName":"route"}}}},"ReportInstanceStatus":{"input":{"type":"structure","required":["Instances","ReasonCodes","Status"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"Instances":{"shape":"Sn2","locationName":"instanceId"},"ReasonCodes":{"locationName":"reasonCode","type":"list","member":{"locationName":"item"}},"StartTime":{"locationName":"startTime","type":"timestamp"},"Status":{"locationName":"status"}}}},"RequestSpotFleet":{"input":{"type":"structure","required":["SpotFleetRequestConfig"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestConfig":{"shape":"S13j","locationName":"spotFleetRequestConfig"}}},"output":{"type":"structure","members":{"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"RequestSpotInstances":{"input":{"type":"structure","members":{"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ClientToken":{"locationName":"clientToken"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"type":"structure","members":{"SecurityGroupIds":{"locationName":"SecurityGroupId","type":"list","member":{"locationName":"item"}},"SecurityGroups":{"locationName":"SecurityGroup","type":"list","member":{"locationName":"item"}},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Ssi","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S2i","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"shape":"S14b","locationName":"monitoring"},"NetworkInterfaces":{"shape":"S13q","locationName":"NetworkInterface"},"Placement":{"shape":"S13s","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"}}},"SpotPrice":{"locationName":"spotPrice"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"S148","locationName":"spotInstanceRequestSet"}}}},"ResetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ResetFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ResetImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ResetInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}}},"ResetNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"locationName":"sourceDestCheck"}}}},"ResetSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RestoreAddressToClassic":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"Status":{"locationName":"status"}}}},"RevokeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"RevokeAllGroups":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S40","locationName":"status"}}}},"RevokeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S43","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"RevokeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S43"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RunInstances":{"input":{"type":"structure","required":["MaxCount","MinCount"],"members":{"BlockDeviceMappings":{"shape":"S8z","locationName":"BlockDeviceMapping"},"ImageId":{},"InstanceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"shape":"Sbb","locationName":"Ipv6Address"},"KernelId":{},"KeyName":{},"MaxCount":{"type":"integer"},"MinCount":{"type":"integer"},"Monitoring":{"shape":"S14b"},"Placement":{"shape":"S87"},"RamdiskId":{},"SecurityGroupIds":{"shape":"S9v","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Saf","locationName":"SecurityGroup"},"SubnetId":{},"UserData":{},"AdditionalInfo":{"locationName":"additionalInfo"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S2i","locationName":"iamInstanceProfile"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"NetworkInterfaces":{"shape":"S13q","locationName":"networkInterface"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ElasticGpuSpecification":{"type":"list","member":{"shape":"Sab","locationName":"item"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{},"Count":{"type":"integer"}}}},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"Sal"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"}}},"CapacityReservationSpecification":{"shape":"S1dw"},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"MetadataOptions":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{}}}}},"output":{"shape":"Sww"}},"RunScheduledInstances":{"input":{"type":"structure","required":["LaunchSpecification","ScheduledInstanceId"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"InstanceCount":{"type":"integer"},"LaunchSpecification":{"type":"structure","required":["ImageId"],"members":{"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{},"VirtualName":{}}}},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"ImageId":{},"InstanceType":{},"KernelId":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S1ir","locationName":"Group"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"locationName":"Ipv6Address","type":"list","member":{"locationName":"Ipv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddressConfigs":{"locationName":"PrivateIpAddressConfig","type":"list","member":{"locationName":"PrivateIpAddressConfigSet","type":"structure","members":{"Primary":{"type":"boolean"},"PrivateIpAddress":{}}}},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"GroupName":{}}},"RamdiskId":{},"SecurityGroupIds":{"shape":"S1ir","locationName":"SecurityGroupId"},"SubnetId":{},"UserData":{}}},"ScheduledInstanceId":{}}},"output":{"type":"structure","members":{"InstanceIdSet":{"locationName":"instanceIdSet","type":"list","member":{"locationName":"item"}}}}},"SearchLocalGatewayRoutes":{"input":{"type":"structure","required":["LocalGatewayRouteTableId","Filters"],"members":{"LocalGatewayRouteTableId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Sc0","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"SearchTransitGatewayMulticastGroups":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MulticastGroups":{"locationName":"multicastGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupIpAddress":{"locationName":"groupIpAddress"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"SubnetId":{"locationName":"subnetId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"GroupMember":{"locationName":"groupMember","type":"boolean"},"GroupSource":{"locationName":"groupSource","type":"boolean"},"MemberType":{"locationName":"memberType"},"SourceType":{"locationName":"sourceType"}}}},"NextToken":{"locationName":"nextToken"}}}},"SearchTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","Filters"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sm2","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Sfr","locationName":"item"}},"AdditionalRoutesAvailable":{"locationName":"additionalRoutesAvailable","type":"boolean"}}}},"SendDiagnosticInterrupt":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"type":"boolean"}}}},"StartInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"AdditionalInfo":{"locationName":"additionalInfo"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"StartingInstances":{"shape":"S1jf","locationName":"instancesSet"}}}},"StartVpcEndpointServicePrivateDnsVerification":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"StopInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"Hibernate":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"StoppingInstances":{"shape":"S1jf","locationName":"instancesSet"}}}},"TerminateClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ConnectionId":{},"Username":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Username":{"locationName":"username"},"ConnectionStatuses":{"locationName":"connectionStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"PreviousStatus":{"shape":"Snh","locationName":"previousStatus"},"CurrentStatus":{"shape":"Snh","locationName":"currentStatus"}}}}}}},"TerminateInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"TerminatingInstances":{"shape":"S1jf","locationName":"instancesSet"}}}},"UnassignIpv6Addresses":{"input":{"type":"structure","required":["Ipv6Addresses","NetworkInterfaceId"],"members":{"Ipv6Addresses":{"shape":"S1y","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"UnassignedIpv6Addresses":{"shape":"S1y","locationName":"unassignedIpv6Addresses"}}}},"UnassignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId","PrivateIpAddresses"],"members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S22","locationName":"privateIpAddress"}}}},"UnmonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sn2","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S1fx","locationName":"instancesSet"}}}},"UpdateSecurityGroupRuleDescriptionsEgress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S43"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"UpdateSecurityGroupRuleDescriptionsIngress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S43"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"WithdrawByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1e","locationName":"byoipCidr"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"ReservedInstanceId"}},"S5":{"type":"list","member":{"locationName":"TargetConfigurationRequest","type":"structure","required":["OfferingId"],"members":{"InstanceCount":{"type":"integer"},"OfferingId":{}}}},"Se":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"RequesterTgwInfo":{"shape":"Sf","locationName":"requesterTgwInfo"},"AccepterTgwInfo":{"shape":"Sf","locationName":"accepterTgwInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sf":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"OwnerId":{"locationName":"ownerId"},"Region":{"locationName":"region"}}},"Sj":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sn":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"VpcId":{"locationName":"vpcId"},"VpcOwnerId":{"locationName":"vpcOwnerId"},"State":{"locationName":"state"},"SubnetIds":{"shape":"So","locationName":"subnetIds"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"DnsSupport":{"locationName":"dnsSupport"},"Ipv6Support":{"locationName":"ipv6Support"}}},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"So":{"type":"list","member":{"locationName":"item"}},"Su":{"type":"list","member":{"locationName":"item"}},"Sx":{"type":"list","member":{"shape":"Sy","locationName":"item"}},"Sy":{"type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ResourceId":{"locationName":"resourceId"}}},"S13":{"type":"structure","members":{"AccepterVpcInfo":{"shape":"S14","locationName":"accepterVpcInfo"},"ExpirationTime":{"locationName":"expirationTime","type":"timestamp"},"RequesterVpcInfo":{"shape":"S14","locationName":"requesterVpcInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Tags":{"shape":"Sj","locationName":"tagSet"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S14":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Ipv6CidrBlockSet":{"locationName":"ipv6CidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"}}}},"CidrBlockSet":{"locationName":"cidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"}}}},"OwnerId":{"locationName":"ownerId"},"PeeringOptions":{"locationName":"peeringOptions","type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"VpcId":{"locationName":"vpcId"},"Region":{"locationName":"region"}}},"S1e":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Description":{"locationName":"description"},"StatusMessage":{"locationName":"statusMessage"},"State":{"locationName":"state"}}},"S1l":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sj","locationName":"Tag"}}}},"S1q":{"type":"list","member":{"locationName":"item"}},"S1u":{"type":"list","member":{"locationName":"item"}},"S1y":{"type":"list","member":{"locationName":"item"}},"S22":{"type":"list","member":{"locationName":"PrivateIpAddress"}},"S2d":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S2i":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S2k":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"InstanceId":{"locationName":"instanceId"},"IamInstanceProfile":{"shape":"S2l","locationName":"iamInstanceProfile"},"State":{"locationName":"state"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}},"S2l":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"S2r":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S2v":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"locationName":"ipv6CidrBlockState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S31":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Subnets":{"locationName":"subnets","type":"list","member":{"shape":"S34","locationName":"item"}}}},"S34":{"type":"structure","members":{"SubnetId":{"locationName":"subnetId"},"State":{"locationName":"state"}}},"S39":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}},"S3e":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"shape":"S3f","locationName":"ipv6CidrBlockState"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Ipv6Pool":{"locationName":"ipv6Pool"}}},"S3f":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S3h":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"CidrBlock":{"locationName":"cidrBlock"},"CidrBlockState":{"shape":"S3f","locationName":"cidrBlockState"}}},"S3j":{"type":"list","member":{"locationName":"groupId"}},"S3r":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"Device":{"locationName":"device"},"InstanceId":{"locationName":"instanceId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"S3w":{"type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}},"S40":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S43":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIp":{"locationName":"cidrIp"},"Description":{"locationName":"description"}}}},"Ipv6Ranges":{"locationName":"ipv6Ranges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIpv6":{"locationName":"cidrIpv6"},"Description":{"locationName":"description"}}}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"PrefixListId":{"locationName":"prefixListId"}}}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S4c","locationName":"item"}}}}},"S4c":{"type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S4g":{"type":"structure","members":{"S3":{"type":"structure","members":{"AWSAccessKeyId":{},"Bucket":{"locationName":"bucket"},"Prefix":{"locationName":"prefix"},"UploadPolicy":{"locationName":"uploadPolicy","type":"blob"},"UploadPolicySignature":{"locationName":"uploadPolicySignature"}}}}},"S4k":{"type":"structure","members":{"BundleId":{"locationName":"bundleId"},"BundleTaskError":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"InstanceId":{"locationName":"instanceId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"state"},"Storage":{"shape":"S4g","locationName":"storage"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"S53":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"InstanceCounts":{"locationName":"instanceCounts","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"State":{"locationName":"state"}}}},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"Active":{"locationName":"active","type":"boolean"},"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sj","locationName":"tagSet"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}},"S5f":{"type":"list","member":{"locationName":"item"}},"S5q":{"type":"list","member":{"locationName":"SpotInstanceRequestId"}},"S6c":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"OwnerId":{"locationName":"ownerId"},"CapacityReservationArn":{"locationName":"capacityReservationArn"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"InstanceType":{"locationName":"instanceType"},"InstancePlatform":{"locationName":"instancePlatform"},"AvailabilityZone":{"locationName":"availabilityZone"},"Tenancy":{"locationName":"tenancy"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EphemeralStorage":{"locationName":"ephemeralStorage","type":"boolean"},"State":{"locationName":"state"},"EndDate":{"locationName":"endDate","type":"timestamp"},"EndDateType":{"locationName":"endDateType"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S6l":{"type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"S6o":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S6s":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S6x":{"type":"structure","members":{"BgpAsn":{"locationName":"bgpAsn"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"IpAddress":{"locationName":"ipAddress"},"CertificateArn":{"locationName":"certificateArn"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"DeviceName":{"locationName":"deviceName"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S70":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"AvailableIpAddressCount":{"locationName":"availableIpAddressCount","type":"integer"},"CidrBlock":{"locationName":"cidrBlock"},"DefaultForAz":{"locationName":"defaultForAz","type":"boolean"},"MapPublicIpOnLaunch":{"locationName":"mapPublicIpOnLaunch","type":"boolean"},"MapCustomerOwnedIpOnLaunch":{"locationName":"mapCustomerOwnedIpOnLaunch","type":"boolean"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"AssignIpv6AddressOnCreation":{"locationName":"assignIpv6AddressOnCreation","type":"boolean"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S2v","locationName":"item"}},"Tags":{"shape":"Sj","locationName":"tagSet"},"SubnetArn":{"locationName":"subnetArn"},"OutpostArn":{"locationName":"outpostArn"}}},"S76":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S3e","locationName":"item"}},"CidrBlockAssociationSet":{"locationName":"cidrBlockAssociationSet","type":"list","member":{"shape":"S3h","locationName":"item"}},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S7f":{"type":"structure","members":{"DhcpConfigurations":{"locationName":"dhcpConfigurationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"locationName":"valueSet","type":"list","member":{"shape":"S7j","locationName":"item"}}}}},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S7j":{"type":"structure","members":{"Value":{"locationName":"value"}}},"S7m":{"type":"structure","members":{"Attachments":{"shape":"S7n","locationName":"attachmentSet"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S7n":{"type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}}},"S87":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"},"HostResourceGroupArn":{"locationName":"hostResourceGroupArn"}}},"S88":{"type":"structure","required":["TotalTargetCapacity"],"members":{"TotalTargetCapacity":{"type":"integer"},"OnDemandTargetCapacity":{"type":"integer"},"SpotTargetCapacity":{"type":"integer"},"DefaultTargetCapacityType":{}}},"S8f":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S8g","locationName":"launchTemplateSpecification"},"Overrides":{"shape":"S8h","locationName":"overrides"}}},"S8g":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"S8h":{"type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"MaxPrice":{"locationName":"maxPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"},"Placement":{"locationName":"placement","type":"structure","members":{"GroupName":{"locationName":"groupName"}}}}},"S8m":{"type":"list","member":{"locationName":"item"}},"S8w":{"type":"structure","members":{"Bucket":{},"Key":{}}},"S8z":{"type":"list","member":{"shape":"S90","locationName":"BlockDeviceMapping"}},"S90":{"type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"},"KmsKeyId":{},"Encrypted":{"locationName":"encrypted","type":"boolean"}}},"NoDevice":{"locationName":"noDevice"}}},"S9a":{"type":"structure","members":{"Description":{"locationName":"description"},"ExportTaskId":{"locationName":"exportTaskId"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"InstanceExportDetails":{"locationName":"instanceExport","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S9g":{"type":"structure","members":{"Attachments":{"shape":"S7n","locationName":"attachmentSet"},"InternetGatewayId":{"locationName":"internetGatewayId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"S9m":{"type":"structure","members":{"KernelId":{},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"Encrypted":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{}}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"InstanceNetworkInterfaceSpecification","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S9v","locationName":"SecurityGroupId"},"InterfaceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"type":"list","member":{"locationName":"InstanceIpv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddresses":{"shape":"S9y"},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"ImageId":{},"InstanceType":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"Affinity":{},"GroupName":{},"HostId":{},"Tenancy":{},"SpreadDomain":{},"HostResourceGroupArn":{},"PartitionNumber":{"type":"integer"}}},"RamDiskId":{},"DisableApiTermination":{"type":"boolean"},"InstanceInitiatedShutdownBehavior":{},"UserData":{},"TagSpecifications":{"locationName":"TagSpecification","type":"list","member":{"locationName":"LaunchTemplateTagSpecificationRequest","type":"structure","members":{"ResourceType":{},"Tags":{"shape":"Sj","locationName":"Tag"}}}},"ElasticGpuSpecifications":{"locationName":"ElasticGpuSpecification","type":"list","member":{"shape":"Sab","locationName":"ElasticGpuSpecification"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{},"Count":{"type":"integer"}}}},"SecurityGroupIds":{"shape":"S9v","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Saf","locationName":"SecurityGroup"},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"Sal"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"}}},"CapacityReservationSpecification":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"Sap"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"MetadataOptions":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{}}}}},"S9v":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S9y":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Primary":{"locationName":"primary","type":"boolean"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"Sab":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Saf":{"type":"list","member":{"locationName":"SecurityGroup"}},"Sal":{"type":"structure","required":["CpuCredits"],"members":{"CpuCredits":{}}},"Sap":{"type":"structure","members":{"CapacityReservationId":{}}},"Sax":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersionNumber":{"locationName":"defaultVersionNumber","type":"long"},"LatestVersionNumber":{"locationName":"latestVersionNumber","type":"long"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Say":{"type":"structure","members":{"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"Sb3":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"VersionDescription":{"locationName":"versionDescription"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersion":{"locationName":"defaultVersion","type":"boolean"},"LaunchTemplateData":{"shape":"Sb4","locationName":"launchTemplateData"}}},"Sb4":{"type":"structure","members":{"KernelId":{"locationName":"kernelId"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"BlockDeviceMappings":{"locationName":"blockDeviceMappingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"KmsKeyId":{"locationName":"kmsKeyId"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"}}},"NoDevice":{"locationName":"noDevice"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S3j","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sbb","locationName":"ipv6AddressesSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S9y","locationName":"privateIpAddressesSet"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}}},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Placement":{"locationName":"placement","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"},"HostResourceGroupArn":{"locationName":"hostResourceGroupArn"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"}}},"RamDiskId":{"locationName":"ramDiskId"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"UserData":{"locationName":"userData"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sj","locationName":"tagSet"}}}},"ElasticGpuSpecifications":{"locationName":"elasticGpuSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"}}}},"ElasticInferenceAccelerators":{"locationName":"elasticInferenceAcceleratorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"Count":{"locationName":"count","type":"integer"}}}},"SecurityGroupIds":{"shape":"So","locationName":"securityGroupIdSet"},"SecurityGroups":{"shape":"So","locationName":"securityGroupSet"},"InstanceMarketOptions":{"locationName":"instanceMarketOptions","type":"structure","members":{"MarketType":{"locationName":"marketType"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"MaxPrice":{"locationName":"maxPrice"},"SpotInstanceType":{"locationName":"spotInstanceType"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}}},"CreditSpecification":{"locationName":"creditSpecification","type":"structure","members":{"CpuCredits":{"locationName":"cpuCredits"}}},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"}}},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"Sbq","locationName":"capacityReservationTarget"}}},"LicenseSpecifications":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"MetadataOptions":{"locationName":"metadataOptions","type":"structure","members":{"State":{"locationName":"state"},"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"}}}}},"Sbb":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"Sbq":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"}}},"Sc0":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"Type":{"locationName":"type"},"State":{"locationName":"state"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"}}},"Sc5":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociationId":{"locationName":"localGatewayRouteTableVpcAssociationId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayId":{"locationName":"localGatewayId"},"VpcId":{"locationName":"vpcId"},"State":{"locationName":"state"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sc9":{"type":"structure","members":{"CreateTime":{"locationName":"createTime","type":"timestamp"},"DeleteTime":{"locationName":"deleteTime","type":"timestamp"},"FailureCode":{"locationName":"failureCode"},"FailureMessage":{"locationName":"failureMessage"},"NatGatewayAddresses":{"locationName":"natGatewayAddressSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIp":{"locationName":"privateIp"},"PublicIp":{"locationName":"publicIp"}}}},"NatGatewayId":{"locationName":"natGatewayId"},"ProvisionedBandwidth":{"locationName":"provisionedBandwidth","type":"structure","members":{"ProvisionTime":{"locationName":"provisionTime","type":"timestamp"},"Provisioned":{"locationName":"provisioned"},"RequestTime":{"locationName":"requestTime","type":"timestamp"},"Requested":{"locationName":"requested"},"Status":{"locationName":"status"}}},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Scg":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkAclAssociationId":{"locationName":"networkAclAssociationId"},"NetworkAclId":{"locationName":"networkAclId"},"SubnetId":{"locationName":"subnetId"}}}},"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Scl","locationName":"icmpTypeCode"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"PortRange":{"shape":"Scm","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"IsDefault":{"locationName":"default","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Scl":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Type":{"locationName":"type","type":"integer"}}},"Scm":{"type":"structure","members":{"From":{"locationName":"from","type":"integer"},"To":{"locationName":"to","type":"integer"}}},"Sct":{"type":"structure","members":{"Association":{"shape":"Scu","locationName":"association"},"Attachment":{"shape":"Scv","locationName":"attachment"},"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"Groups":{"shape":"Scw","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6Addresses":{"locationName":"ipv6AddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Scu","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"RequesterId":{"locationName":"requesterId"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"TagSet":{"shape":"Sj","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"Scu":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"Scv":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"Status":{"locationName":"status"}}},"Scw":{"type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"Sd7":{"type":"structure","members":{"NetworkInterfacePermissionId":{"locationName":"networkInterfacePermissionId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"Permission":{"locationName":"permission"},"PermissionState":{"locationName":"permissionState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"Sdd":{"type":"structure","members":{"GroupName":{"locationName":"groupName"},"State":{"locationName":"state"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"locationName":"partitionCount","type":"integer"},"GroupId":{"locationName":"groupId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sdq":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Main":{"locationName":"main","type":"boolean"},"RouteTableAssociationId":{"locationName":"routeTableAssociationId"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"},"GatewayId":{"locationName":"gatewayId"},"AssociationState":{"shape":"S2r","locationName":"associationState"}}}},"PropagatingVgws":{"locationName":"propagatingVgwSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GatewayId":{"locationName":"gatewayId"}}}},"RouteTableId":{"locationName":"routeTableId"},"Routes":{"locationName":"routeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"LocalGatewayId":{"locationName":"localGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"State":{"locationName":"state"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"Tags":{"shape":"Sj","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Se2":{"type":"structure","members":{"DataEncryptionKeyId":{"locationName":"dataEncryptionKeyId"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"StateMessage":{"locationName":"statusMessage"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"OwnerAlias":{"locationName":"ownerAlias"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sed":{"type":"structure","members":{"Bucket":{"locationName":"bucket"},"Fault":{"shape":"See","locationName":"fault"},"OwnerId":{"locationName":"ownerId"},"Prefix":{"locationName":"prefix"},"State":{"locationName":"state"}}},"See":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sej":{"type":"list","member":{}},"Sen":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"IngressFilterRules":{"shape":"Seo","locationName":"ingressFilterRuleSet"},"EgressFilterRules":{"shape":"Seo","locationName":"egressFilterRuleSet"},"NetworkServices":{"shape":"Set","locationName":"networkServiceSet"},"Description":{"locationName":"description"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Seo":{"type":"list","member":{"shape":"Sep","locationName":"item"}},"Sep":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"TrafficDirection":{"locationName":"trafficDirection"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"},"RuleAction":{"locationName":"ruleAction"},"Protocol":{"locationName":"protocol","type":"integer"},"DestinationPortRange":{"shape":"Ses","locationName":"destinationPortRange"},"SourcePortRange":{"shape":"Ses","locationName":"sourcePortRange"},"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"SourceCidrBlock":{"locationName":"sourceCidrBlock"},"Description":{"locationName":"description"}}},"Ses":{"type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"}}},"Set":{"type":"list","member":{"locationName":"item"}},"Sex":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}},"Sf2":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"},"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PacketLength":{"locationName":"packetLength","type":"integer"},"SessionNumber":{"locationName":"sessionNumber","type":"integer"},"VirtualNetworkId":{"locationName":"virtualNetworkId","type":"integer"},"Description":{"locationName":"description"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sf5":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkLoadBalancerArn":{"locationName":"networkLoadBalancerArn"},"Type":{"locationName":"type"},"Description":{"locationName":"description"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sff":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayArn":{"locationName":"transitGatewayArn"},"State":{"locationName":"state"},"OwnerId":{"locationName":"ownerId"},"Description":{"locationName":"description"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"AutoAcceptSharedAttachments":{"locationName":"autoAcceptSharedAttachments"},"DefaultRouteTableAssociation":{"locationName":"defaultRouteTableAssociation"},"AssociationDefaultRouteTableId":{"locationName":"associationDefaultRouteTableId"},"DefaultRouteTablePropagation":{"locationName":"defaultRouteTablePropagation"},"PropagationDefaultRouteTableId":{"locationName":"propagationDefaultRouteTableId"},"VpnEcmpSupport":{"locationName":"vpnEcmpSupport"},"DnsSupport":{"locationName":"dnsSupport"},"MulticastSupport":{"locationName":"multicastSupport"}}},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sfk":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sfr":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceType":{"locationName":"resourceType"}}}},"Type":{"locationName":"type"},"State":{"locationName":"state"}}},"Sfy":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"DefaultAssociationRouteTable":{"locationName":"defaultAssociationRouteTable","type":"boolean"},"DefaultPropagationRouteTable":{"locationName":"defaultPropagationRouteTable","type":"boolean"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sg1":{"type":"list","member":{"locationName":"item"}},"Sg5":{"type":"structure","members":{"Attachments":{"locationName":"attachmentSet","type":"list","member":{"shape":"S3r","locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OutpostArn":{"locationName":"outpostArn"},"Size":{"locationName":"size","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"Iops":{"locationName":"iops","type":"integer"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VolumeType":{"locationName":"volumeType"},"FastRestored":{"locationName":"fastRestored","type":"boolean"},"MultiAttachEnabled":{"locationName":"multiAttachEnabled","type":"boolean"}}},"Sgc":{"type":"list","member":{"locationName":"item"}},"Sgd":{"type":"list","member":{"locationName":"item"}},"Sge":{"type":"list","member":{"locationName":"item"}},"Sgg":{"type":"structure","members":{"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointType":{"locationName":"vpcEndpointType"},"VpcId":{"locationName":"vpcId"},"ServiceName":{"locationName":"serviceName"},"State":{"locationName":"state"},"PolicyDocument":{"locationName":"policyDocument"},"RouteTableIds":{"shape":"So","locationName":"routeTableIdSet"},"SubnetIds":{"shape":"So","locationName":"subnetIdSet"},"Groups":{"locationName":"groupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"PrivateDnsEnabled":{"locationName":"privateDnsEnabled","type":"boolean"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"NetworkInterfaceIds":{"shape":"So","locationName":"networkInterfaceIdSet"},"DnsEntries":{"shape":"Sgk","locationName":"dnsEntrySet"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"Tags":{"shape":"Sj","locationName":"tagSet"},"OwnerId":{"locationName":"ownerId"},"LastError":{"locationName":"lastError","type":"structure","members":{"Message":{"locationName":"message"},"Code":{"locationName":"code"}}}}},"Sgk":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DnsName":{"locationName":"dnsName"},"HostedZoneId":{"locationName":"hostedZoneId"}}}},"Sgp":{"type":"structure","members":{"ConnectionNotificationId":{"locationName":"connectionNotificationId"},"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"ConnectionNotificationType":{"locationName":"connectionNotificationType"},"ConnectionNotificationArn":{"locationName":"connectionNotificationArn"},"ConnectionEvents":{"shape":"So","locationName":"connectionEvents"},"ConnectionNotificationState":{"locationName":"connectionNotificationState"}}},"Sgu":{"type":"structure","members":{"ServiceType":{"shape":"Sgv","locationName":"serviceType"},"ServiceId":{"locationName":"serviceId"},"ServiceName":{"locationName":"serviceName"},"ServiceState":{"locationName":"serviceState"},"AvailabilityZones":{"shape":"So","locationName":"availabilityZoneSet"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"NetworkLoadBalancerArns":{"shape":"So","locationName":"networkLoadBalancerArnSet"},"BaseEndpointDnsNames":{"shape":"So","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateDnsNameConfiguration":{"locationName":"privateDnsNameConfiguration","type":"structure","members":{"State":{"locationName":"state"},"Type":{"locationName":"type"},"Value":{"locationName":"value"},"Name":{"locationName":"name"}}},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sgv":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceType":{"locationName":"serviceType"}}}},"Sh8":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Sha":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Shc":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"She":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Shg":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"type":"integer"}}}},"Shi":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"type":"integer"}}}},"Shk":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Shn":{"type":"structure","members":{"CustomerGatewayConfiguration":{"locationName":"customerGatewayConfiguration"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"Category":{"locationName":"category"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpnConnectionId":{"locationName":"vpnConnectionId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"Options":{"locationName":"options","type":"structure","members":{"EnableAcceleration":{"locationName":"enableAcceleration","type":"boolean"},"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelOptions":{"locationName":"tunnelOptionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"OutsideIpAddress":{"locationName":"outsideIpAddress"},"TunnelInsideCidr":{"locationName":"tunnelInsideCidr"},"PreSharedKey":{"locationName":"preSharedKey"},"Phase1LifetimeSeconds":{"locationName":"phase1LifetimeSeconds","type":"integer"},"Phase2LifetimeSeconds":{"locationName":"phase2LifetimeSeconds","type":"integer"},"RekeyMarginTimeSeconds":{"locationName":"rekeyMarginTimeSeconds","type":"integer"},"RekeyFuzzPercentage":{"locationName":"rekeyFuzzPercentage","type":"integer"},"ReplayWindowSize":{"locationName":"replayWindowSize","type":"integer"},"DpdTimeoutSeconds":{"locationName":"dpdTimeoutSeconds","type":"integer"},"Phase1EncryptionAlgorithms":{"locationName":"phase1EncryptionAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase2EncryptionAlgorithms":{"locationName":"phase2EncryptionAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase1IntegrityAlgorithms":{"locationName":"phase1IntegrityAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase2IntegrityAlgorithms":{"locationName":"phase2IntegrityAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase1DHGroupNumbers":{"locationName":"phase1DHGroupNumberSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value","type":"integer"}}}},"Phase2DHGroupNumbers":{"locationName":"phase2DHGroupNumberSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value","type":"integer"}}}},"IkeVersions":{"locationName":"ikeVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}}}}}}},"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"Source":{"locationName":"source"},"State":{"locationName":"state"}}}},"Tags":{"shape":"Sj","locationName":"tagSet"},"VgwTelemetry":{"locationName":"vgwTelemetry","type":"list","member":{"locationName":"item","type":"structure","members":{"AcceptedRouteCount":{"locationName":"acceptedRouteCount","type":"integer"},"LastStatusChange":{"locationName":"lastStatusChange","type":"timestamp"},"OutsideIpAddress":{"locationName":"outsideIpAddress"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"CertificateArn":{"locationName":"certificateArn"}}}}}},"Sig":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpcAttachments":{"locationName":"attachments","type":"list","member":{"shape":"S3w","locationName":"item"}},"VpnGatewayId":{"locationName":"vpnGatewayId"},"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Sis":{"type":"list","member":{}},"Sj2":{"type":"list","member":{"locationName":"item"}},"Sjd":{"type":"list","member":{"locationName":"item"}},"Sl5":{"type":"list","member":{"locationName":"item"}},"Slj":{"type":"list","member":{"locationName":"item"}},"Sll":{"type":"structure","members":{"InstanceTagKeys":{"shape":"Slj","locationName":"instanceTagKeySet"},"IncludeAllTagsOfInstance":{"locationName":"includeAllTagsOfInstance","type":"boolean"}}},"Sln":{"type":"list","member":{"locationName":"item"}},"Sm2":{"type":"list","member":{"locationName":"Filter","type":"structure","members":{"Name":{},"Values":{"shape":"So","locationName":"Value"}}}},"Smb":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Deadline":{"locationName":"deadline","type":"timestamp"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"Sn2":{"type":"list","member":{"locationName":"InstanceId"}},"Snh":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Soj":{"type":"structure","members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"ExpirationTime":{"locationName":"expirationTime"},"ImportInstance":{"locationName":"importInstance","type":"structure","members":{"Description":{"locationName":"description"},"InstanceId":{"locationName":"instanceId"},"Platform":{"locationName":"platform"},"Volumes":{"locationName":"volumes","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Son","locationName":"image"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Volume":{"shape":"Soo","locationName":"volume"}}}}}},"ImportVolume":{"locationName":"importVolume","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Son","locationName":"image"},"Volume":{"shape":"Soo","locationName":"volume"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Sj","locationName":"tagSet"}}},"Son":{"type":"structure","members":{"Checksum":{"locationName":"checksum"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"},"Size":{"locationName":"size","type":"long"}}},"Soo":{"type":"structure","members":{"Id":{"locationName":"id"},"Size":{"locationName":"size","type":"long"}}},"Spm":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"Sq3":{"type":"structure","members":{"EventDescription":{"locationName":"eventDescription"},"EventSubType":{"locationName":"eventSubType"},"InstanceId":{"locationName":"instanceId"}}},"Sq6":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"InstanceHealth":{"locationName":"instanceHealth"}}}},"Sqw":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"LoadPermissions":{"locationName":"loadPermissions","type":"list","member":{"locationName":"item","type":"structure","members":{"UserId":{"locationName":"userId"},"Group":{"locationName":"group"}}}},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"}}},"Sr0":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ProductCodeId":{"locationName":"productCode"},"ProductCodeType":{"locationName":"type"}}}},"Sr5":{"type":"list","member":{"locationName":"Owner"}},"Srq":{"type":"list","member":{"locationName":"item"}},"Srt":{"type":"list","member":{"locationName":"item"}},"Ssi":{"type":"list","member":{"shape":"S90","locationName":"item"}},"Ssj":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Ssw":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"St4":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"DeviceName":{"locationName":"deviceName"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"St6","locationName":"userBucket"}}}},"St6":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"St7":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"Stf":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Format":{"locationName":"format"},"KmsKeyId":{"locationName":"kmsKeyId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"St6","locationName":"userBucket"}}},"Stj":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Status":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"}}}}}},"Stm":{"type":"structure","members":{"Value":{"locationName":"value","type":"boolean"}}},"Stz":{"type":"structure","members":{"InstanceEventId":{"locationName":"instanceEventId"},"Code":{"locationName":"code"},"Description":{"locationName":"description"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"NotBeforeDeadline":{"locationName":"notBeforeDeadline","type":"timestamp"}}},"Su2":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Name":{"locationName":"name"}}},"Su4":{"type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"ImpairedSince":{"locationName":"impairedSince","type":"timestamp"},"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"Sww":{"type":"structure","members":{"Groups":{"shape":"Scw","locationName":"groupSet"},"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiLaunchIndex":{"locationName":"amiLaunchIndex","type":"integer"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"LaunchTime":{"locationName":"launchTime","type":"timestamp"},"Monitoring":{"shape":"Swz","locationName":"monitoring"},"Placement":{"shape":"S87","locationName":"placement"},"Platform":{"locationName":"platform"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ProductCodes":{"shape":"Sr0","locationName":"productCodes"},"PublicDnsName":{"locationName":"dnsName"},"PublicIpAddress":{"locationName":"ipAddress"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"shape":"Su2","locationName":"instanceState"},"StateTransitionReason":{"locationName":"reason"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"Stj","locationName":"blockDeviceMapping"},"ClientToken":{"locationName":"clientToken"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"IamInstanceProfile":{"shape":"S2l","locationName":"iamInstanceProfile"},"InstanceLifecycle":{"locationName":"instanceLifecycle"},"ElasticGpuAssociations":{"locationName":"elasticGpuAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"ElasticGpuAssociationId":{"locationName":"elasticGpuAssociationId"},"ElasticGpuAssociationState":{"locationName":"elasticGpuAssociationState"},"ElasticGpuAssociationTime":{"locationName":"elasticGpuAssociationTime"}}}},"ElasticInferenceAcceleratorAssociations":{"locationName":"elasticInferenceAcceleratorAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticInferenceAcceleratorArn":{"locationName":"elasticInferenceAcceleratorArn"},"ElasticInferenceAcceleratorAssociationId":{"locationName":"elasticInferenceAcceleratorAssociationId"},"ElasticInferenceAcceleratorAssociationState":{"locationName":"elasticInferenceAcceleratorAssociationState"},"ElasticInferenceAcceleratorAssociationTime":{"locationName":"elasticInferenceAcceleratorAssociationTime","type":"timestamp"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Sx8","locationName":"association"},"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Status":{"locationName":"status"}}},"Description":{"locationName":"description"},"Groups":{"shape":"Scw","locationName":"groupSet"},"Ipv6Addresses":{"shape":"Sbb","locationName":"ipv6AddressesSet"},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Sx8","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"InterfaceType":{"locationName":"interfaceType"}}}},"OutpostArn":{"locationName":"outpostArn"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SecurityGroups":{"shape":"Scw","locationName":"groupSet"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Ssw","locationName":"stateReason"},"Tags":{"shape":"Sj","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"}}},"CapacityReservationId":{"locationName":"capacityReservationId"},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"Sbq","locationName":"capacityReservationTarget"}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"Licenses":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"MetadataOptions":{"shape":"Sxh","locationName":"metadataOptions"}}}},"OwnerId":{"locationName":"ownerId"},"RequesterId":{"locationName":"requesterId"},"ReservationId":{"locationName":"reservationId"}}},"Swz":{"type":"structure","members":{"State":{"locationName":"state"}}},"Sx8":{"type":"structure","members":{"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"Sxh":{"type":"structure","members":{"State":{"locationName":"state"},"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"}}},"Syy":{"type":"list","member":{"locationName":"item"}},"S110":{"type":"list","member":{"locationName":"ReservedInstancesId"}},"S118":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"Frequency":{"locationName":"frequency"}}}},"S11m":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"},"Scope":{"locationName":"scope"}}},"S129":{"type":"structure","members":{"Frequency":{"locationName":"frequency"},"Interval":{"locationName":"interval","type":"integer"},"OccurrenceDaySet":{"locationName":"occurrenceDaySet","type":"list","member":{"locationName":"item","type":"integer"}},"OccurrenceRelativeToEnd":{"locationName":"occurrenceRelativeToEnd","type":"boolean"},"OccurrenceUnit":{"locationName":"occurrenceUnit"}}},"S12h":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"NetworkPlatform":{"locationName":"networkPlatform"},"NextSlotStartTime":{"locationName":"nextSlotStartTime","type":"timestamp"},"Platform":{"locationName":"platform"},"PreviousSlotEndTime":{"locationName":"previousSlotEndTime","type":"timestamp"},"Recurrence":{"shape":"S129","locationName":"recurrence"},"ScheduledInstanceId":{"locationName":"scheduledInstanceId"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TermEndDate":{"locationName":"termEndDate","type":"timestamp"},"TermStartDate":{"locationName":"termStartDate","type":"timestamp"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}},"S12o":{"type":"list","member":{"locationName":"GroupName"}},"S12w":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"S130":{"type":"list","member":{"locationName":"SnapshotId"}},"S13j":{"type":"structure","required":["IamFleetRole","TargetCapacity"],"members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"OnDemandAllocationStrategy":{"locationName":"onDemandAllocationStrategy"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"OnDemandFulfilledCapacity":{"locationName":"onDemandFulfilledCapacity","type":"double"},"IamFleetRole":{"locationName":"iamFleetRole"},"LaunchSpecifications":{"locationName":"launchSpecifications","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroups":{"shape":"Scw","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Ssi","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S2i","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"NetworkInterfaces":{"shape":"S13q","locationName":"networkInterfaceSet"},"Placement":{"shape":"S13s","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Sj","locationName":"tag"}}}}}}},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S8g","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"}}}}}}},"SpotPrice":{"locationName":"spotPrice"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"OnDemandMaxTotalPrice":{"locationName":"onDemandMaxTotalPrice"},"SpotMaxTotalPrice":{"locationName":"spotMaxTotalPrice"},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"LoadBalancersConfig":{"locationName":"loadBalancersConfig","type":"structure","members":{"ClassicLoadBalancersConfig":{"locationName":"classicLoadBalancersConfig","type":"structure","members":{"ClassicLoadBalancers":{"locationName":"classicLoadBalancers","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"}}}}}},"TargetGroupsConfig":{"locationName":"targetGroupsConfig","type":"structure","members":{"TargetGroups":{"locationName":"targetGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"}}}}}}}},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"TagSpecifications":{"shape":"S1l","locationName":"TagSpecification"}}},"S13q":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S9v","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sbb","locationName":"ipv6AddressesSet","queryName":"Ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S9y","locationName":"privateIpAddressesSet","queryName":"PrivateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"},"InterfaceType":{}}}},"S13s":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"GroupName":{"locationName":"groupName"},"Tenancy":{"locationName":"tenancy"}}},"S148":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ActualBlockHourlyPrice":{"locationName":"actualBlockHourlyPrice"},"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Fault":{"shape":"See","locationName":"fault"},"InstanceId":{"locationName":"instanceId"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"UserData":{"locationName":"userData"},"SecurityGroups":{"shape":"Scw","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Ssi","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S2i","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"NetworkInterfaces":{"shape":"S13q","locationName":"networkInterfaceSet"},"Placement":{"shape":"S13s","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"Monitoring":{"shape":"S14b","locationName":"monitoring"}}},"LaunchedAvailabilityZone":{"locationName":"launchedAvailabilityZone"},"ProductDescription":{"locationName":"productDescription"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SpotPrice":{"locationName":"spotPrice"},"State":{"locationName":"state"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"Tags":{"shape":"Sj","locationName":"tagSet"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}},"S14b":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"S14q":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item"}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item"}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S4c","locationName":"item"}}}}},"S15i":{"type":"list","member":{}},"S16a":{"type":"list","member":{"locationName":"VolumeId"}},"S16v":{"type":"structure","members":{"VolumeId":{"locationName":"volumeId"},"ModificationState":{"locationName":"modificationState"},"StatusMessage":{"locationName":"statusMessage"},"TargetSize":{"locationName":"targetSize","type":"integer"},"TargetIops":{"locationName":"targetIops","type":"integer"},"TargetVolumeType":{"locationName":"targetVolumeType"},"OriginalSize":{"locationName":"originalSize","type":"integer"},"OriginalIops":{"locationName":"originalIops","type":"integer"},"OriginalVolumeType":{"locationName":"originalVolumeType"},"Progress":{"locationName":"progress","type":"long"},"StartTime":{"locationName":"startTime","type":"timestamp"},"EndTime":{"locationName":"endTime","type":"timestamp"}}},"S171":{"type":"list","member":{"locationName":"VpcId"}},"S18q":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S191":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"S1b5":{"type":"structure","members":{"InstanceFamily":{"locationName":"instanceFamily"},"CpuCredits":{"locationName":"cpuCredits"}}},"S1bb":{"type":"list","member":{"locationName":"item"}},"S1bd":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HostIdSet":{"shape":"Srq","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"S1bl":{"type":"structure","members":{"HourlyPrice":{"locationName":"hourlyPrice"},"RemainingTotalValue":{"locationName":"remainingTotalValue"},"RemainingUpfrontValue":{"locationName":"remainingUpfrontValue"}}},"S1ca":{"type":"structure","members":{"Comment":{},"UploadEnd":{"type":"timestamp"},"UploadSize":{"type":"double"},"UploadStart":{"type":"timestamp"}}},"S1cd":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S1ck":{"type":"structure","required":["Bytes","Format","ImportManifestUrl"],"members":{"Bytes":{"locationName":"bytes","type":"long"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"}}},"S1cl":{"type":"structure","required":["Size"],"members":{"Size":{"locationName":"size","type":"long"}}},"S1dc":{"type":"list","member":{"locationName":"UserId"}},"S1dd":{"type":"list","member":{"locationName":"UserGroup"}},"S1de":{"type":"list","member":{"locationName":"ProductCode"}},"S1dg":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{},"UserId":{}}}},"S1dl":{"type":"list","member":{"shape":"Sy","locationName":"item"}},"S1dw":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"Sap"}}},"S1fi":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"type":"boolean"}}},"S1fk":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"S1fx":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Monitoring":{"shape":"Swz","locationName":"monitoring"}}}},"S1ir":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S1jf":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentState":{"shape":"Su2","locationName":"currentState"},"InstanceId":{"locationName":"instanceId"},"PreviousState":{"shape":"Su2","locationName":"previousState"}}}}}}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccountAttributes":{"result_key":"AccountAttributes"},"DescribeAddresses":{"result_key":"Addresses"},"DescribeAvailabilityZones":{"result_key":"AvailabilityZones"},"DescribeBundleTasks":{"result_key":"BundleTasks"},"DescribeByoipCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ByoipCidrs"},"DescribeCapacityReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservations"},"DescribeClassicLinkInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Instances"},"DescribeClientVpnAuthorizationRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthorizationRules"},"DescribeClientVpnConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Connections"},"DescribeClientVpnEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnEndpoints"},"DescribeClientVpnRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"DescribeClientVpnTargetNetworks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnTargetNetworks"},"DescribeCoipPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CoipPools"},"DescribeConversionTasks":{"result_key":"ConversionTasks"},"DescribeCustomerGateways":{"result_key":"CustomerGateways"},"DescribeDhcpOptions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DhcpOptions"},"DescribeEgressOnlyInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EgressOnlyInternetGateways"},"DescribeExportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ExportImageTasks"},"DescribeExportTasks":{"result_key":"ExportTasks"},"DescribeFastSnapshotRestores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FastSnapshotRestores"},"DescribeFleets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fleets"},"DescribeFlowLogs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FlowLogs"},"DescribeFpgaImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FpgaImages"},"DescribeHostReservationOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OfferingSet"},"DescribeHostReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HostReservationSet"},"DescribeHosts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Hosts"},"DescribeIamInstanceProfileAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IamInstanceProfileAssociations"},"DescribeImages":{"result_key":"Images"},"DescribeImportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportImageTasks"},"DescribeImportSnapshotTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportSnapshotTasks"},"DescribeInstanceCreditSpecifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceCreditSpecifications"},"DescribeInstanceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceStatuses"},"DescribeInstanceTypeOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypeOfferings"},"DescribeInstanceTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypes"},"DescribeInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Reservations"},"DescribeInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InternetGateways"},"DescribeIpv6Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipv6Pools"},"DescribeKeyPairs":{"result_key":"KeyPairs"},"DescribeLaunchTemplateVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplateVersions"},"DescribeLaunchTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplates"},"DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTableVirtualInterfaceGroupAssociations"},"DescribeLocalGatewayRouteTableVpcAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTableVpcAssociations"},"DescribeLocalGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTables"},"DescribeLocalGatewayVirtualInterfaceGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayVirtualInterfaceGroups"},"DescribeLocalGatewayVirtualInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayVirtualInterfaces"},"DescribeLocalGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGateways"},"DescribeMovingAddresses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MovingAddressStatuses"},"DescribeNatGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NatGateways"},"DescribeNetworkAcls":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkAcls"},"DescribeNetworkInterfacePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfacePermissions"},"DescribeNetworkInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfaces"},"DescribePlacementGroups":{"result_key":"PlacementGroups"},"DescribePrefixLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixLists"},"DescribePrincipalIdFormat":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Principals"},"DescribePublicIpv4Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PublicIpv4Pools"},"DescribeRegions":{"result_key":"Regions"},"DescribeReservedInstances":{"result_key":"ReservedInstances"},"DescribeReservedInstancesListings":{"result_key":"ReservedInstancesListings"},"DescribeReservedInstancesModifications":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReservedInstancesModifications"},"DescribeReservedInstancesOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReservedInstancesOfferings"},"DescribeRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RouteTables"},"DescribeScheduledInstanceAvailability":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceAvailabilitySet"},"DescribeScheduledInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceSet"},"DescribeSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroups"},"DescribeSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"DescribeSpotFleetRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotFleetRequestConfigs"},"DescribeSpotInstanceRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotInstanceRequests"},"DescribeSpotPriceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPriceHistory"},"DescribeStaleSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StaleSecurityGroupSet"},"DescribeSubnets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Subnets"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"DescribeTrafficMirrorFilters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorFilters"},"DescribeTrafficMirrorSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorSessions"},"DescribeTrafficMirrorTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorTargets"},"DescribeTransitGatewayAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachments"},"DescribeTransitGatewayMulticastDomains":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayMulticastDomains"},"DescribeTransitGatewayPeeringAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayPeeringAttachments"},"DescribeTransitGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTables"},"DescribeTransitGatewayVpcAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayVpcAttachments"},"DescribeTransitGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGateways"},"DescribeVolumeStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumeStatuses"},"DescribeVolumes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Volumes"},"DescribeVolumesModifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumesModifications"},"DescribeVpcClassicLinkDnsSupport":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpcEndpointConnectionNotifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ConnectionNotificationSet"},"DescribeVpcEndpointConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpointConnections"},"DescribeVpcEndpointServiceConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServiceConfigurations"},"DescribeVpcEndpointServicePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AllowedPrincipals"},"DescribeVpcEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpoints"},"DescribeVpcPeeringConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcPeeringConnections"},"DescribeVpcs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpnConnections":{"result_key":"VpnConnections"},"DescribeVpnGateways":{"result_key":"VpnGateways"},"GetAssociatedIpv6PoolCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipv6CidrAssociations"},"GetTransitGatewayAttachmentPropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachmentPropagations"},"GetTransitGatewayMulticastDomainAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MulticastDomainAssociations"},"GetTransitGatewayRouteTableAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"GetTransitGatewayRouteTablePropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTablePropagations"},"SearchLocalGatewayRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"SearchTransitGatewayMulticastGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MulticastGroups"}}}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceExists":{"delay":5,"maxAttempts":40,"operation":"DescribeInstances","acceptors":[{"matcher":"path","expected":true,"argument":"length(Reservations[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"BundleTaskComplete":{"delay":15,"operation":"DescribeBundleTasks","maxAttempts":40,"acceptors":[{"expected":"complete","matcher":"pathAll","state":"success","argument":"BundleTasks[].State"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"BundleTasks[].State"}]},"ConversionTaskCancelled":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"ConversionTaskCompleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"},{"expected":"cancelled","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"},{"expected":"cancelling","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"}]},"ConversionTaskDeleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"CustomerGatewayAvailable":{"delay":15,"operation":"DescribeCustomerGateways","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"CustomerGateways[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"}]},"ExportTaskCancelled":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ExportTaskCompleted":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ImageExists":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"matcher":"path","expected":true,"argument":"length(Images[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidAMIID.NotFound","state":"retry"}]},"ImageAvailable":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Images[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"Images[].State","expected":"failed"}]},"InstanceRunning":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"running","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"shutting-down","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].InstanceStatus.Status","expected":"ok"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"KeyPairExists":{"operation":"DescribeKeyPairs","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(KeyPairs[].KeyName) > `0`"},{"expected":"InvalidKeyPair.NotFound","matcher":"error","state":"retry"}]},"NatGatewayAvailable":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"failed"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleting"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleted"},{"state":"retry","matcher":"error","expected":"NatGatewayNotFound"}]},"NetworkInterfaceAvailable":{"operation":"DescribeNetworkInterfaces","delay":20,"maxAttempts":10,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"NetworkInterfaces[].Status"},{"expected":"InvalidNetworkInterfaceID.NotFound","matcher":"error","state":"failure"}]},"PasswordDataAvailable":{"operation":"GetPasswordData","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"path","argument":"length(PasswordData) > `0`","expected":true}]},"SnapshotCompleted":{"delay":15,"operation":"DescribeSnapshots","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"Snapshots[].State"}]},"SecurityGroupExists":{"operation":"DescribeSecurityGroups","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(SecurityGroups[].GroupId) > `0`"},{"expected":"InvalidGroupNotFound","matcher":"error","state":"retry"}]},"SpotInstanceRequestFulfilled":{"operation":"DescribeSpotInstanceRequests","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"fulfilled"},{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"request-canceled-and-instance-running"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"schedule-expired"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"canceled-before-fulfillment"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"bad-parameters"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"system-error"},{"state":"retry","matcher":"error","expected":"InvalidSpotInstanceRequestID.NotFound"}]},"SubnetAvailable":{"delay":15,"operation":"DescribeSubnets","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Subnets[].State"}]},"SystemStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].SystemStatus.Status","expected":"ok"}]},"VolumeAvailable":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VolumeDeleted":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"matcher":"error","expected":"InvalidVolume.NotFound","state":"success"}]},"VolumeInUse":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"in-use","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VpcAvailable":{"delay":15,"operation":"DescribeVpcs","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Vpcs[].State"}]},"VpcExists":{"operation":"DescribeVpcs","delay":1,"maxAttempts":5,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcID.NotFound","state":"retry"}]},"VpnConnectionAvailable":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpnConnectionDeleted":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpcPeeringConnectionExists":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"retry"}]},"VpcPeeringConnectionDeleted":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpcPeeringConnections[].Status.Code"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"success"}]}}}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-09-21","endpointPrefix":"api.ecr","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECR","serviceFullName":"Amazon EC2 Container Registry","serviceId":"ECR","signatureVersion":"v4","signingName":"ecr","targetPrefix":"AmazonEC2ContainerRegistry_V20150921","uid":"ecr-2015-09-21"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"failures":{"shape":"Sn"}}}},"BatchGetImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"acceptedMediaTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"images":{"type":"list","member":{"shape":"Sv"}},"failures":{"shape":"Sn"}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"tags":{"shape":"S12"},"imageTagMutability":{},"imageScanningConfiguration":{"shape":"S17"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1a"}}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1a"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImageScanFindings":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageScanStatus":{"shape":"S1s"},"imageScanFindings":{"type":"structure","members":{"imageScanCompletedAt":{"type":"timestamp"},"vulnerabilitySourceUpdatedAt":{"type":"timestamp"},"findings":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"uri":{},"severity":{},"attributes":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}},"findingSeverityCounts":{"shape":"S27"}}},"nextToken":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"shape":"S2f"},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"},"imageScanStatus":{"shape":"S1s"},"imageScanFindingsSummary":{"type":"structure","members":{"imageScanCompletedAt":{"type":"timestamp"},"vulnerabilitySourceUpdatedAt":{"type":"timestamp"},"findingSeverityCounts":{"shape":"S27"}}}}}},"nextToken":{}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1a"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{"registryIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"authorizationData":{"type":"list","member":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"},"proxyEndpoint":{}}}}}}},"GetDownloadUrlForLayer":{"input":{"type":"structure","required":["repositoryName","layerDigest"],"members":{"registryId":{},"repositoryName":{},"layerDigest":{}}},"output":{"type":"structure","members":{"downloadUrl":{},"layerDigest":{}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"GetLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{},"nextToken":{},"previewResults":{"type":"list","member":{"type":"structure","members":{"imageTags":{"shape":"S2f"},"imageDigest":{},"imagePushedAt":{"type":"timestamp"},"action":{"type":"structure","members":{"type":{}}},"appliedRulePriority":{"type":"integer"}}}},"summary":{"type":"structure","members":{"expiringImageTotalCount":{"type":"integer"}}}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S12"}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageManifestMediaType":{},"imageTag":{}}},"output":{"type":"structure","members":{"image":{"shape":"Sv"}}}},"PutImageScanningConfiguration":{"input":{"type":"structure","required":["repositoryName","imageScanningConfiguration"],"members":{"registryId":{},"repositoryName":{},"imageScanningConfiguration":{"shape":"S17"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageScanningConfiguration":{"shape":"S17"}}}},"PutImageTagMutability":{"input":{"type":"structure","required":["repositoryName","imageTagMutability"],"members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName","lifecyclePolicyText"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"StartImageScan":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageScanStatus":{"shape":"S1s"}}}},"StartLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}}},"shapes":{"Si":{"type":"list","member":{"shape":"Sj"}},"Sj":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sn":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sj"},"failureCode":{},"failureReason":{}}}},"Sv":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageManifest":{},"imageManifestMediaType":{}}},"S12":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S17":{"type":"structure","members":{"scanOnPush":{"type":"boolean"}}},"S1a":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"},"imageTagMutability":{},"imageScanningConfiguration":{"shape":"S17"}}},"S1s":{"type":"structure","members":{"status":{},"description":{}}},"S27":{"type":"map","key":{},"value":{"type":"integer"}},"S2f":{"type":"list","member":{}}}}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeImageScanFindings":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["registryId","repositoryName","imageId","imageScanStatus","imageScanFindings"],"output_token":"nextToken","result_key":"imageScanFindings.findings"},"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"},"GetLifecyclePolicyPreview":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["registryId","repositoryName","lifecyclePolicyText","status","summary"],"output_token":"nextToken","result_key":"previewResults"},"ListImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageIds"}}}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ImageScanComplete":{"description":"Wait until an image scan is complete and findings can be accessed","operation":"DescribeImageScanFindings","delay":5,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"imageScanStatus.status","expected":"COMPLETE"},{"state":"failure","matcher":"path","argument":"imageScanStatus.status","expected":"FAILED"}]},"LifecyclePolicyPreviewComplete":{"description":"Wait until a lifecycle policy preview request is complete and results can be accessed","operation":"GetLifecyclePolicyPreview","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"status","expected":"COMPLETE"},{"state":"failure","matcher":"path","argument":"status","expected":"FAILED"}]}}}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-13","endpointPrefix":"ecs","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECS","serviceFullName":"Amazon EC2 Container Service","serviceId":"ECS","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerServiceV20141113","uid":"ecs-2014-11-13"},"operations":{"CreateCapacityProvider":{"input":{"type":"structure","required":["name","autoScalingGroupProvider"],"members":{"name":{},"autoScalingGroupProvider":{"shape":"S3"},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Se"}}}},"CreateCluster":{"input":{"type":"structure","members":{"clusterName":{},"tags":{"shape":"S9"},"settings":{"shape":"Si"},"capacityProviders":{"shape":"Sl"},"defaultCapacityProviderStrategy":{"shape":"Sm"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sr"}}}},"CreateService":{"input":{"type":"structure","required":["serviceName"],"members":{"cluster":{},"serviceName":{},"taskDefinition":{},"loadBalancers":{"shape":"Sz"},"serviceRegistries":{"shape":"S12"},"desiredCount":{"type":"integer"},"clientToken":{},"launchType":{},"capacityProviderStrategy":{"shape":"Sm"},"platformVersion":{},"role":{},"deploymentConfiguration":{"shape":"S15"},"placementConstraints":{"shape":"S16"},"placementStrategy":{"shape":"S19"},"networkConfiguration":{"shape":"S1c"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"S1g"},"tags":{"shape":"S9"},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{}}},"output":{"type":"structure","members":{"service":{"shape":"S1l"}}}},"CreateTaskSet":{"input":{"type":"structure","required":["service","cluster","taskDefinition"],"members":{"service":{},"cluster":{},"externalId":{},"taskDefinition":{},"networkConfiguration":{"shape":"S1c"},"loadBalancers":{"shape":"Sz"},"serviceRegistries":{"shape":"S12"},"launchType":{},"capacityProviderStrategy":{"shape":"Sm"},"platformVersion":{},"scale":{"shape":"S1p"},"clientToken":{},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1n"}}}},"DeleteAccountSetting":{"input":{"type":"structure","required":["name"],"members":{"name":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S22"}}}},"DeleteAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S24"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S24"}}}},"DeleteCapacityProvider":{"input":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Se"}}}},"DeleteCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sr"}}}},"DeleteService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"service":{"shape":"S1l"}}}},"DeleteTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet"],"members":{"cluster":{},"service":{},"taskSet":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1n"}}}},"DeregisterContainerInstance":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S2j"}}}},"DeregisterTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S2r"}}}},"DescribeCapacityProviders":{"input":{"type":"structure","members":{"capacityProviders":{"shape":"Sl"},"include":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"capacityProviders":{"type":"list","member":{"shape":"Se"}},"failures":{"shape":"S4v"},"nextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"clusters":{"shape":"Sl"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"clusters":{"type":"list","member":{"shape":"Sr"}},"failures":{"shape":"S4v"}}}},"DescribeContainerInstances":{"input":{"type":"structure","required":["containerInstances"],"members":{"cluster":{},"containerInstances":{"shape":"Sl"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S56"},"failures":{"shape":"S4v"}}}},"DescribeServices":{"input":{"type":"structure","required":["services"],"members":{"cluster":{},"services":{"shape":"Sl"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"shape":"S1l"}},"failures":{"shape":"S4v"}}}},"DescribeTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S2r"},"tags":{"shape":"S9"}}}},"DescribeTaskSets":{"input":{"type":"structure","required":["cluster","service"],"members":{"cluster":{},"service":{},"taskSets":{"shape":"Sl"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskSets":{"shape":"S1m"},"failures":{"shape":"S4v"}}}},"DescribeTasks":{"input":{"type":"structure","required":["tasks"],"members":{"cluster":{},"tasks":{"shape":"Sl"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"tasks":{"shape":"S5o"},"failures":{"shape":"S4v"}}}},"DiscoverPollEndpoint":{"input":{"type":"structure","members":{"containerInstance":{},"cluster":{}}},"output":{"type":"structure","members":{"endpoint":{},"telemetryEndpoint":{}}}},"ListAccountSettings":{"input":{"type":"structure","members":{"name":{},"value":{},"principalArn":{},"effectiveSettings":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"settings":{"type":"list","member":{"shape":"S22"}},"nextToken":{}}}},"ListAttributes":{"input":{"type":"structure","required":["targetType"],"members":{"cluster":{},"targetType":{},"attributeName":{},"attributeValue":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S24"},"nextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"clusterArns":{"shape":"Sl"},"nextToken":{}}}},"ListContainerInstances":{"input":{"type":"structure","members":{"cluster":{},"filter":{},"nextToken":{},"maxResults":{"type":"integer"},"status":{}}},"output":{"type":"structure","members":{"containerInstanceArns":{"shape":"Sl"},"nextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"cluster":{},"nextToken":{},"maxResults":{"type":"integer"},"launchType":{},"schedulingStrategy":{}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"Sl"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S9"}}}},"ListTaskDefinitionFamilies":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"families":{"shape":"Sl"},"nextToken":{}}}},"ListTaskDefinitions":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"sort":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"taskDefinitionArns":{"shape":"Sl"},"nextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"cluster":{},"containerInstance":{},"family":{},"nextToken":{},"maxResults":{"type":"integer"},"startedBy":{},"serviceName":{},"desiredStatus":{},"launchType":{}}},"output":{"type":"structure","members":{"taskArns":{"shape":"Sl"},"nextToken":{}}}},"PutAccountSetting":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S22"}}}},"PutAccountSettingDefault":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S22"}}}},"PutAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S24"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S24"}}}},"PutClusterCapacityProviders":{"input":{"type":"structure","required":["cluster","capacityProviders","defaultCapacityProviderStrategy"],"members":{"cluster":{},"capacityProviders":{"shape":"Sl"},"defaultCapacityProviderStrategy":{"shape":"Sm"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sr"}}}},"RegisterContainerInstance":{"input":{"type":"structure","members":{"cluster":{},"instanceIdentityDocument":{},"instanceIdentityDocumentSignature":{},"totalResources":{"shape":"S2m"},"versionInfo":{"shape":"S2l"},"containerInstanceArn":{},"attributes":{"shape":"S24"},"platformDevices":{"type":"list","member":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}}},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S2j"}}}},"RegisterTaskDefinition":{"input":{"type":"structure","required":["family","containerDefinitions"],"members":{"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"containerDefinitions":{"shape":"S2s"},"volumes":{"shape":"S42"},"placementConstraints":{"shape":"S4e"},"requiresCompatibilities":{"shape":"S4h"},"cpu":{},"memory":{},"tags":{"shape":"S9"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S4n"},"inferenceAccelerators":{"shape":"S4j"}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S2r"},"tags":{"shape":"S9"}}}},"RunTask":{"input":{"type":"structure","required":["taskDefinition"],"members":{"capacityProviderStrategy":{"shape":"Sm"},"cluster":{},"count":{"type":"integer"},"enableECSManagedTags":{"type":"boolean"},"group":{},"launchType":{},"networkConfiguration":{"shape":"S1c"},"overrides":{"shape":"S5z"},"placementConstraints":{"shape":"S16"},"placementStrategy":{"shape":"S19"},"platformVersion":{},"propagateTags":{},"referenceId":{},"startedBy":{},"tags":{"shape":"S9"},"taskDefinition":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S5o"},"failures":{"shape":"S4v"}}}},"StartTask":{"input":{"type":"structure","required":["containerInstances","taskDefinition"],"members":{"cluster":{},"containerInstances":{"shape":"Sl"},"enableECSManagedTags":{"type":"boolean"},"group":{},"networkConfiguration":{"shape":"S1c"},"overrides":{"shape":"S5z"},"propagateTags":{},"referenceId":{},"startedBy":{},"tags":{"shape":"S9"},"taskDefinition":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S5o"},"failures":{"shape":"S4v"}}}},"StopTask":{"input":{"type":"structure","required":["task"],"members":{"cluster":{},"task":{},"reason":{}}},"output":{"type":"structure","members":{"task":{"shape":"S5p"}}}},"SubmitAttachmentStateChanges":{"input":{"type":"structure","required":["attachments"],"members":{"cluster":{},"attachments":{"shape":"S7g"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitContainerStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"containerName":{},"runtimeId":{},"status":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S5t"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitTaskStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"status":{},"reason":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerName":{},"imageDigest":{},"runtimeId":{},"exitCode":{"type":"integer"},"networkBindings":{"shape":"S5t"},"reason":{},"status":{}}}},"attachments":{"shape":"S7g"},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateClusterSettings":{"input":{"type":"structure","required":["cluster","settings"],"members":{"cluster":{},"settings":{"shape":"Si"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sr"}}}},"UpdateContainerAgent":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S2j"}}}},"UpdateContainerInstancesState":{"input":{"type":"structure","required":["containerInstances","status"],"members":{"cluster":{},"containerInstances":{"shape":"Sl"},"status":{}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S56"},"failures":{"shape":"S4v"}}}},"UpdateService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"desiredCount":{"type":"integer"},"taskDefinition":{},"capacityProviderStrategy":{"shape":"Sm"},"deploymentConfiguration":{"shape":"S15"},"networkConfiguration":{"shape":"S1c"},"placementConstraints":{"shape":"S16"},"placementStrategy":{"shape":"S19"},"platformVersion":{},"forceNewDeployment":{"type":"boolean"},"healthCheckGracePeriodSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"service":{"shape":"S1l"}}}},"UpdateServicePrimaryTaskSet":{"input":{"type":"structure","required":["cluster","service","primaryTaskSet"],"members":{"cluster":{},"service":{},"primaryTaskSet":{}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1n"}}}},"UpdateTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet","scale"],"members":{"cluster":{},"service":{},"taskSet":{},"scale":{"shape":"S1p"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1n"}}}}},"shapes":{"S3":{"type":"structure","required":["autoScalingGroupArn"],"members":{"autoScalingGroupArn":{},"managedScaling":{"type":"structure","members":{"status":{},"targetCapacity":{"type":"integer"},"minimumScalingStepSize":{"type":"integer"},"maximumScalingStepSize":{"type":"integer"}}},"managedTerminationProtection":{}}},"S9":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Se":{"type":"structure","members":{"capacityProviderArn":{},"name":{},"status":{},"autoScalingGroupProvider":{"shape":"S3"},"updateStatus":{},"updateStatusReason":{},"tags":{"shape":"S9"}}},"Si":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"Sl":{"type":"list","member":{}},"Sm":{"type":"list","member":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{},"weight":{"type":"integer"},"base":{"type":"integer"}}}},"Sr":{"type":"structure","members":{"clusterArn":{},"clusterName":{},"status":{},"registeredContainerInstancesCount":{"type":"integer"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"activeServicesCount":{"type":"integer"},"statistics":{"type":"list","member":{"shape":"Su"}},"tags":{"shape":"S9"},"settings":{"shape":"Si"},"capacityProviders":{"shape":"Sl"},"defaultCapacityProviderStrategy":{"shape":"Sm"},"attachments":{"shape":"Sv"},"attachmentsStatus":{}}},"Su":{"type":"structure","members":{"name":{},"value":{}}},"Sv":{"type":"list","member":{"type":"structure","members":{"id":{},"type":{},"status":{},"details":{"type":"list","member":{"shape":"Su"}}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"targetGroupArn":{},"loadBalancerName":{},"containerName":{},"containerPort":{"type":"integer"}}}},"S12":{"type":"list","member":{"type":"structure","members":{"registryArn":{},"port":{"type":"integer"},"containerName":{},"containerPort":{"type":"integer"}}}},"S15":{"type":"structure","members":{"maximumPercent":{"type":"integer"},"minimumHealthyPercent":{"type":"integer"}}},"S16":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S19":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"S1c":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"Sl"},"securityGroups":{"shape":"Sl"},"assignPublicIp":{}}}}},"S1g":{"type":"structure","required":["type"],"members":{"type":{}}},"S1l":{"type":"structure","members":{"serviceArn":{},"serviceName":{},"clusterArn":{},"loadBalancers":{"shape":"Sz"},"serviceRegistries":{"shape":"S12"},"status":{},"desiredCount":{"type":"integer"},"runningCount":{"type":"integer"},"pendingCount":{"type":"integer"},"launchType":{},"capacityProviderStrategy":{"shape":"Sm"},"platformVersion":{},"taskDefinition":{},"deploymentConfiguration":{"shape":"S15"},"taskSets":{"shape":"S1m"},"deployments":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"taskDefinition":{},"desiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"capacityProviderStrategy":{"shape":"Sm"},"launchType":{},"platformVersion":{},"networkConfiguration":{"shape":"S1c"}}}},"roleArn":{},"events":{"type":"list","member":{"type":"structure","members":{"id":{},"createdAt":{"type":"timestamp"},"message":{}}}},"createdAt":{"type":"timestamp"},"placementConstraints":{"shape":"S16"},"placementStrategy":{"shape":"S19"},"networkConfiguration":{"shape":"S1c"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"S1g"},"tags":{"shape":"S9"},"createdBy":{},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{}}},"S1m":{"type":"list","member":{"shape":"S1n"}},"S1n":{"type":"structure","members":{"id":{},"taskSetArn":{},"serviceArn":{},"clusterArn":{},"startedBy":{},"externalId":{},"status":{},"taskDefinition":{},"computedDesiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"launchType":{},"capacityProviderStrategy":{"shape":"Sm"},"platformVersion":{},"networkConfiguration":{"shape":"S1c"},"loadBalancers":{"shape":"Sz"},"serviceRegistries":{"shape":"S12"},"scale":{"shape":"S1p"},"stabilityStatus":{},"stabilityStatusAt":{"type":"timestamp"},"tags":{"shape":"S9"}}},"S1p":{"type":"structure","members":{"value":{"type":"double"},"unit":{}}},"S22":{"type":"structure","members":{"name":{},"value":{},"principalArn":{}}},"S24":{"type":"list","member":{"shape":"S25"}},"S25":{"type":"structure","required":["name"],"members":{"name":{},"value":{},"targetType":{},"targetId":{}}},"S2j":{"type":"structure","members":{"containerInstanceArn":{},"ec2InstanceId":{},"capacityProviderName":{},"version":{"type":"long"},"versionInfo":{"shape":"S2l"},"remainingResources":{"shape":"S2m"},"registeredResources":{"shape":"S2m"},"status":{},"statusReason":{},"agentConnected":{"type":"boolean"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"agentUpdateStatus":{},"attributes":{"shape":"S24"},"registeredAt":{"type":"timestamp"},"attachments":{"shape":"Sv"},"tags":{"shape":"S9"}}},"S2l":{"type":"structure","members":{"agentVersion":{},"agentHash":{},"dockerVersion":{}}},"S2m":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"integerValue":{"type":"integer"},"stringSetValue":{"shape":"Sl"}}}},"S2r":{"type":"structure","members":{"taskDefinitionArn":{},"containerDefinitions":{"shape":"S2s"},"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"revision":{"type":"integer"},"volumes":{"shape":"S42"},"status":{},"requiresAttributes":{"type":"list","member":{"shape":"S25"}},"placementConstraints":{"shape":"S4e"},"compatibilities":{"shape":"S4h"},"requiresCompatibilities":{"shape":"S4h"},"cpu":{},"memory":{},"inferenceAccelerators":{"shape":"S4j"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S4n"}}},"S2s":{"type":"list","member":{"type":"structure","members":{"name":{},"image":{},"repositoryCredentials":{"type":"structure","required":["credentialsParameter"],"members":{"credentialsParameter":{}}},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"links":{"shape":"Sl"},"portMappings":{"type":"list","member":{"type":"structure","members":{"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"essential":{"type":"boolean"},"entryPoint":{"shape":"Sl"},"command":{"shape":"Sl"},"environment":{"shape":"S2y"},"environmentFiles":{"shape":"S2z"},"mountPoints":{"type":"list","member":{"type":"structure","members":{"sourceVolume":{},"containerPath":{},"readOnly":{"type":"boolean"}}}},"volumesFrom":{"type":"list","member":{"type":"structure","members":{"sourceContainer":{},"readOnly":{"type":"boolean"}}}},"linuxParameters":{"type":"structure","members":{"capabilities":{"type":"structure","members":{"add":{"shape":"Sl"},"drop":{"shape":"Sl"}}},"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}},"initProcessEnabled":{"type":"boolean"},"sharedMemorySize":{"type":"integer"},"tmpfs":{"type":"list","member":{"type":"structure","required":["containerPath","size"],"members":{"containerPath":{},"size":{"type":"integer"},"mountOptions":{"shape":"Sl"}}}},"maxSwap":{"type":"integer"},"swappiness":{"type":"integer"}}},"secrets":{"shape":"S3e"},"dependsOn":{"type":"list","member":{"type":"structure","required":["containerName","condition"],"members":{"containerName":{},"condition":{}}}},"startTimeout":{"type":"integer"},"stopTimeout":{"type":"integer"},"hostname":{},"user":{},"workingDirectory":{},"disableNetworking":{"type":"boolean"},"privileged":{"type":"boolean"},"readonlyRootFilesystem":{"type":"boolean"},"dnsServers":{"shape":"Sl"},"dnsSearchDomains":{"shape":"Sl"},"extraHosts":{"type":"list","member":{"type":"structure","required":["hostname","ipAddress"],"members":{"hostname":{},"ipAddress":{}}}},"dockerSecurityOptions":{"shape":"Sl"},"interactive":{"type":"boolean"},"pseudoTerminal":{"type":"boolean"},"dockerLabels":{"type":"map","key":{},"value":{}},"ulimits":{"type":"list","member":{"type":"structure","required":["name","softLimit","hardLimit"],"members":{"name":{},"softLimit":{"type":"integer"},"hardLimit":{"type":"integer"}}}},"logConfiguration":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}},"secretOptions":{"shape":"S3e"}}},"healthCheck":{"type":"structure","required":["command"],"members":{"command":{"shape":"Sl"},"interval":{"type":"integer"},"timeout":{"type":"integer"},"retries":{"type":"integer"},"startPeriod":{"type":"integer"}}},"systemControls":{"type":"list","member":{"type":"structure","members":{"namespace":{},"value":{}}}},"resourceRequirements":{"shape":"S3v"},"firelensConfiguration":{"type":"structure","required":["type"],"members":{"type":{},"options":{"type":"map","key":{},"value":{}}}}}}},"S2y":{"type":"list","member":{"shape":"Su"}},"S2z":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S3e":{"type":"list","member":{"type":"structure","required":["name","valueFrom"],"members":{"name":{},"valueFrom":{}}}},"S3v":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S42":{"type":"list","member":{"type":"structure","members":{"name":{},"host":{"type":"structure","members":{"sourcePath":{}}},"dockerVolumeConfiguration":{"type":"structure","members":{"scope":{},"autoprovision":{"type":"boolean"},"driver":{},"driverOpts":{"shape":"S47"},"labels":{"shape":"S47"}}},"efsVolumeConfiguration":{"type":"structure","required":["fileSystemId"],"members":{"fileSystemId":{},"rootDirectory":{},"transitEncryption":{},"transitEncryptionPort":{"type":"integer"},"authorizationConfig":{"type":"structure","members":{"accessPointId":{},"iam":{}}}}}}}},"S47":{"type":"map","key":{},"value":{}},"S4e":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S4h":{"type":"list","member":{}},"S4j":{"type":"list","member":{"type":"structure","required":["deviceName","deviceType"],"members":{"deviceName":{},"deviceType":{}}}},"S4n":{"type":"structure","required":["containerName"],"members":{"type":{},"containerName":{},"properties":{"type":"list","member":{"shape":"Su"}}}},"S4v":{"type":"list","member":{"type":"structure","members":{"arn":{},"reason":{},"detail":{}}}},"S56":{"type":"list","member":{"shape":"S2j"}},"S5o":{"type":"list","member":{"shape":"S5p"}},"S5p":{"type":"structure","members":{"attachments":{"shape":"Sv"},"attributes":{"shape":"S24"},"availabilityZone":{},"capacityProviderName":{},"clusterArn":{},"connectivity":{},"connectivityAt":{"type":"timestamp"},"containerInstanceArn":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerArn":{},"taskArn":{},"name":{},"image":{},"imageDigest":{},"runtimeId":{},"lastStatus":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S5t"},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"privateIpv4Address":{},"ipv6Address":{}}}},"healthStatus":{},"cpu":{},"memory":{},"memoryReservation":{},"gpuIds":{"type":"list","member":{}}}}},"cpu":{},"createdAt":{"type":"timestamp"},"desiredStatus":{},"executionStoppedAt":{"type":"timestamp"},"group":{},"healthStatus":{},"inferenceAccelerators":{"shape":"S4j"},"lastStatus":{},"launchType":{},"memory":{},"overrides":{"shape":"S5z"},"platformVersion":{},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"startedBy":{},"stopCode":{},"stoppedAt":{"type":"timestamp"},"stoppedReason":{},"stoppingAt":{"type":"timestamp"},"tags":{"shape":"S9"},"taskArn":{},"taskDefinitionArn":{},"version":{"type":"long"}}},"S5t":{"type":"list","member":{"type":"structure","members":{"bindIP":{},"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"S5z":{"type":"structure","members":{"containerOverrides":{"type":"list","member":{"type":"structure","members":{"name":{},"command":{"shape":"Sl"},"environment":{"shape":"S2y"},"environmentFiles":{"shape":"S2z"},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"resourceRequirements":{"shape":"S3v"}}}},"cpu":{},"inferenceAcceleratorOverrides":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"deviceType":{}}}},"executionRoleArn":{},"memory":{},"taskRoleArn":{}}},"S7g":{"type":"list","member":{"type":"structure","required":["attachmentArn","status"],"members":{"attachmentArn":{},"status":{}}}}}}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAccountSettings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"settings"},"ListAttributes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"attributes"},"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusterArns"},"ListContainerInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"containerInstanceArns"},"ListServices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListTaskDefinitionFamilies":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"families"},"ListTaskDefinitions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskDefinitionArns"},"ListTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskArns"}}}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TasksRunning":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAny","state":"failure","argument":"tasks[].lastStatus"},{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"RUNNING","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"TasksStopped":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"ServicesStable":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"DRAINING","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":"INACTIVE","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":true,"matcher":"path","state":"success","argument":"length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"}]},"ServicesInactive":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"INACTIVE","matcher":"pathAny","state":"success","argument":"services[].status"}]}}}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-02","endpointPrefix":"elasticache","protocol":"query","serviceFullName":"Amazon ElastiCache","serviceId":"ElastiCache","signatureVersion":"v4","uid":"elasticache-2015-02-02","xmlNamespace":"http://elasticache.amazonaws.com/doc/2015-02-02/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}},"output":{"shape":"S5","resultWrapper":"AddTagsToResourceResult"}},"AuthorizeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"BatchApplyUpdateAction":{"input":{"type":"structure","required":["ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"ServiceUpdateName":{}}},"output":{"shape":"Se","resultWrapper":"BatchApplyUpdateActionResult"}},"BatchStopUpdateAction":{"input":{"type":"structure","required":["ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"ServiceUpdateName":{}}},"output":{"shape":"Se","resultWrapper":"BatchStopUpdateActionResult"}},"CompleteMigration":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"CompleteMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{},"KmsKeyId":{}}},"output":{"resultWrapper":"CopySnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1a"}}}},"CreateCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"ReplicationGroupId":{},"AZMode":{},"PreferredAvailabilityZone":{},"PreferredAvailabilityZones":{"shape":"S1i"},"NumCacheNodes":{"type":"integer"},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"S1j"},"SecurityGroupIds":{"shape":"S1k"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S1l"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{}}},"output":{"resultWrapper":"CreateCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S1n"}}}},"CreateCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","CacheParameterGroupFamily","Description"],"members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheParameterGroupResult","type":"structure","members":{"CacheParameterGroup":{"shape":"S20"}}}},"CreateCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName","Description"],"members":{"CacheSecurityGroupName":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheSecurityGroupResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CreateCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName","CacheSubnetGroupDescription","SubnetIds"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S24"}}},"output":{"resultWrapper":"CreateCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S26"}}}},"CreateGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupIdSuffix","PrimaryReplicationGroupId"],"members":{"GlobalReplicationGroupIdSuffix":{},"GlobalReplicationGroupDescription":{},"PrimaryReplicationGroupId":{}}},"output":{"resultWrapper":"CreateGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"CreateReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId","ReplicationGroupDescription"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"GlobalReplicationGroupId":{},"PrimaryClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"MultiAZEnabled":{"type":"boolean"},"NumCacheClusters":{"type":"integer"},"PreferredCacheClusterAZs":{"shape":"S1f"},"NumNodeGroups":{"type":"integer"},"ReplicasPerNodeGroup":{"type":"integer"},"NodeGroupConfiguration":{"type":"list","member":{"shape":"S1d","locationName":"NodeGroupConfiguration"}},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"S1j"},"SecurityGroupIds":{"shape":"S1k"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S1l"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"KmsKeyId":{}}},"output":{"resultWrapper":"CreateReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"KmsKeyId":{}}},"output":{"resultWrapper":"CreateSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1a"}}}},"DecreaseNodeGroupsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"GlobalNodeGroupsToRemove":{"shape":"S2n"},"GlobalNodeGroupsToRetain":{"shape":"S2n"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseNodeGroupsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"DecreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S2q"},"ReplicasToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"DeleteCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S1n"}}}},"DeleteCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{}}}},"DeleteCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName"],"members":{"CacheSecurityGroupName":{}}}},"DeleteCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{}}}},"DeleteGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","RetainPrimaryReplicationGroup"],"members":{"GlobalReplicationGroupId":{},"RetainPrimaryReplicationGroup":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"DeleteReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"RetainPrimaryCluster":{"type":"boolean"},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"resultWrapper":"DeleteSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1a"}}}},"DescribeCacheClusters":{"input":{"type":"structure","members":{"CacheClusterId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowCacheNodeInfo":{"type":"boolean"},"ShowCacheClustersNotInReplicationGroups":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheClustersResult","type":"structure","members":{"Marker":{},"CacheClusters":{"type":"list","member":{"shape":"S1n","locationName":"CacheCluster"}}}}},"DescribeCacheEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheEngineVersionsResult","type":"structure","members":{"Marker":{},"CacheEngineVersions":{"type":"list","member":{"locationName":"CacheEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"CacheEngineDescription":{},"CacheEngineVersionDescription":{}}}}}}},"DescribeCacheParameterGroups":{"input":{"type":"structure","members":{"CacheParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParameterGroupsResult","type":"structure","members":{"Marker":{},"CacheParameterGroups":{"type":"list","member":{"shape":"S20","locationName":"CacheParameterGroup"}}}}},"DescribeCacheParameters":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParametersResult","type":"structure","members":{"Marker":{},"Parameters":{"shape":"S3h"},"CacheNodeTypeSpecificParameters":{"shape":"S3k"}}}},"DescribeCacheSecurityGroups":{"input":{"type":"structure","members":{"CacheSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSecurityGroupsResult","type":"structure","members":{"Marker":{},"CacheSecurityGroups":{"type":"list","member":{"shape":"S8","locationName":"CacheSecurityGroup"}}}}},"DescribeCacheSubnetGroups":{"input":{"type":"structure","members":{"CacheSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSubnetGroupsResult","type":"structure","members":{"Marker":{},"CacheSubnetGroups":{"type":"list","member":{"shape":"S26","locationName":"CacheSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["CacheParameterGroupFamily"],"members":{"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"CacheParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S3h"},"CacheNodeTypeSpecificParameters":{"shape":"S3k"}},"wrapper":true}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeGlobalReplicationGroups":{"input":{"type":"structure","members":{"GlobalReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowMemberInfo":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeGlobalReplicationGroupsResult","type":"structure","members":{"Marker":{},"GlobalReplicationGroups":{"type":"list","member":{"shape":"S2c","locationName":"GlobalReplicationGroup"}}}}},"DescribeReplicationGroups":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReplicationGroupsResult","type":"structure","members":{"Marker":{},"ReplicationGroups":{"type":"list","member":{"shape":"So","locationName":"ReplicationGroup"}}}}},"DescribeReservedCacheNodes":{"input":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesResult","type":"structure","members":{"Marker":{},"ReservedCacheNodes":{"type":"list","member":{"shape":"S4b","locationName":"ReservedCacheNode"}}}}},"DescribeReservedCacheNodesOfferings":{"input":{"type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedCacheNodesOfferings":{"type":"list","member":{"locationName":"ReservedCacheNodesOffering","type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"ProductDescription":{},"OfferingType":{},"RecurringCharges":{"shape":"S4c"}},"wrapper":true}}}}},"DescribeServiceUpdates":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateStatus":{"shape":"S4j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeServiceUpdatesResult","type":"structure","members":{"Marker":{},"ServiceUpdates":{"type":"list","member":{"locationName":"ServiceUpdate","type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateEndDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateStatus":{},"ServiceUpdateDescription":{},"ServiceUpdateType":{},"Engine":{},"EngineVersion":{},"AutoUpdateAfterRecommendedApplyByDate":{"type":"boolean"},"EstimatedUpdateTime":{}}}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"SnapshotSource":{},"Marker":{},"MaxRecords":{"type":"integer"},"ShowNodeGroupConfig":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"S1a","locationName":"Snapshot"}}}}},"DescribeUpdateActions":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"Engine":{},"ServiceUpdateStatus":{"shape":"S4j"},"ServiceUpdateTimeRange":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"UpdateActionStatus":{"type":"list","member":{}},"ShowNodeLevelUpdateStatus":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUpdateActionsResult","type":"structure","members":{"Marker":{},"UpdateActions":{"type":"list","member":{"locationName":"UpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateStatus":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateType":{},"UpdateActionAvailableDate":{"type":"timestamp"},"UpdateActionStatus":{},"NodesUpdated":{},"UpdateActionStatusModifiedDate":{"type":"timestamp"},"SlaMet":{},"NodeGroupUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupUpdateStatus","type":"structure","members":{"NodeGroupId":{},"NodeGroupMemberUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupMemberUpdateStatus","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}}}}},"CacheNodeUpdateStatus":{"type":"list","member":{"locationName":"CacheNodeUpdateStatus","type":"structure","members":{"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}},"EstimatedUpdateTime":{},"Engine":{}}}}}}},"DisassociateGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ReplicationGroupId","ReplicationGroupRegion"],"members":{"GlobalReplicationGroupId":{},"ReplicationGroupId":{},"ReplicationGroupRegion":{}}},"output":{"resultWrapper":"DisassociateGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"FailoverGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","PrimaryRegion","PrimaryReplicationGroupId"],"members":{"GlobalReplicationGroupId":{},"PrimaryRegion":{},"PrimaryReplicationGroupId":{}}},"output":{"resultWrapper":"FailoverGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"IncreaseNodeGroupsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"RegionalConfigurations":{"type":"list","member":{"locationName":"RegionalConfiguration","type":"structure","required":["ReplicationGroupId","ReplicationGroupRegion","ReshardingConfiguration"],"members":{"ReplicationGroupId":{},"ReplicationGroupRegion":{},"ReshardingConfiguration":{"shape":"S5f"}}}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseNodeGroupsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"IncreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S2q"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ListAllowedNodeTypeModifications":{"input":{"type":"structure","members":{"CacheClusterId":{},"ReplicationGroupId":{}}},"output":{"resultWrapper":"ListAllowedNodeTypeModificationsResult","type":"structure","members":{"ScaleUpModifications":{"shape":"S5m"},"ScaleDownModifications":{"shape":"S5m"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"shape":"S5","resultWrapper":"ListTagsForResourceResult"}},"ModifyCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S1p"},"AZMode":{},"NewAvailabilityZones":{"shape":"S1i"},"CacheSecurityGroupNames":{"shape":"S1j"},"SecurityGroupIds":{"shape":"S1k"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"AuthToken":{},"AuthTokenUpdateStrategy":{}}},"output":{"resultWrapper":"ModifyCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S1n"}}}},"ModifyCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","ParameterNameValues"],"members":{"CacheParameterGroupName":{},"ParameterNameValues":{"shape":"S5s"}}},"output":{"shape":"S5u","resultWrapper":"ModifyCacheParameterGroupResult"}},"ModifyCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S24"}}},"output":{"resultWrapper":"ModifyCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S26"}}}},"ModifyGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"ApplyImmediately":{"type":"boolean"},"CacheNodeType":{},"EngineVersion":{},"GlobalReplicationGroupDescription":{},"AutomaticFailoverEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"ModifyReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"SnapshottingClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"MultiAZEnabled":{"type":"boolean"},"NodeGroupId":{"deprecated":true},"CacheSecurityGroupNames":{"shape":"S1j"},"SecurityGroupIds":{"shape":"S1k"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"AuthToken":{},"AuthTokenUpdateStrategy":{}}},"output":{"resultWrapper":"ModifyReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ModifyReplicationGroupShardConfiguration":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReshardingConfiguration":{"shape":"S5f"},"NodeGroupsToRemove":{"type":"list","member":{"locationName":"NodeGroupToRemove"}},"NodeGroupsToRetain":{"type":"list","member":{"locationName":"NodeGroupToRetain"}}}},"output":{"resultWrapper":"ModifyReplicationGroupShardConfigurationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"PurchaseReservedCacheNodesOffering":{"input":{"type":"structure","required":["ReservedCacheNodesOfferingId"],"members":{"ReservedCacheNodesOfferingId":{},"ReservedCacheNodeId":{},"CacheNodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedCacheNodesOfferingResult","type":"structure","members":{"ReservedCacheNode":{"shape":"S4b"}}}},"RebalanceSlotsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"RebalanceSlotsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2c"}}}},"RebootCacheCluster":{"input":{"type":"structure","required":["CacheClusterId","CacheNodeIdsToReboot"],"members":{"CacheClusterId":{},"CacheNodeIdsToReboot":{"shape":"S1p"}}},"output":{"resultWrapper":"RebootCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S1n"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"shape":"S5","resultWrapper":"RemoveTagsFromResourceResult"}},"ResetCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"ParameterNameValues":{"shape":"S5s"}}},"output":{"shape":"S5u","resultWrapper":"ResetCacheParameterGroupResult"}},"RevokeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"StartMigration":{"input":{"type":"structure","required":["ReplicationGroupId","CustomerNodeEndpointList"],"members":{"ReplicationGroupId":{},"CustomerNodeEndpointList":{"type":"list","member":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}}}}},"output":{"resultWrapper":"StartMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"TestFailover":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupId"],"members":{"ReplicationGroupId":{},"NodeGroupId":{}}},"output":{"resultWrapper":"TestFailoverResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S5":{"type":"structure","members":{"TagList":{"shape":"S3"}}},"S8":{"type":"structure","members":{"OwnerId":{},"CacheSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}}},"ARN":{}},"wrapper":true},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Se":{"type":"structure","members":{"ProcessedUpdateActions":{"type":"list","member":{"locationName":"ProcessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"UpdateActionStatus":{}}}},"UnprocessedUpdateActions":{"type":"list","member":{"locationName":"UnprocessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"ErrorType":{},"ErrorMessage":{}}}}}},"So":{"type":"structure","members":{"ReplicationGroupId":{},"Description":{},"GlobalReplicationGroupInfo":{"type":"structure","members":{"GlobalReplicationGroupId":{},"GlobalReplicationGroupMemberRole":{}}},"Status":{},"PendingModifiedValues":{"type":"structure","members":{"PrimaryClusterId":{},"AutomaticFailoverStatus":{},"Resharding":{"type":"structure","members":{"SlotMigration":{"type":"structure","members":{"ProgressPercentage":{"type":"double"}}}}},"AuthTokenStatus":{}}},"MemberClusters":{"type":"list","member":{"locationName":"ClusterId"}},"NodeGroups":{"type":"list","member":{"locationName":"NodeGroup","type":"structure","members":{"NodeGroupId":{},"Status":{},"PrimaryEndpoint":{"shape":"Sz"},"ReaderEndpoint":{"shape":"Sz"},"Slots":{},"NodeGroupMembers":{"type":"list","member":{"locationName":"NodeGroupMember","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"ReadEndpoint":{"shape":"Sz"},"PreferredAvailabilityZone":{},"CurrentRole":{}}}}}}},"SnapshottingClusterId":{},"AutomaticFailover":{},"MultiAZ":{},"ConfigurationEndpoint":{"shape":"Sz"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"ClusterEnabled":{"type":"boolean"},"CacheNodeType":{},"AuthTokenEnabled":{"type":"boolean"},"AuthTokenLastModifiedDate":{"type":"timestamp"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"KmsKeyId":{},"ARN":{}},"wrapper":true},"Sz":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"S1a":{"type":"structure","members":{"SnapshotName":{},"ReplicationGroupId":{},"ReplicationGroupDescription":{},"CacheClusterId":{},"SnapshotStatus":{},"SnapshotSource":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"VpcId":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumNodeGroups":{"type":"integer"},"AutomaticFailover":{},"NodeSnapshots":{"type":"list","member":{"locationName":"NodeSnapshot","type":"structure","members":{"CacheClusterId":{},"NodeGroupId":{},"CacheNodeId":{},"NodeGroupConfiguration":{"shape":"S1d"},"CacheSize":{},"CacheNodeCreateTime":{"type":"timestamp"},"SnapshotCreateTime":{"type":"timestamp"}},"wrapper":true}},"KmsKeyId":{},"ARN":{}},"wrapper":true},"S1d":{"type":"structure","members":{"NodeGroupId":{},"Slots":{},"ReplicaCount":{"type":"integer"},"PrimaryAvailabilityZone":{},"ReplicaAvailabilityZones":{"shape":"S1f"}}},"S1f":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S1i":{"type":"list","member":{"locationName":"PreferredAvailabilityZone"}},"S1j":{"type":"list","member":{"locationName":"CacheSecurityGroupName"}},"S1k":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S1l":{"type":"list","member":{"locationName":"SnapshotArn"}},"S1n":{"type":"structure","members":{"CacheClusterId":{},"ConfigurationEndpoint":{"shape":"Sz"},"ClientDownloadLandingPage":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheClusterStatus":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S1p"},"EngineVersion":{},"CacheNodeType":{},"AuthTokenStatus":{}}},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"CacheSecurityGroups":{"type":"list","member":{"locationName":"CacheSecurityGroup","type":"structure","members":{"CacheSecurityGroupName":{},"Status":{}}}},"CacheParameterGroup":{"type":"structure","members":{"CacheParameterGroupName":{},"ParameterApplyStatus":{},"CacheNodeIdsToReboot":{"shape":"S1p"}}},"CacheSubnetGroupName":{},"CacheNodes":{"type":"list","member":{"locationName":"CacheNode","type":"structure","members":{"CacheNodeId":{},"CacheNodeStatus":{},"CacheNodeCreateTime":{"type":"timestamp"},"Endpoint":{"shape":"Sz"},"ParameterGroupStatus":{},"SourceCacheNodeId":{},"CustomerAvailabilityZone":{}}}},"AutoMinorVersionUpgrade":{"type":"boolean"},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"ReplicationGroupId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthTokenEnabled":{"type":"boolean"},"AuthTokenLastModifiedDate":{"type":"timestamp"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"ARN":{}},"wrapper":true},"S1p":{"type":"list","member":{"locationName":"CacheNodeId"}},"S20":{"type":"structure","members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{},"IsGlobal":{"type":"boolean"},"ARN":{}},"wrapper":true},"S24":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S26":{"type":"structure","members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"VpcId":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}},"wrapper":true}}}},"ARN":{}},"wrapper":true},"S2c":{"type":"structure","members":{"GlobalReplicationGroupId":{},"GlobalReplicationGroupDescription":{},"Status":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"Members":{"type":"list","member":{"locationName":"GlobalReplicationGroupMember","type":"structure","members":{"ReplicationGroupId":{},"ReplicationGroupRegion":{},"Role":{},"AutomaticFailover":{},"Status":{}},"wrapper":true}},"ClusterEnabled":{"type":"boolean"},"GlobalNodeGroups":{"type":"list","member":{"locationName":"GlobalNodeGroup","type":"structure","members":{"GlobalNodeGroupId":{},"Slots":{}}}},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"ARN":{}},"wrapper":true},"S2n":{"type":"list","member":{"locationName":"GlobalNodeGroupId"}},"S2q":{"type":"list","member":{"locationName":"ConfigureShard","type":"structure","required":["NodeGroupId","NewReplicaCount"],"members":{"NodeGroupId":{},"NewReplicaCount":{"type":"integer"},"PreferredAvailabilityZones":{"shape":"S1i"}}}},"S3h":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ChangeType":{}}}},"S3k":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificParameter","type":"structure","members":{"ParameterName":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"CacheNodeTypeSpecificValues":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificValue","type":"structure","members":{"CacheNodeType":{},"Value":{}}}},"ChangeType":{}}}},"S4b":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CacheNodeCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"State":{},"RecurringCharges":{"shape":"S4c"},"ReservationARN":{}},"wrapper":true},"S4c":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4j":{"type":"list","member":{}},"S5f":{"type":"list","member":{"locationName":"ReshardingConfiguration","type":"structure","members":{"NodeGroupId":{},"PreferredAvailabilityZones":{"shape":"S1f"}}}},"S5m":{"type":"list","member":{}},"S5s":{"type":"list","member":{"locationName":"ParameterNameValue","type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"S5u":{"type":"structure","members":{"CacheParameterGroupName":{}}}}}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCacheClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheClusters"},"DescribeCacheEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheEngineVersions"},"DescribeCacheParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheParameterGroups"},"DescribeCacheParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeCacheSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSecurityGroups"},"DescribeCacheSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeGlobalReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalReplicationGroups"},"DescribeReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReplicationGroups"},"DescribeReservedCacheNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodes"},"DescribeReservedCacheNodesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodesOfferings"},"DescribeServiceUpdates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ServiceUpdates"},"DescribeSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeUpdateActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UpdateActions"}}}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CacheClusterAvailable":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is available.","maxAttempts":40,"operation":"DescribeCacheClusters"},"CacheClusterDeleted":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAll","state":"success"},{"expected":"CacheClusterNotFound","matcher":"error","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"snapshotting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is deleted.","maxAttempts":40,"operation":"DescribeCacheClusters"},"ReplicationGroupAvailable":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache replication group is available.","maxAttempts":40,"operation":"DescribeReplicationGroups"},"ReplicationGroupDeleted":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ReplicationGroupNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until ElastiCache replication group is deleted.","maxAttempts":40,"operation":"DescribeReplicationGroups"}}}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"elasticbeanstalk","protocol":"query","serviceAbbreviation":"Elastic Beanstalk","serviceFullName":"AWS Elastic Beanstalk","serviceId":"Elastic Beanstalk","signatureVersion":"v4","uid":"elasticbeanstalk-2010-12-01","xmlNamespace":"http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"},"operations":{"AbortEnvironmentUpdate":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"ApplyEnvironmentManagedAction":{"input":{"type":"structure","required":["ActionId"],"members":{"EnvironmentName":{},"EnvironmentId":{},"ActionId":{}}},"output":{"resultWrapper":"ApplyEnvironmentManagedActionResult","type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{}}}},"AssociateEnvironmentOperationsRole":{"input":{"type":"structure","required":["EnvironmentName","OperationsRole"],"members":{"EnvironmentName":{},"OperationsRole":{}}}},"CheckDNSAvailability":{"input":{"type":"structure","required":["CNAMEPrefix"],"members":{"CNAMEPrefix":{}}},"output":{"resultWrapper":"CheckDNSAvailabilityResult","type":"structure","members":{"Available":{"type":"boolean"},"FullyQualifiedCNAME":{}}}},"ComposeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"GroupName":{},"VersionLabels":{"type":"list","member":{}}}},"output":{"shape":"Sk","resultWrapper":"ComposeEnvironmentsResult"}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{},"ResourceLifecycleConfig":{"shape":"S19"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S1j","resultWrapper":"CreateApplicationResult"}},"CreateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{},"SourceBuildInformation":{"shape":"S1p"},"SourceBundle":{"shape":"S1t"},"BuildConfiguration":{"type":"structure","required":["CodeBuildServiceRole","Image"],"members":{"ArtifactName":{},"CodeBuildServiceRole":{},"ComputeType":{},"Image":{},"TimeoutInMinutes":{"type":"integer"}}},"AutoCreateApplication":{"type":"boolean"},"Process":{"type":"boolean"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S21","resultWrapper":"CreateApplicationVersionResult"}},"CreateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"SourceConfiguration":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{}}},"EnvironmentId":{},"Description":{},"OptionSettings":{"shape":"S27"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S2d","resultWrapper":"CreateConfigurationTemplateResult"}},"CreateEnvironment":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"EnvironmentName":{},"GroupName":{},"Description":{},"CNAMEPrefix":{},"Tier":{"shape":"S13"},"Tags":{"shape":"S1f"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"},"OperationsRole":{}}},"output":{"shape":"Sm","resultWrapper":"CreateEnvironmentResult"}},"CreatePlatformVersion":{"input":{"type":"structure","required":["PlatformName","PlatformVersion","PlatformDefinitionBundle"],"members":{"PlatformName":{},"PlatformVersion":{},"PlatformDefinitionBundle":{"shape":"S1t"},"EnvironmentName":{},"OptionSettings":{"shape":"S27"},"Tags":{"shape":"S1f"}}},"output":{"resultWrapper":"CreatePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2m"},"Builder":{"type":"structure","members":{"ARN":{}}}}}},"CreateStorageLocation":{"output":{"resultWrapper":"CreateStorageLocationResult","type":"structure","members":{"S3Bucket":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TerminateEnvByForce":{"type":"boolean"}}}},"DeleteApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"DeleteSourceBundle":{"type":"boolean"}}}},"DeleteConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{}}}},"DeleteEnvironmentConfiguration":{"input":{"type":"structure","required":["ApplicationName","EnvironmentName"],"members":{"ApplicationName":{},"EnvironmentName":{}}}},"DeletePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DeletePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2m"}}}},"DescribeAccountAttributes":{"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"ResourceQuotas":{"type":"structure","members":{"ApplicationQuota":{"shape":"S3c"},"ApplicationVersionQuota":{"shape":"S3c"},"EnvironmentQuota":{"shape":"S3c"},"ConfigurationTemplateQuota":{"shape":"S3c"},"CustomPlatformQuota":{"shape":"S3c"}}}}}},"DescribeApplicationVersions":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabels":{"shape":"S1m"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeApplicationVersionsResult","type":"structure","members":{"ApplicationVersions":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"ApplicationNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeApplicationsResult","type":"structure","members":{"Applications":{"type":"list","member":{"shape":"S1k"}}}}},"DescribeConfigurationOptions":{"input":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"SolutionStackName":{},"PlatformArn":{},"Options":{"shape":"S2g"}}},"output":{"resultWrapper":"DescribeConfigurationOptionsResult","type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"Options":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Name":{},"DefaultValue":{},"ChangeSeverity":{},"UserDefined":{"type":"boolean"},"ValueType":{},"ValueOptions":{"type":"list","member":{}},"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"MaxLength":{"type":"integer"},"Regex":{"type":"structure","members":{"Pattern":{},"Label":{}}}}}}}}},"DescribeConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeConfigurationSettingsResult","type":"structure","members":{"ConfigurationSettings":{"type":"list","member":{"shape":"S2d"}}}}},"DescribeEnvironmentHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeEnvironmentHealthResult","type":"structure","members":{"EnvironmentName":{},"HealthStatus":{},"Status":{},"Color":{},"Causes":{"shape":"S48"},"ApplicationMetrics":{"shape":"S4a"},"InstancesHealth":{"type":"structure","members":{"NoData":{"type":"integer"},"Unknown":{"type":"integer"},"Pending":{"type":"integer"},"Ok":{"type":"integer"},"Info":{"type":"integer"},"Warning":{"type":"integer"},"Degraded":{"type":"integer"},"Severe":{"type":"integer"}}},"RefreshedAt":{"type":"timestamp"}}}},"DescribeEnvironmentManagedActionHistory":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionHistoryResult","type":"structure","members":{"ManagedActionHistoryItems":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionType":{},"ActionDescription":{},"FailureType":{},"Status":{},"FailureDescription":{},"ExecutedTime":{"type":"timestamp"},"FinishedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEnvironmentManagedActions":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"Status":{}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionsResult","type":"structure","members":{"ManagedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{},"WindowStartTime":{"type":"timestamp"}}}}}}},"DescribeEnvironmentResources":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeEnvironmentResourcesResult","type":"structure","members":{"EnvironmentResources":{"type":"structure","members":{"EnvironmentName":{},"AutoScalingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"LaunchTemplates":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Triggers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Queues":{"type":"list","member":{"type":"structure","members":{"Name":{},"URL":{}}}}}}}}},"DescribeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"EnvironmentIds":{"type":"list","member":{}},"EnvironmentNames":{"type":"list","member":{}},"IncludeDeleted":{"type":"boolean"},"IncludedDeletedBackTo":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"shape":"Sk","resultWrapper":"DescribeEnvironmentsResult"}},"DescribeEvents":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentId":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventDate":{"type":"timestamp"},"Message":{},"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{}}}},"NextToken":{}}}},"DescribeInstancesHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"resultWrapper":"DescribeInstancesHealthResult","type":"structure","members":{"InstanceHealthList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"HealthStatus":{},"Color":{},"Causes":{"shape":"S48"},"LaunchedAt":{"type":"timestamp"},"ApplicationMetrics":{"shape":"S4a"},"System":{"type":"structure","members":{"CPUUtilization":{"type":"structure","members":{"User":{"type":"double"},"Nice":{"type":"double"},"System":{"type":"double"},"Idle":{"type":"double"},"IOWait":{"type":"double"},"IRQ":{"type":"double"},"SoftIRQ":{"type":"double"},"Privileged":{"type":"double"}}},"LoadAverage":{"type":"list","member":{"type":"double"}}}},"Deployment":{"type":"structure","members":{"VersionLabel":{},"DeploymentId":{"type":"long"},"Status":{},"DeploymentTime":{"type":"timestamp"}}},"AvailabilityZone":{},"InstanceType":{}}}},"RefreshedAt":{"type":"timestamp"},"NextToken":{}}}},"DescribePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DescribePlatformVersionResult","type":"structure","members":{"PlatformDescription":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformName":{},"PlatformVersion":{},"SolutionStackName":{},"PlatformStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"PlatformCategory":{},"Description":{},"Maintainer":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"ProgrammingLanguages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"Frameworks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"CustomAmiList":{"type":"list","member":{"type":"structure","members":{"VirtualizationType":{},"ImageId":{}}}},"SupportedTierList":{"shape":"S2s"},"SupportedAddonList":{"shape":"S2u"},"PlatformLifecycleState":{},"PlatformBranchName":{},"PlatformBranchLifecycleState":{}}}}}},"DisassociateEnvironmentOperationsRole":{"input":{"type":"structure","required":["EnvironmentName"],"members":{"EnvironmentName":{}}}},"ListAvailableSolutionStacks":{"output":{"resultWrapper":"ListAvailableSolutionStacksResult","type":"structure","members":{"SolutionStacks":{"type":"list","member":{}},"SolutionStackDetails":{"type":"list","member":{"type":"structure","members":{"SolutionStackName":{},"PermittedFileTypes":{"type":"list","member":{}}}}}}}},"ListPlatformBranches":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Attribute":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformBranchesResult","type":"structure","members":{"PlatformBranchSummaryList":{"type":"list","member":{"type":"structure","members":{"PlatformName":{},"BranchName":{},"LifecycleState":{},"BranchOrder":{"type":"integer"},"SupportedTierList":{"shape":"S2s"}}}},"NextToken":{}}}},"ListPlatformVersions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Type":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformVersionsResult","type":"structure","members":{"PlatformSummaryList":{"type":"list","member":{"shape":"S2m"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"ResourceArn":{},"ResourceTags":{"shape":"S7f"}}}},"RebuildEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RequestEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}}},"RestartAppServer":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RetrieveEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}},"output":{"resultWrapper":"RetrieveEnvironmentInfoResult","type":"structure","members":{"EnvironmentInfo":{"type":"list","member":{"type":"structure","members":{"InfoType":{},"Ec2InstanceId":{},"SampleTimestamp":{"type":"timestamp"},"Message":{}}}}}}},"SwapEnvironmentCNAMEs":{"input":{"type":"structure","members":{"SourceEnvironmentId":{},"SourceEnvironmentName":{},"DestinationEnvironmentId":{},"DestinationEnvironmentName":{}}}},"TerminateEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"TerminateResources":{"type":"boolean"},"ForceTerminate":{"type":"boolean"}}},"output":{"shape":"Sm","resultWrapper":"TerminateEnvironmentResult"}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{}}},"output":{"shape":"S1j","resultWrapper":"UpdateApplicationResult"}},"UpdateApplicationResourceLifecycle":{"input":{"type":"structure","required":["ApplicationName","ResourceLifecycleConfig"],"members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S19"}}},"output":{"resultWrapper":"UpdateApplicationResourceLifecycleResult","type":"structure","members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S19"}}}},"UpdateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{}}},"output":{"shape":"S21","resultWrapper":"UpdateApplicationVersionResult"}},"UpdateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"Description":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"}}},"output":{"shape":"S2d","resultWrapper":"UpdateConfigurationTemplateResult"}},"UpdateEnvironment":{"input":{"type":"structure","members":{"ApplicationName":{},"EnvironmentId":{},"EnvironmentName":{},"GroupName":{},"Description":{},"Tier":{"shape":"S13"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"}}},"output":{"shape":"Sm","resultWrapper":"UpdateEnvironmentResult"}},"UpdateTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S7f"},"TagsToRemove":{"type":"list","member":{}}}}},"ValidateConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName","OptionSettings"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"OptionSettings":{"shape":"S27"}}},"output":{"resultWrapper":"ValidateConfigurationSettingsResult","type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"Message":{},"Severity":{},"Namespace":{},"OptionName":{}}}}}}}},"shapes":{"Sk":{"type":"structure","members":{"Environments":{"type":"list","member":{"shape":"Sm"}},"NextToken":{}}},"Sm":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"ApplicationName":{},"VersionLabel":{},"SolutionStackName":{},"PlatformArn":{},"TemplateName":{},"Description":{},"EndpointURL":{},"CNAME":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{},"AbortableOperationInProgress":{"type":"boolean"},"Health":{},"HealthStatus":{},"Resources":{"type":"structure","members":{"LoadBalancer":{"type":"structure","members":{"LoadBalancerName":{},"Domain":{},"Listeners":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}}}}}}},"Tier":{"shape":"S13"},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"LinkName":{},"EnvironmentName":{}}}},"EnvironmentArn":{},"OperationsRole":{}}},"S13":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"S19":{"type":"structure","members":{"ServiceRole":{},"VersionLifecycleConfig":{"type":"structure","members":{"MaxCountRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxCount":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}},"MaxAgeRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInDays":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}}}}}},"S1f":{"type":"list","member":{"shape":"S1g"}},"S1g":{"type":"structure","members":{"Key":{},"Value":{}}},"S1j":{"type":"structure","members":{"Application":{"shape":"S1k"}}},"S1k":{"type":"structure","members":{"ApplicationArn":{},"ApplicationName":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Versions":{"shape":"S1m"},"ConfigurationTemplates":{"type":"list","member":{}},"ResourceLifecycleConfig":{"shape":"S19"}}},"S1m":{"type":"list","member":{}},"S1p":{"type":"structure","required":["SourceType","SourceRepository","SourceLocation"],"members":{"SourceType":{},"SourceRepository":{},"SourceLocation":{}}},"S1t":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S21":{"type":"structure","members":{"ApplicationVersion":{"shape":"S22"}}},"S22":{"type":"structure","members":{"ApplicationVersionArn":{},"ApplicationName":{},"Description":{},"VersionLabel":{},"SourceBuildInformation":{"shape":"S1p"},"BuildArn":{},"SourceBundle":{"shape":"S1t"},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{},"Value":{}}}},"S2d":{"type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"ApplicationName":{},"TemplateName":{},"Description":{},"EnvironmentName":{},"DeploymentStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"OptionSettings":{"shape":"S27"}}},"S2g":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{}}}},"S2m":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformStatus":{},"PlatformCategory":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"SupportedTierList":{"shape":"S2s"},"SupportedAddonList":{"shape":"S2u"},"PlatformLifecycleState":{},"PlatformVersion":{},"PlatformBranchName":{},"PlatformBranchLifecycleState":{}}},"S2s":{"type":"list","member":{}},"S2u":{"type":"list","member":{}},"S3c":{"type":"structure","members":{"Maximum":{"type":"integer"}}},"S48":{"type":"list","member":{}},"S4a":{"type":"structure","members":{"Duration":{"type":"integer"},"RequestCount":{"type":"integer"},"StatusCodes":{"type":"structure","members":{"Status2xx":{"type":"integer"},"Status3xx":{"type":"integer"},"Status4xx":{"type":"integer"},"Status5xx":{"type":"integer"}}},"Latency":{"type":"structure","members":{"P999":{"type":"double"},"P99":{"type":"double"},"P95":{"type":"double"},"P90":{"type":"double"},"P85":{"type":"double"},"P75":{"type":"double"},"P50":{"type":"double"},"P10":{"type":"double"}}}}},"S7f":{"type":"list","member":{"shape":"S1g"}}}}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApplicationVersions":{"result_key":"ApplicationVersions"},"DescribeApplications":{"result_key":"Applications"},"DescribeConfigurationOptions":{"result_key":"Options"},"DescribeEnvironments":{"result_key":"Environments"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Events"},"ListAvailableSolutionStacks":{"result_key":"SolutionStacks"},"ListPlatformBranches":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"}}}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-01","endpointPrefix":"elasticfilesystem","protocol":"rest-json","serviceAbbreviation":"EFS","serviceFullName":"Amazon Elastic File System","serviceId":"EFS","signatureVersion":"v4","uid":"elasticfilesystem-2015-02-01"},"operations":{"CreateAccessPoint":{"http":{"requestUri":"/2015-02-01/access-points","responseCode":200},"input":{"type":"structure","required":["ClientToken","FileSystemId"],"members":{"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S3"},"FileSystemId":{},"PosixUser":{"shape":"S8"},"RootDirectory":{"shape":"Sc"}}},"output":{"shape":"Si"}},"CreateFileSystem":{"http":{"requestUri":"/2015-02-01/file-systems","responseCode":201},"input":{"type":"structure","required":["CreationToken"],"members":{"CreationToken":{"idempotencyToken":true},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"Tags":{"shape":"S3"}}},"output":{"shape":"Sv"}},"CreateMountTarget":{"http":{"requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","required":["FileSystemId","SubnetId"],"members":{"FileSystemId":{},"SubnetId":{},"IpAddress":{},"SecurityGroups":{"shape":"S14"}}},"output":{"shape":"S16"}},"CreateTags":{"http":{"requestUri":"/2015-02-01/create-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","Tags"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Tags":{"shape":"S3"}}},"deprecated":true,"deprecatedMessage":"Use TagResource."},"DeleteAccessPoint":{"http":{"method":"DELETE","requestUri":"/2015-02-01/access-points/{AccessPointId}","responseCode":204},"input":{"type":"structure","required":["AccessPointId"],"members":{"AccessPointId":{"location":"uri","locationName":"AccessPointId"}}}},"DeleteFileSystem":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteFileSystemPolicy":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteMountTarget":{"http":{"method":"DELETE","requestUri":"/2015-02-01/mount-targets/{MountTargetId}","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}}},"DeleteTags":{"http":{"requestUri":"/2015-02-01/delete-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","TagKeys"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"TagKeys":{"shape":"S1h"}}},"deprecated":true,"deprecatedMessage":"Use UntagResource."},"DescribeAccessPoints":{"http":{"method":"GET","requestUri":"/2015-02-01/access-points","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"AccessPointId":{"location":"querystring","locationName":"AccessPointId"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"AccessPoints":{"type":"list","member":{"shape":"Si"}},"NextToken":{}}}},"DescribeFileSystemPolicy":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S1o"}},"DescribeFileSystems":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"CreationToken":{"location":"querystring","locationName":"CreationToken"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"Marker":{},"FileSystems":{"type":"list","member":{"shape":"Sv"}},"NextMarker":{}}}},"DescribeLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S1w"}},"DescribeMountTargetSecurityGroups":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":200},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}},"output":{"type":"structure","required":["SecurityGroups"],"members":{"SecurityGroups":{"shape":"S14"}}}},"DescribeMountTargets":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"MountTargetId":{"location":"querystring","locationName":"MountTargetId"},"AccessPointId":{"location":"querystring","locationName":"AccessPointId"}}},"output":{"type":"structure","members":{"Marker":{},"MountTargets":{"type":"list","member":{"shape":"S16"}},"NextMarker":{}}}},"DescribeTags":{"http":{"method":"GET","requestUri":"/2015-02-01/tags/{FileSystemId}/","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"type":"structure","required":["Tags"],"members":{"Marker":{},"Tags":{"shape":"S3"},"NextMarker":{}}},"deprecated":true,"deprecatedMessage":"Use ListTagsForResource."},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"},"NextToken":{}}}},"ModifyMountTargetSecurityGroups":{"http":{"method":"PUT","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"},"SecurityGroups":{"shape":"S14"}}}},"PutFileSystemPolicy":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId","Policy"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}},"output":{"shape":"S1o"}},"PutLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId","LifecyclePolicies"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"LifecyclePolicies":{"shape":"S1x"}}},"output":{"shape":"S1w"}},"TagResource":{"http":{"requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Tags":{"shape":"S3"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"TagKeys":{"shape":"S1h","location":"querystring","locationName":"tagKeys"}}}},"UpdateFileSystem":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":202},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"}}},"output":{"shape":"Sv"}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S8":{"type":"structure","required":["Uid","Gid"],"members":{"Uid":{"type":"long"},"Gid":{"type":"long"},"SecondaryGids":{"type":"list","member":{"type":"long"}}}},"Sc":{"type":"structure","members":{"Path":{},"CreationInfo":{"type":"structure","required":["OwnerUid","OwnerGid","Permissions"],"members":{"OwnerUid":{"type":"long"},"OwnerGid":{"type":"long"},"Permissions":{}}}}},"Si":{"type":"structure","members":{"ClientToken":{},"Name":{},"Tags":{"shape":"S3"},"AccessPointId":{},"AccessPointArn":{},"FileSystemId":{},"PosixUser":{"shape":"S8"},"RootDirectory":{"shape":"Sc"},"OwnerId":{},"LifeCycleState":{}}},"Sv":{"type":"structure","required":["OwnerId","CreationToken","FileSystemId","CreationTime","LifeCycleState","NumberOfMountTargets","SizeInBytes","PerformanceMode","Tags"],"members":{"OwnerId":{},"CreationToken":{},"FileSystemId":{},"CreationTime":{"type":"timestamp"},"LifeCycleState":{},"Name":{},"NumberOfMountTargets":{"type":"integer"},"SizeInBytes":{"type":"structure","required":["Value"],"members":{"Value":{"type":"long"},"Timestamp":{"type":"timestamp"},"ValueInIA":{"type":"long"},"ValueInStandard":{"type":"long"}}},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"Tags":{"shape":"S3"}}},"S14":{"type":"list","member":{}},"S16":{"type":"structure","required":["MountTargetId","FileSystemId","SubnetId","LifeCycleState"],"members":{"OwnerId":{},"MountTargetId":{},"FileSystemId":{},"SubnetId":{},"LifeCycleState":{},"IpAddress":{},"NetworkInterfaceId":{},"AvailabilityZoneId":{},"AvailabilityZoneName":{}}},"S1h":{"type":"list","member":{}},"S1o":{"type":"structure","members":{"FileSystemId":{},"Policy":{}}},"S1w":{"type":"structure","members":{"LifecyclePolicies":{"shape":"S1x"}}},"S1x":{"type":"list","member":{"type":"structure","members":{"TransitionToIA":{}}}}}}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccessPoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeFileSystems":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems"},"DescribeTags":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-06-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancing-2012-06-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"},"operations":{"AddTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"ApplySecurityGroupsToLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","SecurityGroups"],"members":{"LoadBalancerName":{},"SecurityGroups":{"shape":"Sa"}}},"output":{"resultWrapper":"ApplySecurityGroupsToLoadBalancerResult","type":"structure","members":{"SecurityGroups":{"shape":"Sa"}}}},"AttachLoadBalancerToSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"AttachLoadBalancerToSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"ConfigureHealthCheck":{"input":{"type":"structure","required":["LoadBalancerName","HealthCheck"],"members":{"LoadBalancerName":{},"HealthCheck":{"shape":"Si"}}},"output":{"resultWrapper":"ConfigureHealthCheckResult","type":"structure","members":{"HealthCheck":{"shape":"Si"}}}},"CreateAppCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","CookieName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieName":{}}},"output":{"resultWrapper":"CreateAppCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLBCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}},"output":{"resultWrapper":"CreateLBCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"SecurityGroups":{"shape":"Sa"},"Scheme":{},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"DNSName":{}}}},"CreateLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateLoadBalancerListenersResult","type":"structure","members":{}}},"CreateLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","PolicyTypeName"],"members":{"LoadBalancerName":{},"PolicyName":{},"PolicyTypeName":{},"PolicyAttributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}},"output":{"resultWrapper":"CreateLoadBalancerPolicyResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPorts"],"members":{"LoadBalancerName":{},"LoadBalancerPorts":{"type":"list","member":{"type":"integer"}}}},"output":{"resultWrapper":"DeleteLoadBalancerListenersResult","type":"structure","members":{}}},"DeleteLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerPolicyResult","type":"structure","members":{}}},"DeregisterInstancesFromLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DeregisterInstancesFromLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeInstanceHealth":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeInstanceHealthResult","type":"structure","members":{"InstanceStates":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"State":{},"ReasonCode":{},"Description":{}}}}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerAttributes":{"shape":"S2a"}}}},"DescribeLoadBalancerPolicies":{"input":{"type":"structure","members":{"LoadBalancerName":{},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"DescribeLoadBalancerPoliciesResult","type":"structure","members":{"PolicyDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyTypeName":{},"PolicyAttributeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}}}}}},"DescribeLoadBalancerPolicyTypes":{"input":{"type":"structure","members":{"PolicyTypeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLoadBalancerPolicyTypesResult","type":"structure","members":{"PolicyTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyTypeName":{},"Description":{},"PolicyAttributeTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{},"Description":{},"DefaultValue":{},"Cardinality":{}}}}}}}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerNames":{"shape":"S2"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancerDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"DNSName":{},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"shape":"Sy"},"PolicyNames":{"shape":"S2s"}}}},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieName":{}}}},"LBCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}}},"OtherPolicies":{"shape":"S2s"}}},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}}},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"VPCId":{},"Instances":{"shape":"S1p"},"HealthCheck":{"shape":"Si"},"SourceSecurityGroup":{"type":"structure","members":{"OwnerAlias":{},"GroupName":{}}},"SecurityGroups":{"shape":"Sa"},"CreatedTime":{"type":"timestamp"},"Scheme":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["LoadBalancerNames"],"members":{"LoadBalancerNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"Tags":{"shape":"S4"}}}}}}},"DetachLoadBalancerFromSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"DetachLoadBalancerFromSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"DisableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"DisableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"EnableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"EnableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerAttributes"],"members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}}},"RegisterInstancesWithLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"RegisterInstancesWithLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"RemoveTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"type":"list","member":{"type":"structure","members":{"Key":{}}}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetLoadBalancerListenerSSLCertificate":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","SSLCertificateId"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"SSLCertificateId":{}}},"output":{"resultWrapper":"SetLoadBalancerListenerSSLCertificateResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesForBackendServer":{"input":{"type":"structure","required":["LoadBalancerName","InstancePort","PolicyNames"],"members":{"LoadBalancerName":{},"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesForBackendServerResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesOfListener":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","PolicyNames"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesOfListenerResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Si":{"type":"structure","required":["Target","Interval","Timeout","UnhealthyThreshold","HealthyThreshold"],"members":{"Target":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"},"HealthyThreshold":{"type":"integer"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Protocol","LoadBalancerPort","InstancePort"],"members":{"Protocol":{},"LoadBalancerPort":{"type":"integer"},"InstanceProtocol":{},"InstancePort":{"type":"integer"},"SSLCertificateId":{}}},"S13":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"S2a":{"type":"structure","members":{"CrossZoneLoadBalancing":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"AccessLog":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"S3BucketName":{},"EmitInterval":{"type":"integer"},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","required":["IdleTimeout"],"members":{"IdleTimeout":{"type":"integer"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S2s":{"type":"list","member":{}}}}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeInstanceHealth":{"result_key":"InstanceStates"},"DescribeLoadBalancerPolicies":{"result_key":"PolicyDescriptions"},"DescribeLoadBalancerPolicyTypes":{"result_key":"PolicyTypeDescriptions"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancerDescriptions"}}}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceDeregistered":{"delay":15,"operation":"DescribeInstanceHealth","maxAttempts":40,"acceptors":[{"expected":"OutOfService","matcher":"pathAll","state":"success","argument":"InstanceStates[].State"},{"matcher":"error","expected":"InvalidInstance","state":"success"}]},"AnyInstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAny","state":"success"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"},"InstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"}}}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceAbbreviation":"Elastic Load Balancing v2","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing v2","signatureVersion":"v4","uid":"elasticloadbalancingv2-2015-12-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"},"operations":{"AddListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"AddListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArns","Tags"],"members":{"ResourceArns":{"shape":"S9"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"CreateListener":{"input":{"type":"structure","required":["LoadBalancerArn","Protocol","Port","DefaultActions"],"members":{"LoadBalancerArn":{},"Protocol":{},"Port":{"type":"integer"},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"},"AlpnPolicy":{"shape":"S1y"}}},"output":{"resultWrapper":"CreateListenerResult","type":"structure","members":{"Listeners":{"shape":"S21"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Subnets":{"shape":"S25"},"SubnetMappings":{"shape":"S27"},"SecurityGroups":{"shape":"S2b"},"Scheme":{},"Tags":{"shape":"Sb"},"Type":{},"IpAddressType":{}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"LoadBalancers":{"shape":"S2h"}}}},"CreateRule":{"input":{"type":"structure","required":["ListenerArn","Conditions","Priority","Actions"],"members":{"ListenerArn":{},"Conditions":{"shape":"S2x"},"Priority":{"type":"integer"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateRuleResult","type":"structure","members":{"Rules":{"shape":"S3d"}}}},"CreateTargetGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S3q"},"TargetType":{}}},"output":{"resultWrapper":"CreateTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S3u"}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"resultWrapper":"DeleteListenerResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{}}},"output":{"resultWrapper":"DeleteRuleResult","type":"structure","members":{}}},"DeleteTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DeleteTargetGroupResult","type":"structure","members":{}}},"DeregisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S46"}}},"output":{"resultWrapper":"DeregisterTargetsResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeListenerCertificates":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"},"NextMarker":{}}}},"DescribeListeners":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"ListenerArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenersResult","type":"structure","members":{"Listeners":{"shape":"S21"},"NextMarker":{}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S4p"}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerArns":{"shape":"S3w"},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"shape":"S2h"},"NextMarker":{}}}},"DescribeRules":{"input":{"type":"structure","members":{"ListenerArn":{},"RuleArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeRulesResult","type":"structure","members":{"Rules":{"shape":"S3d"},"NextMarker":{}}}},"DescribeSSLPolicies":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSSLPoliciesResult","type":"structure","members":{"SslPolicies":{"type":"list","member":{"type":"structure","members":{"SslProtocols":{"type":"list","member":{}},"Ciphers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Priority":{"type":"integer"}}}},"Name":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"shape":"S9"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}}}}}},"DescribeTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DescribeTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S5g"}}}},"DescribeTargetGroups":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"TargetGroupArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTargetGroupsResult","type":"structure","members":{"TargetGroups":{"shape":"S3u"},"NextMarker":{}}}},"DescribeTargetHealth":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S46"}}},"output":{"resultWrapper":"DescribeTargetHealthResult","type":"structure","members":{"TargetHealthDescriptions":{"type":"list","member":{"type":"structure","members":{"Target":{"shape":"S47"},"HealthCheckPort":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}}}}},"ModifyListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Port":{"type":"integer"},"Protocol":{},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"},"AlpnPolicy":{"shape":"S1y"}}},"output":{"resultWrapper":"ModifyListenerResult","type":"structure","members":{"Listeners":{"shape":"S21"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn","Attributes"],"members":{"LoadBalancerArn":{},"Attributes":{"shape":"S4p"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S4p"}}}},"ModifyRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{},"Conditions":{"shape":"S2x"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyRuleResult","type":"structure","members":{"Rules":{"shape":"S3d"}}}},"ModifyTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S3q"}}},"output":{"resultWrapper":"ModifyTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S3u"}}}},"ModifyTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn","Attributes"],"members":{"TargetGroupArn":{},"Attributes":{"shape":"S5g"}}},"output":{"resultWrapper":"ModifyTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S5g"}}}},"RegisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S46"}}},"output":{"resultWrapper":"RegisterTargetsResult","type":"structure","members":{}}},"RemoveListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"RemoveListenerCertificatesResult","type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceArns","TagKeys"],"members":{"ResourceArns":{"shape":"S9"},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetIpAddressType":{"input":{"type":"structure","required":["LoadBalancerArn","IpAddressType"],"members":{"LoadBalancerArn":{},"IpAddressType":{}}},"output":{"resultWrapper":"SetIpAddressTypeResult","type":"structure","members":{"IpAddressType":{}}}},"SetRulePriorities":{"input":{"type":"structure","required":["RulePriorities"],"members":{"RulePriorities":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{"type":"integer"}}}}}},"output":{"resultWrapper":"SetRulePrioritiesResult","type":"structure","members":{"Rules":{"shape":"S3d"}}}},"SetSecurityGroups":{"input":{"type":"structure","required":["LoadBalancerArn","SecurityGroups"],"members":{"LoadBalancerArn":{},"SecurityGroups":{"shape":"S2b"}}},"output":{"resultWrapper":"SetSecurityGroupsResult","type":"structure","members":{"SecurityGroupIds":{"shape":"S2b"}}}},"SetSubnets":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{},"Subnets":{"shape":"S25"},"SubnetMappings":{"shape":"S27"}}},"output":{"resultWrapper":"SetSubnetsResult","type":"structure","members":{"AvailabilityZones":{"shape":"S2q"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"IsDefault":{"type":"boolean"}}}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"TargetGroupArn":{},"AuthenticateOidcConfig":{"type":"structure","required":["Issuer","AuthorizationEndpoint","TokenEndpoint","UserInfoEndpoint","ClientId"],"members":{"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"ClientId":{},"ClientSecret":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{},"UseExistingClientSecret":{"type":"boolean"}}},"AuthenticateCognitoConfig":{"type":"structure","required":["UserPoolArn","UserPoolClientId","UserPoolDomain"],"members":{"UserPoolArn":{},"UserPoolClientId":{},"UserPoolDomain":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{}}},"Order":{"type":"integer"},"RedirectConfig":{"type":"structure","required":["StatusCode"],"members":{"Protocol":{},"Port":{},"Host":{},"Path":{},"Query":{},"StatusCode":{}}},"FixedResponseConfig":{"type":"structure","required":["StatusCode"],"members":{"MessageBody":{},"StatusCode":{},"ContentType":{}}},"ForwardConfig":{"type":"structure","members":{"TargetGroups":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"Weight":{"type":"integer"}}}},"TargetGroupStickinessConfig":{"type":"structure","members":{"Enabled":{"type":"boolean"},"DurationSeconds":{"type":"integer"}}}}}}}},"S1y":{"type":"list","member":{}},"S21":{"type":"list","member":{"type":"structure","members":{"ListenerArn":{},"LoadBalancerArn":{},"Port":{"type":"integer"},"Protocol":{},"Certificates":{"shape":"S3"},"SslPolicy":{},"DefaultActions":{"shape":"Sl"},"AlpnPolicy":{"shape":"S1y"}}}},"S25":{"type":"list","member":{}},"S27":{"type":"list","member":{"type":"structure","members":{"SubnetId":{},"AllocationId":{},"PrivateIPv4Address":{}}}},"S2b":{"type":"list","member":{}},"S2h":{"type":"list","member":{"type":"structure","members":{"LoadBalancerArn":{},"DNSName":{},"CanonicalHostedZoneId":{},"CreatedTime":{"type":"timestamp"},"LoadBalancerName":{},"Scheme":{},"VpcId":{},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"AvailabilityZones":{"shape":"S2q"},"SecurityGroups":{"shape":"S2b"},"IpAddressType":{}}}},"S2q":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{},"LoadBalancerAddresses":{"type":"list","member":{"type":"structure","members":{"IpAddress":{},"AllocationId":{},"PrivateIPv4Address":{}}}}}}},"S2x":{"type":"list","member":{"type":"structure","members":{"Field":{},"Values":{"shape":"S30"},"HostHeaderConfig":{"type":"structure","members":{"Values":{"shape":"S30"}}},"PathPatternConfig":{"type":"structure","members":{"Values":{"shape":"S30"}}},"HttpHeaderConfig":{"type":"structure","members":{"HttpHeaderName":{},"Values":{"shape":"S30"}}},"QueryStringConfig":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"HttpRequestMethodConfig":{"type":"structure","members":{"Values":{"shape":"S30"}}},"SourceIpConfig":{"type":"structure","members":{"Values":{"shape":"S30"}}}}}},"S30":{"type":"list","member":{}},"S3d":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{},"Conditions":{"shape":"S2x"},"Actions":{"shape":"Sl"},"IsDefault":{"type":"boolean"}}}},"S3q":{"type":"structure","required":["HttpCode"],"members":{"HttpCode":{}}},"S3u":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"TargetGroupName":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"HealthCheckPath":{},"Matcher":{"shape":"S3q"},"LoadBalancerArns":{"shape":"S3w"},"TargetType":{}}}},"S3w":{"type":"list","member":{}},"S46":{"type":"list","member":{"shape":"S47"}},"S47":{"type":"structure","required":["Id"],"members":{"Id":{},"Port":{"type":"integer"},"AvailabilityZone":{}}},"S4p":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S5g":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"}}}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"LoadBalancerExists":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"retry"}]},"LoadBalancerAvailable":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"state":"retry","matcher":"pathAny","argument":"LoadBalancers[].State.Code","expected":"provisioning"},{"state":"retry","matcher":"error","expected":"LoadBalancerNotFound"}]},"LoadBalancersDeleted":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"retry","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"success"}]},"TargetInService":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"healthy","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}]},"TargetDeregistered":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"matcher":"error","expected":"InvalidTarget","state":"success"},{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"unused","matcher":"pathAll","state":"success"}]}}}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2009-03-31","endpointPrefix":"elasticmapreduce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon EMR","serviceFullName":"Amazon Elastic MapReduce","serviceId":"EMR","signatureVersion":"v4","targetPrefix":"ElasticMapReduce","uid":"elasticmapreduce-2009-03-31"},"operations":{"AddInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"shape":"S3"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceFleetId":{},"ClusterArn":{}}}},"AddInstanceGroups":{"input":{"type":"structure","required":["InstanceGroups","JobFlowId"],"members":{"InstanceGroups":{"shape":"Su"},"JobFlowId":{}}},"output":{"type":"structure","members":{"JobFlowId":{},"InstanceGroupIds":{"type":"list","member":{}},"ClusterArn":{}}}},"AddJobFlowSteps":{"input":{"type":"structure","required":["JobFlowId","Steps"],"members":{"JobFlowId":{},"Steps":{"shape":"S1f"}}},"output":{"type":"structure","members":{"StepIds":{"shape":"S1o"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{}}},"CancelSteps":{"input":{"type":"structure","required":["ClusterId","StepIds"],"members":{"ClusterId":{},"StepIds":{"shape":"S1o"},"StepCancellationOption":{}}},"output":{"type":"structure","members":{"CancelStepsInfoList":{"type":"list","member":{"type":"structure","members":{"StepId":{},"Status":{},"Reason":{}}}}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","SecurityConfiguration"],"members":{"Name":{},"SecurityConfiguration":{}}},"output":{"type":"structure","required":["Name","CreationDateTime"],"members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S2a"},"Ec2InstanceAttributes":{"type":"structure","members":{"Ec2KeyName":{},"Ec2SubnetId":{},"RequestedEc2SubnetIds":{"shape":"S2g"},"Ec2AvailabilityZone":{},"RequestedEc2AvailabilityZones":{"shape":"S2g"},"IamInstanceProfile":{},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S2h"},"AdditionalSlaveSecurityGroups":{"shape":"S2h"}}},"InstanceCollectionType":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"RequestedAmiVersion":{},"RunningAmiVersion":{},"ReleaseLabel":{},"AutoTerminate":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"VisibleToAllUsers":{"type":"boolean"},"Applications":{"shape":"S2k"},"Tags":{"shape":"S1r"},"ServiceRole":{},"NormalizedInstanceHours":{"type":"integer"},"MasterPublicDnsName":{},"Configurations":{"shape":"Sh"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2o"},"ClusterArn":{},"OutpostArn":{},"StepConcurrencyLevel":{"type":"integer"}}}}}},"DescribeJobFlows":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"JobFlowIds":{"shape":"S1m"},"JobFlowStates":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobFlows":{"type":"list","member":{"type":"structure","required":["JobFlowId","Name","ExecutionStatusDetail","Instances"],"members":{"JobFlowId":{},"Name":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"AmiVersion":{},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}},"Instances":{"type":"structure","required":["MasterInstanceType","SlaveInstanceType","InstanceCount"],"members":{"MasterInstanceType":{},"MasterPublicDnsName":{},"MasterInstanceId":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["Market","InstanceRole","InstanceType","InstanceRequestCount","InstanceRunningCount","State","CreationDateTime"],"members":{"InstanceGroupId":{},"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceRequestCount":{"type":"integer"},"InstanceRunningCount":{"type":"integer"},"State":{},"LastStateChangeReason":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}},"NormalizedInstanceHours":{"type":"integer"},"Ec2KeyName":{},"Ec2SubnetId":{},"Placement":{"shape":"S31"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{}}},"Steps":{"type":"list","member":{"type":"structure","required":["StepConfig","ExecutionStatusDetail"],"members":{"StepConfig":{"shape":"S1g"},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}}}}},"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"BootstrapActionConfig":{"shape":"S38"}}}},"SupportedProducts":{"shape":"S3a"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"AutoScalingRole":{},"ScaleDownBehavior":{}}}}}},"deprecated":true},"DescribeSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"SecurityConfiguration":{},"CreationDateTime":{"type":"timestamp"}}}},"DescribeStep":{"input":{"type":"structure","required":["ClusterId","StepId"],"members":{"ClusterId":{},"StepId":{}}},"output":{"type":"structure","members":{"Step":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S3g"},"ActionOnFailure":{},"Status":{"shape":"S3h"}}}}}},"GetBlockPublicAccessConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["BlockPublicAccessConfiguration","BlockPublicAccessConfigurationMetadata"],"members":{"BlockPublicAccessConfiguration":{"shape":"S3p"},"BlockPublicAccessConfigurationMetadata":{"type":"structure","required":["CreationDateTime","CreatedByArn"],"members":{"CreationDateTime":{"type":"timestamp"},"CreatedByArn":{}}}}}},"GetManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"ManagedScalingPolicy":{"shape":"S3w"}}}},"ListBootstrapActions":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ScriptPath":{},"Args":{"shape":"S2h"}}}},"Marker":{}}}},"ListClusters":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ClusterStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S2a"},"NormalizedInstanceHours":{"type":"integer"},"ClusterArn":{},"OutpostArn":{}}}},"Marker":{}}}},"ListInstanceFleets":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceFleets":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ProvisionedOnDemandCapacity":{"type":"integer"},"ProvisionedSpotCapacity":{"type":"integer"},"InstanceTypeSpecifications":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S4k"},"EbsOptimized":{"type":"boolean"}}}},"LaunchSpecifications":{"shape":"Sk"}}}},"Marker":{}}}},"ListInstanceGroups":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Market":{},"InstanceGroupType":{},"BidPrice":{},"InstanceType":{},"RequestedInstanceCount":{"type":"integer"},"RunningInstanceCount":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"Configurations":{"shape":"Sh"},"ConfigurationsVersion":{"type":"long"},"LastSuccessfullyAppliedConfigurations":{"shape":"Sh"},"LastSuccessfullyAppliedConfigurationsVersion":{"type":"long"},"EbsBlockDevices":{"shape":"S4k"},"EbsOptimized":{"type":"boolean"},"ShrinkPolicy":{"shape":"S4x"},"AutoScalingPolicy":{"shape":"S51"}}}},"Marker":{}}}},"ListInstances":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"InstanceGroupId":{},"InstanceGroupTypes":{"type":"list","member":{}},"InstanceFleetId":{},"InstanceFleetType":{},"InstanceStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Ec2InstanceId":{},"PublicDnsName":{},"PublicIpAddress":{},"PrivateDnsName":{},"PrivateIpAddress":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceGroupId":{},"InstanceFleetId":{},"Market":{},"InstanceType":{},"EbsVolumes":{"type":"list","member":{"type":"structure","members":{"Device":{},"VolumeId":{}}}}}}},"Marker":{}}}},"ListSecurityConfigurations":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSteps":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepStates":{"type":"list","member":{}},"StepIds":{"shape":"S1m"},"Marker":{}}},"output":{"type":"structure","members":{"Steps":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S3g"},"ActionOnFailure":{},"Status":{"shape":"S3h"}}}},"Marker":{}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepConcurrencyLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"StepConcurrencyLevel":{"type":"integer"}}}},"ModifyInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"type":"structure","required":["InstanceFleetId"],"members":{"InstanceFleetId":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"}}}}}},"ModifyInstanceGroups":{"input":{"type":"structure","members":{"ClusterId":{},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["InstanceGroupId"],"members":{"InstanceGroupId":{},"InstanceCount":{"type":"integer"},"EC2InstanceIdsToTerminate":{"type":"list","member":{}},"ShrinkPolicy":{"shape":"S4x"},"Configurations":{"shape":"Sh"}}}}}}},"PutAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId","AutoScalingPolicy"],"members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"Sy"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S51"},"ClusterArn":{}}}},"PutBlockPublicAccessConfiguration":{"input":{"type":"structure","required":["BlockPublicAccessConfiguration"],"members":{"BlockPublicAccessConfiguration":{"shape":"S3p"}}},"output":{"type":"structure","members":{}}},"PutManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId","ManagedScalingPolicy"],"members":{"ClusterId":{},"ManagedScalingPolicy":{"shape":"S3w"}}},"output":{"type":"structure","members":{}}},"RemoveAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId"],"members":{"ClusterId":{},"InstanceGroupId":{}}},"output":{"type":"structure","members":{}}},"RemoveManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"shape":"S2h"}}},"output":{"type":"structure","members":{}}},"RunJobFlow":{"input":{"type":"structure","required":["Name","Instances"],"members":{"Name":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"AdditionalInfo":{},"AmiVersion":{},"ReleaseLabel":{},"Instances":{"type":"structure","members":{"MasterInstanceType":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"shape":"Su"},"InstanceFleets":{"type":"list","member":{"shape":"S3"}},"Ec2KeyName":{},"Placement":{"shape":"S31"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{},"Ec2SubnetId":{},"Ec2SubnetIds":{"shape":"S2g"},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S6f"},"AdditionalSlaveSecurityGroups":{"shape":"S6f"}}},"Steps":{"shape":"S1f"},"BootstrapActions":{"type":"list","member":{"shape":"S38"}},"SupportedProducts":{"shape":"S3a"},"NewSupportedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Args":{"shape":"S1m"}}}},"Applications":{"shape":"S2k"},"Configurations":{"shape":"Sh"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"Tags":{"shape":"S1r"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2o"},"StepConcurrencyLevel":{"type":"integer"},"ManagedScalingPolicy":{"shape":"S3w"}}},"output":{"type":"structure","members":{"JobFlowId":{},"ClusterArn":{}}}},"SetTerminationProtection":{"input":{"type":"structure","required":["JobFlowIds","TerminationProtected"],"members":{"JobFlowIds":{"shape":"S1m"},"TerminationProtected":{"type":"boolean"}}}},"SetVisibleToAllUsers":{"input":{"type":"structure","required":["JobFlowIds","VisibleToAllUsers"],"members":{"JobFlowIds":{"shape":"S1m"},"VisibleToAllUsers":{"type":"boolean"}}}},"TerminateJobFlows":{"input":{"type":"structure","required":["JobFlowIds"],"members":{"JobFlowIds":{"shape":"S1m"}}}}},"shapes":{"S3":{"type":"structure","required":["InstanceFleetType"],"members":{"Name":{},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"InstanceTypeConfigs":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"EbsConfiguration":{"shape":"Sa"},"Configurations":{"shape":"Sh"}}}},"LaunchSpecifications":{"shape":"Sk"}}},"Sa":{"type":"structure","members":{"EbsBlockDeviceConfigs":{"type":"list","member":{"type":"structure","required":["VolumeSpecification"],"members":{"VolumeSpecification":{"shape":"Sd"},"VolumesPerInstance":{"type":"integer"}}}},"EbsOptimized":{"type":"boolean"}}},"Sd":{"type":"structure","required":["VolumeType","SizeInGB"],"members":{"VolumeType":{},"Iops":{"type":"integer"},"SizeInGB":{"type":"integer"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Classification":{},"Configurations":{"shape":"Sh"},"Properties":{"shape":"Sj"}}}},"Sj":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","members":{"SpotSpecification":{"type":"structure","required":["TimeoutDurationMinutes","TimeoutAction"],"members":{"TimeoutDurationMinutes":{"type":"integer"},"TimeoutAction":{},"BlockDurationMinutes":{"type":"integer"},"AllocationStrategy":{}}},"OnDemandSpecification":{"type":"structure","required":["AllocationStrategy"],"members":{"AllocationStrategy":{}}}}},"Su":{"type":"list","member":{"type":"structure","required":["InstanceRole","InstanceType","InstanceCount"],"members":{"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceCount":{"type":"integer"},"Configurations":{"shape":"Sh"},"EbsConfiguration":{"shape":"Sa"},"AutoScalingPolicy":{"shape":"Sy"}}}},"Sy":{"type":"structure","required":["Constraints","Rules"],"members":{"Constraints":{"shape":"Sz"},"Rules":{"shape":"S10"}}},"Sz":{"type":"structure","required":["MinCapacity","MaxCapacity"],"members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"S10":{"type":"list","member":{"type":"structure","required":["Name","Action","Trigger"],"members":{"Name":{},"Description":{},"Action":{"type":"structure","required":["SimpleScalingPolicyConfiguration"],"members":{"Market":{},"SimpleScalingPolicyConfiguration":{"type":"structure","required":["ScalingAdjustment"],"members":{"AdjustmentType":{},"ScalingAdjustment":{"type":"integer"},"CoolDown":{"type":"integer"}}}}},"Trigger":{"type":"structure","required":["CloudWatchAlarmDefinition"],"members":{"CloudWatchAlarmDefinition":{"type":"structure","required":["ComparisonOperator","MetricName","Period","Threshold"],"members":{"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"Namespace":{},"Period":{"type":"integer"},"Statistic":{},"Threshold":{"type":"double"},"Unit":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}}}}}},"S1f":{"type":"list","member":{"shape":"S1g"}},"S1g":{"type":"structure","required":["Name","HadoopJarStep"],"members":{"Name":{},"ActionOnFailure":{},"HadoopJarStep":{"type":"structure","required":["Jar"],"members":{"Properties":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Jar":{},"MainClass":{},"Args":{"shape":"S1m"}}}}},"S1m":{"type":"list","member":{}},"S1o":{"type":"list","member":{}},"S1r":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S2a":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S2g":{"type":"list","member":{}},"S2h":{"type":"list","member":{}},"S2k":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Args":{"shape":"S2h"},"AdditionalInfo":{"shape":"Sj"}}}},"S2o":{"type":"structure","required":["Realm","KdcAdminPassword"],"members":{"Realm":{},"KdcAdminPassword":{},"CrossRealmTrustPrincipalPassword":{},"ADDomainJoinUser":{},"ADDomainJoinPassword":{}}},"S31":{"type":"structure","members":{"AvailabilityZone":{},"AvailabilityZones":{"shape":"S2g"}}},"S38":{"type":"structure","required":["Name","ScriptBootstrapAction"],"members":{"Name":{},"ScriptBootstrapAction":{"type":"structure","required":["Path"],"members":{"Path":{},"Args":{"shape":"S1m"}}}}},"S3a":{"type":"list","member":{}},"S3g":{"type":"structure","members":{"Jar":{},"Properties":{"shape":"Sj"},"MainClass":{},"Args":{"shape":"S2h"}}},"S3h":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"FailureDetails":{"type":"structure","members":{"Reason":{},"Message":{},"LogFile":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S3p":{"type":"structure","required":["BlockPublicSecurityGroupRules"],"members":{"BlockPublicSecurityGroupRules":{"type":"boolean"},"PermittedPublicSecurityGroupRuleRanges":{"type":"list","member":{"type":"structure","required":["MinRange"],"members":{"MinRange":{"type":"integer"},"MaxRange":{"type":"integer"}}}}}},"S3w":{"type":"structure","members":{"ComputeLimits":{"type":"structure","required":["UnitType","MinimumCapacityUnits","MaximumCapacityUnits"],"members":{"UnitType":{},"MinimumCapacityUnits":{"type":"integer"},"MaximumCapacityUnits":{"type":"integer"},"MaximumOnDemandCapacityUnits":{"type":"integer"},"MaximumCoreCapacityUnits":{"type":"integer"}}}}},"S4k":{"type":"list","member":{"type":"structure","members":{"VolumeSpecification":{"shape":"Sd"},"Device":{}}}},"S4x":{"type":"structure","members":{"DecommissionTimeout":{"type":"integer"},"InstanceResizePolicy":{"type":"structure","members":{"InstancesToTerminate":{"shape":"S4z"},"InstancesToProtect":{"shape":"S4z"},"InstanceTerminationTimeout":{"type":"integer"}}}}},"S4z":{"type":"list","member":{}},"S51":{"type":"structure","members":{"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}}}},"Constraints":{"shape":"Sz"},"Rules":{"shape":"S10"}}},"S6f":{"type":"list","member":{}}}}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeJobFlows":{"result_key":"JobFlows"},"ListBootstrapActions":{"input_token":"Marker","output_token":"Marker","result_key":"BootstrapActions"},"ListClusters":{"input_token":"Marker","output_token":"Marker","result_key":"Clusters"},"ListInstanceFleets":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceFleets"},"ListInstanceGroups":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceGroups"},"ListInstances":{"input_token":"Marker","output_token":"Marker","result_key":"Instances"},"ListSecurityConfigurations":{"input_token":"Marker","output_token":"Marker","result_key":"SecurityConfigurations"},"ListSteps":{"input_token":"Marker","output_token":"Marker","result_key":"Steps"}}}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterRunning":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"RUNNING"},{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"WAITING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]},"StepComplete":{"delay":30,"operation":"DescribeStep","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Step.Status.State","expected":"COMPLETED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"CANCELLED"}]},"ClusterTerminated":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]}}}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-09-25","endpointPrefix":"elastictranscoder","protocol":"rest-json","serviceFullName":"Amazon Elastic Transcoder","serviceId":"Elastic Transcoder","signatureVersion":"v4","uid":"elastictranscoder-2012-09-25"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/2012-09-25/jobs/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2012-09-25/jobs","responseCode":201},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"Su"},"Outputs":{"type":"list","member":{"shape":"Su"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"}}}},"UserMetadata":{"shape":"S1v"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"CreatePipeline":{"http":{"requestUri":"/2012-09-25/pipelines","responseCode":201},"input":{"type":"structure","required":["Name","InputBucket","Role"],"members":{"Name":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"CreatePreset":{"http":{"requestUri":"/2012-09-25/presets","responseCode":201},"input":{"type":"structure","required":["Name","Container"],"members":{"Name":{},"Description":{},"Container":{},"Video":{"shape":"S2r"},"Audio":{"shape":"S37"},"Thumbnails":{"shape":"S3i"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"},"Warning":{}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2012-09-25/presets/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"ListJobsByPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByPipeline/{PipelineId}"},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{"location":"uri","locationName":"PipelineId"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListJobsByStatus":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByStatus/{Status}"},"input":{"type":"structure","required":["Status"],"members":{"Status":{"location":"uri","locationName":"Status"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Pipelines":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2012-09-25/presets"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Presets":{"type":"list","member":{"shape":"S3m"}},"NextPageToken":{}}}},"ReadJob":{"http":{"method":"GET","requestUri":"/2012-09-25/jobs/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"ReadPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"ReadPreset":{"http":{"method":"GET","requestUri":"/2012-09-25/presets/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"}}}},"TestRole":{"http":{"requestUri":"/2012-09-25/roleTests","responseCode":200},"input":{"type":"structure","required":["Role","InputBucket","OutputBucket","Topics"],"members":{"Role":{},"InputBucket":{},"OutputBucket":{},"Topics":{"type":"list","member":{}}},"deprecated":true},"output":{"type":"structure","members":{"Success":{},"Messages":{"type":"list","member":{}}},"deprecated":true},"deprecated":true},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"InputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"UpdatePipelineNotifications":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/notifications"},"input":{"type":"structure","required":["Id","Notifications"],"members":{"Id":{"location":"uri","locationName":"Id"},"Notifications":{"shape":"S2a"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}},"UpdatePipelineStatus":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/status"},"input":{"type":"structure","required":["Id","Status"],"members":{"Id":{"location":"uri","locationName":"Id"},"Status":{}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}}},"shapes":{"S5":{"type":"structure","members":{"Key":{},"FrameRate":{},"Resolution":{},"AspectRatio":{},"Interlaced":{},"Container":{},"Encryption":{"shape":"Sc"},"TimeSpan":{"shape":"Sg"},"InputCaptions":{"type":"structure","members":{"MergePolicy":{},"CaptionSources":{"shape":"Sk"}}},"DetectedProperties":{"type":"structure","members":{"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"}}}}},"Sc":{"type":"structure","members":{"Mode":{},"Key":{},"KeyMd5":{},"InitializationVector":{}}},"Sg":{"type":"structure","members":{"StartTime":{},"Duration":{}}},"Sk":{"type":"list","member":{"type":"structure","members":{"Key":{},"Language":{},"TimeOffset":{},"Label":{},"Encryption":{"shape":"Sc"}}}},"St":{"type":"list","member":{"shape":"S5"}},"Su":{"type":"structure","members":{"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"}}},"Sx":{"type":"list","member":{"type":"structure","members":{"PresetWatermarkId":{},"InputKey":{},"Encryption":{"shape":"Sc"}}}},"S11":{"type":"structure","members":{"MergePolicy":{},"Artwork":{"type":"list","member":{"type":"structure","members":{"InputKey":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{},"AlbumArtFormat":{},"Encryption":{"shape":"Sc"}}}}}},"S19":{"type":"list","member":{"type":"structure","members":{"TimeSpan":{"shape":"Sg"}},"deprecated":true},"deprecated":true},"S1b":{"type":"structure","members":{"MergePolicy":{"deprecated":true},"CaptionSources":{"shape":"Sk","deprecated":true},"CaptionFormats":{"type":"list","member":{"type":"structure","members":{"Format":{},"Pattern":{},"Encryption":{"shape":"Sc"}}}}}},"S1l":{"type":"list","member":{}},"S1m":{"type":"structure","members":{"Method":{},"Key":{},"KeyMd5":{},"InitializationVector":{},"LicenseAcquisitionUrl":{},"KeyStoragePolicy":{}}},"S1q":{"type":"structure","members":{"Format":{},"Key":{},"KeyMd5":{},"KeyId":{},"InitializationVector":{},"LicenseAcquisitionUrl":{}}},"S1v":{"type":"map","key":{},"value":{}},"S1y":{"type":"structure","members":{"Id":{},"Arn":{},"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"S1z"},"Outputs":{"type":"list","member":{"shape":"S1z"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"},"Status":{},"StatusDetail":{}}}},"Status":{},"UserMetadata":{"shape":"S1v"},"Timing":{"type":"structure","members":{"SubmitTimeMillis":{"type":"long"},"StartTimeMillis":{"type":"long"},"FinishTimeMillis":{"type":"long"}}}}},"S1z":{"type":"structure","members":{"Id":{},"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Status":{},"StatusDetail":{},"Duration":{"type":"long"},"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"},"AppliedColorSpaceConversion":{}}},"S2a":{"type":"structure","members":{"Progressing":{},"Completed":{},"Warning":{},"Error":{}}},"S2c":{"type":"structure","members":{"Bucket":{},"StorageClass":{},"Permissions":{"type":"list","member":{"type":"structure","members":{"GranteeType":{},"Grantee":{},"Access":{"type":"list","member":{}}}}}}},"S2l":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Status":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Code":{},"Message":{}}}},"S2r":{"type":"structure","members":{"Codec":{},"CodecOptions":{"type":"map","key":{},"value":{}},"KeyframesMaxDist":{},"FixedGOP":{},"BitRate":{},"FrameRate":{},"MaxFrameRate":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"DisplayAspectRatio":{},"SizingPolicy":{},"PaddingPolicy":{},"Watermarks":{"type":"list","member":{"type":"structure","members":{"Id":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"HorizontalAlign":{},"HorizontalOffset":{},"VerticalAlign":{},"VerticalOffset":{},"Opacity":{},"Target":{}}}}}},"S37":{"type":"structure","members":{"Codec":{},"SampleRate":{},"BitRate":{},"Channels":{},"AudioPackingMode":{},"CodecOptions":{"type":"structure","members":{"Profile":{},"BitDepth":{},"BitOrder":{},"Signed":{}}}}},"S3i":{"type":"structure","members":{"Format":{},"Interval":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{}}},"S3m":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Container":{},"Audio":{"shape":"S37"},"Video":{"shape":"S2r"},"Thumbnails":{"shape":"S3i"},"Type":{}}},"S3v":{"type":"list","member":{"shape":"S1y"}}}}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListJobsByPipeline":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListJobsByStatus":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListPipelines":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Pipelines"},"ListPresets":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Presets"}}}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"JobComplete":{"delay":30,"operation":"ReadJob","maxAttempts":120,"acceptors":[{"expected":"Complete","matcher":"path","state":"success","argument":"Job.Status"},{"expected":"Canceled","matcher":"path","state":"failure","argument":"Job.Status"},{"expected":"Error","matcher":"path","state":"failure","argument":"Job.Status"}]}}}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"email","protocol":"query","serviceAbbreviation":"Amazon SES","serviceFullName":"Amazon Simple Email Service","serviceId":"SES","signatureVersion":"v4","signingName":"ses","uid":"email-2010-12-01","xmlNamespace":"http://ses.amazonaws.com/doc/2010-12-01/"},"operations":{"CloneReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","OriginalRuleSetName"],"members":{"RuleSetName":{},"OriginalRuleSetName":{}}},"output":{"resultWrapper":"CloneReceiptRuleSetResult","type":"structure","members":{}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSet"],"members":{"ConfigurationSet":{"shape":"S5"}}},"output":{"resultWrapper":"CreateConfigurationSetResult","type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"CreateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"CreateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"CreateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"CreateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"CreateReceiptFilter":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{"shape":"S10"}}},"output":{"resultWrapper":"CreateReceiptFilterResult","type":"structure","members":{}}},"CreateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"After":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"CreateReceiptRuleResult","type":"structure","members":{}}},"CreateReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"CreateReceiptRuleSetResult","type":"structure","members":{}}},"CreateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"CreateTemplateResult","type":"structure","members":{}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetResult","type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetEventDestinationResult","type":"structure","members":{}}},"DeleteConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"DeleteCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}}},"DeleteIdentity":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"DeleteIdentityResult","type":"structure","members":{}}},"DeleteIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName"],"members":{"Identity":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteIdentityPolicyResult","type":"structure","members":{}}},"DeleteReceiptFilter":{"input":{"type":"structure","required":["FilterName"],"members":{"FilterName":{}}},"output":{"resultWrapper":"DeleteReceiptFilterResult","type":"structure","members":{}}},"DeleteReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleResult","type":"structure","members":{}}},"DeleteReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleSetResult","type":"structure","members":{}}},"DeleteTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"DeleteTemplateResult","type":"structure","members":{}}},"DeleteVerifiedEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"DescribeActiveReceiptRuleSet":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeActiveReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"DescribeConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"ConfigurationSetAttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeConfigurationSetResult","type":"structure","members":{"ConfigurationSet":{"shape":"S5"},"EventDestinations":{"type":"list","member":{"shape":"S9"}},"TrackingOptions":{"shape":"Sp"},"DeliveryOptions":{"shape":"S31"},"ReputationOptions":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"},"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}}}}},"DescribeReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleResult","type":"structure","members":{"Rule":{"shape":"S18"}}}},"DescribeReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"GetAccountSendingEnabled":{"output":{"resultWrapper":"GetAccountSendingEnabledResult","type":"structure","members":{"Enabled":{"type":"boolean"}}}},"GetCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetCustomVerificationEmailTemplateResult","type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"GetIdentityDkimAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityDkimAttributesResult","type":"structure","required":["DkimAttributes"],"members":{"DkimAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["DkimEnabled","DkimVerificationStatus"],"members":{"DkimEnabled":{"type":"boolean"},"DkimVerificationStatus":{},"DkimTokens":{"shape":"S3h"}}}}}}},"GetIdentityMailFromDomainAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityMailFromDomainAttributesResult","type":"structure","required":["MailFromDomainAttributes"],"members":{"MailFromDomainAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMXFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMXFailure":{}}}}}}},"GetIdentityNotificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityNotificationAttributesResult","type":"structure","required":["NotificationAttributes"],"members":{"NotificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["BounceTopic","ComplaintTopic","DeliveryTopic","ForwardingEnabled"],"members":{"BounceTopic":{},"ComplaintTopic":{},"DeliveryTopic":{},"ForwardingEnabled":{"type":"boolean"},"HeadersInBounceNotificationsEnabled":{"type":"boolean"},"HeadersInComplaintNotificationsEnabled":{"type":"boolean"},"HeadersInDeliveryNotificationsEnabled":{"type":"boolean"}}}}}}},"GetIdentityPolicies":{"input":{"type":"structure","required":["Identity","PolicyNames"],"members":{"Identity":{},"PolicyNames":{"shape":"S3w"}}},"output":{"resultWrapper":"GetIdentityPoliciesResult","type":"structure","required":["Policies"],"members":{"Policies":{"type":"map","key":{},"value":{}}}}},"GetIdentityVerificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityVerificationAttributesResult","type":"structure","required":["VerificationAttributes"],"members":{"VerificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["VerificationStatus"],"members":{"VerificationStatus":{},"VerificationToken":{}}}}}}},"GetSendQuota":{"output":{"resultWrapper":"GetSendQuotaResult","type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}}},"GetSendStatistics":{"output":{"resultWrapper":"GetSendStatisticsResult","type":"structure","members":{"SendDataPoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"DeliveryAttempts":{"type":"long"},"Bounces":{"type":"long"},"Complaints":{"type":"long"},"Rejects":{"type":"long"}}}}}}},"GetTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"Template":{"shape":"S20"}}}},"ListConfigurationSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListConfigurationSetsResult","type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListCustomVerificationEmailTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListCustomVerificationEmailTemplatesResult","type":"structure","members":{"CustomVerificationEmailTemplates":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"NextToken":{}}}},"ListIdentities":{"input":{"type":"structure","members":{"IdentityType":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListIdentitiesResult","type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"},"NextToken":{}}}},"ListIdentityPolicies":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"ListIdentityPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S3w"}}}},"ListReceiptFilters":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListReceiptFiltersResult","type":"structure","members":{"Filters":{"type":"list","member":{"shape":"S10"}}}}},"ListReceiptRuleSets":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListReceiptRuleSetsResult","type":"structure","members":{"RuleSets":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListTemplatesResult","type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListVerifiedEmailAddresses":{"output":{"resultWrapper":"ListVerifiedEmailAddressesResult","type":"structure","members":{"VerifiedEmailAddresses":{"shape":"S54"}}}},"PutConfigurationSetDeliveryOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"DeliveryOptions":{"shape":"S31"}}},"output":{"resultWrapper":"PutConfigurationSetDeliveryOptionsResult","type":"structure","members":{}}},"PutIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName","Policy"],"members":{"Identity":{},"PolicyName":{},"Policy":{}}},"output":{"resultWrapper":"PutIdentityPolicyResult","type":"structure","members":{}}},"ReorderReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","RuleNames"],"members":{"RuleSetName":{},"RuleNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"ReorderReceiptRuleSetResult","type":"structure","members":{}}},"SendBounce":{"input":{"type":"structure","required":["OriginalMessageId","BounceSender","BouncedRecipientInfoList"],"members":{"OriginalMessageId":{},"BounceSender":{},"Explanation":{},"MessageDsn":{"type":"structure","required":["ReportingMta"],"members":{"ReportingMta":{},"ArrivalDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}},"BouncedRecipientInfoList":{"type":"list","member":{"type":"structure","required":["Recipient"],"members":{"Recipient":{},"RecipientArn":{},"BounceType":{},"RecipientDsnFields":{"type":"structure","required":["Action","Status"],"members":{"FinalRecipient":{},"Action":{},"RemoteMta":{},"Status":{},"DiagnosticCode":{},"LastAttemptDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}}}}},"BounceSenderArn":{}}},"output":{"resultWrapper":"SendBounceResult","type":"structure","members":{"MessageId":{}}}},"SendBulkTemplatedEmail":{"input":{"type":"structure","required":["Source","Template","Destinations"],"members":{"Source":{},"SourceArn":{},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"ReturnPathArn":{},"ConfigurationSetName":{},"DefaultTags":{"shape":"S5x"},"Template":{},"TemplateArn":{},"DefaultTemplateData":{},"Destinations":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S64"},"ReplacementTags":{"shape":"S5x"},"ReplacementTemplateData":{}}}}}},"output":{"resultWrapper":"SendBulkTemplatedEmailResult","type":"structure","required":["Status"],"members":{"Status":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendCustomVerificationEmail":{"input":{"type":"structure","required":["EmailAddress","TemplateName"],"members":{"EmailAddress":{},"TemplateName":{},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendCustomVerificationEmailResult","type":"structure","members":{"MessageId":{}}}},"SendEmail":{"input":{"type":"structure","required":["Source","Destination","Message"],"members":{"Source":{},"Destination":{"shape":"S64"},"Message":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S6e"},"Body":{"type":"structure","members":{"Text":{"shape":"S6e"},"Html":{"shape":"S6e"}}}}},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendRawEmail":{"input":{"type":"structure","required":["RawMessage"],"members":{"Source":{},"Destinations":{"shape":"S54"},"RawMessage":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"FromArn":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendRawEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendTemplatedEmail":{"input":{"type":"structure","required":["Source","Destination","Template","TemplateData"],"members":{"Source":{},"Destination":{"shape":"S64"},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{},"Template":{},"TemplateArn":{},"TemplateData":{}}},"output":{"resultWrapper":"SendTemplatedEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SetActiveReceiptRuleSet":{"input":{"type":"structure","members":{"RuleSetName":{}}},"output":{"resultWrapper":"SetActiveReceiptRuleSetResult","type":"structure","members":{}}},"SetIdentityDkimEnabled":{"input":{"type":"structure","required":["Identity","DkimEnabled"],"members":{"Identity":{},"DkimEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityDkimEnabledResult","type":"structure","members":{}}},"SetIdentityFeedbackForwardingEnabled":{"input":{"type":"structure","required":["Identity","ForwardingEnabled"],"members":{"Identity":{},"ForwardingEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityFeedbackForwardingEnabledResult","type":"structure","members":{}}},"SetIdentityHeadersInNotificationsEnabled":{"input":{"type":"structure","required":["Identity","NotificationType","Enabled"],"members":{"Identity":{},"NotificationType":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityHeadersInNotificationsEnabledResult","type":"structure","members":{}}},"SetIdentityMailFromDomain":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{},"MailFromDomain":{},"BehaviorOnMXFailure":{}}},"output":{"resultWrapper":"SetIdentityMailFromDomainResult","type":"structure","members":{}}},"SetIdentityNotificationTopic":{"input":{"type":"structure","required":["Identity","NotificationType"],"members":{"Identity":{},"NotificationType":{},"SnsTopic":{}}},"output":{"resultWrapper":"SetIdentityNotificationTopicResult","type":"structure","members":{}}},"SetReceiptRulePosition":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{},"After":{}}},"output":{"resultWrapper":"SetReceiptRulePositionResult","type":"structure","members":{}}},"TestRenderTemplate":{"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{},"TemplateData":{}}},"output":{"resultWrapper":"TestRenderTemplateResult","type":"structure","members":{"RenderedTemplate":{}}}},"UpdateAccountSendingEnabled":{"input":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"UpdateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"UpdateConfigurationSetReputationMetricsEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetSendingEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"UpdateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"UpdateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"UpdateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"UpdateReceiptRuleResult","type":"structure","members":{}}},"UpdateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"UpdateTemplateResult","type":"structure","members":{}}},"VerifyDomainDkim":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainDkimResult","type":"structure","required":["DkimTokens"],"members":{"DkimTokens":{"shape":"S3h"}}}},"VerifyDomainIdentity":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainIdentityResult","type":"structure","required":["VerificationToken"],"members":{"VerificationToken":{}}}},"VerifyEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"VerifyEmailIdentity":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}},"output":{"resultWrapper":"VerifyEmailIdentityResult","type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S9":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"type":"list","member":{}},"KinesisFirehoseDestination":{"type":"structure","required":["IAMRoleARN","DeliveryStreamARN"],"members":{"IAMRoleARN":{},"DeliveryStreamARN":{}}},"CloudWatchDestination":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"SNSDestination":{"type":"structure","required":["TopicARN"],"members":{"TopicARN":{}}}}},"Sp":{"type":"structure","members":{"CustomRedirectDomain":{}}},"S10":{"type":"structure","required":["Name","IpFilter"],"members":{"Name":{},"IpFilter":{"type":"structure","required":["Policy","Cidr"],"members":{"Policy":{},"Cidr":{}}}}},"S18":{"type":"structure","required":["Name"],"members":{"Name":{},"Enabled":{"type":"boolean"},"TlsPolicy":{},"Recipients":{"type":"list","member":{}},"Actions":{"type":"list","member":{"type":"structure","members":{"S3Action":{"type":"structure","required":["BucketName"],"members":{"TopicArn":{},"BucketName":{},"ObjectKeyPrefix":{},"KmsKeyArn":{}}},"BounceAction":{"type":"structure","required":["SmtpReplyCode","Message","Sender"],"members":{"TopicArn":{},"SmtpReplyCode":{},"StatusCode":{},"Message":{},"Sender":{}}},"WorkmailAction":{"type":"structure","required":["OrganizationArn"],"members":{"TopicArn":{},"OrganizationArn":{}}},"LambdaAction":{"type":"structure","required":["FunctionArn"],"members":{"TopicArn":{},"FunctionArn":{},"InvocationType":{}}},"StopAction":{"type":"structure","required":["Scope"],"members":{"Scope":{},"TopicArn":{}}},"AddHeaderAction":{"type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}},"SNSAction":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"Encoding":{}}}}}},"ScanEnabled":{"type":"boolean"}}},"S20":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"SubjectPart":{},"TextPart":{},"HtmlPart":{}}},"S2t":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}},"S2v":{"type":"list","member":{"shape":"S18"}},"S31":{"type":"structure","members":{"TlsPolicy":{}}},"S3c":{"type":"list","member":{}},"S3h":{"type":"list","member":{}},"S3w":{"type":"list","member":{}},"S54":{"type":"list","member":{}},"S5i":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5x":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S64":{"type":"structure","members":{"ToAddresses":{"shape":"S54"},"CcAddresses":{"shape":"S54"},"BccAddresses":{"shape":"S54"}}},"S6e":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}}}}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCustomVerificationEmailTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListIdentities":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"Identities"},"ListVerifiedEmailAddresses":{"result_key":"VerifiedEmailAddresses"}}}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","serviceId":"CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S20"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{},"EventBusName":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","required":["Action","Principal","StatementId"],"members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S5"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S20"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["StatementId"],"members":{"StatementId":{},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S20":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S2m"},"SecurityGroups":{"shape":"S2m"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}}}}},"S2m":{"type":"list","member":{}},"S2y":{"type":"list","member":{}}}}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-04","endpointPrefix":"firehose","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Firehose","serviceFullName":"Amazon Kinesis Firehose","serviceId":"Firehose","signatureVersion":"v4","targetPrefix":"Firehose_20150804","uid":"firehose-2015-08-04"},"operations":{"CreateDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamType":{},"KinesisStreamSourceConfiguration":{"type":"structure","required":["KinesisStreamARN","RoleARN"],"members":{"KinesisStreamARN":{},"RoleARN":{}}},"DeliveryStreamEncryptionConfigurationInput":{"shape":"S7"},"S3DestinationConfiguration":{"shape":"Sa","deprecated":true},"ExtendedS3DestinationConfiguration":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"Sa"},"DataFormatConversionConfiguration":{"shape":"Sz"}}},"RedshiftDestinationConfiguration":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","Password","S3Configuration"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1q"},"Username":{"shape":"S1u"},"Password":{"shape":"S1v"},"RetryOptions":{"shape":"S1w"},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"Sa"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationConfiguration":{"type":"structure","required":["RoleARN","IndexName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S25"},"RetryOptions":{"shape":"S28"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfiguration":{"type":"structure","required":["SubnetIds","RoleARN","SecurityGroupIds"],"members":{"SubnetIds":{"shape":"S2c"},"RoleARN":{},"SecurityGroupIds":{"shape":"S2d"}}}}},"SplunkDestinationConfiguration":{"type":"structure","required":["HECEndpoint","HECEndpointType","HECToken","S3Configuration"],"members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2j"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"Tags":{"shape":"S2m"}}},"output":{"type":"structure","members":{"DeliveryStreamARN":{}}}},"DeleteDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"AllowForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"Limit":{"type":"integer"},"ExclusiveStartDestinationId":{}}},"output":{"type":"structure","required":["DeliveryStreamDescription"],"members":{"DeliveryStreamDescription":{"type":"structure","required":["DeliveryStreamName","DeliveryStreamARN","DeliveryStreamStatus","DeliveryStreamType","VersionId","Destinations","HasMoreDestinations"],"members":{"DeliveryStreamName":{},"DeliveryStreamARN":{},"DeliveryStreamStatus":{},"FailureDescription":{"shape":"S30"},"DeliveryStreamEncryptionConfiguration":{"type":"structure","members":{"KeyARN":{},"KeyType":{},"Status":{},"FailureDescription":{"shape":"S30"}}},"DeliveryStreamType":{},"VersionId":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Source":{"type":"structure","members":{"KinesisStreamSourceDescription":{"type":"structure","members":{"KinesisStreamARN":{},"RoleARN":{},"DeliveryStartTimestamp":{"type":"timestamp"}}}}},"Destinations":{"type":"list","member":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{},"S3DestinationDescription":{"shape":"S3b"},"ExtendedS3DestinationDescription":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S3b"},"DataFormatConversionConfiguration":{"shape":"Sz"}}},"RedshiftDestinationDescription":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","S3DestinationDescription"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1q"},"Username":{"shape":"S1u"},"RetryOptions":{"shape":"S1w"},"S3DestinationDescription":{"shape":"S3b"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S3b"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S25"},"RetryOptions":{"shape":"S28"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S3b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfigurationDescription":{"type":"structure","required":["SubnetIds","RoleARN","SecurityGroupIds","VpcId"],"members":{"SubnetIds":{"shape":"S2c"},"RoleARN":{},"SecurityGroupIds":{"shape":"S2d"},"VpcId":{}}}}},"SplunkDestinationDescription":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2j"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S3b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}}}}},"HasMoreDestinations":{"type":"boolean"}}}}}},"ListDeliveryStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"DeliveryStreamType":{},"ExclusiveStartDeliveryStreamName":{}}},"output":{"type":"structure","required":["DeliveryStreamNames","HasMoreDeliveryStreams"],"members":{"DeliveryStreamNames":{"type":"list","member":{}},"HasMoreDeliveryStreams":{"type":"boolean"}}}},"ListTagsForDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"shape":"S2n"}},"HasMoreTags":{"type":"boolean"}}}},"PutRecord":{"input":{"type":"structure","required":["DeliveryStreamName","Record"],"members":{"DeliveryStreamName":{},"Record":{"shape":"S3q"}}},"output":{"type":"structure","required":["RecordId"],"members":{"RecordId":{},"Encrypted":{"type":"boolean"}}}},"PutRecordBatch":{"input":{"type":"structure","required":["DeliveryStreamName","Records"],"members":{"DeliveryStreamName":{},"Records":{"type":"list","member":{"shape":"S3q"}}}},"output":{"type":"structure","required":["FailedPutCount","RequestResponses"],"members":{"FailedPutCount":{"type":"integer"},"Encrypted":{"type":"boolean"},"RequestResponses":{"type":"list","member":{"type":"structure","members":{"RecordId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamEncryptionConfigurationInput":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"StopDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"TagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","Tags"],"members":{"DeliveryStreamName":{},"Tags":{"shape":"S2m"}}},"output":{"type":"structure","members":{}}},"UntagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","TagKeys"],"members":{"DeliveryStreamName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDestination":{"input":{"type":"structure","required":["DeliveryStreamName","CurrentDeliveryStreamVersionId","DestinationId"],"members":{"DeliveryStreamName":{},"CurrentDeliveryStreamVersionId":{},"DestinationId":{},"S3DestinationUpdate":{"shape":"S4b","deprecated":true},"ExtendedS3DestinationUpdate":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S4b"},"DataFormatConversionConfiguration":{"shape":"Sz"}}},"RedshiftDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1q"},"Username":{"shape":"S1u"},"Password":{"shape":"S1v"},"RetryOptions":{"shape":"S1w"},"S3Update":{"shape":"S4b"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S4b"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S25"},"RetryOptions":{"shape":"S28"},"S3Update":{"shape":"S4b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"SplunkDestinationUpdate":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2j"},"S3BackupMode":{},"S3Update":{"shape":"S4b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","required":["KeyType"],"members":{"KeyARN":{},"KeyType":{}}},"Sa":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"Se":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"Si":{"type":"structure","members":{"NoEncryptionConfig":{},"KMSEncryptionConfig":{"type":"structure","required":["AWSKMSKeyARN"],"members":{"AWSKMSKeyARN":{}}}}},"Sl":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogGroupName":{},"LogStreamName":{}}},"Sq":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Processors":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}}}}}}},"Sz":{"type":"structure","members":{"SchemaConfiguration":{"type":"structure","members":{"RoleARN":{},"CatalogId":{},"DatabaseName":{},"TableName":{},"Region":{},"VersionId":{}}},"InputFormatConfiguration":{"type":"structure","members":{"Deserializer":{"type":"structure","members":{"OpenXJsonSerDe":{"type":"structure","members":{"ConvertDotsInJsonKeysToUnderscores":{"type":"boolean"},"CaseInsensitive":{"type":"boolean"},"ColumnToJsonKeyMappings":{"type":"map","key":{},"value":{}}}},"HiveJsonSerDe":{"type":"structure","members":{"TimestampFormats":{"type":"list","member":{}}}}}}}},"OutputFormatConfiguration":{"type":"structure","members":{"Serializer":{"type":"structure","members":{"ParquetSerDe":{"type":"structure","members":{"BlockSizeBytes":{"type":"integer"},"PageSizeBytes":{"type":"integer"},"Compression":{},"EnableDictionaryCompression":{"type":"boolean"},"MaxPaddingBytes":{"type":"integer"},"WriterVersion":{}}},"OrcSerDe":{"type":"structure","members":{"StripeSizeBytes":{"type":"integer"},"BlockSizeBytes":{"type":"integer"},"RowIndexStride":{"type":"integer"},"EnablePadding":{"type":"boolean"},"PaddingTolerance":{"type":"double"},"Compression":{},"BloomFilterColumns":{"type":"list","member":{}},"BloomFilterFalsePositiveProbability":{"type":"double"},"DictionaryKeyThreshold":{"type":"double"},"FormatVersion":{}}}}}}},"Enabled":{"type":"boolean"}}},"S1q":{"type":"structure","required":["DataTableName"],"members":{"DataTableName":{},"DataTableColumns":{},"CopyOptions":{}}},"S1u":{"type":"string","sensitive":true},"S1v":{"type":"string","sensitive":true},"S1w":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S25":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S28":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2c":{"type":"list","member":{}},"S2d":{"type":"list","member":{}},"S2j":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2m":{"type":"list","member":{"shape":"S2n"}},"S2n":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}},"S30":{"type":"structure","required":["Type","Details"],"members":{"Type":{},"Details":{}}},"S3b":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"S3q":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"S4b":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}}}}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecast","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Service","serviceId":"forecast","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecast","uid":"forecast-2018-06-26"},"operations":{"CreateDataset":{"input":{"type":"structure","required":["DatasetName","Domain","DatasetType","Schema"],"members":{"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"S6"},"EncryptionConfig":{"shape":"Sa"}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupName","Domain"],"members":{"DatasetGroupName":{},"Domain":{},"DatasetArns":{"shape":"Sf"}}},"output":{"type":"structure","members":{"DatasetGroupArn":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobName","DatasetArn","DataSource"],"members":{"DatasetImportJobName":{},"DatasetArn":{},"DataSource":{"shape":"Si"},"TimestampFormat":{}}},"output":{"type":"structure","members":{"DatasetImportJobArn":{}}}},"CreateForecast":{"input":{"type":"structure","required":["ForecastName","PredictorArn"],"members":{"ForecastName":{},"PredictorArn":{},"ForecastTypes":{"shape":"So"}}},"output":{"type":"structure","members":{"ForecastArn":{}}}},"CreateForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobName","ForecastArn","Destination"],"members":{"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"Ss"}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{}}}},"CreatePredictor":{"input":{"type":"structure","required":["PredictorName","ForecastHorizon","InputDataConfig","FeaturizationConfig"],"members":{"PredictorName":{},"AlgorithmArn":{},"ForecastHorizon":{"type":"integer"},"PerformAutoML":{"type":"boolean"},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"Sx"},"EvaluationParameters":{"shape":"S10"},"HPOConfig":{"shape":"S11"},"InputDataConfig":{"shape":"S1d"},"FeaturizationConfig":{"shape":"S1g"},"EncryptionConfig":{"shape":"Sa"}}},"output":{"type":"structure","members":{"PredictorArn":{}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"idempotent":true},"DeleteDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"idempotent":true},"DeleteForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"idempotent":true},"DeleteForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"idempotent":true},"DeletePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"S6"},"EncryptionConfig":{"shape":"Sa"},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"output":{"type":"structure","members":{"DatasetGroupName":{},"DatasetGroupArn":{},"DatasetArns":{"shape":"Sf"},"Domain":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"output":{"type":"structure","members":{"DatasetImportJobName":{},"DatasetImportJobArn":{},"DatasetArn":{},"TimestampFormat":{},"DataSource":{"shape":"Si"},"FieldStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"Count":{"type":"integer"},"CountDistinct":{"type":"integer"},"CountNull":{"type":"integer"},"CountNan":{"type":"integer"},"Min":{},"Max":{},"Avg":{"type":"double"},"Stddev":{"type":"double"}}}},"DataSize":{"type":"double"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"output":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"ForecastTypes":{"shape":"So"},"PredictorArn":{},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"Ss"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"AlgorithmArn":{},"ForecastHorizon":{"type":"integer"},"PerformAutoML":{"type":"boolean"},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"Sx"},"EvaluationParameters":{"shape":"S10"},"HPOConfig":{"shape":"S11"},"InputDataConfig":{"shape":"S1d"},"FeaturizationConfig":{"shape":"S1g"},"EncryptionConfig":{"shape":"Sa"},"PredictorExecutionDetails":{"type":"structure","members":{"PredictorExecutions":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"Status":{},"Message":{}}}}}}}}},"DatasetImportJobArns":{"shape":"Sf"},"AutoMLAlgorithmArns":{"shape":"Sf"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"GetAccuracyMetrics":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorEvaluationResults":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"ItemCount":{"type":"integer"},"EvaluationType":{},"Metrics":{"type":"structure","members":{"RMSE":{"type":"double"},"WeightedQuantileLosses":{"type":"list","member":{"type":"structure","members":{"Quantile":{"type":"double"},"LossValue":{"type":"double"}}}}}}}}}}}}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetGroups":{"type":"list","member":{"type":"structure","members":{"DatasetGroupArn":{},"DatasetGroupName":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S30"}}},"output":{"type":"structure","members":{"DatasetImportJobs":{"type":"list","member":{"type":"structure","members":{"DatasetImportJobArn":{},"DatasetImportJobName":{},"DataSource":{"shape":"Si"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"DatasetType":{},"Domain":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecastExportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S30"}}},"output":{"type":"structure","members":{"ForecastExportJobs":{"type":"list","member":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"Destination":{"shape":"Ss"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecasts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S30"}}},"output":{"type":"structure","members":{"Forecasts":{"type":"list","member":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"PredictorArn":{},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPredictors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S30"}}},"output":{"type":"structure","members":{"Predictors":{"type":"list","member":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"UpdateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn","DatasetArns"],"members":{"DatasetGroupArn":{},"DatasetArns":{"shape":"Sf"}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"S6":{"type":"structure","members":{"Attributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{}}}}}},"Sa":{"type":"structure","required":["RoleArn","KMSKeyArn"],"members":{"RoleArn":{},"KMSKeyArn":{}}},"Sf":{"type":"list","member":{}},"Si":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"Sj"}}},"Sj":{"type":"structure","required":["Path","RoleArn"],"members":{"Path":{},"RoleArn":{},"KMSKeyArn":{}}},"So":{"type":"list","member":{}},"Ss":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"Sj"}}},"Sx":{"type":"map","key":{},"value":{}},"S10":{"type":"structure","members":{"NumberOfBacktestWindows":{"type":"integer"},"BackTestWindowOffset":{"type":"integer"}}},"S11":{"type":"structure","members":{"ParameterRanges":{"type":"structure","members":{"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"ContinuousParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"double"},"MinValue":{"type":"double"},"ScalingType":{}}}},"IntegerParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"integer"},"MinValue":{"type":"integer"},"ScalingType":{}}}}}}}},"S1d":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{},"SupplementaryFeatures":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"S1g":{"type":"structure","required":["ForecastFrequency"],"members":{"ForecastFrequency":{},"ForecastDimensions":{"type":"list","member":{}},"Featurizations":{"type":"list","member":{"type":"structure","required":["AttributeName"],"members":{"AttributeName":{},"FeaturizationPipeline":{"type":"list","member":{"type":"structure","required":["FeaturizationMethodName"],"members":{"FeaturizationMethodName":{},"FeaturizationMethodParameters":{"type":"map","key":{},"value":{}}}}}}}}}},"S30":{"type":"list","member":{"type":"structure","required":["Key","Value","Condition"],"members":{"Key":{},"Value":{},"Condition":{}}}}}}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDatasetGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetGroups"},"ListDatasetImportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetImportJobs"},"ListDatasets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Datasets"},"ListForecastExportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ForecastExportJobs"},"ListForecasts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Forecasts"},"ListPredictors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Predictors"}}}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecastquery","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Query Service","serviceId":"forecastquery","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecastRuntime","uid":"forecastquery-2018-06-26"},"operations":{"QueryForecast":{"input":{"type":"structure","required":["ForecastArn","Filters"],"members":{"ForecastArn":{},"StartDate":{},"EndDate":{},"Filters":{"type":"map","key":{},"value":{}},"NextToken":{}}},"output":{"type":"structure","members":{"Forecast":{"type":"structure","members":{"Predictions":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Timestamp":{},"Value":{"type":"double"}}}}}}}}}}},"shapes":{}}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-01","endpointPrefix":"gamelift","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon GameLift","serviceId":"GameLift","signatureVersion":"v4","targetPrefix":"GameLift","uid":"gamelift-2015-10-01"},"operations":{"AcceptMatch":{"input":{"type":"structure","required":["TicketId","PlayerIds","AcceptanceType"],"members":{"TicketId":{},"PlayerIds":{"shape":"S3"},"AcceptanceType":{}}},"output":{"type":"structure","members":{}}},"ClaimGameServer":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"GameServerId":{},"GameServerData":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"CreateAlias":{"input":{"type":"structure","required":["Name","RoutingStrategy"],"members":{"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sn"},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sw"}}}},"CreateBuild":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"S10"},"OperatingSystem":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"Build":{"shape":"S14"},"UploadCredentials":{"shape":"S19"},"StorageLocation":{"shape":"S10"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","EC2InstanceType"],"members":{"Name":{},"Description":{},"BuildId":{},"ScriptId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"EC2InstanceType":{},"EC2InboundPermissions":{"shape":"S1e"},"NewGameSessionProtectionPolicy":{},"RuntimeConfiguration":{"shape":"S1k"},"ResourceCreationLimitPolicy":{"shape":"S1q"},"MetricGroups":{"shape":"S1s"},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"FleetType":{},"InstanceRoleArn":{},"CertificateConfiguration":{"shape":"S1v"},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"FleetAttributes":{"shape":"S1y"}}}},"CreateGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","RoleArn","MinSize","MaxSize","LaunchTemplate","InstanceDefinitions"],"members":{"GameServerGroupName":{},"RoleArn":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceDefinitions":{"shape":"S2b"},"AutoScalingPolicy":{"type":"structure","required":["TargetTrackingConfiguration"],"members":{"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}},"BalancingStrategy":{},"GameServerProtectionPolicy":{},"VpcSubnets":{"type":"list","member":{}},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2n"}}}},"CreateGameSession":{"input":{"type":"structure","required":["MaximumPlayerSessionCount"],"members":{"FleetId":{},"AliasId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"GameProperties":{"shape":"S2v"},"CreatorId":{},"GameSessionId":{},"IdempotencyToken":{},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S32"}}}},"CreateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S3b"},"Destinations":{"shape":"S3d"},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S3h"}}}},"CreateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name","GameSessionQueueArns","RequestTimeoutSeconds","AcceptanceRequired","RuleSetName"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S3k"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S2v"},"GameSessionData":{},"BackfillMode":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S3t"}}}},"CreateMatchmakingRuleSet":{"input":{"type":"structure","required":["Name","RuleSetBody"],"members":{"Name":{},"RuleSetBody":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","required":["RuleSet"],"members":{"RuleSet":{"shape":"S3z"}}}},"CreatePlayerSession":{"input":{"type":"structure","required":["GameSessionId","PlayerId"],"members":{"GameSessionId":{},"PlayerId":{},"PlayerData":{}}},"output":{"type":"structure","members":{"PlayerSession":{"shape":"S43"}}}},"CreatePlayerSessions":{"input":{"type":"structure","required":["GameSessionId","PlayerIds"],"members":{"GameSessionId":{},"PlayerIds":{"type":"list","member":{}},"PlayerDataMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S4a"}}}},"CreateScript":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"S10"},"ZipFile":{"type":"blob"},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"Script":{"shape":"S4e"}}}},"CreateVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"VpcPeeringAuthorization":{"shape":"S4h"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","PeerVpcAwsAccountId","PeerVpcId"],"members":{"FleetId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}}},"DeleteBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}}},"DeleteFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}}},"DeleteGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"DeleteOption":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2n"}}}},"DeleteGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingRuleSet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId"],"members":{"Name":{},"FleetId":{}}}},"DeleteScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}}},"DeleteVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","VpcPeeringConnectionId"],"members":{"FleetId":{},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{}}},"DeregisterGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{}}}},"DescribeAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sw"}}}},"DescribeBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S14"}}}},"DescribeEC2InstanceLimits":{"input":{"type":"structure","members":{"EC2InstanceType":{}}},"output":{"type":"structure","members":{"EC2InstanceLimits":{"type":"list","member":{"type":"structure","members":{"EC2InstanceType":{},"CurrentInstances":{"type":"integer"},"InstanceLimit":{"type":"integer"}}}}}}},"DescribeFleetAttributes":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S5e"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"type":"list","member":{"shape":"S1y"}},"NextToken":{}}}},"DescribeFleetCapacity":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S5e"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceType":{},"InstanceCounts":{"type":"structure","members":{"DESIRED":{"type":"integer"},"MINIMUM":{"type":"integer"},"MAXIMUM":{"type":"integer"},"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}}}}},"NextToken":{}}}},"DescribeFleetEvents":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ResourceId":{},"EventCode":{},"Message":{},"EventTime":{"type":"timestamp"},"PreSignedLogUrl":{}}}},"NextToken":{}}}},"DescribeFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"InboundPermissions":{"shape":"S1e"}}}},"DescribeFleetUtilization":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S5e"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"ActiveServerProcessCount":{"type":"integer"},"ActiveGameSessionCount":{"type":"integer"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"}}}},"NextToken":{}}}},"DescribeGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"DescribeGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2n"}}}},"DescribeGameSessionDetails":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionDetails":{"type":"list","member":{"type":"structure","members":{"GameSession":{"shape":"S32"},"ProtectionPolicy":{}}}},"NextToken":{}}}},"DescribeGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S67"}}}},"DescribeGameSessionQueues":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionQueues":{"type":"list","member":{"shape":"S3h"}},"NextToken":{}}}},"DescribeGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S6k"},"NextToken":{}}}},"DescribeInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InstanceId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"DnsName":{},"OperatingSystem":{},"Type":{},"Status":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMatchmaking":{"input":{"type":"structure","required":["TicketIds"],"members":{"TicketIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"TicketList":{"type":"list","member":{"shape":"S6v"}}}}},"DescribeMatchmakingConfigurations":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"RuleSetName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Configurations":{"type":"list","member":{"shape":"S3t"}},"NextToken":{}}}},"DescribeMatchmakingRuleSets":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["RuleSets"],"members":{"RuleSets":{"type":"list","member":{"shape":"S3z"}},"NextToken":{}}}},"DescribePlayerSessions":{"input":{"type":"structure","members":{"GameSessionId":{},"PlayerId":{},"PlayerSessionId":{},"PlayerSessionStatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S4a"},"NextToken":{}}}},"DescribeRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S1k"}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"Name":{},"Status":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"S7w"}}}},"NextToken":{}}}},"DescribeScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}},"output":{"type":"structure","members":{"Script":{"shape":"S4e"}}}},"DescribeVpcPeeringAuthorizations":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"VpcPeeringAuthorizations":{"type":"list","member":{"shape":"S4h"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"FleetId":{}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"IpV4CidrBlock":{},"VpcPeeringConnectionId":{},"Status":{"type":"structure","members":{"Code":{},"Message":{}}},"PeerVpcId":{},"GameLiftVpcId":{}}}}}}},"GetGameSessionLogUrl":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{}}},"output":{"type":"structure","members":{"PreSignedUrl":{}}}},"GetInstanceAccess":{"input":{"type":"structure","required":["FleetId","InstanceId"],"members":{"FleetId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"InstanceAccess":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Credentials":{"type":"structure","members":{"UserName":{},"Secret":{}},"sensitive":true}}}}}},"ListAliases":{"input":{"type":"structure","members":{"RoutingStrategyType":{},"Name":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"shape":"Sw"}},"NextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"Status":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Builds":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"ListFleets":{"input":{"type":"structure","members":{"BuildId":{},"ScriptId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetIds":{"type":"list","member":{}},"NextToken":{}}}},"ListGameServerGroups":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServerGroups":{"type":"list","member":{"shape":"S2n"}},"NextToken":{}}}},"ListGameServers":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"SortOrder":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServers":{"type":"list","member":{"shape":"Sc"}},"NextToken":{}}}},"ListScripts":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Scripts":{"type":"list","member":{"shape":"S4e"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sr"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId","MetricName"],"members":{"Name":{},"FleetId":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"Threshold":{"type":"double"},"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"S7w"}}},"output":{"type":"structure","members":{"Name":{}}}},"RegisterGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId","InstanceId"],"members":{"GameServerGroupName":{},"GameServerId":{},"InstanceId":{},"ConnectionInfo":{},"GameServerData":{},"CustomSortKey":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"RequestUploadCredentials":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"UploadCredentials":{"shape":"S19"},"StorageLocation":{"shape":"S10"}}}},"ResolveAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"ResumeGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","ResumeActions"],"members":{"GameServerGroupName":{},"ResumeActions":{"shape":"S2q"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2n"}}}},"SearchGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"AliasId":{},"FilterExpression":{},"SortExpression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S6k"},"NextToken":{}}}},"StartFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S23"}}},"output":{"type":"structure","members":{}}},"StartGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId","GameSessionQueueName","MaximumPlayerSessionCount"],"members":{"PlacementId":{},"GameSessionQueueName":{},"GameProperties":{"shape":"S2v"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"PlayerLatencies":{"shape":"S69"},"DesiredPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerData":{}}}},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S67"}}}},"StartMatchBackfill":{"input":{"type":"structure","required":["ConfigurationName","GameSessionArn","Players"],"members":{"TicketId":{},"ConfigurationName":{},"GameSessionArn":{},"Players":{"shape":"S6y"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S6v"}}}},"StartMatchmaking":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"Players":{"shape":"S6y"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S6v"}}}},"StopFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S23"}}},"output":{"type":"structure","members":{}}},"StopGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S67"}}}},"StopMatchmaking":{"input":{"type":"structure","required":["TicketId"],"members":{"TicketId":{}}},"output":{"type":"structure","members":{}}},"SuspendGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","SuspendActions"],"members":{"GameServerGroupName":{},"SuspendActions":{"shape":"S2q"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2n"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sn"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sw"}}}},"UpdateBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{},"Name":{},"Version":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S14"}}}},"UpdateFleetAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Name":{},"Description":{},"NewGameSessionProtectionPolicy":{},"ResourceCreationLimitPolicy":{"shape":"S1q"},"MetricGroups":{"shape":"S1s"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetCapacity":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"DesiredInstances":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InboundPermissionAuthorizations":{"shape":"S1e"},"InboundPermissionRevocations":{"shape":"S1e"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{},"GameServerData":{},"CustomSortKey":{},"UtilizationStatus":{},"HealthCheck":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"UpdateGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"RoleArn":{},"InstanceDefinitions":{"shape":"S2b"},"GameServerProtectionPolicy":{},"BalancingStrategy":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2n"}}}},"UpdateGameSession":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"PlayerSessionCreationPolicy":{},"ProtectionPolicy":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S32"}}}},"UpdateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S3b"},"Destinations":{"shape":"S3d"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S3h"}}}},"UpdateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S3k"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S2v"},"GameSessionData":{},"BackfillMode":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S3t"}}}},"UpdateRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId","RuntimeConfiguration"],"members":{"FleetId":{},"RuntimeConfiguration":{"shape":"S1k"}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S1k"}}}},"UpdateScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{},"Name":{},"Version":{},"StorageLocation":{"shape":"S10"},"ZipFile":{"type":"blob"}}},"output":{"type":"structure","members":{"Script":{"shape":"S4e"}}}},"ValidateMatchmakingRuleSet":{"input":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetBody":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{}},"Sc":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"GameServerId":{},"InstanceId":{},"ConnectionInfo":{},"GameServerData":{},"CustomSortKey":{},"ClaimStatus":{},"UtilizationStatus":{},"RegistrationTime":{"type":"timestamp"},"LastClaimTime":{"type":"timestamp"},"LastHealthCheckTime":{"type":"timestamp"}}},"Sn":{"type":"structure","members":{"Type":{},"FleetId":{},"Message":{}}},"Sr":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sw":{"type":"structure","members":{"AliasId":{},"Name":{},"AliasArn":{},"Description":{},"RoutingStrategy":{"shape":"Sn"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S10":{"type":"structure","members":{"Bucket":{},"Key":{},"RoleArn":{},"ObjectVersion":{}}},"S14":{"type":"structure","members":{"BuildId":{},"BuildArn":{},"Name":{},"Version":{},"Status":{},"SizeOnDisk":{"type":"long"},"OperatingSystem":{},"CreationTime":{"type":"timestamp"}}},"S19":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{}},"sensitive":true},"S1e":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","IpRange","Protocol"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"IpRange":{},"Protocol":{}}}},"S1k":{"type":"structure","members":{"ServerProcesses":{"type":"list","member":{"type":"structure","required":["LaunchPath","ConcurrentExecutions"],"members":{"LaunchPath":{},"Parameters":{},"ConcurrentExecutions":{"type":"integer"}}}},"MaxConcurrentGameSessionActivations":{"type":"integer"},"GameSessionActivationTimeoutSeconds":{"type":"integer"}}},"S1q":{"type":"structure","members":{"NewGameSessionsPerCreator":{"type":"integer"},"PolicyPeriodInMinutes":{"type":"integer"}}},"S1s":{"type":"list","member":{}},"S1v":{"type":"structure","required":["CertificateType"],"members":{"CertificateType":{}}},"S1y":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"FleetType":{},"InstanceType":{},"Description":{},"Name":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"BuildId":{},"BuildArn":{},"ScriptId":{},"ScriptArn":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"NewGameSessionProtectionPolicy":{},"OperatingSystem":{},"ResourceCreationLimitPolicy":{"shape":"S1q"},"MetricGroups":{"shape":"S1s"},"StoppedActions":{"shape":"S23"},"InstanceRoleArn":{},"CertificateConfiguration":{"shape":"S1v"}}},"S23":{"type":"list","member":{}},"S2b":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{}}}},"S2n":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"RoleArn":{},"InstanceDefinitions":{"shape":"S2b"},"BalancingStrategy":{},"GameServerProtectionPolicy":{},"AutoScalingGroupArn":{},"Status":{},"StatusReason":{},"SuspendedActions":{"shape":"S2q"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S2q":{"type":"list","member":{}},"S2v":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S32":{"type":"structure","members":{"GameSessionId":{},"Name":{},"FleetId":{},"FleetArn":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Status":{},"StatusReason":{},"GameProperties":{"shape":"S2v"},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"PlayerSessionCreationPolicy":{},"CreatorId":{},"GameSessionData":{},"MatchmakerData":{}}},"S3b":{"type":"list","member":{"type":"structure","members":{"MaximumIndividualPlayerLatencyMilliseconds":{"type":"integer"},"PolicyDurationSeconds":{"type":"integer"}}}},"S3d":{"type":"list","member":{"type":"structure","members":{"DestinationArn":{}}}},"S3h":{"type":"structure","members":{"Name":{},"GameSessionQueueArn":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S3b"},"Destinations":{"shape":"S3d"}}},"S3k":{"type":"list","member":{}},"S3t":{"type":"structure","members":{"Name":{},"ConfigurationArn":{},"Description":{},"GameSessionQueueArns":{"shape":"S3k"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"RuleSetArn":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"CreationTime":{"type":"timestamp"},"GameProperties":{"shape":"S2v"},"GameSessionData":{},"BackfillMode":{}}},"S3z":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetName":{},"RuleSetArn":{},"RuleSetBody":{},"CreationTime":{"type":"timestamp"}}},"S43":{"type":"structure","members":{"PlayerSessionId":{},"PlayerId":{},"GameSessionId":{},"FleetId":{},"FleetArn":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"PlayerData":{}}},"S4a":{"type":"list","member":{"shape":"S43"}},"S4e":{"type":"structure","members":{"ScriptId":{},"ScriptArn":{},"Name":{},"Version":{},"SizeOnDisk":{"type":"long"},"CreationTime":{"type":"timestamp"},"StorageLocation":{"shape":"S10"}}},"S4h":{"type":"structure","members":{"GameLiftAwsAccountId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"}}},"S5e":{"type":"list","member":{}},"S67":{"type":"structure","members":{"PlacementId":{},"GameSessionQueueName":{},"Status":{},"GameProperties":{"shape":"S2v"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"GameSessionId":{},"GameSessionArn":{},"GameSessionRegion":{},"PlayerLatencies":{"shape":"S69"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"PlacedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}},"GameSessionData":{},"MatchmakerData":{}}},"S69":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"RegionIdentifier":{},"LatencyInMilliseconds":{"type":"float"}}}},"S6k":{"type":"list","member":{"shape":"S32"}},"S6v":{"type":"structure","members":{"TicketId":{},"ConfigurationName":{},"ConfigurationArn":{},"Status":{},"StatusReason":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Players":{"shape":"S6y"},"GameSessionConnectionInfo":{"type":"structure","members":{"GameSessionArn":{},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"MatchedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}}}},"EstimatedWaitTime":{"type":"integer"}}},"S6y":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"S":{},"N":{"type":"double"},"SL":{"shape":"S3"},"SDM":{"type":"map","key":{},"value":{"type":"double"}}}}},"Team":{},"LatencyInMs":{"type":"map","key":{},"value":{"type":"integer"}}}}},"S7w":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-08","endpointPrefix":"iam","globalEndpoint":"iam.amazonaws.com","protocol":"query","serviceAbbreviation":"IAM","serviceFullName":"AWS Identity and Access Management","serviceId":"IAM","signatureVersion":"v4","uid":"iam-2010-05-08","xmlNamespace":"https://iam.amazonaws.com/doc/2010-05-08/"},"operations":{"AddClientIDToOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"AddRoleToInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"AddUserToGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"AttachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"AttachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"AttachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"ChangePassword":{"input":{"type":"structure","required":["OldPassword","NewPassword"],"members":{"OldPassword":{"shape":"Sf"},"NewPassword":{"shape":"Sf"}}}},"CreateAccessKey":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"CreateAccessKeyResult","type":"structure","required":["AccessKey"],"members":{"AccessKey":{"type":"structure","required":["UserName","AccessKeyId","Status","SecretAccessKey"],"members":{"UserName":{},"AccessKeyId":{},"Status":{},"SecretAccessKey":{"type":"string","sensitive":true},"CreateDate":{"type":"timestamp"}}}}}},"CreateAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"CreateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"Path":{},"GroupName":{}}},"output":{"resultWrapper":"CreateGroupResult","type":"structure","required":["Group"],"members":{"Group":{"shape":"Ss"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{},"Path":{}}},"output":{"resultWrapper":"CreateInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"Sw"}}}},"CreateLoginProfile":{"input":{"type":"structure","required":["UserName","Password"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}},"output":{"resultWrapper":"CreateLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1d"}}}},"CreateOpenIDConnectProvider":{"input":{"type":"structure","required":["Url","ThumbprintList"],"members":{"Url":{},"ClientIDList":{"shape":"S1g"},"ThumbprintList":{"shape":"S1h"}}},"output":{"resultWrapper":"CreateOpenIDConnectProviderResult","type":"structure","members":{"OpenIDConnectProviderArn":{}}}},"CreatePolicy":{"input":{"type":"structure","required":["PolicyName","PolicyDocument"],"members":{"PolicyName":{},"Path":{},"PolicyDocument":{},"Description":{}}},"output":{"resultWrapper":"CreatePolicyResult","type":"structure","members":{"Policy":{"shape":"S1p"}}}},"CreatePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","PolicyDocument"],"members":{"PolicyArn":{},"PolicyDocument":{},"SetAsDefault":{"type":"boolean"}}},"output":{"resultWrapper":"CreatePolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1u"}}}},"CreateRole":{"input":{"type":"structure","required":["RoleName","AssumeRolePolicyDocument"],"members":{"Path":{},"RoleName":{},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{},"Tags":{"shape":"S14"}}},"output":{"resultWrapper":"CreateRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"Sy"}}}},"CreateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","Name"],"members":{"SAMLMetadataDocument":{},"Name":{}}},"output":{"resultWrapper":"CreateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{}}}},"CreateServiceLinkedRole":{"input":{"type":"structure","required":["AWSServiceName"],"members":{"AWSServiceName":{},"Description":{},"CustomSuffix":{}}},"output":{"resultWrapper":"CreateServiceLinkedRoleResult","type":"structure","members":{"Role":{"shape":"Sy"}}}},"CreateServiceSpecificCredential":{"input":{"type":"structure","required":["UserName","ServiceName"],"members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"CreateServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S27"}}}},"CreateUser":{"input":{"type":"structure","required":["UserName"],"members":{"Path":{},"UserName":{},"PermissionsBoundary":{},"Tags":{"shape":"S14"}}},"output":{"resultWrapper":"CreateUserResult","type":"structure","members":{"User":{"shape":"S2d"}}}},"CreateVirtualMFADevice":{"input":{"type":"structure","required":["VirtualMFADeviceName"],"members":{"Path":{},"VirtualMFADeviceName":{}}},"output":{"resultWrapper":"CreateVirtualMFADeviceResult","type":"structure","required":["VirtualMFADevice"],"members":{"VirtualMFADevice":{"shape":"S2h"}}}},"DeactivateMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber"],"members":{"UserName":{},"SerialNumber":{}}}},"DeleteAccessKey":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"UserName":{},"AccessKeyId":{}}}},"DeleteAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"DeleteAccountPasswordPolicy":{},"DeleteGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{}}}},"DeleteGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}}},"DeleteLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}}},"DeletePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"DeleteRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}}},"DeleteSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}}},"DeleteSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId"],"members":{"UserName":{},"SSHPublicKeyId":{}}}},"DeleteServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}}},"DeleteServiceLinkedRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"DeleteServiceLinkedRoleResult","type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}}},"DeleteServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}}},"DeleteSigningCertificate":{"input":{"type":"structure","required":["CertificateId"],"members":{"UserName":{},"CertificateId":{}}}},"DeleteUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}}},"DeleteVirtualMFADevice":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{}}}},"DetachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"DetachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"DetachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"EnableMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"GenerateCredentialReport":{"output":{"resultWrapper":"GenerateCredentialReportResult","type":"structure","members":{"State":{},"Description":{}}}},"GenerateOrganizationsAccessReport":{"input":{"type":"structure","required":["EntityPath"],"members":{"EntityPath":{},"OrganizationsPolicyId":{}}},"output":{"resultWrapper":"GenerateOrganizationsAccessReportResult","type":"structure","members":{"JobId":{}}}},"GenerateServiceLastAccessedDetails":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Granularity":{}}},"output":{"resultWrapper":"GenerateServiceLastAccessedDetailsResult","type":"structure","members":{"JobId":{}}}},"GetAccessKeyLastUsed":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyLastUsedResult","type":"structure","members":{"UserName":{},"AccessKeyLastUsed":{"type":"structure","required":["LastUsedDate","ServiceName","Region"],"members":{"LastUsedDate":{"type":"timestamp"},"ServiceName":{},"Region":{}}}}}},"GetAccountAuthorizationDetails":{"input":{"type":"structure","members":{"Filter":{"type":"list","member":{}},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetAccountAuthorizationDetailsResult","type":"structure","members":{"UserDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"UserPolicyList":{"shape":"S43"},"GroupList":{"type":"list","member":{}},"AttachedManagedPolicies":{"shape":"S46"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"}}}},"GroupDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"GroupPolicyList":{"shape":"S43"},"AttachedManagedPolicies":{"shape":"S46"}}}},"RoleDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"InstanceProfileList":{"shape":"S4c"},"RolePolicyList":{"shape":"S43"},"AttachedManagedPolicies":{"shape":"S46"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"},"RoleLastUsed":{"shape":"S18"}}}},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"PolicyVersionList":{"shape":"S4f"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetAccountPasswordPolicy":{"output":{"resultWrapper":"GetAccountPasswordPolicyResult","type":"structure","required":["PasswordPolicy"],"members":{"PasswordPolicy":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"ExpirePasswords":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}}}},"GetAccountSummary":{"output":{"resultWrapper":"GetAccountSummaryResult","type":"structure","members":{"SummaryMap":{"type":"map","key":{},"value":{"type":"integer"}}}}},"GetContextKeysForCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList"],"members":{"PolicyInputList":{"shape":"S4s"}}},"output":{"shape":"S4t","resultWrapper":"GetContextKeysForCustomPolicyResult"}},"GetContextKeysForPrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4s"}}},"output":{"shape":"S4t","resultWrapper":"GetContextKeysForPrincipalPolicyResult"}},"GetCredentialReport":{"output":{"resultWrapper":"GetCredentialReportResult","type":"structure","members":{"Content":{"type":"blob"},"ReportFormat":{},"GeneratedTime":{"type":"timestamp"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"GetGroupResult","type":"structure","required":["Group","Users"],"members":{"Group":{"shape":"Ss"},"Users":{"shape":"S52"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetGroupPolicyResult","type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}},"output":{"resultWrapper":"GetInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"Sw"}}}},"GetLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}},"output":{"resultWrapper":"GetLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1d"}}}},"GetOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}},"output":{"resultWrapper":"GetOpenIDConnectProviderResult","type":"structure","members":{"Url":{},"ClientIDList":{"shape":"S1g"},"ThumbprintList":{"shape":"S1h"},"CreateDate":{"type":"timestamp"}}}},"GetOrganizationsAccessReport":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{},"SortKey":{}}},"output":{"resultWrapper":"GetOrganizationsAccessReportResult","type":"structure","required":["JobStatus","JobCreationDate"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"NumberOfServicesAccessible":{"type":"integer"},"NumberOfServicesNotAccessed":{"type":"integer"},"AccessDetails":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"ServiceNamespace":{},"Region":{},"EntityPath":{},"LastAuthenticatedTime":{"type":"timestamp"},"TotalAuthenticatedEntities":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"ErrorDetails":{"shape":"S5k"}}}},"GetPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}},"output":{"resultWrapper":"GetPolicyResult","type":"structure","members":{"Policy":{"shape":"S1p"}}}},"GetPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}},"output":{"resultWrapper":"GetPolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1u"}}}},"GetRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"GetRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"Sy"}}}},"GetRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetRolePolicyResult","type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}},"output":{"resultWrapper":"GetSAMLProviderResult","type":"structure","members":{"SAMLMetadataDocument":{},"CreateDate":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"}}}},"GetSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Encoding"],"members":{"UserName":{},"SSHPublicKeyId":{},"Encoding":{}}},"output":{"resultWrapper":"GetSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S5y"}}}},"GetServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}},"output":{"resultWrapper":"GetServerCertificateResult","type":"structure","required":["ServerCertificate"],"members":{"ServerCertificate":{"type":"structure","required":["ServerCertificateMetadata","CertificateBody"],"members":{"ServerCertificateMetadata":{"shape":"S64"},"CertificateBody":{},"CertificateChain":{}}}}}},"GetServiceLastAccessedDetails":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsResult","type":"structure","required":["JobStatus","JobCreationDate","ServicesLastAccessed","JobCompletionDate"],"members":{"JobStatus":{},"JobType":{},"JobCreationDate":{"type":"timestamp"},"ServicesLastAccessed":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"LastAuthenticated":{"type":"timestamp"},"ServiceNamespace":{},"LastAuthenticatedEntity":{},"LastAuthenticatedRegion":{},"TotalAuthenticatedEntities":{"type":"integer"},"TrackedActionsLastAccessed":{"type":"list","member":{"type":"structure","members":{"ActionName":{},"LastAccessedEntity":{},"LastAccessedTime":{"type":"timestamp"},"LastAccessedRegion":{}}}}}}},"JobCompletionDate":{"type":"timestamp"},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5k"}}}},"GetServiceLastAccessedDetailsWithEntities":{"input":{"type":"structure","required":["JobId","ServiceNamespace"],"members":{"JobId":{},"ServiceNamespace":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsWithEntitiesResult","type":"structure","required":["JobStatus","JobCreationDate","JobCompletionDate","EntityDetailsList"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"EntityDetailsList":{"type":"list","member":{"type":"structure","required":["EntityInfo"],"members":{"EntityInfo":{"type":"structure","required":["Arn","Name","Type","Id"],"members":{"Arn":{},"Name":{},"Type":{},"Id":{},"Path":{}}},"LastAuthenticated":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5k"}}}},"GetServiceLinkedRoleDeletionStatus":{"input":{"type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}},"output":{"resultWrapper":"GetServiceLinkedRoleDeletionStatusResult","type":"structure","required":["Status"],"members":{"Status":{},"Reason":{"type":"structure","members":{"Reason":{},"RoleUsageList":{"type":"list","member":{"type":"structure","members":{"Region":{},"Resources":{"type":"list","member":{}}}}}}}}}},"GetUser":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"GetUserResult","type":"structure","required":["User"],"members":{"User":{"shape":"S2d"}}}},"GetUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetUserPolicyResult","type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"ListAccessKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccessKeysResult","type":"structure","required":["AccessKeyMetadata"],"members":{"AccessKeyMetadata":{"type":"list","member":{"type":"structure","members":{"UserName":{},"AccessKeyId":{},"Status":{},"CreateDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAccountAliases":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccountAliasesResult","type":"structure","required":["AccountAliases"],"members":{"AccountAliases":{"type":"list","member":{}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedGroupPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedRolePoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedUserPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListEntitiesForPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"EntityFilter":{},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListEntitiesForPolicyResult","type":"structure","members":{"PolicyGroups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupId":{}}}},"PolicyUsers":{"type":"list","member":{"type":"structure","members":{"UserName":{},"UserId":{}}}},"PolicyRoles":{"type":"list","member":{"type":"structure","members":{"RoleName":{},"RoleId":{}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroups":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7o"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupsForUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsForUserResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7o"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4c"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfilesForRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesForRoleResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4c"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListMFADevices":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListMFADevicesResult","type":"structure","required":["MFADevices"],"members":{"MFADevices":{"type":"list","member":{"type":"structure","required":["UserName","SerialNumber","EnableDate"],"members":{"UserName":{},"SerialNumber":{},"EnableDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListOpenIDConnectProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListOpenIDConnectProvidersResult","type":"structure","members":{"OpenIDConnectProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}}}}},"ListPolicies":{"input":{"type":"structure","members":{"Scope":{},"OnlyAttached":{"type":"boolean"},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPoliciesResult","type":"structure","members":{"Policies":{"type":"list","member":{"shape":"S1p"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPoliciesGrantingServiceAccess":{"input":{"type":"structure","required":["Arn","ServiceNamespaces"],"members":{"Marker":{},"Arn":{},"ServiceNamespaces":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListPoliciesGrantingServiceAccessResult","type":"structure","required":["PoliciesGrantingServiceAccess"],"members":{"PoliciesGrantingServiceAccess":{"type":"list","member":{"type":"structure","members":{"ServiceNamespace":{},"Policies":{"type":"list","member":{"type":"structure","required":["PolicyName","PolicyType"],"members":{"PolicyName":{},"PolicyType":{},"PolicyArn":{},"EntityType":{},"EntityName":{}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPolicyVersions":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPolicyVersionsResult","type":"structure","members":{"Versions":{"shape":"S4f"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolePoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoleTags":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRoleTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S14"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolesResult","type":"structure","required":["Roles"],"members":{"Roles":{"shape":"Sx"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListSAMLProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListSAMLProvidersResult","type":"structure","members":{"SAMLProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"ValidUntil":{"type":"timestamp"},"CreateDate":{"type":"timestamp"}}}}}}},"ListSSHPublicKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSSHPublicKeysResult","type":"structure","members":{"SSHPublicKeys":{"type":"list","member":{"type":"structure","required":["UserName","SSHPublicKeyId","Status","UploadDate"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{},"UploadDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServerCertificates":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListServerCertificatesResult","type":"structure","required":["ServerCertificateMetadataList"],"members":{"ServerCertificateMetadataList":{"type":"list","member":{"shape":"S64"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServiceSpecificCredentials":{"input":{"type":"structure","members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"ListServiceSpecificCredentialsResult","type":"structure","members":{"ServiceSpecificCredentials":{"type":"list","member":{"type":"structure","required":["UserName","Status","ServiceUserName","CreateDate","ServiceSpecificCredentialId","ServiceName"],"members":{"UserName":{},"Status":{},"ServiceUserName":{},"CreateDate":{"type":"timestamp"},"ServiceSpecificCredentialId":{},"ServiceName":{}}}}}}},"ListSigningCertificates":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSigningCertificatesResult","type":"structure","required":["Certificates"],"members":{"Certificates":{"type":"list","member":{"shape":"S96"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserTags":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S14"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUsers":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUsersResult","type":"structure","required":["Users"],"members":{"Users":{"shape":"S52"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListVirtualMFADevices":{"input":{"type":"structure","members":{"AssignmentStatus":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListVirtualMFADevicesResult","type":"structure","required":["VirtualMFADevices"],"members":{"VirtualMFADevices":{"type":"list","member":{"shape":"S2h"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"PutGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName","PermissionsBoundary"],"members":{"RoleName":{},"PermissionsBoundary":{}}}},"PutRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName","PermissionsBoundary"],"members":{"UserName":{},"PermissionsBoundary":{}}}},"PutUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"RemoveClientIDFromOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"RemoveRoleFromInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"RemoveUserFromGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"ResetServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}},"output":{"resultWrapper":"ResetServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S27"}}}},"ResyncMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"SetDefaultPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"SetSecurityTokenServicePreferences":{"input":{"type":"structure","required":["GlobalEndpointTokenVersion"],"members":{"GlobalEndpointTokenVersion":{}}}},"SimulateCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList","ActionNames"],"members":{"PolicyInputList":{"shape":"S4s"},"PermissionsBoundaryPolicyInputList":{"shape":"S4s"},"ActionNames":{"shape":"S9w"},"ResourceArns":{"shape":"S9y"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"Sa0"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"Sa6","resultWrapper":"SimulateCustomPolicyResult"}},"SimulatePrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn","ActionNames"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4s"},"PermissionsBoundaryPolicyInputList":{"shape":"S4s"},"ActionNames":{"shape":"S9w"},"ResourceArns":{"shape":"S9y"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"Sa0"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"Sa6","resultWrapper":"SimulatePrincipalPolicyResult"}},"TagRole":{"input":{"type":"structure","required":["RoleName","Tags"],"members":{"RoleName":{},"Tags":{"shape":"S14"}}}},"TagUser":{"input":{"type":"structure","required":["UserName","Tags"],"members":{"UserName":{},"Tags":{"shape":"S14"}}}},"UntagRole":{"input":{"type":"structure","required":["RoleName","TagKeys"],"members":{"RoleName":{},"TagKeys":{"shape":"Sar"}}}},"UntagUser":{"input":{"type":"structure","required":["UserName","TagKeys"],"members":{"UserName":{},"TagKeys":{"shape":"Sar"}}}},"UpdateAccessKey":{"input":{"type":"structure","required":["AccessKeyId","Status"],"members":{"UserName":{},"AccessKeyId":{},"Status":{}}}},"UpdateAccountPasswordPolicy":{"input":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}},"UpdateAssumeRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyDocument"],"members":{"RoleName":{},"PolicyDocument":{}}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"NewPath":{},"NewGroupName":{}}}},"UpdateLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}}},"UpdateOpenIDConnectProviderThumbprint":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ThumbprintList"],"members":{"OpenIDConnectProviderArn":{},"ThumbprintList":{"shape":"S1h"}}}},"UpdateRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Description":{},"MaxSessionDuration":{"type":"integer"}}},"output":{"resultWrapper":"UpdateRoleResult","type":"structure","members":{}}},"UpdateRoleDescription":{"input":{"type":"structure","required":["RoleName","Description"],"members":{"RoleName":{},"Description":{}}},"output":{"resultWrapper":"UpdateRoleDescriptionResult","type":"structure","members":{"Role":{"shape":"Sy"}}}},"UpdateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","SAMLProviderArn"],"members":{"SAMLMetadataDocument":{},"SAMLProviderArn":{}}},"output":{"resultWrapper":"UpdateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{}}}},"UpdateSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{}}}},"UpdateServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{},"NewPath":{},"NewServerCertificateName":{}}}},"UpdateServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId","Status"],"members":{"UserName":{},"ServiceSpecificCredentialId":{},"Status":{}}}},"UpdateSigningCertificate":{"input":{"type":"structure","required":["CertificateId","Status"],"members":{"UserName":{},"CertificateId":{},"Status":{}}}},"UpdateUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"NewPath":{},"NewUserName":{}}}},"UploadSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyBody"],"members":{"UserName":{},"SSHPublicKeyBody":{}}},"output":{"resultWrapper":"UploadSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S5y"}}}},"UploadServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","CertificateBody","PrivateKey"],"members":{"Path":{},"ServerCertificateName":{},"CertificateBody":{},"PrivateKey":{"type":"string","sensitive":true},"CertificateChain":{}}},"output":{"resultWrapper":"UploadServerCertificateResult","type":"structure","members":{"ServerCertificateMetadata":{"shape":"S64"}}}},"UploadSigningCertificate":{"input":{"type":"structure","required":["CertificateBody"],"members":{"UserName":{},"CertificateBody":{}}},"output":{"resultWrapper":"UploadSigningCertificateResult","type":"structure","required":["Certificate"],"members":{"Certificate":{"shape":"S96"}}}}},"shapes":{"Sf":{"type":"string","sensitive":true},"Ss":{"type":"structure","required":["Path","GroupName","GroupId","Arn","CreateDate"],"members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"}}},"Sw":{"type":"structure","required":["Path","InstanceProfileName","InstanceProfileId","Arn","CreateDate","Roles"],"members":{"Path":{},"InstanceProfileName":{},"InstanceProfileId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"Roles":{"shape":"Sx"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Path","RoleName","RoleId","Arn","CreateDate"],"members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"},"RoleLastUsed":{"shape":"S18"}}},"S12":{"type":"structure","members":{"PermissionsBoundaryType":{},"PermissionsBoundaryArn":{}}},"S14":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S18":{"type":"structure","members":{"LastUsedDate":{"type":"timestamp"},"Region":{}}},"S1d":{"type":"structure","required":["UserName","CreateDate"],"members":{"UserName":{},"CreateDate":{"type":"timestamp"},"PasswordResetRequired":{"type":"boolean"}}},"S1g":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"}}},"S1u":{"type":"structure","members":{"Document":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"CreateDate":{"type":"timestamp"}}},"S27":{"type":"structure","required":["CreateDate","ServiceName","ServiceUserName","ServicePassword","ServiceSpecificCredentialId","UserName","Status"],"members":{"CreateDate":{"type":"timestamp"},"ServiceName":{},"ServiceUserName":{},"ServicePassword":{"type":"string","sensitive":true},"ServiceSpecificCredentialId":{},"UserName":{},"Status":{}}},"S2d":{"type":"structure","required":["Path","UserName","UserId","Arn","CreateDate"],"members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"PasswordLastUsed":{"type":"timestamp"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"}}},"S2h":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"Base32StringSeed":{"shape":"S2j"},"QRCodePNG":{"shape":"S2j"},"User":{"shape":"S2d"},"EnableDate":{"type":"timestamp"}}},"S2j":{"type":"blob","sensitive":true},"S43":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyDocument":{}}}},"S46":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyArn":{}}}},"S4c":{"type":"list","member":{"shape":"Sw"}},"S4f":{"type":"list","member":{"shape":"S1u"}},"S4s":{"type":"list","member":{}},"S4t":{"type":"structure","members":{"ContextKeyNames":{"shape":"S4u"}}},"S4u":{"type":"list","member":{}},"S52":{"type":"list","member":{"shape":"S2d"}},"S5k":{"type":"structure","required":["Message","Code"],"members":{"Message":{},"Code":{}}},"S5y":{"type":"structure","required":["UserName","SSHPublicKeyId","Fingerprint","SSHPublicKeyBody","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Fingerprint":{},"SSHPublicKeyBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"S64":{"type":"structure","required":["Path","ServerCertificateName","ServerCertificateId","Arn"],"members":{"Path":{},"ServerCertificateName":{},"ServerCertificateId":{},"Arn":{},"UploadDate":{"type":"timestamp"},"Expiration":{"type":"timestamp"}}},"S7k":{"type":"list","member":{}},"S7o":{"type":"list","member":{"shape":"Ss"}},"S96":{"type":"structure","required":["UserName","CertificateId","CertificateBody","Status"],"members":{"UserName":{},"CertificateId":{},"CertificateBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"S9w":{"type":"list","member":{}},"S9y":{"type":"list","member":{}},"Sa0":{"type":"list","member":{"type":"structure","members":{"ContextKeyName":{},"ContextKeyValues":{"type":"list","member":{}},"ContextKeyType":{}}}},"Sa6":{"type":"structure","members":{"EvaluationResults":{"type":"list","member":{"type":"structure","required":["EvalActionName","EvalDecision"],"members":{"EvalActionName":{},"EvalResourceName":{},"EvalDecision":{},"MatchedStatements":{"shape":"Saa"},"MissingContextValues":{"shape":"S4u"},"OrganizationsDecisionDetail":{"type":"structure","members":{"AllowedByOrganizations":{"type":"boolean"}}},"PermissionsBoundaryDecisionDetail":{"shape":"Sai"},"EvalDecisionDetails":{"shape":"Saj"},"ResourceSpecificResults":{"type":"list","member":{"type":"structure","required":["EvalResourceName","EvalResourceDecision"],"members":{"EvalResourceName":{},"EvalResourceDecision":{},"MatchedStatements":{"shape":"Saa"},"MissingContextValues":{"shape":"S4u"},"EvalDecisionDetails":{"shape":"Saj"},"PermissionsBoundaryDecisionDetail":{"shape":"Sai"}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}},"Saa":{"type":"list","member":{"type":"structure","members":{"SourcePolicyId":{},"SourcePolicyType":{},"StartPosition":{"shape":"Sae"},"EndPosition":{"shape":"Sae"}}}},"Sae":{"type":"structure","members":{"Line":{"type":"integer"},"Column":{"type":"integer"}}},"Sai":{"type":"structure","members":{"AllowedByPermissionsBoundary":{"type":"boolean"}}},"Saj":{"type":"map","key":{},"value":{}},"Sar":{"type":"list","member":{}}}}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetAccountAuthorizationDetails":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["UserDetailList","GroupDetailList","RoleDetailList","Policies"]},"GetGroup":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListAccessKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccessKeyMetadata"},"ListAccountAliases":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccountAliases"},"ListAttachedGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListEntitiesForPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["PolicyGroups","PolicyUsers","PolicyRoles"]},"ListGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListGroups":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListGroupsForUser":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListInstanceProfiles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListInstanceProfilesForRole":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"MFADevices"},"ListPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Policies"},"ListPolicyVersions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Versions"},"ListRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListRoles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Roles"},"ListSAMLProviders":{"result_key":"SAMLProviderList"},"ListSSHPublicKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"SSHPublicKeys"},"ListServerCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"ServerCertificateMetadataList"},"ListSigningCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Certificates"},"ListUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListUsers":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListVirtualMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"VirtualMFADevices"},"SimulateCustomPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"},"SimulatePrincipalPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"}}}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceProfileExists":{"delay":1,"operation":"GetInstanceProfile","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"state":"retry","matcher":"status","expected":404}]},"UserExists":{"delay":1,"operation":"GetUser","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"RoleExists":{"delay":1,"operation":"GetRole","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"PolicyExists":{"delay":1,"operation":"GetPolicy","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]}}}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-16","endpointPrefix":"inspector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Inspector","serviceId":"Inspector","signatureVersion":"v4","targetPrefix":"InspectorService","uid":"inspector-2016-02-16"},"operations":{"AddAttributesToFindings":{"input":{"type":"structure","required":["findingArns","attributes"],"members":{"findingArns":{"shape":"S2"},"attributes":{"shape":"S4"}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"CreateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetName"],"members":{"assessmentTargetName":{},"resourceGroupArn":{}}},"output":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"CreateAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTemplateName","durationInSeconds","rulesPackageArns"],"members":{"assessmentTargetArn":{},"assessmentTemplateName":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"}}},"output":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"CreateExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}},"output":{"type":"structure","required":["previewToken"],"members":{"previewToken":{}}}},"CreateResourceGroup":{"input":{"type":"structure","required":["resourceGroupTags"],"members":{"resourceGroupTags":{"shape":"Sp"}}},"output":{"type":"structure","required":["resourceGroupArn"],"members":{"resourceGroupArn":{}}}},"DeleteAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"DeleteAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"DeleteAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"DescribeAssessmentRuns":{"input":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentRuns","failedItems"],"members":{"assessmentRuns":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTemplateArn","state","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt","stateChangedAt","dataCollected","stateChanges","notifications","findingCounts"],"members":{"arn":{},"name":{},"assessmentTemplateArn":{},"state":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"type":"list","member":{}},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"stateChangedAt":{"type":"timestamp"},"dataCollected":{"type":"boolean"},"stateChanges":{"type":"list","member":{"type":"structure","required":["stateChangedAt","state"],"members":{"stateChangedAt":{"type":"timestamp"},"state":{}}}},"notifications":{"type":"list","member":{"type":"structure","required":["date","event","error"],"members":{"date":{"type":"timestamp"},"event":{},"message":{},"error":{"type":"boolean"},"snsTopicArn":{},"snsPublishStatusCode":{}}}},"findingCounts":{"type":"map","key":{},"value":{"type":"integer"}}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTargets":{"input":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTargets","failedItems"],"members":{"assessmentTargets":{"type":"list","member":{"type":"structure","required":["arn","name","createdAt","updatedAt"],"members":{"arn":{},"name":{},"resourceGroupArn":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTemplates":{"input":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTemplates","failedItems"],"members":{"assessmentTemplates":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTargetArn","durationInSeconds","rulesPackageArns","userAttributesForFindings","assessmentRunCount","createdAt"],"members":{"arn":{},"name":{},"assessmentTargetArn":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"},"lastAssessmentRunArn":{},"assessmentRunCount":{"type":"integer"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeCrossAccountAccessRole":{"output":{"type":"structure","required":["roleArn","valid","registeredAt"],"members":{"roleArn":{},"valid":{"type":"boolean"},"registeredAt":{"type":"timestamp"}}}},"DescribeExclusions":{"input":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"type":"list","member":{}},"locale":{}}},"output":{"type":"structure","required":["exclusions","failedItems"],"members":{"exclusions":{"type":"map","key":{},"value":{"type":"structure","required":["arn","title","description","recommendation","scopes"],"members":{"arn":{},"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"failedItems":{"shape":"S9"}}}},"DescribeFindings":{"input":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["findings","failedItems"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["arn","attributes","userAttributes","createdAt","updatedAt"],"members":{"arn":{},"schemaVersion":{"type":"integer"},"service":{},"serviceAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"assessmentRunArn":{},"rulesPackageArn":{}}},"assetType":{},"assetAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"agentId":{},"autoScalingGroup":{},"amiId":{},"hostname":{},"ipv4Addresses":{"type":"list","member":{}},"tags":{"type":"list","member":{"shape":"S2i"}},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"networkInterfaceId":{},"subnetId":{},"vpcId":{},"privateDnsName":{},"privateIpAddress":{},"privateIpAddresses":{"type":"list","member":{"type":"structure","members":{"privateDnsName":{},"privateIpAddress":{}}}},"publicDnsName":{},"publicIp":{},"ipv6Addresses":{"type":"list","member":{}},"securityGroups":{"type":"list","member":{"type":"structure","members":{"groupName":{},"groupId":{}}}}}}}}},"id":{},"title":{},"description":{},"recommendation":{},"severity":{},"numericSeverity":{"type":"double"},"confidence":{"type":"integer"},"indicatorOfCompromise":{"type":"boolean"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S4"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeResourceGroups":{"input":{"type":"structure","required":["resourceGroupArns"],"members":{"resourceGroupArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["resourceGroups","failedItems"],"members":{"resourceGroups":{"type":"list","member":{"type":"structure","required":["arn","tags","createdAt"],"members":{"arn":{},"tags":{"shape":"Sp"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeRulesPackages":{"input":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["rulesPackages","failedItems"],"members":{"rulesPackages":{"type":"list","member":{"type":"structure","required":["arn","name","version","provider"],"members":{"arn":{},"name":{},"version":{},"provider":{},"description":{}}}},"failedItems":{"shape":"S9"}}}},"GetAssessmentReport":{"input":{"type":"structure","required":["assessmentRunArn","reportFileFormat","reportType"],"members":{"assessmentRunArn":{},"reportFileFormat":{},"reportType":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{},"url":{}}}},"GetExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn","previewToken"],"members":{"assessmentTemplateArn":{},"previewToken":{},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","required":["previewStatus"],"members":{"previewStatus":{},"exclusionPreviews":{"type":"list","member":{"type":"structure","required":["title","description","recommendation","scopes"],"members":{"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"nextToken":{}}}},"GetTelemetryMetadata":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}},"output":{"type":"structure","required":["telemetryMetadata"],"members":{"telemetryMetadata":{"shape":"S3j"}}}},"ListAssessmentRunAgents":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"filter":{"type":"structure","required":["agentHealths","agentHealthCodes"],"members":{"agentHealths":{"type":"list","member":{}},"agentHealthCodes":{"type":"list","member":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunAgents"],"members":{"assessmentRunAgents":{"type":"list","member":{"type":"structure","required":["agentId","assessmentRunArn","agentHealth","agentHealthCode","telemetryMetadata"],"members":{"agentId":{},"assessmentRunArn":{},"agentHealth":{},"agentHealthCode":{},"agentHealthDetails":{},"autoScalingGroup":{},"telemetryMetadata":{"shape":"S3j"}}}},"nextToken":{}}}},"ListAssessmentRuns":{"input":{"type":"structure","members":{"assessmentTemplateArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"states":{"type":"list","member":{}},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"},"startTimeRange":{"shape":"S43"},"completionTimeRange":{"shape":"S43"},"stateChangeTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTargets":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"assessmentTargetNamePattern":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTemplates":{"input":{"type":"structure","members":{"assessmentTargetArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"S45"},"nextToken":{}}}},"ListEventSubscriptions":{"input":{"type":"structure","members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["subscriptions"],"members":{"subscriptions":{"type":"list","member":{"type":"structure","required":["resourceArn","topicArn","eventSubscriptions"],"members":{"resourceArn":{},"topicArn":{},"eventSubscriptions":{"type":"list","member":{"type":"structure","required":["event","subscribedAt"],"members":{"event":{},"subscribedAt":{"type":"timestamp"}}}}}}},"nextToken":{}}}},"ListExclusions":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"shape":"S45"},"nextToken":{}}}},"ListFindings":{"input":{"type":"structure","members":{"assessmentRunArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"agentIds":{"type":"list","member":{}},"autoScalingGroups":{"type":"list","member":{}},"ruleNames":{"type":"list","member":{}},"severities":{"type":"list","member":{}},"rulesPackageArns":{"shape":"S42"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S21"},"creationTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"S45"},"nextToken":{}}}},"ListRulesPackages":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"S45"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S4x"}}}},"PreviewAgents":{"input":{"type":"structure","required":["previewAgentsArn"],"members":{"previewAgentsArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["agentPreviews"],"members":{"agentPreviews":{"type":"list","member":{"type":"structure","required":["agentId"],"members":{"hostname":{},"agentId":{},"autoScalingGroup":{},"agentHealth":{},"agentVersion":{},"operatingSystem":{},"kernelVersion":{},"ipv4Address":{}}}},"nextToken":{}}}},"RegisterCrossAccountAccessRole":{"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{}}}},"RemoveAttributesFromFindings":{"input":{"type":"structure","required":["findingArns","attributeKeys"],"members":{"findingArns":{"shape":"S2"},"attributeKeys":{"type":"list","member":{}}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"SetTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"tags":{"shape":"S4x"}}}},"StartAssessmentRun":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{},"assessmentRunName":{}}},"output":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"StopAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"stopAction":{}}}},"SubscribeToEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UnsubscribeFromEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UpdateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTargetName"],"members":{"assessmentTargetArn":{},"assessmentTargetName":{},"resourceGroupArn":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S9":{"type":"map","key":{},"value":{"type":"structure","required":["failureCode","retryable"],"members":{"failureCode":{},"retryable":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{}},"S1x":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S21":{"type":"list","member":{"shape":"S5"}},"S2i":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["messageType","count"],"members":{"messageType":{},"count":{"type":"long"},"dataSize":{"type":"long"}}}},"S3x":{"type":"list","member":{}},"S41":{"type":"structure","members":{"minSeconds":{"type":"integer"},"maxSeconds":{"type":"integer"}}},"S42":{"type":"list","member":{}},"S43":{"type":"structure","members":{"beginDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}},"S45":{"type":"list","member":{}},"S4x":{"type":"list","member":{"shape":"S2i"}}}}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetExclusionsPreview":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRunAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTargets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventSubscriptions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExclusions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRulesPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"PreviewAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"iot","protocol":"rest-json","serviceFullName":"AWS IoT","serviceId":"IoT","signatureVersion":"v4","signingName":"execute-api","uid":"iot-2015-05-28"},"operations":{"AcceptCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/accept-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}}},"AddThingToBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/addThingToBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"AddThingToThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/addThingToThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AssociateTargetsWithJob":{"http":{"requestUri":"/jobs/{jobId}/targets"},"input":{"type":"structure","required":["targets","jobId"],"members":{"targets":{"shape":"Sg"},"jobId":{"location":"uri","locationName":"jobId"},"comment":{}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"AttachPrincipalPolicy":{"http":{"method":"PUT","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"AttachSecurityProfile":{"http":{"method":"PUT","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"AttachThingPrincipal":{"http":{"method":"PUT","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"CancelAuditMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/audit/mitigationactions/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelAuditTask":{"http":{"method":"PUT","requestUri":"/audit/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/cancel-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"CancelJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"reasonCode":{},"comment":{},"force":{"location":"querystring","locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CancelJobExecution":{"http":{"method":"PUT","requestUri":"/things/{thingName}/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"expectedVersion":{"type":"long"},"statusDetails":{"shape":"S1b"}}}},"ClearDefaultAuthorizer":{"http":{"method":"DELETE","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ConfirmTopicRuleDestination":{"http":{"method":"GET","requestUri":"/confirmdestination/{confirmationToken+}"},"input":{"type":"structure","required":["confirmationToken"],"members":{"confirmationToken":{"location":"uri","locationName":"confirmationToken"}}},"output":{"type":"structure","members":{}}},"CreateAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName","authorizerFunctionArn"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S1n"},"status":{},"tags":{"shape":"S1r"},"signingDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"CreateBillingGroup":{"http":{"requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S1z"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"billingGroupId":{}}}},"CreateCertificateFromCsr":{"http":{"requestUri":"/certificates"},"input":{"type":"structure","required":["certificateSigningRequest"],"members":{"certificateSigningRequest":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{}}}},"CreateDimension":{"http":{"requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name","type","stringValues","clientRequestToken"],"members":{"name":{"location":"uri","locationName":"name"},"type":{},"stringValues":{"shape":"S2b"},"tags":{"shape":"S1r"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"name":{},"arn":{}}}},"CreateDomainConfiguration":{"http":{"requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"},"domainName":{},"serverCertificateArns":{"type":"list","member":{}},"validationCertificateArn":{},"authorizerConfig":{"shape":"S2l"},"serviceType":{},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{}}}},"CreateDynamicThingGroup":{"http":{"requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","queryString"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S2r"},"indexName":{},"queryString":{},"queryVersion":{},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{},"indexName":{},"queryString":{},"queryVersion":{}}}},"CreateJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","targets"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"targets":{"shape":"Sg"},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S36"},"targetSelection":{},"jobExecutionsRolloutConfig":{"shape":"S3a"},"abortConfig":{"shape":"S3h"},"timeoutConfig":{"shape":"S3o"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CreateKeysAndCertificate":{"http":{"requestUri":"/keys-and-certificate"},"input":{"type":"structure","members":{"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{},"keyPair":{"shape":"S3t"}}}},"CreateMitigationAction":{"http":{"requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName","roleArn","actionParams"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S3y"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"CreateOTAUpdate":{"http":{"requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId","targets","files","roleArn"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"description":{},"targets":{"shape":"S4h"},"protocols":{"shape":"S4j"},"targetSelection":{},"awsJobExecutionsRolloutConfig":{"shape":"S4l"},"awsJobPresignedUrlConfig":{"shape":"S4s"},"awsJobAbortConfig":{"type":"structure","required":["abortCriteriaList"],"members":{"abortCriteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"awsJobTimeoutConfig":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"files":{"shape":"S53"},"roleArn":{},"additionalParameters":{"shape":"S60"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"otaUpdateId":{},"awsIotJobId":{},"otaUpdateArn":{},"awsIotJobArn":{},"otaUpdateStatus":{}}}},"CreatePolicy":{"http":{"requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"policyVersionId":{}}}},"CreatePolicyVersion":{"http":{"requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"policyArn":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"CreateProvisioningClaim":{"http":{"requestUri":"/provisioning-templates/{templateName}/provisioning-claim"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{"certificateId":{},"certificatePem":{},"keyPair":{"shape":"S3t"},"expiration":{"type":"timestamp"}}}},"CreateProvisioningTemplate":{"http":{"requestUri":"/provisioning-templates"},"input":{"type":"structure","required":["templateName","templateBody","provisioningRoleArn"],"members":{"templateName":{},"description":{},"templateBody":{},"enabled":{"type":"boolean"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S6n"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"defaultVersionId":{"type":"integer"}}}},"CreateProvisioningTemplateVersion":{"http":{"requestUri":"/provisioning-templates/{templateName}/versions"},"input":{"type":"structure","required":["templateName","templateBody"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"templateBody":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"versionId":{"type":"integer"},"isDefaultVersion":{"type":"boolean"}}}},"CreateRoleAlias":{"http":{"requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias","roleArn"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"CreateScheduledAudit":{"http":{"requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["frequency","targetCheckNames","scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S73"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"CreateSecurityProfile":{"http":{"requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S7a"},"alertTargets":{"shape":"S7t"},"additionalMetricsToRetain":{"shape":"S7x","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S7y"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{}}}},"CreateStream":{"http":{"requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId","files","roleArn"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S84"},"roleArn":{},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"CreateThing":{"http":{"requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S2t"},"billingGroupName":{}}},"output":{"type":"structure","members":{"thingName":{},"thingArn":{},"thingId":{}}}},"CreateThingGroup":{"http":{"requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"parentGroupName":{},"thingGroupProperties":{"shape":"S2r"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{}}}},"CreateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"thingTypeProperties":{"shape":"S8g"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeId":{}}}},"CreateTopicRule":{"http":{"requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S8o"},"tags":{"location":"header","locationName":"x-amz-tagging"}},"payload":"topicRulePayload"}},"CreateTopicRuleDestination":{"http":{"requestUri":"/destinations"},"input":{"type":"structure","required":["destinationConfiguration"],"members":{"destinationConfiguration":{"type":"structure","members":{"httpUrlConfiguration":{"type":"structure","required":["confirmationUrl"],"members":{"confirmationUrl":{}}}}}}},"output":{"type":"structure","members":{"topicRuleDestination":{"shape":"Sbb"}}}},"DeleteAccountAuditConfiguration":{"http":{"method":"DELETE","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"deleteScheduledAudits":{"location":"querystring","locationName":"deleteScheduledAudits","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{}}},"DeleteBillingGroup":{"http":{"method":"DELETE","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteCACertificate":{"http":{"method":"DELETE","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{}}},"DeleteCertificate":{"http":{"method":"DELETE","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"forceDelete":{"location":"querystring","locationName":"forceDelete","type":"boolean"}}}},"DeleteDimension":{"http":{"method":"DELETE","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"DeleteDomainConfiguration":{"http":{"method":"DELETE","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"}}},"output":{"type":"structure","members":{}}},"DeleteDynamicThingGroup":{"http":{"method":"DELETE","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"force":{"location":"querystring","locationName":"force","type":"boolean"}}}},"DeleteJobExecution":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}"},"input":{"type":"structure","required":["jobId","thingName","executionNumber"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"uri","locationName":"executionNumber","type":"long"},"force":{"location":"querystring","locationName":"force","type":"boolean"}}}},"DeleteMitigationAction":{"http":{"method":"DELETE","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{}}},"DeleteOTAUpdate":{"http":{"method":"DELETE","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"deleteStream":{"location":"querystring","locationName":"deleteStream","type":"boolean"},"forceDeleteAWSJob":{"location":"querystring","locationName":"forceDeleteAWSJob","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}}},"DeletePolicyVersion":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"DeleteProvisioningTemplate":{"http":{"method":"DELETE","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningTemplateVersion":{"http":{"method":"DELETE","requestUri":"/provisioning-templates/{templateName}/versions/{versionId}"},"input":{"type":"structure","required":["templateName","versionId"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"versionId":{"location":"uri","locationName":"versionId","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteRegistrationCode":{"http":{"method":"DELETE","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteRoleAlias":{"http":{"method":"DELETE","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAudit":{"http":{"method":"DELETE","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{}}},"DeleteSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"method":"DELETE","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{}}},"DeleteThing":{"http":{"method":"DELETE","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingGroup":{"http":{"method":"DELETE","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingType":{"http":{"method":"DELETE","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{}}},"DeleteTopicRule":{"http":{"method":"DELETE","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"DeleteTopicRuleDestination":{"http":{"method":"DELETE","requestUri":"/destinations/{arn+}"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{}}},"DeleteV2LoggingLevel":{"http":{"method":"DELETE","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["targetType","targetName"],"members":{"targetType":{"location":"querystring","locationName":"targetType"},"targetName":{"location":"querystring","locationName":"targetName"}}}},"DeprecateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}/deprecate"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"undoDeprecate":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeAccountAuditConfiguration":{"http":{"method":"GET","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sd2"},"auditCheckConfigurations":{"shape":"Sd5"}}}},"DescribeAuditFinding":{"http":{"method":"GET","requestUri":"/audit/findings/{findingId}"},"input":{"type":"structure","required":["findingId"],"members":{"findingId":{"location":"uri","locationName":"findingId"}}},"output":{"type":"structure","members":{"finding":{"shape":"Sda"}}}},"DescribeAuditMitigationActionsTask":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"taskStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"totalFindingsCount":{"type":"long"},"failedFindingsCount":{"type":"long"},"succeededFindingsCount":{"type":"long"},"skippedFindingsCount":{"type":"long"},"canceledFindingsCount":{"type":"long"}}}},"target":{"shape":"Sdz"},"auditCheckToActionsMapping":{"shape":"Se3"},"actionsDefinition":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"roleArn":{},"actionParams":{"shape":"S3y"}}}}}}},"DescribeAuditTask":{"http":{"method":"GET","requestUri":"/audit/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"taskType":{},"taskStartTime":{"type":"timestamp"},"taskStatistics":{"type":"structure","members":{"totalChecks":{"type":"integer"},"inProgressChecks":{"type":"integer"},"waitingForDataCollectionChecks":{"type":"integer"},"compliantChecks":{"type":"integer"},"nonCompliantChecks":{"type":"integer"},"failedChecks":{"type":"integer"},"canceledChecks":{"type":"integer"}}},"scheduledAuditName":{},"auditDetails":{"type":"map","key":{},"value":{"type":"structure","members":{"checkRunStatus":{},"checkCompliant":{"type":"boolean"},"totalResourcesCount":{"type":"long"},"nonCompliantResourcesCount":{"type":"long"},"errorCode":{},"message":{}}}}}}},"DescribeAuthorizer":{"http":{"method":"GET","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Set"}}}},"DescribeBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupId":{},"billingGroupArn":{},"version":{"type":"long"},"billingGroupProperties":{"shape":"S1z"},"billingGroupMetadata":{"type":"structure","members":{"creationDate":{"type":"timestamp"}}}}}},"DescribeCACertificate":{"http":{"method":"GET","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"creationDate":{"type":"timestamp"},"autoRegistrationStatus":{},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"generationId":{},"validity":{"shape":"Sf6"}}},"registrationConfig":{"shape":"Sf7"}}}},"DescribeCertificate":{"http":{"method":"GET","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"caCertificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"previousOwnedBy":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"transferData":{"type":"structure","members":{"transferMessage":{},"rejectReason":{},"transferDate":{"type":"timestamp"},"acceptDate":{"type":"timestamp"},"rejectDate":{"type":"timestamp"}}},"generationId":{},"validity":{"shape":"Sf6"},"certificateMode":{}}}}}},"DescribeDefaultAuthorizer":{"http":{"method":"GET","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Set"}}}},"DescribeDimension":{"http":{"method":"GET","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"name":{},"arn":{},"type":{},"stringValues":{"shape":"S2b"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeDomainConfiguration":{"http":{"method":"GET","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{},"domainName":{},"serverCertificates":{"type":"list","member":{"type":"structure","members":{"serverCertificateArn":{},"serverCertificateStatus":{},"serverCertificateStatusDetail":{}}}},"authorizerConfig":{"shape":"S2l"},"domainConfigurationStatus":{},"serviceType":{},"domainType":{}}}},"DescribeEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{"endpointType":{"location":"querystring","locationName":"endpointType"}}},"output":{"type":"structure","members":{"endpointAddress":{}}}},"DescribeEventConfigurations":{"http":{"method":"GET","requestUri":"/event-configurations"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"eventConfigurations":{"shape":"Sfy"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeIndex":{"http":{"method":"GET","requestUri":"/indices/{indexName}"},"input":{"type":"structure","required":["indexName"],"members":{"indexName":{"location":"uri","locationName":"indexName"}}},"output":{"type":"structure","members":{"indexName":{},"indexStatus":{},"schema":{}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"documentSource":{},"job":{"type":"structure","members":{"jobArn":{},"jobId":{},"targetSelection":{},"status":{},"forceCanceled":{"type":"boolean"},"reasonCode":{},"comment":{},"targets":{"shape":"Sg"},"description":{},"presignedUrlConfig":{"shape":"S36"},"jobExecutionsRolloutConfig":{"shape":"S3a"},"abortConfig":{"shape":"S3h"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"jobProcessDetails":{"type":"structure","members":{"processingTargets":{"type":"list","member":{}},"numberOfCanceledThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"},"numberOfFailedThings":{"type":"integer"},"numberOfRejectedThings":{"type":"integer"},"numberOfQueuedThings":{"type":"integer"},"numberOfInProgressThings":{"type":"integer"},"numberOfRemovedThings":{"type":"integer"},"numberOfTimedOutThings":{"type":"integer"}}},"timeoutConfig":{"shape":"S3o"}}}}}},"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"type":"structure","members":{"jobId":{},"status":{},"forceCanceled":{"type":"boolean"},"statusDetails":{"type":"structure","members":{"detailsMap":{"shape":"S1b"}}},"thingArn":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"},"versionNumber":{"type":"long"},"approximateSecondsBeforeTimedOut":{"type":"long"}}}}}},"DescribeMitigationAction":{"http":{"method":"GET","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{"actionName":{},"actionType":{},"actionArn":{},"actionId":{},"roleArn":{},"actionParams":{"shape":"S3y"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeProvisioningTemplate":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"defaultVersionId":{"type":"integer"},"templateBody":{},"enabled":{"type":"boolean"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S6n"}}}},"DescribeProvisioningTemplateVersion":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}/versions/{versionId}"},"input":{"type":"structure","required":["templateName","versionId"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"versionId":{"location":"uri","locationName":"versionId","type":"integer"}}},"output":{"type":"structure","members":{"versionId":{"type":"integer"},"creationDate":{"type":"timestamp"},"templateBody":{},"isDefaultVersion":{"type":"boolean"}}}},"DescribeRoleAlias":{"http":{"method":"GET","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{"roleAliasDescription":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{},"roleArn":{},"owner":{},"credentialDurationSeconds":{"type":"integer"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}}}},"DescribeScheduledAudit":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S73"},"scheduledAuditName":{},"scheduledAuditArn":{}}}},"DescribeSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S7a"},"alertTargets":{"shape":"S7t"},"additionalMetricsToRetain":{"shape":"S7x","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S7y"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeStream":{"http":{"method":"GET","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"streamInfo":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{},"files":{"shape":"S84"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"roleArn":{}}}}}},"DescribeThing":{"http":{"method":"GET","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"defaultClientId":{},"thingName":{},"thingId":{},"thingArn":{},"thingTypeName":{},"attributes":{"shape":"S2u"},"version":{"type":"long"},"billingGroupName":{}}}},"DescribeThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupArn":{},"version":{"type":"long"},"thingGroupProperties":{"shape":"S2r"},"thingGroupMetadata":{"type":"structure","members":{"parentGroupName":{},"rootToParentThingGroups":{"shape":"Shf"},"creationDate":{"type":"timestamp"}}},"indexName":{},"queryString":{},"queryVersion":{},"status":{}}}},"DescribeThingRegistrationTask":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{},"status":{},"message":{},"successCount":{"type":"integer"},"failureCount":{"type":"integer"},"percentageProgress":{"type":"integer"}}}},"DescribeThingType":{"http":{"method":"GET","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeId":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S8g"},"thingTypeMetadata":{"shape":"Shs"}}}},"DetachPolicy":{"http":{"requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"DetachPrincipalPolicy":{"http":{"method":"DELETE","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"DetachSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"DetachThingPrincipal":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"DisableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/disable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"EnableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/enable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"GetCardinality":{"http":{"requestUri":"/indices/cardinality"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"cardinality":{"type":"integer"}}}},"GetEffectivePolicies":{"http":{"requestUri":"/effective-policies"},"input":{"type":"structure","members":{"principal":{},"cognitoIdentityPoolId":{},"thingName":{"location":"querystring","locationName":"thingName"}}},"output":{"type":"structure","members":{"effectivePolicies":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{}}}}}}},"GetIndexingConfiguration":{"http":{"method":"GET","requestUri":"/indexing/config"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Sic"},"thingGroupIndexingConfiguration":{"shape":"Sij"}}}},"GetJobDocument":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/job-document"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"document":{}}}},"GetLoggingOptions":{"http":{"method":"GET","requestUri":"/loggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"logLevel":{}}}},"GetOTAUpdate":{"http":{"method":"GET","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"}}},"output":{"type":"structure","members":{"otaUpdateInfo":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"description":{},"targets":{"shape":"S4h"},"protocols":{"shape":"S4j"},"awsJobExecutionsRolloutConfig":{"shape":"S4l"},"awsJobPresignedUrlConfig":{"shape":"S4s"},"targetSelection":{},"otaUpdateFiles":{"shape":"S53"},"otaUpdateStatus":{},"awsIotJobId":{},"awsIotJobArn":{},"errorInfo":{"type":"structure","members":{"code":{},"message":{}}},"additionalParameters":{"shape":"S60"}}}}}},"GetPercentiles":{"http":{"requestUri":"/indices/percentiles"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{},"percents":{"type":"list","member":{"type":"double"}}}},"output":{"type":"structure","members":{"percentiles":{"type":"list","member":{"type":"structure","members":{"percent":{"type":"double"},"value":{"type":"double"}}}}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"defaultVersionId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetPolicyVersion":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}},"output":{"type":"structure","members":{"policyArn":{},"policyName":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetRegistrationCode":{"http":{"method":"GET","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registrationCode":{}}}},"GetStatistics":{"http":{"requestUri":"/indices/statistics"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"statistics":{"type":"structure","members":{"count":{"type":"integer"},"average":{"type":"double"},"sum":{"type":"double"},"minimum":{"type":"double"},"maximum":{"type":"double"},"sumOfSquares":{"type":"double"},"variance":{"type":"double"},"stdDeviation":{"type":"double"}}}}}},"GetTopicRule":{"http":{"method":"GET","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","members":{"ruleArn":{},"rule":{"type":"structure","members":{"ruleName":{},"sql":{},"description":{},"createdAt":{"type":"timestamp"},"actions":{"shape":"S8r"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"S8s"}}}}}},"GetTopicRuleDestination":{"http":{"method":"GET","requestUri":"/destinations/{arn+}"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{"topicRuleDestination":{"shape":"Sbb"}}}},"GetV2LoggingOptions":{"http":{"method":"GET","requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"ListActiveViolations":{"http":{"method":"GET","requestUri":"/active-violations"},"input":{"type":"structure","members":{"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"activeViolations":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S7b"},"lastViolationValue":{"shape":"S7i"},"lastViolationTime":{"type":"timestamp"},"violationStartTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAttachedPolicies":{"http":{"requestUri":"/attached-policies/{target}"},"input":{"type":"structure","required":["target"],"members":{"target":{"location":"uri","locationName":"target"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sk6"},"nextMarker":{}}}},"ListAuditFindings":{"http":{"requestUri":"/audit/findings"},"input":{"type":"structure","members":{"taskId":{},"checkName":{},"resourceIdentifier":{"shape":"Sdf"},"maxResults":{"type":"integer"},"nextToken":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"findings":{"type":"list","member":{"shape":"Sda"}},"nextToken":{}}}},"ListAuditMitigationActionsExecutions":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/executions"},"input":{"type":"structure","required":["taskId","findingId"],"members":{"taskId":{"location":"querystring","locationName":"taskId"},"actionStatus":{"location":"querystring","locationName":"actionStatus"},"findingId":{"location":"querystring","locationName":"findingId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionsExecutions":{"type":"list","member":{"type":"structure","members":{"taskId":{},"findingId":{},"actionName":{},"actionId":{},"status":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"errorCode":{},"message":{}}}},"nextToken":{}}}},"ListAuditMitigationActionsTasks":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"auditTaskId":{"location":"querystring","locationName":"auditTaskId"},"findingId":{"location":"querystring","locationName":"findingId"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"startTime":{"type":"timestamp"},"taskStatus":{}}}},"nextToken":{}}}},"ListAuditTasks":{"http":{"method":"GET","requestUri":"/audit/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"taskType":{"location":"querystring","locationName":"taskType"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskStatus":{},"taskType":{}}}},"nextToken":{}}}},"ListAuthorizers":{"http":{"method":"GET","requestUri":"/authorizers/"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"authorizers":{"type":"list","member":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"nextMarker":{}}}},"ListBillingGroups":{"http":{"method":"GET","requestUri":"/billing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"}}},"output":{"type":"structure","members":{"billingGroups":{"type":"list","member":{"shape":"Shg"}},"nextToken":{}}}},"ListCACertificates":{"http":{"method":"GET","requestUri":"/cacertificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListCertificates":{"http":{"method":"GET","requestUri":"/certificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sl3"},"nextMarker":{}}}},"ListCertificatesByCA":{"http":{"method":"GET","requestUri":"/certificates-by-ca/{caCertificateId}"},"input":{"type":"structure","required":["caCertificateId"],"members":{"caCertificateId":{"location":"uri","locationName":"caCertificateId"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sl3"},"nextMarker":{}}}},"ListDimensions":{"http":{"method":"GET","requestUri":"/dimensions"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"dimensionNames":{"type":"list","member":{}},"nextToken":{}}}},"ListDomainConfigurations":{"http":{"method":"GET","requestUri":"/domainConfigurations"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"serviceType":{"location":"querystring","locationName":"serviceType"}}},"output":{"type":"structure","members":{"domainConfigurations":{"type":"list","member":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{},"serviceType":{}}}},"nextMarker":{}}}},"ListIndices":{"http":{"method":"GET","requestUri":"/indices"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"indexNames":{"type":"list","member":{}},"nextToken":{}}}},"ListJobExecutionsForJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/things"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"jobExecutionSummary":{"shape":"Sln"}}}},"nextToken":{}}}},"ListJobExecutionsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"jobId":{},"jobExecutionSummary":{"shape":"Sln"}}}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"targetSelection":{"location":"querystring","locationName":"targetSelection"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"thingGroupName":{"location":"querystring","locationName":"thingGroupName"},"thingGroupId":{"location":"querystring","locationName":"thingGroupId"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobArn":{},"jobId":{},"thingGroupId":{},"targetSelection":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListMitigationActions":{"http":{"method":"GET","requestUri":"/mitigationactions/actions"},"input":{"type":"structure","members":{"actionType":{"location":"querystring","locationName":"actionType"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionIdentifiers":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOTAUpdates":{"http":{"method":"GET","requestUri":"/otaUpdates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"otaUpdateStatus":{"location":"querystring","locationName":"otaUpdateStatus"}}},"output":{"type":"structure","members":{"otaUpdates":{"type":"list","member":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOutgoingCertificates":{"http":{"method":"GET","requestUri":"/certificates-out-going"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"outgoingCertificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"transferredTo":{},"transferDate":{"type":"timestamp"},"transferMessage":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListPolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sk6"},"nextMarker":{}}}},"ListPolicyPrincipals":{"http":{"method":"GET","requestUri":"/policy-principals"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"header","locationName":"x-amzn-iot-policy"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"principals":{"shape":"Smc"},"nextMarker":{}}},"deprecated":true},"ListPolicyVersions":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyVersions":{"type":"list","member":{"type":"structure","members":{"versionId":{},"isDefaultVersion":{"type":"boolean"},"createDate":{"type":"timestamp"}}}}}}},"ListPrincipalPolicies":{"http":{"method":"GET","requestUri":"/principal-policies"},"input":{"type":"structure","required":["principal"],"members":{"principal":{"location":"header","locationName":"x-amzn-iot-principal"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sk6"},"nextMarker":{}}},"deprecated":true},"ListPrincipalThings":{"http":{"method":"GET","requestUri":"/principals/things"},"input":{"type":"structure","required":["principal"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{"things":{"shape":"Smm"},"nextToken":{}}}},"ListProvisioningTemplateVersions":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}/versions"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"versions":{"type":"list","member":{"type":"structure","members":{"versionId":{"type":"integer"},"creationDate":{"type":"timestamp"},"isDefaultVersion":{"type":"boolean"}}}},"nextToken":{}}}},"ListProvisioningTemplates":{"http":{"method":"GET","requestUri":"/provisioning-templates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"templates":{"type":"list","member":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"enabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListRoleAliases":{"http":{"method":"GET","requestUri":"/role-aliases"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"roleAliases":{"type":"list","member":{}},"nextMarker":{}}}},"ListScheduledAudits":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"scheduledAudits":{"type":"list","member":{"type":"structure","members":{"scheduledAuditName":{},"scheduledAuditArn":{},"frequency":{},"dayOfMonth":{},"dayOfWeek":{}}}},"nextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"dimensionName":{"location":"querystring","locationName":"dimensionName"}}},"output":{"type":"structure","members":{"securityProfileIdentifiers":{"type":"list","member":{"shape":"Sn5"}},"nextToken":{}}}},"ListSecurityProfilesForTarget":{"http":{"method":"GET","requestUri":"/security-profiles-for-target"},"input":{"type":"structure","required":["securityProfileTargetArn"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{"securityProfileTargetMappings":{"type":"list","member":{"type":"structure","members":{"securityProfileIdentifier":{"shape":"Sn5"},"target":{"shape":"Sna"}}}},"nextToken":{}}}},"ListStreams":{"http":{"method":"GET","requestUri":"/streams"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"streams":{"type":"list","member":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1r"},"nextToken":{}}}},"ListTargetsForPolicy":{"http":{"requestUri":"/policy-targets/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"targets":{"type":"list","member":{}},"nextMarker":{}}}},"ListTargetsForSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"securityProfileTargets":{"type":"list","member":{"shape":"Sna"}},"nextToken":{}}}},"ListThingGroups":{"http":{"method":"GET","requestUri":"/thing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"parentGroup":{"location":"querystring","locationName":"parentGroup"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Shf"},"nextToken":{}}}},"ListThingGroupsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/thing-groups"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Shf"},"nextToken":{}}}},"ListThingPrincipals":{"http":{"method":"GET","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"principals":{"shape":"Smc"}}}},"ListThingRegistrationTaskReports":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}/reports"},"input":{"type":"structure","required":["taskId","reportType"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"reportType":{"location":"querystring","locationName":"reportType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resourceLinks":{"type":"list","member":{}},"reportType":{},"nextToken":{}}}},"ListThingRegistrationTasks":{"http":{"method":"GET","requestUri":"/thing-registration-tasks"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"taskIds":{"type":"list","member":{}},"nextToken":{}}}},"ListThingTypes":{"http":{"method":"GET","requestUri":"/thing-types"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypes":{"type":"list","member":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S8g"},"thingTypeMetadata":{"shape":"Shs"}}}},"nextToken":{}}}},"ListThings":{"http":{"method":"GET","requestUri":"/things"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"attributeName":{"location":"querystring","locationName":"attributeName"},"attributeValue":{"location":"querystring","locationName":"attributeValue"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingTypeName":{},"thingArn":{},"attributes":{"shape":"S2u"},"version":{"type":"long"}}}},"nextToken":{}}}},"ListThingsInBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}/things"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Smm"},"nextToken":{}}}},"ListThingsInThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}/things"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Smm"},"nextToken":{}}}},"ListTopicRuleDestinations":{"http":{"method":"GET","requestUri":"/destinations"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"destinationSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"status":{},"statusReason":{},"httpUrlSummary":{"type":"structure","members":{"confirmationUrl":{}}}}}},"nextToken":{}}}},"ListTopicRules":{"http":{"method":"GET","requestUri":"/rules"},"input":{"type":"structure","members":{"topic":{"location":"querystring","locationName":"topic"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ruleDisabled":{"location":"querystring","locationName":"ruleDisabled","type":"boolean"}}},"output":{"type":"structure","members":{"rules":{"type":"list","member":{"type":"structure","members":{"ruleArn":{},"ruleName":{},"topicPattern":{},"createdAt":{"type":"timestamp"},"ruleDisabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListV2LoggingLevels":{"http":{"method":"GET","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","members":{"targetType":{"location":"querystring","locationName":"targetType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"logTargetConfigurations":{"type":"list","member":{"type":"structure","members":{"logTarget":{"shape":"Sow"},"logLevel":{}}}},"nextToken":{}}}},"ListViolationEvents":{"http":{"method":"GET","requestUri":"/violation-events"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"violationEvents":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S7b"},"metricValue":{"shape":"S7i"},"violationEventType":{},"violationEventTime":{"type":"timestamp"}}}},"nextToken":{}}}},"RegisterCACertificate":{"http":{"requestUri":"/cacertificate"},"input":{"type":"structure","required":["caCertificate","verificationCertificate"],"members":{"caCertificate":{},"verificationCertificate":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"},"allowAutoRegistration":{"location":"querystring","locationName":"allowAutoRegistration","type":"boolean"},"registrationConfig":{"shape":"Sf7"},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificate":{"http":{"requestUri":"/certificate/register"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"caCertificatePem":{},"setAsActive":{"deprecated":true,"location":"querystring","locationName":"setAsActive","type":"boolean"},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificateWithoutCA":{"http":{"requestUri":"/certificate/register-no-ca"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterThing":{"http":{"requestUri":"/things"},"input":{"type":"structure","required":["templateBody"],"members":{"templateBody":{},"parameters":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"certificatePem":{},"resourceArns":{"type":"map","key":{},"value":{}}}}},"RejectCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/reject-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"rejectReason":{}}}},"RemoveThingFromBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/removeThingFromBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"RemoveThingFromThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/removeThingFromThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"ReplaceTopicRule":{"http":{"method":"PATCH","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S8o"}},"payload":"topicRulePayload"}},"SearchIndex":{"http":{"requestUri":"/indices/search"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"nextToken":{},"maxResults":{"type":"integer"},"queryVersion":{}}},"output":{"type":"structure","members":{"nextToken":{},"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingId":{},"thingTypeName":{},"thingGroupNames":{"shape":"Spq"},"attributes":{"shape":"S2u"},"shadow":{},"connectivity":{"type":"structure","members":{"connected":{"type":"boolean"},"timestamp":{"type":"long"}}}}}},"thingGroups":{"type":"list","member":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupDescription":{},"attributes":{"shape":"S2u"},"parentGroupNames":{"shape":"Spq"}}}}}}},"SetDefaultAuthorizer":{"http":{"requestUri":"/default-authorizer"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"SetDefaultPolicyVersion":{"http":{"method":"PATCH","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"SetLoggingOptions":{"http":{"requestUri":"/loggingOptions"},"input":{"type":"structure","required":["loggingOptionsPayload"],"members":{"loggingOptionsPayload":{"type":"structure","required":["roleArn"],"members":{"roleArn":{},"logLevel":{}}}},"payload":"loggingOptionsPayload"}},"SetV2LoggingLevel":{"http":{"requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["logTarget","logLevel"],"members":{"logTarget":{"shape":"Sow"},"logLevel":{}}}},"SetV2LoggingOptions":{"http":{"requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"StartAuditMitigationActionsTask":{"http":{"requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId","target","auditCheckToActionsMapping","clientRequestToken"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"target":{"shape":"Sdz"},"auditCheckToActionsMapping":{"shape":"Se3"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartOnDemandAuditTask":{"http":{"requestUri":"/audit/tasks"},"input":{"type":"structure","required":["targetCheckNames"],"members":{"targetCheckNames":{"shape":"S73"}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartThingRegistrationTask":{"http":{"requestUri":"/thing-registration-tasks"},"input":{"type":"structure","required":["templateBody","inputFileBucket","inputFileKey","roleArn"],"members":{"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"StopThingRegistrationTask":{"http":{"method":"PUT","requestUri":"/thing-registration-tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{}}},"TestAuthorization":{"http":{"requestUri":"/test-authorization"},"input":{"type":"structure","required":["authInfos"],"members":{"principal":{},"cognitoIdentityPoolId":{},"authInfos":{"type":"list","member":{"shape":"Sqf"}},"clientId":{"location":"querystring","locationName":"clientId"},"policyNamesToAdd":{"shape":"Sqj"},"policyNamesToSkip":{"shape":"Sqj"}}},"output":{"type":"structure","members":{"authResults":{"type":"list","member":{"type":"structure","members":{"authInfo":{"shape":"Sqf"},"allowed":{"type":"structure","members":{"policies":{"shape":"Sk6"}}},"denied":{"type":"structure","members":{"implicitDeny":{"type":"structure","members":{"policies":{"shape":"Sk6"}}},"explicitDeny":{"type":"structure","members":{"policies":{"shape":"Sk6"}}}}},"authDecision":{},"missingContextValues":{"type":"list","member":{}}}}}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}/test"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"token":{},"tokenSignature":{},"httpContext":{"type":"structure","members":{"headers":{"type":"map","key":{},"value":{}},"queryString":{}}},"mqttContext":{"type":"structure","members":{"username":{},"password":{"type":"blob"},"clientId":{}}},"tlsContext":{"type":"structure","members":{"serverName":{}}}}},"output":{"type":"structure","members":{"isAuthenticated":{"type":"boolean"},"principalId":{},"policyDocuments":{"type":"list","member":{}},"refreshAfterInSeconds":{"type":"integer"},"disconnectAfterInSeconds":{"type":"integer"}}}},"TransferCertificate":{"http":{"method":"PATCH","requestUri":"/transfer-certificate/{certificateId}"},"input":{"type":"structure","required":["certificateId","targetAwsAccount"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"targetAwsAccount":{"location":"querystring","locationName":"targetAwsAccount"},"transferMessage":{}}},"output":{"type":"structure","members":{"transferredCertificateArn":{}}}},"UntagResource":{"http":{"requestUri":"/untag"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAccountAuditConfiguration":{"http":{"method":"PATCH","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sd2"},"auditCheckConfigurations":{"shape":"Sd5"}}},"output":{"type":"structure","members":{}}},"UpdateAuthorizer":{"http":{"method":"PUT","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S1n"},"status":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"UpdateBillingGroup":{"http":{"method":"PATCH","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName","billingGroupProperties"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S1z"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateCACertificate":{"http":{"method":"PUT","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"},"newAutoRegistrationStatus":{"location":"querystring","locationName":"newAutoRegistrationStatus"},"registrationConfig":{"shape":"Sf7"},"removeAutoRegistration":{"type":"boolean"}}}},"UpdateCertificate":{"http":{"method":"PUT","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId","newStatus"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"}}}},"UpdateDimension":{"http":{"method":"PATCH","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name","stringValues"],"members":{"name":{"location":"uri","locationName":"name"},"stringValues":{"shape":"S2b"}}},"output":{"type":"structure","members":{"name":{},"arn":{},"type":{},"stringValues":{"shape":"S2b"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateDomainConfiguration":{"http":{"method":"PUT","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"},"authorizerConfig":{"shape":"S2l"},"domainConfigurationStatus":{},"removeAuthorizerConfig":{"type":"boolean"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{}}}},"UpdateDynamicThingGroup":{"http":{"method":"PATCH","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S2r"},"expectedVersion":{"type":"long"},"indexName":{},"queryString":{},"queryVersion":{}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateEventConfigurations":{"http":{"method":"PATCH","requestUri":"/event-configurations"},"input":{"type":"structure","members":{"eventConfigurations":{"shape":"Sfy"}}},"output":{"type":"structure","members":{}}},"UpdateIndexingConfiguration":{"http":{"requestUri":"/indexing/config"},"input":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Sic"},"thingGroupIndexingConfiguration":{"shape":"Sij"}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"http":{"method":"PATCH","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"description":{},"presignedUrlConfig":{"shape":"S36"},"jobExecutionsRolloutConfig":{"shape":"S3a"},"abortConfig":{"shape":"S3h"},"timeoutConfig":{"shape":"S3o"}}}},"UpdateMitigationAction":{"http":{"method":"PATCH","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S3y"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"UpdateProvisioningTemplate":{"http":{"method":"PATCH","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"description":{},"enabled":{"type":"boolean"},"defaultVersionId":{"type":"integer"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S6n"},"removePreProvisioningHook":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateRoleAlias":{"http":{"method":"PUT","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"UpdateScheduledAudit":{"http":{"method":"PATCH","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S73"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"UpdateSecurityProfile":{"http":{"method":"PATCH","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S7a"},"alertTargets":{"shape":"S7t"},"additionalMetricsToRetain":{"shape":"S7x","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S7y"},"deleteBehaviors":{"type":"boolean"},"deleteAlertTargets":{"type":"boolean"},"deleteAdditionalMetricsToRetain":{"type":"boolean"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S7a"},"alertTargets":{"shape":"S7t"},"additionalMetricsToRetain":{"shape":"S7x","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S7y"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateStream":{"http":{"method":"PUT","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S84"},"roleArn":{}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"UpdateThing":{"http":{"method":"PATCH","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S2t"},"expectedVersion":{"type":"long"},"removeThingType":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateThingGroup":{"http":{"method":"PATCH","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S2r"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateThingGroupsForThing":{"http":{"method":"PUT","requestUri":"/thing-groups/updateThingGroupsForThing"},"input":{"type":"structure","members":{"thingName":{},"thingGroupsToAdd":{"shape":"Ssp"},"thingGroupsToRemove":{"shape":"Ssp"},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateTopicRuleDestination":{"http":{"method":"PATCH","requestUri":"/destinations"},"input":{"type":"structure","required":["arn","status"],"members":{"arn":{},"status":{}}},"output":{"type":"structure","members":{}}},"ValidateSecurityProfileBehaviors":{"http":{"requestUri":"/security-profile-behaviors/validate"},"input":{"type":"structure","required":["behaviors"],"members":{"behaviors":{"shape":"S7a"}}},"output":{"type":"structure","members":{"valid":{"type":"boolean"},"validationErrors":{"type":"list","member":{"type":"structure","members":{"errorMessage":{}}}}}}}},"shapes":{"Sg":{"type":"list","member":{}},"S1b":{"type":"map","key":{},"value":{}},"S1n":{"type":"map","key":{},"value":{}},"S1r":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1z":{"type":"structure","members":{"billingGroupDescription":{}}},"S2b":{"type":"list","member":{}},"S2l":{"type":"structure","members":{"defaultAuthorizerName":{},"allowAuthorizerOverride":{"type":"boolean"}}},"S2r":{"type":"structure","members":{"thingGroupDescription":{},"attributePayload":{"shape":"S2t"}}},"S2t":{"type":"structure","members":{"attributes":{"shape":"S2u"},"merge":{"type":"boolean"}}},"S2u":{"type":"map","key":{},"value":{}},"S36":{"type":"structure","members":{"roleArn":{},"expiresInSec":{"type":"long"}}},"S3a":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S3h":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"S3o":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"S3t":{"type":"structure","members":{"PublicKey":{},"PrivateKey":{"type":"string","sensitive":true}}},"S3y":{"type":"structure","members":{"updateDeviceCertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"updateCACertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"addThingsToThingGroupParams":{"type":"structure","required":["thingGroupNames"],"members":{"thingGroupNames":{"type":"list","member":{}},"overrideDynamicGroups":{"type":"boolean"}}},"replaceDefaultPolicyVersionParams":{"type":"structure","required":["templateName"],"members":{"templateName":{}}},"enableIoTLoggingParams":{"type":"structure","required":["roleArnForLogging","logLevel"],"members":{"roleArnForLogging":{},"logLevel":{}}},"publishFindingToSnsParams":{"type":"structure","required":["topicArn"],"members":{"topicArn":{}}}}},"S4h":{"type":"list","member":{}},"S4j":{"type":"list","member":{}},"S4l":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S4s":{"type":"structure","members":{"expiresInSec":{"type":"long"}}},"S53":{"type":"list","member":{"type":"structure","members":{"fileName":{},"fileVersion":{},"fileLocation":{"type":"structure","members":{"stream":{"type":"structure","members":{"streamId":{},"fileId":{"type":"integer"}}},"s3Location":{"shape":"S5b"}}},"codeSigning":{"type":"structure","members":{"awsSignerJobId":{},"startSigningJobParameter":{"type":"structure","members":{"signingProfileParameter":{"type":"structure","members":{"certificateArn":{},"platform":{},"certificatePathOnDevice":{}}},"signingProfileName":{},"destination":{"type":"structure","members":{"s3Destination":{"type":"structure","members":{"bucket":{},"prefix":{}}}}}}},"customCodeSigning":{"type":"structure","members":{"signature":{"type":"structure","members":{"inlineDocument":{"type":"blob"}}},"certificateChain":{"type":"structure","members":{"certificateName":{},"inlineDocument":{}}},"hashAlgorithm":{},"signatureAlgorithm":{}}}}},"attributes":{"type":"map","key":{},"value":{}}}}},"S5b":{"type":"structure","members":{"bucket":{},"key":{},"version":{}}},"S60":{"type":"map","key":{},"value":{}},"S6n":{"type":"structure","required":["targetArn"],"members":{"payloadVersion":{},"targetArn":{}}},"S73":{"type":"list","member":{}},"S7a":{"type":"list","member":{"shape":"S7b"}},"S7b":{"type":"structure","required":["name"],"members":{"name":{},"metric":{},"metricDimension":{"shape":"S7e"},"criteria":{"type":"structure","members":{"comparisonOperator":{},"value":{"shape":"S7i"},"durationSeconds":{"type":"integer"},"consecutiveDatapointsToAlarm":{"type":"integer"},"consecutiveDatapointsToClear":{"type":"integer"},"statisticalThreshold":{"type":"structure","members":{"statistic":{}}}}}}},"S7e":{"type":"structure","required":["dimensionName"],"members":{"dimensionName":{},"operator":{}}},"S7i":{"type":"structure","members":{"count":{"type":"long"},"cidrs":{"type":"list","member":{}},"ports":{"type":"list","member":{"type":"integer"}}}},"S7t":{"type":"map","key":{},"value":{"type":"structure","required":["alertTargetArn","roleArn"],"members":{"alertTargetArn":{},"roleArn":{}}}},"S7x":{"type":"list","member":{}},"S7y":{"type":"list","member":{"type":"structure","required":["metric"],"members":{"metric":{},"metricDimension":{"shape":"S7e"}}}},"S84":{"type":"list","member":{"type":"structure","members":{"fileId":{"type":"integer"},"s3Location":{"shape":"S5b"}}}},"S8g":{"type":"structure","members":{"thingTypeDescription":{},"searchableAttributes":{"type":"list","member":{}}}},"S8o":{"type":"structure","required":["sql","actions"],"members":{"sql":{},"description":{},"actions":{"shape":"S8r"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"S8s"}}},"S8r":{"type":"list","member":{"shape":"S8s"}},"S8s":{"type":"structure","members":{"dynamoDB":{"type":"structure","required":["tableName","roleArn","hashKeyField","hashKeyValue"],"members":{"tableName":{},"roleArn":{},"operation":{},"hashKeyField":{},"hashKeyValue":{},"hashKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"rangeKeyType":{},"payloadField":{}}},"dynamoDBv2":{"type":"structure","required":["roleArn","putItem"],"members":{"roleArn":{},"putItem":{"type":"structure","required":["tableName"],"members":{"tableName":{}}}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"sns":{"type":"structure","required":["targetArn","roleArn"],"members":{"targetArn":{},"roleArn":{},"messageFormat":{}}},"sqs":{"type":"structure","required":["roleArn","queueUrl"],"members":{"roleArn":{},"queueUrl":{},"useBase64":{"type":"boolean"}}},"kinesis":{"type":"structure","required":["roleArn","streamName"],"members":{"roleArn":{},"streamName":{},"partitionKey":{}}},"republish":{"type":"structure","required":["roleArn","topic"],"members":{"roleArn":{},"topic":{},"qos":{"type":"integer"}}},"s3":{"type":"structure","required":["roleArn","bucketName","key"],"members":{"roleArn":{},"bucketName":{},"key":{},"cannedAcl":{}}},"firehose":{"type":"structure","required":["roleArn","deliveryStreamName"],"members":{"roleArn":{},"deliveryStreamName":{},"separator":{}}},"cloudwatchMetric":{"type":"structure","required":["roleArn","metricNamespace","metricName","metricValue","metricUnit"],"members":{"roleArn":{},"metricNamespace":{},"metricName":{},"metricValue":{},"metricUnit":{},"metricTimestamp":{}}},"cloudwatchAlarm":{"type":"structure","required":["roleArn","alarmName","stateReason","stateValue"],"members":{"roleArn":{},"alarmName":{},"stateReason":{},"stateValue":{}}},"cloudwatchLogs":{"type":"structure","required":["roleArn","logGroupName"],"members":{"roleArn":{},"logGroupName":{}}},"elasticsearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"salesforce":{"type":"structure","required":["token","url"],"members":{"token":{},"url":{}}},"iotAnalytics":{"type":"structure","members":{"channelArn":{},"channelName":{},"roleArn":{}}},"iotEvents":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"messageId":{},"roleArn":{}}},"iotSiteWise":{"type":"structure","required":["putAssetPropertyValueEntries","roleArn"],"members":{"putAssetPropertyValueEntries":{"type":"list","member":{"type":"structure","required":["propertyValues"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"propertyValues":{"type":"list","member":{"type":"structure","required":["value","timestamp"],"members":{"value":{"type":"structure","members":{"stringValue":{},"integerValue":{},"doubleValue":{},"booleanValue":{}}},"timestamp":{"type":"structure","required":["timeInSeconds"],"members":{"timeInSeconds":{},"offsetInNanos":{}}},"quality":{}}}}}}},"roleArn":{}}},"stepFunctions":{"type":"structure","required":["stateMachineName","roleArn"],"members":{"executionNamePrefix":{},"stateMachineName":{},"roleArn":{}}},"http":{"type":"structure","required":["url"],"members":{"url":{},"confirmationUrl":{},"headers":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"auth":{"type":"structure","members":{"sigv4":{"type":"structure","required":["signingRegion","serviceName","roleArn"],"members":{"signingRegion":{},"serviceName":{},"roleArn":{}}}}}}}}},"Sbb":{"type":"structure","members":{"arn":{},"status":{},"statusReason":{},"httpUrlProperties":{"type":"structure","members":{"confirmationUrl":{}}}}},"Sd2":{"type":"map","key":{},"value":{"type":"structure","members":{"targetArn":{},"roleArn":{},"enabled":{"type":"boolean"}}}},"Sd5":{"type":"map","key":{},"value":{"type":"structure","members":{"enabled":{"type":"boolean"}}}},"Sda":{"type":"structure","members":{"findingId":{},"taskId":{},"checkName":{},"taskStartTime":{"type":"timestamp"},"findingTime":{"type":"timestamp"},"severity":{},"nonCompliantResource":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"Sdf"},"additionalInfo":{"shape":"Sdk"}}},"relatedResources":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"Sdf"},"additionalInfo":{"shape":"Sdk"}}}},"reasonForNonCompliance":{},"reasonForNonComplianceCode":{}}},"Sdf":{"type":"structure","members":{"deviceCertificateId":{},"caCertificateId":{},"cognitoIdentityPoolId":{},"clientId":{},"policyVersionIdentifier":{"type":"structure","members":{"policyName":{},"policyVersionId":{}}},"account":{},"iamRoleArn":{},"roleAliasArn":{}}},"Sdk":{"type":"map","key":{},"value":{}},"Sdz":{"type":"structure","members":{"auditTaskId":{},"findingIds":{"type":"list","member":{}},"auditCheckToReasonCodeFilter":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"Se3":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Set":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S1n"},"status":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"signingDisabled":{"type":"boolean"}}},"Sf6":{"type":"structure","members":{"notBefore":{"type":"timestamp"},"notAfter":{"type":"timestamp"}}},"Sf7":{"type":"structure","members":{"templateBody":{},"roleArn":{}}},"Sfy":{"type":"map","key":{},"value":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"Shf":{"type":"list","member":{"shape":"Shg"}},"Shg":{"type":"structure","members":{"groupName":{},"groupArn":{}}},"Shs":{"type":"structure","members":{"deprecated":{"type":"boolean"},"deprecationDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"}}},"Sic":{"type":"structure","required":["thingIndexingMode"],"members":{"thingIndexingMode":{},"thingConnectivityIndexingMode":{},"managedFields":{"shape":"Sif"},"customFields":{"shape":"Sif"}}},"Sif":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{}}}},"Sij":{"type":"structure","required":["thingGroupIndexingMode"],"members":{"thingGroupIndexingMode":{},"managedFields":{"shape":"Sif"},"customFields":{"shape":"Sif"}}},"Sk6":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{}}}},"Sl3":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificateMode":{},"creationDate":{"type":"timestamp"}}}},"Sln":{"type":"structure","members":{"status":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"}}},"Smc":{"type":"list","member":{}},"Smm":{"type":"list","member":{}},"Sn5":{"type":"structure","required":["name","arn"],"members":{"name":{},"arn":{}}},"Sna":{"type":"structure","required":["arn"],"members":{"arn":{}}},"Sow":{"type":"structure","required":["targetType"],"members":{"targetType":{},"targetName":{}}},"Spq":{"type":"list","member":{}},"Sqf":{"type":"structure","required":["resources"],"members":{"actionType":{},"resources":{"type":"list","member":{}}}},"Sqj":{"type":"list","member":{}},"Ssp":{"type":"list","member":{}}}}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"data.iot","protocol":"rest-json","serviceFullName":"AWS IoT Data Plane","serviceId":"IoT Data Plane","signatureVersion":"v4","signingName":"iotdata","uid":"iot-data-2015-05-28"},"operations":{"DeleteThingShadow":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","required":["payload"],"members":{"payload":{"type":"blob"}},"payload":"payload"}},"GetThingShadow":{"http":{"method":"GET","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}},"ListNamedShadowsForThing":{"http":{"method":"GET","requestUri":"/api/things/shadow/ListNamedShadowsForThing/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{}},"nextToken":{},"timestamp":{"type":"long"}}}},"Publish":{"http":{"requestUri":"/topics/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"},"qos":{"location":"querystring","locationName":"qos","type":"integer"},"payload":{"type":"blob"}},"payload":"payload"}},"UpdateThingShadow":{"http":{"requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName","payload"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"},"payload":{"type":"blob"}},"payload":"payload"},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}}},"shapes":{}}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"iotanalytics","protocol":"rest-json","serviceFullName":"AWS IoT Analytics","serviceId":"IoTAnalytics","signatureVersion":"v4","signingName":"iotanalytics","uid":"iotanalytics-2017-11-27"},"operations":{"BatchPutMessage":{"http":{"requestUri":"/messages/batch","responseCode":200},"input":{"type":"structure","required":["channelName","messages"],"members":{"channelName":{},"messages":{"type":"list","member":{"type":"structure","required":["messageId","payload"],"members":{"messageId":{},"payload":{"type":"blob"}}}}}},"output":{"type":"structure","members":{"batchPutMessageErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"CancelPipelineReprocessing":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}/reprocessing/{reprocessingId}"},"input":{"type":"structure","required":["pipelineName","reprocessingId"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"reprocessingId":{"location":"uri","locationName":"reprocessingId"}}},"output":{"type":"structure","members":{}}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":201},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"channelName":{},"channelArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDataset":{"http":{"requestUri":"/datasets","responseCode":201},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"datasetName":{},"datasetArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDatasetContent":{"http":{"requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}},"output":{"type":"structure","members":{"versionId":{}}}},"CreateDatastore":{"http":{"requestUri":"/datastores","responseCode":201},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{},"datastoreStorage":{"shape":"S2b"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"datastoreName":{},"datastoreArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreatePipeline":{"http":{"requestUri":"/pipelines","responseCode":201},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{},"pipelineActivities":{"shape":"S2h"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineArn":{}}}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{channelName}","responseCode":204},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}}},"DeleteDatasetContent":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}/content","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}}},"DeleteDatastore":{"http":{"method":"DELETE","requestUri":"/datastores/{datastoreName}","responseCode":204},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}","responseCode":204},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"channel":{"type":"structure","members":{"name":{},"storage":{"shape":"Sh"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S3f"}}}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"arn":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"}}}}}},"DescribeDatastore":{"http":{"method":"GET","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"datastore":{"type":"structure","members":{"name":{},"storage":{"shape":"S2b"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S3f"}}}}}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"loggingOptions":{"shape":"S3s"}}}},"DescribePipeline":{"http":{"method":"GET","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}},"output":{"type":"structure","members":{"pipeline":{"type":"structure","members":{"name":{},"arn":{},"activities":{"shape":"S2h"},"reprocessingSummaries":{"shape":"S3y"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"GetDatasetContent":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"entries":{"type":"list","member":{"type":"structure","members":{"entryName":{},"dataURI":{}}}},"timestamp":{"type":"timestamp"},"status":{"shape":"S46"}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"channelSummaries":{"type":"list","member":{"type":"structure","members":{"channelName":{},"channelStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasetContents":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/contents"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"scheduledOnOrAfter":{"location":"querystring","locationName":"scheduledOnOrAfter","type":"timestamp"},"scheduledBefore":{"location":"querystring","locationName":"scheduledBefore","type":"timestamp"}}},"output":{"type":"structure","members":{"datasetContentSummaries":{"type":"list","member":{"type":"structure","members":{"version":{},"status":{"shape":"S46"},"creationTime":{"type":"timestamp"},"scheduleTime":{"type":"timestamp"},"completionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/datasets"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datasetSummaries":{"type":"list","member":{"type":"structure","members":{"datasetName":{},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"triggers":{"shape":"S1l"},"actions":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionType":{}}}}}}},"nextToken":{}}}},"ListDatastores":{"http":{"method":"GET","requestUri":"/datastores"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datastoreSummaries":{"type":"list","member":{"type":"structure","members":{"datastoreName":{},"datastoreStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/pipelines"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"pipelineSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineName":{},"reprocessingSummaries":{"shape":"S3y"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"}}}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S3s"}}}},"RunPipelineActivity":{"http":{"requestUri":"/pipelineactivities/run"},"input":{"type":"structure","required":["pipelineActivity","payloads"],"members":{"pipelineActivity":{"shape":"S2i"},"payloads":{"shape":"S59"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S59"},"logResult":{}}}},"SampleChannelData":{"http":{"method":"GET","requestUri":"/channels/{channelName}/sample"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"maxMessages":{"location":"querystring","locationName":"maxMessages","type":"integer"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S59"}}}},"StartPipelineReprocessing":{"http":{"requestUri":"/pipelines/{pipelineName}/reprocessing"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"reprocessingId":{}}}},"TagResource":{"http":{"requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"}}}},"UpdateDataset":{"http":{"method":"PUT","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"}}}},"UpdateDatastore":{"http":{"method":"PUT","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"retentionPeriod":{"shape":"Sn"},"datastoreStorage":{"shape":"S2b"}}}},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"pipelineActivities":{"shape":"S2h"}}}}},"shapes":{"Sh":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"Sn":{"type":"structure","members":{"unlimited":{"type":"boolean"},"numberOfDays":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{"type":"structure","members":{"actionName":{},"queryAction":{"type":"structure","required":["sqlQuery"],"members":{"sqlQuery":{},"filters":{"type":"list","member":{"type":"structure","members":{"deltaTime":{"type":"structure","required":["offsetSeconds","timeExpression"],"members":{"offsetSeconds":{"type":"integer"},"timeExpression":{}}}}}}}},"containerAction":{"type":"structure","required":["image","executionRoleArn","resourceConfiguration"],"members":{"image":{},"executionRoleArn":{},"resourceConfiguration":{"type":"structure","required":["computeType","volumeSizeInGB"],"members":{"computeType":{},"volumeSizeInGB":{"type":"integer"}}},"variables":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"stringValue":{},"doubleValue":{"type":"double"},"datasetContentVersionValue":{"type":"structure","required":["datasetName"],"members":{"datasetName":{}}},"outputFileUriValue":{"type":"structure","required":["fileName"],"members":{"fileName":{}}}}}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"schedule":{"type":"structure","members":{"expression":{}}},"dataset":{"type":"structure","required":["name"],"members":{"name":{}}}}}},"S1q":{"type":"list","member":{"type":"structure","required":["destination"],"members":{"entryName":{},"destination":{"type":"structure","members":{"iotEventsDestinationConfiguration":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"roleArn":{}}},"s3DestinationConfiguration":{"type":"structure","required":["bucket","key","roleArn"],"members":{"bucket":{},"key":{},"glueConfiguration":{"type":"structure","required":["tableName","databaseName"],"members":{"tableName":{},"databaseName":{}}},"roleArn":{}}}}}}}},"S21":{"type":"structure","members":{"unlimited":{"type":"boolean"},"maxVersions":{"type":"integer"}}},"S2b":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"S2h":{"type":"list","member":{"shape":"S2i"}},"S2i":{"type":"structure","members":{"channel":{"type":"structure","required":["name","channelName"],"members":{"name":{},"channelName":{},"next":{}}},"lambda":{"type":"structure","required":["name","lambdaName","batchSize"],"members":{"name":{},"lambdaName":{},"batchSize":{"type":"integer"},"next":{}}},"datastore":{"type":"structure","required":["name","datastoreName"],"members":{"name":{},"datastoreName":{}}},"addAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"type":"map","key":{},"value":{}},"next":{}}},"removeAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S2t"},"next":{}}},"selectAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S2t"},"next":{}}},"filter":{"type":"structure","required":["name","filter"],"members":{"name":{},"filter":{},"next":{}}},"math":{"type":"structure","required":["name","attribute","math"],"members":{"name":{},"attribute":{},"math":{},"next":{}}},"deviceRegistryEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}},"deviceShadowEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}}}},"S2t":{"type":"list","member":{}},"S3f":{"type":"structure","members":{"estimatedSizeInBytes":{"type":"double"},"estimatedOn":{"type":"timestamp"}}},"S3s":{"type":"structure","required":["roleArn","level","enabled"],"members":{"roleArn":{},"level":{},"enabled":{"type":"boolean"}}},"S3y":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"creationTime":{"type":"timestamp"}}}},"S46":{"type":"structure","members":{"state":{},"reason":{}}},"S59":{"type":"list","member":{"type":"blob"}}}}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListChannels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasetContents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatastores":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-12-02","endpointPrefix":"kinesis","jsonVersion":"1.1","protocol":"json","protocolSettings":{"h2":"eventstream"},"serviceAbbreviation":"Kinesis","serviceFullName":"Amazon Kinesis","serviceId":"Kinesis","signatureVersion":"v4","targetPrefix":"Kinesis_20131202","uid":"kinesis-2013-12-02"},"operations":{"AddTagsToStream":{"input":{"type":"structure","required":["StreamName","Tags"],"members":{"StreamName":{},"Tags":{"type":"map","key":{},"value":{}}}}},"CreateStream":{"input":{"type":"structure","required":["StreamName","ShardCount"],"members":{"StreamName":{},"ShardCount":{"type":"integer"}}}},"DecreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"DeleteStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"EnforceConsumerDeletion":{"type":"boolean"}}}},"DeregisterStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{},"ConsumerName":{},"ConsumerARN":{}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["ShardLimit","OpenShardCount"],"members":{"ShardLimit":{"type":"integer"},"OpenShardCount":{"type":"integer"}}}},"DescribeStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","required":["StreamDescription"],"members":{"StreamDescription":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","Shards","HasMoreShards","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"Shards":{"shape":"Sp"},"HasMoreShards":{"type":"boolean"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"Sw"},"EncryptionType":{},"KeyId":{}}}}}},"DescribeStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{},"ConsumerName":{},"ConsumerARN":{}}},"output":{"type":"structure","required":["ConsumerDescription"],"members":{"ConsumerDescription":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp","StreamARN"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"},"StreamARN":{}}}}}},"DescribeStreamSummary":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{}}},"output":{"type":"structure","required":["StreamDescriptionSummary"],"members":{"StreamDescriptionSummary":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring","OpenShardCount"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"Sw"},"EncryptionType":{},"KeyId":{},"OpenShardCount":{"type":"integer"},"ConsumerCount":{"type":"integer"}}}}}},"DisableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Sy"}}},"output":{"shape":"S1b"}},"EnableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Sy"}}},"output":{"shape":"S1b"}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["SequenceNumber","Data","PartitionKey"],"members":{"SequenceNumber":{},"ApproximateArrivalTimestamp":{"type":"timestamp"},"Data":{"type":"blob"},"PartitionKey":{},"EncryptionType":{}}}},"NextShardIterator":{},"MillisBehindLatest":{"type":"long"}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamName","ShardId","ShardIteratorType"],"members":{"StreamName":{},"ShardId":{},"ShardIteratorType":{},"StartingSequenceNumber":{},"Timestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"IncreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"ListShards":{"input":{"type":"structure","members":{"StreamName":{},"NextToken":{},"ExclusiveStartShardId":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Shards":{"shape":"Sp"},"NextToken":{}}}},"ListStreamConsumers":{"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"NextToken":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Consumers":{"type":"list","member":{"shape":"S1y"}},"NextToken":{}}}},"ListStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartStreamName":{}}},"output":{"type":"structure","required":["StreamNames","HasMoreStreams"],"members":{"StreamNames":{"type":"list","member":{}},"HasMoreStreams":{"type":"boolean"}}}},"ListTagsForStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"HasMoreTags":{"type":"boolean"}}}},"MergeShards":{"input":{"type":"structure","required":["StreamName","ShardToMerge","AdjacentShardToMerge"],"members":{"StreamName":{},"ShardToMerge":{},"AdjacentShardToMerge":{}}}},"PutRecord":{"input":{"type":"structure","required":["StreamName","Data","PartitionKey"],"members":{"StreamName":{},"Data":{"type":"blob"},"PartitionKey":{},"ExplicitHashKey":{},"SequenceNumberForOrdering":{}}},"output":{"type":"structure","required":["ShardId","SequenceNumber"],"members":{"ShardId":{},"SequenceNumber":{},"EncryptionType":{}}}},"PutRecords":{"input":{"type":"structure","required":["Records","StreamName"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["Data","PartitionKey"],"members":{"Data":{"type":"blob"},"ExplicitHashKey":{},"PartitionKey":{}}}},"StreamName":{}}},"output":{"type":"structure","required":["Records"],"members":{"FailedRecordCount":{"type":"integer"},"Records":{"type":"list","member":{"type":"structure","members":{"SequenceNumber":{},"ShardId":{},"ErrorCode":{},"ErrorMessage":{}}}},"EncryptionType":{}}}},"RegisterStreamConsumer":{"input":{"type":"structure","required":["StreamARN","ConsumerName"],"members":{"StreamARN":{},"ConsumerName":{}}},"output":{"type":"structure","required":["Consumer"],"members":{"Consumer":{"shape":"S1y"}}}},"RemoveTagsFromStream":{"input":{"type":"structure","required":["StreamName","TagKeys"],"members":{"StreamName":{},"TagKeys":{"type":"list","member":{}}}}},"SplitShard":{"input":{"type":"structure","required":["StreamName","ShardToSplit","NewStartingHashKey"],"members":{"StreamName":{},"ShardToSplit":{},"NewStartingHashKey":{}}}},"StartStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"StopStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"UpdateShardCount":{"input":{"type":"structure","required":["StreamName","TargetShardCount","ScalingType"],"members":{"StreamName":{},"TargetShardCount":{"type":"integer"},"ScalingType":{}}},"output":{"type":"structure","members":{"StreamName":{},"CurrentShardCount":{"type":"integer"},"TargetShardCount":{"type":"integer"}}}}},"shapes":{"Sp":{"type":"list","member":{"type":"structure","required":["ShardId","HashKeyRange","SequenceNumberRange"],"members":{"ShardId":{},"ParentShardId":{},"AdjacentParentShardId":{},"HashKeyRange":{"type":"structure","required":["StartingHashKey","EndingHashKey"],"members":{"StartingHashKey":{},"EndingHashKey":{}}},"SequenceNumberRange":{"type":"structure","required":["StartingSequenceNumber"],"members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}}}}},"Sw":{"type":"list","member":{"type":"structure","members":{"ShardLevelMetrics":{"shape":"Sy"}}}},"Sy":{"type":"list","member":{}},"S1b":{"type":"structure","members":{"StreamName":{},"CurrentShardLevelMetrics":{"shape":"Sy"},"DesiredShardLevelMetrics":{"shape":"Sy"}}},"S1y":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"}}}}}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeStream":{"input_token":"ExclusiveStartShardId","limit_key":"Limit","more_results":"StreamDescription.HasMoreShards","output_token":"StreamDescription.Shards[-1].ShardId","result_key":"StreamDescription.Shards"},"ListStreamConsumers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListStreams":{"input_token":"ExclusiveStartStreamName","limit_key":"Limit","more_results":"HasMoreStreams","output_token":"StreamNames[-1]","result_key":"StreamNames"}}}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StreamExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"StreamDescription.StreamStatus"}]},"StreamNotExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Archived Media","serviceFullName":"Amazon Kinesis Video Streams Archived Media","serviceId":"Kinesis Video Archived Media","signatureVersion":"v4","uid":"kinesis-video-archived-media-2017-09-30"},"operations":{"GetClip":{"http":{"requestUri":"/getClip"},"input":{"type":"structure","required":["ClipFragmentSelector"],"members":{"StreamName":{},"StreamARN":{},"ClipFragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"shape":"Sa"}},"payload":"Payload"}},"GetDASHStreamingSessionURL":{"http":{"requestUri":"/getDASHStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"DisplayFragmentTimestamp":{},"DisplayFragmentNumber":{},"DASHFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"Expires":{"type":"integer"},"MaxManifestFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"DASHStreamingSessionURL":{}}}},"GetHLSStreamingSessionURL":{"http":{"requestUri":"/getHLSStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"HLSFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"ContainerFormat":{},"DiscontinuityMode":{},"DisplayFragmentTimestamp":{},"Expires":{"type":"integer"},"MaxMediaPlaylistFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"HLSStreamingSessionURL":{}}}},"GetMediaForFragmentList":{"http":{"requestUri":"/getMediaForFragmentList"},"input":{"type":"structure","required":["StreamName","Fragments"],"members":{"StreamName":{},"Fragments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"shape":"Sa"}},"payload":"Payload"}},"ListFragments":{"http":{"requestUri":"/listFragments"},"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"MaxResults":{"type":"long"},"NextToken":{},"FragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"Fragments":{"type":"list","member":{"type":"structure","members":{"FragmentNumber":{},"FragmentSizeInBytes":{"type":"long"},"ProducerTimestamp":{"type":"timestamp"},"ServerTimestamp":{"type":"timestamp"},"FragmentLengthInMilliseconds":{"type":"long"}}}},"NextToken":{}}}}},"shapes":{"Sa":{"type":"blob","streaming":true}}}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Media","serviceFullName":"Amazon Kinesis Video Streams Media","serviceId":"Kinesis Video Media","signatureVersion":"v4","uid":"kinesis-video-media-2017-09-30"},"operations":{"GetMedia":{"http":{"requestUri":"/getMedia"},"input":{"type":"structure","required":["StartSelector"],"members":{"StreamName":{},"StreamARN":{},"StartSelector":{"type":"structure","required":["StartSelectorType"],"members":{"StartSelectorType":{},"AfterFragmentNumber":{},"StartTimestamp":{"type":"timestamp"},"ContinuationToken":{}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"type":"blob","streaming":true}},"payload":"Payload"}}},"shapes":{}}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-04","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Amazon Kinesis Video Signaling Channels","serviceFullName":"Amazon Kinesis Video Signaling Channels","serviceId":"Kinesis Video Signaling","signatureVersion":"v4","uid":"kinesis-video-signaling-2019-12-04"},"operations":{"GetIceServerConfig":{"http":{"requestUri":"/v1/get-ice-server-config"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"ClientId":{},"Service":{},"Username":{}}},"output":{"type":"structure","members":{"IceServerList":{"type":"list","member":{"type":"structure","members":{"Uris":{"type":"list","member":{}},"Username":{},"Password":{},"Ttl":{"type":"integer"}}}}}}},"SendAlexaOfferToMaster":{"http":{"requestUri":"/v1/send-alexa-offer-to-master"},"input":{"type":"structure","required":["ChannelARN","SenderClientId","MessagePayload"],"members":{"ChannelARN":{},"SenderClientId":{},"MessagePayload":{}}},"output":{"type":"structure","members":{"Answer":{}}}}},"shapes":{}}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video","serviceFullName":"Amazon Kinesis Video Streams","serviceId":"Kinesis Video","signatureVersion":"v4","uid":"kinesisvideo-2017-09-30"},"operations":{"CreateSignalingChannel":{"http":{"requestUri":"/createSignalingChannel"},"input":{"type":"structure","required":["ChannelName"],"members":{"ChannelName":{},"ChannelType":{},"SingleMasterConfiguration":{"shape":"S4"},"Tags":{"type":"list","member":{"shape":"S7"}}}},"output":{"type":"structure","members":{"ChannelARN":{}}}},"CreateStream":{"http":{"requestUri":"/createStream"},"input":{"type":"structure","required":["StreamName"],"members":{"DeviceName":{},"StreamName":{},"MediaType":{},"KmsKeyId":{},"DataRetentionInHours":{"type":"integer"},"Tags":{"shape":"Si"}}},"output":{"type":"structure","members":{"StreamARN":{}}}},"DeleteSignalingChannel":{"http":{"requestUri":"/deleteSignalingChannel"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"requestUri":"/deleteStream"},"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DescribeSignalingChannel":{"http":{"requestUri":"/describeSignalingChannel"},"input":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{}}},"output":{"type":"structure","members":{"ChannelInfo":{"shape":"Sr"}}}},"DescribeStream":{"http":{"requestUri":"/describeStream"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"StreamInfo":{"shape":"Sw"}}}},"GetDataEndpoint":{"http":{"requestUri":"/getDataEndpoint"},"input":{"type":"structure","required":["APIName"],"members":{"StreamName":{},"StreamARN":{},"APIName":{}}},"output":{"type":"structure","members":{"DataEndpoint":{}}}},"GetSignalingChannelEndpoint":{"http":{"requestUri":"/getSignalingChannelEndpoint"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"SingleMasterChannelEndpointConfiguration":{"type":"structure","members":{"Protocols":{"type":"list","member":{}},"Role":{}}}}},"output":{"type":"structure","members":{"ResourceEndpointList":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"ResourceEndpoint":{}}}}}}},"ListSignalingChannels":{"http":{"requestUri":"/listSignalingChannels"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"ChannelNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"ChannelInfoList":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListStreams":{"http":{"requestUri":"/listStreams"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"StreamNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"StreamInfoList":{"type":"list","member":{"shape":"Sw"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["ResourceARN"],"members":{"NextToken":{},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Si"}}}},"ListTagsForStream":{"http":{"requestUri":"/listTagsForStream"},"input":{"type":"structure","members":{"NextToken":{},"StreamARN":{},"StreamName":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Si"}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"type":"list","member":{"shape":"S7"}}}},"output":{"type":"structure","members":{}}},"TagStream":{"http":{"requestUri":"/tagStream"},"input":{"type":"structure","required":["Tags"],"members":{"StreamARN":{},"StreamName":{},"Tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["ResourceARN","TagKeyList"],"members":{"ResourceARN":{},"TagKeyList":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"UntagStream":{"http":{"requestUri":"/untagStream"},"input":{"type":"structure","required":["TagKeyList"],"members":{"StreamARN":{},"StreamName":{},"TagKeyList":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"UpdateDataRetention":{"http":{"requestUri":"/updateDataRetention"},"input":{"type":"structure","required":["CurrentVersion","Operation","DataRetentionChangeInHours"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"Operation":{},"DataRetentionChangeInHours":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"UpdateSignalingChannel":{"http":{"requestUri":"/updateSignalingChannel"},"input":{"type":"structure","required":["ChannelARN","CurrentVersion"],"members":{"ChannelARN":{},"CurrentVersion":{},"SingleMasterConfiguration":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UpdateStream":{"http":{"requestUri":"/updateStream"},"input":{"type":"structure","required":["CurrentVersion"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"DeviceName":{},"MediaType":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","members":{"MessageTtlSeconds":{"type":"integer"}}},"S7":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"Si":{"type":"map","key":{},"value":{}},"Sr":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{},"ChannelType":{},"ChannelStatus":{},"CreationTime":{"type":"timestamp"},"SingleMasterConfiguration":{"shape":"S4"},"Version":{}}},"Sw":{"type":"structure","members":{"DeviceName":{},"StreamName":{},"StreamARN":{},"MediaType":{},"KmsKeyId":{},"Version":{},"Status":{},"CreationTime":{"type":"timestamp"},"DataRetentionInHours":{"type":"integer"}}},"S1v":{"type":"list","member":{}}}}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListSignalingChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ChannelInfoList"},"ListStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StreamInfoList"}}}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-01","endpointPrefix":"kms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"KMS","serviceFullName":"AWS Key Management Service","serviceId":"KMS","signatureVersion":"v4","targetPrefix":"TrentService","uid":"kms-2014-11-01"},"operations":{"CancelKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"ConnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"CreateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreName","CloudHsmClusterId","TrustAnchorCertificate","KeyStorePassword"],"members":{"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"KeyStorePassword":{"shape":"Sd"}}},"output":{"type":"structure","members":{"CustomKeyStoreId":{}}}},"CreateGrant":{"input":{"type":"structure","required":["KeyId","GranteePrincipal","Operations"],"members":{"KeyId":{},"GranteePrincipal":{},"RetiringPrincipal":{},"Operations":{"shape":"Sh"},"Constraints":{"shape":"Sj"},"GrantTokens":{"shape":"Sn"},"Name":{}}},"output":{"type":"structure","members":{"GrantToken":{},"GrantId":{}}}},"CreateKey":{"input":{"type":"structure","members":{"Policy":{},"Description":{},"KeyUsage":{},"CustomerMasterKeySpec":{},"Origin":{},"CustomKeyStoreId":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S14"}}}},"Decrypt":{"input":{"type":"structure","required":["CiphertextBlob"],"members":{"CiphertextBlob":{"type":"blob"},"EncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"},"KeyId":{},"EncryptionAlgorithm":{}}},"output":{"type":"structure","members":{"KeyId":{},"Plaintext":{"shape":"S1i"},"EncryptionAlgorithm":{}}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasName"],"members":{"AliasName":{}}}},"DeleteCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"DeleteImportedKeyMaterial":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DescribeCustomKeyStores":{"input":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"CustomKeyStores":{"type":"list","member":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"ConnectionState":{},"ConnectionErrorCode":{},"CreationDate":{"type":"timestamp"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"DescribeKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S14"}}}},"DisableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisconnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"EnableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"Encrypt":{"input":{"type":"structure","required":["KeyId","Plaintext"],"members":{"KeyId":{},"Plaintext":{"shape":"S1i"},"EncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"},"EncryptionAlgorithm":{}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{},"EncryptionAlgorithm":{}}}},"GenerateDataKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sk"},"NumberOfBytes":{"type":"integer"},"KeySpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"Plaintext":{"shape":"S1i"},"KeyId":{}}}},"GenerateDataKeyPair":{"input":{"type":"structure","required":["KeyId","KeyPairSpec"],"members":{"EncryptionContext":{"shape":"Sk"},"KeyId":{},"KeyPairSpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"PrivateKeyCiphertextBlob":{"type":"blob"},"PrivateKeyPlaintext":{"shape":"S1i"},"PublicKey":{"type":"blob"},"KeyId":{},"KeyPairSpec":{}}}},"GenerateDataKeyPairWithoutPlaintext":{"input":{"type":"structure","required":["KeyId","KeyPairSpec"],"members":{"EncryptionContext":{"shape":"Sk"},"KeyId":{},"KeyPairSpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"PrivateKeyCiphertextBlob":{"type":"blob"},"PublicKey":{"type":"blob"},"KeyId":{},"KeyPairSpec":{}}}},"GenerateDataKeyWithoutPlaintext":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sk"},"KeySpec":{},"NumberOfBytes":{"type":"integer"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateRandom":{"input":{"type":"structure","members":{"NumberOfBytes":{"type":"integer"},"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{"Plaintext":{"shape":"S1i"}}}},"GetKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName"],"members":{"KeyId":{},"PolicyName":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetKeyRotationStatus":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyRotationEnabled":{"type":"boolean"}}}},"GetParametersForImport":{"input":{"type":"structure","required":["KeyId","WrappingAlgorithm","WrappingKeySpec"],"members":{"KeyId":{},"WrappingAlgorithm":{},"WrappingKeySpec":{}}},"output":{"type":"structure","members":{"KeyId":{},"ImportToken":{"type":"blob"},"PublicKey":{"shape":"S1i"},"ParametersValidTo":{"type":"timestamp"}}}},"GetPublicKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyId":{},"PublicKey":{"type":"blob"},"CustomerMasterKeySpec":{},"KeyUsage":{},"EncryptionAlgorithms":{"shape":"S1b"},"SigningAlgorithms":{"shape":"S1d"}}}},"ImportKeyMaterial":{"input":{"type":"structure","required":["KeyId","ImportToken","EncryptedKeyMaterial"],"members":{"KeyId":{},"ImportToken":{"type":"blob"},"EncryptedKeyMaterial":{"type":"blob"},"ValidTo":{"type":"timestamp"},"ExpirationModel":{}}},"output":{"type":"structure","members":{}}},"ListAliases":{"input":{"type":"structure","members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"type":"structure","members":{"AliasName":{},"AliasArn":{},"TargetKeyId":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListGrants":{"input":{"type":"structure","required":["KeyId"],"members":{"Limit":{"type":"integer"},"Marker":{},"KeyId":{}}},"output":{"shape":"S31"}},"ListKeyPolicies":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"PolicyNames":{"type":"list","member":{}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeys":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Keys":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"KeyArn":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListResourceTags":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sz"},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListRetirableGrants":{"input":{"type":"structure","required":["RetiringPrincipal"],"members":{"Limit":{"type":"integer"},"Marker":{},"RetiringPrincipal":{}}},"output":{"shape":"S31"}},"PutKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName","Policy"],"members":{"KeyId":{},"PolicyName":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}}},"ReEncrypt":{"input":{"type":"structure","required":["CiphertextBlob","DestinationKeyId"],"members":{"CiphertextBlob":{"type":"blob"},"SourceEncryptionContext":{"shape":"Sk"},"SourceKeyId":{},"DestinationKeyId":{},"DestinationEncryptionContext":{"shape":"Sk"},"SourceEncryptionAlgorithm":{},"DestinationEncryptionAlgorithm":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"SourceKeyId":{},"KeyId":{},"SourceEncryptionAlgorithm":{},"DestinationEncryptionAlgorithm":{}}}},"RetireGrant":{"input":{"type":"structure","members":{"GrantToken":{},"KeyId":{},"GrantId":{}}}},"RevokeGrant":{"input":{"type":"structure","required":["KeyId","GrantId"],"members":{"KeyId":{},"GrantId":{}}}},"ScheduleKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PendingWindowInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyId":{},"DeletionDate":{"type":"timestamp"}}}},"Sign":{"input":{"type":"structure","required":["KeyId","Message","SigningAlgorithm"],"members":{"KeyId":{},"Message":{"shape":"S1i"},"MessageType":{},"GrantTokens":{"shape":"Sn"},"SigningAlgorithm":{}}},"output":{"type":"structure","members":{"KeyId":{},"Signature":{"type":"blob"},"SigningAlgorithm":{}}}},"TagResource":{"input":{"type":"structure","required":["KeyId","Tags"],"members":{"KeyId":{},"Tags":{"shape":"Sz"}}}},"UntagResource":{"input":{"type":"structure","required":["KeyId","TagKeys"],"members":{"KeyId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"UpdateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{},"NewCustomKeyStoreName":{},"KeyStorePassword":{"shape":"Sd"},"CloudHsmClusterId":{}}},"output":{"type":"structure","members":{}}},"UpdateKeyDescription":{"input":{"type":"structure","required":["KeyId","Description"],"members":{"KeyId":{},"Description":{}}}},"Verify":{"input":{"type":"structure","required":["KeyId","Message","Signature","SigningAlgorithm"],"members":{"KeyId":{},"Message":{"shape":"S1i"},"MessageType":{},"Signature":{"type":"blob"},"SigningAlgorithm":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyId":{},"SignatureValid":{"type":"boolean"},"SigningAlgorithm":{}}}}},"shapes":{"Sd":{"type":"string","sensitive":true},"Sh":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"EncryptionContextSubset":{"shape":"Sk"},"EncryptionContextEquals":{"shape":"Sk"}}},"Sk":{"type":"map","key":{},"value":{}},"Sn":{"type":"list","member":{}},"Sz":{"type":"list","member":{"type":"structure","required":["TagKey","TagValue"],"members":{"TagKey":{},"TagValue":{}}}},"S14":{"type":"structure","required":["KeyId"],"members":{"AWSAccountId":{},"KeyId":{},"Arn":{},"CreationDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"Description":{},"KeyUsage":{},"KeyState":{},"DeletionDate":{"type":"timestamp"},"ValidTo":{"type":"timestamp"},"Origin":{},"CustomKeyStoreId":{},"CloudHsmClusterId":{},"ExpirationModel":{},"KeyManager":{},"CustomerMasterKeySpec":{},"EncryptionAlgorithms":{"shape":"S1b"},"SigningAlgorithms":{"shape":"S1d"}}},"S1b":{"type":"list","member":{}},"S1d":{"type":"list","member":{}},"S1i":{"type":"blob","sensitive":true},"S31":{"type":"structure","members":{"Grants":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"GrantId":{},"Name":{},"CreationDate":{"type":"timestamp"},"GranteePrincipal":{},"RetiringPrincipal":{},"IssuingAccount":{},"Operations":{"shape":"Sh"},"Constraints":{"shape":"Sj"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}}}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Aliases"},"ListGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"},"ListKeyPolicies":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"PolicyNames"},"ListKeys":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Keys"}}}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"apiVersion":"2014-11-11","endpointPrefix":"lambda","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","protocol":"rest-json"},"operations":{"AddEventSource":{"http":{"requestUri":"/2014-11-13/event-source-mappings/"},"input":{"type":"structure","required":["EventSource","FunctionName","Role"],"members":{"EventSource":{},"FunctionName":{},"Role":{},"BatchSize":{"type":"integer"},"Parameters":{"shape":"S6"}}},"output":{"shape":"S7"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetEventSource":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S7"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"shape":"Se"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"shape":"Sq"}},"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}}}},"ListEventSources":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSource"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSources":{"type":"list","member":{"shape":"S7"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"type":"list","member":{"shape":"Se"}}}}},"RemoveEventSource":{"http":{"method":"DELETE","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":204},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}}},"output":{"shape":"Se"}},"UploadFunction":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":201},"input":{"type":"structure","required":["FunctionName","FunctionZip","Runtime","Role","Handler","Mode"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionZip":{"shape":"Sq"},"Runtime":{"location":"querystring","locationName":"Runtime"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Mode":{"location":"querystring","locationName":"Mode"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}},"payload":"FunctionZip"},"output":{"shape":"Se"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSource":{},"FunctionName":{},"Parameters":{"shape":"S6"},"Role":{},"LastModified":{"type":"timestamp"},"IsActive":{"type":"boolean"},"Status":{}}},"Se":{"type":"structure","members":{"FunctionName":{},"FunctionARN":{},"ConfigurationId":{},"Runtime":{},"Role":{},"Handler":{},"Mode":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{"type":"timestamp"}}},"Sq":{"type":"blob","streaming":true}}}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-03-31","endpointPrefix":"lambda","protocol":"rest-json","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","uid":"lambda-2015-03-31"},"operations":{"AddLayerVersionPermission":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":201},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId","Action","Principal"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{},"Action":{},"Principal":{},"OrganizationId":{},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}},"output":{"type":"structure","members":{"Statement":{},"RevisionId":{}}}},"AddPermission":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":201},"input":{"type":"structure","required":["FunctionName","StatementId","Action","Principal"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{},"Action":{},"Principal":{},"SourceArn":{},"SourceAccount":{},"EventSourceToken":{},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{}}},"output":{"type":"structure","members":{"Statement":{}}}},"CreateAlias":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":201},"input":{"type":"structure","required":["FunctionName","Name","FunctionVersion"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sn"}}},"output":{"shape":"Sr"}},"CreateEventSourceMapping":{"http":{"requestUri":"/2015-03-31/event-source-mappings/","responseCode":202},"input":{"type":"structure","required":["EventSourceArn","FunctionName"],"members":{"EventSourceArn":{},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"},"DestinationConfig":{"shape":"S10"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"}}},"output":{"shape":"S17"}},"CreateFunction":{"http":{"requestUri":"/2015-03-31/functions","responseCode":201},"input":{"type":"structure","required":["FunctionName","Runtime","Role","Handler","Code"],"members":{"FunctionName":{},"Runtime":{},"Role":{},"Handler":{},"Code":{"type":"structure","members":{"ZipFile":{"shape":"S1d"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{}}},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"Publish":{"type":"boolean"},"VpcConfig":{"shape":"S1k"},"DeadLetterConfig":{"shape":"S1p"},"Environment":{"shape":"S1r"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1w"},"Tags":{"shape":"S1y"},"Layers":{"shape":"S21"},"FileSystemConfigs":{"shape":"S23"}}},"output":{"shape":"S27"}},"DeleteAlias":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":204},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}}},"DeleteEventSourceMapping":{"http":{"method":"DELETE","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S17"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionConcurrency":{"http":{"method":"DELETE","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"DeleteFunctionEventInvokeConfig":{"http":{"method":"DELETE","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteLayerVersion":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}}},"DeleteProvisionedConcurrencyConfig":{"http":{"method":"DELETE","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName","Qualifier"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/2016-08-19/account-settings/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountLimit":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"CodeSizeUnzipped":{"type":"long"},"CodeSizeZipped":{"type":"long"},"ConcurrentExecutions":{"type":"integer"},"UnreservedConcurrentExecutions":{"type":"integer"}}},"AccountUsage":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"FunctionCount":{"type":"long"}}}}}},"GetAlias":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"shape":"Sr"}},"GetEventSourceMapping":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S17"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S27"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}},"Tags":{"shape":"S1y"},"Concurrency":{"shape":"S38"}}}},"GetFunctionConcurrency":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S27"}},"GetFunctionEventInvokeConfig":{"http":{"method":"GET","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S3e"}},"GetLayerVersion":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"shape":"S3i"}},"GetLayerVersionByArn":{"http":{"method":"GET","requestUri":"/2018-10-31/layers?find=LayerVersion","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"querystring","locationName":"Arn"}}},"output":{"shape":"S3i"}},"GetLayerVersionPolicy":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetProvisionedConcurrencyConfig":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","Qualifier"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"Invoke":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Payload":{"shape":"S1d"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"FunctionError":{"location":"header","locationName":"X-Amz-Function-Error"},"LogResult":{"location":"header","locationName":"X-Amz-Log-Result"},"Payload":{"shape":"S1d"},"ExecutedVersion":{"location":"header","locationName":"X-Amz-Executed-Version"}},"payload":"Payload"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"type":"blob","streaming":true}},"deprecated":true,"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}},"deprecated":true},"deprecated":true},"ListAliases":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Aliases":{"type":"list","member":{"shape":"Sr"}}}}},"ListEventSourceMappings":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSourceArn"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSourceMappings":{"type":"list","member":{"shape":"S17"}}}}},"ListFunctionEventInvokeConfigs":{"http":{"method":"GET","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config/list","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"FunctionEventInvokeConfigs":{"type":"list","member":{"shape":"S3e"}},"NextMarker":{}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/","responseCode":200},"input":{"type":"structure","members":{"MasterRegion":{"location":"querystring","locationName":"MasterRegion"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"shape":"S4k"}}}},"ListLayerVersions":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":200},"input":{"type":"structure","required":["LayerName"],"members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"LayerName":{"location":"uri","locationName":"LayerName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"LayerVersions":{"type":"list","member":{"shape":"S4p"}}}}},"ListLayers":{"http":{"method":"GET","requestUri":"/2018-10-31/layers","responseCode":200},"input":{"type":"structure","members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Layers":{"type":"list","member":{"type":"structure","members":{"LayerName":{},"LayerArn":{},"LatestMatchingVersion":{"shape":"S4p"}}}}}}},"ListProvisionedConcurrencyConfigs":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency?List=ALL","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"ProvisionedConcurrencyConfigs":{"type":"list","member":{"type":"structure","members":{"FunctionArn":{},"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"NextMarker":{}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2017-03-31/tags/{ARN}"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"uri","locationName":"ARN"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1y"}}}},"ListVersionsByFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"shape":"S4k"}}}},"PublishLayerVersion":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":201},"input":{"type":"structure","required":["LayerName","Content"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"Description":{},"Content":{"type":"structure","members":{"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ZipFile":{"shape":"S1d"}}},"CompatibleRuntimes":{"shape":"S3l"},"LicenseInfo":{}}},"output":{"type":"structure","members":{"Content":{"shape":"S3j"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S3l"},"LicenseInfo":{}}}},"PublishVersion":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":201},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"CodeSha256":{},"Description":{},"RevisionId":{}}},"output":{"shape":"S27"}},"PutFunctionConcurrency":{"http":{"method":"PUT","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","ReservedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ReservedConcurrentExecutions":{"type":"integer"}}},"output":{"shape":"S38"}},"PutFunctionEventInvokeConfig":{"http":{"method":"PUT","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S10"}}},"output":{"shape":"S3e"}},"PutProvisionedConcurrencyConfig":{"http":{"method":"PUT","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":202},"input":{"type":"structure","required":["FunctionName","Qualifier","ProvisionedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"ProvisionedConcurrentExecutions":{"type":"integer"}}},"output":{"type":"structure","members":{"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"RemoveLayerVersionPermission":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{"location":"uri","locationName":"StatementId"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["FunctionName","StatementId"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{"location":"uri","locationName":"StatementId"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"TagResource":{"http":{"requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"Tags":{"shape":"S1y"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAlias":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sn"},"RevisionId":{}}},"output":{"shape":"Sr"}},"UpdateEventSourceMapping":{"http":{"method":"PUT","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S10"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"ParallelizationFactor":{"type":"integer"}}},"output":{"shape":"S17"}},"UpdateFunctionCode":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/code","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ZipFile":{"shape":"S1d"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"Publish":{"type":"boolean"},"DryRun":{"type":"boolean"},"RevisionId":{}}},"output":{"shape":"S27"}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{},"Handler":{},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"VpcConfig":{"shape":"S1k"},"Environment":{"shape":"S1r"},"Runtime":{},"DeadLetterConfig":{"shape":"S1p"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1w"},"RevisionId":{},"Layers":{"shape":"S21"},"FileSystemConfigs":{"shape":"S23"}}},"output":{"shape":"S27"}},"UpdateFunctionEventInvokeConfig":{"http":{"requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S10"}}},"output":{"shape":"S3e"}}},"shapes":{"Sn":{"type":"structure","members":{"AdditionalVersionWeights":{"type":"map","key":{},"value":{"type":"double"}}}},"Sr":{"type":"structure","members":{"AliasArn":{},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sn"},"RevisionId":{}}},"S10":{"type":"structure","members":{"OnSuccess":{"type":"structure","members":{"Destination":{}}},"OnFailure":{"type":"structure","members":{"Destination":{}}}}},"S17":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"EventSourceArn":{},"FunctionArn":{},"LastModified":{"type":"timestamp"},"LastProcessingResult":{},"State":{},"StateTransitionReason":{},"DestinationConfig":{"shape":"S10"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"}}},"S1d":{"type":"blob","sensitive":true},"S1k":{"type":"structure","members":{"SubnetIds":{"shape":"S1l"},"SecurityGroupIds":{"shape":"S1n"}}},"S1l":{"type":"list","member":{}},"S1n":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"TargetArn":{}}},"S1r":{"type":"structure","members":{"Variables":{"shape":"S1s"}}},"S1s":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true},"sensitive":true},"S1w":{"type":"structure","members":{"Mode":{}}},"S1y":{"type":"map","key":{},"value":{}},"S21":{"type":"list","member":{}},"S23":{"type":"list","member":{"type":"structure","required":["Arn","LocalMountPath"],"members":{"Arn":{},"LocalMountPath":{}}}},"S27":{"type":"structure","members":{"FunctionName":{},"FunctionArn":{},"Runtime":{},"Role":{},"Handler":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{},"CodeSha256":{},"Version":{},"VpcConfig":{"type":"structure","members":{"SubnetIds":{"shape":"S1l"},"SecurityGroupIds":{"shape":"S1n"},"VpcId":{}}},"DeadLetterConfig":{"shape":"S1p"},"Environment":{"type":"structure","members":{"Variables":{"shape":"S1s"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"type":"string","sensitive":true}}}}},"KMSKeyArn":{},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"MasterArn":{},"RevisionId":{},"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CodeSize":{"type":"long"}}}},"State":{},"StateReason":{},"StateReasonCode":{},"LastUpdateStatus":{},"LastUpdateStatusReason":{},"LastUpdateStatusReasonCode":{},"FileSystemConfigs":{"shape":"S23"}}},"S38":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}},"S3e":{"type":"structure","members":{"LastModified":{"type":"timestamp"},"FunctionArn":{},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S10"}}},"S3i":{"type":"structure","members":{"Content":{"shape":"S3j"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S3l"},"LicenseInfo":{}}},"S3j":{"type":"structure","members":{"Location":{},"CodeSha256":{},"CodeSize":{"type":"long"}}},"S3l":{"type":"list","member":{}},"S4k":{"type":"list","member":{"shape":"S27"}},"S4p":{"type":"structure","members":{"LayerVersionArn":{},"Version":{"type":"long"},"Description":{},"CreatedDate":{},"CompatibleRuntimes":{"shape":"S3l"},"LicenseInfo":{}}}}}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Aliases"},"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctionEventInvokeConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionEventInvokeConfigs"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"},"ListLayerVersions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"LayerVersions"},"ListLayers":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Layers"},"ListProvisionedConcurrencyConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"ProvisionedConcurrencyConfigs"},"ListVersionsByFunction":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Versions"}}}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"FunctionExists":{"delay":1,"operation":"GetFunction","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]},"FunctionActive":{"delay":5,"maxAttempts":60,"operation":"GetFunctionConfiguration","description":"Waits for the function's State to be Active.","acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"Active"},{"state":"failure","matcher":"path","argument":"State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"State","expected":"Pending"}]},"FunctionUpdated":{"delay":5,"maxAttempts":60,"operation":"GetFunctionConfiguration","description":"Waits for the function's LastUpdateStatus to be Successful.","acceptors":[{"state":"success","matcher":"path","argument":"LastUpdateStatus","expected":"Successful"},{"state":"failure","matcher":"path","argument":"LastUpdateStatus","expected":"Failed"},{"state":"retry","matcher":"path","argument":"LastUpdateStatus","expected":"InProgress"}]}}}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"models.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Model Building Service","serviceId":"Lex Model Building Service","signatureVersion":"v4","signingName":"lex","uid":"lex-models-2017-04-19"},"operations":{"CreateBotVersion":{"http":{"requestUri":"/bots/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"}}}},"CreateIntentVersion":{"http":{"requestUri":"/intents/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sz"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S10"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S11"},"fulfillmentActivity":{"shape":"S14"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"kendraConfiguration":{"shape":"S17"}}}},"CreateSlotTypeVersion":{"http":{"requestUri":"/slottypes/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1e"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1j"}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}}},"DeleteBotChannelAssociation":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/intents/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteIntentVersion":{"http":{"method":"DELETE","requestUri":"/intents/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteSlotTypeVersion":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}/version/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/utterances/{userId}","responseCode":204},"input":{"type":"structure","required":["botName","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"userId":{"location":"uri","locationName":"userId"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/{versionoralias}","responseCode":200},"input":{"type":"structure","required":["name","versionOrAlias"],"members":{"name":{"location":"uri","locationName":"name"},"versionOrAlias":{"location":"uri","locationName":"versionoralias"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"}}}},"GetBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S24"}}}},"GetBotAliases":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/","responseCode":200},"input":{"type":"structure","required":["botName"],"members":{"botName":{"location":"uri","locationName":"botName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"BotAliases":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S24"}}}},"nextToken":{}}}},"GetBotChannelAssociation":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S2m"},"status":{},"failureReason":{}}}},"GetBotChannelAssociations":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/","responseCode":200},"input":{"type":"structure","required":["botName","botAlias"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"botChannelAssociations":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S2m"},"status":{},"failureReason":{}}}},"nextToken":{}}}},"GetBotVersions":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2v"},"nextToken":{}}}},"GetBots":{"http":{"method":"GET","requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2v"},"nextToken":{}}}},"GetBuiltinIntent":{"http":{"method":"GET","requestUri":"/builtins/intents/{signature}","responseCode":200},"input":{"type":"structure","required":["signature"],"members":{"signature":{"location":"uri","locationName":"signature"}}},"output":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S31"},"slots":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}}},"GetBuiltinIntents":{"http":{"method":"GET","requestUri":"/builtins/intents/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S31"}}}},"nextToken":{}}}},"GetBuiltinSlotTypes":{"http":{"method":"GET","requestUri":"/builtins/slottypes/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S31"}}}},"nextToken":{}}}},"GetExport":{"http":{"method":"GET","requestUri":"/exports/","responseCode":200},"input":{"type":"structure","required":["name","version","resourceType","exportType"],"members":{"name":{"location":"querystring","locationName":"name"},"version":{"location":"querystring","locationName":"version"},"resourceType":{"location":"querystring","locationName":"resourceType"},"exportType":{"location":"querystring","locationName":"exportType"}}},"output":{"type":"structure","members":{"name":{},"version":{},"resourceType":{},"exportType":{},"exportStatus":{},"failureReason":{},"url":{}}}},"GetImport":{"http":{"method":"GET","requestUri":"/imports/{importId}","responseCode":200},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"GetIntent":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sz"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S10"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S11"},"fulfillmentActivity":{"shape":"S14"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"kendraConfiguration":{"shape":"S17"}}}},"GetIntentVersions":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"shape":"S3s"},"nextToken":{}}}},"GetIntents":{"http":{"method":"GET","requestUri":"/intents/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"intents":{"shape":"S3s"},"nextToken":{}}}},"GetSlotType":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1e"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1j"}}}},"GetSlotTypeVersions":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S40"},"nextToken":{}}}},"GetSlotTypes":{"http":{"method":"GET","requestUri":"/slottypes/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S40"},"nextToken":{}}}},"GetUtterancesView":{"http":{"method":"GET","requestUri":"/bots/{botname}/utterances?view=aggregation","responseCode":200},"input":{"type":"structure","required":["botName","botVersions","statusType"],"members":{"botName":{"location":"uri","locationName":"botname"},"botVersions":{"location":"querystring","locationName":"bot_versions","type":"list","member":{}},"statusType":{"location":"querystring","locationName":"status_type"}}},"output":{"type":"structure","members":{"botName":{},"utterances":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"utterances":{"type":"list","member":{"type":"structure","members":{"utteranceString":{},"count":{"type":"integer"},"distinctUsers":{"type":"integer"},"firstUtteredDate":{"type":"timestamp"},"lastUtteredDate":{"type":"timestamp"}}}}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S4h"}}}},"PutBot":{"http":{"method":"PUT","requestUri":"/bots/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name","locale","childDirected"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"processBehavior":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"},"createVersion":{"type":"boolean"},"tags":{"shape":"S4h"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"},"detectSentiment":{"type":"boolean"},"tags":{"shape":"S4h"}}}},"PutBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botVersion","botName"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"botVersion":{},"botName":{"location":"uri","locationName":"botName"},"checksum":{},"conversationLogs":{"type":"structure","required":["logSettings","iamRoleArn"],"members":{"logSettings":{"type":"list","member":{"type":"structure","required":["logType","destination","resourceArn"],"members":{"logType":{},"destination":{},"kmsKeyArn":{},"resourceArn":{}}}},"iamRoleArn":{}}},"tags":{"shape":"S4h"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S24"},"tags":{"shape":"S4h"}}}},"PutIntent":{"http":{"method":"PUT","requestUri":"/intents/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sz"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S10"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S11"},"fulfillmentActivity":{"shape":"S14"},"parentIntentSignature":{},"checksum":{},"createVersion":{"type":"boolean"},"kendraConfiguration":{"shape":"S17"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sz"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S10"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S11"},"fulfillmentActivity":{"shape":"S14"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"createVersion":{"type":"boolean"},"kendraConfiguration":{"shape":"S17"}}}},"PutSlotType":{"http":{"method":"PUT","requestUri":"/slottypes/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"enumerationValues":{"shape":"S1e"},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1j"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1e"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1j"}}}},"StartImport":{"http":{"requestUri":"/imports/","responseCode":201},"input":{"type":"structure","required":["payload","resourceType","mergeStrategy"],"members":{"payload":{"type":"blob"},"resourceType":{},"mergeStrategy":{},"tags":{"shape":"S4h"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"tags":{"shape":"S4h"},"createdDate":{"type":"timestamp"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S4h"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["intentName","intentVersion"],"members":{"intentName":{},"intentVersion":{}}}},"Sa":{"type":"structure","required":["messages","maxAttempts"],"members":{"messages":{"shape":"Sb"},"maxAttempts":{"type":"integer"},"responseCard":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["contentType","content"],"members":{"contentType":{},"content":{},"groupNumber":{"type":"integer"}}}},"Si":{"type":"structure","required":["messages"],"members":{"messages":{"shape":"Sb"},"responseCard":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["name","slotConstraint"],"members":{"name":{},"description":{},"slotConstraint":{},"slotType":{},"slotTypeVersion":{},"valueElicitationPrompt":{"shape":"Sa"},"priority":{"type":"integer"},"sampleUtterances":{"type":"list","member":{}},"responseCard":{},"obfuscationSetting":{}}}},"Sz":{"type":"list","member":{}},"S10":{"type":"structure","required":["prompt","rejectionStatement"],"members":{"prompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"}}},"S11":{"type":"structure","required":["uri","messageVersion"],"members":{"uri":{},"messageVersion":{}}},"S14":{"type":"structure","required":["type"],"members":{"type":{},"codeHook":{"shape":"S11"}}},"S17":{"type":"structure","required":["kendraIndex","role"],"members":{"kendraIndex":{},"queryFilterString":{},"role":{}}},"S1e":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{},"synonyms":{"type":"list","member":{}}}}},"S1j":{"type":"list","member":{"type":"structure","members":{"regexConfiguration":{"type":"structure","required":["pattern"],"members":{"pattern":{}}}}}},"S24":{"type":"structure","members":{"logSettings":{"type":"list","member":{"type":"structure","members":{"logType":{},"destination":{},"kmsKeyArn":{},"resourceArn":{},"resourcePrefix":{}}}},"iamRoleArn":{}}},"S2m":{"type":"map","key":{},"value":{},"sensitive":true},"S2v":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"status":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S31":{"type":"list","member":{}},"S3s":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S40":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S4h":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotChannelAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypeVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","serviceId":"CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["logGroupName","kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Se"}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteQueryDefinition":{"input":{"type":"structure","required":["queryDefinitionId"],"members":{"queryDefinitionId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"S11"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"logGroupNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.","type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1z"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueries":{"input":{"type":"structure","members":{"logGroupName":{},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queries":{"type":"list","member":{"type":"structure","members":{"queryId":{},"queryString":{},"status":{},"createTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueryDefinitions":{"input":{"type":"structure","members":{"queryDefinitionNamePrefix":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queryDefinitions":{"type":"list","member":{"type":"structure","members":{"queryDefinitionId":{},"name":{},"queryString":{},"lastModified":{"type":"long"},"logGroupNames":{"shape":"S2h"}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S2l"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"FilterLogEvents":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNames":{"type":"list","member":{}},"logStreamNamePrefix":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.","type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"GetLogGroupFields":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"time":{"type":"long"}}},"output":{"type":"structure","members":{"logGroupFields":{"type":"list","member":{"type":"structure","members":{"name":{},"percent":{"type":"integer"}}}}}}},"GetLogRecord":{"input":{"type":"structure","required":["logRecordPointer"],"members":{"logRecordPointer":{}}},"output":{"type":"structure","members":{"logRecord":{"type":"map","key":{},"value":{}}}}},"GetQueryResults":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"field":{},"value":{}}}}},"statistics":{"type":"structure","members":{"recordsMatched":{"type":"double"},"recordsScanned":{"type":"double"},"bytesScanned":{"type":"double"}}},"status":{}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{}}},"output":{"type":"structure","members":{"destination":{"shape":"S11"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1z"}}}},"PutQueryDefinition":{"input":{"type":"structure","required":["name","queryString"],"members":{"name":{},"queryDefinitionId":{},"logGroupNames":{"shape":"S2h"},"queryString":{}}},"output":{"type":"structure","members":{"queryDefinitionId":{}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S2l"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"StartQuery":{"input":{"type":"structure","required":["startTime","endTime","queryString"],"members":{"logGroupName":{},"logGroupNames":{"shape":"S2h"},"startTime":{"type":"long"},"endTime":{"type":"long"},"queryString":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"queryId":{}}}},"StopQuery":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Se"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}}}}},"shapes":{"Se":{"type":"map","key":{},"value":{}},"S11":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S1z":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"}}}},"S2h":{"type":"list","member":{}},"S2l":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}}}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"}}}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"uid":"machinelearning-2014-12-12","apiVersion":"2014-12-12","endpointPrefix":"machinelearning","jsonVersion":"1.1","serviceFullName":"Amazon Machine Learning","serviceId":"Machine Learning","signatureVersion":"v4","targetPrefix":"AmazonML_20141212","protocol":"json"},"operations":{"AddTags":{"input":{"type":"structure","required":["Tags","ResourceId","ResourceType"],"members":{"Tags":{"shape":"S2"},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"CreateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","MLModelId","BatchPredictionDataSourceId","OutputUri"],"members":{"BatchPredictionId":{},"BatchPredictionName":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"OutputUri":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"CreateDataSourceFromRDS":{"input":{"type":"structure","required":["DataSourceId","RDSData","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"RDSData":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation","ResourceRole","ServiceRole","SubnetId","SecurityGroupIds"],"members":{"DatabaseInformation":{"shape":"Sf"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{},"ResourceRole":{},"ServiceRole":{},"SubnetId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromRedshift":{"input":{"type":"structure","required":["DataSourceId","DataSpec","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation"],"members":{"DatabaseInformation":{"shape":"Sy"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromS3":{"input":{"type":"structure","required":["DataSourceId","DataSpec"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DataLocationS3"],"members":{"DataLocationS3":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaLocationS3":{}}},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateEvaluation":{"input":{"type":"structure","required":["EvaluationId","MLModelId","EvaluationDataSourceId"],"members":{"EvaluationId":{},"EvaluationName":{},"MLModelId":{},"EvaluationDataSourceId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"CreateMLModel":{"input":{"type":"structure","required":["MLModelId","MLModelType","TrainingDataSourceId"],"members":{"MLModelId":{},"MLModelName":{},"MLModelType":{},"Parameters":{"shape":"S1d"},"TrainingDataSourceId":{},"Recipe":{},"RecipeUri":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"CreateRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"DeleteEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"DeleteMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"DeleteRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteTags":{"input":{"type":"structure","required":["TagKeys","ResourceId","ResourceType"],"members":{"TagKeys":{"type":"list","member":{}},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"DescribeBatchPredictions":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"NextToken":{}}}},"DescribeDataSources":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEvaluations":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMLModels":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"Algorithm":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId","ResourceType"],"members":{"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Tags":{"shape":"S2"}}}},"GetBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"GetDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"LogUri":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"DataSourceSchema":{}}}},"GetEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"GetMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"Recipe":{},"Schema":{}}}},"Predict":{"input":{"type":"structure","required":["MLModelId","Record","PredictEndpoint"],"members":{"MLModelId":{},"Record":{"type":"map","key":{},"value":{}},"PredictEndpoint":{}}},"output":{"type":"structure","members":{"Prediction":{"type":"structure","members":{"predictedLabel":{},"predictedValue":{"type":"float"},"predictedScores":{"type":"map","key":{},"value":{"type":"float"}},"details":{"type":"map","key":{},"value":{}}}}}}},"UpdateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","BatchPredictionName"],"members":{"BatchPredictionId":{},"BatchPredictionName":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"UpdateDataSource":{"input":{"type":"structure","required":["DataSourceId","DataSourceName"],"members":{"DataSourceId":{},"DataSourceName":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"UpdateEvaluation":{"input":{"type":"structure","required":["EvaluationId","EvaluationName"],"members":{"EvaluationId":{},"EvaluationName":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"UpdateMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"MLModelName":{},"ScoreThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"MLModelId":{}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["InstanceIdentifier","DatabaseName"],"members":{"InstanceIdentifier":{},"DatabaseName":{}}},"Sy":{"type":"structure","required":["DatabaseName","ClusterIdentifier"],"members":{"DatabaseName":{},"ClusterIdentifier":{}}},"S1d":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"PeakRequestsPerSecond":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"EndpointUrl":{},"EndpointStatus":{}}},"S2i":{"type":"structure","members":{"RedshiftDatabase":{"shape":"Sy"},"DatabaseUserName":{},"SelectSqlQuery":{}}},"S2j":{"type":"structure","members":{"Database":{"shape":"Sf"},"DatabaseUserName":{},"SelectSqlQuery":{},"ResourceRole":{},"ServiceRole":{},"DataPipelineId":{}}},"S2q":{"type":"structure","members":{"Properties":{"type":"map","key":{},"value":{}}}}},"examples":{}}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeBatchPredictions":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DataSourceAvailable":{"delay":30,"operation":"DescribeDataSources","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"MLModelAvailable":{"delay":30,"operation":"DescribeMLModels","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"EvaluationAvailable":{"delay":30,"operation":"DescribeEvaluations","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"BatchPredictionAvailable":{"delay":30,"operation":"DescribeBatchPredictions","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]}}}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-01","endpointPrefix":"marketplacecommerceanalytics","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Commerce Analytics","serviceId":"Marketplace Commerce Analytics","signatureVersion":"v4","signingName":"marketplacecommerceanalytics","targetPrefix":"MarketplaceCommerceAnalytics20150701","uid":"marketplacecommerceanalytics-2015-07-01"},"operations":{"GenerateDataSet":{"input":{"type":"structure","required":["dataSetType","dataSetPublicationDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"dataSetPublicationDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}},"StartSupportDataExport":{"input":{"type":"structure","required":["dataSetType","fromDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"fromDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-01","endpointPrefix":"data.mediastore","protocol":"rest-json","serviceAbbreviation":"MediaStore Data","serviceFullName":"AWS Elemental MediaStore Data Plane","serviceId":"MediaStore Data","signatureVersion":"v4","signingName":"mediastore","uid":"mediastore-data-2017-09-01"},"operations":{"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{}}},"DescribeObject":{"http":{"method":"HEAD","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{"ETag":{"location":"header","locationName":"ETag"},"ContentType":{"location":"header","locationName":"Content-Type"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"},"Range":{"location":"header","locationName":"Range"}}},"output":{"type":"structure","required":["StatusCode"],"members":{"Body":{"shape":"Se"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentType":{"location":"header","locationName":"Content-Type"},"ETag":{"location":"header","locationName":"ETag"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"StatusCode":{"location":"statusCode","type":"integer"}},"payload":"Body"}},"ListItems":{"http":{"method":"GET"},"input":{"type":"structure","members":{"Path":{"location":"querystring","locationName":"Path"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"ETag":{},"LastModified":{"type":"timestamp"},"ContentType":{},"ContentLength":{"type":"long"}}}},"NextToken":{}}}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Body","Path"],"members":{"Body":{"shape":"Se"},"Path":{"location":"uri","locationName":"Path"},"ContentType":{"location":"header","locationName":"Content-Type"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"UploadAvailability":{"location":"header","locationName":"x-amz-upload-availability"}},"payload":"Body"},"output":{"type":"structure","members":{"ContentSHA256":{},"ETag":{},"StorageClass":{}}},"authtype":"v4-unsigned-body"}},"shapes":{"Se":{"type":"blob","streaming":true}}}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","serviceId":"Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-08-01","endpointPrefix":"monitoring","protocol":"query","serviceAbbreviation":"CloudWatch","serviceFullName":"Amazon CloudWatch","serviceId":"CloudWatch","signatureVersion":"v4","uid":"monitoring-2010-08-01","xmlNamespace":"http://monitoring.amazonaws.com/doc/2010-08-01/"},"operations":{"DeleteAlarms":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DeleteAnomalyDetector":{"input":{"type":"structure","required":["Namespace","MetricName","Stat"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{}}},"output":{"resultWrapper":"DeleteAnomalyDetectorResult","type":"structure","members":{}}},"DeleteDashboards":{"input":{"type":"structure","required":["DashboardNames"],"members":{"DashboardNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DeleteDashboardsResult","type":"structure","members":{}}},"DeleteInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Si"}}},"output":{"resultWrapper":"DeleteInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sl"}}}},"DescribeAlarmHistory":{"input":{"type":"structure","members":{"AlarmName":{},"AlarmTypes":{"shape":"Ss"},"HistoryItemType":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{},"ScanBy":{}}},"output":{"resultWrapper":"DescribeAlarmHistoryResult","type":"structure","members":{"AlarmHistoryItems":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmType":{},"Timestamp":{"type":"timestamp"},"HistoryItemType":{},"HistorySummary":{},"HistoryData":{}}}},"NextToken":{}}}},"DescribeAlarms":{"input":{"type":"structure","members":{"AlarmNames":{"shape":"S2"},"AlarmNamePrefix":{},"AlarmTypes":{"shape":"Ss"},"ChildrenOfAlarmName":{},"ParentsOfAlarmName":{},"StateValue":{},"ActionPrefix":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmsResult","type":"structure","members":{"CompositeAlarms":{"type":"list","member":{"type":"structure","members":{"ActionsEnabled":{"type":"boolean"},"AlarmActions":{"shape":"S1c"},"AlarmArn":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"AlarmDescription":{},"AlarmName":{},"AlarmRule":{},"InsufficientDataActions":{"shape":"S1c"},"OKActions":{"shape":"S1c"},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"StateValue":{}},"xmlOrder":["ActionsEnabled","AlarmActions","AlarmArn","AlarmConfigurationUpdatedTimestamp","AlarmDescription","AlarmName","AlarmRule","InsufficientDataActions","OKActions","StateReason","StateReasonData","StateUpdatedTimestamp","StateValue"]}},"MetricAlarms":{"shape":"S1j"},"NextToken":{}}}},"DescribeAlarmsForMetric":{"input":{"type":"structure","required":["MetricName","Namespace"],"members":{"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{}}},"output":{"resultWrapper":"DescribeAlarmsForMetricResult","type":"structure","members":{"MetricAlarms":{"shape":"S1j"}}}},"DescribeAnomalyDetectors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"}}},"output":{"resultWrapper":"DescribeAnomalyDetectorsResult","type":"structure","members":{"AnomalyDetectors":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{},"Configuration":{"shape":"S2b"},"StateValue":{}}}},"NextToken":{}}}},"DescribeInsightRules":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeInsightRulesResult","type":"structure","members":{"NextToken":{},"InsightRules":{"type":"list","member":{"type":"structure","required":["Name","State","Schema","Definition"],"members":{"Name":{},"State":{},"Schema":{},"Definition":{}}}}}}},"DisableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DisableInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Si"}}},"output":{"resultWrapper":"DisableInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sl"}}}},"EnableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"EnableInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Si"}}},"output":{"resultWrapper":"EnableInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sl"}}}},"GetDashboard":{"input":{"type":"structure","required":["DashboardName"],"members":{"DashboardName":{}}},"output":{"resultWrapper":"GetDashboardResult","type":"structure","members":{"DashboardArn":{},"DashboardBody":{},"DashboardName":{}}}},"GetInsightRuleReport":{"input":{"type":"structure","required":["RuleName","StartTime","EndTime","Period"],"members":{"RuleName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"MaxContributorCount":{"type":"integer"},"Metrics":{"type":"list","member":{}},"OrderBy":{}}},"output":{"resultWrapper":"GetInsightRuleReportResult","type":"structure","members":{"KeyLabels":{"type":"list","member":{}},"AggregationStatistic":{},"AggregateValue":{"type":"double"},"ApproximateUniqueCount":{"type":"long"},"Contributors":{"type":"list","member":{"type":"structure","required":["Keys","ApproximateAggregateValue","Datapoints"],"members":{"Keys":{"type":"list","member":{}},"ApproximateAggregateValue":{"type":"double"},"Datapoints":{"type":"list","member":{"type":"structure","required":["Timestamp","ApproximateValue"],"members":{"Timestamp":{"type":"timestamp"},"ApproximateValue":{"type":"double"}}}}}}},"MetricDatapoints":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"UniqueContributors":{"type":"double"},"MaxContributorValue":{"type":"double"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}}}}}},"GetMetricData":{"input":{"type":"structure","required":["MetricDataQueries","StartTime","EndTime"],"members":{"MetricDataQueries":{"shape":"S1v"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"ScanBy":{},"MaxDatapoints":{"type":"integer"}}},"output":{"resultWrapper":"GetMetricDataResult","type":"structure","members":{"MetricDataResults":{"type":"list","member":{"type":"structure","members":{"Id":{},"Label":{},"Timestamps":{"type":"list","member":{"type":"timestamp"}},"Values":{"type":"list","member":{"type":"double"}},"StatusCode":{},"Messages":{"shape":"S3q"}}}},"NextToken":{},"Messages":{"shape":"S3q"}}}},"GetMetricStatistics":{"input":{"type":"structure","required":["Namespace","MetricName","StartTime","EndTime","Period"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"Statistics":{"type":"list","member":{}},"ExtendedStatistics":{"type":"list","member":{}},"Unit":{}}},"output":{"resultWrapper":"GetMetricStatisticsResult","type":"structure","members":{"Label":{},"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"},"Unit":{},"ExtendedStatistics":{"type":"map","key":{},"value":{"type":"double"}}},"xmlOrder":["Timestamp","SampleCount","Average","Sum","Minimum","Maximum","Unit","ExtendedStatistics"]}}}}},"GetMetricWidgetImage":{"input":{"type":"structure","required":["MetricWidget"],"members":{"MetricWidget":{},"OutputFormat":{}}},"output":{"resultWrapper":"GetMetricWidgetImageResult","type":"structure","members":{"MetricWidgetImage":{"type":"blob"}}}},"ListDashboards":{"input":{"type":"structure","members":{"DashboardNamePrefix":{},"NextToken":{}}},"output":{"resultWrapper":"ListDashboardsResult","type":"structure","members":{"DashboardEntries":{"type":"list","member":{"type":"structure","members":{"DashboardName":{},"DashboardArn":{},"LastModified":{"type":"timestamp"},"Size":{"type":"long"}}}},"NextToken":{}}}},"ListMetrics":{"input":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}}},"NextToken":{}}},"output":{"resultWrapper":"ListMetricsResult","type":"structure","members":{"Metrics":{"type":"list","member":{"shape":"S1z"}},"NextToken":{}},"xmlOrder":["Metrics","NextToken"]}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"S4l"}}}},"PutAnomalyDetector":{"input":{"type":"structure","required":["Namespace","MetricName","Stat"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{},"Configuration":{"shape":"S2b"}}},"output":{"resultWrapper":"PutAnomalyDetectorResult","type":"structure","members":{}}},"PutCompositeAlarm":{"input":{"type":"structure","required":["AlarmName","AlarmRule"],"members":{"ActionsEnabled":{"type":"boolean"},"AlarmActions":{"shape":"S1c"},"AlarmDescription":{},"AlarmName":{},"AlarmRule":{},"InsufficientDataActions":{"shape":"S1c"},"OKActions":{"shape":"S1c"},"Tags":{"shape":"S4l"}}}},"PutDashboard":{"input":{"type":"structure","required":["DashboardName","DashboardBody"],"members":{"DashboardName":{},"DashboardBody":{}}},"output":{"resultWrapper":"PutDashboardResult","type":"structure","members":{"DashboardValidationMessages":{"type":"list","member":{"type":"structure","members":{"DataPath":{},"Message":{}}}}}}},"PutInsightRule":{"input":{"type":"structure","required":["RuleName","RuleDefinition"],"members":{"RuleName":{},"RuleState":{},"RuleDefinition":{},"Tags":{"shape":"S4l"}}},"output":{"resultWrapper":"PutInsightRuleResult","type":"structure","members":{}}},"PutMetricAlarm":{"input":{"type":"structure","required":["AlarmName","EvaluationPeriods","ComparisonOperator"],"members":{"AlarmName":{},"AlarmDescription":{},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S1c"},"AlarmActions":{"shape":"S1c"},"InsufficientDataActions":{"shape":"S1c"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"S1v"},"Tags":{"shape":"S4l"},"ThresholdMetricId":{}}}},"PutMetricData":{"input":{"type":"structure","required":["Namespace","MetricData"],"members":{"Namespace":{},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName"],"members":{"MetricName":{},"Dimensions":{"shape":"S7"},"Timestamp":{"type":"timestamp"},"Value":{"type":"double"},"StatisticValues":{"type":"structure","required":["SampleCount","Sum","Minimum","Maximum"],"members":{"SampleCount":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}},"Values":{"type":"list","member":{"type":"double"}},"Counts":{"type":"list","member":{"type":"double"}},"Unit":{},"StorageResolution":{"type":"integer"}}}}}}},"SetAlarmState":{"input":{"type":"structure","required":["AlarmName","StateValue","StateReason"],"members":{"AlarmName":{},"StateValue":{},"StateReason":{},"StateReasonData":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S4l"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}},"xmlOrder":["Name","Value"]}},"Si":{"type":"list","member":{}},"Sl":{"type":"list","member":{"type":"structure","members":{"FailureResource":{},"ExceptionType":{},"FailureCode":{},"FailureDescription":{}}}},"Ss":{"type":"list","member":{}},"S1c":{"type":"list","member":{}},"S1j":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmArn":{},"AlarmDescription":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S1c"},"AlarmActions":{"shape":"S1c"},"InsufficientDataActions":{"shape":"S1c"},"StateValue":{},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"S1v"},"ThresholdMetricId":{}},"xmlOrder":["AlarmName","AlarmArn","AlarmDescription","AlarmConfigurationUpdatedTimestamp","ActionsEnabled","OKActions","AlarmActions","InsufficientDataActions","StateValue","StateReason","StateReasonData","StateUpdatedTimestamp","MetricName","Namespace","Statistic","Dimensions","Period","Unit","EvaluationPeriods","Threshold","ComparisonOperator","ExtendedStatistic","TreatMissingData","EvaluateLowSampleCountPercentile","DatapointsToAlarm","Metrics","ThresholdMetricId"]}},"S1v":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"MetricStat":{"type":"structure","required":["Metric","Period","Stat"],"members":{"Metric":{"shape":"S1z"},"Period":{"type":"integer"},"Stat":{},"Unit":{}}},"Expression":{},"Label":{},"ReturnData":{"type":"boolean"},"Period":{"type":"integer"}}}},"S1z":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"}},"xmlOrder":["Namespace","MetricName","Dimensions"]},"S2b":{"type":"structure","members":{"ExcludedTimeRanges":{"type":"list","member":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}},"xmlOrder":["StartTime","EndTime"]}},"MetricTimezone":{}}},"S3q":{"type":"list","member":{"type":"structure","members":{"Code":{},"Value":{}}}},"S4l":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAlarmHistory":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AlarmHistoryItems"},"DescribeAlarms":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":["MetricAlarms","CompositeAlarms"]},"DescribeAlarmsForMetric":{"result_key":"MetricAlarms"},"DescribeInsightRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxDatapoints","output_token":"NextToken","result_key":["MetricDataResults","Messages"]},"ListDashboards":{"input_token":"NextToken","output_token":"NextToken","result_key":"DashboardEntries"},"ListMetrics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Metrics"}}}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(MetricAlarms[]) > `0`","state":"success"}]},"CompositeAlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(CompositeAlarms[]) > `0`","state":"success"}]}}}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-17","endpointPrefix":"mturk-requester","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MTurk","serviceFullName":"Amazon Mechanical Turk","serviceId":"MTurk","signatureVersion":"v4","targetPrefix":"MTurkRequesterServiceV20170117","uid":"mturk-requester-2017-01-17"},"operations":{"AcceptQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"IntegerValue":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"ApproveAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{},"RequesterFeedback":{},"OverrideRejection":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateQualificationWithWorker":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{},"IntegerValue":{"type":"integer"},"SendNotification":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateAdditionalAssignmentsForHIT":{"input":{"type":"structure","required":["HITId","NumberOfAdditionalAssignments"],"members":{"HITId":{},"NumberOfAdditionalAssignments":{"type":"integer"},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"CreateHIT":{"input":{"type":"structure","required":["LifetimeInSeconds","AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"MaxAssignments":{"type":"integer"},"AutoApprovalDelayInSeconds":{"type":"long"},"LifetimeInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"Question":{},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateHITType":{"input":{"type":"structure","required":["AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"AutoApprovalDelayInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"QualificationRequirements":{"shape":"Si"}}},"output":{"type":"structure","members":{"HITTypeId":{}}},"idempotent":true},"CreateHITWithHITType":{"input":{"type":"structure","required":["HITTypeId","LifetimeInSeconds"],"members":{"HITTypeId":{},"MaxAssignments":{"type":"integer"},"LifetimeInSeconds":{"type":"long"},"Question":{},"RequesterAnnotation":{},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateQualificationType":{"input":{"type":"structure","required":["Name","Description","QualificationTypeStatus"],"members":{"Name":{},"Keywords":{},"Description":{},"QualificationTypeStatus":{},"RetryDelayInSeconds":{"type":"long"},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}},"CreateWorkerBlock":{"input":{"type":"structure","required":["WorkerId","Reason"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"DeleteHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkerBlock":{"input":{"type":"structure","required":["WorkerId"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateQualificationFromWorker":{"input":{"type":"structure","required":["WorkerId","QualificationTypeId"],"members":{"WorkerId":{},"QualificationTypeId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"GetAccountBalance":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AvailableBalance":{},"OnHoldBalance":{}}},"idempotent":true},"GetAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{}}},"output":{"type":"structure","members":{"Assignment":{"shape":"S1p"},"HIT":{"shape":"Sz"}}},"idempotent":true},"GetFileUploadURL":{"input":{"type":"structure","required":["AssignmentId","QuestionIdentifier"],"members":{"AssignmentId":{},"QuestionIdentifier":{}}},"output":{"type":"structure","members":{"FileUploadURL":{}}},"idempotent":true},"GetHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}},"idempotent":true},"GetQualificationScore":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{}}},"output":{"type":"structure","members":{"Qualification":{"shape":"S1x"}}},"idempotent":true},"GetQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}},"idempotent":true},"ListAssignmentsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"NextToken":{},"MaxResults":{"type":"integer"},"AssignmentStatuses":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Assignments":{"type":"list","member":{"shape":"S1p"}}}},"idempotent":true},"ListBonusPayments":{"input":{"type":"structure","members":{"HITId":{},"AssignmentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"BonusPayments":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"GrantTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListHITs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListHITsForQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListQualificationRequests":{"input":{"type":"structure","members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationRequests":{"type":"list","member":{"type":"structure","members":{"QualificationRequestId":{},"QualificationTypeId":{},"WorkerId":{},"Test":{},"Answer":{},"SubmitTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListQualificationTypes":{"input":{"type":"structure","required":["MustBeRequestable"],"members":{"Query":{},"MustBeRequestable":{"type":"boolean"},"MustBeOwnedByCaller":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationTypes":{"type":"list","member":{"shape":"S1a"}}}},"idempotent":true},"ListReviewPolicyResultsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"PolicyLevels":{"type":"list","member":{}},"RetrieveActions":{"type":"boolean"},"RetrieveResults":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"HITId":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"AssignmentReviewReport":{"shape":"S2r"},"HITReviewReport":{"shape":"S2r"},"NextToken":{}}},"idempotent":true},"ListReviewableHITs":{"input":{"type":"structure","members":{"HITTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListWorkerBlocks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"WorkerBlocks":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"Reason":{}}}}}},"idempotent":true},"ListWorkersWithQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Qualifications":{"type":"list","member":{"shape":"S1x"}}}},"idempotent":true},"NotifyWorkers":{"input":{"type":"structure","required":["Subject","MessageText","WorkerIds"],"members":{"Subject":{},"MessageText":{},"WorkerIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NotifyWorkersFailureStatuses":{"type":"list","member":{"type":"structure","members":{"NotifyWorkersFailureCode":{},"NotifyWorkersFailureMessage":{},"WorkerId":{}}}}}}},"RejectAssignment":{"input":{"type":"structure","required":["AssignmentId","RequesterFeedback"],"members":{"AssignmentId":{},"RequesterFeedback":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RejectQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBonus":{"input":{"type":"structure","required":["WorkerId","BonusAmount","AssignmentId","Reason"],"members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"SendTestEventNotification":{"input":{"type":"structure","required":["Notification","TestEventType"],"members":{"Notification":{"shape":"S3k"},"TestEventType":{}}},"output":{"type":"structure","members":{}}},"UpdateExpirationForHIT":{"input":{"type":"structure","required":["HITId","ExpireAt"],"members":{"HITId":{},"ExpireAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITReviewStatus":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"Revert":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITTypeOfHIT":{"input":{"type":"structure","required":["HITId","HITTypeId"],"members":{"HITId":{},"HITTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotificationSettings":{"input":{"type":"structure","required":["HITTypeId"],"members":{"HITTypeId":{},"Notification":{"shape":"S3k"},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Description":{},"QualificationTypeStatus":{},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"RetryDelayInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}}},"shapes":{"Si":{"type":"list","member":{"type":"structure","required":["QualificationTypeId","Comparator"],"members":{"QualificationTypeId":{},"Comparator":{},"IntegerValues":{"type":"list","member":{"type":"integer"}},"LocaleValues":{"type":"list","member":{"shape":"Sn"}},"RequiredToPreview":{"deprecated":true,"type":"boolean"},"ActionsGuarded":{}}}},"Sn":{"type":"structure","required":["Country"],"members":{"Country":{},"Subdivision":{}}},"Sq":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"},"MapEntries":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"}}}}}}}}},"St":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Sz":{"type":"structure","members":{"HITId":{},"HITTypeId":{},"HITGroupId":{},"HITLayoutId":{},"CreationTime":{"type":"timestamp"},"Title":{},"Description":{},"Question":{},"Keywords":{},"HITStatus":{},"MaxAssignments":{"type":"integer"},"Reward":{},"AutoApprovalDelayInSeconds":{"type":"long"},"Expiration":{"type":"timestamp"},"AssignmentDurationInSeconds":{"type":"long"},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"HITReviewStatus":{},"NumberOfAssignmentsPending":{"type":"integer"},"NumberOfAssignmentsAvailable":{"type":"integer"},"NumberOfAssignmentsCompleted":{"type":"integer"}}},"S1a":{"type":"structure","members":{"QualificationTypeId":{},"CreationTime":{"type":"timestamp"},"Name":{},"Description":{},"Keywords":{},"QualificationTypeStatus":{},"Test":{},"TestDurationInSeconds":{"type":"long"},"AnswerKey":{},"RetryDelayInSeconds":{"type":"long"},"IsRequestable":{"type":"boolean"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"S1p":{"type":"structure","members":{"AssignmentId":{},"WorkerId":{},"HITId":{},"AssignmentStatus":{},"AutoApprovalTime":{"type":"timestamp"},"AcceptTime":{"type":"timestamp"},"SubmitTime":{"type":"timestamp"},"ApprovalTime":{"type":"timestamp"},"RejectionTime":{"type":"timestamp"},"Deadline":{"type":"timestamp"},"Answer":{},"RequesterFeedback":{}}},"S1x":{"type":"structure","members":{"QualificationTypeId":{},"WorkerId":{},"GrantTime":{"type":"timestamp"},"IntegerValue":{"type":"integer"},"LocaleValue":{"shape":"Sn"},"Status":{}}},"S2d":{"type":"list","member":{"shape":"Sz"}},"S2r":{"type":"structure","members":{"ReviewResults":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"SubjectId":{},"SubjectType":{},"QuestionId":{},"Key":{},"Value":{}}}},"ReviewActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionName":{},"TargetId":{},"TargetType":{},"Status":{},"CompleteTime":{"type":"timestamp"},"Result":{},"ErrorCode":{}}}}}},"S3k":{"type":"structure","required":["Destination","Transport","Version","EventTypes"],"members":{"Destination":{},"Transport":{},"Version":{},"EventTypes":{"type":"list","member":{}}}}}}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAssignmentsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBonusPayments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITsForQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewPolicyResultsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewableHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkerBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkersWithQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-18","endpointPrefix":"opsworks","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS OpsWorks","serviceId":"OpsWorks","signatureVersion":"v4","targetPrefix":"OpsWorks_20130218","uid":"opsworks-2013-02-18"},"operations":{"AssignInstance":{"input":{"type":"structure","required":["InstanceId","LayerIds"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"}}}},"AssignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"InstanceId":{}}}},"AssociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"InstanceId":{}}}},"AttachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"CloneStack":{"input":{"type":"structure","required":["SourceStackId","ServiceRoleArn"],"members":{"SourceStackId":{},"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"ClonePermissions":{"type":"boolean"},"CloneAppIds":{"shape":"S3"},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateApp":{"input":{"type":"structure","required":["StackId","Name","Type"],"members":{"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}},"output":{"type":"structure","members":{"AppId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["StackId","Command"],"members":{"StackId":{},"AppId":{},"InstanceIds":{"shape":"S3"},"LayerIds":{"shape":"S3"},"Command":{"shape":"Ss"},"Comment":{},"CustomJson":{}}},"output":{"type":"structure","members":{"DeploymentId":{}}}},"CreateInstance":{"input":{"type":"structure","required":["StackId","LayerIds","InstanceType"],"members":{"StackId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"AvailabilityZone":{},"VirtualizationType":{},"SubnetId":{},"Architecture":{},"RootDeviceType":{},"BlockDeviceMappings":{"shape":"Sz"},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{},"Tenancy":{}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"CreateLayer":{"input":{"type":"structure","required":["StackId","Type","Name","Shortname"],"members":{"StackId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}},"output":{"type":"structure","members":{"LayerId":{}}}},"CreateStack":{"input":{"type":"structure","required":["Name","Region","ServiceRoleArn","DefaultInstanceProfileArn"],"members":{"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}},"output":{"type":"structure","members":{"IamUserArn":{}}}},"DeleteApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{}}}},"DeleteInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DeleteElasticIp":{"type":"boolean"},"DeleteVolumes":{"type":"boolean"}}}},"DeleteLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{}}}},"DeregisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn"],"members":{"EcsClusterArn":{}}}},"DeregisterElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"DeregisterInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"DeregisterRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{}}}},"DeregisterVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"DescribeAgentVersions":{"input":{"type":"structure","members":{"StackId":{},"ConfigurationManager":{"shape":"Sa"}}},"output":{"type":"structure","members":{"AgentVersions":{"type":"list","member":{"type":"structure","members":{"Version":{},"ConfigurationManager":{"shape":"Sa"}}}}}}},"DescribeApps":{"input":{"type":"structure","members":{"StackId":{},"AppIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"AppId":{},"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"CreatedAt":{},"Environment":{"shape":"So"}}}}}}},"DescribeCommands":{"input":{"type":"structure","members":{"DeploymentId":{},"InstanceId":{},"CommandIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"DeploymentId":{},"CreatedAt":{},"AcknowledgedAt":{},"CompletedAt":{},"Status":{},"ExitCode":{"type":"integer"},"LogUrl":{},"Type":{}}}}}}},"DescribeDeployments":{"input":{"type":"structure","members":{"StackId":{},"AppId":{},"DeploymentIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"DeploymentId":{},"StackId":{},"AppId":{},"CreatedAt":{},"CompletedAt":{},"Duration":{"type":"integer"},"IamUserArn":{},"Comment":{},"Command":{"shape":"Ss"},"Status":{},"CustomJson":{},"InstanceIds":{"shape":"S3"}}}}}}},"DescribeEcsClusters":{"input":{"type":"structure","members":{"EcsClusterArns":{"shape":"S3"},"StackId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EcsClusters":{"type":"list","member":{"type":"structure","members":{"EcsClusterArn":{},"EcsClusterName":{},"StackId":{},"RegisteredAt":{}}}},"NextToken":{}}}},"DescribeElasticIps":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"Ips":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticIps":{"type":"list","member":{"type":"structure","members":{"Ip":{},"Name":{},"Domain":{},"Region":{},"InstanceId":{}}}}}}},"DescribeElasticLoadBalancers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticLoadBalancers":{"type":"list","member":{"type":"structure","members":{"ElasticLoadBalancerName":{},"Region":{},"DnsName":{},"StackId":{},"LayerId":{},"VpcId":{},"AvailabilityZones":{"shape":"S3"},"SubnetIds":{"shape":"S3"},"Ec2InstanceIds":{"shape":"S3"}}}}}}},"DescribeInstances":{"input":{"type":"structure","members":{"StackId":{},"LayerId":{},"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"AgentVersion":{},"AmiId":{},"Architecture":{},"Arn":{},"AutoScalingType":{},"AvailabilityZone":{},"BlockDeviceMappings":{"shape":"Sz"},"CreatedAt":{},"EbsOptimized":{"type":"boolean"},"Ec2InstanceId":{},"EcsClusterArn":{},"EcsContainerInstanceArn":{},"ElasticIp":{},"Hostname":{},"InfrastructureClass":{},"InstallUpdatesOnBoot":{"type":"boolean"},"InstanceId":{},"InstanceProfileArn":{},"InstanceType":{},"LastServiceErrorId":{},"LayerIds":{"shape":"S3"},"Os":{},"Platform":{},"PrivateDns":{},"PrivateIp":{},"PublicDns":{},"PublicIp":{},"RegisteredBy":{},"ReportedAgentVersion":{},"ReportedOs":{"type":"structure","members":{"Family":{},"Name":{},"Version":{}}},"RootDeviceType":{},"RootDeviceVolumeId":{},"SecurityGroupIds":{"shape":"S3"},"SshHostDsaKeyFingerprint":{},"SshHostRsaKeyFingerprint":{},"SshKeyName":{},"StackId":{},"Status":{},"SubnetId":{},"Tenancy":{},"VirtualizationType":{}}}}}}},"DescribeLayers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"StackId":{},"LayerId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"DefaultSecurityGroupNames":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"DefaultRecipes":{"shape":"S1h"},"CustomRecipes":{"shape":"S1h"},"CreatedAt":{},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}}}}},"DescribeLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerIds"],"members":{"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"LoadBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}}}}},"DescribeMyUserProfile":{"output":{"type":"structure","members":{"UserProfile":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{}}}}}},"DescribeOperatingSystems":{"output":{"type":"structure","members":{"OperatingSystems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Type":{},"ConfigurationManagers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"ReportedName":{},"ReportedVersion":{},"Supported":{"type":"boolean"}}}}}}},"DescribePermissions":{"input":{"type":"structure","members":{"IamUserArn":{},"StackId":{}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}}}}},"DescribeRaidArrays":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"RaidArrays":{"type":"list","member":{"type":"structure","members":{"RaidArrayId":{},"InstanceId":{},"Name":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"AvailabilityZone":{},"CreatedAt":{},"StackId":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DescribeRdsDbInstances":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"RdsDbInstanceArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"RdsDbInstances":{"type":"list","member":{"type":"structure","members":{"RdsDbInstanceArn":{},"DbInstanceIdentifier":{},"DbUser":{},"DbPassword":{},"Region":{},"Address":{},"Engine":{},"StackId":{},"MissingOnRds":{"type":"boolean"}}}}}}},"DescribeServiceErrors":{"input":{"type":"structure","members":{"StackId":{},"InstanceId":{},"ServiceErrorIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ServiceErrors":{"type":"list","member":{"type":"structure","members":{"ServiceErrorId":{},"StackId":{},"InstanceId":{},"Type":{},"Message":{},"CreatedAt":{}}}}}}},"DescribeStackProvisioningParameters":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"AgentInstallerUrl":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"DescribeStackSummary":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"StackSummary":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"LayersCount":{"type":"integer"},"AppsCount":{"type":"integer"},"InstancesCount":{"type":"structure","members":{"Assigning":{"type":"integer"},"Booting":{"type":"integer"},"ConnectionLost":{"type":"integer"},"Deregistering":{"type":"integer"},"Online":{"type":"integer"},"Pending":{"type":"integer"},"Rebooting":{"type":"integer"},"Registered":{"type":"integer"},"Registering":{"type":"integer"},"Requested":{"type":"integer"},"RunningSetup":{"type":"integer"},"SetupFailed":{"type":"integer"},"ShuttingDown":{"type":"integer"},"StartFailed":{"type":"integer"},"StopFailed":{"type":"integer"},"Stopped":{"type":"integer"},"Stopping":{"type":"integer"},"Terminated":{"type":"integer"},"Terminating":{"type":"integer"},"Unassigning":{"type":"integer"}}}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"CreatedAt":{},"DefaultRootDeviceType":{},"AgentVersion":{}}}}}}},"DescribeTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"TimeBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}}}}},"DescribeUserProfiles":{"input":{"type":"structure","members":{"IamUserArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayId":{},"VolumeIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"type":"structure","members":{"VolumeId":{},"Ec2VolumeId":{},"Name":{},"RaidArrayId":{},"InstanceId":{},"Status":{},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"Region":{},"AvailabilityZone":{},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}}}}},"DetachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"DisassociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"GetHostnameSuggestion":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}},"output":{"type":"structure","members":{"LayerId":{},"Hostname":{}}}},"GrantAccess":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ValidForInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"TemporaryCredential":{"type":"structure","members":{"Username":{},"Password":{},"ValidForInMinutes":{"type":"integer"},"InstanceId":{}}}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S50"},"NextToken":{}}}},"RebootInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"RegisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn","StackId"],"members":{"EcsClusterArn":{},"StackId":{}}},"output":{"type":"structure","members":{"EcsClusterArn":{}}}},"RegisterElasticIp":{"input":{"type":"structure","required":["ElasticIp","StackId"],"members":{"ElasticIp":{},"StackId":{}}},"output":{"type":"structure","members":{"ElasticIp":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Hostname":{},"PublicIp":{},"PrivateIp":{},"RsaPublicKey":{},"RsaPublicKeyFingerprint":{},"InstanceIdentity":{"type":"structure","members":{"Document":{},"Signature":{}}}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"RegisterRdsDbInstance":{"input":{"type":"structure","required":["StackId","RdsDbInstanceArn","DbUser","DbPassword"],"members":{"StackId":{},"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"RegisterVolume":{"input":{"type":"structure","required":["StackId"],"members":{"Ec2VolumeId":{},"StackId":{}}},"output":{"type":"structure","members":{"VolumeId":{}}}},"SetLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}},"SetPermission":{"input":{"type":"structure","required":["StackId","IamUserArn"],"members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}},"SetTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}},"StartInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StartStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"StopInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Force":{"type":"boolean"}}}},"StopStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S50"}}}},"UnassignInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"UnassignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}}},"UpdateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"Name":{}}}},"UpdateInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"Architecture":{},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{}}}},"UpdateLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}},"UpdateMyUserProfile":{"input":{"type":"structure","members":{"SshPublicKey":{}}}},"UpdateRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Name":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"UseOpsworksSecurityGroups":{"type":"boolean"},"AgentVersion":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"Name":{},"MountPoint":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"map","key":{},"value":{}},"Sa":{"type":"structure","members":{"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"ManageBerkshelf":{"type":"boolean"},"BerkshelfVersion":{}}},"Sd":{"type":"structure","members":{"Type":{},"Url":{},"Username":{},"Password":{},"SshKey":{},"Revision":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Type":{},"Arn":{},"DatabaseName":{}}}},"Sl":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"Certificate":{},"PrivateKey":{},"Chain":{}}},"Sm":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{},"Secure":{"type":"boolean"}}}},"Ss":{"type":"structure","required":["Name"],"members":{"Name":{},"Args":{"type":"map","key":{},"value":{"shape":"S3"}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"NoDevice":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"Iops":{"type":"integer"},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"}}}}}},"S17":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogStreams":{"type":"list","member":{"type":"structure","members":{"LogGroupName":{},"DatetimeFormat":{},"TimeZone":{},"File":{},"FileFingerprintLines":{},"MultiLineStartPattern":{},"InitialPosition":{},"Encoding":{},"BufferDuration":{"type":"integer"},"BatchCount":{"type":"integer"},"BatchSize":{"type":"integer"}}}}}},"S1f":{"type":"list","member":{"type":"structure","required":["MountPoint","NumberOfDisks","Size"],"members":{"MountPoint":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}},"S1h":{"type":"structure","members":{"Setup":{"shape":"S3"},"Configure":{"shape":"S3"},"Deploy":{"shape":"S3"},"Undeploy":{"shape":"S3"},"Shutdown":{"shape":"S3"}}},"S1i":{"type":"structure","members":{"Shutdown":{"type":"structure","members":{"ExecutionTimeout":{"type":"integer"},"DelayUntilElbConnectionsDrained":{"type":"boolean"}}}}},"S36":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"ThresholdsWaitTime":{"type":"integer"},"IgnoreMetricsTime":{"type":"integer"},"CpuThreshold":{"type":"double"},"MemoryThreshold":{"type":"double"},"LoadThreshold":{"type":"double"},"Alarms":{"shape":"S3"}}},"S4b":{"type":"structure","members":{"Monday":{"shape":"S4c"},"Tuesday":{"shape":"S4c"},"Wednesday":{"shape":"S4c"},"Thursday":{"shape":"S4c"},"Friday":{"shape":"S4c"},"Saturday":{"shape":"S4c"},"Sunday":{"shape":"S4c"}}},"S4c":{"type":"map","key":{},"value":{}},"S50":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApps":{"result_key":"Apps"},"DescribeCommands":{"result_key":"Commands"},"DescribeDeployments":{"result_key":"Deployments"},"DescribeEcsClusters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EcsClusters"},"DescribeElasticIps":{"result_key":"ElasticIps"},"DescribeElasticLoadBalancers":{"result_key":"ElasticLoadBalancers"},"DescribeInstances":{"result_key":"Instances"},"DescribeLayers":{"result_key":"Layers"},"DescribeLoadBasedAutoScaling":{"result_key":"LoadBasedAutoScalingConfigurations"},"DescribePermissions":{"result_key":"Permissions"},"DescribeRaidArrays":{"result_key":"RaidArrays"},"DescribeServiceErrors":{"result_key":"ServiceErrors"},"DescribeStacks":{"result_key":"Stacks"},"DescribeTimeBasedAutoScaling":{"result_key":"TimeBasedAutoScalingConfigurations"},"DescribeUserProfiles":{"result_key":"UserProfiles"},"DescribeVolumes":{"result_key":"Volumes"}}}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AppExists":{"delay":1,"operation":"DescribeApps","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"matcher":"status","expected":400,"state":"failure"}]},"DeploymentSuccessful":{"delay":15,"operation":"DescribeDeployments","maxAttempts":40,"description":"Wait until a deployment has completed successfully.","acceptors":[{"expected":"successful","matcher":"pathAll","state":"success","argument":"Deployments[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Deployments[].Status"}]},"InstanceOnline":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is online.","acceptors":[{"expected":"online","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceRegistered":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is registered.","acceptors":[{"expected":"registered","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is stopped.","acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is terminated.","acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]}}}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Personalize","serviceId":"Personalize","signatureVersion":"v4","signingName":"personalize","targetPrefix":"AmazonPersonalize","uid":"personalize-2018-05-22"},"operations":{"CreateBatchInferenceJob":{"input":{"type":"structure","required":["jobName","solutionVersionArn","jobInput","jobOutput","roleArn"],"members":{"jobName":{},"solutionVersionArn":{},"filterArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"S5"},"jobOutput":{"shape":"S9"},"roleArn":{}}},"output":{"type":"structure","members":{"batchInferenceJobArn":{}}}},"CreateCampaign":{"input":{"type":"structure","required":["name","solutionVersionArn","minProvisionedTPS"],"members":{"name":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true},"CreateDataset":{"input":{"type":"structure","required":["name","schemaArn","datasetGroupArn","datasetType"],"members":{"name":{},"schemaArn":{},"datasetGroupArn":{},"datasetType":{}}},"output":{"type":"structure","members":{"datasetArn":{}}},"idempotent":true},"CreateDatasetGroup":{"input":{"type":"structure","required":["name"],"members":{"name":{},"roleArn":{},"kmsKeyArn":{}}},"output":{"type":"structure","members":{"datasetGroupArn":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["jobName","datasetArn","dataSource","roleArn"],"members":{"jobName":{},"datasetArn":{},"dataSource":{"shape":"Sl"},"roleArn":{}}},"output":{"type":"structure","members":{"datasetImportJobArn":{}}}},"CreateEventTracker":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"datasetGroupArn":{}}},"output":{"type":"structure","members":{"eventTrackerArn":{},"trackingId":{}}},"idempotent":true},"CreateFilter":{"input":{"type":"structure","required":["name","datasetGroupArn","filterExpression"],"members":{"name":{},"datasetGroupArn":{},"filterExpression":{"shape":"Sr"}}},"output":{"type":"structure","members":{"filterArn":{}}}},"CreateSchema":{"input":{"type":"structure","required":["name","schema"],"members":{"name":{},"schema":{}}},"output":{"type":"structure","members":{"schemaArn":{}}},"idempotent":true},"CreateSolution":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"S10"}}},"output":{"type":"structure","members":{"solutionArn":{}}}},"CreateSolutionVersion":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{},"trainingMode":{}}},"output":{"type":"structure","members":{"solutionVersionArn":{}}}},"DeleteCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"idempotent":true},"DeleteDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"idempotent":true},"DeleteEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"idempotent":true},"DeleteFilter":{"input":{"type":"structure","required":["filterArn"],"members":{"filterArn":{}}}},"DeleteSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"idempotent":true},"DeleteSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"idempotent":true},"DescribeAlgorithm":{"input":{"type":"structure","required":["algorithmArn"],"members":{"algorithmArn":{}}},"output":{"type":"structure","members":{"algorithm":{"type":"structure","members":{"name":{},"algorithmArn":{},"algorithmImage":{"type":"structure","required":["dockerURI"],"members":{"name":{},"dockerURI":{}}},"defaultHyperParameters":{"shape":"S1n"},"defaultHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"},"isTunable":{"type":"boolean"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"},"isTunable":{"type":"boolean"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S1l"},"isTunable":{"type":"boolean"}}}}}},"defaultResourceConfig":{"type":"map","key":{},"value":{}},"trainingInputMode":{},"roleArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeBatchInferenceJob":{"input":{"type":"structure","required":["batchInferenceJobArn"],"members":{"batchInferenceJobArn":{}}},"output":{"type":"structure","members":{"batchInferenceJob":{"type":"structure","members":{"jobName":{},"batchInferenceJobArn":{},"filterArn":{},"failureReason":{},"solutionVersionArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"S5"},"jobOutput":{"shape":"S9"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"output":{"type":"structure","members":{"campaign":{"type":"structure","members":{"name":{},"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestCampaignUpdate":{"type":"structure","members":{"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetGroupArn":{},"datasetType":{},"schemaArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"output":{"type":"structure","members":{"datasetGroup":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"roleArn":{},"kmsKeyArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["datasetImportJobArn"],"members":{"datasetImportJobArn":{}}},"output":{"type":"structure","members":{"datasetImportJob":{"type":"structure","members":{"jobName":{},"datasetImportJobArn":{},"datasetArn":{},"dataSource":{"shape":"Sl"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"output":{"type":"structure","members":{"eventTracker":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"accountId":{},"trackingId":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeFeatureTransformation":{"input":{"type":"structure","required":["featureTransformationArn"],"members":{"featureTransformationArn":{}}},"output":{"type":"structure","members":{"featureTransformation":{"type":"structure","members":{"name":{},"featureTransformationArn":{},"defaultParameters":{"type":"map","key":{},"value":{}},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{}}}}},"idempotent":true},"DescribeFilter":{"input":{"type":"structure","required":["filterArn"],"members":{"filterArn":{}}},"output":{"type":"structure","members":{"filter":{"type":"structure","members":{"name":{},"filterArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"datasetGroupArn":{},"failureReason":{},"filterExpression":{"shape":"Sr"},"status":{}}}}},"idempotent":true},"DescribeRecipe":{"input":{"type":"structure","required":["recipeArn"],"members":{"recipeArn":{}}},"output":{"type":"structure","members":{"recipe":{"type":"structure","members":{"name":{},"recipeArn":{},"algorithmArn":{},"featureTransformationArn":{},"status":{},"description":{},"creationDateTime":{"type":"timestamp"},"recipeType":{},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"output":{"type":"structure","members":{"schema":{"type":"structure","members":{"name":{},"schemaArn":{},"schema":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"output":{"type":"structure","members":{"solution":{"type":"structure","members":{"name":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"S10"},"autoMLResult":{"type":"structure","members":{"bestRecipeArn":{}}},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestSolutionVersion":{"shape":"S3p"}}}}},"idempotent":true},"DescribeSolutionVersion":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersion":{"type":"structure","members":{"solutionVersionArn":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"eventType":{},"datasetGroupArn":{},"solutionConfig":{"shape":"S10"},"trainingHours":{"type":"double"},"trainingMode":{},"tunedHPOParams":{"type":"structure","members":{"algorithmHyperParameters":{"shape":"S1n"}}},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"GetSolutionMetrics":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersionArn":{},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"ListBatchInferenceJobs":{"input":{"type":"structure","members":{"solutionVersionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"batchInferenceJobs":{"type":"list","member":{"type":"structure","members":{"batchInferenceJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"solutionVersionArn":{}}}},"nextToken":{}}},"idempotent":true},"ListCampaigns":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"campaigns":{"type":"list","member":{"type":"structure","members":{"name":{},"campaignArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetGroups":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"datasetArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetImportJobs":{"type":"list","member":{"type":"structure","members":{"datasetImportJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasets":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetType":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListEventTrackers":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTrackers":{"type":"list","member":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListFilters":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"name":{},"filterArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"datasetGroupArn":{},"failureReason":{},"status":{}}}},"nextToken":{}}},"idempotent":true},"ListRecipes":{"input":{"type":"structure","members":{"recipeProvider":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"recipes":{"type":"list","member":{"type":"structure","members":{"name":{},"recipeArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListSchemas":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"schemas":{"type":"list","member":{"type":"structure","members":{"name":{},"schemaArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListSolutionVersions":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutionVersions":{"type":"list","member":{"shape":"S3p"}},"nextToken":{}}},"idempotent":true},"ListSolutions":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutions":{"type":"list","member":{"type":"structure","members":{"name":{},"solutionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"UpdateCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true}},"shapes":{"S5":{"type":"structure","required":["s3DataSource"],"members":{"s3DataSource":{"shape":"S6"}}},"S6":{"type":"structure","required":["path"],"members":{"path":{},"kmsKeyArn":{}}},"S9":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"Sl":{"type":"structure","members":{"dataLocation":{}}},"Sr":{"type":"string","sensitive":true},"S10":{"type":"structure","members":{"eventValueThreshold":{},"hpoConfig":{"type":"structure","members":{"hpoObjective":{"type":"structure","members":{"type":{},"metricName":{},"metricRegex":{}}},"hpoResourceConfig":{"type":"structure","members":{"maxNumberOfTrainingJobs":{},"maxParallelTrainingJobs":{}}},"algorithmHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S1l"}}}}}}}},"algorithmHyperParameters":{"shape":"S1n"},"featureTransformationParameters":{"type":"map","key":{},"value":{}},"autoMLConfig":{"type":"structure","members":{"metricName":{},"recipeList":{"type":"list","member":{}}}}}},"S1l":{"type":"list","member":{}},"S1n":{"type":"map","key":{},"value":{}},"S3p":{"type":"structure","members":{"solutionVersionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListBatchInferenceJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"batchInferenceJobs"},"ListCampaigns":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"campaigns"},"ListDatasetGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetGroups"},"ListDatasetImportJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetImportJobs"},"ListDatasets":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasets"},"ListEventTrackers":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventTrackers"},"ListRecipes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"recipes"},"ListSchemas":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"schemas"},"ListSolutionVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutionVersions"},"ListSolutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutions"}}}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-03-22","endpointPrefix":"personalize-events","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Events","serviceId":"Personalize Events","signatureVersion":"v4","signingName":"personalize","uid":"personalize-events-2018-03-22"},"operations":{"PutEvents":{"http":{"requestUri":"/events"},"input":{"type":"structure","required":["trackingId","sessionId","eventList"],"members":{"trackingId":{},"userId":{},"sessionId":{},"eventList":{"type":"list","member":{"type":"structure","required":["eventType","properties","sentAt"],"members":{"eventId":{},"eventType":{},"properties":{"jsonvalue":true},"sentAt":{"type":"timestamp"}}}}}}}},"shapes":{}}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize-runtime","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Runtime","serviceId":"Personalize Runtime","signatureVersion":"v4","signingName":"personalize","uid":"personalize-runtime-2018-05-22"},"operations":{"GetPersonalizedRanking":{"http":{"requestUri":"/personalize-ranking"},"input":{"type":"structure","required":["campaignArn","inputList","userId"],"members":{"campaignArn":{},"inputList":{"type":"list","member":{}},"userId":{},"context":{"shape":"S6"}}},"output":{"type":"structure","members":{"personalizedRanking":{"shape":"Sa"}}},"idempotent":true},"GetRecommendations":{"http":{"requestUri":"/recommendations"},"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{},"itemId":{},"userId":{},"numResults":{"type":"integer"},"context":{"shape":"S6"},"filterArn":{}}},"output":{"type":"structure","members":{"itemList":{"shape":"Sa"}}},"idempotent":true}},"shapes":{"S6":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"Sa":{"type":"list","member":{"type":"structure","members":{"itemId":{},"score":{"type":"double"}}}}}}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-10","endpointPrefix":"polly","protocol":"rest-json","serviceFullName":"Amazon Polly","serviceId":"Polly","signatureVersion":"v4","uid":"polly-2016-06-10"},"operations":{"DeleteLexicon":{"http":{"method":"DELETE","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{}}},"DescribeVoices":{"http":{"method":"GET","requestUri":"/v1/voices","responseCode":200},"input":{"type":"structure","members":{"Engine":{"location":"querystring","locationName":"Engine"},"LanguageCode":{"location":"querystring","locationName":"LanguageCode"},"IncludeAdditionalLanguageCodes":{"location":"querystring","locationName":"IncludeAdditionalLanguageCodes","type":"boolean"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Voices":{"type":"list","member":{"type":"structure","members":{"Gender":{},"Id":{},"LanguageCode":{},"LanguageName":{},"Name":{},"AdditionalLanguageCodes":{"type":"list","member":{}},"SupportedEngines":{"type":"list","member":{}}}}},"NextToken":{}}}},"GetLexicon":{"http":{"method":"GET","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{"Lexicon":{"type":"structure","members":{"Content":{},"Name":{"shape":"S2"}}},"LexiconAttributes":{"shape":"Sm"}}}},"GetSpeechSynthesisTask":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks/{TaskId}","responseCode":200},"input":{"type":"structure","required":["TaskId"],"members":{"TaskId":{"location":"uri","locationName":"TaskId"}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"ListLexicons":{"http":{"method":"GET","requestUri":"/v1/lexicons","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Lexicons":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"S2"},"Attributes":{"shape":"Sm"}}}},"NextToken":{}}}},"ListSpeechSynthesisTasks":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"Status":{"location":"querystring","locationName":"Status"}}},"output":{"type":"structure","members":{"NextToken":{},"SynthesisTasks":{"type":"list","member":{"shape":"Sv"}}}}},"PutLexicon":{"http":{"method":"PUT","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name","Content"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"},"Content":{}}},"output":{"type":"structure","members":{}}},"StartSpeechSynthesisTask":{"http":{"requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","required":["OutputFormat","OutputS3BucketName","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"SampleRate":{},"SnsTopicArn":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"SynthesizeSpeech":{"http":{"requestUri":"/v1/speech","responseCode":200},"input":{"type":"structure","required":["OutputFormat","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"AudioStream":{"type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"RequestCharacters":{"location":"header","locationName":"x-amzn-RequestCharacters","type":"integer"}},"payload":"AudioStream"}}},"shapes":{"S2":{"type":"string","sensitive":true},"Sm":{"type":"structure","members":{"Alphabet":{},"LanguageCode":{},"LastModified":{"type":"timestamp"},"LexiconArn":{},"LexemesCount":{"type":"integer"},"Size":{"type":"integer"}}},"Sv":{"type":"structure","members":{"Engine":{},"TaskId":{},"TaskStatus":{},"TaskStatusReason":{},"OutputUri":{},"CreationTime":{"type":"timestamp"},"RequestCharacters":{"type":"integer"},"SnsTopicArn":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"TextType":{},"VoiceId":{},"LanguageCode":{}}},"S12":{"type":"list","member":{"shape":"S2"}},"S15":{"type":"list","member":{}}}}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListSpeechSynthesisTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-15","endpointPrefix":"api.pricing","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Pricing","serviceFullName":"AWS Price List Service","serviceId":"Pricing","signatureVersion":"v4","signingName":"pricing","targetPrefix":"AWSPriceListService","uid":"pricing-2017-10-15"},"operations":{"DescribeServices":{"input":{"type":"structure","members":{"ServiceCode":{},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"ServiceCode":{},"AttributeNames":{"type":"list","member":{}}}}},"FormatVersion":{},"NextToken":{}}}},"GetAttributeValues":{"input":{"type":"structure","required":["ServiceCode","AttributeName"],"members":{"ServiceCode":{},"AttributeName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AttributeValues":{"type":"list","member":{"type":"structure","members":{"Value":{}}}},"NextToken":{}}}},"GetProducts":{"input":{"type":"structure","members":{"ServiceCode":{},"Filters":{"type":"list","member":{"type":"structure","required":["Type","Field","Value"],"members":{"Type":{},"Field":{},"Value":{}}}},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FormatVersion":{},"PriceList":{"type":"list","member":{"jsonvalue":true}},"NextToken":{}}}}},"shapes":{}}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetAttributeValues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-10","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-01-10","xmlNamespace":"http://rds.amazonaws.com/doc/2013-01-10/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1c"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S25"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S25","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2f"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2f"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1o","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3o"}},"wrapper":true}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3m"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMembership":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1i":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S25":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2f":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3o"}},"wrapper":true},"S3o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3z":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-12","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-02-12","xmlNamespace":"http://rds.amazonaws.com/doc/2013-02-12/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1d"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S28"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S28","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1d","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2n"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1p","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3w","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3y"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3w"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1d":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1j":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1t":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S28":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2n":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3w":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3y"}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4b":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-09-09","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-09-09","xmlNamespace":"http://rds.amazonaws.com/doc/2013-09-09/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2d"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2d","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1f","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2s"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S27"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1r","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S41","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S43"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S41"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1f":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1v":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S27":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2d":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S41":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S43"}},"wrapper":true},"S43":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4g":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-09-01","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-09-01","xmlNamespace":"http://rds.amazonaws.com/doc/2014-09-01/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{},"StorageType":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S17","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2w"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1b","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S2b"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"St","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1e","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S45","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"S13"},"VpcSecurityGroupMemberships":{"shape":"S14"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S45"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"Sn":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"St":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sy"},"VpcSecurityGroupMemberships":{"shape":"S10"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"Sx":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"Sy":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S14":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S17":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sy"},"VpcSecurityGroups":{"shape":"S10"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1b"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1e"},"SubnetStatus":{}}}}},"wrapper":true},"S1e":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2b":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S45":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4k":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddRoleToDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sb"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Sf"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"BacktrackDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","BacktrackTo"],"members":{"DBClusterIdentifier":{},"BacktrackTo":{"type":"timestamp"},"Force":{"type":"boolean"},"UseEarliestTimeOnPointInTimeUnavailable":{"type":"boolean"}}},"output":{"shape":"Ss","resultWrapper":"BacktrackDBClusterResult"}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskIdentifier"],"members":{"ExportTaskIdentifier":{}}},"output":{"shape":"Su","resultWrapper":"CancelExportTaskResult"}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sz"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sb"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S12"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S16"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"KmsKeyId":{},"Tags":{"shape":"Sb"},"CopyTags":{"type":"boolean"},"PreSignedUrl":{},"OptionGroupName":{},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1f"}}}},"CreateCustomAvailabilityZone":{"input":{"type":"structure","required":["CustomAvailabilityZoneName"],"members":{"CustomAvailabilityZoneName":{},"ExistingVpnId":{},"NewVpnTunnelName":{},"VpnTunnelOriginatorIP":{}}},"output":{"resultWrapper":"CreateCustomAvailabilityZoneResult","type":"structure","members":{"CustomAvailabilityZone":{"shape":"S1q"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"S13"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1u"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"EngineMode":{},"ScalingConfiguration":{"shape":"S1x"},"DeletionProtection":{"type":"boolean"},"GlobalClusterIdentifier":{},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"EnableGlobalWriteForwarding":{"type":"boolean"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"CreateDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterIdentifier","DBClusterEndpointIdentifier","EndpointType"],"members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"},"Tags":{"shape":"Sb"}}},"output":{"shape":"S2e","resultWrapper":"CreateDBClusterEndpointResult"}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sz"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S12"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S2k"},"VpcSecurityGroupIds":{"shape":"S1u"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"ProcessorFeatures":{"shape":"S1b"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"DBParameterGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"S1u"},"StorageType":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S16"}}}},"CreateDBProxy":{"input":{"type":"structure","required":["DBProxyName","EngineFamily","Auth","RoleArn","VpcSubnetIds"],"members":{"DBProxyName":{},"EngineFamily":{},"Auth":{"shape":"S3a"},"RoleArn":{},"VpcSubnetIds":{"shape":"Sv"},"VpcSecurityGroupIds":{"shape":"Sv"},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S3f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S3o"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S2q"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"SourceIds":{"shape":"S7"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"CreateGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"SourceDBClusterIdentifier":{},"Engine":{},"EngineVersion":{},"DeletionProtection":{"type":"boolean"},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"}}},"output":{"resultWrapper":"CreateGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3u"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1f"}}}},"DeleteCustomAvailabilityZone":{"input":{"type":"structure","required":["CustomAvailabilityZoneId"],"members":{"CustomAvailabilityZoneId":{}}},"output":{"resultWrapper":"DeleteCustomAvailabilityZoneResult","type":"structure","members":{"CustomAvailabilityZone":{"shape":"S1q"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"DeleteDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{}}},"output":{"shape":"S2e","resultWrapper":"DeleteDBClusterEndpointResult"}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S12"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{},"DeleteAutomatedBackups":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"DeleteDBInstanceAutomatedBackup":{"input":{"type":"structure","required":["DbiResourceId"],"members":{"DbiResourceId":{}}},"output":{"resultWrapper":"DeleteDBInstanceAutomatedBackupResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S4c"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBProxy":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{}}},"output":{"resultWrapper":"DeleteDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S3f"}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"DeleteGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3u"}}}},"DeleteInstallationMedia":{"input":{"type":"structure","required":["InstallationMediaId"],"members":{"InstallationMediaId":{}}},"output":{"shape":"S4q","resultWrapper":"DeleteInstallationMediaResult"}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DeregisterDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"DBInstanceIdentifiers":{"shape":"Sv"},"DBClusterIdentifiers":{"shape":"Sv"}}},"output":{"resultWrapper":"DeregisterDBProxyTargetsResult","type":"structure","members":{}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountQuotas":{"type":"list","member":{"locationName":"AccountQuota","type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}},"wrapper":true}}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"Certificates":{"type":"list","member":{"shape":"S56","locationName":"Certificate"}},"Marker":{}}}},"DescribeCustomAvailabilityZones":{"input":{"type":"structure","members":{"CustomAvailabilityZoneId":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCustomAvailabilityZonesResult","type":"structure","members":{"Marker":{},"CustomAvailabilityZones":{"type":"list","member":{"shape":"S1q","locationName":"CustomAvailabilityZone"}}}}},"DescribeDBClusterBacktracks":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterBacktracksResult","type":"structure","members":{"Marker":{},"DBClusterBacktracks":{"type":"list","member":{"shape":"Ss","locationName":"DBClusterBacktrack"}}}}},"DescribeDBClusterEndpoints":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterEndpointsResult","type":"structure","members":{"Marker":{},"DBClusterEndpoints":{"type":"list","member":{"shape":"S2e","locationName":"DBClusterEndpointList"}}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sz","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S5l"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S5r"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"S12","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"S1z","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"},"IncludeAll":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S65"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S65","locationName":"CharacterSet"}},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"S1w"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"},"SupportedEngineModes":{"shape":"S5o"},"SupportedFeatureNames":{"type":"list","member":{}},"Status":{}}}}}}},"DescribeDBInstanceAutomatedBackups":{"input":{"type":"structure","members":{"DbiResourceId":{},"DBInstanceIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstanceAutomatedBackupsResult","type":"structure","members":{"Marker":{},"DBInstanceAutomatedBackups":{"type":"list","member":{"shape":"S4c","locationName":"DBInstanceAutomatedBackup"}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S2m","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S16","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S5l"},"Marker":{}}}},"DescribeDBProxies":{"input":{"type":"structure","members":{"DBProxyName":{},"Filters":{"shape":"S51"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxiesResult","type":"structure","members":{"DBProxies":{"type":"list","member":{"shape":"S3f"}},"Marker":{}}}},"DescribeDBProxyTargetGroups":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"Filters":{"shape":"S51"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyTargetGroupsResult","type":"structure","members":{"TargetGroups":{"type":"list","member":{"shape":"S6y"}},"Marker":{}}}},"DescribeDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"Filters":{"shape":"S51"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyTargetsResult","type":"structure","members":{"Targets":{"shape":"S72"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sl","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshotAttributes":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBSnapshotAttributesResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S7d"}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"},"DbiResourceId":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"S19","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S2q","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S7o"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S7o"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S51"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S8"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S6","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S8"},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S8"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIdentifier":{},"SourceArn":{},"Filters":{"shape":"S51"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeExportTasksResult","type":"structure","members":{"Marker":{},"ExportTasks":{"type":"list","member":{"shape":"Su","locationName":"ExportTask"}}}}},"DescribeGlobalClusters":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeGlobalClustersResult","type":"structure","members":{"Marker":{},"GlobalClusters":{"type":"list","member":{"shape":"S3u","locationName":"GlobalClusterMember"}}}}},"DescribeInstallationMedia":{"input":{"type":"structure","members":{"InstallationMediaId":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeInstallationMediaResult","type":"structure","members":{"Marker":{},"InstallationMedia":{"type":"list","member":{"shape":"S4q","locationName":"InstallationMedia"}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"OptionsConflictsWith":{"type":"list","member":{"locationName":"OptionConflictName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"RequiresAutoMinorEngineVersionUpgrade":{"type":"boolean"},"VpcOnly":{"type":"boolean"},"SupportsOptionVersionDowngrade":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsRequired":{"type":"boolean"},"MinimumEngineVersionPerAllowedValue":{"type":"list","member":{"locationName":"MinimumEngineVersionPerAllowedValue","type":"structure","members":{"AllowedValue":{},"MinimumEngineVersion":{}}}}}}},"OptionGroupOptionVersions":{"type":"list","member":{"locationName":"OptionVersion","type":"structure","members":{"Version":{},"IsDefault":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S51"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1f","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZoneGroup":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZoneGroup":{},"AvailabilityZones":{"type":"list","member":{"shape":"S2t","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"},"AvailableProcessorFeatures":{"shape":"S8x"},"SupportedEngineModes":{"shape":"S5o"},"SupportsStorageAutoscaling":{"type":"boolean"},"SupportsKerberosAuthentication":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S51"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Sf","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"LeaseId":{},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S95","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S51"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S97"}},"wrapper":true}}}}},"DescribeSourceRegions":{"input":{"type":"structure","members":{"RegionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S51"}}},"output":{"resultWrapper":"DescribeSourceRegionsResult","type":"structure","members":{"Marker":{},"SourceRegions":{"type":"list","member":{"locationName":"SourceRegion","type":"structure","members":{"RegionName":{},"Endpoint":{},"Status":{}}}}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"S9m"},"ProvisionedIops":{"shape":"S9m"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}},"SupportsStorageAutoscaling":{"type":"boolean"}}}},"ValidProcessorFeatures":{"shape":"S8x"}},"wrapper":true}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"FailoverDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"ImportInstallationMedia":{"input":{"type":"structure","required":["CustomAvailabilityZoneId","Engine","EngineVersion","EngineInstallationMediaPath","OSInstallationMediaPath"],"members":{"CustomAvailabilityZoneId":{},"Engine":{},"EngineVersion":{},"EngineInstallationMediaPath":{},"OSInstallationMediaPath":{}}},"output":{"shape":"S4q","resultWrapper":"ImportInstallationMediaResult"}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S51"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sb"}}}},"ModifyCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"RemoveCustomerOverride":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyCertificatesResult","type":"structure","members":{"Certificate":{"shape":"S56"}}}},"ModifyCurrentDBClusterCapacity":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"Capacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}},"output":{"resultWrapper":"ModifyCurrentDBClusterCapacityResult","type":"structure","members":{"DBClusterIdentifier":{},"PendingCapacity":{"type":"integer"},"CurrentCapacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1u"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"CloudwatchLogsExportConfiguration":{"shape":"Sa2"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"DBInstanceParameterGroupName":{},"Domain":{},"DomainIAMRoleName":{},"ScalingConfiguration":{"shape":"S1x"},"DeletionProtection":{"type":"boolean"},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"EnableGlobalWriteForwarding":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"ModifyDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"}}},"output":{"shape":"S2e","resultWrapper":"ModifyDBClusterEndpointResult"}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S5l"}}},"output":{"shape":"Sa6","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S5u"},"ValuesToRemove":{"shape":"S5u"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S5r"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S2k"},"VpcSecurityGroupIds":{"shape":"S1u"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"CloudwatchLogsExportConfiguration":{"shape":"Sa2"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"CertificateRotationRestart":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S5l"}}},"output":{"shape":"Sac","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBProxy":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"NewDBProxyName":{},"Auth":{"shape":"S3a"},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"RoleArn":{},"SecurityGroups":{"shape":"Sv"}}},"output":{"resultWrapper":"ModifyDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S3f"}}}},"ModifyDBProxyTargetGroup":{"input":{"type":"structure","required":["TargetGroupName","DBProxyName"],"members":{"TargetGroupName":{},"DBProxyName":{},"ConnectionPoolConfig":{"type":"structure","members":{"MaxConnectionsPercent":{"type":"integer"},"MaxIdleConnectionsPercent":{"type":"integer"},"ConnectionBorrowTimeout":{"type":"integer"},"SessionPinningFilters":{"shape":"Sv"},"InitQuery":{}}},"NewName":{}}},"output":{"resultWrapper":"ModifyDBProxyTargetGroupResult","type":"structure","members":{"DBProxyTargetGroup":{"shape":"S6y"}}}},"ModifyDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{},"EngineVersion":{},"OptionGroupName":{}}},"output":{"resultWrapper":"ModifyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"ModifyDBSnapshotAttribute":{"input":{"type":"structure","required":["DBSnapshotIdentifier","AttributeName"],"members":{"DBSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S5u"},"ValuesToRemove":{"shape":"S5u"}}},"output":{"resultWrapper":"ModifyDBSnapshotAttributeResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S7d"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S3o"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S2q"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"ModifyGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"NewGlobalClusterIdentifier":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3u"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"OptionVersion":{},"DBSecurityGroupMemberships":{"shape":"S2k"},"VpcSecurityGroupMemberships":{"shape":"S1u"},"OptionSettings":{"type":"list","member":{"shape":"S1j","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1f"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S95"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"RegisterDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"DBInstanceIdentifiers":{"shape":"Sv"},"DBClusterIdentifiers":{"shape":"Sv"}}},"output":{"resultWrapper":"RegisterDBProxyTargetsResult","type":"structure","members":{"DBProxyTargets":{"shape":"S72"}}}},"RemoveFromGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"DbClusterIdentifier":{}}},"output":{"resultWrapper":"RemoveFromGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3u"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveRoleFromDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S5l"}}},"output":{"shape":"Sa6","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S5l"}}},"output":{"shape":"Sac","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromS3":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","MasterUserPassword","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"AvailabilityZones":{"shape":"S13"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1u"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{}}},"output":{"resultWrapper":"RestoreDBClusterFromS3Result","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"S13"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1u"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"EngineMode":{},"ScalingConfiguration":{"shape":"S1x"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1u"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S1u"},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"RestoreDBInstanceFromS3":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S2k"},"VpcSecurityGroupIds":{"shape":"S1u"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBInstanceFromS3Result","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CopyTagsToSnapshot":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S1u"},"Domain":{},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S1w"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"SourceDbiResourceId":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"StartActivityStream":{"input":{"type":"structure","required":["ResourceArn","Mode","KmsKeyId"],"members":{"ResourceArn":{},"Mode":{},"KmsKeyId":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"StartActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{},"Mode":{},"ApplyImmediately":{"type":"boolean"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"StartDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"StartDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}},"StartExportTask":{"input":{"type":"structure","required":["ExportTaskIdentifier","SourceArn","S3BucketName","IamRoleArn","KmsKeyId"],"members":{"ExportTaskIdentifier":{},"SourceArn":{},"S3BucketName":{},"IamRoleArn":{},"KmsKeyId":{},"S3Prefix":{},"ExportOnly":{"shape":"Sv"}}},"output":{"shape":"Su","resultWrapper":"StartExportTaskResult"}},"StopActivityStream":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"StopActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1z"}}}},"StopDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"StopDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2m"}}}}},"shapes":{"S6":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S7"},"EventCategoriesList":{"shape":"S8"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S7":{"type":"list","member":{"locationName":"SourceId"}},"S8":{"type":"list","member":{"locationName":"EventCategory"}},"Sb":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sl":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}},"DBSecurityGroupArn":{}},"wrapper":true},"Ss":{"type":"structure","members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"BacktrackTo":{"type":"timestamp"},"BacktrackedFrom":{"type":"timestamp"},"BacktrackRequestCreationTime":{"type":"timestamp"},"Status":{}}},"Su":{"type":"structure","members":{"ExportTaskIdentifier":{},"SourceArn":{},"ExportOnly":{"shape":"Sv"},"SnapshotTime":{"type":"timestamp"},"TaskStartTime":{"type":"timestamp"},"TaskEndTime":{"type":"timestamp"},"S3Bucket":{},"S3Prefix":{},"IamRoleArn":{},"KmsKeyId":{},"Status":{},"PercentProgress":{"type":"integer"},"TotalExtractedDataInGB":{"type":"integer"},"FailureCause":{},"WarningMessage":{}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"S12":{"type":"structure","members":{"AvailabilityZones":{"shape":"S13"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"S13":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S16":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"S19":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDBSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"DBSnapshotArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"ProcessorFeatures":{"shape":"S1b"},"DbiResourceId":{}},"wrapper":true},"S1b":{"type":"list","member":{"locationName":"ProcessorFeature","type":"structure","members":{"Name":{},"Value":{}}}},"S1f":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionVersion":{},"OptionSettings":{"type":"list","member":{"shape":"S1j","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"S1k"},"VpcSecurityGroupMemberships":{"shape":"S1m"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{},"OptionGroupArn":{}},"wrapper":true},"S1j":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S1k":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S1m":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1q":{"type":"structure","members":{"CustomAvailabilityZoneId":{},"CustomAvailabilityZoneName":{},"CustomAvailabilityZoneStatus":{},"VpnDetails":{"type":"structure","members":{"VpnId":{},"VpnTunnelOriginatorIP":{},"VpnGatewayIp":{},"VpnPSK":{"type":"string","sensitive":true},"VpnName":{},"VpnState":{}}}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1w":{"type":"list","member":{}},"S1x":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{}}},"S1z":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"S13"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"CustomEndpoints":{"shape":"Sv"},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S1m"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{},"FeatureName":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"},"EarliestBacktrackTime":{"type":"timestamp"},"BacktrackWindow":{"type":"long"},"BacktrackConsumedChangeRecords":{"type":"long"},"EnabledCloudwatchLogsExports":{"shape":"S1w"},"Capacity":{"type":"integer"},"EngineMode":{},"ScalingConfigurationInfo":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{}}},"DeletionProtection":{"type":"boolean"},"HttpEndpointEnabled":{"type":"boolean"},"ActivityStreamMode":{},"ActivityStreamStatus":{},"ActivityStreamKmsKeyId":{},"ActivityStreamKinesisStreamName":{},"CopyTagsToSnapshot":{"type":"boolean"},"CrossAccountClone":{"type":"boolean"},"DomainMemberships":{"shape":"S2a"},"GlobalWriteForwardingStatus":{},"GlobalWriteForwardingRequested":{"type":"boolean"}},"wrapper":true},"S2a":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"S2e":{"type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"},"DBClusterEndpointArn":{}}},"S2k":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S2m":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"shape":"S2n"},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"S1k"},"VpcSecurityGroups":{"shape":"S1m"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S2q"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"S1w"},"LogTypesToDisable":{"shape":"S1w"}}},"ProcessorFeatures":{"shape":"S1b"}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"shape":"S2a"},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnabledCloudwatchLogsExports":{"shape":"S1w"},"ProcessorFeatures":{"shape":"S1b"},"DeletionProtection":{"type":"boolean"},"AssociatedRoles":{"type":"list","member":{"locationName":"DBInstanceRole","type":"structure","members":{"RoleArn":{},"FeatureName":{},"Status":{}}}},"ListenerEndpoint":{"shape":"S2n"},"MaxAllocatedStorage":{"type":"integer"}},"wrapper":true},"S2n":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"S2q":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S2t"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S2t":{"type":"structure","members":{"Name":{}},"wrapper":true},"S3a":{"type":"list","member":{"type":"structure","members":{"Description":{},"UserName":{},"AuthScheme":{},"SecretArn":{},"IAMAuth":{}}}},"S3f":{"type":"structure","members":{"DBProxyName":{},"DBProxyArn":{},"Status":{},"EngineFamily":{},"VpcSecurityGroupIds":{"shape":"Sv"},"VpcSubnetIds":{"shape":"Sv"},"Auth":{"type":"list","member":{"type":"structure","members":{"Description":{},"UserName":{},"AuthScheme":{},"SecretArn":{},"IAMAuth":{}}}},"RoleArn":{},"Endpoint":{},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"}}},"S3o":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S3u":{"type":"structure","members":{"GlobalClusterIdentifier":{},"GlobalClusterResourceId":{},"GlobalClusterArn":{},"Status":{},"Engine":{},"EngineVersion":{},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"GlobalClusterMembers":{"type":"list","member":{"locationName":"GlobalClusterMember","type":"structure","members":{"DBClusterArn":{},"Readers":{"type":"list","member":{}},"IsWriter":{"type":"boolean"},"GlobalWriteForwardingStatus":{}},"wrapper":true}}},"wrapper":true},"S4c":{"type":"structure","members":{"DBInstanceArn":{},"DbiResourceId":{},"Region":{},"DBInstanceIdentifier":{},"RestoreWindow":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"Engine":{},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"StorageType":{},"KmsKeyId":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"S4q":{"type":"structure","members":{"InstallationMediaId":{},"CustomAvailabilityZoneId":{},"Engine":{},"EngineVersion":{},"EngineInstallationMediaPath":{},"OSInstallationMediaPath":{},"Status":{},"FailureCause":{"type":"structure","members":{"Message":{}}}}},"S51":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S56":{"type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{},"CustomerOverride":{"type":"boolean"},"CustomerOverrideValidTill":{"type":"timestamp"}},"wrapper":true},"S5l":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{},"SupportedEngineModes":{"shape":"S5o"}}}},"S5o":{"type":"list","member":{}},"S5r":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S5u"}}}}},"wrapper":true},"S5u":{"type":"list","member":{"locationName":"AttributeValue"}},"S65":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S6y":{"type":"structure","members":{"DBProxyName":{},"TargetGroupName":{},"TargetGroupArn":{},"IsDefault":{"type":"boolean"},"Status":{},"ConnectionPoolConfig":{"type":"structure","members":{"MaxConnectionsPercent":{"type":"integer"},"MaxIdleConnectionsPercent":{"type":"integer"},"ConnectionBorrowTimeout":{"type":"integer"},"SessionPinningFilters":{"shape":"Sv"},"InitQuery":{}}},"CreatedDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"}}},"S72":{"type":"list","member":{"type":"structure","members":{"TargetArn":{},"Endpoint":{},"TrackedClusterId":{},"RdsResourceId":{},"Port":{"type":"integer"},"Type":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}},"S7d":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBSnapshotAttributes":{"type":"list","member":{"locationName":"DBSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S5u"}},"wrapper":true}}},"wrapper":true},"S7o":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S5l"}},"wrapper":true},"S8x":{"type":"list","member":{"locationName":"AvailableProcessorFeature","type":"structure","members":{"Name":{},"DefaultValue":{},"AllowedValues":{}}}},"S95":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S97"},"ReservedDBInstanceArn":{},"LeaseId":{}},"wrapper":true},"S97":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S9m":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"Sa2":{"type":"structure","members":{"EnableLogTypes":{"shape":"S1w"},"DisableLogTypes":{"shape":"S1w"}}},"Sa6":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"Sac":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Certificates"},"DescribeCustomAvailabilityZones":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CustomAvailabilityZones"},"DescribeDBClusterBacktracks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterBacktracks"},"DescribeDBClusterEndpoints":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterEndpoints"},"DescribeDBClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterParameterGroups"},"DescribeDBClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterSnapshots"},"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstanceAutomatedBackups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstanceAutomatedBackups"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBProxies":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBProxies"},"DescribeDBProxyTargetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TargetGroups"},"DescribeDBProxyTargets":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Targets"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeExportTasks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ExportTasks"},"DescribeGlobalClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalClusters"},"DescribeInstallationMedia":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"InstallationMedia"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribePendingMaintenanceActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"PendingMaintenanceActions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DescribeSourceRegions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SourceRegions"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBInstances) == `0`"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBSnapshotAvailable":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBSnapshotDeleted":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBSnapshots) == `0`"},{"expected":"DBSnapshotNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBClusterSnapshotAvailable":{"delay":30,"operation":"DescribeDBClusterSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBClusterSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"}]},"DBClusterSnapshotDeleted":{"delay":30,"operation":"DescribeDBClusterSnapshots","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBClusterSnapshots) == `0`"},{"expected":"DBClusterSnapshotNotFoundFault","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"}]}}}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-12-01","endpointPrefix":"redshift","protocol":"query","serviceFullName":"Amazon Redshift","serviceId":"Redshift","signatureVersion":"v4","uid":"redshift-2012-12-01","xmlNamespace":"http://redshift.amazonaws.com/doc/2012-12-01/"},"operations":{"AcceptReservedNodeExchange":{"input":{"type":"structure","required":["ReservedNodeId","TargetReservedNodeOfferingId"],"members":{"ReservedNodeId":{},"TargetReservedNodeOfferingId":{}}},"output":{"resultWrapper":"AcceptReservedNodeExchangeResult","type":"structure","members":{"ExchangedReservedNode":{"shape":"S4"}}}},"AuthorizeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sd"}}}},"AuthorizeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"AuthorizeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"BatchDeleteClusterSnapshots":{"input":{"type":"structure","required":["Identifiers"],"members":{"Identifiers":{"type":"list","member":{"shape":"Sv","locationName":"DeleteClusterSnapshotMessage"}}}},"output":{"resultWrapper":"BatchDeleteClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"Sx"},"Errors":{"type":"list","member":{"shape":"Sz","locationName":"SnapshotErrorMessage"}}}}},"BatchModifyClusterSnapshots":{"input":{"type":"structure","required":["SnapshotIdentifierList"],"members":{"SnapshotIdentifierList":{"shape":"Sx"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"BatchModifyClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"Sx"},"Errors":{"type":"list","member":{"shape":"Sz","locationName":"SnapshotErrorMessage"}}}}},"CancelResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S14","resultWrapper":"CancelResizeResult"}},"CopyClusterSnapshot":{"input":{"type":"structure","required":["SourceSnapshotIdentifier","TargetSnapshotIdentifier"],"members":{"SourceSnapshotIdentifier":{},"SourceSnapshotClusterIdentifier":{},"TargetSnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"CopyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NodeType","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"MasterUsername":{},"MasterUserPassword":{},"ClusterSecurityGroups":{"shape":"S1d"},"VpcSecurityGroupIds":{"shape":"S1e"},"ClusterSubnetGroupName":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Port":{"type":"integer"},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"Tags":{"shape":"Sg"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S1g"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{}}},"output":{"resultWrapper":"CreateClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"CreateClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterGroupFamily","Description"],"members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterParameterGroupResult","type":"structure","members":{"ClusterParameterGroup":{"shape":"S29"}}}},"CreateClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName","Description"],"members":{"ClusterSecurityGroupName":{},"Description":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterSecurityGroupResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sd"}}}},"CreateClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier","ClusterIdentifier"],"members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"CreateClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","Description","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S2f"},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S2h"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S2o"},"EventCategories":{"shape":"S2p"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S2r"}}}},"CreateHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateHsmClientCertificateResult","type":"structure","members":{"HsmClientCertificate":{"shape":"S2u"}}}},"CreateHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier","Description","HsmIpAddress","HsmPartitionName","HsmPartitionPassword","HsmServerPublicCertificate"],"members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"HsmPartitionPassword":{},"HsmServerPublicCertificate":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateHsmConfigurationResult","type":"structure","members":{"HsmConfiguration":{"shape":"S2x"}}}},"CreateScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName","TargetAction","Schedule","IamRole"],"members":{"ScheduledActionName":{},"TargetAction":{"shape":"S2z"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Enable":{"type":"boolean"}}},"output":{"shape":"S33","resultWrapper":"CreateScheduledActionResult"}},"CreateSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateSnapshotCopyGrantResult","type":"structure","members":{"SnapshotCopyGrant":{"shape":"S38"}}}},"CreateSnapshotSchedule":{"input":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S3a"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"Sg"},"DryRun":{"type":"boolean"},"NextInvocations":{"type":"integer"}}},"output":{"shape":"S3b","resultWrapper":"CreateSnapshotScheduleResult"}},"CreateTags":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sg"}}}},"CreateUsageLimit":{"input":{"type":"structure","required":["ClusterIdentifier","FeatureType","LimitType","Amount"],"members":{"ClusterIdentifier":{},"FeatureType":{},"LimitType":{},"Amount":{"type":"long"},"Period":{},"BreachAction":{},"Tags":{"shape":"Sg"}}},"output":{"shape":"S3l","resultWrapper":"CreateUsageLimitResult"}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SkipFinalClusterSnapshot":{"type":"boolean"},"FinalClusterSnapshotIdentifier":{},"FinalClusterSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"DeleteClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"DeleteClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}}},"DeleteClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{}}}},"DeleteClusterSnapshot":{"input":{"shape":"Sv"},"output":{"resultWrapper":"DeleteClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"DeleteClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName"],"members":{"ClusterSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}}},"DeleteHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{}}}},"DeleteHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier"],"members":{"HsmConfigurationIdentifier":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{}}}},"DeleteSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier"],"members":{"ScheduleIdentifier":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"shape":"S3z"}}}},"DeleteUsageLimit":{"input":{"type":"structure","required":["UsageLimitId"],"members":{"UsageLimitId":{}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"type":"list","member":{"locationName":"AttributeName"}}}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountAttributes":{"type":"list","member":{"locationName":"AccountAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"type":"list","member":{"locationName":"AttributeValueTarget","type":"structure","members":{"AttributeValue":{}}}}}}}}}},"DescribeClusterDbRevisions":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterDbRevisionsResult","type":"structure","members":{"Marker":{},"ClusterDbRevisions":{"type":"list","member":{"locationName":"ClusterDbRevision","type":"structure","members":{"ClusterIdentifier":{},"CurrentDatabaseRevision":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"},"RevisionTargets":{"type":"list","member":{"locationName":"RevisionTarget","type":"structure","members":{"DatabaseRevision":{},"Description":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"}}}}}}}}}},"DescribeClusterParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"ParameterGroups":{"type":"list","member":{"shape":"S29","locationName":"ClusterParameterGroup"}}}}},"DescribeClusterParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S4k"},"Marker":{}}}},"DescribeClusterSecurityGroups":{"input":{"type":"structure","members":{"ClusterSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeClusterSecurityGroupsResult","type":"structure","members":{"Marker":{},"ClusterSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"ClusterSecurityGroup"}}}}},"DescribeClusterSnapshots":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"Marker":{},"OwnerAccount":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"},"ClusterExists":{"type":"boolean"},"SortingEntities":{"type":"list","member":{"locationName":"SnapshotSortingEntity","type":"structure","required":["Attribute"],"members":{"Attribute":{},"SortOrder":{}}}}}},"output":{"resultWrapper":"DescribeClusterSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sm","locationName":"Snapshot"}}}}},"DescribeClusterSubnetGroups":{"input":{"type":"structure","members":{"ClusterSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeClusterSubnetGroupsResult","type":"structure","members":{"Marker":{},"ClusterSubnetGroups":{"type":"list","member":{"shape":"S2h","locationName":"ClusterSubnetGroup"}}}}},"DescribeClusterTracks":{"input":{"type":"structure","members":{"MaintenanceTrackName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterTracksResult","type":"structure","members":{"MaintenanceTracks":{"type":"list","member":{"locationName":"MaintenanceTrack","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"UpdateTargets":{"type":"list","member":{"locationName":"UpdateTarget","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"SupportedOperations":{"type":"list","member":{"locationName":"SupportedOperation","type":"structure","members":{"OperationName":{}}}}}}}}}},"Marker":{}}}},"DescribeClusterVersions":{"input":{"type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterVersionsResult","type":"structure","members":{"Marker":{},"ClusterVersions":{"type":"list","member":{"locationName":"ClusterVersion","type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"Description":{}}}}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeClustersResult","type":"structure","members":{"Marker":{},"Clusters":{"type":"list","member":{"shape":"S1i","locationName":"Cluster"}}}}},"DescribeDefaultClusterParameters":{"input":{"type":"structure","required":["ParameterGroupFamily"],"members":{"ParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDefaultClusterParametersResult","type":"structure","members":{"DefaultClusterParameters":{"type":"structure","members":{"ParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S4k"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"Events":{"type":"list","member":{"locationName":"EventInfoMap","type":"structure","members":{"EventId":{},"EventCategories":{"shape":"S2p"},"EventDescription":{},"Severity":{}},"wrapper":true}}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S2r","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S2p"},"Severity":{},"Date":{"type":"timestamp"},"EventId":{}}}}}}},"DescribeHsmClientCertificates":{"input":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeHsmClientCertificatesResult","type":"structure","members":{"Marker":{},"HsmClientCertificates":{"type":"list","member":{"shape":"S2u","locationName":"HsmClientCertificate"}}}}},"DescribeHsmConfigurations":{"input":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeHsmConfigurationsResult","type":"structure","members":{"Marker":{},"HsmConfigurations":{"type":"list","member":{"shape":"S2x","locationName":"HsmConfiguration"}}}}},"DescribeLoggingStatus":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S63","resultWrapper":"DescribeLoggingStatusResult"}},"DescribeNodeConfigurationOptions":{"input":{"type":"structure","required":["ActionType"],"members":{"ActionType":{},"ClusterIdentifier":{},"SnapshotIdentifier":{},"OwnerAccount":{},"Filters":{"locationName":"Filter","type":"list","member":{"locationName":"NodeConfigurationOptionsFilter","type":"structure","members":{"Name":{},"Operator":{},"Values":{"shape":"S6a","locationName":"Value"}}}},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNodeConfigurationOptionsResult","type":"structure","members":{"NodeConfigurationOptionList":{"type":"list","member":{"locationName":"NodeConfigurationOption","type":"structure","members":{"NodeType":{},"NumberOfNodes":{"type":"integer"},"EstimatedDiskUtilizationPercent":{"type":"double"},"Mode":{}}}},"Marker":{}}}},"DescribeOrderableClusterOptions":{"input":{"type":"structure","members":{"ClusterVersion":{},"NodeType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableClusterOptionsResult","type":"structure","members":{"OrderableClusterOptions":{"type":"list","member":{"locationName":"OrderableClusterOption","type":"structure","members":{"ClusterVersion":{},"ClusterType":{},"NodeType":{},"AvailabilityZones":{"type":"list","member":{"shape":"S2k","locationName":"AvailabilityZone"}}},"wrapper":true}},"Marker":{}}}},"DescribeReservedNodeOfferings":{"input":{"type":"structure","members":{"ReservedNodeOfferingId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S6m"}}}},"DescribeReservedNodes":{"input":{"type":"structure","members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodesResult","type":"structure","members":{"Marker":{},"ReservedNodes":{"type":"list","member":{"shape":"S4","locationName":"ReservedNode"}}}}},"DescribeResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S14","resultWrapper":"DescribeResizeResult"}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"ScheduledActionName":{},"TargetActionType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Filters":{"type":"list","member":{"locationName":"ScheduledActionFilter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S6a"}}}},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"Marker":{},"ScheduledActions":{"type":"list","member":{"shape":"S33","locationName":"ScheduledAction"}}}}},"DescribeSnapshotCopyGrants":{"input":{"type":"structure","members":{"SnapshotCopyGrantName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeSnapshotCopyGrantsResult","type":"structure","members":{"Marker":{},"SnapshotCopyGrants":{"type":"list","member":{"shape":"S38","locationName":"SnapshotCopyGrant"}}}}},"DescribeSnapshotSchedules":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSnapshotSchedulesResult","type":"structure","members":{"SnapshotSchedules":{"type":"list","member":{"shape":"S3b","locationName":"SnapshotSchedule"}},"Marker":{}}}},"DescribeStorage":{"output":{"resultWrapper":"DescribeStorageResult","type":"structure","members":{"TotalBackupSizeInMegaBytes":{"type":"double"},"TotalProvisionedStorageInMegaBytes":{"type":"double"}}}},"DescribeTableRestoreStatus":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"TableRestoreRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeTableRestoreStatusResult","type":"structure","members":{"TableRestoreStatusDetails":{"type":"list","member":{"shape":"S79","locationName":"TableRestoreStatus"}},"Marker":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"ResourceName":{},"ResourceType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TaggedResources":{"type":"list","member":{"locationName":"TaggedResource","type":"structure","members":{"Tag":{"shape":"Sh"},"ResourceName":{},"ResourceType":{}}}},"Marker":{}}}},"DescribeUsageLimits":{"input":{"type":"structure","members":{"UsageLimitId":{},"ClusterIdentifier":{},"FeatureType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3z"},"TagValues":{"shape":"S4f"}}},"output":{"resultWrapper":"DescribeUsageLimitsResult","type":"structure","members":{"UsageLimits":{"type":"list","member":{"shape":"S3l"}},"Marker":{}}}},"DisableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S63","resultWrapper":"DisableLoggingResult"}},"DisableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DisableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"EnableLogging":{"input":{"type":"structure","required":["ClusterIdentifier","BucketName"],"members":{"ClusterIdentifier":{},"BucketName":{},"S3KeyPrefix":{}}},"output":{"shape":"S63","resultWrapper":"EnableLoggingResult"}},"EnableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier","DestinationRegion"],"members":{"ClusterIdentifier":{},"DestinationRegion":{},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"EnableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"GetClusterCredentials":{"input":{"type":"structure","required":["DbUser","ClusterIdentifier"],"members":{"DbUser":{},"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"AutoCreate":{"type":"boolean"},"DbGroups":{"type":"list","member":{"locationName":"DbGroup"}}}},"output":{"resultWrapper":"GetClusterCredentialsResult","type":"structure","members":{"DbUser":{},"DbPassword":{"type":"string","sensitive":true},"Expiration":{"type":"timestamp"}}}},"GetReservedNodeExchangeOfferings":{"input":{"type":"structure","required":["ReservedNodeId"],"members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetReservedNodeExchangeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S6m"}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterSecurityGroups":{"shape":"S1d"},"VpcSecurityGroupIds":{"shape":"S1e"},"MasterUserPassword":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"PreferredMaintenanceWindow":{},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"NewClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"ElasticIp":{},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{}}},"output":{"resultWrapper":"ModifyClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterDbRevision":{"input":{"type":"structure","required":["ClusterIdentifier","RevisionTarget"],"members":{"ClusterIdentifier":{},"RevisionTarget":{}}},"output":{"resultWrapper":"ModifyClusterDbRevisionResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterIamRoles":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AddIamRoles":{"shape":"S1g"},"RemoveIamRoles":{"shape":"S1g"}}},"output":{"resultWrapper":"ModifyClusterIamRolesResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterMaintenance":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"DeferMaintenance":{"type":"boolean"},"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"},"DeferMaintenanceDuration":{"type":"integer"}}},"output":{"resultWrapper":"ModifyClusterMaintenanceResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Parameters"],"members":{"ParameterGroupName":{},"Parameters":{"shape":"S4k"}}},"output":{"shape":"S83","resultWrapper":"ModifyClusterParameterGroupResult"}},"ModifyClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"ModifyClusterSnapshotSchedule":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"DisassociateSchedule":{"type":"boolean"}}}},"ModifyClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S2f"}}},"output":{"resultWrapper":"ModifyClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S2h"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S2o"},"EventCategories":{"shape":"S2p"},"Severity":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S2r"}}}},"ModifyScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"TargetAction":{"shape":"S2z"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Enable":{"type":"boolean"}}},"output":{"shape":"S33","resultWrapper":"ModifyScheduledActionResult"}},"ModifySnapshotCopyRetentionPeriod":{"input":{"type":"structure","required":["ClusterIdentifier","RetentionPeriod"],"members":{"ClusterIdentifier":{},"RetentionPeriod":{"type":"integer"},"Manual":{"type":"boolean"}}},"output":{"resultWrapper":"ModifySnapshotCopyRetentionPeriodResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifySnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier","ScheduleDefinitions"],"members":{"ScheduleIdentifier":{},"ScheduleDefinitions":{"shape":"S3a"}}},"output":{"shape":"S3b","resultWrapper":"ModifySnapshotScheduleResult"}},"ModifyUsageLimit":{"input":{"type":"structure","required":["UsageLimitId"],"members":{"UsageLimitId":{},"Amount":{"type":"long"},"BreachAction":{}}},"output":{"shape":"S3l","resultWrapper":"ModifyUsageLimitResult"}},"PauseCluster":{"input":{"shape":"S31"},"output":{"resultWrapper":"PauseClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"PurchaseReservedNodeOffering":{"input":{"type":"structure","required":["ReservedNodeOfferingId"],"members":{"ReservedNodeOfferingId":{},"NodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedNodeOfferingResult","type":"structure","members":{"ReservedNode":{"shape":"S4"}}}},"RebootCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RebootClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ResetClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S4k"}}},"output":{"shape":"S83","resultWrapper":"ResetClusterParameterGroupResult"}},"ResizeCluster":{"input":{"shape":"S30"},"output":{"resultWrapper":"ResizeClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"RestoreFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"Port":{"type":"integer"},"AvailabilityZone":{},"AllowVersionUpgrade":{"type":"boolean"},"ClusterSubnetGroupName":{},"PubliclyAccessible":{"type":"boolean"},"OwnerAccount":{},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"ClusterParameterGroupName":{},"ClusterSecurityGroups":{"shape":"S1d"},"VpcSecurityGroupIds":{"shape":"S1e"},"PreferredMaintenanceWindow":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"NodeType":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S1g"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{},"NumberOfNodes":{"type":"integer"}}},"output":{"resultWrapper":"RestoreFromClusterSnapshotResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"RestoreTableFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier","SourceDatabaseName","SourceTableName","NewTableName"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}}},"output":{"resultWrapper":"RestoreTableFromClusterSnapshotResult","type":"structure","members":{"TableRestoreStatus":{"shape":"S79"}}}},"ResumeCluster":{"input":{"shape":"S32"},"output":{"resultWrapper":"ResumeClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"RevokeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sd"}}}},"RevokeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"RevokeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"RotateEncryptionKey":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RotateEncryptionKeyResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}}},"shapes":{"S4":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeOfferingId":{},"NodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"NodeCount":{"type":"integer"},"State":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true},"S8":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"Sd":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{},"Tags":{"shape":"Sg"}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{},"Tags":{"shape":"Sg"}}}},"Tags":{"shape":"Sg"}},"wrapper":true},"Sg":{"type":"list","member":{"shape":"Sh","locationName":"Tag"}},"Sh":{"type":"structure","members":{"Key":{},"Value":{}}},"Sm":{"type":"structure","members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"ClusterVersion":{},"SnapshotType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"DBName":{},"VpcId":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"EncryptedWithHSM":{"type":"boolean"},"AccountsWithRestoreAccess":{"type":"list","member":{"locationName":"AccountWithRestoreAccess","type":"structure","members":{"AccountId":{},"AccountAlias":{}}}},"OwnerAccount":{},"TotalBackupSizeInMegaBytes":{"type":"double"},"ActualIncrementalBackupSizeInMegaBytes":{"type":"double"},"BackupProgressInMegaBytes":{"type":"double"},"CurrentBackupRateInMegaBytesPerSecond":{"type":"double"},"EstimatedSecondsToCompletion":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"SourceRegion":{},"Tags":{"shape":"Sg"},"RestorableNodeTypes":{"type":"list","member":{"locationName":"NodeType"}},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRemainingDays":{"type":"integer"},"SnapshotRetentionStartTime":{"type":"timestamp"}},"wrapper":true},"Sv":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{}}},"Sx":{"type":"list","member":{"locationName":"String"}},"Sz":{"type":"structure","members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"FailureCode":{},"FailureReason":{}}},"S14":{"type":"structure","members":{"TargetNodeType":{},"TargetNumberOfNodes":{"type":"integer"},"TargetClusterType":{},"Status":{},"ImportTablesCompleted":{"type":"list","member":{}},"ImportTablesInProgress":{"type":"list","member":{}},"ImportTablesNotStarted":{"type":"list","member":{}},"AvgResizeRateInMegaBytesPerSecond":{"type":"double"},"TotalResizeDataInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ResizeType":{},"Message":{},"TargetEncryptionType":{},"DataTransferProgressPercent":{"type":"double"}}},"S1d":{"type":"list","member":{"locationName":"ClusterSecurityGroupName"}},"S1e":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1g":{"type":"list","member":{"locationName":"IamRoleArn"}},"S1i":{"type":"structure","members":{"ClusterIdentifier":{},"NodeType":{},"ClusterStatus":{},"ClusterAvailabilityStatus":{},"ModifyStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"ClusterCreateTime":{"type":"timestamp"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ClusterSecurityGroups":{"type":"list","member":{"locationName":"ClusterSecurityGroup","type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"type":"list","member":{"locationName":"VpcSecurityGroup","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"ClusterParameterGroups":{"type":"list","member":{"locationName":"ClusterParameterGroup","type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}}}}},"ClusterSubnetGroupName":{},"VpcId":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterType":{},"ClusterVersion":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"EncryptionType":{}}},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"RestoreStatus":{"type":"structure","members":{"Status":{},"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"SnapshotSizeInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}},"DataTransferProgress":{"type":"structure","members":{"Status":{},"CurrentRateInMegaBytesPerSecond":{"type":"double"},"TotalDataInMegaBytes":{"type":"long"},"DataTransferredInMegaBytes":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"}}},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"RetentionPeriod":{"type":"long"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"ClusterPublicKey":{},"ClusterNodes":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIPAddress":{},"PublicIPAddress":{}}}},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ClusterRevisionNumber":{},"Tags":{"shape":"Sg"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"IamRoles":{"type":"list","member":{"locationName":"ClusterIamRole","type":"structure","members":{"IamRoleArn":{},"ApplyStatus":{}}}},"PendingActions":{"type":"list","member":{}},"MaintenanceTrackName":{},"ElasticResizeNumberOfNodeOptions":{},"DeferredMaintenanceWindows":{"type":"list","member":{"locationName":"DeferredMaintenanceWindow","type":"structure","members":{"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"}}}},"SnapshotScheduleIdentifier":{},"SnapshotScheduleState":{},"ExpectedNextSnapshotScheduleTime":{"type":"timestamp"},"ExpectedNextSnapshotScheduleTimeStatus":{},"NextMaintenanceWindowStartTime":{"type":"timestamp"},"ResizeInfo":{"type":"structure","members":{"ResizeType":{},"AllowCancelResize":{"type":"boolean"}}}},"wrapper":true},"S29":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S2f":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2h":{"type":"structure","members":{"ClusterSubnetGroupName":{},"Description":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S2k"},"SubnetStatus":{}}}},"Tags":{"shape":"Sg"}},"wrapper":true},"S2k":{"type":"structure","members":{"Name":{},"SupportedPlatforms":{"type":"list","member":{"locationName":"SupportedPlatform","type":"structure","members":{"Name":{}},"wrapper":true}}},"wrapper":true},"S2o":{"type":"list","member":{"locationName":"SourceId"}},"S2p":{"type":"list","member":{"locationName":"EventCategory"}},"S2r":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{"type":"timestamp"},"SourceType":{},"SourceIdsList":{"shape":"S2o"},"EventCategoriesList":{"shape":"S2p"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sg"}},"wrapper":true},"S2u":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmClientCertificatePublicKey":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S2x":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S2z":{"type":"structure","members":{"ResizeCluster":{"shape":"S30"},"PauseCluster":{"shape":"S31"},"ResumeCluster":{"shape":"S32"}}},"S30":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"Classic":{"type":"boolean"}}},"S31":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"S32":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"S33":{"type":"structure","members":{"ScheduledActionName":{},"TargetAction":{"shape":"S2z"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"State":{},"NextInvocations":{"type":"list","member":{"locationName":"ScheduledActionTime","type":"timestamp"}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S38":{"type":"structure","members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S3a":{"type":"list","member":{"locationName":"ScheduleDefinition"}},"S3b":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S3a"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"Sg"},"NextInvocations":{"type":"list","member":{"locationName":"SnapshotTime","type":"timestamp"}},"AssociatedClusterCount":{"type":"integer"},"AssociatedClusters":{"type":"list","member":{"locationName":"ClusterAssociatedToSchedule","type":"structure","members":{"ClusterIdentifier":{},"ScheduleAssociationState":{}}}}}},"S3l":{"type":"structure","members":{"UsageLimitId":{},"ClusterIdentifier":{},"FeatureType":{},"LimitType":{},"Amount":{"type":"long"},"Period":{},"BreachAction":{},"Tags":{"shape":"Sg"}}},"S3z":{"type":"list","member":{"locationName":"TagKey"}},"S4f":{"type":"list","member":{"locationName":"TagValue"}},"S4k":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"ApplyType":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{}}}},"S63":{"type":"structure","members":{"LoggingEnabled":{"type":"boolean"},"BucketName":{},"S3KeyPrefix":{},"LastSuccessfulDeliveryTime":{"type":"timestamp"},"LastFailureTime":{"type":"timestamp"},"LastFailureMessage":{}}},"S6a":{"type":"list","member":{"locationName":"item"}},"S6m":{"type":"list","member":{"locationName":"ReservedNodeOffering","type":"structure","members":{"ReservedNodeOfferingId":{},"NodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true}},"S79":{"type":"structure","members":{"TableRestoreRequestId":{},"Status":{},"Message":{},"RequestTime":{"type":"timestamp"},"ProgressInMegaBytes":{"type":"long"},"TotalDataInMegaBytes":{"type":"long"},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}},"wrapper":true},"S83":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupStatus":{}}}}}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ParameterGroups"},"DescribeClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeClusterSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSecurityGroups"},"DescribeClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeClusterSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSubnetGroups"},"DescribeClusterVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterVersions"},"DescribeClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Clusters"},"DescribeDefaultClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"DefaultClusterParameters.Marker","result_key":"DefaultClusterParameters.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeHsmClientCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmClientCertificates"},"DescribeHsmConfigurations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmConfigurations"},"DescribeNodeConfigurationOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"NodeConfigurationOptionList"},"DescribeOrderableClusterOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableClusterOptions"},"DescribeReservedNodeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"DescribeReservedNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodes"},"DescribeScheduledActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ScheduledActions"},"DescribeUsageLimits":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UsageLimits"}}}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterAvailable":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Clusters[].ClusterStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"ClusterNotFound","matcher":"error","state":"retry"}]},"ClusterDeleted":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"ClusterNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"}]},"ClusterRestored":{"operation":"DescribeClusters","maxAttempts":30,"delay":60,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Clusters[].RestoreStatus.Status","expected":"completed"},{"state":"failure","matcher":"pathAny","argument":"Clusters[].ClusterStatus","expected":"deleting"}]},"SnapshotAvailable":{"delay":15,"operation":"DescribeClusterSnapshots","maxAttempts":20,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Snapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"}]}}}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-27","endpointPrefix":"rekognition","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Rekognition","serviceId":"Rekognition","signatureVersion":"v4","targetPrefix":"RekognitionService","uid":"rekognition-2016-06-27"},"operations":{"CompareFaces":{"input":{"type":"structure","required":["SourceImage","TargetImage"],"members":{"SourceImage":{"shape":"S2"},"TargetImage":{"shape":"S2"},"SimilarityThreshold":{"type":"float"},"QualityFilter":{}}},"output":{"type":"structure","members":{"SourceImageFace":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"}}},"FaceMatches":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"Sg"}}}},"UnmatchedFaces":{"type":"list","member":{"shape":"Sg"}},"SourceImageOrientationCorrection":{},"TargetImageOrientationCorrection":{}}}},"CreateCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"},"CollectionArn":{},"FaceModelVersion":{}}}},"CreateProject":{"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{}}},"output":{"type":"structure","members":{"ProjectArn":{}}}},"CreateProjectVersion":{"input":{"type":"structure","required":["ProjectArn","VersionName","OutputConfig","TrainingData","TestingData"],"members":{"ProjectArn":{},"VersionName":{},"OutputConfig":{"shape":"S10"},"TrainingData":{"shape":"S12"},"TestingData":{"shape":"S16"}}},"output":{"type":"structure","members":{"ProjectVersionArn":{}}}},"CreateStreamProcessor":{"input":{"type":"structure","required":["Input","Output","Name","Settings","RoleArn"],"members":{"Input":{"shape":"S1b"},"Output":{"shape":"S1e"},"Name":{},"Settings":{"shape":"S1i"},"RoleArn":{}}},"output":{"type":"structure","members":{"StreamProcessorArn":{}}}},"DeleteCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"}}}},"DeleteFaces":{"input":{"type":"structure","required":["CollectionId","FaceIds"],"members":{"CollectionId":{},"FaceIds":{"shape":"S1q"}}},"output":{"type":"structure","members":{"DeletedFaces":{"shape":"S1q"}}}},"DeleteProject":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DeleteProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn"],"members":{"ProjectVersionArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DeleteStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"FaceCount":{"type":"long"},"FaceModelVersion":{},"CollectionARN":{},"CreationTimestamp":{"type":"timestamp"}}}},"DescribeProjectVersions":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{},"VersionNames":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProjectVersionDescriptions":{"type":"list","member":{"type":"structure","members":{"ProjectVersionArn":{},"CreationTimestamp":{"type":"timestamp"},"MinInferenceUnits":{"type":"integer"},"Status":{},"StatusMessage":{},"BillableTrainingTimeInSeconds":{"type":"long"},"TrainingEndTimestamp":{"type":"timestamp"},"OutputConfig":{"shape":"S10"},"TrainingDataResult":{"type":"structure","members":{"Input":{"shape":"S12"},"Output":{"shape":"S12"}}},"TestingDataResult":{"type":"structure","members":{"Input":{"shape":"S16"},"Output":{"shape":"S16"}}},"EvaluationResult":{"type":"structure","members":{"F1Score":{"type":"float"},"Summary":{"type":"structure","members":{"S3Object":{"shape":"S4"}}}}}}}},"NextToken":{}}}},"DescribeProjects":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProjectDescriptions":{"type":"list","member":{"type":"structure","members":{"ProjectArn":{},"CreationTimestamp":{"type":"timestamp"},"Status":{}}}},"NextToken":{}}}},"DescribeStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"StreamProcessorArn":{},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Input":{"shape":"S1b"},"Output":{"shape":"S1e"},"RoleArn":{},"Settings":{"shape":"S1i"}}}},"DetectCustomLabels":{"input":{"type":"structure","required":["ProjectVersionArn","Image"],"members":{"ProjectVersionArn":{},"Image":{"shape":"S2"},"MaxResults":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"CustomLabels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Geometry":{"shape":"S2u"}}}}}}},"DetectFaces":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Attributes":{"shape":"S2y"}}},"output":{"type":"structure","members":{"FaceDetails":{"type":"list","member":{"shape":"S32"}},"OrientationCorrection":{}}}},"DetectLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MaxLabels":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"shape":"S3j"}},"OrientationCorrection":{},"LabelModelVersion":{}}}},"DetectModerationLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MinConfidence":{"type":"float"},"HumanLoopConfig":{"type":"structure","required":["HumanLoopName","FlowDefinitionArn"],"members":{"HumanLoopName":{},"FlowDefinitionArn":{},"DataAttributes":{"type":"structure","members":{"ContentClassifiers":{"type":"list","member":{}}}}}}}},"output":{"type":"structure","members":{"ModerationLabels":{"type":"list","member":{"shape":"S3x"}},"ModerationModelVersion":{},"HumanLoopActivationOutput":{"type":"structure","members":{"HumanLoopArn":{},"HumanLoopActivationReasons":{"type":"list","member":{}},"HumanLoopActivationConditionsEvaluationResults":{"jsonvalue":true}}}}}},"DetectText":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Filters":{"type":"structure","members":{"WordFilter":{"shape":"S45"},"RegionsOfInterest":{"shape":"S48"}}}}},"output":{"type":"structure","members":{"TextDetections":{"type":"list","member":{"shape":"S4c"}},"TextModelVersion":{}}}},"GetCelebrityInfo":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Urls":{"shape":"S4h"},"Name":{}}}},"GetCelebrityRecognition":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S4q"},"NextToken":{},"Celebrities":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Celebrity":{"type":"structure","members":{"Urls":{"shape":"S4h"},"Name":{},"Id":{},"Confidence":{"type":"float"},"BoundingBox":{"shape":"Sc"},"Face":{"shape":"S32"}}}}}}}}},"GetContentModeration":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S4q"},"ModerationLabels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"ModerationLabel":{"shape":"S3x"}}}},"NextToken":{},"ModerationModelVersion":{}}}},"GetFaceDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S4q"},"NextToken":{},"Faces":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Face":{"shape":"S32"}}}}}}},"GetFaceSearch":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"NextToken":{},"VideoMetadata":{"shape":"S4q"},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S59"},"FaceMatches":{"shape":"S5b"}}}}}}},"GetLabelDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S4q"},"NextToken":{},"Labels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Label":{"shape":"S3j"}}}},"LabelModelVersion":{}}}},"GetPersonTracking":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S4q"},"NextToken":{},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S59"}}}}}}},"GetSegmentDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"type":"list","member":{"shape":"S4q"}},"AudioMetadata":{"type":"list","member":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"SampleRate":{"type":"long"},"NumberOfChannels":{"type":"long"}}}},"NextToken":{},"Segments":{"type":"list","member":{"type":"structure","members":{"Type":{},"StartTimestampMillis":{"type":"long"},"EndTimestampMillis":{"type":"long"},"DurationMillis":{"type":"long"},"StartTimecodeSMPTE":{},"EndTimecodeSMPTE":{},"DurationSMPTE":{},"TechnicalCueSegment":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}},"ShotSegment":{"type":"structure","members":{"Index":{"type":"long"},"Confidence":{"type":"float"}}}}}},"SelectedSegmentTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ModelVersion":{}}}}}}},"GetTextDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S4q"},"TextDetections":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"TextDetection":{"shape":"S4c"}}}},"NextToken":{},"TextModelVersion":{}}}},"IndexFaces":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"ExternalImageId":{},"DetectionAttributes":{"shape":"S2y"},"MaxFaces":{"type":"integer"},"QualityFilter":{}}},"output":{"type":"structure","members":{"FaceRecords":{"type":"list","member":{"type":"structure","members":{"Face":{"shape":"S5d"},"FaceDetail":{"shape":"S32"}}}},"OrientationCorrection":{},"FaceModelVersion":{},"UnindexedFaces":{"type":"list","member":{"type":"structure","members":{"Reasons":{"type":"list","member":{}},"FaceDetail":{"shape":"S32"}}}}}}},"ListCollections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CollectionIds":{"type":"list","member":{}},"NextToken":{},"FaceModelVersions":{"type":"list","member":{}}}}},"ListFaces":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Faces":{"type":"list","member":{"shape":"S5d"}},"NextToken":{},"FaceModelVersion":{}}}},"ListStreamProcessors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"StreamProcessors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{}}}}}}},"RecognizeCelebrities":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"CelebrityFaces":{"type":"list","member":{"type":"structure","members":{"Urls":{"shape":"S4h"},"Name":{},"Id":{},"Face":{"shape":"Sg"},"MatchConfidence":{"type":"float"}}}},"UnrecognizedFaces":{"type":"list","member":{"shape":"Sg"}},"OrientationCorrection":{}}}},"SearchFaces":{"input":{"type":"structure","required":["CollectionId","FaceId"],"members":{"CollectionId":{},"FaceId":{},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceId":{},"FaceMatches":{"shape":"S5b"},"FaceModelVersion":{}}}},"SearchFacesByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"},"QualityFilter":{}}},"output":{"type":"structure","members":{"SearchedFaceBoundingBox":{"shape":"Sc"},"SearchedFaceConfidence":{"type":"float"},"FaceMatches":{"shape":"S5b"},"FaceModelVersion":{}}}},"StartCelebrityRecognition":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S77"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartContentModeration":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S75"},"MinConfidence":{"type":"float"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S77"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S77"},"FaceAttributes":{},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceSearch":{"input":{"type":"structure","required":["Video","CollectionId"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"FaceMatchThreshold":{"type":"float"},"CollectionId":{},"NotificationChannel":{"shape":"S77"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartLabelDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"MinConfidence":{"type":"float"},"NotificationChannel":{"shape":"S77"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartPersonTracking":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S77"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn","MinInferenceUnits"],"members":{"ProjectVersionArn":{},"MinInferenceUnits":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{}}}},"StartSegmentDetection":{"input":{"type":"structure","required":["Video","SegmentTypes"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S77"},"JobTag":{},"Filters":{"type":"structure","members":{"TechnicalCueFilter":{"type":"structure","members":{"MinSegmentConfidence":{"type":"float"}}},"ShotFilter":{"type":"structure","members":{"MinSegmentConfidence":{"type":"float"}}}}},"SegmentTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StartTextDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S75"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S77"},"JobTag":{},"Filters":{"type":"structure","members":{"WordFilter":{"shape":"S45"},"RegionsOfInterest":{"shape":"S48"}}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StopProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn"],"members":{"ProjectVersionArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"StopStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"S4"}}},"S4":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"Sc":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Sg":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"},"Landmarks":{"shape":"Sh"},"Pose":{"shape":"Sk"},"Quality":{"shape":"Sm"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Type":{},"X":{"type":"float"},"Y":{"type":"float"}}}},"Sk":{"type":"structure","members":{"Roll":{"type":"float"},"Yaw":{"type":"float"},"Pitch":{"type":"float"}}},"Sm":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"}}},"S10":{"type":"structure","members":{"S3Bucket":{},"S3KeyPrefix":{}}},"S12":{"type":"structure","members":{"Assets":{"shape":"S13"}}},"S13":{"type":"list","member":{"type":"structure","members":{"GroundTruthManifest":{"type":"structure","members":{"S3Object":{"shape":"S4"}}}}}},"S16":{"type":"structure","members":{"Assets":{"shape":"S13"},"AutoCreate":{"type":"boolean"}}},"S1b":{"type":"structure","members":{"KinesisVideoStream":{"type":"structure","members":{"Arn":{}}}}},"S1e":{"type":"structure","members":{"KinesisDataStream":{"type":"structure","members":{"Arn":{}}}}},"S1i":{"type":"structure","members":{"FaceSearch":{"type":"structure","members":{"CollectionId":{},"FaceMatchThreshold":{"type":"float"}}}}},"S1q":{"type":"list","member":{}},"S2u":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Polygon":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}}}},"S2y":{"type":"list","member":{}},"S32":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"AgeRange":{"type":"structure","members":{"Low":{"type":"integer"},"High":{"type":"integer"}}},"Smile":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Eyeglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sunglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Gender":{"type":"structure","members":{"Value":{},"Confidence":{"type":"float"}}},"Beard":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Mustache":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyesOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"MouthOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Emotions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}}},"Landmarks":{"shape":"Sh"},"Pose":{"shape":"Sk"},"Quality":{"shape":"Sm"},"Confidence":{"type":"float"}}},"S3j":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Instances":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"}}}},"Parents":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}},"S3x":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{},"ParentName":{}}},"S45":{"type":"structure","members":{"MinConfidence":{"type":"float"},"MinBoundingBoxHeight":{"type":"float"},"MinBoundingBoxWidth":{"type":"float"}}},"S48":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"}}}},"S4c":{"type":"structure","members":{"DetectedText":{},"Type":{},"Id":{"type":"integer"},"ParentId":{"type":"integer"},"Confidence":{"type":"float"},"Geometry":{"shape":"S2u"}}},"S4h":{"type":"list","member":{}},"S4q":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"Format":{},"FrameRate":{"type":"float"},"FrameHeight":{"type":"long"},"FrameWidth":{"type":"long"}}},"S59":{"type":"structure","members":{"Index":{"type":"long"},"BoundingBox":{"shape":"Sc"},"Face":{"shape":"S32"}}},"S5b":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"S5d"}}}},"S5d":{"type":"structure","members":{"FaceId":{},"BoundingBox":{"shape":"Sc"},"ImageId":{},"ExternalImageId":{},"Confidence":{"type":"float"}}},"S75":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S77":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}}}}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeProjectVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectVersionDescriptions"},"DescribeProjects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectDescriptions"},"GetCelebrityRecognition":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetContentModeration":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceSearch":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetLabelDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPersonTracking":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetSegmentDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTextDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CollectionIds"},"ListFaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Faces"},"ListStreamProcessors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ProjectVersionTrainingCompleted":{"description":"Wait until the ProjectVersion training completes.","operation":"DescribeProjectVersions","delay":120,"maxAttempts":360,"acceptors":[{"state":"success","matcher":"pathAll","argument":"ProjectVersionDescriptions[].Status","expected":"TRAINING_COMPLETED"},{"state":"failure","matcher":"pathAny","argument":"ProjectVersionDescriptions[].Status","expected":"TRAINING_FAILED"}]},"ProjectVersionRunning":{"description":"Wait until the ProjectVersion is running.","delay":30,"maxAttempts":40,"operation":"DescribeProjectVersions","acceptors":[{"state":"success","matcher":"pathAll","argument":"ProjectVersionDescriptions[].Status","expected":"RUNNING"},{"state":"failure","matcher":"pathAny","argument":"ProjectVersionDescriptions[].Status","expected":"FAILED"}]}}}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"resource-groups","protocol":"rest-json","serviceAbbreviation":"Resource Groups","serviceFullName":"AWS Resource Groups","serviceId":"Resource Groups","signatureVersion":"v4","signingName":"resource-groups","uid":"resource-groups-2017-11-27"},"operations":{"CreateGroup":{"http":{"requestUri":"/groups"},"input":{"type":"structure","required":["Name","ResourceQuery"],"members":{"Name":{},"Description":{},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"}}}},"DeleteGroup":{"http":{"method":"DELETE","requestUri":"/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"}}}},"GetGroup":{"http":{"method":"GET","requestUri":"/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"}}}},"GetGroupQuery":{"http":{"method":"GET","requestUri":"/groups/{GroupName}/query"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"Sj"}}}},"GetTags":{"http":{"method":"GET","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"uri","locationName":"Arn"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"ListGroupResources":{"http":{"requestUri":"/groups/{GroupName}/resource-identifiers-list"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"shape":"Sv"},"NextToken":{},"QueryErrors":{"shape":"Sz"}}}},"ListGroups":{"http":{"requestUri":"/groups-list"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"GroupIdentifiers":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupArn":{}}}},"Groups":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use GroupIdentifiers instead.","type":"list","member":{"shape":"Sb"}},"NextToken":{}}}},"SearchResources":{"http":{"requestUri":"/resources/search"},"input":{"type":"structure","required":["ResourceQuery"],"members":{"ResourceQuery":{"shape":"S4"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"shape":"Sv"},"NextToken":{},"QueryErrors":{"shape":"Sz"}}}},"Tag":{"http":{"method":"PUT","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"Untag":{"http":{"method":"PATCH","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Keys"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Keys":{"shape":"S1i"}}},"output":{"type":"structure","members":{"Arn":{},"Keys":{"shape":"S1i"}}}},"UpdateGroup":{"http":{"method":"PUT","requestUri":"/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"Description":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"}}}},"UpdateGroupQuery":{"http":{"method":"PUT","requestUri":"/groups/{GroupName}/query"},"input":{"type":"structure","required":["GroupName","ResourceQuery"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"ResourceQuery":{"shape":"S4"}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"Sj"}}}}},"shapes":{"S4":{"type":"structure","required":["Type","Query"],"members":{"Type":{},"Query":{}}},"S7":{"type":"map","key":{},"value":{}},"Sb":{"type":"structure","required":["GroupArn","Name"],"members":{"GroupArn":{},"Name":{},"Description":{}}},"Sj":{"type":"structure","required":["GroupName","ResourceQuery"],"members":{"GroupName":{},"ResourceQuery":{"shape":"S4"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"Message":{}}}},"S1i":{"type":"list","member":{}}}}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListGroupResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-04-01","endpointPrefix":"route53","globalEndpoint":"route53.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Route 53","serviceFullName":"Amazon Route 53","serviceId":"Route 53","signatureVersion":"v4","uid":"route53-2013-04-01"},"operations":{"AssociateVPCWithHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/associatevpc"},"input":{"locationName":"AssociateVPCWithHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeResourceRecordSets":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/rrset/"},"input":{"locationName":"ChangeResourceRecordSetsRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","ChangeBatch"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"ChangeBatch":{"type":"structure","required":["Changes"],"members":{"Comment":{},"Changes":{"type":"list","member":{"locationName":"Change","type":"structure","required":["Action","ResourceRecordSet"],"members":{"Action":{},"ResourceRecordSet":{"shape":"Sh"}}}}}}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeTagsForResource":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"locationName":"ChangeTagsForResourceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"AddTags":{"shape":"S15"},"RemoveTagKeys":{"type":"list","member":{"locationName":"Key"}}}},"output":{"type":"structure","members":{}}},"CreateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck","responseCode":201},"input":{"locationName":"CreateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HealthCheckConfig"],"members":{"CallerReference":{},"HealthCheckConfig":{"shape":"S1d"}}},"output":{"type":"structure","required":["HealthCheck","Location"],"members":{"HealthCheck":{"shape":"S1z"},"Location":{"location":"header","locationName":"Location"}}}},"CreateHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone","responseCode":201},"input":{"locationName":"CreateHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"VPC":{"shape":"S3"},"CallerReference":{},"HostedZoneConfig":{"shape":"S2h"},"DelegationSetId":{}}},"output":{"type":"structure","required":["HostedZone","ChangeInfo","DelegationSet","Location"],"members":{"HostedZone":{"shape":"S2k"},"ChangeInfo":{"shape":"S8"},"DelegationSet":{"shape":"S2m"},"VPC":{"shape":"S3"},"Location":{"location":"header","locationName":"Location"}}}},"CreateQueryLoggingConfig":{"http":{"requestUri":"/2013-04-01/queryloggingconfig","responseCode":201},"input":{"locationName":"CreateQueryLoggingConfigRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"output":{"type":"structure","required":["QueryLoggingConfig","Location"],"members":{"QueryLoggingConfig":{"shape":"S2r"},"Location":{"location":"header","locationName":"Location"}}}},"CreateReusableDelegationSet":{"http":{"requestUri":"/2013-04-01/delegationset","responseCode":201},"input":{"locationName":"CreateReusableDelegationSetRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"HostedZoneId":{}}},"output":{"type":"structure","required":["DelegationSet","Location"],"members":{"DelegationSet":{"shape":"S2m"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicy":{"http":{"requestUri":"/2013-04-01/trafficpolicy","responseCode":201},"input":{"locationName":"CreateTrafficPolicyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","Document"],"members":{"Name":{},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S30"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance","responseCode":201},"input":{"locationName":"CreateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","Name","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance","Location"],"members":{"TrafficPolicyInstance":{"shape":"S35"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyVersion":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}","responseCode":201},"input":{"locationName":"CreateTrafficPolicyVersionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Document"],"members":{"Id":{"location":"uri","locationName":"Id"},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S30"},"Location":{"location":"header","locationName":"Location"}}}},"CreateVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"locationName":"CreateVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{},"VPC":{"shape":"S3"}}}},"DeleteHealthCheck":{"http":{"method":"DELETE","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","members":{}}},"DeleteHostedZone":{"http":{"method":"DELETE","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"DeleteQueryLoggingConfig":{"http":{"method":"DELETE","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteReusableDelegationSet":{"http":{"method":"DELETE","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicy":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicyInstance":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"},"input":{"locationName":"DeleteVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"DisassociateVPCFromHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disassociatevpc"},"input":{"locationName":"DisassociateVPCFromHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetAccountLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/accountlimit/{Type}"},"input":{"type":"structure","required":["Type"],"members":{"Type":{"location":"uri","locationName":"Type"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetChange":{"http":{"method":"GET","requestUri":"/2013-04-01/change/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetCheckerIpRanges":{"http":{"method":"GET","requestUri":"/2013-04-01/checkeripranges"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["CheckerIpRanges"],"members":{"CheckerIpRanges":{"type":"list","member":{}}}}},"GetGeoLocation":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocation"},"input":{"type":"structure","members":{"ContinentCode":{"location":"querystring","locationName":"continentcode"},"CountryCode":{"location":"querystring","locationName":"countrycode"},"SubdivisionCode":{"location":"querystring","locationName":"subdivisioncode"}}},"output":{"type":"structure","required":["GeoLocationDetails"],"members":{"GeoLocationDetails":{"shape":"S47"}}}},"GetHealthCheck":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1z"}}}},"GetHealthCheckCount":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheckcount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HealthCheckCount"],"members":{"HealthCheckCount":{"type":"long"}}}},"GetHealthCheckLastFailureReason":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S4i"}}}},"GetHealthCheckStatus":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/status"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S4i"}}}},"GetHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2k"},"DelegationSet":{"shape":"S2m"},"VPCs":{"shape":"S4q"}}}},"GetHostedZoneCount":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HostedZoneCount"],"members":{"HostedZoneCount":{"type":"long"}}}},"GetHostedZoneLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonelimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","HostedZoneId"],"members":{"Type":{"location":"uri","locationName":"Type"},"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetQueryLoggingConfig":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["QueryLoggingConfig"],"members":{"QueryLoggingConfig":{"shape":"S2r"}}}},"GetReusableDelegationSet":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["DelegationSet"],"members":{"DelegationSet":{"shape":"S2m"}}}},"GetReusableDelegationSetLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","DelegationSetId"],"members":{"Type":{"location":"uri","locationName":"Type"},"DelegationSetId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetTrafficPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S30"}}}},"GetTrafficPolicyInstance":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S35"}}}},"GetTrafficPolicyInstanceCount":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstancecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TrafficPolicyInstanceCount"],"members":{"TrafficPolicyInstanceCount":{"type":"integer"}}}},"ListGeoLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocations"},"input":{"type":"structure","members":{"StartContinentCode":{"location":"querystring","locationName":"startcontinentcode"},"StartCountryCode":{"location":"querystring","locationName":"startcountrycode"},"StartSubdivisionCode":{"location":"querystring","locationName":"startsubdivisioncode"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["GeoLocationDetailsList","IsTruncated","MaxItems"],"members":{"GeoLocationDetailsList":{"type":"list","member":{"shape":"S47","locationName":"GeoLocationDetails"}},"IsTruncated":{"type":"boolean"},"NextContinentCode":{},"NextCountryCode":{},"NextSubdivisionCode":{},"MaxItems":{}}}},"ListHealthChecks":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HealthChecks","Marker","IsTruncated","MaxItems"],"members":{"HealthChecks":{"type":"list","member":{"shape":"S1z","locationName":"HealthCheck"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZones":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"DelegationSetId":{"location":"querystring","locationName":"delegationsetid"}}},"output":{"type":"structure","required":["HostedZones","Marker","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S5o"},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZonesByName":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyname"},"input":{"type":"structure","members":{"DNSName":{"location":"querystring","locationName":"dnsname"},"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HostedZones","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S5o"},"DNSName":{},"HostedZoneId":{},"IsTruncated":{"type":"boolean"},"NextDNSName":{},"NextHostedZoneId":{},"MaxItems":{}}}},"ListHostedZonesByVPC":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyvpc"},"input":{"type":"structure","required":["VPCId","VPCRegion"],"members":{"VPCId":{"location":"querystring","locationName":"vpcid"},"VPCRegion":{"location":"querystring","locationName":"vpcregion"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"NextToken":{"location":"querystring","locationName":"nexttoken"}}},"output":{"type":"structure","required":["HostedZoneSummaries","MaxItems"],"members":{"HostedZoneSummaries":{"type":"list","member":{"locationName":"HostedZoneSummary","type":"structure","required":["HostedZoneId","Name","Owner"],"members":{"HostedZoneId":{},"Name":{},"Owner":{"type":"structure","members":{"OwningAccount":{},"OwningService":{}}}}}},"MaxItems":{},"NextToken":{}}}},"ListQueryLoggingConfigs":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig"},"input":{"type":"structure","members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["QueryLoggingConfigs"],"members":{"QueryLoggingConfigs":{"type":"list","member":{"shape":"S2r","locationName":"QueryLoggingConfig"}},"NextToken":{}}}},"ListResourceRecordSets":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/rrset"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"StartRecordName":{"location":"querystring","locationName":"name"},"StartRecordType":{"location":"querystring","locationName":"type"},"StartRecordIdentifier":{"location":"querystring","locationName":"identifier"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["ResourceRecordSets","IsTruncated","MaxItems"],"members":{"ResourceRecordSets":{"type":"list","member":{"shape":"Sh","locationName":"ResourceRecordSet"}},"IsTruncated":{"type":"boolean"},"NextRecordName":{},"NextRecordType":{},"NextRecordIdentifier":{},"MaxItems":{}}}},"ListReusableDelegationSets":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["DelegationSets","Marker","IsTruncated","MaxItems"],"members":{"DelegationSets":{"type":"list","member":{"shape":"S2m","locationName":"DelegationSet"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}},"output":{"type":"structure","required":["ResourceTagSet"],"members":{"ResourceTagSet":{"shape":"S6b"}}}},"ListTagsForResources":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}"},"input":{"locationName":"ListTagsForResourcesRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceIds"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceIds":{"type":"list","member":{"locationName":"ResourceId"}}}},"output":{"type":"structure","required":["ResourceTagSets"],"members":{"ResourceTagSets":{"type":"list","member":{"shape":"S6b","locationName":"ResourceTagSet"}}}}},"ListTrafficPolicies":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies"},"input":{"type":"structure","members":{"TrafficPolicyIdMarker":{"location":"querystring","locationName":"trafficpolicyid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicySummaries","IsTruncated","TrafficPolicyIdMarker","MaxItems"],"members":{"TrafficPolicySummaries":{"type":"list","member":{"locationName":"TrafficPolicySummary","type":"structure","required":["Id","Name","Type","LatestVersion","TrafficPolicyCount"],"members":{"Id":{},"Name":{},"Type":{},"LatestVersion":{"type":"integer"},"TrafficPolicyCount":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"TrafficPolicyIdMarker":{},"MaxItems":{}}}},"ListTrafficPolicyInstances":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances"},"input":{"type":"structure","members":{"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6m"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/hostedzone"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"querystring","locationName":"id"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6m"},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/trafficpolicy"},"input":{"type":"structure","required":["TrafficPolicyId","TrafficPolicyVersion"],"members":{"TrafficPolicyId":{"location":"querystring","locationName":"id"},"TrafficPolicyVersion":{"location":"querystring","locationName":"version","type":"integer"},"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6m"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyVersions":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies/{Id}/versions"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TrafficPolicyVersionMarker":{"location":"querystring","locationName":"trafficpolicyversion"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicies","IsTruncated","TrafficPolicyVersionMarker","MaxItems"],"members":{"TrafficPolicies":{"type":"list","member":{"shape":"S30","locationName":"TrafficPolicy"}},"IsTruncated":{"type":"boolean"},"TrafficPolicyVersionMarker":{},"MaxItems":{}}}},"ListVPCAssociationAuthorizations":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["HostedZoneId","VPCs"],"members":{"HostedZoneId":{},"NextToken":{},"VPCs":{"shape":"S4q"}}}},"TestDNSAnswer":{"http":{"method":"GET","requestUri":"/2013-04-01/testdnsanswer"},"input":{"type":"structure","required":["HostedZoneId","RecordName","RecordType"],"members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"RecordName":{"location":"querystring","locationName":"recordname"},"RecordType":{"location":"querystring","locationName":"recordtype"},"ResolverIP":{"location":"querystring","locationName":"resolverip"},"EDNS0ClientSubnetIP":{"location":"querystring","locationName":"edns0clientsubnetip"},"EDNS0ClientSubnetMask":{"location":"querystring","locationName":"edns0clientsubnetmask"}}},"output":{"type":"structure","required":["Nameserver","RecordName","RecordType","RecordData","ResponseCode","Protocol"],"members":{"Nameserver":{},"RecordName":{},"RecordType":{},"RecordData":{"type":"list","member":{"locationName":"RecordDataEntry"}},"ResponseCode":{},"Protocol":{}}}},"UpdateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"locationName":"UpdateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"},"HealthCheckVersion":{"type":"long"},"IPAddress":{},"Port":{"type":"integer"},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"FailureThreshold":{"type":"integer"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1q"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1s"},"AlarmIdentifier":{"shape":"S1u"},"InsufficientDataHealthStatus":{},"ResetElements":{"type":"list","member":{"locationName":"ResettableElementName"}}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1z"}}}},"UpdateHostedZoneComment":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"locationName":"UpdateHostedZoneCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Comment":{}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2k"}}}},"UpdateTrafficPolicyComment":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"locationName":"UpdateTrafficPolicyCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Version","Comment"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S30"}}}},"UpdateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"locationName":"UpdateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"Id":{"location":"uri","locationName":"Id"},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S35"}}}}},"shapes":{"S3":{"type":"structure","members":{"VPCRegion":{},"VPCId":{}}},"S8":{"type":"structure","required":["Id","Status","SubmittedAt"],"members":{"Id":{},"Status":{},"SubmittedAt":{"type":"timestamp"},"Comment":{}}},"Sh":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"SetIdentifier":{},"Weight":{"type":"long"},"Region":{},"GeoLocation":{"type":"structure","members":{"ContinentCode":{},"CountryCode":{},"SubdivisionCode":{}}},"Failover":{},"MultiValueAnswer":{"type":"boolean"},"TTL":{"type":"long"},"ResourceRecords":{"type":"list","member":{"locationName":"ResourceRecord","type":"structure","required":["Value"],"members":{"Value":{}}}},"AliasTarget":{"type":"structure","required":["HostedZoneId","DNSName","EvaluateTargetHealth"],"members":{"HostedZoneId":{},"DNSName":{},"EvaluateTargetHealth":{"type":"boolean"}}},"HealthCheckId":{},"TrafficPolicyInstanceId":{}}},"S15":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S1d":{"type":"structure","required":["Type"],"members":{"IPAddress":{},"Port":{"type":"integer"},"Type":{},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"RequestInterval":{"type":"integer"},"FailureThreshold":{"type":"integer"},"MeasureLatency":{"type":"boolean"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1q"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1s"},"AlarmIdentifier":{"shape":"S1u"},"InsufficientDataHealthStatus":{}}},"S1q":{"type":"list","member":{"locationName":"ChildHealthCheck"}},"S1s":{"type":"list","member":{"locationName":"Region"}},"S1u":{"type":"structure","required":["Region","Name"],"members":{"Region":{},"Name":{}}},"S1z":{"type":"structure","required":["Id","CallerReference","HealthCheckConfig","HealthCheckVersion"],"members":{"Id":{},"CallerReference":{},"LinkedService":{"shape":"S20"},"HealthCheckConfig":{"shape":"S1d"},"HealthCheckVersion":{"type":"long"},"CloudWatchAlarmConfiguration":{"type":"structure","required":["EvaluationPeriods","Threshold","ComparisonOperator","Period","MetricName","Namespace","Statistic"],"members":{"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"Period":{"type":"integer"},"MetricName":{},"Namespace":{},"Statistic":{},"Dimensions":{"type":"list","member":{"locationName":"Dimension","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}}},"S20":{"type":"structure","members":{"ServicePrincipal":{},"Description":{}}},"S2h":{"type":"structure","members":{"Comment":{},"PrivateZone":{"type":"boolean"}}},"S2k":{"type":"structure","required":["Id","Name","CallerReference"],"members":{"Id":{},"Name":{},"CallerReference":{},"Config":{"shape":"S2h"},"ResourceRecordSetCount":{"type":"long"},"LinkedService":{"shape":"S20"}}},"S2m":{"type":"structure","required":["NameServers"],"members":{"Id":{},"CallerReference":{},"NameServers":{"type":"list","member":{"locationName":"NameServer"}}}},"S2r":{"type":"structure","required":["Id","HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"Id":{},"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"S30":{"type":"structure","required":["Id","Version","Name","Type","Document"],"members":{"Id":{},"Version":{"type":"integer"},"Name":{},"Type":{},"Document":{},"Comment":{}}},"S35":{"type":"structure","required":["Id","HostedZoneId","Name","TTL","State","Message","TrafficPolicyId","TrafficPolicyVersion","TrafficPolicyType"],"members":{"Id":{},"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"State":{},"Message":{},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"},"TrafficPolicyType":{}}},"S47":{"type":"structure","members":{"ContinentCode":{},"ContinentName":{},"CountryCode":{},"CountryName":{},"SubdivisionCode":{},"SubdivisionName":{}}},"S4i":{"type":"list","member":{"locationName":"HealthCheckObservation","type":"structure","members":{"Region":{},"IPAddress":{},"StatusReport":{"type":"structure","members":{"Status":{},"CheckedTime":{"type":"timestamp"}}}}}},"S4q":{"type":"list","member":{"shape":"S3","locationName":"VPC"}},"S5o":{"type":"list","member":{"shape":"S2k","locationName":"HostedZone"}},"S6b":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S15"}}},"S6m":{"type":"list","member":{"shape":"S35","locationName":"TrafficPolicyInstance"}}}}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListHealthChecks":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HealthChecks"},"ListHostedZones":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HostedZones"},"ListQueryLoggingConfigs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueryLoggingConfigs"},"ListResourceRecordSets":{"input_token":["StartRecordName","StartRecordType","StartRecordIdentifier"],"limit_key":"MaxItems","more_results":"IsTruncated","output_token":["NextRecordName","NextRecordType","NextRecordIdentifier"],"result_key":"ResourceRecordSets"}}}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-15","endpointPrefix":"route53domains","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Route 53 Domains","serviceId":"Route 53 Domains","signatureVersion":"v4","targetPrefix":"Route53Domains_v20140515","uid":"route53domains-2014-05-15"},"operations":{"AcceptDomainTransferFromAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName","Password"],"members":{"DomainName":{},"Password":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CancelDomainTransferToAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CheckDomainAvailability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"IdnLangCode":{}}},"output":{"type":"structure","required":["Availability"],"members":{"Availability":{}}}},"CheckDomainTransferability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AuthCode":{"shape":"Sd"}}},"output":{"type":"structure","required":["Transferability"],"members":{"Transferability":{"type":"structure","members":{"Transferable":{}}}}}},"DeleteTagsForDomain":{"input":{"type":"structure","required":["DomainName","TagsToDelete"],"members":{"DomainName":{},"TagsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DisableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"EnableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"EnableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"GetContactReachabilityStatus":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"status":{}}}},"GetDomainDetail":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["DomainName","Nameservers","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"Nameservers":{"shape":"Sy"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S14"},"RegistrantContact":{"shape":"S14"},"TechContact":{"shape":"S14"},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"RegistrarName":{},"WhoIsServer":{},"RegistrarUrl":{},"AbuseContactEmail":{},"AbuseContactPhone":{},"RegistryDomainId":{},"CreationDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"},"ExpirationDate":{"type":"timestamp"},"Reseller":{},"DnsSec":{},"StatusList":{"type":"list","member":{}}}}},"GetDomainSuggestions":{"input":{"type":"structure","required":["DomainName","SuggestionCount","OnlyAvailable"],"members":{"DomainName":{},"SuggestionCount":{"type":"integer"},"OnlyAvailable":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuggestionsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Availability":{}}}}}}},"GetOperationDetail":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Status":{},"Message":{},"DomainName":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"ListDomains":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Domains"],"members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AutoRenew":{"type":"boolean"},"TransferLock":{"type":"boolean"},"Expiry":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListOperations":{"input":{"type":"structure","members":{"SubmittedSince":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Operations"],"members":{"Operations":{"type":"list","member":{"type":"structure","required":["OperationId","Status","Type","SubmittedDate"],"members":{"OperationId":{},"Status":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S2d"}}}},"RegisterDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S14"},"RegistrantContact":{"shape":"S14"},"TechContact":{"shape":"S14"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"RejectDomainTransferFromAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"RenewDomain":{"input":{"type":"structure","required":["DomainName","CurrentExpiryYear"],"members":{"DomainName":{},"DurationInYears":{"type":"integer"},"CurrentExpiryYear":{"type":"integer"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"ResendContactReachabilityEmail":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"emailAddress":{},"isAlreadyVerified":{"type":"boolean"}}}},"RetrieveDomainAuthCode":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["AuthCode"],"members":{"AuthCode":{"shape":"Sd"}}}},"TransferDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"Nameservers":{"shape":"Sy"},"AuthCode":{"shape":"Sd"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S14"},"RegistrantContact":{"shape":"S14"},"TechContact":{"shape":"S14"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"TransferDomainToAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName","AccountId"],"members":{"DomainName":{},"AccountId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Password":{}}}},"UpdateDomainContact":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminContact":{"shape":"S14"},"RegistrantContact":{"shape":"S14"},"TechContact":{"shape":"S14"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContactPrivacy":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainNameservers":{"input":{"type":"structure","required":["DomainName","Nameservers"],"members":{"DomainName":{},"FIAuthKey":{"deprecated":true},"Nameservers":{"shape":"Sy"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"TagsToUpdate":{"shape":"S2d"}}},"output":{"type":"structure","members":{}}},"ViewBilling":{"input":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageMarker":{},"BillingRecords":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Operation":{},"InvoiceId":{},"BillDate":{"type":"timestamp"},"Price":{"type":"double"}}}}}}}},"shapes":{"Sd":{"type":"string","sensitive":true},"Sy":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"GlueIps":{"type":"list","member":{}}}}},"S14":{"type":"structure","members":{"FirstName":{},"LastName":{},"ContactType":{},"OrganizationName":{},"AddressLine1":{},"AddressLine2":{},"City":{},"State":{},"CountryCode":{},"ZipCode":{},"PhoneNumber":{},"Email":{},"Fax":{},"ExtraParams":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}},"sensitive":true},"S2d":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDomains":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Domains"},"ListOperations":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Operations"}}}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"runtime.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Runtime Service","serviceId":"Lex Runtime Service","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex-2016-11-28"},"operations":{"DeleteSession":{"http":{"method":"DELETE","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"botName":{},"botAlias":{},"userId":{},"sessionId":{}}}},"GetSession":{"http":{"method":"GET","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session/"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"checkpointLabelFilter":{"location":"querystring","locationName":"checkpointLabelFilter"}}},"output":{"type":"structure","members":{"recentIntentSummaryView":{"shape":"Sa"},"sessionAttributes":{"shape":"Sd"},"sessionId":{},"dialogAction":{"shape":"Sh"}}}},"PostContent":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/content"},"input":{"type":"structure","required":["botName","botAlias","userId","contentType","inputStream"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sl","jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"requestAttributes":{"shape":"Sl","jsonvalue":true,"location":"header","locationName":"x-amz-lex-request-attributes"},"contentType":{"location":"header","locationName":"Content-Type"},"accept":{"location":"header","locationName":"Accept"},"inputStream":{"shape":"So"}},"payload":"inputStream"},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"sentimentResponse":{"location":"header","locationName":"x-amz-lex-sentiment"},"message":{"shape":"Si","location":"header","locationName":"x-amz-lex-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"inputTranscript":{"location":"header","locationName":"x-amz-lex-input-transcript"},"audioStream":{"shape":"So"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"},"PostText":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/text"},"input":{"type":"structure","required":["botName","botAlias","userId","inputText"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sd"},"requestAttributes":{"shape":"Sd"},"inputText":{"shape":"Si"}}},"output":{"type":"structure","members":{"intentName":{},"slots":{"shape":"Sd"},"sessionAttributes":{"shape":"Sd"},"message":{"shape":"Si"},"sentimentResponse":{"type":"structure","members":{"sentimentLabel":{},"sentimentScore":{}}},"messageFormat":{},"dialogState":{},"slotToElicit":{},"responseCard":{"type":"structure","members":{"version":{},"contentType":{},"genericAttachments":{"type":"list","member":{"type":"structure","members":{"title":{},"subTitle":{},"attachmentLinkUrl":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}},"sessionId":{}}}},"PutSession":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sd"},"dialogAction":{"shape":"Sh"},"recentIntentSummaryView":{"shape":"Sa"},"accept":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Si","location":"header","locationName":"x-amz-lex-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"audioStream":{"shape":"So"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"}},"payload":"audioStream"}}},"shapes":{"Sa":{"type":"list","member":{"type":"structure","required":["dialogActionType"],"members":{"intentName":{},"checkpointLabel":{},"slots":{"shape":"Sd"},"confirmationStatus":{},"dialogActionType":{},"fulfillmentState":{},"slotToElicit":{}}}},"Sd":{"type":"map","key":{},"value":{},"sensitive":true},"Sh":{"type":"structure","required":["type"],"members":{"type":{},"intentName":{},"slots":{"shape":"Sd"},"slotToElicit":{},"fulfillmentState":{},"message":{"shape":"Si"},"messageFormat":{}}},"Si":{"type":"string","sensitive":true},"Sl":{"type":"string","sensitive":true},"So":{"type":"blob","streaming":true}}}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2006-03-01","checksumFormat":"md5","endpointPrefix":"s3","globalEndpoint":"s3.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Amazon S3","serviceFullName":"Amazon Simple Storage Service","serviceId":"S3","signatureVersion":"s3","uid":"s3-2006-03-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MultipartUpload":{"locationName":"CompleteMultipartUpload","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"ETag":{},"PartNumber":{"type":"integer"}}},"flattened":true}}},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"MultipartUpload"},"output":{"type":"structure","members":{"Location":{},"Bucket":{},"Key":{},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CopyObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"MetadataDirective":{"location":"header","locationName":"x-amz-metadata-directive"},"TaggingDirective":{"location":"header","locationName":"x-amz-tagging-directive"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1d","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}},"output":{"type":"structure","members":{"CopyObjectResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyObjectResult"},"alias":"PutObjectCopy"},"CreateBucket":{"http":{"method":"PUT","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LocationConstraint":{}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ObjectLockEnabledForBucket":{"location":"header","locationName":"x-amz-bucket-object-lock-enabled","type":"boolean"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"}}},"alias":"PutBucket"},"CreateMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}?uploads"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{"locationName":"Bucket"},"Key":{},"UploadId":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"InitiateMultipartUpload"},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/{Bucket}","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketAnalyticsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?analytics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketCors":{"http":{"method":"DELETE","requestUri":"/{Bucket}?cors","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketEncryption":{"http":{"method":"DELETE","requestUri":"/{Bucket}?encryption","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketInventoryConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?inventory","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketLifecycle":{"http":{"method":"DELETE","requestUri":"/{Bucket}?lifecycle","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketMetricsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?metrics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/{Bucket}?policy","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketReplication":{"http":{"method":"DELETE","requestUri":"/{Bucket}?replication","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketWebsite":{"http":{"method":"DELETE","requestUri":"/{Bucket}?website","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"DeleteObjectTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"DeleteObjects":{"http":{"requestUri":"/{Bucket}?delete"},"input":{"type":"structure","required":["Bucket","Delete"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delete":{"locationName":"Delete","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Objects"],"members":{"Objects":{"locationName":"Object","type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"VersionId":{}}},"flattened":true},"Quiet":{"type":"boolean"}}},"MFA":{"location":"header","locationName":"x-amz-mfa"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"}},"payload":"Delete"},"output":{"type":"structure","members":{"Deleted":{"type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"DeleteMarker":{"type":"boolean"},"DeleteMarkerVersionId":{}}},"flattened":true},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"Errors":{"locationName":"Error","type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"Code":{},"Message":{}}},"flattened":true}}},"alias":"DeleteMultipleObjects","httpChecksumRequired":true},"DeletePublicAccessBlock":{"http":{"method":"DELETE","requestUri":"/{Bucket}?publicAccessBlock","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"GetBucketAccelerateConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{}}}},"GetBucketAcl":{"http":{"method":"GET","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S32"},"Grants":{"shape":"S35","locationName":"AccessControlList"}}}},"GetBucketAnalyticsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"AnalyticsConfiguration":{"shape":"S3e"}},"payload":"AnalyticsConfiguration"}},"GetBucketCors":{"http":{"method":"GET","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"CORSRules":{"shape":"S3u","locationName":"CORSRule"}}}},"GetBucketEncryption":{"http":{"method":"GET","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ServerSideEncryptionConfiguration":{"shape":"S47"}},"payload":"ServerSideEncryptionConfiguration"}},"GetBucketInventoryConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"InventoryConfiguration":{"shape":"S4d"}},"payload":"InventoryConfiguration"}},"GetBucketLifecycle":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S4t","locationName":"Rule"}}},"deprecated":true},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S58","locationName":"Rule"}}}},"GetBucketLocation":{"http":{"method":"GET","requestUri":"/{Bucket}?location"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LocationConstraint":{}}}},"GetBucketLogging":{"http":{"method":"GET","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LoggingEnabled":{"shape":"S5i"}}}},"GetBucketMetricsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"MetricsConfiguration":{"shape":"S5q"}},"payload":"MetricsConfiguration"}},"GetBucketNotification":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5t"},"output":{"shape":"S5u"},"deprecated":true},"GetBucketNotificationConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5t"},"output":{"shape":"S65"}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Policy":{}},"payload":"Policy"}},"GetBucketPolicyStatus":{"http":{"method":"GET","requestUri":"/{Bucket}?policyStatus"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"PolicyStatus":{"type":"structure","members":{"IsPublic":{"locationName":"IsPublic","type":"boolean"}}}},"payload":"PolicyStatus"}},"GetBucketReplication":{"http":{"method":"GET","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ReplicationConfiguration":{"shape":"S6s"}},"payload":"ReplicationConfiguration"}},"GetBucketRequestPayment":{"http":{"method":"GET","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Payer":{}}}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3k"}}}},"GetBucketVersioning":{"http":{"method":"GET","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{},"MFADelete":{"locationName":"MfaDelete"}}}},"GetBucketWebsite":{"http":{"method":"GET","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"RedirectAllRequestsTo":{"shape":"S7t"},"IndexDocument":{"shape":"S7w"},"ErrorDocument":{"shape":"S7y"},"RoutingRules":{"shape":"S7z"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"ResponseCacheControl":{"location":"querystring","locationName":"response-cache-control"},"ResponseContentDisposition":{"location":"querystring","locationName":"response-content-disposition"},"ResponseContentEncoding":{"location":"querystring","locationName":"response-content-encoding"},"ResponseContentLanguage":{"location":"querystring","locationName":"response-content-language"},"ResponseContentType":{"location":"querystring","locationName":"response-content-type"},"ResponseExpires":{"location":"querystring","locationName":"response-expires","type":"timestamp"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"TagCount":{"location":"header","locationName":"x-amz-tagging-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}},"payload":"Body"}},"GetObjectAcl":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S32"},"Grants":{"shape":"S35","locationName":"AccessControlList"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"GetObjectLegalHold":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"LegalHold":{"shape":"S8y"}},"payload":"LegalHold"}},"GetObjectLockConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ObjectLockConfiguration":{"shape":"S91"}},"payload":"ObjectLockConfiguration"}},"GetObjectRetention":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Retention":{"shape":"S99"}},"payload":"Retention"}},"GetObjectTagging":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","required":["TagSet"],"members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"},"TagSet":{"shape":"S3k"}}}},"GetObjectTorrent":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?torrent"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"Body"}},"GetPublicAccessBlock":{"http":{"method":"GET","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"PublicAccessBlockConfiguration":{"shape":"S9g"}},"payload":"PublicAccessBlockConfiguration"}},"HeadBucket":{"http":{"method":"HEAD","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"HeadObject":{"http":{"method":"HEAD","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}}},"ListBucketAnalyticsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"AnalyticsConfigurationList":{"locationName":"AnalyticsConfiguration","type":"list","member":{"shape":"S3e"},"flattened":true}}}},"ListBucketInventoryConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"ContinuationToken":{},"InventoryConfigurationList":{"locationName":"InventoryConfiguration","type":"list","member":{"shape":"S4d"},"flattened":true},"IsTruncated":{"type":"boolean"},"NextContinuationToken":{}}}},"ListBucketMetricsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"MetricsConfigurationList":{"locationName":"MetricsConfiguration","type":"list","member":{"shape":"S5q"},"flattened":true}}}},"ListBuckets":{"http":{"method":"GET"},"output":{"type":"structure","members":{"Buckets":{"type":"list","member":{"locationName":"Bucket","type":"structure","members":{"Name":{},"CreationDate":{"type":"timestamp"}}}},"Owner":{"shape":"S32"}}},"alias":"GetService"},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{Bucket}?uploads"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxUploads":{"location":"querystring","locationName":"max-uploads","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"UploadIdMarker":{"location":"querystring","locationName":"upload-id-marker"}}},"output":{"type":"structure","members":{"Bucket":{},"KeyMarker":{},"UploadIdMarker":{},"NextKeyMarker":{},"Prefix":{},"Delimiter":{},"NextUploadIdMarker":{},"MaxUploads":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Uploads":{"locationName":"Upload","type":"list","member":{"type":"structure","members":{"UploadId":{},"Key":{},"Initiated":{"type":"timestamp"},"StorageClass":{},"Owner":{"shape":"S32"},"Initiator":{"shape":"Sad"}}},"flattened":true},"CommonPrefixes":{"shape":"Sae"},"EncodingType":{}}}},"ListObjectVersions":{"http":{"method":"GET","requestUri":"/{Bucket}?versions"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"VersionIdMarker":{"location":"querystring","locationName":"version-id-marker"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"KeyMarker":{},"VersionIdMarker":{},"NextKeyMarker":{},"NextVersionIdMarker":{},"Versions":{"locationName":"Version","type":"list","member":{"type":"structure","members":{"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"},"Owner":{"shape":"S32"}}},"flattened":true},"DeleteMarkers":{"locationName":"DeleteMarker","type":"list","member":{"type":"structure","members":{"Owner":{"shape":"S32"},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"}}},"flattened":true},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sae"},"EncodingType":{}}},"alias":"GetBucketObjectVersions"},"ListObjects":{"http":{"method":"GET","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"Marker":{"location":"querystring","locationName":"marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{},"Contents":{"shape":"Saw"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sae"},"EncodingType":{}}},"alias":"GetBucket"},"ListObjectsV2":{"http":{"method":"GET","requestUri":"/{Bucket}?list-type=2"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"FetchOwner":{"location":"querystring","locationName":"fetch-owner","type":"boolean"},"StartAfter":{"location":"querystring","locationName":"start-after"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Contents":{"shape":"Saw"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sae"},"EncodingType":{},"KeyCount":{"type":"integer"},"ContinuationToken":{},"NextContinuationToken":{},"StartAfter":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MaxParts":{"location":"querystring","locationName":"max-parts","type":"integer"},"PartNumberMarker":{"location":"querystring","locationName":"part-number-marker","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{},"Key":{},"UploadId":{},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"}}},"flattened":true},"Initiator":{"shape":"Sad"},"Owner":{"shape":"S32"},"StorageClass":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutBucketAccelerateConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket","AccelerateConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"AccelerateConfiguration":{"locationName":"AccelerateConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Status":{}}}},"payload":"AccelerateConfiguration"}},"PutBucketAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sbe","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"}},"payload":"AccessControlPolicy"},"httpChecksumRequired":true},"PutBucketAnalyticsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id","AnalyticsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"AnalyticsConfiguration":{"shape":"S3e","locationName":"AnalyticsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"AnalyticsConfiguration"}},"PutBucketCors":{"http":{"method":"PUT","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket","CORSConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CORSConfiguration":{"locationName":"CORSConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["CORSRules"],"members":{"CORSRules":{"shape":"S3u","locationName":"CORSRule"}}},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"}},"payload":"CORSConfiguration"},"httpChecksumRequired":true},"PutBucketEncryption":{"http":{"method":"PUT","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket","ServerSideEncryptionConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"ServerSideEncryptionConfiguration":{"shape":"S47","locationName":"ServerSideEncryptionConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"ServerSideEncryptionConfiguration"},"httpChecksumRequired":true},"PutBucketInventoryConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id","InventoryConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"InventoryConfiguration":{"shape":"S4d","locationName":"InventoryConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"InventoryConfiguration"}},"PutBucketLifecycle":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S4t","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"},"deprecated":true,"httpChecksumRequired":true},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S58","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"},"httpChecksumRequired":true},"PutBucketLogging":{"http":{"method":"PUT","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket","BucketLoggingStatus"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"BucketLoggingStatus":{"locationName":"BucketLoggingStatus","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LoggingEnabled":{"shape":"S5i"}}},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"}},"payload":"BucketLoggingStatus"},"httpChecksumRequired":true},"PutBucketMetricsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id","MetricsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"MetricsConfiguration":{"shape":"S5q","locationName":"MetricsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"MetricsConfiguration"}},"PutBucketNotification":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"NotificationConfiguration":{"shape":"S5u","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"},"deprecated":true,"httpChecksumRequired":true},"PutBucketNotificationConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"NotificationConfiguration":{"shape":"S65","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"}},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket","Policy"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"ConfirmRemoveSelfBucketAccess":{"location":"header","locationName":"x-amz-confirm-remove-self-bucket-access","type":"boolean"},"Policy":{}},"payload":"Policy"},"httpChecksumRequired":true},"PutBucketReplication":{"http":{"method":"PUT","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket","ReplicationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"ReplicationConfiguration":{"shape":"S6s","locationName":"ReplicationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"}},"payload":"ReplicationConfiguration"},"httpChecksumRequired":true},"PutBucketRequestPayment":{"http":{"method":"PUT","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket","RequestPaymentConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"RequestPaymentConfiguration":{"locationName":"RequestPaymentConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Payer"],"members":{"Payer":{}}}},"payload":"RequestPaymentConfiguration"},"httpChecksumRequired":true},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sc1","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"},"httpChecksumRequired":true},"PutBucketVersioning":{"http":{"method":"PUT","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket","VersioningConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersioningConfiguration":{"locationName":"VersioningConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"MFADelete":{"locationName":"MfaDelete"},"Status":{}}}},"payload":"VersioningConfiguration"},"httpChecksumRequired":true},"PutBucketWebsite":{"http":{"method":"PUT","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket","WebsiteConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"WebsiteConfiguration":{"locationName":"WebsiteConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"ErrorDocument":{"shape":"S7y"},"IndexDocument":{"shape":"S7w"},"RedirectAllRequestsTo":{"shape":"S7t"},"RoutingRules":{"shape":"S7z"}}}},"payload":"WebsiteConfiguration"},"httpChecksumRequired":true},"PutObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}},"payload":"Body"},"output":{"type":"structure","members":{"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{"location":"header","locationName":"ETag"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sbe","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"}},"payload":"AccessControlPolicy"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksumRequired":true},"PutObjectLegalHold":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"LegalHold":{"shape":"S8y","locationName":"LegalHold","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"}},"payload":"LegalHold"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksumRequired":true},"PutObjectLockConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ObjectLockConfiguration":{"shape":"S91","locationName":"ObjectLockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"}},"payload":"ObjectLockConfiguration"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksumRequired":true},"PutObjectRetention":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"Retention":{"shape":"S99","locationName":"Retention","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"}},"payload":"Retention"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksumRequired":true},"PutObjectTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sc1","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}},"httpChecksumRequired":true},"PutPublicAccessBlock":{"http":{"method":"PUT","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket","PublicAccessBlockConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"deprecated":true,"deprecatedMessage":"Content-MD5 header will now be automatically computed and injected in associated operation's Http request.","location":"header","locationName":"Content-MD5"},"PublicAccessBlockConfiguration":{"shape":"S9g","locationName":"PublicAccessBlockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"PublicAccessBlockConfiguration"},"httpChecksumRequired":true},"RestoreObject":{"http":{"requestUri":"/{Bucket}/{Key+}?restore"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RestoreRequest":{"locationName":"RestoreRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Days":{"type":"integer"},"GlacierJobParameters":{"type":"structure","required":["Tier"],"members":{"Tier":{}}},"Type":{},"Tier":{},"Description":{},"SelectParameters":{"type":"structure","required":["InputSerialization","ExpressionType","Expression","OutputSerialization"],"members":{"InputSerialization":{"shape":"Scr"},"ExpressionType":{},"Expression":{},"OutputSerialization":{"shape":"Sd6"}}},"OutputLocation":{"type":"structure","members":{"S3":{"type":"structure","required":["BucketName","Prefix"],"members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","required":["EncryptionType"],"members":{"EncryptionType":{},"KMSKeyId":{"shape":"Sj"},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"shape":"S35"},"Tagging":{"shape":"Sc1"},"UserMetadata":{"type":"list","member":{"locationName":"MetadataEntry","type":"structure","members":{"Name":{},"Value":{}}}},"StorageClass":{}}}}}}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"RestoreRequest"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"RestoreOutputPath":{"location":"header","locationName":"x-amz-restore-output-path"}}},"alias":"PostObjectRestore"},"SelectObjectContent":{"http":{"requestUri":"/{Bucket}/{Key+}?select&select-type=2"},"input":{"locationName":"SelectObjectContentRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Bucket","Key","Expression","ExpressionType","InputSerialization","OutputSerialization"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"Expression":{},"ExpressionType":{},"RequestProgress":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InputSerialization":{"shape":"Scr"},"OutputSerialization":{"shape":"Sd6"},"ScanRange":{"type":"structure","members":{"Start":{"type":"long"},"End":{"type":"long"}}}}},"output":{"type":"structure","members":{"Payload":{"type":"structure","members":{"Records":{"type":"structure","members":{"Payload":{"eventpayload":true,"type":"blob"}},"event":true},"Stats":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Progress":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Cont":{"type":"structure","members":{},"event":true},"End":{"type":"structure","members":{},"event":true}},"eventstream":true}},"payload":"Payload"}},"UploadPart":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","PartNumber","UploadId"],"members":{"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Body"},"output":{"type":"structure","members":{"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"ETag":{"location":"header","locationName":"ETag"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"UploadPartCopy":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key","PartNumber","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"CopySourceRange":{"location":"header","locationName":"x-amz-copy-source-range"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1d","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"CopyPartResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyPartResult"}}},"shapes":{"Sj":{"type":"string","sensitive":true},"S11":{"type":"map","key":{},"value":{}},"S19":{"type":"blob","sensitive":true},"S1b":{"type":"string","sensitive":true},"S1d":{"type":"blob","sensitive":true},"S1h":{"type":"timestamp","timestampFormat":"iso8601"},"S32":{"type":"structure","members":{"DisplayName":{},"ID":{}}},"S35":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S37"},"Permission":{}}}},"S37":{"type":"structure","required":["Type"],"members":{"DisplayName":{},"EmailAddress":{},"ID":{},"Type":{"locationName":"xsi:type","xmlAttribute":true},"URI":{}},"xmlNamespace":{"prefix":"xsi","uri":"http://www.w3.org/2001/XMLSchema-instance"}},"S3e":{"type":"structure","required":["Id","StorageClassAnalysis"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}},"StorageClassAnalysis":{"type":"structure","members":{"DataExport":{"type":"structure","required":["OutputSchemaVersion","Destination"],"members":{"OutputSchemaVersion":{},"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Format","Bucket"],"members":{"Format":{},"BucketAccountId":{},"Bucket":{},"Prefix":{}}}}}}}}}}},"S3h":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S3k":{"type":"list","member":{"shape":"S3h","locationName":"Tag"}},"S3u":{"type":"list","member":{"type":"structure","required":["AllowedMethods","AllowedOrigins"],"members":{"AllowedHeaders":{"locationName":"AllowedHeader","type":"list","member":{},"flattened":true},"AllowedMethods":{"locationName":"AllowedMethod","type":"list","member":{},"flattened":true},"AllowedOrigins":{"locationName":"AllowedOrigin","type":"list","member":{},"flattened":true},"ExposeHeaders":{"locationName":"ExposeHeader","type":"list","member":{},"flattened":true},"MaxAgeSeconds":{"type":"integer"}}},"flattened":true},"S47":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","members":{"ApplyServerSideEncryptionByDefault":{"type":"structure","required":["SSEAlgorithm"],"members":{"SSEAlgorithm":{},"KMSMasterKeyID":{"shape":"Sj"}}}}},"flattened":true}}},"S4d":{"type":"structure","required":["Destination","IsEnabled","Id","IncludedObjectVersions","Schedule"],"members":{"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Bucket","Format"],"members":{"AccountId":{},"Bucket":{},"Format":{},"Prefix":{},"Encryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{"shape":"Sj"}}}}}}}}},"IsEnabled":{"type":"boolean"},"Filter":{"type":"structure","required":["Prefix"],"members":{"Prefix":{}}},"Id":{},"IncludedObjectVersions":{},"OptionalFields":{"type":"list","member":{"locationName":"Field"}},"Schedule":{"type":"structure","required":["Frequency"],"members":{"Frequency":{}}}}},"S4t":{"type":"list","member":{"type":"structure","required":["Prefix","Status"],"members":{"Expiration":{"shape":"S4v"},"ID":{},"Prefix":{},"Status":{},"Transition":{"shape":"S50"},"NoncurrentVersionTransition":{"shape":"S52"},"NoncurrentVersionExpiration":{"shape":"S53"},"AbortIncompleteMultipartUpload":{"shape":"S54"}}},"flattened":true},"S4v":{"type":"structure","members":{"Date":{"shape":"S4w"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"S4w":{"type":"timestamp","timestampFormat":"iso8601"},"S50":{"type":"structure","members":{"Date":{"shape":"S4w"},"Days":{"type":"integer"},"StorageClass":{}}},"S52":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{}}},"S53":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"}}},"S54":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"S58":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Expiration":{"shape":"S4v"},"ID":{},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}},"Status":{},"Transitions":{"locationName":"Transition","type":"list","member":{"shape":"S50"},"flattened":true},"NoncurrentVersionTransitions":{"locationName":"NoncurrentVersionTransition","type":"list","member":{"shape":"S52"},"flattened":true},"NoncurrentVersionExpiration":{"shape":"S53"},"AbortIncompleteMultipartUpload":{"shape":"S54"}}},"flattened":true},"S5i":{"type":"structure","required":["TargetBucket","TargetPrefix"],"members":{"TargetBucket":{},"TargetGrants":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S37"},"Permission":{}}}},"TargetPrefix":{}}},"S5q":{"type":"structure","required":["Id"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}}}},"S5t":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"S5u":{"type":"structure","members":{"TopicConfiguration":{"type":"structure","members":{"Id":{},"Events":{"shape":"S5x","locationName":"Event"},"Event":{"deprecated":true},"Topic":{}}},"QueueConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5x","locationName":"Event"},"Queue":{}}},"CloudFunctionConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5x","locationName":"Event"},"CloudFunction":{},"InvocationRole":{}}}}},"S5x":{"type":"list","member":{},"flattened":true},"S65":{"type":"structure","members":{"TopicConfigurations":{"locationName":"TopicConfiguration","type":"list","member":{"type":"structure","required":["TopicArn","Events"],"members":{"Id":{},"TopicArn":{"locationName":"Topic"},"Events":{"shape":"S5x","locationName":"Event"},"Filter":{"shape":"S68"}}},"flattened":true},"QueueConfigurations":{"locationName":"QueueConfiguration","type":"list","member":{"type":"structure","required":["QueueArn","Events"],"members":{"Id":{},"QueueArn":{"locationName":"Queue"},"Events":{"shape":"S5x","locationName":"Event"},"Filter":{"shape":"S68"}}},"flattened":true},"LambdaFunctionConfigurations":{"locationName":"CloudFunctionConfiguration","type":"list","member":{"type":"structure","required":["LambdaFunctionArn","Events"],"members":{"Id":{},"LambdaFunctionArn":{"locationName":"CloudFunction"},"Events":{"shape":"S5x","locationName":"Event"},"Filter":{"shape":"S68"}}},"flattened":true}}},"S68":{"type":"structure","members":{"Key":{"locationName":"S3Key","type":"structure","members":{"FilterRules":{"locationName":"FilterRule","type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}},"flattened":true}}}}},"S6s":{"type":"structure","required":["Role","Rules"],"members":{"Role":{},"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["Status","Destination"],"members":{"ID":{},"Priority":{"type":"integer"},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}},"Status":{},"SourceSelectionCriteria":{"type":"structure","members":{"SseKmsEncryptedObjects":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"ExistingObjectReplication":{"type":"structure","required":["Status"],"members":{"Status":{}}},"Destination":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Account":{},"StorageClass":{},"AccessControlTranslation":{"type":"structure","required":["Owner"],"members":{"Owner":{}}},"EncryptionConfiguration":{"type":"structure","members":{"ReplicaKmsKeyID":{}}},"ReplicationTime":{"type":"structure","required":["Status","Time"],"members":{"Status":{},"Time":{"shape":"S7c"}}},"Metrics":{"type":"structure","required":["Status","EventThreshold"],"members":{"Status":{},"EventThreshold":{"shape":"S7c"}}}}},"DeleteMarkerReplication":{"type":"structure","members":{"Status":{}}}}},"flattened":true}}},"S7c":{"type":"structure","members":{"Minutes":{"type":"integer"}}},"S7t":{"type":"structure","required":["HostName"],"members":{"HostName":{},"Protocol":{}}},"S7w":{"type":"structure","required":["Suffix"],"members":{"Suffix":{}}},"S7y":{"type":"structure","required":["Key"],"members":{"Key":{}}},"S7z":{"type":"list","member":{"locationName":"RoutingRule","type":"structure","required":["Redirect"],"members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"HostName":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}},"S8y":{"type":"structure","members":{"Status":{}}},"S91":{"type":"structure","members":{"ObjectLockEnabled":{},"Rule":{"type":"structure","members":{"DefaultRetention":{"type":"structure","members":{"Mode":{},"Days":{"type":"integer"},"Years":{"type":"integer"}}}}}}},"S99":{"type":"structure","members":{"Mode":{},"RetainUntilDate":{"shape":"S4w"}}},"S9g":{"type":"structure","members":{"BlockPublicAcls":{"locationName":"BlockPublicAcls","type":"boolean"},"IgnorePublicAcls":{"locationName":"IgnorePublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"BlockPublicPolicy","type":"boolean"},"RestrictPublicBuckets":{"locationName":"RestrictPublicBuckets","type":"boolean"}}},"Sad":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"Sae":{"type":"list","member":{"type":"structure","members":{"Prefix":{}}},"flattened":true},"Saw":{"type":"list","member":{"type":"structure","members":{"Key":{},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Owner":{"shape":"S32"}}},"flattened":true},"Sbe":{"type":"structure","members":{"Grants":{"shape":"S35","locationName":"AccessControlList"},"Owner":{"shape":"S32"}}},"Sc1":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3k"}}},"Scr":{"type":"structure","members":{"CSV":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{},"AllowQuotedRecordDelimiter":{"type":"boolean"}}},"CompressionType":{},"JSON":{"type":"structure","members":{"Type":{}}},"Parquet":{"type":"structure","members":{}}}},"Sd6":{"type":"structure","members":{"CSV":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}},"JSON":{"type":"structure","members":{"RecordDelimiter":{}}}}}}}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListBuckets":{"result_key":"Buckets"},"ListMultipartUploads":{"input_token":["KeyMarker","UploadIdMarker"],"limit_key":"MaxUploads","more_results":"IsTruncated","output_token":["NextKeyMarker","NextUploadIdMarker"],"result_key":["Uploads","CommonPrefixes"]},"ListObjectVersions":{"input_token":["KeyMarker","VersionIdMarker"],"limit_key":"MaxKeys","more_results":"IsTruncated","output_token":["NextKeyMarker","NextVersionIdMarker"],"result_key":["Versions","DeleteMarkers","CommonPrefixes"]},"ListObjects":{"input_token":"Marker","limit_key":"MaxKeys","more_results":"IsTruncated","output_token":"NextMarker || Contents[-1].Key","result_key":["Contents","CommonPrefixes"]},"ListObjectsV2":{"input_token":"ContinuationToken","limit_key":"MaxKeys","output_token":"NextContinuationToken","result_key":["Contents","CommonPrefixes"]},"ListParts":{"input_token":"PartNumberMarker","limit_key":"MaxParts","more_results":"IsTruncated","output_token":"NextPartNumberMarker","result_key":"Parts"}}}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"BucketExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":301,"matcher":"status","state":"success"},{"expected":403,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"BucketNotExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]},"ObjectExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"ObjectNotExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]}}}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-17","endpointPrefix":"secretsmanager","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Secrets Manager","serviceId":"Secrets Manager","signatureVersion":"v4","signingName":"secretsmanager","targetPrefix":"secretsmanager","uid":"secretsmanager-2017-10-17"},"operations":{"CancelRotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"CreateSecret":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"DeleteSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"RecoveryWindowInDays":{"type":"long"},"ForceDeleteWithoutRecovery":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"DeletionDate":{"type":"timestamp"}}}},"DescribeSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"Su"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"Tags":{"shape":"Se"},"VersionIdsToStages":{"shape":"S10"},"OwningService":{}}}},"GetRandomPassword":{"input":{"type":"structure","members":{"PasswordLength":{"type":"long"},"ExcludeCharacters":{},"ExcludeNumbers":{"type":"boolean"},"ExcludePunctuation":{"type":"boolean"},"ExcludeUppercase":{"type":"boolean"},"ExcludeLowercase":{"type":"boolean"},"IncludeSpace":{"type":"boolean"},"RequireEachIncludedType":{"type":"boolean"}}},"output":{"type":"structure","members":{"RandomPassword":{"type":"string","sensitive":true}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"ResourcePolicy":{}}}},"GetSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"VersionId":{},"VersionStage":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"VersionStages":{"shape":"S11"},"CreatedDate":{"type":"timestamp"}}}},"ListSecretVersionIds":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"MaxResults":{"type":"integer"},"NextToken":{},"IncludeDeprecated":{"type":"boolean"}}},"output":{"type":"structure","members":{"Versions":{"type":"list","member":{"type":"structure","members":{"VersionId":{},"VersionStages":{"shape":"S11"},"LastAccessedDate":{"type":"timestamp"},"CreatedDate":{"type":"timestamp"}}}},"NextToken":{},"ARN":{},"Name":{}}}},"ListSecrets":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SecretList":{"type":"list","member":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"Su"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"Tags":{"shape":"Se"},"SecretVersionsToStages":{"shape":"S10"},"OwningService":{}}}},"NextToken":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["SecretId","ResourcePolicy"],"members":{"SecretId":{},"ResourcePolicy":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"PutSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"VersionStages":{"shape":"S11"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"VersionStages":{"shape":"S11"}}}},"RestoreSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"RotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"RotationLambdaARN":{},"RotationRules":{"shape":"Su"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"TagResource":{"input":{"type":"structure","required":["SecretId","Tags"],"members":{"SecretId":{},"Tags":{"shape":"Se"}}}},"UntagResource":{"input":{"type":"structure","required":["SecretId","TagKeys"],"members":{"SecretId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"UpdateSecretVersionStage":{"input":{"type":"structure","required":["SecretId","VersionStage"],"members":{"SecretId":{},"VersionStage":{},"RemoveFromVersionId":{},"MoveToVersionId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}}},"shapes":{"Sc":{"type":"blob","sensitive":true},"Sd":{"type":"string","sensitive":true},"Se":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Su":{"type":"structure","members":{"AutomaticallyAfterDays":{"type":"long"}}},"S10":{"type":"map","key":{},"value":{"shape":"S11"}},"S11":{"type":"list","member":{}}}}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListSecretVersionIds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecrets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-10","endpointPrefix":"servicecatalog","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Service Catalog","serviceId":"Service Catalog","signatureVersion":"v4","targetPrefix":"AWS242ServiceCatalogService","uid":"servicecatalog-2015-12-10"},"operations":{"AcceptPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"AssociateBudgetWithResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"AssociatePrincipalWithPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN","PrincipalType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"AssociateProductWithPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"AssociateTagOptionWithResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sm"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sp"}}}},"BatchDisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sm"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sp"}}}},"CopyProduct":{"input":{"type":"structure","required":["SourceProductArn","IdempotencyToken"],"members":{"AcceptLanguage":{},"SourceProductArn":{},"TargetProductId":{},"TargetProductName":{},"SourceProvisioningArtifactIdentifiers":{"type":"list","member":{"type":"map","key":{},"value":{}}},"CopyOptions":{"type":"list","member":{}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CopyProductToken":{}}}},"CreateConstraint":{"input":{"type":"structure","required":["PortfolioId","ProductId","Parameters","Type","IdempotencyToken"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"Parameters":{},"Type":{},"Description":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"CreatePortfolio":{"input":{"type":"structure","required":["DisplayName","ProviderName","IdempotencyToken"],"members":{"AcceptLanguage":{},"DisplayName":{},"Description":{},"ProviderName":{},"Tags":{"shape":"S1i"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"CreatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"CreateProduct":{"input":{"type":"structure","required":["Name","Owner","ProductType","ProvisioningArtifactParameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"ProductType":{},"Tags":{"shape":"S1i"},"ProvisioningArtifactParameters":{"shape":"S23"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2c"},"ProvisioningArtifactDetail":{"shape":"S2h"},"Tags":{"shape":"S1q"}}}},"CreateProvisionedProductPlan":{"input":{"type":"structure","required":["PlanName","PlanType","ProductId","ProvisionedProductName","ProvisioningArtifactId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanName":{},"PlanType":{},"NotificationArns":{"shape":"S2n"},"PathId":{},"ProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{},"ProvisioningParameters":{"shape":"S2q"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"S1q"}}},"output":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{}}}},"CreateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","Parameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"Parameters":{"shape":"S23"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2h"},"Info":{"shape":"S26"},"Status":{}}}},"CreateServiceAction":{"input":{"type":"structure","required":["Name","DefinitionType","Definition","IdempotencyToken"],"members":{"Name":{},"DefinitionType":{},"Definition":{"shape":"S31"},"Description":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S36"}}}},"CreateTagOption":{"input":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3c"}}}},"DeleteConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"DeleteProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeleteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"IgnoreErrors":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{}}},"output":{"type":"structure","members":{}}},"DeleteServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"DeleteTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DescribeConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"DescribeCopyProductStatus":{"input":{"type":"structure","required":["CopyProductToken"],"members":{"AcceptLanguage":{},"CopyProductToken":{}}},"output":{"type":"structure","members":{"CopyProductStatus":{},"TargetProductId":{},"StatusDetail":{}}}},"DescribePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S43"},"Budgets":{"shape":"S44"}}}},"DescribePortfolioShareStatus":{"input":{"type":"structure","required":["PortfolioShareToken"],"members":{"PortfolioShareToken":{}}},"output":{"type":"structure","members":{"PortfolioShareToken":{},"PortfolioId":{},"OrganizationNodeValue":{},"Status":{},"ShareDetails":{"type":"structure","members":{"SuccessfulShares":{"type":"list","member":{}},"ShareErrors":{"type":"list","member":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Message":{},"Error":{}}}}}}}}},"DescribeProduct":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"ProvisioningArtifacts":{"shape":"S4i"},"Budgets":{"shape":"S44"},"LaunchPaths":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}},"DescribeProductAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2c"},"ProvisioningArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProvisioningArtifactMetadata":{"shape":"S26"}}}},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S43"},"Budgets":{"shape":"S44"}}}},"DescribeProductView":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"ProvisioningArtifacts":{"shape":"S4i"}}}},"DescribeProvisionedProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProvisionedProductDetail":{"shape":"S4w"},"CloudWatchDashboards":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}},"DescribeProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProductPlanDetails":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"PathId":{},"ProductId":{},"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{},"Status":{},"UpdatedTime":{"type":"timestamp"},"NotificationArns":{"shape":"S2n"},"ProvisioningParameters":{"shape":"S2q"},"Tags":{"shape":"S1q"},"StatusMessage":{}}},"ResourceChanges":{"type":"list","member":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"CausingEntity":{}}}}}}},"NextPageToken":{}}}},"DescribeProvisioningArtifact":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisioningArtifactId":{},"ProductId":{},"ProvisioningArtifactName":{},"ProductName":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2h"},"Info":{"shape":"S26"},"Status":{}}}},"DescribeProvisioningParameters":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactParameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"IsNoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"ConstraintSummaries":{"shape":"S68"},"UsageInstructions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"TagOptions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ProvisioningArtifactPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6i"},"StackSetRegions":{"shape":"S6j"}}}}}},"DescribeRecord":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6n"},"RecordOutputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{}}}},"NextPageToken":{}}}},"DescribeServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S36"}}}},"DescribeServiceActionExecutionParameters":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionParameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"DefaultValues":{"shape":"S7a"}}}}}}},"DescribeTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3c"}}}},"DisableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateBudgetFromResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"DisassociatePrincipalFromPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{}}},"output":{"type":"structure","members":{}}},"DisassociateProductFromPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"DisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"DisassociateTagOptionFromResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"EnableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ExecuteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6n"}}}},"ExecuteProvisionedProductServiceAction":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId","ExecuteToken"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"ExecuteToken":{"idempotencyToken":true},"AcceptLanguage":{},"Parameters":{"type":"map","key":{},"value":{"shape":"S7a"}}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6n"}}}},"GetAWSOrganizationsAccessStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccessStatus":{}}}},"ListAcceptedPortfolioShares":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"},"PortfolioShareType":{}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S82"},"NextPageToken":{}}}},"ListBudgetsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"AcceptLanguage":{},"ResourceId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Budgets":{"shape":"S44"},"NextPageToken":{}}}},"ListConstraintsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ConstraintDetails":{"type":"list","member":{"shape":"S1b"}},"NextPageToken":{}}}},"ListLaunchPaths":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"LaunchPathSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"ConstraintSummaries":{"shape":"S68"},"Tags":{"shape":"S1q"},"Name":{}}}},"NextPageToken":{}}}},"ListOrganizationPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId","OrganizationNodeType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationNodeType":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationNodes":{"type":"list","member":{"shape":"S1s"}},"NextPageToken":{}}}},"ListPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationParentId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextPageToken":{}}}},"ListPortfolios":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S82"},"NextPageToken":{}}}},"ListPortfoliosForProduct":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S82"},"NextPageToken":{}}}},"ListPrincipalsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"PrincipalARN":{},"PrincipalType":{}}}},"NextPageToken":{}}}},"ListProvisionedProductPlans":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionProductId":{},"PageSize":{"type":"integer"},"PageToken":{},"AccessLevelFilter":{"shape":"S8r"}}},"output":{"type":"structure","members":{"ProvisionedProductPlans":{"type":"list","member":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{}}}},"NextPageToken":{}}}},"ListProvisioningArtifacts":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetails":{"type":"list","member":{"shape":"S2h"}},"NextPageToken":{}}}},"ListProvisioningArtifactsForServiceAction":{"input":{"type":"structure","required":["ServiceActionId"],"members":{"ServiceActionId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactViews":{"type":"list","member":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"ProvisioningArtifact":{"shape":"S4j"}}}},"NextPageToken":{}}}},"ListRecordHistory":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S8r"},"SearchFilter":{"type":"structure","members":{"Key":{},"Value":{}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"RecordDetails":{"type":"list","member":{"shape":"S6n"}},"NextPageToken":{}}}},"ListResourcesForTagOption":{"input":{"type":"structure","required":["TagOptionId"],"members":{"TagOptionId":{},"ResourceType":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ResourceDetails":{"type":"list","member":{"type":"structure","members":{"Id":{},"ARN":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"PageToken":{}}}},"ListServiceActions":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"S9m"},"NextPageToken":{}}}},"ListServiceActionsForProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"S9m"},"NextPageToken":{}}}},"ListStackInstancesForProvisionedProduct":{"input":{"type":"structure","required":["ProvisionedProductId"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"StackInstances":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"StackInstanceStatus":{}}}},"NextPageToken":{}}}},"ListTagOptions":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"TagOptionDetails":{"shape":"S43"},"PageToken":{}}}},"ProvisionProduct":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ProvisionedProductName","ProvisionToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisionedProductName":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6i"},"StackSetRegions":{"shape":"S6j"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"}}},"Tags":{"shape":"S1q"},"NotificationArns":{"shape":"S2n"},"ProvisionToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6n"}}}},"RejectPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"ScanProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S8r"},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"shape":"S4w"}},"NextPageToken":{}}}},"SearchProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Filters":{"shape":"Sac"},"PageSize":{"type":"integer"},"SortBy":{},"SortOrder":{},"PageToken":{}}},"output":{"type":"structure","members":{"ProductViewSummaries":{"type":"list","member":{"shape":"S2d"}},"ProductViewAggregations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Value":{},"ApproximateCount":{"type":"integer"}}}}},"NextPageToken":{}}}},"SearchProductsAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PortfolioId":{},"Filters":{"shape":"Sac"},"SortBy":{},"SortOrder":{},"PageToken":{},"PageSize":{"type":"integer"},"ProductSource":{}}},"output":{"type":"structure","members":{"ProductViewDetails":{"type":"list","member":{"shape":"S2c"}},"NextPageToken":{}}}},"SearchProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S8r"},"Filters":{"type":"map","key":{},"value":{"type":"list","member":{}}},"SortBy":{},"SortOrder":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"Tags":{"shape":"S1q"},"PhysicalId":{},"ProductId":{},"ProvisioningArtifactId":{},"UserArn":{},"UserArnSession":{}}}},"TotalResultsCount":{"type":"integer"},"NextPageToken":{}}}},"TerminateProvisionedProduct":{"input":{"type":"structure","required":["TerminateToken"],"members":{"ProvisionedProductName":{},"ProvisionedProductId":{},"TerminateToken":{"idempotencyToken":true},"IgnoreErrors":{"type":"boolean"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6n"}}}},"UpdateConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Description":{},"Parameters":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"UpdatePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"DisplayName":{},"Description":{},"ProviderName":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sbd"}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"UpdateProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sbd"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2c"},"Tags":{"shape":"S1q"}}}},"UpdateProvisionedProduct":{"input":{"type":"structure","required":["UpdateToken"],"members":{"AcceptLanguage":{},"ProvisionedProductName":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisioningParameters":{"shape":"S2q"},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6i"},"StackSetRegions":{"shape":"S6j"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"},"StackSetOperationType":{}}},"Tags":{"shape":"S1q"},"UpdateToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6n"}}}},"UpdateProvisionedProductProperties":{"input":{"type":"structure","required":["ProvisionedProductId","ProvisionedProductProperties","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sbm"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sbm"},"RecordId":{},"Status":{}}}},"UpdateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"Name":{},"Description":{},"Active":{"type":"boolean"},"Guidance":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2h"},"Info":{"shape":"S26"},"Status":{}}}},"UpdateServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Name":{},"Definition":{"shape":"S31"},"Description":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S36"}}}},"UpdateTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Value":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3c"}}}}},"shapes":{"Sm":{"type":"list","member":{"type":"structure","required":["ServiceActionId","ProductId","ProvisioningArtifactId"],"members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{}}}},"Sp":{"type":"list","member":{"type":"structure","members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{},"ErrorCode":{},"ErrorMessage":{}}}},"S1b":{"type":"structure","members":{"ConstraintId":{},"Type":{},"Description":{},"Owner":{},"ProductId":{},"PortfolioId":{}}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S1n":{"type":"structure","members":{"Id":{},"ARN":{},"DisplayName":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProviderName":{}}},"S1q":{"type":"list","member":{"shape":"S1j"}},"S1s":{"type":"structure","members":{"Type":{},"Value":{}}},"S23":{"type":"structure","required":["Info"],"members":{"Name":{},"Description":{},"Info":{"shape":"S26"},"Type":{},"DisableTemplateValidation":{"type":"boolean"}}},"S26":{"type":"map","key":{},"value":{}},"S2c":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"Status":{},"ProductARN":{},"CreatedTime":{"type":"timestamp"}}},"S2d":{"type":"structure","members":{"Id":{},"ProductId":{},"Name":{},"Owner":{},"ShortDescription":{},"Type":{},"Distributor":{},"HasDefaultPath":{"type":"boolean"},"SupportEmail":{},"SupportDescription":{},"SupportUrl":{}}},"S2h":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Type":{},"CreatedTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Guidance":{}}},"S2n":{"type":"list","member":{}},"S2q":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"UsePreviousValue":{"type":"boolean"}}}},"S31":{"type":"map","key":{},"value":{}},"S36":{"type":"structure","members":{"ServiceActionSummary":{"shape":"S37"},"Definition":{"shape":"S31"}}},"S37":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"DefinitionType":{}}},"S3c":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"},"Id":{}}},"S43":{"type":"list","member":{"shape":"S3c"}},"S44":{"type":"list","member":{"type":"structure","members":{"BudgetName":{}}}},"S4i":{"type":"list","member":{"shape":"S4j"}},"S4j":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"Guidance":{}}},"S4w":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"ProductId":{},"ProvisioningArtifactId":{}}},"S68":{"type":"list","member":{"type":"structure","members":{"Type":{},"Description":{}}}},"S6i":{"type":"list","member":{}},"S6j":{"type":"list","member":{}},"S6n":{"type":"structure","members":{"RecordId":{},"ProvisionedProductName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ProvisionedProductType":{},"RecordType":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"RecordErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Description":{}}}},"RecordTags":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S7a":{"type":"list","member":{}},"S82":{"type":"list","member":{"shape":"S1n"}},"S8r":{"type":"structure","members":{"Key":{},"Value":{}}},"S9m":{"type":"list","member":{"shape":"S37"}},"Sac":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sbd":{"type":"list","member":{}},"Sbm":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAcceptedPortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListBudgetsForResource":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListConstraintsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListLaunchPaths":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListOrganizationPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolios":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfoliosForProduct":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPrincipalsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListProvisioningArtifactsForServiceAction":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListResourcesForTagOption":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"ListServiceActions":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListServiceActionsForProvisioningArtifact":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListTagOptions":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"SearchProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProductsAsAdmin":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProvisionedProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"}}}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-03-31","endpointPrefix":"sns","protocol":"query","serviceAbbreviation":"Amazon SNS","serviceFullName":"Amazon Simple Notification Service","serviceId":"SNS","signatureVersion":"v4","uid":"sns-2010-03-31","xmlNamespace":"http://sns.amazonaws.com/doc/2010-03-31/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["TopicArn","Label","AWSAccountId","ActionName"],"members":{"TopicArn":{},"Label":{},"AWSAccountId":{"type":"list","member":{}},"ActionName":{"type":"list","member":{}}}}},"CheckIfPhoneNumberIsOptedOut":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"CheckIfPhoneNumberIsOptedOutResult","type":"structure","members":{"isOptedOut":{"type":"boolean"}}}},"ConfirmSubscription":{"input":{"type":"structure","required":["TopicArn","Token"],"members":{"TopicArn":{},"Token":{},"AuthenticateOnUnsubscribe":{}}},"output":{"resultWrapper":"ConfirmSubscriptionResult","type":"structure","members":{"SubscriptionArn":{}}}},"CreatePlatformApplication":{"input":{"type":"structure","required":["Name","Platform","Attributes"],"members":{"Name":{},"Platform":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformApplicationResult","type":"structure","members":{"PlatformApplicationArn":{}}}},"CreatePlatformEndpoint":{"input":{"type":"structure","required":["PlatformApplicationArn","Token"],"members":{"PlatformApplicationArn":{},"Token":{},"CustomUserData":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformEndpointResult","type":"structure","members":{"EndpointArn":{}}}},"CreateTopic":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Attributes":{"shape":"Sp"},"Tags":{"shape":"Ss"}}},"output":{"resultWrapper":"CreateTopicResult","type":"structure","members":{"TopicArn":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"DeletePlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}}},"DeleteTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}},"GetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"resultWrapper":"GetEndpointAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}},"output":{"resultWrapper":"GetPlatformApplicationAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetSMSAttributes":{"input":{"type":"structure","members":{"attributes":{"type":"list","member":{}}}},"output":{"resultWrapper":"GetSMSAttributesResult","type":"structure","members":{"attributes":{"shape":"Sj"}}}},"GetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"resultWrapper":"GetSubscriptionAttributesResult","type":"structure","members":{"Attributes":{"shape":"S19"}}}},"GetTopicAttributes":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"output":{"resultWrapper":"GetTopicAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sp"}}}},"ListEndpointsByPlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListEndpointsByPlatformApplicationResult","type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListPhoneNumbersOptedOut":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"resultWrapper":"ListPhoneNumbersOptedOutResult","type":"structure","members":{"phoneNumbers":{"type":"list","member":{}},"nextToken":{}}}},"ListPlatformApplications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListPlatformApplicationsResult","type":"structure","members":{"PlatformApplications":{"type":"list","member":{"type":"structure","members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListSubscriptions":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsResult","type":"structure","members":{"Subscriptions":{"shape":"S1r"},"NextToken":{}}}},"ListSubscriptionsByTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsByTopicResult","type":"structure","members":{"Subscriptions":{"shape":"S1r"},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"Ss"}}}},"ListTopics":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListTopicsResult","type":"structure","members":{"Topics":{"type":"list","member":{"type":"structure","members":{"TopicArn":{}}}},"NextToken":{}}}},"OptInPhoneNumber":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"OptInPhoneNumberResult","type":"structure","members":{}}},"Publish":{"input":{"type":"structure","required":["Message"],"members":{"TopicArn":{},"TargetArn":{},"PhoneNumber":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"DataType":{},"StringValue":{},"BinaryValue":{"type":"blob"}}}}}},"output":{"resultWrapper":"PublishResult","type":"structure","members":{"MessageId":{}}}},"RemovePermission":{"input":{"type":"structure","required":["TopicArn","Label"],"members":{"TopicArn":{},"Label":{}}}},"SetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn","Attributes"],"members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"SetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn","Attributes"],"members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"SetSMSAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"SetSMSAttributesResult","type":"structure","members":{}}},"SetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn","AttributeName"],"members":{"SubscriptionArn":{},"AttributeName":{},"AttributeValue":{}}}},"SetTopicAttributes":{"input":{"type":"structure","required":["TopicArn","AttributeName"],"members":{"TopicArn":{},"AttributeName":{},"AttributeValue":{}}}},"Subscribe":{"input":{"type":"structure","required":["TopicArn","Protocol"],"members":{"TopicArn":{},"Protocol":{},"Endpoint":{},"Attributes":{"shape":"S19"},"ReturnSubscriptionArn":{"type":"boolean"}}},"output":{"resultWrapper":"SubscribeResult","type":"structure","members":{"SubscriptionArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Ss"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"Unsubscribe":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}}},"shapes":{"Sj":{"type":"map","key":{},"value":{}},"Sp":{"type":"map","key":{},"value":{}},"Ss":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S19":{"type":"map","key":{},"value":{}},"S1r":{"type":"list","member":{"type":"structure","members":{"SubscriptionArn":{},"Owner":{},"Protocol":{},"Endpoint":{},"TopicArn":{}}}}}}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEndpointsByPlatformApplication":{"input_token":"NextToken","output_token":"NextToken","result_key":"Endpoints"},"ListPlatformApplications":{"input_token":"NextToken","output_token":"NextToken","result_key":"PlatformApplications"},"ListSubscriptions":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListSubscriptionsByTopic":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListTopics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Topics"}}}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-11-05","endpointPrefix":"sqs","protocol":"query","serviceAbbreviation":"Amazon SQS","serviceFullName":"Amazon Simple Queue Service","serviceId":"SQS","signatureVersion":"v4","uid":"sqs-2012-11-05","xmlNamespace":"http://queue.amazonaws.com/doc/2012-11-05/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["QueueUrl","Label","AWSAccountIds","Actions"],"members":{"QueueUrl":{},"Label":{},"AWSAccountIds":{"type":"list","member":{"locationName":"AWSAccountId"},"flattened":true},"Actions":{"type":"list","member":{"locationName":"ActionName"},"flattened":true}}}},"ChangeMessageVisibility":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle","VisibilityTimeout"],"members":{"QueueUrl":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}}},"ChangeMessageVisibilityBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}},"flattened":true}}},"output":{"resultWrapper":"ChangeMessageVisibilityBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"CreateQueue":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"Attributes":{"shape":"Sh","locationName":"Attribute"},"tags":{"shape":"Sj","locationName":"Tag"}}},"output":{"resultWrapper":"CreateQueueResult","type":"structure","members":{"QueueUrl":{}}}},"DeleteMessage":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle"],"members":{"QueueUrl":{},"ReceiptHandle":{}}}},"DeleteMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"DeleteMessageBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{}}},"flattened":true}}},"output":{"resultWrapper":"DeleteMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"DeleteMessageBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"DeleteQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"GetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sw"}}},"output":{"resultWrapper":"GetQueueAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"GetQueueUrl":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"QueueOwnerAWSAccountId":{}}},"output":{"resultWrapper":"GetQueueUrlResult","type":"structure","members":{"QueueUrl":{}}}},"ListDeadLetterSourceQueues":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListDeadLetterSourceQueuesResult","type":"structure","required":["queueUrls"],"members":{"queueUrls":{"shape":"S14"},"NextToken":{}}}},"ListQueueTags":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListQueueTagsResult","type":"structure","members":{"Tags":{"shape":"Sj","locationName":"Tag"}}}},"ListQueues":{"input":{"type":"structure","members":{"QueueNamePrefix":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListQueuesResult","type":"structure","members":{"QueueUrls":{"shape":"S14"},"NextToken":{}}}},"PurgeQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"ReceiveMessage":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sw"},"MessageAttributeNames":{"type":"list","member":{"locationName":"MessageAttributeName"},"flattened":true},"MaxNumberOfMessages":{"type":"integer"},"VisibilityTimeout":{"type":"integer"},"WaitTimeSeconds":{"type":"integer"},"ReceiveRequestAttemptId":{}}},"output":{"resultWrapper":"ReceiveMessageResult","type":"structure","members":{"Messages":{"type":"list","member":{"locationName":"Message","type":"structure","members":{"MessageId":{},"ReceiptHandle":{},"MD5OfBody":{},"Body":{},"Attributes":{"locationName":"Attribute","type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true},"MD5OfMessageAttributes":{},"MessageAttributes":{"shape":"S1i","locationName":"MessageAttribute"}}},"flattened":true}}}},"RemovePermission":{"input":{"type":"structure","required":["QueueUrl","Label"],"members":{"QueueUrl":{},"Label":{}}}},"SendMessage":{"input":{"type":"structure","required":["QueueUrl","MessageBody"],"members":{"QueueUrl":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1i","locationName":"MessageAttribute"},"MessageSystemAttributes":{"shape":"S1p","locationName":"MessageSystemAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"SendMessageResult","type":"structure","members":{"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MD5OfMessageSystemAttributes":{},"MessageId":{},"SequenceNumber":{}}}},"SendMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"SendMessageBatchRequestEntry","type":"structure","required":["Id","MessageBody"],"members":{"Id":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1i","locationName":"MessageAttribute"},"MessageSystemAttributes":{"shape":"S1p","locationName":"MessageSystemAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"flattened":true}}},"output":{"resultWrapper":"SendMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"SendMessageBatchResultEntry","type":"structure","required":["Id","MessageId","MD5OfMessageBody"],"members":{"Id":{},"MessageId":{},"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MD5OfMessageSystemAttributes":{},"SequenceNumber":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"SetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl","Attributes"],"members":{"QueueUrl":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"TagQueue":{"input":{"type":"structure","required":["QueueUrl","Tags"],"members":{"QueueUrl":{},"Tags":{"shape":"Sj"}}}},"UntagQueue":{"input":{"type":"structure","required":["QueueUrl","TagKeys"],"members":{"QueueUrl":{},"TagKeys":{"type":"list","member":{"locationName":"TagKey"},"flattened":true}}}}},"shapes":{"Sd":{"type":"list","member":{"locationName":"BatchResultErrorEntry","type":"structure","required":["Id","SenderFault","Code"],"members":{"Id":{},"SenderFault":{"type":"boolean"},"Code":{},"Message":{}}},"flattened":true},"Sh":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Attribute"},"Sj":{"type":"map","key":{"locationName":"Key"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Tag"},"Sw":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"S14":{"type":"list","member":{"locationName":"QueueUrl"},"flattened":true},"S1i":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"shape":"S1l","flattened":true,"locationName":"StringListValue"},"BinaryListValues":{"shape":"S1m","flattened":true,"locationName":"BinaryListValue"},"DataType":{}}},"flattened":true},"S1l":{"type":"list","member":{"locationName":"StringListValue"}},"S1m":{"type":"list","member":{"locationName":"BinaryListValue","type":"blob"}},"S1p":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"shape":"S1l","flattened":true,"locationName":"StringListValue"},"BinaryListValues":{"shape":"S1m","flattened":true,"locationName":"BinaryListValue"},"DataType":{}}},"flattened":true}}}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDeadLetterSourceQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"queueUrls"},"ListQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueueUrls"}}}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-06","endpointPrefix":"ssm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon SSM","serviceFullName":"Amazon Simple Systems Manager (SSM)","serviceId":"SSM","signatureVersion":"v4","targetPrefix":"AmazonSSM","uid":"ssm-2014-11-06"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","Tags"],"members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"CancelCommand":{"input":{"type":"structure","required":["CommandId"],"members":{"CommandId":{},"InstanceIds":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"CancelMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{}}}},"CreateActivation":{"input":{"type":"structure","required":["IamRole"],"members":{"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"ActivationId":{},"ActivationCode":{}}}},"CreateAssociation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"InstanceId":{},"Parameters":{"shape":"St"},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"AssociationName":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1g"}}}},"CreateAssociationBatch":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"shape":"S1u"}}}},"output":{"type":"structure","members":{"Successful":{"type":"list","member":{"shape":"S1g"}},"Failed":{"type":"list","member":{"type":"structure","members":{"Entry":{"shape":"S1u"},"Message":{},"Fault":{}}}}}}},"CreateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Requires":{"shape":"S23"},"Attachments":{"shape":"S25"},"Name":{},"VersionName":{},"DocumentType":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S2h"}}}},"CreateMaintenanceWindow":{"input":{"type":"structure","required":["Name","Schedule","Duration","Cutoff","AllowUnassociatedTargets"],"members":{"Name":{},"Description":{"shape":"S33"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"WindowId":{}}}},"CreateOpsItem":{"input":{"type":"structure","required":["Description","Source","Title"],"members":{"Description":{},"OperationalData":{"shape":"S3g"},"Notifications":{"shape":"S3l"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S3p"},"Source":{},"Title":{},"Tags":{"shape":"S4"},"Category":{},"Severity":{}}},"output":{"type":"structure","members":{"OpsItemId":{}}}},"CreatePatchBaseline":{"input":{"type":"structure","required":["Name"],"members":{"OperatingSystem":{},"Name":{},"GlobalFilters":{"shape":"S3z"},"ApprovalRules":{"shape":"S45"},"ApprovedPatches":{"shape":"S4c"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S4c"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S4g"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"CreateResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{},"S3Destination":{"shape":"S4q"},"SyncType":{},"SyncSource":{"shape":"S4z"}}},"output":{"type":"structure","members":{}}},"DeleteActivation":{"input":{"type":"structure","required":["ActivationId"],"members":{"ActivationId":{}}},"output":{"type":"structure","members":{}}},"DeleteAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteInventory":{"input":{"type":"structure","required":["TypeName"],"members":{"TypeName":{},"SchemaDeleteOption":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionSummary":{"shape":"S5m"}}}},"DeleteMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{}}}},"DeleteParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S5z"}}},"output":{"type":"structure","members":{"DeletedParameters":{"shape":"S5z"},"InvalidParameters":{"shape":"S5z"}}}},"DeletePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"DeleteResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{},"SyncType":{}}},"output":{"type":"structure","members":{}}},"DeregisterManagedInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}},"output":{"type":"structure","members":{}}},"DeregisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"DeregisterTargetFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Safe":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{}}}},"DeregisterTaskFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{}}}},"DescribeActivations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ActivationList":{"type":"list","member":{"type":"structure","members":{"ActivationId":{},"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"RegistrationsCount":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Expired":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"DescribeAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1g"}}}},"DescribeAssociationExecutionTargets":{"input":{"type":"structure","required":["AssociationId","ExecutionId"],"members":{"AssociationId":{},"ExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutionTargets":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"ResourceId":{},"ResourceType":{},"Status":{},"DetailedStatus":{},"LastExecutionDate":{"type":"timestamp"},"OutputSource":{"type":"structure","members":{"OutputSourceId":{},"OutputSourceType":{}}}}}},"NextToken":{}}}},"DescribeAssociationExecutions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value","Type"],"members":{"Key":{},"Value":{},"Type":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"Status":{},"DetailedStatus":{},"CreatedTime":{"type":"timestamp"},"LastExecutionDate":{"type":"timestamp"},"ResourceCountByStatus":{}}}},"NextToken":{}}}},"DescribeAutomationExecutions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionMetadataList":{"type":"list","member":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"AutomationExecutionStatus":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"ExecutedBy":{},"LogFile":{},"Outputs":{"shape":"S7u"},"Mode":{},"ParentAutomationExecutionId":{},"CurrentStepName":{},"CurrentAction":{},"FailureMessage":{},"TargetParameterName":{},"Targets":{"shape":"Sx"},"TargetMaps":{"shape":"S7z"},"ResolvedTargets":{"shape":"S84"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"AutomationType":{}}}},"NextToken":{}}}},"DescribeAutomationStepExecutions":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxResults":{"type":"integer"},"ReverseOrder":{"type":"boolean"}}},"output":{"type":"structure","members":{"StepExecutions":{"shape":"S8e"},"NextToken":{}}}},"DescribeAvailablePatches":{"input":{"type":"structure","members":{"Filters":{"shape":"S8u"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"shape":"S92"}},"NextToken":{}}}},"DescribeDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{}}},"output":{"type":"structure","members":{"Document":{"shape":"S2h"}}}},"DescribeDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"S9j"},"AccountSharingInfoList":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"SharedDocumentVersion":{}}}}}}},"DescribeEffectiveInstanceAssociations":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"InstanceId":{},"Content":{},"AssociationVersion":{}}}},"NextToken":{}}}},"DescribeEffectivePatchesForPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EffectivePatches":{"type":"list","member":{"type":"structure","members":{"Patch":{"shape":"S92"},"PatchStatus":{"type":"structure","members":{"DeploymentStatus":{},"ComplianceLevel":{},"ApprovalDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeInstanceAssociationsStatus":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceAssociationStatusInfos":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Name":{},"DocumentVersion":{},"AssociationVersion":{},"InstanceId":{},"ExecutionDate":{"type":"timestamp"},"Status":{},"DetailedStatus":{},"ExecutionSummary":{},"ErrorCode":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{"type":"structure","members":{"OutputUrl":{}}}}},"AssociationName":{}}}},"NextToken":{}}}},"DescribeInstanceInformation":{"input":{"type":"structure","members":{"InstanceInformationFilterList":{"type":"list","member":{"type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"Sac"}}}},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"Sac"}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceInformationList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"IsLatestVersion":{"type":"boolean"},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"Name":{},"IPAddress":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"type":"structure","members":{"DetailedStatus":{},"InstanceAssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}}}}},"NextToken":{}}}},"DescribeInstancePatchStates":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sb"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Saw"}},"NextToken":{}}}},"DescribeInstancePatchStatesForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Type"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Saw"}},"NextToken":{}}}},"DescribeInstancePatches":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Filters":{"shape":"S8u"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"type":"structure","required":["Title","KBId","Classification","Severity","State","InstalledTime"],"members":{"Title":{},"KBId":{},"Classification":{},"Severity":{},"State":{},"InstalledTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeInventoryDeletions":{"input":{"type":"structure","members":{"DeletionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InventoryDeletions":{"type":"list","member":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionStartTime":{"type":"timestamp"},"LastStatus":{},"LastStatusMessage":{},"DeletionSummary":{"shape":"S5m"},"LastStatusUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{},"Filters":{"shape":"Sbz"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskInvocationIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Scb"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Saz"},"WindowTargetId":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTasks":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{},"Filters":{"shape":"Sbz"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TaskArn":{},"TaskType":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutions":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sbz"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowSchedule":{"input":{"type":"structure","members":{"WindowId":{},"Targets":{"shape":"Sx"},"ResourceType":{},"Filters":{"shape":"S8u"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledWindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"ExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTargets":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sbz"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"ResourceType":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saz"},"Name":{},"Description":{"shape":"S33"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTasks":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sbz"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"TaskArn":{},"Type":{},"Targets":{"shape":"Sx"},"TaskParameters":{"shape":"Sd2"},"Priority":{"type":"integer"},"LoggingInfo":{"shape":"Sd8"},"ServiceRoleArn":{},"MaxConcurrency":{},"MaxErrors":{},"Name":{},"Description":{"shape":"S33"}}}},"NextToken":{}}}},"DescribeMaintenanceWindows":{"input":{"type":"structure","members":{"Filters":{"shape":"Sbz"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S33"},"Enabled":{"type":"boolean"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"EndDate":{},"StartDate":{},"NextExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowsForTarget":{"input":{"type":"structure","required":["Targets","ResourceType"],"members":{"Targets":{"shape":"Sx"},"ResourceType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{}}}},"NextToken":{}}}},"DescribeOpsItems":{"input":{"type":"structure","members":{"OpsItemFilters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"OpsItemSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedBy":{},"CreatedTime":{"type":"timestamp"},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Priority":{"type":"integer"},"Source":{},"Status":{},"OpsItemId":{},"Title":{},"OperationalData":{"shape":"S3g"},"Category":{},"Severity":{}}}}}}},"DescribeParameters":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ParameterFilters":{"shape":"Se2"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"AllowedPattern":{},"Version":{"type":"long"},"Tier":{},"Policies":{"shape":"Seh"},"DataType":{}}}},"NextToken":{}}}},"DescribePatchBaselines":{"input":{"type":"structure","members":{"Filters":{"shape":"S8u"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BaselineIdentities":{"type":"list","member":{"shape":"Sen"}},"NextToken":{}}}},"DescribePatchGroupState":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{}}},"output":{"type":"structure","members":{"Instances":{"type":"integer"},"InstancesWithInstalledPatches":{"type":"integer"},"InstancesWithInstalledOtherPatches":{"type":"integer"},"InstancesWithInstalledPendingRebootPatches":{"type":"integer"},"InstancesWithInstalledRejectedPatches":{"type":"integer"},"InstancesWithMissingPatches":{"type":"integer"},"InstancesWithFailedPatches":{"type":"integer"},"InstancesWithNotApplicablePatches":{"type":"integer"},"InstancesWithUnreportedNotApplicablePatches":{"type":"integer"}}}},"DescribePatchGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Filters":{"shape":"S8u"},"NextToken":{}}},"output":{"type":"structure","members":{"Mappings":{"type":"list","member":{"type":"structure","members":{"PatchGroup":{},"BaselineIdentity":{"shape":"Sen"}}}},"NextToken":{}}}},"DescribePatchProperties":{"input":{"type":"structure","required":["OperatingSystem","Property"],"members":{"OperatingSystem":{},"Property":{},"PatchSet":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Properties":{"type":"list","member":{"type":"map","key":{},"value":{}}},"NextToken":{}}}},"DescribeSessions":{"input":{"type":"structure","required":["State"],"members":{"State":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}},"output":{"type":"structure","members":{"Sessions":{"type":"list","member":{"type":"structure","members":{"SessionId":{},"Target":{},"Status":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"DocumentName":{},"Owner":{},"Details":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{},"CloudWatchOutputUrl":{}}}}}},"NextToken":{}}}},"GetAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{"AutomationExecution":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"AutomationExecutionStatus":{},"StepExecutions":{"shape":"S8e"},"StepExecutionsTruncated":{"type":"boolean"},"Parameters":{"shape":"S7u"},"Outputs":{"shape":"S7u"},"FailureMessage":{},"Mode":{},"ParentAutomationExecutionId":{},"ExecutedBy":{},"CurrentStepName":{},"CurrentAction":{},"TargetParameterName":{},"Targets":{"shape":"Sx"},"TargetMaps":{"shape":"S7z"},"ResolvedTargets":{"shape":"S84"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"TargetLocations":{"shape":"Sfp"},"ProgressCounters":{"type":"structure","members":{"TotalSteps":{"type":"integer"},"SuccessSteps":{"type":"integer"},"FailedSteps":{"type":"integer"},"CancelledSteps":{"type":"integer"},"TimedOutSteps":{"type":"integer"}}}}}}}},"GetCalendarState":{"input":{"type":"structure","required":["CalendarNames"],"members":{"CalendarNames":{"type":"list","member":{}},"AtTime":{}}},"output":{"type":"structure","members":{"State":{},"AtTime":{},"NextTransitionTime":{}}}},"GetCommandInvocation":{"input":{"type":"structure","required":["CommandId","InstanceId"],"members":{"CommandId":{},"InstanceId":{},"PluginName":{}}},"output":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"PluginName":{},"ResponseCode":{"type":"integer"},"ExecutionStartDateTime":{},"ExecutionElapsedTime":{},"ExecutionEndDateTime":{},"Status":{},"StatusDetails":{},"StandardOutputContent":{},"StandardOutputUrl":{},"StandardErrorContent":{},"StandardErrorUrl":{},"CloudWatchOutputConfig":{"shape":"Sg7"}}}},"GetConnectionStatus":{"input":{"type":"structure","required":["Target"],"members":{"Target":{}}},"output":{"type":"structure","members":{"Target":{},"Status":{}}}},"GetDefaultPatchBaseline":{"input":{"type":"structure","members":{"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"OperatingSystem":{}}}},"GetDeployablePatchSnapshotForInstance":{"input":{"type":"structure","required":["InstanceId","SnapshotId"],"members":{"InstanceId":{},"SnapshotId":{}}},"output":{"type":"structure","members":{"InstanceId":{},"SnapshotId":{},"SnapshotDownloadUrl":{},"Product":{}}}},"GetDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{}}},"output":{"type":"structure","members":{"Name":{},"VersionName":{},"DocumentVersion":{},"Status":{},"StatusInformation":{},"Content":{},"DocumentType":{},"DocumentFormat":{},"Requires":{"shape":"S23"},"AttachmentsContent":{"type":"list","member":{"type":"structure","members":{"Name":{},"Size":{"type":"long"},"Hash":{},"HashType":{},"Url":{}}}}}}},"GetInventory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sgs"},"Aggregators":{"shape":"Sgy"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","required":["TypeName","SchemaVersion","Content"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Shf"}}}}}}},"NextToken":{}}}},"GetInventorySchema":{"input":{"type":"structure","members":{"TypeName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Aggregator":{"type":"boolean"},"SubType":{"type":"boolean"}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","required":["TypeName","Attributes"],"members":{"TypeName":{},"Version":{},"Attributes":{"type":"list","member":{"type":"structure","required":["Name","DataType"],"members":{"Name":{},"DataType":{}}}},"DisplayName":{}}}},"NextToken":{}}}},"GetMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S33"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"NextExecutionTime":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"}}}},"GetMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskIds":{"type":"list","member":{}},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTask":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"TaskArn":{},"ServiceRole":{},"Type":{},"TaskParameters":{"type":"list","member":{"shape":"Sd2"},"sensitive":true},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTaskInvocation":{"input":{"type":"structure","required":["WindowExecutionId","TaskId","InvocationId"],"members":{"WindowExecutionId":{},"TaskId":{},"InvocationId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Scb"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Saz"},"WindowTargetId":{}}}},"GetMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Sd2"},"TaskInvocationParameters":{"shape":"Si6"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sd8"},"Name":{},"Description":{"shape":"S33"}}}},"GetOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}},"output":{"type":"structure","members":{"OpsItem":{"type":"structure","members":{"CreatedBy":{},"CreatedTime":{"type":"timestamp"},"Description":{},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Notifications":{"shape":"S3l"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S3p"},"Status":{},"OpsItemId":{},"Version":{},"Title":{},"Source":{},"OperationalData":{"shape":"S3g"},"Category":{},"Severity":{}}}}}},"GetOpsSummary":{"input":{"type":"structure","members":{"SyncName":{},"Filters":{"shape":"Siq"},"Aggregators":{"shape":"Siw"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","members":{"CaptureTime":{},"Content":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}}}}},"NextToken":{}}}},"GetParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameter":{"shape":"Sji"}}}},"GetParameterHistory":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"Value":{},"AllowedPattern":{},"Version":{"type":"long"},"Labels":{"shape":"Sjp"},"Tier":{},"Policies":{"shape":"Seh"},"DataType":{}}}},"NextToken":{}}}},"GetParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S5z"},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sjt"},"InvalidParameters":{"shape":"S5z"}}}},"GetParametersByPath":{"input":{"type":"structure","required":["Path"],"members":{"Path":{},"Recursive":{"type":"boolean"},"ParameterFilters":{"shape":"Se2"},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sjt"},"NextToken":{}}}},"GetPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S3z"},"ApprovalRules":{"shape":"S45"},"ApprovedPatches":{"shape":"S4c"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S4c"},"RejectedPatchesAction":{},"PatchGroups":{"type":"list","member":{}},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S4g"}}}},"GetPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{},"OperatingSystem":{}}}},"GetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Sk5"}}}},"LabelParameterVersion":{"input":{"type":"structure","required":["Name","Labels"],"members":{"Name":{},"ParameterVersion":{"type":"long"},"Labels":{"shape":"Sjp"}}},"output":{"type":"structure","members":{"InvalidLabels":{"shape":"Sjp"},"ParameterVersion":{"type":"long"}}}},"ListAssociationVersions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationVersions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"CreatedDate":{"type":"timestamp"},"Name":{},"DocumentVersion":{},"Parameters":{"shape":"St"},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"AssociationFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{},"DocumentVersion":{},"Targets":{"shape":"Sx"},"LastExecutionDate":{"type":"timestamp"},"Overview":{"shape":"S1n"},"ScheduleExpression":{},"AssociationName":{}}}},"NextToken":{}}}},"ListCommandInvocations":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Skn"},"Details":{"type":"boolean"}}},"output":{"type":"structure","members":{"CommandInvocations":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"InstanceName":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"TraceOutput":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"CommandPlugins":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"StatusDetails":{},"ResponseCode":{"type":"integer"},"ResponseStartDateTime":{"type":"timestamp"},"ResponseFinishDateTime":{"type":"timestamp"},"Output":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}},"ServiceRole":{},"NotificationConfig":{"shape":"Si8"},"CloudWatchOutputConfig":{"shape":"Sg7"}}}},"NextToken":{}}}},"ListCommands":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Skn"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"shape":"Sl3"}},"NextToken":{}}}},"ListComplianceItems":{"input":{"type":"structure","members":{"Filters":{"shape":"Sla"},"ResourceIds":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Id":{},"Title":{},"Status":{},"Severity":{},"ExecutionSummary":{"shape":"Sls"},"Details":{"shape":"Slv"}}}},"NextToken":{}}}},"ListComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sla"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"CompliantSummary":{"shape":"Sm0"},"NonCompliantSummary":{"shape":"Sm3"}}}},"NextToken":{}}}},"ListDocumentVersions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"VersionName":{},"CreatedDate":{"type":"timestamp"},"IsDefaultVersion":{"type":"boolean"},"DocumentFormat":{},"Status":{},"StatusInformation":{}}}},"NextToken":{}}}},"ListDocuments":{"input":{"type":"structure","members":{"DocumentFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentIdentifiers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Owner":{},"VersionName":{},"PlatformTypes":{"shape":"S2v"},"DocumentVersion":{},"DocumentType":{},"SchemaVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"Requires":{"shape":"S23"}}}},"NextToken":{}}}},"ListInventoryEntries":{"input":{"type":"structure","required":["InstanceId","TypeName"],"members":{"InstanceId":{},"TypeName":{},"Filters":{"shape":"Sgs"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TypeName":{},"InstanceId":{},"SchemaVersion":{},"CaptureTime":{},"Entries":{"shape":"Shf"},"NextToken":{}}}},"ListResourceComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sla"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Status":{},"OverallSeverity":{},"ExecutionSummary":{"shape":"Sls"},"CompliantSummary":{"shape":"Sm0"},"NonCompliantSummary":{"shape":"Sm3"}}}},"NextToken":{}}}},"ListResourceDataSync":{"input":{"type":"structure","members":{"SyncType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceDataSyncItems":{"type":"list","member":{"type":"structure","members":{"SyncName":{},"SyncType":{},"SyncSource":{"type":"structure","members":{"SourceType":{},"AwsOrganizationsSource":{"shape":"S51"},"SourceRegions":{"shape":"S56"},"IncludeFutureRegions":{"type":"boolean"},"State":{}}},"S3Destination":{"shape":"S4q"},"LastSyncTime":{"type":"timestamp"},"LastSuccessfulSyncTime":{"type":"timestamp"},"SyncLastModifiedTime":{"type":"timestamp"},"LastStatus":{},"SyncCreatedTime":{"type":"timestamp"},"LastSyncStatusMessage":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4"}}}},"ModifyDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"AccountIdsToAdd":{"shape":"S9j"},"AccountIdsToRemove":{"shape":"S9j"},"SharedDocumentVersion":{}}},"output":{"type":"structure","members":{}}},"PutComplianceItems":{"input":{"type":"structure","required":["ResourceId","ResourceType","ComplianceType","ExecutionSummary","Items"],"members":{"ResourceId":{},"ResourceType":{},"ComplianceType":{},"ExecutionSummary":{"shape":"Sls"},"Items":{"type":"list","member":{"type":"structure","required":["Severity","Status"],"members":{"Id":{},"Title":{},"Severity":{},"Status":{},"Details":{"shape":"Slv"}}}},"ItemContentHash":{},"UploadType":{}}},"output":{"type":"structure","members":{}}},"PutInventory":{"input":{"type":"structure","required":["InstanceId","Items"],"members":{"InstanceId":{},"Items":{"type":"list","member":{"type":"structure","required":["TypeName","SchemaVersion","CaptureTime"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Shf"},"Context":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{"Message":{}}}},"PutParameter":{"input":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Description":{},"Value":{},"Type":{},"KeyId":{},"Overwrite":{"type":"boolean"},"AllowedPattern":{},"Tags":{"shape":"S4"},"Tier":{},"Policies":{},"DataType":{}}},"output":{"type":"structure","members":{"Version":{"type":"long"},"Tier":{}}}},"RegisterDefaultPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"RegisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"RegisterTargetWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","ResourceType","Targets"],"members":{"WindowId":{},"ResourceType":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saz"},"Name":{},"Description":{"shape":"S33"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTargetId":{}}}},"RegisterTaskWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","Targets","TaskArn","TaskType","MaxConcurrency","MaxErrors"],"members":{"WindowId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Sd2"},"TaskInvocationParameters":{"shape":"Si6"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sd8"},"Name":{},"Description":{"shape":"S33"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTaskId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","TagKeys"],"members":{"ResourceType":{},"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"ResetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Sk5"}}}},"ResumeSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"SendAutomationSignal":{"input":{"type":"structure","required":["AutomationExecutionId","SignalType"],"members":{"AutomationExecutionId":{},"SignalType":{},"Payload":{"shape":"S7u"}}},"output":{"type":"structure","members":{}}},"SendCommand":{"input":{"type":"structure","required":["DocumentName"],"members":{"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Sx"},"DocumentName":{},"DocumentVersion":{},"DocumentHash":{},"DocumentHashType":{},"TimeoutSeconds":{"type":"integer"},"Comment":{},"Parameters":{"shape":"St"},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"ServiceRoleArn":{},"NotificationConfig":{"shape":"Si8"},"CloudWatchOutputConfig":{"shape":"Sg7"}}},"output":{"type":"structure","members":{"Command":{"shape":"Sl3"}}}},"StartAssociationsOnce":{"input":{"type":"structure","required":["AssociationIds"],"members":{"AssociationIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartAutomationExecution":{"input":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S7u"},"ClientToken":{},"Mode":{},"TargetParameterName":{},"Targets":{"shape":"Sx"},"TargetMaps":{"shape":"S7z"},"MaxConcurrency":{},"MaxErrors":{},"TargetLocations":{"shape":"Sfp"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StartSession":{"input":{"type":"structure","required":["Target"],"members":{"Target":{},"DocumentName":{},"Parameters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"StopAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"TerminateSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{}}}},"UpdateAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Parameters":{"shape":"St"},"DocumentVersion":{},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"Name":{},"Targets":{"shape":"Sx"},"AssociationName":{},"AssociationVersion":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1g"}}}},"UpdateAssociationStatus":{"input":{"type":"structure","required":["Name","InstanceId","AssociationStatus"],"members":{"Name":{},"InstanceId":{},"AssociationStatus":{"shape":"S1j"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1g"}}}},"UpdateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Attachments":{"shape":"S25"},"Name":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{},"TargetType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S2h"}}}},"UpdateDocumentDefaultVersion":{"input":{"type":"structure","required":["Name","DocumentVersion"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Description":{"type":"structure","members":{"Name":{},"DefaultVersion":{},"DefaultVersionName":{}}}}}},"UpdateMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Name":{},"Description":{"shape":"S33"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S33"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"}}}},"UpdateMaintenanceWindowTarget":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saz"},"Name":{},"Description":{"shape":"S33"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saz"},"Name":{},"Description":{"shape":"S33"}}}},"UpdateMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Sd2"},"TaskInvocationParameters":{"shape":"Si6"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sd8"},"Name":{},"Description":{"shape":"S33"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Sd2"},"TaskInvocationParameters":{"shape":"Si6"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sd8"},"Name":{},"Description":{"shape":"S33"}}}},"UpdateManagedInstanceRole":{"input":{"type":"structure","required":["InstanceId","IamRole"],"members":{"InstanceId":{},"IamRole":{}}},"output":{"type":"structure","members":{}}},"UpdateOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"Description":{},"OperationalData":{"shape":"S3g"},"OperationalDataToDelete":{"type":"list","member":{}},"Notifications":{"shape":"S3l"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S3p"},"Status":{},"OpsItemId":{},"Title":{},"Category":{},"Severity":{}}},"output":{"type":"structure","members":{}}},"UpdatePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"Name":{},"GlobalFilters":{"shape":"S3z"},"ApprovalRules":{"shape":"S45"},"ApprovedPatches":{"shape":"S4c"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S4c"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S4g"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S3z"},"ApprovalRules":{"shape":"S45"},"ApprovedPatches":{"shape":"S4c"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S4c"},"RejectedPatchesAction":{},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S4g"}}}},"UpdateResourceDataSync":{"input":{"type":"structure","required":["SyncName","SyncType","SyncSource"],"members":{"SyncName":{},"SyncType":{},"SyncSource":{"shape":"S4z"}}},"output":{"type":"structure","members":{}}},"UpdateServiceSetting":{"input":{"type":"structure","required":["SettingId","SettingValue"],"members":{"SettingId":{},"SettingValue":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"list","member":{}},"St":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sx":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S13":{"type":"structure","members":{"S3Location":{"type":"structure","members":{"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}}},"S1g":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationVersion":{},"Date":{"type":"timestamp"},"LastUpdateAssociationDate":{"type":"timestamp"},"Status":{"shape":"S1j"},"Overview":{"shape":"S1n"},"DocumentVersion":{},"AutomationTargetParameterName":{},"Parameters":{"shape":"St"},"AssociationId":{},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"LastExecutionDate":{"type":"timestamp"},"LastSuccessfulExecutionDate":{"type":"timestamp"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"}}},"S1j":{"type":"structure","required":["Date","Name","Message"],"members":{"Date":{"type":"timestamp"},"Name":{},"Message":{},"AdditionalInfo":{}}},"S1n":{"type":"structure","members":{"Status":{},"DetailedStatus":{},"AssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"S1u":{"type":"structure","required":["Name"],"members":{"Name":{},"InstanceId":{},"Parameters":{"shape":"St"},"AutomationTargetParameterName":{},"DocumentVersion":{},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"}}},"S23":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Version":{}}}},"S25":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Name":{}}}},"S2h":{"type":"structure","members":{"Sha1":{},"Hash":{},"HashType":{},"Name":{},"VersionName":{},"Owner":{},"CreatedDate":{"type":"timestamp"},"Status":{},"StatusInformation":{},"DocumentVersion":{},"Description":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Description":{},"DefaultValue":{}}}},"PlatformTypes":{"shape":"S2v"},"DocumentType":{},"SchemaVersion":{},"LatestVersion":{},"DefaultVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"AttachmentsInformation":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Requires":{"shape":"S23"}}},"S2v":{"type":"list","member":{}},"S33":{"type":"string","sensitive":true},"S3g":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{},"Type":{}}}},"S3l":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}},"S3p":{"type":"list","member":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}}},"S3z":{"type":"structure","required":["PatchFilters"],"members":{"PatchFilters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"S45":{"type":"structure","required":["PatchRules"],"members":{"PatchRules":{"type":"list","member":{"type":"structure","required":["PatchFilterGroup"],"members":{"PatchFilterGroup":{"shape":"S3z"},"ComplianceLevel":{},"ApproveAfterDays":{"type":"integer"},"ApproveUntilDate":{},"EnableNonSecurity":{"type":"boolean"}}}}}},"S4c":{"type":"list","member":{}},"S4g":{"type":"list","member":{"type":"structure","required":["Name","Products","Configuration"],"members":{"Name":{},"Products":{"type":"list","member":{}},"Configuration":{"type":"string","sensitive":true}}}},"S4q":{"type":"structure","required":["BucketName","SyncFormat","Region"],"members":{"BucketName":{},"Prefix":{},"SyncFormat":{},"Region":{},"AWSKMSKeyARN":{},"DestinationDataSharing":{"type":"structure","members":{"DestinationDataSharingType":{}}}}},"S4z":{"type":"structure","required":["SourceType","SourceRegions"],"members":{"SourceType":{},"AwsOrganizationsSource":{"shape":"S51"},"SourceRegions":{"shape":"S56"},"IncludeFutureRegions":{"type":"boolean"}}},"S51":{"type":"structure","required":["OrganizationSourceType"],"members":{"OrganizationSourceType":{},"OrganizationalUnits":{"type":"list","member":{"type":"structure","members":{"OrganizationalUnitId":{}}}}}},"S56":{"type":"list","member":{}},"S5m":{"type":"structure","members":{"TotalCount":{"type":"integer"},"RemainingCount":{"type":"integer"},"SummaryItems":{"type":"list","member":{"type":"structure","members":{"Version":{},"Count":{"type":"integer"},"RemainingCount":{"type":"integer"}}}}}},"S5z":{"type":"list","member":{}},"S7u":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S7z":{"type":"list","member":{"type":"map","key":{},"value":{"type":"list","member":{}}}},"S84":{"type":"structure","members":{"ParameterValues":{"type":"list","member":{}},"Truncated":{"type":"boolean"}}},"S8e":{"type":"list","member":{"type":"structure","members":{"StepName":{},"Action":{},"TimeoutSeconds":{"type":"long"},"OnFailure":{},"MaxAttempts":{"type":"integer"},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"StepStatus":{},"ResponseCode":{},"Inputs":{"type":"map","key":{},"value":{}},"Outputs":{"shape":"S7u"},"Response":{},"FailureMessage":{},"FailureDetails":{"type":"structure","members":{"FailureStage":{},"FailureType":{},"Details":{"shape":"S7u"}}},"StepExecutionId":{},"OverriddenParameters":{"shape":"S7u"},"IsEnd":{"type":"boolean"},"NextStep":{},"IsCritical":{"type":"boolean"},"ValidNextSteps":{"type":"list","member":{}},"Targets":{"shape":"Sx"},"TargetLocation":{"shape":"S8n"}}}},"S8n":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Regions":{"type":"list","member":{}},"TargetLocationMaxConcurrency":{},"TargetLocationMaxErrors":{},"ExecutionRoleName":{}}},"S8u":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S92":{"type":"structure","members":{"Id":{},"ReleaseDate":{"type":"timestamp"},"Title":{},"Description":{},"ContentUrl":{},"Vendor":{},"ProductFamily":{},"Product":{},"Classification":{},"MsrcSeverity":{},"KbNumber":{},"MsrcNumber":{},"Language":{}}},"S9j":{"type":"list","member":{}},"Sac":{"type":"list","member":{}},"Saw":{"type":"structure","required":["InstanceId","PatchGroup","BaselineId","OperationStartTime","OperationEndTime","Operation"],"members":{"InstanceId":{},"PatchGroup":{},"BaselineId":{},"SnapshotId":{},"InstallOverrideList":{},"OwnerInformation":{"shape":"Saz"},"InstalledCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"InstalledPendingRebootCount":{"type":"integer"},"InstalledRejectedCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"UnreportedNotApplicableCount":{"type":"integer"},"NotApplicableCount":{"type":"integer"},"OperationStartTime":{"type":"timestamp"},"OperationEndTime":{"type":"timestamp"},"Operation":{},"LastNoRebootInstallOperationTime":{"type":"timestamp"},"RebootOption":{}}},"Saz":{"type":"string","sensitive":true},"Sbz":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Scb":{"type":"string","sensitive":true},"Sd2":{"type":"map","key":{},"value":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true}},"sensitive":true},"sensitive":true},"Sd8":{"type":"structure","required":["S3BucketName","S3Region"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"S3Region":{}}},"Se2":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Option":{},"Values":{"type":"list","member":{}}}}},"Seh":{"type":"list","member":{"type":"structure","members":{"PolicyText":{},"PolicyType":{},"PolicyStatus":{}}}},"Sen":{"type":"structure","members":{"BaselineId":{},"BaselineName":{},"OperatingSystem":{},"BaselineDescription":{},"DefaultBaseline":{"type":"boolean"}}},"Sfp":{"type":"list","member":{"shape":"S8n"}},"Sg7":{"type":"structure","members":{"CloudWatchLogGroupName":{},"CloudWatchOutputEnabled":{"type":"boolean"}}},"Sgs":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sgy":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Aggregators":{"shape":"Sgy"},"Groups":{"type":"list","member":{"type":"structure","required":["Name","Filters"],"members":{"Name":{},"Filters":{"shape":"Sgs"}}}}}}},"Shf":{"type":"list","member":{"type":"map","key":{},"value":{}}},"Si6":{"type":"structure","members":{"RunCommand":{"type":"structure","members":{"Comment":{},"CloudWatchOutputConfig":{"shape":"Sg7"},"DocumentHash":{},"DocumentHashType":{},"DocumentVersion":{},"NotificationConfig":{"shape":"Si8"},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"Parameters":{"shape":"St"},"ServiceRoleArn":{},"TimeoutSeconds":{"type":"integer"}}},"Automation":{"type":"structure","members":{"DocumentVersion":{},"Parameters":{"shape":"S7u"}}},"StepFunctions":{"type":"structure","members":{"Input":{"type":"string","sensitive":true},"Name":{}}},"Lambda":{"type":"structure","members":{"ClientContext":{},"Qualifier":{},"Payload":{"type":"blob","sensitive":true}}}}},"Si8":{"type":"structure","members":{"NotificationArn":{},"NotificationEvents":{"type":"list","member":{}},"NotificationType":{}}},"Siq":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Siw":{"type":"list","member":{"type":"structure","members":{"AggregatorType":{},"TypeName":{},"AttributeName":{},"Values":{"type":"map","key":{},"value":{}},"Filters":{"shape":"Siq"},"Aggregators":{"shape":"Siw"}}}},"Sji":{"type":"structure","members":{"Name":{},"Type":{},"Value":{},"Version":{"type":"long"},"Selector":{},"SourceResult":{},"LastModifiedDate":{"type":"timestamp"},"ARN":{},"DataType":{}}},"Sjp":{"type":"list","member":{}},"Sjt":{"type":"list","member":{"shape":"Sji"}},"Sk5":{"type":"structure","members":{"SettingId":{},"SettingValue":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"ARN":{},"Status":{}}},"Skn":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sl3":{"type":"structure","members":{"CommandId":{},"DocumentName":{},"DocumentVersion":{},"Comment":{},"ExpiresAfter":{"type":"timestamp"},"Parameters":{"shape":"St"},"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Sx"},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"TargetCount":{"type":"integer"},"CompletedCount":{"type":"integer"},"ErrorCount":{"type":"integer"},"DeliveryTimedOutCount":{"type":"integer"},"ServiceRole":{},"NotificationConfig":{"shape":"Si8"},"CloudWatchOutputConfig":{"shape":"Sg7"},"TimeoutSeconds":{"type":"integer"}}},"Sla":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sls":{"type":"structure","required":["ExecutionTime"],"members":{"ExecutionTime":{"type":"timestamp"},"ExecutionId":{},"ExecutionType":{}}},"Slv":{"type":"map","key":{},"value":{}},"Sm0":{"type":"structure","members":{"CompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sm2"}}},"Sm2":{"type":"structure","members":{"CriticalCount":{"type":"integer"},"HighCount":{"type":"integer"},"MediumCount":{"type":"integer"},"LowCount":{"type":"integer"},"InformationalCount":{"type":"integer"},"UnspecifiedCount":{"type":"integer"}}},"Sm3":{"type":"structure","members":{"NonCompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sm2"}}}}}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeActivations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActivationList"},"DescribeInstanceInformation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceInformationList"},"DescribeParameters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParameterHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParametersByPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"ListCommandInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CommandInvocations"},"ListCommands":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Commands"},"ListDocuments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentIdentifiers"}}}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-06-30","endpointPrefix":"storagegateway","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Storage Gateway","serviceId":"Storage Gateway","signatureVersion":"v4","targetPrefix":"StorageGateway_20130630","uid":"storagegateway-2013-06-30"},"operations":{"ActivateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayName","GatewayTimezone","GatewayRegion"],"members":{"ActivationKey":{},"GatewayName":{},"GatewayTimezone":{},"GatewayRegion":{},"GatewayType":{},"TapeDriveType":{},"MediumChangerType":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddCache":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"AddUploadBuffer":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddWorkingStorage":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AssignTapePool":{"input":{"type":"structure","required":["TapeARN","PoolId"],"members":{"TapeARN":{},"PoolId":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"AttachVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeARN","NetworkInterfaceId"],"members":{"GatewayARN":{},"TargetName":{},"VolumeARN":{},"NetworkInterfaceId":{},"DiskId":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CancelArchival":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CancelRetrieval":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateCachediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeSizeInBytes","TargetName","NetworkInterfaceId","ClientToken"],"members":{"GatewayARN":{},"VolumeSizeInBytes":{"type":"long"},"SnapshotId":{},"TargetName":{},"SourceVolumeARN":{},"NetworkInterfaceId":{},"ClientToken":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CreateNFSFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"NFSFileShareDefaults":{"shape":"S1c"},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1j"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSMBFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AdminUserList":{"shape":"S1p"},"ValidUserList":{"shape":"S1p"},"InvalidUserList":{"shape":"S1p"},"AuditDestinationARN":{},"Authentication":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"SnapshotId":{}}}},"CreateSnapshotFromVolumeRecoveryPoint":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"SnapshotId":{},"VolumeARN":{},"VolumeRecoveryPointTime":{}}}},"CreateStorediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","DiskId","PreserveExistingData","TargetName","NetworkInterfaceId"],"members":{"GatewayARN":{},"DiskId":{},"SnapshotId":{},"PreserveExistingData":{"type":"boolean"},"TargetName":{},"NetworkInterfaceId":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"TargetARN":{}}}},"CreateTapeWithBarcode":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","TapeBarcode"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"TapeBarcode":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateTapes":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","ClientToken","NumTapesToCreate","TapeBarcodePrefix"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"ClientToken":{},"NumTapesToCreate":{"type":"integer"},"TapeBarcodePrefix":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARNs":{"shape":"S2b"}}}},"DeleteAutomaticTapeCreationPolicy":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN","BandwidthType"],"members":{"GatewayARN":{},"BandwidthType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteChapCredentials":{"input":{"type":"structure","required":["TargetARN","InitiatorName"],"members":{"TargetARN":{},"InitiatorName":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"DeleteFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DeleteTape":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapeArchive":{"input":{"type":"structure","required":["TapeARN"],"members":{"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DescribeAvailabilityMonitorTest":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Status":{},"StartTime":{"type":"timestamp"}}}},"DescribeBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"DescribeCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"CacheAllocatedInBytes":{"type":"long"},"CacheUsedPercentage":{"type":"double"},"CacheDirtyPercentage":{"type":"double"},"CacheHitPercentage":{"type":"double"},"CacheMissPercentage":{"type":"double"}}}},"DescribeCachediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S38"}}},"output":{"type":"structure","members":{"CachediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"SourceSnapshotId":{},"VolumeiSCSIAttributes":{"shape":"S3h"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeChapCredentials":{"input":{"type":"structure","required":["TargetARN"],"members":{"TargetARN":{}}},"output":{"type":"structure","members":{"ChapCredentials":{"type":"list","member":{"type":"structure","members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S3q"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S3q"}}}}}}},"DescribeGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayId":{},"GatewayName":{},"GatewayTimezone":{},"GatewayState":{},"GatewayNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"Ipv4Address":{},"MacAddress":{},"Ipv6Address":{}}}},"GatewayType":{},"NextUpdateAvailabilityDate":{},"LastSoftwareUpdate":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{},"Tags":{"shape":"S9"},"VPCEndpoint":{},"CloudWatchLogGroupARN":{},"HostEnvironment":{},"EndpointType":{}}}},"DescribeMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"},"Timezone":{}}}},"DescribeNFSFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S4b"}}},"output":{"type":"structure","members":{"NFSFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"NFSFileShareDefaults":{"shape":"S1c"},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1j"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"}}}}}}},"DescribeSMBFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S4b"}}},"output":{"type":"structure","members":{"SMBFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AdminUserList":{"shape":"S1p"},"ValidUserList":{"shape":"S1p"},"InvalidUserList":{"shape":"S1p"},"AuditDestinationARN":{},"Authentication":{},"Tags":{"shape":"S9"}}}}}}},"DescribeSMBSettings":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DomainName":{},"ActiveDirectoryStatus":{},"SMBGuestPasswordSet":{"type":"boolean"},"SMBSecurityStrategy":{}}}},"DescribeSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Timezone":{},"Tags":{"shape":"S9"}}}},"DescribeStorediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S38"}}},"output":{"type":"structure","members":{"StorediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"VolumeDiskId":{},"SourceSnapshotId":{},"PreservedExistingData":{"type":"boolean"},"VolumeiSCSIAttributes":{"shape":"S3h"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeTapeArchives":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2b"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeArchives":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"CompletionTime":{"type":"timestamp"},"RetrievedTo":{},"TapeStatus":{},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{}}}},"Marker":{}}}},"DescribeTapeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"TapeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeRecoveryPointTime":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{}}}},"Marker":{}}}},"DescribeTapes":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"TapeARNs":{"shape":"S2b"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tapes":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"VTLDevice":{},"Progress":{"type":"double"},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{}}}},"Marker":{}}}},"DescribeUploadBuffer":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"UploadBufferUsedInBytes":{"type":"long"},"UploadBufferAllocatedInBytes":{"type":"long"}}}},"DescribeVTLDevices":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"VTLDeviceARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"VTLDevices":{"type":"list","member":{"type":"structure","members":{"VTLDeviceARN":{},"VTLDeviceType":{},"VTLDeviceVendor":{},"VTLDeviceProductIdentifier":{},"DeviceiSCSIAttributes":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}},"Marker":{}}}},"DescribeWorkingStorage":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"WorkingStorageUsedInBytes":{"type":"long"},"WorkingStorageAllocatedInBytes":{"type":"long"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{},"ForceDetach":{"type":"boolean"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DisableGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"JoinDomain":{"input":{"type":"structure","required":["GatewayARN","DomainName","UserName","Password"],"members":{"GatewayARN":{},"DomainName":{},"OrganizationalUnit":{},"DomainControllers":{"type":"list","member":{}},"TimeoutInSeconds":{"type":"integer"},"UserName":{},"Password":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{},"ActiveDirectoryStatus":{}}}},"ListAutomaticTapeCreationPolicies":{"input":{"type":"structure","members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"AutomaticTapeCreationPolicyInfos":{"type":"list","member":{"type":"structure","members":{"AutomaticTapeCreationRules":{"shape":"S6a"},"GatewayARN":{}}}}}}},"ListFileShares":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareType":{},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{}}}}}}},"ListGateways":{"input":{"type":"structure","members":{"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayId":{},"GatewayARN":{},"GatewayType":{},"GatewayOperationalState":{},"GatewayName":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{}}}},"Marker":{}}}},"ListLocalDisks":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Disks":{"type":"list","member":{"type":"structure","members":{"DiskId":{},"DiskPath":{},"DiskNode":{},"DiskStatus":{},"DiskSizeInBytes":{"type":"long"},"DiskAllocationType":{},"DiskAllocationResource":{},"DiskAttributeList":{"type":"list","member":{}}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceARN":{},"Marker":{},"Tags":{"shape":"S9"}}}},"ListTapes":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2b"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"GatewayARN":{},"PoolId":{}}}},"Marker":{}}}},"ListVolumeInitiators":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"Initiators":{"type":"list","member":{}}}}},"ListVolumeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"VolumeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"VolumeUsageInBytes":{"type":"long"},"VolumeRecoveryPointTime":{}}}}}}},"ListVolumes":{"input":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"VolumeInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"GatewayARN":{},"GatewayId":{},"VolumeType":{},"VolumeSizeInBytes":{"type":"long"},"VolumeAttachmentStatus":{}}}}}}},"NotifyWhenUploaded":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RefreshCache":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"FolderList":{"type":"list","member":{}},"Recursive":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"ResetCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"RetrieveTapeArchive":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"RetrieveTapeRecoveryPoint":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"SetLocalConsolePassword":{"input":{"type":"structure","required":["GatewayARN","LocalConsolePassword"],"members":{"GatewayARN":{},"LocalConsolePassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"SetSMBGuestPassword":{"input":{"type":"structure","required":["GatewayARN","Password"],"members":{"GatewayARN":{},"Password":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ShutdownGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartAvailabilityMonitorTest":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateAutomaticTapeCreationPolicy":{"input":{"type":"structure","required":["AutomaticTapeCreationRules","GatewayARN"],"members":{"AutomaticTapeCreationRules":{"shape":"S6a"},"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateChapCredentials":{"input":{"type":"structure","required":["TargetARN","SecretToAuthenticateInitiator","InitiatorName"],"members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S3q"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S3q"}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"GatewayName":{},"GatewayTimezone":{},"CloudWatchLogGroupARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayName":{}}}},"UpdateGatewaySoftwareNow":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN","HourOfDay","MinuteOfHour"],"members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateNFSFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"NFSFileShareDefaults":{"shape":"S1c"},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1j"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AdminUserList":{"shape":"S1p"},"ValidUserList":{"shape":"S1p"},"InvalidUserList":{"shape":"S1p"},"AuditDestinationARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBSecurityStrategy":{"input":{"type":"structure","required":["GatewayARN","SMBSecurityStrategy"],"members":{"GatewayARN":{},"SMBSecurityStrategy":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN","StartAt","RecurrenceInHours"],"members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"UpdateVTLDeviceType":{"input":{"type":"structure","required":["VTLDeviceARN","DeviceType"],"members":{"VTLDeviceARN":{},"DeviceType":{}}},"output":{"type":"structure","members":{"VTLDeviceARN":{}}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sg":{"type":"list","member":{}},"S1c":{"type":"structure","members":{"FileMode":{},"DirectoryMode":{},"GroupId":{"type":"long"},"OwnerId":{"type":"long"}}},"S1j":{"type":"list","member":{}},"S1p":{"type":"list","member":{}},"S2b":{"type":"list","member":{}},"S38":{"type":"list","member":{}},"S3h":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"LunNumber":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}},"S3q":{"type":"string","sensitive":true},"S4b":{"type":"list","member":{}},"S6a":{"type":"list","member":{"type":"structure","required":["TapeBarcodePrefix","PoolId","TapeSizeInBytes","MinimumNumTapes"],"members":{"TapeBarcodePrefix":{},"PoolId":{},"TapeSizeInBytes":{"type":"long"},"MinimumNumTapes":{"type":"integer"}}}}}}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCachediSCSIVolumes":{"result_key":"CachediSCSIVolumes"},"DescribeStorediSCSIVolumes":{"result_key":"StorediSCSIVolumes"},"DescribeTapeArchives":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeArchives"},"DescribeTapeRecoveryPoints":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeRecoveryPointInfos"},"DescribeTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Tapes"},"DescribeVTLDevices":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VTLDevices"},"ListFileShares":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["Marker"],"output_token":"NextMarker","result_key":"FileShareInfoList"},"ListGateways":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Gateways"},"ListLocalDisks":{"result_key":"Disks"},"ListTagsForResource":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["ResourceARN"],"output_token":"Marker","result_key":"Tags"},"ListTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeInfos"},"ListVolumeRecoveryPoints":{"result_key":"VolumeRecoveryPointInfos"},"ListVolumes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VolumeInfos"}}}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"streams.dynamodb","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon DynamoDB Streams","serviceId":"DynamoDB Streams","signatureVersion":"v4","signingName":"dynamodb","targetPrefix":"DynamoDBStreams_20120810","uid":"streams-dynamodb-2012-08-10"},"operations":{"DescribeStream":{"input":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","members":{"StreamDescription":{"type":"structure","members":{"StreamArn":{},"StreamLabel":{},"StreamStatus":{},"StreamViewType":{},"CreationRequestDateTime":{"type":"timestamp"},"TableName":{},"KeySchema":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"Shards":{"type":"list","member":{"type":"structure","members":{"ShardId":{},"SequenceNumberRange":{"type":"structure","members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}},"ParentShardId":{}}}},"LastEvaluatedShardId":{}}}}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"eventID":{},"eventName":{},"eventVersion":{},"eventSource":{},"awsRegion":{},"dynamodb":{"type":"structure","members":{"ApproximateCreationDateTime":{"type":"timestamp"},"Keys":{"shape":"Sr"},"NewImage":{"shape":"Sr"},"OldImage":{"shape":"Sr"},"SequenceNumber":{},"SizeBytes":{"type":"long"},"StreamViewType":{}}},"userIdentity":{"type":"structure","members":{"PrincipalId":{},"Type":{}}}}}},"NextShardIterator":{}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamArn","ShardId","ShardIteratorType"],"members":{"StreamArn":{},"ShardId":{},"ShardIteratorType":{},"SequenceNumber":{}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"ListStreams":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"ExclusiveStartStreamArn":{}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"TableName":{},"StreamLabel":{}}}},"LastEvaluatedStreamArn":{}}}}},"shapes":{"Sr":{"type":"map","key":{},"value":{"shape":"St"}},"St":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"St"}},"L":{"type":"list","member":{"shape":"St"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}}}}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"},"TransitiveTagKeys":{"type":"list","member":{}},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"AssumedRoleUser":{"shape":"Sm"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{"type":"string","sensitive":true},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"AssumedRoleUser":{"shape":"Sm"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{"type":"string","sensitive":true},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sm"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sh"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sh"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"S8":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sh":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sm":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"translate","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Translate","serviceId":"Translate","signatureVersion":"v4","signingName":"translate","targetPrefix":"AWSShineFrontendService_20170701","uid":"translate-2017-07-01"},"operations":{"DeleteTerminology":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DescribeTextTranslationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TextTranslationJobProperties":{"shape":"S6"}}}},"GetTerminology":{"input":{"type":"structure","required":["Name","TerminologyDataFormat"],"members":{"Name":{},"TerminologyDataFormat":{}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"So"},"TerminologyDataLocation":{"type":"structure","required":["RepositoryType","Location"],"members":{"RepositoryType":{},"Location":{}}}}}},"ImportTerminology":{"input":{"type":"structure","required":["Name","MergeStrategy","TerminologyData"],"members":{"Name":{},"MergeStrategy":{},"Description":{},"TerminologyData":{"type":"structure","required":["File","Format"],"members":{"File":{"type":"blob","sensitive":true},"Format":{}}},"EncryptionKey":{"shape":"Ss"}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"So"}}}},"ListTerminologies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TerminologyPropertiesList":{"type":"list","member":{"shape":"So"}},"NextToken":{}}}},"ListTextTranslationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmittedBeforeTime":{"type":"timestamp"},"SubmittedAfterTime":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TextTranslationJobPropertiesList":{"type":"list","member":{"shape":"S6"}},"NextToken":{}}}},"StartTextTranslationJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","SourceLanguageCode","TargetLanguageCodes","ClientToken"],"members":{"JobName":{},"InputDataConfig":{"shape":"Sg"},"OutputDataConfig":{"shape":"Sj"},"DataAccessRoleArn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"Sc"},"TerminologyNames":{"shape":"Sd"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTextTranslationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"TranslateText":{"input":{"type":"structure","required":["Text","SourceLanguageCode","TargetLanguageCode"],"members":{"Text":{},"TerminologyNames":{"shape":"Sd"},"SourceLanguageCode":{},"TargetLanguageCode":{}}},"output":{"type":"structure","required":["TranslatedText","SourceLanguageCode","TargetLanguageCode"],"members":{"TranslatedText":{},"SourceLanguageCode":{},"TargetLanguageCode":{},"AppliedTerminologies":{"type":"list","member":{"type":"structure","members":{"Name":{},"Terms":{"type":"list","member":{"type":"structure","members":{"SourceText":{},"TargetText":{}}}}}}}}}}},"shapes":{"S6":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"JobDetails":{"type":"structure","members":{"TranslatedDocumentsCount":{"type":"integer"},"DocumentsWithErrorsCount":{"type":"integer"},"InputDocumentsCount":{"type":"integer"}}},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"Sc"},"TerminologyNames":{"shape":"Sd"},"Message":{},"SubmittedTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"Sg"},"OutputDataConfig":{"shape":"Sj"},"DataAccessRoleArn":{}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sg":{"type":"structure","required":["S3Uri","ContentType"],"members":{"S3Uri":{},"ContentType":{}}},"Sj":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"So":{"type":"structure","members":{"Name":{},"Description":{},"Arn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"type":"list","member":{}},"EncryptionKey":{"shape":"Ss"},"SizeBytes":{"type":"integer"},"TermCount":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"}}},"Ss":{"type":"structure","required":["Type","Id"],"members":{"Type":{},"Id":{}}}}}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListTerminologies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTextTranslationJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-24","endpointPrefix":"waf","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF","serviceFullName":"AWS WAF","serviceId":"WAF","signatureVersion":"v4","targetPrefix":"AWSWAF_20150824","uid":"waf-2015-08-24"},"operations":{"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"},"ChangeToken":{}}}},"CreateWebACLMigrationStack":{"input":{"type":"structure","required":["WebACLId","S3BucketName","IgnoreUnsupportedType"],"members":{"WebACLId":{},"S3BucketName":{},"IgnoreUnsupportedType":{"type":"boolean"}}},"output":{"type":"structure","required":["S3ObjectUrl"],"members":{"S3ObjectUrl":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2k"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3s"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S4e"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S4e"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2k"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S24"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S3s"}},"NextMarker":{}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5p"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5p"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"Sx"}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S3s"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3s"}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"S8"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sj"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"Sq"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7f"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S1b"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7f"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1r"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S1y"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"DefaultAction":{"shape":"S20"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2m"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S5":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"S8"}}}},"S8":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"S9"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"S9":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sh":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sj"}}}},"Sj":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"So":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sx":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S12":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"S13"},"RateKey":{},"RateLimit":{"type":"long"}}},"S13":{"type":"list","member":{"shape":"S14"}},"S14":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S19":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S1b"}}}},"S1b":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1e":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1j":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"S13"}}},"S1m":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1p":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1r"}}}},"S1r":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1w":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S1y"}}}},"S1y":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S20":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S23":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"Rules":{"shape":"S24"},"WebACLArn":{}}},"S24":{"type":"list","member":{"shape":"S25"}},"S25":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S20"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{},"ExcludedRules":{"type":"list","member":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}}}}},"S2k":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2m"}}}},"S2m":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S3s":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"S9"}}}},"S4e":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S5p":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S7f":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S14"}}}}}}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-05-01","endpointPrefix":"workdocs","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkDocs","serviceId":"WorkDocs","signatureVersion":"v4","uid":"workdocs-2016-05-01"},"operations":{"AbortDocumentVersionUpload":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"}}}},"ActivateUser":{"http":{"requestUri":"/api/v1/users/{UserId}/activation","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"AddResourcePermissions":{"http":{"requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":201},"input":{"type":"structure","required":["ResourceId","Principals"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Principals":{"type":"list","member":{"type":"structure","required":["Id","Type","Role"],"members":{"Id":{},"Type":{},"Role":{}}}},"NotificationOptions":{"type":"structure","members":{"SendEmail":{"type":"boolean"},"EmailMessage":{"shape":"St"}}}}},"output":{"type":"structure","members":{"ShareResults":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"InviteePrincipalId":{},"Role":{},"Status":{},"ShareId":{},"StatusMessage":{"shape":"St"}}}}}}},"CreateComment":{"http":{"requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment","responseCode":201},"input":{"type":"structure","required":["DocumentId","VersionId","Text"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Visibility":{},"NotifyCollaborators":{"type":"boolean"}}},"output":{"type":"structure","members":{"Comment":{"shape":"S13"}}}},"CreateCustomMetadata":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId","CustomMetadata"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionid"},"CustomMetadata":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"CreateFolder":{"http":{"requestUri":"/api/v1/folders","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Name":{},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"}}}},"CreateLabels":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId","Labels"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Labels":{"shape":"S1g"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{}}},"CreateNotificationSubscription":{"http":{"requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId","Endpoint","Protocol","SubscriptionType"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Endpoint":{},"Protocol":{},"SubscriptionType":{}}},"output":{"type":"structure","members":{"Subscription":{"shape":"S1p"}}}},"CreateUser":{"http":{"requestUri":"/api/v1/users","responseCode":201},"input":{"type":"structure","required":["Username","GivenName","Surname","Password"],"members":{"OrganizationId":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"Password":{"type":"string","sensitive":true},"TimeZoneId":{},"StorageRule":{"shape":"Sj"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"DeactivateUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}/activation","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}}},"DeleteComment":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","CommentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"CommentId":{"location":"uri","locationName":"CommentId"}}}},"DeleteCustomMetadata":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionId"},"Keys":{"location":"querystring","locationName":"keys","type":"list","member":{}},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteFolderContents":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteLabels":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Labels":{"shape":"S1g","location":"querystring","locationName":"labels"},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteNotificationSubscription":{"http":{"method":"DELETE","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}","responseCode":200},"input":{"type":"structure","required":["SubscriptionId","OrganizationId"],"members":{"SubscriptionId":{"location":"uri","locationName":"SubscriptionId"},"OrganizationId":{"location":"uri","locationName":"OrganizationId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeActivities":{"http":{"method":"GET","requestUri":"/api/v1/activities","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"StartTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"EndTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"ActivityTypes":{"location":"querystring","locationName":"activityTypes"},"ResourceId":{"location":"querystring","locationName":"resourceId"},"UserId":{"location":"querystring","locationName":"userId"},"IncludeIndirectActivities":{"location":"querystring","locationName":"includeIndirectActivities","type":"boolean"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"UserActivities":{"type":"list","member":{"type":"structure","members":{"Type":{},"TimeStamp":{"type":"timestamp"},"IsIndirectActivity":{"type":"boolean"},"OrganizationId":{},"Initiator":{"shape":"S2d"},"Participants":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2d"}},"Groups":{"shape":"S2g"}}},"ResourceMetadata":{"shape":"S2j"},"OriginalParent":{"shape":"S2j"},"CommentMetadata":{"type":"structure","members":{"CommentId":{},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"CommentStatus":{},"RecipientId":{}}}}}},"Marker":{}}}},"DescribeComments":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comments","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Comments":{"type":"list","member":{"shape":"S13"}},"Marker":{}}}},"DescribeDocumentVersions":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Include":{"location":"querystring","locationName":"include"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"shape":"S2u"}},"Marker":{}}}},"DescribeFolderContents":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Sort":{"location":"querystring","locationName":"sort"},"Order":{"location":"querystring","locationName":"order"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"},"Type":{"location":"querystring","locationName":"type"},"Include":{"location":"querystring","locationName":"include"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Documents":{"shape":"S38"},"Marker":{}}}},"DescribeGroups":{"http":{"method":"GET","requestUri":"/api/v1/groups","responseCode":200},"input":{"type":"structure","required":["SearchQuery"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"SearchQuery":{"shape":"S3b","location":"querystring","locationName":"searchQuery"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S2g"},"Marker":{}}}},"DescribeNotificationSubscriptions":{"http":{"method":"GET","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Subscriptions":{"type":"list","member":{"shape":"S1p"}},"Marker":{}}}},"DescribeResourcePermissions":{"http":{"method":"GET","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"querystring","locationName":"principalId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Role":{},"Type":{}}}}}}},"Marker":{}}}},"DescribeRootFolders":{"http":{"method":"GET","requestUri":"/api/v1/me/root","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Marker":{}}}},"DescribeUsers":{"http":{"method":"GET","requestUri":"/api/v1/users","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserIds":{"location":"querystring","locationName":"userIds"},"Query":{"shape":"S3b","location":"querystring","locationName":"query"},"Include":{"location":"querystring","locationName":"include"},"Order":{"location":"querystring","locationName":"order"},"Sort":{"location":"querystring","locationName":"sort"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S8"}},"TotalNumberOfUsers":{"deprecated":true,"type":"long"},"Marker":{}}}},"GetCurrentUser":{"http":{"method":"GET","requestUri":"/api/v1/me","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"GetDocument":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S39"},"CustomMetadata":{"shape":"S16"}}}},"GetDocumentPath":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/path","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S42"}}}},"GetDocumentVersion":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Fields":{"location":"querystring","locationName":"fields"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S2u"},"CustomMetadata":{"shape":"S16"}}}},"GetFolder":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"},"CustomMetadata":{"shape":"S16"}}}},"GetFolderPath":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/path","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S42"}}}},"GetResources":{"http":{"method":"GET","requestUri":"/api/v1/resources","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"querystring","locationName":"userId"},"CollectionType":{"location":"querystring","locationName":"collectionType"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Documents":{"shape":"S38"},"Marker":{}}}},"InitiateDocumentVersionUpload":{"http":{"requestUri":"/api/v1/documents","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Id":{},"Name":{},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"ContentType":{},"DocumentSizeInBytes":{"type":"long"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S39"},"UploadMetadata":{"type":"structure","members":{"UploadUrl":{"shape":"S2z"},"SignedHeaders":{"type":"map","key":{},"value":{}}}}}}},"RemoveAllResourcePermissions":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":204},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}}},"RemoveResourcePermission":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions/{PrincipalId}","responseCode":204},"input":{"type":"structure","required":["ResourceId","PrincipalId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"PrincipalType":{"location":"querystring","locationName":"type"}}}},"UpdateDocument":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateDocumentVersion":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"VersionStatus":{}}}},"UpdateFolder":{"http":{"method":"PATCH","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateUser":{"http":{"method":"PATCH","requestUri":"/api/v1/users/{UserId}","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"},"GivenName":{},"Surname":{},"Type":{},"StorageRule":{"shape":"Sj"},"TimeZoneId":{},"Locale":{},"GrantPoweruserPrivileges":{}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S8":{"type":"structure","members":{"Id":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"OrganizationId":{},"RootFolderId":{},"RecycleBinFolderId":{},"Status":{},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"TimeZoneId":{},"Locale":{},"Storage":{"type":"structure","members":{"StorageUtilizedInBytes":{"type":"long"},"StorageRule":{"shape":"Sj"}}}}},"Sj":{"type":"structure","members":{"StorageAllocatedInBytes":{"type":"long"},"StorageType":{}}},"St":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S13":{"type":"structure","required":["CommentId"],"members":{"CommentId":{},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"Status":{},"Visibility":{},"RecipientId":{}}},"S16":{"type":"map","key":{},"value":{}},"S1d":{"type":"structure","members":{"Id":{},"Name":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ResourceState":{},"Signature":{},"Labels":{"shape":"S1g"},"Size":{"type":"long"},"LatestVersionSize":{"type":"long"}}},"S1g":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"SubscriptionId":{},"EndPoint":{},"Protocol":{}}},"S2d":{"type":"structure","members":{"Id":{},"Username":{},"GivenName":{},"Surname":{},"EmailAddress":{}}},"S2g":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}},"S2j":{"type":"structure","members":{"Type":{},"Name":{},"OriginalName":{},"Id":{},"VersionId":{},"Owner":{"shape":"S2d"},"ParentId":{}}},"S2u":{"type":"structure","members":{"Id":{},"Name":{},"ContentType":{},"Size":{"type":"long"},"Signature":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"CreatorId":{},"Thumbnail":{"type":"map","key":{},"value":{"shape":"S2z"}},"Source":{"type":"map","key":{},"value":{"shape":"S2z"}}}},"S2z":{"type":"string","sensitive":true},"S37":{"type":"list","member":{"shape":"S1d"}},"S38":{"type":"list","member":{"shape":"S39"}},"S39":{"type":"structure","members":{"Id":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"LatestVersionMetadata":{"shape":"S2u"},"ResourceState":{},"Labels":{"shape":"S1g"}}},"S3b":{"type":"string","sensitive":true},"S42":{"type":"structure","members":{"Components":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}}}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDocumentVersions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"DocumentVersions"},"DescribeFolderContents":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":["Folders","Documents"]},"DescribeUsers":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Users"}}}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-12","endpointPrefix":"xray","protocol":"rest-json","serviceFullName":"AWS X-Ray","serviceId":"XRay","signatureVersion":"v4","uid":"xray-2016-04-12"},"operations":{"BatchGetTraces":{"http":{"requestUri":"/Traces"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Traces":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"Segments":{"type":"list","member":{"type":"structure","members":{"Id":{},"Document":{}}}}}}},"UnprocessedTraceIds":{"type":"list","member":{}},"NextToken":{}}}},"CreateGroup":{"http":{"requestUri":"/CreateGroup"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"FilterExpression":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Si"}}}},"CreateSamplingRule":{"http":{"requestUri":"/CreateSamplingRule"},"input":{"type":"structure","required":["SamplingRule"],"members":{"SamplingRule":{"shape":"Sk"}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S10"}}}},"DeleteGroup":{"http":{"requestUri":"/DeleteGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{}}},"DeleteSamplingRule":{"http":{"requestUri":"/DeleteSamplingRule"},"input":{"type":"structure","members":{"RuleName":{},"RuleARN":{}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S10"}}}},"GetEncryptionConfig":{"http":{"requestUri":"/EncryptionConfig"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S19"}}}},"GetGroup":{"http":{"requestUri":"/GetGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Si"}}}},"GetGroups":{"http":{"requestUri":"/Groups"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{}}}},"NextToken":{}}}},"GetSamplingRules":{"http":{"requestUri":"/GetSamplingRules"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingRuleRecords":{"type":"list","member":{"shape":"S10"}},"NextToken":{}}}},"GetSamplingStatisticSummaries":{"http":{"requestUri":"/SamplingStatisticSummaries"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingStatisticSummaries":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"BorrowCount":{"type":"integer"},"SampledCount":{"type":"integer"}}}},"NextToken":{}}}},"GetSamplingTargets":{"http":{"requestUri":"/SamplingTargets"},"input":{"type":"structure","required":["SamplingStatisticsDocuments"],"members":{"SamplingStatisticsDocuments":{"type":"list","member":{"type":"structure","required":["RuleName","ClientID","Timestamp","RequestCount","SampledCount"],"members":{"RuleName":{},"ClientID":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"SampledCount":{"type":"integer"},"BorrowCount":{"type":"integer"}}}}}},"output":{"type":"structure","members":{"SamplingTargetDocuments":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"FixedRate":{"type":"double"},"ReservoirQuota":{"type":"integer"},"ReservoirQuotaTTL":{"type":"timestamp"},"Interval":{"type":"integer"}}}},"LastRuleModification":{"type":"timestamp"},"UnprocessedStatistics":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"ErrorCode":{},"Message":{}}}}}}},"GetServiceGraph":{"http":{"requestUri":"/ServiceGraph"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"NextToken":{}}},"output":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Services":{"shape":"S27"},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTimeSeriesServiceStatistics":{"http":{"requestUri":"/TimeSeriesServiceStatistics"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"EntitySelectorExpression":{},"Period":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TimeSeriesServiceStatistics":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"EdgeSummaryStatistics":{"shape":"S2d"},"ServiceSummaryStatistics":{"shape":"S2m"},"ResponseTimeHistogram":{"shape":"S2h"}}}},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTraceGraph":{"http":{"requestUri":"/TraceGraph"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Services":{"shape":"S27"},"NextToken":{}}}},"GetTraceSummaries":{"http":{"requestUri":"/TraceSummaries"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TimeRangeType":{},"Sampling":{"type":"boolean"},"SamplingStrategy":{"type":"structure","members":{"Name":{},"Value":{"type":"double"}}},"FilterExpression":{},"NextToken":{}}},"output":{"type":"structure","members":{"TraceSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"ResponseTime":{"type":"double"},"HasFault":{"type":"boolean"},"HasError":{"type":"boolean"},"HasThrottle":{"type":"boolean"},"IsPartial":{"type":"boolean"},"Http":{"type":"structure","members":{"HttpURL":{},"HttpStatus":{"type":"integer"},"HttpMethod":{},"UserAgent":{},"ClientIp":{}}},"Annotations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"AnnotationValue":{"type":"structure","members":{"NumberValue":{"type":"double"},"BooleanValue":{"type":"boolean"},"StringValue":{}}},"ServiceIds":{"shape":"S38"}}}}},"Users":{"type":"list","member":{"type":"structure","members":{"UserName":{},"ServiceIds":{"shape":"S38"}}}},"ServiceIds":{"shape":"S38"},"ResourceARNs":{"type":"list","member":{"type":"structure","members":{"ARN":{}}}},"InstanceIds":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"AvailabilityZones":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"EntryPoint":{"shape":"S39"},"FaultRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S3o"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"ErrorRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S3o"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"ResponseTimeRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Coverage":{"type":"double"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"Revision":{"type":"integer"},"MatchedEventTime":{"type":"timestamp"}}}},"ApproximateTime":{"type":"timestamp"},"TracesProcessedCount":{"type":"long"},"NextToken":{}}}},"PutEncryptionConfig":{"http":{"requestUri":"/PutEncryptionConfig"},"input":{"type":"structure","required":["Type"],"members":{"KeyId":{},"Type":{}}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S19"}}}},"PutTelemetryRecords":{"http":{"requestUri":"/TelemetryRecords"},"input":{"type":"structure","required":["TelemetryRecords"],"members":{"TelemetryRecords":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"SegmentsReceivedCount":{"type":"integer"},"SegmentsSentCount":{"type":"integer"},"SegmentsSpilloverCount":{"type":"integer"},"SegmentsRejectedCount":{"type":"integer"},"BackendConnectionErrors":{"type":"structure","members":{"TimeoutCount":{"type":"integer"},"ConnectionRefusedCount":{"type":"integer"},"HTTPCode4XXCount":{"type":"integer"},"HTTPCode5XXCount":{"type":"integer"},"UnknownHostCount":{"type":"integer"},"OtherCount":{"type":"integer"}}}}}},"EC2InstanceId":{},"Hostname":{},"ResourceARN":{}}},"output":{"type":"structure","members":{}}},"PutTraceSegments":{"http":{"requestUri":"/TraceSegments"},"input":{"type":"structure","required":["TraceSegmentDocuments"],"members":{"TraceSegmentDocuments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedTraceSegments":{"type":"list","member":{"type":"structure","members":{"Id":{},"ErrorCode":{},"Message":{}}}}}}},"UpdateGroup":{"http":{"requestUri":"/UpdateGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Si"}}}},"UpdateSamplingRule":{"http":{"requestUri":"/UpdateSamplingRule"},"input":{"type":"structure","required":["SamplingRuleUpdate"],"members":{"SamplingRuleUpdate":{"type":"structure","members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"Host":{},"ServiceName":{},"ServiceType":{},"HTTPMethod":{},"URLPath":{},"Attributes":{"shape":"Sw"}}}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S10"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Si":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{}}},"Sk":{"type":"structure","required":["ResourceARN","Priority","FixedRate","ReservoirSize","ServiceName","ServiceType","Host","HTTPMethod","URLPath","Version"],"members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"ServiceName":{},"ServiceType":{},"Host":{},"HTTPMethod":{},"URLPath":{},"Version":{"type":"integer"},"Attributes":{"shape":"Sw"}}},"Sw":{"type":"map","key":{},"value":{}},"S10":{"type":"structure","members":{"SamplingRule":{"shape":"Sk"},"CreatedAt":{"type":"timestamp"},"ModifiedAt":{"type":"timestamp"}}},"S19":{"type":"structure","members":{"KeyId":{},"Status":{},"Type":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"Name":{},"Names":{"shape":"S29"},"Root":{"type":"boolean"},"AccountId":{},"Type":{},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Edges":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SummaryStatistics":{"shape":"S2d"},"ResponseTimeHistogram":{"shape":"S2h"},"Aliases":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"type":"list","member":{}},"Type":{}}}}}}},"SummaryStatistics":{"shape":"S2m"},"DurationHistogram":{"shape":"S2h"},"ResponseTimeHistogram":{"shape":"S2h"}}}},"S29":{"type":"list","member":{}},"S2d":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S2f"},"FaultStatistics":{"shape":"S2g"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S2f":{"type":"structure","members":{"ThrottleCount":{"type":"long"},"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S2g":{"type":"structure","members":{"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S2h":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"double"},"Count":{"type":"integer"}}}},"S2m":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S2f"},"FaultStatistics":{"shape":"S2g"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S38":{"type":"list","member":{"shape":"S39"}},"S39":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"AccountId":{},"Type":{}}},"S3o":{"type":"list","member":{"type":"structure","members":{"Name":{},"Message":{}}}}}}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetTraces":{"input_token":"NextToken","non_aggregate_keys":["UnprocessedTraceIds"],"output_token":"NextToken","result_key":"Traces"},"GetGroups":{"input_token":"NextToken","output_token":"NextToken","result_key":"Groups"},"GetSamplingRules":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingRuleRecords"},"GetSamplingStatisticSummaries":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingStatisticSummaries"},"GetServiceGraph":{"input_token":"NextToken","non_aggregate_keys":["StartTime","EndTime","ContainsOldGroupVersions"],"output_token":"NextToken","result_key":"Services"},"GetTimeSeriesServiceStatistics":{"input_token":"NextToken","non_aggregate_keys":["ContainsOldGroupVersions"],"output_token":"NextToken","result_key":"TimeSeriesServiceStatistics"},"GetTraceGraph":{"input_token":"NextToken","output_token":"NextToken","result_key":"Services"},"GetTraceSummaries":{"input_token":"NextToken","non_aggregate_keys":["TracesProcessedCount","ApproximateTime"],"output_token":"NextToken","result_key":"TraceSummaries"}}}

/***/ }),
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"us-iso-*/*":{"endpoint":"{service}.{region}.c2s.ic.gov"},"us-isob-*/*":{"endpoint":"{service}.{region}.sc2s.sgov.gov"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":"globalSSL","cn-*/route53":{"endpoint":"{service}.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-northwest-1"},"us-gov-*/route53":"globalGovCloud","*/waf":"globalSSL","*/iam":"globalSSL","cn-*/iam":{"endpoint":"{service}.cn-north-1.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-north-1"},"us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true,"signingRegion":"us-east-1"},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com","globalEndpoint":true,"signingRegion":"us-gov-west-1"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoadingBar__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoadingBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoadingBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_shared_ErrorView_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_shared_ErrorView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_shared_ErrorView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal___default.a,
    ErrorView: __WEBPACK_IMPORTED_MODULE_3__views_shared_ErrorView_vue___default.a,
    LoadingBar: __WEBPACK_IMPORTED_MODULE_2__components_LoadingBar___default.a

  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('sessionStore', ['logged']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('overlayStore', ['notifications'])),
  mounted: function mounted() {
    console.log('------APP MOUNT-------');
  }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoadingBar__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoadingBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LoadingBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PolicyAgreement__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PolicyAgreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PolicyAgreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FindElement__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FindElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_FindElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_profile_Index_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_profile_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_profile_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_sharing_SharingItem_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_sharing_SharingItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_sharing_SharingItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_configuration_ConfigGroup__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_configuration_ConfigGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_configuration_ConfigGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_profile_OrganizationDisplay__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_profile_OrganizationDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_profile_OrganizationDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_help_Index__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_help_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_help_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(3);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal___default.a,
    ErrorView: __WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView_vue___default.a,
    LoadingBar: __WEBPACK_IMPORTED_MODULE_4__components_LoadingBar___default.a,
    PolicyAgreement: __WEBPACK_IMPORTED_MODULE_6__components_PolicyAgreement___default.a,
    FindElement: __WEBPACK_IMPORTED_MODULE_7__components_FindElement___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_8__components_Spinner_vue___default.a,
    ProfileView: __WEBPACK_IMPORTED_MODULE_9__views_profile_Index_vue___default.a,
    ConfigGroup: __WEBPACK_IMPORTED_MODULE_11__views_configuration_ConfigGroup___default.a,
    SharingItem: __WEBPACK_IMPORTED_MODULE_10__views_sharing_SharingItem_vue___default.a,
    OrganizationDisplay: __WEBPACK_IMPORTED_MODULE_12__views_profile_OrganizationDisplay___default.a,
    HelpSection: __WEBPACK_IMPORTED_MODULE_13__views_help_Index___default.a
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
      mobile: window.innerWith <= 700,
      navMenuFontSize: 3,

      displayHeadMenu: true,
      displayHeadMenuShowHideButton: true,
      displayElIot: window.innerWidth >= 1000,
      displayHideHeadMenuOpen: { FR: 'Afficher Entête', EN: 'Display Head Menu' },
      displayHideHeadMenuClose: { FR: 'Cacher Entête', EN: 'Hide Head Menu' },


      displayNavBar: false,
      actualLanguage: "FR",
      displayEvsensAdminFlag: false,
      actualGroupName: '',
      groupSelect1: -1,
      groupSelect2: -1,
      groupSelect3: -1,
      groupSelect4: -1,
      displayGroupSelector2to4: [false, false, false],
      actualBundleName: '',

      displayBundleSelector1to3: [false, false, false],

      navBarLink: [],
      navIndexGU: [],
      navIndexGS: [],
      navIndexGUTempo: [],
      navIndexGSTempo: [],
      flagDisplayHome: true,
      flagBundleIsLoading: false,
      flagBundleIsLoaded: false,
      flagBundleSelected: false,
      flagArborescenceIsLoading: true,
      displayListSharingFlag: true,
      groupIsDeleting: false,

      flagDisplayProfileView: false,
      flagDisplayCostSplittingMenu: false,

      groupInOrganizationIsCreating: false,
      groupInGroupIsCreating: false,

      headerMenuSelectedTab: 3,

      actualOrganizationIndex: 0,

      stringToFind: '',
      searchDoneFlag: false,
      researchInProgress: false,
      researchResults: [],

      displayHomeTab: false,
      test: 1,
      homeTabMenuSelector: [true, false, false, false],
      homeTabMenuProfile: { FR: 'Mon Profile', EN: 'My Profile' },
      homeTabMenuOrganizations: { FR: 'Mes Organisations', EN: 'My Organizations' },
      homeTabMenuFirstLevelGroup: { FR: 'Création de groupe', EN: 'Group creator' },
      homeTabMenuResearch: { FR: 'Recherche', EN: 'Research' },
      homeTabMenuHelp: { FR: 'Aide', EN: 'Help' },

      sectionLabelOrganization: { FR: "Mes Organisations", EN: 'My Organizations' },
      buttonLabelCreateOrganization: { FR: "Créer une organisation", EN: 'Create an organization' },
      buttonHelpManagerVersionDocumentation: { FR: "AIDE : Explication de la version gestionaire de la plateforme web", EN: 'HELP : Explanation documentation of the web platform manager version' },
      massageOrganizationRequired: { FR: "Une organisation est requise pour accéder à la plateforme gestionaire.", EN: 'An organization is required to access the manager platform version.' },

      groupTempo: {},
      groupParentTempo: {},
      flagPersonalGroupSelected: false,
      flagFirstLevelGUSelector: true,
      flagGroupInParentSelect: [],
      flagGroupSelected: false,
      flagGroupSelectedByBundle: false,
      groupParentId: 'TBD',

      flagShowCustomerSupportSection: false,

      bundleIsLoading: false,
      bundleTempo: {},
      subBundleTempo: [],
      bundleParentTempo: { 'bundles': [] },
      flagBundleInParentSelect: [],
      bundleParent: '',
      bundleParentId: 'TBD',
      tata: '',

      parentContainer: 'NA',

      messageAcceuil: { FR: 'Bonjour ', EN: 'Hi ' },
      messageLoading: { FR: 'Chargement...', EN: 'Loading...' },
      labelProfileButton: { FR: 'Mon profile', EN: "My profile" },
      labelPortButton: { FR: 'Port de recharge', EN: "Charging port" },
      labelMesElcButton: { FR: 'Mesures', EN: "Measurements" },
      labelAlertsButton: { FR: 'Mes alertes', EN: "My alerts" },
      labelSplitCostButton: { FR: 'Répartiteur coûts', EN: "Cost splitting" },
      labelGrpButton: { FR: 'Groupe', EN: "Group" },
      labelHelpButton: { FR: 'Aide', EN: "Help" },
      labelSharingButton: { FR: 'Réception de partage', EN: "Sharing reception" },

      labelSession: {
        FR: 'Votre session est expirée, vous devez rafraichir votre session.',
        EN: "Your session is expired, you need to refresh your session"
      },
      labelSessionBtn: { FR: 'Rafraichir ma session', EN: "Refresn my session" },
      sharingInvitationsPopUp: { FR: "Vous avez reçu une invitation de partage, utilisez le menu ''Réception de partage'' pour traiter l'invitation", EN: "You receive a sharing invitation, you must go in the ''Sharing reception'' menu to manage this invitation." },
      sharingInvitationsPopUp2: { FR: "Vos partages sont disponibles en navigant dans vos groupes ou système et/ou en sélectionant le menu ''Réception de partage''", EN: "Your sharing are available by navigating in your Group or Systems or by accessing the ''Sharing reception'' menu to manage theses invitations." },

      buttonLabelRefresh: { FR: 'Actualiser', EN: 'Refresh' },
      menuLabelGroup: { FR: 'Groupes', EN: 'Groups' },
      menuLabelSystem: { FR: 'Systèmes', EN: 'Systems' },
      buttonLabelReadSystem: { FR: 'Lire le système', EN: 'Read System' },
      textMessageSelectAndPressReadSystem: { FR: 'Sélectionné le système et appuyer sur le bouton "Lire le système"', EN: 'Select your system and press "Read System" button' },
      buttonLabelReadRefreshSystem: { FR: 'Lire/Rafraichir les données du Système', EN: 'Read/Refresh System datas' },
      textLabelCreateFirstLevelGroup: { FR: 'Création de Groupe de premier niveau', EN: 'Create first level Group' },
      textIndicationCreateFirstLevelGroup: { FR: "Création de Groupe de premier niveau à l'organisation", EN: 'Create first level Group to the Organization' },
      buttonLabelSelectGroup: { FR: "Sélection de l'Organisation", EN: 'Organization selection' },
      buttonLabelCreateFirstLevelGroup: { FR: 'Créer un Groupe de premier niveau', EN: 'Create first level Group' },
      textYouReceiveGroupSharing: { FR: "Vous avez reçu un partage de Groupe", EN: 'You received Group sharing' },
      textYouReceiveSystemSharing: { FR: "Vous avez reçu un partage de Système", EN: 'You received System sharing' },
      blocLabelSelectAddGroupOrSystem: { FR: "Navigation et gestion de Groupe", EN: 'Navigation and Group management' },
      textIndicationSelectAddGroupOrSystem: { FR: "Sélectionnez un Groupe ou un System dans le menu de navigation (à gauche).", EN: 'Select Group or System in navigation menu (left).' },
      textIndicationAddOrModifyGroup: { FR: "Vous pouvez créer un sous groupe ou modifier les configurations du groupe sélectionné.", EN: 'You can create a subgroup or modify the configurations of the selected group.' },

      blocLabelAddComponentToGroupe: { FR: "Ajout de Sous-Groupe et Systèmes", EN: 'Create Sub-Group or System' },
      blocLabelConfigGroup: { FR: "Configuration du groupe", EN: 'Group configuration' },
      buttonLabelAddSubGroup: { FR: "Ajouter un Sous-Groupe", EN: 'Add Sub-Group' },
      buttonLabelAddSystemToGroup: { FR: "Ajouter un Système", EN: 'Add System' },
      buttonLabelShareThisGroup: { FR: "Partager ce Groupe", EN: 'Share this Group' },
      buttonLabelDeleteGroup: { FR: "Supprimer le Groupe sélectionné", EN: 'Delete selected Group' },
      textIndicationSelectGroupOrSystem: { FR: "Sélectionnez un Groupe ou un Système dans le menu de navigation (à gauche).", EN: 'Select Group or System in navigation menu (left).' },

      findElementSectionLabel: { FR: "Recherche d'élément", EN: "Search element" },
      findElementSearchLabel: { FR: "Rechercher", EN: "Search" },
      findElementNoResults: { FR: "Aucun résultats", EN: "No results" },
      researchTableTitleType: { FR: "Type", EN: "Type" },
      researchTableTitlePath: { FR: "Chemin d'accèes", EN: "Access Path" },
      researchTableTitleName: { FR: "Nom", EN: "Name" },
      researchTableTitleRefName: { FR: "Nom de référence", EN: "Reference Name" },
      researchTableTitleAction: { FR: "Ouvrir", EN: "Open" },

      userAcessLevel2Flag: false,

      groupConfigViewFlag: false,
      groupConfigEditFlag: false,
      groupConfigDeleteFlag: false,
      groupSharingEnableFlag: false,

      sidebarIsActive: false

    }, 'groupConfigEditFlag', false);
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'dashboardFlags', 'groupArborescence', 'actualGroup', 'actualBundle', 'profileDataReceivedFlag', 'displayAdminFlag', 'navIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["a" /* mapState */])('groupStore', ['actualGroupLevel'])),

  watch: {
    profileData: function profileData() {
      var _this = this;

      if (this.profileData.licences.length > 0) {
        this.groupConfigEditFlag = this.findPermissionItemValue(this.profileData.licences[0].permissions.group, 'groupConfigEdit');
        this.userAcessLevel2Flag = this.findPermissionItemValue(this.profileData.licences[0].permissions.user, 'userAdminAccessLevel02');
      }

      this.flagDisplayProfileView = false;
      this.displayListSharingFlag = false;
      this.$nextTick(function () {
        _this.displayListSharingFlag = true;
        _this.flagDisplayProfileView = true;
      });

      this.parentContainer = this.profileData.profileId;

      this.$store.dispatch('sessionStore/setParentContainer', this.parentContainer);
    },
    groupArborescence: function groupArborescence() {

      if (this.navBarLink.length > 0) {
        this.navIndexGUTempo = this.navBarLink[this.navBarLink.length - 1].IndexGU;
        this.navIndexGSTempo = this.navBarLink[this.navBarLink.length - 1].IndexGS;
        this.navIndexGU = [];
        this.navIndexGS = [];
        this.groupParentId = this.profileData.profileId;
      }

      this.navBarLink = [];
      this.refreshNavMenu();

      if (this.profileData.sharingInvitations.length < 100) {
        if (this.dashboardFlags['evsensAdminFlag'] == false && this.navBarLink.length == 0) {
          this.navIndexGUTempo = [];
          this.navIndexGSTempo = [];
          this.selectFirstLevelGroup(0);

          if (this.bundleParentTempo.bundles.length == 1 || this.profileData.licences.length == 0) {
            this.selectFirstLevelBundle(0);
          }

          this.$store.dispatch('sessionStore/setParentContainer', this.computeParentContainerPrefix() + ':' + this.actualGroup.group_id);
        }
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    displaySidebar: function displaySidebar() {
      this.sidebarIsActive = !this.sidebarIsActive;
    },
    logOut: function logOut() {
      var _this2 = this;

      this.$store.dispatch('sessionStore/logOut').then(function () {
        _this2.$router.push({ name: "login" });
      });
    },
    refreshPage: function refreshPage() {
      console.log('Dashboard:RefreshPage called');
      document.location.reload();
    },
    toggleLanguage: function toggleLanguage() {
      var _this3 = this;

      if (this.actualLanguage == 'FR') {
        this.actualLanguage = 'EN';
        localStorage.language = 'EN';
      } else {
        this.actualLanguage = 'FR';
        localStorage.language = 'FR';
      }
      this.$store.dispatch('sessionStore/updatelanguage', { language: this.actualLanguage }).then(function () {
        _this3.location.reload();
      });
    },
    checkDashboardNews: function checkDashboardNews() {

      for (var m = 0; m < this.profileData.dashboard_news.length; m++) {
        if (this.profileData.dashboard_news[m].readFlag == false) {
          var modalParameters = { 'newsIndex': m };
          this.$store.dispatch('overlayStore/setParameters', modalParameters);
          this.showModal('dashboard-news');
        }
      }
    },
    actualiserArborescence: function actualiserArborescence() {
      var _this4 = this;

      this.flagBundleIsLoading = true;
      this.flagArborescenceIsLoading = true;
      this.$store.dispatch('sessionStore/refreshProfileData').then(function (response) {
        _this4.$store.dispatch('sessionStore/getGroupArborescence').then(function (response) {
          _this4.flagArborescenceIsLoading = false;
          if (_this4.flagBundleSelected) {
            _this4.loadSelectedBundle();
          } else {
            _this4.flagBundleIsLoading = false;
          }
        });
      });
    },
    toggleShowHideHead: function toggleShowHideHead() {
      if (this.displayHeadMenu) {
        this.displayHeadMenu = false;
      } else {
        this.displayHeadMenu = true;
      }
    },
    toggleHomeTabMenuSelector: function toggleHomeTabMenuSelector(index) {
      this.displayHomeTab = false;
      for (var n = 0; n < this.homeTabMenuSelector.length; n++) {
        this.homeTabMenuSelector[n] = false;
      }
      this.homeTabMenuSelector[index] = true;

      this.test = index;
      this.displayHomeTab = true;
    },
    openMultiGroupDocumentation: function openMultiGroupDocumentation() {
      var localUrl = 'https://s3.amazonaws.com/evsenscloud.com/documents/Description_Portail_Multi_Groupe_V1P00.pdf';
      window.open(localUrl, '_blank');
    },
    goHomeGroup: function goHomeGroup(index) {
      this.flagDisplayHome = true;
      this.flagGroupSelectedByBundle = false;
      this.flagBundleSelected = false;
      this.flagBundleIsLoaded = false;

      this.groupParentId = this.profileData.profileId;

      this.$store.dispatch('sessionStore/setActualBundle', { 'bundle_id': '!!NONE!!', 'bundle_name': '!!None!!' });
      this.$store.dispatch('sessionStore/setActualGroup', { 'group_id': '!!NONE!!', 'permissions': { 'GrpLinkedProfileRead': [false] } });

      this.navBarLink = [];
      this.navIndexGU = [];
      this.navIndexGS = [];
      this.flagGroupSelected = false;
      this.flagGroupInParentSelect = [];
      this.groupParentTempo = this.groupArborescence;
      for (var m = 0; m < this.groupParentTempo.length; m++) {
        this.flagGroupInParentSelect.push(false);
      }
      this.selectGroupFromNav();
      this.parentContainer = this.profileData.profileId;

      this.$store.dispatch('sessionStore/setParentContainer', this.computeParentContainerPrefix() + ':' + this.parentContainer);
    },
    goBackNav: function goBackNav(index) {
      this.navBarLink = this.navBarLink.splice(0, index + 1);
      this.navIndexGUTempo = this.navBarLink[index].IndexGU;
      this.navIndexGSTempo = this.navBarLink[index].IndexGS;
      this.navIndexGU = [];
      this.navIndexGS = [];

      var selectedItemIsBundle = this.navBarLink[index].Type == 'GS';
      if (this.navBarLink[index].Type == 'GU') {
        this.flagBundleSelected = false;
        this.flagBundleIsLoaded = false;
      }
      if (this.actualBundle.bundle_name == 'None') {
        this.flagBundleSelected = false;
      }
      this.navBarLink = [];
      this.refreshNavMenu();

      if (selectedItemIsBundle) {
        this.loadSelectedBundle();
      }
    },
    refreshNavMenu: function refreshNavMenu() {
      this.groupParentTempo = this.groupArborescence;
      this.bundleParentTempo = { 'bundles': [] };
      this.groupParentId = this.profileData.profileId;

      if (this.navIndexGUTempo.length > 0) {
        this.selectFirstLevelGroup(this.navIndexGUTempo[0]);
        for (var n = 1; n < this.navIndexGUTempo.length; n++) {
          this.selectSecondLevelGroup(this.navIndexGUTempo[n]);
        }
        this.flagGroupInParentSelect = [];

        for (var n = 0; n < this.groupParentTempo.length; n++) {
          this.flagGroupInParentSelect.push(false);
        }
        this.flagGroupInParentSelect[this.navIndexGU[this.navIndexGU.length - 1]] = true;

        if (this.navIndexGSTempo.length > 0) {
          this.selectFirstLevelBundle(this.navIndexGSTempo[0]);
          for (var n = 1; n < this.navIndexGSTempo.length; n++) {
            this.selectSecondLevelBundle(this.navIndexGSTempo[n]);
          }
        }

        this.flagBundleInParentSelect = [];
        for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
          this.flagBundleInParentSelect.push(false);
        }
        this.flagBundleInParentSelect[this.navIndexGS[this.navIndexGS.length - 1]] = true;
      }

      this.$store.dispatch('sessionStore/setActualNavIndex', {
        'GU': this.navIndexGU,
        'GS': this.navIndexGS,
        'groupParentId': this.groupParentId,
        'bundleParentId': this.bundleParentId
      });
    },
    selectFirstLevelGroup: function selectFirstLevelGroup(index) {

      this.flagBundleSelected = false;
      this.flagBundleIsLoading = false;

      for (var n = 0; n < this.groupParentTempo.length; n++) {
        this.flagGroupInParentSelect[n] = false;
      }

      if (index == 0 && this.navIndexGU.length <= 1) {
        this.flagPersonalGroupSelected = true;
      } else {
        this.flagPersonalGroupSelected = false;
      }

      this.bundleParentTempo = this.groupParentTempo[index];

      this.flagBundleInParentSelect = [];
      for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
        this.flagBundleInParentSelect.push(false);
      }

      this.flagGroupInParentSelect[index] = true;
      this.flagGroupSelected = true;
      this.flagDisplayHome = false;
      if (this.navIndexGU.length == 0) {
        this.navIndexGS = [];
        this.navIndexGU.push(index);
        this.navBarLink = [];
        this.selectGroupFromNav();
        var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGU));
        var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGS));
        this.navBarLink.push({ 'Name': this.actualGroup.group_name, 'Type': 'GU', 'IndexGU': a, 'IndexGS': b });
      } else {
        this.navIndexGU[this.navIndexGU.length - 1] = index;
        this.navIndexGS = [];
        this.selectGroupFromNav();
        var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGU));
        var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGS));
        this.navBarLink.splice(this.navBarLink.length - 1, 1, {
          'Name': this.actualGroup.group_name,
          'Type': 'GU',
          'IndexGU': a,
          'IndexGS': b
        });
      }
    },
    selectSecondLevelGroup: function selectSecondLevelGroup(index) {
      this.groupTempo = [];
      this.flagBundleSelected = false;
      this.flagBundleIsLoading = false;

      for (var n = 0; n < this.groupParentTempo[this.navIndexGU[this.navIndexGU.length - 1]].sub_group.length; n++) {
        this.groupTempo.push(this.groupParentTempo[this.navIndexGU[this.navIndexGU.length - 1]].sub_group[n]);
      }

      this.groupParentTempo = this.groupTempo;

      this.bundleParentTempo = this.groupParentTempo[index];
      this.flagBundleInParentSelect = [];
      for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
        this.flagBundleInParentSelect.push(false);
      }

      for (var n = 0; n < this.groupParentTempo.length; n++) {
        this.flagGroupInParentSelect[n] = false;
      }
      this.flagGroupInParentSelect[index] = true;

      this.navIndexGS = [];
      this.navIndexGU.push(index);
      this.selectGroupFromNav();

      var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGU));
      var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGS));
      this.navBarLink.push({ 'Name': this.actualGroup.group_name, 'Type': 'GU', 'IndexGU': a, 'IndexGS': b });
    },
    selectFirstLevelBundle: function selectFirstLevelBundle(index) {
      this.flagGroupSelectedByBundle = true;
      this.flagBundleIsLoaded = false;
      this.flagBundleInParentSelect = [];
      this.flagBundleSelected = true;
      for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
        this.flagBundleInParentSelect.push(false);
      }

      this.flagBundleInParentSelect[index] = true;
      if (this.navIndexGS.length == 0) {
        this.navIndexGS.push(index);
        this.selectGroupFromNav();
        var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGU));
        var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGS));
        this.navBarLink.push({ 'Name': this.actualBundle.bundle_name, 'Type': 'GS', 'IndexGU': a, 'IndexGS': b });
      } else {
        this.navIndexGS[this.navIndexGS.length - 1] = index;
        this.selectGroupFromNav();
        var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGU));
        var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGS));
        this.navBarLink.splice(this.navBarLink.length - 1, 1, {
          'Name': this.actualBundle.bundle_name,
          'Type': 'GS',
          'IndexGU': a,
          'IndexGS': b
        });
      }
    },
    selectSecondLevelBundle: function selectSecondLevelBundle(index) {
      this.bundleTempo = {};
      this.subBundleTempo = [];
      this.flagBundleIsLoaded = false;

      for (var n = 0; n < this.bundleParentTempo.bundles[this.navIndexGS[this.navIndexGS.length - 1]].sub_bundle.length; n++) {
        this.subBundleTempo.push(this.bundleParentTempo.bundles[this.navIndexGS[this.navIndexGS.length - 1]].sub_bundle[n]);
      }
      this.bundleTempo = { 'bundles': this.subBundleTempo };
      this.bundleParentTempo = this.bundleTempo;

      this.flagBundleInParentSelect = [];
      for (var n = 0; n < this.bundleParentTempo.bundles.length; n++) {
        this.flagBundleInParentSelect.push(false);
      }
      this.flagBundleInParentSelect[index] = true;

      this.navIndexGS.push(index);
      this.selectGroupFromNav();
      var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGU));
      var b = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.navIndexGS));
      this.navBarLink.push({ 'Name': this.actualBundle.bundle_name, 'Type': 'GS', 'IndexGU': a, 'IndexGS': b });
    },
    selectGroupFromNav: function selectGroupFromNav() {
      if (this.navIndexGU.length > 0) {
        this.groupTempo = this.groupArborescence[this.navIndexGU[0]];
        this.groupParentId = this.profileData.profileId;
        this.parentContainer = this.profileData.profileId;

        for (var n = 1; n < this.navIndexGU.length; n++) {
          this.groupParentId = this.groupTempo['group_id'];
          this.parentContainer = this.groupTempo['group_id'];
          this.groupTempo = this.groupTempo.sub_group[this.navIndexGU[n]];
        }

        this.bundleTempo = { 'bundle_id': '!!NONE!!', 'bundle_name': 'None' };
        this.bundleParentId = this.groupTempo['group_id'];
        if (this.navIndexGS.length > 0) {
          this.flagDisplaySubGroupSelector = false;
          this.parentContainer = this.groupTempo['group_id'];

          this.bundleTempo = this.groupTempo.bundles[this.navIndexGS[0]];

          for (var n = 1; n < this.navIndexGS.length; n++) {
            this.bundleParentId = this.bundleTempo['bundle_id'];
            this.parentContainer = this.bundleTempo['bundle_id'];
            this.bundleTempo = this.bundleTempo.sub_bundle[this.navIndexGS[n]];
          }
        }
      } else {
        this.groupTempo = { 'group_id': '!!NONE!!', 'permissions': { 'GrpLinkedProfileRead': [false] } };
        this.bundleTempo = { 'bundle_id': '!!NONE!!', 'bundle_name': 'None' };
        this.groupParentId = this.profileData.profileId;
      }

      this.$store.dispatch('sessionStore/setActualGroup', this.groupTempo);

      if ('group' in this.actualGroup.permissions) {
        this.groupConfigViewFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupConfigView');
        this.groupConfigEditFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupConfigEdit');
        this.groupConfigDeleteFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupConfigDelete');
        this.groupSharingEnableFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupSharingEnable');
      }

      this.$store.dispatch('sessionStore/setParentContainer', this.computeParentContainerPrefix() + ':' + this.parentContainer);

      this.$store.dispatch('sessionStore/setActualBundle', this.bundleTempo);

      this.$store.dispatch('sessionStore/setActualNavIndex', {
        'GU': this.navIndexGU,
        'GS': this.navIndexGS,
        'groupParentId': this.groupParentId,
        'bundleParentId': this.bundleParentId
      });

      if (this.navIndexGS.length > 0 && this.bundleTempo.sub_bundle.length == 0) {
        if (this.bundleParentTempo.bundles.length == 1) {
          this.loadSelectedBundle();
        } else {
          if (this.profileData.licences.length == 0) {
            this.loadSelectedBundle();
          }
        }
      }
    },
    loadSelectedBundle: function loadSelectedBundle() {
      var _this5 = this;

      this.flagBundleIsLoading = true;
      this.flagBundleIsLoaded = false;

      if ('bundle_id' in this.bundleTempo) {
        if (this.bundleTempo.bundle_id != '!!NONE!!') {

          this.flagBundleSelected = false;
          var requestData = { 'postAction': 'ReadBundleData',
            'bundleId': this.bundleTempo.bundle_id };
          this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
            if (response.data.Code == 'OK') {
              _this5.bundleTempo = response.data.BundleData;

              if ('moduleCostSplit' in _this5.bundleTempo.bundleRights) {
                _this5.flagDisplayCostSplittingMenu = _this5.bundleTempo.bundleRights.moduleCostSplit.moduleEnable;
              } else {
                _this5.flagDisplayCostSplittingMenu = false;
              }

              _this5.$store.dispatch('sessionStore/setActualBundle', _this5.bundleTempo);
              _this5.flagBundleSelected = true;
              _this5.flagBundleIsLoading = false;
              _this5.flagBundleIsLoaded = true;
            } else {
              window.alert("La lecture a échouée. / Reading fail. (Dashboard:loadSelectedBundle)");
            }
          });
        }
      }
    },
    computeParentContainerPrefix: function computeParentContainerPrefix() {
      var returnString = '';
      for (var n = 0; n < this.navIndex.GU.length; n++) {
        returnString = returnString + this.navIndex.GU[n].toString();
      }
      for (var m = 0; m < this.navIndex.GS.length - 1; m++) {
        returnString = returnString + this.navIndex.GS[m].toString();
      }
      return returnString;
    },
    createNewGroupInOrganization: function createNewGroupInOrganization() {
      var _this6 = this;

      if (this.actualLanguage == "FR") {
        var newGroupName = prompt("Nom du nouveau Groupe Usager", "Nom du groupe");
      } else {
        var newGroupName = prompt("New User Group name", "Group name");
      }

      if (newGroupName != null) {
        this.groupInOrganizationIsCreating = true;
        var requestData = {
          'postAction': 'CreateNewGroupInOrganization',
          'groupName': newGroupName,
          'organizationId': this.profileData.managed_organizations[this.actualOrganizationIndex].organizationId
        };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          _this6.groupInOrganizationIsCreating = false;
          if (response.data.Code == 'OK') {
            _this6.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this6.actualLanguage]);
          }
        });
      }
    },
    createNewGroupInGroup: function createNewGroupInGroup() {
      var _this7 = this;

      if (this.actualLanguage == "FR") {
        var newGroupName = prompt("Nom de votre nouveau Groupe Usager à ajouter au Groupe : " + this.actualGroup.group_name, "Nom du groupe");
      } else {
        var newGroupName = prompt("New User Group name", "Group name");
      }

      if (newGroupName != null) {
        this.groupInGroupIsCreating = true;
        var requestData = {
          'postAction': 'CreateNewGroupInGroup',
          'groupName': newGroupName,
          'hostGroup': this.actualGroup.group_id
        };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          _this7.groupInGroupIsCreating = false;
          if (response.data.Code == 'OK') {
            _this7.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this7.actualLanguage]);
          }
        });
      }
    },
    createNewBundleInGroup: function createNewBundleInGroup() {
      var _this8 = this;

      if (this.actualLanguage == "FR") {
        var newBundleName = prompt("Nom de votre nouveau Groupe Système à ajouter au Groupe : " + this.actualGroup.group_name, "Nom du groupe système");
      } else {
        var newBundleName = prompt("New System name", "System Group name");
      }
      if (newBundleName != null) {
        var requestData = {
          'postAction': 'CreateNewBundleInGroup',
          'bundleName': newBundleName,
          'hostGroup': this.actualGroup.group_id
        };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this8.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this8.actualLanguage]);
          }
        });
      }
    },
    deleteActualGroup: function deleteActualGroup() {
      var _this9 = this;

      if (this.actualLanguage == "FR") {
        var confirmation = prompt("Supprimer le Groupe: " + this.actualGroup.group_name, "Confirmer en écrivant DELETE");
      } else {
        var confirmation = prompt("Delete the Group: " + this.actualGroup.group_name, "Confirm by writing : DELETE");
      }
      if (confirmation == 'DELETE') {
        this.groupIsDeleting = true;
        var hostId = this.navIndex.bundleParentId;

        var requestData = { 'postAction': 'DeleteGroup',
          'groupId': this.actualGroup.group_id,
          'parentContainer': this.computeParentContainerPrefix() + ':' + this.parentContainer,
          'hostId': hostId };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {

            document.location.reload();

            _this9.groupIsDeleting = false;
          } else {
            window.alert("L'enregistrement a échoué. / Saving fail.");
          }
        });
      }
    },
    shareActualGroup: function shareActualGroup() {
      var modalParameters = { 'modalTitle': { FR: "Partage de Groupe Usager", EN: 'User Group sharing' },
        'entityOwner': this.actualGroup.group_id,
        'sharingType': 'Group',
        'entityId': this.actualGroup.group_id,
        'entityReferenceName': this.actualGroup.group_name,
        'displayAlertOptions': false,
        'displayChannelOptions': true,
        'displayDeviceOptions': true,
        'displayBundleOptions': true,
        'displayGroupOptions': true,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    createNewUserProfile: function createNewUserProfile() {
      var _this10 = this;

      if (this.actualLanguage == "FR") {
        var newProfileEmail = prompt("Introduire le courriel du profile a créer:", "Courriel");
      } else {
        var newProfileEmail = prompt("Introduce the new profile email:", "Email");
      }

      if (this.actualLanguage == "FR") {
        var newUserFirstName = prompt("Introduire le prénom de l'usager:", "Prenom");
      } else {
        var newUserFirstName = prompt("Introduce the first name of the user:", "First name");
      }

      if (this.actualLanguage == "FR") {
        var newUserLastName = prompt("Introduire le nom de l'usager:", "Nom famille");
      } else {
        var newUserLastName = prompt("Introduce the last name of the user:", "Last name");
      }

      if (this.actualLanguage == "FR") {
        var newUserLanguage = prompt("Language (FR ou EN):", "FR / EN");
      } else {
        var newUserLanguage = prompt("Language (FR or EN):", "FR / EN");
      }

      if (newProfileEmail != null) {
        var requestData = {
          'postAction': 'CreateNewEVSensUser',
          'email': newProfileEmail,
          'firstName': newUserFirstName,
          'lastName': newUserLastName,
          'language': newUserLanguage,
          'frontEndVersion': "EVSENS",
          'hostGroup': this.actualGroup.group_id
        };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this10.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this10.actualLanguage]);
          }
        });
      }
    },
    addDefaultBundleOfExistingUser: function addDefaultBundleOfExistingUser() {
      var _this11 = this;

      if (this.actualLanguage == "FR") {
        var profileEmail = prompt("Introduire le courriel du profile:", "Courriel");
      } else {
        var profileEmail = prompt("Introduce the profile email:", "Email");
      }

      if (profileEmail != null) {
        var requestData = {
          'postAction': 'AddDefaultBundleOfExistingUser',
          'email': profileEmail,
          'hostGroup': this.actualGroup.group_id
        };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this11.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this11.actualLanguage]);
          }
        });
      }
    },
    removeSpecifiedSystem: function removeSpecifiedSystem() {
      var _this12 = this;

      if (this.actualLanguage == "FR") {
        var bundleToRemove = prompt("Introduire le nom du système a retirer:", "Nom du système");
      } else {
        var bundleToRemove = prompt("Introduce the system to remove:", "System name");
      }

      if (bundleToRemove != null) {
        var requestData = {
          'postAction': 'RemoveSpecificBundle',
          'bundleToRemove': bundleToRemove,
          'hostGroup': this.actualGroup.group_id
        };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this12.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this12.actualLanguage]);
          }
        });
      }
    },
    researchInProfile: function researchInProfile() {
      var _this13 = this;

      var requestData = {
        'postAction': 'FindInProfile',
        'stringToFind': this.stringToFind
      };
      this.researchInProgress = true;
      this.searchDoneFlag = false;
      this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
        _this13.researchInProgress = false;

        if (response.data.Code == 'OK') {
          _this13.searchDoneFlag = true;
          _this13.researchResults = response.data.Results;
        } else {
          window.alert(response.data.PromptMessage[_this13.actualLanguage]);
        }
      });
    },
    researchResultGoToPath: function researchResultGoToPath(index) {

      if (this.researchResults[index].NavGroup.length > 0) {
        this.selectFirstLevelGroup(this.researchResults[index].NavGroup[0]);
        for (var n = 1; n < this.researchResults[index].NavGroup.length; n++) {

          this.selectSecondLevelGroup(this.researchResults[index].NavGroup[n]);
        }
      }

      if (this.researchResults[index].NavBundle.length > 0) {
        this.selectFirstLevelBundle(this.researchResults[index].NavBundle[0]);
        for (var n = 1; n < this.researchResults[index].NavBundle.length; n++) {
          this.selectSecondLevelBundle(this.researchResults[index].NavBundle[n]);
        }
        this.loadSelectedBundle();
      }
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),

  beforeCreate: function beforeCreate() {
    var _this14 = this;

    addEventListener('resize', function () {
      _this14.mobile = window.innerWidth <= 700;
      _this14.displayElIot = window.innerWidth >= 1100;
      if (_this14.mobile == true) {
        _this14.navMenuFontSize = 2;
      } else {
        _this14.navMenuFontSize = 3;
      }
    });

    if (this.mobile == true) {
      this.navMenuFontSize = 2;
    } else {
      this.navMenuFontSize = 3;
    }
  },
  mounted: function mounted() {
    var _this15 = this;

    console.log("2.03.002");
    var thisDayUnix = Math.floor(moment().unix() / (24 * 3600)) * (24 * 3600) + 0;

    this.toggleHomeTabMenuSelector(0);

    this.mobile = window.innerWidth <= 925;
    this.$store.dispatch('sessionStore/refreshProfileData').then(function (response) {
      _this15.$store.dispatch('appliancesStore/get');
      _this15.$store.dispatch('appliancesStore/getSystems');

      if (localStorage.lastOpenUnixDay) {
        if (localStorage.lastOpenUnixDay != thisDayUnix) {
          localStorage.lastOpenUnixDay = thisDayUnix;
          _this15.checkDashboardNews();
        }
      } else {
        localStorage.lastOpenUnixDay = thisDayUnix;
        _this15.checkDashboardNews();
      }

      _this15.$store.dispatch('sessionStore/getGroupArborescence').then(function (response) {
        _this15.flagDisplayProfileView = true;
        _this15.flagArborescenceIsLoading = false;

        if (_this15.profileData.sharingInvitations.length > 0) {
          window.alert(_this15.sharingInvitationsPopUp[_this15.actualLanguage]);
          if (_this15.dashboardFlags['evsensAdminFlag']) {
            window.alert(_this15.sharingInvitationsPopUp2[_this15.actualLanguage]);
          }
        }

        if (_this15.profileData.profileInfo.profile_type['masterUserCode']) {
          if (_this15.profileData.profileInfo.profile_type['masterUserCode'].includes("-EVSensAdmin")) {
            _this15.flagShowCustomerSupportSection = true;
          }
        }

        _this15.$router.push({ name: 'measurements' });
      });
    });

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    clearInterval();
  }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfigAccessRulesForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      flagRuleIsLoading: true,
      commentIsSaving: false,
      userExistsFlag: false,
      sharingTransmittedFlag: false,
      sharingRuleTemplateVersion: "V01P00_FE_Template",
      description: '',
      channelIndex: 0,
      workTime: 0,
      sharingReferenceName: '',
      sharingMessage: '',
      ruleTemplate: {},
      sharingUserRecipient: '',

      actualLanguage: "FR",
      labelSectionUser: { FR: 'Accès usager', EN: 'User access' },
      labelSectionGroup: { FR: 'Groupe', EN: 'Group' },
      labelSectionBundle: { FR: 'Systèmes', EN: 'Systems' },
      labelSectionDevice: { FR: 'Modules', EN: 'Modules' },
      labelSectionChannel: { FR: 'Appareils', EN: 'Device' },
      labelSectionAlert: { FR: 'Alerte', EN: 'Alerts' },
      labelSectionCar: { FR: 'VE ou Borne de recharge', EN: 'EV or EVSE' },

      textSharingTransmitted: { FR: 'Le partage a été transmit avec succès!', EN: 'Sharing was successfully transmitted!' },
      textSharingTransmitted2: { FR: 'Vous pouvez fermer cette fenêtre.', EN: 'You can close this window.' },

      labelUserRecipient: { FR: 'Destinataire du partage (courriel)', EN: 'Sharing recipient user (email)' },
      textDescriptionToDo: { FR: "Entrez le courriel du destinataire du partage et appuyer sur ENTRÉ pour valider son enregistrement dans le système.", EN: 'Enter the sharing recipient email and press ENTER to validate if this user exits in the system.' },
      labelReferenceName: { FR: 'Identifiant de partage', EN: 'Sharing identifier' },
      labelMessage: { FR: 'Message au destinataire', EN: 'Sharing recipient message' },
      labelButtonCheckUserExist: { FR: "Vérifier si l'usager existe dans le système", EN: 'Verify if the user exist in the system' },
      labelButtonShare: { FR: "Transmettre l'invitation de partage", EN: 'Transmit the sharing invitation' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'actualGroup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: {
    loadRuleTemplate: function loadRuleTemplate() {
      var _this = this;

      var requestData = { 'postAction': 'GetRuleTemplate',
        'ruleVersion': this.sharingRuleTemplateVersion
      };
      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        console.log(response.data);
        if (response.data.Code == 'OK') {
          console.log(response.data);
          _this.ruleTemplate = response.data.Template;
          _this.flagRuleIsLoading = false;
        } else {
          window.alert("L'enregistrement a échoué. / Saving fail.");
        }
      });
    },
    toUsername: function toUsername(email) {
      var email2 = email.replace('.', '-dot-');
      email = email2.replace('.', '-dot-');
      email2 = email.replace('.', '-dot-');
      return email2.replace('@', '-at-');
    },
    validateUserExist: function validateUserExist() {
      var _this2 = this;

      return this.$store.dispatch('sessionStore/validateUserExist', this.sharingUserRecipient).then(function (response) {
        _this2.displayMessage = response.data.Message;
        if (response.data.Code == 'Fail' && _this2.actualLanguage == "FR") window.alert('Erreur de validation !');
        if (response.data.Code == 'Fail' && _this2.actualLanguage == "EN") window.alert('Validation error !');

        if (response.data.Code == 'E01' && _this2.actualLanguage == "FR") window.alert("L'utilisateur n'existe pas dans le system EV Sens!");
        if (response.data.Code == 'E01' && _this2.actualLanguage == "EN") window.alert("User don't exists in the EV Sens system");
        _this2.userExistsFlag = false;

        if (response.data.Code == 'OK') {
          _this2.userExistsFlag = true;
        }
      });
    },
    saveNewSharing: function saveNewSharing() {
      var _this3 = this;

      this.commentIsSaving = true;

      var requestData = { 'postAction': 'SaveNewSharing',
        'guessProfileId': this.toUsername(this.sharingUserRecipient),
        'groupId': this.actualGroup.group_id,
        'bundleId': this.actualBundle.bundle_id,

        'sharingInfo': { 'referenceName': this.sharingReferenceName,
          'sharingMessage': this.sharingMessage },
        'entityOwner': this.overlayParameters.entityOwner,
        'sharedEntity': { 'entityType': this.overlayParameters.sharingType,
          'entityId': this.overlayParameters.entityId,
          'entityReferenceName': this.overlayParameters.entityReferenceName },
        'ruleTemplateVersion': this.sharingRuleTemplateVersion,
        'permissions': this.ruleTemplate.permissions
      };


      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        _this3.commentIsSaving = false;
        if (response.data.Code == 'OK') {
          _this3.sharingTransmittedFlag = true;
        } else {
          window.alert(response.data.Message[_this3.actualLanguage]);
        }
      });
    }
  },

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.channelIndex = this.overlayParameters.channelIndex;

    this.loadRuleTemplate();
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BarChart_js__ = __webpack_require__(54);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tableDataObj'],
  data: function data() {
    return {

      tableTitle: '',
      tableData: '',
      tableData2: '',
      dataTempo01: ['None'],
      filterOptionList: [],
      filterSelectedOption: [],
      resultsCount: 0,
      flagDisplayHistogramSection: false,
      flagDisplayHistogram: true,
      histogramData: null,
      histogramDataDay: null,
      labelResultFilter: { FR: 'Filtre des résultats', EN: 'Results filters' },
      labelHistogramTitle: { FR: 'Histogramme', EN: 'Histogram' },
      labelHistogramActivate: { FR: 'Activer', EN: 'Activate' },
      labelHistogramPerHour: { FR: 'Histogramme par heure', EN: 'Hour histogram' },
      labelHistogramPerDay: { FR: 'Histogramme par jour', EN: 'Daily histogram' },
      labelHistogramDay: { FR: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'], EN: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] },

      labelNone: { FR: 'Aucun', EN: 'None' },
      labelApplyFilter: { FR: 'Filtrer', EN: 'Apply filter' },
      labelResetFilter: { FR: 'Annuler les filtres', EN: 'Reset filters' },
      labelResults: { FR: 'Résultats', EN: 'Results' },
      actualLanguage: "FR"
    };
  },


  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_1__components_BarChart_js__["a" /* default */]
  },

  methods: {
    clearFilter: function clearFilter() {
      this.tableData2 = this.tableData;
      this.resultsCount = this.tableData2.length;
      this.constructFilterOptionList();
      this.constructHistogramData();
    },
    applyFilter: function applyFilter() {

      this.tableData2 = this.tableData.filter(function (e) {
        return e[1] == ['Allo', 'Bebe'];
      });
      this.resultsCount = this.tableData2.length;
    },
    applyFilter2: function applyFilter2(index) {
      var strToFind = this.filterSelectedOption[index];

      this.tableData2 = [];
      for (var i = 0; i < this.tableData.length; i++) {
        for (var j = 0; j < strToFind.length; j++) {
          if (this.tableData[i][index] == strToFind[j]) {
            this.tableData2.push(this.tableData[i]);
          }
        }
      }
      this.resultsCount = this.tableData2.length;
      this.constructFilterOptionList();
      this.constructHistogramData();
    },
    constructFilterOptionList: function constructFilterOptionList() {

      this.filterOptionList = [];
      this.filterSelectedOption = [];
      for (var i = 0; i < this.tableTitle.length; i++) {
        this.filterOptionList.push([]);
        this.filterSelectedOption.push(['None']);
      }

      for (var _i = 0; _i < this.tableTitle.length; _i++) {
        for (var j = 0; j < this.tableData2.length; j++) {
          var optionNotFound = true;
          for (var k = 0; k < this.filterOptionList[_i].length; k++) {
            if (this.tableData2[j][_i] == this.filterOptionList[_i][k]) {
              optionNotFound = false;
            }
          }
          if (optionNotFound) {
            this.filterOptionList[_i].push(this.tableData2[j][_i]);
          }
        }
        this.filterOptionList[_i].sort();
      }
    },
    constructHistogramData: function constructHistogramData() {
      var alertCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var alertCountDay = [0, 0, 0, 0, 0, 0, 0];

      for (var j = 0; j < this.tableData2.length; j++) {
        var str = this.tableData2[j][0];
        var dayOfWeek = new Date(str).getDay();

        alertCount[parseInt(str.substr(11, 2))] = alertCount[parseInt(str.substr(11, 2))] + 1;
        alertCountDay[dayOfWeek] = alertCountDay[dayOfWeek] + 1;
      }

      this.histogramData = {
        labels: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
        datasets: [{
          label: 'Nombre alerte par heure',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: alertCount }]
      };

      this.histogramDataDay = {
        labels: this.labelHistogramDay[this.actualLanguage],
        datasets: [{
          label: 'Nombre alerte par jour',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: alertCountDay }]
      };
    }
  },
  mounted: function mounted() {

    this.tableTitle = this.tableDataObj.tableTitle;
    this.tableData = this.tableDataObj.tableData;
    this.flagDisplayHistogramSection = this.tableDataObj.flagDisplayHistogramSection;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.tableData2 = this.tableData;
    this.resultsCount = this.tableData2.length;
    this.constructFilterOptionList();
    this.constructHistogramData();
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfigAccessRulesForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      flagRuleIsLoading: true,
      commentIsSaving: false,
      sharingTransmittedFlag: false,
      sharingEntityType: 'ND',
      description: '',
      channelIndex: 0,
      workTime: 0,
      sharingReferenceName: '',
      sharingMessage: '',
      ruleTemplate: {},
      sharingUserRecipient: '',

      entityReferenceName: false,
      displayAlertOptions: false,
      displayChannelOptions: false,
      displayDeviceOptions: false,
      displayBundleOptions: false,
      displayGroupOptions: false,
      displayUserOptions: false,
      displayCarOptions: false,

      actualLanguage: "FR",
      labelSectionUser: { FR: 'Accès usager', EN: 'User access' },
      labelSectionGroup: { FR: 'Group usagers', EN: 'User group' },
      labelSectionBundle: { FR: 'Groupes système', EN: 'Systems bundle' },
      labelSectionDevice: { FR: 'Appareil', EN: 'Device' },
      labelSectionChannel: { FR: 'Canaux de mesure', EN: 'Channels' },
      labelSectionAlert: { FR: 'Alerte', EN: 'Alerts' },
      labelSectionCar: { FR: 'VE ou Borne de recharge', EN: 'EV or EVSE' },

      textSharingTransmitted: { FR: 'La modification a été enregistrée avec succès!', EN: 'modification was successfully saved!' },
      textSharingTransmitted2: { FR: 'Vous pouvez fermer cette fenêtre.', EN: 'You can close this window.' },

      labelButtonShare: { FR: "Enregistrer les modifications", EN: 'Save modifications' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'actualGroup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: {
    loadRuleTemplate: function loadRuleTemplate() {
      var _this = this;

      var requestData = { 'postAction': 'GetSingleRulePermissions',
        'ruleId': this.overlayParameters.ruleId,
        'referenceId': this.overlayParameters.referenceId
      };
      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          console.log(response.data);
          _this.ruleTemplate = response.data.Data;
          _this.sharingEntityType = response.data.Data.entityType;

          if (_this.sharingEntityType == 'Car') {
            _this.displayCarOptions = true;
          }

          if (_this.sharingEntityType == 'Channel') {
            _this.displayChannelOptions = true;
          }

          if (_this.sharingEntityType == 'Device') {
            _this.displayDeviceOptions = true;
          }

          if (_this.sharingEntityType == 'Bundle') {
            _this.displayDeviceOptions = true;
            _this.displayChannelOptions = true;
            _this.displayBundleOptions = true;
            _this.displayAlertOptions = true;
          }

          if (_this.sharingEntityType == 'Group') {
            _this.displayDeviceOptions = true;
            _this.displayChannelOptions = true;
            _this.displayBundleOptions = true;
            _this.displayGroupOptions = true;
            _this.displayAlertOptions = true;
          }

          _this.flagRuleIsLoading = false;
        } else {
          window.alert("L'enregistrement a échoué. / Saving fail.");
        }
      });
    },
    toUsername: function toUsername(email) {
      var email2 = email.replace('.', '-dot-');
      email = email2.replace('.', '-dot-');
      email2 = email.replace('.', '-dot-');
      return email2.replace('@', '-at-');
    },
    saveSharingPermissions: function saveSharingPermissions() {
      var _this2 = this;

      this.commentIsSaving = true;
      var requestData = { 'postAction': 'SaveSingleRulePermissions',
        'ruleId': this.overlayParameters.ruleId,
        'referenceId': this.overlayParameters.referenceId,
        'permissions': this.ruleTemplate.permissions
      };
      console.log(requestData);

      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        _this2.commentIsSaving = false;
        if (response.data.Code == 'OK') {
          _this2.sharingTransmittedFlag = true;
        } else {
          window.alert(response.data.Message[_this2.actualLanguage]);
        }
      });
    }
  },

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.channelIndex = this.overlayParameters.channelIndex;

    this.loadRuleTemplate();
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'policyAgreement',

  components: {},

  data: function data() {
    return {
      actualLanguage: "FR",
      stringToFind: '',
      searchResult: [],
      NAVTempoGU: [],
      NAVTempoGS: [],

      tempo: '',
      sectionLabel: { FR: "Recherche d'élément", EN: "Search element" },
      searchLabel: { FR: "Rechercher", EN: "Search" }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'dashboardFlags', 'groupArborescence', 'navIndex'])),

  methods: {
    refresh: function refresh() {

      if (localStorage.language) {
        this.actualLanguage = localStorage.language;
      } else {
        this.actualLanguage = 'FR';
      }
    },
    findElement: function findElement() {

      console.log(this.stringToFind);
    }
  },

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
    this.refresh();

    this.tempo = this.groupArborescence.length;
  }
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['loading']))
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_configuration_CarForm__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_configuration_CarForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_configuration_CarForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_BindingCode__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_BindingCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_configuration_BindingCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_configuration_ConfigChannel__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_configuration_ConfigChannel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_configuration_ConfigChannel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_profile_OrganizationAddForm__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_profile_OrganizationAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_profile_OrganizationAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_measurements_SubComponents_ChannelCommentAddForm__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_measurements_SubComponents_ChannelCommentAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_measurements_SubComponents_ChannelCommentAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_measurements_SubComponents_ChannelMaintenanceAddForm__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_measurements_SubComponents_ChannelMaintenanceAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_measurements_SubComponents_ChannelMaintenanceAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ConfigAccessRulesForm__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ConfigAccessRulesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ConfigAccessRulesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_EditAccessRulesForm__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_EditAccessRulesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_EditAccessRulesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_help_TransmitHelpRequestForm__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_help_TransmitHelpRequestForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_help_TransmitHelpRequestForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_measurements_SubComponents_ChannelCloudLiveModalDisplay__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_measurements_SubComponents_ChannelCloudLiveModalDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_measurements_SubComponents_ChannelCloudLiveModalDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_profile_OrganizationApiAddMasterKeyForm__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_profile_OrganizationApiAddMasterKeyForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_profile_OrganizationApiAddMasterKeyForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_profile_OrganizationApiChannelTemplateAddForm__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_profile_OrganizationApiChannelTemplateAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_profile_OrganizationApiChannelTemplateAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_profile_OrganizationApiDeviceTemplateAddForm__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_profile_OrganizationApiDeviceTemplateAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_profile_OrganizationApiDeviceTemplateAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_profile_OrganizationApiSignalsSetAddForm__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_profile_OrganizationApiSignalsSetAddForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_profile_OrganizationApiSignalsSetAddForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_profile_OrganizationApiAddPictureForm__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_profile_OrganizationApiAddPictureForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_profile_OrganizationApiAddPictureForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_profile_DashboardNews__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_profile_DashboardNews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_profile_DashboardNews__);


























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CarForm: __WEBPACK_IMPORTED_MODULE_2__views_configuration_CarForm___default.a,
    ErrorView: __WEBPACK_IMPORTED_MODULE_5__views_shared_ErrorView___default.a,
    BindingCode: __WEBPACK_IMPORTED_MODULE_4__views_configuration_BindingCode___default.a,
    AddDeviceForm: __WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm___default.a,

    ConfigChannel: __WEBPACK_IMPORTED_MODULE_6__views_configuration_ConfigChannel___default.a,
    OrganizationAddForm: __WEBPACK_IMPORTED_MODULE_7__views_profile_OrganizationAddForm___default.a,
    ChannelCommentAddForm: __WEBPACK_IMPORTED_MODULE_8__views_measurements_SubComponents_ChannelCommentAddForm___default.a,
    ChannelMaintenanceAddForm: __WEBPACK_IMPORTED_MODULE_9__views_measurements_SubComponents_ChannelMaintenanceAddForm___default.a,
    ConfigAccessRulesForm: __WEBPACK_IMPORTED_MODULE_10__components_ConfigAccessRulesForm___default.a,
    EditAccessRulesForm: __WEBPACK_IMPORTED_MODULE_11__components_EditAccessRulesForm___default.a,
    TransmitHelpRequestForm: __WEBPACK_IMPORTED_MODULE_12__views_help_TransmitHelpRequestForm___default.a,
    ChannelCloudLiveModalDisplay: __WEBPACK_IMPORTED_MODULE_13__views_measurements_SubComponents_ChannelCloudLiveModalDisplay___default.a,
    OrganizationApiAddMasterKeyForm: __WEBPACK_IMPORTED_MODULE_14__views_profile_OrganizationApiAddMasterKeyForm___default.a,
    OrganizationApiChannelTemplateAddForm: __WEBPACK_IMPORTED_MODULE_15__views_profile_OrganizationApiChannelTemplateAddForm___default.a,
    OrganizationApiSignalsSetAddForm: __WEBPACK_IMPORTED_MODULE_17__views_profile_OrganizationApiSignalsSetAddForm___default.a,
    OrganizationApiDeviceTemplateAddForm: __WEBPACK_IMPORTED_MODULE_16__views_profile_OrganizationApiDeviceTemplateAddForm___default.a,
    OrganizationApiAddPictureForm: __WEBPACK_IMPORTED_MODULE_18__views_profile_OrganizationApiAddPictureForm___default.a,
    DashboardNews: __WEBPACK_IMPORTED_MODULE_19__views_profile_DashboardNews___default.a
  },
  data: function data() {
    return {
      mobile: false,
      largeSize: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['showModal', 'currentModalView', 'overlayParameters'])),
  watch: {
    showModal: function showModal() {
      this.mobile = window.innerWidth <= 900;
      this.largeSize = window.innerWidth >= 1200;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('overlayStore', ['toggleModal'])),
  mounted: function mounted() {

    this.mobile = window.innerWidth <= 900;
    this.largeSize = window.innerWidth >= 1200;
  }
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Line */],
  props: ['charges'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
      datasets: [{
        label: 'Dernier mois',
        backgroundColor: 'rgba(70, 195, 123, .07)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, .25)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: [600, 350, 1100, 420, 750, 1050, 670]
      }, {
        label: 'Dernière semaine',
        backgroundColor: 'rgba(70, 195, 123, .25)',
        borderColor: 'rgba(5, 210, 92, .55)',
        pointBackgroundColor: 'rgba(68, 180, 166, .55)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: [490, 430, 560, 790, 1200, 950, 1500]
      }]
    }, {
      scaleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      scaleFontColor: '#999',
      scaleFontStyle: '600',
      tooltipTitleFontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      tooltipCornerRadius: 3,
      maintainAspectRatio: false,
      responsive: true
    });
  }
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.location.href = "/static/404-not-found.html";
  }
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
                name: 'policyAgreement',

                components: {},

                data: function data() {
                                var _ref;

                                return _ref = {
                                                actualLanguage: "FR",
                                                acceptConditionFlag: false,
                                                acceptCookieFlag: false,
                                                labelButton4Weeks: { FR: '4 semaines', EN: '4 weeks' },

                                                policyEndPoint: "https://evsenscloud.com",
                                                policyCompany: "EvSens inc.",
                                                policyEmailSupport: "support@evsens.ca",
                                                policyEmailInfo: "info@evsens.ca",

                                                policyConditionUtilizationPreviewImg: { FR: "Condition_Utilisation_EV_Sens_FR.png",
                                                                EN: "Condition_Utilisation_EV_Sens_EN.png" },
                                                policyConfidentialPoliticsPreviewImg: { FR: "Politique_Confidentialite_EV_Sens_FR.png",
                                                                EN: "Politique_Confidentialite_EV_Sens_EN.png" },

                                                labelTopTitle01: { FR: "Conditions générales d'utilisation.",
                                                                EN: "General terms of use." },
                                                labelTopTitle02: { FR: "de",
                                                                EN: "of" },
                                                labelTopTitle03: { FR: "Date de dernière mise à jour: 22 Novembre 2019",
                                                                EN: "Last update: 22 November 2019" },
                                                labelTopTitle04: { FR: "Vous devez confirmer et accepter les termes au bas de la page.",
                                                                EN: "You must accept and confirm the terms in the bottom of this page" }

                                }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelTopTitle01', { FR: "Conditions générales d'utilisation.",
                                                EN: "General terms of use." }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelTopTitle02', { FR: "de",
                                                EN: "of" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelTopTitle03', { FR: "Date de dernière mise à jour: 22 Novembre 2019",
                                                EN: "Last update: 22 November 2019" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelTopTitle04', { FR: "Vous devez confirmer et accepter les termes au bas de la page.",
                                                EN: "You must accept and confirm the terms in the bottom of this page" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelTopFilePreview', { FR: "Il vous suffit de cliquer sur les images pour voir les documents.",
                                                EN: "You only have to click on pictures to see each document" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelConfidentialityPolicy', { FR: "Politique de confidentialité",
                                                EN: "Confidentiality policy" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelTitle22', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelText22', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelConfirmCheckBox', { FR: "Je confirme avoir pris connaissance des conditions d'utilisation.",
                                                EN: "I confirm that I have read the terms of use." }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelCookiesTitle', { FR: "Utilisation des cookies",
                                                EN: "Cookies" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelConfirmCookiesConditions', { FR: "Le site web evsenscloud.com nécessite l'utilisation des cookies et des technologies de suivi similaires. Si vous n'acceptez pas les cookies, il vous sera impossible d'ouvrir votre profil du portail web.",
                                                EN: "The evsenscloud.com web site required cookies or similar technologies usage. If you not accept the cookie usage, it will not be possible to access the web portal." }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelConfirmCookiesCheckBox', { FR: "J'autorise l'utilisation des cookies.",
                                                EN: "I authorize the use of cookies." }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'labelButtonAcceptCondition', { FR: "J'accepte les conditions",
                                                EN: "I accept the conditions" }), _ref;
                },


                methods: {
                                refresh: function refresh() {

                                                if (localStorage.language) {
                                                                this.actualLanguage = localStorage.language;
                                                } else {
                                                                this.actualLanguage = 'FR';
                                                }
                                },
                                saveMyAgreement: function saveMyAgreement() {
                                                var _this = this;

                                                var payload = { "putAction": 'SignPolicy', "policyVersion": 'Policy_2019_11_20_V01' };

                                                this.$store.dispatch('sessionStore/updateProfile', payload).then(function (response) {

                                                                if (response.data.Code == 'OK') {
                                                                                if (_this.actualLanguage == "FR") {
                                                                                                window.alert("Signature enregistré.");
                                                                                } else {
                                                                                                window.alert('Signature saved.');
                                                                                }
                                                                } else {
                                                                                if (_this.actualLanguage == "FR") {
                                                                                                window.alert("Erreur d'enregistrement de signature.");
                                                                                } else {
                                                                                                window.alert('Signature not saved.');
                                                                                }
                                                                }
                                                                window.location.reload();
                                                });
                                },
                                openUtilizationConditions: function openUtilizationConditions() {
                                                var localUrl = '';
                                                if (this.actualLanguage == 'FR') {
                                                                localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Conditions_Utilisation_EvSens_FR.pdf";
                                                }
                                                if (this.actualLanguage == 'EN') {
                                                                localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Conditions_Utilisation_EvSens_EN.pdf";
                                                }
                                                window.open(localUrl, '_blank');
                                },
                                openConfidentialityPolitics: function openConfidentialityPolitics() {
                                                var localUrl = '';
                                                if (this.actualLanguage == 'FR') {
                                                                localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Politique_Confidentialite_EvSens_FR.pdf";
                                                }
                                                if (this.actualLanguage == 'EN') {
                                                                localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Politique_Confidentialite_EvSens_EN.pdf";
                                                }
                                                window.open(localUrl, '_blank');
                                }
                },

                mounted: function mounted() {
                                if (localStorage.language) {
                                                this.actualLanguage = localStorage.language;
                                } else {
                                                this.actualLanguage = 'FR';
                                }
                                this.refresh();
                }
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rangePicker',

    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_2_element_ui__["DatePicker"],
        TimePicker: __WEBPACK_IMPORTED_MODULE_2_element_ui__["TimePicker"],
        TimeSelect: __WEBPACK_IMPORTED_MODULE_2_element_ui__["TimeSelect"]
    },

    data: function data() {
        return {
            startDate: new Date(this.$store.state.chargesStore.startDate * 1000),
            endDate: new Date(this.$store.state.chargesStore.endDate * 1000),
            startTime: '00:00',
            endTime: '00:00',
            actualLanguage: "FR",
            labelStartDate: { FR: 'Date de début', EN: 'Start date' },
            labelStartTime: { FR: 'Heure de début', EN: 'Start time' },
            dataSamplingSelect: 'Automatic',

            labelEndDate: { FR: 'Date de fin', EN: 'End date' },
            labelEndTime: { FR: 'Heure de fin', EN: 'End time' },
            labelButtonObserve: { FR: 'Rafraichir', EN: 'Refresh' },
            labelButton4Hour: { FR: '4 Hrs', EN: '4 Hrs' },
            labelButton12Hour: { FR: '12 Hrs', EN: '12 Hrs' },
            labelButtonToday: { FR: "Aujourd'hui", EN: 'Today' },
            labelButton3Days: { FR: '3 Jours', EN: '3 Days' },
            labelButton7Days: { FR: '7 jours', EN: '7 Days' },
            labelButton4Weeks: { FR: '4 semaines', EN: '4 weeks' },
            labelDataSamplingTitle: { FR: 'Type de données des graphiques :', EN: 'Graph data type :' },
            labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
            labelDataSampling5min: { FR: '5 minutes', EN: '5 minute' },
            labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
            labelDataSamplingDays: { FR: 'Jour', EN: 'Days' }

        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['actualBundle'])),

    methods: {
        refresh: function refresh() {
            var _this = this;

            var startDate = this.formatTimeToUnix(this.startDate, this.startTime);
            var endDate = this.formatTimeToUnix(this.endDate, this.endTime);


            this.$emit('refresh', { startDate: startDate, endDate: endDate });

            var channelListToRead = [];
            for (var j = 0; j < this.actualBundle.channels.length; j++) {
                if (this.actualBundle.channels[j].ChannelData.DisplayOpenFlag) {
                    channelListToRead.push({ 'channelData': this.actualBundle.channels[j].ChannelData,
                        'channelBundleIndex': j });
                }
            }
            this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', false);

            var requestData = { 'postAction': 'GetBundleChannelReadings',
                'bundleId': this.actualBundle.bundle_id,
                'channelList': channelListToRead,
                'start': startDate,
                'end': endDate,
                'dataType': this.dataSamplingSelect
            };

            this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', true);
                } else {
                    window.alert("L'enregistrement a échoué. / Saving fail.");
                }
            });
        },
        setPresets: function setPresets(rangeType, callRefresh) {
            this.rangeType = rangeType <= 60 ? rangeType * 86400 : rangeType;
            this.endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().unix() * 1000;
            this.startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.endDate).subtract(this.rangeType, 'seconds');

            if (rangeType > 30) {
                var startTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()();

                this.endTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.endDate).format('HH:mm');
                this.startTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.startDate).format('HH:mm');
            } else {
                this.startTime = '24:00';
                this.endTime = '24:00';
            }

            if (callRefresh) {
                this.refresh();
            }
        },
        formatTimeToUnix: function formatTimeToUnix(date, time) {
            var unixTime = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

            return unixTime;
        }
    },

    mounted: function mounted() {
        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
        this.setPresets(28800, true);
    }
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['message', 'size']
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_configuration_AddDeviceForm__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      gettingCode: false,

      actualLanguage: "FR",
      labelTitle: { FR: "Jumelage d'appareil", EN: "Device binding" },
      labelMessage: { FR: "Vous n'avez pas d'appareils EVA enregistrés.", EN: "Your profile do not contain any registered EVA device" },
      labelButton01: { FR: "+ Ajouter un module pré-enregistré", EN: "+ Add registered module" },
      labelButton02: { FR: "Récuperer un code de jumelage", EN: "Get binding code" }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
  },

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    getCode: function getCode() {
      var _this = this;

      this.gettingCode = true;
      this.$store.dispatch('sessionStore/bind').then(function (code) {
        _this.showModal('binding-code');
        _this.gettingCode = false;
      }).catch(function (e) {
        _this.gettingCode = false;
        console.log(e);
      });
    }
  }),
  created: function created() {}
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RangePicker__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_RangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(7);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertIndex',

  data: function data() {
    return {
      isOpen: true,
      loadingAlertData: false,
      displayAlertTronquedResults: false,
      dataTempo01: 'test',
      dataTempo02: 'test',
      flagDisplayAddService: -1,
      displayMessage: '--',
      moduleBindingData: '',
      codeConfirmed: false,
      transmitDataModel: {
        deviceId: '',
        deviceKey: ''
      },
      tableData: {
        tableTitle: [{ FR: 'Moment', EN: 'Time' }, { FR: 'Appareil', EN: 'Device' }, { FR: 'Port', EN: 'Port' }, { FR: 'Nom du port', EN: 'Port name' }, { FR: "Type d'alerte", EN: 'Alert type' }, { FR: "Message de l'alerte", EN: 'Alert message' }],
        tableData: [['', '', '', '', '', '']],
        flagDisplayHistogramSection: true
      },
      eventLogData: [],
      labelTopDatePicker: { FR: 'Plage à observer', EN: 'Period selector' },
      labelAlertList: { FR: 'Liste des alertes', EN: 'Alert list' },
      labelSpinner: { FR: 'Téléchargement des données', EN: 'Data transfer' },
      alertTronquedResultMessage: { FR: 'Il peut manquer des alertes dans la liste, la plage de temps est trop grande.', EN: 'Alerts may be missing from the list, time range is too large. ' },
      actualLanguage: "FR"
    };
  },


  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DynamicTable: __WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1___default.a,
    RangePicker: __WEBPACK_IMPORTED_MODULE_3__components_RangePicker___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayAddService: function toggleDisplayAddService() {
      this.flagDisplayAddService = ~this.flagDisplayAddService;
    },
    readAlertsHistory: function readAlertsHistory(dates) {
      var _this = this;

      this.loadingAlertData = true;
      return this.$store.dispatch('sessionStore/getAlertsHistory', dates).then(function (response) {
        _this.displayAlertTronquedResults = false;
        _this.tableData.tableData = [];
        for (var i = 0; i < response.data.AlertData.length; i++) {
          _this.tableData.tableData.push([response.data.AlertData[i].timestamp, response.data.AlertData[i].device_id, response.data.AlertData[i].port_id, response.data.AlertData[i].port_name, response.data.AlertData[i].alert_title, response.data.AlertData[i].message]);
          response.data.AlertData[i].timestamp;
        }

        if (response.data.LimitReached) {
          _this.displayAlertTronquedResults = true;
        }

        _this.loadingAlertData = false;
      });
    },
    refreshData: function refreshData(dates) {
      this.$store.dispatch('chargesStore/setStartDate', dates.startDate);
      this.$store.dispatch('chargesStore/setEndDate', dates.endDate);
      this.readAlertsHistory(dates);
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddDeviceForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      savingCar: false,
      displayMessage: '',
      codeConfirmed: false,
      deviceIsSaving: false,
      displayKey: true,
      deviceModel: {
        deviceId: '',
        deviceKey: ''
      },

      actualLanguage: "FR",
      labelFieldTitleAddDevice: { FR: "Ajout d'appareil", EN: 'Add device' },
      labelFieldTitleSticker: { FR: "(Voir l'étiquette sous l'appareil)", EN: "(See the sticker on back panel of the device)" },
      labelFieldModuleId: { FR: "Identifiant de module de mesure", EN: 'Device ID' },
      labelFieldModuleKey: { FR: "Clef d'accès", EN: 'Access key' },
      labelFieldButtonCheck: { FR: 'Vérifier', EN: 'Validate' },
      labelFieldButtonAdd: { FR: "Ajouter le module", EN: 'Add module' },
      labelField: { FR: '', EN: '' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['actualBundle'])),

  methods: {
    testKey: function testKey() {
      var _this = this;

      this.displayMessage = '--';
      this.codeConfirmed = false;

      return this.$store.dispatch('devicesStore/validateDeviceId', this.deviceModel).then(function (response) {
        _this.displayMessage = response.data.Message;
        if (response.data.Code == 'Fail' && _this.actualLanguage == "FR") _this.displayMessage = 'Identifiant de module non valide!';
        if (response.data.Code == 'Fail' && _this.actualLanguage == "EN") _this.displayMessage = 'Wrong Module ID!';

        if (response.data.Code == 'OK' && _this.actualLanguage == "FR") _this.displayMessage = "Code d'appareil valide, clef confirmée, appuyer sur Ajouter l'appareil";
        if (response.data.Code == 'OK' && _this.actualLanguage == "EN") _this.displayMessage = 'Valid Module ID, key confirmed, press "Add device"';

        if (response.data.Code == 'E00' && _this.actualLanguage == "FR") _this.displayMessage = 'Code de module valide, clef non valide';
        if (response.data.Code == 'E00' && _this.actualLanguage == "EN") _this.displayMessage = 'Existing Module ID, Wrong access key';

        if (response.data.Code == 'E01' && _this.actualLanguage == "FR") _this.displayMessage = 'Module déjà alloué';
        if (response.data.Code == 'E01' && _this.actualLanguage == "EN") _this.displayMessage = 'Module already allocated';

        _this.codeConfirmed = response.data.Code == 'OK';
      });
    },
    saveDevice: function saveDevice() {
      var _this2 = this;

      this.displayMessage = 'Enregistrement';
      this.codeConfirmed = false;

      if (this.actualLanguage == "FR") {
        var deviceReferenceName = prompt("Nom de référence pour cet appareil", "Mon appareil");
      } else {
        var deviceReferenceName = prompt("Reference name for this device", "My device");
      }
      if (deviceReferenceName != null) {
        this.deviceIsSaving = true;
        var requestData = { 'postAction': 'AddDeviceToBundle',
          'bundleId': this.actualBundle.bundle_id,
          'referenceName': deviceReferenceName,
          'deviceId': this.deviceModel.deviceId,
          'deviceKey': this.deviceModel.deviceKey
        };

        this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
          _this2.deviceIsSaving = false;
          if (response.data.Code == 'OK') {
            _this2.$store.dispatch('sessionStore/getGroupArborescence');
            _this2.$store.dispatch('overlayStore/toggleModal', false);
          } else {
            window.alert(response.data.PromptMessage[_this2.actualLanguage]);
          }
        });
      }
    },
    saveDeviceOld: function saveDeviceOld() {
      var _this3 = this;

      this.displayMessage = 'Enregistrement';
      this.codeConfirmed = false;

      return this.$store.dispatch('devicesStore/addDeviceToProfile', this.deviceModel).then(function (response) {
        _this3.displayMessage = response.data.Message;
        _this3.codeConfirmed = response.data.Code != 'OK';
        _this3.displayKey = response.data.Code != 'OK';
        if (response.data.Code == 'OK') _this3.displayMessage = 'Module ajouté à votre profil, rafraichir la page et aller dans CONFIGURATION';
        if (response.data.Code == 'E01') _this3.displayMessage = 'Clef non valide';
        _this3.deviceModel.deviceKey = '';
        _this3.$store.dispatch('overlayStore/toggleModal', false);
      });
    }
  },

  created: function created() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApplianceList',
  data: function data() {
    return {};
  },

  methods: {
    selectItem: function selectItem(appliance) {
      this.$emit('onSelect', appliance);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('appliancesStore', ['appliancesList'])),
  mounted: function mounted() {}
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BindingCode',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['bindingCode']))
});

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CarForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a
  },
  props: ['car'],
  data: function data() {
    return {
      errorMsg: '',
      savingCar: false,
      evseFlag: false,
      filteredYears: [],
      filteredModels: [],
      filteredColors: [],
      filteredCarPool: [],
      carModel: {
        manufacturer: '',
        color: '',
        year: '',
        model: '',
        carName: '',
        linkedDevice: '',
        linkedPort: '',
        averageWhPerKm: ''
      },

      actualLanguage: "FR",
      labelFieldEvName: { FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name' },
      labelFieldManufacturer: { FR: 'Manufacturier', EN: 'Manufacturer' },
      labelFieldSelect: { FR: 'Choisir', EN: 'Select' },
      labelFieldLevel: { FR: 'Niveau', EN: 'Level' },
      labelFieldEVSEBrand: { FR: 'Marque de borne', EN: 'EVSE Brand' },
      labelFieldEVSEModel: { FR: 'Type/Modèle', EN: 'Model' },
      labelFieldEVYear: { FR: 'Année', EN: 'Year' },
      labelFieldEVModel: { FR: 'Modèle', EN: 'Model' },
      labelFieldEVColor: { FR: 'Couleur', EN: 'Color' },
      labelFieldLinkModule: { FR: 'Module accosié à la recharge', EN: 'Linked module' },
      labelFieldLinkPort: { FR: 'Port associé à la recharge', EN: 'Linked port' },
      labelFieldEVConsumption: { FR: 'Consommation (Wh/km)', EN: 'Consumption (Wh/)' },
      labelFieldButtonSave: { FR: 'Sauvegarder', EN: 'Save' },
      labelFieldButtonDelete: { FR: 'Supprimer', EN: 'Delete' },
      labelField: { FR: '', EN: '' }
    };
  },

  methods: {
    getCarDataToSave: function getCarDataToSave() {
      var _this = this;

      var car = __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].find(this.filteredCarPool, function (car) {
        return car.model == _this.carModel.model && car.color == _this.carModel.color && car.manufacturer == _this.carModel.manufacturer && car.year == _this.carModel.year;
      });
      return car;
    },
    showConfirmationModal: function showConfirmationModal() {
      if (this.actualLanguage == "FR") {
        if (window.confirm('Le v\xE9hicule "' + this.carModel.carName + '" sera supprim\xE9. Cette op\xE9ration est irr\xE9versible.')) {
          this.deleteCar();
        }
      } else {
        if (window.confirm('The vehicle "' + this.carModel.carName + '" will be deleted. This operation is not reversible.')) {
          this.deleteCar();
        }
      }
    },
    deleteCar: function deleteCar() {
      var _this2 = this;

      this.$store.dispatch('carsStore/deleteCar', this.carModel.profileCarId).then(function (response) {
        _this2.$store.dispatch('overlayStore/pushNotification', { text: "Véhicule supprimer", type: 'success' });
        _this2.refresh();
      }).catch(function (error) {
        _this2.$store.dispatch('overlayStore/pushNotification', { text: "Erreur lors de la suppression", type: 'danger' });
      });
    },
    save: function save() {
      var _this3 = this;

      var carData = this.getCarDataToSave();
      if (this.car && carData) {
        carData.carName = this.carModel.carName;

        this.savingCar = true;
        carData.profileCarId = this.carModel.profileCarId;
        carData.averageWhPerKm = this.carModel.averageWhPerKm;
        carData.linkedPort = this.carModel.linkedPort;
        carData.linkedDevice = this.carModel.linkedDevice;

        this.$store.dispatch('carsStore/updateCar', carData).then(function (response) {
          _this3.$store.dispatch('overlayStore/pushNotification', { text: "Véhicule sauvegardé", type: 'success' });
          _this3.savingCar = false;
        }).catch(function (error) {
          _this3.$store.dispatch('overlayStore/pushNotification', { text: "Erreur lors de la sauvegarde", type: 'danger' });
          console.log('error on updating car', error);
          _this3.savingCar = false;
        });
      } else if (carData) {
        carData.linkedDevice = this.carModel.linkedDevice;
        carData.linkedPort = this.carModel.linkedPort;
        carData.carName = this.carModel.carName;
        carData.averageWhPerKm = this.carModel.averageWhPerKm;
        this.savingCar = true;
        this.$store.dispatch('carsStore/createCar', carData).then(function (response) {
          _this3.$store.dispatch('overlayStore/pushNotification', { text: "Véhicule sauvegardé", type: 'success' });
          _this3.$store.dispatch('overlayStore/toggleModal', false);
          _this3.refresh();
          _this3.savingCar = false;
        }).catch(function (error) {
          _this3.$store.dispatch('overlayStore/pushNotification', { text: "Erreur lors de la sauvegarde", type: 'danger' });
          _this3.savingCar = false;
          console.log('error on creating car', error);
        });
      } else {
        this.$store.dispatch('overlayStore/pushNotification', { text: "Le formulaire contient des erreurs", type: 'danger' });
      }
    },
    onManufacturerChange: function onManufacturerChange(e) {
      var _this4 = this;

      if (e) this.resetData();
      if (this.carModel.manufacturer == "Borne de recharge") {
        this.evseFlag = true;
      } else {
        this.evseFlag = false;
      }

      return this.$store.dispatch('carsStore/getManufacturerInfos', { manufacturer: this.carModel.manufacturer }).then(function (response) {
        _this4.filteredCarPool = response.data;
        _this4.filteredYears = __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].uniq(__WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].map(response.data, function (object) {
          return object.year;
        }));
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    onYearChange: function onYearChange() {
      var _this5 = this;

      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.carModel.manufacturer,
        year: this.carModel.year
      }).then(function (response) {
        _this5.filteredCarPool = response.data;
        _this5.filteredModels = __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].uniq(__WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].map(response.data, function (object) {
          return object.model;
        }));
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    onModelChange: function onModelChange() {
      var _this6 = this;

      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.carModel.manufacturer,
        year: this.carModel.year,
        model: this.carModel.model,
        whPerKm: this.carModel.averageWhPerKm
      }).then(function (response) {
        _this6.filteredCarPool = response.data;
        _this6.filteredColors = __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].uniq(__WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].map(response.data, function (object) {
          return object.color;
        }));
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    resetData: function resetData() {
      this.filteredYears = [];
      this.filteredModels = [];
      this.filteredColors = [];
      this.carModel.year = '';
      this.carModel.color = '';
      this.carModel.model = '';
      this.carModel.linkedPort = '';
      this.carModel.linkedDevice = '';
    },
    fillDefaultData: function fillDefaultData() {
      this.carModel.profileCarId = this.car.profileCarId;
      this.carModel.manufacturer = this.car.manufacturer;
      this.carModel.color = this.car.color;
      this.carModel.model = this.car.model;
      this.carModel.year = this.car.year;
      this.carModel.carName = this.car.carName;
      this.carModel.linkedDevice = this.car.linkedDevice;
      this.carModel.linkedPort = this.car.linkedPort;
      this.carModel.averageWhPerKm = this.car.averageWhPerKm;
      this.onManufacturerChange().then(this.onYearChange).then(this.onModelChange);
    },
    refresh: function refresh() {
      var _this7 = this;

      this.$store.dispatch('carsStore/getCars').then(function () {
        _this7.fillDefaultData();
      });
      this.$emit('refresh');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('carsStore', ['cars', 'manufacturers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('devicesStore', ['devices'])),
  created: function created() {
    this.$store.dispatch('devicesStore/devices');
    if (this.car) {
      this.fillDefaultData();
    }
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['alertIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      flagDisplayAlert: 0,
      alertIsSaving: false,
      alertIsDeleting: false,

      actualGroupIsDefaultGroup: true,

      labelAlertTitle: { FR: 'Alertes du port', EN: 'Port alerts' },
      labelFieldButtonSave: { FR: "Sauvegarder l'alerte", EN: 'Save alert' },
      labelFieldButtonDelete: { FR: "Supprimer l'alerte", EN: 'Delete this alert' },
      labelAlertSelect: { FR: "Sélectionner le type d'alerte à ajouter:", EN: 'Select type of alert to add:' },
      labelAlertDescription: { FR: "Description de l'alerte:", EN: 'Alert description:' },
      labelAlertMessage: { FR: "Message envoyé dans le courriel:", EN: 'E-mail sent message:' },

      labelRecipientList: { FR: "Liste d'utilisateur avisés:", EN: 'List of notified users:' },
      labelRecipientEmailEnable: { FR: "Courriel", EN: 'Email' },
      labelRecipientSMSEnable: { FR: "Message texte (SMS)", EN: 'Text message (SMS)' },
      labelRecipientDelete: { FR: "Effacer", EN: 'Delete' },
      labelRecipientSMSNotAvailable: { FR: "Non disponible", EN: 'Not available' },

      labelFieldButtonAddRecipient: { FR: "Ajouter un destinataire", EN: 'Add E-mail recipient' },
      labelFieldButtonAddAlert: { FR: 'Ajouter une alerte au port', EN: 'Add alert to port' },
      labelFieldButtonConfirmAddAlert: { FR: 'Ajouter', EN: 'Add' },
      labelFieldButtonCancelAddAlert: { FR: 'Annuler', EN: 'Cancel' },
      tableTitleParameter: { FR: "Paramètre(s) de l'alerte", EN: 'Alert parameter(s)' },
      tableTitleValue: { FR: "Valeur", EN: 'Value' },
      tableTitleAlertSMS: { FR: "Alerte SMS : Liste de #Téléphone", EN: 'SMS Alert : Phone number' },
      buttonLabelAddPhone: { FR: "Ajouter un numéro téléphone", EN: 'Add phone number' },
      buttonLabelTransmitEmailToGroup: { FR: "Transmettre l'alerte aux membres du groupe:", EN: 'Transmit alert to group members:' },

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },

      alertConfigViewFlag: false,
      alertConfigEditFlag: false,
      alertConfigDeleteFlag: false,
      alertSharingEnableFlag: false,

      transmitEmailToActualGroupMember: false,

      monthOptions: [{ text: '01-Jan', value: '1' }, { text: '02-Fév/Feb', value: '2' }, { text: '03-Mar', value: '3' }, { text: '04-Avr/Apr', value: '4' }, { text: '05-Mai/May', value: '5' }, { text: '06-Jui/Jun', value: '6' }, { text: '07-Jui/Jul', value: '7' }, { text: '08-Aoû/Aug', value: '8' }, { text: '09-Sept', value: '9' }, { text: '10-Oct', value: '10' }, { text: '11-Nov', value: '11' }, { text: '12-Déc/Dec', value: '12' }],

      dayOptions: [{ text: 'Lun/Mon', value: '1' }, { text: 'Mar/Tue', value: '2' }, { text: 'Mer/Wed', value: '3' }, { text: 'Jeu/Thu', value: '4' }, { text: 'Ven/Fri', value: '5' }, { text: 'Sam/Sat', value: '6' }, { text: 'Dim/Sun', value: '7' }],

      hourOptions: [{ text: '00:00', value: '0' }, { text: '01:00', value: '1' }, { text: '02:00', value: '2' }, { text: '03:00', value: 3 }, { text: '04:00', value: '4' }, { text: '05:00', value: '5' }, { text: '06:00', value: '6' }, { text: '07:00', value: '7' }, { text: '08:00', value: 8 }, { text: '09:00', value: '9' }, { text: '10:00', value: '10' }, { text: '11:00', value: '11' }, { text: '12:00', value: '12' }, { text: '13:00', value: 13 }, { text: '14:00', value: '14' }, { text: '15:00', value: '15' }, { text: '16:00', value: '16' }, { text: '17:00', value: '17' }, { text: '18:00', value: 18 }, { text: '19:00', value: '19' }, { text: '20:00', value: '20' }, { text: '21:00', value: '21' }, { text: '22:00', value: '22' }, { text: '23:00', value: 23 }, { text: '24:00', value: '24' }]

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualGroup', 'actualBundle', 'navIndex']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayAlert: function toggleDisplayAlert() {
      this.flagDisplayAlert = ~this.flagDisplayAlert;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    confirmRemoveAlertLine: function confirmRemoveAlertLine() {
      var _this = this;

      var FlagProcessToDelete = false;
      if (this.actualLanguage == "FR") {
        if (window.confirm('Confirmer la supression de l\'alerte. Cette action est irr\xE9versible!')) {
          FlagProcessToDelete = true;
        }
      } else {
        if (window.confirm('Confirm alert supression. This operation is not reversible!')) {
          FlagProcessToDelete = true;
        }
      }

      if (FlagProcessToDelete == true) {
        this.alertIsDeleting = true;
        var requestData = { 'postAction': 'RemoveAlertFromBundle',
          'alertIndex': this.alertIndex,
          'alertData': this.tempoBundle.alerts[this.alertIndex].AlertData,
          'bundleData': { 'bundleId': this.actualBundle.bundle_id }
        };
        this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
          _this.alertIsDeleting = false;
          if (response.data.Code == 'OK') {
            _this.$store.dispatch('sessionStore/getGroupArborescence');
            _this.alertShowAddButton = true;
          } else {
            window.alert("L'enregistrement a échoué. / Saving fail.");
          }
        });
      }
    },
    addEmail: function addEmail() {
      var _this2 = this;

      if (this.actualLanguage == "FR") {
        var newEmail = prompt("Entrer l'adresse email à ajouter", "@");
      } else {
        var newEmail = prompt("Enter the E-mail to add", "@");
      }

      return this.$store.dispatch('sessionStore/validateUserExist', newEmail).then(function (response) {
        _this2.displayMessage = response.data.Message;
        if (response.data.Code == 'Fail' && _this2.actualLanguage == "FR") window.alert('Erreur de validation !');
        if (response.data.Code == 'Fail' && _this2.actualLanguage == "EN") window.alert('Validation error !');

        if (response.data.Code == 'E01' && _this2.actualLanguage == "FR") window.alert("L'utilisateur n'existe pas dans le system EV Sens!");
        if (response.data.Code == 'E01' && _this2.actualLanguage == "EN") window.alert("User don't exists in the EV Sens system");

        if (response.data.Code == 'OK') {
          var userToAdd = { 'profileId': response.data.profileId,
            'email': newEmail,
            'emailEnableFlag': true,
            'smsEnableFlag': false };
          _this2.tempoBundle.alerts[_this2.alertIndex].AlertData.users_recipient.push(userToAdd);
          if (_this2.actualLanguage == "FR") {
            window.alert("Vous devez Sauvegarder l'alerte pour confirmer l'enregistrement.");
          } else {
            window.alert('You must Save the alert to record modifications.');
          }
        }
      });
    },
    confirmRemoveEmail: function confirmRemoveEmail(indexEmail) {
      if (this.actualLanguage == "FR") {
        if (window.confirm('Confirmer la supression du destinataire "' + (indexEmail + 1) + '". Cette action est irr\xE9versible suite \xE0 la sauvegarde de l\'alerte!')) {
          this.tempoBundle.alerts[this.alertIndex].AlertData.users_recipient.splice(indexEmail, 1);
          window.alert("Vous devez Sauvegarder l'alerte pour confirmer l'enregistrement.");
        }
      } else {
        if (window.confirm('Confirm recipient "' + (indexEmail + 1) + '" supression. This operation is not reversible after alert saving!')) {
          this.tempoBundle.alerts[this.alertIndex].AlertData.users_recipient.splice(indexEmail, 1);
          window.alert('You must Save the alert to record modifications.');
        }
      }
    },
    modifyActualGroupInGroupRecipient: function modifyActualGroupInGroupRecipient() {
      if (this.transmitEmailToActualGroupMember) {
        var flagGroupFound = false;
        for (var m = 0; m < this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.length; m++) {
          if (this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient[m] == this.actualGroup.group_id) {
            flagGroupFound = true;
          }
        }
        if (flagGroupFound == false) {
          this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.push(this.actualGroup.group_id);
        }
      } else {
        var indexToRemove = -1;
        for (var m = 0; m < this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.length; m++) {
          if (this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient[m] == this.actualGroup.group_id) {
            indexToRemove = m;
          }
        }
        if (indexToRemove > -1) {
          this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.pop(indexToRemove);
        }
      }
    },
    validateActualGroupInGroupRecipient: function validateActualGroupInGroupRecipient() {
      var flagGroupFound = false;
      for (var m = 0; m < this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient.length; m++) {
        if (this.tempoBundle.alerts[this.alertIndex].AlertData.group_recipient[m] == this.actualGroup.group_id) {
          this.transmitEmailToActualGroupMember = true;
        }
      }
    },
    alertButtonAction: function alertButtonAction(indexButton) {
      var _this3 = this;

      if (window.confirm(this.tempoBundle.alerts[this.alertIndex].AlertData.buttons[indexButton].confirmationMessage[this.actualLanguage])) {
        var requestData = { 'postAction': this.tempoBundle.alerts[this.alertIndex].AlertData.buttons[indexButton].alertPostAction,
          'alertLinkedBundle': this.tempoBundle.alerts[this.alertIndex].AlertData.alert_linked_bundle,
          'alertId': this.tempoBundle.alerts[this.alertIndex].AlertData.alert_id };

        this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(_this3.tempoBundle.alerts[_this3.alertIndex].AlertData.buttons[indexButton].successMessage[_this3.actualLanguage]);
          } else {
            window.alert(_this3.tempoBundle.alerts[_this3.alertIndex].AlertData.buttons[indexButton].errorMessage[_this3.actualLanguage]);
          }
        });
      }
    },
    saveAlertModifications: function saveAlertModifications() {
      var _this4 = this;

      this.alertIsSaving = true;
      var requestData = { 'postAction': 'SaveAlertModification',
        'alertData': this.tempoBundle.alerts[this.alertIndex].AlertData

      };
      this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
        _this4.alertIsSaving = false;
        if (response.data.Code == 'OK') {
          _this4.$store.dispatch('sessionStore/reloadActualBundle');
          _this4.alertShowAddButton = true;
        } else {
          window.alert("L'enregistrement a échoué. / Saving fail.");
        }
      });
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage d'alerte", EN: 'Alert sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Alert',
        'entityId': this.actualBundle.alerts[this.alertIndex].AlertData.alert_id,
        'entityReferenceName': this.actualBundle.alerts[this.alertIndex].ReferenceName,
        'displayAlertOptions': true,
        'displayChannelOptions': false,
        'displayDeviceOptions': false,
        'displayBundleOptions': false,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),

  mounted: function mounted() {

    this.alertConfigViewFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions, 'alertConfigView');
    this.alertConfigEditFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions, 'alertConfigEdit');
    this.alertConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions, 'alertConfigDelete');
    this.alertSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.alerts[this.alertIndex].AlertData.permissions, 'alertSharingEnable');

    this.actualGroupIsDefaultGroup = this.actualGroup.group_id.includes('::DefaultGroup');
    this.validateActualGroupInGroupRecipient();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'configureBundle',
    data: function data() {
        return {
            displayDataTable: false,

            flagDisplaySubBundle: 0,
            flagDisplayPieChart: 0,
            flagDisplayAttributes: 0,
            flagDisplayChannelAverage: 0,
            flagDisplaySharing: 0,
            flagDisplayDeleteBundle: false,

            ListOfSharings: [],

            tempoBundle: {},
            newBundleIsSaving: false,
            addBundleIsSaving: false,
            addBundleIsSaving2: false,
            bundleIsDeleting: false,
            channelAttributeSelect: [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
            actualLanguage: "FR",
            labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },

            actualBundleIsDefaultBundle: true,
            flagDisplayCompleteBundleName: false,
            actualParentIsOwner: true,
            bundleConfigViewFlag: false,
            bundleConfigEditFlag: false,
            bundleConfigDeleteFlag: false,
            bundleSharingEnableFlag: false,

            textLabelBundleID: { FR: "Identifiant du système", EN: 'System ID' },
            buttonLabelModifySystemName: { FR: "Modifier le nom du Système", EN: 'Modify System name' },
            buttonLabelDeleteSystem: { FR: "Supprimer le Système sélectionné", EN: 'Delete selected System' },
            buttonLabelCreateSameLevelSystem: { FR: "Créer un Système de même niveau", EN: 'Create same level System' },
            buttonLabelCreateSubSystem: { FR: "Créer un Sous-Système", EN: 'Create Sub-System' },
            blocTitleSharing: { FR: "Partage du système", EN: 'System sharings' },
            blocTitleSharingList: { FR: "Liste des partage de Système", EN: 'System sharing list' },
            buttonLabelShareSystem: { FR: "Partager le système", EN: 'Share system' },
            textSharingDetail: { FR: "Le partage des composantes (module, appareils et VE) s'effectue en utilisant l'icône partage de chacun d'eux dans leur menu de configuration respectif. La liste des partages émits sont disponible pour visualisation ou modification de chacun des menus des composantes.", EN: 'Component sharing (module, device and VE) can be done by using the sharing icon on corresponding configuration menu. Sharing list is available for visualization or edition on top of corresponding component menu.' },
            blocLabelTags: { FR: "Étiquette de catégorisation des Appareils et Sous-Système", EN: 'Device and Sub-System categorisation tags' },
            textDescriptionTags: { FR: "Les étiquettes de permettent de filtrer les listes d'affichages. Créer des catégories et ensuite vous ajouter des étiquettes dans chacune de ces catégories.", EN: 'Tags allow to filter display list. You need to create you tags categories thenafter create tags in your defined categories.' },

            buttonLabelAddTagCategory: { FR: "Ajouter une catégorie d'étiquettes", EN: 'Add tags category' },
            buttonLabelAddTag: { FR: "Ajouter une étiquette", EN: 'Add tag' },
            buttonLabelDeleteTag: { FR: "Supprimer l'étiquette", EN: 'Delete selected tag' },
            buttonLabelDeleteTagCategory: { FR: "Supprimer la catégorie", EN: 'Delete category' },
            buttonLabelShowTags: { FR: "Afficher les étiquettes d'Appareils et Sous-Système dans l'onglet mesure", EN: 'Display Device and Sub-Systems tag in measurement menu' },
            blocLabelPieCharts: { FR: "Diagrammes circulaires et options d'affichage des appareils", EN: 'Pie charts and device display options' },
            textConfigPieChart: { FR: "Permet la comparaison des lectures des appareils (courant, Kwh et $).", EN: 'Allows to compare device consumption (peak current, Kwh and $).' },
            buttonLabelDisplayPieChart: { FR: "Afficher les diagrammes circulaires (pie charts)", EN: 'Display pie charts' },
            buttonLabelDisplayChannelLocalisation: { FR: "Afficher la carte de localisation par appareil", EN: 'Display localization map per device' },
            blocLabelMovingAverage: { FR: "Moyenne mobile de consommation", EN: 'Consumption moving average' },
            textConfigMovingAverage: { FR: "Options d'affichage des barres de moyenne mobile de puissance de l'onglet Mesures.", EN: 'Moving average display options in the measurement tab.' },
            buttonLabelDisplayMA: { FR: "Affichage des barres de moyenne mobile dans les entêtes des appareils en mode détails", EN: 'Display moving average bars on top of device display detail tab' },
            buttonLabelMA_DisplayActual: { FR: "Afficher la dernière mesure", EN: 'Display last reading' },
            buttonLabelMA_DisplayHr: { FR: "Afficher la moyenne mobile", EN: 'Display moving average' },
            buttonLabelMA_Day: { FR: "jour", EN: 'day' },
            buttonLabelMA_Days: { FR: "jours", EN: 'days' },

            messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
            messageRemoveConfirmA: { FR: "Confirmer la supression du système : ", EN: 'Confirm deletion of system : ' },
            messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },
            messageConfigTagDeletion: { FR: "Confirmer la supression de l'attribut (ceci met à jour les appareils et sous-system configuré avec cet élément)?", EN: 'Confirm attribute supression (this will update all device and sub-system settled with this element)?' },
            messageConfigTagCategoryDeletion: { FR: "Confirmer la supression de la catégorie (ceci retire la catégorie de tous les appareils et sous-system)?", EN: 'Confirm category supression (this will remove this categogy of all device and sub-system)?' },
            messageAddTagCategory: { FR: "Titre de la catégorie", EN: 'Category title' },
            messageAddTagCategoryTextField: { FR: "Categorie", EN: 'Category' },
            messageAddTag: { FR: "Étiquette à ajouter", EN: 'Tag to add' },
            messageAddTextField: { FR: "Étiquette", EN: 'Tag' },
            messageAddSystem: { FR: "Nouveau nom de Système : ", EN: 'New System name' },
            messageAddSystemTextField: { FR: "Nom du système", EN: 'System name' },
            messageAddNewSystem: { FR: "Nom du nouveau Système : ", EN: 'New System name' },
            messageAddNewSystemTextField: { FR: "Nom du système", EN: 'System name' },
            messageAddNewSystemToGroup: { FR: "Nom de votre nouveau Système à ajouter au Groupe : ", EN: 'New System name to add to the Group :' }

        };
    },

    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a,
        ConfigSharingList: __WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualGroup', 'actualBundle', 'navIndex', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

    watch: {
        actualBundle: function actualBundle() {
            this.reloadTempoBundle();
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
        reloadTempoBundle: function reloadTempoBundle() {
            this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
        },
        toggleDisplaySharing: function toggleDisplaySharing() {
            this.flagDisplaySharing = ~this.flagDisplaySharing;
        },
        toggleDisplaySubBundle: function toggleDisplaySubBundle() {
            this.flagDisplaySubBundle = ~this.flagDisplaySubBundle;
        },
        toggleDisplayPieChart: function toggleDisplayPieChart() {
            this.flagDisplayPieChart = ~this.flagDisplayPieChart;
        },
        toggleDisplayAttributes: function toggleDisplayAttributes() {
            this.flagDisplayAttributes = ~this.flagDisplayAttributes;
        },
        toggleDisplayChannelAverage: function toggleDisplayChannelAverage() {
            this.flagDisplayChannelAverage = ~this.flagDisplayChannelAverage;
        },
        addAttributeCategorie: function addAttributeCategorie() {
            var CategoryName = prompt(this.messageAddTagCategory[this.actualLanguage], this.messageAddTagCategoryTextField[this.actualLanguage]);
            this.actualBundle.channelsAttributes.push({ 'title': CategoryName, 'data': [] });
            this.saveNewAttributes();
        },
        addAttributeElement: function addAttributeElement(index) {
            var attribute = prompt(this.messageAddTag[this.actualLanguage], this.messageAddTextField[this.actualLanguage]);
            this.actualBundle.channelsAttributes[index].data.push(attribute);
            this.actualBundle.channelsAttributes[index].data.sort();
            this.saveNewAttributes();
        },
        deleteAttributeElement: function deleteAttributeElement(index1) {
            var FlagProcessToDelete = false;
            FlagProcessToDelete = window.confirm(this.messageConfigTagDeletion[this.actualLanguage]);

            if (FlagProcessToDelete == true) {
                var AttributeToDelete = this.actualBundle.channelsAttributes[index1].data[this.channelAttributeSelect[index1]];

                this.actualBundle.channelsAttributes[index1].data.splice(this.channelAttributeSelect[index1], 1);
                for (var n = 0; n < this.actualBundle.channels.length; n++) {
                    if (this.actualBundle.channels[n].Attributes[index1] == AttributeToDelete) {
                        this.actualBundle.channels[n].Attributes[index1] = 'ND';
                    }
                }
                this.saveNewAttributes();
            }
        },
        deleteCategoryList: function deleteCategoryList(index1) {
            var FlagProcessToDelete = false;
            FlagProcessToDelete = window.confirm(this.messageConfigTagCategoryDeletion[this.actualLanguage]);

            if (FlagProcessToDelete == true) {
                this.actualBundle.channelsAttributes.splice(index1, 1);

                for (var n = 0; n < this.actualBundle.channels.length; n++) {
                    for (var m = index1; m < this.actualBundle.channels[n].Attributes.length - 1; m++) {
                        this.actualBundle.channels[n].attributes[m] = this.actualBundle.channels[n].Attributes[m + 1];
                        this.actualBundle.channels[n].attributes[m + 1] = 'ND';
                    }
                }
                this.saveNewAttributes();
            }
        },
        saveChannelModifications: function saveChannelModifications(index) {
            var _this = this;

            this.channelIsSaving = true;
            var requestData = { 'postAction': 'SaveChannelModification',
                'bundleId': this.actualBundle.bundle_id,
                'channelIndex': index,
                'channelData': this.actualBundle.channels[index]
            };

            this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
                if (response.data.Code == 'OK') {} else {
                    window.alert(_this.messagePostFail[_this.actualLanguage]);
                }
            });
        },
        saveNewBundleData: function saveNewBundleData() {
            var _this2 = this;

            var requestData = { 'postAction': 'SaveNewBundleName',
                'bundleData': { 'bundleId': this.tempoBundle.bundle_id,
                    'bundleName': this.tempoBundle.bundle_name } };

            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this2.$store.dispatch('sessionStore/reloadActualBundle');
                }
            });
        },
        saveNewAttributes: function saveNewAttributes() {
            var _this3 = this;

            var requestData = { 'postAction': 'SaveBundleAttributes',
                'bundleData': { 'bundleId': this.tempoBundle.bundle_id,
                    'channelsAttributes': this.actualBundle.channelsAttributes,
                    'bundleChannelsList': this.actualBundle.channels } };

            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {} else {
                    window.alert(_this3.messagePostFail[_this3.actualLanguage]);
                }
            });
        },
        saveNewBundleConfiguration: function saveNewBundleConfiguration() {
            var _this4 = this;

            var requestData = { 'postAction': 'saveNewBundleConfiguration',
                'bundleData': { 'bundleId': this.tempoBundle.bundle_id,
                    'bundleConfiguration': this.actualBundle.bundle_configuration } };

            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {} else {
                    window.alert(_this4.messagePostFail[_this4.actualLanguage]);
                }
            });
        },
        saveNewBundleName: function saveNewBundleName() {
            var _this5 = this;

            var newBundleName = prompt(this.messageAddSystem[this.actualLanguage], this.messageAddSystemTextField[this.actualLanguage]);

            if (newBundleName != null) {
                this.newBundleIsSaving = true;
                var requestData = { 'postAction': 'SaveNewBundleName',
                    'bundleData': { 'bundleId': this.tempoBundle.bundle_id,
                        'bundleName': newBundleName } };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this5.newBundleIsSaving = false;
                        _this5.$store.dispatch('sessionStore/getGroupArborescence');
                    }
                });
            }
        },
        saveNewSubBundle: function saveNewSubBundle() {
            var _this6 = this;

            var newBundleName = prompt(this.messageAddNewSystem[this.actualLanguage], this.messageAddNewSystemTextField[this.actualLanguage]);

            if (newBundleName != null) {
                this.addBundleIsSaving = true;
                var requestData = { 'postAction': 'AddNewSubBundle',
                    'bundleData': { 'bundleId': this.tempoBundle.bundle_id,
                        'bundleName': newBundleName } };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this6.addBundleIsSaving = false;
                        _this6.$store.dispatch('sessionStore/getGroupArborescence');
                    } else {
                        window.alert(_this6.messagePostFail[_this6.actualLanguage]);
                    }
                });
            }
        },
        createNewBundleInGroup: function createNewBundleInGroup() {
            var _this7 = this;

            var newBundleName = prompt(this.messageAddNewSystemToGroup[this.actualLanguage] + this.actualGroup.group_name, this.messageAddNewSystemTextField[this.actualLanguage]);

            if (newBundleName != null) {
                this.newBundleIsSaving2 = true;
                var requestData = { 'postAction': 'CreateNewBundleInGroup',
                    'bundleName': newBundleName,
                    'hostGroup': this.actualGroup.group_id };
                this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
                    _this7.newBundleIsSaving2 = false;
                    if (response.data.Code == 'OK') {
                        _this7.$store.dispatch('sessionStore/getGroupArborescence');
                    } else {
                        window.alert(_this7.messagePostFail[_this7.actualLanguage]);
                    }
                });
            }
        },
        deleteBundle: function deleteBundle() {
            var _this8 = this;

            var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.actualBundle.bundle_name, this.messageRemoveConfirmB[this.actualLanguage]);

            if (confirmation == 'DELETE') {
                this.bundleIsDeleting = true;
                var hostId = this.navIndex.bundleParentId;

                var requestData = { 'postAction': 'DeleteBundle',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        document.location.reload();
                        _this8.bundleIsDeleting = false;
                    } else {
                        window.alert(_this8.messagePostFail[_this8.actualLanguage]);
                    }
                });
            }
        },
        shareEntity: function shareEntity() {
            var modalParameters = { 'modalTitle': { FR: "Partage de Système", EN: 'System sharing' },
                'entityOwner': this.actualBundle.bundle_id,
                'sharingType': 'Bundle',
                'entityId': this.actualBundle.bundle_id,
                'entityReferenceName': this.actualBundle.bundle_name,
                'displayAlertOptions': false,
                'displayChannelOptions': true,
                'displayDeviceOptions': true,
                'displayBundleOptions': true,
                'displayGroupOptions': false,
                'displayUserOptions': false };

            this.$store.dispatch('overlayStore/setParameters', modalParameters);
            this.showModal('config-access-rules-form');
        },
        findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
            var value = false;
            for (var n = 0; n < permissionList.length; n++) {
                if (permissionList[n].id == idToFind) {
                    value = permissionList[n].value;
                }
            }
            return value;
        }
    }),
    mounted: function mounted() {

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
        this.reloadTempoBundle();

        this.actualParentIsOwner = this.actualBundle.bundle_id.includes(this.parentContainer.slice(6));
        this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle');
        this.flagDisplayDeleteBundle = this.actualParentIsOwner && this.actualBundleIsDefaultBundle == false;

        this.bundleConfigViewFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigView');
        this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigEdit');
        this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigDelete');
        this.bundleSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleSharingEnable');

        this.flagDisplayCompleteBundleName = this.profileData.profileInfo.profile_type['masterUserCode'].includes("-EVSensAdmin");

        window.scrollTo(0, 0);
    }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_configuration_CarForm__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_configuration_CarForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_configuration_CarForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['carIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
    CarForm: __WEBPACK_IMPORTED_MODULE_5__views_configuration_CarForm___default.a,
    ConfigSharingList: __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      flagDisplayCar: 0,
      alertShowAddButton: true,
      carIsSaving: false,
      carIsDeleting: false,

      evseFlag: false,
      filteredYears: [],
      filteredModels: [],
      filteredColors: [],
      filteredCarPool: [],
      carModel: {
        manufacturer: '',
        color: '',
        year: '',
        model: '',
        carName: '',
        linkedDevice: '',
        linkedPort: '',
        averageWhPerKm: ''
      },

      actualLanguage: "FR",
      labelFieldEvName: { FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name' },
      labelFieldManufacturer: { FR: 'Manufacturier', EN: 'Manufacturer' },
      labelFieldSelect: { FR: 'Choisir', EN: 'Select' },
      labelFieldLevel: { FR: 'Niveau', EN: 'Level' },
      labelFieldEVSEBrand: { FR: 'Marque de borne', EN: 'EVSE Brand' },
      labelFieldEVSEModel: { FR: 'Type/Modèle', EN: 'Model' },
      labelFieldEVYear: { FR: 'Année', EN: 'Year' },
      labelFieldEVModel: { FR: 'Modèle', EN: 'Model' },
      labelFieldEVColor: { FR: 'Couleur', EN: 'Color' },
      labelFieldLinkModule: { FR: 'Module accosié à la recharge', EN: 'Linked module' },
      labelFieldLinkPort: { FR: 'Port associé à la recharge', EN: 'Linked port' },
      labelFieldEVConsumption: { FR: 'Consommation (Wh/km)', EN: 'Consumption (Wh/km)' },
      labelFieldSessDetecMinThld: { FR: 'Plage detection min. (W)', EN: 'Detection range min. (W)' },
      labelFieldSessDetecMaxThld: { FR: 'Plage detectin max. (W)', EN: 'Detection range max. (W)' },
      labelFieldButtonSave: { FR: 'Sauvegarder', EN: 'Save' },
      labelFieldButtonDelete: { FR: 'Supprimer', EN: 'Delete' },

      textLabelRefrenceName: { FR: "Nom de référence", EN: 'Referencen name' },
      textLabelName: { FR: "Nom", EN: 'Name' },
      textLabelDevicePort: { FR: "Module et port associé", EN: 'Module and linked port' },
      textLabelChargeDetectionRange: { FR: "Plage de détection de recharge", EN: 'Charge detection range' },
      buttonLabelDelete: { FR: "Supprimer", EN: 'Delete' },
      buttonLabelSaveModification: { FR: "Enregistrer les modification", EN: 'Save modifications' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messageRemoveConfirmA: { FR: "Confirmer la supression du véhicule ou chargeur : ", EN: 'Confirm deletion of EV or EVSE : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },
      messageConfirmCarManufacturerChange: { FR: "Confirmer la modification de modèle de VE? (Ce changement permet de modifier votre définition de VE mais les données d'économies sont sauvegardées).", EN: 'Confirm electric vehicule model? (This modification allow you to change your EV descrition but caculated savings are kept)' },

      carConfigViewFlag: false,
      carConfigEditFlag: false,
      carConfigDeleteFlag: false,
      carSharingEnableFlag: false,

      bundleConfigEditFlag: false,

      displayDevicePortConfig: false

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('carsStore', ['cars', 'manufacturers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayCar: function toggleDisplayCar() {
      this.flagDisplayCar = ~this.flagDisplayCar;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    onManufacturerChange: function onManufacturerChange() {
      var _this = this;

      if (this.tempoBundle.cars[this.carIndex].CarData.carInfo.model != '') {
        var changeCarFlag = window.confirm(this.messageConfirmCarManufacturerChange[this.actualLanguage]);
      } else {
        var changeCarFlag = true;
      }

      if (changeCarFlag == true) {
        this.resetData();
        if (this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer == "Borne de recharge") {
          this.evseFlag = true;
        } else {
          this.evseFlag = false;
        }

        return this.$store.dispatch('carsStore/getManufacturerInfos', { manufacturer: this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer }).then(function (response) {
          _this.filteredCarPool = response.data;
          _this.filteredYears = __WEBPACK_IMPORTED_MODULE_3_underscore__["a" /* default */].uniq(__WEBPACK_IMPORTED_MODULE_3_underscore__["a" /* default */].map(response.data, function (object) {
            return object.year;
          }));
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        });
      }
    },
    onYearChange: function onYearChange() {
      var _this2 = this;

      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer,
        year: this.tempoBundle.cars[this.carIndex].CarData.carInfo.year
      }).then(function (response) {
        _this2.filteredCarPool = response.data;
        _this2.filteredModels = __WEBPACK_IMPORTED_MODULE_3_underscore__["a" /* default */].uniq(__WEBPACK_IMPORTED_MODULE_3_underscore__["a" /* default */].map(response.data, function (object) {
          return object.model;
        }));

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    onModelChange: function onModelChange() {
      var _this3 = this;

      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer,
        year: this.tempoBundle.cars[this.carIndex].CarData.carInfo.year,
        model: this.tempoBundle.cars[this.carIndex].CarData.carInfo.model,
        whPerKm: this.carModel.averageWhPerKm
      }).then(function (response) {
        _this3.filteredCarPool = response.data;

        _this3.tempoBundle.cars[_this3.carIndex].CarData.carInfo.averageWhPerKm = _this3.filteredCarPool[0].averageWhPerKm;
        _this3.tempoBundle.cars[_this3.carIndex].CarData.carInfo.averageLtPerKm = _this3.filteredCarPool[0].averageLtPerKm;

        _this3.filteredColors = __WEBPACK_IMPORTED_MODULE_3_underscore__["a" /* default */].uniq(__WEBPACK_IMPORTED_MODULE_3_underscore__["a" /* default */].map(response.data, function (object) {
          return object.color;
        }));
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    onColorChange: function onColorChange() {
      for (var n = 0; n < this.filteredCarPool.length; n++) {
        if (this.filteredCarPool[n].color == this.tempoBundle.cars[this.carIndex].CarData.carInfo.color) {
          this.tempoBundle.cars[this.carIndex].CarData.carInfo.carPictureFile = this.filteredCarPool[n].carPictureFile;
          this.tempoBundle.cars[this.carIndex].CarData.carInfo.carId = this.filteredCarPool[n].carId;
        }
      }
    },
    resetData: function resetData() {
      this.filteredYears = [];
      this.filteredModels = [];
      this.filteredColors = [];
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.year = '';
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.color = '';
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.model = '';
      this.tempoBundle.cars[this.carIndex].CarData.linkedDevice = '';
      this.tempoBundle.cars[this.carIndex].CarData.linkedPort = '';
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.carPictureFile = '';
    },
    saveCarModifications: function saveCarModifications() {
      var _this4 = this;

      this.carIsSaving = true;
      var requestData = { 'postAction': 'SaveCarModification',
        'bundleId': this.tempoBundle.bundle_id,
        'carIndex': this.carIndex,
        'carData': this.tempoBundle.cars[this.carIndex]
      };

      this.$store.dispatch('sessionStore/postCar', requestData).then(function (response) {
        _this4.channelIsSaving = false;
        if (response.data.Code == 'OK') {
          _this4.$store.dispatch('sessionStore/reloadActualBundle');
          _this4.alertShowAddButton = true;
          _this4.carIsSaving = false;
        } else {
          window.alert(_this4.messagePostFail[_this4.actualLanguage]);
        }
      });
    },
    confirmRemoveCar: function confirmRemoveCar() {
      var _this5 = this;

      var FlagProcessToDelete = false;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tempoBundle.cars[this.carIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.carIsDeleting = true;
        var requestData = { 'postAction': 'RemoveCarFromBundle',
          'carIndex': this.carIndex,
          'carId': this.tempoBundle.cars[this.carIndex].CarData.carId,
          'bundleId': this.actualBundle.bundle_id,
          'parentContainer': this.parentContainer
        };

        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          _this5.carIsDeleting = false;
          if (response.data.Code == 'OK') {

            _this5.$store.dispatch('sessionStore/reloadActualBundle');
            _this5.alertShowAddButton = true;
          } else {
            window.alert(_this5.messagePostFail[_this5.actualLanguage]);
          }
        });
      }
    },
    computeSumBundleAlert: function computeSumBundleAlert() {
      this.sumAlertActualBundle = this.actualBundle.alerts.length;
    },
    computeSumChannelAlert: function computeSumChannelAlert() {
      this.sumAlertActualChannel = 0;
      for (var n = 0; n < this.actualBundle.alerts.length; n++) {
        if (this.actualBundle.alerts[n].AlertData.linked_channel[0] == this.tempoBundle.channels[this.channelIndex].ChannelData.channelId) {
          this.sumAlertActualChannel++;
        }
      }
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de VE ou borne", EN: 'EV or EVSE sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Car',
        'entityId': this.tempoBundle.cars[this.carIndex].CarData.carId,
        'entityReferenceName': this.tempoBundle.cars[this.carIndex].ReferenceName,
        'displayCarOptions': true,
        'displayAlertOptions': false,
        'displayChannelOptions': false,
        'displayDeviceOptions': false,
        'displayBundleOptions': false,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    },
    validateIfCarDeviceInDeviceList: function validateIfCarDeviceInDeviceList() {
      var returnValue = false;
      for (var n = 0; n < this.tempoBundle.devices.length; n++) {
        if (this.tempoBundle.cars[this.carIndex].CarData.linkedDevice == this.tempoBundle.devices[n].DeviceData.deviceId) {
          returnValue = true;
        }
      }

      if (this.tempoBundle.cars[this.carIndex].CarData.linkedDevice == '') {
        returnValue = true;
      }

      return returnValue;
    }
  }),

  mounted: function mounted() {
    if (this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer == "Borne de recharge") {
      this.evseFlag = true;
    } else {
      this.evseFlag = false;
    }

    this.filteredYears = [this.tempoBundle.cars[this.carIndex].CarData.carInfo.year];
    this.filteredModels = [this.tempoBundle.cars[this.carIndex].CarData.carInfo.model];
    this.filteredColors = [this.tempoBundle.cars[this.carIndex].CarData.carInfo.color];

    if (this.tempoBundle.cars[this.carIndex].CarData.carInfo.model == "TBD") {
      this.resetData();
    }

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.carConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions, 'carConfigView');
    this.carConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions, 'carConfigEdit');
    this.carConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions, 'carConfigDelete');
    this.carSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions, 'carSharingEnable');

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle, 'bundleConfigEdit');

    this.displayDevicePortConfig = this.validateIfCarDeviceInDeviceList();
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigAlert__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfigAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_configuration_AlertDefinition_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  components: {
    ApplianceList: __WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList___default.a,
    ConfigAlert: __WEBPACK_IMPORTED_MODULE_5__ConfigAlert___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      showApplianceList: false,
      flagDisplayChannel: 0,

      alertsDefinitions: [],
      alertShowAddButton: true,
      channelIsSaving: false,
      channelIsDeleting: false,
      flagDisplayAlertConfig: false,
      alertIsCreating: false,
      channelIDLast4: 'AAAA',

      alertToAddIndex: 0,
      sumAlertActualBundle: 0,
      sumAlertActualChannel: 0,
      thisChannelDeviceIndex: -1,

      center: { lat: 46, lng: 71 },
      markers: [],
      place: null,
      locationString: '',

      labelAlertSelect: { FR: "Sélectionner le type d'alerte à ajouter:", EN: 'Select type of alert to add:' },
      labelFieldButtonAddAlert: { FR: "Ajouter une alerte à l'appareil", EN: 'Add device alert' },
      labelUserMustSubscribeToConfigAlert: { FR: "Pour accéder aux alertes, vous devez adhérer a un forfait incluant ce service. Vous pouvez adhérer à un forfait dans  la section MON PLAN DE SERVICE dans le menu MON PROFILE.",
        EN: 'To access alerts, you must subscribe to a package that includes this service. You can subscribe to a monitoring package in the MY SERVICE PLAN section in the MY PROFILE menu.' },
      labelFieldButtonConfirmAddAlert: { FR: 'Ajouter', EN: 'Add' },
      labelFieldButtonCancelAddAlert: { FR: 'Annuler', EN: 'Cancel' },
      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },
      messageLinkedModuleNotInSystem: { FR: "Le module lié à cet appareil ne fait pas partie de ce système.", EN: 'The module linked to this device is not in this system.' },
      messageModifyForModuleInSystem: { FR: "Modifier pour un module de ce système", EN: 'Modify for a module in this system' },

      textLabelRefrenceName: { FR: "Nom de référence", EN: 'Referencen name' },
      sectionLabelDeviceConfig: { FR: "Configuration de l'appareil", EN: 'Device configuration' },
      textLabelName: { FR: "Nom de l'appareil", EN: 'Device name' },
      selectLabelLinkedModule: { FR: "Module de mesure lié", EN: 'Linked monitoring module' },
      selectLabelLinkedPort: { FR: "Port(s) du module lié(s)", EN: 'Monitoring linked port(s)' },
      textSelectMultiplePort: { FR: "(Appuyer sur CTRL pour sélectionner plusieurs ports)", EN: '(Press CTRL button to select multiple ports)' },

      titleLivePanel: { FR: "Mesure temps réel", EN: 'Real time measurement' },
      addThisChannelToLivePanel: { FR: "Ajouter cet appareil à la section Mesure temps réel", EN: 'Add this device to Real time measurement panel' },
      warningLevelLivePanel: { FR: " Puissance avertissement (jaune) :", EN: ' Warning power level (yellow) :' },
      limitLevelLivePanel: { FR: " Puissance limite (rouge) :", EN: ' Limit power level (red) :' },
      realTimeMeasurementPanelNotAvailable: { FR: "Mesure temps réel non disponible. Pour activer cette option vous devez contacter support@evsens.ca.",
        EN: 'Real-time measurement not available. To activate this option you must contact support@evsens.ca.' },

      sectionChannelLocation: { FR: "Localisation de l'appareil", EN: 'Device location' },
      labelFieldChannelAddress: { FR: "Adresse", EN: 'Address' },

      sectionLabelDeviceTags: { FR: "Étiquettes de l'appareil", EN: 'Device tags' },
      buttonLabelDeleteDevice: { FR: "Supprimer cet appareil", EN: 'Delete this device' },
      buttonLabelSaveDevice: { FR: "Enregistrer les paramètres", EN: 'Save parameters' },
      sectionLabelDeviceAlert: { FR: "Alertes de l'appareil mesuré", EN: "Monitored device alerts" },
      tableTitleAlertParameter: { FR: "Paramètre(s) de l'alerte", EN: 'Alert parameter(s)' },
      tableTitleAlertParameterValue: { FR: "Valeur", EN: 'Value' },
      channelSaveMessage: { FR: "Attention, si le nom de référence a été modifié, il est possible que la position dans la liste soit modifiée!",
        EN: 'Attention, if the reference name changed, it is possible that the device position in the list change!' },

      messageRemoveConfirmA: { FR: "Confirmer la supression de l'appareil : ", EN: 'Confirm device deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messageHigherPlanRequired: { FR: "Ce type d'alerte requiert un plan plus élevé. Vous devez souscrire à un nouveau plan pour y avoir accèes.", EN: 'This alert type requires higher plan. You need to subscribe to higher plan to have acsess.' },
      messageAlertLimitReach: { FR: "Vous avez atteint la limite d'alerte de votre profile", EN: 'You reach the alert limit of your profile.' },
      messageAlertLimitDeviceReach: { FR: "Vous avez atteint la limite d'alerte pour cet appareil", EN: 'You reach the alert limit for this device' },
      messageReferenceNamePrompt: { FR: "Nom de référence pour cette alerte", EN: 'Alert reference name' },
      messageReferenceNamePromptTextBox: { FR: "Alerte", EN: 'Alert' },

      channelConfigViewFlag: false,
      channelConfigEditFlag: false,
      channelConfigDeleteFlag: false,
      channelSharingEnableFlag: false,
      displayDevicePortConfig: false,
      valBidon: false,
      puissanceAvertissement: 0,
      puissanceLimit: 0,

      monthOptions: [{ text: '01-Jan', value: '1' }, { text: '02-Fév/Feb', value: '2' }, { text: '03-Mar', value: '3' }, { text: '04-Avr/Apr', value: '4' }, { text: '05-Mai/May', value: '5' }, { text: '06-Jui/Jun', value: '6' }, { text: '07-Jui/Jul', value: '7' }, { text: '08-Aoû/Aug', value: '8' }, { text: '09-Sept', value: '9' }, { text: '10-Oct', value: '10' }, { text: '11-Nov', value: '11' }, { text: '12-Déc/Dec', value: '12' }],

      dayOptions: [{ text: 'Lun/Mon', value: '1' }, { text: 'Mar/Tue', value: '2' }, { text: 'Mer/Wed', value: '3' }, { text: 'Jeu/Thu', value: '4' }, { text: 'Ven/Fri', value: '5' }, { text: 'Sam/Sat', value: '6' }, { text: 'Dim/Sun', value: '7' }],

      hourOptions: [{ text: '00:00', value: '0' }, { text: '01:00', value: '1' }, { text: '02:00', value: '2' }, { text: '03:00', value: 3 }, { text: '04:00', value: '4' }, { text: '05:00', value: '5' }, { text: '06:00', value: '6' }, { text: '07:00', value: '7' }, { text: '08:00', value: 8 }, { text: '09:00', value: '9' }, { text: '10:00', value: '10' }, { text: '11:00', value: '11' }, { text: '12:00', value: '12' }, { text: '13:00', value: 13 }, { text: '14:00', value: '14' }, { text: '15:00', value: '15' }, { text: '16:00', value: '16' }, { text: '17:00', value: '17' }, { text: '18:00', value: 18 }, { text: '19:00', value: '19' }, { text: '20:00', value: '20' }, { text: '21:00', value: '21' }, { text: '22:00', value: '22' }, { text: '23:00', value: 23 }, { text: '24:00', value: '24' }]

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayChannel: function toggleDisplayChannel() {
      this.flagDisplayChannel = ~this.flagDisplayChannel;
    },
    usePlace: function usePlace(place) {
      var newLat = place.geometry.location.lat();
      var newLng = place.geometry.location.lng();
      this.center = { lat: newLat, lng: newLng };
      this.place = place;
      this.locationString = place.formatted_address;
      this.markers = [{
        position: {
          lat: newLat,
          lng: newLng
        }
      }];

      this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude = newLat;
      this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude = newLng;
      this.tempoBundle.channels[this.channelIndex].ChannelData.address = place.formatted_address;

      this.place = null;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    onApplianceSelect: function onApplianceSelect(a) {
      this.showApplianceList = false;

      this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.iconFile = a.iconFile;
      this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelType = a.applianceType;
      if (this.actualLanguage == "FR") {
        this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelName = a.name;
      } else {
        this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelName = a.name_EN;
      }
    },
    saveChannelModifications: function saveChannelModifications() {
      var _this = this;

      this.channelIsSaving = true;
      var requestData = { 'postAction': 'SaveChannelModification',
        'bundleId': this.tempoBundle.bundle_id,
        'channelIndex': this.tempoBundle.channels[this.channelIndex].ChannelBundleIndex,
        'channelData': this.tempoBundle.channels[this.channelIndex],
        'parentContainer': this.parentContainer
      };

      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        _this.channelIsSaving = false;
        if (response.data.Code == 'OK') {
          window.alert(_this.channelSaveMessage[_this.actualLanguage]);
          _this.$store.dispatch('sessionStore/reloadActualBundle');
          _this.alertShowAddButton = true;
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    },
    confirmRemoveChannel: function confirmRemoveChannel() {
      var _this2 = this;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tempoBundle.channels[this.channelIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.channelIsDeleting = true;
        var requestData = { 'postAction': 'RemoveChannelFromBundle',
          'channelIndex': this.tempoBundle.channels[this.channelIndex].ChannelBundleIndex,
          'bundleId': this.tempoBundle.bundle_id,
          'channelData': { 'channelId': this.tempoBundle.channels[this.channelIndex].ChannelData.channelId },
          'bundleData': { 'bundleId': this.actualBundle.bundle_id },
          'parentContainer': this.parentContainer
        };
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          _this2.channelIsDeleting = false;
          if (response.data.Code == 'OK') {
            _this2.$store.dispatch('sessionStore/reloadActualBundle');
            _this2.alertShowAddButton = true;
          } else {
            window.alert(response.data.PromptMessage[_this2.actualLanguage]);
          }
        });
      }
    },
    openAlertAddMenu: function openAlertAddMenu() {
      var _this3 = this;

      var requestData = { 'postAction': 'GetAlertsDefinitions' };
      this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
        _this3.alertIsCreating = false;

        if (response.data.Code == 'OK') {
          _this3.alertsDefinitions = response.data.AlertsDefinitions;
          _this3.alertShowAddButton = false;
        }
      });
    },
    addAlertLine: function addAlertLine() {
      var _this4 = this;

      this.alertsDefinitions[this.alertToAddIndex].alertId = moment().format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss');
      this.alertsDefinitions[this.alertToAddIndex].emailRecipient[0] = this.profileData.profileInfo.email;
      this.alertsDefinitions[this.alertToAddIndex].usersRecipient[0].email = this.profileData.profileInfo.email;
      this.alertsDefinitions[this.alertToAddIndex].usersRecipient[0].profileId = this.profileData.profileId;

      var tempo = jQuery.extend(true, {}, this.alertsDefinitions[this.alertToAddIndex]);
      tempo['alert_linked_bundle'] = this.actualBundle.bundle_id;
      tempo['linked_channel'] = this.actualBundle.channels[this.channelIndex].ChannelData.channelId;


      var alertReferenceName = prompt(this.messageReferenceNamePrompt[this.actualLanguage], this.messageReferenceNamePromptTextBox[this.actualLanguage]);

      if (alertReferenceName != null) {
        this.alertIsCreating = true;
        var requestData = { 'postAction': 'AddNewAlert',
          'referenceName': alertReferenceName,
          'bundleData': { 'bundleId': this.actualBundle.bundle_id },
          'alertData': tempo };
        this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
          _this4.alertIsCreating = false;

          if (response.data.Code == 'OK') {
            _this4.$store.dispatch('sessionStore/reloadActualBundle');
            _this4.sumAlertActualChannel += 1;
            _this4.alertShowAddButton = true;
          } else {
            window.alert(response.data.PromptMessage[_this4.actualLanguage]);
          }
        });
      }
    },
    computeSumChannelAlert: function computeSumChannelAlert() {
      this.sumAlertActualChannel = 0;
      for (var n = 0; n < this.actualBundle.alerts.length; n++) {
        if (this.actualBundle.alerts[n].AlertData.linked_channel[0] == this.tempoBundle.channels[this.channelIndex].ChannelData.channelId) {
          this.sumAlertActualChannel++;
        }
      }
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de mesure d'appareils", EN: 'Device monitoring sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Channel',
        'entityId': this.tempoBundle.channels[this.channelIndex].ChannelData.channelId,
        'entityReferenceName': this.tempoBundle.channels[this.channelIndex].ReferenceName,
        'displayAlertOptions': false,
        'displayChannelOptions': true,
        'displayDeviceOptions': false,
        'displayBundleOptions': false,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    },
    validateIfChannelDeviceInDeviceList: function validateIfChannelDeviceInDeviceList() {
      var returnValue = false;
      this.thisChannelDeviceIndex = -1;
      for (var n = 0; n < this.tempoBundle.devices.length; n++) {
        if (this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == this.tempoBundle.devices[n].DeviceData.deviceId) {
          returnValue = true;
          this.thisChannelDeviceIndex = n;
        }
      }

      if (this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == 'TBD') {
        returnValue = true;
      }

      if (this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == 'Aucun/None') {
        returnValue = true;
      }

      return returnValue;
    }
  }),

  mounted: function mounted() {

    this.computeSumChannelAlert();

    var LengthChannelId = this.tempoBundle.channels[this.channelIndex].ChannelData.channelId.length;

    this.channelIDLast4 = this.tempoBundle.channels[this.channelIndex].ChannelData.channelId.substring(LengthChannelId - 4, LengthChannelId);

    this.channelConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.channels[this.channelIndex].ChannelData.permissions, 'channelConfigView');
    this.channelConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.channel, 'channelConfigEdit');
    this.channelConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.permissions.channel, 'channelConfigDelete');
    this.channelSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.channels[this.channelIndex].ChannelData.permissions, 'channelSharingEnable');

    this.displayDevicePortConfig = this.validateIfChannelDeviceInDeviceList();

    this.locationString = this.tempoBundle.channels[this.channelIndex].ChannelData.address;
    this.markers = [{
      position: {
        lat: this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude,
        lng: this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude
      }
    }];
    this.center = { lat: this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude,
      lng: this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude };

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    if (parseInt(this.tempoBundle.bundleRights.alertLimitPerBundle.max) > 0) {
      this.flagDisplayAlertConfig = true;
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigAlert__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfigAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_configuration_AlertDefinition_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  components: {
    ApplianceList: __WEBPACK_IMPORTED_MODULE_4__views_configuration_ApplianceList___default.a,
    ConfigAlert: __WEBPACK_IMPORTED_MODULE_5__ConfigAlert___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_7__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      showApplianceList: false,
      flagDisplayChannel: 0,

      alertsDefinitions: [],
      alertShowAddButton: true,
      channelIsSaving: false,
      channelIsDeleting: false,
      alertIsCreating: false,
      channelIDLast4: 'AAAA',

      alertToAddIndex: 0,
      sumAlertActualBundle: 0,
      sumAlertActualChannel: 0,
      thisChannelDeviceIndex: -1,

      center: { lat: 46, lng: 71 },
      markers: [],
      place: null,
      locationString: '',

      labelAlertSelect: { FR: "Sélectionner le type d'alerte à ajouter:", EN: 'Select type of alert to add:' },
      labelFieldButtonAddAlert: { FR: "Ajouter une alerte à l'appareil", EN: 'Add device alert' },
      labelFieldButtonConfirmAddAlert: { FR: 'Ajouter', EN: 'Add' },
      labelFieldButtonCancelAddAlert: { FR: 'Annuler', EN: 'Cancel' },
      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },
      messageLinkedModuleNotInSystem: { FR: "Le module lié à cet appareil ne fait pas partie de ce système.", EN: 'The module linked to this device is not in this system.' },
      messageModifyForModuleInSystem: { FR: "Modifier pour un module de ce système", EN: 'Modify for a module in this system' },

      textLabelRefrenceName: { FR: "Nom de référence", EN: 'Referencen name' },
      sectionLabelDeviceConfig: { FR: "Configuration de l'appareil", EN: 'Device configuration' },
      textLabelName: { FR: "Nom de l'appareil", EN: 'Device name' },
      selectLabelLinkedModule: { FR: "Module de mesure lié", EN: 'Linked monitoring module' },
      selectLabelLinkedPort: { FR: "Port(s) du module lié(s)", EN: 'Monitoring linked port(s)' },
      textSelectMultiplePort: { FR: "(Appuyer sur CTRL pour sélectionner plusieurs ports)", EN: '(Press CTRL button to select multiple ports)' },

      sectionChannelLocation: { FR: "Localisation de l'appareil", EN: 'Device location' },
      labelFieldChannelAddress: { FR: "Adresse", EN: 'Address' },

      sectionLabelDeviceTags: { FR: "Étiquettes de l'appareil", EN: 'Device tags' },
      buttonLabelDeleteDevice: { FR: "Supprimer cet appareil", EN: 'Delete this device' },
      buttonLabelSaveDevice: { FR: "Enregistrer les paramètres", EN: 'Save parameters' },
      sectionLabelDeviceAlert: { FR: "Alertes de l'appareil", EN: 'Device alerts' },
      tableTitleAlertParameter: { FR: "Paramètre(s) de l'alerte", EN: 'Alert parameter(s)' },
      tableTitleAlertParameterValue: { FR: "Valeur", EN: 'Value' },

      messageRemoveConfirmA: { FR: "Confirmer la supression de l'appareil : ", EN: 'Confirm device deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messageHigherPlanRequired: { FR: "Ce type d'alerte requiert un plan plus élevé. Vous devez souscrire à un nouveau plan pour y avoir accèes.", EN: 'This alert type requires higher plan. You need to subscribe to higher plan to have acsess.' },
      messageAlertLimitReach: { FR: "Vous avez atteint la limite d'alerte de votre profile", EN: 'You reach the alert limit of your profile.' },
      messageAlertLimitDeviceReach: { FR: "Vous avez atteint la limite d'alerte pour cet appareil", EN: 'You reach the alert limit for this device' },
      messageReferenceNamePrompt: { FR: "Nom de référence pour cette alerte", EN: 'Alert reference name' },
      messageReferenceNamePromptTextBox: { FR: "Alerte", EN: 'Alert' },

      channelConfigViewFlag: false,
      channelConfigEditFlag: false,
      channelConfigDeleteFlag: false,
      channelSharingEnableFlag: false,
      displayDevicePortConfig: false,

      monthOptions: [{ text: '01-Jan', value: '1' }, { text: '02-Fév/Feb', value: '2' }, { text: '03-Mar', value: '3' }, { text: '04-Avr/Apr', value: '4' }, { text: '05-Mai/May', value: '5' }, { text: '06-Jui/Jun', value: '6' }, { text: '07-Jui/Jul', value: '7' }, { text: '08-Aoû/Aug', value: '8' }, { text: '09-Sept', value: '9' }, { text: '10-Oct', value: '10' }, { text: '11-Nov', value: '11' }, { text: '12-Déc/Dec', value: '12' }],

      dayOptions: [{ text: 'Lun/Mon', value: '1' }, { text: 'Mar/Tue', value: '2' }, { text: 'Mer/Wed', value: '3' }, { text: 'Jeu/Thu', value: '4' }, { text: 'Ven/Fri', value: '5' }, { text: 'Sam/Sat', value: '6' }, { text: 'Dim/Sun', value: '7' }],

      hourOptions: [{ text: '00:00', value: '0' }, { text: '01:00', value: '1' }, { text: '02:00', value: '2' }, { text: '03:00', value: 3 }, { text: '04:00', value: '4' }, { text: '05:00', value: '5' }, { text: '06:00', value: '6' }, { text: '07:00', value: '7' }, { text: '08:00', value: 8 }, { text: '09:00', value: '9' }, { text: '10:00', value: '10' }, { text: '11:00', value: '11' }, { text: '12:00', value: '12' }, { text: '13:00', value: 13 }, { text: '14:00', value: '14' }, { text: '15:00', value: '15' }, { text: '16:00', value: '16' }, { text: '17:00', value: '17' }, { text: '18:00', value: 18 }, { text: '19:00', value: '19' }, { text: '20:00', value: '20' }, { text: '21:00', value: '21' }, { text: '22:00', value: '22' }, { text: '23:00', value: 23 }, { text: '24:00', value: '24' }]

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayChannel: function toggleDisplayChannel() {
      this.flagDisplayChannel = ~this.flagDisplayChannel;
    },
    usePlace: function usePlace(place) {
      var newLat = place.geometry.location.lat();
      var newLng = place.geometry.location.lng();
      this.center = { lat: newLat, lng: newLng };
      this.place = place;
      this.locationString = place.formatted_address;
      this.markers = [{
        position: {
          lat: newLat,
          lng: newLng
        }
      }];

      this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude = newLat;
      this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude = newLng;
      this.tempoBundle.channels[this.channelIndex].ChannelData.address = place.formatted_address;

      this.place = null;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    onApplianceSelect: function onApplianceSelect(a) {
      this.showApplianceList = false;
      console.log(a);

      this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.iconFile = a.iconFile;
      this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelType = a.applianceType;
      if (this.actualLanguage == "FR") {
        this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelName = a.name;
      } else {
        this.tempoBundle.channels[this.channelIndex].ChannelData.channelInfo.channelName = a.name_EN;
      }
    },
    saveChannelModifications: function saveChannelModifications() {
      var _this = this;

      this.channelIsSaving = true;
      var requestData = { 'postAction': 'SaveChannelModification',
        'bundleId': this.tempoBundle.bundle_id,
        'channelIndex': this.channelIndex,
        'channelData': this.tempoBundle.channels[this.channelIndex],
        'parentContainer': this.parentContainer
      };
      console.log(requestData);
      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        console.log(response.data);
        _this.channelIsSaving = false;
        if (response.data.Code == 'OK') {
          _this.$store.dispatch('sessionStore/reloadActualBundle');
          _this.alertShowAddButton = true;
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    },
    confirmRemoveChannel: function confirmRemoveChannel() {
      var _this2 = this;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tempoBundle.channels[this.channelIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.channelIsDeleting = true;
        var requestData = { 'postAction': 'RemoveChannelFromBundle',
          'channelIndex': this.channelIndex,
          'bundleId': this.tempoBundle.bundle_id,
          'channelData': { 'channelId': this.tempoBundle.channels[this.channelIndex].ChannelData.channelId },
          'bundleData': { 'bundleId': this.actualBundle.bundle_id },
          'parentContainer': this.parentContainer
        };
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          console.log(response.data);
          _this2.channelIsDeleting = false;
          if (response.data.Code == 'OK') {
            _this2.$store.dispatch('sessionStore/reloadActualBundle');
            _this2.alertShowAddButton = true;
          } else {
            window.alert(response.data.PromptMessage[_this2.actualLanguage]);
          }
        });
      }
    },
    openAlertAddMenu: function openAlertAddMenu() {
      var _this3 = this;

      var requestData = { 'postAction': 'GetAlertsDefinitions',
        'alertListId': 'Alert_ApiDevice_V1P00' };
      this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
        _this3.alertIsCreating = false;

        if (response.data.Code == 'OK') {
          _this3.alertsDefinitions = response.data.AlertsDefinitions;
          _this3.alertShowAddButton = false;
        }
      });
    },
    addAlertLine: function addAlertLine() {
      var _this4 = this;

      this.alertsDefinitions[this.alertToAddIndex].alertId = moment().format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss');
      this.alertsDefinitions[this.alertToAddIndex].emailRecipient[0] = this.profileData.profileInfo.email;

      var tempo = jQuery.extend(true, {}, this.alertsDefinitions[this.alertToAddIndex]);
      tempo['alert_linked_bundle'] = this.actualBundle.bundle_id;
      tempo['linked_channel'] = this.actualBundle.channels[this.channelIndex].ChannelData.channelId;

      var alertReferenceName = prompt(this.messageReferenceNamePrompt[this.actualLanguage], this.messageReferenceNamePromptTextBox[this.actualLanguage]);

      if (alertReferenceName != null) {
        this.alertIsCreating = true;
        var requestData = { 'postAction': 'AddNewAlert',
          'referenceName': alertReferenceName,
          'bundleData': { 'bundleId': this.actualBundle.bundle_id },
          'alertData': tempo };
        this.$store.dispatch('sessionStore/postAlert', requestData).then(function (response) {
          _this4.alertIsCreating = false;

          if (response.data.Code == 'OK') {
            _this4.$store.dispatch('sessionStore/reloadActualBundle');
            _this4.alertShowAddButton = true;
          } else {
            window.alert(response.data.PromptMessage[_this4.actualLanguage]);
          }
        });
      }
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de mesure d'appareils", EN: 'Device monitoring sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Channel',
        'entityId': this.tempoBundle.channels[this.channelIndex].ChannelData.channelId,
        'entityReferenceName': this.tempoBundle.channels[this.channelIndex].ReferenceName,
        'displayAlertOptions': false,
        'displayChannelOptions': true,
        'displayDeviceOptions': false,
        'displayBundleOptions': false,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    },
    validateIfChannelDeviceInDeviceList: function validateIfChannelDeviceInDeviceList() {
      var returnValue = false;
      this.thisChannelDeviceIndex = -1;
      for (var n = 0; n < this.tempoBundle.devices.length; n++) {
        if (this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == this.tempoBundle.devices[n].DeviceData.deviceId) {
          returnValue = true;
          this.thisChannelDeviceIndex = n;
        }
      }

      if (this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == 'TBD') {
        returnValue = true;
      }

      if (this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId == 'Aucun/None') {
        returnValue = true;
      }

      return returnValue;
    }
  }),

  mounted: function mounted() {
    var LengthChannelId = this.tempoBundle.channels[this.channelIndex].ChannelData.channelId.length;

    this.channelIDLast4 = this.tempoBundle.channels[this.channelIndex].ChannelData.channelId.substring(LengthChannelId - 4, LengthChannelId);

    this.channelConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.channels[this.channelIndex].ChannelData.permissions, 'channelConfigView');
    this.channelConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.channel, 'channelConfigEdit');
    this.channelConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.permissions.channel, 'channelConfigDelete');
    this.channelSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.channels[this.channelIndex].ChannelData.permissions, 'channelSharingEnable');

    this.displayDevicePortConfig = this.validateIfChannelDeviceInDeviceList();

    this.locationString = this.tempoBundle.channels[this.channelIndex].ChannelData.address;
    this.markers = [{
      position: {
        lat: this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude,
        lng: this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude
      }
    }];
    this.center = { lat: this.tempoBundle.channels[this.channelIndex].ChannelData.position.latitude,
      lng: this.tempoBundle.channels[this.channelIndex].ChannelData.position.longitude };

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfigChannel__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfigChannel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfigChannel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigChannelApiDevV1p00__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigChannelApiDevV1p00___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfigChannelApiDevV1p00__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubComponent_ConfigSharingList__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    ConfigChannel: __WEBPACK_IMPORTED_MODULE_4__ConfigChannel___default.a,
    ConfigChannelApiDevV1p00: __WEBPACK_IMPORTED_MODULE_5__ConfigChannelApiDevV1p00___default.a,
    ConfigSharingList: __WEBPACK_IMPORTED_MODULE_6__SubComponent_ConfigSharingList___default.a
  },
  data: function data() {
    return {
      actualLanguage: "FR",
      showListOfChannel: true,
      flagDisplayFilter: 0,
      attributesFilters: [],
      channelDisplayFlag: [],
      attributesFiltersChoice: [],
      channelCount: 0,
      defaultBundleSelected: true,

      sectionLabelDeviceFilter: { FR: "Filtres d'affichage des appareils", EN: 'Display devices filters' },
      buttonLabelEraseFilter: { FR: "Effacer les filtres appliqués", EN: 'Reset applied filters' },
      buttonLabelApplyFilter: { FR: "Appliquer les filtres", EN: 'Apply filters' },

      bundleConfigEditFlag: false

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'groupArborescence', 'actualBundle', 'dashboardFlags'])),
  watch: {
    actualBundle: function actualBundle() {
      this.showListOfChannel = false;
      this.resetDisplayFlag();
      this.showListOfChannel = true;
    },
    groupArborescence: function groupArborescence() {
      this.showListOfChannel = false;
      this.resetDisplayFlag();
      this.showListOfChannel = true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayFilter: function toggleDisplayFilter() {
      this.flagDisplayFilter = ~this.flagDisplayFilter;
    },
    resetDisplayFlag: function resetDisplayFlag() {
      this.channelDisplayFlag = [];
      var previousDisplayFilter = this.flagDisplayFilter;
      this.showListOfChannel = false;
      this.flagDisplayFilter = 0;
      for (var m = 0; m < this.actualBundle.channels.length; m++) {
        this.channelDisplayFlag[m] = true;
      }
      this.generatesFiltersList();
      this.showListOfChannel = true;
      this.flagDisplayFilter = previousDisplayFilter;

      this.channelCount = this.actualBundle.channels.length;
    },
    generatesFiltersList: function generatesFiltersList() {
      this.attributesFilters = [];
      this.attributesFiltersChoice = [];
      for (var attrList = 0; attrList < this.actualBundle.channelsAttributes.length; attrList++) {
        this.attributesFilters.push([]);
        this.attributesFiltersChoice.push([]);
        for (var m = 0; m < this.actualBundle.channels.length; m++) {
          if (this.channelDisplayFlag[m] == true) {
            if (this.actualBundle.channels[m].Attributes[attrList] != "ND") {
              if (this.attributesFilters[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList]) < 0) {
                this.attributesFilters[attrList].push(this.actualBundle.channels[m].Attributes[attrList]);
              }
            }
          }
        }
      }
    },
    applyFilter: function applyFilter() {
      this.showListOfChannel = false;
      this.flagDisplayFilter = 0;
      for (var m = 0; m < this.actualBundle.channels.length; m++) {

        for (var attrList = 0; attrList < this.actualBundle.channelsAttributes.length; attrList++) {
          if (this.attributesFiltersChoice[attrList].length > 0) {
            if (this.attributesFiltersChoice[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList]) >= 0) {
              this.channelDisplayFlag[m] = true;
            } else {
              this.channelDisplayFlag[m] = false;
            }
          }
        }
      }
      this.generatesFiltersList();
      this.flagDisplayFilter = -1;
      this.showListOfChannel = true;
    },
    openChannel: function openChannel(channelIndex) {
      this.channelSelected = true;
    },
    closeChannel: function closeChannel() {
      this.channelSelected = false;
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),

  mounted: function mounted() {

    this.resetDisplayFlag();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigEdit');

    this.defaultBundleSelected = this.actualBundle.bundle_id.includes(':DefaultBundle');
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__custom_dashboard_SubComponent_CustomDashboardTileV1p00_vue__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__custom_dashboard_SubComponent_CustomDashboardTileV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__custom_dashboard_SubComponent_CustomDashboardTileV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FavIconList_js__ = __webpack_require__(1071);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    CustomDashboardTile: __WEBPACK_IMPORTED_MODULE_4__custom_dashboard_SubComponent_CustomDashboardTileV1p00_vue___default.a

  },
  data: function data() {
    return {
      actualLanguage: "FR",
      dashboardData: { version: '1P00',
        tabs: [],
        itemCount: '0' },
      maxItemCount: '4',
      tabTitleClass: ['active', ''],
      tabContentClass: ['tab-pane active', 'tab-pane'],
      flagDisplayPanes: true,

      descriptionTitle: { FR: "Configuration du menu <Mon Dashboard>",
        EN: "<My Dashboard> configuration menu" },
      description01: { FR: "Cette section de configuration vous permet de configurer l'affichage du menu 'Mon Dashboard' (boutons du haut de la page).",
        EN: "This configuration section allows you to configure the display of the 'My Dashboard' menu (buttons at the top of the page)." },
      description02: { FR: "Utilisez l'onglet 'Configuration' pour ajouter les éléments souhaités pour votre Dashboard et utiliser l'onglet 'Prévisualisation' pour voir le résultat.",
        EN: "Use the 'Configuration' tab to add the desired elements for your Dashboard and use the 'Preview' tab to see the result." },

      messageMaxItemCountReach: { FR: "Vous avez atteint le nombre maximal d'item pour votre Dashboard, pour augmenter cette limite, vous devez modifier votre forfait (via la section Mon Profile).",
        EN: "You have reached the maximum number of items for your Dashboard, to increase this limit, you must modify your package (via the My Profile section)." },

      onglet01: { FR: "Configuration", EN: "Configuration" },
      onglet02: { FR: "Prévisualisation", EN: "Preview" },

      labelTab: { FR: "Onglet", EN: 'Tab' },
      labelTabName: { FR: "Nom d'onglet", EN: 'Tab name' },
      labelButtonAddTab: { FR: "Ajouter un onglet", EN: 'Add tab' },
      labelButtonDeleteTab: { FR: "Supprimer cet onglet", EN: 'Delete this tab' },

      labelButtonAddSection: { FR: "Ajouter une section", EN: 'Add section' },
      labelSectionSize: { FR: "Dimension de la section", EN: 'Section size' },

      titleTile: { FR: "Tuile", EN: 'Tile' },
      labelButtonAddTile: { FR: "Ajouter une tuile", EN: 'Add tile' },
      labelTileLabel: { FR: "Étiquette", EN: 'Label' },
      labelTileAgregation: { FR: "Agregation", EN: 'Agregation' },
      labelTileIcon: { FR: "Icone", EN: 'Icon' },

      titleGraph: { FR: "Graphique", EN: 'Graph' },
      labelButtonAddGraph: { FR: "Ajouter un graphique", EN: 'Add graph' },
      labelButtonDeleteSection: { FR: "Supprimer cette section", EN: 'Delete this section' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'groupArborescence', 'actualBundle', 'dashboardFlags'])),

  methods: {
    switchPane: function switchPane(index) {
      var _this = this;

      for (var m = 0; m < this.tabTitleClass.length; m++) {
        this.tabTitleClass[m] = '';
        this.tabContentClass[m] = 'tab-pane';
      }
      this.tabTitleClass[index] = 'active';
      this.tabContentClass[index] = 'tab-pane active';
      this.flagDisplayPanes = false;
      this.$nextTick(function () {
        _this.flagDisplayPanes = true;
      });
    },
    validateItemCount: function validateItemCount() {
      var ActualFloatCount = parseInt(this.dashboardData.itemCount);
      ActualFloatCount += 1;
      if (ActualFloatCount >= parseInt(this.maxItemCount)) {
        window.alert(this.messageMaxItemCountReach[this.actualLanguage]);
        return false;
      } else {
        this.dashboardData.itemCount = ActualFloatCount.toString();
        return true;
      }
    },
    addTabToDashboard: function addTabToDashboard() {
      this.dashboardData.tabs.push({
        tabName: 'Nom Onglet/Tab Name',
        sections: [] });
    },
    deleteTabToDashboard: function deleteTabToDashboard(index) {
      this.dashboardData.tabs.pop(index);
    },
    addSectionToDashboard: function addSectionToDashboard(index) {
      this.dashboardData.tabs[index].sections.push({
        size: 'Large',
        tiles: [],
        graphs: [] });
    },
    addTileToSection: function addTileToSection(index1, index2) {
      if (this.validateItemCount()) {
        this.dashboardData.tabs[index1].sections[index2].tiles.push({
          label: 'Étiquette/Label',
          width: 'Large',
          favIcon: '',
          sufix: '',
          value: Math.floor(Math.random() * 10),
          decimal: "2",
          agregation: 'Sum',
          linkedChannels: [],
          colorConditions: [{ colorBackground: "#46c37b",
            minValue: -100000,
            maxValue: 100000,
            customColorFlag: false,
            customColorRed: 125,
            customColorGreen: 125,
            customColorBlue: 125 }]
        });
      }
    },
    addConditionalColor: function addConditionalColor(index1, index2, index3) {
      this.dashboardData.tabs[index1].sections[index2].tiles[index3].push({
        colorBackground: "#46c37b",
        minValue: -100000,
        maxValue: 100000,
        customColorFlag: false,
        customColorRed: 125,
        customColorGreen: 125,
        customColorBlue: 125
      });
    },
    addGraphToSection: function addGraphToSection(index1, index2) {
      if (this.validateItemCount()) {
        this.dashboardData.tabs[index1].sections[index2].graphs.push('allo');
      }
    },
    deleteThisSection: function deleteThisSection(index1, index2) {
      this.dashboardData.tabs[index1].sections.pop(index2);
    }
  },

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ElectricalPlanDefinition_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['deviceIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner___default.a,
    ConfigDevicePlan: __WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan___default.a,
    ConfigSharingList: __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      center: { lat: 46, lng: 71 },
      markers: [],
      place: null,
      flagDisplayMap: 0,
      flagDisplayPortCfg: 0,
      flagDisplayDevice: 0,
      deviceIsSaving: false,
      deviceIsDeleting: false,
      displayCloudLiveButton: false,
      displayLiveButton: false,
      flagCloudLiveIsActivating: false,
      electricalPlanDefinitions: __WEBPACK_IMPORTED_MODULE_4__views_configuration_ElectricalPlanDefinition_js__["a" /* default */],
      locationString: '',

      flagDisplayListOfChannel: 0,
      deviceLinkedChannelIsReading: false,
      deviceListOfLinkedChannel: [],

      actualLanguage: "FR",
      flagDisplaySelectPlan: false,
      labelFieldDeviceName: { FR: "Nom de l'appareil", EN: 'Device name' },
      labelFieldDeviceAddress: { FR: "Localisation du module (adresse)", EN: 'Device location (address)' },
      labelFieldTitleBillPlan: { FR: 'Plan de tarification électrique', EN: 'Electrical billing plan' },
      labelApplyButtonBillPlan: { FR: 'Appliquer', EN: 'Apply' },
      labelCancelButtonBillPlan: { FR: 'Annuler', EN: 'Cancel' },
      labelSelectPreRecBillPlan: { FR: 'Sélectionner un plan pré-enregistré', EN: 'Select pre-recorded plan' },
      labelSelectPlan: { FR: 'Sélectionner un plan', EN: 'Select plan' },
      labelFieldTitleBasePrice: { FR: 'Tarif de base:', EN: 'Base price:' },
      labelFieldTitleTarif: { FR: 'Tarif ($/kWh)', EN: 'Price ($/kWh)' },
      labelFieldOptionHoraire: { FR: 'Horaire', EN: 'Scheduled' },
      labelFieldOptionTemperature: { FR: 'Température', EN: 'Temperature' },
      labelFieldTitleStartMonth: { FR: 'Mois début', EN: 'Start month' },
      labelFieldTitleEndMonth: { FR: 'Mois fin', EN: 'End month' },
      labelFieldTitleStartDay: { FR: 'Jour début', EN: 'Start day' },
      labelFieldTitleEndDay: { FR: 'Jour fin', EN: 'End day' },
      labelFieldTitleStartHour: { FR: 'Heure début', EN: 'Start hour' },
      labelFieldTitleEndHour: { FR: 'Heure fin', EN: 'End hour' },
      labelFieldOptionUnder: { FR: 'Inférieur à:', EN: 'Under:' },
      labelFieldOptionOver: { FR: 'Supérieur à:', EN: 'Over:' },
      labelFieldTitleTempThld: { FR: 'Température seuil (C)', EN: 'Threshold température (C)' },
      labelFieldButtonDelete: { FR: 'Supprimer', EN: 'Delete' },
      labelFieldButtonAddCond: { FR: 'Ajouter une condition au plan', EN: 'Add billing plan condition' },
      labelField: { FR: '', EN: '' },
      labelFieldButtonConfirmDeleteDevice: { FR: "Supprimer le module", EN: 'Delete module' },
      labelFieldButtonConfirmSaveDevice: { FR: "Sauvegarder les paramètres du module", EN: 'Save module parameters' },
      deviceSaveMessage: { FR: "Attention, si le nom de référence a été modifié, il est possible que la position dans la liste soit modifiée!",
        EN: 'Attention, if the reference name changed, it is possible that the module position in the list change!' },

      textLabelReferenceName: { FR: "Nom de référence", EN: 'Referencen name' },
      textLabelModuleName: { FR: "Nom du module", EN: 'Module name' },
      textLabelModuleID: { FR: "Identifiant du module", EN: 'Module ID' },
      textLabelModuleSN: { FR: "Numéro de série", EN: 'Serial number' },
      liveMonitorMessage: { FR: "Le Live Monitor requiert que l'appareil d'observation (ordinateur, tablette, téléphone) soit branché au même routeur que le module",
        EN: 'The Live Monitor requires that observation device (computer, tablet, mobile) is connected on the same router than the module.' },
      sectionLabelPortConfiguration: { FR: "Configuration des ports de mesure", EN: 'Measurement port configuration' },
      tableLabelSensorFactor: { FR: "Facteur de multiplication du capteur", EN: 'Sensor multiplication factor' },
      tableLabelCircuitVoltage: { FR: "Tension du circuit", EN: 'Circuit voltage' },
      tableLabelAvrPowerFactor: { FR: "Facteur de puissance moyen", EN: 'Power factor (average)' },
      sectionLabelLocalisation: { FR: "Localisation du module", EN: 'Module location' },

      sectionLabelLinkedChannel: { FR: "Appareils liés au module", EN: 'Linked devices to this module' },

      tableLinkedChannelChannelName: { FR: "Nom d'appareil", EN: 'Device name' },
      tableLinkedChannelUserOrg: { FR: "Utilisateur/Organisation", EN: 'User/Organization' },
      tableLinkedChannelBundle: { FR: "Nom du système", EN: 'System name' },
      tableLinkedChannelPort: { FR: "Ports", EN: 'Ports' },

      messageRemoveDevice: { FR: "ATTENTION : La supression d'un module dont vous êtes propriétaire supprime automatiquement les partages et les appareils et alertes liés a ces partages! Si ce module provient d'un partage il sera uniquement retiré de votre système.",
        EN: 'WARNING : The module deletion that you are owner will automatically delete all sharings and all device and alert linked to these sharings! If this module comes from a sharing, it will be only removed from your system.' },
      messageRemoveConfirmA: { FR: "Confirmer la supression du module : ", EN: 'Confirm module deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      deviceConfigViewFlag: false,
      deviceConfigEditFlag: false,
      deviceConfigDeleteFlag: false,
      deviceSharingEnableFlag: false,

      bundleConfigEditFlag: false

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayDevice: function toggleDisplayDevice() {
      this.flagDisplayDevice = ~this.flagDisplayDevice;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    togglePlanMap: function togglePlanMap() {
      this.flagDisplayMap = ~this.flagDisplayMap;
    },
    togglePortCfg: function togglePortCfg() {
      this.flagDisplayPortCfg = ~this.flagDisplayPortCfg;
    },
    toggleListOfChannel: function toggleListOfChannel() {
      this.flagDisplayListOfChannel = ~this.flagDisplayListOfChannel;
      if (this.flagDisplayListOfChannel == -1) {
        this.getDeviceListOfLinkedChannels();
      }
    },
    usePlace: function usePlace(place) {
      var newLat = place.geometry.location.lat();
      var newLng = place.geometry.location.lng();
      this.center = { lat: newLat, lng: newLng };
      this.place = place;
      this.locationString = place.formatted_address;
      this.markers = [{
        position: {
          lat: newLat,
          lng: newLng
        }
      }];
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude = newLat;
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude = newLng;
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress = place.formatted_address;
      this.place = null;
    },
    saveDeviceModifications: function saveDeviceModifications() {
      var _this = this;

      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan;
      this.deviceIsSaving = true;
      var requestData = { 'postAction': 'SaveDeviceModification',
        'bundleId': this.tempoBundle.bundle_id,
        'deviceIndex': this.tempoBundle.devices[this.deviceIndex].DeviceBundleIndex,
        'deviceData': JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tempoBundle.devices[this.deviceIndex]))
      };

      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        _this.deviceIsSaving = false;
        if (response.data.Code == 'OK') {
          window.alert(_this.deviceSaveMessage[_this.actualLanguage]);
          _this.$store.dispatch('sessionStore/reloadActualBundle');
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    },
    getDeviceListOfLinkedChannels: function getDeviceListOfLinkedChannels() {
      var _this2 = this;

      this.deviceLinkedChannelIsReading = true;
      var requestData = { 'postAction': 'GetDeviceListOfLinkedChannel',
        'bundleId': this.tempoBundle.bundle_id,
        'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId
      };

      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        _this2.deviceLinkedChannelIsReading = false;
        if (response.data.Code == 'OK') {
          _this2.deviceListOfLinkedChannel = response.data.LinkedChannelList;
        } else {
          window.alert(_this2.messagePostFail[_this2.actualLanguage]);
        }
      });
    },
    confirmRemoveDevice: function confirmRemoveDevice() {
      var _this3 = this;

      window.alert(this.messageRemoveDevice[this.actualLanguage]);
      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tempoBundle.devices[this.deviceIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.deviceIsDeleting = true;
        var requestData = { 'postAction': 'RemoveDeviceFromBundle',
          'deviceIndex': this.tempoBundle.devices[this.deviceIndex].DeviceBundleIndex,
          'bundleId': this.tempoBundle.bundle_id,
          'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
          'parentContainer': this.parentContainer
        };
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          _this3.deviceIsDeleting = false;
          if (response.data.Code == 'OK') {
            _this3.$store.dispatch('sessionStore/reloadActualBundle');
            _this3.alertShowAddButton = true;
          } else {
            window.alert(_this3.messagePostFail[_this3.actualLanguage]);
          }
        });
      }
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de module", EN: 'Module sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Device',
        'entityId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
        'entityReferenceName': this.tempoBundle.devices[this.deviceIndex].ReferenceName,
        'displayAlertOptions': false,
        'displayChannelOptions': false,
        'displayDeviceOptions': true,
        'displayBundleOptions': false,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    },
    loadLiveMonitor: function loadLiveMonitor() {
      var localUrl = 'http://' + this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.localIpAddr + '/live';
      window.open(localUrl, '_blank');
    },
    loadCloudLive: function loadCloudLive() {
      var _this4 = this;

      this.flagCloudLiveIsActivating = true;
      var requestData = { 'postAction': 'EnableDeviceLiveCloudReadings',
        'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId
      };
      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        _this4.flagCloudLiveIsActivating = false;
        if (response.data.Code == 'OK') {
          var modalParameters = {
            'liveType': 'Device',
            'deviceIndex': _this4.deviceIndex,
            'deviceId': _this4.tempoBundle.devices[_this4.deviceIndex].DeviceData.deviceId
          };

          _this4.$store.dispatch('overlayStore/setParameters', modalParameters);
          _this4.showModal('channel-cloud-live-modal-display');
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {
    this.locationString = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress;

    this.deviceConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceConfigView');
    this.deviceConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceConfigEdit');
    this.deviceConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceConfigDelete');
    this.deviceSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceSharingEnable');

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigEdit');

    this.displayCloudLiveButton = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.model.includes('CM6');
    this.displayLiveButton = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.model.includes('MM6');

    this.markers = [{
      position: {
        lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
        lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude
      }
    }];
    this.center = { lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
      lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude };

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ElectricalPlanDefinition_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['deviceIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner___default.a,
    ConfigDevicePlan: __WEBPACK_IMPORTED_MODULE_5__ConfigDevicePlan___default.a,
    ConfigSharingList: __WEBPACK_IMPORTED_MODULE_7__SubComponent_ConfigSharingList___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      center: { lat: 46, lng: 71 },
      markers: [],
      place: null,
      flagDisplayMap: 0,
      flagDisplayPortCfg: 0,
      flagDisplayDevice: 0,
      flagDisplayApiDevConfig: 0,
      flagBundleIsDeviceCreatorBundle: false,
      deviceIsSaving: false,
      deviceIsDeleting: false,
      displayCloudLiveButton: false,
      flagCloudLiveIsActivating: false,
      electricalPlanDefinitions: __WEBPACK_IMPORTED_MODULE_4__views_configuration_ElectricalPlanDefinition_js__["a" /* default */],
      locationString: '',

      flagDisplayListOfChannel: 0,
      deviceLinkedChannelIsReading: false,
      deviceListOfLinkedChannel: [],

      actualLanguage: "FR",
      flagDisplaySelectPlan: false,
      labelFieldDeviceName: { FR: "Nom de l'appareil", EN: 'Device name' },
      labelFieldDeviceAddress: { FR: "Localisation du module (adresse)", EN: 'Device location (address)' },
      labelFieldTitleBillPlan: { FR: 'Plan de tarification électrique', EN: 'Electrical billing plan' },
      labelApplyButtonBillPlan: { FR: 'Appliquer', EN: 'Apply' },
      labelCancelButtonBillPlan: { FR: 'Annuler', EN: 'Cancel' },
      labelSelectPreRecBillPlan: { FR: 'Sélectionner un plan pré-enregistré', EN: 'Select pre-recorded plan' },

      labelFieldButtonConfirmDeleteDevice: { FR: "Supprimer le module", EN: 'Delete module' },
      labelFieldButtonConfirmSaveDevice: { FR: "Sauvegarder les paramètres du module", EN: 'Save module parameters' },

      textLabelReferenceName: { FR: "Nom de référence", EN: 'Referencen name' },
      textLabelModuleName: { FR: "Nom du module", EN: 'Module name' },
      textLabelModuleID: { FR: "Identifiant du module", EN: 'Module ID' },
      textLabelModuleSN: { FR: "Numéro de série", EN: 'Serial number' },

      sectionLabelApiDev: { FR: "Parametres de contrôle", EN: 'Control parameters' },
      sectionLabelApiDevCtrlParamID: { FR: "Paramètre", EN: 'Parameter' },
      sectionLabelApiDevCtrlValue: { FR: "Valeur", EN: 'Value' },
      sectionLabelApiDevCtrlLastValue: { FR: "Dernière transmise", EN: 'Last transmit' },
      sectionLabelApiDevTTLRaw: { FR: "Données brutes", EN: 'RAW data' },
      sectionLabelApiDevTTLHr: { FR: "Données aux heures", EN: 'Hourly data' },
      sectionLabelApiDevTTLDay: { FR: "Données aux journée", EN: 'Daily data' },

      sectionLabelLocalisation: { FR: "Localisation du module", EN: 'Module location' },

      sectionLabelLinkedChannel: { FR: "Appareils liés au module", EN: 'Linked devices to this module' },

      messageRemoveDevice: { FR: "ATTENTION : La supression d'un module dont vous êtes propriétaire supprime automatiquement les partages et les appareils et alertes liés a ces partages! Si ce module provient d'un partage il sera uniquement retiré de votre système.",
        EN: 'WARNING : The module deletion that you are owner will automatically delete all sharings and all device and alert linked to these sharings! If this module comes from a sharing, it will be only removed from your system.' },
      messageRemoveConfirmA: { FR: "Confirmer la supression du module : ", EN: 'Confirm module deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      deviceConfigViewFlag: false,
      deviceConfigEditFlag: false,
      deviceConfigDeleteFlag: false,
      deviceSharingEnableFlag: false,

      bundleConfigEditFlag: false

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayDevice: function toggleDisplayDevice() {
      this.flagDisplayDevice = ~this.flagDisplayDevice;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    togglePlanMap: function togglePlanMap() {
      this.flagDisplayMap = ~this.flagDisplayMap;
    },
    togglePortCfg: function togglePortCfg() {
      this.flagDisplayPortCfg = ~this.flagDisplayPortCfg;
    },
    toggleApiDevConfig: function toggleApiDevConfig() {
      this.flagDisplayApiDevConfig = ~this.flagDisplayApiDevConfig;
    },
    toggleListOfChannel: function toggleListOfChannel() {
      this.flagDisplayListOfChannel = ~this.flagDisplayListOfChannel;
      if (this.flagDisplayListOfChannel == -1) {
        this.getDeviceListOfLinkedChannels();
      }
    },
    usePlace: function usePlace(place) {
      var newLat = place.geometry.location.lat();
      var newLng = place.geometry.location.lng();
      this.center = { lat: newLat, lng: newLng };
      this.place = place;
      this.locationString = place.formatted_address;
      this.markers = [{
        position: {
          lat: newLat,
          lng: newLng
        }
      }];
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude = newLat;
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude = newLng;
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress = place.formatted_address;
      this.place = null;
    },
    saveDeviceModifications: function saveDeviceModifications() {
      var _this = this;

      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan;
      this.deviceIsSaving = true;
      var requestData = { 'postAction': 'SaveDeviceModification',
        'bundleId': this.tempoBundle.bundle_id,
        'deviceIndex': this.deviceIndex,
        'deviceData': JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tempoBundle.devices[this.deviceIndex]))
      };

      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        console.log(response.data);
        _this.deviceIsSaving = false;
        if (response.data.Code == 'OK') {
          _this.$store.dispatch('sessionStore/reloadActualBundle');
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    },
    getDeviceListOfLinkedChannels: function getDeviceListOfLinkedChannels() {
      var _this2 = this;

      this.deviceLinkedChannelIsReading = true;
      var requestData = { 'postAction': 'GetDeviceListOfLinkedChannel',
        'bundleId': this.tempoBundle.bundle_id,
        'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId
      };

      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        console.log(response.data);
        _this2.deviceLinkedChannelIsReading = false;
        if (response.data.Code == 'OK') {
          _this2.deviceListOfLinkedChannel = response.data.LinkedChannelList;
        } else {
          window.alert(_this2.messagePostFail[_this2.actualLanguage]);
        }
      });
    },
    confirmRemoveDevice: function confirmRemoveDevice() {
      var _this3 = this;

      window.alert(this.messageRemoveDevice[this.actualLanguage]);
      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tempoBundle.devices[this.deviceIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.deviceIsDeleting = true;
        var requestData = { 'postAction': 'RemoveDeviceFromBundle',
          'deviceIndex': this.deviceIndex,
          'bundleId': this.tempoBundle.bundle_id,
          'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
          'parentContainer': this.parentContainer
        };
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          console.log(response.data);
          _this3.deviceIsDeleting = false;
          if (response.data.Code == 'OK') {
            _this3.$store.dispatch('sessionStore/reloadActualBundle');
            _this3.alertShowAddButton = true;
          } else {
            window.alert(_this3.messagePostFail[_this3.actualLanguage]);
          }
        });
      }
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de module", EN: 'Module sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Device',
        'entityId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
        'entityReferenceName': this.tempoBundle.devices[this.deviceIndex].ReferenceName,
        'displayAlertOptions': false,
        'displayChannelOptions': false,
        'displayDeviceOptions': true,
        'displayBundleOptions': false,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),

  mounted: function mounted() {
    this.locationString = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress;

    this.deviceConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceConfigView');
    this.deviceConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceConfigEdit');
    this.deviceConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceConfigDelete');
    this.deviceSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions, 'deviceSharingEnable');

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigEdit');

    this.displayCloudLiveButton = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.model.includes('CM6');

    var DeviceCreatorOrganization = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId.slice(0, 5);
    this.flagBundleIsDeviceCreatorBundle = this.actualBundle.bundle_id.includes(DeviceCreatorOrganization);

    this.markers = [{
      position: {
        lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
        lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude
      }
    }];
    this.center = { lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
      lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude };

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_configuration_ElectricalPlanDefinition_js__ = __webpack_require__(125);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['deviceIndex'],
  data: function data() {
    return {
      flagDisplayDevice: 0,
      electricalPlanDefinitions: __WEBPACK_IMPORTED_MODULE_4__views_configuration_ElectricalPlanDefinition_js__["a" /* default */],
      elecPlanToAddIndex: 0,

      actualLanguage: "FR",
      flagDisplaySelectPlan: false,
      flagDisplayPlanCfg: 0,

      moduleIndexToCopyPlan: 0,

      monthOptions: [{ text: '01-Jan', value: 1 }, { text: '02-Fév/Feb', value: 2 }, { text: '03-Mar', value: 3 }, { text: '04-Avr/Apr', value: 4 }, { text: '05-Mai/May', value: 5 }, { text: '06-Jui/Jun', value: 6 }, { text: '07-Jui/Jul', value: 7 }, { text: '08-Aoû/Aug', value: 8 }, { text: '09-Sept', value: 9 }, { text: '10-Oct', value: 10 }, { text: '11-Nov', value: 11 }, { text: '12-Déc/Dec', value: 12 }],

      dayOptions: [{ text: 'Lun/Mon', value: 1 }, { text: 'Mar/Tue', value: 2 }, { text: 'Mer/Wed', value: 3 }, { text: 'Jeu/Thu', value: 4 }, { text: 'Ven/Fri', value: 5 }, { text: 'Sam/Sat', value: 6 }, { text: 'Dim/Sun', value: 7 }],

      hourOptions: [{ text: '00:00', value: 0 }, { text: '01:00', value: 1 }, { text: '02:00', value: 2 }, { text: '03:00', value: 3 }, { text: '04:00', value: 4 }, { text: '05:00', value: 5 }, { text: '06:00', value: 6 }, { text: '07:00', value: 7 }, { text: '08:00', value: 8 }, { text: '09:00', value: 9 }, { text: '10:00', value: 10 }, { text: '11:00', value: 11 }, { text: '12:00', value: 12 }, { text: '13:00', value: 13 }, { text: '14:00', value: 14 }, { text: '15:00', value: 15 }, { text: '16:00', value: 16 }, { text: '17:00', value: 17 }, { text: '18:00', value: 18 }, { text: '19:00', value: 19 }, { text: '20:00', value: 20 }, { text: '21:00', value: 21 }, { text: '22:00', value: 22 }, { text: '23:00', value: 23 }, { text: '24:00', value: 24 }],

      labelFieldTitleBillPlan: { FR: 'Plan de tarification électrique', EN: 'Electrical billing plan' },
      labelApplyButtonBillPlan: { FR: 'Appliquer', EN: 'Apply' },
      labelCancelButtonBillPlan: { FR: 'Annuler', EN: 'Cancel' },
      labelSelectPreRecBillPlan: { FR: 'Sélectionner un plan pré-enregistré', EN: 'Select pre-recorded plan' },
      labelSelectPlan: { FR: 'Sélectionner un plan', EN: 'Select plan' },
      labelFieldTitleBasePrice: { FR: 'Tarif de base:', EN: 'Base price:' },
      labelFieldTitleTarif: { FR: 'Tarif ($/kWh)', EN: 'Price ($/kWh)' },
      labelFieldOptionHoraire: { FR: 'Horaire', EN: 'Scheduled' },
      labelFieldOptionTemperature: { FR: 'Température', EN: 'Temperature' },
      labelFieldTitleStartMonth: { FR: 'Mois début', EN: 'Start month' },
      labelFieldTitleEndMonth: { FR: 'Mois fin', EN: 'End month' },
      labelFieldTitleStartDay: { FR: 'Jour début', EN: 'Start day' },
      labelFieldTitleEndDay: { FR: 'Jour fin', EN: 'End day' },
      labelFieldTitleStartHour: { FR: 'Heure début', EN: 'Start hour' },
      labelFieldTitleEndHour: { FR: 'Heure fin', EN: 'End hour' },
      labelFieldOptionUnder: { FR: 'Inférieur à:', EN: 'Under:' },
      labelFieldOptionOver: { FR: 'Supérieur à:', EN: 'Over:' },
      labelFieldTitleTempThld: { FR: 'Température seuil (C)', EN: 'Threshold température (C)' },
      labelFieldButtonDelete: { FR: 'Supprimer cette condition', EN: 'Delete this contition' },

      labelButtonCopyPlanFromModule: { FR: 'Copier le plan du module:', EN: 'Copy plan from module:' },
      labelFieldButtonApplyPlanAllDevice: { FR: 'Appliquer ce plan à tous les modules de ce Système', EN: 'Apply this plan to all module of this Systems' },
      labelFieldButtonAddCond: { FR: 'Ajouter une condition au plan', EN: 'Add billing plan condition' },
      labelField: { FR: '', EN: '' },
      labelFieldButtonSave: { FR: "Sauvegarder les paramètres du module", EN: 'Save module parameters' },

      textLabelPreRecordedPlan: { FR: "Plan pré-enregistré", EN: 'Pre recorded plan' },
      labelCopyPlanFromAnotherModule: { FR: "Copier le plan d'un module du système, sélectionner le module dont vous voulez copier le plan et appuyez sur le bouton.", EN: "Copy plan from another module of the system, select the module that you want to copy it's plan and press the button" },
      labelApplyActualPlanToOtherModule: { FR: "Appliquer ce plan du module actuel aux autres modules du système", EN: "Apply the plan of this module to all other system's modules" },
      messageConfirmApplyPlanToOtherDevice: { FR: "Confirmer l'application de ce plan aux autres Modules de ce Système!", EN: 'Confirm billing plan change for all Module in this Systems!' },
      messageConfirmApplyPlanToOtherDeviceSave: { FR: "Vous devez Sauvegarder les paramètres de chaque module pour officialiser le changement de plan.", EN: 'You must Save the module parameters for each module to confirm plan modifications.' },

      messageConfirmPlanChangeA: { FR: "Confirmer le changement de plan de tarification pour :", EN: 'Confirm billing plan change for : ' },
      messageConfirmPlanChangeB: { FR: ". Cette action est irréversible!", EN: '. This operation is not reversible!' },
      messageMustSaveDevice: { FR: "Vous devez Sauvegarder les paramètres du module pour confirmer l'enregistrement.", EN: 'You must save the module parameters to record modifications.' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle'])),
  watch: {},

  methods: {
    togglePlanDisplay: function togglePlanDisplay() {
      this.flagDisplayPlanCfg = ~this.flagDisplayPlanCfg;
    },
    addPlanLine: function addPlanLine() {
      this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan.push({ type: '0', tempCondition: '0', tempThreshold: -14, startMonth: 1, endMonth: 12, startDay: 1, endDay: 7, startHour: 0, endHour: 24, price: 0.092 });
    },
    removePlanLine: function removePlanLine(index) {
      this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan.splice(index, 1);
    },
    applyThisPlanToAll: function applyThisPlanToAll() {
      var ActualPlan = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan));

      if (window.confirm(this.messageConfirmApplyPlanToOtherDevice[this.actualLanguage])) {
        for (var n = 0; n < this.actualBundle.devices.length; n++) {
          this.actualBundle.devices[n].DeviceData.deviceInfo.pricingPlan = ActualPlan;
        }
        window.alert(this.messageConfirmApplyPlanToOtherDeviceSave[this.actualLanguage]);
      }
    },
    selectPreRecordedPlan: function selectPreRecordedPlan() {
      var _this = this;

      var requestData = { 'postAction': 'GetPreRecordedPlan',
        'planList': 'Electrical_Pricing_Plan::' + "EVSENS" };

      this.$store.dispatch('sessionStore/postElectricalPlan', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.electricalPlanDefinitions = response.data.PlansDefinitions;

          _this.flagDisplaySelectPlan = true;
        }
      });
    },
    addPreRecordedPlan: function addPreRecordedPlan() {
      if (this.elecPlanToAddIndex >= 0) {
        var ActualPlanTitle = this.electricalPlanDefinitions[this.elecPlanToAddIndex].planTitle[this.actualLanguage];

        if (window.confirm(this.messageConfirmPlanChangeA[this.actualLanguage] + ActualPlanTitle + this.messageConfirmPlanChangeB[this.actualLanguage])) {
          this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = this.electricalPlanDefinitions[this.elecPlanToAddIndex].plan;
          window.alert(this.messageMustSaveDevice[this.actualLanguage]);
          this.flagDisplaySelectPlan = false;
        }
      }
    },
    copyPlanFromAnothermodule: function copyPlanFromAnothermodule() {
      this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle.devices[this.moduleIndexToCopyPlan].DeviceData.deviceInfo.pricingPlan));

      window.alert(this.messageMustSaveDevice[this.actualLanguage]);
    }
  },

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configureBundle',
  data: function data() {
    return {

      flagDisplayConfig: 0,
      flagDisplaySharing: 0,
      flagDisplayGroupMembers: 0,

      tempoBundle: {},
      newGroupNameIsSaving: false,
      newBundleIsSaving: false,
      addBundleIsSaving: false,
      addBundleIsSaving2: false,
      groupIsDeleting: false,

      addMySelfToGroup: false,
      addAnotherUserToGroup: false,

      ListOfSharings: [],

      actualLanguage: "FR",
      textLabelGroupID: { FR: 'Identifiant du groupe', EN: 'Group ID' },
      textLabelLinkedOrganization: { FR: 'Organisation', EN: 'Organization' },
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },
      textSectionToAddGroupA: { FR: "Pour ajouter des groupes à votre arborescence (barre de navigation), vous devez revenir en arrière en sélectionnant un groupe  (", EN: 'To add new group to your arborescence, you must go back on group selection (' },
      textSectionToAddGroupB: { FR: ") ou sélectionner la section HOME de la barre du haut pour accéder au menu d'ajouts de groupe de premier niveau.", EN: ') or select HOME on top link menu to access first level group creation menu.' },
      buttonLabelModifyGroupName: { FR: "Modifier le nom du Groupe", EN: 'Modify Group name' },
      buttonLabelDeleteGroup: { FR: "Supprimer ce Groupe", EN: 'Delete this Group' },
      sectionLabelSharing: { FR: "Partages", EN: 'Sharings' },
      textSharingMessage: { FR: "Le partage de groupe est uniquement possible vers des usagers ayant accèes au portail gestionaire.", EN: 'Group sharing is only available with other manager portal users' },
      buttonLabelShareThisGroup: { FR: "Partager le groupe : ", EN: 'Share Group : ' },

      sectionLabelConfig: { FR: "Configuration", EN: 'Configuration' },
      subSectionGroupOptionsConfig: { FR: "Options du groupe", EN: 'Group options' },

      sectionLabelGroupMembers: { FR: "Membres du groupe", EN: 'Group members' },
      textGroupMembersMessage: { FR: "Les membres peuvent recevoir les alertes des systèmes sous ce groupe.", EN: 'Members can receive systems alerts.' },
      groupMembersTableColumnOrganisation: { FR: "Organisation", EN: 'Organization' },
      groupMembersTableColumnName: { FR: "Nom du membre", EN: "Member's name" },
      groupMembersTableColumnEmail: { FR: "Courriel", EN: 'Email' },
      groupMembersTableColumnEmailEnabled: { FR: "Courriel activé", EN: 'Email enabled' },
      groupMembersTableColumnSMSEnabled: { FR: "SMS activé", EN: 'SMS enabled' },
      groupMembersTableColumnRemove: { FR: "Retirer", EN: 'Remove' },
      buttonGroupAddMySelfAsMember: { FR: "M'ajouter comme membre", EN: 'Add myself as member' },
      buttonGroupOtherUserAsMember: { FR: "Ajouter un autre utilisateur", EN: 'Add another user' },

      messageNewSystemNameInGroup: { FR: "Nom de votre nouveau Système à ajouter au Groupe : ", EN: 'New System name in Group :' },
      messageNewSystemNameInGroupTextBox: { FR: "Nom du système", EN: 'System Group name' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messageRemoveConfirmA: { FR: "Confirmer la supression du Groupe : ", EN: 'Confirm Group deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },

      groupConfigViewFlag: false,
      groupConfigEditFlag: false,
      groupConfigDeleteFlag: false,
      groupSharingEnableFlag: false,

      flagActualGroupDefault: true

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a,
    ConfigSharingList: __WEBPACK_IMPORTED_MODULE_5__SubComponent_ConfigSharingList___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualGroup', 'actualBundle', 'navIndex', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    toggleDisplayConfig: function toggleDisplayConfig() {
      this.flagDisplayConfig = ~this.flagDisplayConfig;
    },
    toggleDisplaySharing: function toggleDisplaySharing() {
      this.readGroupSharings();
      this.flagDisplaySharing = ~this.flagDisplaySharing;
    },
    toggleDisplayGroupMembers: function toggleDisplayGroupMembers() {
      this.flagDisplayGroupMembers = ~this.flagDisplayGroupMembers;
    },
    toUsername: function toUsername(email) {
      var email2 = email.replace('.', '-dot-');
      email = email2.replace('.', '-dot-');
      email2 = email.replace('.', '-dot-');
      return email2.replace('@', '-at-');
    },
    saveNewGroupName: function saveNewGroupName() {
      var _this = this;

      if (this.actualLanguage == "FR") {
        var newGroupName = prompt("Nouveau nom de Groupe usagers : ", "Nom du groupe usager");
      } else {
        var newGroupName = prompt("New User Group name", "User Group name");
      }
      if (newGroupName != null) {
        this.newGroupNameIsSaving = true;
        var requestData = { 'postAction': 'SaveNewGroupName',
          'groupId': this.actualGroup.group_id,
          'groupName': newGroupName };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this.newGroupNameIsSaving = false;
            _this.$store.dispatch('sessionStore/getGroupArborescence');
          }
        });
      }
    },
    createNewBundleInGroup: function createNewBundleInGroup() {
      var _this2 = this;

      var newBundleName = prompt(this.messageNewSystemNameInGroup[this.actualLanguage] + this.actualGroup.group_name, this.messageNewSystemNameInGroupTextBox[this.actualLanguage]);

      if (newBundleName != null) {
        this.newBundleIsSaving2 = true;
        var requestData = { 'postAction': 'CreateNewBundleInGroup',
          'bundleName': newBundleName,
          'hostGroup': this.actualGroup.group_id };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          _this2.newBundleIsSaving2 = false;
          if (response.data.Code == 'OK') {
            _this2.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(_this2.messagePostFail[_this2.actualLanguage]);
          }
        });
      }
    },
    deleteGroup: function deleteGroup() {
      var _this3 = this;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.actualGroup.group_name, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.groupIsDeleting = true;
        var hostId = this.navIndex.bundleParentId;

        var requestData = { 'postAction': 'DeleteGroup',
          'groupId': this.actualGroup.group_id,
          'parentContainer': this.parentContainer,
          'hostId': hostId };

        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
            document.location.reload();
            _this3.groupIsDeleting = false;
          } else {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
            _this3.groupIsDeleting = false;
          }
        });
      }
    },
    updateGroupOptions: function updateGroupOptions() {
      var _this4 = this;

      var requestData = { 'postAction': 'UpdateGroupOptions',
        'groupId': this.actualGroup.group_id,
        'groupOptions': this.actualGroup.group_options };
      this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de Groupe Usager", EN: 'User Group sharing' },
        'entityOwner': this.actualGroup.group_id,
        'sharingType': 'Group',
        'entityId': this.actualGroup.group_id,
        'entityReferenceName': this.actualGroup.group_name,
        'displayAlertOptions': false,
        'displayChannelOptions': true,
        'displayDeviceOptions': true,
        'displayBundleOptions': true,
        'displayGroupOptions': true,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    readGroupSharings: function readGroupSharings() {
      var _this5 = this;

      var requestData = { 'postAction': 'GetRuleForEntity', 'EntityToRead': this.actualGroup.group_id };
      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this5.ListOfSharings = response.data.Data;
        } else {
          window.alert(response.data.Message[_this5.actualLanguage]);
        }
      });
    },
    editSharingRulePermissions: function editSharingRulePermissions(sharingIndex) {
      var modalParameters = { 'ruleId': this.ListOfSharings[sharingIndex].ruleId,
        'referenceId': this.ListOfSharings[sharingIndex].referenceId,
        'sharingReferenceName': this.ListOfSharings[sharingIndex].sharingReferenceName,
        'sharingGuessEmail': this.ListOfSharings[sharingIndex].guessEmail
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('edit-access-rules-form');
    },
    saveSharingStatus: function saveSharingStatus(sharingIndex, newStatus) {
      var _this6 = this;

      var requestData = { 'postAction': 'SaveSingleRuleStatus',
        'ruleId': this.ListOfSharings[sharingIndex].ruleId,
        'referenceId': this.ListOfSharings[sharingIndex].referenceId,
        'newStatus': newStatus
      };

      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          window.alert(response.data.Message[_this6.actualLanguage]);
          _this6.readGroupSharings();
        } else {
          window.alert(response.data.Message[_this6.actualLanguage]);
        }
      });
    },
    deleteSharing: function deleteSharing(sharingIndex) {
      var _this7 = this;

      if (this.actualLanguage == "FR") {
        var confirmation = prompt("Supprimer le partage : " + this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirmer en écrivant : DELETE");
      } else {
        var confirmation = prompt("Delete the sharing : " + this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirm by writing : DELETE");
      }
      if (confirmation == 'DELETE') {
        var requestData = { 'postAction': 'DeleteSingleRule',
          'ruleId': this.ListOfSharings[sharingIndex].ruleId,
          'referenceId': this.ListOfSharings[sharingIndex].referenceId
        };

        this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(response.data.Message[_this7.actualLanguage]);
            _this7.readGroupSharings();
          } else {
            window.alert(response.data.Message[_this7.actualLanguage]);
          }
        });
      }
    },
    addMySelfAsMember: function addMySelfAsMember() {
      var _this8 = this;

      this.addMySelfToGroup = true;

      var requestData = { 'postAction': 'AddActualUserToGroupMember',
        'groupId': this.actualGroup.group_id };
      this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
        _this8.addMySelfToGroup = false;
        if (response.data.Code == 'OK') {
          window.alert(response.data.PromptMessage[_this8.actualLanguage]);
          _this8.$store.dispatch('sessionStore/getGroupArborescence');
        } else {
          window.alert(response.data.PromptMessage[_this8.actualLanguage]);
        }
      });
    },
    addOtherProfileAsMember: function addOtherProfileAsMember() {
      var _this9 = this;

      if (this.actualLanguage == "FR") {
        var newMemberEmail = prompt("Courriel de l'usager a ajouter comme membre : ", "@");
      } else {
        var newMemberEmail = prompt("Email of the user to add as member", "@");
      }
      if (newMemberEmail != null) {
        this.addAnotherUserToGroup = true;
        var requestData = { 'postAction': 'AddGuessUserToGroupMember',
          'groupId': this.actualGroup.group_id,
          'guessProfileId': this.toUsername(newMemberEmail) };
        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          _this9.addAnotherUserToGroup = false;
          if (response.data.Code == 'OK') {
            window.alert(response.data.PromptMessage[_this9.actualLanguage]);
            _this9.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this9.actualLanguage]);
          }
        });
      }
    },
    updateGroupMemberOptions: function updateGroupMemberOptions(index) {
      var _this10 = this;

      var requestData = { 'postAction': 'ModifyGroupMemberOptions',
        'groupId': this.actualGroup.group_id,
        'profileId': this.toUsername(this.actualGroup.group_members[index].email),
        'memberOptions': this.actualGroup.group_members[index].memberOptions };

      this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          window.alert(response.data.PromptMessage[_this10.actualLanguage]);
          _this10.$store.dispatch('sessionStore/getGroupArborescence');
        } else {
          window.alert(response.data.PromptMessage[_this10.actualLanguage]);
        }
      });
    },
    deleteGroupMember: function deleteGroupMember(index) {
      var _this11 = this;

      if (this.actualLanguage == "FR") {
        var confirmation = prompt("Retirer le membre : " + this.actualGroup.group_members[index].email, "Confirmer en écrivant : DELETE");
      } else {
        var confirmation = prompt("Remove member : " + this.actualGroup.group_members[index].email, "Confirm by writing : DELETE");
      }
      if (confirmation == 'DELETE') {
        var requestData = { 'postAction': 'RemoveGroupMember',
          'groupId': this.actualGroup.group_id,
          'profileIdToRemove': this.toUsername(this.actualGroup.group_members[index].email)
        };

        this.$store.dispatch('sessionStore/postGroup', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(response.data.PromptMessage[_this11.actualLanguage]);
            _this11.$store.dispatch('sessionStore/getGroupArborescence');
          } else {
            window.alert(response.data.PromptMessage[_this11.actualLanguage]);
          }
        });
      }
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),
  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }


    this.groupConfigViewFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupConfigView');
    this.groupConfigEditFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupConfigEdit');
    this.groupConfigDeleteFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupConfigDelete');
    this.groupSharingEnableFlag = this.findPermissionItemValue(this.actualGroup.permissions.group, 'groupSharingEnable');

    this.flagActualGroupDefault = this.actualGroup.group_id.includes('DefaultGroup');

    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_configuration_SystemsList__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_configuration_SystemsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_configuration_SystemsList__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['subBundleIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a,
    SystemsList: __WEBPACK_IMPORTED_MODULE_5__views_configuration_SystemsList___default.a
  },
  data: function data() {
    return {
      tempoBundle: {},
      flagDisplaySubBundle: 0,

      subBundleIsSaving: false,
      subBundleIsDeleting: false,
      showSystemsList: false,

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },

      bundleConfigViewFlag: false,
      bundleConfigEditFlag: false,
      bundleConfigDeleteFlag: false,
      bundleSharingEnableFlag: false,

      textLabelReferenceName: { FR: "Nom de référence", EN: 'Referencen name' },
      sectionTitleDisplayMA: { FR: "Option affichage de moyenne mobile du sous-système", EN: 'Display option for sub-system moving average' },
      buttonLabelMA_Option: { FR: "Calculer la somme des appareils et sous-systèmes.", EN: 'Compute the device and sub-system summation' },
      sectionLabelSubSystemTag: { FR: "Étiquettes du sous-système", EN: 'Sub-system tags' },
      labelSectionSubSystemConfiguration: { FR: "Configuration du Sous-Système", EN: 'Sub-System configuration' },
      textLabelSubSystemName: { FR: "Nom du System", EN: 'System name' },
      buttonDeleteSystem: { FR: "Supprimer ce Sous-Système", EN: 'Delete this Sub-System' },
      buttonSaveThisSubSystem: { FR: "Enregistrer les paramètres du Sous-Système", EN: 'Save Sub-System parameters' },
      subBundleSaveMessage: { FR: "Attention, si le nom de référence a été modifié, il est possible que la position dans la liste soit modifiée!",
        EN: "Attention, if the reference name changed, it is possible that the system position in the list change!" },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messageRemoveConfirmA: { FR: "Confirmer la supression du Sous-Système : ", EN: 'Confirm Sub-System deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      this.reloadTempoBundle();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplaySubBundle: function toggleDisplaySubBundle() {
      this.flagDisplaySubBundle = ~this.flagDisplaySubBundle;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    onSystemSelect: function onSystemSelect(a) {
      this.showSystemsList = false;

      this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.bundle_icon = a.iconFile;
    },
    saveSubBundleModifications: function saveSubBundleModifications() {
      var _this = this;

      this.subBundleIsSaving = true;
      var requestData = { 'postAction': 'SaveSubBundleModification',
        'parentContainer': this.parentContainer,
        'bundleId': this.tempoBundle.bundle_id,
        'subBundleIndex': this.tempoBundle.sub_bundle[this.subBundleIndex].SubBundleBundleIndex,
        'subBundleItem': this.tempoBundle.sub_bundle[this.subBundleIndex]
      };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        _this.subBundleIsSaving = false;
        if (response.data.Code == 'OK') {
          window.alert(_this.subBundleSaveMessage[_this.actualLanguage]);
          _this.$store.dispatch('sessionStore/reloadActualBundle');
          _this.$store.dispatch('sessionStore/getGroupArborescence');
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    },
    confirmRemoveSubBundle: function confirmRemoveSubBundle() {
      var _this2 = this;

      var FlagProcessToDelete = false;
      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tempoBundle.sub_bundle[this.subBundleIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        this.subBundleIsDeleting = true;
        var requestData = { 'postAction': 'RemoveSubBundleFromBundle',
          'parentContainer': this.parentContainer,
          'bundleId': this.tempoBundle.bundle_id,
          'subBundleIndex': this.tempoBundle.sub_bundle[this.subBundleIndex].SubBundleBundleIndex,
          'subBundleItem': this.tempoBundle.sub_bundle[this.subBundleIndex]
        };
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          _this2.subBundleIsDeleting = false;
          if (response.data.Code == 'OK') {
            _this2.$store.dispatch('sessionStore/reloadActualBundle');
          } else {
            window.alert(response.data.PromptMessage[_this2.actualLanguage]);
          }
        });
      }
    },
    shareEntity: function shareEntity() {
      var modalParameters = { 'modalTitle': { FR: "Partage de sous Systèmes", EN: 'Sub systems sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Bundle',
        'entityId': this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.bundle_id,
        'entityReferenceName': this.tempoBundle.sub_bundle[this.subBundleIndex].ReferenceName,
        'displayAlertOptions': true,
        'displayChannelOptions': true,
        'displayDeviceOptions': true,
        'displayBundleOptions': true,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),

  mounted: function mounted() {
    this.bundleConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle, 'bundleConfigView');

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle, 'bundleConfigEdit');

    this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle, 'bundleConfigDelete');

    this.bundleSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.permissions.bundle, 'bundleSharingEnable');

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
  }
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfigGroup__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfigGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConfigGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfigBundle__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfigBundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfigBundle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigSubBundle__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfigSubBundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfigSubBundle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfigDevice__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfigDevice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ConfigDevice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConfigDeviceApiDevV1p00__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConfigDeviceApiDevV1p00___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ConfigDeviceApiDevV1p00__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfigChannelList__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfigChannelList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ConfigChannelList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_configuration_AddDeviceForm__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_configuration_AddDeviceForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_configuration_AddDeviceForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ConfigAlert__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ConfigAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ConfigAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfigCar__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfigCar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ConfigCar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SubComponent_ConfigSharingList__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SubComponent_ConfigSharingList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SubComponent_ConfigSharingList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConfigCustomDashboardV1p00__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConfigCustomDashboardV1p00___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ConfigCustomDashboardV1p00__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'configuration',
  data: function data() {
    return {
      actualLanguage: "FR",
      channelIsCreating: false,
      carIsCreating: false,
      labelTopPage: { FR: 'Configuration', EN: 'Configuration' },
      labelButtonAddDevice: { FR: 'Ajouter un module', EN: 'Add module' },
      labelButtonAddChannel: { FR: 'Ajouter un appareil', EN: 'Add device' },
      labelButtonAddCar: { FR: 'Ajouter un véhicule / borne', EN: 'Add vehicle / EVSE' },
      tabMenuSelector: [],
      stringBidon: '',
      displayChannelList: true,
      flagDisplaySharing: 0,
      ListOfSharings: [],
      test: 1,

      actualBundleIsDefaultBundle: true,
      bundleConfigViewFlag: false,
      bundleConfigEditFlag: false,
      bundleConfigDeleteFlag: false,
      bundleSharingEnableFlag: false,
      deviceConfigEditFlag: false,
      flagConfigCustomDashboard: false,

      sectionLabelSharing: { FR: "Partages", EN: 'Sharings' },
      buttonLabelShareMyDefaultBundle: { FR: "Partager les informations de mon système", EN: 'Share my system informations' },
      buttonLabelRefreshListSharing: { FR: "Rafraichir la liste de partages", EN: 'Refresh list of sharings' },
      textSharingDetail: { FR: "Les composantes (module, appareils et VE) sont partageables individuellement en utilisant l'icône partage de leur menu de configuration respectif. Suite a une transmission de partage, ceux-ci sont accessibles à partir du tableau affiché dans ce menu.", EN: 'Individual component sharing (module, device and EV) can be done by using the sharing icon button in respective component menu. Afterwards, sharing are acessible in the table displayed in this section.' },
      tableLabelReferenceName: { FR: "Nom de référence", EN: 'Reference name' },
      tableLabelSharingName: { FR: "Identifiant de partage", EN: 'Sharing identifier' },
      tableLabelRecipient: { FR: "Destinataire", EN: 'Recipient' },
      tableLabelStatus: { FR: "Statut", EN: 'Status' },
      tableStatusLabelActivated: { FR: "Activé", EN: 'Activated' },
      tableStatusLabelRejected: { FR: "Refusé", EN: 'Rejected' },
      tableStatusLabelWaiting: { FR: "Attente", EN: 'Pending' },
      tableStatusLabelPause: { FR: "Pause", EN: 'Standbye' },
      tabLabelGroup: { FR: "Groupe", EN: 'Group' },
      tabLabelSystem: { FR: "Système", EN: 'System' },
      tabLabelSubSystem: { FR: "Sous-Systèmes", EN: 'Sub-Systems' },
      tabLabelModule: { FR: "Module de mesure", EN: 'Monitoring module' },
      tabLabelDevice: { FR: "Appareils mesurés", EN: 'Monitored devices' },
      tabLabelAlert: { FR: "Alertes avancées", EN: 'Advance Alerts' },
      tabLabelEV: { FR: "VE/Bornes", EN: 'EV/EVSE' },
      tabLabelCustomDashboard: { FR: "Mon Dashboard", EN: 'My Dashboard' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messageMaxDeviceLimit: { FR: "Vous avez atteint le nombre maximale de canaux, vous devez choisir un plan de service plus élevé.", EN: 'You reach the maximum channels count, you need to upgrade your service plan.' },
      messagePromptChannelReferenceName: { FR: "Nom de référence pour cet appareil", EN: 'Reference name for this device' },
      messagePromptChannelReferenceNameTextBox: { FR: "Nom d'appareil", EN: 'Device name' },
      messageMaxEVLimit: { FR: "Vous devez avoir un module de mesure enregistré pour créer un VE ou une borne.",
        EN: 'You must have a registered measuring module to create an EV or a charging station.' },
      messagePromptEvReferenceName: { FR: "Nom de référence pour ce VE (ou Borne)", EN: 'Reference name for this EV (or EVSE)' },
      messagePromptEVReferenceNameTextBox: { FR: "Nom de VE", EN: 'EV name' },
      messagePromptConfirmRemoveSharing: { FR: "Vous désirez effacer ce partage?", EN: 'You want to delete this sharing?' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a,
    ConfigGroup: __WEBPACK_IMPORTED_MODULE_3__ConfigGroup___default.a,
    ConfigBundle: __WEBPACK_IMPORTED_MODULE_4__ConfigBundle___default.a,
    ConfigSubBundle: __WEBPACK_IMPORTED_MODULE_5__ConfigSubBundle___default.a,
    ConfigDevice: __WEBPACK_IMPORTED_MODULE_6__ConfigDevice___default.a,
    ConfigDeviceApiDevV1p00: __WEBPACK_IMPORTED_MODULE_7__ConfigDeviceApiDevV1p00___default.a,
    ConfigChannelList: __WEBPACK_IMPORTED_MODULE_8__ConfigChannelList___default.a,
    AddDeviceForm: __WEBPACK_IMPORTED_MODULE_9__views_configuration_AddDeviceForm___default.a,
    ConfigAlert: __WEBPACK_IMPORTED_MODULE_10__ConfigAlert___default.a,
    ConfigCar: __WEBPACK_IMPORTED_MODULE_11__ConfigCar___default.a,
    ConfigSharingList: __WEBPACK_IMPORTED_MODULE_12__SubComponent_ConfigSharingList___default.a,
    ConfigCustomDashboard: __WEBPACK_IMPORTED_MODULE_13__ConfigCustomDashboardV1p00___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'dashboardFlags', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleTabMenuSelector: function toggleTabMenuSelector(index) {
      for (var n = 0; n < this.tabMenuSelector.length; n++) {
        this.tabMenuSelector[n] = false;
      }
      this.tabMenuSelector[index] = true;
      localStorage.actualConfigTab = index;

      this.test = index;
    },
    toggleDisplaySharing: function toggleDisplaySharing() {
      this.readGroupSharings();
      this.flagDisplaySharing = ~this.flagDisplaySharing;
    },
    addChannelToBundle: function addChannelToBundle() {
      var _this = this;

      var channelReferenceName = prompt(this.messagePromptChannelReferenceName[this.actualLanguage], this.messagePromptChannelReferenceNameTextBox[this.actualLanguage]);

      if (channelReferenceName != null) {
        this.channelIsCreating = true;
        var requestData = { 'postAction': 'AddNewChannel',
          'referenceName': channelReferenceName,
          'bundleData': { 'bundleId': this.actualBundle.bundle_id }
        };
        this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
          _this.channelIsCreating = false;

          if (response.data.Code == 'OK') {
            _this.displayChannelList = false;

            _this.reloadActualBundle();
            _this.alertShowAddButton = true;
            _this.displayChannelList = true;
          } else {
            window.alert(response.data.PromptMessage[_this.actualLanguage]);
          }
        });
      }
    },
    reloadActualBundle: function reloadActualBundle() {
      var _this2 = this;

      var requestData = { 'postAction': 'ReadBundleData',
        'bundleId': this.actualBundle.bundle_id };
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          var bundleTempo = response.data.BundleData;
          _this2.$store.dispatch('sessionStore/setActualBundle', bundleTempo);
        } else {
          window.alert(_this2.messagePostFail[_this2.actualLanguage]);
        }
      });
    },
    addCarToBundle: function addCarToBundle() {
      var _this3 = this;

      if (parseInt(this.actualBundle.devices.length * 6) <= parseInt(this.actualBundle.cars.length)) {
        window.alert(this.messageMaxEVLimit[this.actualLanguage]);
      } else {
        var carReferenceName = prompt(this.messagePromptEvReferenceName[this.actualLanguage], this.messagePromptEVReferenceNameTextBox[this.actualLanguage]);

        if (carReferenceName != null) {
          this.carIsCreating = true;
          var requestData = { 'postAction': 'AddNewCar',
            'referenceName': carReferenceName,
            'bundleData': { 'bundleId': this.actualBundle.bundle_id }
          };
          this.$store.dispatch('sessionStore/postCar', requestData).then(function (response) {
            _this3.carIsCreating = false;

            if (response.data.Code == 'OK') {
              _this3.$store.dispatch('sessionStore/reloadActualBundle');
              _this3.alertShowAddButton = true;
            } else {
              window.alert(_this3.messagePostFail[_this3.actualLanguage]);
            }
          });
        }
      }
    },
    shareMyDefaultBundle: function shareMyDefaultBundle() {
      var modalParameters = { 'modalTitle': { FR: "Partage de mon système", EN: 'My System sharing' },
        'entityOwner': this.actualBundle.bundle_id,
        'sharingType': 'Bundle',
        'entityId': this.actualBundle.bundle_id,
        'entityReferenceName': this.actualBundle.bundle_name,
        'displayAlertOptions': false,
        'displayChannelOptions': true,
        'displayDeviceOptions': true,
        'displayBundleOptions': true,
        'displayGroupOptions': false,
        'displayUserOptions': false };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('config-access-rules-form');
    },
    readGroupSharings: function readGroupSharings() {
      var _this4 = this;

      var requestData = { 'postAction': 'GetRuleForEntity', 'EntityToRead': this.actualBundle.bundle_id };

      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this4.ListOfSharings = response.data.Data;
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    editSharingRulePermissions: function editSharingRulePermissions(sharingIndex) {
      var modalParameters = { 'ruleId': this.ListOfSharings[sharingIndex].ruleId,
        'referenceId': this.ListOfSharings[sharingIndex].referenceId,
        'sharingReferenceName': this.ListOfSharings[sharingIndex].sharingReferenceName,
        'sharingGuessEmail': this.ListOfSharings[sharingIndex].guessEmail
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('edit-access-rules-form');
    },
    saveSharingStatus: function saveSharingStatus(sharingIndex, newStatus) {
      var _this5 = this;

      var requestData = { 'postAction': 'SaveSingleRuleStatus',
        'ruleId': this.ListOfSharings[sharingIndex].ruleId,
        'referenceId': this.ListOfSharings[sharingIndex].referenceId,
        'newStatus': newStatus
      };

      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          window.alert(response.data.PromptMessage[_this5.actualLanguage]);
          _this5.readGroupSharings();
        } else {
          window.alert(response.data.PromptMessage[_this5.actualLanguage]);
        }
      });
    },
    deleteSharing: function deleteSharing(sharingIndex, newStatus) {
      var _this6 = this;

      if (confirm(this.messagePromptConfirmRemoveSharing[this.actualLanguage])) {
        var requestData = { 'postAction': 'DeleteSingleRule',
          'ruleId': this.ListOfSharings[sharingIndex].ruleId,
          'referenceId': this.ListOfSharings[sharingIndex].referenceId,
          'newStatus': newStatus
        };

        this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(response.data.PromptMessage[_this6.actualLanguage]);
            _this6.readGroupSharings();
          } else {
            window.alert(response.data.PromptMessage[_this6.actualLanguage]);
          }
        });
      }
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),
  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.tabMenuSelector = [true, false, false, false, false, false];

    this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle');
    this.actualBundleIsDefaultBundle = this.actualBundleIsDefaultBundle & this.actualBundle.bundle_id.includes(this.profileData.profileId);

    this.bundleConfigViewFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigView');
    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigEdit');
    this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigDelete');
    this.bundleSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleSharingEnable');
    this.deviceConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.device, 'deviceConfigEdit');

    if (localStorage.actualConfigTab) {
      this.toggleTabMenuSelector(localStorage.actualConfigTab);
    } else {
      this.toggleTabMenuSelector(4);
    }

    if (this.actualBundle.bundle_id.includes(':DefaultBundle')) {
      this.toggleTabMenuSelector(3);
    }

    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['sharingListData'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      actualLanguage: "FR",
      flagDisplaySharing: 0,

      ListOfSharings: [],

      bundleConfigViewFlag: false,
      bundleConfigEditFlag: false,
      bundleConfigDeleteFlag: false,
      bundleSharingEnableFlag: false,

      blocLabelSharingList: { FR: "Liste des partages", EN: 'Sharings list' },
      tableTitleType: { FR: "Type", EN: 'Type' },
      tableTitleReferenceName: { FR: "Nom de référence", EN: 'Reference name' },
      tableTitleSharingName: { FR: "Nom du partage", EN: 'Sharing name' },
      tableTitleRecipient: { FR: "Destinataire", EN: 'Recipient' },
      tableTitleStatus: { FR: "Statut", EN: 'Status' },
      tableTitleAction: { FR: "Action", EN: 'Action' },
      tableStatusActivated: { FR: "Activé", EN: 'Activated' },
      tableStatusRejected: { FR: "Refusé", EN: 'Rejected' },
      tableStatusOnHold: { FR: "Attente", EN: 'On hold' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'groupArborescence', 'actualGroup', 'actualBundle'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplaySharing: function toggleDisplaySharing() {
      this.readGroupSharings();
      this.flagDisplaySharing = ~this.flagDisplaySharing;
    },
    readGroupSharings: function readGroupSharings() {
      var _this = this;

      if (this.sharingListData.sharingType == 'Group') {
        var requestData = { 'postAction': 'GetRuleForEntity', 'EntityToRead': this.actualGroup.group_id };
      } else {
        var requestData = { 'postAction': 'GetRuleForEntity', 'EntityToRead': this.actualBundle.bundle_id };
      }

      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.ListOfSharings = response.data.Data;
        } else {
          window.alert(response.data.Message[_this.actualLanguage]);
        }
      });
    },
    editSharingRulePermissions: function editSharingRulePermissions(sharingIndex) {
      var modalParameters = { 'ruleId': this.ListOfSharings[sharingIndex].ruleId,
        'referenceId': this.ListOfSharings[sharingIndex].referenceId,
        'sharingReferenceName': this.ListOfSharings[sharingIndex].sharingReferenceName,
        'sharingGuessEmail': this.ListOfSharings[sharingIndex].guessEmail
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('edit-access-rules-form');
    },
    saveSharingStatus: function saveSharingStatus(sharingIndex, newStatus) {
      var _this2 = this;

      var requestData = { 'postAction': 'SaveSingleRuleStatus',
        'ruleId': this.ListOfSharings[sharingIndex].ruleId,
        'referenceId': this.ListOfSharings[sharingIndex].referenceId,
        'newStatus': newStatus
      };

      this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          window.alert(response.data.Message[_this2.actualLanguage]);
          _this2.readGroupSharings();
        } else {
          window.alert(response.data.Message[_this2.actualLanguage]);
        }
      });
    },
    deleteSharing: function deleteSharing(sharingIndex) {
      var _this3 = this;

      if (this.actualLanguage == "FR") {
        var confirmation = prompt("Supprimer le partage : " + this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirmer en écrivant : DELETE");
      } else {
        var confirmation = prompt("Delete the sharing : " + this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirm by writing : DELETE");
      }
      if (confirmation == 'DELETE') {
        var requestData = { 'postAction': 'DeleteSingleRule',
          'ruleId': this.ListOfSharings[sharingIndex].ruleId,
          'referenceId': this.ListOfSharings[sharingIndex].referenceId
        };

        this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
            _this3.readGroupSharings();
          } else {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
          }
        });
      }
    },
    findPermissionItemValue: function findPermissionItemValue(permissionList, idToFind) {
      var value = false;
      for (var n = 0; n < permissionList.length; n++) {
        if (permissionList[n].id == idToFind) {
          value = permissionList[n].value;
        }
      }
      return value;
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    if (this.sharingListData.sharingType == 'Group') {
      this.bundleConfigViewFlag = true;
      this.bundleConfigEditFlag = true;
      this.bundleConfigDeleteFlag = true;
      this.bundleSharingEnableFlag = true;
    } else {
      this.bundleConfigViewFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigView');
      this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigEdit');
      this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleConfigDelete');
      this.bundleSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle, 'bundleSharingEnable');
    }
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SystemsList',
  data: function data() {
    return {};
  },

  methods: {
    selectItem: function selectItem(system) {
      this.$emit('onSelect', system);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('appliancesStore', ['systemsList'])),
  mounted: function mounted() {}
});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitType',

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,

      actualLanguage: "FR",
      labelTitleBanner: { FR: "Configurateur des messages de comparaison", EN: 'Comparison message configurator' },

      labelAddTitle: { FR: "Ajouter une liste de message à votre organisation", EN: 'Add a message list to your organization' },

      labelExplanation: { FR: "Les messages de comparaison sont ajouté au rapport de consommation pour féliciter ou soliciter l'attention des consomateurs. Il est possible de créer des messages selon le niveau d'écart par rapport à la moyenne de consommation des consomateurs de même type d'unité.",
        EN: 'The creation of a unit type makes it possible to compare the consumption of services between units of the same type. You can create a custom list for your organization.' },

      labelExplanation1: { FR: "Il est possible de créer plusieurs liste de message afin de lier les unités a une liste en particulier.",
        EN: 'It is possible to create several message lists in order to link the units to a particular list.' },

      labelExplanation2: { FR: "Une liste contient une série de condition (plage de comparaison) pour lesquelles on indique un niveau inférieur et supérieur d'écart et le message lié a cette plage.",
        EN: 'A list contains a series of conditions (comparison range) for which a lower and upper level of difference is indicated and the message linked to this range.' },

      labelExplanation3: { FR: "Il est important de définir les plages dans un ordre croissant de plages, Exemple : -100 à -50, -50 à -25, -25 à 25... Il faut aussi s'assurer de couvrir la plage 0% puisque celle-ci correspond au cas ou la consommation est égale à la moyenne des autres unités de même type.",
        EN: 'It is important to define the ranges in increasing order of ranges, Example: -100 to -50, -50 to -25, -25 to 25... You must also make sure to cover the 0% range since this corresponds to the case where consumption is equal to the average of other units of the same type.' },

      labelListName: { FR: "Nom de la liste", EN: 'List name' },
      labelListDescription: { FR: "Description de la liste", EN: 'List description' },
      listName: '',
      listDescription: '',
      listList: [],
      listIsSaving: false,

      labellistListTitle: { FR: "Liste de messages", EN: 'Message list' },

      messageListOpenFlag: [],
      flagDisplaySectionMessageList: 1,

      labelButtonAddList: { FR: "Ajouter la liste", EN: 'Add this list' },

      labelRangeStart: { FR: "Début plage", EN: 'Range start' },
      labelRangeEnd: { FR: "Fin plage", EN: 'Range end' },
      labelRangeMessage: { FR: "Message", EN: 'Message' },

      labelButtonSaveModifications: { FR: 'Enregistrer modifications', EN: 'Save modifications' },
      labelButtonAddLine: { FR: 'Ajouter une ligne de condition', EN: 'Add conditional line' },
      labelButtonDeleteThisList: { FR: 'Supprimer cette liste', EN: 'Delete this list' },

      messageRemoveConfirmA: { FR: "Confirmer la supression de la liste: ", EN: 'Confirm list deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },

      messageErrorWithCondition: { FR: "Erreur de fin de plage a la ligne: ", EN: 'Error with range end at line : ' },
      messageErrorWithCondition2: { FR: "Erreur de début-fin de plage a la ligne: ", EN: 'Error with range start-end at line : ' },
      messageErrorNotSaving: { FR: "Les modifications ne sont pas enregistrées.", EN: 'Modifications are not saved.' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
      this.getMessageListList();
    },
    addMessageList: function addMessageList() {
      var _this = this;

      this.listIsSaving = true;
      var requestData = { 'postAction': 'AddMessageList',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'listName': this.listName,
        'language': this.actualLanguage,
        'listDescription': this.listDescription };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        _this.listIsSaving = false;
        if (response.data.Code == 'OK') {
          _this.listName = '';
          _this.listDescription = '';
          _this.listList = response.data.MessageListList;
          _this.buildMessageListOpenFlag();
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    getMessageListList: function getMessageListList() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetMessageList',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.listList = response.data.MessageList;
          _this2.buildMessageListOpenFlag();
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    saveMessageListModifications: function saveMessageListModifications(index) {
      var _this3 = this;

      var conditionOrderOk = true;

      for (var m = 0; m < this.listList[index].compareLevelList.length - 1; m++) {
        if (parseFloat(this.listList[index].compareLevelList[m].rangeEnd) != parseFloat(this.listList[index].compareLevelList[m + 1].rangeStart)) {
          conditionOrderOk = false;
          window.alert(this.messageErrorWithCondition[this.actualLanguage] + parseInt(m + 1));
        }
      }

      for (var n = 0; n < this.listList[index].compareLevelList.length; n++) {
        if (parseFloat(this.listList[index].compareLevelList[n].rangeEnd) < parseFloat(this.listList[index].compareLevelList[n].rangeStart)) {
          conditionOrderOk = false;
          window.alert(this.messageErrorWithCondition2[this.actualLanguage] + parseInt(n + 1));
        }
      }

      if (conditionOrderOk) {
        var requestData = { 'postAction': 'SaveMessageListModifications',
          'bundleId': this.actualBundle.bundle_id,
          'parentContainer': this.parentContainer,
          'messageListData': this.listList[index] };

        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this3.listList = response.data.MessageList;
          } else {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
          }
        });
      } else {
        window.alert(this.messageErrorNotSaving[this.actualLanguage]);
      }
    },
    deleteMessageList: function deleteMessageList(index) {
      var _this4 = this;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.listList[index].referenceName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        var requestData = { 'postAction': 'DeleteMessageList',
          'bundleId': this.actualBundle.bundle_id,
          'parentContainer': this.parentContainer,
          'messageListData': this.listList[index] };

        this.flagDisplaySectionMessageList = false;
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          _this4.buildMessageListOpenFlag();
          _this4.flagDisplaySectionMessageList = true;
          if (response.data.Code == 'OK') {
            _this4.listList = response.data.MessageList;
          } else {
            window.alert(response.data.PromptMessage[_this4.actualLanguage]);
          }
        });
      }
    },
    toggleDisplayMessageList: function toggleDisplayMessageList(index) {
      this.flagDisplaySectionMessageList = 0;
      this.messageListOpenFlag[index] = ~this.messageListOpenFlag[index];
      this.flagDisplaySectionMessageList = -1;
    },
    buildMessageListOpenFlag: function buildMessageListOpenFlag() {
      this.messageListOpenFlag = [];
      for (var m = 0; m < this.listList.length; m++) {
        this.messageListOpenFlag.push(0);
      }
    },
    deleteMessageLine: function deleteMessageLine(index, index2) {
      this.listList[index].compareLevelList.splice(index2, 1);
    },
    addMessageLine: function addMessageLine(index) {
      this.listList[index].compareLevelList.push({ 'rangeStart': '-10', 'rangeEnd': '10', 'message': 'Message' });
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitTag',

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,

      actualLanguage: "FR",
      labelTitleBanner: { FR: "Configurateur des étiquette d'unité", EN: 'Unit tag configurator' },

      labelAddTitle: { FR: "Ajout de d'étiquette d'unité à votre organisation", EN: 'Adding a unit tag to your organization' },
      labelExplanation: { FR: "La création de d'étiquette d'unité permet de comparer les consommations de services entre les unités de même type. Vous pouvez créer une liste personalisée pour votre organisation.",
        EN: 'The creation of a unit tags makes it possible to compare the consumption of services between units of the same type. You can create a custom list for your organization.' },

      labelTagName: { FR: "Nom de l'étiquette d'unité", EN: 'Unit tag name' },
      labelTagDescription: { FR: "Description du l'étiquette d'unité", EN: 'Unit tag description' },
      tagName: '',
      tagDescription: '',
      tagList: [],
      tagIsSaving: false,
      labelButtonAddUnitTag: { FR: "Ajouter l'étiquette", EN: 'Add this tag' },

      labelTagListTitle: { FR: "Liste des étiquette", EN: 'Tags list' },

      tableTagColumnTitle01: { FR: "Nom de l'étiquette", EN: "Tag name" },
      tableTagColumnTitle02: { FR: "Description", EN: "Description" },
      tableTagColumnTitle03: { FR: "Supprimer", EN: "Delete" },

      messageRemoveConfirmA: { FR: "Confirmer la supression de l'étiquette: ", EN: 'Confirm tag deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
      this.getUnitTags();
    },
    addUnitTag: function addUnitTag() {
      var _this = this;

      this.tagIsSaving = true;
      var requestData = { 'postAction': 'AddUnitTag',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'tagName': this.tagName,
        'tagDescription': this.tagDescription };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        _this.tagIsSaving = false;
        if (response.data.Code == 'OK') {
          _this.tagName = '';
          _this.tagDescription = '';
          _this.tagList = response.data.UnitTagsList;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    getUnitTags: function getUnitTags() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetUnitTags',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.tagList = response.data.UnitTagsList;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    deleteUnitTag: function deleteUnitTag(index) {
      var _this3 = this;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.tagList[index].tagName, this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        var requestData = { 'postAction': 'DeleteUnitTag',
          'bundleId': this.actualBundle.bundle_id,
          'parentContainer': this.parentContainer,
          'tagId': this.tagList[index].tagId };

        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this3.tagList = response.data.UnitTagsList;
          } else {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
          }
        });
      }
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GraphApexTimeline',
  props: ['GraphData'],

  data: function data() {
    return {
      actualLanguage: "FR",
      sectionTitle: this.GraphData.ChartTitle,
      flagDisplayNewGraph: true,

      chartDataSeries: this.GraphData.YData,

      chartOptions: {
        chart: {
          id: 'vuechart-example',
          stacked: this.GraphData.Options.Stacked,
          stackType: this.GraphData.Options.StackType
        },
        xaxis: {
          categories: this.GraphData.XData
        }
      }
    };
  },


  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GraphApexTimeline',
  props: ['GraphData'],

  data: function data() {
    return {
      actualLanguage: "FR",
      sectionTitle: this.GraphData.ChartTitle,
      flagDisplayNewGraph: true,

      pieChartDataSeries: this.GraphData.Data,
      pieChartOptions: {
        chart: {
          type: 'pie'
        },
        pie: {
          expandOnClick: true,
          customScale: 0.4
        },
        dataLabels: {
          enabled: true,
          style: { fontSize: '16px' }
        },
        labels: this.GraphData.Labels
      }

    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_3_vue_apexcharts___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GraphApexTimeline',
  props: ['GraphData'],

  data: function data() {
    return {
      actualLanguage: "FR",
      sectionTitle: { FR: 'Titre du graphique', EN: 'Graph title' },
      flagDisplayNewGraph: true,

      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54], [1326236400000, 43], [1326236405000, 43], [1326236406000, 53], [1326236406500, 63]]
      }, {
        name: 'TBD',
        data: [[1324508400000, 25], [1324594800000, 32], [1326236400000, 24], [1326236405000, 36], [1326236406000, 43], [1326236406500, 62]]
      }],

      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        tooltip: {
          x: { format: 'dd MMM hh:mm' }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          }
        },
        xaxis: {
          type: 'datetime'
        }
      }

    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainServiceDisplay__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainServiceDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainServiceDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnitDisplay__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnitDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UnitDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnitDisplayStats__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnitDisplayStats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UnitDisplayStats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompUnitTagsDisplay__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompUnitTagsDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CompUnitTagsDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CompCompareLevelMessageDisplay__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CompCompareLevelMessageDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CompCompareLevelMessageDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OccupantDisplay__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OccupantDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OccupantDisplay__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GroupIndex',
    data: function data() {
        return {
            flagDisplayBanner: 0,
            profileIsSaving: false,
            actualLanguage: "FR",
            mainServiceListIsLoading: true,

            serviceIsDeleting: false,
            labelTitle: { FR: "Répartiteur de coût de service", EN: 'Service cost splitter' },
            labelButtonAddMainService: { FR: "Ajouter un service principal", EN: 'Add main service' },
            labelButtonDeleteService: { FR: "Supprimer", EN: 'Delete' },
            messagePromptMainServiceReferenceName: { FR: "Nom de référence du service principal", EN: 'Main service reference name' },
            messagePromptMainServiceReferenceNameTextBox: { FR: "Nom de référence", EN: 'Reference name' },

            messageRemoveService: { FR: "ATTENTION : La supression d'un service principal peut affecter les configurations de votre système de répartition de coût, assurez vous que les unités lié au service principal et sous services rattachés n'y soient plus liés.",
                EN: 'WARNING : The deletion of a main service can affect the configurations of your cost splitting system, make sure that the units linked to the main service and under attached services are no longer linked to it.' },
            messageRemoveConfirmA: { FR: "Confirmer la supression du service : ", EN: 'Confirm service deletion : ' },
            messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },

            MainServiceList: [],

            tabLabelMainService: { FR: "Services", EN: 'Services' },

            unitIsDeleting: false,
            tabLabelUnits: { FR: "Unités", EN: 'Unit' },
            messageRemoveUnit: { FR: "ATTENTION : La supression d'une unité peut affecter les configurations de votre système de répartition de coût, cette action n'est pas récupérable suite a son exécution.",
                EN: 'WARNING: Deleting a unit can affect the configurations of your cost distribution system, this action is not recoverable after its execution.' },
            messageRemoveUnitConfirmA: { FR: "Confirmer la supression de l'unité : ", EN: 'Confirm unit deletion : ' },
            messageRemoveUnitConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },

            tabLabelOccupants: { FR: "Occupants", EN: 'Occupants' },
            tabLabelComplement: { FR: "Compléments", EN: 'Complement' },
            tabMenuSelector: [],
            test: 0,
            displayTab: false,

            unitListIsLoading: true,
            UnitList: [],
            labelButtonAddUnit: { FR: "Ajouter une unité", EN: 'Add unit' },
            messagePromptUnitReferenceName: { FR: "Nom de référence de l'unité", EN: 'Unit reference name' },

            occupantListIsLoading: true,
            occupantIsDeleting: false,
            occupantsList: [],
            labelButtonAddOccupant: { FR: "Ajouter un occupant", EN: 'Add occupant' },
            messagePromptOccupantFirstName: { FR: "Prénom de l'occupant principal à ajouter", EN: 'Firstname of the occupant to add' },
            messagePromptOccupantFirstNameTextBox: { FR: "Prénom", EN: 'Firstname' },
            messagePromptOccupantLastName: { FR: "Nom de l'occupant principal à ajouter", EN: 'Lastname of the occupant to add' },
            messagePromptOccupantLastNameTextBox: { FR: "Nom", EN: 'Lastname' },
            messageRemoveOccupantConfirmA: { FR: "Confirmer la supression de l'occupant: ", EN: 'Confirm occupant deletion : ' },
            messageRemoveOccupantConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' }

        };
    },

    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
        MainServiceDisplay: __WEBPACK_IMPORTED_MODULE_3__MainServiceDisplay___default.a,
        UnitDisplay: __WEBPACK_IMPORTED_MODULE_4__UnitDisplay___default.a,
        UnitDisplayStats: __WEBPACK_IMPORTED_MODULE_5__UnitDisplayStats___default.a,
        CompUnitTagsDisplay: __WEBPACK_IMPORTED_MODULE_6__CompUnitTagsDisplay___default.a,
        CompCompareLevelMessageDisplay: __WEBPACK_IMPORTED_MODULE_7__CompCompareLevelMessageDisplay___default.a,
        OccupantDisplay: __WEBPACK_IMPORTED_MODULE_8__OccupantDisplay___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['actualBundle', 'parentContainer'])),

    watch: {
        actualBundle: function actualBundle() {
            this.readMainServiceList();
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
        toggleDisplayBanner: function toggleDisplayBanner() {
            this.flagDisplayBanner = ~this.flagDisplayBanner;
        },
        toggleTabMenuSelector: function toggleTabMenuSelector(index) {
            this.displayTab = false;
            for (var n = 0; n < this.tabMenuSelector.length; n++) {
                this.tabMenuSelector[n] = false;
            }
            this.tabMenuSelector[index] = true;
            localStorage.actualCostSplitTab = index;

            if (this.tabMenuSelector[0]) {
                this.readMainServiceList();
            }
            if (this.tabMenuSelector[1]) {
                this.readUnitList();
            }
            if (this.tabMenuSelector[2]) {
                this.readOccupantList();
            }

            this.test = index;
            this.displayTab = true;
        },
        readMainServiceList: function readMainServiceList() {
            var _this = this;

            var requestData = { 'postAction': 'GetBundleMainServices',
                'bundleId': this.actualBundle.bundle_id };
            this.mainServiceListIsLoading = true;
            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this.mainServiceListIsLoading = false;
                    _this.MainServiceList = response.data.MainServiceList;
                } else {
                    window.alert(response.data.PromptMessage[_this.actualLanguage]);
                    _this.mainServiceListIsLoading = false;
                }
            });
        },
        addMainService: function addMainService() {
            var _this2 = this;

            var mainServiceReferenceName = prompt(this.messagePromptMainServiceReferenceName[this.actualLanguage], this.messagePromptMainServiceReferenceNameTextBox[this.actualLanguage]);

            if (mainServiceReferenceName != null) {
                var requestData = { 'postAction': 'AddMainServiceToBundle',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'referenceName': mainServiceReferenceName };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this2.readMainServiceList();
                    } else {
                        window.alert(response.data.PromptMessage[_this2.actualLanguage]);
                    }
                });
            }
        },
        deleteMainService: function deleteMainService(index) {
            var _this3 = this;

            window.alert(this.messageRemoveService[this.actualLanguage]);
            var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.MainServiceList[index].reference_name, this.messageRemoveConfirmB[this.actualLanguage]);

            if (confirmation == 'DELETE') {
                this.deviceIsDeleting = true;
                var requestData = { 'postAction': 'DeleteMainService',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'mainServiceData': this.MainServiceList[index]
                };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this3.deviceIsDeleting = false;
                        _this3.readMainServiceList();
                    } else {
                        window.alert(response.data.PromptMessage[_this3.actualLanguage]);
                    }
                });
            }
        },
        readUnitList: function readUnitList() {
            var _this4 = this;

            var requestData = { 'postAction': 'GetBundleUnits',
                'bundleId': this.actualBundle.bundle_id };
            this.unitListIsLoading = true;
            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this4.unitListIsLoading = false;
                    _this4.UnitList = response.data.UnitList;
                } else {
                    window.alert(response.data.PromptMessage[_this4.actualLanguage]);
                    _this4.unitListIsLoading = false;
                }
            });
        },
        addUnit: function addUnit() {
            var _this5 = this;

            var unitReferenceName = prompt(this.messagePromptUnitReferenceName[this.actualLanguage], this.messagePromptMainServiceReferenceNameTextBox[this.actualLanguage]);

            if (unitReferenceName != null) {
                var requestData = { 'postAction': 'AddUnitToBundle',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'referenceName': unitReferenceName };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this5.readUnitList();
                    } else {
                        window.alert(response.data.PromptMessage[_this5.actualLanguage]);
                    }
                });
            }
        },
        deleteUnit: function deleteUnit(index) {
            var _this6 = this;

            window.alert(this.messageRemoveUnit[this.actualLanguage]);
            var confirmation = prompt(this.messageRemoveUnitConfirmA[this.actualLanguage] + this.UnitList[index].reference_name, this.messageRemoveUnitConfirmB[this.actualLanguage]);

            if (confirmation == 'DELETE') {
                this.unitIsDeleting = true;
                var requestData = { 'postAction': 'DeleteUnit',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'unitData': this.UnitList[index]
                };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this6.unitIsDeleting = false;
                        _this6.readUnitList();
                    } else {
                        window.alert(response.data.PromptMessage[_this6.actualLanguage]);
                    }
                });
            }
        },
        addOccupant: function addOccupant() {
            var _this7 = this;

            var occupantFirstName = prompt(this.messagePromptOccupantFirstName[this.actualLanguage], this.messagePromptOccupantFirstNameTextBox[this.actualLanguage]);
            var occupantLastName = prompt(this.messagePromptOccupantLastName[this.actualLanguage], this.messagePromptOccupantLastNameTextBox[this.actualLanguage]);

            if (occupantFirstName != null && occupantLastName != null) {
                var requestData = { 'postAction': 'AddOccupant',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'firstname': occupantFirstName,
                    'lastname': occupantLastName };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this7.occupantsList = response.data.OccupantList;
                    } else {
                        window.alert(response.data.PromptMessage[_this7.actualLanguage]);
                    }
                });
            }
        },
        deleteOccupant: function deleteOccupant(index) {
            var _this8 = this;

            var confirmation = prompt(this.messageRemoveOccupantConfirmA[this.actualLanguage] + this.occupantsList[index].completeName, this.messageRemoveOccupantConfirmB[this.actualLanguage]);

            if (confirmation == 'DELETE') {
                this.occupantIsDeleting = true;
                var requestData = { 'postAction': 'DeleteOccupant',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'occupantData': this.occupantsList[index]
                };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this8.occupantsList = response.data.OccupantList;
                        _this8.occupantIsDeleting = false;
                    } else {
                        window.alert(response.data.PromptMessage[_this8.actualLanguage]);
                    }
                });
            }
        },
        readOccupantList: function readOccupantList() {
            var _this9 = this;

            var requestData = { 'postAction': 'GetOccupantList',
                'bundleId': this.actualBundle.bundle_id };
            this.occupantListIsLoading = true;
            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this9.occupantsList = response.data.OccupantList;
                    _this9.occupantListIsLoading = false;
                } else {
                    window.alert(response.data.PromptMessage[_this9.actualLanguage]);
                    _this9.unitListIsLoading = false;
                }
            });
        },
        returnToMyServicePlan: function returnToMyServicePlan() {
            this.planTransactionData.transactionStatusCode = '000';
            this.flagDisplayPlan = 0;
            window.scrollTo(0, 0);
        }
    }),

    mounted: function mounted() {

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }

        this.tabMenuSelector = [true, false, false, false, false, false];

        if (localStorage.actualCostSplitTab) {
            this.toggleTabMenuSelector(localStorage.actualCostSplitTab);
        } else {
            this.toggleTabMenuSelector(0);
        }
        this.displayTab = true;

        this.readMainServiceList();
    }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubServiceDisplay__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubServiceDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubServiceDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainServiceDisplayTabInvoices__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainServiceDisplayTabInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainServiceDisplayTabInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainServiceDisplayTabGraphs__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainServiceDisplayTabGraphs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainServiceDisplayTabGraphs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GroupIndex',
    props: ['mainService'],

    data: function data() {
        return {
            flagDisplayBanner: 0,
            flagDisplayDetail: 0,
            profileIsSaving: false,
            serviceIsDeleting: false,
            actualLanguage: "FR",
            tabMenuSelector: [],
            test: 0,
            displayTab: false,

            tabLabelMenuVisualisation: { FR: 'Visualisation', EN: 'Visualization' },
            tabLabelMenuInvoices: { FR: 'Saisie de factures', EN: 'Invoice entry' },
            tabLabelMenuSubService: { FR: 'Sous services', EN: 'Sub service' },

            labelTitleSection: { FR: 'Titre bannière', EN: 'Banner Title' },
            labelTitleBanner: { FR: 'Titre bannière', EN: 'Banner Title' },

            labelButtonConfig: { FR: 'Configuration', EN: 'Configuration' },
            labelButtonConfigClose: { FR: 'Fermer configuration', EN: 'Close configuration' },
            labelButtonSaveModifications: { FR: 'Enregistrer modifications', EN: 'Save modifications' },
            labelButtonDeleteService: { FR: "Supprimer", EN: 'Delete' },

            labelRefenrenceName: { FR: "Nom de référence du service", EN: 'Service reference name' },
            selectLabelLinkedChannel: { FR: "Appareil mesuré lié", EN: 'Linked monitored device' },

            tableOptionsColumnTitle01: { FR: "Description de l'option", EN: "Option description" },
            tableOptionsColumnTitle02: { FR: "Détail de l'option", EN: "Option detail" },
            labelActivated: { FR: "Activé", EN: 'Activated' },

            serviceIsSaving: false,
            subServiceListIsLoading: false,

            messageRemoveService: { FR: "ATTENTION : La supression d'un service peut affecter les configurations de votre système de répartition de coût, assurez vous que les unités lié au service principal et sous services rattachés n'y soient plus liés.",
                EN: 'WARNING : The deletion of a  service can affect the configurations of your cost splitting system, make sure that the units linked to the main service and under attached services are no longer linked to it.' },
            messageRemoveConfirmA: { FR: "Confirmer la supression du service : ", EN: 'Confirm service deletion : ' },
            messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },

            subServiceList: [],
            labelButtonAddSubService: { FR: "Ajouter un sous service", EN: 'Add sub service' },

            messagePromptSubServiceReferenceName: { FR: "Nom de référence du sous service", EN: 'Sub service reference name' },
            messagePromptSubServiceReferenceNameTextBox: { FR: "Nom de référence", EN: 'Reference name' }

        };
    },

    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
        SubServiceDisplay: __WEBPACK_IMPORTED_MODULE_3__SubServiceDisplay___default.a,
        MainServiceDisplayTabInvoices: __WEBPACK_IMPORTED_MODULE_4__MainServiceDisplayTabInvoices___default.a,
        MainServiceDisplayTabGraphs: __WEBPACK_IMPORTED_MODULE_5__MainServiceDisplayTabGraphs___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_6_element_ui__["DatePicker"],
        TimePicker: __WEBPACK_IMPORTED_MODULE_6_element_ui__["TimePicker"],
        TimeSelect: __WEBPACK_IMPORTED_MODULE_6_element_ui__["TimeSelect"]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData', 'actualBundle', 'parentContainer'])),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
        toggleDisplayBanner: function toggleDisplayBanner() {
            this.flagDisplayBanner = ~this.flagDisplayBanner;
            if (this.flagDisplayBanner == -1) {
                this.readSubServiceList();
            }
        },
        toggleConfigView: function toggleConfigView() {
            this.flagDisplayDetail = ~this.flagDisplayDetail;
        },
        toggleTabMenuSelector: function toggleTabMenuSelector(index) {
            this.displayTab = false;
            for (var n = 0; n < this.tabMenuSelector.length; n++) {
                this.tabMenuSelector[n] = false;
            }
            this.tabMenuSelector[index] = true;

            if (this.tabMenuSelector[2]) {
                this.readSubServiceList();
            }

            this.test = index;
            this.displayTab = true;
        },
        saveMainServiceModifications: function saveMainServiceModifications() {
            var _this = this;

            var requestData = { 'postAction': 'SaveMainService',
                'bundleId': this.actualBundle.bundle_id,
                'parentContainer': this.parentContainer,
                'mainServiceData': this.mainService };
            this.serviceIsSaving = true;
            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                console.log(response);
                if (response.data.Code == 'OK') {
                    _this.serviceIsSaving = false;
                } else {
                    window.alert(response.data.PromptMessage[_this.actualLanguage]);
                }
            });
        },
        readSubServiceList: function readSubServiceList() {
            var _this2 = this;

            var requestData = { 'postAction': 'GetMainServicesSubService',
                'bundleId': this.actualBundle.bundle_id,
                'parentContainer': this.parentContainer,
                'mainServiceId': this.mainService.service_id };
            this.subServiceListIsLoading = true;
            this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this2.subServiceListIsLoading = false;
                    _this2.subServiceList = response.data.SubServiceList;
                } else {
                    window.alert(response.data.PromptMessage[_this2.actualLanguage]);
                    _this2.subServiceListIsLoading = false;
                }
            });
        },
        addSubService: function addSubService() {
            var _this3 = this;

            var subServiceReferenceName = prompt(this.messagePromptSubServiceReferenceName[this.actualLanguage], this.messagePromptSubServiceReferenceNameTextBox[this.actualLanguage]);

            if (subServiceReferenceName != null) {
                var requestData = { 'postAction': 'AddMainServicesSubService',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'mainServiceId': this.mainService.service_id,
                    'referenceName': subServiceReferenceName };
                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this3.readSubServiceList();
                    } else {
                        window.alert(response.data.PromptMessage[_this3.actualLanguage]);
                    }
                });
            }
        },
        deleteSubService: function deleteSubService(index) {
            var _this4 = this;

            window.alert(this.messageRemoveService[this.actualLanguage]);
            var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + this.subServiceList[index].reference_name, this.messageRemoveConfirmB[this.actualLanguage]);

            if (confirmation == 'DELETE') {
                this.deviceIsDeleting = true;
                var requestData = { 'postAction': 'DeleteSubService',
                    'bundleId': this.actualBundle.bundle_id,
                    'parentContainer': this.parentContainer,
                    'mainServiceId': this.mainService.service_id,
                    'subServiceId': this.subServiceList[index].sub_service_id
                };

                this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
                    if (response.data.Code == 'OK') {
                        _this4.readSubServiceList();
                    } else {
                        window.alert(response.data.PromptMessage[_this4.actualLanguage]);
                    }
                });
            }
        },
        returnToMyServicePlan: function returnToMyServicePlan() {
            this.planTransactionData.transactionStatusCode = '000';
            this.flagDisplayPlan = 0;
            window.scrollTo(0, 0);
        }
    }),

    mounted: function mounted() {
        this.toggleTabMenuSelector(0);

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
    }
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GraphApexTimeLine__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GraphApexTimeLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__GraphApexTimeLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GraphApexBars__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GraphApexBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__GraphApexBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GraphApexPies__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GraphApexPies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__GraphApexPies__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['mainService'],

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,
      flagDisplayGraph: false,
      flagGraphDataIsUpdating: false,
      actualLanguage: "FR",
      flagReadByInvoiceData: false,

      labelButton: { FR: "Données selon les saisies de factures",
        EN: 'Read data according to billing data' },
      lableActivated: { FR: "Activé", EN: 'Enabled' },
      lableNotActivated: { FR: "Désactivé", EN: 'Disabled' },

      invoiceColumn01: { FR: "Numéro de référence", EN: 'Reference number' },

      periodCost: { FR: "Coûts de la période", EN: 'Period costs' },
      summaryTableColumn01: { FR: "Sous service", EN: 'Sub service' },
      summaryTableColumn02: { FR: "Pourcentage", EN: 'Pourcentage' },
      summaryTableColumn03: { FR: "Coûts", EN: 'Costs' },

      labelSelectInvoicePeriod: { FR: "Période de facturation", EN: 'Billing period' },
      visualisationDateStart: '',
      visualisationDateEnd: '',
      GraphData: [],
      selectedInvoiceIndex: 0,

      labelButtonReadGraph: { FR: "Actualiser les graphiques", EN: 'Refresh graphs' },
      summary: { 'sumCosts': 0, subServices: [] },
      pieChartData: { ChartTitle: { FR: 'Répartition des coûts pour la période sélectionnée', EN: 'Breakdown of costs for the selected period' },
        Labels: [],
        Data: [] },

      barChartDataMain1: { ChartTitle: { FR: 'Distribution des coûts journaliers du service principal ($)',
          EN: 'Main service daily distribution of costs ($)' },
        XData: [],
        YData: [],
        Options: { Stacked: false, StackType: "none" } },

      barChartDataSub1: { ChartTitle: { FR: 'Distribution des coûts par sous service',
          EN: 'Distribution of costs by sub-service' },
        XData: [],
        YData: [],
        Options: { Stacked: true, StackType: "normal" } },

      barChartDataSub2: { ChartTitle: { FR: 'Répartition des coûts par jour', EN: 'Breakdown of costs per day' },
        XData: [],
        YData: [],
        Options: { Stacked: true, StackType: "100%" } }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimeSelect"],
    GraphApexTimeline: __WEBPACK_IMPORTED_MODULE_5__GraphApexTimeLine___default.a,
    GraphApexBars: __WEBPACK_IMPORTED_MODULE_6__GraphApexBars___default.a,
    GraphApexPies: __WEBPACK_IMPORTED_MODULE_7__GraphApexPies___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    applyInvoiceDate: function applyInvoiceDate() {
      if (this.mainService.service_invoices.length > 0) {
        this.visualisationDateStart = this.mainService.service_invoices[this.selectedInvoiceIndex].dateStart;
        this.visualisationDateEnd = this.mainService.service_invoices[this.selectedInvoiceIndex].dateEnd;
      }
    },
    readMainServiceGraphData: function readMainServiceGraphData() {
      var _this = this;

      this.flagDisplayGraph = false;
      this.flagGraphDataIsUpdating = true;
      var GraphReadPostAction = 'GetMainServiceGraphData';

      if (this.flagReadByInvoiceData) {
        GraphReadPostAction = 'GetMainServiceGraphDataFromInvoices';
      }

      var requestData = { 'postAction': GraphReadPostAction,
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'mainServiceId': this.mainService.service_id,
        'dateStart': this.visualisationDateStart,
        'dateEnd': this.visualisationDateEnd };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        _this.flagGraphDataIsUpdating = false;
        if (response.data.Code == 'OK') {
          _this.GraphData = response.data.GraphData;
          _this.summary = response.data.GraphData[0].summary;
          _this.pieChartData.Labels = response.data.GraphData[0].pieData.labels;
          _this.pieChartData.Data = response.data.GraphData[0].pieData.data;

          _this.barChartDataMain1.XData = response.data.GraphData[0].barData.mainXData;
          _this.barChartDataMain1.YData = response.data.GraphData[0].barData.mainYData;

          _this.barChartDataSub1.XData = response.data.GraphData[0].barData.subXData;
          _this.barChartDataSub1.YData = response.data.GraphData[0].barData.subYData;

          _this.barChartDataSub2.XData = response.data.GraphData[0].barData.subXData;
          _this.barChartDataSub2.YData = response.data.GraphData[0].barData.subYData;

          _this.flagDisplayGraph = true;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {
    this.applyInvoiceDate();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    var thisDayUnix = Math.floor(__WEBPACK_IMPORTED_MODULE_4_moment___default()().unix() / (24 * 3600)) * (24 * 3600);
    this.visualisationDateStart = (thisDayUnix - 7 * 24 * 3600) * 1000;
    this.visualisationDateEnd = thisDayUnix * 1000;

    this.readMainServiceGraphData();
  }
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);



var _extends2;







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['mainService'],

  data: function data() {
    var _ref;

    return _ref = {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,
      invoiceIsSaving01: false,
      serviceIsDeleting: false,
      actualLanguage: "FR",

      invoiceColumn01: { FR: "Numéro de référence", EN: 'Reference number' },
      invoiceColumn02: { FR: "Date début", EN: 'Date start' },
      invoiceColumn03: { FR: "Date de fin", EN: 'Date end' },
      invoiceColumn04: { FR: "Montant ($)", EN: 'Amount ($)' },
      invoiceColumn05: { FR: "Taxes ($)", EN: 'Tax ($)' },
      invoiceColumn06: { FR: "Total ($)", EN: 'Total ($)' },

      labelTitleSectionInvoices: { FR: "Factures du service", EN: 'Service invoices' },
      labelButtonAddInvoice: { FR: "Ajouter une facture", EN: 'Add invoice' },
      labelButtonSaveInvoice: { FR: "Enregistrer la facture", EN: 'Save invoice' },
      labelButtonCancel: { FR: "Annuler", EN: 'Cancel' },
      flagAddInvoice: 0,
      labelAddInvoiceTitle: { FR: "Details de la facture", EN: 'Service Invoice details' },
      labelReference: { FR: "Numero de référence", EN: 'Reference number' },
      labelDateStart: { FR: "Date début", EN: 'Date start' },
      labelDateEnd: { FR: "Date fin", EN: 'Date end' },
      labelAmount: { FR: "Montant ($)", EN: 'Amount ($)' },
      labelTax: { FR: "Taxes ($)", EN: 'Tax ($)' },
      labelTotal: { FR: "Total ($)", EN: 'Total ($)' }

    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'labelButtonSaveInvoice', { FR: "Enregistrer la facture", EN: 'Save invoice' }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tempoInvoiceReferenceNumber', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tempoInvoiceDateStart', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tempoInvoiceDateEnd', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tempoAmount', '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tempoTax', '0'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tempoAmountWithTax', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'saveInvoiceConfirmationMessage', { FR: "Informations validées, confirmer l'enregistrement de cette facture. ATTENTION CETTE OPÉRATION NE PEUT SE FAIRE QU'UNE SEULE FOIS!",
      EN: 'Information validated, confirm the recording of this invoice. CAUTION THIS OPERATION CAN ONLY BE DONE ONCE!' }), _ref;
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_4_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_4_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_4_element_ui__["TimeSelect"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), (_extends2 = {
    toggleAddInvoice: function toggleAddInvoice() {
      this.flagAddInvoice = ~this.flagAddInvoice;
    },
    addInvoiceStep01: function addInvoiceStep01() {

      console.log(response);
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'addInvoiceStep01', function addInvoiceStep01() {
    var _this = this;

    this.computeAmountTotal();

    var requestData = { 'postAction': 'ValidateMainServiceInvoice',
      'bundleId': this.actualBundle.bundle_id,
      'parentContainer': this.parentContainer,
      'mainServiceId': this.mainService.service_id,
      'invoiceReferenceNumber': this.tempoInvoiceReferenceNumber,
      'invoiceDateStart': this.tempoInvoiceDateStart,
      'invoiceDateEnd': this.tempoInvoiceDateEnd,
      'invoiceAmount': this.tempoAmount,
      'invoiceTax': this.tempoTax,
      'invoiceTotal': this.tempoAmountWithTax };
    this.invoiceIsSaving01 = true;
    this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
      if (response.data.Code == 'OK') {
        _this.invoiceIsSaving01 = false;
        var response = window.confirm(_this.saveInvoiceConfirmationMessage[_this.actualLanguage]);
        if (response) {
          _this.addInvoiceStep02();
        }
      } else {
        window.alert(response.data.PromptMessage[_this.actualLanguage]);
        _this.invoiceIsSaving01 = false;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'addInvoiceStep02', function addInvoiceStep02() {
    var _this2 = this;

    var requestData = { 'postAction': 'AddMainServiceInvoice',
      'bundleId': this.actualBundle.bundle_id,
      'parentContainer': this.parentContainer,
      'mainServiceId': this.mainService.service_id,
      'invoiceReferenceNumber': this.tempoInvoiceReferenceNumber,
      'invoiceDateStart': this.tempoInvoiceDateStart,
      'invoiceDateEnd': this.tempoInvoiceDateEnd,
      'invoiceAmount': this.tempoAmount,
      'invoiceTax': this.tempoTax,
      'invoiceTotal': this.tempoAmountWithTax };
    this.invoiceIsSaving01 = true;
    this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
      if (response.data.Code == 'OK') {
        _this2.invoiceIsSaving01 = false;
        _this2.mainService.service_invoices = response.data.ServiceInvoice;
        _this2.flagAddInvoice = 0;
      } else {
        window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        _this2.invoiceIsSaving01 = false;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'computeAmountTotal', function computeAmountTotal() {
    var total = parseFloat(this.tempoAmount) + parseFloat(this.tempoTax);
    this.tempoAmountWithTax = total.toFixed(2).toString();
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'returnToMyServicePlan', function returnToMyServicePlan() {
    this.planTransactionData.transactionStatusCode = '000';
    this.flagDisplayPlan = 0;
    window.scrollTo(0, 0);
  }), _extends2)),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Occupant',
  props: ['occupant'],

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,
      profileIsSaving: false,
      occupantIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: 'Titre bannière', EN: 'Banner Title' },
      labelTitleBanner: { FR: 'Titre bannière', EN: 'Banner Title' },
      labelOccupant: { FR: 'Occupant', EN: 'Occupant' },

      labelButtonConfig: { FR: 'Configuration', EN: 'Configuration' },
      labelButtonConfigClose: { FR: 'Fermer configuration', EN: 'Close configuration' },
      labelButtonSaveModifications: { FR: 'Enregistrer modifications', EN: 'Save modifications' },

      labelFirstName: { FR: "Prénom de l'occupant principal", EN: 'Main occupant firstname' },
      labelLastName: { FR: "Nom du l'occupant principal", EN: 'Main occupant lastname' },
      labelEmail: { FR: "Courriel", EN: 'Email' },
      labelMobile: { FR: "Téléphone mobile", EN: 'Mobile phone number' },
      labelReportMonthDay: { FR: "Journée du mois de génération des rapport et relevés (à ce moment, les factures de services doivent avoir été saisies dans le système)",
        EN: 'Day of the month for generating reports and statements (at this time, service invoices must have been entered into the system)' },

      labelTitleSectionUnitAttribution: { FR: "Attribution d'unité", EN: 'Unit assigment' },
      labelButtonAjouterAttribution: { FR: "Ajouter une attribution", EN: 'Add assigment' },
      labelButtonCancel: { FR: "Annuler", EN: 'Cancel' },
      flagAddAttribution: 0,
      flagDisplayAttributionTable: false,
      labelUnit: { FR: "Unité", EN: 'Unit' },
      labelDateStart: { FR: "Date début", EN: 'Date start' },
      labelDateEnd: { FR: "Date fin", EN: 'Date end' },
      labelButtonSaveAttribution: { FR: "Enregistrer l'attribution", EN: 'Save assigment' },
      unitListIsLoading: false,
      unitList: [],
      tempoUnit: '',
      tempoUnitDateStart: '',
      tempoUnitDateEnd: '',

      attributionColumn01: { FR: "Unité", EN: 'Unit' },
      attributionColumn02: { FR: "Date début", EN: 'Start date' },
      attributionColumn03: { FR: "Date fin", EN: 'End date' },
      attributionColumn04: { FR: "Action", EN: 'Action' },

      messageRemoveConfirmA: { FR: "Confirmer la supression de l'attribution de la ligne : ", EN: 'Confirm line assigment deletion : ' },
      messageRemoveConfirmB: { FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE' },

      labelFixCostExplanation: { FR: "Un coût fixe s'ajoute au relevé de consommation et s'applique pour la période mentionnée. Le coût total est divisé par le nombre de jour et ensuite calculé selon le nombre de jour du relevé. Un coût de type ANNUEL se voit répété a chaque années au mois et jour sélectionnés.",
        EN: "A fixed cost is added to the consumption statement and applies for the period mentioned. The total cost is divided by the number of days and then calculated according to the number of days of the statement. An ANNUAL type cost is repeated every year on the selected month and day." },
      labelTitleSectionFixCosts: { FR: "Coûts fixe", EN: 'Fixed costs' },

      labelButtonAddFixCost: { FR: 'Ajouter un coût fixe', EN: 'Add fixed cost' },
      fixCostColumn01: { FR: "Annuel", EN: 'Annual' },
      fixCostColumn02: { FR: "Date début", EN: 'Start date' },
      fixCostColumn03: { FR: "Date fin", EN: 'End date' },
      fixCostColumn04: { FR: "Description", EN: 'Description' },
      fixCostColumn05: { FR: "Coût total($)", EN: 'Total cost ($)' },
      fixCostColumn06: { FR: "Supprimer", EN: 'Delete' },

      errorMessageSelectUnit: { FR: "Vous devez sélectionner un unité.", EN: 'You must select one unit.' },
      errorMessageSelectDateStart: { FR: "Vous devez sélectionner une date de début.", EN: 'You must select a start date.' },
      errorMessageSelectDateEnd: { FR: "Vous devez sélectionner une date de fin.", EN: 'You must select a end date.' },
      labelActivated: { FR: "Activé", EN: 'Activated' },
      typeList: [],
      messageList: []

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimeSelect"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
    },
    toggleConfigView: function toggleConfigView() {
      this.flagDisplayDetail = ~this.flagDisplayDetail;
    },
    toggleAddAttribution: function toggleAddAttribution() {
      this.flagAddAttribution = ~this.flagAddAttribution;
    },
    saveOccupantModifications: function saveOccupantModifications() {
      var _this = this;

      var requestData = { 'postAction': 'SaveOccupant',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'occupantData': this.occupant };
      this.occupantIsSaving = true;
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.occupantIsSaving = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
          _this.occupantIsSaving = false;
        }
      });
    },
    addFixCostLine: function addFixCostLine() {
      this.occupant.fix_costs.push({ 'yearlyFlag': false,
        'periodStart': '',
        'periodEnd': '',
        'description': '',
        'cost': '' });
    },
    deleteFixCost: function deleteFixCost(index) {
      this.occupant.fix_costs.splice(index, 1);
    },
    readUnitList: function readUnitList() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetBundleUnits',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };
      this.unitListIsLoading = true;
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.unitListIsLoading = false;
          _this2.unitList = response.data.UnitList;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
          _this2.unitListIsLoading = false;
        }
      });
    },
    saveOccupantAttribution: function saveOccupantAttribution() {
      var _this3 = this;

      var processToSaving = true;

      if (this.tempoUnit.length == 0) {
        window.alert(this.errorMessageSelectUnit[this.actualLanguage]);
        processToSaving = false;
      }
      if (this.tempoUnitDateStart.length == 0) {
        window.alert(this.errorMessageSelectDateStart[this.actualLanguage]);
        processToSaving = false;
      }
      if (this.tempoUnitDateEnd.length == 0) {
        window.alert(this.errorMessageSelectDateEnd[this.actualLanguage]);
        processToSaving = false;
      }

      if (processToSaving) {
        var requestData = { 'postAction': 'SaveOccupantAttribution',
          'bundleId': this.actualBundle.bundle_id,
          'parentContainer': this.parentContainer,
          'occupantId': this.occupant.occupant_id,
          'unitId': this.tempoUnit,
          'dateStart': this.tempoUnitDateStart,
          'dateEnd': this.tempoUnitDateEnd };
        this.flagDisplayAttributionTable = false;
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          console.log(response);
          if (response.data.Code == 'OK') {
            _this3.occupant.unit_attributions = response.data.OccupantAttributions;
            _this3.flagDisplayAttributionTable = true;

            _this3.$nextTick(function () {
              _this3.toggleAddAttribution();
            });
          } else {
            window.alert(response.data.PromptMessage[_this3.actualLanguage]);
          }
        });
      }
    },
    deleteOccupantAttribution: function deleteOccupantAttribution(index) {
      var _this4 = this;

      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage] + (index + 1), this.messageRemoveConfirmB[this.actualLanguage]);

      if (confirmation == 'DELETE') {
        var requestData = { 'postAction': 'DeleteOccupantAttribution',
          'bundleId': this.actualBundle.bundle_id,
          'parentContainer': this.parentContainer,
          'occupantId': this.occupant.occupant_id,
          'index': index };
        this.flagDisplayAttributionTable = false;
        this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this4.occupant.unit_attributions = response.data.OccupantAttributions;
            _this4.flagDisplayAttributionTable = true;
          } else {
            window.alert(response.data.PromptMessage[_this4.actualLanguage]);
          }
        });
      }
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {
    this.readUnitList();
    this.flagDisplayAttributionTable = true;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GraphApexBars__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GraphApexBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GraphApexBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['subService'],

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,
      profileIsSaving: false,
      serviceIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: 'Titre bannière', EN: 'Banner Title' },
      labelTitleBanner: { FR: 'Titre bannière', EN: 'Banner Title' },

      labelButtonConfig: { FR: 'Configuration', EN: 'Configuration' },
      labelButtonConfigClose: { FR: 'Fermer configuration', EN: 'Close configuration' },
      labelButtonSaveModifications: { FR: 'Enregistrer modifications', EN: 'Save modifications' },

      labelRefenrenceName: { FR: "Nom de référence du service", EN: 'Service reference name' },
      selectLabelLinkedChannel: { FR: "Pour liées un ou des appareils mesurés a ce service, sélectionnez l'appareil dans la liste et utiliser le bouton 'Ajouter l'appareil'",
        EN: "To link one or more devices measured to this service, select the device in the list and use the 'Add device' button" },
      channelToAddIndex: '',
      channelAddButton: { FR: "Ajouter l'appareil", EN: "Add monitored device" },
      channelTableColumn01: { FR: "Liste d'appareils liée au service", EN: 'Linked monitored device' },
      channelTableColumn02: { FR: "Retirer", EN: 'Delete' },

      messageSaveModifRequired: { FR: "Vous devez utiliser le bouton 'Enregistrer modifications' pour que les modifications soient enregistrés dans le système.",
        EN: "You must use the 'Save Modifications' to save modification into the system." },
      messageSaveModifFlag: true,

      tableOptionsColumnTitle01: { FR: "Description de l'option", EN: "Option description" },
      tableOptionsColumnTitle02: { FR: "Détail de l'option", EN: "Option detail" },
      labelActivated: { FR: "Activé", EN: 'Activated' },

      labelSectionTitleLinkedChannel: { FR: "Appareil(s) mesuré(s) lié(s) au sous-service",
        EN: 'Add sub service' },
      labelButtonAddSubService: { FR: "Ajouter un sous service", EN: 'Add sub service' },

      labelTitleGraph: { FR: 'Mesures du sous service', EN: 'Sub service measurement' },
      flagReadByInvoiceData: false,
      labelButton: { FR: "Données selon les saisies de factures",
        EN: 'Read data according to billing data' },
      lableActivated: { FR: "Activé", EN: 'Enabled' },
      lableNotActivated: { FR: "Désactivé", EN: 'Disabled' },

      visualisationDateStart: '',
      visualisationDateEnd: '',

      flagDisplayGraph: false,
      flagGraphDataIsUpdating: false,
      labelButtonReadGraph: { FR: "Actualiser le graphique", EN: 'Refresh graph' },
      GraphData: [],
      barChartDataSub1: { ChartTitle: { FR: 'Distribution des coûts',
          EN: 'Distribution of costs' },
        XData: [],
        YData: [],
        Options: { Stacked: true, StackType: "normal" } }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimeSelect"],
    GraphApexBars: __WEBPACK_IMPORTED_MODULE_4__GraphApexBars___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
      console.log(this.flagDisplayBanner);
      if (this.flagDisplayBanner == -1) {
        this.readSubServiceGraphData();
      }
    },
    toggleConfigView: function toggleConfigView() {
      this.flagDisplayDetail = ~this.flagDisplayDetail;
    },
    addChannelToLinkedChannel: function addChannelToLinkedChannel() {
      this.subService.linked_channel.push({ channelId: this.actualBundle.channels[this.channelToAddIndex].ChannelData.channelId,
        referenceName: this.actualBundle.channels[this.channelToAddIndex].ReferenceName });
      this.messageSaveModif();
    },
    deleteLinkedChannel: function deleteLinkedChannel(index) {
      this.subService.linked_channel.pop(index);
      this.messageSaveModif();
    },
    messageSaveModif: function messageSaveModif() {
      if (this.messageSaveModifFlag) {
        window.alert(this.messageSaveModifRequired[this.actualLanguage]);
        this.messageSaveModifFlag = false;
      }
    },
    saveSubServiceModifications: function saveSubServiceModifications() {
      var _this = this;

      var requestData = { 'postAction': 'SaveSubService',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'subServiceData': this.subService };
      this.serviceIsSaving = true;
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.serviceIsSaving = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    readSubServiceGraphData: function readSubServiceGraphData() {
      var _this2 = this;

      this.flagDisplayGraph = false;
      this.flagGraphDataIsUpdating = true;
      var GraphReadPostAction = 'GetSubServiceGraphData';

      if (this.flagReadByInvoiceData) {
        GraphReadPostAction = 'GetSubServiceGraphDataFromInvoices';
      }

      var requestData = { 'postAction': GraphReadPostAction,
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'mainServiceId': this.subService.main_service_id,
        'subServiceId': this.subService.sub_service_id,
        'dateStart': this.visualisationDateStart,
        'dateEnd': this.visualisationDateEnd };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        console.log(response.data);
        _this2.flagGraphDataIsUpdating = false;
        if (response.data.Code == 'OK') {
          _this2.GraphData = response.data.GraphData;

          _this2.barChartDataSub1.XData = response.data.BarData.subXData;
          _this2.barChartDataSub1.YData = response.data.BarData.subYData;

          _this2.flagDisplayGraph = true;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    var thisDayUnix = Math.floor(__WEBPACK_IMPORTED_MODULE_5_moment___default()().unix() / (24 * 3600)) * (24 * 3600);
    this.visualisationDateStart = (thisDayUnix - 7 * 24 * 3600) * 1000;
    this.visualisationDateEnd = thisDayUnix * 1000;
  }
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GraphApexBars__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GraphApexBars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GraphApexBars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GraphApexPies__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GraphApexPies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__GraphApexPies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Unit',
  props: ['unit'],

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,
      profileIsSaving: false,
      unitIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: 'Titre bannière', EN: 'Banner Title' },
      labelTitleBanner: { FR: 'Titre bannière', EN: 'Banner Title' },
      labelUnit: { FR: 'Unité', EN: 'Unit' },

      labelTitleGraph: { FR: "Mesures de l'unité", EN: 'Unit measurement' },
      flagReadByInvoiceData: false,
      labelButton: { FR: "Lire données selon les données de facturations de service",
        EN: 'Read data according to service billing data' },
      visualisationDateStart: '',
      visualisationDateEnd: '',

      flagDisplayGraph: false,
      flagGraphDataIsUpdating: false,
      labelSumCost: { FR: "Coûts total", EN: 'Sum costs' },
      labelCost: { FR: "Coûts", EN: 'Costs' },
      labelButtonReadGraph: { FR: "Actualiser le graphique", EN: 'Refresh graph' },
      GraphData: [],
      barChartDataUnit1: { ChartTitle: { FR: 'Coûts par jour par service',
          EN: 'Costs per day per service' },
        XData: [],
        YData: [],
        Options: { Stacked: true, StackType: "normal" } },

      barChartDataUnit2: { ChartTitle: { FR: 'Répartition par jours',
          EN: 'Distribution by days' },
        XData: [],
        YData: [],
        Options: { Stacked: true, StackType: "100%" } },

      pieChartData: { ChartTitle: { FR: 'Répartition des coûts pour la période sélectionnée', EN: 'Breakdown of costs for the selected period' },
        Labels: [],
        Data: [] },
      sumPeriodCosts: 0,

      labelButtonConfig: { FR: 'Configuration', EN: 'Configuration' },
      labelButtonConfigClose: { FR: 'Fermer configuration', EN: 'Close configuration' },
      labelButtonSaveModifications: { FR: 'Enregistrer modifications', EN: 'Save modifications' },
      labelUnitServiceAttributions: { FR: 'Attributions de services', EN: 'Service attribtions' },

      labelRefenrenceName: { FR: "Nom de référence de l'unité", EN: 'Unit reference name' },
      selectLabelLinkedChannel: { FR: "Appareil mesuré lié", EN: 'Linked monitored device' },

      tableAttributionsColumnTitle01: { FR: "Service liés", EN: "Linked Service" },
      tableAttributionsColumnTitle02: { FR: "Attribution (%)", EN: "Attribution (%)" },
      tableAttributionsColumnTitle03: { FR: "Supprimer", EN: "Delete" },

      labelAddAttributionSection: { FR: "Ajout d'attribution de service:", EN: "Add service attribution:" },
      tableAttributionsAdd: { FR: "Ajouter", EN: "Add" },
      tempoAttribution: '0',
      tempoService: {},
      bundleServiceIsLoading: false,
      selectLabelNewAttribution: { FR: "Services", EN: "Service" },
      bundleServiceList: [],

      labelSpecificationSection: { FR: "Spécifications de l'unité",
        EN: 'Unit spécification' },
      labelSpecType: { FR: "Type d'unité",
        EN: 'Unit type' },
      labelSpecArea: { FR: "Superficie de l'unité",
        EN: 'Unit area' },
      labelSpecYearOfConstruction: { FR: "Année de construction (ou de rénovation)",
        EN: 'Year of construction (or renovation)' },
      labelSpecHeatingIncluded: { FR: "Chauffage inclu dans les services",
        EN: 'Heating included in the services' },
      labelSpecHotIncludedIncluded: { FR: "Eau chaude incluse dans les services",
        EN: 'Hot water included in the services' },
      specAreaList: [],
      specTypeList: [],
      specYearOfConstructList: [],

      labelUnitTags: { FR: "Étiquette de l'unité (nécessaire pour les rapports de comparaison)", EN: 'Unit tags (necessary for comparison reports)' },
      labelUnitTagsHelp: { FR: "Maintenir la touche CTRL pour attribuer plusieurs étiquettes.",
        EN: 'Hold CTRL to assign multiple labels.' },
      labelUnitTagsHelp2: { FR: "Vous pouvez définir les étiquettes dans la section COMPLÉMENTS.",
        EN: 'You can define the labels in the COMPLEMENT section' },
      tagsList: [],
      messageList: [],

      labelFixCostExplanation: { FR: "Un coût fixe s'ajoute au relevé de consommation et s'applique pour la période mentionnée. Le coût total est divisé par le nombre de jour et ensuite calculé selon le nombre de jour du relevé. Un coût de type ANNUEL se voit répété a chaque années au mois et jour sélectionnés.",
        EN: "A fixed cost is added to the consumption statement and applies for the period mentioned. The total cost is divided by the number of days and then calculated according to the number of days of the statement. An ANNUAL type cost is repeated every year on the selected month and day." },
      labelTitleSectionFixCosts: { FR: "Coûts fixe", EN: 'Fixed costs' },
      labelButtonAddFixCost: { FR: 'Ajouter un coût fixe', EN: 'Add fixed cost' },
      fixCostColumn01: { FR: "Annuel", EN: 'Annual' },
      fixCostColumn02: { FR: "Date début", EN: 'Start date' },
      fixCostColumn03: { FR: "Date fin", EN: 'End date' },
      fixCostColumn04: { FR: "Description", EN: 'Description' },
      fixCostColumn05: { FR: "Coût total($)", EN: 'Total cost ($)' },
      fixCostColumn06: { FR: "Supprimer", EN: 'Delete' },

      labelActivated: { FR: "Activé", EN: 'Activated' },

      listDaysInMonth: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '11', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      periodicityOptions: [{ 'value': 'Monthly', 'displayText': { FR: "Mensuel", EN: 'Monthly' } }, { 'value': 'BiMonthly', 'displayText': { FR: "Bi Mensuel", EN: 'Bi monthly' } }]

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_3_element_ui__["TimeSelect"],
    GraphApexBars: __WEBPACK_IMPORTED_MODULE_4__GraphApexBars___default.a,
    GraphApexPies: __WEBPACK_IMPORTED_MODULE_5__GraphApexPies___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
      this.getBundleServiceList();
      this.getUnitTags();
      this.getSpecLists();

      if (this.flagDisplayBanner == -1) {
        this.readUnitGraphData();
      }
    },
    toggleConfigView: function toggleConfigView() {
      this.flagDisplayDetail = ~this.flagDisplayDetail;
    },
    saveUnitModifications: function saveUnitModifications() {
      var _this = this;

      var requestData = { 'postAction': 'SaveUnit',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'unitData': this.unit };
      this.unitIsSaving = true;
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.unitIsSaving = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
          _this.unitIsSaving = false;
        }
      });
    },
    getBundleServiceList: function getBundleServiceList() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetBundleServices',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'unitData': this.unit };
      this.bundleServiceIsLoading = true;
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.bundleServiceList = response.data.BundleServiceList;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
        _this2.bundleServiceIsLoading = false;
      });
    },
    getMessageListList: function getMessageListList() {
      var _this3 = this;

      var requestData = { 'postAction': 'GetMessageList',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this3.messageList = response.data.MessageList;
        } else {
          window.alert(response.data.PromptMessage[_this3.actualLanguage]);
        }
      });
    },
    addAttribution: function addAttribution() {
      var _this4 = this;

      this.tempoService.attribution = this.tempoAttribution;

      var requestData = { 'postAction': 'AddUnitServiceAttribution',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'unitData': this.unit,
        'serviceToAdd': this.tempoService };
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this4.unit.service_attributions = response.data.ServiceAttribution;
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    deleteAttribution: function deleteAttribution(index) {
      var _this5 = this;

      var requestData = { 'postAction': 'RemoveUnitServiceAttribution',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'unitData': this.unit,
        'indexToRemove': index };
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this5.unit.service_attributions = response.data.ServiceAttribution;
        } else {
          window.alert(response.data.PromptMessage[_this5.actualLanguage]);
        }
      });
    },
    getUnitTags: function getUnitTags() {
      var _this6 = this;

      var requestData = { 'postAction': 'GetUnitTags',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this6.tagsList = response.data.UnitTagsList;
        } else {
          window.alert(response.data.PromptMessage[_this6.actualLanguage]);
        }
      });
    },
    getSpecLists: function getSpecLists() {
      var _this7 = this;

      var requestData = { 'postAction': 'GetUnitSpecLists',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this7.specAreaList = response.data.SpecAreaList;
          _this7.specTypeList = response.data.SpecTypeList;
          _this7.specYearOfConstructList = response.data.SpecYearOfConstructList;
        } else {
          window.alert(response.data.PromptMessage[_this7.actualLanguage]);
        }
      });
    },
    addFixCostLine: function addFixCostLine() {
      this.unit.fix_costs.push({ 'yearlyFlag': false,
        'periodStart': '',
        'periodEnd': '',
        'description': '',
        'cost': '' });
    },
    deleteFixCost: function deleteFixCost(index) {
      this.unit.fix_costs.splice(index, 1);
    },
    readUnitGraphData: function readUnitGraphData() {
      var _this8 = this;

      this.flagDisplayGraph = false;
      this.flagGraphDataIsUpdating = true;
      var GraphReadPostAction = 'GetUnitGraphData';

      if (this.flagReadByInvoiceData) {
        GraphReadPostAction = 'GetUnitGraphDataFromInvoices';
      }

      var requestData = { 'postAction': GraphReadPostAction,
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer,
        'unitData': this.unit,
        'dateStart': this.visualisationDateStart,
        'dateEnd': this.visualisationDateEnd };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        _this8.flagGraphDataIsUpdating = false;
        if (response.data.Code == 'OK') {
          _this8.GraphData = response.data.GraphData;

          _this8.barChartDataUnit1.XData = response.data.BarData.unitXData;
          _this8.barChartDataUnit1.YData = response.data.BarData.unitYData;
          _this8.barChartDataUnit2.XData = response.data.BarData.unitXData;
          _this8.barChartDataUnit2.YData = response.data.BarData.unitYData;

          _this8.pieChartData.Labels = response.data.PieData.labels;
          _this8.pieChartData.Data = response.data.PieData.data;
          _this8.sumPeriodCosts = 0;
          for (var m = 0; m < _this8.pieChartData.Data.length; m++) {
            _this8.sumPeriodCosts += _this8.pieChartData.Data[m];
          }
          _this8.sumPeriodCosts = parseFloat(_this8.sumPeriodCosts.toFixed(2));

          _this8.flagDisplayGraph = true;
        } else {
          window.alert(response.data.PromptMessage[_this8.actualLanguage]);
        }
      });
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {
    this.getBundleServiceList();
    this.getMessageListList();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    var thisDayUnix = Math.floor(__WEBPACK_IMPORTED_MODULE_6_moment___default()().unix() / (24 * 3600)) * (24 * 3600);
    this.visualisationDateStart = (thisDayUnix - 7 * 24 * 3600) * 1000;
    this.visualisationDateEnd = thisDayUnix * 1000;
  }
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_apexcharts__);










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_6_vue_apexcharts___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitStats',
  props: ['unitList'],

  data: function data() {
    return {
      flagDisplayBanner: 0,
      flagDisplayDetail: 0,
      profileIsSaving: false,
      unitIsSaving: false,
      actualLanguage: "FR",
      labelTitleBanner: { FR: "Statistiques d'unités", EN: 'Units statistics' },

      flagReadByInvoiceData: false,
      labelButton: { FR: "Données selon les saisies de factures",
        EN: 'Read data according to billing data' },
      lableActivated: { FR: "Activé", EN: 'Enabled' },
      lableNotActivated: { FR: "Désactivé", EN: 'Disabled' },

      visualisationDateStart: '',
      visualisationDateEnd: '',
      labelButtonReadGraph: { FR: "Lire les données", EN: 'Read data' },

      labelFiltreSection: { FR: "Filtre", EN: 'Filter' },
      labelTagSelect: { FR: "Étiquette", EN: 'Tag' },
      selectedTag: 'All',
      selectedType: 'All',
      selectedArea: 'All',
      selectedYearOfConstruction: 'All',
      labelSpecType: { FR: "Type d'unité",
        EN: 'Unit type' },
      labelSpecArea: { FR: "Superficie de l'unité",
        EN: 'Unit area' },
      labelSpecYearOfConstruction: { FR: "Année de construction",
        EN: 'Year of construction)' },

      specAreaList: [],
      specTypeList: [],
      specYearOfConstructList: [],
      tagsList: [],

      unitFilterFlagList: [],
      unitListID: [],
      unitData: [],

      flagDisplayGraph: false,
      flagDisplayStatTable: false,
      flagGraphDataIsUpdating: false,
      unitsData: [],
      unitsDataFiltered: [],
      averageCost: { FR: "Coût moyen par unité", EN: 'Average costs per unit' },
      averageCostValue: 0,
      averageCostPerDay: [],

      statTableColumn01: { FR: "Unité", EN: 'Unit' },
      statTableColumn02: { FR: "Étiquette", EN: 'Tag' },
      statTableColumn03: { FR: "Spécifications", EN: 'Specification' },
      statTableColumn04: { FR: "Occupant", EN: 'Occupant' },
      statTableColumn05: { FR: "Coût", EN: 'Costs' },
      statTableColumn06: { FR: "Ratio selon la moyenne", EN: 'Ratio vs average' },

      chartTitle: { FR: "Coûts journalier", EN: 'Daily costs' },
      chartYlabel: { FR: "Coûts ($)", EN: 'Costs ($)' },
      buttonCloseChart: { FR: "Fermer", EN: 'Close' },
      chartLine2Label: { FR: "Coûts moyen", EN: 'Average costs' },
      chartDataSeries: [{ name: 'line 1', type: 'column', data: [440, 505] }, { name: 'line 2', type: 'column', data: [440, 600] }],

      unitGraphOptions: {
        chart: {
          height: 350,
          type: 'line'
        },
        stroke: {
          width: [0, 4]
        },
        title: {
          text: 'Traffic Sources'
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0, 1]
        },
        labels: ['23-10-01', '23-10-02'],
        xaxis: {
          type: 'normal'
        },
        yaxis: [{
          title: {
            text: 'Website Blog'
          }

        }]
      }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_4_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_4_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_4_element_ui__["TimeSelect"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'actualBundle', 'parentContainer'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
      this.getUnitTags();
      this.getSpecLists();
    },
    toggleConfigView: function toggleConfigView() {
      this.flagDisplayDetail = ~this.flagDisplayDetail;
    },
    getUnitTags: function getUnitTags() {
      var _this = this;

      var requestData = { 'postAction': 'GetUnitTags',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.tagsList = response.data.UnitTagsList;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    getSpecLists: function getSpecLists() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetUnitSpecLists',
        'bundleId': this.actualBundle.bundle_id,
        'parentContainer': this.parentContainer };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          console.log('--Spec List---');
          console.log(response.data);
          _this2.specAreaList = response.data.SpecAreaList;
          _this2.specTypeList = response.data.SpecTypeList;
          _this2.specYearOfConstructList = response.data.SpecYearOfConstructList;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    applyUnitFilter: function applyUnitFilter() {
      this.flagDisplayStatTable = false;
      this.flagDisplayGraph = false;
      this.unitsDataFiltered = [];
      for (var n = 0; n < this.unitList.length; n++) {
        this.unitFilterFlagList[n] = true;

        if (this.selectedTag != 'All') {
          this.unitFilterFlagList[n] = false;
          for (var m = 0; m < this.unitList[n].unit_tags.length; m++) {
            if (this.unitList[n].unit_tags[m] == this.selectedTag) {
              this.unitFilterFlagList[n] = true;
            }
          }
        }

        if (this.selectedType != 'All') {
          this.unitFilterFlagList[n] = this.unitFilterFlagList[n] && this.unitList[n].spec_type_id == this.selectedType;
        }

        if (this.selectedArea != 'All') {
          this.unitFilterFlagList[n] = this.unitFilterFlagList[n] && this.unitList[n].spec_area_id == this.selectedArea;
        }

        if (this.selectedYearOfConstruction != 'All') {
          this.unitFilterFlagList[n] = this.unitFilterFlagList[n] && this.unitList[n].spec_building_construction_year_id == this.selectedYearOfConstruction;
        }

        if (this.unitFilterFlagList[n]) {
          this.unitsDataFiltered.push(this.unitsData[n]);
          this.unitsDataFiltered[this.unitsDataFiltered.length - 1]['tags'] = this.selecTagNameFromID(this.unitList[n].unit_tags);
          this.unitsDataFiltered[this.unitsDataFiltered.length - 1]['type'] = this.selecSpecNameFromID(this.unitList[n].spec_type_id);
          this.unitsDataFiltered[this.unitsDataFiltered.length - 1]['area'] = this.selecAreaNameFromID(this.unitList[n].spec_area_id);
          this.unitsDataFiltered[this.unitsDataFiltered.length - 1]['yoc'] = this.selecYocNameFromID(this.unitList[n].spec_building_construction_year_id);
        }
      }

      this.averageCostValue = 0;
      for (var m = 0; m < this.unitsDataFiltered.length; m++) {
        var SumCost = 0;
        if (m == 0) {
          this.averageCostPerDay = this.unitsDataFiltered[m].SumService.map(function (x) {
            return x;
          });
        }

        for (var i = 0; i < this.unitsDataFiltered[m].SumService.length; i++) {
          SumCost += this.unitsDataFiltered[m].SumService[i];
          if (m > 0) {
            this.averageCostPerDay[i] += this.unitsDataFiltered[m].SumService[i];
          }
        }
        this.unitsDataFiltered[m]['SumCost'] = parseFloat(SumCost.toFixed(2));
        this.averageCostValue += SumCost;
      }

      this.averageCostValue = Math.round(this.averageCostValue / m * 100) / 100;
      for (var j = 0; j < this.unitsDataFiltered.length; j++) {
        this.unitsDataFiltered[j]['CostVsAverage'] = parseFloat((this.unitsDataFiltered[j].SumCost / this.averageCostValue * 100).toFixed(1));
      }

      for (var j = 0; j < this.averageCostPerDay.length; j++) {
        this.averageCostPerDay[j] = parseFloat((this.averageCostPerDay[j] / m).toFixed(2));
      }
      this.flagDisplayStatTable = true;
    },
    selecTagNameFromID: function selecTagNameFromID(TagId) {
      var returnArray = [];
      for (var m = 0; m < TagId.length; m++) {
        for (var i = 0; i < this.tagsList.length; i++) {
          if (this.tagsList[i].tagId == TagId[m]) {
            returnArray.push(this.tagsList[i].tagName);
          }
        }
      }
      return returnArray;
    },
    selecSpecNameFromID: function selecSpecNameFromID(SpecId) {
      var returnValue = '';
      for (var i = 0; i < this.specTypeList.length; i++) {
        if (this.specTypeList[i].list_id == SpecId) {
          returnValue = this.specTypeList[i].description[this.actualLanguage];
        }
      }
      return returnValue;
    },
    selecAreaNameFromID: function selecAreaNameFromID(AreaId) {
      var returnValue = '';
      for (var i = 0; i < this.specAreaList.length; i++) {
        if (this.specAreaList[i].list_id == AreaId) {
          returnValue = this.specAreaList[i].description[this.actualLanguage];
        }
      }
      return returnValue;
    },
    selecYocNameFromID: function selecYocNameFromID(YocId) {
      var returnValue = '';
      for (var i = 0; i < this.specYearOfConstructList.length; i++) {
        if (this.specYearOfConstructList[i].list_id == YocId) {
          returnValue = this.specYearOfConstructList[i].description[this.actualLanguage];
        }
      }
      return returnValue;
    },
    buildUnitListID: function buildUnitListID() {
      this.unitListID = [];
      for (var n = 0; n < this.unitList.length; n++) {
        this.unitListID.push(this.unitList[n].unit_id);
      }
    },
    displayUnitGraph: function displayUnitGraph(index) {
      var _this3 = this;

      this.flagDisplayGraph = false;
      this.unitGraphOptions.title.text = this.chartTitle[this.actualLanguage].concat(" : ", this.unitsDataFiltered[index].UnitName);
      this.unitGraphOptions.yaxis[0].title.text = this.chartYlabel[this.actualLanguage];
      this.unitGraphOptions.labels = this.unitsDataFiltered[index].UnitXData;

      this.chartDataSeries[0].name = this.unitsDataFiltered[index].UnitName;
      this.chartDataSeries[0].data = this.unitsDataFiltered[index].SumService;

      this.chartDataSeries[1].name = this.chartLine2Label[this.actualLanguage];
      this.chartDataSeries[1].data = this.averageCostPerDay;
      this.$nextTick(function () {
        _this3.flagDisplayGraph = true;
      });
    },
    readUnitsGraphData: function readUnitsGraphData() {
      var _this4 = this;

      this.buildUnitListID();

      this.flagDisplayGraph = false;
      this.flagDisplayStatTable = false;
      this.flagGraphDataIsUpdating = true;
      var GraphReadPostAction = 'GetMuttipleUnitsData';

      if (this.flagReadByInvoiceData) {
        GraphReadPostAction = 'GetMuttipleUnitsDataFromInvoices';
      }

      var requestData = { 'postAction': GraphReadPostAction,
        'bundleId': this.actualBundle.bundle_id,
        'unitList': this.unitListID,
        'selectedTag': this.selectedTag,
        'selectedType': this.selectedType,
        'selectedArea': this.selectedArea,
        'selectedYearOfConstruction': this.selectedYearOfConstruction,
        'dateStart': this.visualisationDateStart,
        'dateEnd': this.visualisationDateEnd };

      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        console.log(response);
        _this4.flagGraphDataIsUpdating = false;
        if (response.data.Code == 'OK') {
          _this4.unitsData = response.data.UnitsData;

          for (var unit = 0; unit < _this4.unitsData.length; unit++) {
            for (var service = 0; service < _this4.unitsData[unit].SumService.length; service++) {
              _this4.unitsData[unit].SumService[service] = parseFloat(_this4.unitsData[unit].SumService[service].toFixed(2));
            }
          }

          _this4.applyUnitFilter();
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    var thisDayUnix = Math.floor(__WEBPACK_IMPORTED_MODULE_5_moment___default()().unix() / (24 * 3600)) * (24 * 3600);
    this.visualisationDateStart = (thisDayUnix - 7 * 24 * 3600) * 1000;
    this.visualisationDateEnd = thisDayUnix * 1000;

    this.unitFilterFlagList = [];
    for (var n = 0; n < this.unitList.length; n++) {
      this.unitFilterFlagList.push(true);
    }
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tile'],

  data: function data() {
    return {
      actualLanguage: "FR",
      testColor: '#46c37b'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData'])),
  watch: {},
  methods: {},

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {}
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {}
});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewEditManualInvoice__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewEditManualInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewEditManualInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewEditIntegratorData__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewEditIntegratorData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ViewEditIntegratorData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',

  data: function data() {
    return {
      isOpen: true,
      dataTempo01: 'test',
      dataTempo02: 'test',
      loadingData: false,
      flagDisplayAddService: 0,
      flagDisplayUploadSubscription: false,
      flagDisplayReadEventLog: 0,
      displayMessage: '--',

      moduleBindingData: '',
      codeConfirmed: false,
      transmitDataModel: {
        deviceId: '',
        deviceKey: '',
        monthFree: '36',
        subscriptionTemplate: 'ND'
      },

      planDescription: {},
      flagShowPlanListOption: false,
      flagPlanCodeReceived: false,
      PlanCode: '',
      ValidationCode: '',

      readEventLogDataModel: {
        profileid: '',
        startDate: '2020-01-01'
      },

      tableData: {
        tableTitle: [{ FR: 'TimeStamp', EN: 'Timestamp' }, { FR: 'Action', EN: 'Action' }, { FR: 'Detail', EN: 'Detail' }],
        tableData: [['Vide', 'Vide', 'Vide']],
        flagDisplayHistogramSection: false
      },
      eventLogData: [],
      actualLanguage: "FR"

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    DynamicTable: __WEBPACK_IMPORTED_MODULE_2__components_DynamicDataTable1___default.a,
    ViewEditManualInvoice: __WEBPACK_IMPORTED_MODULE_3__ViewEditManualInvoice___default.a,
    ViewEditIntegratorData: __WEBPACK_IMPORTED_MODULE_4__ViewEditIntegratorData___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData', 'actualBundle', 'authToken', 'idToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('devicesStore', ['devices', 'devicesPortData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayAddService: function toggleDisplayAddService() {
      this.flagDisplayAddService = ~this.flagDisplayAddService;
    },
    toggleDisplayReadEventLog: function toggleDisplayReadEventLog() {
      this.flagDisplayReadEventLog = ~this.flagDisplayReadEventLog;
    },
    getUserPlanList: function getUserPlanList() {
      var _this = this;

      var requestData = { 'postAction': 'GetUserPlanList',
        'subscriptionListId': "EndUserPlanList_V02P04"
      };

      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.planDescription = response.data.PlanList;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    generatePreRegisteredPlan: function generatePreRegisteredPlan() {
      var _this2 = this;

      var requestData = { 'postAction': 'GeneratePreRecordedPlan',
        'template': this.transmitDataModel.subscriptionTemplate,
        'freemonth': this.transmitDataModel.monthFree
      };
      this.flagPlanCodeReceived = false;
      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.PlanCode = response.data.PlanCode;
          _this2.ValidationCode = response.data.ValidationCode;
          _this2.flagPlanCodeReceived = true;
        }
      });
    },
    getUserEventLogs: function getUserEventLogs() {
      var _this3 = this;

      this.eventLogData = [];
      this.loadingData = true;
      return this.$store.dispatch('sessionStore/getEventsLog', this.readEventLogDataModel).then(function (response) {
        _this3.eventLogData = response.data.eventLogData.reverse();

        _this3.tableData.tableData = [];
        for (var i = 0; i < _this3.eventLogData.length; i++) {
          _this3.tableData.tableData.push([_this3.eventLogData[i].timestamp, _this3.eventLogData[i].Action, _this3.eventLogData[i].Details]);
        }
        _this3.loadingData = false;
      });
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    toggleIsOpen: function toggleIsOpen() {
      this.isOpen = !this.isOpen;
    }
  }),

  mounted: function mounted() {
    this.readEventLogDataModel.profileid = this.profileData.profileInfo.email;
    window.scrollTo(0, 0);

    this.getUserPlanList();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GroupIndex',
    props: ['inputData'],
    data: function data() {
        return {
            flagDisplayBanner: 0,
            profileIsSaving: false,
            actualLanguage: "FR",
            labelTitleSection: { FR: 'Intégrateurs', EN: 'Integrator' },
            labelTitleBanner: { FR: 'Configuration et Rapports de commissions', EN: 'Configuration and Commissions reports' },

            organizationList: [],
            selectedOrganizationId: '',

            integratorOptionsIsReading: true,
            integratorOptions: {},
            integratorParent: 'ND',

            reportsIsReading: true,
            reportsList: [],
            reportIsSaving: [],
            historyLength: 20,

            labelButtonReadHistory: { FR: "Lire l'historique de rapport", EN: 'Read report history' },
            labelHistoryLength: { FR: "Nombre de lignes lues", EN: 'Read lines' },

            labelTabel01_Col01: { FR: 'Rapport', EN: 'Report' },
            labelTabel01_Col02: { FR: 'Transaction liées', EN: 'Linked transaction' },
            labelTabel01_Col03: { FR: 'Facturation', EN: 'Billing' },
            labelTabel01_Col04: { FR: 'Paiement', EN: 'Payment' },
            labelTabel01_Col05: { FR: '', EN: '' },
            labelTabel01_Col06: { FR: 'Rapport lié', EN: 'Linked report' },
            labelAddToReport: { FR: 'Ajouter au rapport', EN: 'Add to report' },
            labelInvoiceAmount: { FR: 'Montant', EN: 'Amount' },

            labelInvoiceReferenceNumber: { FR: 'Numéro de référence', EN: 'Reference number' },
            labelButtonInvoiceReferenceNumber: { FR: 'Enregistrer', EN: 'Save' },

            messageAlertSelectLines: { FR: 'Vous devez sélectionner des transactions (colonne AJOUTER AU RAPPORT).',
                EN: 'You must select transactions lines (column ADD TO REPORT)' },
            messageConfirmCreateReport: { FR: 'Vous confirmer la création du rapport de commissions?',
                EN: 'Confirm the commission report generation?' }

        };
    },

    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
        toggleDisplayBanner: function toggleDisplayBanner() {
            this.getReportsHistory();
            this.flagDisplayBanner = ~this.flagDisplayBanner;
        },
        getOrganizationList: function getOrganizationList() {
            var _this = this;

            var requestData = { 'postAction': 'ReadOrganizationList',
                'organizationId': 'None' };
            this.profileIsSaving = true;
            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this.organizationList = response.data.OrganizationsList;
                } else {
                    window.alert(response.data.PromptMessage[_this.actualLanguage]);
                }
            });
        },
        getIntegratorOptions: function getIntegratorOptions() {
            var _this2 = this;

            var requestData = { 'postAction': 'IntegratorGetIntegratorOptions',
                'organizationId': this.selectedOrganizationId };
            this.integratorOptionsIsReading = true;

            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this2.integratorOptions = response.data.IntegratorOptions;
                    _this2.integratorParent = response.data.ParentIntegratorName + "  [" + response.data.ParentIntegratorId + "]";

                    _this2.integratorOptionsIsReading = false;
                } else {
                    window.alert(response.data.PromptMessage[_this2.actualLanguage]);
                    _this2.integratorOptionsIsReading = false;
                }
            });
        },
        addCommissionLevel: function addCommissionLevel() {
            this.integratorOptions.commissions.push(0);
        },
        removeCommissionLevel: function removeCommissionLevel() {
            this.integratorOptions.commissions.pop();
        },
        saveIntegratorOptions: function saveIntegratorOptions() {
            var _this3 = this;

            var requestData = { 'postAction': 'IntegratorSaveIntegratorOptions',
                'organizationId': this.selectedOrganizationId,
                'options': this.integratorOptions };

            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    window.alert("Options intégrateur enregistrée");
                } else {
                    window.alert(response.data.PromptMessage[_this3.actualLanguage]);
                    _this3.integratorOptionsIsReading = false;
                }
            });
        },
        getReportsHistory: function getReportsHistory() {
            var _this4 = this;

            if (this.selectedOrganizationId.includes('ORG')) {
                this.getIntegratorOptions();
            }

            var requestData = { 'postAction': 'IntegratorGetReportsHistory',
                'organizationId': this.selectedOrganizationId,
                'readItems': this.historyLength };
            this.reportsIsReading = true;
            this.reportIsSaving = [];
            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this4.reportsList = response.data.ReportsList;
                    for (var m = 0; m < _this4.reportsList.length; m++) {
                        _this4.reportIsSaving.push(false);
                    }
                    _this4.reportsIsReading = false;
                } else {
                    window.alert(response.data.PromptMessage[_this4.actualLanguage]);
                    _this4.reportsIsReading = false;
                }
            });
        },
        saveReportReferenceNumber: function saveReportReferenceNumber(index) {
            var _this5 = this;

            var requestData = { 'postAction': 'IntegratorUpdateReportData',
                'organizationId': this.selectedOrganizationId,
                'reportData': this.reportsList[index] };
            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                if (response.data.Code == 'OK') {} else {
                    window.alert(response.data.PromptMessage[_this5.actualLanguage]);
                }
            });
        }
    }),

    mounted: function mounted() {
        this.getOrganizationList();

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
    }
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['inputData'],
  data: function data() {
    return {
      flagDisplayBanner: 0,
      profileIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: "Historique de transaction d'organisation", EN: 'Organization transaction history' },
      labelTitleBanner: { FR: 'Historique de transaction', EN: 'Transaction history' },
      organizationList: [],
      selectedOrganizationId: '',
      flagDisplaySectionTransactions: true,
      transactions: [],
      transactionOpenFlag: [],
      transactionIsSaving: false,

      transactionIsReading: false,

      textLabelProduct: { FR: "Produit", EN: 'Product' },
      textLabelLastPaimentDate: { FR: "Date du précédent prélèvement : ", EN: 'Previous payment date:' },
      textLabelNextPaimentDate: { FR: "Date du prochain prélèvement : ", EN: 'Next payment date:' },
      InvoiceText: { FR: "Facture: ", EN: 'Invoice: ' },
      InvoiceTitle: { FR: "SERVICE PLATEFORME ADMINISTRATEUR", EN: 'MANAGER PLATFORM CHARGE' },
      InvoiceCustomer: { FR: "CLIENT: ", EN: 'CUSTOMER: ' },
      InvoicePaidBy: { FR: "PAYÉ AVEC: ", EN: 'PAID BY: ' },
      InvoiceQuantity: { FR: "Quantité", EN: 'Quantity' },
      InvoiceUnitPrice: { FR: "Prix unitaire", EN: 'Unit price' },
      InvoicePrice: { FR: "Prix", EN: 'Price' },
      InvoiceSubTotal: { FR: "Sous total", EN: 'Sub total' },
      CardInfoPaidBy: { FR: "Payé par:", EN: 'Paid by:' },
      CardInfoLast4: { FR: "Finissant par:", EN: 'Last digits:' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.flagDisplayBanner = ~this.flagDisplayBanner;
    },
    toggleDisplayTransaction: function toggleDisplayTransaction(index) {
      this.flagDisplaySectionTransactions = 0;
      this.transactionOpenFlag[index] = ~this.transactionOpenFlag[index];
      this.flagDisplaySectionTransactions = -1;
    },
    getOrganizationList: function getOrganizationList() {
      var _this = this;

      var requestData = { 'postAction': 'ReadOrganizationList',
        'organizationId': 'None' };
      this.profileIsSaving = true;
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.organizationList = response.data.OrganizationsList;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    getTransactionHistory: function getTransactionHistory() {
      var _this2 = this;

      var requestData = { 'postAction': 'ReadOrganizationTransactionHistory',
        'organizationId': this.selectedOrganizationId
      };

      this.transactionIsReading = true;
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.transactions = response.data.TransactionHistory;
          _this2.transactionOpenFlag = [];
          for (var m = 0; m < _this2.transactions.length; m++) {
            _this2.transactionOpenFlag.push(0);
            if (parseFloat(_this2.transactions[m].subTotal) < 0) {
              _this2.transactions[m].subTotal = "0";
            }
            if (parseFloat(_this2.transactions[m].tps) < 0) {
              _this2.transactions[m].tps = "0";
            }
            if (parseFloat(_this2.transactions[m].tvq) < 0) {
              _this2.transactions[m].tvq = "0";
            }
            if (parseFloat(_this2.transactions[m].total) < 0) {
              _this2.transactions[m].total = "0";
            }

            for (var n = 0; n < _this2.transactions[m].taxesList.length; n++) {
              if (parseFloat(_this2.transactions[m].taxesList[n].Amount) < 0) {
                _this2.transactions[m].taxesList[n].Amount = "0";
              }
            }
          }
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
      this.transactionIsReading = false;
    },
    saveTransactionPaymentInformation: function saveTransactionPaymentInformation(index) {
      var _this3 = this;

      var requestData = { 'postAction': 'SaveTransactionPaymentInfo',
        'organizationId': this.selectedOrganizationId,
        'transaction': this.transactions[index] };
      this.transactionIsSaving = true;
      console.log(requestData);
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        console.log(response);
        if (response.data.Code == 'OK') {
          _this3.transactionIsSaving = false;
        } else {
          _this3.transactionIsSaving = false;
          window.alert(response.data.PromptMessage[_this3.actualLanguage]);
        }
      });
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {
    this.getOrganizationList();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateGroupForm',
    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
    },
    data: function data() {
        return {
            errorMsg: '',
            groupInfo: {
                profileId: '',
                groupName: ''
            },
            displayMessage: false,

            actualLanguage: "FR",
            labelFieldTitleAddGroup: { FR: 'Ajouter un groupe au profile:', EN: 'Add group to profile' },
            labelFieldGroupName: { FR: 'Nom du groupe:', EN: 'Group name:' },
            labelButtonConfirmed: { FR: 'Créer le groupe', EN: 'Create Group' },
            textDisplayMessage: { FR: 'Groupe créé!', EN: 'Group created' },
            labelField: { FR: '', EN: '' }
        };
    },


    props: ['componentState'],

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'groupArborescence', 'actualGroup', 'actualBundle'])),

    methods: {
        createGroup: function createGroup() {
            var _this = this;

            this.displayMessage = '';
            this.groupInfo.profileId = this.profileData.profileId;
            return this.$store.dispatch('groupStore/createNewGroupInProfile', this.groupInfo).then(function (response) {
                _this.groupInfo.groupName = '';
                _this.displayMessage = true;
            });
        }
    },

    created: function created() {
        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
    }
});

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSubGroupForm',
    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
    },
    data: function data() {
        return {
            errorMsg: '',
            groupInfo: {
                profileId: '',
                parentGroupId: '',
                newGroupName: ''
            },
            displayMessage: false,

            actualLanguage: "FR",
            labelFieldTitleAddGroup: { FR: 'Ajouter un sous groupe au groupe:', EN: 'Add sub group to group:' },
            labelFieldGroupName: { FR: 'Nom du groupe:', EN: 'Group name:' },
            labelButtonConfirmed: { FR: 'Créer le groupe', EN: 'Create Group' },
            textDisplayMessage: { FR: 'Groupe créé!', EN: 'Group created' },
            labelField: { FR: '', EN: '' }
        };
    },


    props: ['componentState'],

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'groupArborescence', 'actualGroup', 'actualBundle'])),

    methods: {
        createSubGroup: function createSubGroup() {
            var _this = this;

            this.displayMessage = '';
            this.groupInfo.profileId = this.profileData.profileId;
            this.groupInfo.parentGroupId = this.actualGroup.group_id;
            return this.$store.dispatch('groupStore/createNewGroupInGroup', this.groupInfo).then(function (response) {
                _this.groupInfo.newGroupName = '';
                _this.displayMessage = true;
            });
        },
        createSubGroup2: function createSubGroup2() {
            var _this2 = this;

            this.displayMessage = '';
            this.groupInfo.profileId = this.profileData.profileId;
            this.groupInfo.parentGroupId = this.actualGroup.group_id;

            this.$store.dispatch('groupStore/createNewGroupInGroup', this.groupInfo).then(function (response) {
                _this2.groupInfo.newGroupName = '';
                _this2.displayMessage = true;

                _this2.$store.dispatch('overlayStore/pushNotification', { text: "Groupe créé", type: 'success' });
            }).catch(function (error) {
                _this2.$store.dispatch('overlayStore/pushNotification', { text: "Erreur d'enregistrement", type: 'error' });
            });
        }
    },

    created: function created() {
        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
    }
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'groupIndex',
  data: function data() {
    return {
      displayAddGroupToUser: false,
      displayAddSubGroupToGroup: false,
      selectedDevices: 0,
      loadingPort: true,
      localIp: '',
      actualLanguage: "FR",
      labelTopPage: { FR: 'Mesure électrique', EN: 'Energy monitor' }
    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    CreateGroupForm: __WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm___default.a,
    CreateSubGroupForm: __WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'groupArborescence', 'actualGroup', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('groupStore', ['actualGroupLevel'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    closeDisplayAddGroupToUser: function closeDisplayAddGroupToUser() {
      this.displayAddGroupToUser = false;
      this.$store.dispatch('sessionStore/getGroupArborescence');
    },
    closeDisplayAddSubGroupToGroup: function closeDisplayAddSubGroupToGroup() {
      this.displayAddSubGroupToGroup = false;
      this.$store.dispatch('sessionStore/getGroupArborescence');
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  data: function data() {
    return {
      flagDisplayAddFaq: 0,

      labelButtonConfigurationDocumentation: { FR: 'Instructions de configuration', EN: 'Configuration instruction' },
      labelButtonUserGuideDocumentation: { FR: 'Guide utilisateur (Usagers)', EN: 'User guide (End user)' },
      labelButtonElectricalMeasurementDocumentation: { FR: 'Mesures électriques (tutoriel)', EN: 'Electrical measurement tutorial' },

      DocumentTableTitle: { FR: 'Documentation', EN: 'Documentation' },
      DocumentTableDetail: { FR: "Liste des documents disponibles. Si vous ne trouvez pas l'information recherchée, merci de nous transmettre votre demande en utilisant le bouton Demande d'assistance.",
        EN: 'This is the list of available documents. If you do not find information you are looking for, please send us a request by using the Transmit support request button.' },

      DocumentListIsReading: false,
      DocumentTableContain: [],

      labelText01: { FR: "Consultez notre FAQ, vous pourriez y trouviez votre réponse! ", EN: 'Please check our FAQ, you may found your answer!' },
      labelText010: { FR: "Si un des sujets correspond à votre situation, vous n'avez qu'à cliquez sur le sujet correspondant pour voir la solution proposée.", EN: 'If one subject corresponds to your question, click on it to see the proposed solution.' },

      labelText02: { FR: "Vous n'avez pas trouver votre réponse? Transmettez-nous votre demande d'assistance:", EN: 'You did not found your answer? Please send us your support request:' },
      labelButtonSendMessage: { FR: "Demande d'assistance", EN: 'Transmit support request' },

      readEventLogDataModel: {
        profileid: '',
        startDate: '2020-01-01'
      },
      eventLogData: [],
      actualLanguage: 'FR',

      faqItems: [],
      faqId: [],
      faqIdTag: [],

      faqSubId: [],
      faqSubIdTag: []

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a

  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayAddFaq: function toggleDisplayAddFaq() {
      this.flagDisplayAddFaq = ~this.flagDisplayAddFaq;
    },
    toggleDisplayReadEventLog: function toggleDisplayReadEventLog() {
      this.flagDisplayReadEventLog = ~this.flagDisplayReadEventLog;
    },
    openConfigurationProcedure: function openConfigurationProcedure() {
      var localUrl = '';
      if (this.actualLanguage == 'FR') {
        localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf";
      }
      if (this.actualLanguage == 'EN') {
        localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf";
      }

      window.open(localUrl, '_blank');
    },
    openDocumentInTable: function openDocumentInTable(FileLink) {
      var localUrl = '';
      window.open(FileLink, '_blank');
    },
    openUserGuide: function openUserGuide() {
      var localUrl = '';
      if (this.actualLanguage == 'FR') {
        localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Manuel_Utilisateur_Portail_EL-IOT_Version_Usagers_R01.pdf";
      }
      if (this.actualLanguage == 'EN') {
        localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Manuel_Utilisateur_Portail_EL-IOT_Version_Usagers_R01.pdf";
      }

      window.open(localUrl, '_blank');
    },
    openElectricalMeasurementGuide: function openElectricalMeasurementGuide() {
      var localUrl = '';
      if (this.actualLanguage == 'FR') {
        localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Guide_utilisateur_mesures_de_circuits_electriques_R01.pdf";
      }
      if (this.actualLanguage == 'EN') {
        localUrl = "https://s3.amazonaws.com/evsenscloud.com/documents/Guide_utilisateur_mesures_de_circuits_electriques_R01.pdf";
      }

      window.open(localUrl, '_blank');
    },
    getUserEventLogs: function getUserEventLogs() {
      var _this = this;

      this.eventLogData = [];
      return this.$store.dispatch('sessionStore/getEventsLog', this.readEventLogDataModel).then(function (response) {
        _this.eventLogData = response.data.eventLogData.reverse();
      });
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    getListHelpDocuments: function getListHelpDocuments() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetHelpDocumentList',
        'helpListVersion': 'V1P00' };
      this.DocumentListIsReading = true;
      this.$store.dispatch('sessionStore/postSupport', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.DocumentTableContain = response.data.Documents;
          _this2.DocumentListIsReading = false;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    getFaqItems: function getFaqItems() {
      var _this3 = this;

      var requestData = { 'postAction': 'GetAllItemOver0',
        'partitionKey': "FAQ_EVSENS_V1P01" };
      this.$store.dispatch('sessionStore/postFrontEndTemplates', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this3.faqItems = response.data.TemplateItems;
          _this3.faqId = [];
          _this3.faqIdTag = [];
          _this3.faqSubId = [];
          _this3.faqSubIdTag = [];

          var mm = 0;
          var faqSubIdTempo = [];
          var faqSubIdTagTempo = [];
          for (var m = 0; m < response.data.TemplateItems.length; m++) {
            _this3.faqId.push('faq' + m);
            _this3.faqIdTag.push('#faq' + m);
            faqSubIdTempo = [];
            faqSubIdTagTempo = [];
            for (mm = 0; mm < response.data.TemplateItems[m].issues.length; mm++) {
              faqSubIdTempo.push('faq' + m + '_q' + mm);
              faqSubIdTagTempo.push('#faq' + m + '_q' + mm);
            }
            _this3.faqSubId.push(faqSubIdTempo);
            _this3.faqSubIdTag.push(faqSubIdTagTempo);
          }
        }
      });
    }
  }),

  mounted: function mounted() {
    this.readEventLogDataModel.profileid = this.profileData.profileInfo.email;

    this.getFaqItems();
    this.getListHelpDocuments();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransmitHelpRequestForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      savingCar: false,

      actualStatus: '01',
      messageRequestIsSending: false,
      userMessage: '',

      actualLanguage: "FR",
      labelFieldTitle: { FR: "Demande d'assistance", EN: 'Support request' },
      labelTextBoxTitle: { FR: "Décrire le problème que vous rencontrez.", EN: 'Describe your issue.' },
      labelInFieldMessage: { FR: "Écrire votre message ici..", EN: 'Enter your message here..' },
      labelButtonSendMessage: { FR: "Envoyé le message", EN: 'Send message' },
      messageTransmitOk: { FR: "Message envoyé, le service technique vous contactera sous peu par courriel. Vous pouvez fermer cette fenêtre.", EN: 'Message sent, the technical service will contact you by email. You can close this window.' },
      messageTransmitFail: { FR: "Une erreur de transmission s'est produite. Fermez cette fenêtre et essayez à nouveau.", EN: 'Communication error occurs, close this window and try again.' }
    };
  },


  methods: {
    sendSupportRequest: function sendSupportRequest() {
      var _this = this;

      var requestData = { 'postAction': 'SendSupportMessage',
        'RequestMessage': this.userMessage };
      this.messageRequestIsSending = true;
      this.$store.dispatch('sessionStore/postSupport', requestData).then(function (response) {
        _this.messageRequestIsSending = false;
        if (response.data.Code == 'OK') {
          _this.actualStatus = 'MessageTransmitOk';
        } else {
          _this.actualStatus = 'MessageTransmitFail';
        }
      });
    }
  },

  created: function created() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubComponents_ApiDevicePanesV1p00_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubComponents_ApiDevicePanesV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SubComponents_ApiDevicePanesV1p00_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a,
    PortGraph: __WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue___default.a,
    RelativePowerBar: __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue___default.a,
    MultipleGraph: __WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue___default.a,
    ChannelJournal: __WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue___default.a,
    ApiDevicePanesV1p00: __WEBPACK_IMPORTED_MODULE_9__SubComponents_ApiDevicePanesV1p00_vue___default.a
  },

  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      flagDisplayChannel: 0,
      flagDisplayGraph: true,
      flagChannelDataIsLoading: true,
      flagDisplayChannelJournal: false,
      flagDisplayPowerBar: true,
      alertShowAddButton: true,
      thisChannelAsDeviceFlag: false,
      channelIsSaving: false,
      channelIsDeleting: false,
      alertIsCreating: false,
      flagCloudLiveIsActivating: false,
      channelReadings: [],
      totalPower: 0,
      peakCurrent: 0,
      totalCost: 0,

      actualBundleIsDefaultBundle: true,
      labelAddress: { FR: 'Adresse', EN: 'Address' },
      center: { lat: 46.82, lng: -71.25 },
      markers: [{ position: { lat: 46.1, lng: -72.4 }, label: "1" }],

      flagDisplayPowerMA: true,
      powerBarDataWk: { Label: 'Dernière semaine', PreviousText: 'Semaine', Value: 10, Max: 20, AfterText: ' kWh' },
      powerBarDataDay: { Label: 'Dernier jour', PreviousText: 'Jour', Value: 5, Max: 20, AfterText: ' kWh' },
      powerBarDataHr: { Label: 'Dernière heure', PreviousText: 'Heure', Value: 16, Max: 20, AfterText: ' kW' },
      powerBarData5Min: { Label: 'Dernière mesure', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_001H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_004H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_006H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_012H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_024H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_072H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_168H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_336H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_720H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },

      labelGraphPeakCurrent: { FR: 'Courant maximum', EN: 'Max current' },
      labelGraphCost: { FR: 'Coût', EN: 'Cost' },
      labelGraphSaving: { FR: 'Économies', EN: 'Savings' },
      labelGraphConsumption: { FR: 'Consommation', EN: 'Consumption' },

      labelBarActual: { FR: 'Actuelle', EN: 'Actual' },
      labelBar001H: { FR: 'Moyenne 1Hr', EN: 'Average 1Hr' },
      barLabelLastReading: { FR: "Dernière mesure", EN: 'Last measure' },
      barLabelMA_1Hr: { FR: "Moyenne 1Hr", EN: '1 Hr Average' },
      barLabelMA_4Hr: { FR: "Moyenne 4Hrs", EN: '4 Hrs Average' },
      barLabelMA_6Hr: { FR: "Moyenne 6Hrs", EN: '6 Hrs Average' },
      barLabelMA_12Hr: { FR: "Moyenne 12Hrs", EN: '12 Hrs Average' },
      barLabelMA_1Day: { FR: "Moyenne 1Jr", EN: '1 Day Average' },
      barLabelMA_3Day: { FR: "Moyenne 3Jrs", EN: '3 Days Average' },
      barLabelMA_7Day: { FR: "Moyenne 7Jrs", EN: '7 Days Average' },
      barLabelMA_14Day: { FR: "Moyenne 14Jrs", EN: '14 Days Average' },
      barLabelMA_30Day: { FR: "Moyenne 30Jrs", EN: '30 Days Average' },

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },

      buttonLabelHideJournal: { FR: "Cacher le journal", EN: 'Hide device log book' },
      buttonLabelShowJournal: { FR: "Afficher le journal", EN: 'Display device log book' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'actualBundleChannelMaximums', 'displayAllChannelGraphFlag']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      var _this = this;

      this.reloadTempoBundle();
      this.flagDisplayGraph = false;

      this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings;

      this.computeChannelOverview();

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    displayAllChannelGraphFlag: function displayAllChannelGraphFlag() {
      if (this.displayAllChannelGraphFlag) {} else {}
    },
    actualBundleChannelMaximums: function actualBundleChannelMaximums() {
      this.flagDisplayPowerBar = false;
      this.flagDisplayPowerBar = true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayChannel: function toggleDisplayChannel() {
      this.flagDisplayChannel = ~this.flagDisplayChannel;

      if (this.flagDisplayChannel) {
        this.readChannelReadings();
      } else {
        this.actualBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag = false;
        this.$store.dispatch('sessionStore/setActualBundle', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle)));
      }
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    readChannelReadings: function readChannelReadings() {
      var _this2 = this;

      this.flagChannelDataIsLoading = true;
      var requestData = { 'postAction': 'GetBundleChannelReadings',
        'bundleId': this.actualBundle.bundle_id,
        'channelList': [{ 'channelData': this.actualBundle.channels[this.channelIndex].ChannelData,
          'channelBundleIndex': this.channelIndex }],
        'start': this.startDate,
        'end': this.endDate,
        'dataType': 'Automatic'
      };

      this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.channelReadings = _this2.actualBundle.channels[_this2.channelIndex].ChannelData.Readings;
          _this2.computeChannelOverview();
          _this2.flagChannelDataIsLoading = false;
        } else {
          window.alert("L'enregistrement a échoué. / Saving fail.");
        }
      });
    },
    computeChannelOverview: function computeChannelOverview() {
      this.totalCost = 0;
      this.totalPower = 0;
      this.peakCurrent = 0;

      for (var j = 0; j < this.channelReadings.length; j++) {
        this.totalCost = this.totalCost + this.channelReadings[j].cost;
        this.totalPower = this.totalPower + this.channelReadings[j].kwr;
        if (this.channelReadings[j].peakCurrent > this.peakCurrent) {
          this.peakCurrent = this.channelReadings[j].peakCurrent;
        }
      }
    }
  }),

  mounted: function mounted() {
    this.markers[0].position.lat = this.actualBundle.channels[this.channelIndex].ChannelData.position.latitude;
    this.markers[0].position.lng = this.actualBundle.channels[this.channelIndex].ChannelData.position.longitude;
    this.markers[0].position.label = this.channelIndex;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();

    this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle');

    this.thisChannelAsDeviceFlag = this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId != "TBD";

    if (this.tempoBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag) {
      this.flagDisplayChannel = -1;
      this.flagChannelDataIsLoading = false;
      this.channelReadings = this.tempoBundle.channels[this.channelIndex].ChannelData.Readings;
    }
  }
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a,
    PortGraph: __WEBPACK_IMPORTED_MODULE_6__SubComponents_PortGraph_vue___default.a,
    RelativePowerBar: __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue___default.a,
    MultipleGraph: __WEBPACK_IMPORTED_MODULE_7__SubComponents_MultipleGraph_vue___default.a,
    ChannelJournal: __WEBPACK_IMPORTED_MODULE_8__SubComponents_ChannelJournal_vue___default.a
  },

  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      flagDisplayChannel: 0,
      flagDisplayGraph: true,
      flagChannelDataIsLoading: true,
      flagDisplayChannelJournal: false,
      flagDisplayPowerBar: true,
      alertShowAddButton: true,
      thisChannelAsDeviceFlag: false,
      channelIsSaving: false,
      channelIsDeleting: false,
      alertIsCreating: false,
      flagCloudLiveIsActivating: false,
      channelReadings: [],
      totalPower: 0,
      peakCurrent: 0,
      totalCost: 0,

      actualBundleIsDefaultBundle: true,
      labelAddress: { FR: 'Adresse', EN: 'Address' },
      center: { lat: 46.82, lng: -71.25 },
      markers: [{ position: { lat: 46.1, lng: -72.4 }, label: "1" }],

      flagDisplayPowerMA: true,
      powerBarDataWk: { Label: 'Dernière semaine', PreviousText: 'Semaine', Value: 10, Max: 20, AfterText: ' kWh' },
      powerBarDataDay: { Label: 'Dernier jour', PreviousText: 'Jour', Value: 5, Max: 20, AfterText: ' kWh' },
      powerBarDataHr: { Label: 'Dernière heure', PreviousText: 'Heure', Value: 16, Max: 20, AfterText: ' kW' },
      powerBarData5Min: { Label: 'Dernière mesure', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_001H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_004H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_006H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_012H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_024H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_072H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_168H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_336H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_720H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },

      labelGraphPeakCurrent: { FR: 'Courant maximum', EN: 'Max current' },
      labelGraphCost: { FR: 'Coût', EN: 'Cost' },
      labelGraphSaving: { FR: 'Économies', EN: 'Savings' },
      labelGraphConsumption: { FR: 'Consommation', EN: 'Consumption' },

      labelBarActual: { FR: 'Actuelle', EN: 'Actual' },
      labelBar001H: { FR: 'Moyenne 1Hr', EN: 'Average 1Hr' },
      barLabelLastReading: { FR: "Dernière mesure", EN: 'Last measure' },
      barLabelMA_1Hr: { FR: "Moyenne 1Hr", EN: '1 Hr Average' },
      barLabelMA_4Hr: { FR: "Moyenne 4Hrs", EN: '4 Hrs Average' },
      barLabelMA_6Hr: { FR: "Moyenne 6Hrs", EN: '6 Hrs Average' },
      barLabelMA_12Hr: { FR: "Moyenne 12Hrs", EN: '12 Hrs Average' },
      barLabelMA_1Day: { FR: "Moyenne 1Jr", EN: '1 Day Average' },
      barLabelMA_3Day: { FR: "Moyenne 3Jrs", EN: '3 Days Average' },
      barLabelMA_7Day: { FR: "Moyenne 7Jrs", EN: '7 Days Average' },
      barLabelMA_14Day: { FR: "Moyenne 14Jrs", EN: '14 Days Average' },
      barLabelMA_30Day: { FR: "Moyenne 30Jrs", EN: '30 Days Average' },

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },

      buttonLabelHideJournal: { FR: "Cacher le journal", EN: 'Hide device log book' },
      buttonLabelShowJournal: { FR: "Afficher le journal", EN: 'Display device log book' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'actualBundleChannelMaximums', 'displayAllChannelGraphFlag']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),
  watch: {
    actualBundle: function actualBundle() {
      var _this = this;

      this.reloadTempoBundle();
      this.flagDisplayGraph = false;

      this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings;

      this.computeChannelOverview();

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    displayAllChannelGraphFlag: function displayAllChannelGraphFlag() {
      if (this.displayAllChannelGraphFlag) {} else {}
    },
    actualBundleChannelMaximums: function actualBundleChannelMaximums() {
      this.flagDisplayPowerBar = false;
      this.refreshPowerBar();
      this.flagDisplayPowerBar = true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayChannel: function toggleDisplayChannel() {
      this.flagDisplayChannel = ~this.flagDisplayChannel;

      if (this.flagDisplayChannel) {
        this.readChannelReadings();
      } else {
        this.actualBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag = false;
        this.$store.dispatch('sessionStore/setActualBundle', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle)));
      }
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    readChannelReadings: function readChannelReadings() {
      var _this2 = this;

      this.flagChannelDataIsLoading = true;
      var requestData = { 'postAction': 'GetBundleChannelReadings',
        'bundleId': this.actualBundle.bundle_id,
        'channelList': [{ 'channelData': this.actualBundle.channels[this.channelIndex].ChannelData,
          'channelBundleIndex': this.channelIndex }],
        'start': this.startDate,
        'end': this.endDate,
        'dataType': 'Automatic'
      };

      this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.channelReadings = _this2.actualBundle.channels[_this2.channelIndex].ChannelData.Readings;
          _this2.computeChannelOverview();
          _this2.flagChannelDataIsLoading = false;
        } else {
          window.alert("L'enregistrement a échoué. / Saving fail.");
        }
      });
    },
    computeChannelOverview: function computeChannelOverview() {
      this.totalCost = 0;
      this.totalPower = 0;
      this.peakCurrent = 0;

      for (var j = 0; j < this.channelReadings.length; j++) {
        this.totalCost = this.totalCost + this.channelReadings[j].cost;
        this.totalPower = this.totalPower + this.channelReadings[j].kwr;
        if (this.channelReadings[j].peakCurrent > this.peakCurrent) {
          this.peakCurrent = this.channelReadings[j].peakCurrent;
        }
      }
    },
    refreshPowerBar: function refreshPowerBar() {
      this.powerBarData5Min = { Label: this.barLabelLastReading[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['5min'],
        Max: this.actualBundleChannelMaximums['5min'],
        AfterText: ' W' };

      this.powerBarDataMA_001H = { Label: this.barLabelMA_1Hr[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_001H'],
        Max: this.actualBundleChannelMaximums['MA_001H'],
        AfterText: ' W' };

      this.powerBarDataMA_004H = { Label: this.barLabelMA_4Hr[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_004H'],
        Max: this.actualBundleChannelMaximums['MA_004H'],
        AfterText: ' W' };

      this.powerBarDataMA_006H = { Label: this.barLabelMA_6Hr[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_006H'],
        Max: this.actualBundleChannelMaximums['MA_006H'],
        AfterText: ' W' };

      this.powerBarDataMA_012H = { Label: this.barLabelMA_12Hr[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_012H'],
        Max: this.actualBundleChannelMaximums['MA_012H'],
        AfterText: ' W' };

      this.powerBarDataMA_024H = { Label: this.barLabelMA_1Day[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_024H'],
        Max: this.actualBundleChannelMaximums['MA_024H'],
        AfterText: ' W' };

      this.powerBarDataMA_072H = { Label: this.barLabelMA_3Day[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_072H'],
        Max: this.actualBundleChannelMaximums['MA_072H'],
        AfterText: ' W' };

      this.powerBarDataMA_168H = { Label: this.barLabelMA_7Day[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_168H'],
        Max: this.actualBundleChannelMaximums['MA_168H'],
        AfterText: ' W' };

      this.powerBarDataMA_336H = { Label: this.barLabelMA_14Day[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_336H'],
        Max: this.actualBundleChannelMaximums['MA_336H'],
        AfterText: ' W' };

      this.powerBarDataMA_720H = { Label: this.barLabelMA_30Day[this.actualLanguage],
        PreviousText: '',
        Value: this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_720H'],
        Max: this.actualBundleChannelMaximums['MA_720H'],
        AfterText: ' W' };
    },
    loadCloudLive: function loadCloudLive() {
      var _this3 = this;

      this.flagCloudLiveIsActivating = true;
      var requestData = { 'postAction': 'EnableDeviceLiveCloudReadings',
        'deviceId': this.actualBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId
      };
      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        _this3.flagCloudLiveIsActivating = false;
        if (response.data.Code == 'OK') {
          var modalParameters = {
            'liveType': 'Channel',
            'channelIndex': _this3.channelIndex,
            'channelId': _this3.actualBundle.channels[_this3.channelIndex].ChannelData.channelId,
            'deviceId': _this3.actualBundle.channels[_this3.channelIndex].ChannelData.linkedDevicePorts.deviceId
          };

          _this3.$store.dispatch('overlayStore/setParameters', modalParameters);
          _this3.showModal('channel-cloud-live-modal-display');
        } else {
          window.alert(response.data.PromptMessage[_this3.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {
    this.markers[0].position.lat = this.actualBundle.channels[this.channelIndex].ChannelData.position.latitude;
    this.markers[0].position.lng = this.actualBundle.channels[this.channelIndex].ChannelData.position.longitude;
    this.markers[0].position.label = this.channelIndex;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.refreshPowerBar();
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
    this.refreshPowerBar();

    this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle');

    this.thisChannelAsDeviceFlag = this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId != "TBD";

    if (this.tempoBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag) {
      this.flagDisplayChannel = -1;
      this.flagChannelDataIsLoading = false;
      this.channelReadings = this.tempoBundle.channels[this.channelIndex].ChannelData.Readings;
    }
  }
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisplayChannel__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisplayChannel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DisplayChannel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DisplaySubBundle__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DisplaySubBundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DisplaySubBundle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PieChart__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponents_PieChartPowerAverage__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SubComponents_PieChartPowerAverage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SubComponents_PieChartPowerAverage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubComponents_RelativePowerBar_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubComponents_RelativePowerBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SubComponents_RelativePowerBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubComponents_RelativePowerBarMini_vue__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubComponents_RelativePowerBarMini_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SubComponents_RelativePowerBarMini_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ApiDisplayChannelV1p00_vue__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ApiDisplayChannelV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ApiDisplayChannelV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubComponents_ApiDeviceListIndicatorV1p00_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubComponents_ApiDeviceListIndicatorV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SubComponents_ApiDeviceListIndicatorV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_apexcharts__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    DisplayChannel: __WEBPACK_IMPORTED_MODULE_4__DisplayChannel___default.a,
    DisplaySubBundle: __WEBPACK_IMPORTED_MODULE_5__DisplaySubBundle___default.a,
    PieChartPowerAvr: __WEBPACK_IMPORTED_MODULE_7__SubComponents_PieChartPowerAverage___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_6__components_PieChart__["a" /* default */],
    RelativePowerBar: __WEBPACK_IMPORTED_MODULE_8__SubComponents_RelativePowerBar_vue___default.a,
    RelativePowerBarMini: __WEBPACK_IMPORTED_MODULE_9__SubComponents_RelativePowerBarMini_vue___default.a,
    ApiDisplayChannelV1p00: __WEBPACK_IMPORTED_MODULE_10__ApiDisplayChannelV1p00_vue___default.a,
    ApiDeviceListIndicatorV1p00: __WEBPACK_IMPORTED_MODULE_11__SubComponents_ApiDeviceListIndicatorV1p00_vue___default.a
  },
  data: function data() {
    return {
      actualLanguage: "FR",
      showListOfChannel: false,
      showPieChart: false,
      flagDisplayFilter: 0,
      flagDisplayMap: 0,
      attributesFilters: [],
      EvSenschannelCounter: 0,
      flagChannelIsEvsensChannel: [],
      channelDisplayFlag: [],
      channelDisplayTemplate: [],
      subBundleDisplayFlag: [],
      attributesFiltersChoice: [],
      channelCount: 0,
      channelsParamaters: [],
      displayAsTableFlag: true,
      channelsMmMaximums: { '5Min': 0, 'MA_001H': 0, 'MA_004H': 0, 'MA_006H': 0, 'MA_012H': 0, 'MA_024H': 0, 'MA_072H': 0, 'MA_168H': 0, 'MA_336H': 0, 'MA_720H': 0 },
      powerBarDataMA_001H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },

      sectionLabelFilters: { FR: "Filtres des Appareils et Sous-systèmes", EN: 'Device and Sub-Systems filters' },
      buttonLabelEraseFilter: { FR: "Effacer les filtres", EN: 'Erase filters' },
      buttonApplyFilters: { FR: "Appliquer les filtres", EN: 'Apply filters' },
      sectionLabelDeviceLocalisation: { FR: "Localisation des appareils", EN: 'Devices location' },
      buttonPieChartRefresh: { FR: "Actualiser les données de la période sélectionnée", EN: 'Refresh pie data of the selected period' },
      labelPieConsumption: { FR: "Consommation électrique", EN: 'Électrical consumption' },
      labelPieCost: { FR: "Coût", EN: 'Cost' },
      labelPieMaximumCurrent: { FR: "Courant maximum", EN: 'Maximum current' },

      buttonLabelDisplayDetail: { FR: "Afficher en mode detail", EN: 'Display in detail mode' },
      buttonLabelDisplayList: { FR: "Afficher en mode combiné et les moyennes", EN: 'Display in combined mode and average' },
      textLabelRequireDeviceSelect: { FR: "* Utilisez les cases à cocher bleu de la liste du bas pour activer/désactiver l'affichage des données de l'appareil sur les graphiques.",
        EN: '* Use the blue checkboxes in the bottom list to enable/disable the display of device data on charts.' },
      tableLabelDevice: { FR: "Composante", EN: 'Component' },
      tableLabelOnline: { FR: "Connecté", EN: 'On Line' },
      tableLabelMaxCurrent: { FR: "Courant Max*", EN: 'Max current*' },
      tableLabelCunsumption: { FR: "Consommation (kWh/$)*", EN: 'Cunsumption (kWh/$)*' },
      tableLabelLastReading: { FR: "Dernière mesure", EN: 'Last measure' },

      tableLabelMA_1Hr: { FR: "Moyenne 1Hr", EN: '1Hr Average' },
      tableLabelMA_4Hr: { FR: "Moyenne 4Hr", EN: '4Hr Average' },
      tableLabelMA_6Hr: { FR: "Moyenne 6Hr", EN: '6Hr Average' },
      tableLabelMA_12Hr: { FR: "Moyenne 12Hr", EN: '12Hr Average' },
      tableLabelMA_1Day: { FR: "Moyenne 1Jr", EN: '1Day Average' },
      tableLabelMA_3Day: { FR: "Moyenne 3Jr", EN: '3Day Average' },
      tableLabelMA_7Day: { FR: "Moyenne 7Jr", EN: '7Day Average' },
      tableLabelMA_14Day: { FR: "Moyenne 14Jr", EN: '14Day Average' },
      tableLabelMA_30Day: { FR: "Moyenne 30Jr", EN: '30Day Average' },
      textLabelSubSystem: { FR: "Sous-Système", EN: 'Sub-Systems' },
      textLabelSubDevice: { FR: "Appareils", EN: 'Devices' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      labelSelectorAvrPowerKW: { FR: 'Puissance Moyenne (kW)', EN: 'Average Power (kW)' },
      labelSelectorPeakPowerKW: { FR: 'Puissance crête (kW)', EN: 'Peak Power (kW)' },
      labelSelectorKWHShort: { FR: 'kWh par mesure', EN: 'kWr per sample' },
      labelSelectorCostShort: { FR: 'Coût par mesure ($)', EN: 'Cost per sample ($)' },
      labelSelectorCumSumKWH: { FR: 'Consommation cumulée (kWh)', EN: 'Cumulated consumption (kWh)' },
      labelSelectorCumSumCost: { FR: 'Consommation cumulée ($)', EN: 'Cumulated consumption ($)' },

      center: { lat: 46.82, lng: -71.25 },
      markers: [{ position: { lat: 46.1, lng: -72.4 }, label: "1" }, { position: { lat: 46.1, lng: -73.4 }, label: "2" }],

      flagDisplayOldGraph: false,
      crunchedMaxCurrent: {
        labels: ['Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40]
        }]
      },

      crunchedCost: {
        labels: ['Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40]
        }]
      },

      crunchedCunsumption: {
        labels: ['Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40]
        }]
      },

      flagDisplayNewGraph: true,

      pieChartDataSeriesKWH: [10, 20, 30],
      pieChartOptionsKWH: {
        chart: {
          type: 'pie'
        },
        pie: {
          expandOnClick: true,
          customScale: 0.4
        },
        dataLabels: {
          enabled: true,
          style: { fontSize: '16px' }
        },
        labels: ['Label1', 'Label2', 'Label3']
      },

      pieChartDataSeriesCost: [10, 20, 30],
      pieChartOptionsCost: {
        chart: {
          type: 'pie'
        },
        pie: {
          expandOnClick: true,
          customScale: 0.4
        },
        dataLabels: {
          enabled: true,
          style: { fontSize: '16px' }
        },
        labels: ['Label1', 'Label2', 'Label3']
      },

      selectedGraphCurve: 'AvrPower',

      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54], [1326236400000, 43], [1326236405000, 43], [1326236406000, 53], [1326236406500, 63]]
      }],

      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 400,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        tooltip: {
          x: { format: 'dd MMM hh:mm' }
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          }
        },
        xaxis: {
          type: 'datetime'
        }
      }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'groupArborescence', 'actualBundle', 'dashboardFlags']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),
  watch: {
    actualBundle: function actualBundle() {
      var _this = this;

      this.showPieChart = false;

      this.updatePieChartData();

      this.$nextTick(function () {
        _this.showListOfChannel = true;
        _this.showPieChart = true;
      });
    },
    groupArborescence: function groupArborescence() {
      this.showListOfChannel = false;
      this.resetDisplayFlag();
      this.showListOfChannel = true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayFilter: function toggleDisplayFilter() {
      this.flagDisplayFilter = ~this.flagDisplayFilter;
    },
    toggleDisplayMap: function toggleDisplayMap() {
      this.flagDisplayMap = ~this.flagDisplayMap;
    },
    toggleDisplayTable: function toggleDisplayTable() {
      if (this.displayAsTableFlag) {
        this.displayAsTableFlag = false;
      } else {
        this.displayAsTableFlag = true;
      }
    },
    resetDisplayFlag: function resetDisplayFlag() {
      var _this2 = this;

      this.channelDisplayFlag = [];
      this.subBundleDisplayFlag = [];
      this.flagChannelIsEvsensChannel = [];
      var previousDisplayFilter = this.flagDisplayFilter;
      this.showListOfChannel = false;
      this.showPieChart = false;
      this.flagDisplayFilter = 0;
      this.channelsMmMaximums = { '5min': 0, 'MA_001H': 0, 'MA_004H': 0, 'MA_006H': 0, 'MA_012H': 0, 'MA_024H': 0, 'MA_072H': 0, 'MA_168H': 0, 'MA_336H': 0, 'MA_720H': 0 };
      this.markers = [];
      var positionMarkerNotFound = true;
      var mm = 0;

      this.EvSenschannelCounter = 0;
      for (var m = 0; m < this.actualBundle.channels.length; m++) {
        this.channelDisplayFlag[m] = true;
        this.validateMmMaximums(m);

        this.flagChannelIsEvsensChannel[m] = this.actualBundle.channels[m].FrontendTemplates.componentChannelDisplay == 'EVA_V1P00';

        if (this.flagChannelIsEvsensChannel[m] == false) {
          this.actualBundle.channels[m].ChannelData.DisplayOpenFlag = true;
        } else {
          this.EvSenschannelCounter += 1;
        }

        positionMarkerNotFound = true;
        for (mm = 0; mm < this.markers.length; mm++) {

          if (this.markers[mm].position.lat == this.actualBundle.channels[m].ChannelData.position.latitude && this.markers[mm].position.lng == this.actualBundle.channels[m].ChannelData.position.longitude) {
            positionMarkerNotFound = false;
            this.markers[mm].label = this.markers[mm].label.concat("-", (m + 1).toString());
          }
        }

        if (positionMarkerNotFound) {
          this.markers.push({ position: { lat: this.actualBundle.channels[m].ChannelData.position.latitude,
              lng: this.actualBundle.channels[m].ChannelData.position.longitude },
            label: (m + 1).toString() });
        }
      }

      for (var m = 0; m < this.actualBundle.sub_bundle.length; m++) {
        this.subBundleDisplayFlag[m] = true;
        this.validateMmMaximumsSubBundle(m);
      }

      this.$store.dispatch('sessionStore/setActualBundleChannelMaximums', this.channelsMmMaximums);

      this.generatesFiltersList();
      this.updatePieChartData();

      this.flagDisplayFilter = previousDisplayFilter;
      this.channelCount = this.actualBundle.channels.length;

      this.$nextTick(function () {
        _this2.showListOfChannel = true;
        _this2.showPieChart = true;
      });
    },
    generatesFiltersList: function generatesFiltersList() {
      this.attributesFilters = [];
      this.attributesFiltersChoice = [];
      for (var attrList = 0; attrList < this.actualBundle.channelsAttributes.length; attrList++) {
        this.attributesFilters.push([]);
        this.attributesFiltersChoice.push([]);

        for (var m = 0; m < this.actualBundle.channels.length; m++) {
          if (this.channelDisplayFlag[m] == true) {
            if (this.actualBundle.channels[m].Attributes[attrList] != "ND") {
              if (this.attributesFilters[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList]) < 0) {
                this.attributesFilters[attrList].push(this.actualBundle.channels[m].Attributes[attrList]);
              }
            }
          }
        }

        for (var m = 0; m < this.actualBundle.sub_bundle.length; m++) {
          if (this.subBundleDisplayFlag[m] == true) {
            if (this.actualBundle.sub_bundle[m].Attributes[attrList] != "ND") {
              if (this.attributesFilters[attrList].indexOf(this.actualBundle.sub_bundle[m].Attributes[attrList]) < 0) {
                this.attributesFilters[attrList].push(this.actualBundle.sub_bundle[m].Attributes[attrList]);
              }
            }
          }
        }
      }
    },
    applyFilter: function applyFilter() {
      var _this3 = this;

      this.showListOfChannel = false;
      this.showPieChart = false;
      this.flagDisplayFilter = 0;
      this.channelsMmMaximums = { '5min': 0, 'MA_001H': 0, 'MA_004H': 0, 'MA_006H': 0, 'MA_012H': 0, 'MA_024H': 0, 'MA_072H': 0, 'MA_168H': 0, 'MA_336H': 0, 'MA_720H': 0 };
      this.markers = [];
      var positionMarkerNotFound = true;
      var mm = 0;

      console.log('Apply Filter');

      for (var m = 0; m < this.actualBundle.channels.length; m++) {

        for (var attrList = 0; attrList < this.actualBundle.channelsAttributes.length; attrList++) {
          if (this.attributesFiltersChoice[attrList].length > 0) {
            if (this.attributesFiltersChoice[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList]) >= 0) {
              this.channelDisplayFlag[m] = true;
              this.validateMmMaximums(m);
              positionMarkerNotFound = true;
              for (mm = 0; mm < this.markers.length; mm++) {

                if (this.markers[mm].position.lat == this.actualBundle.channels[m].ChannelData.position.latitude && this.markers[mm].position.lng == this.actualBundle.channels[m].ChannelData.position.longitude) {
                  positionMarkerNotFound = false;
                  this.markers[mm].label = this.markers[mm].label.concat("-", (m + 1).toString());
                }
              }

              if (positionMarkerNotFound) {
                this.markers.push({ position: { lat: this.actualBundle.channels[m].ChannelData.position.latitude,
                    lng: this.actualBundle.channels[m].ChannelData.position.longitude },
                  label: (m + 1).toString() });
              }
            } else {
              this.channelDisplayFlag[m] = false;
            }
          }
        }
      }

      for (var m = 0; m < this.actualBundle.sub_bundle.length; m++) {

        for (var attrList = 0; attrList < this.actualBundle.channelsAttributes.length; attrList++) {
          if (this.attributesFiltersChoice[attrList].length > 0) {
            if (this.attributesFiltersChoice[attrList].indexOf(this.actualBundle.sub_bundle[m].Attributes[attrList]) >= 0) {
              this.subBundleDisplayFlag[m] = true;
              this.validateMmMaximumsSubBundle(m);
            } else {
              this.subBundleDisplayFlag[m] = false;
            }
          }
        }
      }

      this.$store.dispatch('sessionStore/setActualBundleChannelMaximums', this.channelsMmMaximums);
      this.generatesFiltersList();
      this.updatePieChartData();

      this.$nextTick(function () {
        _this3.showListOfChannel = true;
        _this3.showPieChart = true;
        _this3.flagDisplayFilter = -1;
      });
    },
    refreshPie: function refreshPie() {
      var _this4 = this;

      this.showPieChart = false;
      this.updatePieChartData();
      this.$nextTick(function () {
        _this4.showPieChart = true;
      });
    },
    updatePieChartData: function updatePieChartData() {
      this.crunchedMaxCurrent.labels = [];
      this.crunchedMaxCurrent.datasets[0].data = [];

      this.crunchedCost.labels = [];
      this.crunchedCost.datasets[0].data = [];

      this.crunchedCunsumption.labels = [];
      this.crunchedCunsumption.datasets[0].data = [];

      this.pieChartDataSeriesKWH = [];
      this.pieChartOptionsKWH.labels = [];
      this.pieChartDataSeriesCost = [];
      this.pieChartOptionsCost.labels = [];

      this.chartDataSeries = [];
      var NewGraphDataTempo = [];
      var actualValue = 0.0;

      for (var m = 0; m < this.actualBundle.channels.length; m++) {
        if (this.actualBundle.channels[m].ChannelData.DisplayOpenFlag && this.channelDisplayFlag[m] && this.actualBundle.channels[m].ChannelData.peakCurrent) {
          this.crunchedMaxCurrent.labels.push(this.actualBundle.channels[m].ReferenceName);
          this.crunchedCost.labels.push(this.actualBundle.channels[m].ReferenceName);
          this.crunchedCunsumption.labels.push(this.actualBundle.channels[m].ReferenceName);

          this.crunchedMaxCurrent.datasets[0].data.push(this.actualBundle.channels[m].ChannelData.peakCurrent.toFixed(2));
          this.crunchedCost.datasets[0].data.push(this.actualBundle.channels[m].ChannelData.sumCost.toFixed(2));
          this.crunchedCunsumption.datasets[0].data.push(this.actualBundle.channels[m].ChannelData.sumKwh.toFixed(2));

          this.pieChartOptionsKWH.labels.push(this.actualBundle.channels[m].ReferenceName);
          this.pieChartDataSeriesKWH.push(this.actualBundle.channels[m].ChannelData.sumKwh);

          this.pieChartOptionsCost.labels.push(this.actualBundle.channels[m].ReferenceName);
          this.pieChartDataSeriesCost.push(this.actualBundle.channels[m].ChannelData.sumCost);

          NewGraphDataTempo = [];
          actualValue = 0;
          for (var i = 0; i < this.actualBundle.channels[m].ChannelData.Readings.length; i++) {
            if (this.selectedGraphCurve == 'AvrPower') {
              actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].avrPower / 1000;
            }
            if (this.selectedGraphCurve == 'PeakPower') {
              actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].peak / 1000;
            }
            if (this.selectedGraphCurve == 'KWH_PerSample') {
              actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].kwr;
            }
            if (this.selectedGraphCurve == 'Cost_PerSample') {
              actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].cost;
            }
            if (this.selectedGraphCurve == 'CumSumKWH') {
              actualValue += this.actualBundle.channels[m].ChannelData.Readings[i].kwr;
            }
            if (this.selectedGraphCurve == 'CumSumCost') {
              actualValue += this.actualBundle.channels[m].ChannelData.Readings[i].cost;
            }

            NewGraphDataTempo.push([this.actualBundle.channels[m].ChannelData.Readings[i].localEpochTime, actualValue.toFixed(3)]);
          }
          this.chartDataSeries.push({ name: this.actualBundle.channels[m].ReferenceName,
            data: NewGraphDataTempo });
        }
      }
    },
    validateMmMaximums: function validateMmMaximums(index) {
      if (this.actualBundle.channels[index].ChannelData.lastMeasure['5min'] > this.channelsMmMaximums['5min']) {
        this.channelsMmMaximums['5min'] = this.actualBundle.channels[index].ChannelData.lastMeasure['5min'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_001H'] > this.channelsMmMaximums['MA_001H']) {
        this.channelsMmMaximums['MA_001H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_001H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_004H'] > this.channelsMmMaximums['MA_004H']) {
        this.channelsMmMaximums['MA_004H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_004H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_006H'] > this.channelsMmMaximums['MA_006H']) {
        this.channelsMmMaximums['MA_006H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_006H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_012H'] > this.channelsMmMaximums['MA_012H']) {
        this.channelsMmMaximums['MA_012H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_012H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_024H'] > this.channelsMmMaximums['MA_024H']) {
        this.channelsMmMaximums['MA_024H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_024H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_072H'] > this.channelsMmMaximums['MA_072H']) {
        this.channelsMmMaximums['MA_072H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_072H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_168H'] > this.channelsMmMaximums['MA_168H']) {
        this.channelsMmMaximums['MA_168H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_168H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_336H'] > this.channelsMmMaximums['MA_336H']) {
        this.channelsMmMaximums['MA_336H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_336H'];
      }

      if (this.actualBundle.channels[index].ChannelData.lastMeasure['MA_720H'] > this.channelsMmMaximums['MA_720H']) {
        this.channelsMmMaximums['MA_720H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_720H'];
      }
    },
    validateMmMaximumsSubBundle: function validateMmMaximumsSubBundle(index) {
      if (this.actualBundle.sub_bundle[index].lastMeasure['5min'] > this.channelsMmMaximums['5min']) {
        this.channelsMmMaximums['5min'] = this.actualBundle.sub_bundle[index].lastMeasure['5min'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_001H'] > this.channelsMmMaximums['MA_001H']) {
        this.channelsMmMaximums['MA_001H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_001H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_004H'] > this.channelsMmMaximums['MA_004H']) {
        this.channelsMmMaximums['MA_004H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_004H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_006H'] > this.channelsMmMaximums['MA_006H']) {
        this.channelsMmMaximums['MA_006H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_006H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_012H'] > this.channelsMmMaximums['MA_012H']) {
        this.channelsMmMaximums['MA_012H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_012H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_024H'] > this.channelsMmMaximums['MA_024H']) {
        this.channelsMmMaximums['MA_024H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_024H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_072H'] > this.channelsMmMaximums['MA_072H']) {
        this.channelsMmMaximums['MA_072H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_072H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_168H'] > this.channelsMmMaximums['MA_168H']) {
        this.channelsMmMaximums['MA_168H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_168H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_336H'] > this.channelsMmMaximums['MA_336H']) {
        this.channelsMmMaximums['MA_336H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_336H'];
      }

      if (this.actualBundle.sub_bundle[index].lastMeasure['MA_720H'] > this.channelsMmMaximums['MA_720H']) {
        this.channelsMmMaximums['MA_720H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_720H'];
      }
    },
    toggleChannelDisplayFlag: function toggleChannelDisplayFlag(index) {
      if (this.actualBundle.channels[index].ChannelData.DisplayOpenFlag) {
        this.actualBundle.channels[index].ChannelData.DisplayOpenFlag = false;
        this.refreshPie();
      } else {
        this.actualBundle.channels[index].ChannelData.DisplayOpenFlag = true;
        this.readChannelReadings(index);
      }
    },
    readChannelReadings: function readChannelReadings(index) {
      var _this5 = this;

      this.flagChannelDataIsLoading = true;
      var requestData = { 'postAction': 'GetBundleChannelReadings',
        'bundleId': this.actualBundle.bundle_id,
        'channelList': [{ 'channelData': this.actualBundle.channels[index].ChannelData,
          'channelBundleIndex': index }],
        'start': this.startDate,
        'end': this.endDate,
        'dataType': 'Automatic'
      };

      this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData).then(function (response) {
        if (response.data.Code == 'OK') {} else {
          window.alert(_this5.messagePostFail[_this5.actualLanguage]);
        }
      });
    },
    openAllChannelAndReadData: function openAllChannelAndReadData() {
      var _this6 = this;

      var MyChannelList = [];
      for (var m = 0; m < this.actualBundle.channels.length; m++) {
        this.actualBundle.channels[m].ChannelData.DisplayOpenFlag = true;
        MyChannelList.push({ 'channelData': this.actualBundle.channels[m].ChannelData,
          'channelBundleIndex': m });
      }

      this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', false);

      var endDate = moment().unix();
      var requestData = { 'postAction': 'GetBundleChannelReadings',
        'bundleId': this.actualBundle.bundle_id,
        'channelList': MyChannelList,
        'start': endDate - 28800,
        'end': endDate,
        'dataType': 'Automatic'
      };

      this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this6.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', true);
        } else {
          window.alert(_this6.messagePostFail[_this6.actualLanguage]);
        }
      });
    },
    openChannel: function openChannel(channelIndex) {
      this.channelSelected = true;
    },
    closeChannel: function closeChannel() {
      this.channelSelected = false;
    }
  }),

  mounted: function mounted() {
    if (this.actualBundle.bundle_id.includes(':DefaultBundle')) {
      this.showListOfChannel = false;
      this.displayAsTableFlag = true;
      this.openAllChannelAndReadData();
    } else {
      this.openAllChannelAndReadData();
      this.updatePieChartData();
    }

    if (this.crunchedCunsumption.labels.length > 0) {
      this.showPieChart = true;
    }

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    for (var m = 0; m < this.actualBundle.channels.length; m++) {
      this.channelDisplayTemplate[m] = this.actualBundle.channels[m].FrontendTemplates.componentChannelConfig;
    }
  },
  beforeMount: function beforeMount() {
    this.resetDisplayFlag();
  }
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['subBundleIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a,
    RelativePowerBar: __WEBPACK_IMPORTED_MODULE_5__SubComponents_RelativePowerBar_vue___default.a
  },

  data: function data() {
    return {
      tempoBundle: {},
      displayDataTable: false,
      flagDisplayChannel: 0,
      flagDisplayGraph: true,
      flagChannelDataIsLoading: true,
      flagDisplayChannelJournal: false,
      flagDisplayPowerBar: true,
      alertShowAddButton: true,
      channelIsSaving: false,
      channelIsDeleting: false,
      alertIsCreating: false,
      channelReadings: [],
      totalPower: 0,
      peakCurrent: 0,
      totalCost: 0,

      flagDisplayPowerMA: true,
      powerBarDataWk: { Label: 'Dernière semaine', PreviousText: 'Semaine', Value: 10, Max: 20, AfterText: ' kWh' },
      powerBarDataDay: { Label: 'Dernier jour', PreviousText: 'Jour', Value: 5, Max: 20, AfterText: ' kWh' },
      powerBarDataHr: { Label: 'Dernière heure', PreviousText: 'Heure', Value: 16, Max: 20, AfterText: ' kW' },
      powerBarData5Min: { Label: 'Dernière mesure', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_001H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_004H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_006H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_012H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' W' },
      powerBarDataMA_024H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_072H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_168H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_336H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },
      powerBarDataMA_720H: { Label: 'Moyenne 1Hr', PreviousText: '5 Min', Value: 19, Max: 20, AfterText: ' kW' },

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle', 'actualBundleChannelMaximums', 'displayAllChannelGraphFlag']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),
  watch: {
    actualBundle: function actualBundle() {
      var _this = this;

      this.reloadTempoBundle();

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    displayAllChannelGraphFlag: function displayAllChannelGraphFlag() {
      if (this.displayAllChannelGraphFlag) {} else {}
    },
    actualBundleChannelMaximums: function actualBundleChannelMaximums() {
      this.flagDisplayPowerBar = false;
      this.refreshPowerBar();
      this.flagDisplayPowerBar = true;
    }
  },

  methods: {
    selectThisSubBundle: function selectThisSubBundle() {

      console.log('===TO BE IMPLEMENTED====');
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    refreshPowerBar: function refreshPowerBar() {
      this.powerBarData5Min = { Label: 'Mesure actuelle',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['5min'],
        Max: this.actualBundleChannelMaximums['5min'],
        AfterText: ' W' };

      this.powerBarDataMA_001H = { Label: 'Moyenne 1 hr',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_001H'],
        Max: this.actualBundleChannelMaximums['MA_001H'],
        AfterText: ' W' };

      this.powerBarDataMA_004H = { Label: 'Moyenne 4 hrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_004H'],
        Max: this.actualBundleChannelMaximums['MA_004H'],
        AfterText: ' W' };

      this.powerBarDataMA_006H = { Label: 'Moyenne 6 hrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_006H'],
        Max: this.actualBundleChannelMaximums['MA_006H'],
        AfterText: ' W' };

      this.powerBarDataMA_012H = { Label: 'Moyenne 12 hrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_012H'],
        Max: this.actualBundleChannelMaximums['MA_012H'],
        AfterText: ' W' };

      this.powerBarDataMA_024H = { Label: 'Moyenne 1 jr',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_024H'],
        Max: this.actualBundleChannelMaximums['MA_024H'],
        AfterText: ' W' };

      this.powerBarDataMA_072H = { Label: 'Moyenne 3 jrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_072H'],
        Max: this.actualBundleChannelMaximums['MA_072H'],
        AfterText: ' W' };

      this.powerBarDataMA_168H = { Label: 'Moyenne 7 jrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_168H'],
        Max: this.actualBundleChannelMaximums['MA_168H'],
        AfterText: ' W' };

      this.powerBarDataMA_336H = { Label: 'Moyenne 14 jrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_336H'],
        Max: this.actualBundleChannelMaximums['MA_336H'],
        AfterText: ' W' };

      this.powerBarDataMA_720H = { Label: 'Moyenne 30 jrs',
        PreviousText: '',
        Value: this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_720H'],
        Max: this.actualBundleChannelMaximums['MA_720H'],
        AfterText: ' W' };
    }
  },

  mounted: function mounted() {
    this.refreshPowerBar();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.reloadTempoBundle();
    this.refreshPowerBar();
  }
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RangePicker__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_RangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bundle__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bundle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PieChart__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DisplayChannelList__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DisplayChannelList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DisplayChannelList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponents_PowerLiveMonitor__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubComponents_PowerLiveMonitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubComponents_PowerLiveMonitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'measurementsIndex',
  data: function data() {
    return {
      numberOfRow: [1, 2, 3, 4, 5],
      selectedDevices: 0,
      loadingPort: true,
      localIp: '',
      actualBundleLoadedFlag: false,
      actualLanguage: "FR",
      labelTopPage1: { FR: 'Mesures temps réel', EN: 'Real time measurement' },
      realTimeMeasurementPanelNotAvailable: { FR: "Mesure temps réel non disponible. Pour activer cette option vous devez contacter support@evsens.ca.",
        EN: 'Real-time measurement not available. To activate this option you must contact support@evsens.ca.' },

      labelTopPage: { FR: 'Mesures', EN: 'Measurement' },
      labelTopDatePicker: { FR: 'Plage à observer', EN: 'Period selector' },
      labelTopModuleSelector: { FR: 'Sélection de module', EN: 'Module selector' },
      labelButtonRealTime: { FR: 'Moniteur temps réél', EN: 'Real time monitor' },
      labelGraphPeakCurrent: { FR: 'Courant maximum', EN: 'Max current' },
      labelGraphCost: { FR: 'Coût', EN: 'Cost' },
      labelGraphSaving: { FR: 'Économies', EN: 'Savings' },
      labelGraphConsumption: { FR: 'Consommation', EN: 'Consumption' },
      dataTableFlag: false,

      crunchedMaxCurrent: {
        labels: ['Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40]
        }]
      },

      crunchedCost: {
        labels: ['Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40]
        }]
      },

      crunchedCunsumption: {
        labels: ['Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40]
        }]
      }

    };
  },

  components: {
    RangePicker: __WEBPACK_IMPORTED_MODULE_1__components_RangePicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_4__components_PieChart__["a" /* default */],
    Bundle: __WEBPACK_IMPORTED_MODULE_3__bundle___default.a,
    DisplayChannelList: __WEBPACK_IMPORTED_MODULE_5__DisplayChannelList___default.a,
    PowerLiveMonitor: __WEBPACK_IMPORTED_MODULE_6__SubComponents_PowerLiveMonitor___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])('devicesStore', ['devices', 'devicesPortData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'dashboardFlags', 'actualBundle'])),
  watch: {
    selectedDevices: function selectedDevices() {}
  },
  methods: {
    refreshData: function refreshData(dates) {
      this.$store.dispatch('chargesStore/setStartDate', dates.startDate);
      this.$store.dispatch('chargesStore/setEndDate', dates.endDate);
    },
    loadLiveMonitor: function loadLiveMonitor() {
      var localUrl = 'http://' + this.localIp + '/live';
      window.open(localUrl, '_blank');
    },
    refreshPieChart: function refreshPieChart() {
      this.crunchedMaxCurrent.labels = [];
      this.crunchedMaxCurrent.datasets[0].data = [];
      this.crunchedCost.labels = [];
      this.crunchedCost.datasets[0].data = [];
      this.crunchedCunsumption.labels = [];
      this.crunchedCunsumption.datasets[0].data = [];

      for (var i = 0; i < this.devicesPortData.portsData.length; i++) {
        this.crunchedMaxCurrent.labels.push(this.devicesPortData.portsData[i].portName);
        this.crunchedMaxCurrent.datasets[0].data.push(this.devicesPortData.portsData[i].peakPower.toFixed(2));
        this.crunchedCost.labels.push(this.devicesPortData.portsData[i].portName);
        this.crunchedCost.datasets[0].data.push(this.devicesPortData.portsData[i].sumCost.toFixed(2));
        this.crunchedCunsumption.labels.push(this.devicesPortData.portsData[i].portName);
        this.crunchedCunsumption.datasets[0].data.push(this.devicesPortData.portsData[i].sumKwr.toFixed(2));
      }
    }
  },
  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.actualBundleLoadedFlag = true;
  }
});

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BarChart_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['graphData'],
  data: function data() {
    return {
      timeRange: 0,
      actualLanguage: "FR",
      dataIsLoading: false,
      flagDisplayGraph: false,
      flagGraphDataIsLoading: false,
      movingAverageData: [],
      crunchedData: {},

      graphTimeSpan: 100,
      graphTimeCenter: 50,

      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      myStartDateTime: this.startDate,
      myEndDateTime: this.endDate,
      dataSamplingSelect: 'Automatic',

      displayTraceFlag: [],

      graphTitle: { FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)' },
      buttonLabelMA: { FR: "Moyenne", EN: 'Average' },
      buttonLabelMA_Days: { FR: "jours", EN: 'days' },
      graphLabelLastReading: { FR: "Dernière mesure", EN: 'Last reading' },

      labelStartDate: { FR: 'Date de début', EN: 'Start date' },
      labelStartTime: { FR: 'Heure de début', EN: 'Start time' },

      labelEndDate: { FR: 'Date de fin', EN: 'End date' },
      labelEndTime: { FR: 'Heure de fin', EN: 'End time' },

      labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },

      labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
      labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
      labelDataSampling5min: { FR: 'Données brutes', EN: 'Raw data' },
      labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
      labelDataSamplingDays: { FR: 'Jour', EN: 'Days' },

      labelTimeSpan: { FR: 'Plage de temps (%)', EN: 'Time span (%)' },
      labelTimeCenter: { FR: 'Centre de temps (%)', EN: 'Time center (%)' }

    };
  },


  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_4__components_BarChart_js__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimeSelect"]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: {
    refreshGraph: function refreshGraph() {
      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
    },
    updateChartData: function updateChartData() {
      var _this = this;

      var dynamicDataset = [];
      this.flagDisplayGraph = false;

      var firstIndex = 0;
      var lastIndex = this.graphData.xData.length;

      firstIndex = Math.round((parseInt(this.graphTimeCenter) - parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (firstIndex < 0) {
        firstIndex = 0;
      }
      lastIndex = Math.round((parseInt(this.graphTimeCenter) + parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (lastIndex > this.graphData.xData.length) {
        lastIndex = this.graphData.xData.length;
      }

      var actualColor = 'rgba(70, 195, 123, 0.8)';

      for (var m = 0; m < this.graphData.traces.length; m++) {

        if (m % 5 == 0) {
          actualColor = 'rgba(70, 195, 123, 0.8)';
        }
        if (m % 5 == 1) {
          actualColor = 'rgba(210, 106, 92, 0.8)';
        }
        if (m % 5 == 2) {
          actualColor = 'rgba(92, 144, 210, 0.8)';
        }
        if (m % 5 == 3) {
          actualColor = 'rgba(153, 153, 153, 0.8)';
        }
        if (m % 5 == 4) {
          actualColor = 'rgba(243, 183, 96, 0.8)';
        }

        if (this.displayTraceFlag[m]) {
          dynamicDataset.push({
            label: this.graphData.traces[m].label[this.actualLanguage],
            backgroundColor: actualColor,
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: this.graphData.traces[m].yData.slice(firstIndex, lastIndex)
          });
        }
      }

      this.crunchedData = {
        labels: this.graphData.xData.slice(firstIndex, lastIndex),
        datasets: dynamicDataset
      };

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    formatTimeToUnix: function formatTimeToUnix(date, time) {
      var unixTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

      return unixTime;
    }
  },
  mounted: function mounted() {

    this.timeRange = this.endDate - this.startDate;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    for (var m = 0; m < this.graphData.traces.length; m++) {
      this.displayTraceFlag.push(true);
    }

    this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

    var DateStringSplit = this.myStartDate.toString().split(':');
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    DateStringSplit = this.myEndDate.toString().split(':');
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

    if (this.graphData.traces.length > 0) {
      this.updateChartData();
    }
  }
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BarChart_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['graphData'],
  data: function data() {
    return {
      timeRange: 0,
      actualLanguage: "FR",
      dataIsLoading: false,
      flagDisplayGraph: false,
      flagGraphDataIsLoading: false,
      movingAverageData: [],
      crunchedData: {},
      selectedTraceIndex: 0,

      graphTimeSpan: 100,
      graphTimeCenter: 50,

      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      myStartDateTime: this.startDate,
      myEndDateTime: this.endDate,
      dataSamplingSelect: 'Automatic',

      displayTraceFlag: [],

      graphTitle: { FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)' },
      buttonLabelMA: { FR: "Moyenne", EN: 'Average' },
      buttonLabelMA_Days: { FR: "jours", EN: 'days' },
      graphLabelLastReading: { FR: "Dernière mesure", EN: 'Last reading' },

      labelStartDate: { FR: 'Date de début', EN: 'Start date' },
      labelStartTime: { FR: 'Heure de début', EN: 'Start time' },

      labelEndDate: { FR: 'Date de fin', EN: 'End date' },
      labelEndTime: { FR: 'Heure de fin', EN: 'End time' },

      labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },

      labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
      labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
      labelDataSampling5min: { FR: 'Données brutes', EN: 'Raw data' },
      labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
      labelDataSamplingDays: { FR: 'Jour', EN: 'Days' },

      labelTimeSpan: { FR: 'Plage de temps (%)', EN: 'Time span (%)' },
      labelTimeCenter: { FR: 'Centre de temps (%)', EN: 'Time center (%)' }

    };
  },


  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_4__components_BarChart_js__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimeSelect"]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: {
    refreshGraph: function refreshGraph() {
      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
    },
    updateChartData: function updateChartData() {
      var _this = this;

      var dynamicDataset = [];
      this.flagDisplayGraph = false;

      var firstIndex = 0;
      var lastIndex = this.graphData.xData.length;

      firstIndex = Math.round((parseInt(this.graphTimeCenter) - parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (firstIndex < 0) {
        firstIndex = 0;
      }
      lastIndex = Math.round((parseInt(this.graphTimeCenter) + parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (lastIndex > this.graphData.xData.length) {
        lastIndex = this.graphData.xData.length;
      }

      dynamicDataset.push({
        label: this.graphData.traces[this.selectedTraceIndex].label[this.actualLanguage],
        backgroundColor: 'rgba(70, 195, 123, 0.8)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: this.graphData.traces[this.selectedTraceIndex].yData.slice(firstIndex, lastIndex)
      });

      this.crunchedData = {
        labels: this.graphData.xData.slice(firstIndex, lastIndex),
        datasets: dynamicDataset
      };

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    formatTimeToUnix: function formatTimeToUnix(date, time) {
      var unixTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

      return unixTime;
    }
  },
  mounted: function mounted() {

    this.timeRange = this.endDate - this.startDate;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    for (var m = 0; m < this.graphData.traces.length; m++) {
      this.displayTraceFlag.push(true);
    }

    this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

    var DateStringSplit = this.myStartDate.toString().split(':');
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    DateStringSplit = this.myEndDate.toString().split(':');
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

    if (this.graphData.traces.length > 0) {
      this.updateChartData();
    }
  }
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LineChart__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['graphData'],
  data: function data() {
    return {
      timeRange: 0,
      actualLanguage: "FR",
      dataIsLoading: false,
      flagDisplayGraph: false,
      flagGraphDataIsLoading: false,
      movingAverageData: [],
      crunchedData: {},

      graphTimeSpan: 100,
      graphTimeCenter: 50,

      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      myStartDateTime: this.startDate,
      myEndDateTime: this.endDate,
      dataSamplingSelect: 'Automatic',

      displayTraceFlag: [],

      graphTitle: { FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)' },
      buttonLabelMA: { FR: "Moyenne", EN: 'Average' },
      buttonLabelMA_Days: { FR: "jours", EN: 'days' },
      graphLabelLastReading: { FR: "Dernière mesure", EN: 'Last reading' },

      labelStartDate: { FR: 'Date de début', EN: 'Start date' },
      labelStartTime: { FR: 'Heure de début', EN: 'Start time' },

      labelEndDate: { FR: 'Date de fin', EN: 'End date' },
      labelEndTime: { FR: 'Heure de fin', EN: 'End time' },

      labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },

      labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
      labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
      labelDataSampling5min: { FR: 'Données brutes', EN: 'Raw data' },
      labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
      labelDataSamplingDays: { FR: 'Jour', EN: 'Days' },

      labelTimeSpan: { FR: 'Plage de temps (%)', EN: 'Time span (%)' },
      labelTimeCenter: { FR: 'Centre de temps (%)', EN: 'Time center (%)' }

    };
  },


  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_4__components_LineChart__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimeSelect"]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: {
    refreshGraph: function refreshGraph() {
      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
    },
    updateChartData: function updateChartData() {
      var _this = this;

      var dynamicDataset = [];
      this.flagDisplayGraph = false;

      var firstIndex = 0;
      var lastIndex = this.graphData.xData.length;

      firstIndex = Math.round((parseInt(this.graphTimeCenter) - parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (firstIndex < 0) {
        firstIndex = 0;
      }
      lastIndex = Math.round((parseInt(this.graphTimeCenter) + parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (lastIndex > this.graphData.xData.length) {
        lastIndex = this.graphData.xData.length;
      }

      for (var m = 0; m < this.graphData.traces.length; m++) {
        if (this.displayTraceFlag[m]) {
          dynamicDataset.push({
            label: this.graphData.traces[m].label[this.actualLanguage],
            backgroundColor: 'rgba(70, 195, 123, 0.1)',
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: this.graphData.traces[m].yData.slice(firstIndex, lastIndex)
          });
        }
      }

      this.crunchedData = {
        labels: this.graphData.xData.slice(firstIndex, lastIndex),
        datasets: dynamicDataset
      };

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    formatTimeToUnix: function formatTimeToUnix(date, time) {
      var unixTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

      return unixTime;
    }
  },
  mounted: function mounted() {

    this.timeRange = this.endDate - this.startDate;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    for (var m = 0; m < this.graphData.traces.length; m++) {
      this.displayTraceFlag.push(true);
    }

    this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

    var DateStringSplit = this.myStartDate.toString().split(':');
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    DateStringSplit = this.myEndDate.toString().split(':');
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

    if (this.graphData.traces.length > 0) {
      this.updateChartData();
    }
  }
});

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LineChart__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['graphData'],
  data: function data() {
    return {
      timeRange: 0,
      actualLanguage: "FR",
      dataIsLoading: false,
      flagDisplayGraph: false,
      flagGraphDataIsLoading: false,
      movingAverageData: [],
      crunchedData: {},
      selectedTraceIndex: 0,

      graphTimeSpan: 100,
      graphTimeCenter: 50,

      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      myStartDateTime: this.startDate,
      myEndDateTime: this.endDate,
      dataSamplingSelect: 'Automatic',

      displayTraceFlag: [],

      graphTitle: { FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)' },
      buttonLabelMA: { FR: "Moyenne", EN: 'Average' },
      buttonLabelMA_Days: { FR: "jours", EN: 'days' },
      graphLabelLastReading: { FR: "Dernière mesure", EN: 'Last reading' },

      labelStartDate: { FR: 'Date de début', EN: 'Start date' },
      labelStartTime: { FR: 'Heure de début', EN: 'Start time' },

      labelEndDate: { FR: 'Date de fin', EN: 'End date' },
      labelEndTime: { FR: 'Heure de fin', EN: 'End time' },

      labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },

      labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
      labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
      labelDataSampling5min: { FR: 'Données brutes', EN: 'Raw data' },
      labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
      labelDataSamplingDays: { FR: 'Jour', EN: 'Days' },

      labelTimeSpan: { FR: 'Plage de temps (%)', EN: 'Time span (%)' },
      labelTimeCenter: { FR: 'Centre de temps (%)', EN: 'Time center (%)' }

    };
  },


  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_4__components_LineChart__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimeSelect"]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: {
    refreshGraph: function refreshGraph() {
      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
    },
    updateChartData: function updateChartData() {
      var _this = this;

      var dynamicDataset = [];
      this.flagDisplayGraph = false;

      var firstIndex = 0;
      var lastIndex = this.graphData.xData.length;

      firstIndex = Math.round((parseInt(this.graphTimeCenter) - parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (firstIndex < 0) {
        firstIndex = 0;
      }
      lastIndex = Math.round((parseInt(this.graphTimeCenter) + parseInt(this.graphTimeSpan) / 2) / 100 * this.graphData.xData.length);
      if (lastIndex > this.graphData.xData.length) {
        lastIndex = this.graphData.xData.length;
      }

      dynamicDataset.push({
        label: this.graphData.traces[this.selectedTraceIndex].label[this.actualLanguage],
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: this.graphData.traces[this.selectedTraceIndex].yData.slice(firstIndex, lastIndex)
      });

      this.crunchedData = {
        labels: this.graphData.xData.slice(firstIndex, lastIndex),
        datasets: dynamicDataset
      };

      this.$nextTick(function () {
        _this.flagDisplayGraph = true;
      });
    },
    formatTimeToUnix: function formatTimeToUnix(date, time) {
      var unixTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

      return unixTime;
    }
  },
  mounted: function mounted() {

    this.timeRange = this.endDate - this.startDate;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    for (var m = 0; m < this.graphData.traces.length; m++) {
      this.displayTraceFlag.push(true);
    }

    this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

    var DateStringSplit = this.myStartDate.toString().split(':');
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    DateStringSplit = this.myEndDate.toString().split(':');
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

    if (this.graphData.traces.length > 0) {
      this.updateChartData();
    }
  }
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['componentListIndicators'], data: function data() {
    return {
      actualLanguage: "FR",
      testColor: '#46c37b'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData'])),
  watch: {},
  methods: {},

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApiDeviceGraphLineSingleV1p00_vue__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApiDeviceGraphLineSingleV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ApiDeviceGraphLineSingleV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApiDeviceGraphLineMultipleV1p00_vue__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApiDeviceGraphLineMultipleV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ApiDeviceGraphLineMultipleV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApiDeviceGraphBarSingleV1p00_vue__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApiDeviceGraphBarSingleV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ApiDeviceGraphBarSingleV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ApiDeviceGraphBarMultipleV1p00_vue__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ApiDeviceGraphBarMultipleV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ApiDeviceGraphBarMultipleV1p00_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['panes'],
  components: {
    ApiDeviceGraphLineSingleV1p00: __WEBPACK_IMPORTED_MODULE_3__ApiDeviceGraphLineSingleV1p00_vue___default.a,
    ApiDeviceGraphLineMultipleV1p00: __WEBPACK_IMPORTED_MODULE_4__ApiDeviceGraphLineMultipleV1p00_vue___default.a,
    ApiDeviceGraphBarSingleV1p00: __WEBPACK_IMPORTED_MODULE_5__ApiDeviceGraphBarSingleV1p00_vue___default.a,
    ApiDeviceGraphBarMultipleV1p00: __WEBPACK_IMPORTED_MODULE_6__ApiDeviceGraphBarMultipleV1p00_vue___default.a
  },
  data: function data() {
    return {
      actualLanguage: "FR",
      testColor: '#46c37b',
      flagDisplayPanes: false,
      tabTitleClass: ['', 'active', '', ''],
      tabContentClass: ['tab-pane', 'tab-pane active', 'tab-pane']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData'])),
  watch: {},
  methods: {
    switchPane: function switchPane(index) {
      var _this = this;

      for (var m = 0; m < this.tabTitleClass.length; m++) {
        this.tabTitleClass[m] = '';
        this.tabContentClass[m] = 'tab-pane';
      }
      this.tabTitleClass[index] = 'active';
      this.tabContentClass[index] = 'tab-pane active';
      this.flagDisplayPanes = false;
      this.$nextTick(function () {
        _this.flagDisplayPanes = true;
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.tabTitleClass = [];
    this.tabContentClass = [];

    this.flagDisplayPanes = false;
    console.log("Pane mount 1");
    console.log(this.panes);
    for (var m = 0; m < this.panes.length; m++) {
      this.tabTitleClass.push('');
      this.tabContentClass.push('tab-pane');
    }
    console.log("Pane mount 2");
    this.tabTitleClass[0] = 'active';
    this.tabContentClass[0] = 'tab-pane active';

    this.$nextTick(function () {
      _this2.flagDisplayPanes = true;
    });
  }
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LineChart__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelCloudLiveModalDisplay',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_3__components_LineChart__["a" /* default */]
  },
  data: function data() {
    return {
      channelIndex: 0,
      dataTimestamp: [],
      dataTimestampEpoch: [],
      dataRead: [],
      GraphTitle: '',
      selectedDeviceDataType: 'current_RMS',

      I_RMS_Port01: [],
      I_RMS_Port02: [],
      I_RMS_Port03: [],
      I_RMS_Port04: [],
      I_RMS_Port05: [],
      I_RMS_Port06: [],

      PowerPort01: [],
      PowerPort02: [],
      PowerPort03: [],
      PowerPort04: [],
      PowerPort05: [],
      PowerPort06: [],
      ActualChannelPortList: [],
      PowerActualChannel: [],

      InputV_RMS01: [],
      InputV_RMS02: [],
      InputV_RMS03: [],
      InputV_RMS04: [],
      InputV_RMS05: [],
      InputV_RMS06: [],

      dataIsLoading: false,
      pooling: null,
      dataPoolingIsActive: false,
      dataPoolingCounter: 0,

      actualLanguage: "FR",
      labelSectionUser: { FR: 'Accès usager', EN: 'User access' },
      labelSectionGroup: { FR: 'Group usagers', EN: 'User group' },

      labelSelectorCurrentRMS: { FR: 'Courant (A)', EN: 'Current (A)' },
      labelSelectorPower: { FR: 'Puissance (W)', EN: 'Power (W)' },
      labelSelectorInputVRMS: { FR: 'Tension du senseur (mV)', EN: 'Sensor voltage (mV)' },

      labelAppareilDevice: { FR: 'Appareil actuel (W)', EN: 'Actual Device (W)' },
      labelButtonDownload: { FR: "Téléchargement", EN: 'Download' },

      graphData: {
        labels: __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }),

        datasets: [{
          label: 'Mesure',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].map(this.portData, function (data) {
            return data.avrPower;
          })
        }]
      },

      flagDisplayNewGraph: true,
      chartDataSeries: [],

      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 400,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          }
        },
        xaxis: {}
      }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: {
    testGetLiveCloud: function testGetLiveCloud() {
      var _this = this;

      var startTimestamp_epoch = moment().unix() - 20;
      this.dataIsLoading = true;

      if (this.dataTimestampEpoch.length > 0) {
        startTimestamp_epoch = this.dataTimestampEpoch[this.dataTimestampEpoch.length - 1];
      }

      var requestData = { 'postAction': 'GetDeviceLiveCloudReadings',
        'bundleId': this.actualBundle.bundleId,
        'deviceId': this.overlayParameters.deviceId,
        'startTimestamp': startTimestamp_epoch,
        'channelId': this.overlayParameters.channelId
      };
      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        if (response.data.Code == 'OK') {

          for (var n = 0; n < response.data.DataTimestamp.length; n++) {
            _this.dataTimestampEpoch.push(response.data.DataTimestamp[n]);
            _this.dataTimestamp.push(moment(response.data.DataTimestamp[n] * 1000).format('HH:mm:ss'));

            _this.I_RMS_Port01.push(response.data.LiveData[n].currentRMS[0]);
            _this.I_RMS_Port02.push(response.data.LiveData[n].currentRMS[1]);
            _this.I_RMS_Port03.push(response.data.LiveData[n].currentRMS[2]);
            _this.I_RMS_Port04.push(response.data.LiveData[n].currentRMS[3]);
            _this.I_RMS_Port05.push(response.data.LiveData[n].currentRMS[4]);
            _this.I_RMS_Port06.push(response.data.LiveData[n].currentRMS[5]);

            _this.PowerPort01.push(response.data.LiveData[n].power[0]);
            _this.PowerPort02.push(response.data.LiveData[n].power[1]);
            _this.PowerPort03.push(response.data.LiveData[n].power[2]);
            _this.PowerPort04.push(response.data.LiveData[n].power[3]);
            _this.PowerPort05.push(response.data.LiveData[n].power[4]);
            _this.PowerPort06.push(response.data.LiveData[n].power[5]);

            _this.InputV_RMS01.push(response.data.LiveData[n].inputV_RMS[0]);
            _this.InputV_RMS02.push(response.data.LiveData[n].inputV_RMS[1]);
            _this.InputV_RMS03.push(response.data.LiveData[n].inputV_RMS[2]);
            _this.InputV_RMS04.push(response.data.LiveData[n].inputV_RMS[3]);
            _this.InputV_RMS05.push(response.data.LiveData[n].inputV_RMS[4]);
            _this.InputV_RMS06.push(response.data.LiveData[n].inputV_RMS[5]);

            if (_this.overlayParameters.liveType == 'Channel') {
              var ActualChannelPower = 0;

              if (_this.ActualChannelPortList.indexOf("1") > -1) {
                ActualChannelPower += response.data.LiveData[n].power[0];
              }
              if (_this.ActualChannelPortList.indexOf("2") > -1) {
                ActualChannelPower += response.data.LiveData[n].power[1];
              }
              if (_this.ActualChannelPortList.indexOf("3") > -1) {
                ActualChannelPower += response.data.LiveData[n].power[2];
              }
              if (_this.ActualChannelPortList.indexOf("4") > -1) {
                ActualChannelPower += response.data.LiveData[n].power[3];
              }
              if (_this.ActualChannelPortList.indexOf("5") > -1) {
                ActualChannelPower += response.data.LiveData[n].power[4];
              }
              if (_this.ActualChannelPortList.indexOf("6") > -1) {
                ActualChannelPower += response.data.LiveData[n].power[5];
              }
              _this.PowerActualChannel.push(ActualChannelPower);
            }
          }

          if (_this.overlayParameters.liveType == 'Channel') {
            _this.updateGraphDataChannel();
          }

          if (_this.overlayParameters.liveType == 'Device') {
            _this.updateGraphDataDevice();
          }
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
        _this.dataIsLoading = false;
      });

      this.dataPoolingCounter += 1;
      if (this.dataPoolingCounter == 100) {
        clearInterval(this.polling);
        this.dataPoolingIsActive = false;
      }
    },
    pollData: function pollData() {
      var _this2 = this;

      this.polling = setInterval(function () {
        _this2.testGetLiveCloud();
      }, 5000);
    },
    updateGraphDataChannel: function updateGraphDataChannel() {
      var graphDataset = [];
      this.chartDataSeries = [];
      var NewGraphDataTempo = [];
      var actualValue = 0.0;

      if (this.ActualChannelPortList.indexOf("1") > -1) {
        graphDataset.push({ label: 'Module Port 1 (W)',
          backgroundColor: 'rgba(70, 195, 123, 0.2)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: this.PowerPort01 });

        NewGraphDataTempo = [];
        for (var i = 0; i < this.PowerPort01.length; i++) {
          actualValue = this.PowerPort01[i];
          NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: 'Module Port 1 (W)', data: NewGraphDataTempo });
      }

      if (this.ActualChannelPortList.indexOf("2") > -1) {
        graphDataset.push({ label: 'Module Port 2 (W)',
          backgroundColor: 'rgba(70, 195, 123, 0.2)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: this.PowerPort02 });

        NewGraphDataTempo = [];
        for (var i = 0; i < this.PowerPort02.length; i++) {
          actualValue = this.PowerPort02[i];
          NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: 'Module Port 2 (W)', data: NewGraphDataTempo });
      }

      if (this.ActualChannelPortList.indexOf("3") > -1) {
        graphDataset.push({ label: 'Module Port 3 (W)',
          backgroundColor: 'rgba(70, 195, 123, 0.2)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: this.PowerPort03 });

        NewGraphDataTempo = [];
        for (var i = 0; i < this.PowerPort03.length; i++) {
          actualValue = this.PowerPort03[i];
          NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: 'Module Port 3 (W)', data: NewGraphDataTempo });
      }

      if (this.ActualChannelPortList.indexOf("4") > -1) {
        graphDataset.push({ label: 'Module Port 4 (W)',
          backgroundColor: 'rgba(70, 195, 123, 0.2)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: this.PowerPort04 });

        NewGraphDataTempo = [];
        for (var i = 0; i < this.PowerPort04.length; i++) {
          actualValue = this.PowerPort04[i];
          NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: 'Module Port 4 (W)', data: NewGraphDataTempo });
      }

      if (this.ActualChannelPortList.indexOf("5") > -1) {
        graphDataset.push({ label: 'Module Port 5 (W)',
          backgroundColor: 'rgba(70, 195, 123, 0.2)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: this.PowerPort05 });

        NewGraphDataTempo = [];
        for (var i = 0; i < this.PowerPort05.length; i++) {
          actualValue = this.PowerPort05[i];
          NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: 'Module Port 5 (W)', data: NewGraphDataTempo });
      }

      if (this.ActualChannelPortList.indexOf("6") > -1) {
        graphDataset.push({ label: 'Module Port 6 (W)',
          backgroundColor: 'rgba(70, 195, 123, 0.2)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: this.PowerPort06 });
        NewGraphDataTempo = [];
        for (var i = 0; i < this.PowerPort06.length; i++) {
          actualValue = this.PowerPort06[i];
          NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: 'Module Port 6 (W)', data: NewGraphDataTempo });
      }

      graphDataset.push({ label: this.labelAppareilDevice[this.actualLanguage],
        backgroundColor: 'rgba(70, 195, 123, 0.2)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: this.PowerActualChannel });

      NewGraphDataTempo = [];
      for (var i = 0; i < this.PowerActualChannel.length; i++) {
        actualValue = this.PowerActualChannel[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: this.labelAppareilDevice[this.actualLanguage], data: NewGraphDataTempo });

      this.graphData = {
        labels: this.dataTimestamp,

        datasets: graphDataset
      };
    },
    updateGraphDataDevice: function updateGraphDataDevice() {
      var graphDataset = [];
      var portDataTempo = [];

      this.chartDataSeries = [];
      var NewGraphDataTempo = [];
      var actualValue = 0.0;

      if (this.selectedDeviceDataType == 'current_RMS') {
        portDataTempo = this.I_RMS_Port01;
      }
      if (this.selectedDeviceDataType == 'power') {
        portDataTempo = this.PowerPort01;
      }
      if (this.selectedDeviceDataType == 'input_VRMS') {
        portDataTempo = this.InputV_RMS01;
      }
      graphDataset.push({ label: 'Port 1',
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: portDataTempo });
      NewGraphDataTempo = [];
      for (var i = 0; i < portDataTempo.length; i++) {
        actualValue = portDataTempo[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: 'Port 1', data: NewGraphDataTempo });

      if (this.selectedDeviceDataType == 'current_RMS') {
        portDataTempo = this.I_RMS_Port02;
      }
      if (this.selectedDeviceDataType == 'power') {
        portDataTempo = this.PowerPort02;
      }
      if (this.selectedDeviceDataType == 'input_VRMS') {
        portDataTempo = this.InputV_RMS02;
      }
      graphDataset.push({ label: 'Port 2',
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: portDataTempo });
      NewGraphDataTempo = [];
      for (var i = 0; i < portDataTempo.length; i++) {
        actualValue = portDataTempo[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: 'Port 2', data: NewGraphDataTempo });

      if (this.selectedDeviceDataType == 'current_RMS') {
        portDataTempo = this.I_RMS_Port03;
      }
      if (this.selectedDeviceDataType == 'power') {
        portDataTempo = this.PowerPort03;
      }
      if (this.selectedDeviceDataType == 'input_VRMS') {
        portDataTempo = this.InputV_RMS03;
      }
      graphDataset.push({ label: 'Port 3',
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: portDataTempo });
      NewGraphDataTempo = [];
      for (var i = 0; i < portDataTempo.length; i++) {
        actualValue = portDataTempo[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: 'Port 3', data: NewGraphDataTempo });

      if (this.selectedDeviceDataType == 'current_RMS') {
        portDataTempo = this.I_RMS_Port04;
      }
      if (this.selectedDeviceDataType == 'power') {
        portDataTempo = this.PowerPort04;
      }
      if (this.selectedDeviceDataType == 'input_VRMS') {
        portDataTempo = this.InputV_RMS04;
      }
      graphDataset.push({ label: 'Port 4',
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: portDataTempo });
      NewGraphDataTempo = [];
      for (var i = 0; i < portDataTempo.length; i++) {
        actualValue = portDataTempo[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: 'Port 4', data: NewGraphDataTempo });

      if (this.selectedDeviceDataType == 'current_RMS') {
        portDataTempo = this.I_RMS_Port05;
      }
      if (this.selectedDeviceDataType == 'power') {
        portDataTempo = this.PowerPort05;
      }
      if (this.selectedDeviceDataType == 'input_VRMS') {
        portDataTempo = this.InputV_RMS05;
      }
      graphDataset.push({ label: 'Port 5',
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: portDataTempo });
      NewGraphDataTempo = [];
      for (var i = 0; i < portDataTempo.length; i++) {
        actualValue = portDataTempo[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: 'Port 5', data: NewGraphDataTempo });

      if (this.selectedDeviceDataType == 'current_RMS') {
        portDataTempo = this.I_RMS_Port06;
      }
      if (this.selectedDeviceDataType == 'power') {
        portDataTempo = this.PowerPort06;
      }
      if (this.selectedDeviceDataType == 'input_VRMS') {
        portDataTempo = this.InputV_RMS06;
      }
      graphDataset.push({ label: 'Port 6',
        backgroundColor: 'rgba(70, 195, 123, 0.1)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: portDataTempo });
      NewGraphDataTempo = [];
      for (var i = 0; i < portDataTempo.length; i++) {
        actualValue = portDataTempo[i];
        NewGraphDataTempo.push([this.dataTimestampEpoch[i] - this.dataTimestampEpoch[0], actualValue.toFixed(3)]);
      }
      this.chartDataSeries.push({ name: 'Port 6', data: NewGraphDataTempo });

      this.graphData = {
        labels: this.dataTimestamp,

        datasets: graphDataset
      };
    }
  },

  created: function created() {
    this.pollData();
    this.dataPoolingIsActive = true;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.dataPoolingIsActive) {
      clearInterval(this.polling);
    }
  },
  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.channelIndex = this.overlayParameters.channelIndex;

    clearInterval();


    if (this.overlayParameters.liveType == 'Channel') {
      this.GraphTitle = this.actualBundle.channels[this.overlayParameters.channelIndex].ChannelData.channelInfo.channelName;
      this.ActualChannelPortList = this.actualBundle.channels[this.overlayParameters.channelIndex].ChannelData.linkedDevicePorts.ports;
    }

    if (this.overlayParameters.liveType == 'Device') {
      this.GraphTitle = this.actualBundle.devices[this.overlayParameters.deviceIndex].DeviceData.deviceInfo.name;
    }
  }
});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelCommentAddForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      commentIsSaving: false,
      comment: '',
      channelIndex: 0,

      actualLanguage: "FR",
      labelFieldEvName: { FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name' },

      sectionLabelAddComment: { FR: "Enregistrer un commentaire au journal de l'appareil", EN: 'Add comment to this device log book' },
      buttonLabelSave: { FR: "Enregistrer", EN: 'Save' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: {
    saveChannelCommentLog: function saveChannelCommentLog() {
      var _this = this;

      this.commentIsSaving = true;
      var requestData = { 'postAction': 'SaveChannelCommentLog',
        'bundleId': this.actualBundle.bundle_id,
        'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
        'localTime': moment().format('Y-MM-DDTHH:mm'),
        'info': { 'postedBy': this.profileData.profileInfo.firstName + " " + this.profileData.profileInfo.lastName,
          'postedById': this.profileData.profileId,
          'postedByEmail': this.profileData.profileInfo.email,
          'comment': this.comment }
      };

      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        _this.commentIsSaving = false;
        if (response.data.Code == 'OK') {
          var parameters = { 'Parameter': 'None' };
          _this.$store.dispatch('overlayStore/setParameters', parameters);
          _this.$store.dispatch('overlayStore/toggleModal', false);
        } else {
          window.alert("L'enregistrement a échoué. / Saving fail.");
        }
      });
    }
  },

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.channelIndex = this.overlayParameters.channelIndex;
  }
});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortGraph_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortGraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PortGraph_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  components: {
    PortGraph: __WEBPACK_IMPORTED_MODULE_3__PortGraph_vue___default.a
  },
  data: function data() {
    return {
      timeRange: 0,
      journalItems: [],
      totalWorkingTime: 0,

      actualLanguage: "FR",

      sectionLabelLogBook: { FR: "Journal de l'appareil", EN: 'Device log book' },
      textLableTotalMaintenance: { FR: "Temps maintenance total:", EN: 'Total maintenance work time:' },
      buttonAddComment: { FR: "Ajouter un commentaire", EN: 'Add comment' },
      buttonAddMaintenance: { FR: "Ajouter un entretient", EN: 'Add maintenance' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  watch: {
    startDate: function startDate() {},
    overlayParameters: function overlayParameters() {
      var _this = this;

      this.$nextTick(function () {
        _this.readJournalReadings();
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    computeTimeRange: function computeTimeRange() {
      this.timeRange = this.endDate - this.startDate;
    },
    addChannelCommentLog: function addChannelCommentLog() {
      var parameters = { 'channelIndex': this.channelIndex };
      this.$store.dispatch('overlayStore/setParameters', parameters);
      this.showModal('channel-comment-add-form');
      this.readJournalReadings();
    },
    addChannelMaintenanceLog: function addChannelMaintenanceLog() {
      var parameters = { 'channelIndex': this.channelIndex };
      this.$store.dispatch('overlayStore/setParameters', parameters);
      this.showModal('channel-maintenance-add-form');
      this.readJournalReadings();
    },
    readJournalReadings: function readJournalReadings() {
      var _this2 = this;

      this.flagChannelDataIsLoading = true;

      var requestData = { 'postAction': 'GetChannelJournalLog',
        'bundleId': this.actualBundle.bundle_id,
        'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
        'start': this.startDate,
        'end': this.endDate
      };

      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.journalItems = response.data.journalItems;

          _this2.totalWorkingTime = 0;
          for (var n = 0; n < _this2.journalItems.length; n++) {
            if (_this2.journalItems[n].event_type == 'maintenance') {
              _this2.totalWorkingTime += parseFloat(_this2.journalItems[n].event_info.workTime);
            }
          }
        } else {
          window.alert(_this2.messagePostFail[_this2.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {
    this.computeTimeRange();
    this.readJournalReadings();


    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChannelMaintenanceAddForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      commentIsSaving: false,
      description: '',
      channelIndex: 0,
      workTime: 0,

      actualLanguage: "FR",
      labelFieldEvName: { FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name' },
      sectionLabelMaintenance: { FR: "Enregistrement de maintenance d'appareil", EN: 'Records device maintenance' },
      labelInterventionTime: { FR: "Temps d'intervention", EN: 'Intervention time' },
      buttonLabelSave: { FR: "Enregistrer", EN: 'Save' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: {
    saveChannelCommentLog: function saveChannelCommentLog() {
      var _this = this;

      this.commentIsSaving = true;
      var requestData = { 'postAction': 'SaveChannelMaintenanceLog',
        'bundleId': this.actualBundle.bundle_id,
        'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
        'localTime': moment().format('Y-MM-DDTHH:mm'),
        'info': { 'postedBy': this.profileData.profileInfo.firstName + " " + this.profileData.profileInfo.lastName,
          'postedById': this.profileData.profileId,
          'postedByEmail': this.profileData.profileInfo.email,
          'description': this.description,
          'workTime': this.workTime }
      };

      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        _this.commentIsSaving = false;
        if (response.data.Code == 'OK') {
          var parameters = { 'Parameter': 'None' };
          _this.$store.dispatch('overlayStore/setParameters', parameters);
          _this.$store.dispatch('overlayStore/toggleModal', false);
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    }
  },

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.channelIndex = this.overlayParameters.channelIndex;
  }
});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tableData'],
  data: function data() {
    return {
      displayDataTable: false,
      displayAvrPowerColumn: true,
      displayPeakColumn: true,
      displayKwrColumn: true,
      displayCostColumn: true,
      displayTemperatureColumn: false,
      displayHumidityColumn: false,
      displayCloudColumn: false,
      displayWindColumn: false,

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },
      labelTableColTime: { FR: 'Temps', EN: 'Time' },
      labelTableColAvrPower: { FR: 'Puissance moyenne', EN: 'Average power' },
      labelTableColPeakPower: { FR: 'Appel de puissance', EN: 'Peak power' },
      labelTableColConsumption: { FR: 'Consommation(kWh)', EN: 'Consumption(kWh)' },
      labelTableColCost: { FR: 'Consommation($)', EN: 'Consumption($)' },
      labelTableColTemperature: { FR: 'Température(C)', EN: 'Temperature(C)' },
      labelTableColHumidity: { FR: 'Humidité(%)', EN: 'Humidity(%)' },
      labelTableColCloud: { FR: 'Ennuagement(%)', EN: 'Cloudy(%)' },
      labelTableColWind: { FR: 'Vent(km/h)', EN: 'Wind(km/h)' },

      labelButtonDownloadData: { FR: 'Télécharger les données', EN: 'Download data' }
    };
  },


  methods: {},
  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BarChart_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_apexcharts__);











__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_7_vue_json_csv___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  data: function data() {
    return {
      timeRange: 0,
      readings: [],

      tableTitle: '',
      flagDisplayHistogramSection: false,
      flagDisplayHistogramHr: true,
      flagHistogramDataComputed: false,
      histogramData: null,
      histogramDataDay: null,
      selectedDataType: 'cost',
      histogramDataDownloadHour: [],
      histogramDataDownloadDay: [],
      labelSelectorPeakCurrent: { FR: 'Appelde courant (A)', EN: 'Peak current (A)' },
      labelSelectorPeakPower: { FR: 'Appel de puissance (W)', EN: 'Peak power (W)' },
      labelSelectorKWH: { FR: 'Consommation (kWh)', EN: 'Consumption (kWh)' },
      labelSelectorCost: { FR: 'Coût ($)', EN: 'Cost ($)' },

      labelHistogramTypeHr: { FR: 'Heure', EN: 'Hour' },
      labelHistogramTypeDay: { FR: 'Jour', EN: 'Day' },
      labelHistogramActivate: { FR: 'Activer', EN: 'Activate' },

      labelHistogramDay: { FR: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'], EN: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] },
      labelButtonDownloadData: { FR: 'Télécharger les données', EN: 'Download data' },

      actualLanguage: "FR",

      cumulativeSumKWH: [],
      cumulativeSumCost: [],
      maxCurrent: 0,
      sumCost: 0,
      sumKWH: 0,
      flagGraphDataIsLoading: false,
      labelGraphPeakCurrent: { FR: 'Courant maximum', EN: 'Max current' },
      labelGraphCost: { FR: 'Coût', EN: 'Cost' },
      labelGraphSaving: { FR: 'Économies', EN: 'Savings' },
      labelGraphConsumption: { FR: 'Consommation', EN: 'Consumption' },
      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      dataSamplingSelect: 'Automatic',
      myStartDateTime: this.startDate,
      myEndDateTime: this.endDate,
      labelStartDate: { FR: 'Date de début', EN: 'Start date' },
      labelStartTime: { FR: 'Heure de début', EN: 'Start time' },
      labelEndDate: { FR: 'Date de fin', EN: 'End date' },
      labelEndTime: { FR: 'Heure de fin', EN: 'End time' },
      labelButtonRefresh: { FR: 'Rafraichir le graphique', EN: 'Refresh graph' },
      labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
      labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
      labelDataSampling5min: { FR: '5 minutes', EN: '5 minute' },
      labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
      labelDataSamplingDays: { FR: 'Jour', EN: 'Days' }
    };
  },


  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_3__components_BarChart_js__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_4_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_4_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_4_element_ui__["TimeSelect"],
    Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: {
    constructHistogramData: function constructHistogramData() {

      var costHr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var kwhHr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var peakPowerHr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var peakCurrentHr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      var costDay = [0, 0, 0, 0, 0, 0, 0];
      var kwhDay = [0, 0, 0, 0, 0, 0, 0];
      var peakPowerDay = [0, 0, 0, 0, 0, 0, 0];
      var peakCurrentDay = [0, 0, 0, 0, 0, 0, 0];

      for (var j = 0; j < this.readings.length; j++) {
        var str = this.readings[j].timestamp;
        var dayOfWeek = new Date(str).getDay();

        costHr[parseInt(str.substr(12, 2))] = costHr[parseInt(str.substr(12, 2))] + this.readings[j].cost;
        costDay[dayOfWeek] = costDay[dayOfWeek] + this.readings[j].cost;

        kwhHr[parseInt(str.substr(12, 2))] = kwhHr[parseInt(str.substr(12, 2))] + this.readings[j].kwr;
        kwhDay[dayOfWeek] = kwhDay[dayOfWeek] + this.readings[j].kwr;

        if (this.readings[j].peak > peakPowerHr[parseInt(str.substr(12, 2))]) {
          peakPowerHr[parseInt(str.substr(12, 2))] = this.readings[j].peak;
        }
        if (this.readings[j].peak > peakPowerDay[dayOfWeek]) {
          peakPowerDay[dayOfWeek] = this.readings[j].peak;
        }

        if (this.readings[j].peakCurrent > peakCurrentHr[parseInt(str.substr(12, 2))]) {
          peakCurrentHr[parseInt(str.substr(12, 2))] = this.readings[j].peakCurrent;
        }
        if (this.readings[j].peakCurrent > peakCurrentDay[dayOfWeek]) {
          peakCurrentDay[dayOfWeek] = this.readings[j].peakCurrent;
        }
      }

      var dataHr = costHr;
      var dataDay = costDay;

      if (this.selectedDataType == "kwh") {
        dataHr = kwhHr;
        dataDay = kwhDay;
      }

      if (this.selectedDataType == "peakPower") {
        dataHr = peakPowerHr;
        dataDay = peakPowerDay;
      }

      if (this.selectedDataType == "peakCurrent") {
        dataHr = peakCurrentHr;
        dataDay = peakCurrentDay;
      }

      this.histogramData = {
        labels: ['0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
        datasets: [{
          label: '',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: dataHr }]
      };

      this.histogramDataDay = {
        labels: this.labelHistogramDay[this.actualLanguage],
        datasets: [{
          label: '',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: dataDay }]
      };

      this.histogramDataDownloadHour = [];
      this.histogramDataDownloadDay = [];

      for (var _j = 0; _j < dataHr.length; _j++) {
        this.histogramDataDownloadHour.push({ 'Hour': this.histogramData.labels[_j], 'Cost': costHr[_j], 'kWh': kwhHr[_j], 'Peak Power': peakPowerHr[_j], 'Peak Current': peakCurrentHr[_j] });
      }

      for (var _j2 = 0; _j2 < dataDay.length; _j2++) {
        this.histogramDataDownloadDay.push({ 'Day': this.labelHistogramDay[this.actualLanguage][_j2], 'Cost': costDay[_j2], 'kWh': kwhDay[_j2], 'Peak Power': peakPowerDay[_j2], 'Peak Current': peakCurrentDay[_j2] });
      }

      this.flagHistogramDataComputed = true;
    },
    refreshGraph: function refreshGraph() {
      var _this = this;

      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
      this.flagGraphDataIsLoading = true;
      var requestData = { 'postAction': 'GetChannelReadings',
        'bundleId': this.actualBundle.bundle_id,
        'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
        'start': this.myStartDateTime,
        'end': this.myEndDateTime,
        'dataSampling': this.dataSamplingSelect
      };


      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.readings = response.data.ChannelReadings;
          _this.computeCumulativeSum();
          _this.constructHistogramData();
          _this.flagGraphDataIsLoading = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
          _this.flagGraphDataIsLoading = false;
        }
      });

      this.$store.dispatch('chargesStore/setStartDate', this.myStartDateTime);
      this.$store.dispatch('chargesStore/setEndDate', this.myEndDateTime);
    },
    computeCumulativeSum: function computeCumulativeSum() {
      this.cumulativeSumKWH = __WEBPACK_IMPORTED_MODULE_1_underscore__["a" /* default */].map(this.readings, function (data) {
        return data.kwr;
      });
      var Sum = this.cumulativeSumKWH[0];
      for (var i = 1; i < this.cumulativeSumKWH.length; i++) {
        Sum += this.cumulativeSumKWH[i];
        this.cumulativeSumKWH[i] = Sum.toFixed(3);
        this.cumulativeSumKWH[i] = Sum.toFixed(3);
      }
      this.sumKWH = Sum;

      this.cumulativeSumCost = __WEBPACK_IMPORTED_MODULE_1_underscore__["a" /* default */].map(this.readings, function (data) {
        return data.cost;
      });
      var Sum = this.cumulativeSumCost[0];
      for (var i = 1; i < this.cumulativeSumCost.length; i++) {
        Sum += this.cumulativeSumCost[i];
        this.cumulativeSumCost[i] = Sum.toFixed(3);
      }
      this.sumCost = Sum;

      var currents = __WEBPACK_IMPORTED_MODULE_1_underscore__["a" /* default */].map(this.readings, function (data) {
        return data.peakCurrent;
      });
      this.maxCurrent = 0;
      for (var i = 1; i < this.cumulativeSumCost.length; i++) {
        if (currents[i] > this.maxCurrent) {
          this.maxCurrent = currents[i];
        }
      }
    },
    formatTimeToUnix: function formatTimeToUnix(date, time) {
      var unixTime = moment(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();
      return unixTime;
    }
  },
  mounted: function mounted() {
    this.timeRange = this.endDate - this.startDate;
    this.readings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings;


    this.tableTitle = 'None';
    this.flagDisplayHistogramSection = true;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

    var DateStringSplit = this.myStartDate.toString().split(':');
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    DateStringSplit = this.myEndDate.toString().split(':');
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

    this.computeCumulativeSum();
    this.constructHistogramData();
  }
});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LineChart__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_apexcharts__);










__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_6_vue_json_csv___default.a);







/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['channel_id'],
    data: function data() {
        return {
            timeRange: 0,
            actualLanguage: "FR",
            flagMovingAverageDataAvailable: false,
            flagMovingAverageDataIsLoading: true,
            flagDisplayGraph: false,
            flagGraphDataIsLoading: false,
            movingAverageData: [],
            crunchedData: {},

            myStartDate: '',
            myEndDate: '',
            startTime: '00:00',
            endTime: '00:00',
            myStartDateTime: this.startDate,
            myEndDateTime: this.endDate,
            dataSamplingSelect: 'Automatic',

            display5Min: false,
            display001H: false,
            display004H: false,
            display006H: false,
            display012H: false,
            display024H: false,
            display072H: false,
            display168H: false,
            display336H: false,
            display720H: false,

            graphTitle: { FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)' },
            buttonLabelMA: { FR: "Moyenne", EN: 'Average' },
            buttonLabelMA_Days: { FR: "jours", EN: 'days' },
            graphLabelLastReading: { FR: "Dernière mesure", EN: 'Last reading' },

            labelStartDate: { FR: 'Date de début', EN: 'Start date' },
            labelStartTime: { FR: 'Heure de début', EN: 'Start time' },

            labelEndDate: { FR: 'Date de fin', EN: 'End date' },
            labelEndTime: { FR: 'Heure de fin', EN: 'End time' },

            labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },

            labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
            labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
            labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
            labelDataSamplingDays: { FR: 'Jour', EN: 'Days' },

            chartDataSeries: [{
                name: 'TBD',
                data: [[1324508400000, 34], [1324594800000, 54], [1326236400000, 43], [1326236405000, 43], [1326236406000, 53], [1326236406500, 63]]
            }],

            chartOptions: {
                chart: {
                    type: 'area',
                    stacked: false,
                    height: 400,
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                dataLabels: {
                    enabled: false
                },
                markers: {
                    size: 0
                },
                tooltip: {
                    x: { format: 'dd MMM hh:mm' }
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.5,
                        opacityTo: 0,
                        stops: [0, 70, 100]
                    }
                },
                xaxis: {
                    type: 'datetime'
                }
            }

        };
    },


    components: {
        LineChart: __WEBPACK_IMPORTED_MODULE_4__components_LineChart__["a" /* default */],
        Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"],
        TimePicker: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimePicker"],
        TimeSelect: __WEBPACK_IMPORTED_MODULE_7_element_ui__["TimeSelect"]
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

    methods: {
        refreshGraph: function refreshGraph() {
            this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
            this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
            this.getMovingAverageLogData();
        },
        getMovingAverageLogData: function getMovingAverageLogData() {
            var _this = this;

            this.flagGraphDataIsLoading = true;
            var requestData = { 'postAction': 'GetMovingAverageLog',
                'bundleId': this.actualBundle.bundle_id,
                'channelId': this.channel_id,
                'start': this.myStartDateTime,
                'end': this.myEndDateTime,
                'dataSampling': this.dataSamplingSelect
            };

            this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this.movingAverageData = response.data.LogItems;
                    _this.updateChartData();
                    _this.flagGraphDataIsLoading = false;
                    _this.flagMovingAverageDataIsLoading = false;
                } else {
                    window.alert(response.PromptMessage[_this.actualLanguage]);
                    _this.flagGraphDataIsLoading = false;
                }
            });
        },
        updateChartData: function updateChartData() {
            var _this2 = this;

            this.chartDataSeries = [];
            var NewGraphDataTempo = [];

            this.flagDisplayGraph = false;

            if (this.display001H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_001H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "1 hr", data: NewGraphDataTempo });
            }

            if (this.display004H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_004H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "4 hr", data: NewGraphDataTempo });
            }

            if (this.display006H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_006H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "6 hr", data: NewGraphDataTempo });
            }

            if (this.display012H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_012H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "12 hr", data: NewGraphDataTempo });
            }

            if (this.display024H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_024H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "24 hr", data: NewGraphDataTempo });
            }

            if (this.display072H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_072H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "3 jr/days", data: NewGraphDataTempo });
            }

            if (this.display168H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_168H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "7 jr/days", data: NewGraphDataTempo });
            }

            if (this.display336H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_336H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "14 jr/days", data: NewGraphDataTempo });
            }

            if (this.display720H) {
                NewGraphDataTempo = [];
                for (var i = 0; i < this.movingAverageData.length; i++) {
                    NewGraphDataTempo.push([this.movingAverageData[i].timestamp, this.movingAverageData[i].MA_720H.toFixed(3)]);
                }
                this.chartDataSeries.push({ name: "30 jr/days", data: NewGraphDataTempo });
            }

            this.$nextTick(function () {
                _this2.flagDisplayGraph = true;
            });
        },
        formatTimeToUnix: function formatTimeToUnix(date, time) {
            var unixTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

            return unixTime;
        }
    },
    mounted: function mounted() {

        this.timeRange = this.endDate - this.startDate;

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }

        this.display5Min = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual;
        this.display001H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H;
        this.display004H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H;
        this.display006H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H;
        this.display012H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H;
        this.display024H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H;
        this.display072H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H;
        this.display168H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H;
        this.display336H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H;
        this.display720H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H;

        this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

        var DateStringSplit = this.myStartDate.toString().split(':');
        this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

        DateStringSplit = this.myEndDate.toString().split(':');
        this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

        this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
        this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

        this.getMovingAverageLogData();
    }
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortGraph_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortGraph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PortGraph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HistogramGraph__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HistogramGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HistogramGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataTable__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MovingAverageGraph__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MovingAverageGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MovingAverageGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SessionsGraph__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SessionsGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SessionsGraph__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  components: {
    PortGraph: __WEBPACK_IMPORTED_MODULE_3__PortGraph_vue___default.a,
    DataTable: __WEBPACK_IMPORTED_MODULE_5__DataTable___default.a,
    MovingAverageGraph: __WEBPACK_IMPORTED_MODULE_6__MovingAverageGraph___default.a,
    HistogramGraph: __WEBPACK_IMPORTED_MODULE_4__HistogramGraph___default.a,
    SessionsGraph: __WEBPACK_IMPORTED_MODULE_7__SessionsGraph___default.a
  },
  data: function data() {
    return {
      timeRange: 0,
      actualLanguage: "FR",
      channelReadings: [],
      btnTimeLineSelected: true,
      displayGraphBlock: true,
      btnHistogramSelected: false,
      btnSessionsSelected: false,
      btnMovingAverageSelected: false,

      buttonLabelTimeSeries: { FR: "Mesures temporelles", EN: 'Time series' },
      buttonLabelMovingAverage: { FR: "Moyennes mobiles", EN: 'Moving average' },
      buttonLabelHistogram: { FR: "Histogramme", EN: 'Histogram' },
      textSectionTableau: { FR: "Tableau des mesures", EN: 'Measurement table' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),


  methods: {
    selectTimeLine: function selectTimeLine() {
      this.btnTimeLineSelected = true;
      this.btnHistogramSelected = false;
      this.btnSessionsSelected = false;
      this.btnMovingAverageSelected = false;
    },
    selectHistogram: function selectHistogram() {
      this.btnTimeLineSelected = false;
      this.btnHistogramSelected = true;
      this.btnSessionsSelected = false;
      this.btnMovingAverageSelected = false;
    },
    selectSession: function selectSession() {
      this.btnTimeLineSelected = false;
      this.btnHistogramSelected = false;
      this.btnSessionsSelected = true;
      this.btnMovingAverageSelected = false;
    },
    selectMovingAverage: function selectMovingAverage() {
      this.btnTimeLineSelected = false;
      this.btnHistogramSelected = false;
      this.btnSessionsSelected = false;
      this.btnMovingAverageSelected = true;
    },
    computeTimeRange: function computeTimeRange() {
      this.timeRange = this.endDate - this.startDate;
    }
  },

  mounted: function mounted() {
    this.computeTimeRange();
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings;
  }
});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PieChart__ = __webpack_require__(123);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelDisplayFlag'],
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_3__components_PieChart__["a" /* default */]
  },
  data: function data() {
    return {
      actualLanguage: "FR",
      showListOfChannel: false,
      flagDisplayFilter: 0,
      attributesFilters: [],
      attributesFiltersChoice: [],
      channelCount: 0,
      channelsParamaters: [],
      channelsMmMaximums: { '5Min': 0, 'MA_001H': 0, 'MA_004H': 0, 'MA_006H': 0, 'MA_012H': 0, 'MA_024H': 0, 'MA_072H': 0, 'MA_168H': 0, 'MA_336H': 0, 'MA_720H': 0 },

      textSectionActualMeasurement: { FR: "Mesures actuelles", EN: 'Actual measurements' },

      crunchedMaxCurrent: {
        labels: ['Data 1', 'Datadsfsdf 2', 'Datsdfdsfsdfsda 3', 'Data 1', 'Dasdfsdfdsfta 2', 'Data 3', 'Data 1', 'Data 2', 'Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: ['rgba(171, 227, 125, 1)', 'rgba(250, 219, 125, 1)', 'rgba(117, 176, 235, 1)', 'rgba(117, 200, 235, 1)', 'rgba(117, 250, 235, 1)', 'rgba(150, 250, 235, 1)', 'rgba(190, 250, 235, 1)', 'rgba(210, 250, 235, 1)', 'rgba(230, 250, 235, 1)', 'rgba(250, 250, 235, 1)', 'rgba(117, 250, 235, 1)', 'rgba(117, 250, 235, 1)'],
          data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        }]
      }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'groupArborescence', 'actualBundle'])),

  methods: {
    resetDisplayFlag: function resetDisplayFlag() {
      this.channelDisplayFlag = [];
      var previousDisplayFilter = this.flagDisplayFilter;
    }
  },

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LineChart__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_apexcharts__);









__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_7_vue_json_csv___default.a);





__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_apexcharts___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('apexchart', __WEBPACK_IMPORTED_MODULE_10_vue_apexcharts___default.a);

var defaultGraphOptions = {
  backgroundColor: 'rgba(70, 195, 123, 0.8)',
  borderColor: 'rgba(5, 210, 92, .25)',
  pointBackgroundColor: 'rgba(68, 180, 166, 1)',
  pointBorderColor: '#fff',
  pointHoverBackgroundColor: '#fff',
  pointHoverBorderColor: 'rgba(68, 180, 166, 1)'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['channelIndex'],
  data: function data() {
    return {

      portData: [],
      selectedDataType: 'avrPower',
      selectedWeatherType: 'none',
      showWeatherSelector: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.temperature;
      }).slice(0, 1) > -50,
      showWeatherGraph: false,
      displayDataTable: false,
      flagDisplayGraph: false,
      flagDisplayOldGraphVersion: false,

      graphTimeSpan: 100,
      graphTimeCenter: 50,
      graphStartIndex: 0,
      graphLastIndex: 100,

      labelTimeSpan: { FR: 'Plage de temps (%)', EN: 'Time span (%)' },
      labelTimeCenter: { FR: 'Centre de temps (%)', EN: 'Time center (%)' },

      cumulativeSumKWH: [],
      cumulativeSumCost: [],
      maxCurrent: 0,
      sumCost: 0,
      sumKWH: 0,
      flagGraphDataIsLoading: false,
      labelGraphPeakCurrent: { FR: 'Courant maximum', EN: 'Max current' },
      labelGraphCost: { FR: 'Coût', EN: 'Cost' },
      labelGraphSaving: { FR: 'Économies', EN: 'Savings' },
      labelGraphConsumption: { FR: 'Consommation', EN: 'Consumption' },
      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      dataSamplingSelect: 'Automatic',
      myStartDateTime: this.startDate,
      myEndDateTime: this.endDate,
      labelStartDate: { FR: 'Date de début', EN: 'Start date' },
      labelStartTime: { FR: 'Heure de début', EN: 'Start time' },
      labelEndDate: { FR: 'Date de fin', EN: 'End date' },
      labelEndTime: { FR: 'Heure de fin', EN: 'End time' },
      labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },
      labelDataSamplingTitle: { FR: 'Type de données :', EN: 'Data type :' },
      labelDataSamplingAuto: { FR: 'Automatique', EN: 'Automatic' },
      labelDataSampling5min: { FR: '5 minutes', EN: '5 minute' },
      labelDataSamplingHour: { FR: 'Heure', EN: 'Hour' },
      labelDataSamplingDays: { FR: 'Jour', EN: 'Days' },


      actualLanguage: "FR",
      labelSelectorAvrPower: { FR: 'Puissance Moyenne (W)', EN: 'Average Power (W)' },
      labelSelectorAvrPowerKW: { FR: 'Puissance Moyenne (kW)', EN: 'Average Power (kW)' },
      labelSelectorPeakPower: { FR: 'Appel de puissance (W)', EN: 'Peak Power (W)' },
      labelSelectorPeakPowerKW: { FR: 'Puissance crête (kW)', EN: 'Peak Power (kW)' },
      labelSelectorKWH: { FR: 'Consommation par mesure (kWh)', EN: 'Consumption per sample (kWh)' },
      labelSelectorKWHShort: { FR: 'kWh par mesure', EN: 'kWr per sample' },
      labelSelectorCost: { FR: 'Consommation par mesure ($)', EN: 'Consumption per sample ($)' },
      labelSelectorCostShort: { FR: 'Coût par mesure ($)', EN: 'Cost per sample ($)' },
      labelSelectorCumSumKWH: { FR: 'Consommation cumulée (kWh)', EN: 'Cumulated consumption (kWh)' },
      labelSelectorCumSumKWHShort: { FR: 'kWh cumulée', EN: 'Cumulated kWh' },
      labelSelectorCumSumCost: { FR: 'Consommation cumulée ($)', EN: 'Cumulated consumption ($)' },
      labelSelectorCumSumCostShort: { FR: 'Coût cumulée ($)', EN: 'Cumulated cost ($)' },

      labelSelectorSelectWeather: { FR: 'Choisir données météo', EN: 'Select weather condition' },
      labelSelectorUnSelectWeather: { FR: 'Retirer données météo', EN: 'Remove weather display' },
      labelSelectorTemperature: { FR: 'Température (C)', EN: 'Temperature (C)' },
      labelSelectorHumidity: { FR: 'Humidité (%)', EN: 'Humidity (%)' },
      labelSelectorCloud: { FR: 'Ennuagement (%)', EN: 'Cloudy (%)' },
      labelSelectorWind: { FR: 'Vent (km/h)', EN: 'Wind speed (km/h)' },

      labelButtonDownloadData: { FR: 'Télécharger les données', EN: 'Download data' },
      textSectionTableau: { FR: "Tableau des mesures", EN: 'Measurement table' },

      crunchedPowerCall: {
        labels: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }),

        datasets: [{
          label: 'Mesure',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
            return data.avrPower;
          })
        }]
      },

      crunchedWeatherCall: {
        labels: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }),

        datasets: [{
          label: 'Meteo',
          backgroundColor: 'rgba(18, 35, 240, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(18, 35, 240, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(18, 35, 240, 1)',
          data: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
            return data.temperature;
          })
        }]
      },

      selectAvrPower: true,
      selectPeakPower: true,
      selectKWH: false,
      selectCost: false,
      selectCumSumKwh: false,
      selectCumSumCost: false,
      selectTemperature: false,
      selectHumidity: false,
      selectCloud: false,
      selectWind: false,

      flagDisplayNewGraph: false,
      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54], [1326236400000, 43], [1326236405000, 43], [1326236406000, 53], [1326236406500, 63]]
      }],

      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        tooltip: {
          x: { format: 'dd MMM hh:mm' }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          }
        },
        xaxis: {
          type: 'datetime'
        }
      }

    };
  },


  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_1__components_LineChart__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_2__DataTable___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_8_element_ui__["DatePicker"],
    TimePicker: __WEBPACK_IMPORTED_MODULE_8_element_ui__["TimePicker"],
    TimeSelect: __WEBPACK_IMPORTED_MODULE_8_element_ui__["TimeSelect"],
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

  methods: {
    sliderChange: function sliderChange() {
      this.changeDataForGraph(this.selectedDataType);
      this.changeDataForWeatherGraph(this.selectedWeatherType);
    },
    changeDataForGraph: function changeDataForGraph(value) {
      var changedData = [];

      var firstIndex = 0;
      var lastIndex = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length;

      firstIndex = Math.round((parseInt(this.graphTimeCenter) - parseInt(this.graphTimeSpan) / 2) / 100 * __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length);
      if (firstIndex < 0) {
        firstIndex = 0;
      }
      lastIndex = Math.round((parseInt(this.graphTimeCenter) + parseInt(this.graphTimeSpan) / 2) / 100 * __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length);
      if (lastIndex > __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length) {
        lastIndex = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }).length;
      }

      this.graphStartIndex = firstIndex;
      this.graphLastIndex = lastIndex;

      if (this.selectedDataType == 'peak') {
        changedData = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.peak;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedDataType == 'kwh') {
        changedData = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.kwr;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedDataType == 'avrPower') {
        changedData = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.avrPower;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedDataType == 'cost') {
        changedData = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.cost;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedDataType == 'cumSumKwh') {
        changedData = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.cumulativeSumKWH).slice(firstIndex, lastIndex);
      } else {
        changedData = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.cumulativeSumCost).slice(firstIndex, lastIndex);
      }

      this.crunchedPowerCall = {
        labels: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }).slice(firstIndex, lastIndex),
        datasets: [{
          label: 'Mesure',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: changedData
        }]
      };
    },
    changeDataForWeatherGraph: function changeDataForWeatherGraph(value) {
      var changedDataWeather = [];
      this.showWeatherGraph = true;

      var firstIndex = 0;
      var lastIndex = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length;

      firstIndex = Math.round((parseInt(this.graphTimeCenter) - parseInt(this.graphTimeSpan) / 2) / 100 * __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length);
      if (firstIndex < 0) {
        firstIndex = 0;
      }
      lastIndex = Math.round((parseInt(this.graphTimeCenter) + parseInt(this.graphTimeSpan) / 2) / 100 * __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length);
      if (lastIndex > __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.timestamp;
      }).length) {
        lastIndex = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }).length;
      }

      if (this.selectedWeatherType == 'temperature') {
        changedDataWeather = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.temperature;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedWeatherType == 'cloud') {
        changedDataWeather = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.cloud;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedWeatherType == 'humidity') {
        changedDataWeather = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.humidity;
        }).slice(firstIndex, lastIndex);
      } else if (this.selectedWeatherType == 'wind') {
        changedDataWeather = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.wind;
        }).slice(firstIndex, lastIndex);
      } else {
        this.showWeatherGraph = false;
      }

      this.crunchedWeatherCall = {
        labels: __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
          return data.timestamp;
        }).slice(firstIndex, lastIndex),
        datasets: [{
          label: 'Meteo',
          backgroundColor: 'rgba(18, 35, 240, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(18, 35, 240, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(18, 35, 240, 1)',
          data: changedDataWeather
        }]
      };
    },
    refreshGraph: function refreshGraph() {
      var _this = this;

      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
      this.flagGraphDataIsLoading = true;
      var requestData = { 'postAction': 'GetChannelReadings',
        'bundleId': this.actualBundle.bundle_id,
        'channelId': this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
        'start': this.myStartDateTime,
        'end': this.myEndDateTime,
        'dataSampling': this.dataSamplingSelect
      };


      this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.portData = response.data.ChannelReadings;

          if (_this.profileData.rights.rights.logWeatherFlag == false) {
            for (var i = 0; i < _this.portData.length; i++) {
              _this.portData[i].temperature = 0;
              _this.portData[i].cloud = 0;
              _this.portData[i].humidity = 0;
              _this.portData[i].wind = 0;
            }
          }

          _this.computeCumulativeSum();
          _this.changeDataForGraph('avrPower');
          _this.refreshNewGraphData();
          _this.flagGraphDataIsLoading = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
          _this.flagGraphDataIsLoading = false;
        }
      });

      this.$store.dispatch('chargesStore/setStartDate', this.myStartDateTime);
      this.$store.dispatch('chargesStore/setEndDate', this.myEndDateTime);
    },
    computeCumulativeSum: function computeCumulativeSum() {
      this.cumulativeSumKWH = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.kwr;
      });
      var Sum = this.cumulativeSumKWH[0];
      for (var i = 1; i < this.cumulativeSumKWH.length; i++) {
        Sum += this.cumulativeSumKWH[i];
        this.cumulativeSumKWH[i] = Sum.toFixed(3);
        this.cumulativeSumKWH[i] = Sum.toFixed(3);
      }
      this.sumKWH = parseFloat(Sum).toFixed(2);

      this.cumulativeSumCost = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.cost;
      });
      var Sum = this.cumulativeSumCost[0];
      for (var i = 1; i < this.cumulativeSumCost.length; i++) {
        Sum += this.cumulativeSumCost[i];
        this.cumulativeSumCost[i] = Sum.toFixed(3);
      }
      this.sumCost = parseFloat(Sum).toFixed(2);

      var currents = __WEBPACK_IMPORTED_MODULE_5_underscore__["a" /* default */].map(this.portData, function (data) {
        return data.peakCurrent;
      });
      this.maxCurrent = 0;
      for (var i = 1; i < this.cumulativeSumCost.length; i++) {
        if (currents[i] > this.maxCurrent) {
          this.maxCurrent = currents[i].toFixed(1);
        }
      }
    },
    refreshNewGraphData: function refreshNewGraphData() {
      this.chartDataSeries = [];
      var NewGraphDataTempo = [];
      this.flagDisplayNewGraph = false;
      var actualValue = 0.0;

      if (this.selectAvrPower && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          actualValue = this.portData[i].avrPower / 1000;
          NewGraphDataTempo.push([this.portData[i].localEpochTime, actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorAvrPowerKW[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectPeakPower && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          actualValue = this.portData[i].peak / 1000;
          NewGraphDataTempo.push([this.portData[i].localEpochTime, actualValue.toFixed(3)]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorPeakPowerKW[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectKWH && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.portData[i].kwr]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorKWH[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectCost && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.portData[i].cost]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorCost[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectCumSumKwh && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.cumulativeSumKWH[i]]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorCumSumKWH[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectCumSumCost && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.cumulativeSumCost[i]]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorCumSumCost[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectTemperature && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.portData[i].temperature]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorTemperature[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectHumidity && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.portData[i].humidity]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorHumidity[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectCloud && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.portData[i].cloud]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorCloud[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      if (this.selectWind && this.portData.length > 0) {
        NewGraphDataTempo = [];
        for (var i = 0; i < this.portData.length; i++) {
          NewGraphDataTempo.push([this.portData[i].localEpochTime, this.portData[i].wind]);
        }
        this.chartDataSeries.push({ name: this.labelSelectorWind[this.actualLanguage],
          data: NewGraphDataTempo });
      }

      this.flagDisplayNewGraph = true;
    },
    formatTimeToUnix: function formatTimeToUnix(date, time) {
      var unixTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();
      return unixTime;
    }
  },
  mounted: function mounted() {
    this.portData = this.actualBundle.channels[this.channelIndex].ChannelData.Readings;

    if (this.profileData.rights.rights.logWeatherFlag == false) {
      for (var i = 0; i < this.portData.length; i++) {
        this.portData[i].temperature = 0;
        this.portData[i].cloud = 0;
        this.portData[i].humidity = 0;
        this.portData[i].wind = 0;
      }
    }

    this.computeCumulativeSum();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

    var DateStringSplit = this.myStartDate.toString().split(':');
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    DateStringSplit = this.myEndDate.toString().split(':');
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

    this.changeDataForGraph('avrPower');
    this.flagDisplayGraph = true;

    this.refreshNewGraphData();
  }
});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tableData'],
  data: function data() {
    var _ref;

    return _ref = {
      displayDataTable: false,

      flagCloudLiveIsActivating: false,
      flagCloudLiveIsActivated: false,
      dataPoolingIsActive: false,
      dataPoolingCounter: 0,
      dataIsLoading: false,

      flagDisplayLiveData: false,
      flagDisplayMessageHowToUse: false,

      polling: null,
      deviceToPoolList: [],
      deviceData: {},
      deviceDataModel: { 'dataTimestampEpoch': [],
        'dataTimestamp': [],
        'I_RMS': { 'P01': [], 'P02': [], 'P03': [], 'P04': [], 'P05': [], 'P06': [] },
        'Power': { 'P01': [], 'P02': [], 'P03': [], 'P04': [], 'P05': [], 'P06': [] } },

      channelList: [],
      channelDataModel: { 'channelName': '',
        'lastTotalPower': 0,
        'lastPower': [],
        'color': "#46c37b",
        'linkedDevice': '',
        'devicePorts': [],
        'lastCurrent': [],
        'dataTimestampEpoch': [],
        'dataTimestamp': [],
        'dataTotalPower': [],
        'portLabel': [],
        'dataPowerPerPort': [],
        'dataCurrentPerPort': [],
        'flagDisplayGraph': false,
        'flagDisplayCurrent': false,
        'liveMeasurementConfiguration': {}
      },

      dataTimestamp: [],
      dataRead: [],

      actualLanguage: "FR",
      sectionTitle: { FR: 'Mesure de puissance temps réel', EN: 'Real time power measurement' },
      buttonLabelStartAcquisition: { FR: 'Lancer la mesure', EN: 'Start measurement' },
      tileTotalPower: { FR: 'Puissance totale', EN: 'Total power' },
      tileSensor: { FR: 'Capteur ', EN: 'Sensor ' },
      buttonClose: { FR: 'Fermer', EN: 'Close' },

      labelDisplayGraph: { FR: 'Afficher graphique ', EN: 'Display graph ' },
      labelDisplayCurrent: { FR: 'Afficher le courant ', EN: 'Display current ' },
      labelGraphTotalPower: { FR: 'Puissance totale ', EN: 'Total power' }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'labelGraphTotalPower', { FR: 'Puissance ', EN: 'Power' }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'labelGraphCurrent', { FR: 'Courant ', EN: 'Current ' }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'messageHowToUse', { FR: "Aucun appareil mesuré configuré pour la mesure temps réel. Vous devez sélectionner cette option dans la configuration de votre appareil mesuré pour activer son visionnement.",
      EN: 'No measured device configured for real-time measurement. You must select this option in the configuration of your measured device to activate its viewing.' }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'chartDataSeries', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'chartOptions', {
      chart: {
        type: 'area',
        stacked: false,
        height: 300,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: 'zoom'
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0
      },
      title: {
        text: '',
        align: 'left'
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 70, 100]
        }
      },
      xaxis: {}
    }), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('sessionStore', ['actualBundle'])),
  methods: {
    startMeasurement: function startMeasurement() {
      var _this = this;

      this.channelList = [];
      var deviceID = '';
      for (var j = 0; j < this.actualBundle.channels.length; j++) {
        if (this.actualBundle.channels[j].ChannelData.liveMeasurementConfiguration.enabled) {
          deviceID = this.actualBundle.channels[j].ChannelData.linkedDevicePorts.deviceId;
          this.channelList.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.channelDataModel)));
          this.channelList[this.channelList.length - 1].channelName = this.actualBundle.channels[j].ReferenceName;
          this.channelList[this.channelList.length - 1].liveMeasurementConfiguration = this.actualBundle.channels[j].ChannelData.liveMeasurementConfiguration;
          this.channelList[this.channelList.length - 1].devicePorts = this.actualBundle.channels[j].ChannelData.linkedDevicePorts.ports;
          this.channelList[this.channelList.length - 1].linkedDevice = this.actualBundle.channels[j].ChannelData.linkedDevicePorts.deviceId;

          for (var k = 0; k < this.actualBundle.channels[j].ChannelData.linkedDevicePorts.ports.length; k++) {
            this.channelList[this.channelList.length - 1].lastPower.push(0);
            this.channelList[this.channelList.length - 1].lastCurrent.push(0);
            this.channelList[this.channelList.length - 1].dataPowerPerPort.push([]);
            this.channelList[this.channelList.length - 1].dataCurrentPerPort.push([]);
            this.channelList[this.channelList.length - 1].portLabel.push(this.tileSensor[this.actualLanguage] + ": " + (k + 1).toString());
          }

          this.chartDataSeries.push({});

          if (this.deviceToPoolList.includes(this.actualBundle.channels[j].ChannelData.linkedDevicePorts.deviceId) == false) {
            this.deviceToPoolList.push(deviceID);
            this.deviceData[deviceID] = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.deviceDataModel));
            this.startModuleCloudLive(deviceID);
          }
        }
      }

      if (this.channelList.length == 0) {
        this.flagDisplayMessageHowToUse = true;
      } else {
        this.flagDisplayMessageHowToUse = false;
      }

      clearInterval();
      this.dataPoolingCounter = 0;
      this.pollData();

      this.$nextTick(function () {
        _this.flagDisplayLiveData = true;
      });
    },
    stopMeasurement: function stopMeasurement() {
      this.flagDisplayLiveData = false;
      clearInterval();
    },
    startModuleCloudLive: function startModuleCloudLive(deviceId) {
      var _this2 = this;

      this.flagCloudLiveIsActivating = true;
      var requestData = { 'postAction': 'EnableDeviceLiveCloudReadings',
        'deviceId': deviceId
      };
      this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
        _this2.flagCloudLiveIsActivating = false;
        if (response.data.Code == 'OK') {
          _this2.flagCloudLiveIsActivated = true;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    pollData: function pollData() {
      var _this3 = this;

      this.polling = setInterval(function () {
        _this3.readModuleLiveData();
      }, 3000);
    },
    readModuleLiveData: function readModuleLiveData() {
      var _this4 = this;

      this.dataPoolingCounter += 1;
      if (this.dataPoolingCounter >= 30) {
        clearInterval(this.polling);
        this.dataPoolingIsActive = false;
      }

      var deviceID = '';
      var startTimestamp_epoch = moment().unix() - 20;
      this.dataIsLoading = true;
      var sensorCount = 0;
      var lastTotalPower = 0;

      for (var j = 0; j < this.deviceToPoolList.length; j++) {
        deviceID = this.deviceToPoolList[j];
        if (this.deviceData[deviceID].dataTimestampEpoch.length > 0) {
          startTimestamp_epoch = this.deviceData[deviceID].dataTimestampEpoch[this.deviceData[deviceID].dataTimestampEpoch.length - 1];
        }
        var requestData = { 'postAction': 'GetDeviceLiveCloudReadings',
          'bundleId': this.actualBundle.bundleId,
          'deviceId': deviceID,
          'startTimestamp': startTimestamp_epoch
        };

        this.$store.dispatch('sessionStore/postDevice', requestData).then(function (response) {
          if (response.data.Code == 'OK') {

            for (var n = 0; n < response.data.DataTimestamp.length; n++) {
              _this4.deviceData[deviceID].dataTimestampEpoch.push(response.data.DataTimestamp[n]);
              _this4.deviceData[deviceID].dataTimestamp.push(moment(response.data.DataTimestamp[n] * 1000).format('HH:mm:ss'));

              _this4.deviceData[deviceID].I_RMS.P01.push(response.data.LiveData[n].currentRMS[0]);
              _this4.deviceData[deviceID].I_RMS.P02.push(response.data.LiveData[n].currentRMS[1]);
              _this4.deviceData[deviceID].I_RMS.P03.push(response.data.LiveData[n].currentRMS[2]);
              _this4.deviceData[deviceID].I_RMS.P04.push(response.data.LiveData[n].currentRMS[3]);
              _this4.deviceData[deviceID].I_RMS.P05.push(response.data.LiveData[n].currentRMS[4]);
              _this4.deviceData[deviceID].I_RMS.P06.push(response.data.LiveData[n].currentRMS[5]);

              _this4.deviceData[deviceID].Power.P01.push(response.data.LiveData[n].power[0]);
              _this4.deviceData[deviceID].Power.P02.push(response.data.LiveData[n].power[1]);
              _this4.deviceData[deviceID].Power.P03.push(response.data.LiveData[n].power[2]);
              _this4.deviceData[deviceID].Power.P04.push(response.data.LiveData[n].power[3]);
              _this4.deviceData[deviceID].Power.P05.push(response.data.LiveData[n].power[4]);
              _this4.deviceData[deviceID].Power.P06.push(response.data.LiveData[n].power[5]);

              for (var k = 0; k < _this4.channelList.length; k++) {
                if (_this4.channelList[k].linkedDevice == deviceID) {
                  _this4.channelList[k].dataTimestampEpoch.push(response.data.DataTimestamp[n]);
                  _this4.channelList[k].dataTimestamp.push(moment(response.data.DataTimestamp[n] * 1000).format('HH:mm:ss'));

                  sensorCount = 0;
                  lastTotalPower = 0;
                  if (_this4.channelList[k].devicePorts.indexOf("1") > -1) {
                    _this4.channelList[k].lastCurrent[sensorCount] = response.data.LiveData[n].currentRMS[0].toFixed(2);
                    _this4.channelList[k].lastPower[sensorCount] = response.data.LiveData[n].power[0].toFixed(1);
                    lastTotalPower += response.data.LiveData[n].power[0];
                    _this4.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[0].toFixed(1));
                    _this4.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[0].toFixed(2));
                    sensorCount += 1;
                  }

                  if (_this4.channelList[k].devicePorts.indexOf("2") > -1) {
                    _this4.channelList[k].lastCurrent[sensorCount] = response.data.LiveData[n].currentRMS[1].toFixed(2);
                    _this4.channelList[k].lastPower[sensorCount] = response.data.LiveData[n].power[1].toFixed(1);
                    lastTotalPower += response.data.LiveData[n].power[1];
                    _this4.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[1].toFixed(1));
                    _this4.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[1].toFixed(2));
                    sensorCount += 1;
                  }

                  if (_this4.channelList[k].devicePorts.indexOf("3") > -1) {
                    _this4.channelList[k].lastCurrent[sensorCount] = response.data.LiveData[n].currentRMS[2].toFixed(2);
                    _this4.channelList[k].lastPower[sensorCount] = response.data.LiveData[n].power[2].toFixed(1);
                    lastTotalPower += response.data.LiveData[n].power[2];
                    _this4.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[2].toFixed(1));
                    _this4.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[2].toFixed(2));
                    sensorCount += 1;
                  }

                  if (_this4.channelList[k].devicePorts.indexOf("4") > -1) {
                    _this4.channelList[k].lastCurrent[sensorCount] = response.data.LiveData[n].currentRMS[3].toFixed(2);
                    _this4.channelList[k].lastPower[sensorCount] = response.data.LiveData[n].power[3].toFixed(1);
                    lastTotalPower += response.data.LiveData[n].power[3];
                    _this4.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[3].toFixed(1));
                    _this4.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[3].toFixed(2));
                    sensorCount += 1;
                  }

                  if (_this4.channelList[k].devicePorts.indexOf("5") > -1) {
                    _this4.channelList[k].lastCurrent[sensorCount] = response.data.LiveData[n].currentRMS[4].toFixed(2);
                    _this4.channelList[k].lastPower[sensorCount] = response.data.LiveData[n].power[4].toFixed(1);
                    lastTotalPower += response.data.LiveData[n].power[4];
                    _this4.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[4].toFixed(1));
                    _this4.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[4].toFixed(2));
                    sensorCount += 1;
                  }

                  if (_this4.channelList[k].devicePorts.indexOf("6") > -1) {
                    _this4.channelList[k].lastCurrent[sensorCount] = response.data.LiveData[n].currentRMS[5].toFixed(2);
                    _this4.channelList[k].lastPower[sensorCount] = response.data.LiveData[n].power[5].toFixed(1);
                    lastTotalPower += response.data.LiveData[n].power[5];
                    _this4.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[5].toFixed(1));
                    _this4.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[5].toFixed(2));
                    sensorCount += 1;
                  }
                  _this4.channelList[k].lastTotalPower = lastTotalPower.toFixed(1);
                  _this4.channelList[k].dataTotalPower.push(lastTotalPower.toFixed(1));

                  if (lastTotalPower < _this4.channelList[k].liveMeasurementConfiguration.powerWarningLevel) {
                    _this4.channelList[k].color = "#46c37b";
                  } else {
                    if (lastTotalPower > _this4.channelList[k].liveMeasurementConfiguration.powerLimitLevel) {
                      _this4.channelList[k].color = "#ff0000";
                    } else {
                      _this4.channelList[k].color = "#e1e100";
                    }
                  }

                  _this4.updateGraphData(k);
                }
              }
            }
          } else {
            window.alert(response.data.PromptMessage[_this4.actualLanguage]);
          }
          _this4.dataIsLoading = false;
        });
      }
    },
    updateGraphData: function updateGraphData(channelIndex) {
      this.chartDataSeries[channelIndex] = [];
      var NewGraphDataTempo = [];
      var portDataTempo = [];
      var actualValue = 0.0;

      NewGraphDataTempo = [];

      if (this.channelList[channelIndex].flagDisplayCurrent) {
        for (var j = 0; j < this.channelList[channelIndex].dataPowerPerPort.length; j++) {
          NewGraphDataTempo = [];
          portDataTempo = this.channelList[channelIndex].dataCurrentPerPort[j];
          for (var i = 0; i < portDataTempo.length; i++) {
            actualValue = portDataTempo[i];
            NewGraphDataTempo.push([this.channelList[channelIndex].dataTimestampEpoch[i] - this.channelList[channelIndex].dataTimestampEpoch[0], actualValue]);
          }
          this.chartDataSeries[channelIndex].push({ name: this.labelGraphCurrent[this.actualLanguage] + this.tileSensor[this.actualLanguage] + (j + 1).toString(), data: NewGraphDataTempo });
        }
      } else {
        portDataTempo = this.channelList[channelIndex].dataTotalPower;
        for (var i = 0; i < portDataTempo.length; i++) {
          actualValue = portDataTempo[i];
          NewGraphDataTempo.push([this.channelList[channelIndex].dataTimestampEpoch[i] - this.channelList[channelIndex].dataTimestampEpoch[0], actualValue]);
        }
        this.chartDataSeries[channelIndex].push({ name: this.labelGraphTotalPower[this.actualLanguage], data: NewGraphDataTempo });

        for (var j = 0; j < this.channelList[channelIndex].dataPowerPerPort.length; j++) {
          NewGraphDataTempo = [];
          portDataTempo = this.channelList[channelIndex].dataPowerPerPort[j];
          for (var i = 0; i < portDataTempo.length; i++) {
            actualValue = portDataTempo[i];
            NewGraphDataTempo.push([this.channelList[channelIndex].dataTimestampEpoch[i] - this.channelList[channelIndex].dataTimestampEpoch[0], actualValue]);
          }
          this.chartDataSeries[channelIndex].push({ name: this.tileSensor[this.actualLanguage] + (j + 1).toString(), data: NewGraphDataTempo });
        }
      }
    }
  },
  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
    clearInterval();
  }
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['barData'], data: function data() {
    return {
      tempoBundle: {},
      actualBarWidth: '',
      actualPourcentage: 0,
      displayValue: 0,
      flagDisplayBar: true,
      buttonDisplayColor: 1 };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['actualBundleChannelMaximums'])),
  watch: {
    actualBundleChannelMaximums: function actualBundleChannelMaximums() {
      this.computeColorDisplay();
    }
  },
  methods: {
    computeColorDisplay: function computeColorDisplay() {
      this.flagDisplayBar = false;
      this.buttonDisplayColor = 1;
      this.displayValue = this.barData.Value.toFixed(2);
      if (this.barData.Value > 0.70 * this.barData.Max) {
        this.buttonDisplayColor = 2;
      }
      if (this.barData.Value > 0.9 * this.barData.Max) {
        this.buttonDisplayColor = 3;
      }

      this.actualPourcentage = 100 * this.barData.Value / this.barData.Max;
      this.actualBarWidth = '';
      this.actualBarWidth = this.actualBarWidth.concat(100 * this.barData.Value / this.barData.Max, '%');
      this.flagDisplayBar = true;
    }
  },

  mounted: function mounted() {
    this.computeColorDisplay();
  }
});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['barParameters'], data: function data() {
    return {
      tempoBundle: {},
      actualBarWidth: '',
      actualPourcentage: 0,
      displayValue: 0,
      barData: {},
      flagDisplayBar: true,
      buttonDisplayColor: 1 };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['actualBundleChannelMaximums', 'actualBundle'])),
  watch: {
    actualBundleChannelMaximums: function actualBundleChannelMaximums() {
      this.computeColorDisplay();
    }
  },
  methods: {
    computeColorDisplay: function computeColorDisplay() {
      this.flagDisplayBar = false;
      this.buttonDisplayColor = 1;
      this.barData.AfterText = 'W';
      if (this.barParameters.type == 'CHN') {
        this.barData.Value = this.actualBundle.channels[this.barParameters.index].ChannelData.lastMeasure[this.barParameters.MAType];
      }
      if (this.barParameters.type == 'BDL') {
        this.barData.Value = this.actualBundle.sub_bundle[this.barParameters.index].lastMeasure[this.barParameters.MAType];
      }
      this.barData.Max = this.actualBundleChannelMaximums[this.barParameters.MAType];
      this.displayValue = this.barData.Value.toFixed(2);
      if (this.barData.Value > 0.70 * this.barData.Max) {
        this.buttonDisplayColor = 2;
      }
      if (this.barData.Value > 0.9 * this.barData.Max) {
        this.buttonDisplayColor = 3;
      }

      this.actualPourcentage = 100 * this.barData.Value / this.barData.Max;
      this.actualBarWidth = '';
      this.actualBarWidth = this.actualBarWidth.concat(100 * this.barData.Value / this.barData.Max, '%');
      this.flagDisplayBar = true;
    }
  },

  mounted: function mounted() {
    this.computeColorDisplay();
  }
});

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LineChart__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BarChart_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_json_csv__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_json_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_json_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);












__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('downloadCsv', __WEBPACK_IMPORTED_MODULE_8_vue_json_csv___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['channel_id'],
    data: function data() {
        return {
            timeRange: 0,
            actualLanguage: "FR",
            flagSessionsDataIsLoading: false,

            flagDisplayGraph: false,
            flagGraphDataIsLoading: false,
            sessionsData: [],
            channelSessionsGraphData: null,

            selectedDataType: 'kwh',
            labelSelectorEnergy: { FR: "Énergie (kW/h)", EN: 'Energy (kW/h)' },
            labelSelectorCost: { FR: "Coût ($)", EN: 'Cost ($)' },
            labelSelectorDuration: { FR: "Durée (Hr)", EN: 'Duration (Hr)' },

            myStartDate: '',
            myEndDate: '',
            startTime: '00:00',
            endTime: '00:00',
            myStartDateTime: this.startDate,
            myEndDateTime: this.endDate,
            dataSamplingSelect: 'Automatic',

            labelStartDate: { FR: 'Date de début', EN: 'Start date' },
            labelStartTime: { FR: 'Heure de début', EN: 'Start time' },

            labelEndDate: { FR: 'Date de fin', EN: 'End date' },
            labelEndTime: { FR: 'Heure de fin', EN: 'End time' },

            labelButtonRefresh: { FR: 'Rafraichir', EN: 'Refresh' },
            labelButtonDownloadData: { FR: 'Télécharger les données', EN: 'Download data' }

        };
    },


    components: {
        LineChart: __WEBPACK_IMPORTED_MODULE_5__components_LineChart__["a" /* default */],
        BarChart: __WEBPACK_IMPORTED_MODULE_6__components_BarChart_js__["a" /* default */],
        Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_9_element_ui__["DatePicker"],
        TimePicker: __WEBPACK_IMPORTED_MODULE_9_element_ui__["TimePicker"],
        TimeSelect: __WEBPACK_IMPORTED_MODULE_9_element_ui__["TimeSelect"]
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate'])),

    methods: {
        refreshGraph: function refreshGraph() {

            this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
            this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);
            this.getSessionsData();
            this.$store.dispatch('chargesStore/setStartDate', this.myStartDateTime);
            this.$store.dispatch('chargesStore/setEndDate', this.myEndDateTime);
        },
        setSessionsChartData: function setSessionsChartData() {
            var _this = this;

            this.flagDisplayGraph = false;

            var time = [];
            var y1 = [];
            var y2 = [];
            var actualLabel = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.sessionsData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var session = _step.value;

                    var labelX = session.startTime + ' - ' + session.endTime.split(' ')[2];
                    time.push(labelX);

                    if (this.selectedDataType == 'kwh') {
                        y1.push(session.energy_kwh);
                        actualLabel = this.labelSelectorEnergy[this.actualLanguage];
                    }
                    if (this.selectedDataType == 'cost') {
                        y1.push(session.cost);
                        actualLabel = this.labelSelectorCost[this.actualLanguage];
                    }
                    if (this.selectedDataType == 'duration') {
                        y1.push(session.duration_min);
                        actualLabel = this.labelSelectorDuration[this.actualLanguage];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.channelSessionsGraphData = {
                labels: time,
                datasets: [{
                    label: actualLabel,
                    backgroundColor: 'rgba(70, 195, 123, 0.8)',
                    borderColor: 'rgba(5, 210, 92, .25)',
                    pointBackgroundColor: 'rgba(68, 180, 166, 1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
                    data: y1 }]

            };

            this.$nextTick(function () {
                _this.flagDisplayGraph = true;
            });
        },
        getSessionsData: function getSessionsData() {
            var _this2 = this;

            this.flagGraphDataIsLoading = true;
            var requestData = { 'postAction': 'GetChannelSessions',
                'bundleId': this.actualBundle.bundle_id,
                'channelId': this.channel_id,

                'start': this.myStartDateTime,
                'end': this.myEndDateTime
            };

            this.$store.dispatch('sessionStore/postChannel', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    console.log(response.data);
                    _this2.sessionsData = response.data.ChannelSessions;
                    _this2.setSessionsChartData();
                    _this2.flagGraphDataIsLoading = false;
                } else {
                    window.alert(response.data.PromptMessage[_this2.actualLanguage]);
                    _this2.flagGraphDataIsLoading = false;
                }
            });
        },
        formatTimeToUnix: function formatTimeToUnix(date, time) {
            var unixTime = __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]).set('seconds', 0).unix();

            return unixTime;
        }
    },
    mounted: function mounted() {

        this.timeRange = this.endDate - this.startDate;

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }

        this.myStartDate = new Date(this.startDate * 1000), this.myEndDate = new Date(this.endDate * 1000);

        var DateStringSplit = this.myStartDate.toString().split(':');
        this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

        DateStringSplit = this.myEndDate.toString().split(':');
        this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length - 2, DateStringSplit[0].length) + ':' + DateStringSplit[1];

        this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime);
        this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime);

        this.getSessionsData();
        this.flagSessionsDataIsLoading = false;
    }
});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['bundleIndex'],
  data: function data() {
    return {
      displayDataTable: false,
      flagDisplayBundle: 0,

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle'])),
  methods: {
    toggleDisplayBundle: function toggleDisplayBundle() {
      this.flagDisplayBundle = ~this.flagDisplayBundle;
    }
  },
  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LineChart_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BarChart_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RangePicker__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RangePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_RangePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MonthlyFeeChart__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MonthlyFeeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MonthlyFeeChart__);




var moment = __webpack_require__(0);







var getTotalFromKey = function getTotalFromKey(key, chargeArray) {
  var total = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(chargeArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var charge = _step.value;

      total += charge[key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return total;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboardHome',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_4__components_BarChart_js__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_3__components_LineChart_js__["a" /* default */], RangePicker: __WEBPACK_IMPORTED_MODULE_5__components_RangePicker___default.a },
  data: function data() {
    return {
      msg: 'Mon e-portail',
      selectedCar: 0,
      chargeMonthChartData: null,
      costMonthChartData: null,
      actualLanguage: "FR",
      carChargeList: [],
      textNoEVCarRegistered: { FR: "Vous n'avez pas de Véhicule Électrique d'enregistré, vous devez utiliser le menu configuration pour enregistrer un véhicule.", EN: "You don't have any registered Electric Vehicle, you must use the configuration menu to add one." },
      labelTopPage: { FR: 'Ports de recharge', EN: 'Charging ports' },
      labelTimeSelectorTitle: { FR: 'Plage à observer', EN: 'Period selector' },
      labelCarTotalSavings: { FR: 'Économies', EN: 'Savings' },
      labelCarTotalGreenSavings: { FR: 'Écologie', EN: 'Green gaz savings' },
      labelCarTotalSavingsStartDate: { FR: 'Depuis le ', EN: 'Since ' },
      labelPeriodSummaryTitle: { FR: 'BILAN DE PÉRIODE :', EN: 'PERIOD SUMMARY :' },
      labelPeriodSummaryTitle2: { FR: 'AU', EN: 'TO' },
      labelPeriodSummaryChargeCosts: { FR: 'Coût de charge', EN: 'Charge costs' },
      labelPeriodSummaryChargeTime: { FR: 'Temps de charge', EN: 'Charge time' },
      labelPeriodSummaryPower: { FR: 'Consommation', EN: 'Consumption' },
      labelPeriodSummaryGazSaving: { FR: "Économie d'essence", EN: 'Gaz savings' },
      labelPeriodSummaryGreenGazSaving: { FR: "Économie écologique", EN: 'Green gaz savings' },
      labelPeriodSummaryGraphCharge: { FR: "Charge en kWh :", EN: 'Charge in kWh :' },
      labelPeriodSummaryGraphCosts: { FR: "Coûts des charges ($) :", EN: 'Charge costs ($) :' },
      labelPeriodSummaryGraphCostsBubble: { FR: 'Coût charge', EN: 'Charge cost' },
      labelPeriodSummaryTableTitle: { FR: "Liste des charges", EN: 'Charges list' },
      labelPeriodSummaryTableColStart: { FR: "Début", EN: 'Start' },
      labelPeriodSummaryTableColEnd: { FR: "Fin", EN: 'End' },
      labelPeriodSummaryTableColEnergy: { FR: "Énergie (kWh)", EN: 'Energy (kWh)' },
      labelPeriodSummaryTableColCost: { FR: "Coût Charge ($)", EN: 'Charge Cost ($)' },
      labelPeriodSummaryTableColSaving: { FR: "Économie ($)", EN: 'Savings ($)' },
      labelPeriodSummaryTableColGreenSaving: { FR: "T CO2", EN: 'T CO2' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' }

    };
  },


  watch: {
    selectedCar: function selectedCar() {
      this.getCarChargeList();
    },
    startDate: function startDate() {
      this.getCarChargeList();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('chargesStore', ['startDate', 'endDate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'displayAdminFlag', 'actualBundle']), {
    totalCost: function totalCost() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('cost', this.carChargeList);
    },
    totalChargeTime: function totalChargeTime() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('chargeTime', this.carChargeList);
    },
    totalEnergy: function totalEnergy() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('energy', this.carChargeList);
    },
    totalMoneySaving: function totalMoneySaving() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('moneySaving', this.carChargeList);
    },
    totalgreenGazSaving: function totalgreenGazSaving() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('greenGazSaving', this.carChargeList);
    }
  }),

  methods: {
    refreshData: function refreshData(dates) {
      this.$store.dispatch('chargesStore/setStartDate', dates.startDate);
      this.$store.dispatch('chargesStore/setEndDate', dates.endDate);
      this.getCarChargeList;
    },
    setChargeMonthChartData: function setChargeMonthChartData() {
      if (this.carChargeList.length) {
        var myChargesList = this.carChargeList;
        var time = [];
        var y1 = [];
        var y2 = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(myChargesList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var charge = _step2.value;

            var labelX = charge.startTime.split(' ')[2] + ' - ' + charge.endTime.split(' ')[2];
            time.push(labelX);
            y1.push(charge.energy);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.chargeMonthChartData = {
          labels: time,
          datasets: [{
            label: 'Charge (kWh)',
            backgroundColor: 'rgba(70, 195, 123, 0.8)',
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: y1 }]

        };
      }
    },
    setCostMonthChartData: function setCostMonthChartData() {
      if (this.carChargeList.length == 0) return;
      var myChargesList = this.carChargeList;
      var time = [];
      var y1 = [];
      var y2 = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(myChargesList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var charge = _step3.value;

          var labelX = charge.startTime.split(' ')[2] + ' - ' + charge.endTime.split(' ')[2];
          time.push(labelX);
          y1.push(charge.cost);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.costMonthChartData = {
        labels: time,
        datasets: [{
          label: 'Charge ($)',
          backgroundColor: 'rgba(70, 195, 123, 0.8)',
          borderColor: 'rgba(5, 210, 92, .25)',
          pointBackgroundColor: 'rgba(68, 180, 166, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
          data: y1 }]
      };
    },
    getCarChargeList: function getCarChargeList() {
      var _this = this;

      if (this.actualBundle.cars.length > 0) {
        var requestData = { 'postAction': 'GetCarCharges',
          'carId': this.actualBundle.cars[this.selectedCar].CarData.carId,
          'start': this.startDate,
          'end': this.endDate
        };

        this.$store.dispatch('sessionStore/postCar', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this.carChargeList = response.data.ChargeList;

            _this.setChargeMonthChartData();
            _this.setCostMonthChartData();
          } else {
            window.alert(_this.messagePostFail[_this.actualLanguage]);
          }
        });
      }
    }
  },

  mounted: function mounted() {
    this.getCarChargeList();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['portData'],

  components: {},

  data: function data() {
    return {
      displayDataTable: false,
      flagShowPlanList: false,

      processState: 'ViewPlanList',
      selectedPlan: {},
      customizedOrganizationLicence: {},
      customizedUserLicences: [],

      countryStateTaxRates: [],
      actualTaxes01: [],
      actualTaxes02: [],
      selectMyCountry: { FR: 'Pays:', EN: 'Country' },
      selectMyState: { FR: 'Province:', EN: 'State' },
      actualCountryIndex: -1,
      actualCountryName: 'ND',
      actualStateNames: { EN: 'ND', FR: 'ND' },
      actualStateIndex: -1,

      displaySelectedPlanFlag: false,
      acceptConditionFlag: false,
      actualLanguage: "FR",

      textSubscriptionDescriptionTitle01: { FR: "Abonnement d'organisation", EN: 'Organization subscription' },

      textSubscriptionDescriptionText01: { FR: "La plateforme gestionaire permet aux usagers d'une organisation de créer des Groupes et des Systèmes dans lesquels les modules de mesures et les appareils mesurés y sont enregistrés.",
        EN: "The manager platform allows to organization's users to create Groups and System in which monitoring module and monitored device are registered." },

      textSubscriptionDescriptionText02: { FR: "Ainsi, les usagers peuvent créer des arborescences de Groupes et de Systemes dans leur profil. Ces Groupes et Systèmes sont liés à l'organisation et donc les fonctionalités accessibles dépendent des licences d'accèes détenues par l'organisation.",
        EN: "Then users can creates an arborescence of Groups and Systems in their profile. These Groups and Systems are linked to the organization then accessible functionalities depends on access licences held by the organization." },

      textSubscriptionDescriptionText03: { FR: "Un abonnement d'organisation comporte une licence d'organisation à laquelle s'ajoute des licences d'utilisateur(s). Les licences utilisateurs sont ainsi alloués à des usagers afin de leur permettre l'accèes aux fonctionalités de la plateforme gestionaire.",
        EN: "An organization subscription includes an organization licence and user(s) licences. Users licences are thus allocated to users in order to allow them access to the functionalities of the manager platform." },

      textSubscriptionDescriptionText04: { FR: "Les frais d'abonnement comportent des frais mensuels fixes pour chaque licence incluses dans l'abonnement. Les frais mensuel sont composés de frais de base à lesquels peuvent s'ajouter des frais par options qui sont choisies (configurable).",
        EN: "The subscription fees have a fixed monthly fee for each licence included in the subscription. The monthly fees are composed of basic fees which can be added to fees of chosen options (congigurable)." },

      textSubscriptionDescriptionText05: { FR: "Les frais mensuel d'abonnement dependent aussi du nombre total d'appareils enregistrés dans les différents systèmes liés à l'organisation. Les administrateurs peuvent configurer une limite d'appareils enregistrable afin de limiter ou contrôler les coûts mensuel.",
        EN: "The monthly subscription fees also depend on the total number of devices registered in the various systems linked to the organization. Administrators can configure a recordable device limit to limit or control costs monthly." },

      textSubscriptionDescriptionTitle02: { FR: "Utilisez plus et payé moins!", EN: 'Use more to pay less!' },

      textSubscriptionDescriptionText11: { FR: "Les frais d'abonnement affichés sont les frais de base pour chaque éléments. Lors de la facturation, un % de réduction, par tranche de coût, est appliquée à chaque tranche de coût total de base. Ainsi, plus vous utilisez de service et moins coûteux sont les services ajoutés!",
        EN: "The subscription fees shown are the base charges for each item. When invoicing, a % reduction per cost bracket is applied per base total cost bracket. So the more service you use, less expensive are the added services!" },

      textSubscriptionDescriptionText12: { FR: "Après avoir sélectioner un type d'abonnement, il vous est possible de simuler les côuts avec les options choisies.",
        EN: "After selecting a subscription type, you can simulate the costs with the options chosen" },

      textSubscriptionDescriptionTitle03: { FR: "Pour plus d'information consultez le document explicatif suivant:", EN: 'For more explanation, consult the following explanation document:' },

      buttonLabelPlatformDucumentationExplanation: { FR: "Fonctionalités de la plateforme EL-iot.", EN: 'Functionalities of the EL-iot platform.' },

      textSubscriptionDescriptionTitle04: { FR: "Plans disponibles", EN: 'Available plans' },
      textSubscriptionOrgLicenceSection: { FR: "Licence de l'organisation", EN: 'Organisation licence' },
      textSubscriptionUserLicenceSection: { FR: "Licence utilisateur (additionelles)", EN: 'User licence (additional)' },
      textSubscriptionLicenceOptionSection: { FR: "Détails et options de la licence:", EN: 'Licence detail and options:' },

      textRebateTableTitle: { FR: "Charte de rabais de volume", EN: 'Volume rebate chart' },
      textRebateTableSubTitle: { FR: "Rabais par tranche de coût de base (mensuel).",
        EN: 'Discount per base cost bracket (monthly).' },
      textRebateTableColumn01: { FR: "De:", EN: 'From:' },
      textRebateTableColumn02: { FR: "À:", EN: 'To:' },
      textRebateTableColumn03: { FR: "% Rabais", EN: '% Rebate' },

      labelBtnSelectThisPlan: { FR: "Sélectionner ce plan", EN: 'Select this plan' },

      contactEVSensForSubscribe: { FR: "Pour vous abonnez à ce forfait, contactez support@evsens.ca.",
        EN: 'To subscribe to this plan, contact support@evsens.ca.' },

      selectedPlanLicenceConfigurationTitle: { FR: "Configuration de la licence d'organisation", EN: 'Selected plan organization licence configuration' },
      tableLicenceBaseCostDescription: { FR: "Coûts de base de l'abonnement", EN: 'Subscription base cost' },
      selectPlanOptionColumnTitle01: { FR: "Description / Détails", EN: 'Description / Detail' },
      selectPlanOptionColumnTitle02: { FR: "Activation de l'option / Valeur maximum", EN: 'Option activation / Maximum value' },
      selectPlanOptionColumnTitle03: { FR: "Coût mensuel de base", EN: 'Monthly base cost' },
      maxValueLabel: { FR: "Valeur maximale (limite)", EN: 'Maximum value (limit)' },

      selectedPlanUserLicenceConfigurationTitle: { FR: "Configuration de la licence de l'usager", EN: 'Licence configuration for user' },
      tableUserLicenceBaseCostDescription: { FR: "Coûts de base de la licence usager", EN: 'User licence base cost' },

      labelBtnAddUserLicence: { FR: "Ajouter une licence usager", EN: 'Add user licence' },
      labelBtnRemoveUserLicence: { FR: "Retirer une licence usager", EN: 'Remove user licence' },

      textCostSimulationTitle01: { FR: "Estimateur de frais mensuel", EN: 'Monthly fees estimator' },
      actualCostTitle: { FR: "Estimation des coûts mensuels", EN: 'Monthly fees estimation' },
      actualCostDescriptionNoDevice: { FR: "Coûts mensuel avec les options choisies (sans les éléments chargés à la consommation).",
        EN: 'Monthly fees with selected options (without element charged per units).' },
      actualCostDescription: { FR: "L'estimation suppose que les valeurs maximales sont atteintes. Il est possible d'estimer les coûts en modifiant les valeurs limites",
        EN: 'The estimation assume cunsumption with maximum values reached. You can estimate cost for different maximum values.' },
      labelBaseCost: { FR: "Coûts de base : ", EN: 'Base cost : ' },
      labelCostRebate: { FR: "Rabais de volume : ", EN: 'Volume rebate : ' },
      labelCostSpecialRebate: { FR: "Rabais spécial : ", EN: 'Special rebate : ' },
      labelMonthlyCostNoDevice: { FR: "Mensualité minimale : ", EN: 'Minimum monthly fees : ' },
      labelMonthlyCost: { FR: "Mensualité si maximums atteint : ", EN: 'Monthly fees if maximas reached : ' },
      labelMonthlyCostNoDeviceSpecialRebate: { FR: "Mensualité minimale avec rabais spécial : ", EN: 'Minimum monthly fees with special rebate : ' },
      labelMonthlyCostSpecialRebate: { FR: "Mensualité si maximums atteint avec rabais spécial : ", EN: 'Monthly fees if maximas reached with special rebate : ' },

      labelBtnUnSelectThisPlan: { FR: "Revenir au choix de plans", EN: 'Back to plan list' },
      labelBtnSignUp: { FR: "S'inscrire", EN: 'Sign up' },
      ButtonProceedOrder: { FR: "Procéder à l'achat", EN: 'Proceed to order' },
      validateLocalisation: { FR: 'Validez votre localisation:', EN: 'Validate your location:' },

      ButtonApplyPromoCode: { FR: "Appliquer un code promotionnel", EN: 'Apply promotional code' },
      ReadCodePromptMessage: { FR: "Introduire votre code promotionnel:", EN: 'Introduce your promotional code:' },
      ButtonProceedPayment: { FR: "Procéder au paiement", EN: 'Proceed to payment' },
      ButtonCancelSelection: { FR: "Annuler la sélection", EN: 'Cancel selection' },

      InvoiceHeaderFirst: { FR: "Détail de votre premier versement", EN: 'First payment detail' },
      InvoiceHeader: { FR: "Détail de vos versements mensuel*", EN: 'Monthly payment detail*' },
      InvoiceHeaderNext: { FR: "Détail de vos versements par la suite", EN: 'Next payment detail' },
      InvoiceOrgLicenceText: { FR: "1 Licence d'organisation + ", EN: '1 Organisation licence + ' },
      InvoiceOrgUserText: { FR: "licence(s) usager(s) ", EN: 'user licence' },

      InvoiceSubscriptionCredit: { FR: "Crédit d'abonnement", EN: 'Subscription credit' },
      InvoiceSpecialRebate: { FR: "Rabais spécial", EN: 'Special rebate' },
      InvoiceQuantity: { FR: "Quantité", EN: 'Quantity' },
      InvoiceUnitPrice: { FR: "Prix unitaire", EN: 'Unit price' },
      InvoicePrice: { FR: "Prix", EN: 'Price' },
      InvoiceEVSensServicePlan: { FR: "Plan de service EV Sens", EN: 'EV Sens service plan' },
      InvoiceSubTotal: { FR: "Sous total", EN: 'Sub total' },
      InvoiceMonthlyFeesCondition: { FR: "*Si les maximums d'utilisation permettent d'enregistré plus d'appareils que le nombre inclue au forfait, des frais d'appareils additionnels peuvent s'ajouter à vos versement mensuel.",
        EN: '*If the usage limits allow you to register more devices than the number included in the package, additional device fees may be added to your monthly payment.' },

      flagDisplayApplyPromoCodeButton: true,
      sumBaseCostNoDevice: 0,
      sumRebateNoDevice: 0,
      sumFinalCostNoDevice: 0,
      specialRabateNoDevice: 0,
      sumFinalCostWithSpecialRebateNoDevice: 0,

      sumBaseCost: 0,
      sumRebate: 0,
      sumFinalCost: 0,
      specialRabate: 0,
      sumFinalCostWithSpecialRebate: 0,

      sousTotal1: 0.00,
      total1: 0.00,
      sousTotal2: 0.00,
      total2: 0.00
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    selectPlan: function selectPlan(planIndex) {
      this.selectedPlan = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.planDescription[planIndex]));
      this.customizedOrganizationLicence = this.selectedPlan.organizationLicenceData;
      this.customizedUserLicences = [];
      this.flagDisplayApplyPromoCodeButton = true;

      for (var n = 0; n < this.selectedPlan.planInfo.includedLicence; n++) {
        this.customizedUserLicences.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedPlan.userLicenceData)));
        this.customizedUserLicences[n].price = "0";
      }

      this.computeCost();
      this.processState = 'ViewSelectedPlan';
    },
    addUserLicence: function addUserLicence() {
      this.customizedUserLicences.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedPlan.userLicenceData)));
      this.computeCost();
    },
    removeUserLicence: function removeUserLicence() {
      this.customizedUserLicences.pop();
      this.computeCost();
    },
    unSelectPlan: function unSelectPlan() {
      this.processState = 'ViewPlanList';
    },
    applyPromoCode: function applyPromoCode() {
      var _this = this;

      var requestData = { 'postAction': 'ReadPromoCode',
        'PromoCode': prompt(this.ReadCodePromptMessage[this.actualLanguage], "")
      };

      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.flagDisplayApplyPromoCodeButton = false;
          _this.selectedPlan.specialRebate.push(response.data.SpecialRebate);
          _this.computeCost();
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    computeCost: function computeCost() {
      this.sumBaseCost = 0;
      this.sumBaseCost += parseFloat(this.customizedOrganizationLicence.price);

      this.sumBaseCostNoDevice = 0;
      this.sumBaseCostNoDevice += parseFloat(this.customizedOrganizationLicence.price);

      for (var n = 0; n < this.customizedOrganizationLicence.options.length; n++) {
        if (this.customizedOrganizationLicence.options[n].valueType == 'BOOL' && this.customizedOrganizationLicence.options[n].value == true) {
          this.sumBaseCost += parseFloat(this.customizedOrganizationLicence.options[n].price);
          this.sumBaseCostNoDevice += parseFloat(this.customizedOrganizationLicence.options[n].price);
        }

        if (this.customizedOrganizationLicence.options[n].valueType == 'NUMERIC') {
          var extraCount = parseFloat(this.customizedOrganizationLicence.options[n].value) - parseFloat(this.customizedOrganizationLicence.options[n].firstNoChargeCountValue);

          if (extraCount > 0) {
            this.sumBaseCost += parseFloat(this.customizedOrganizationLicence.options[n].price) * extraCount;
          }
        }
      }

      for (var m = 0; m < this.customizedUserLicences.length; m++) {
        this.sumBaseCost += parseFloat(this.customizedUserLicences[m].price);
        this.sumBaseCostNoDevice += parseFloat(this.customizedUserLicences[m].price);
        for (var n = 0; n < this.customizedUserLicences[m].options.length; n++) {
          if (this.customizedUserLicences[m].options[n].valueType == 'BOOL' && this.customizedUserLicences[m].options[n].value == true) {
            this.sumBaseCost += parseFloat(this.customizedUserLicences[m].options[n].price);
            this.sumBaseCostNoDevice += parseFloat(this.customizedUserLicences[m].options[n].price);
          }
          if (this.customizedUserLicences[m].options[n].valueType == 'NUMERIC') {
            this.sumBaseCost += parseFloat(this.customizedUserLicences[m].options[n].price) * parseFloat(this.customizedUserLicences[m].options[n].value);
          }
        }
      }

      this.sumBaseCost = Math.round(this.sumBaseCost * 100) / 100;
      this.sumBaseCostNoDevice = Math.round(this.sumBaseCostNoDevice * 100) / 100;

      var sliceMin = 0;
      var sliceMax = 0;
      var slicePourcentage = 0;

      this.sumRebate = 0;
      this.sumRebateNoDevice = 0;

      for (var m = 0; m < this.selectedPlan.rebateChartData.chart.length; m++) {
        var sliceMin = parseFloat(this.selectedPlan.rebateChartData.chart[m].priceSliceMin);
        var sliceMax = parseFloat(this.selectedPlan.rebateChartData.chart[m].priceSliceMax);
        var slicePourcentage = parseFloat(this.selectedPlan.rebateChartData.chart[m].pourcentageReduction) / 100;

        if (this.sumBaseCost > sliceMax) {
          this.sumRebate += (sliceMax - sliceMin) * slicePourcentage;
        }
        if (this.sumBaseCost >= sliceMin && this.sumBaseCost < sliceMax) {
          this.sumRebate += (this.sumBaseCost - sliceMin) * slicePourcentage;
        }
        if (m == this.selectedPlan.rebateChartData.chart.length - 1 && this.sumBaseCost > sliceMax) {
          this.sumRebate += (this.sumBaseCost - sliceMax) * slicePourcentage;
        }

        if (this.sumBaseCostNoDevice > sliceMax) {
          this.sumRebateNoDevice += (sliceMax - sliceMin) * slicePourcentage;
        }
        if (this.sumBaseCostNoDevice >= sliceMin && this.sumBaseCostNoDevice < sliceMax) {
          this.sumRebateNoDevice += (this.sumBaseCostNoDevice - sliceMin) * slicePourcentage;
        }
        if (m == this.selectedPlan.rebateChartData.chart.length - 1 && this.sumBaseCostNoDevice > sliceMax) {
          this.sumRebateNoDevice += (this.sumBaseCostNoDevice - sliceMax) * slicePourcentage;
        }
      }

      this.specialRabateNoDevice = 0;
      this.specialRabate = 0;
      for (var m = 0; m < this.selectedPlan.specialRebate.length; m++) {
        var rebateAmmount = parseFloat(this.selectedPlan.specialRebate[m].RebateAmount);
        if (this.selectedPlan.specialRebate[m].RebateType == 'Pourcentage') {
          this.specialRabateNoDevice = this.specialRabateNoDevice + Math.round(rebateAmmount * this.sumBaseCostNoDevice) / 100;
          this.specialRabate = this.specialRabate + Math.round(rebateAmmount * this.sumBaseCost) / 100;
        } else {
          this.specialRabateNoDevice = this.specialRabateNoDevice + rebateAmmount;
          this.specialRabate = this.specialRabate + rebateAmmount;
        }
      }

      this.sumFinalCost = this.sumBaseCost - this.sumRebate;
      this.sumRebate = Math.round(this.sumRebate * 100) / 100;
      this.sumFinalCost = Math.round(this.sumFinalCost * 100) / 100;
      this.sumFinalCostWithSpecialRebate = Math.round((this.sumFinalCost - this.specialRabate) * 100) / 100;

      this.sumFinalCostNoDevice = this.sumBaseCostNoDevice - this.sumRebateNoDevice;
      this.sumRebateNoDevice = Math.round(this.sumRebateNoDevice * 100) / 100;
      this.sumFinalCostNoDevice = Math.round(this.sumFinalCostNoDevice * 100) / 100;
      this.sumFinalCostWithSpecialRebateNoDevice = Math.round((this.sumFinalCostNoDevice - this.specialRabateNoDevice) * 100) / 100;
    },
    openAdministratorDocumentation: function openAdministratorDocumentation() {
      var localUrl = '';
      if (this.actualLanguage = 'FR') {
        localUrl = 'https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf';
        window.open(localUrl, '_blank');
      }
      if (this.actualLanguage = 'EN') {
        localUrl = 'https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf';
        window.open(localUrl, '_blank');
      }
    },
    cancelSelection: function cancelSelection() {
      this.displayYearToggleSelect = true;
      this.displaySelectedPlanFlag = false;
      this.planTransactionData.transactionStatusCode = '055';
      window.scrollTo(0, 0);
    },
    confirmOrder: function confirmOrder() {
      var _this2 = this;

      this.sousTotal1 = Math.round(Math.round(this.sumFinalCostWithSpecialRebateNoDevice * 100) / 100 - this.selectedPlan.transactionCredit);

      var SumTax = 0;
      var SumSubTotal = this.sousTotal1;
      for (var n = 0; n < this.actualTaxes01.length; n++) {
        this.actualTaxes01[n].Amount = (Math.round(SumSubTotal * parseFloat(this.actualTaxes01[n].Rate) * 100) / 100).toString();
        if (this.actualTaxes01[n].CumulativeSubtotal) {
          SumSubTotal += parseFloat(this.actualTaxes01[n].Amount);
        }
        SumTax += parseFloat(this.actualTaxes01[n].Amount);
      }
      this.total1 = Math.round((this.sousTotal1 + SumTax) * 100) / 100;

      this.sousTotal2 = Math.round(parseFloat(this.planTransactionData.renewalPrice) * 100) / 100;
      SumTax = 0;
      SumSubTotal = this.sousTotal2;
      for (var n = 0; n < this.actualTaxes02.length; n++) {
        this.actualTaxes02[n].Amount = (Math.round(SumSubTotal * parseFloat(this.actualTaxes02[n].Rate) * 100) / 100).toString();
        if (this.actualTaxes02[n].CumulativeSubtotal) {
          SumSubTotal += parseFloat(this.actualTaxes02[n].Amount);
        }
        SumTax += parseFloat(this.actualTaxes02[n].Amount);
      }
      this.total2 = Math.round((this.sousTotal2 + SumTax) * 100) / 100;

      this.$nextTick(function () {
        _this2.planTransactionData.transactionStatusCode = '105';
      });

      this.planTransactionData.postAction = 'NewOrganizationSubscription';
      this.planTransactionData.organizationSubscription = { 'planDescription': this.selectedPlan,
        'customizedOrganizationLicence': this.customizedOrganizationLicence,
        'customizedUserLicences': this.customizedUserLicences };
      window.scrollTo(0, 0);
    },
    getAdminPlanList: function getAdminPlanList() {
      var _this3 = this;

      var requestData = { 'postAction': 'GetAdminPlanList',
        'subscriptionListId': "Manager_Plan_List_V02P04",
        'organizationId': this.planTransactionData.organizationId
      };

      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this3.planDescription = response.data.PlanList;
          _this3.flagShowPlanList = true;
        }
      });
    },
    getCountryStateTaxList: function getCountryStateTaxList() {
      var _this4 = this;

      var requestData = { 'postAction': 'GetCountryTaxRates'
      };

      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this4.countryStateTaxRates = response.data.CountryList;

          for (var n = 0; n < _this4.countryStateTaxRates.length; n++) {
            if (_this4.countryStateTaxRates[n].Country == 'Canada') {
              for (var m = 0; m < _this4.countryStateTaxRates[n].StateTaxData.StateList.length; m++) {
                if (_this4.countryStateTaxRates[n].StateTaxData.StateList[m].Name.EN == 'Quebec') {
                  _this4.actualCountryName = _this4.countryStateTaxRates[n].Country;
                  _this4.actualStateNames = _this4.countryStateTaxRates[n].StateTaxData.StateList[m].Name;
                  _this4.actualTaxes01 = structuredClone(_this4.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes);
                  _this4.actualTaxes02 = structuredClone(_this4.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes);
                }
              }
            }
          }
        }
      });
    },
    selectActualCountry: function selectActualCountry() {
      this.actualStateIndex = -1;
      this.planTransactionData.taxRateData = { 'countrySortKey': 'Canada',
        'stateNames': { FR: 'Québec', EN: 'Quebec' } };
    },
    selectActualState: function selectActualState() {
      if (this.actualCountryIndex >= 0 & this.actualStateIndex >= 0) {
        this.actualCountryName = this.countryStateTaxRates[this.actualCountryIndex].Country;
        this.actualStateNames = this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Name;
        this.actualTaxes01 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes);
        this.actualTaxes02 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes);

        this.planTransactionData.taxRateData = { 'countrySortKey': this.actualCountryName,
          'stateNames': this.actualStateNames };
      }
    }
  }),

  mounted: function mounted() {
    this.planTransactionData.taxRateData = { 'countrySortKey': 'Canada',
      'stateNames': { FR: 'Québec', EN: 'Quebec' } };

    this.getAdminPlanList();
    this.getCountryStateTaxList();

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
    window.scrollTo(0, 0);
  }
});

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardNews',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      displayFlag: false,
      dontShowAgainFlag: false,
      dontShowAgainFlag2: false,

      actualLanguage: "FR",
      actualNews: {},
      labelSectionUser: { FR: 'Accès usager', EN: 'User access' },
      labelDontShowAgain: { FR: 'Ne plus afficher cet avis.', EN: 'Do not display this notice again.' },
      labelButtonClose: { FR: 'Fermer cette fenêtre', EN: 'Close this window' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: {
    closeModalWindow: function closeModalWindow() {
      this.$store.dispatch('overlayStore/toggleModal', false);
    },
    toggleDontShowAgain: function toggleDontShowAgain() {
      this.dontShowAgainFlag2 = !this.dontShowAgainFlag;
      this.applyShowAgainChoice();
    },
    applyShowAgainChoice: function applyShowAgainChoice() {
      var _this = this;

      var requestData = { 'postAction': 'ChangeDashboardNewsFlag',
        'newsIndex': this.overlayParameters.newsIndex,
        'flagValue': this.dontShowAgainFlag2 };

      this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
        if (response.data.Code != 'OK') {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    }
  },

  mounted: function mounted() {
    this.actualNews = this.profileData.dashboard_news[this.overlayParameters.newsIndex];
    this.displayFlag = true;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_group_CreateGroupForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_group_CreateSubGroupForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPlanTable__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPlanTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserPlanTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MyPlanDisplay__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MyPlanDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MyPlanDisplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MyPaymentInfo__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MyPaymentInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MyPaymentInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserPaymentHistory__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserPaymentHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UserPaymentHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AdminPlanTable__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AdminPlanTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AdminPlanTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrganizationDisplay__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrganizationDisplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__OrganizationDisplay__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GroupIndex',
    data: function data() {
        return {
            flagDisplayProfile: 0,
            flagDisplayPlan: 0,
            flagDisplayMyPlan: 0,
            flagDisplayMyPayment: 0,
            profileIsSaving: false,
            actualLanguage: "FR",
            labelTitleProfileInfo: { FR: 'Informations du profil', EN: 'Profile information' },
            labelTitleProfileInfoFirstName: { FR: 'Prénom', EN: 'First name' },
            labelTitleProfileInfoLastName: { FR: 'Nom', EN: 'Last name' },
            labelTitleProfileMobilePhone: { FR: '# Téléphone mobile', EN: 'Mobile phone #' },
            labelOptionAlertEnableEmail: { FR: "Activer transmission d'alerte par courriel", EN: 'Enable email alert transmission' },
            labelOptionAlertEnableSMS: { FR: "Activer transmission d'alerte par message texte", EN: 'Enable text message alert transmission' },

            labelSaveMyProfileBtn: { FR: 'Enregistrer mon profile', EN: 'Save my profile' },
            labelTitleServiceMyPlan: { FR: 'Mon plan de service personnel (lié à Mon Profile)', EN: 'My service plan (linked to My Profile)' },
            labelModifyMyPlanBtn: { FR: 'Modifier mon plan de service', EN: 'Modify my service plan' },
            labelTitleServicePlan: { FR: 'Plan de service utilisateur', EN: 'End user service plan' },
            labelTitleServicePlanOrganization: { FR: 'Plan de service pour les organisations', EN: 'Organization service plan' },
            labelTitleServiceMyPayment: { FR: 'Options de paiement de mon plan personnel (lié à Mon Profile)', EN: 'My personal plan payment options (linked to My Profile)' },
            labelRefreshMessage: { FR: 'Les données du plan ne sont pas disponibles, la page doit être rafraichie pour y avoir accèes. Revenir dans "Mon profil" après le rafraichissement:', EN: 'The service plan data are not available, the web page needs to be refreshed. Come back to "My profile" after refresh:' },
            labelRefreshPageBtn: { FR: 'Rafraichir la page', EN: 'Refresh the web page' },
            labelReturnToMyProfileBtn: { FR: 'Retour à mon profile', EN: 'Return to my profile' },
            labelSubscriptionRecorded: { FR: 'Abonnement enregistré, Merci !', EN: 'Subscription recorded, Thanks !' },
            labelAdminSubscriptionRecorded: { FR: 'Abonnement enregistré, Merci !', EN: 'Subscription recorded, Thanks !' },
            labelNewCreditCardRecorded: { FR: 'Votre nouvelle carte a été enregistré, Merci !', EN: 'New credit card recorded, Thanks !' },

            freePlanSectionTitle: { FR: "Appliquer un plan pré-enregistré", EN: 'Apply pre-recorded user plan' },
            freePlanCodeLabel: { FR: "Code du plan pré-enregistré (ex: 12AB3C5D)", EN: 'Pre-recorded plan code (ex: 12AB3C5D)' },
            freePlanModuleIDLabel: { FR: "Code de validation (ex: 1234-ABCD)", EN: 'Validation code (ex: 1234-ABCD)' },
            freePlanCode: '',
            freePlanDeviceId: '',
            freePlanIsSaving: false,
            labelFreePlanBtn: { FR: "Appliquer le plan", EN: 'Apply included plan' },
            planLoadedMessage: { FR: "Le plan a été appliqué a votre profil. La page sera rafraichie pour lire les informations", EN: 'The plan was applied to your profile, the page will be refresh.' },

            sectionLabelMyProfile: { FR: "Mon profile", EN: 'My profile' },
            labelMyProfileLicence: { FR: "Licence d'accèes à la plateforme gestionaire", EN: 'Manager platform access license' },
            sectionLabelOrganization: { FR: "Mes Organisations", EN: 'My Organizations' },

            organizationExplanation01: { FR: "Pour accéder à la version administrateur de la plateforme EL-iot, vous devez créer une organisation et ensuite adhéré l'organisation à un forfait selon vos besoins.",
                EN: 'To access the administrator version of the EL-iot platform, you must create an organization and then join the organization to a package according to your needs.' },
            organizationExplanation02: { FR: "La version administrateur permet de regrouper en système des ensembles de modules de mesure ainsi que les appareils mesurés créés.",
                EN: 'The administrator version makes it possible to group together sets of measurement modules as well as the measured devices created in a system.' },
            organizationExplanation03: { FR: "Cette version de la plateforme facilite le partage d'information entre plusieurs collaborateurs en permettant le partage des systèmes entre plusieurs usagers.",
                EN: 'This version of the platform facilitates the sharing of information between several collaborators by allowing the sharing of systems between several users.' },

            labelOrganisation: { FR: "Organisation", EN: 'Organization' },
            labelLicenceType: { FR: "Type de licence", EN: 'License type' },
            buttonLabelReleaseLicence: { FR: "Libérer la licence", EN: 'Release license' },
            labelNoLicence: { FR: "Aucune licence enregistrée", EN: 'No license registered' },

            buttonLabelCreateOrganization: { FR: "Créer une organisation", EN: 'Create an organization' },
            massageOrganizationRequired: { FR: "Une organisation est requise pour accéder à la plateforme gestionaire.", EN: 'An organization is required to access the manager platform version.' },
            buttonHelpManagerVersionDocumentation: { FR: "AIDE : Explication de la version gestionaire de la plateforme web", EN: 'HELP : Explanation documentation of the web platform manager version' },

            messageProfileSaved: { FR: "Profil enregistré", EN: 'Profile saved' },
            messageProfileSavedError: { FR: "Erreur d'enregistrement", EN: 'Saving error' },
            messageConfirmLicenceRelease: { FR: "Confirmer la relâche de licence", EN: 'Confirm license release' },
            messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' }

        };
    },

    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
        UserPlanTable: __WEBPACK_IMPORTED_MODULE_5__UserPlanTable___default.a,
        MyPlanDisplay: __WEBPACK_IMPORTED_MODULE_6__MyPlanDisplay___default.a,
        AdminPlanTable: __WEBPACK_IMPORTED_MODULE_9__AdminPlanTable___default.a,
        MyPaymentInfo: __WEBPACK_IMPORTED_MODULE_7__MyPaymentInfo___default.a,
        MyPaymentHistory: __WEBPACK_IMPORTED_MODULE_8__UserPaymentHistory___default.a,
        OrganizationDisplay: __WEBPACK_IMPORTED_MODULE_10__OrganizationDisplay___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'dashboardFlags', 'planTransactionData'])),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
        toggleDisplayProfile: function toggleDisplayProfile() {
            this.flagDisplayProfile = ~this.flagDisplayProfile;
        },
        toggleDisplayPlan: function toggleDisplayPlan() {
            this.flagDisplayPlan = ~this.flagDisplayPlan;
        },
        toggleDisplayMyPlan: function toggleDisplayMyPlan() {
            this.flagDisplayMyPlan = ~this.flagDisplayMyPlan;
        },
        toggleDisplayMyPayment: function toggleDisplayMyPayment() {
            this.flagDisplayMyPayment = ~this.flagDisplayMyPayment;
        },
        reloadPage: function reloadPage() {
            window.location.reload();
        },
        saveMyProfile: function saveMyProfile() {
            var _this = this;

            var requestData = { 'postAction': 'UpdateProfile',
                'profileData': this.profileData };
            this.profileIsSaving = true;
            this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
                _this.profileIsSaving = false;
                if (response.data.Code == 'OK') {
                    window.alert(_this.messageProfileSaved[_this.actualLanguage]);
                } else {
                    window.alert(_this.messageProfileSavedError[_this.actualLanguage]);
                }
            });
        },
        applyFreePlan: function applyFreePlan() {
            var _this2 = this;

            var requestData = { 'postAction': 'PutFreePlanToUser',
                'deviceId': this.freePlanDeviceId,
                'freeCode': this.freePlanCode };
            this.freePlanIsSaving = true;
            this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
                _this2.freePlanIsSaving = false;
                if (response.data.Code == 'OK') {
                    window.alert(_this2.planLoadedMessage[_this2.actualLanguage]);
                    _this2.$store.dispatch('sessionStore/refreshProfileData');
                } else {
                    window.alert(response.data.PromptMessage[_this2.actualLanguage]);
                }
            });
        },
        releaseLicence: function releaseLicence() {
            var _this3 = this;

            var ProceedToAction = false;

            if (window.confirm(this.messageConfirmLicenceRelease[this.actualLanguage])) {
                ProceedToAction = true;
            }

            if (ProceedToAction) {
                var requestData = { 'postAction': 'ReleaseUserLicence',
                    'organizationId': this.profileData.licences[0].licenceFrom,
                    'subscriptionId': this.profileData.licences[0].licenceId.substring(0, 22),
                    'userLicenceId': this.profileData.licences[0].licenceId,
                    'licenceIndex': 'ND' };

                this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
                    _this3.profileIsSaving = false;
                    if (response.data.Code == 'OK') {
                        _this3.$store.dispatch('sessionStore/refreshProfileData');
                    } else {
                        window.alert(response.data.PromptMessage[_this3.actualLanguage]);
                    }
                });
            }
        },
        modifyMyServicePlan: function modifyMyServicePlan() {
            this.planTransactionData.transactionStatusCode = '050';
            this.planTransactionData.postAction = 'NewSubscription';
            this.flagDisplayPlan = -1;
            window.scrollTo(0, 0);
        },
        modifyMyPaymentOption: function modifyMyPaymentOption() {
            this.planTransactionData.transactionStatusCode = '100';
            this.planTransactionData.postAction = 'ModifyCreditCard';

            this.flagDisplayPlan = -1;
        },
        returnToMyServicePlan: function returnToMyServicePlan() {
            this.planTransactionData.transactionStatusCode = '000';
            this.flagDisplayPlan = 0;
            window.scrollTo(0, 0);
        }
    }),

    mounted: function mounted() {
        this.flagDisplayProfile = 0;
        this.flagDisplayMyPlan = 0;
        this.flagDisplayPlan = 0;

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
    }
});

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['organization'],
  data: function data() {
    return {
      flagDisplayBanner: 0,
      profileIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: 'Historique de rapport de commissions', EN: 'Commissions report history' },
      labelTitleBanner: { FR: 'Rapports de commissions', EN: 'Commissions reports' },

      reportsIsReading: true,
      reportsList: [],
      reportIsSaving: [],
      historyLength: 20,

      labelButtonReadHistory: { FR: "Lire l'historique de rapport", EN: 'Read report history' },
      labelHistoryLength: { FR: "Nombre de lignes lues", EN: 'Read lines' },

      labelTabel01_Col01: { FR: 'Rapport', EN: 'Report' },
      labelTabel01_Col02: { FR: 'Transaction liées', EN: 'Linked transaction' },
      labelTabel01_Col03: { FR: 'Facturation', EN: 'Billing' },
      labelTabel01_Col04: { FR: 'Paiement', EN: 'Payment' },
      labelTabel01_Col05: { FR: '', EN: '' },
      labelTabel01_Col06: { FR: 'Rapport lié', EN: 'Linked report' },
      labelAddToReport: { FR: 'Ajouter au rapport', EN: 'Add to report' },
      labelInvoiceAmount: { FR: 'Montant', EN: 'Amount' },

      labelInvoiceReferenceNumber: { FR: 'Numéro de référence', EN: 'Reference number' },
      labelButtonInvoiceReferenceNumber: { FR: 'Enregistrer', EN: 'Save' },

      messageAlertSelectLines: { FR: 'Vous devez sélectionner des transactions (colonne AJOUTER AU RAPPORT).',
        EN: 'You must select transactions lines (column ADD TO REPORT)' },
      messageConfirmCreateReport: { FR: 'Vous confirmer la création du rapport de commissions?',
        EN: 'Confirm the commission report generation?' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.getReportsHistory();
      this.flagDisplayBanner = ~this.flagDisplayBanner;
    },
    getReportsHistory: function getReportsHistory() {
      var _this = this;

      var requestData = { 'postAction': 'IntegratorGetReportsHistory',
        'organizationId': this.organization.organizationId,
        'readItems': this.historyLength };
      this.reportsIsReading = true;
      this.reportIsSaving = [];
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.reportsList = response.data.ReportsList;
          for (var m = 0; m < _this.reportsList.length; m++) {
            _this.reportIsSaving.push(false);
          }
          _this.reportsIsReading = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
          _this.reportsIsReading = false;
        }
      });
    },
    saveReportReferenceNumber: function saveReportReferenceNumber(index) {
      var _this2 = this;

      var requestData = { 'postAction': 'IntegratorUpdateReportData',
        'organizationId': this.organization.organizationId,
        'reportData': this.reportsList[index] };
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {} else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['organization'],
  data: function data() {
    return {
      flagDisplayBanner: 0,
      profileIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: 'Historique de payment client', EN: 'Customer payment history' },
      labelTitleBanner: { FR: 'Transaction clients', EN: 'Customer transactions' },

      commissionsIsReading: true,
      commissionsList: [],
      historyLength: 20,

      labelCommissionsAvailable: { FR: 'Montant de commissions disponible', EN: 'Available commissions amount' },
      labelCommissionsSelected: { FR: 'Montant de commissions sélectionné', EN: 'Selected commissions amount' },
      labelButtonComputeSelected: { FR: 'Calculer montant lignes sélectionné', EN: 'Compute selected lines' },
      labelButtonCreateReport: { FR: 'Créer un rapport de commissions', EN: 'Create a commissions report' },
      labelButtonReadHistory: { FR: "Lire l'historique de transaction", EN: 'Read transaction history' },
      labelHistoryLength: { FR: "Nombre de lignes lues", EN: 'Read lines' },

      labelTabel01_Col01: { FR: 'Organisation', EN: 'Organization' },
      labelTabel01_Col02: { FR: 'Transaction', EN: 'Transaction' },
      labelTabel01_Col03: { FR: 'Montant', EN: 'Amount' },
      labelTabel01_Col04: { FR: 'Paiement reçu', EN: 'Paiement received' },
      labelTabel01_Col05: { FR: 'Ajouter au rapport', EN: 'Add to report' },
      labelTabel01_Col06: { FR: 'Rapport lié', EN: 'Linked report' },
      labelAddToReport: { FR: 'Ajouter au rapport', EN: 'Add to report' },

      TotalCommissionAvailable: 0,
      TotalCommissionSelected: 0,

      messageAlertSelectLines: { FR: 'Vous devez sélectionner des transactions (colonne AJOUTER AU RAPPORT).',
        EN: 'You must select transactions lines (column ADD TO REPORT)' },
      messageConfirmCreateReport: { FR: 'Vous confirmer la création du rapport de commissions?',
        EN: 'Confirm the commission report generation?' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayBanner: function toggleDisplayBanner() {
      this.getCommissionsHistory();
      this.flagDisplayBanner = ~this.flagDisplayBanner;
    },
    getCommissionsHistory: function getCommissionsHistory() {
      var _this = this;

      var requestData = { 'postAction': 'IntegratorGetCommissionsHistory',
        'organizationId': this.organization.organizationId,
        'readItems': this.historyLength };
      this.commissionsIsReading = true;
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this.commissionsList = response.data.CommissionsList;
          _this.computeTempoCommission();
          _this.commissionsIsReading = false;
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
          _this.commissionsIsReading = false;
        }
      });
    },
    computeTempoCommission: function computeTempoCommission() {
      this.TotalCommissionAvailable = 0;
      this.TotalCommissionSelected = 0;
      for (var n = 0; n < this.commissionsList.length; n++) {
        if (this.commissionsList[n].PaymentReceived & this.commissionsList[n].CommissionsReport == 'ND') {
          this.TotalCommissionAvailable += parseFloat(this.commissionsList[n].CommissionAmount);
        }
        if (this.commissionsList[n].FlagAddToReport) {
          this.TotalCommissionSelected += parseFloat(this.commissionsList[n].CommissionAmount);
        }
      }
      this.TotalCommissionAvailable = Math.round(this.TotalCommissionAvailable * 100) / 100;
      this.TotalCommissionSelected = Math.round(this.TotalCommissionSelected * 100) / 100;
    },
    createCommissionReport: function createCommissionReport() {
      var _this2 = this;

      this.computeTempoCommission();
      if (this.TotalCommissionSelected == 0) {
        window.alert(this.messageAlertSelectLines[this.actualLanguage]);
      } else {
        if (confirm(this.messageConfirmCreateReport[this.actualLanguage])) {
          var requestData = { 'postAction': 'IntegratorCreateCommissionReport',
            'organizationId': this.organization.organizationId,
            'commissionsList': this.commissionsList };
          this.commissionsIsReading = true;
          this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
            if (response.data.Code == 'OK') {
              window.alert(response.data.PromptMessage[_this2.actualLanguage]);
              _this2.getCommissionsHistory();
            } else {
              window.alert(response.data.PromptMessage[_this2.actualLanguage]);
            }
          });
        }
      }
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GroupIndex',
    props: ['organization'],
    data: function data() {
        return {
            flagDisplayAddOrganization: -1,
            profileIsSaving: false,
            actualLanguage: "FR",
            labelTitleSection: { FR: 'Gestion des organisations client', EN: 'Costumer organization management' },
            labelButtonAddOrganization: { FR: 'Ajouter une organisation', EN: 'Add organization' },
            labelButtonCancel: { FR: 'Annuler', EN: 'Cancel' },
            labelButtonAdd: { FR: 'Ajouter', EN: 'Add' },

            labelOrganizationToAddId: { FR: "ID de l'organisation", EN: 'Organization ID' },
            labelOrganizationToPhoneNumber: { FR: "Numéro de téléphone de l'organisation", EN: 'Organization phone number' },
            organizationToAddId: '',
            organizationToAddPhoneNumber: '',

            organizationIsSaving: false,
            organizationListIsLoading: false,
            managedOrganizations: [],
            labelOrganizationTableColumn1: { FR: "Nom organisation", EN: 'Organization name' },
            labelOrganizationTableColumn2: { FR: "Abonnement", EN: 'Subscription' },
            labelOrganizationTableColumn3: { FR: "Actif", EN: 'Active' },
            labelOrganizationTableColumn4: { FR: "Action", EN: 'Action' },
            labelTableApplyPlan: { FR: "Appliquer un abonnement", EN: 'Apply subscription' },
            labelTableModifyPlan: { FR: "Modifier l'abonnement", EN: 'Modify subscription' },

            flagDisplayTable: true,
            flagDisplayAddPlan: false,
            flagDisplayModifyPlan: false,
            selectedOrganizationIndex: 0,

            labelApplyPlanTo: { FR: "Appliquer un abonnement à l'organisation:", EN: 'Apply subscription to the organization:' },
            labelActualPlan: { FR: "Plan actuel de l'organisation:", EN: 'Actual plan of the organization:' },
            labelButtonActualPlan: { FR: "Appliquer le plan sélectionné", EN: 'Apply selected plan' },
            planDescription: [],
            selectedPlanSortKey: 'TBD',
            planSelectedFlag: false,
            selectedPlanDetail: {},
            planIsSaving: false,
            messagePromptConfirmApplyNewPlan: { FR: "Confirmer l'application du nouveau plan.", EN: 'Confirm subscription change.' },

            textSubscriptionDescriptionTitle04: { FR: "Plans disponibles", EN: 'Available plans' },
            textSubscriptionOrgLicenceSection: { FR: "Licence de l'organisation", EN: 'Organisation licence' },
            textSubscriptionUserLicenceSection: { FR: "Licence utilisateur (additionelles)", EN: 'User licence (additional)' },
            textSubscriptionLicenceOptionSection: { FR: "Détails et options de la licence:", EN: 'Licence detail and options:' },
            textRebateTableTitle: { FR: "Charte de rabais de volume", EN: 'Volume rebate chart' },
            textRebateTableSubTitle: { FR: "Rabais par tranche de coût de base (mensuel).",
                EN: 'Discount per base cost bracket (monthly).' },
            textRebateTableColumn01: { FR: "De:", EN: 'From:' },
            textRebateTableColumn02: { FR: "À:", EN: 'To:' },
            textRebateTableColumn03: { FR: "% Rabais", EN: '% Rebate' },

            labelModifyOrganizationPlan: { FR: "Modification de l'abonnement de l'organisation", EN: 'Modification of the organization subscrition' },
            subscriptionIsLoading: false,
            subOrganizationSubscription: {},

            sectionLabelLicenceOrganization: { FR: "Détails du forfait de l'organisation", EN: 'Organization subscription details and options' },
            baseCostLabel: { FR: "Coût de base", EN: 'Base cost' },
            selectPlanOptionColumnTitle01: { FR: "Option", EN: 'Option' },
            selectPlanOptionColumnTitle02: { FR: "Description", EN: 'Description' },
            selectPlanOptionColumnTitle03: { FR: "Activation de l'option / Valeur maximum", EN: 'Option activation / Maximum value' },
            maxValueLabel: { FR: "Valeur maximale (limite)", EN: 'Maximum value (limit)' },
            buttonLabelDeleteLicence: { FR: "Supprimer cette licence", EN: 'Delete this licence' },
            buttonLabelAddUserLicence: { FR: "Ajouter une licence usager", EN: 'Add user licence' },

            sectionLabelLicence: { FR: "Licences usagers", EN: 'Users licenses' },
            displayUserLicenceSectionFLag: true,
            displayUserLicenceFlag: [],
            tableLicenceType: { FR: "Type", EN: 'Type' },
            tableLicenceUser: { FR: "Utilisateur lié", EN: 'Linked user' },
            tableLicenceAction: { FR: "Action", EN: 'Action' },
            buttonLabelRemoveLicence: { FR: "Retirer", EN: 'Remove' },
            buttonLabelAllocate: { FR: "Allouer la licence", EN: 'Allocate the licence' },
            sectionLabelSubscriptionFees: { FR: "Frais d'abonnement", EN: 'Subscription fees' },

            labelOtherCostSection: { FR: "Autres frais", EN: 'Other fees' },
            otherFeesList: [],
            flagAddOtherFeeSection: false,
            labelButtonAddOtherFees: { FR: "Ajouter un frais", EN: 'Add other fees' },
            labelButtonAddSelectedFees: { FR: "Ajouter", EN: 'Add' },
            labelButtonAddOtherFeesCancel: { FR: "Annuler", EN: 'Cancel' },
            selectedFeeToAdd: {},
            otherFeeColumnTitle01: { 'FR': 'Quantité', 'EN': 'Quantity' },
            otherFeeColumnTitle02: { 'FR': 'Description', 'EN': 'Description' },
            otherFeeColumnTitle03: { 'FR': 'Coût unitaire', 'EN': 'Unit price' },
            otherFeeColumnTitle04: { 'FR': 'Supprimer', 'EN': 'Delete' },

            labelButtonSaveSupscription: { FR: "Enregistrer les modifications à l'abonnement", EN: 'Save subscription modifications' }

        };
    },

    components: {
        Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
        toggleDisplayAddOrganization: function toggleDisplayAddOrganization() {
            this.flagDisplayAddOrganization = ~this.flagDisplayAddOrganization;
        },
        addNewOrganisation: function addNewOrganisation() {
            var _this = this;

            this.organizationIsSaving = true;
            var requestData = { 'postAction': 'IntegratorAddNewOrganization',
                'organizationId': this.organization.organizationId,
                'organizationToAddId': this.organizationToAddId,
                'organizationToAddPhoneNumber': this.organizationToAddPhoneNumber
            };
            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                _this.organizationIsSaving = false;

                if (response.data.Code == 'OK') {
                    _this.getListSubOrganizations();
                } else {
                    window.alert(response.data.PromptMessage[_this.actualLanguage]);
                }
            });
        },
        getListSubOrganizations: function getListSubOrganizations() {
            var _this2 = this;

            this.organizationListIsLoading = true;
            var requestData = { 'postAction': 'GetListSubOrganization',
                'organizationId': this.organization.organizationId
            };
            this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
                _this2.organizationListIsLoading = false;

                if (response.data.Code == 'OK') {
                    _this2.managedOrganizations = response.data.subOrganizations;
                } else {
                    window.alert(response.data.PromptMessage[_this2.actualLanguage]);
                }
            });
        },
        getAdminPlanList: function getAdminPlanList() {
            var _this3 = this;

            var requestData = { 'postAction': 'GetAdminPlanList',
                'subscriptionListId': "Manager_Plan_List_V02P04",
                'organizationId': this.organization.organizationId
            };

            this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this3.planDescription = response.data.PlanList;
                }
            });
        },
        getOtherFeesList: function getOtherFeesList() {
            var _this4 = this;

            var requestData = { 'postAction': 'IntegratorGetOtherFeesList' };

            this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    _this4.otherFeesList = response.data.FeesList;
                }
            });
        },
        openApplyPlanToSubOrganization: function openApplyPlanToSubOrganization(index) {
            this.selectedOrganizationIndex = index;
            this.flagDisplayTable = false;
            this.flagDisplayAddPlan = true;
            this.flagDisplayModifyPlan = false;
        },
        readSelectedPlanDetail: function readSelectedPlanDetail() {

            this.selectedPlanDetail = {};
            this.planSelectedFlag = false;
            for (var n = 0; n < this.planDescription.length; n++) {
                if (this.planDescription[n].sort_key == this.selectedPlanSortKey) {
                    this.selectedPlanDetail = this.planDescription[n];

                    this.planSelectedFlag = true;
                }
            }
        },
        applyPlanToSelectedOrganization: function applyPlanToSelectedOrganization() {
            var _this5 = this;

            var ProceedToAction = false;

            if (window.confirm(this.messagePromptConfirmApplyNewPlan[this.actualLanguage])) {
                ProceedToAction = true;
            }

            if (ProceedToAction) {
                this.planIsSaving = true;
                var requestData = { 'postAction': 'IntegratorApplySubscription',
                    'integratorOrganizationId': this.organization.organizationId,
                    'subOrganizationId': this.managedOrganizations[this.selectedOrganizationIndex].organizationId,
                    'selectedPlanDetail': this.selectedPlanDetail };
                this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
                    _this5.planIsSaving = false;
                    if (response.data.Code == 'OK') {
                        _this5.cancelAddModifyPlan();
                        _this5.getListSubOrganizations();
                    } else {
                        window.alert(response.data.PromptMessage[_this5.actualLanguage]);
                    }
                });
            }
        },
        cancelAddModifyPlan: function cancelAddModifyPlan() {
            this.flagDisplayTable = true;
            this.flagDisplayAddPlan = false;
            this.flagDisplayModifyPlan = false;
        },
        openModifyPlanToSubOrganization: function openModifyPlanToSubOrganization(index) {
            var _this6 = this;

            this.selectedOrganizationIndex = index;
            this.flagDisplayTable = false;
            this.flagDisplayAddPlan = false;
            this.flagDisplayModifyPlan = true;

            this.subscriptionIsLoading = true;
            var requestData = { 'postAction': 'IntegratorReadSubOrganizationSubscription',
                'integratorOrganizationId': this.organization.organizationId,
                'subOrganizationId': this.managedOrganizations[this.selectedOrganizationIndex].organizationId };
            this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
                _this6.subscriptionIsLoading = false;
                if (response.data.Code == 'OK') {
                    _this6.subOrganizationSubscription = response.data.SubscriptionData;
                    _this6.displayUserLicenceFlag = [];
                    for (var m = 0; m < _this6.subOrganizationSubscription.organization_user_licences.length; m++) {
                        _this6.displayUserLicenceFlag.push(0);
                    }
                } else {
                    window.alert(response.data.PromptMessage[_this6.actualLanguage]);
                }
            });
        },
        openAddOtherFee: function openAddOtherFee() {
            this.flagAddOtherFeeSection = true;
            this.selectedFeeToAdd = {};
        },
        closeAddOtherFee: function closeAddOtherFee() {
            this.flagAddOtherFeeSection = false;
        },
        addSelectedFee: function addSelectedFee() {
            this.subOrganizationSubscription.subscription_other_fees.push(this.selectedFeeToAdd);
            this.flagAddOtherFeeSection = false;
        },
        deleteFeeLine: function deleteFeeLine(index) {
            this.subOrganizationSubscription.subscription_other_fees.pop(index);
        },
        toggleDisplayUserLicenceFlag: function toggleDisplayUserLicenceFlag(index) {
            this.displayUserLicenceSectionFLag = false;
            this.displayUserLicenceFlag[index] = ~this.displayUserLicenceFlag[index];
            this.displayUserLicenceSectionFLag = true;
        },
        saveSubscriptionModification: function saveSubscriptionModification() {
            var requestData = { 'postAction': 'IntegratorSaveSubOrganizationSubscription',
                'subscriptionData': this.subOrganizationSubscription
            };

            this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
                if (response.data.Code == 'OK') {
                    console.log(response.data);
                }
            });
        }
    }),

    mounted: function mounted() {
        this.getAdminPlanList();
        this.getListSubOrganizations();
        this.getOtherFeesList();

        if (localStorage.language) {
            this.actualLanguage = localStorage.language;
        } else {
            this.actualLanguage = 'FR';
        }
    }
});

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IntegratorSubOrganization__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IntegratorSubOrganization___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__IntegratorSubOrganization__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IntegratorCustomerPaymentHistory__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IntegratorCustomerPaymentHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IntegratorCustomerPaymentHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IntegratorCommissionsReports__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IntegratorCommissionsReports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__IntegratorCommissionsReports__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',
  props: ['organization'],
  data: function data() {
    return {
      flagDisplayBanner: 0,
      profileIsSaving: false,
      actualLanguage: "FR",
      labelTitleSection: { FR: 'Titre bannière', EN: 'Banner Title' },
      labelTitleBanner: { FR: 'Titre bannière', EN: 'Banner Title' },

      displayTab: false,
      test: 1,
      tabMenuSelector: [true, false, false, false],
      homeTabMenuOrganization: { FR: 'Organisations clients', EN: 'Organizations customers' },
      homeTabMenuPayment: { FR: 'Historique de commissions', EN: 'Commissions history' },
      homeTabMenuRoyalties: { FR: 'Rapport commissions', EN: 'Commissions report' }

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    IntegratorSubOrganization: __WEBPACK_IMPORTED_MODULE_3__IntegratorSubOrganization___default.a,
    IntegratorCustomerPaymentHistory: __WEBPACK_IMPORTED_MODULE_4__IntegratorCustomerPaymentHistory___default.a,
    IntegratorCommissionsReports: __WEBPACK_IMPORTED_MODULE_5__IntegratorCommissionsReports___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleTabMenuSelector: function toggleTabMenuSelector(index) {
      this.displayTab = false;
      for (var n = 0; n < this.tabMenuSelector.length; n++) {
        this.tabMenuSelector[n] = false;
      }
      this.tabMenuSelector[index] = true;

      this.test = index;
      this.displayTab = true;
    },
    saveMyProfile: function saveMyProfile() {
      var _this = this;

      var requestData = { 'postAction': 'UpdateProfile',
        'profileData': this.profileData };
      this.profileIsSaving = true;
      this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
        _this.profileIsSaving = false;
        if (response.data.Code == 'OK') {
          window.alert(_this.messageProfileSaved[_this.actualLanguage]);
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';
      this.flagDisplayPlan = 0;
      window.scrollTo(0, 0);
    }
  }),

  mounted: function mounted() {
    this.toggleTabMenuSelector(0);

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['portData'],

  components: {},

  data: function data() {
    return {

      actualLanguage: "FR",
      labelFreeService: { FR: 'Service gratuit ou plan pré-enregistré', EN: 'Free service or pre-recorded plan' },
      automaticRenewFlagInititalValue: false,
      renewFlagModified: false,

      buttonLabelAutomaticRenewal: { FR: "Renouvellement automatique", EN: 'Automatic renwal' },
      buttonLabelSaveModification: { FR: "Enregistrer les modifications", EN: 'Save modifications' },
      sectionLabelCreditCard: { FR: "Carte de crédit enregistrée", EN: 'Credit card recorded' },
      textLabelCardLastDigit: { FR: "Se terminant par...", EN: 'Ends by...' },
      buttonLabelModifyCard: { FR: "Modifier la carte de crédit", EN: 'Modify recorded card' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    automaticRenewButtonSwitch: function automaticRenewButtonSwitch() {
      if (this.profileData.profile_subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue) {
        this.renewFlagModified = true;
      } else {
        this.renewFlagModified = false;
      }
    },
    modifyMyAutomaticRenew: function modifyMyAutomaticRenew() {
      var _this = this;

      this.automaticRenewFlagInititalValue = this.profileData.profile_subscription.data.automaticRenewFlag;
      this.renewFlagModified = false;
      this.planTransactionData.postAction = 'UpdateAutomaticRenewFlag';
      this.planTransactionData.automaticRenewFlag = this.profileData.profile_subscription.data.automaticRenewFlag;

      this.$store.dispatch('sessionStore/processSubscription', this.planTransactionData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.$store.dispatch('sessionStore/refreshProfileData');
        }
      });
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.automaticRenewFlagInititalValue = this.profileData.profile_subscription.data.automaticRenewFlag;
  }
});

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
                          props: ['portData'],

                          components: {},

                          data: function data() {
                                                    return {

                                                                              actualLanguage: "FR",
                                                                              labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },
                                                                              labelTileHistoric: { FR: 'Historique de données', EN: 'Data history' },
                                                                              labelTileWeather: { FR: 'Données météo', EN: 'Weather data' },
                                                                              labelTileDataTable: { FR: 'Tableau de données', EN: 'Data table' },
                                                                              labelTileEVportal: { FR: 'Plateforme EV', EN: 'EV Portal' },
                                                                              labelTileAlert01: { FR: 'Alerte Niveau 1', EN: 'Alert Level 1' },
                                                                              labelTileAlert02: { FR: 'Alerte Niveau 2', EN: 'Alert Level 2' },
                                                                              labelTileAlert03: { FR: 'Alerte Niveau 3', EN: 'Alert Level 3' },
                                                                              labelTileAlertPerPort: { FR: 'Alerte par port', EN: 'Alert per port' },
                                                                              labelTileAlertPerModule: { FR: 'Alerte par module', EN: 'Alert per module' },
                                                                              labelTileAlertEmail: { FR: 'Alerte email', EN: 'Email alert' },
                                                                              labelMultipleRecipient: { FR: 'Multiple destinataires courriel', EN: 'Multiple email recipient' },
                                                                              labelTileAlertSMS: { FR: 'Alerte SMS', EN: 'SMS alert' },

                                                                              labelActivated: { FR: 'Activé', EN: 'Activated' },
                                                                              labelNotActivated: { FR: 'Non activé', EN: 'Not activated' },
                                                                              labelUnlimited: { FR: 'Illimité', EN: 'Unlimited' },
                                                                              labelMonth: { FR: 'Mois', EN: 'Month' },
                                                                              labelCounterRenewal: { FR: 'Date de renouvellement des compteurs :', EN: 'Counter renewal date :' },
                                                                              labelSubscriptionRenewal: { FR: 'Date de renouvellement du forfait :', EN: 'Subscription renewal date :' },

                                                                              labelOptionEnabled: { FR: 'Liste des options de votre plan de service',
                                                                                                        EN: 'Option list of your actual plan' },
                                                                              labelOptionSeeButton: { FR: 'Pour voir la liste de plan disponible, utilisez le bouton MODIFIER MON PLAN DE SERVICE.',
                                                                                                        EN: 'To see the list of avaible plan, use the MODIFY MY SERVICE PLAN button' },
                                                                              labelEnabledColumn: { FR: 'Active',
                                                                                                        EN: 'Activated' },
                                                                              planOptionDataHistory1Y: { FR: "Historique de visualisation de données 1 an",
                                                                                                        EN: "One year data history acess" },
                                                                              planOptionDataHistory2Y: { FR: "Historique de visualisation de données 2 an",
                                                                                                        EN: "Two year data history acess" },
                                                                              planOptionDataHistory3Y: { FR: "Historique de visualisation de données 3 an",
                                                                                                        EN: "Tree year data history acess" },
                                                                              planOptionDataHistoryIll: { FR: "Historique de visualisation de données illimité",
                                                                                                        EN: "Unlimitted data history acess" },

                                                                              planOptionEV_Platform: { FR: "Plateforme Véhicule Électrique (EV)",
                                                                                                        EN: "Electric Vehicule (VE) platform" },

                                                                              lblThisMonth: { FR: 'Mois en cours', EN: 'Actual month' },

                                                                              planOptionAlert: { FR: "Système de surveillance (configuration d'alertes)",
                                                                                                        EN: "Monitoring system (alert configuration)" },
                                                                              planOptionAlertMax: { FR: "Nombre d'alerte disponible",
                                                                                                        EN: "Alert count available" },
                                                                              planOptionAlertEmail: { FR: "Nombre de courriel d'alerte par mois",
                                                                                                        EN: "Monthly email alert count" },
                                                                              planOptionAlertSMS: { FR: "Nombre de message texte d'alerte par mois",
                                                                                                        EN: "Monthly SMS alert count" },

                                                                              planOptionWeather: { FR: "Enregistrement des données météo",
                                                                                                        EN: "Weather data logging" },

                                                                              planOptionUnlimitedMaterialWarranty: { FR: "Garantie illimitée sur le matériel*",
                                                                                                        EN: "Unlimited material warranty*" },

                                                                              planOptionUnlimitedMaterialWarrantyCondition: { FR: "La garantie illimité s'applique sur les deux premiers modules enregistrés au profil, pour ajouter une garantie sur les modules additionnels, vous devez contacter EV Sens.",
                                                                                                        EN: "The unlimited guarantee applies to the first two modules registered in the profile, to add a guarantee to the additional modules, you must contact EV Sens." },

                                                                              numberOfDiplayedMonth: 6,
                                                                              dataTableFlag: false,
                                                                              alertL1Flag: false,
                                                                              alertL2Flag: false,
                                                                              alertL3Flag: false,
                                                                              alertL4Flag: false,

                                                                              myDashboardFlag: false,
                                                                              availableAlertCountString: '0'

                                                    };
                          },


                          computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

                          methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
                                                    cancelSelection: function cancelSelection() {
                                                                              this.displayYearToggleSelect = true;
                                                                              this.displaySelectedPlanFlag = false;
                                                    },
                                                    automaticRenewButtonSwitch: function automaticRenewButtonSwitch() {
                                                                              if (this.automaticRenewFlagInititalValue == this.profileData.profile_subscription.data.automaticRenewFlag) {
                                                                                                        this.renewFlagModified = true;
                                                                              } else {
                                                                                                        this.renewFlagModified = false;
                                                                              }
                                                    }
                          }),

                          mounted: function mounted() {
                                                    if (localStorage.language) {
                                                                              this.actualLanguage = localStorage.language;
                                                    } else {
                                                                              this.actualLanguage = 'FR';
                                                    }

                                                    this.numberOfDiplayedMonth = 6;
                                                    if (this.profileData.rights.rights.historicDataAccessDays > 200) {
                                                                              this.numberOfDiplayedMonth = 12;
                                                    }
                                                    if (this.profileData.rights.rights.historicDataAccessDays > 365) {
                                                                              this.numberOfDiplayedMonth = 20000;
                                                    }
                                                    this.alertL1Flag = this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL1');
                                                    this.alertL2Flag = this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL2');
                                                    this.alertL3Flag = this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL3');
                                                    this.alertL4Flag = this.profileData.profileInfo.profile_type.endUserCode.includes('AlrtL4');
                                                    this.dataTableFlag = this.profileData.profileInfo.profile_type.endUserCode.includes('DatTbl');

                                                    this.automaticRenewFlagInititalValue = this.profileData.profile_subscription.data.automaticRenewFlag;

                                                    if (this.profileData.rights.rights.myDashboard) {
                                                                              this.myDashboardFlag = true;
                                                    }

                                                    if (this.profileData.rights.rights.alertLimitPerBundle.max > 0) {
                                                                              this.availableAlertCountString = this.profileData.rights.rights.alertLimitPerBundle.max;
                                                    }
                                                    if (this.profileData.rights.rights.alertLimitPerBundle.max > 900) {
                                                                              this.availableAlertCountString = this.labelUnlimited[this.actualLanguage];
                                                    }
                          }
});

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddOrganizationForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      organizationIsSaving: false,
      organizationModel: {
        organizationInfo: { name: '',
          address: '',
          city: '',
          province: '',
          country: '',
          postalCode: '',
          phoneNumber: '' },
        managers: [{ profileId: 'TBD',
          firstName: 'TBD',
          lastName: 'TBD',
          email: 'TBD',
          phoneNumber: '',
          mainContactFlag: false }]

      },

      actualLanguage: "FR",
      labelFieldEvName: { FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name' },

      sectionLabelCreateOrganisation: { FR: "Créer une organisation", EN: 'Create an organization' },
      labelTextBoxOrganisation: { FR: "Nom de l'organisation", EN: 'Organization name' },
      labelTextBoxAdress: { FR: "Adresse", EN: 'Address' },
      labelTextBoxCity: { FR: "Ville", EN: 'City' },
      labelTextBoxProvince: { FR: "Province", EN: 'Province' },
      labelTextBoxCountry: { FR: "Pays", EN: 'Country' },
      labelTextBoxPostalCode: { FR: "Code Postal", EN: 'Postal code' },
      labelTextBoxPhone: { FR: "Numéro téléphone", EN: 'Phone number' },

      labelSectionContactPerson: { FR: "Personne contact", EN: 'Contact person' },
      labelSectionContactPersonFirstname: { FR: "Prénom", EN: 'First name' },
      labelSectionContactPersonLastname: { FR: "Nom", EN: 'Last name' },
      labelSectionContactPersonEmail: { FR: "Courriel", EN: 'Email' },
      labelSectionContactPersonPhone: { FR: "Téléphone", EN: 'Phone number' },

      buttonLabelSave: { FR: "Enregistrer", EN: 'Save' },
      messageAllFiledRequired: { FR: "Vous devez remplir tous les champs.", EN: 'You must fill all fields.' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' }

    };
  },

  methods: {
    saveOrganization: function saveOrganization() {
      var _this = this;

      var DataCheck = true;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.name.length > 0;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.address.length > 0;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.city.length > 0;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.province.length > 0;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.country.length > 0;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.postalCode.length > 0;
      DataCheck = DataCheck && this.organizationModel.organizationInfo.phoneNumber.length > 0;
      DataCheck = DataCheck && this.organizationModel.managers[0].phoneNumber.length > 0;

      if (DataCheck == false) {
        window.alert(this.messageAllFiledRequired[this.actualLanguage]);
      } else {
        this.organizationIsSaving = true;
        var requestData = { 'postAction': 'AddOrganizationToProfile',
          'organizationData': this.organizationModel
        };
        this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
          _this.organizationIsSaving = false;
          if (response.data.Code == 'OK') {
            _this.$store.dispatch('sessionStore/refreshProfileData');
            _this.$store.dispatch('overlayStore/toggleModal', false);
          } else {
            window.alert(_this.messagePostFail[_this.actualLanguage]);
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.organizationModel.managers[0].profileId = this.profileData.profileId;
    this.organizationModel.managers[0].firstName = this.profileData.profileInfo.firstName;
    this.organizationModel.managers[0].lastName = this.profileData.profileInfo.lastName;
    this.organizationModel.managers[0].email = this.profileData.profileInfo.email;
    this.organizationModel.managers[0].mainContactFlag = true;
  }
});

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddOrganizationForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      keyIsCreating: false,

      actualLanguage: "FR",
      referenceName: "",
      maximumMonthlyCost: "50",

      sectionLabelCreateMasterApiKey: { FR: "Création clef d'API maître", EN: 'Create API master key' },
      labelApiKeyReferenceName: { FR: "Nom de référence de la clef", EN: 'Key reference name' },
      labelTextBoxMaxCost: { FR: "Limite coût mensuel", EN: 'Maximum monthly cost' },

      buttonLabelSave: { FR: "Créer la clef", EN: 'Create key' }

    };
  },


  methods: {
    saveOrganization: function saveOrganization() {
      var _this = this;

      this.keyIsCreating = true;

      var requestData = { 'postAction': 'CreateNewOrganizationMasterKey',
        'organizationId': this.overlayParameters.actualOrganizationId,
        'referenceName': this.referenceName,
        'maximumMonthlyCost': this.maximumMonthlyCost
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        _this.keyIsCreating = false;
        if (response.data.Code == 'OK') {
          _this.$store.dispatch('sessionStore/refreshProfileData');
          _this.$store.dispatch('overlayStore/toggleModal', false);
          window.alert("The organisation will be refreshed");
        } else {
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddDeviceTemplateForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage: "FR",
      flagSaveNewPicture: true,

      labelFileType: { FR: "Type de fichier", EN: 'File type' },
      fileType: "jpg",

      sectionLabelCreateNewPicture: { FR: "Enregistrement d'image au système", EN: 'System picture saving' },
      textDescription: { FR: "Pour configurer une image affiché dans la plateforme EV Sens, il faut que cette image soit au préalable enregistrée dans le système avec un identifiant spécifique. Le nom de fichier a transmettre est automatiquement créé par le système.",
        EN: 'To configure an image displayed in the EV Sens platform, this image must first be registered in the system with a specific identifier. The file name to be transmitted is automatically created by the system.' },

      textBoxLabelPictureReferenceName: { FR: "Nom de référence de l'image", EN: 'Picture reference name' },
      referenceName: "",

      messageTransmitFile: { FR: "Nommer votre fichier image avec le nom suivant et le transmettre par courriel à support@evsens.ca",
        EN: 'Rename your picture file with the following file name and transmit your file by email to support@evsens.ca' },
      newFileName: "",

      buttonCreatePicture: { FR: "Créer l'image", EN: 'Create picture' },

      labelTableChannel: { FR: "Images d'appareil enregistrés dans le système", EN: 'Device picture saved in the system' },
      labelTableDevice: { FR: "Images d'appareil de mesure enregistrés dans le système", EN: 'Measurement device picture saved in the system' },
      pictureList: [],

      textPictureCreated: { FR: "Le lien de l'image est créé dans le système", EN: 'The picture link is created in the system' }

    };
  },


  methods: {
    createNewPicture: function createNewPicture() {
      var _this = this;

      if (this.referenceName.length > 0) {
        var requestData = { 'postAction': 'CreateOrganizationPicture',
          'organizationId': this.overlayParameters.organizationId,
          'referenceName': this.referenceName,
          'pictureType': this.overlayParameters.pictureType,
          'fileType': this.fileType
        };

        this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

          if (response.data.Code == 'OK') {
            _this.flagSaveNewPicture = false;
            _this.newFileName = response.data.FileName;
            _this.getPictureList();
          } else {
            window.alert(response.data.PromptMessage[_this.actualLanguage]);
          }
        });
      } else {
        var ErrorMessage = { FR: "Le nom de référence ne doit pas etre vide!", EN: "The reference name must not be empty!" };
        window.alert(ErrorMessage[this.actualLanguage]);
      }
    },
    getPictureList: function getPictureList() {
      var _this2 = this;

      this.pictureList = [];
      var requestData = { 'postAction': 'GetOrganizationPictureList',
        'organizationId': this.overlayParameters.organizationId,
        'pictureType': this.overlayParameters.pictureType
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this2.pictureList = response.data.PictureList;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.getPictureList();
  }
});

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__measurements_SubComponents_ApiDeviceListIndicatorV1p00_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__measurements_SubComponents_ApiDeviceListIndicatorV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__measurements_SubComponents_ApiDeviceListIndicatorV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__measurements_SubComponents_ApiDevicePanesV1p00_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__measurements_SubComponents_ApiDevicePanesV1p00_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__measurements_SubComponents_ApiDevicePanesV1p00_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddOrganizationForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a,
    ApiDeviceListIndicatorV1p00: __WEBPACK_IMPORTED_MODULE_3__measurements_SubComponents_ApiDeviceListIndicatorV1p00_vue___default.a,
    ApiDevicePanesV1p00: __WEBPACK_IMPORTED_MODULE_4__measurements_SubComponents_ApiDevicePanesV1p00_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage: "FR",

      sectionLabelCreateChannelTemplate: { FR: "Gabarit d'affichage des appareils (channel)", EN: 'Channel display templates' },

      textBoxLabelTemplateId: { FR: "Identifiant du gabarit d'affichage des appareils", EN: 'Channel display templates ID' },
      templateId: "",

      textBoxLabelChannelName: { FR: "Identifiant de l'appareil (channel)", EN: 'Device identifier' },
      channelName: "",

      textBoxLabelChannelType: { FR: "Type d'appareil", EN: 'Device type' },
      channelType: "",

      textBoxLabelChannelDescription: { FR: "Description d'appareil", EN: 'Device description' },
      channelDescription: "",

      textBoxLabelIconFile: { FR: "Image d'appareil", EN: 'Device picture' },
      channelIconFile: "",
      pictureList: [],

      textBoxLabelSignalSet: { FR: "Ensemble de signaux", EN: 'Signal set' },
      signalsSetTemplates: [],
      signalSetIndex: -1,

      selectedApiKey: "",

      textBoxLabelFrontEndComponent: { FR: "Composante d'affichage du portail", EN: 'Web portal display component' },
      frontendChannelComponent: "MultiPanes_V1P00",

      textSectionTitleListIndicator: { FR: "Indicateur en format liste", EN: "Indicator in list format" },
      componentListIndicators: [],
      labelListIndicatorLabelFR: { FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)" },
      labelListIndicatorLabelEN: { FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)" },
      labelListIndicatorVarName: { FR: "Variable (signal)", EN: "Variable (signal)" },
      labelListIndicatorAgregation: { FR: "Type agrégation", EN: "Agregation type" },

      buttonDeleteListIndicator: { FR: "Supprimer dernière indicateur", EN: 'Deleta last indicator' },
      buttonAddListIndicator: { FR: "Ajouter un indicateur", EN: 'Add indicator' },

      buttonLabelSave: { FR: "Créer/Modifier le gabarit", EN: 'Create/Modify the template' },
      labelSelectApiKey: { FR: "L'enregistrement d'un gabarit requiert une clef d'API maître, vous devez en sélectionné une:", EN: 'Template saving require a master API key, select one:' },
      messageProfileRefreshAction: { FR: "Le gabarit a été créé dans le système, cette opération requiert un rafraichissement des données de votre organisation (fait automatiquement).",
        EN: 'The template was created in the system, this action require an organization data refresh (done automatically).' },

      labelIndicator: { FR: "Indicateur:", EN: 'Indicator:' },
      labelIndicatorTestValue: { FR: "Valeur test", EN: 'Test value' },
      flagDisplayConditions: true,
      labelIndicatorColorCondition: { FR: "Couleurs conditionelles", EN: 'Conditional color' },
      labelIndicatorMinValue: { FR: "Valeur min", EN: 'Min value' },
      labelIndicatorMaxValue: { FR: "Valeur max", EN: 'Max value' },
      buttonSetCustomColor: { FR: "Couleur personalisée", EN: 'Personalized color' },
      buttonRed: { FR: "Rouge", EN: 'Red' },
      buttonGreen: { FR: "Vert", EN: 'Green' },
      buttonBlue: { FR: "Bleu", EN: 'Blue' },

      buttonAddColorCondition: { FR: "Ajouter une couleur conditionelle", EN: 'Add conditionnal color' },
      buttonDeleteColorCondition: { FR: "Supprimer dernière condition", EN: 'Delete last condition' },

      labelListIndicatorPreview: { FR: "Preview affichage format liste", EN: 'List display preview' },

      textSectionTitlePanes: { FR: "Onglets en format detail", EN: "Detail tabs" },
      textTitlePanes: { FR: "Onglets (pane):", EN: "Tabs (pane):" },
      componentDetailPanes: [],

      labelPaneButtonLabelFR: { FR: "Étiquette bouton sélection (FR)", EN: "Selection button label (FR)" },
      labelPaneButtonLabelEN: { FR: "Étiquette bouton sélection (EN)", EN: "Selection button label (EN)" },

      labelPaneTitleFR: { FR: "Titre de l'onglet (FR)", EN: "Tab title (FR)" },
      labelPaneTitleEN: { FR: "Titre de l'onglet (EN)", EN: "Tab title(EN)" },

      buttonAddPane: { FR: "Ajouter onglet", EN: 'Add tab' },
      buttonDeleteLastPane: { FR: "Supprimer dernière onglet", EN: 'Deleta last tabs' },

      labePanePreview: { FR: "Preview affichage en detail", EN: 'Detail view preview' },
      labelButtonPaneRefresh: { FR: "Rafraichir", EN: 'Refresh' },
      flagDisplayPreview: true,

      textTile: { FR: "Tuile", EN: "Tile" },
      textTileSection: { FR: "Tuiles de l'onglet", EN: "Tab tiles" },
      labelTileLabelFR: { FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)" },
      labelTileLabelEN: { FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)" },
      labelTileLabelIcon: { FR: "Icône (fa fav icon)", EN: "Icon (fa fav icon)" },
      labelTileValueSufix: { FR: "Sufixe de la valeur", EN: "Value sufix" },
      labelTileLabelIcon2: { FR: "Icône (entrée manuelle)", EN: "Icon (manual entry)" },
      labelTileVarName: { FR: "Variable (signal)", EN: "Variable (signal)" },
      labelTileColor: { FR: "Couleur prédéfinie", EN: "Predefined color" },
      labelTileSize: { FR: "Dimension", EN: "Width" },
      labelTileAgregation: { FR: "Type d'agrégation", EN: "Agregation type" },
      faFavIconList: ["fa fa-adjust", "fa fa-align-justify", "fa fa-anchor", "fa fa-android", "fa fa-angle-double-down", "fa fa-angle-double-left", "fa fa-angle-double-right", "fa fa-angle-double-up", "fa fa-archive", "fa fa-area-chart", "fa fa-arrow-circle-down", "fa fa-arrow-circle-left", "fa fa-arrow-circle-right", "fa fa-arrow-circle-up", "fa fa-arrow-circle-up", "fa fa-arrows-h", "fa fa-arrows-v", "fa fa-arrows", "fa fa-asterisk", "fa fa-automobile", "fa fa-bar-chart", "fa fa-bars", "fa fa-bathtub", "fa fa-battery-1", "fa fa-battery-2", "fa fa-battery-3", "fa fa-battery-4", "fa fa-bell", "fa fa-bolt", "fa fa-building-o", "fa fa-bus", "fa fa-cab", "fa fa-calendar-o", "fa fa-chain", "fa fa-child", "fa fa-cloud", "fa fa-cogs", "fa fa-cubes", "fa fa-database", "fafa-desktop", "fa fa-eject", "fa fa-file", "fa fa-files-o", "fa fa-free-code-camp", "fa fa-gear", "fa fa-gears", "fa fa-home", "fa fa-leaf", "fa fa-money", "fa fa-plug", "fa fa-server", "fa fa-signal", "fa fa-sort-amount-asc", "fa fa-sort-amount-desc", "fa fa-spinner", "fa fa-tachometer", "fa fa-thermometer", "fa fa-thumbs-o-down", "fa fa-thumbs-o-up", "fa fa-tint", "fa fa-trash", "fa fa-tree", "fa fa-volume-up", "fa fa-upload"],

      buttonAddTile: { FR: "Ajouter tuile", EN: 'Add tile' },
      buttonDeleteLastTile: { FR: "Supprimer dernière tuile", EN: 'Deleta last tile' },

      textGraph: { FR: "Graphiques", EN: "Graph" },
      textGraphsSection: { FR: "Graphiques de l'onglet", EN: "Tab graph" },
      labelGraphTitleFR: { FR: "Titre du graphique (FR)", EN: "Graph title (FR)" },
      labelGraphTitleEN: { FR: "Titre du graphique (EN)", EN: "Graph title (EN)" },

      textGraphTraceSection: { FR: "Traces du graphique", EN: "Graph traces" },
      buttonAddGraphTrace: { FR: "Ajouter une trace", EN: 'Add trace' },
      labelGraphTraceFR: { FR: "Étiquette (FR)", EN: "Label (FR)" },
      labelGraphTraceEN: { FR: "Étiquette (EN)", EN: "Label (EN)" },
      labelGraphTraveVarName: { FR: "Variable (signal)", EN: "Variable (signal)" },
      labelHrDayTraces: { FR: "Traces (Heure/Jour)", EN: "Traces (Hour/Day)" },

      buttonDeleteLastGraphTrace: { FR: "Supprimer dernière trace", EN: 'Deleta last trace' },

      buttonAddGraph: { FR: "Ajouter un graphique", EN: 'Add one graph' },
      buttonDeleteLastGraph: { FR: "Supprimer dernièr graphique", EN: 'Deleta last graph' }

    };
  },


  methods: {
    addListIndicator: function addListIndicator() {
      this.componentListIndicators.push({
        label: { FR: "", EN: "" },
        favIcon: "",
        varName: "",
        width: "Small",
        value: Math.floor(Math.random() * 10),
        agregation: "Sum",
        decimal: "2",
        colorConditions: [{ colorBackground: "#46c37b",
          minValue: -100000,
          maxValue: 100000,
          customColorFlag: false,
          customColorRed: 125,
          customColorGreen: 125,
          customColorBlue: 125 }]
      });
    },
    deleteListIndicator: function deleteListIndicator() {
      this.componentListIndicators.pop();
    },
    addConditionalColor: function addConditionalColor(index) {
      this.componentListIndicators[index].colorConditions.push({
        colorBackground: "#46c37b",
        minValue: -100000,
        maxValue: 100000,
        customColorFlag: false,
        customColorRed: 125,
        customColorGreen: 125,
        customColorBlue: 125
      });
    },
    resetListIndicatorsAndPanes: function resetListIndicatorsAndPanes() {
      this.componentListIndicators = [];
      this.componentDetailPanes = [];
    },
    selectListIndicatorSignal: function selectListIndicatorSignal(indicatorIndex) {
      for (var n = 0; n < this.signalsSetTemplates[this.signalSetIndex].deviceSignals.length; n++) {
        if (this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalName == this.componentListIndicators[indicatorIndex].varName) {
          this.componentListIndicators[indicatorIndex].label.FR = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.FR;
          this.componentListIndicators[indicatorIndex].label.EN = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.EN;
        }
      }
    },
    switchCustomColor: function switchCustomColor(index1, index2, value) {
      this.componentListIndicators[index1].colorConditions[index2].customColorFlag = value;
      this.applyCustomColor(index1, index2);
    },
    applyCustomColor: function applyCustomColor(index1, index2) {
      var RED = this.componentListIndicators[index1].colorConditions[index2].customColorRed;
      var GREEN = this.componentListIndicators[index1].colorConditions[index2].customColorGreen;
      var BLUE = this.componentListIndicators[index1].colorConditions[index2].customColorBlue;
      this.componentListIndicators[index1].colorConditions[index2].colorBackground = this.convertRGBtoHex(RED, GREEN, BLUE);
    },
    deleteConditionalColor: function deleteConditionalColor(index) {
      this.componentListIndicators[index].colorConditions.pop();
    },
    addPane: function addPane() {
      this.componentDetailPanes.push({
        buttonLabel: { FR: "Onglet", EN: "Tab" },
        title: { FR: "Nouvel onglet", EN: "New tab" },
        tilesIndicator: [],
        graphs: []
      });
    },
    deleteLastPane: function deleteLastPane() {
      this.componentDetailPanes.pop();
    },
    refreshPane: function refreshPane() {
      var _this = this;

      this.flagDisplayPreview = false;
      this.$nextTick(function () {
        _this.flagDisplayPreview = true;
      });
    },
    addTile: function addTile(index) {
      this.componentDetailPanes[index].tilesIndicator.push({
        label: { FR: "Étiquette FR", EN: "Label EN" },
        valueSufix: "",
        varName: "",
        decimal: "2",
        value: Math.floor(Math.random() * 10),
        agregation: "Sum",
        favIcon: "fa fa-tachometer",
        colorBackground: "bg-success"
      });
    },
    selectTileSignal: function selectTileSignal(paneIndex, tileIndex) {
      for (var n = 0; n < this.signalsSetTemplates[this.signalSetIndex].deviceSignals.length; n++) {
        if (this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalName == this.componentDetailPanes[paneIndex].tilesIndicator[tileIndex].varName) {
          this.componentDetailPanes[paneIndex].tilesIndicator[tileIndex].label.FR = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.FR;
          this.componentDetailPanes[paneIndex].tilesIndicator[tileIndex].label.EN = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.EN;
        }
      }
    },
    deleteLastTile: function deleteLastTile(index) {
      this.componentDetailPanes[index].tilesIndicator.pop();
    },
    addGraph: function addGraph(index) {
      this.componentDetailPanes[index].graphs.push({
        title: { FR: "Titre FR", EN: "Title EN" },
        type: "LineSingle",
        xLabel: { FR: "Time FR", EN: "Title X EN" },
        xData: ['2022-01-01 01:00:00', '2022-01-01 01:10:00', '2022-01-01 01:20:00', '2022-01-01 01:30:00', '2022-01-01 01:40:00'],
        xVarName: "DateTime",
        traces: []
      });
    },
    deleteLastGraph: function deleteLastGraph(index) {
      this.componentDetailPanes[index].graphs.pop();
    },
    addGraphTrace: function addGraphTrace(index, index2) {
      this.componentDetailPanes[index].graphs[index2].traces.push({
        label: { FR: "Étiquette FR", EN: "Label EN" },
        yVarName: "",
        yData: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), Math.floor(Math.random() * 10)],
        hourDayTraces: []
      });
    },
    selectGraphTraceSignal: function selectGraphTraceSignal(paneIndex, graphIndex, traceIndex) {
      for (var n = 0; n < this.signalsSetTemplates[this.signalSetIndex].deviceSignals.length; n++) {
        if (this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalName == this.componentDetailPanes[paneIndex].graphs[graphIndex].traces[traceIndex].yVarName) {
          this.componentDetailPanes[paneIndex].graphs[graphIndex].traces[traceIndex].label.FR = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.FR;
          this.componentDetailPanes[paneIndex].graphs[graphIndex].traces[traceIndex].label.EN = this.signalsSetTemplates[this.signalSetIndex].deviceSignals[n].signalLabel.EN;
        }
      }
    },
    deleteLastGraphTrace: function deleteLastGraphTrace(index, index2) {
      this.componentDetailPanes[index].graphs[index2].traces.pop();
    },
    getSignalSetList: function getSignalSetList() {
      var _this2 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationSignalsSet',
        'organizationId': this.overlayParameters.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this2.signalsSetTemplates = response.data.SignalsSets;


          if (_this2.overlayParameters.action == 'edit') {
            _this2.getChannelTemplate();
          }
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    saveChannelTemplate: function saveChannelTemplate() {
      var _this3 = this;

      this.keyIsCreating = true;

      var updateAllChannelFlag = false;
      var confirmMessage = { FR: "Mettre a jour tous les appareils créés avec ce gabarit? (OUI = OK, NON=ANNULER)",
        EN: "Update all device created with this template? (YES = OK, NO=CANCEL)" };
      if (this.overlayParameters.action == 'edit') {
        updateAllChannelFlag = window.confirm(confirmMessage[this.actualLanguage]);
      }

      var postBody = {
        'postAction': 'createChannelTemplate',
        'postSubAction': this.overlayParameters.action,
        'updateAllChannelFlag': updateAllChannelFlag,
        'organization_id': this.overlayParameters.organizationId.substring(5, 20),
        'template_id': this.templateId,
        'channelName': this.channelName,
        'channelType': this.channelType,
        'channelDescription': this.channelDescription,
        'iconFile': this.channelIconFile,
        'signalSetId': this.signalsSetTemplates[this.signalSetIndex].signalSetId,
        'frontEndChannelComponent': this.frontendChannelComponent,
        'componentListIndicators': this.componentListIndicators,
        'componentDetailPanes': this.componentDetailPanes
      };

      var requestData = { 'postAction': 'ApiCustomerGateway',
        'organizationId': this.overlayParameters.organizationId,
        'organizationApiKey': this.selectedApiKey,
        'postBody': postBody
      };

      this.templateIsCreating = true;
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        _this3.templateIsCreating = false;
        if (response.data.Code == 'OK') {
          window.alert(_this3.messageProfileRefreshAction[_this3.actualLanguage]);
          _this3.$store.dispatch('sessionStore/refreshProfileData');
          _this3.$store.dispatch('overlayStore/toggleModal', false);
        } else {
          window.alert(response.data.CallResponse.message);
        }
      });
    },
    getChannelTemplate: function getChannelTemplate() {
      var _this4 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationSingleChannelTemplate',
        'organizationId': this.overlayParameters.organizationId,
        'templateId': this.overlayParameters.templateId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this4.templateId = _this4.overlayParameters.templateId;
          _this4.channelName = response.data.ChannelTemplate.channelInfo.channelName;
          _this4.channelType = response.data.ChannelTemplate.channelInfo.channelType;
          _this4.channelDescription = response.data.ChannelTemplate.channelInfo.channelDescription;
          _this4.channelIconFile = response.data.ChannelTemplate.channelInfo.iconFile;
          _this4.frontendChannelComponent = response.data.ChannelTemplate.channelInfo.channelComponent;

          _this4.componentListIndicators = response.data.ChannelTemplate.channelComponentData.listIndicators;
          _this4.componentDetailPanes = response.data.ChannelTemplate.channelComponentData.detailPanes;

          for (var n = 0; n < _this4.signalsSetTemplates.length; n++) {
            if (_this4.signalsSetTemplates[n].signalSetId == response.data.ChannelTemplate.signalSetId) {
              _this4.signalSetIndex = n;
            }
          }
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    getPictureList: function getPictureList() {
      var _this5 = this;

      this.pictureList = [];
      var requestData = { 'postAction': 'GetOrganizationPictureList',
        'organizationId': this.overlayParameters.organizationId,
        'pictureType': 'channel'
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this5.pictureList = response.data.PictureList;
        } else {
          window.alert(response.data.PromptMessage[_this5.actualLanguage]);
        }
      });
    },
    colorToHex: function colorToHex(color) {
      var hexadecimal = color.toString(16);
      return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
    },
    convertRGBtoHex: function convertRGBtoHex(red, green, blue) {
      return "#" + this.colorToHex(red) + this.colorToHex(green) + this.colorToHex(blue);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.getPictureList();
    this.getSignalSetList();
  }
});

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddDeviceTemplateForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage: "FR",

      sectionLabelCreateDeviceTemplate: { FR: "Gabarit d'appareil de mesure", EN: 'Measurement device templates' },

      textBoxLabelTemplateId: { FR: "Identifiant du gabarit d'appareil de mesure", EN: 'Measurement device templates ID' },
      templateId: "",

      textBoxLabelDevicePicture: { FR: "Image d'appareil", EN: 'Device picture' },
      devicePicture: "",
      pictureList: [],

      textBoxLabelDeviceModel: { FR: "Modèle d'appareil", EN: 'Device model' },
      deviceModel: "",

      textBoxLabelDeviceName: { FR: "Nom d'appareil", EN: 'Device name' },
      deviceName: "",

      textSectionTitleVariables: { FR: "Signaux de l'appareil (définis par l'ensemble sélectionné)", EN: "Device signals (define by signal set)" },

      textBoxLabelSignalSet: { FR: "Ensemble de signaux", EN: 'Signal set' },
      signalsSetTemplates: [],
      signalSetIndex: -1,

      deviceSignals: [],
      labelVariableLabelFR: { FR: "Étiquette (FR)", EN: "Label (FR)" },
      labelVariableLabelEN: { FR: "Étiquette (EN)", EN: "Label (EN)" },
      labelVariableVarName: { FR: "Signal (variable)", EN: "Signal (variable)" },

      labelVariableDataFormat: { FR: "Format", EN: "Format" },
      labelVariableDataType: { FR: "Type", EN: "Type" },

      buttonAddVariable: { FR: "Ajouter une variable", EN: 'Add variable' },
      buttonDeleteVariable: { FR: "Supprimer dernière variable", EN: 'Deleta last variable' },

      labelDataTtlSection: { FR: "Durée de vie des données (jours)", EN: 'Data life time (days)' },
      labelDataTtlRaw: { FR: "Données brutes (RAW)", EN: 'RAW data' },
      labelDataTtlHr: { FR: "Données agrégées aux heures", EN: 'Agregated hourly data' },
      labelDataTtlDay: { FR: "Données agrégées aux journées", EN: 'Agregated daily data' },
      dataTTL: { raw: '365', hr: '365', day: '730' },

      controlParameters: [],
      textSectionTitleControlParameter: { FR: "Parametre de control de l'appareil de mesure",
        EN: "Control parameters of the measurement device" },
      textParameterDescription01: { FR: "Les paramètres de contrôle permettent de modifier un état de l'appareil en cours de fonctionnement.",
        EN: "The control parameters make it possible to modify a state ot the device during operation" },
      textParameterDescription02: { FR: "Une nouvelle valeur est modifiable via la page de configuration de l'appareil et transmise à l'appareil lors que ce dernier communique des mesures au cloud EV Sens.",
        EN: "A new value can be modified via the device configuration page and transmitted to the device when the latter communicates measurements to the EV Sens cloud" },

      labelParameterLabelFR: { FR: "Étiquette (FR)", EN: "Label (FR)" },
      labelParameterLabelEN: { FR: "Étiquette (EN)", EN: "Label (EN)" },
      labelParameterVarName: { FR: "Nom variable programme", EN: "Program variable name" },
      labelParameterDataType: { FR: "Type de donnée", EN: "Data type" },
      labelParameterValue: { FR: "Valeur", EN: "Value" },
      labelParameterFlagVisibleByCustomer: { FR: "Visible par client", EN: "Visible by customer" },
      labelParameterFlagEditByCustomer: { FR: "Modifiable par client", EN: "Editable by customer" },
      labelParameter: { FR: "", EN: "" },

      buttonAddParameter: { FR: "Ajouter un parametre", EN: 'Add parameter' },
      buttonDeleteParameter: { FR: "Supprimer dernière parametre", EN: 'Deleta last parameter' },

      labelChannelToCreate: { FR: "Appareils mesurés qui seront créés lors de l'enregistrement au profil client", EN: 'Measured device(s) created when customer bind the measurement device' },
      labelChannelToCreate2: { FR: "Sélection multiple possible (maintenir la touche CTRL pour sélection multiple)", EN: 'Multiple selection is possible (maintain CTRL key for multiple selection)' },
      channelTemplateList: [],
      compatibleChannelTemplateList: [],
      channelsToCreate: [],

      selectedApiKey: "",

      buttonLabelSave: { FR: "Créer/Modifier le gabarit", EN: 'Create/Modify the template' },

      labelSelectApiKey: { FR: "Cette action requiert une clef d'API maître, vous devez en sélectionné une:", EN: 'This action require a master API key, select one:' },
      messageProfileRefreshAction: { FR: "Le gabarit a été créé dans le système, cette opération requiert un rafraichissement des données de votre organisation (fait automatiquement).",
        EN: 'The template was created in the system, this action require an organization data refresh (done automatically).' }

    };
  },


  methods: {
    applyNewSignalSet: function applyNewSignalSet() {
      this.deviceSignals = this.signalsSetTemplates[this.signalSetIndex].deviceSignals;
      this.controlParameters = this.signalsSetTemplates[this.signalSetIndex].controlParameters;

      this.compatibleChannelTemplateList = [];
      for (var n = 0; n < this.channelTemplateList.length; n++) {
        if (this.channelTemplateList[n].signalSetId == this.signalsSetTemplates[this.signalSetIndex].signalSetId) this.compatibleChannelTemplateList.push(this.channelTemplateList[n]);
      }
    },
    addDeviceSignal: function addDeviceSignal() {
      this.deviceSignals.push({
        signalLabel: { FR: "", EN: "" },
        signalName: "",
        dataFormat: "",
        dataType: ""
      });
    },
    deleteDeviceSignal: function deleteDeviceSignal() {
      this.deviceSignals.pop();
    },
    addDeviceControlParameter: function addDeviceControlParameter() {
      this.controlParameters.push({
        parameterLabel: { FR: "", EN: "" },
        parameterName: "",
        dataType: "",
        dataValue: "",
        dataValueLastTransmit: "999999999999",
        flagViewByCustomer: false,
        flagEditByCustomer: false
      });
    },
    deleteDeviceControlParameter: function deleteDeviceControlParameter() {
      this.controlParameters.pop();
    },
    changeDataType: function changeDataType(index) {
      if (this.controlParameters[index].dataType == 'Numeric') {
        this.controlParameters[index].dataValue = '0';
      }
      if (this.controlParameters[index].dataType == 'Bool') {
        this.controlParameters[index].dataValue = false;
      }
    },
    saveDeviceTemplate: function saveDeviceTemplate() {
      var _this = this;

      var ValidationFlag = true;
      if (this.templateId.length == 0) {
        var ErrorMessage = { FR: "L'identifiant de gabarit est vide!", EN: "The template ID is empty!" };
        window.alert(ErrorMessage[this.actualLanguage]);
        ValidationFlag = false;
      }

      if (ValidationFlag) {
        var postBody = {
          'postAction': 'createDeviceTemplate',
          'postSubAction': this.overlayParameters.action,
          'organization_id': this.overlayParameters.organizationId.substring(5, 20),
          'template_id': this.templateId,
          'evsTemplate': 'ApiDevice_V1P00',
          'devicePicture': this.devicePicture,
          'deviceModel': this.deviceModel,
          'deviceName': this.deviceName,
          'signalSetId': this.signalsSetTemplates[this.signalSetIndex].signalSetId,
          'deviceSignals': this.deviceSignals,
          'controlParameters': this.controlParameters,
          'dataTTL': this.dataTTL,
          'channelToCreates': this.channelsToCreate
        };

        var requestData = { 'postAction': 'ApiCustomerGateway',
          'organizationId': this.overlayParameters.organizationId,
          'organizationApiKey': this.selectedApiKey,
          'postBody': postBody
        };

        this.templateIsCreating = true;
        this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
          _this.templateIsCreating = false;
          if (response.data.Code == 'OK') {
            window.alert(_this.messageProfileRefreshAction[_this.actualLanguage]);
            _this.$store.dispatch('sessionStore/refreshProfileData');
            _this.$store.dispatch('overlayStore/toggleModal', false);
          } else {
            window.alert(response.data.CallResponse.message);
          }
        });
      }
    },
    getDeviceTemplate: function getDeviceTemplate() {
      var _this2 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationSingleDeviceTemplate',
        'organizationId': this.overlayParameters.organizationId,
        'templateId': this.overlayParameters.templateId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this2.templateId = _this2.overlayParameters.templateId;
          _this2.deviceName = response.data.DeviceTemplate.deviceName;
          _this2.deviceModel = response.data.DeviceTemplate.deviceModel;
          _this2.devicePicture = response.data.DeviceTemplate.devicePicture;
          _this2.deviceSignals = response.data.DeviceTemplate.deviceSignals;
          _this2.controlParameters = response.data.DeviceTemplate.controlParameters;
          _this2.dataTTL = response.data.DeviceTemplate.dataTTL;
          _this2.channelsToCreate = response.data.DeviceTemplate.channelsToCreate;

          for (var n = 0; n < _this2.signalsSetTemplates.length; n++) {
            if (_this2.signalsSetTemplates[n].signalSetId == response.data.DeviceTemplate.signalSetId) {
              _this2.signalSetIndex = n;
            }
          }

          _this2.compatibleChannelTemplateList = [];
          for (var n = 0; n < _this2.channelTemplateList.length; n++) {
            if (_this2.channelTemplateList[n].signalSetId == _this2.signalsSetTemplates[_this2.signalSetIndex].signalSetId) _this2.compatibleChannelTemplateList.push(_this2.channelTemplateList[n]);
          }
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    getSignalSetList: function getSignalSetList() {
      var _this3 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationSignalsSet',
        'organizationId': this.overlayParameters.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this3.signalsSetTemplates = response.data.SignalsSets;

          if (_this3.overlayParameters.action == 'edit') {
            _this3.getDeviceTemplate();
          }
        } else {
          window.alert(response.data.PromptMessage[_this3.actualLanguage]);
        }
      });
    },
    getChannelTemplateList: function getChannelTemplateList() {
      var _this4 = this;

      this.pictureList = [];
      var requestData = { 'postAction': 'GetOrganizationChannelTemplates',
        'organizationId': this.overlayParameters.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this4.channelTemplateList = response.data.ChannelTemplates;
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    getPictureList: function getPictureList() {
      var _this5 = this;

      this.pictureList = [];
      var requestData = { 'postAction': 'GetOrganizationPictureList',
        'organizationId': this.overlayParameters.organizationId,
        'pictureType': 'device'
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this5.pictureList = response.data.PictureList;
        } else {
          window.alert(response.data.PromptMessage[_this5.actualLanguage]);
        }
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.getPictureList();
    this.getChannelTemplateList();
    this.getSignalSetList();
  }
});

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['organizationData'],

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a
  },

  data: function data() {
    return {

      actualLanguage: "FR",
      labelFreeService: { FR: 'Service gratuit', EN: 'Free service' },

      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      signalsSetTemplates: [],
      channelTemplates: [],
      deviceTemplates: [],

      sectionLabelApiManagement: { FR: "Gestion API", EN: 'API Management' },
      flagDisplaySectionApi: 0,
      displayMasterAPIKeysListFlag: true,
      organizationApiKey: [],
      organizationApiKeyData: [],
      organizationApiKeySubKeyData: [],
      organizationApiKeyOpenFlag: [],
      organizationApiKeyIsLoagingFlag: [],
      organizationApiKeyCreateDeviceFlag: [],

      descriptionStepSectionTitle: { FR: "Étapes à suivre:", EN: 'Steps to follow:' },
      descriptionStep01: { FR: "1) Créer une clef d'API maître (section GESTION DES CLEF D'API).",
        EN: '1) Create a master API key (section MANAGE API KEYS).' },
      descriptionStep01p1: { FR: "2) Créer un ensemble de signaux et de paramètres du système mesuré.",
        EN: '2) Create signal set for your system.' },
      descriptionStep02: { FR: "3) Créer un gabarit d'affichage (section GABARIT D'AFFICHAGE DES APPAREILS). ",
        EN: '3) Create device display template (section CREATE CHANNEL DISPLAY TEMPLATE).' },
      descriptionStep03: { FR: "4) Créer un gabarit d'appareil de mesure (section GABARIT D'APPAREILS DE MESURE).",
        EN: '4) Create a measurement device template (section MEASUREMENT DEVICE TEMPLATES).' },
      descriptionStep04: { FR: "5) Chaque appareil de mesure qui sont produit doivent avoir une clef d'API ainsi qu'un identifiant d'appareil (device_id), vous devez donc créer une clef d'API d'appareil sous une clef maître d'API (section GESTION DES CLEF D'API).",
        EN: '5) Each measuring device that is produced must have an API key as well as a device identifier (device_id), create a device API key under a master API key (section MANAGE API KEYS).' },
      descriptionStep05: { FR: "6) Utiliser les informations de l'API d'appareils pour la préparation de votre unitée produite.",
        EN: '6) Use the API key informations to prepare to produce unit.' },

      flagDisplayDocument: 0,
      DocumentTableTitle: { FR: 'Documentation', EN: 'Documentation' },

      DocumentTableContain: [{ Document: { FR: "Guide utilisation API", EN: "API User guide" },
        Detail: { FR: "Explication de fonctionnement et guide de programmation.",
          EN: "Functionality description and programming guide." },
        FileLink: { FR: "https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf",
          EN: "https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Configuration_1P1.pdf" } }, { Document: { FR: "Coût d'utilisation de l'API", EN: "API pricing fees" },
        Detail: { FR: "Détails des coûts d'utilisation de l'API.",
          EN: "Pricing detail." },
        FileLink: { FR: "https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Installation_EVA_V2_ENFR_V1P03.pdf",
          EN: "https://s3.amazonaws.com/evsenscloud.com/documents/Instruction_Installation_EVA_V2_ENFR_V1P03.pdf" } }],

      flagDisplaySectionSignalsSet: 0,
      SignalSetSectionTitle: { FR: "Ensembles de signaux et de paramètres", EN: 'Signals and parameters sets' },
      labelButtonSignalsSetCreate: { FR: "Créer un ensemble", EN: 'Create set' },
      tableLabelSignalsSetID: { FR: "Identifiant (ID)", EN: 'Identifier (ID)' },
      tableLabelSgnalsSetEdit: { FR: "Modifier", EN: 'Edit' },

      ChannelTemplateSectionTitle: { FR: "Gabarit d'affichage des appareils (channel)", EN: 'Device display templates' },
      labelButtonChannelTemplateCreate: { FR: "Créer un gabarit d'affichage d'appareil", EN: 'Create channel display template' },
      labelButtonSaveNewPictureChannel: { FR: "Enregistrer une nouvelle image d'appareil", EN: 'Save new device picture' },
      labelButtonSaveNewPictureDevice: { FR: "Enregistrer une nouvelle image d'appareil de mesure", EN: 'Save new measurement device picture' },
      tableLabelChannelTemplateID: { FR: "Identifiant (ID)", EN: 'Identifier (ID)' },
      tableLabelChannelTemplateName: { FR: "Nom du gabarit", EN: 'Template name' },
      tableLabelChannelTemplateType: { FR: "Type de gabarit", EN: 'Template type' },
      tableLabelChannelTemplateEdit: { FR: "Modifier", EN: 'Edit' },
      flagDisplaySectionChannelTemplate: 0,

      DeviceTemplateSectionTitle: { FR: "Gabarit d'appareils de mesure (device)", EN: 'Measurement device templates' },
      labelButtonDeviceTemplateCreate: { FR: "Créer un gabarit d'appareil de mesure", EN: 'Create measurement device template' },
      flagDisplaySectionDeviceTemplate: 0,

      flagDisplayMasterApiKey: 0,
      sectionLabelCreateApiMasterKey: { FR: "Gestion des clef d'API (Création d'appareils)", EN: 'Manage API keys (Devices creation)' },
      sectionTextCreateApiMasterKey: { FR: "Les clef d'API maître permettent de créer des sous clef d'appareils. Les clef d'appareils sont utilisés par les appareils de mesure pour transmettre des données vers le cloud EV Sens. Si une clef maître est désactivée, toutes les sous clef deviendront inactives. Il est possible de régler une limite de frais mensuel par clef maître. Ainsi si la sommes des frais des sous-clef atteigne le maximum, celles-si seront temporairement inactivées. POUR PLUS D'INFORMATION SE RÉFÉRER A LA SECTION DOCUMENTATION CI-HAUT.",
        EN: 'Master API keys are used to create device sub-keys. Device keys are used by measuring devices to transmit data to the EV Sens cloud. If a master key is deactivated, all the sub-keys will become inactive. It is possible to set a monthly fee limit per master key. So if the sum of the costs of the sub-keys reaches the maximum, they will be temporarily inactivated. FOR MORE INFORMATION, REFER TO THE DOCUMENTATION SECTION ABOVE.' },
      buttonLabelCreateApiMasterKey: { FR: "Créer une clef d'API maître", EN: 'Create API Master Key' },
      buttonLabelCancelCreateApiMasterKey: { FR: "Annuler", EN: 'Cancel' },
      buttonLabelConfirmCreateApiMasterKey: { FR: "Confirmer", EN: 'Confirm' },

      sectionLabelCreateMasterApiKey: { FR: "Création clef d'API maître", EN: 'Create API master key' },
      createNewApiMasterKey: false,
      labelApiKeyReferenceName: { FR: "Nom de référence de la clef", EN: 'Key reference name' },
      referenceName: "",
      labelTextBoxMaxCost: { FR: "Limite coût mensuel", EN: 'Maximum monthly cost' },
      maximumMonthlyCost: "50",

      labelMasterKeyList: { FR: "Clefs maître", EN: 'Master keys' },
      labelMasterKeyDeviceList: { FR: "Appareils", EN: 'Devices' },

      labelCreateDeviceSerialNumber: { FR: "Numéro de série de l'appareil", EN: 'Device serial number' },
      newDeviceSerialNumber: "",
      labelCreateDeviceTemplateToUse: { FR: "Template d'appareil", EN: 'Device template' },
      newDeviceTemplateToUse: "",

      lastCreatedDevice: { deviceId: "", deviceBindingKey: "", deviceApiKey: "" },

      labelDeviceKeyList: { FR: "Appareils créés sous cette clef maître:", EN: 'Device list created under this master key:' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayApi: function toggleDisplayApi() {
      this.flagDisplaySectionApi = ~this.flagDisplaySectionApi;
    },
    toggleDisplayDocument: function toggleDisplayDocument() {
      this.flagDisplayDocument = ~this.flagDisplayDocument;
    },
    toggleDisplaySignalsSet: function toggleDisplaySignalsSet() {
      this.flagDisplaySectionSignalsSet = ~this.flagDisplaySectionSignalsSet;
    },
    toggleDisplayChannelTemplate: function toggleDisplayChannelTemplate() {
      this.getChannelTemplateList();
      this.flagDisplaySectionChannelTemplate = ~this.flagDisplaySectionChannelTemplate;
    },
    toggleDisplayDeviceTemplate: function toggleDisplayDeviceTemplate() {
      this.getDeviceTemplateList();
      this.flagDisplaySectionDeviceTemplate = ~this.flagDisplaySectionDeviceTemplate;
    },
    openDocumentInTable: function openDocumentInTable(FileLink) {
      var localUrl = '';
      window.open(FileLink, '_blank');
    },
    toggleDisplayMasterApiKey: function toggleDisplayMasterApiKey() {
      this.flagDisplayMasterApiKey = ~this.flagDisplayMasterApiKey;
    },
    openCreateNewMasterKey: function openCreateNewMasterKey() {
      this.createNewApiMasterKey = true;
      this.displayMasterAPIKeysListFlag = false;
    },
    cancelCreateNewMasterKey: function cancelCreateNewMasterKey() {
      this.createNewApiMasterKey = false;
      this.displayMasterAPIKeysListFlag = true;
    },
    createConfirmNewMasterKey: function createConfirmNewMasterKey() {
      var _this = this;

      if (this.referenceName.length > 0) {
        var requestData = { 'postAction': 'CreateNewOrganizationMasterKey',
          'organizationId': this.organizationData.organizationId,
          'referenceName': this.referenceName,
          'maximumMonthlyCost': this.maximumMonthlyCost
        };

        this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this.organizationApiKey.push(response.data.CreatedKey);
            _this.organizationApiKeySubKeyData.push({ TBD: "TBD" });
            _this.organizationApiKeyCreateDeviceFlag.push(false);
            _this.organizationApiKeyIsLoagingFlag.push(false);
            _this.displayMasterAPIKeysListFlag = true;
          } else {
            window.alert(response.data.PromptMessage[_this.actualLanguage]);
          }
        });

        this.createNewApiMasterKey = false;
      } else {
        var ErrorMessage = { FR: "Le nom de référence est vide!", EN: "The reference name is empty!" };
        window.alert(ErrorMessage[this.actualLanguage]);
      }
    },
    getChannelTemplateList: function getChannelTemplateList() {
      var _this2 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationChannelTemplates',
        'organizationId': this.organizationData.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this2.channelTemplates = response.data.ChannelTemplates;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    },
    getSignalSetList: function getSignalSetList() {
      var _this3 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationSignalsSet',
        'organizationId': this.organizationData.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this3.signalsSetTemplates = response.data.SignalsSets;
        } else {
          window.alert(response.data.PromptMessage[_this3.actualLanguage]);
        }
      });
    },
    createSignalsSet: function createSignalsSet() {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'organizationApiKeys': this.organizationApiKey,
        'action': 'create'
      };
      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-signals-set-add-form');
    },
    createChannelTemplate: function createChannelTemplate() {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'organizationApiKeys': this.organizationApiKey,
        'action': 'create'
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-channel-template-add-form');
    },
    createNewPicture: function createNewPicture(pictureType) {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'pictureType': pictureType
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-add-picture-form');
    },
    editSignalSetTemplate: function editSignalSetTemplate(index) {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'organizationApiKeys': this.organizationApiKey,
        'action': 'edit',
        'templateId': this.signalsSetTemplates[index].signalSetId
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-signals-set-add-form');
    },
    editChannelTemplate: function editChannelTemplate(index) {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'organizationApiKeys': this.organizationApiKey,
        'action': 'edit',
        'templateId': this.channelTemplates[index].channelTemplateId
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-channel-template-add-form');
    },
    getDeviceTemplateList: function getDeviceTemplateList() {
      var _this4 = this;

      this.deviceTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationDeviceTemplates',
        'organizationId': this.organizationData.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this4.deviceTemplates = response.data.DeviceTemplates;
        } else {
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    createDeviceTemplate: function createDeviceTemplate() {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'organizationApiKeys': this.organizationApiKey,
        'action': 'create'
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-device-template-add-form');
    },
    editDeviceTemplate: function editDeviceTemplate(index) {
      var modalParameters = {
        'organizationId': this.organizationData.organizationId,
        'organizationApiKeys': this.organizationApiKey,
        'action': 'edit',
        'templateId': this.deviceTemplates[index].deviceTemplateId
      };

      this.$store.dispatch('overlayStore/setParameters', modalParameters);
      this.showModal('organization-api-device-template-add-form');
    },
    toggleDisplayApiKey: function toggleDisplayApiKey(index) {
      var _this5 = this;

      this.lastCreatedDevice = { deviceId: "", deviceBindingKey: "", deviceApiKey: "" }, this.newDeviceSerialNumber = "";
      this.newDeviceTemplateToUse = "";

      this.organizationApiKeyIsLoagingFlag[index] = true;
      this.displayMasterAPIKeysListFlag = false;
      this.$nextTick(function () {
        _this5.displayMasterAPIKeysListFlag = true;
      });

      var requestData = { 'postAction': 'ReadKeyDetails',
        'organizationId': this.organizationData.organizationId,
        'keyId': this.organizationApiKey[index].key
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this5.organizationApiKeyData[index] = response.data.KeyData;
          _this5.organizationApiKeyOpenFlag[index] = ~_this5.organizationApiKeyOpenFlag[index];

          _this5.organizationApiKeyIsLoagingFlag[index] = false;
          _this5.displayMasterAPIKeysListFlag = false;
          _this5.$nextTick(function () {
            _this5.displayMasterAPIKeysListFlag = true;
          });

          _this5.readSubKeyDetails(index);
        } else {
          window.alert(response.data.PromptMessage[_this5.actualLanguage]);
        }
      });
    },
    createDevice: function createDevice(index) {
      var _this6 = this;

      this.displayMasterAPIKeysListFlag = false;
      this.organizationApiKeyCreateDeviceFlag[index] = true;
      this.$nextTick(function () {
        _this6.displayMasterAPIKeysListFlag = true;
      });
    },
    cancelCreateDevice: function cancelCreateDevice(index) {
      var _this7 = this;

      this.displayMasterAPIKeysListFlag = false;
      this.organizationApiKeyCreateDeviceFlag[index] = false;
      this.$nextTick(function () {
        _this7.displayMasterAPIKeysListFlag = true;
      });
    },
    confirmCreateDevice: function confirmCreateDevice(index) {
      var _this8 = this;

      if (this.newDeviceSerialNumber.length == 0 | this.newDeviceTemplateToUse.length == 0) {
        var ErrorMessage = { FR: "Le numéro de série ou le template est vide!", EN: "The serial number or template is empty!" };
        window.alert(ErrorMessage[this.actualLanguage]);
      } else {

        var postBody = {
          'postAction': 'createNewDevice',
          'organization_id': this.organizationData.organizationId.substring(5, 20),
          'template_id': this.newDeviceTemplateToUse,
          'serialNumber': this.newDeviceSerialNumber
        };

        var requestData = { 'postAction': 'ApiCustomerGateway',
          'organizationId': this.organizationData.organizationId,
          'organizationApiKey': this.organizationApiKey[index].key,
          'postBody': postBody
        };

        this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            var Message = { FR: "Votre appareil de mesure a été créé dans le système!", EN: "Your measurement device was created in the system!" };
            window.alert(Message[_this8.actualLanguage]);


            _this8.lastCreatedDevice.deviceId = response.data.CallResponse.deviceInfo.deviceId;
            _this8.lastCreatedDevice.deviceBindingKey = response.data.CallResponse.deviceInfo.deviceBindingKey;
            _this8.lastCreatedDevice.deviceApiKey = response.data.CallResponse.deviceInfo.deviceApiKey;

            _this8.cancelCreateDevice(index);
            _this8.readSubKeyDetails(index);
          } else {
            window.alert(response.data.CallResponse.message);
          }
        });
      }
    },
    readSubKeyDetails: function readSubKeyDetails(index) {
      var _this9 = this;

      var postBody = {
        'postAction': 'readSubKeysDetails',
        'organization_id': this.organizationData.organizationId.substring(5, 20),
        'masterKeyId': this.organizationApiKey[index].key
      };

      var requestData = { 'postAction': 'ApiCustomerGateway',
        'organizationId': this.organizationData.organizationId,
        'organizationApiKey': this.organizationApiKey[index].key,
        'postBody': postBody
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this9.organizationApiKeySubKeyData[index] = response.data.CallResponse.subKeysDetail;
          _this9.displayMasterAPIKeysListFlag = false;
          _this9.$nextTick(function () {
            _this9.displayMasterAPIKeysListFlag = true;
          });
        } else {
          window.alert(response.data.CallResponse.message);
        }
      });
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.organizationApiKey = this.organizationData.apiManagement.apiOrganizationKeys;
    this.organizationApiKeyOpenFlag = [];
    this.organizationApiKeyCreateDeviceFlag = [];
    for (var m = 0; m < this.organizationApiKey.length; m++) {
      this.organizationApiKeyOpenFlag.push(0);
      this.organizationApiKeyCreateDeviceFlag.push(false);
      this.organizationApiKeyIsLoagingFlag.push(false);
      this.organizationApiKeyData.push({ TBD: 'TBD' });
      this.organizationApiKeySubKeyData.push({ TBD: "TBD" });
    }

    this.getChannelTemplateList();
    this.getDeviceTemplateList();
    this.getSignalSetList();
  }
});

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddDeviceTemplateForm',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },
  data: function data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage: "FR",

      sectionLabelCreateSignalsSet: { FR: "Éditeur d'ensemble de signaux et paramètres de contrôle", EN: 'Signal and control parameters set editor' },

      textBoxLabelTemplateId: { FR: "Identifiant de l'ensemble", EN: 'Set ID' },
      templateId: "",

      textSectionTitleVariables: { FR: "Liste des signaux", EN: "Signals list" },

      deviceSignals: [],
      labelVariableLabelFR: { FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)" },
      labelVariableLabelEN: { FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)" },
      labelVariableVarName: { FR: "Signal (nom de variable)", EN: "Signal (variable name)" },

      labelVariableDataFormat: { FR: "Format de donnée", EN: "Data format" },
      labelVariableDataType: { FR: "Type de donnée", EN: "Data type" },

      buttonAddSignal: { FR: "Ajouter un signal", EN: 'Add signal' },
      buttonDeleteSignal: { FR: "Supprimer dernière signal", EN: 'Deleta last signal' },

      controlParameters: [],
      textSectionTitleControlParameter: { FR: "Parametre de control de l'appareil de mesure",
        EN: "Control parameters of the measurement device" },
      textParameterDescription01: { FR: "Les paramètres de contrôle permettent de modifier un état de l'appareil en cours de fonctionnement.",
        EN: "The control parameters make it possible to modify a state ot the device during operation" },
      textParameterDescription02: { FR: "Une nouvelle valeur est modifiable via la page de configuration de l'appareil et transmise à l'appareil lors que ce dernier communique des mesures au cloud EV Sens.",
        EN: "A new value can be modified via the device configuration page and transmitted to the device when the latter communicates measurements to the EV Sens cloud" },

      labelParameterLabelFR: { FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)" },
      labelParameterLabelEN: { FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)" },
      labelParameterVarName: { FR: "Nom variable programme", EN: "Program variable name" },
      labelParameterDataType: { FR: "Type de donnée", EN: "Data type" },
      labelParameterValue: { FR: "Valeur", EN: "Value" },
      labelParameterFlagVisibleByCustomer: { FR: "Visible par client", EN: "Visible by customer" },
      labelParameterFlagEditByCustomer: { FR: "Modifiable par client", EN: "Editable by customer" },
      labelParameter: { FR: "", EN: "" },

      buttonAddParameter: { FR: "Ajouter un parametre", EN: 'Add parameter' },
      buttonDeleteParameter: { FR: "Supprimer dernière parametre", EN: 'Deleta last parameter' },

      labelChannelToCreate: { FR: "Affichage d'appareils créés lors de l'enregistrement au profil client", EN: 'Displayed device created when customer bind the measurement device' },
      labelChannelToCreate2: { FR: "Sélection multiple possible (maintenir la touche CTRL pour sélection multiple)", EN: 'Multiple selection is possible (maintain CTRL key for multiple selection)' },
      channelTemplateList: [],
      channelsToCreate: [],

      selectedApiKey: "",

      buttonLabelSave: { FR: "Créer/Modifier le gabarit", EN: 'Create/Modify the template' },

      labelSelectApiKey: { FR: "Cette action requiert une clef d'API maître, vous devez en sélectionné une:", EN: 'This action require a master API key, select one:' },
      messageProfileRefreshAction: { FR: "Le gabarit a été créé dans le système, cette opération requiert un rafraichissement des données de votre organisation (fait automatiquement).",
        EN: 'The template was created in the system, this action require an organization data refresh (done automatically).' }

    };
  },


  methods: {
    addDeviceSignal: function addDeviceSignal() {
      this.deviceSignals.push({
        signalLabel: { FR: "", EN: "" },
        signalName: "",
        dataFormat: "",
        dataType: ""
      });
    },
    deleteDeviceSignal: function deleteDeviceSignal() {
      this.deviceSignals.pop();
    },
    addDeviceControlParameter: function addDeviceControlParameter() {
      this.controlParameters.push({
        parameterLabel: { FR: "", EN: "" },
        parameterName: "",
        dataType: "",
        dataValue: "",
        dataValueLastTransmit: "999999999999",
        flagViewByCustomer: false,
        flagEditByCustomer: false
      });
    },
    deleteDeviceControlParameter: function deleteDeviceControlParameter() {
      this.controlParameters.pop();
    },
    changeDataType: function changeDataType(index) {
      if (this.controlParameters[index].dataType == 'Numeric') {
        this.controlParameters[index].dataValue = '0';
      }
      if (this.controlParameters[index].dataType == 'Bool') {
        this.controlParameters[index].dataValue = false;
      }
    },
    saveSignalSetTemplate: function saveSignalSetTemplate() {
      var _this = this;

      var ValidationFlag = true;
      if (this.templateId.length == 0) {
        var ErrorMessage = { FR: "L'identifiant de gabarit est vide!", EN: "The template ID is empty!" };
        window.alert(ErrorMessage[this.actualLanguage]);
        ValidationFlag = false;
      }

      if (ValidationFlag) {
        var postBody = {
          'postAction': 'createSignalSetTemplate',
          'postSubAction': this.overlayParameters.action,
          'organization_id': this.overlayParameters.organizationId.substring(5, 20),
          'template_id': this.templateId,
          'deviceSignals': this.deviceSignals,
          'controlParameters': this.controlParameters
        };

        var requestData = { 'postAction': 'ApiCustomerGateway',
          'organizationId': this.overlayParameters.organizationId,
          'organizationApiKey': this.selectedApiKey,
          'postBody': postBody
        };

        this.templateIsCreating = true;
        this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
          _this.templateIsCreating = false;
          if (response.data.Code == 'OK') {
            window.alert(_this.messageProfileRefreshAction[_this.actualLanguage]);
            _this.$store.dispatch('sessionStore/refreshProfileData');
            _this.$store.dispatch('overlayStore/toggleModal', false);
          } else {
            window.alert(response.data.CallResponse.message);
          }
        });
      }
    },
    getSignalSetTemplate: function getSignalSetTemplate() {
      var _this2 = this;

      this.channelTemplates = [];
      var requestData = { 'postAction': 'GetOrganizationSingleSignalsSet',
        'organizationId': this.overlayParameters.organizationId,
        'templateId': this.overlayParameters.templateId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {

        if (response.data.Code == 'OK') {
          _this2.templateId = _this2.overlayParameters.templateId;
          _this2.deviceSignals = response.data.SignalsSet.deviceSignals;
          _this2.controlParameters = response.data.SignalsSet.controlParameters;
        } else {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['profileData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlayStore', ['overlayParameters'])),

  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    if (this.overlayParameters.action == 'edit') {
      this.getSignalSetTemplate();
    }
  }
});

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrganizationPaymentInfo__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrganizationPaymentInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrganizationPaymentInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrganizationPaymentHistory__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrganizationPaymentHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OrganizationPaymentHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrganizationApiManagement__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrganizationApiManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__OrganizationApiManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Integrator_IntegratorTabMenu__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Integrator_IntegratorTabMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Integrator_IntegratorTabMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AdminPlanTable__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AdminPlanTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AdminPlanTable__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['organizationIndex'],
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a,
    OrganizationPaymentInfo: __WEBPACK_IMPORTED_MODULE_5__OrganizationPaymentInfo___default.a,
    OrganizationPaymentHistory: __WEBPACK_IMPORTED_MODULE_6__OrganizationPaymentHistory___default.a,
    OrganizationApiManagement: __WEBPACK_IMPORTED_MODULE_7__OrganizationApiManagement___default.a,
    IntegratorTabMenu: __WEBPACK_IMPORTED_MODULE_8__Integrator_IntegratorTabMenu___default.a,
    AdminPlanTable: __WEBPACK_IMPORTED_MODULE_9__AdminPlanTable___default.a
  },
  data: function data() {
    return {
      flagDisplayOrganization: 0,
      flagDisplayMySubscription: 0,

      organizationIsSaving: false,
      organizationIsLoading: false,
      subscriptionPrice: 0,

      organizationModel: {
        organizationId: '',
        rights: {},
        organizationInfo: { name: '',
          address: '',
          city: '',
          province: '',
          country: '',
          postalCode: '',
          phoneNumber: '' },
        managers: [{ profileId: 'TBD',
          firstName: 'TBD',
          lastName: 'TBD',
          email: 'TBD',
          phoneNumber: '',
          mainContactFlag: false }],
        subscription: [],
        licences: []

      },

      actualLanguage: "FR",
      flagDisplaySelectPlan: false,
      flagUserAsAdministratorLicence: false,

      flagDisplayIntegratorPanel: 0,
      labelButtonOpenIntegratorPanel: { FR: "Outils Intégrateurs", EN: 'Integrator tools' },
      labelButtonCloseIntegratorPanel: { FR: "Fermer", EN: 'Close' },
      labelTitleIntegratorTools: { FR: "Outils Intégrateurs", EN: 'Integrator tools' },

      labelField: { FR: '', EN: '' },
      labelPaymentTerms: { 'Month': { FR: "Paiement mensuel", EN: 'Monthly payment' },
        'Year': { FR: "Paiement annuel", EN: 'Annually payment' } },

      labelTextBoxOrganizationName: { FR: "Nom de l'organisation", EN: 'Organization name' },
      labelTextBoxAdress: { FR: "Adresse", EN: 'Address' },
      labelTextBoxCity: { FR: "Ville", EN: 'City' },
      labelTextBoxProvince: { FR: "Province", EN: 'Province' },
      labelTextBoxCountry: { FR: "Pays", EN: 'Country' },
      labelTextBoxPostalCode: { FR: "Code Postal", EN: 'Postal code' },
      labelTextBoxPhone: { FR: "Numéro téléphone", EN: 'Phone number' },

      sectionLabelOrganizationManager: { FR: "Administateur de l'Organisation", EN: 'Organization Administrator' },
      labelSectionContactPersonFirstname: { FR: "Prénom", EN: 'First name' },
      labelSectionContactPersonLastname: { FR: "Nom", EN: 'Last name' },
      labelSectionContactPersonEmail: { FR: "Courriel", EN: 'Email' },
      labelSectionContactPersonPhone: { FR: "Téléphone", EN: 'Phone number' },
      buttonLabelDeleteManager: { FR: "Retirer", EN: 'Remove' },
      buttonLabelAddOrganizationManager: { FR: "Ajouter un administrateur de l'organisation", EN: 'Add organization administrator' },
      buttonSaveModifications: { FR: "Enregistrer les modifications", EN: 'Save modifications' },
      sectionLabelSubscriptionLicense: { FR: "Abonnement & Licences", EN: 'Subscription & Licenses' },
      tileLabelGroup: { FR: "Groupes", EN: 'Groups' },
      tileLabelSystem: { FR: "Systems", EN: 'Systems' },
      tileLabelDevice: { FR: "Appareils", EN: 'Devices' },
      tileLabelDevicePerSystem: { FR: "Appareils par system", EN: 'Devices per system' },

      tileLabelConsumptionTitle: { FR: "Statistiques d'utilisation (mois en cours)", EN: 'Usage statistics (this month)' },
      tileLabelCallsCount: { FR: "Nombre requêtes", EN: 'Requests count' },
      tileLabelItemsRead: { FR: "Items lus", EN: 'Items read count' },
      tileLabelProcessTime: { FR: "Temps opération", EN: 'Process time' },

      tileLabelEmail: { FR: "Courriel", EN: 'Email' },
      tileLabelSMS: { FR: "SMS", EN: 'SMS' },

      sectionLabelLicenceOrganization: { FR: "Détails du forfait de l'organisation", EN: 'Organization subscription details and options' },
      baseCostLabel: { FR: "Coût de base", EN: 'Base cost' },
      selectPlanOptionColumnTitle01: { FR: "Option", EN: 'Option' },
      selectPlanOptionColumnTitle02: { FR: "Description", EN: 'Description' },
      selectPlanOptionColumnTitle03: { FR: "Activation de l'option / Valeur maximum", EN: 'Option activation / Maximum value' },
      maxValueLabel: { FR: "Valeur maximale (limite)", EN: 'Maximum value (limit)' },
      buttonLabelDeleteLicence: { FR: "Supprimer cette licence", EN: 'Delete this licence' },
      buttonLabelAddUserLicence: { FR: "Ajouter une licence usager", EN: 'Add user licence' },

      sectionLabelLicence: { FR: "Licences usagers", EN: 'Users licenses' },
      tableLicenceType: { FR: "Type", EN: 'Type' },
      tableLicenceUser: { FR: "Utilisateur lié", EN: 'Linked user' },
      tableLicenceAction: { FR: "Action", EN: 'Action' },
      buttonLabelRemoveLicence: { FR: "Retirer", EN: 'Remove' },
      buttonLabelAllocate: { FR: "Allouer la licence", EN: 'Allocate the licence' },
      sectionLabelSubscriptionFees: { FR: "Frais d'abonnement", EN: 'Subscription fees' },

      buttonSaveLicenceOptions: { FR: "Enregistrer mes modifications de licence", EN: 'Save my licences options' },
      actualMensualityLabel: { FR: "Estimation de votre mensualité", EN: 'Estimated monthly fees' },
      actualmensualityDescripCol1: { FR: "Détails", EN: 'Details' },
      actualmensualityDescripCol2: { FR: "Valeur", EN: 'Value' },

      sectionLabelPaymentInfo: { FR: "Information de paiement", EN: 'Payment information' },
      textMessageUserDoNotHaveLicenceToEditOrganization: { FR: "Votre licence d'accèes ne permet pas de modifier les accèes de l'organisation ", EN: 'Your user licence does not allows to edit the organization access.' },
      textMessageToAccessMenager: { FR: "Pour activer la plateforme gestionaire, votre organisation doit adhérer à un forfait.", EN: 'To activate the manager web platform, your organization must subscribe to a package.' },
      buttonLabelSubcribeToPackage: { FR: "Adhérer à un forfait", EN: 'Subscribe to a package' },
      buttonLabelModifyMyPackage: { FR: "Modifier le forfait", EN: 'Modify package' },

      messagePromptNewManagerEmail: { FR: "Inscrire l'adresse courriel de l'utilisateur EV Sens que vous désirez ajouter comme administrateur de l'organisation", EN: 'Write the EV Sens user email that you want to add as organization administrator' },
      messageUserValidationFail: { FR: "Erreur de validation de l'existance de l'usager!", EN: 'User validation error!' },
      messageUserValidationUserDoNotExist: { FR: "L'utilisateur n'existe pas dans le système EV Sens.", EN: 'The user do not exists in the EV Sens system.' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },
      messagePromptConfirmManagerRemove: { FR: "Confirmer le retrait de l'administrateur: ", EN: 'Confirm administrator removal:' },
      messagePromptCannotRemoveLastManager: { FR: "Vous ne pouvez pas supprimer le dernier administrateur de l'organisation.", EN: 'You cannot remove the last administrator of the organization.' },

      messagePromptEmailLicenceRecipient: { FR: "Entrer l'adresse courriel de l'utilisateur EV Sens que vous désirez lier à la licence:", EN: 'Write the user email that you want to link to the license:' },
      messageUserAlreadyHaveLicence: { FR: "L'usager détient déjà une licence, il doit la libérer avant de pouvoir lui octroyer!", EN: 'User already had licence, he needs to release it before you can attribute to him!' },
      messagePromptConfirmLicenceRelease: { FR: "Confirmer la relâche de la licence!", EN: 'Confirm licence release!' },
      messagePromptConfirmUserLicenceAdd1: { FR: "Confirmer la création d'une licence usager, cette opération sera enregistrée dans le système et des frais de ",
        EN: 'Confirm the user licence creation, this operation is automatically saved in the system so your next monthly payment will have an additionnal ' },
      messagePromptConfirmUserLicenceAdd2: { FR: "$ seront ajouté au coût de base (avant rabais) de votre prochaine mensualitée.",
        EN: '$ charge on your base cost fees (before rebate application).' },
      messagePromptConfirmLicenceDeleting: { FR: "Confirmer la supression de la licence.",
        EN: 'Confirm licence deletion.' },
      sumBaseCost: 0,
      sumRebate: 0,
      specialRebate: 0,
      specialRebateString: "",
      sumFinalCost: 0,
      displayUserLicenceSectionFLag: true,
      displayUserLicenceFlag: [],

      licenceOptionsIsSaving: false,
      flagAdviseUserAboutChangeOptionSave: 0,
      messageYouMustSaveOption: { FR: "Vous pouvez modifer les options afin de visualiser les changements. Pour enregistrer vos options dans le système, vous devez utiliser le bouton : Enregistrer mes modifications de licence",
        EN: 'You can modify the licence options to observe fees impacts. To save and confirm your options, use the Save my licence options button' },

      labelTitleServicePlanOrganization: { FR: 'Plan de service pour les organisations', EN: 'Organization service plan' },
      labelReturnToMyProfileBtn: { FR: 'Retour à mon organisation', EN: 'Return to my organization' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['profileData', 'planTransactionData'])),
  watch: {
    profileData: function profileData() {
      this.getOrganizationData();
    }
  },

  methods: {
    toggleDisplayOrganization: function toggleDisplayOrganization() {
      this.flagDisplayOrganization = ~this.flagDisplayOrganization;

      if (this.flagDisplayOrganization == -1) {
        this.getOrganizationData();
      }
    },
    toggleDisplayMySubscription: function toggleDisplayMySubscription() {
      this.flagDisplayMySubscription = ~this.flagDisplayMySubscription;
    },
    toggleIntegratorPanel: function toggleIntegratorPanel() {
      this.flagDisplayIntegratorPanel = ~this.flagDisplayIntegratorPanel;
    },
    reloadTempoBundle: function reloadTempoBundle() {
      this.tempoBundle = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actualBundle));
    },
    toUsername: function toUsername(email) {
      var email2 = email.replace('.', '-dot-');
      email = email2.replace('.', '-dot-');
      email2 = email.replace('.', '-dot-');
      return email2.replace('@', '-at-');
    },
    returnToMyServicePlan: function returnToMyServicePlan() {
      this.planTransactionData.transactionStatusCode = '000';

      window.scrollTo(0, 0);
    },
    addManager: function addManager() {
      var _this = this;

      var newEmail = prompt(this.messagePromptNewManagerEmail[this.actualLanguage], "@");

      return this.$store.dispatch('sessionStore/validateUserExist', newEmail).then(function (response) {
        _this.displayMessage = response.data.Message;

        if (response.data.Code == 'Fail') window.alert(_this.messageUserValidationFail[_this.actualLanguage]);
        if (response.data.Code == 'E01') window.alert(_this.messageUserValidationUserDoNotExist[_this.actualLanguage]);

        if (response.data.Code == 'OK') {
          var requestData = { 'postAction': 'AddOrganizationManager',
            'organizationId': _this.profileData.managed_organizations[_this.organizationIndex].organizationId,
            'userId': _this.toUsername(newEmail)
          };

          _this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
            if (response.data.Code == 'OK') {
              _this.getOrganizationData();
            } else {
              window.alert(response.data.PromptMessage[_this.actualLanguage]);
            }
          });
        }
      });
    },
    confirmRemoveManager: function confirmRemoveManager(index) {
      var _this2 = this;

      var proceedToAction = false;

      if (this.organizationModel.managers.length > 1) {

        if (window.confirm(this.messagePromptConfirmManagerRemove[this.actualLanguage] + ('"' + this.organizationModel.managers[index].email + '"?'))) {
          proceedToAction = true;
        }
      } else {
        window.alert(this.messagePromptCannotRemoveLastManager[this.actualLanguage]);
      }

      if (proceedToAction) {
        this.organizationIsSaving = true;
        var requestData = { 'postAction': 'RemoveOrganizationManager',
          'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
          'managerIndex': index
        };
        this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
          _this2.organizationIsSaving = false;
          if (response.data.Code == 'OK') {
            _this2.getOrganizationData();
          } else {
            window.alert(response.data.PromptMessage[_this2.actualLanguage]);
          }
        });
      }
    },
    saveOrganizationModifications: function saveOrganizationModifications() {
      var _this3 = this;

      this.organizationIsSaving = true;
      var requestData = { 'postAction': 'SaveOrganizationModifications',
        'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
        'organizationData': this.organizationModel
      };
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        _this3.organizationIsSaving = false;
        if (response.data.Code == 'OK') {
          _this3.getOrganizationData();
        } else {
          window.alert(response.data.PromptMessage[_this3.actualLanguage]);
        }
      });
    },
    getOrganizationData: function getOrganizationData() {
      var _this4 = this;

      this.organizationIsLoading = true;
      var requestData = { 'postAction': 'ReadOrganizationData',
        'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId
      };
      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this4.organizationModel = response.data.OrganizationData;
          _this4.displayUserLicenceFlag = [];
          if (_this4.organizationModel.subscription.subscriptionId != 'NONE') {
            for (var m = 0; m < _this4.organizationModel.subscription.data.organization_user_licences.length; m++) {
              _this4.displayUserLicenceFlag.push(0);
            }
            _this4.computeCost();
          }

          _this4.organizationIsLoading = false;
        } else {
          _this4.organizationIsLoading = false;
          window.alert(response.data.PromptMessage[_this4.actualLanguage]);
        }
      });
    },
    toggleDisplayUserLicenceFlag: function toggleDisplayUserLicenceFlag(index) {
      this.displayUserLicenceSectionFLag = false;
      this.displayUserLicenceFlag[index] = ~this.displayUserLicenceFlag[index];
      this.displayUserLicenceSectionFLag = true;
    },
    subscribeToAdminPlan: function subscribeToAdminPlan() {
      this.planTransactionData.transactionStatusCode = '055';
      this.planTransactionData.postAction = 'NewAdminSubscription';
      this.planTransactionData.organizationId = this.profileData.managed_organizations[this.organizationIndex].organizationId;
      this.planTransactionData.organizationSubscription = this.organizationModel.subscription;
    },
    addUserLicence: function addUserLicence() {
      var _this5 = this;

      var promptMessage = this.messagePromptConfirmUserLicenceAdd1[this.actualLanguage];
      promptMessage = promptMessage + this.organizationModel.subscription.data.organization_plan_description.userLicenceData.price;
      promptMessage = promptMessage + this.messagePromptConfirmUserLicenceAdd2[this.actualLanguage];
      if (window.confirm(promptMessage)) {

        var requestData = { 'postAction': 'AddUserLicenceToSubscription',
          'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
          'subscriptionId': this.organizationModel.subscription.subscriptionId
        };
        this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            _this5.organizationModel = response.data.OrganizationData;
            _this5.subscriptionPrice = _this5.organizationModel.subscription.data.renewalPrice / 100;
            _this5.computeCost();
          } else {
            window.alert(response.data.PromptMessage[_this5.actualLanguage]);
          }
        });
      }
    },
    saveLicenceOptionsModifications: function saveLicenceOptionsModifications() {
      var _this6 = this;

      this.licenceOptionsIsSaving = true;

      var requestData = { 'postAction': 'SaveLicencesOptionsModifications',
        'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
        'subscriptionId': this.organizationModel.subscription.subscriptionId,
        'organizationLicence': this.organizationModel.subscription.data.organization_licence,
        'userLicences': this.organizationModel.subscription.data.organization_user_licences
      };
      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        _this6.licenceOptionsIsSaving = false;
        if (response.data.Code == 'OK') {
          _this6.organizationModel = response.data.OrganizationData;
          _this6.computeCost();
        } else {
          window.alert(response.data.PromptMessage[_this6.actualLanguage]);
        }
      });
    },
    attributeLicence: function attributeLicence(index) {
      var _this7 = this;

      var licenceId = this.organizationModel.subscription.data.organization_user_licences[index].licenceId.substring(11, 30);

      var newEmail = prompt(this.messagePromptEmailLicenceRecipient[this.actualLanguage] + licenceId, "@");

      return this.$store.dispatch('sessionStore/validateUserExist', newEmail).then(function (response) {
        _this7.displayMessage = response.data.Message;

        if (response.data.Code == 'Fail') window.alert(_this7.messageUserValidationFail[_this7.actualLanguage]);
        if (response.data.Code == 'E01' && _this7.actualLanguage == "FR") window.alert(_this7.messageUserValidationUserDoNotExist[_this7.actualLanguage]);

        if (response.data.Code == 'OK') {
          if (response.data.UserHadLicenceFlag) {
            window.alert(_this7.messageUserAlreadyHaveLicence[_this7.actualLanguage]);
          } else {
            var requestData = { 'postAction': 'AttributeUserLicence',
              'organizationId': _this7.profileData.managed_organizations[_this7.organizationIndex].organizationId,
              'subscriptionId': _this7.organizationModel.subscription.subscriptionId,
              'userLicenceId': _this7.organizationModel.subscription.data.organization_user_licences[index].licenceId,
              'licenceIndex': index,
              'userIdRecipient': _this7.toUsername(newEmail)
            };

            _this7.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
              if (response.data.Code == 'OK') {
                _this7.getOrganizationData();
              } else {
                window.alert(response.data.PromptMessage[_this7.actualLanguage]);
              }
            });
          }
        }
      });
    },
    releaseLicence: function releaseLicence(index) {
      var _this8 = this;

      var ProceedToAction = false;

      if (window.confirm(this.messagePromptConfirmLicenceRelease[this.actualLanguage])) {
        ProceedToAction = true;
      }

      if (ProceedToAction) {
        var requestData = { 'postAction': 'ReleaseUserLicence',
          'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
          'subscriptionId': this.organizationModel.subscription.subscriptionId,
          'userLicenceId': this.organizationModel.subscription.data.organization_user_licences[index].licenceId,
          'licenceIndex': index };
        this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
          _this8.profileIsSaving = false;
          if (response.data.Code == 'OK') {
            _this8.getOrganizationData();
          } else {
            window.alert(response.data.PromptMessage[_this8.actualLanguage]);
          }
        });
      }
    },
    deleteLicence: function deleteLicence(index) {
      var _this9 = this;

      var ProceedToAction = false;

      if (window.confirm(this.messagePromptConfirmLicenceDeleting[this.actualLanguage])) {
        ProceedToAction = true;
      }

      if (ProceedToAction) {
        var requestData = { 'postAction': 'DeleteUserLicence',
          'organizationId': this.profileData.managed_organizations[this.organizationIndex].organizationId,
          'subscriptionId': this.organizationModel.subscription.subscriptionId,
          'userLicenceId': this.organizationModel.subscription.data.organization_user_licences[index].licenceId,
          'licenceIndex': index };
        this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
          _this9.profileIsSaving = false;
          if (response.data.Code == 'OK') {
            _this9.getOrganizationData();
          } else {
            window.alert(response.data.PromptMessage[_this9.actualLanguage]);
          }
        });
      }
    },
    computeCost: function computeCost() {

      this.flagAdviseUserAboutChangeOptionSave = this.flagAdviseUserAboutChangeOptionSave + 1;
      if (this.flagAdviseUserAboutChangeOptionSave == 2 && this.sumBaseCost > 0) {
        window.alert(this.messageYouMustSaveOption[this.actualLanguage]);
      }

      this.sumBaseCost = 0;
      this.sumBaseCost += parseFloat(this.organizationModel.subscription.data.organization_licence.price);
      var subscriptionData = this.organizationModel.subscription.data;

      for (var n = 0; n < subscriptionData.organization_licence.customizedOptions.length; n++) {
        if (subscriptionData.organization_licence.customizedOptions[n].valueType == 'BOOL' && subscriptionData.organization_licence.customizedOptions[n].value == true) {
          this.sumBaseCost += parseFloat(subscriptionData.organization_licence.customizedOptions[n].price);
        }

        if (subscriptionData.organization_licence.customizedOptions[n].optionID == 'ChannelMaxCount') {
          var extraCount = parseFloat(this.organizationModel.rights.rights.channelLimit.count) - parseFloat(subscriptionData.organization_licence.customizedOptions[n].firstNoChargeCountValue);

          if (extraCount > 0) {
            this.sumBaseCost += parseFloat(subscriptionData.organization_licence.customizedOptions[n].price) * extraCount;
          }
        }
      }

      for (var m = 0; m < subscriptionData.organization_user_licences.length; m++) {
        this.sumBaseCost += parseFloat(subscriptionData.organization_user_licences[m].price);

        for (var n = 0; n < subscriptionData.organization_user_licences[m].customizedOptions.length; n++) {
          if (subscriptionData.organization_user_licences[m].customizedOptions[n].valueType == 'BOOL' && subscriptionData.organization_user_licences[m].customizedOptions[n].value == true) {
            this.sumBaseCost += parseFloat(subscriptionData.organization_user_licences[m].customizedOptions[n].price);
          }
          if (subscriptionData.organization_user_licences[m].customizedOptions[n].valueType == 'NUMERIC') {
            this.sumBaseCost += parseFloat(subscriptionData.organization_user_licences[m].customizedOptions[n].price) * parseFloat(subscriptionData.organization_user_licences[m].customizedOptions[n].value);
          }
        }
      }

      this.sumBaseCost = Math.round(this.sumBaseCost * 100) / 100;

      var sliceMin = 0;
      var sliceMax = 0;
      var slicePourcentage = 0;

      this.sumRebate = 0;
      var actualChart = this.organizationModel.subscription.data.organization_plan_description.rebateChartData.chart;

      for (var m = 0; m < actualChart.length; m++) {
        var sliceMin = parseFloat(actualChart[m].priceSliceMin);
        var sliceMax = parseFloat(actualChart[m].priceSliceMax);
        var slicePourcentage = parseFloat(actualChart[m].pourcentageReduction) / 100;

        if (this.sumBaseCost > sliceMax) {
          this.sumRebate += (sliceMax - sliceMin) * slicePourcentage;
        }
        if (this.sumBaseCost >= sliceMin && this.sumBaseCost < sliceMax) {
          this.sumRebate += (this.sumBaseCost - sliceMin) * slicePourcentage;
        }
        if (m == actualChart.length - 1 && this.sumBaseCost > sliceMax) {
          this.sumRebate += (this.sumBaseCost - sliceMax) * slicePourcentage;
        }
      }

      this.specialRebateString = "";
      this.specialRebate = 0;
      var actualSpecialRebate = this.organizationModel.subscription.data.organization_special_rebate;
      for (var m = 0; m < actualSpecialRebate.length; m++) {

        this.specialRebateString = this.specialRebateString + "( " + actualSpecialRebate[m].RebateBillingDescription[this.actualLanguage];

        if (actualSpecialRebate[m].RebateType == 'Fix') {
          this.specialRebateString = this.specialRebateString + ":" + actualSpecialRebate[m].RebateAmount + "$";
          this.specialRebate = this.specialRebate + parseFloat(actualSpecialRebate[m].RebateAmount);
        }
        if (actualSpecialRebate[m].RebateType == 'Pourcentage') {
          this.specialRebateString = this.specialRebateString + ":" + actualSpecialRebate[m].RebateAmount + "%";
          this.specialRebate = this.specialRebate + parseFloat(actualSpecialRebate[m].RebateAmount) * this.sumBaseCost / 100;
        }
        this.specialRebateString = this.specialRebateString + ", expire :" + actualSpecialRebate[m].ExpiringDate;
        this.specialRebateString = this.specialRebateString + " )";
      }

      this.specialRebate = Math.round(this.specialRebate * 100) / 100;
      this.sumFinalCost = this.sumBaseCost - this.sumRebate - this.specialRebate;
      this.sumRebate = Math.round(this.sumRebate * 100) / 100;
      this.sumFinalCost = Math.round(this.sumFinalCost * 100) / 100;
      if (this.sumFinalCost < 0) {
        this.sumFinalCost = 0;
      }
    }
  },

  mounted: function mounted() {
    var userLicenceLength = this.profileData.licences.length;
    this.flagUserAsAdministratorLicence = true;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(271);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['organizationData'],

  components: {},

  data: function data() {
    return {

      actualLanguage: "FR",
      labelFreeService: { FR: 'Service gratuit', EN: 'Free service' },
      automaticRenewFlagInititalValue: false,
      renewFlagModified: false,

      textLabelProduct: { FR: "Produit", EN: 'Product' },
      textLabelLastPaimentDate: { FR: "Date du précédent prélèvement : ", EN: 'Previous payment date:' },
      textLabelNextPaimentDate: { FR: "Date du prochain prélèvement : ", EN: 'Next payment date:' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      sectionLabelTransactions: { FR: "Historique de paiement", EN: 'Payment history' },
      flagDisplaySectionTransactions: 0,
      transactions: [],
      transactionOpenFlag: [],

      InvoiceText: { FR: "Facture: ", EN: 'Invoice: ' },
      InvoiceTitle: { FR: "SERVICE PLATEFORME ADMINISTRATEUR", EN: 'MANAGER PLATFORM CHARGE' },
      InvoiceCustomer: { FR: "CLIENT: ", EN: 'CUSTOMER: ' },
      InvoicePaidBy: { FR: "PAYÉ AVEC: ", EN: 'PAID BY: ' },
      InvoiceQuantity: { FR: "Quantité", EN: 'Quantity' },
      InvoiceUnitPrice: { FR: "Prix unitaire", EN: 'Unit price' },
      InvoicePrice: { FR: "Prix", EN: 'Price' },
      InvoiceSubTotal: { FR: "Sous total", EN: 'Sub total' },
      CardInfoPaidBy: { FR: "Payé par:", EN: 'Paid by:' },
      CardInfoLast4: { FR: "Finissant par:", EN: 'Last digits:' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayTransactions: function toggleDisplayTransactions() {
      this.flagDisplaySectionTransactions = ~this.flagDisplaySectionTransactions;
    },
    toggleDisplayTransaction: function toggleDisplayTransaction(index) {
      this.flagDisplaySectionTransactions = 0;
      this.transactionOpenFlag[index] = ~this.transactionOpenFlag[index];
      this.flagDisplaySectionTransactions = -1;
    },
    automaticRenewButtonSwitch: function automaticRenewButtonSwitch() {
      if (this.organizationData.subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue) {
        this.renewFlagModified = true;
      } else {
        this.renewFlagModified = false;
      }
    },
    getTransactionHistory: function getTransactionHistory() {
      var _this = this;

      var requestData = { 'postAction': 'ReadOrganizationTransactionHistory',
        'organizationId': this.organizationData.organizationId
      };

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.transactions = response.data.TransactionHistory;
          _this.transactionOpenFlag = [];
          for (var m = 0; m < _this.transactions.length; m++) {
            _this.transactionOpenFlag.push(0);
            if (parseFloat(_this.transactions[m].subTotal) < 0) {
              _this.transactions[m].subTotal = "0";
            }
            if (parseFloat(_this.transactions[m].tps) < 0) {
              _this.transactions[m].tps = "0";
            }
            if (parseFloat(_this.transactions[m].tvq) < 0) {
              _this.transactions[m].tvq = "0";
            }
            if (parseFloat(_this.transactions[m].total) < 0) {
              _this.transactions[m].total = "0";
            }

            for (var n = 0; n < _this.transactions[m].taxesList.length; n++) {
              if (parseFloat(_this.transactions[m].taxesList[n].Amount) < 0) {
                _this.transactions[m].taxesList[n].Amount = "0";
              }
            }
          }
        } else {
          console.log(response);
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    generatePdfInvoice: function generatePdfInvoice(index) {

      var columns = [{ title: "Title", dataKey: "title" }, { title: "Body", dataKey: "body" }];
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf__["a" /* default */]({
        orientation: "portrait",
        unit: "in",
        format: "letter"
      });

      doc.setFontSize(10).text(this.InvoiceText[this.actualLanguage] + this.transactions[index].subscription + ':' + this.transactions[index].timestamp, 0.5, 1.0);
      doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1);
      doc.setFontSize(14).text('EV Sens inc.', 8, 1.3, { align: "right" });
      doc.setFontSize(10).text('65 rue de la Fenière', 8, 1.5, { align: "right" });
      doc.setFontSize(10).text("L'Ancienne-Lorette, QC", 8, 1.7, { align: "right" });
      doc.setFontSize(10).text("CANADA, G2E 1X8", 8, 1.9, { align: "right" });
      doc.setFontSize(10).text("support@evsens.ca", 8, 2.1, { align: "right" });

      doc.setLineWidth(0.01).line(0.5, 2.2, 8.0, 2.2);
      doc.setFontSize(16).text(this.InvoiceTitle[this.actualLanguage], 4.25, 2.5, { align: "center", maxWidth: "7.5" });
      doc.setLineWidth(0.01).line(0.5, 2.7, 8.0, 2.7);

      doc.setFontSize(12).text(this.InvoiceCustomer[this.actualLanguage], 0.5, 3, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(12).text(this.organizationData.organizationInfo.name, 0.5, 3.2, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(10).text(this.organizationData.organizationInfo.address, 0.5, 3.4, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(10).text(this.organizationData.organizationInfo.city + ', ' + this.organizationData.organizationInfo.province, 0.5, 3.6, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(10).text(this.organizationData.organizationInfo.country + ', ' + this.organizationData.organizationInfo.postalCode, 0.5, 3.8, { align: "left", maxWidth: "7.5" });

      doc.setFontSize(10).text("Quantity", 0.5, 4.2, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(10).text("Description", 1.5, 4.2, { align: "left", maxWidth: "3" });
      doc.setFontSize(10).text("Unit Price ($)", 6.5, 4.2, { align: "right", maxWidth: "7.5" });
      doc.setFontSize(10).text("Cost ($)", 7.5, 4.2, { align: "right", maxWidth: "7.5" });
      doc.setLineWidth(0.01).line(0.5, 4.3, 8.0, 4.3);

      var y_pos = 0;
      var lineCost = 0;
      for (var n = 0; n < this.transactions[index].detailLines.length; n++) {
        y_pos = 4.5 + n * 0.2;
        lineCost = this.transactions[index].detailLines[n].unitPrice * this.transactions[index].detailLines[n].quantity;
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].quantity, 0.5, y_pos, { align: "left", maxWidth: "7.5" });
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].description[this.actualLanguage], 1.5, y_pos, { align: "left", maxWidth: "3" });
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].unitPrice, 6.5, y_pos, { align: "right", maxWidth: "7.5" });
        doc.setFontSize(10).text(lineCost.toString(), 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }
      y_pos = y_pos + 0.2;
      doc.setLineWidth(0.01).line(0.5, y_pos, 8.0, y_pos);
      y_pos = y_pos + 0.2;
      doc.setFontSize(10).text('Sub Total', 6.5, y_pos, { align: "right", maxWidth: "2" });
      doc.setFontSize(10).text(this.transactions[index].subTotal, 7.5, y_pos, { align: "right", maxWidth: "7.5" });

      if (this.transactions[index].tps > 0) {
        y_pos = y_pos + 0.2;
        doc.setFontSize(10).text('TPS (5%)', 6.5, y_pos, { align: "right", maxWidth: "2" });
        doc.setFontSize(10).text(this.transactions[index].tps, 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }

      if (this.transactions[index].tvq > 0) {
        y_pos = y_pos + 0.2;
        doc.setFontSize(10).text('TVQ (9.975%)', 6.5, y_pos, { align: "right", maxWidth: "2" });
        doc.setFontSize(10).text(this.transactions[index].tvq, 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }

      for (var m = 0; m < this.transactions[index].taxesList.length; m++) {
        y_pos = y_pos + 0.2;
        doc.setFontSize(10).text(this.transactions[index].taxesList[m].Label[this.actualLanguage], 6.5, y_pos, { align: "right", maxWidth: "4" });
        doc.setFontSize(10).text(this.transactions[index].taxesList[m].Amount, 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }

      y_pos = y_pos + 0.3;
      doc.setFontSize(12).text('TOTAL', 6.5, y_pos, { align: "right", maxWidth: "2" });
      doc.setFontSize(12).text(this.transactions[index].total, 7.5, y_pos, { align: "right", maxWidth: "7.5" });

      y_pos = y_pos + 1;
      doc.setFontSize(12).text(this.InvoicePaidBy[this.actualLanguage], 0.5, y_pos, { align: "left", maxWidth: "2" });
      y_pos = y_pos + 0.2;
      doc.setLineWidth(0.01).line(0.5, y_pos, 8.0, y_pos);
      y_pos = y_pos + 0.2;
      doc.setFontSize(10).text(this.transactions[index].cardData.CardType, 0.5, y_pos, { align: "left", maxWidth: "7.5" });
      y_pos = y_pos + 0.2;
      doc.setFontSize(10).text(this.CardInfoLast4[this.actualLanguage] + this.transactions[index].cardData.CardLast4, 0.5, y_pos, { align: "left", maxWidth: "7.5" });

      doc.setLineWidth(0.01).line(0.5, 10, 8.0, 10);

      doc.save('Invoice_' + (this.transactions[index].timestamp + '.pdf'));
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
    this.getTransactionHistory();
  }
});

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['organizationData'],

  components: {},

  data: function data() {
    return {

      actualLanguage: "FR",
      labelFreeService: { FR: 'Service gratuit', EN: 'Free service' },
      automaticRenewFlagInititalValue: false,
      preAuthorizedPaymentFlagInititalValue: false,
      renewFlagModified: false,

      buttonLabelAutomaticRenewal: { FR: "Poursuivre l'abonnement", EN: 'Continue subscription' },
      buttonLabelAutomaticPreAuthorizedPaiement: { FR: "Prélèvement automatique sur carte de crédit", EN: 'Credit card direct debit' },

      buttonLabelSaveModification: { FR: "Enregistrer les modifications", EN: 'Save modifications' },
      sectionLabelCreditCard: { FR: "Carte de crédit enregistrée", EN: 'Credit card recorded' },
      textLabelCardLastDigit: { FR: "Se terminant par...", EN: 'Ends by...' },
      buttonLabelModifyCard: { FR: "Modifier la carte de crédit", EN: 'Modify recorded card' },
      buttonLabelApplyCard: { FR: "Enregistrer une carte de crédit", EN: 'Apply a credit card' },
      textYouMustRegisterCreditCard: { FR: "Vous devez enregistrer une carte de crédit pour l'abonnement", EN: 'You must register a credit card for the subscription' },

      messageSubscriptionEnding: { FR: "Votre abonnement se terminera à la date de la prochaine facturation. Les licences d'utilisateur seront retirés automatiquement.",
        EN: 'Your subscription will end at the next billing date. All user licences will be removed automatically.' },

      manuallyBilledTitle: { FR: "Paiement par émission de facture par courriel.", EN: 'Payment by issuing an invoice by email.' },
      activateManuallyBilledOptionMessage: { FR: "Votre abonnement est de type qui nécessite un paiement par carte de crédit. Pour le convertir à facturation manuelle, contactez EV Sens.",
        EN: 'Your subscription is of the type that requires payment by credit card. To convert it to manual billing, contact EV Sens.' },

      activateManuallyBilledOptionMessage2: { FR: "Si vous enregistrez cette option sans que la conversion à facturation manuelle ait été activée, votre abonnement prendra fin à la date de la prochaine facturation.",
        EN: 'If you save this option without manual billing conversion enabled, your subscription will end on the next billing date.' },

      textLabelLastPaimentDate: { FR: "Date de la précédente facturation: ", EN: 'Date of previous billing:' },
      textLabelNextPaimentDate: { FR: "Date de la prochaine facturation: ", EN: 'Next billing date:' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      apiManagementSectionTitle: { FR: "Control d'accès à l'API client EV Sens", EN: 'EV Sens Customer API Access control' },
      apiManagementSectionText1: { FR: "L'API EV Sens permet aux organisations qui développent leur propre appareils de mesure d'utiliser la plateforme EL-iot comme outil d'enregistrement des données. En activant l'API, la section Gestion API sera activé dans ce panneau de contrôle de l'organisation",
        EN: 'The EV Sens API allows organizations developing their own measuring devices to use the EL-iot platform as a data logging tool. By activating the API, the API Management section will be activated in this organization control panel.' },
      apiManagementSectionText2: { FR: "L'API comporte des frais d'utilisation qui dépendent du taux d'utilisation de l'API. Ceci requiert une carte de crédit valide rattachée à l'abonnement de l'organisation. Les frais d'utilisation sont décrit dans la section Gestion API.",
        EN: "The API as usage fees that depend on the API usage rate. This requires a valid credit card attached to the organization's subscription. User fees are described in the API Management section." },
      apiManagementActivationButton: { FR: "Activation", EN: 'Activation' },
      apiConfirmButtonDisplay: false,
      apiManagementActivationConfirmeButton: { FR: "Confirmer le changement", EN: 'Confirm the modification' },
      apiDesactivationMessage: { FR: "En désactivant le controle d'accès d'API, toutes les clefs d'API seront désactivée. Si des appareils effectuent de communications vers le cloud EV Sens, celles-ci seront bloquées.",
        EN: 'By disabling API access control, all API keys will be diseabled. If any devices make communications to the EV Sens cloud, they will be blocked.' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    automaticRenewButtonSwitch: function automaticRenewButtonSwitch() {
      if (this.organizationData.subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue || this.organizationData.subscription.data.preAuthorizedPaymentFlag == this.preAuthorizedPaymentFlagInititalValue) {
        this.renewFlagModified = true;
      } else {
        this.renewFlagModified = false;
      }

      if (this.organizationData.subscription.data.automaticRenewFlag == true) {
        this.organizationData.subscription.data.preAuthorizedPaymentFlag = false;
      }
    },
    modifyMyAutomaticRenew: function modifyMyAutomaticRenew() {
      var _this = this;

      this.automaticRenewFlagInititalValue = this.organizationData.subscription.data.automaticRenewFlag;
      this.preAuthorizedPaymentFlagInititalValue = this.organizationData.subscription.data.preAuthorizedPaymentFlag;
      this.renewFlagModified = false;
      this.planTransactionData.organizationId = this.organizationData.organizationId;
      this.planTransactionData.postAction = 'UpdateOrganizationAutomaticRenewFlag';
      this.planTransactionData.automaticRenewFlag = this.organizationData.subscription.data.automaticRenewFlag;
      this.planTransactionData.preAuthorizedPaymentFlag = this.organizationData.subscription.data.preAuthorizedPaymentFlag;

      this.$store.dispatch('sessionStore/processSubscription', this.planTransactionData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.$store.dispatch('sessionStore/refreshProfileData');
        } else {
          window.alert(_this.messagePostFail[_this.actualLanguage]);
        }
      });
    },
    modifyMyCreditCard: function modifyMyCreditCard() {
      this.planTransactionData.organizationId = this.organizationData.organizationId;
      this.planTransactionData.postAction = 'ModifyOrganizationCreditCard';
      this.planTransactionData.buttonPay = { FR: "Modifier ma carte de crédit", EN: 'Modify my credit card' };
    },
    applyCreditCard: function applyCreditCard() {
      this.planTransactionData.organizationId = this.organizationData.organizationId;
      this.planTransactionData.postAction = 'ModifyOrganizationCreditCard';
      this.planTransactionData.buttonPay = { FR: "Appliquer cette carte", EN: 'Apply this card' };
    },
    apiActivationChange: function apiActivationChange() {
      this.apiConfirmButtonDisplay = true;

      if (this.organizationData.apiManagement.apiActivationFlag) {
        window.alert(this.apiDesactivationMessage[this.actualLanguage]);
      }
    },
    apiActivationButtonSwitch: function apiActivationButtonSwitch() {
      var _this2 = this;

      var requestData = { 'postAction': 'SetApiManagement',
        'organizationId': this.organizationData.organizationId,
        'apiActivationFlag': this.organizationData.apiManagement.apiActivationFlag
      };
      this.apiConfirmButtonDisplay = false;

      this.$store.dispatch('sessionStore/postOrganization', requestData).then(function (response) {
        if (response.data.Code != 'OK') {
          window.alert(response.data.PromptMessage[_this2.actualLanguage]);
        }
      });
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.automaticRenewFlagInititalValue = this.organizationData.subscription.data.automaticRenewFlag;
    this.preAuthorizedPaymentFlagInititalValue = this.organizationData.subscription.data.preAuthorizedPaymentFlag;
  }
});

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StripePaiement',


  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue___default.a
  },

  data: function data() {
    return {
      stripe: null,
      card: null,
      processingTransaction: false,
      displayStripeElement: false,
      errorMessage: "",
      actualLanguage: "FR",
      labelComponentTop: { FR: 'Paiment par carte de crédit', EN: 'Payment with credit card' },
      PaymentSuccess: { FR: "Paiement réussi.", EN: 'Payment succeed.' },
      CloseThisWindow: { FR: "Fermez cette fenêtre avec le X.", EN: 'CLose this window with the X.' },
      Pay: { FR: "Payer", EN: 'Pay' },

      transactionMessage: "",
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCVCElement: null,
      stripeValidationError: null

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData'])),

  methods: {
    loadStripe: function loadStripe() {
      this.displayFlag = false;
    },
    createAndMountFormElements: function createAndMountFormElements() {
      var elements = this.stripe.elements();
      var card = undefined;

      var style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '20px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };
    },
    setValidationError: function setValidationError(event) {
      this.stripeValidationError = event.error ? event.error.message : "";
    },
    purchase: function purchase() {

      var stripeResponse = null;
      var stripeTokenValue = 'None';
      this.processingTransaction = true;

      stripeResponse = this.stripe.createToken(this.card).then(function (result) {
        if (result.error) {
          this.stripeValidationError = result.error.message;
        } else {
          return result.token.id;
        }
      });

      stripeResponse.then(function (value, stripeTokenValue) {
        var _this = this;

        stripeTokenValue = value;

        this.planTransactionData.cardToken = stripeTokenValue;

        this.$store.dispatch('sessionStore/processSubscription', this.planTransactionData).then(function (response) {
          _this.processingTransaction = false;
          if (response.data.Code == 'OK') {
            _this.planTransactionData.transactionStatusCode = '999';


            _this.$store.dispatch('sessionStore/refreshProfileData');
          } else {
            _this.transactionMessage = "Transaction abordée, ré-essayer. / Transaction aborded, try again.";
          }
        });
      }.bind(this));
    }
  },

  beforemount: function beforemount() {
    var elements = this.stripe.elements();
    var card = undefined;

    var style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '18px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };
  },
  mounted: function mounted() {

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(271);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['organizationData'],

  components: {},

  data: function data() {
    return {

      actualLanguage: "FR",
      labelFreeService: { FR: 'Service gratuit', EN: 'Free service' },
      automaticRenewFlagInititalValue: false,
      renewFlagModified: false,

      textLabelProduct: { FR: "Produit", EN: 'Product' },
      textLabelLastPaimentDate: { FR: "Date du précédent prélèvement : ", EN: 'Previous payment date:' },
      textLabelNextPaimentDate: { FR: "Date du prochain prélèvement : ", EN: 'Next payment date:' },
      messagePostFail: { FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation' },

      sectionLabelTransactions: { FR: "Historique de paiement", EN: 'Payment history' },
      flagDisplaySectionTransactions: 0,
      transactions: [],
      transactionOpenFlag: [],

      InvoiceText: { FR: "Facture: ", EN: 'Invoice: ' },
      InvoiceTitle: { FR: "Plan de service EV Sens", EN: 'EV Sens service plan' },
      InvoiceCustomer: { FR: "CLIENT: ", EN: 'CUSTOMER: ' },
      InvoicePaidBy: { FR: "PAYÉ AVEC: ", EN: 'PAID BY: ' },
      InvoiceQuantity: { FR: "Quantité", EN: 'Quantity' },
      InvoiceUnitPrice: { FR: "Prix unitaire", EN: 'Unit price' },
      InvoicePrice: { FR: "Prix", EN: 'Price' },
      InvoiceSubTotal: { FR: "Sous total", EN: 'Sub total' },
      CardInfoPaidBy: { FR: "Payé par:", EN: 'Paid by:' },
      CardInfoLast4: { FR: "Finissant par:", EN: 'Last digits:' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    toggleDisplayTransactions: function toggleDisplayTransactions() {
      this.flagDisplaySectionTransactions = ~this.flagDisplaySectionTransactions;
    },
    toggleDisplayTransaction: function toggleDisplayTransaction(index) {
      this.flagDisplaySectionTransactions = 0;
      this.transactionOpenFlag[index] = ~this.transactionOpenFlag[index];
      this.flagDisplaySectionTransactions = -1;
    },
    automaticRenewButtonSwitch: function automaticRenewButtonSwitch() {
      if (this.organizationData.subscription.data.automaticRenewFlag == this.automaticRenewFlagInititalValue) {
        this.renewFlagModified = true;
      } else {
        this.renewFlagModified = false;
      }
    },
    getTransactionHistory: function getTransactionHistory() {
      var _this = this;

      var requestData = { 'postAction': 'ReadProfileTransactionHistory' };

      this.$store.dispatch('sessionStore/postProfile', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.transactions = response.data.TransactionHistory;
          _this.transactionOpenFlag = [];
          for (var m = 0; m < _this.transactions.length; m++) {
            _this.transactionOpenFlag.push(0);
            if (parseFloat(_this.transactions[m].subTotal) < 0) {
              _this.transactions[m].subTotal = "0";
            }
            if (parseFloat(_this.transactions[m].tps) < 0) {
              _this.transactions[m].tps = "0";
            }
            if (parseFloat(_this.transactions[m].tvq) < 0) {
              _this.transactions[m].tvq = "0";
            }
            if (parseFloat(_this.transactions[m].total) < 0) {
              _this.transactions[m].total = "0";
            }

            for (var n = 0; n < _this.transactions[m].taxesList.length; n++) {
              if (parseFloat(_this.transactions[m].taxesList[n].Amount) < 0) {
                _this.transactions[m].taxesList[n].Amount = "0";
              }
            }
          }
        } else {
          console.log(response);
          window.alert(response.data.PromptMessage[_this.actualLanguage]);
        }
      });
    },
    generatePdfInvoice: function generatePdfInvoice(index) {

      var columns = [{ title: "Title", dataKey: "title" }, { title: "Body", dataKey: "body" }];
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf__["a" /* default */]({
        orientation: "portrait",
        unit: "in",
        format: "letter"
      });

      doc.setFontSize(10).text(this.InvoiceText[this.actualLanguage] + this.transactions[index].subscription + ':' + this.transactions[index].timestamp, 0.5, 1.0);
      doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1);
      doc.setFontSize(14).text('EV Sens inc.', 8, 1.3, { align: "right" });
      doc.setFontSize(10).text('65 rue de la Fenière', 8, 1.5, { align: "right" });
      doc.setFontSize(10).text("L'Ancienne-Lorette, QC", 8, 1.7, { align: "right" });
      doc.setFontSize(10).text("CANADA, G2E 1X8", 8, 1.9, { align: "right" });
      doc.setFontSize(10).text("support@evsens.ca", 8, 2.1, { align: "right" });

      doc.setLineWidth(0.01).line(0.5, 2.2, 8.0, 2.2);
      doc.setFontSize(16).text(this.InvoiceTitle[this.actualLanguage], 4.25, 2.5, { align: "center", maxWidth: "7.5" });
      doc.setLineWidth(0.01).line(0.5, 2.7, 8.0, 2.7);

      doc.setFontSize(12).text(this.InvoiceCustomer[this.actualLanguage], 0.5, 3, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(12).text(this.profileData.profileInfo.firstName + " " + this.profileData.profileInfo.lastName, 0.5, 3.2, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(12).text(this.profileData.profileInfo.email, 0.5, 3.4, { align: "left", maxWidth: "7.5" });

      doc.setFontSize(10).text("Quantity", 0.5, 4.2, { align: "left", maxWidth: "7.5" });
      doc.setFontSize(10).text("Description", 1.5, 4.2, { align: "left", maxWidth: "3" });
      doc.setFontSize(10).text("Unit Price ($)", 6.5, 4.2, { align: "right", maxWidth: "7.5" });
      doc.setFontSize(10).text("Cost ($)", 7.5, 4.2, { align: "right", maxWidth: "7.5" });
      doc.setLineWidth(0.01).line(0.5, 4.3, 8.0, 4.3);

      var y_pos = 0;
      var lineCost = 0;
      for (var n = 0; n < this.transactions[index].detailLines.length; n++) {
        y_pos = 4.5 + n * 0.2;
        lineCost = this.transactions[index].detailLines[n].unitPrice * this.transactions[index].detailLines[n].quantity;
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].quantity, 0.5, y_pos, { align: "left", maxWidth: "7.5" });
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].description[this.actualLanguage], 1.5, y_pos, { align: "left", maxWidth: "3" });
        doc.setFontSize(10).text(this.transactions[index].detailLines[n].unitPrice, 6.5, y_pos, { align: "right", maxWidth: "7.5" });
        doc.setFontSize(10).text(lineCost.toString(), 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }
      y_pos = y_pos + 0.2;
      doc.setLineWidth(0.01).line(0.5, y_pos, 8.0, y_pos);
      y_pos = y_pos + 0.2;
      doc.setFontSize(10).text('Sub Total', 6.5, y_pos, { align: "right", maxWidth: "2" });
      doc.setFontSize(10).text(this.transactions[index].subTotal, 7.5, y_pos, { align: "right", maxWidth: "7.5" });

      if (this.transactions[index].tps > 0) {
        y_pos = y_pos + 0.2;
        doc.setFontSize(10).text('TPS (5%)', 6.5, y_pos, { align: "right", maxWidth: "2" });
        doc.setFontSize(10).text(this.transactions[index].tps, 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }

      if (this.transactions[index].tvq > 0) {
        y_pos = y_pos + 0.2;
        doc.setFontSize(10).text('TVQ (9.975%)', 6.5, y_pos, { align: "right", maxWidth: "2" });
        doc.setFontSize(10).text(this.transactions[index].tvq, 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }

      for (var m = 0; m < this.transactions[index].taxesList.length; m++) {
        y_pos = y_pos + 0.2;
        doc.setFontSize(10).text(this.transactions[index].taxesList[m].Label[this.actualLanguage], 6.5, y_pos, { align: "right", maxWidth: "4" });
        doc.setFontSize(10).text(this.transactions[index].taxesList[m].Amount, 7.5, y_pos, { align: "right", maxWidth: "7.5" });
      }

      y_pos = y_pos + 0.3;
      doc.setFontSize(12).text('TOTAL', 6.5, y_pos, { align: "right", maxWidth: "2" });
      doc.setFontSize(12).text(this.transactions[index].total, 7.5, y_pos, { align: "right", maxWidth: "7.5" });

      y_pos = y_pos + 1;
      doc.setFontSize(12).text(this.InvoicePaidBy[this.actualLanguage], 0.5, y_pos, { align: "left", maxWidth: "2" });
      y_pos = y_pos + 0.2;
      doc.setLineWidth(0.01).line(0.5, y_pos, 8.0, y_pos);
      y_pos = y_pos + 0.2;
      doc.setFontSize(10).text(this.transactions[index].cardData.CardType, 0.5, y_pos, { align: "left", maxWidth: "7.5" });
      y_pos = y_pos + 0.2;
      doc.setFontSize(10).text(this.CardInfoLast4[this.actualLanguage] + this.transactions[index].cardData.CardLast4, 0.5, y_pos, { align: "left", maxWidth: "7.5" });

      doc.setLineWidth(0.01).line(0.5, 10, 8.0, 10);

      doc.save('Invoice_' + (this.transactions[index].timestamp + '.pdf'));
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
    this.getTransactionHistory();
  }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_profile_UserPlanDescriptions_js__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StripePaiment__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StripePaiment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StripePaiment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['portData'],

  components: {
    StripePaiement: __WEBPACK_IMPORTED_MODULE_4__StripePaiment___default.a
  },

  data: function data() {
    return {
      displayDataTable: false,
      monthYearPaymentToggle: true,
      displayYearToggleSelect: true,

      displaySelectedPlanFlag: false,
      acceptConditionFlag: false,
      flagShowPlanList: false,

      countryStateTaxRates: [],
      actualTaxes01: [],
      actualTaxes02: [],
      selectMyCountry: { FR: 'Pays:', EN: 'Country' },
      selectMyState: { FR: 'Province:', EN: 'State' },
      actualCountryIndex: -1,
      actualCountryName: 'ND',
      actualStateNames: { EN: 'ND', FR: 'ND' },
      actualStateIndex: -1,

      actualLanguage: "FR",
      labelTableTop: { FR: 'Afficher le tableau des données', EN: 'Display data table' },
      subscriptionOptionDescription01: { FR: "Les abonnements vous permettent d'accéder aux services suivants:",
        EN: 'Subscriptions allow you to access the following services:' },

      subscriptionOptionDescription02: { FR: "Plus longue durée d'historique de données disponible.",
        EN: 'Longest data history available.' },
      subscriptionOptionDescription03: { FR: "Service de surveillance (alertes liées aux appareils mesurés).",
        EN: 'Monitoring service (alerts related to measured devices).' },
      subscriptionOptionDescription04: { FR: "Enregistrement de l'historique de données météorologique.",
        EN: 'Record weather data history.' },
      subscriptionOptionDescription05: { FR: "Prolongement de votre garantie de matériel.",
        EN: 'Extending Your Hardware Warranty.' },
      subscriptionOptionDescription06: { FR: "Capacité d'enregistrer plus de module de mesure a votre profil.",
        EN: 'The ability to record more measuring modules to your profile.' },
      subscriptionOptionDescription07: { FR: "Possibilité de créer plus d'appareils mesurés dans votre profil.",
        EN: 'The possibility to create more measured devices in your profile' },
      labelPaymentToggle: { FR: "Abonnements disponibles:", EN: 'Subscription available:' },

      labelPaymentToggleYear: { FR: 'Facturé annuellement', EN: 'Annually billed' },
      labelPaymentToggleMonth: { FR: 'Facturé mensuellement', EN: 'Monthly billed' },
      labelPriceMonthly: { FR: 'Par mois', EN: 'per month' },
      labelPriceYearly: { FR: 'Par année', EN: 'Per year' },

      titlePlanTable: { FR: { false: 'Facturé mensuellement', true: 'Facturé annuellement' }, EN: { false: 'Monthly billed', true: 'Annually billed' } },

      labelBtnSignUpFree: { FR: "Gratuit", EN: 'Free' },
      labelBtnSignUp: { FR: "S'inscrire", EN: 'Sign up' },
      contactEVSensForSubscribe: { FR: "Pour vous abonnez à ce forfait, contactez support@evsens.ca pour recevoir un code de plan pré-enregistré.",
        EN: 'To subscribe to this plan, contact support@evsens.ca to receive a pre-registered plan code.' },

      alertSubscriptionLimitation01: { FR: 'Votre abonnement ne peut pas être remboursé automatiquement, contactez support@evsens.ca', EN: 'Your subscription cannot be refund automatically, contact support@evsens.ca' },

      optionSelectLabel: { FR: "Ajouter cette option", EN: 'Add this option' },

      planDescription: __WEBPACK_IMPORTED_MODULE_3__views_profile_UserPlanDescriptions_js__["a" /* default */],

      SelectPlanText01: { FR: 'Plan sélectionné :', EN: 'Selected plan :' },
      SelectPlanText02: { FR: 'Paiement annuel de :', EN: 'Yearly payment of :' },
      SelectPlanText03: { FR: 'Paiement mensuel de :', EN: 'Monthly payment of :' },
      SelectPlanText04: { FR: 'Un rabais de :', EN: 'Credit of :' },
      SelectPlanText05: { FR: '$ sera appliqué à votre premier paiement due au crédit de votre plan actuel.', EN: '$ will be applied on your first payment for your precedent subscription' },
      SelectPlanText06: { FR: 'Renouvellement automatique', EN: 'Automatic renewal' },
      SelectPlanText07: { FR: 'Activé', EN: 'Activated' },
      SelectPlanText08: { FR: 'Désactivé', EN: 'Unactivated' },

      SelectPlanText09A: { FR: "Ceci vous permet de fixer le prix de votre forfait d'abonnement.", EN: 'This allows you to set the price of your subscription package.' },
      SelectPlanText09B: { FR: "Il vous est possible de vous désinscrire du renouvellement automatique en tout temps.", EN: 'You can unsubscribe from automatic renewal at any time.' },
      SelectPlanText09C: { FR: 'En date du renouvellement, votre carte de crédit sera débitée automatiquement.', EN: 'On the renewal date, your credit card will be charged automatically.' },
      SelectPlanText09D: { FR: "Notez que si la date d'expiration de votre carte est antérieur à la date de renouvellement du plan,", EN: 'Please note that if your card expires before the plan renewal date,' },
      SelectPlanText09E: { FR: "un courriel vous sera transmit pour vous aviser d'enregistrer vos nouvelles données de carte de crédit.", EN: 'an email will be sent to you advising that you need to save new credit card in your profile.' },

      SelectPlanText10A: { FR: "Avant la fin de votre période d'abonnement, vous devez soit sélectionner l'option Renouvellement Automatique pour prolonger votre service ou vous abonner à un plan disponible en cette date*.", EN: 'Before the end of your subscription period, you must either select the Automatic Renewal option to extend your service or subscribe to a plan available on this date *.' },
      SelectPlanText10B: { FR: "Trois jours avant la fin de votre plan, un avis par courriel vous sera transmit.", EN: 'Three days before the end of your plan, an email notification will be sent to you.' },
      SelectPlanText10C: { FR: "Si aucune action n'est prise, vos accèes seront automatiquement mis au service de base à la date de fin de votre abonnement.", EN: 'If no action is taken, your access will automatically be put to the basic service on the end date of your subscription.' },
      SelectPlanText10D: { FR: "*La disponibilité des plans peut varier, un renouvellement automatique permet de préserver les option et le prix d'un plan.", EN: '* The availability of the plans can vary, an automatic renewal preserve the options and the price of your plan.' },

      SelectPlanText11: { FR: "Politique d'achat de plan eV Sens", EN: 'EV Sens plan purchase policy' },

      politiqueAchatPlan: { FR: "Dans le cas d'un abonnement facturé annuellement, ceci donne accès aux services du plan choisi pour une durée de 1 ans. Le client bénéficie d'une période d'essaie de 1 mois dans laquelle il peut demander un désabonnement qui sera remboursé au montant de l'achat.  Suite à cette période d'essaie, l'achat du plan ne sera plus remboursable. Si le client désire faire une majoration de son plan de service au cours de la durée de validité de son achat, un crédit sera calculé selon la balance de durée accessible de son plan moins les frais de transaction et d'administration applicable. Si le client active l'option de renouvellement automatique, le plan annuel sera renouveler et facturer automatique à la fin de la précédente période. L'option de renouvellement automatique permet de fixer le prix du plan sans quoi si le client n'active pas le renouvellement automatique avant la fin de la période, le plan de service du client sera remis avec les options du plan de base en date du renouvellement. Le client devra par la suite se ré-abonner selon les plans disponibles en date de ré-inscription. Dans le cas d'une annulation avant échéance, le service sera maintenu jusqu'à expiration de l'engagement. Une fois l'annulation effective le client sera retourné au plan de base gratuit. ",
        EN: "In the case of a subscription billed annually, this gives access to the services of the plan chosen for a period of 1 year. The customer benefits from a trial period of 1 month in which he can request an unsubscription which will be reimbursed at the amount of the purchase minus the price of the same plan billed monthly. Following this trial period, the purchase of the plan will no longer be refundable. If the customer wishes to make an increase in his service plan during the period of validity of his purchase, a credit will be calculated according to the available duration balance of his plan less the applicable transaction and administration fees. If the customer activates the automatic renewal option, the annual plan will be renewed and billed automatically at the end of the previous period. The automatic renewal option allows you to set the price of the plan, otherwise if the client does not activate the automatic renewal before the end of the period, the client's service plan will be delivered with the options of the basic plan as of renewal. The client must then re-subscribe according to the plans available on the re-registration date. In the case of a cancellation before maturity, the service will be maintained until the expiration of the engagement. Once the cancellation is effective, the customer will be returned to the free basic plan." },

      SelectPlanText12: { FR: "J'accepte les termes et conditions", EN: 'I agree the terms and conditions' },

      validateLocalisation: { FR: 'Validez votre localisation:', EN: 'Validate your location:' },

      ButtonCancelSelection: { FR: "Annuler la sélection", EN: 'Cancel selection' },
      ButtonProceedOrder: { FR: "Procéder à l'achat", EN: 'Proceed to order' },
      ButtonProceedPayment: { FR: "Procéder à l'achat", EN: 'Proceed to payment' },

      InvoiceHeaderFirst: { FR: "Détail de votre premier versement", EN: 'First payment detail' },
      InvoiceHeader: { FR: "Détail de vos versements", EN: 'Payment detail' },
      InvoiceHeaderNext: { FR: "Détail de vos versements par la suite", EN: 'Next payment detail' },
      InvoiceSubscriptionCredit: { FR: "Crédit d'abonnement", EN: 'Subscription credit' },
      InvoiceQuantity: { FR: "Quantité", EN: 'Quantity' },
      InvoiceUnitPrice: { FR: "Prix unitaire", EN: 'Unit price' },
      InvoicePrice: { FR: "Prix", EN: 'Price' },
      InvoiceEVSensServicePlan: { FR: "Plan de service EV Sens", EN: 'EV Sens service plan' },
      InvoiceSubTotal: { FR: "Sous total", EN: 'Sub total' },

      sousTotal1: 0.00,
      total1: 0.00,
      sousTotal2: 0.00,
      total2: 0.00
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['planTransactionData', 'profileData'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    selectPlan: function selectPlan(planIndex) {
      this.displayYearToggleSelect = false;
      this.planTransactionData.planCode = this.planDescription[planIndex]['PlanTemplate'];
      this.planTransactionData.planName = this.planDescription[planIndex]['Title'][this.actualLanguage];
      this.planTransactionData.options = this.planDescription[planIndex]['options'];
      if (this.monthYearPaymentToggle == true) {
        this.planTransactionData.yearSinglePaymentFlag = true;
        this.planTransactionData.renewalPrice = this.planDescription[planIndex]['PlanPricing'][this.monthYearPaymentToggle];
      } else {
        this.planTransactionData.yearSinglePaymentFlag = false;
        this.planTransactionData.renewalPrice = this.planDescription[planIndex]['PlanPricing'][this.monthYearPaymentToggle];
      }

      this.sousTotal1 = parseFloat(this.planTransactionData.renewalPrice);
      for (var m = 0; m < this.planTransactionData.options.length; m++) {
        if (this.planTransactionData.options[m].flagOptionEnabled) {
          this.sousTotal1 += parseFloat(this.planTransactionData.options[m].unitPrice) * parseFloat(this.planTransactionData.options[m].quantity);
        }
      }
      this.total1 = Math.round(this.sousTotal1 * 100) / 100;

      var ActualDate = moment().format('YYYY-MM-DD');
      var ActualTimestamp = Date.parse(ActualDate) / 1000;
      var renewalDate = this.profileData.profile_subscription.data.renewalDate.slice(0, 10);
      var renewalTimestamp = Date.parse(renewalDate) / 1000;
      var subscriptionBalanceDays = (renewalTimestamp - ActualTimestamp) / 86400;
      var subscriptionBalancePercent = 0;

      if (this.profileData.profile_subscription.data.renewalDelay == "Year") {
        subscriptionBalancePercent = subscriptionBalanceDays / 365;
      } else {
        subscriptionBalancePercent = subscriptionBalanceDays / 30;
      }
      var subscriptionBalance = parseInt(subscriptionBalancePercent * this.profileData.profile_subscription.data.renewalPrice - 150);
      var value2 = subscriptionBalance / 100;
      this.planTransactionData.firstPaymentRebate = '0.0';
      if (subscriptionBalance > 0) {
        this.planTransactionData.firstPaymentRebate = value2.toFixed(2);
      }

      var continuePurchaseFlag = true;

      if (this.profileData.profile_subscription.data.renewalDelay == "Month") {
        if (this.planTransactionData.firstPaymentRebate > this.planTransactionData.renewalPrice + 1.5) {
          window.alert("Crédit de votre abonnement mensuel précédent n'est pas acessible, si vous pousuivez, vous perdrez vos droits liés à votre abonnement actuel. Il est suggéré d'attendre la fin de votre abonnement actuel avant de diminuer le plan choisi.");
          this.planTransactionData.firstPaymentRebate = '0.0';
        }
      }

      if (this.profileData.profile_subscription.data.renewalDelay == "Year") {
        if (subscriptionBalanceDays < 335 && this.planTransactionData.firstPaymentRebate > parseFloat(this.planTransactionData.renewalPrice) + 1.5) {
          window.alert("Crédit de votre abonnement annuel précédent n'est pas acessible puisque la période d'essaie de 30 jours est dépassée, si vous pousuivez, vous perdrez vos droits liés à votre abonnement actuel sans remboursement. Il est suggéré d'attendre quelques-temps avant d'effectuer une transaction de réduction de plan.");
          this.planTransactionData.firstPaymentRebate = '0.0';
        }

        if (subscriptionBalanceDays >= 335 && this.planTransactionData.firstPaymentRebate > parseFloat(this.planTransactionData.renewalPrice) + 1.5) {
          window.alert("Communiquez avec eV Sens pour le remboursement de votre abonnement annuel actuel");
          this.planTransactionData.firstPaymentRebate = '0.0';
        }
      }

      if (continuePurchaseFlag) {
        this.planTransactionData.postAction = 'NewSubscription';
        this.planTransactionData.transactionStatusCode = '060';
        this.displaySelectedPlanFlag = true;
        this.acceptConditionFlag = false;
        window.scrollTo(0, 0);
      }
    },
    cancelSelection: function cancelSelection() {
      this.displayYearToggleSelect = true;
      this.displaySelectedPlanFlag = false;
      this.planTransactionData.transactionStatusCode = '050';
      window.scrollTo(0, 0);
    },
    confirmOrder: function confirmOrder() {

      this.sousTotal1 = Math.round((parseFloat(this.planTransactionData.renewalPrice) - parseFloat(this.planTransactionData.firstPaymentRebate)) * 100) / 100;

      for (var m = 0; m < this.planTransactionData.options.length; m++) {
        if (this.planTransactionData.options[m].flagOptionEnabled) {
          this.sousTotal1 += parseFloat(this.planTransactionData.options[m].unitPrice) * parseFloat(this.planTransactionData.options[m].quantity);
        }
      }

      var SumTax = 0;
      var SumSubTotal = this.sousTotal1;
      for (var n = 0; n < this.actualTaxes01.length; n++) {
        this.actualTaxes01[n].Amount = (Math.round(SumSubTotal * parseFloat(this.actualTaxes01[n].Rate) * 100) / 100).toString();

        if (this.actualTaxes01[n].CumulativeSubtotal) {
          SumSubTotal += parseFloat(this.actualTaxes01[n].Amount);
        }
        SumTax += parseFloat(this.actualTaxes01[n].Amount);
      }
      this.total1 = Math.round((this.sousTotal1 + SumTax) * 100) / 100;

      this.sousTotal2 = Math.round(parseFloat(this.planTransactionData.renewalPrice) * 100) / 100;
      SumTax = 0;
      SumSubTotal = this.sousTotal2;
      for (var n = 0; n < this.actualTaxes01.length; n++) {
        this.actualTaxes02[n].Amount = (Math.round(SumSubTotal * parseFloat(this.actualTaxes02[n].Rate) * 100) / 100).toString();

        if (this.actualTaxes02[n].CumulativeSubtotal) {
          SumSubTotal += parseFloat(this.actualTaxes02[n].Amount);
        }
        SumTax += parseFloat(this.actualTaxes02[n].Amount);
      }
      this.total2 = Math.round((this.sousTotal2 + SumTax) * 100) / 100;

      this.planTransactionData.transactionStatusCode = '100';
      window.scrollTo(0, 0);
    },
    getUserPlanList: function getUserPlanList() {
      var _this = this;

      var requestData = { 'postAction': 'GetUserPlanList',
        'subscriptionListId': "EndUserPlanList_V02P04"
      };

      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this.planDescription = response.data.PlanList;
          _this.flagShowPlanList = true;
        }
      });
    },
    getCountryStateTaxList: function getCountryStateTaxList() {
      var _this2 = this;

      var requestData = { 'postAction': 'GetCountryTaxRates'
      };

      this.$store.dispatch('sessionStore/processSubscription', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this2.countryStateTaxRates = response.data.CountryList;

          for (var n = 0; n < _this2.countryStateTaxRates.length; n++) {
            if (_this2.countryStateTaxRates[n].Country == 'Canada') {
              for (var m = 0; m < _this2.countryStateTaxRates[n].StateTaxData.StateList.length; m++) {
                if (_this2.countryStateTaxRates[n].StateTaxData.StateList[m].Name.EN == 'Quebec') {
                  _this2.actualCountryName = _this2.countryStateTaxRates[n].Country;
                  _this2.actualStateNames = _this2.countryStateTaxRates[n].StateTaxData.StateList[m].Name;
                  _this2.actualTaxes01 = structuredClone(_this2.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes);
                  _this2.actualTaxes02 = structuredClone(_this2.countryStateTaxRates[n].StateTaxData.StateList[m].Taxes);
                }
              }
            }
          }
        }
      });
    },
    selectActualCountry: function selectActualCountry() {
      this.actualStateIndex = -1;
      this.planTransactionData.taxRateData = { 'countrySortKey': 'Canada',
        'stateNames': { FR: 'Québec', EN: 'Quebec' } };
    },
    selectActualState: function selectActualState() {
      if (this.actualCountryIndex >= 0 & this.actualStateIndex >= 0) {
        this.actualCountryName = this.countryStateTaxRates[this.actualCountryIndex].Country;
        this.actualStateNames = this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Name;
        this.actualTaxes01 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes);
        this.actualTaxes02 = structuredClone(this.countryStateTaxRates[this.actualCountryIndex].StateTaxData.StateList[this.actualStateIndex].Taxes);

        this.planTransactionData.taxRateData = { 'countrySortKey': this.actualCountryName,
          'stateNames': this.actualStateNames };
      }
    }
  }),

  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
    this.planTransactionData.taxRateData = { 'countrySortKey': 'Canada',
      'stateNames': { FR: 'Québec', EN: 'Quebec' } };

    this.getUserPlanList();
    this.getCountryStateTaxList();
  }
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  name: "ForgotPW",
  data: function data() {
    return {
      email: '',
      isWorking: false,
      errorMsg: '',
      notif: '',

      displayCodeInput: false,
      confirmationCode: '',
      newPassWord: '',

      labelFieldTitle: { FR: 'Mot de passe oublié', EN: 'Forgot password' },
      actualLanguage: "FR",
      labelFieldButtonLanguage: { FR: 'English version', EN: 'Version française' },
      labelFieldEmail: { FR: 'Adresse courriel', EN: 'Email' },
      labelFieldTextFirstTime: { FR: "C'est votre première fois ?", EN: 'This is your first time ?' },
      labelFieldButtonSubscribe: { FR: 'Inscription', EN: 'Subscribe' },
      labelFieldButtonForgotPW: { FR: 'Mot de passe oublié?', EN: 'Forgot password?' },
      labelFieldButtonSendCode: { FR: 'Envoyer le code de confirmation', EN: 'Send confirmation code' },
      labelFieldGoHome: { FR: 'Revenir à la page d\'accueil', EN: 'Go back to home page' },

      labelFieldConfirmationCode: { FR: 'Code de confirmation', EN: 'Confirmation code' },
      emailSentMessage: { FR: "Un code de confirmation de compte a été envoyé à l'adresse courriel, introduisez le code reçu. (Consultez votre dossier de courrier indésirable si le courrier n'apparaît pas dans votre boîte de réception)",
        EN: "An account confirmation code has been sent to the email address, please enter the receved code. (Check your spam folder if the email doesn't appear in your inbox.)" },

      passwordConditionMessage: { FR: "Introduisez votre nouveau mot de passe (doit contenir un minimum de 8 caractères).",
        EN: 'Enter your new password (must contain a minimum of 8 characters).' },
      labelNewPW: { FR: 'Nouveau mot de passe', EN: 'New password' },
      labelBtnApplyNewPW: { FR: 'Enregistrer le nouveau mot de passe', EN: 'Apply new password' }

    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('sessionStore', ['userEmail'])),

  mounted: function mounted() {
    this.isWorking = false;
    if (this.$router.currentRoute.params.notif) {
      this.notif = this.$router.currentRoute.params.notif;
    }

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },


  methods: {
    forgotPassword: function forgotPassword() {
      var _this = this;

      this.isWorking = true;
      this.$store.dispatch('sessionStore/forgotPassword', { email: this.email, language: this.actualLanguage }).then(function () {
        _this.$router.push({ name: "login" });
      }).catch(function (e) {
        _this.errorMsg = e.message;
        _this.isWorking = false;
      });
    },
    forgotPasswordStep01: function forgotPasswordStep01() {
      var _this2 = this;

      this.isWorking = true;
      this.$store.dispatch('sessionStore/forgotPasswordStep01', { email: this.email, language: this.actualLanguage }).then(function () {
        _this2.displayCodeInput = true;
        _this2.isWorking = false;
        _this2.errorMsg = "";

        _this2.labelFieldButtonSendCode.FR = 'Envoyer un nouveau code de confirmation';
        _this2.labelFieldButtonSendCode.EN = 'Send new confirmation code';
      }).catch(function (e) {
        _this2.errorMsg = e.message;
        _this2.isWorking = false;
      });
    },
    forgotPasswordStep02: function forgotPasswordStep02() {
      var _this3 = this;

      this.isWorking = true;
      this.$store.dispatch('sessionStore/forgotPasswordStep02', { email: this.email, language: this.actualLanguage, verificationCode: this.confirmationCode, newPassword: this.newPassWord }).then(function () {
        _this3.$router.push({ name: "login" });
      }).catch(function (e) {
        _this3.errorMsg = e.message;
        _this3.isWorking = false;
      });
    },
    toggleLanguage: function toggleLanguage() {
      if (this.actualLanguage == 'FR') {
        this.actualLanguage = 'EN';
        localStorage.language = 'EN';
      } else {
        this.actualLanguage = 'FR';
        localStorage.language = 'FR';
      }
      location.reload();
    }
  }
});

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
  },
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: '',
      isWorking: false,
      errorMsg: '',
      notif: '',
      name: '',
      lastName: '',

      actualLanguage: "FR",
      labelFieldTitle: { FR: 'Connectez-vous', EN: 'Login' },
      labelFieldButtonLanguage: { FR: 'English version', EN: 'Version française' },
      labelFieldEmail: { FR: 'Adresse courriel', EN: 'Email' },
      labelFieldPW: { FR: 'Mot de passe', EN: 'Password' },
      labelFieldButtonConnect: { FR: 'Connexion', EN: 'Connect' },
      labelFieldTextFirstTime: { FR: "C'est votre première fois ?", EN: 'This is your first time ?' },
      labelFieldButtonSubscribe: { FR: 'Inscription', EN: 'Subscribe' },
      labelFieldButtonForgotPW: { FR: 'Mot de passe oublié?', EN: 'Forgot password?' }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['userEmail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['userName']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['userLastName'])),

  mounted: function mounted() {
    this.email = this.userEmail;
    this.name = this.userName;
    this.lastName = this.userLastName;

    this.isWorking = false;
    if (this.$router.currentRoute.params.notif) {
      this.notif = this.$router.currentRoute.params.notif;
    }

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },


  methods: {
    signIn: function signIn() {
      var _this = this;

      this.isWorking = true;
      this.$store.dispatch('sessionStore/signIn', {
        email: this.email,
        password: this.password,
        name: this.name,
        lastName: this.lastName,
        language: this.actualLanguage
      }).then(function () {
        _this.$store.dispatch('sessionStore/refreshProfileData').then(function (response) {
          _this.$router.push({ name: 'measurements' });
        });
      }).catch(function (e) {
        _this.errorMsg = e.message;
        _this.isWorking = false;
      });
    },
    toggleLanguage: function toggleLanguage() {
      if (this.actualLanguage == 'FR') {
        this.actualLanguage = 'EN';
        localStorage.language = 'EN';
      } else {
        this.actualLanguage = 'FR';
        localStorage.language = 'FR';
      }
      location.reload();
    }
  }
});

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Verify__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Verify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Verify__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    VerifyForm: __WEBPACK_IMPORTED_MODULE_2__Verify___default.a
  },
  name: 'login',
  data: function data() {
    return {
      userInfos: {
        name: '',
        lastName: '',
        email: '',
        password: '',
        repassword: '',
        verifyCode: ''
      },
      isRegistering: false,
      registerSuccess: false,
      errorMsg: '',

      actualLanguage: "FR",
      labelFieldTitle: { FR: 'Inscription', EN: 'Subscribe' },
      labelFieldName: { FR: 'Nom', EN: 'Last name' },
      labelFieldFirstName: { FR: 'Prénom', EN: 'First name' },
      labelFieldEmail: { FR: 'Adresse courriel', EN: 'Email' },
      labelFieldPW: { FR: 'Mot de passe', EN: 'Password' },
      labelFieldConfirmPW: { FR: 'Confirmation du mot de passe', EN: 'Confirm password' },
      labelFieldButtonSubscribe: { FR: "S'inscrire", EN: 'Subscribe' },
      labelFieldAlready: { FR: "Vous avez déjà un compte ?", EN: 'You already have an account ?' },
      labelFieldButtonLogIn: { FR: "Se connecter", EN: 'Log in' },
      labelFieldButtonLanguage: { FR: 'English version', EN: 'Version française' }
    };
  },
  mounted: function mounted() {
    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },


  methods: {
    register: function register() {
      var _this = this;

      this.isRegistering = true;
      this.$store.dispatch('sessionStore/register', this.userInfos).then(function (user) {
        _this.isRegistering = false;
        _this.$router.push({ name: "verify" });
      }).catch(function (e) {
        _this.errorMsg = e.message;
        _this.isRegistering = false;
      });
    },
    toggleLanguage: function toggleLanguage() {
      if (this.actualLanguage == 'FR') {
        this.actualLanguage = 'EN';
        localStorage.language = 'EN';
      } else {
        this.actualLanguage = 'FR';
        localStorage.language = 'FR';
      }
      location.reload();
    }
  }
});

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
  },
  name: 'verify',
  data: function data() {
    return {
      userInfos: {
        verifyCode: '',
        email: '',
        name: '',
        language: ''
      },
      isVerifying: false,
      errorMsg: '',

      actualLanguage: "FR",
      labelFieldTitle: { FR: 'Vérification', EN: 'Verification' },
      labelFieldMessage: { FR: "Votre compte à été créé mais est inactif. Pour l'activer, veuillez saisir le code que nous vous avons envoyé par courriel dans le champ suivant:", EN: 'To confirm your account, verify your email and copy the confirmation code in the corresponding field and press "Verify"' },
      labelFieldEmail: { FR: 'Courriel', EN: 'Email' },
      labelFieldConfirmationCode: { FR: 'Code de vérification', EN: 'Confirmation code' },
      labelFieldButtonVerify: { FR: 'Vérifier', EN: 'Verify' },
      labelFieldAlready: { FR: "Vous avez déjà un compte ?", EN: 'You already have an account ?' },
      labelFieldButtonLogIn: { FR: "Se connecter", EN: 'Log in' },
      firstConnectMessage: { FR: 'Vous pouvez maintenant vous connecter.', EN: 'You can login now.' }

    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['userEmail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['userName']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('sessionStore', ['userLastName'])),
  mounted: function mounted() {
    this.userInfos.email = this.userEmail;
    this.userInfos.name = this.userName;
    this.userInfos.lastName = this.userLastName;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }

    this.userInfos.language = this.actualLanguage;
  },

  methods: {
    submitVerification: function submitVerification() {
      var _this = this;

      this.isVerifying = true;
      this.$store.dispatch('sessionStore/verify', this.userInfos).then(function (user) {
        _this.isVerifying = false;

        _this.$router.push({ name: 'login', params: { notif: _this.firstConnectMessage[_this.actualLanguage] } });
      }).catch(function (e) {
        _this.errorMsg = e.message;
        _this.isVerifying = false;
      });
    }
  }
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ErrorView',
  mounted: function mounted() {}
});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SharingItem__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SharingItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SharingItem__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GroupIndex',

  data: function data() {
    return {
      isOpen: true,

      loadingData: false,
      defaultGroupSelectedFlag: false,
      displayListSharingFlag: false,

      messageNoMoreSharing: { FR: "Plus de partage en attente pour l'instant. Vous devez selectionner un autre menu.", EN: 'No more sharings for now. Select other menu.' },
      messageNoMoreSharing2: { FR: "Appuyez sur le bouton Actualiser et sélectionnez l'un des menus Mesures ou Configuration.", EN: 'Press Refress button and select Measurement or Configuration menu.' },

      actualLanguage: "FR"

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    SharingItem: __WEBPACK_IMPORTED_MODULE_4__SharingItem___default.a

  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData', 'actualGroup', 'actualBundle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('devicesStore', ['devices', 'devicesPortData'])),

  watch: {
    profileData: function profileData() {
      var _this = this;

      this.displayListSharingFlag = false;
      this.$nextTick(function () {
        _this.displayListSharingFlag = true;
      });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    reloadPage: function reloadPage() {
      window.location.reload();
    }
  }),

  mounted: function mounted() {

    window.scrollTo(0, 0);
    this.defaultGroupSelectedFlag = this.actualGroup.group_id.includes(':DefaultGroup');
    this.displayListSharingFlag = true;

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SharingItem',
  props: ['index'],

  data: function data() {
    return {
      isOpen: true,
      dataTempo01: 'test',
      dataTempo02: 'test',
      loadingData: false,
      defaultGroupSelectedFlag: false,
      invitation: {},

      messageNoMoreSharing: { FR: "Plus de partage en attente pour l'instant. Vous devez selectionner un autre menu.", EN: 'No more sharings for now. Select other menu.' },

      titleSharingChannel: { FR: "Partage d'appareil", EN: 'Device sharing' },
      titleSharingDevice: { FR: "Partage de module de mesure", EN: 'Monitoring module' },
      titleSharingBundle: { FR: 'Partage de système', EN: 'System sharing' },
      titleSharingGroup: { FR: 'Partage de groupe', EN: 'Group sharing' },

      labelButtonAccept: { FR: 'Accepter le partage', EN: 'Accept sharing' },
      labelButtonReject: { FR: 'Refuser le partage', EN: 'Reject sharing' },
      sharingBottomMessage: { FR: "L'acceptation ou le refus du partage doit s'effectuer au maximum 30 jours aprés son émission.", EN: 'Acceptation or Rejection of sharing must be done within the next 30 days of its emission.' },
      mustSelectGroupNotDefaultGroup: { FR: "Vous devez obligatoirement sélectionner l'option Groupe de premier niveau", EN: 'You must select the option First Level Group' },
      mustSelectGroupNotDefaultBundle: { FR: "Vous devez sélectionner un groupe usager et un groupe système autre que votre profile pour accepter le partage.", EN: 'You must select a User Groupe and System Groupe to accept the sharing.' },

      messageGroupReceptionRacine: { FR: "L'acceptation du groupe sera enregistré comme groupe racine a votre profile. Si vous désirez enregistrer ce groupe comme sous groupe d'un groupe existant, vous devez sélectionner le groupe dans lequel vous désirez enregistrer AVANT d'accepter le partage.", EN: 'Group is by default save as first level group in your profile. It is possible to save the group as sub group selecting the recipient groupe BEFORE accepting the sharing.' },
      messageGroupReception: { FR: "L'enregistrement d'un groupe s'enregistre comme Sous Groupe du groupe actuellement séléctionné. Il est possible d'enregistrer un Groupe comme groupe de premier niveau dans votre profil en utilisant l'option suivante:", EN: 'User group is by default save as a sub Group in the actual selected Group, it is possible to save the group as first level group in your profile by using the following option:' },
      labelCheckBoxGroup: { FR: 'Enregistrer ce groupe en tant que groupe de premier niveau', EN: 'Save this group as first level group' },
      flagSaveGroupAtFirstLevel: false,

      messageBundleReception: { FR: "L'enregistrement d'un Système s'enregistre comme Sous Système du Système actuellement séléctionné. Il est possible d'enregistrer le Système comme Système de même niveau que le Système actuellement sélectionné en utilisant l'option suivante:", EN: 'System is by default save as a Sub System in the actual selected System, it is possible to save the System at same level as the actual System by using the following option:' },
      messageBundleReceptionRacine: { FR: "L'acceptation du partage du Système sera enregistré dans le groupe actuellement sélectionné. Si vous désirez enregistrer ce partage dans un Système, vous devez sélectionner ce système AVANT d'accepter le partage", EN: 'System is by default save as a System in the actual selected Group, it is possible to save the System into another system by selecting the System BEFORE sharing acceptation' },

      labelCheckBoxBundle: { FR: 'Enregistrer ce Système au même niveau', EN: 'Save this System at same level' },
      flagSaveBundleAtSameLevel: false,

      actualLanguage: "FR"

    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a

  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('sessionStore', ['userEmail', 'profileData', 'planTransactionData', 'actualGroup', 'actualBundle', 'parentContainer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('devicesStore', ['devices', 'devicesPortData'])),

  watch: {
    actualGroup: function actualGroup() {
      this.defaultGroupSelectedFlag = this.actualGroup.group_id.includes(':DefaultGroup');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('overlayStore', ['showModal']), {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    acceptSharing: function acceptSharing(sharingIndex) {
      var _this = this;

      var confirmAcceptSharing = false;
      if (this.actualLanguage == "FR") {
        if (window.confirm('Confirmer de l\'acceptation du partage. L\'aceptation de partage agit sur le compteur d\'appareils de votre organisation.')) {
          confirmAcceptSharing = true;
        }
      } else {
        if (window.confirm('Confirm the sharing acceptance. Sharing acceptance increase your organization devices counter.')) {
          confirmAcceptSharing = true;
        }
      }

      if (confirmAcceptSharing) {
        var requestData = { 'postAction': 'AcceptSharing',
          'invitationId': this.profileData.sharingInvitations[sharingIndex].InvitationId,
          'parentContainer': this.parentContainer,
          'groupId': this.actualGroup.group_id,
          'bundleId': this.actualBundle.bundle_id,
          'flagSaveGroupFirstLevel': this.flagSaveGroupAtFirstLevel,
          'flagSaveBundleAtSameLevel': this.flagSaveBundleAtSameLevel
        };

        this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
          if (response.data.Code == 'OK') {

            window.alert(response.data.PromptMessage[_this.actualLanguage]);

            _this.$store.dispatch('sessionStore/refreshProfileData').then(function (response) {
              _this.$store.dispatch('sessionStore/getGroupArborescence').then(function (response) {
                _this.flagBundleIsLoading = false;
              });
            });
          } else {
            window.alert(response.data.PromptMessage[_this.actualLanguage]);
          }
        });
      }
    },
    rejectSharing: function rejectSharing(sharingIndex) {
      var _this2 = this;

      var confirmRejectSharing = false;
      if (this.actualLanguage == "FR") {
        if (window.confirm('Confirmer le refus du partage')) {
          confirmRejectSharing = true;
        }
      } else {
        if (window.confirm('Confirm the sharing reject')) {
          confirmRejectSharing = true;
        }
      }

      if (confirmRejectSharing) {
        var requestData = { 'postAction': 'RejectSharing',
          'invitationId': this.profileData.sharingInvitations[sharingIndex].InvitationId,
          'groupId': this.actualGroup.group_id,
          'bundleId': this.actualBundle.bundle_id,
          'flagSaveGroupFirstLevel': this.flagSaveGroupAtFirstLevel,
          'flagSaveBundleAtSameLevel': this.flagSaveBundleAtSameLevel
        };

        this.$store.dispatch('sessionStore/postRule', requestData).then(function (response) {
          if (response.data.Code == 'OK') {
            window.alert(response.data.Message[_this2.actualLanguage]);

            _this2.$store.dispatch('sessionStore/refreshProfileData');
          } else {
            window.alert("L'enregistrement a échoué. / Saving fail.");
          }
        });
      }
    },
    refreshBundle: function refreshBundle() {
      var _this3 = this;

      var requestData = { 'postAction': 'ReadBundleData', 'bundleId': this.bundleTempo.bundle_id };
      this.$store.dispatch('sessionStore/postBundle', requestData).then(function (response) {
        if (response.data.Code == 'OK') {
          _this3.bundleTempo = response.data.BundleData;
          _this3.$store.dispatch('sessionStore/setActualBundle', _this3.bundleTempo);
          _this3.flagBundleSelected = true;
        } else {
          window.alert("La lecture a échouée. / Reading fail.");
        }
      });
    }
  }),

  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.defaultGroupSelectedFlag = this.actualGroup.group_id.includes(':DefaultGroup');

    if (localStorage.language) {
      this.actualLanguage = localStorage.language;
    } else {
      this.actualLanguage = 'FR';
    }
  },
  beforeMount: function beforeMount() {
    this.invitation = this.profileData.sharingInvitations[this.index];
  }
});

/***/ }),
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Cookie = {
  set: function set(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  get: function get(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  destroy: function destroy(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (Cookie);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendors_bootstrap_datepicker_bootstrap_datepicker3_min_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendors_bootstrap_datepicker_bootstrap_datepicker3_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendors_bootstrap_datepicker_bootstrap_datepicker3_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendors_stylesheets_oneui_bootstrap_min_css__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendors_stylesheets_oneui_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vendors_stylesheets_oneui_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendors_stylesheets_oneui_oneui_css__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendors_stylesheets_oneui_oneui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vendors_stylesheets_oneui_oneui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendors_oneui_oneui_min_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendors_bootstrap_datepicker_bootstrap_datepicker_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vendors_moment_locale_fr_ca_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stores__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_axios__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_google_maps__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_fr__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_stylesheets_global_sass__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_stylesheets_global_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_stylesheets_global_sass__);























__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_fr___default.a);



__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_12_axios___default.a.defaults.baseURL = "https://1lba7wtlli.execute-api.us-east-1.amazonaws.com/api";

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_12_axios___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDONkBos7uKFL1aClosfH8WzPSaEozA0fw',
    libraries: 'places'
  }
});

new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__stores__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App___default.a }
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_ports_Home__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_ports_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_ports_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_measurements_Index__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_measurements_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_measurements_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_alerts_Index__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_alerts_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_alerts_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_cost_splitting_Index__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_cost_splitting_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_cost_splitting_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_configuration_Index__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_configuration_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_configuration_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_BindingCode__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_BindingCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_BindingCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_group_Index__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_group_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_group_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_profile_Index__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_profile_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_profile_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_evsens_admin_Index__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_evsens_admin_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_evsens_admin_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_sharing_Index__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_sharing_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_sharing_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_help_Index__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_help_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_help_Index__);
















var checkDevicesLength = function checkDevicesLength() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__stores__["a" /* default */].dispatch('devicesStore/devices').then(function (response) {
      if (response.data.length == 0) {
        reject({ message: 'no devices' });
      } else {
        resolve();
      }
    }).catch(function (e) {
      reject(e);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '',
  name: 'ports',
  component: __WEBPACK_IMPORTED_MODULE_2__views_ports_Home___default.a,
  meta: { auth: true }

}, {
  path: 'mesures-electriques',
  component: __WEBPACK_IMPORTED_MODULE_3__views_measurements_Index___default.a,
  name: 'measurements',
  meta: { auth: true }
}, {
  path: 'code-jumelage',
  component: __WEBPACK_IMPORTED_MODULE_7__views_BindingCode___default.a,
  name: 'bindingcode',
  meta: { auth: true }
}, {
  path: 'configuration',
  component: __WEBPACK_IMPORTED_MODULE_6__views_configuration_Index___default.a,
  name: 'configuration',
  meta: { auth: true }

}, {
  path: 'cost-splitting',
  component: __WEBPACK_IMPORTED_MODULE_5__views_cost_splitting_Index___default.a,
  name: 'cost-splitting',
  meta: { auth: true }
}, {
  path: 'group',
  component: __WEBPACK_IMPORTED_MODULE_8__views_group_Index___default.a,
  name: 'group',
  meta: { auth: true }
}, {
  path: 'profile',
  component: __WEBPACK_IMPORTED_MODULE_9__views_profile_Index___default.a,
  name: 'profile',
  meta: { auth: true }
}, {
  path: 'evsensadmin',
  component: __WEBPACK_IMPORTED_MODULE_10__views_evsens_admin_Index___default.a,
  name: 'evsensadmin',
  meta: { auth: true }
}, {
  path: 'alerts',
  component: __WEBPACK_IMPORTED_MODULE_4__views_alerts_Index___default.a,
  name: 'alerts',
  meta: { auth: true }
}, {
  path: 'sharing',
  component: __WEBPACK_IMPORTED_MODULE_11__views_sharing_Index___default.a,
  name: 'sharing',
  meta: { auth: true }
}, {
  path: 'help',
  component: __WEBPACK_IMPORTED_MODULE_12__views_help_Index___default.a,
  name: 'help',
  meta: { auth: true }
}]);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);




var appliancesStore = {
  namespaced: true,
  state: {
    appliancesList: [],
    systemsList: []
  },
  mutations: {
    SET_APPLIANCES_LIST: function SET_APPLIANCES_LIST(state, list) {
      state.appliancesList = list;
    },
    SET_SYSTEMS_LIST: function SET_SYSTEMS_LIST(state, list) {
      state.systemsList = list;
    }
  },
  actions: {
    reset: function reset(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('SET_APPLIANCES_LIST', []);
      commit('SET_SYSTEMS_LIST', []);
    },
    get: function get(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      var actualLanguage;
      if (localStorage.language) {
        actualLanguage = localStorage.language;
      } else {
        actualLanguage = 'FR';
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('./rest/appliance/list?language=' + actualLanguage).then(function (response) {
          commit('SET_APPLIANCES_LIST', response.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getSystems: function getSystems(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var actualLanguage;
      if (localStorage.language) {
        actualLanguage = localStorage.language;
      } else {
        actualLanguage = 'FR';
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('./rest/systems/list?language=' + actualLanguage).then(function (response) {
          commit('SET_SYSTEMS_LIST', response.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (appliancesStore);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_session__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(7);







var manufacturers = ['Borne de recharge', 'BMW', 'Chevrolet', 'Ford', 'Hyundai', 'Kia', 'Nissan', 'Smart', 'Tesla', 'Toyota', 'Volkswagen'];
var carStore = {
  namespaced: true,
  state: {
    manufacturers: manufacturers,
    carCreateData: [],
    cars: []
  },
  mutations: {
    SET_CARS: function SET_CARS(state, cars) {
      state.cars = cars;
    },
    FILTER_POSSIBLE_CARS: function FILTER_POSSIBLE_CARS(state, data) {
      state.carCreateData = data;
    }
  },
  actions: {
    reset: function reset(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      commit('SET_CARS', []);
      commit('FILTER_POSSIBLE_CARS', []);
    },
    getManufacturerInfos: function getManufacturerInfos(_ref2, data) {
      var state = _ref2.state,
          commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/cars/makers', { params: data }).then(function (response) {
        commit('FILTER_POSSIBLE_CARS', response.data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
      });
    },
    getCars: function getCars(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/cars/').then(function (response) {
        commit('SET_CARS', response.data);
      });
    },
    updateCar: function updateCar(_ref4, carData) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/cars', carData);
    },
    deleteCar: function deleteCar(_ref5, profileCarId) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/cars', { params: { profileCarId: profileCarId } });
    },
    createCar: function createCar(_ref6, carData) {
      var commit = _ref6.commit,
          state = _ref6.state,
          dispatch = _ref6.dispatch;

      var saveData = __WEBPACK_IMPORTED_MODULE_4_underscore__["a" /* default */].find(state.carCreateData, function (car) {
        return car.color == carData.color && car.manufacturer == carData.manufacturer && car.model == carData.model && car.year == carData.year;
      });

      if (!saveData) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject({ message: 'Le formulaire contient des erreurs' });
      }
      saveData.carName = carData.carName;
      saveData.linkedDevice = carData.linkedDevice;
      saveData.linkedPort = carData.linkedPort;
      saveData.averageWhPerKm = carData.averageWhPerKm;
      console.log(saveData);
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/cars', carData);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (carStore);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_session__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_charges__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores_overlay__ = __webpack_require__(124);








var deviceStore = {
  namespaced: true,
  state: {
    devices: [],
    devicesPortData: []
  },
  mutations: {
    SET_DEVICES: function SET_DEVICES(state, devices) {
      state.devices = devices;
    },
    SET_DEVICE_PORT_DATA: function SET_DEVICE_PORT_DATA(state, portData) {
      state.devicesPortData = portData;
    }
  },
  actions: {
    reset: function reset(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('SET_DEVICES', []);
      commit('SET_DEVICE_PORT_DATA', []);
      commit('SET_ACTUAL_BUNDLE_DEVICE_DATA', [{ 'deviceId': 'None', 'portData': [] }]);
    },
    readDeviceDataOld: function readDeviceDataOld(_ref2, deviceId) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/device/' + deviceId + '/graph?start=' + __WEBPACK_IMPORTED_MODULE_4__stores_charges__["a" /* default */].state.startDate + '&end=' + __WEBPACK_IMPORTED_MODULE_4__stores_charges__["a" /* default */].state.endDate).then(function (response) {
          console.log("store_device_readDeviceData");
          console.log(response.data);
          response.data.deviceId = deviceId;

          for (var i = 0; i < response.data.portsData.length; i++) {
            response.data.portsData[i].data.reverse();
          }
          state.actualBundleDeviceData.push({ 'deviceId': deviceId, 'portData': response.data.portsData });
          console.log(state.actualBundleDeviceData);
          commit("SET_DEVICE_PORT_DATA", response.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    clearDevices: function clearDevices(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('SET_DEVICES', []);
    },
    live: function live(_ref4, deviceId) {
      var commit = _ref4.commit,
          state = _ref4.state;

      console.log('Live call');
    },
    updatePort: function updatePort(_ref5, data) {
      var commit = _ref5.commit,
          state = _ref5.state;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/device/' + data.deviceId + '/portupdate', data.portData);
    },
    validateDeviceId: function validateDeviceId(_ref6, device) {
      var commit = _ref6.commit,
          state = _ref6.state;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/validatedeviceid?deviceId=' + device.deviceId + '&deviceKey=' + device.deviceKey).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
      });
    },
    addDeviceToProfile: function addDeviceToProfile(_ref7, device) {
      var commit = _ref7.commit,
          state = _ref7.state;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/addrecordeddevice?deviceId=' + device.deviceId + '&deviceKey=' + device.deviceKey).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
      });
    },
    addSubscriptionToDevice: function addSubscriptionToDevice(_ref8, device) {
      var commit = _ref8.commit,
          state = _ref8.state;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/addsubscriptiontodevice?deviceId=' + device.deviceId + '&deviceKey=' + device.deviceKey + '&template=' + device.subscriptionTemplate + '&freemonth=' + device.monthFree).then(function (response) {
        console.log(response.data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (deviceStore);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_session__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(7);







var groupStore = {
  namespaced: true,
  state: {
    actualGroupLevel: 1
  },
  mutations: {
    SET_ACTUAL_GROUP_LEVEL: function SET_ACTUAL_GROUP_LEVEL(state, groupLevel) {
      state.actualGroupLevel = groupLevel;
    }
  },
  actions: {
    setActualGroupLevel: function setActualGroupLevel(_ref, data) {
      var commit = _ref.commit,
          state = _ref.state;

      commit('SET_ACTUAL_GROUP_LEVEL', data);
    },
    addGroupToProfile: function addGroupToProfile(_ref2, device) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('/rest/profile/' + __WEBPACK_IMPORTED_MODULE_3__stores_session__["a" /* default */].state.profileId + '/addrecordeddevice?deviceId=' + device.deviceId + '&deviceKey=' + device.deviceKey).then(function (response) {
        console.log(response.data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
      });
    },
    refreshProfileData: function refreshProfileData(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      console.log('store_session_refresh_profile_data');

      var payload = { "firstName": 'John', "email": 'Bidon', "lastName": 'Doe' };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post('/rest/profile/' + localStorage.actualUserName + '/login', payload).then(function (response) {
        console.log("store_session_refressed");
        console.log(response.data.userData);
        commit('SET_PROFILE_DATA', response.data.userData);
      }).catch(function (e) {
        console.log(e);
      });
    },
    createNewGroupInProfile: function createNewGroupInProfile(_ref4, groupInfo) {
      var commit = _ref4.commit,
          state = _ref4.state;

      var payload = groupInfo;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post('/rest/profile/' + groupInfo.profileId + '/createNewGroupInProfile', payload).then(function (response) {
        console.log(response.data);
      }).catch(function (e) {
        console.log(e);
      });
    },
    createNewGroupInGroup: function createNewGroupInGroup(_ref5, groupInfo) {
      var commit = _ref5.commit,
          state = _ref5.state;

      var payload = groupInfo;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post('/rest/profile/' + groupInfo.profileId + '/createNewGroupInGroup', payload).then(function (response) {
        console.log(response.data);
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (groupStore);

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {



(function (root, undefined) {
  var lib = {};

  lib.version = '0.4.2';

  lib.settings = {
    currency: {
      symbol: "$",
      format: "%s%v",
      decimal: ".",
      thousand: ",",
      precision: 2,
      grouping: 3 },
    number: {
      precision: 0,
      grouping: 3,
      thousand: ",",
      decimal: "."
    }
  };

  var nativeMap = Array.prototype.map,
      nativeIsArray = Array.isArray,
      toString = Object.prototype.toString;

  function isString(obj) {
    return !!(obj === '' || obj && obj.charCodeAt && obj.substr);
  }

  function isArray(obj) {
    return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
  }

  function isObject(obj) {
    return obj && toString.call(obj) === '[object Object]';
  }

  function defaults(object, defs) {
    var key;
    object = object || {};
    defs = defs || {};

    for (key in defs) {
      if (defs.hasOwnProperty(key)) {
        if (object[key] == null) object[key] = defs[key];
      }
    }
    return object;
  }

  function map(obj, iterator, context) {
    var results = [],
        i,
        j;

    if (!obj) return results;

    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

    for (i = 0, j = obj.length; i < j; i++) {
      results[i] = iterator.call(context, obj[i], i, obj);
    }
    return results;
  }

  function checkPrecision(val, base) {
    val = Math.round(Math.abs(val));
    return isNaN(val) ? base : val;
  }

  function checkCurrencyFormat(format) {
    var defaults = lib.settings.currency.format;

    if (typeof format === "function") format = format();

    if (isString(format) && format.match("%v")) {
      return {
        pos: format,
        neg: format.replace("-", "").replace("%v", "-%v"),
        zero: format
      };
    } else if (!format || !format.pos || !format.pos.match("%v")) {
      return !isString(defaults) ? defaults : lib.settings.currency.format = {
        pos: defaults,
        neg: defaults.replace("%v", "-%v"),
        zero: defaults
      };
    }

    return format;
  }

  var unformat = lib.unformat = lib.parse = function (value, decimal) {
    if (isArray(value)) {
      return map(value, function (val) {
        return unformat(val, decimal);
      });
    }

    value = value || 0;

    if (typeof value === "number") return value;

    decimal = decimal || lib.settings.number.decimal;

    var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
        unformatted = parseFloat(("" + value).replace(/\((?=\d+)(.*)\)/, "-$1").replace(regex, '').replace(decimal, '.'));

    return !isNaN(unformatted) ? unformatted : 0;
  };

  var toFixed = lib.toFixed = function (value, precision) {
    precision = checkPrecision(precision, lib.settings.number.precision);

    var exponentialForm = Number(lib.unformat(value) + 'e' + precision);
    var rounded = Math.round(exponentialForm);
    var finalResult = Number(rounded + 'e-' + precision).toFixed(precision);
    return finalResult;
  };

  var formatNumber = lib.formatNumber = lib.format = function (number, precision, thousand, decimal) {
    if (isArray(number)) {
      return map(number, function (val) {
        return formatNumber(val, precision, thousand, decimal);
      });
    }

    number = unformat(number);

    var opts = defaults(isObject(precision) ? precision : {
      precision: precision,
      thousand: thousand,
      decimal: decimal
    }, lib.settings.number),
        usePrecision = checkPrecision(opts.precision),
        negative = number < 0 ? "-" : "",
        base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
        mod = base.length > 3 ? base.length % 3 : 0;

    return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
  };

  var formatMoney = lib.formatMoney = function (number, symbol, precision, thousand, decimal, format) {
    if (isArray(number)) {
      return map(number, function (val) {
        return formatMoney(val, symbol, precision, thousand, decimal, format);
      });
    }

    number = unformat(number);

    var opts = defaults(isObject(symbol) ? symbol : {
      symbol: symbol,
      precision: precision,
      thousand: thousand,
      decimal: decimal,
      format: format
    }, lib.settings.currency),
        formats = checkCurrencyFormat(opts.format),
        useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

    return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
  };

  lib.formatColumn = function (list, symbol, precision, thousand, decimal, format) {
    if (!list || !isArray(list)) return [];

    var opts = defaults(isObject(symbol) ? symbol : {
      symbol: symbol,
      precision: precision,
      thousand: thousand,
      decimal: decimal,
      format: format
    }, lib.settings.currency),
        formats = checkCurrencyFormat(opts.format),
        padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
        maxLength = 0,
        formatted = map(list, function (val, i) {
      if (isArray(val)) {
        return lib.formatColumn(val, opts);
      } else {
        val = unformat(val);

        var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
            fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

        if (fVal.length > maxLength) maxLength = fVal.length;
        return fVal;
      }
    });

    return map(formatted, function (val, i) {
      if (isString(val) && val.length < maxLength) {
        return padAfterSymbol ? val.replace(opts.symbol, opts.symbol + new Array(maxLength - val.length + 1).join(" ")) : new Array(maxLength - val.length + 1).join(" ") + val;
      }
      return val;
    });
  };

  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = lib;
    }
    exports.accounting = lib;
  } else if (typeof define === 'function' && define.amd) {
    define([], function () {
      return lib;
    });
  } else {
    lib.noConflict = function (oldAccounting) {
      return function () {
        root.accounting = oldAccounting;

        lib.noConflict = undefined;

        return lib;
      };
    }(root.accounting);

    root['accounting'] = lib;
  }
})(this);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = [{ favIcon: 'fa-500px', label: '500px' }, { favIcon: 'fa-adjust', label: 'adjust' }, { favIcon: 'fa-american-sign-language-interpreting', label: 'american sign language interpreting' }, { favIcon: 'fa-adn', label: 'adn' }, { favIcon: 'fa-address-book', label: 'address book' }, { favIcon: 'fa-address-book-o', label: 'address book o' }, { favIcon: 'fa-address-card', label: 'address card' }, { favIcon: 'fa-address-card-o', label: 'address card o' }, { favIcon: 'fa-align-center', label: 'align center' }, { favIcon: 'fa-align-justify', label: 'align justify' }, { favIcon: 'fa-align-left', label: 'align left' }, { favIcon: 'fa-align-right', label: 'align right' }, { favIcon: 'fa-amazon', label: 'amazon' }, { favIcon: 'fa-ambulance', label: 'ambulance' }, { favIcon: 'fa-anchor', label: 'anchor' }, { favIcon: 'fa-android', label: 'android' }, { favIcon: 'fa-angellist', label: 'angellist' }, { favIcon: 'fa-angle-double-down', label: 'angle double down' }, { favIcon: 'fa-angle-double-left', label: 'angle double left' }, { favIcon: 'fa-angle-double-right', label: 'angle double right' }, { favIcon: 'fa-angle-double-up', label: 'angle double up' }, { favIcon: 'fa-angle-down', label: 'angle down' }, { favIcon: 'fa-angle-left', label: 'angle left' }, { favIcon: 'fa-angle-right', label: 'angle right' }, { favIcon: 'fa-angle-up', label: 'angle up' }, { favIcon: 'fa-apple', label: 'apple' }, { favIcon: 'fa-archive', label: 'archive' }, { favIcon: 'fa-area-chart', label: 'area chart' }, { favIcon: 'fa-arrow-circle-down', label: 'arrow circle down' }, { favIcon: 'fa-arrow-circle-left', label: 'arrow circle left' }, { favIcon: 'fa-arrow-circle-o-down', label: 'arrow circle o down' }, { favIcon: 'fa-arrow-circle-o-left', label: 'arrow circle o left' }, { favIcon: 'fa-arrow-circle-o-right', label: 'arrow circle o right' }, { favIcon: 'fa-arrow-circle-o-up', label: 'arrow circle o up' }, { favIcon: 'fa-arrow-circle-right', label: 'arrow circle right' }, { favIcon: 'fa-arrow-circle-up', label: 'arrow circle up' }, { favIcon: 'fa-arrow-down', label: 'arrow down' }, { favIcon: 'fa-arrow-left', label: 'arrow left' }, { favIcon: 'fa-arrow-right', label: 'arrow right' }, { favIcon: 'fa-arrow-up', label: 'arrow up' }, { favIcon: 'fa-arrows-alt', label: 'arrows alt' }, { favIcon: 'fa-arrows-h', label: 'arrows h' }, { favIcon: 'fa-arrows-v', label: 'arrows v' }, { favIcon: 'fa-arrows', label: 'arrows' }, { favIcon: 'fa-asl-interpreting', label: 'asl interpreting' }, { favIcon: 'fa-assistive-listening-systems', label: 'assistive listening systems' }, { favIcon: 'fa-asterisk', label: 'asterisk' }, { favIcon: 'fa-at', label: 'at' }, { favIcon: 'fa-audio-description', label: 'audio description' }, { favIcon: 'fa-automobile', label: 'automobile' }, { favIcon: 'fa-backward', label: 'backward' }, { favIcon: 'fa-balance-scale', label: 'balance scale' }, { favIcon: 'fa-ban', label: 'ban' }, { favIcon: 'fa-bandcamp', label: 'bandcamp' }, { favIcon: 'fa-bank', label: 'bank' }, { favIcon: 'fa-bar-chart', label: 'bar chart' }, { favIcon: 'fa-bar-chart-o', label: 'bar chart o' }, { favIcon: 'fa-barcode', label: 'barcode' }, { favIcon: 'fa-bars', label: 'bars' }, { favIcon: 'fa-bath', label: 'bath' }, { favIcon: 'fa-bathtub', label: 'bathtub' }, { favIcon: 'fa-battery-0', label: 'battery 0' }, { favIcon: 'fa-battery-1', label: 'battery 1' }, { favIcon: 'fa-battery-2', label: 'battery 2' }, { favIcon: 'fa-battery-3', label: 'battery 3' }, { favIcon: 'fa-battery-4', label: 'battery 4' }, { favIcon: 'fa-battery-empty', label: 'battery empty' }, { favIcon: 'fa-battery-full', label: 'battery full' }, { favIcon: 'fa-battery-half', label: 'battery half' }, { favIcon: 'fa-battery-quarter', label: 'battery quarter' }, { favIcon: 'fa-battery-three-quarters', label: 'battery three quarters' }, { favIcon: 'fa-bed', label: 'bed' }, { favIcon: 'fa-beer', label: 'beer' }, { favIcon: 'fa-behance', label: 'behance' }, { favIcon: 'fa-behance-square', label: 'behance square' }, { favIcon: 'fa-bell', label: 'bell' }, { favIcon: 'fa-bell-o', label: 'bell o' }, { favIcon: 'fa-bell-slash', label: 'bell slash' }, { favIcon: 'fa-bell-slash-o', label: 'bell slash o' }, { favIcon: 'fa-bicycle', label: 'bicycle' }, { favIcon: 'fa-binoculars', label: 'binoculars' }, { favIcon: 'fa-birthday-cake', label: 'birthday cake' }, { favIcon: 'fa-bitbucket', label: 'bitbucket' }, { favIcon: 'fa-bitbucket-square', label: 'bitbucket square' }, { favIcon: 'fa-bitcoin', label: 'bitcoin' }, { favIcon: 'fa-black-tie', label: 'black tie' }, { favIcon: 'fa-blind', label: 'blind' }, { favIcon: 'fa-bluetooth', label: 'bluetooth' }, { favIcon: 'fa-bluetooth-b', label: 'bluetooth b' }, { favIcon: 'fa-bold', label: 'bold' }, { favIcon: 'fa-bolt', label: 'bolt' }, { favIcon: 'fa-bomb', label: 'bomb' }, { favIcon: 'fa-book', label: 'book' }, { favIcon: 'fa-bookmark', label: 'bookmark' }, { favIcon: 'fa-bookmark-o', label: 'bookmark o' }, { favIcon: 'fa-braille', label: 'braille' }, { favIcon: 'fa-briefcase', label: 'briefcase' }, { favIcon: 'fa-btc', label: 'btc' }, { favIcon: 'fa-bug', label: 'bug' }, { favIcon: 'fa-building', label: 'building' }, { favIcon: 'fa-building-o', label: 'building o' }, { favIcon: 'fa-bullhorn', label: 'bullhorn' }, { favIcon: 'fa-bullseye', label: 'bullseye' }, { favIcon: 'fa-bus', label: 'bus' }, { favIcon: 'fa-buysellads', label: 'buysellads' }, { favIcon: 'fa-cab', label: 'cab' }, { favIcon: 'fa-calculator', label: 'calculator' }, { favIcon: 'fa-calendar', label: 'calendar' }, { favIcon: 'fa-calendar-check-o', label: 'calendar check o' }, { favIcon: 'fa-calendar-minus-o', label: 'calendar minus o' }, { favIcon: 'fa-calendar-plus-o', label: 'calendar plus o' }, { favIcon: 'fa-calendar-times-o', label: 'calendar times o' }, { favIcon: 'fa-calendar-o', label: 'calendar o' }, { favIcon: 'fa-camera', label: 'camera' }, { favIcon: 'fa-camera-retro', label: 'camera retro' }, { favIcon: 'fa-car', label: 'car' }, { favIcon: 'fa-caret-down', label: 'caret down' }, { favIcon: 'fa-caret-left', label: 'caret left' }, { favIcon: 'fa-caret-right', label: 'caret right' }, { favIcon: 'fa-caret-square-o-down', label: 'caret square o down' }, { favIcon: 'fa-caret-square-o-left', label: 'caret square o left' }, { favIcon: 'fa-caret-square-o-right', label: 'caret square o right' }, { favIcon: 'fa-caret-square-o-up', label: 'caret square o up' }, { favIcon: 'fa-caret-up', label: 'caret up' }, { favIcon: 'fa-cart-arrow-down', label: 'cart arrow down' }, { favIcon: 'fa-cart-plus', label: 'cart plus' }, { favIcon: 'fa-cc', label: 'cc' }, { favIcon: 'fa-cc-amex', label: 'cc amex' }, { favIcon: 'fa-cc-diners-club', label: 'cc diners club' }, { favIcon: 'fa-cc-discover', label: 'cc discover' }, { favIcon: 'fa-cc-jcb', label: 'cc jcb' }, { favIcon: 'fa-cc-mastercard', label: 'cc mastercard' }, { favIcon: 'fa-cc-paypal', label: 'cc paypal' }, { favIcon: 'fa-cc-stripe', label: 'cc stripe' }, { favIcon: 'fa-cc-visa', label: 'cc visa' }, { favIcon: 'fa-certificate', label: 'certificate' }, { favIcon: 'fa-chain', label: 'chain' }, { favIcon: 'fa-chain-broken', label: 'chain broken' }, { favIcon: 'fa-check', label: 'check' }, { favIcon: 'fa-check-circle', label: 'check circle' }, { favIcon: 'fa-check-circle-o', label: 'check circle o' }, { favIcon: 'fa-check-square', label: 'check square' }, { favIcon: 'fa-check-square-o', label: 'check square o' }, { favIcon: 'fa-chevron-circle-down', label: 'chevron circle down' }, { favIcon: 'fa-chevron-circle-left', label: 'chevron circle left' }, { favIcon: 'fa-chevron-circle-right', label: 'chevron circle right' }, { favIcon: 'fa-chevron-circle-up', label: 'chevron circle up' }, { favIcon: 'fa-chevron-down', label: 'chevron down' }, { favIcon: 'fa-chevron-left', label: 'chevron left' }, { favIcon: 'fa-ch', label: 'ch' }, { favIcon: 'fa-chevron-up', label: 'chevron up' }, { favIcon: 'fa-child', label: 'child' }, { favIcon: 'fa-chrome', label: 'chrome' }, { favIcon: 'fa-clone', label: 'clone' }, { favIcon: 'fa-circle', label: 'circle' }, { favIcon: 'fa-circle-o', label: 'circle o' }, { favIcon: 'fa-circle-o-notch', label: 'circle o notch' }, { favIcon: 'fa-circle-thin', label: 'circle thin' }, { favIcon: 'fa-clipboard', label: 'clipboard' }, { favIcon: 'fa-clock-o', label: 'clock o' }, { favIcon: 'fa-close', label: 'close' }, { favIcon: 'fa-cloud', label: 'cloud' }, { favIcon: 'fa-cloud-download', label: 'cloud download' }, { favIcon: 'fa-cloud-upload', label: 'cloud upload' }, { favIcon: 'fa-cny', label: 'cny' }, { favIcon: 'fa-code', label: 'code' }, { favIcon: 'fa-code-fork', label: 'code fork' }, { favIcon: 'fa-codepen', label: 'codepen' }, { favIcon: 'fa-codiepie', label: 'codiepie' }, { favIcon: 'fa-coffee', label: 'coffee' }, { favIcon: 'fa-cog', label: 'cog' }, { favIcon: 'fa-cogs', label: 'cogs' }, { favIcon: 'fa-columns', label: 'columns' }, { favIcon: 'fa-comment', label: 'comment' }, { favIcon: 'fa-comment-o', label: 'comment o' }, { favIcon: 'fa-comments', label: 'comments' }, { favIcon: 'fa-comments-o', label: 'comments o' }, { favIcon: 'fa-commenting', label: 'commenting' }, { favIcon: 'fa-commenting-o', label: 'commenting o' }, { favIcon: 'fa-compass', label: 'compass' }, { favIcon: 'fa-compress', label: 'compress' }, { favIcon: 'fa-connectdevelop', label: 'connectdevelop' }, { favIcon: 'fa-contao', label: 'contao' }, { favIcon: 'fa-copy', label: 'copy' }, { favIcon: 'fa-copyright', label: 'copyright' }, { favIcon: 'fa-creative-commons', label: 'creative commons' }, { favIcon: 'fa-credit-card', label: 'credit card' }, { favIcon: 'fa-credit-card-alt', label: 'credit card alt' }, { favIcon: 'fa-crop', label: 'crop' }, { favIcon: 'fa-crosshairs', label: 'crosshairs' }, { favIcon: 'fa-css3', label: 'css3' }, { favIcon: 'fa-cube', label: 'cube' }, { favIcon: 'fa-cubes', label: 'cubes' }, { favIcon: 'fa-cut', label: 'cut' }, { favIcon: 'fa-cutlery', label: 'cutlery' }, { favIcon: 'fa-dashboard', label: 'dashboard' }, { favIcon: 'fa-dashcube', label: 'dashcube' }, { favIcon: 'fa-database', label: 'database' }, { favIcon: 'fa-deaf', label: 'deaf' }, { favIcon: 'fa-deafness', label: 'deafness' }, { favIcon: 'fa-dedent', label: 'dedent' }, { favIcon: 'fa-delicious', label: 'delicious' }, { favIcon: 'fa-desktop', label: 'desktop' }, { favIcon: 'fa-deviantart', label: 'deviantart' }, { favIcon: 'fa-diamond', label: 'diamond' }, { favIcon: 'fa-digg', label: 'digg' }, { favIcon: 'fa-dollar', label: 'dollar' }, { favIcon: 'fa-dot-circle-o', label: 'dot circle o' }, { favIcon: 'fa-download', label: 'download' }, { favIcon: 'fa-dribbble', label: 'dribbble' }, { favIcon: 'fa-drivers-license', label: 'drivers license' }, { favIcon: 'fa-drivers-license-o', label: 'drivers license o' }, { favIcon: 'fa-dropbox', label: 'dropbox' }, { favIcon: 'fa-drupal', label: 'drupal' }, { favIcon: 'fa-edge', label: 'edge' }, { favIcon: 'fa-edit', label: 'edit' }, { favIcon: 'fa-eercast', label: 'eercast' }, { favIcon: 'fa-eject', label: 'eject' }, { favIcon: 'fa-ellipsis-h', label: 'ellipsis h' }, { favIcon: 'fa-ellipsis-v', label: 'ellipsis v' }, { favIcon: 'fa-empire', label: 'empire' }, { favIcon: 'fa-envelope', label: 'envelope' }, { favIcon: 'fa-envelope-o', label: 'envelope o' }, { favIcon: 'fa-envelope-open', label: 'envelope open' }, { favIcon: 'fa-envelope-open-o', label: 'envelope open o' }, { favIcon: 'fa-envelope-square', label: 'envelope square' }, { favIcon: 'fa-envira', label: 'envira' }, { favIcon: 'fa-eraser', label: 'eraser' }, { favIcon: 'fa-etsy', label: 'etsy' }, { favIcon: 'fa-eur', label: 'eur' }, { favIcon: 'fa-euro', label: 'euro' }, { favIcon: 'fa-exchange', label: 'exchange' }, { favIcon: 'fa-exclamation', label: 'exclamation' }, { favIcon: 'fa-exclamation-circle', label: 'exclamation circle' }, { favIcon: 'fa-exclamation-triangle', label: 'exclamation triangle' }, { favIcon: 'fa-expand', label: 'expand' }, { favIcon: 'fa-expeditedssl', label: 'expeditedssl' }, { favIcon: 'fa-external-link', label: 'external link' }, { favIcon: 'fa-external-link-square', label: 'external link square' }, { favIcon: 'fa-eye', label: 'eye' }, { favIcon: 'fa-eye-slash', label: 'eye slash' }, { favIcon: 'fa-eyedropper', label: 'eyedropper' }, { favIcon: 'fa-facebook', label: 'facebook' }, { favIcon: 'fa-facebook-f', label: 'facebook f' }, { favIcon: 'fa-facebook-official', label: 'facebook official' }, { favIcon: 'fa-facebook-square', label: 'facebook square' }, { favIcon: 'fa-fast-backward', label: 'fast backward' }, { favIcon: 'fa-fast-forward', label: 'fast forward' }, { favIcon: 'fa-fax', label: 'fax' }, { favIcon: 'fa-female', label: 'female' }, { favIcon: 'fa-fighter-jet', label: 'fighter jet' }, { favIcon: 'fa-file', label: 'file' }, { favIcon: 'fa-file-archive-o', label: 'file archive o' }, { favIcon: 'fa-file-audio-o', label: 'file audio o' }, { favIcon: 'fa-file-code-o', label: 'file code o' }, { favIcon: 'fa-file-excel-o', label: 'file excel o' }, { favIcon: 'fa-file-image-o', label: 'file image o' }, { favIcon: 'fa-file-movie-o', label: 'file movie o' }, { favIcon: 'fa-file-o', label: 'file o' }, { favIcon: 'fa-file-pdf-o', label: 'file pdf o' }, { favIcon: 'fa-file-photo-o', label: 'file photo o' }, { favIcon: 'fa-file-picture-o', label: 'file picture o' }, { favIcon: 'fa-file-powerpoint-o', label: 'file powerpoint o' }, { favIcon: 'fa-file-sound-o', label: 'file sound o' }, { favIcon: 'fa-file-text', label: 'file text' }, { favIcon: 'fa-file-text-o', label: 'file text o' }, { favIcon: 'fa-file-video-o', label: 'file video o' }, { favIcon: 'fa-file-word-o', label: 'file word o' }, { favIcon: 'fa-file-zip-o', label: 'file zip o' }, { favIcon: 'fa-files-o', label: 'files o' }, { favIcon: 'fa-film', label: 'film' }, { favIcon: 'fa-filter', label: 'filter' }, { favIcon: 'fa-fire', label: 'fire' }, { favIcon: 'fa-fire-extinguisher', label: 'fire extinguisher' }, { favIcon: 'fa-firefox', label: 'firefox' }, { favIcon: 'fa-first-order', label: 'first order' }, { favIcon: 'fa-flag', label: 'flag' }, { favIcon: 'fa-flag-checkered', label: 'flag checkered' }, { favIcon: 'fa-flag-o', label: 'flag o' }, { favIcon: 'fa-flash', label: 'flash' }, { favIcon: 'fa-flask', label: 'flask' }, { favIcon: 'fa-flickr', label: 'flickr' }, { favIcon: 'fa-floppy-o', label: 'floppy o' }, { favIcon: 'fa-folder', label: 'folder' }, { favIcon: 'fa-folder-o', label: 'folder o' }, { favIcon: 'fa-folder-open', label: 'folder open' }, { favIcon: 'fa-folder-open-o', label: 'folder open o' }, { favIcon: 'fa-font', label: 'font' }, { favIcon: 'fa-fonticons', label: 'fonticons' }, { favIcon: 'fa-fort-awesome', label: 'fort awesome' }, { favIcon: 'fa-forumbee', label: 'forumbee' }, { favIcon: 'fa-forward', label: 'forward' }, { favIcon: 'fa-foursquare', label: 'foursquare' }, { favIcon: 'fa-free-code-camp', label: 'free code camp' }, { favIcon: 'fa-frown-o', label: 'frown o' }, { favIcon: 'fa-futbol-o', label: 'futbol o' }, { favIcon: 'fa-gamepad', label: 'gamepad' }, { favIcon: 'fa-gavel', label: 'gavel' }, { favIcon: 'fa-gbp', label: 'gbp' }, { favIcon: 'fa-ge', label: 'ge' }, { favIcon: 'fa-gear', label: 'gear' }, { favIcon: 'fa-gears', label: 'gears' }, { favIcon: 'fa-genderless', label: 'genderless' }, { favIcon: 'fa-get-pocket', label: 'get pocket' }, { favIcon: 'fa-gg', label: 'gg' }, { favIcon: 'fa-gg-circle', label: 'gg circle' }, { favIcon: 'fa-gift', label: 'gift' }, { favIcon: 'fa-git', label: 'git' }, { favIcon: 'fa-git-square', label: 'git square' }, { favIcon: 'fa-github', label: 'github' }, { favIcon: 'fa-github-alt', label: 'github alt' }, { favIcon: 'fa-github-square', label: 'github square' }, { favIcon: 'fa-gitlab', label: 'gitlab' }, { favIcon: 'fa-gittip', label: 'gittip' }, { favIcon: 'fa-glass', label: 'glass' }, { favIcon: 'fa-glide', label: 'glide' }, { favIcon: 'fa-glide-g', label: 'glide g' }, { favIcon: 'fa-globe', label: 'globe' }, { favIcon: 'fa-google', label: 'google' }, { favIcon: 'fa-google-plus', label: 'google plus' }, { favIcon: 'fa-google-plus-square', label: 'google plus square' }, { favIcon: 'fa-google-wallet', label: 'google wallet' }, { favIcon: 'fa-graduation-cap', label: 'graduation cap' }, { favIcon: 'fa-gratipay', label: 'gratipay' }, { favIcon: 'fa-grav', label: 'grav' }, { favIcon: 'fa-group', label: 'group' }, { favIcon: 'fa-h-square', label: 'h square' }, { favIcon: 'fa-hacker-news', label: 'hacker news' }, { favIcon: 'fa-hand-grab-o', label: 'hand grab o' }, { favIcon: 'fa-hand-lizard-o', label: 'hand lizard o' }, { favIcon: 'fa-hand-paper-o', label: 'hand paper o' }, { favIcon: 'fa-hand-peace-o', label: 'hand peace o' }, { favIcon: 'fa-hand-pointer-o', label: 'hand pointer o' }, { favIcon: 'fa-hand-rock-o', label: 'hand rock o' }, { favIcon: 'fa-hand-scissors-o', label: 'hand scissors o' }, { favIcon: 'fa-hand-spock-o', label: 'hand spock o' }, { favIcon: 'fa-hand-stop-o', label: 'hand stop o' }, { favIcon: 'fa-hand-o-down', label: 'hand o down' }, { favIcon: 'fa-hand-o-left', label: 'hand o left' }, { favIcon: 'fa-hand-o-right', label: 'hand o right' }, { favIcon: 'fa-hand-o-up', label: 'hand o up' }, { favIcon: 'fa-handshake-o', label: 'handshake o' }, { favIcon: 'fa-hard-of-hearing', label: 'hard of hearing' }, { favIcon: 'fa-hashtag', label: 'hashtag' }, { favIcon: 'fa-hdd-o', label: 'hdd o' }, { favIcon: 'fa-header', label: 'header' }, { favIcon: 'fa-headphones', label: 'headphones' }, { favIcon: 'fa-heart', label: 'heart' }, { favIcon: 'fa-heart-o', label: 'heart o' }, { favIcon: 'fa-heartbeat', label: 'heartbeat' }, { favIcon: 'fa-history', label: 'history' }, { favIcon: 'fa-home', label: 'home' }, { favIcon: 'fa-hospital-o', label: 'hospital o' }, { favIcon: 'fa-hotel', label: 'hotel' }, { favIcon: 'fa-hourglass', label: 'hourglass' }, { favIcon: 'fa-hourglass-1', label: 'hourglass 1' }, { favIcon: 'fa-hourglass-2', label: 'hourglass 2' }, { favIcon: 'fa-hourglass-3', label: 'hourglass 3' }, { favIcon: 'fa-hourglass-end', label: 'hourglass end' }, { favIcon: 'fa-hourglass-half', label: 'hourglass half' }, { favIcon: 'fa-hourglass-o', label: 'hourglass o' }, { favIcon: 'fa-hourglass-start', label: 'hourglass start' }, { favIcon: 'fa-houzz', label: 'houzz' }, { favIcon: 'fa-html5', label: 'html5' }, { favIcon: 'fa-i-cursor', label: 'i cursor' }, { favIcon: 'fa-id-badge', label: 'id badge' }, { favIcon: 'fa-id-card', label: 'id card' }, { favIcon: 'fa-id-card-o', label: 'id card o' }, { favIcon: 'fa-ils', label: 'ils' }, { favIcon: 'fa-image', label: 'image' }, { favIcon: 'fa-imdb', label: 'imdb' }, { favIcon: 'fa-inbox', label: 'inbox' }, { favIcon: 'fa-indent', label: 'indent' }, { favIcon: 'fa-industry', label: 'industry' }, { favIcon: 'fa-info', label: 'info' }, { favIcon: 'fa-info-circle', label: 'info circle' }, { favIcon: 'fa-inr', label: 'inr' }, { favIcon: 'fa-instagram', label: 'instagram' }, { favIcon: 'fa-institution', label: 'institution' }, { favIcon: 'fa-internet-explorer', label: 'internet explorer' }, { favIcon: 'fa-ioxhost', label: 'ioxhost' }, { favIcon: 'fa-italic', label: 'italic' }, { favIcon: 'fa-joomla', label: 'joomla' }, { favIcon: 'fa-jpy', label: 'jpy' }, { favIcon: 'fa-jsfiddle', label: 'jsfiddle' }, { favIcon: 'fa-key', label: 'key' }, { favIcon: 'fa-keyboard-o', label: 'keyboard o' }, { favIcon: 'fa-krw', label: 'krw' }, { favIcon: 'fa-language', label: 'language' }, { favIcon: 'fa-laptop', label: 'laptop' }, { favIcon: 'fa-lastfm', label: 'lastfm' }, { favIcon: 'fa-lastfm-square', label: 'lastfm square' }, { favIcon: 'fa-leaf', label: 'leaf' }, { favIcon: 'fa-leanpub', label: 'leanpub' }, { favIcon: 'fa-legal', label: 'legal' }, { favIcon: 'fa-lemon-o', label: 'lemon o' }, { favIcon: 'fa-level-down', label: 'level down' }, { favIcon: 'fa-level-up', label: 'level up' }, { favIcon: 'fa-life-bouy', label: 'life bouy' }, { favIcon: 'fa-life-buoy', label: 'life buoy' }, { favIcon: 'fa-life-ring', label: 'life ring' }, { favIcon: 'fa-life-saver', label: 'life saver' }, { favIcon: 'fa-lightbulb-o', label: 'lightbulb o' }, { favIcon: 'fa-line-chart', label: 'line chart' }, { favIcon: 'fa-link', label: 'link' }, { favIcon: 'fa-linkedin', label: 'linkedin' }, { favIcon: 'fa-linkedin-square', label: 'linkedin square' }, { favIcon: 'fa-linode', label: 'linode' }, { favIcon: 'fa-linux', label: 'linux' }, { favIcon: 'fa-list-alt', label: 'list alt' }, { favIcon: 'fa-list-ol', label: 'list ol' }, { favIcon: 'fa-list-ul', label: 'list ul' }, { favIcon: 'fa-location-arrow', label: 'location arrow' }, { favIcon: 'fa-lock', label: 'lock' }, { favIcon: 'fa-long-arrow-down', label: 'long arrow down' }, { favIcon: 'fa-long-arrow-left', label: 'long arrow left' }, { favIcon: 'fa-long-arrow-right', label: 'long arrow right' }, { favIcon: 'fa-long-arrow-up', label: 'long arrow up' }, { favIcon: 'fa-low-vision', label: 'low vision' }, { favIcon: 'fa-magic', label: 'magic' }, { favIcon: 'fa-magnet', label: 'magnet' }, { favIcon: 'fa-mail-forward', label: 'mail forward' }, { favIcon: 'fa-mail-reply', label: 'mail reply' }, { favIcon: 'fa-mail-reply-all', label: 'mail reply all' }, { favIcon: 'fa-male', label: 'male' }, { favIcon: 'fa-map', label: 'map' }, { favIcon: 'fa-map-marker', label: 'map marker' }, { favIcon: 'fa-map-o', label: 'map o' }, { favIcon: 'fa-map-pin', label: 'map pin' }, { favIcon: 'fa-map-signs', label: 'map signs' }, { favIcon: 'fa-mars', label: 'mars' }, { favIcon: 'fa-mars-double', label: 'mars double' }, { favIcon: 'fa-mars-stroke', label: 'mars stroke' }, { favIcon: 'fa-mars-stroke-h', label: 'mars stroke h' }, { favIcon: 'fa-mars-stroke-v', label: 'mars stroke v' }, { favIcon: 'fa-maxcdn', label: 'maxcdn' }, { favIcon: 'fa-meanpath', label: 'meanpath' }, { favIcon: 'fa-medium', label: 'medium' }, { favIcon: 'fa-medkit', label: 'medkit' }, { favIcon: 'fa-meetup', label: 'meetup' }, { favIcon: 'fa-meh-o', label: 'meh o' }, { favIcon: 'fa-mercury', label: 'mercury' }, { favIcon: 'fa-microchip', label: 'microchip' }, { favIcon: 'fa-microphone', label: 'microphone' }, { favIcon: 'fa-microphone-slash', label: 'microphone slash' }, { favIcon: 'fa-minus', label: 'minus' }, { favIcon: 'fa-minus-circle', label: 'minus circle' }, { favIcon: 'fa-minus-square', label: 'minus square' }, { favIcon: 'fa-minus-square-o', label: 'minus square o' }, { favIcon: 'fa-mixcloud', label: 'mixcloud' }, { favIcon: 'fa-mobile', label: 'mobile' }, { favIcon: 'fa-mobile-phone', label: 'mobile phone' }, { favIcon: 'fa-modx', label: 'modx' }, { favIcon: 'fa-money', label: 'money' }, { favIcon: 'fa-moon-o', label: 'moon o' }, { favIcon: 'fa-mortar-board', label: 'mortar board' }, { favIcon: 'fa-motorcycle', label: 'motorcycle' }, { favIcon: 'fa-mouse-pointer', label: 'mouse pointer' }, { favIcon: 'fa-music', label: 'music' }, { favIcon: 'fa-navicon', label: 'navicon' }, { favIcon: 'fa-neuter', label: 'neuter' }, { favIcon: 'fa-newspaper-o', label: 'newspaper o' }, { favIcon: 'fa-object-group', label: 'object group' }, { favIcon: 'fa-object-ungroup', label: 'object ungroup' }, { favIcon: 'fa-odnoklassniki', label: 'odnoklassniki' }, { favIcon: 'fa-odnoklassniki-square', label: 'odnoklassniki square' }, { favIcon: 'fa-opencart', label: 'opencart' }, { favIcon: 'fa-openid', label: 'openid' }, { favIcon: 'fa-opera', label: 'opera' }, { favIcon: 'fa-optin-monster', label: 'optin monster' }, { favIcon: 'fa-outdent', label: 'outdent' }, { favIcon: 'fa-pagelines', label: 'pagelines' }, { favIcon: 'fa-paint-brush', label: 'paint brush' }, { favIcon: 'fa-paper-plane', label: 'paper plane' }, { favIcon: 'fa-paper-plane-o', label: 'paper plane o' }, { favIcon: 'fa-paperclip', label: 'paperclip' }, { favIcon: 'fa-paragraph', label: 'paragraph' }, { favIcon: 'fa-paste', label: 'paste' }, { favIcon: 'fa-pause', label: 'pause' }, { favIcon: 'fa-pause-circle', label: 'pause circle' }, { favIcon: 'fa-pause-circle-o', label: 'pause circle o' }, { favIcon: 'fa-paw', label: 'paw' }, { favIcon: 'fa-paypal', label: 'paypal' }, { favIcon: 'fa-pencil', label: 'pencil' }, { favIcon: 'fa-pencil-square', label: 'pencil square' }, { favIcon: 'fa-pencil-square-o', label: 'pencil square o' }, { favIcon: 'fa-percent', label: 'percent' }, { favIcon: 'fa-phone', label: 'phone' }, { favIcon: 'fa-phone-square', label: 'phone square' }, { favIcon: 'fa-photo', label: 'photo' }, { favIcon: 'fa-picture-o', label: 'picture o' }, { favIcon: 'fa-pie-chart', label: 'pie chart' }, { favIcon: 'fa-pied-piper', label: 'pied piper' }, { favIcon: 'fa-pied-piper-alt', label: 'pied piper alt' }, { favIcon: 'fa-pinterest', label: 'pinterest' }, { favIcon: 'fa-pinterest-p', label: 'pinterest p' }, { favIcon: 'fa-pinterest-square', label: 'pinterest square' }, { favIcon: 'fa-plane', label: 'plane' }, { favIcon: 'fa-play', label: 'play' }, { favIcon: 'fa-play-circle', label: 'play circle' }, { favIcon: 'fa-play-circle-o', label: 'play circle o' }, { favIcon: 'fa-plug', label: 'plug' }, { favIcon: 'fa-plus', label: 'plus' }, { favIcon: 'fa-plus-circle', label: 'plus circle' }, { favIcon: 'fa-plus-square', label: 'plus square' }, { favIcon: 'fa-plus-square-o', label: 'plus square o' }, { favIcon: 'fa-podcast', label: 'podcast' }, { favIcon: 'fa-power-off', label: 'power off' }, { favIcon: 'fa-print', label: 'print' }, { favIcon: 'fa-product-hunt', label: 'product hunt' }, { favIcon: 'fa-puzzle-piece', label: 'puzzle piece' }, { favIcon: 'fa-qq', label: 'qq' }, { favIcon: 'fa-qrcode', label: 'qrcode' }, { favIcon: 'fa-question', label: 'question' }, { favIcon: 'fa-question-circle', label: 'question circle' }, { favIcon: 'fa-question-circle-o', label: 'question circle o' }, { favIcon: 'fa-quora', label: 'quora' }, { favIcon: 'fa-quote-left', label: 'quote left' }, { favIcon: 'fa-quote-right', label: 'quote right' }, { favIcon: 'fa-ra', label: 'ra' }, { favIcon: 'fa-random', label: 'random' }, { favIcon: 'fa-ravelry', label: 'ravelry' }, { favIcon: 'fa-rebel', label: 'rebel' }, { favIcon: 'fa-recycle', label: 'recycle' }, { favIcon: 'fa-reddit', label: 'reddit' }, { favIcon: 'fa-reddit-alien', label: 'reddit alien' }, { favIcon: 'fa-reddit-square', label: 'reddit square' }, { favIcon: 'fa-refresh', label: 'refresh' }, { favIcon: 'fa-registered', label: 'registered' }, { favIcon: 'fa-remove', label: 'remove' }, { favIcon: 'fa-renren', label: 'renren' }, { favIcon: 'fa-reorder', label: 'reorder' }, { favIcon: 'fa-repeat', label: 'repeat' }, { favIcon: 'fa-reply', label: 'reply' }, { favIcon: 'fa-reply-all', label: 'reply all' }, { favIcon: 'fa-retweet', label: 'retweet' }, { favIcon: 'fa-rmb', label: 'rmb' }, { favIcon: 'fa-road', label: 'road' }, { favIcon: 'fa-rocket', label: 'rocket' }, { favIcon: 'fa-rouble', label: 'rouble' }, { favIcon: 'fa-s15', label: 's15' }, { favIcon: 'fa-safari', label: 'safari' }, { favIcon: 'fa-save', label: 'save' }, { favIcon: 'fa-scissors', label: 'scissors' }, { favIcon: 'fa-scribd', label: 'scribd' }, { favIcon: 'fa-search', label: 'search' }, { favIcon: 'fa-search-minus', label: 'search minus' }, { favIcon: 'fa-search-plus', label: 'search plus' }, { favIcon: 'fa-sellsy', label: 'sellsy' }, { favIcon: 'fa-send', label: 'send' }, { favIcon: 'fa-send-o', label: 'send o' }, { favIcon: 'fa-server', label: 'server' }, { favIcon: 'fa-share', label: 'share' }, { favIcon: 'fa-share-alt', label: 'share alt' }, { favIcon: 'fa-share-alt-square', label: 'share alt square' }, { favIcon: 'fa-share-square', label: 'share square' }, { favIcon: 'fa-shower', label: 'shower' }, { favIcon: 'fa-square-o', label: 'square o' }, { favIcon: 'fa-share-square-o', label: 'share square o' }, { favIcon: 'fa-shekel', label: 'shekel' }, { favIcon: 'fa-sheqel', label: 'sheqel' }, { favIcon: 'fa-shield', label: 'shield' }, { favIcon: 'fa-ship', label: 'ship' }, { favIcon: 'fa-shirtsinbulk', label: 'shirtsinbulk' }, { favIcon: 'fa-shopping-bag', label: 'shopping bag' }, { favIcon: 'fa-shopping-basket', label: 'shopping basket' }, { favIcon: 'fa-shopping-cart', label: 'shopping cart' }, { favIcon: 'fa-sign-in', label: 'sign in' }, { favIcon: 'fa-sign-out', label: 'sign out' }, { favIcon: 'fa-signal', label: 'signal' }, { favIcon: 'fa-sign-language', label: 'sign language' }, { favIcon: 'fa-signing', label: 'signing' }, { favIcon: 'fa-simplybuilt', label: 'simplybuilt' }, { favIcon: 'fa-sitemap', label: 'sitemap' }, { favIcon: 'fa-skyatlas', label: 'skyatlas' }, { favIcon: 'fa-skype', label: 'skype' }, { favIcon: 'fa-slack', label: 'slack' }, { favIcon: 'fa-sliders', label: 'sliders' }, { favIcon: 'fa-slideshare', label: 'slideshare' }, { favIcon: 'fa-smile-o', label: 'smile o' }, { favIcon: 'fa-snapchat', label: 'snapchat' }, { favIcon: 'fa-snapchat-ghost', label: 'snapchat ghost' }, { favIcon: 'fa-snapchat-square', label: 'snapchat square' }, { favIcon: 'fa-snowflake-o', label: 'snowflake o' }, { favIcon: 'fa-soccer-ball-o', label: 'soccer ball o' }, { favIcon: 'fa-sort', label: 'sort' }, { favIcon: 'fa-sort-alpha-asc', label: 'sort alpha asc' }, { favIcon: 'fa-sort-alpha-desc', label: 'sort alpha desc' }, { favIcon: 'fa-sort-amount-asc', label: 'sort amount asc' }, { favIcon: 'fa-sort-amount-desc', label: 'sort amount desc' }, { favIcon: 'fa-sort-asc', label: 'sort asc' }, { favIcon: 'fa-sort-desc', label: 'sort desc' }, { favIcon: 'fa-sort-down', label: 'sort down' }, { favIcon: 'fa-sort-numeric-asc', label: 'sort numeric asc' }, { favIcon: 'fa-sort-numeric-desc', label: 'sort numeric desc' }, { favIcon: 'fa-sort-up', label: 'sort up' }, { favIcon: 'fa-soundcloud', label: 'soundcloud' }, { favIcon: 'fa-space-shuttle', label: 'space shuttle' }, { favIcon: 'fa-spinner', label: 'spinner' }, { favIcon: 'fa-spoon', label: 'spoon' }, { favIcon: 'fa-spotify', label: 'spotify' }, { favIcon: 'fa-square', label: 'square' }, { favIcon: 'fa-stack-exchange', label: 'stack exchange' }, { favIcon: 'fa-stack-overflow', label: 'stack overflow' }, { favIcon: 'fa-star', label: 'star' }, { favIcon: 'fa-star-half', label: 'star half' }, { favIcon: 'fa-star-half-empty', label: 'star half empty' }, { favIcon: 'fa-star-half-full', label: 'star half full' }, { favIcon: 'fa-star-half-o', label: 'star half o' }, { favIcon: 'fa-star-o', label: 'star o' }, { favIcon: 'fa-steam', label: 'steam' }, { favIcon: 'fa-steam-square', label: 'steam square' }, { favIcon: 'fa-step-backward', label: 'step backward' }, { favIcon: 'fa-step-forward', label: 'step forward' }, { favIcon: 'fa-stethoscope', label: 'stethoscope' }, { favIcon: 'fa-sticky-note', label: 'sticky note' }, { favIcon: 'fa-sticky-note-o', label: 'sticky note o' }, { favIcon: 'fa-stop', label: 'stop' }, { favIcon: 'fa-stop-circle', label: 'stop circle' }, { favIcon: 'fa-stop-circle-o', label: 'stop circle o' }, { favIcon: 'fa-street-view', label: 'street view' }, { favIcon: 'fa-strikethrough', label: 'strikethrough' }, { favIcon: 'fa-stumbleupon', label: 'stumbleupon' }, { favIcon: 'fa-stumbleupon-circle', label: 'stumbleupon circle' }, { favIcon: 'fa-subscript', label: 'subscript' }, { favIcon: 'fa-subway', label: 'subway' }, { favIcon: 'fa-suitcase', label: 'suitcase' }, { favIcon: 'fa-sun-o', label: 'sun o' }, { favIcon: 'fa-superpowers', label: 'superpowers' }, { favIcon: 'fa-superscript', label: 'superscript' }, { favIcon: 'fa-support', label: 'support' }, { favIcon: 'fa-table', label: 'table' }, { favIcon: 'fa-tablet', label: 'tablet' }, { favIcon: 'fa-tachometer', label: 'tachometer' }, { favIcon: 'fa-tag', label: 'tag' }, { favIcon: 'fa-tags', label: 'tags' }, { favIcon: 'fa-tasks', label: 'tasks' }, { favIcon: 'fa-taxi', label: 'taxi' }, { favIcon: 'fa-telegram', label: 'telegram' }, { favIcon: 'fa-television', label: 'television' }, { favIcon: 'fa-tencent-weibo', label: 'tencent weibo' }, { favIcon: 'fa-terminal', label: 'terminal' }, { favIcon: 'fa-text-height', label: 'text height' }, { favIcon: 'fa-text-width', label: 'text width' }, { favIcon: 'fa-th', label: 'th' }, { favIcon: 'fa-th-large', label: 'th large' }, { favIcon: 'fa-th-list', label: 'th list' }, { favIcon: 'fa-themeisle', label: 'themeisle' }, { favIcon: 'fa-thermometer', label: 'thermometer' }, { favIcon: 'fa-thermometer-0', label: 'thermometer 0' }, { favIcon: 'fa-thermometer-1', label: 'thermometer 1' }, { favIcon: 'fa-thermometer-2', label: 'thermometer 2' }, { favIcon: 'fa-thermometer-3', label: 'thermometer 3' }, { favIcon: 'fa-thermometer-4', label: 'thermometer 4' }, { favIcon: 'fa-thermometer-empty', label: 'thermometer empty' }, { favIcon: 'fa-thermometer-full', label: 'thermometer full' }, { favIcon: 'fa-thermometer-half', label: 'thermometer half' }, { favIcon: 'fa-thermometer-quarter', label: 'thermometer quarter' }, { favIcon: 'fa-thermometer-three-quarters', label: 'thermometer three quarters' }, { favIcon: 'fa-thumb-tack', label: 'thumb tack' }, { favIcon: 'fa-thumbs-down', label: 'thumbs down' }, { favIcon: 'fa-thumbs-o-down', label: 'thumbs o down' }, { favIcon: 'fa-thumbs-o-up', label: 'thumbs o up' }, { favIcon: 'fa-thumbs-up', label: 'thumbs up' }, { favIcon: 'fa-ticket', label: 'ticket' }, { favIcon: 'fa-times', label: 'times' }, { favIcon: 'fa-times-circle', label: 'times circle' }, { favIcon: 'fa-times-circle-o', label: 'times circle o' }, { favIcon: 'fa-times-rectangle', label: 'times rectangle' }, { favIcon: 'fa-times-rectangle-o', label: 'times rectangle o' }, { favIcon: 'fa-tint', label: 'tint' }, { favIcon: 'fa-toggle-down', label: 'toggle down' }, { favIcon: 'fa-toggle-left', label: 'toggle left' }, { favIcon: 'fa-toggle-off', label: 'toggle off' }, { favIcon: 'fa-toggle-on', label: 'toggle on' }, { favIcon: 'fa-toggle-right', label: 'toggle right' }, { favIcon: 'fa-toggle-up', label: 'toggle up' }, { favIcon: 'fa-trademark', label: 'trademark' }, { favIcon: 'fa-train', label: 'train' }, { favIcon: 'fa-transgender', label: 'transgender' }, { favIcon: 'fa-transgender-alt', label: 'transgender alt' }, { favIcon: 'fa-trash', label: 'trash' }, { favIcon: 'fa-trash-o', label: 'trash o' }, { favIcon: 'fa-tree', label: 'tree' }, { favIcon: 'fa-trello', label: 'trello' }, { favIcon: 'fa-tripadvisor', label: 'tripadvisor' }, { favIcon: 'fa-trophy', label: 'trophy' }, { favIcon: 'fa-truck', label: 'truck' }, { favIcon: 'fa-try', label: 'try' }, { favIcon: 'fa-tty', label: 'tty' }, { favIcon: 'fa-tv', label: 'tv' }, { favIcon: 'fa-tumblr', label: 'tumblr' }, { favIcon: 'fa-tumblr-square', label: 'tumblr square' }, { favIcon: 'fa-turkish-lira', label: 'turkish lira' }, { favIcon: 'fa-twitch', label: 'twitch' }, { favIcon: 'fa-twitter', label: 'twitter' }, { favIcon: 'fa-twitter-square', label: 'twitter square' }, { favIcon: 'fa-venus', label: 'venus' }, { favIcon: 'fa-venus-double', label: 'venus double' }, { favIcon: 'fa-venus-mars', label: 'venus mars' }, { favIcon: 'fa-viacoin', label: 'viacoin' }, { favIcon: 'fa-viadeo', label: 'viadeo' }, { favIcon: 'fa-viadeo-square', label: 'viadeo square' }, { favIcon: 'fa-video-camera', label: 'video camera' }, { favIcon: 'fa-vimeo', label: 'vimeo' }, { favIcon: 'fa-vimeo-square', label: 'vimeo square' }, { favIcon: 'fa-vine', label: 'vine' }, { favIcon: 'fa-vk', label: 'vk' }, { favIcon: 'fa-volume-control-phone', label: 'volume control phone' }, { favIcon: 'fa-volume-down', label: 'volume down' }, { favIcon: 'fa-volume-off', label: 'volume off' }, { favIcon: 'fa-volume-up', label: 'volume up' }, { favIcon: 'fa-umbrella', label: 'umbrella' }, { favIcon: 'fa-underline', label: 'underline' }, { favIcon: 'fa-undo', label: 'undo' }, { favIcon: 'fa-university', label: 'university' }, { favIcon: 'fa-universal-access', label: 'universal access' }, { favIcon: 'fa-unlink', label: 'unlink' }, { favIcon: 'fa-unlock', label: 'unlock' }, { favIcon: 'fa-unlock-alt', label: 'unlock alt' }, { favIcon: 'fa-unsorted', label: 'unsorted' }, { favIcon: 'fa-upload', label: 'upload' }, { favIcon: 'fa-usb', label: 'usb' }, { favIcon: 'fa-usd', label: 'usd' }, { favIcon: 'fa-user', label: 'user' }, { favIcon: 'fa-user-circle', label: 'user circle' }, { favIcon: 'fa-user-circle-o', label: 'user circle o' }, { favIcon: 'fa-user-md', label: 'user md' }, { favIcon: 'fa-user-o', label: 'user o' }, { favIcon: 'fa-user-plus', label: 'user plus' }, { favIcon: 'fa-user-secret', label: 'user secret' }, { favIcon: 'fa-user-times', label: 'user times' }, { favIcon: 'fa-users', label: 'users' }, { favIcon: 'fa-vcard', label: 'vcard' }, { favIcon: 'fa-vcard-o', label: 'vcard o' }, { favIcon: 'fa-warning', label: 'warning' }, { favIcon: 'fa-wechat', label: 'wechat' }, { favIcon: 'fa-weibo', label: 'weibo' }, { favIcon: 'fa-weixin', label: 'weixin' }, { favIcon: 'fa-whatsapp', label: 'whatsapp' }, { favIcon: 'fa-wheelchair', label: 'wheelchair' }, { favIcon: 'fa-wheelchair-alt', label: 'wheelchair alt' }, { favIcon: 'fa-wifi', label: 'wifi' }, { favIcon: 'fa-wikipedia-w', label: 'wikipedia w' }, { favIcon: 'fa-window-close', label: 'window close' }, { favIcon: 'fa-window-close-o', label: 'window close o' }, { favIcon: 'fa-window-maximize', label: 'window maximize' }, { favIcon: 'fa-window-minimize', label: 'window minimize' }, { favIcon: 'fa-window-restore', label: 'window restore' }, { favIcon: 'fa-windows', label: 'windows' }, { favIcon: 'fa-won', label: 'won' }, { favIcon: 'fa-wordpress', label: 'wordpress' }, { favIcon: 'fa-wpbeginner', label: 'wpbeginner' }, { favIcon: 'fa-wpexplorer', label: 'wpexplorer' }, { favIcon: 'fa-wpforms', label: 'wpforms' }, { favIcon: 'fa-wrench', label: 'wrench' }, { favIcon: 'fa-xing', label: 'xing' }, { favIcon: 'fa-xing-square', label: 'xing square' }, { favIcon: 'fa-y-combinator', label: 'y combinator' }, { favIcon: 'fa-y-combinator-square', label: 'y combinator square' }, { favIcon: 'fa-yahoo', label: 'yahoo' }, { favIcon: 'fa-yc', label: 'yc' }, { favIcon: 'fa-yc-square', label: 'yc square' }, { favIcon: 'fa-yelp', label: 'yelp' }, { favIcon: 'fa-yen', label: 'yen' }, { favIcon: 'fa-yoast', label: 'yoast' }, { favIcon: 'fa-youtube', label: 'youtube' }, { favIcon: 'fa-youtube-play', label: 'youtube play' }, { favIcon: 'fa-youtube-square', label: 'youtube square' }];
/* unused harmony default export */ var _unused_webpack_default_export = (data);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = [{
                'DisplayPlan': { true: true, false: true },
                'Title': { FR: 'Régulier', EN: 'Regular Service' },
                'DisplayButton': { true: false, false: false },
                'PlanTemplate': 'EndUser_000_V02P00',
                'PlanPricing': { true: 0, false: 0 },
                'Description': [{ 'text1': { FR: 'Historique de consultation :', EN: 'Data historic :' },
                                'text2': { FR: '1 an', EN: '1 year' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: "Niveau d'alerte:", EN: 'Available alert level:' },
                                'text2': { FR: 'Niveau 1', EN: 'Level 1' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Alerte configurable :', EN: 'Configurable alert :' },
                                'text2': { FR: '1 par port, 3 par module', EN: '1 per port, 3 per module' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Alerte email maximum :', EN: 'Maximum email alert :' },
                                'text2': { FR: '50', EN: '50' },
                                'text3': { FR: 'par mois', EN: 'per month' } }, { 'text1': { FR: 'Rapport hebdomadaire', EN: 'Weekly report:' },
                                'text2': { FR: 'Simplifié', EN: 'Simple' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Plateforme pour véhicule électrique', EN: 'Electric vehicle platform' },
                                'text2': { FR: '', EN: '' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Garantie sur le matériel', EN: 'Material warranty' },
                                'text2': { FR: '1 an', EN: '1 year' },
                                'text3': { FR: '', EN: '' } }]
}, {
                'DisplayPlan': { true: true, false: true },
                'Title': { FR: 'Client Premium', EN: 'Premium Customer' },
                'DisplayButton': { true: true, false: true },
                'PlanTemplate': 'EndUser_030_V02P00',
                'PlanPricing': { true: '60', false: '8' },
                'Description': [{ 'text1': { FR: 'Historique de consultation :', EN: 'Data historic :' },
                                'text2': { FR: 'illimité', EN: 'unlimited' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: "Niveau d'alerte:", EN: 'Available alert level:' },
                                'text2': { FR: 'Niveau 2', EN: 'Level 2' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Alerte configurable :', EN: 'Configurable alert :' },
                                'text2': { FR: 'illimité', EN: 'unlimited' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Alerte email maximum :', EN: 'Maximum email alert :' },
                                'text2': { FR: 'illimité', EN: 'unlimited' },
                                'text3': { FR: 'par mois', EN: 'per month' } }, { 'text1': { FR: 'Alerte SMS :', EN: 'SMS alert :' },
                                'text2': { FR: '100', EN: '100' },
                                'text3': { FR: 'max par mois', EN: 'max per month' } }, { 'text1': { FR: 'Rapport hebdomadaire', EN: 'Weekly report' },
                                'text2': { FR: 'avec comparatif semaines précédentes', EN: 'with last weeks comparison' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Données météo :', EN: 'Weather data :' },
                                'text2': { FR: 'température, vent, humidité, ennuagement', EN: 'temperature, wind, humidity, cloud' },
                                'text3': { FR: 'enregistrés aux heures', EN: 'hourly recorded' } }, { 'text1': { FR: 'Plateforme pour véhicule électrique', EN: 'Electric vehicle platform' },
                                'text2': { FR: '', EN: '' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: "Tableau des données de mesure", EN: 'Measurement data table' },
                                'text2': { FR: '', EN: '' },
                                'text3': { FR: '(copiez vos données dans Excel)', EN: '(copy your data in Excel)' } }, { 'text1': { FR: "Émission d'alerte courriel vers d'autres usagers EV Sens", EN: 'Alert transmission to other EV Sens users' },
                                'text2': { FR: '', EN: '' },
                                'text3': { FR: '', EN: '' } }, { 'text1': { FR: 'Garantie sur le matériel', EN: 'Material warranty' },
                                'text2': { FR: "pour la durée de l'abonnement Premium", EN: 'for the entire Premium subscription' },
                                'text3': { FR: '', EN: '' } }]
}];
/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 299,
	"./af.js": 299,
	"./ar": 306,
	"./ar-dz": 300,
	"./ar-dz.js": 300,
	"./ar-kw": 301,
	"./ar-kw.js": 301,
	"./ar-ly": 302,
	"./ar-ly.js": 302,
	"./ar-ma": 303,
	"./ar-ma.js": 303,
	"./ar-sa": 304,
	"./ar-sa.js": 304,
	"./ar-tn": 305,
	"./ar-tn.js": 305,
	"./ar.js": 306,
	"./az": 307,
	"./az.js": 307,
	"./be": 308,
	"./be.js": 308,
	"./bg": 309,
	"./bg.js": 309,
	"./bm": 310,
	"./bm.js": 310,
	"./bn": 311,
	"./bn.js": 311,
	"./bo": 312,
	"./bo.js": 312,
	"./br": 313,
	"./br.js": 313,
	"./bs": 314,
	"./bs.js": 314,
	"./ca": 315,
	"./ca.js": 315,
	"./cs": 316,
	"./cs.js": 316,
	"./cv": 317,
	"./cv.js": 317,
	"./cy": 318,
	"./cy.js": 318,
	"./da": 319,
	"./da.js": 319,
	"./de": 322,
	"./de-at": 320,
	"./de-at.js": 320,
	"./de-ch": 321,
	"./de-ch.js": 321,
	"./de.js": 322,
	"./dv": 323,
	"./dv.js": 323,
	"./el": 324,
	"./el.js": 324,
	"./en-au": 325,
	"./en-au.js": 325,
	"./en-ca": 326,
	"./en-ca.js": 326,
	"./en-gb": 327,
	"./en-gb.js": 327,
	"./en-ie": 328,
	"./en-ie.js": 328,
	"./en-il": 329,
	"./en-il.js": 329,
	"./en-in": 330,
	"./en-in.js": 330,
	"./en-nz": 331,
	"./en-nz.js": 331,
	"./en-sg": 332,
	"./en-sg.js": 332,
	"./eo": 333,
	"./eo.js": 333,
	"./es": 336,
	"./es-do": 334,
	"./es-do.js": 334,
	"./es-us": 335,
	"./es-us.js": 335,
	"./es.js": 336,
	"./et": 337,
	"./et.js": 337,
	"./eu": 338,
	"./eu.js": 338,
	"./fa": 339,
	"./fa.js": 339,
	"./fi": 340,
	"./fi.js": 340,
	"./fil": 341,
	"./fil.js": 341,
	"./fo": 342,
	"./fo.js": 342,
	"./fr": 345,
	"./fr-ca": 343,
	"./fr-ca.js": 343,
	"./fr-ch": 344,
	"./fr-ch.js": 344,
	"./fr.js": 345,
	"./fy": 346,
	"./fy.js": 346,
	"./ga": 347,
	"./ga.js": 347,
	"./gd": 348,
	"./gd.js": 348,
	"./gl": 349,
	"./gl.js": 349,
	"./gom-deva": 350,
	"./gom-deva.js": 350,
	"./gom-latn": 351,
	"./gom-latn.js": 351,
	"./gu": 352,
	"./gu.js": 352,
	"./he": 353,
	"./he.js": 353,
	"./hi": 354,
	"./hi.js": 354,
	"./hr": 355,
	"./hr.js": 355,
	"./hu": 356,
	"./hu.js": 356,
	"./hy-am": 357,
	"./hy-am.js": 357,
	"./id": 358,
	"./id.js": 358,
	"./is": 359,
	"./is.js": 359,
	"./it": 361,
	"./it-ch": 360,
	"./it-ch.js": 360,
	"./it.js": 361,
	"./ja": 362,
	"./ja.js": 362,
	"./jv": 363,
	"./jv.js": 363,
	"./ka": 364,
	"./ka.js": 364,
	"./kk": 365,
	"./kk.js": 365,
	"./km": 366,
	"./km.js": 366,
	"./kn": 367,
	"./kn.js": 367,
	"./ko": 368,
	"./ko.js": 368,
	"./ku": 369,
	"./ku.js": 369,
	"./ky": 370,
	"./ky.js": 370,
	"./lb": 371,
	"./lb.js": 371,
	"./lo": 372,
	"./lo.js": 372,
	"./lt": 373,
	"./lt.js": 373,
	"./lv": 374,
	"./lv.js": 374,
	"./me": 375,
	"./me.js": 375,
	"./mi": 376,
	"./mi.js": 376,
	"./mk": 377,
	"./mk.js": 377,
	"./ml": 378,
	"./ml.js": 378,
	"./mn": 379,
	"./mn.js": 379,
	"./mr": 380,
	"./mr.js": 380,
	"./ms": 382,
	"./ms-my": 381,
	"./ms-my.js": 381,
	"./ms.js": 382,
	"./mt": 383,
	"./mt.js": 383,
	"./my": 384,
	"./my.js": 384,
	"./nb": 385,
	"./nb.js": 385,
	"./ne": 386,
	"./ne.js": 386,
	"./nl": 388,
	"./nl-be": 387,
	"./nl-be.js": 387,
	"./nl.js": 388,
	"./nn": 389,
	"./nn.js": 389,
	"./oc-lnc": 390,
	"./oc-lnc.js": 390,
	"./pa-in": 391,
	"./pa-in.js": 391,
	"./pl": 392,
	"./pl.js": 392,
	"./pt": 394,
	"./pt-br": 393,
	"./pt-br.js": 393,
	"./pt.js": 394,
	"./ro": 395,
	"./ro.js": 395,
	"./ru": 396,
	"./ru.js": 396,
	"./sd": 397,
	"./sd.js": 397,
	"./se": 398,
	"./se.js": 398,
	"./si": 399,
	"./si.js": 399,
	"./sk": 400,
	"./sk.js": 400,
	"./sl": 401,
	"./sl.js": 401,
	"./sq": 402,
	"./sq.js": 402,
	"./sr": 404,
	"./sr-cyrl": 403,
	"./sr-cyrl.js": 403,
	"./sr.js": 404,
	"./ss": 405,
	"./ss.js": 405,
	"./sv": 406,
	"./sv.js": 406,
	"./sw": 407,
	"./sw.js": 407,
	"./ta": 408,
	"./ta.js": 408,
	"./te": 409,
	"./te.js": 409,
	"./tet": 410,
	"./tet.js": 410,
	"./tg": 411,
	"./tg.js": 411,
	"./th": 412,
	"./th.js": 412,
	"./tk": 413,
	"./tk.js": 413,
	"./tl-ph": 414,
	"./tl-ph.js": 414,
	"./tlh": 415,
	"./tlh.js": 415,
	"./tr": 416,
	"./tr.js": 416,
	"./tzl": 417,
	"./tzl.js": 417,
	"./tzm": 419,
	"./tzm-latn": 418,
	"./tzm-latn.js": 418,
	"./tzm.js": 419,
	"./ug-cn": 420,
	"./ug-cn.js": 420,
	"./uk": 421,
	"./uk.js": 421,
	"./ur": 422,
	"./ur.js": 422,
	"./uz": 424,
	"./uz-latn": 423,
	"./uz-latn.js": 423,
	"./uz.js": 424,
	"./vi": 425,
	"./vi.js": 425,
	"./x-pseudo": 426,
	"./x-pseudo.js": 426,
	"./yo": 427,
	"./yo.js": 427,
	"./zh-cn": 428,
	"./zh-cn.js": 428,
	"./zh-hk": 429,
	"./zh-hk.js": 429,
	"./zh-mo": 430,
	"./zh-mo.js": 430,
	"./zh-tw": 431,
	"./zh-tw.js": 431
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;

/***/ }),
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1058),
  /* template */
  __webpack_require__(1487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1059),
  /* template */
  __webpack_require__(1492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1246)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(1574),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(1578),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1244)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(1572),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1556),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(1526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1198)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(1490),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(952),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(1543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1251)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(1582),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(1564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(1566),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1195)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(1485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(1512),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(1521),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1206)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1247)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(1575),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1205)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(1503),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(970),
  /* template */
  __webpack_require__(1560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1193)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(1482),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1252)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(974),
  /* template */
  __webpack_require__(1583),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1231)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(975),
  /* template */
  __webpack_require__(1551),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73d7efb6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(1554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(978),
  /* template */
  __webpack_require__(1557),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(979),
  /* template */
  __webpack_require__(1479),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(1580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(983),
  /* template */
  __webpack_require__(1549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(1480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(985),
  /* template */
  __webpack_require__(1519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(986),
  /* template */
  __webpack_require__(1591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(987),
  /* template */
  __webpack_require__(1536),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(988),
  /* template */
  __webpack_require__(1507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(989),
  /* template */
  __webpack_require__(1577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(990),
  /* template */
  __webpack_require__(1534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1200)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(991),
  /* template */
  __webpack_require__(1494),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(992),
  /* template */
  __webpack_require__(1502),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(993),
  /* template */
  __webpack_require__(1541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(994),
  /* template */
  __webpack_require__(1567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(995),
  /* template */
  __webpack_require__(1505),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(996),
  /* template */
  __webpack_require__(1501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(999),
  /* template */
  __webpack_require__(1525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1001),
  /* template */
  __webpack_require__(1585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1002),
  /* template */
  __webpack_require__(1513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1003),
  /* template */
  __webpack_require__(1592),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(1538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1227)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(1545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1248)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1006),
  /* template */
  __webpack_require__(1576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b27242e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1210)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1007),
  /* template */
  __webpack_require__(1511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(1496),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1009),
  /* template */
  __webpack_require__(1506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1010),
  /* template */
  __webpack_require__(1552),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1013),
  /* template */
  __webpack_require__(1539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1014),
  /* template */
  __webpack_require__(1491),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1016),
  /* template */
  __webpack_require__(1481),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1018),
  /* template */
  __webpack_require__(1486),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1019),
  /* template */
  __webpack_require__(1565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1021),
  /* template */
  __webpack_require__(1524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1023),
  /* template */
  __webpack_require__(1497),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21b642f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1025),
  /* template */
  __webpack_require__(1579),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1026),
  /* template */
  __webpack_require__(1489),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1027),
  /* template */
  __webpack_require__(1514),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1221)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1028),
  /* template */
  __webpack_require__(1529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1030),
  /* template */
  __webpack_require__(1518),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1032),
  /* template */
  __webpack_require__(1532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1033),
  /* template */
  __webpack_require__(1484),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1034),
  /* template */
  __webpack_require__(1535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1035),
  /* template */
  __webpack_require__(1561),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1250)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1036),
  /* template */
  __webpack_require__(1581),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1037),
  /* template */
  __webpack_require__(1531),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1038),
  /* template */
  __webpack_require__(1569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1039),
  /* template */
  __webpack_require__(1544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1040),
  /* template */
  __webpack_require__(1499),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1041),
  /* template */
  __webpack_require__(1540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1042),
  /* template */
  __webpack_require__(1587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1256)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1043),
  /* template */
  __webpack_require__(1593),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1044),
  /* template */
  __webpack_require__(1523),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1192)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1046),
  /* template */
  __webpack_require__(1478),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1047),
  /* template */
  __webpack_require__(1555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1048),
  /* template */
  __webpack_require__(1527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1229)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1049),
  /* template */
  __webpack_require__(1547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1050),
  /* template */
  __webpack_require__(1548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1204)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1051),
  /* template */
  __webpack_require__(1500),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2388a3d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1052),
  /* template */
  __webpack_require__(1483),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1053),
  /* template */
  __webpack_require__(1493),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1056),
  /* template */
  __webpack_require__(1584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayPlanCfg === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPlanCfg) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.togglePlanDisplay()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelFieldTitleBillPlan[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayPlanCfg) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [(_vm.flagDisplaySelectPlan == true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12 control-label",
    attrs: {
      "for": "val-select2"
    }
  }, [_vm._v(_vm._s(this.textLabelPreRecordedPlan[this.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.elecPlanToAddIndex),
      expression: "elecPlanToAddIndex"
    }],
    staticClass: "js-select2 form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "val-select2",
      "name": "val-select2",
      "data-placeholder": "Choose one.."
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.elecPlanToAddIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectPlan[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.electricalPlanDefinitions), function(plan, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(plan.planTitle[_vm.actualLanguage]))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-md btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addPreRecordedPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelApplyButtonBillPlan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-md btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplaySelectPlan = false
      }
    }
  }, [_vm._v(_vm._s(_vm.labelCancelButtonBillPlan[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySelectPlan == false) ? _c('div', [_vm._l((_vm.actualBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.pricingPlan), function(planLine, index) {
    return _c('div', {
      key: index
    }, [(index === 0) ? _c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('h4', {
      staticClass: "h3 font-w300 push"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleBasePrice[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "h3 col-xs-12 col-md-4"
    }, [_c('div', {
      staticClass: "h4 form-material"
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.labelFieldTitleTarif[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.price),
        expression: "planLine.price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (planLine.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(planLine, "price", $event.target.value)
        }
      }
    })])])])]) : _c('div', {
      staticClass: "row push"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12  items-push"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.type),
        expression: "planLine.type"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "id": "example-select",
        "name": "example-select",
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.labelFieldOptionHoraire[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.labelFieldOptionTemperature[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleTarif[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.price),
        expression: "planLine.price"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (planLine.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(planLine, "price", $event.target.value)
        }
      }
    })])])])]), _vm._v(" "), (planLine.type === '0') ? _c('div', {
      staticClass: "col-xs-12  items-push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleStartMonth[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.startMonth),
        expression: "planLine.startMonth"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "startMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.monthOptions), function(month) {
      return _c('option', {
        domProps: {
          "value": month.value
        }
      }, [_vm._v(_vm._s(month.text))])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleEndMonth[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.endMonth),
        expression: "planLine.endMonth"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "endMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.monthOptions), function(month) {
      return _c('option', {
        domProps: {
          "value": month.value
        }
      }, [_vm._v(_vm._s(month.text))])
    }), 0)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleStartDay[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.startDay),
        expression: "planLine.startDay"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "startDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.dayOptions), function(day) {
      return _c('option', {
        domProps: {
          "value": day.value
        }
      }, [_vm._v(_vm._s(day.text))])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleEndDay[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.endDay),
        expression: "planLine.endDay"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "endDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.dayOptions), function(day) {
      return _c('option', {
        domProps: {
          "value": day.value
        }
      }, [_vm._v(_vm._s(day.text))])
    }), 0)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleStartHour[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.startHour),
        expression: "planLine.startHour"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "startHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.hourOptions), function(hour) {
      return _c('option', {
        domProps: {
          "value": hour.value
        }
      }, [_vm._v(_vm._s(hour.text))])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "h3 col-xs-12"
    }, [_vm._v(_vm._s(_vm.labelFieldTitleEndHour[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "h3 col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.endHour),
        expression: "planLine.endHour"
      }],
      staticClass: "h3 form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "endHour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.hourOptions), function(hour) {
      return _c('option', {
        domProps: {
          "value": hour.value
        }
      }, [_vm._v(_vm._s(hour.text))])
    }), 0)])])])]) : _vm._e(), _vm._v(" "), (planLine.type === '1') ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12"
    }, [_vm._v("Condition")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.tempCondition),
        expression: "planLine.tempCondition"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(planLine, "tempCondition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.labelFieldOptionUnder[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.labelFieldOptionOver[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-text-input2"
      }
    }, [_vm._v(_vm._s(_vm.labelFieldTitleTempThld[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (planLine.tempThreshold),
        expression: "planLine.tempThreshold"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "example-text-input2"
      },
      domProps: {
        "value": (planLine.tempThreshold)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(planLine, "tempThreshold", $event.target.value)
        }
      }
    })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [(index > 0) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('button', {
      staticClass: "h4 btn btn align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.removePlanLine(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelFieldButtonDelete[_vm.actualLanguage]))])]) : _vm._e()])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('button', {
    staticClass: "h4 btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": _vm.addPlanLine
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonAddCond[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('button', {
    staticClass: "h4 btn btn-block btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectPreRecordedPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelSelectPreRecBillPlan[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('label', {
    staticClass: "h4 col-xs-12",
    attrs: {
      "for": "example-text-input2"
    }
  }, [_vm._v(_vm._s(_vm.labelCopyPlanFromAnotherModule[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "h4 col-xs-12 col-md-6"
  }, [_c('button', {
    staticClass: "h4 btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": _vm.copyPlanFromAnothermodule
    }
  }, [_c('i', {
    staticClass: "fa fa-copy fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCopyPlanFromModule[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleIndexToCopyPlan),
      expression: "moduleIndexToCopyPlan"
    }],
    staticClass: "h4 form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleIndexToCopyPlan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.actualBundle.devices), function(device, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(device.ReferenceName))])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('label', {
    staticClass: "h3 col-xs-12",
    attrs: {
      "for": "example-text-input2"
    }
  }, [_vm._v(_vm._s(_vm.labelApplyActualPlanToOtherModule[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-md-12"
  }, [_c('button', {
    staticClass: "h4 btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": _vm.applyThisPlanToAll
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonApplyPlanAllDevice[_vm.actualLanguage]))])])])])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  })]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
}]}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySectionTransactions === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTransactions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySectionTransactions) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTransactions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTransactions()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelTransactions[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionTransactions) ? _c('div', {
    staticClass: "block-content"
  }, _vm._l((_vm.transactions), function(transaction, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleDisplayTransaction(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dollar"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayTransaction(index)
        }
      }
    }, [_vm._v(_vm._s(transaction.subscription) + ":" + _vm._s(transaction.timestamp))])]), _vm._v(" "), (_vm.transactionOpenFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "table-responsive push-50"
    }, [_c('table', {
      staticClass: "table table-bordered table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.textLabelProduct[[_vm.actualLanguage]]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceQuantity[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceUnitPrice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.InvoicePrice[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_vm._l((transaction.detailLines), function(transactionLine, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('p', {
        staticClass: "font-w600 push-10"
      }, [_vm._v(_vm._s(transactionLine.description[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "badge badge-primary"
      }, [_vm._v(_vm._s(transactionLine.quantity))])]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(transactionLine.unitPrice))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(transactionLine.unitPrice * transactionLine.quantity))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceSubTotal[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.subTotal))])]), _vm._v(" "), (transaction.tps > 0) ? _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("TPS (5%)")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.tps))])]) : _vm._e(), _vm._v(" "), (transaction.tvq > 0) ? _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("TVQ (9.975%)")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.tvq))])]) : _vm._e(), _vm._v(" "), _vm._l((transaction.taxesList), function(taxLine, index2) {
      return _c('tr', [_c('td', {
        staticClass: "font-w600 text-right",
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(taxLine.Label[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(taxLine.Amount))])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "active"
    }, [_c('td', {
      staticClass: "font-w700 text-uppercase text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
      staticClass: "font-w700 text-right"
    }, [_vm._v("$ " + _vm._s(transaction.total))])])], 2)]), _vm._v(" "), _c('div', [_c('h6', {
      staticClass: "block-title text-left"
    }, [_vm._v(_vm._s(_vm.CardInfoPaidBy[_vm.actualLanguage]) + _vm._s(transaction.cardData.CardType))]), _vm._v(" "), _c('h6', {
      staticClass: "block-title text-left"
    }, [_vm._v(_vm._s(_vm.CardInfoLast4[_vm.actualLanguage]) + _vm._s(transaction.cardData.CardLast4))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col-lg-6 align-right"
    }, [_c('button', {
      staticClass: "btn btn-md btn-success align-right",
      attrs: {
        "type": "button",
        "title": "Download PDF"
      },
      on: {
        "click": function($event) {
          return _vm.generatePdfInvoice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download PDF Invoice")])])])]) : _vm._e()])
  }), 0) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelExplanation[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelAddTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelTagName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagName),
      expression: "tagName"
    }],
    staticClass: "form-control align-left ",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tagName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelTagDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagDescription),
      expression: "tagDescription"
    }],
    staticClass: "form-control align-left",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tagDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default margin-bottom",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addUnitTag()
      }
    }
  }, [(_vm.tagIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddUnitTag[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTagListTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTagColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.tableTagColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableTagColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tagList), function(Tag, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Tag.tagName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Tag.tagDescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteUnitTag(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])])])])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.mainService.reference_name))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagDisplayDetail === 0) ? _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-dafault align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfig[_vm.actualLanguage]))]), _vm._v(" "), (_vm.displayTab) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bar-chart-o"
  }), _vm._v(" " + _vm._s(_vm.tabLabelMenuVisualisation[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" " + _vm._s(_vm.tabLabelMenuInvoices[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" " + _vm._s(_vm.tabLabelMenuSubService[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[0] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('main-service-display-tab-graphs', {
    attrs: {
      "mainService": _vm.mainService
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[1] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('main-service-display-tab-invoices', {
    attrs: {
      "mainService": _vm.mainService
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Liste des sous services")]), _vm._v(" "), (_vm.subServiceListIsLoading) ? _c('spinner') : _c('div', _vm._l((_vm.subServiceList), function(subService, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('sub-service-display', {
      attrs: {
        "subService": subService
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSubService(index)
        }
      }
    }, [(_vm.serviceIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  }), 0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addSubService
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddSubService[_vm.actualLanguage]))])])], 1)])])])]) : _vm._e()]) : _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfigClose[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Configuration service ID: " + _vm._s(_vm.mainService.service_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelRefenrenceName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainService.reference_name),
      expression: "mainService.reference_name"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.mainService.reference_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mainService, "reference_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-6",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedChannel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mainService.linked_channel_id),
      expression: "mainService.linked_channel_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mainService, "linked_channel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Aucun/None"
    }
  }, [_vm._v("Aucun/None")]), _vm._v(" "), _vm._l((_vm.actualBundle.channels), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.ChannelData.channelId
      }
    }, [_vm._v(_vm._s(channel.ReferenceName))])
  })], 2)])])]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.mainService.options), function(category, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12 push"
    }, [_c('h5', {}, [_c('u', [_vm._v(_vm._s(category.categoryTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
      staticClass: "push-30"
    }, [_vm._v(_vm._s(category.categoryDescription[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((category.options), function(Option, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [(Option.valueType == 'bool') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(Option.value) ? _vm._i(Option.value, null) > -1 : (Option.value)
        },
        on: {
          "change": function($event) {
            var $$a = Option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(Option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(Option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(Option, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span'), _vm._v(" "), (Option.value) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'stringNumber') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control align-center",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (Option.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Option, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'listString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_vm._v("\r\n                                  " + _vm._s(Option) + "\r\n                                ")]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveMainServiceModifications()
      }
    }
  }, [(_vm.serviceIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelMaintenance[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelInterventionTime[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workTime),
      expression: "workTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hr"
    },
    domProps: {
      "value": (_vm.workTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workTime = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelCommentLog()
      }
    }
  }, [(_vm.commentIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-comment fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [(_vm.deviceSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayDevice === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDevice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayDevice) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDevice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDevice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-server fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.devices[_vm.deviceIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayDevice) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].ReferenceName),
      expression: "tempoBundle.devices[deviceIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (true) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12 col-md-12"
  }, [_vm._v(_vm._s(_vm.textLabelModuleName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.name),
      expression: "tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelModuleID[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelModuleSN[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.serialNumber))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "200px",
      "src": _vm._f("s3Image")(("organization_img/" + (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.devicePicture)))
    }
  })])])])]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMap === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMap) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.togglePlanMap()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelLocalisation[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMap) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelFieldDeviceAddress[_vm.actualLanguage]))]), _vm._v(" "), _c('gmap-autocomplete', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "5px"
    },
    attrs: {
      "placeholder": _vm.locationString
    },
    on: {
      "place_changed": _vm.usePlace
    }
  })], 1), _vm._v(" "), _c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "zoom": 7,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "draggable": true
      }
    })
  }), 1)], 1)])]) : _vm._e()])])])]), _vm._v(" "), (_vm.deviceConfigViewFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayApiDevConfig === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleApiDevConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayApiDevConfig) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleApiDevConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleApiDevConfig()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelApiDev[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayApiDevConfig) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelApiDev[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.controlParameters), function(parameter, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [(parameter.flagViewByCustomer || _vm.flagBundleIsDeviceCreatorBundle) ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(parameter.parameterLabel[_vm.actualLanguage]))])]), _vm._v(" "), (parameter.editViewByCustomer || _vm.flagBundleIsDeviceCreatorBundle) ? _c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-3"
    }, [(parameter.dataType === 'Bool') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.sectionLabelApiDevCtrlValue[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValue),
        expression: "parameter.dataValue"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.dataValue) ? _vm._i(parameter.dataValue, null) > -1 : (parameter.dataValue)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.dataValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "dataValue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "dataValue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "dataValue", $$c)
          }
        }
      }
    }), _c('span')]) : _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.sectionLabelApiDevCtrlValue[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValue),
        expression: "parameter.dataValue"
      }],
      staticClass: "form-control  align-center",
      attrs: {
        "type": "text",
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (parameter.dataValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "dataValue", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (true) ? _c('div', {
      staticClass: "col-sm-6 col-md-6 col-lg-3"
    }, [(parameter.dataType === 'Bool') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.sectionLabelApiDevCtrlLastValue[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValueLastTransmit),
        expression: "parameter.dataValueLastTransmit"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.dataValueLastTransmit) ? _vm._i(parameter.dataValueLastTransmit, null) > -1 : (parameter.dataValueLastTransmit)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.dataValueLastTransmit,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "dataValueLastTransmit", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "dataValueLastTransmit", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "dataValueLastTransmit", $$c)
          }
        }
      }
    }), _c('span')]) : _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.sectionLabelApiDevCtrlLastValue[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValueLastTransmit),
        expression: "parameter.dataValueLastTransmit"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "text",
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (parameter.dataValueLastTransmit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "dataValueLastTransmit", $event.target.value)
        }
      }
    })])]) : _vm._e()]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.flagBundleIsDeviceCreatorBundle) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelApiDevTTLRaw[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL.raw),
      expression: "tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.dataTTL.raw"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "text",
      "placeholder": "Valeur/Value"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL.raw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL, "raw", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelApiDevTTLHr[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL.hr),
      expression: "tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.dataTTL.hr"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "text",
      "placeholder": "Valeur/Value"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL.hr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL, "hr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelApiDevTTLRaw[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL.day),
      expression: "tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.dataTTL.day"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "text",
      "placeholder": "Valeur/Value"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL.day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.apiDeviceConfig.dataTTL, "day", $event.target.value)
      }
    }
  })])])]) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-danger align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveDevice()
      }
    }
  }, [(_vm.deviceIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmDeleteDevice[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), (_vm.deviceConfigEditFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDeviceModifications()
      }
    }
  }, [(_vm.deviceIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmSaveDevice[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Durée de vie")])])
}]}

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "push-50-t"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.notif) ? _c('div', {
    staticClass: "alert push-30-t alert-success alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.notif))])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "simple_form form-horizontal push-50-t",
    attrs: {
      "novalidate": "novalidate",
      "id": "new_user",
      "action": "/lobby/connexion",
      "accept-charset": "UTF-8",
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "name": "utf8",
      "type": "hidden",
      "value": "✓"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "authenticity_token",
      "value": "Ahic++4LN7D6ofsViOL59IWMgE7/qyXEiqG8ApI4fBU+CXupmcktQPQ19HxfIKmW2lGSWB4L+DcKWi9eQQPY/g=="
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control string email optional form-control",
    attrs: {
      "disabled": _vm.isWorking,
      "autofocus": "autofocus",
      "type": "email",
      "value": "",
      "name": "user[email]",
      "id": "user_email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_email"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control password optional form-control",
    attrs: {
      "disabled": _vm.isWorking,
      "type": "password",
      "id": "user_password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_password"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldPW[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isWorking) ? _c('div', [_c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signIn
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonConnect[_vm.actualLanguage]) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('router-link', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "type": "button",
      "to": {
        name: 'forgotPW'
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.labelFieldButtonForgotPW[_vm.actualLanguage]) + "\n                ")])], 1)]) : _c('spinner')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.labelFieldTextFirstTime[_vm.actualLanguage]) + "\n              "), _c('router-link', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.labelFieldButtonSubscribe[_vm.actualLanguage]) + "\n              ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isWorking) ? _c('button', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLanguage
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonLanguage[_vm.actualLanguage]) + "\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelCommissionsAvailable[_vm.actualLanguage]) + " : " + _vm._s(_vm.TotalCommissionAvailable) + "$")]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelCommissionsSelected[_vm.actualLanguage]) + " : " + _vm._s(_vm.TotalCommissionSelected) + "$")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.computeTempoCommission()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonComputeSelected[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createCommissionReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonCreateReport[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCommissionsHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonReadHistory[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelHistoryLength[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historyLength),
      expression: "historyLength"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.historyLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.historyLength = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.commissionsIsReading) ? _c('spinner') : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.commissionsList), function(commission, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(commission.OrganizationName))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(commission.TransactionId))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(commission.TransactionAmount) + "$")]), _vm._v(" "), _c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(commission.CommissionPourcentage) + "%")]), _vm._v(" "), _c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v("Com:" + _vm._s(commission.CommissionAmount) + "$")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(commission.PaymentReceived) ? _c('i', {
      staticClass: "fa fa-check-square"
    }) : _c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(commission.CommissionsReport == 'ND' & commission.PaymentReceived) ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      attrs: {
        "for": "example-checkbox1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (commission.FlagAddToReport),
        expression: "commission.FlagAddToReport"
      }],
      staticClass: "larger",
      attrs: {
        "type": "checkbox",
        "value": "option1"
      },
      domProps: {
        "checked": Array.isArray(commission.FlagAddToReport) ? _vm._i(commission.FlagAddToReport, "option1") > -1 : (commission.FlagAddToReport)
      },
      on: {
        "change": function($event) {
          var $$a = commission.FlagAddToReport,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "option1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(commission, "FlagAddToReport", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(commission, "FlagAddToReport", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(commission, "FlagAddToReport", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(_vm.labelAddToReport[_vm.actualLanguage]) + "\r\n                                                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(commission.CommissionsReport))])])
  }), 0)])])])], 1)])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-center"
  }, [_c('p', [_vm._v("Votre code:")]), _vm._v(" "), _c('strong', {
    staticClass: "binding-code"
  }, [_vm._v(_vm._s(_vm.bindingCode))])])
},staticRenderFns: []}

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Automatic"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Automatic")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Automatic"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]) + "\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "5Min"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "5Min")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "5Min"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]) + "\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Hour"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Hour")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Hour"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]) + "\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Day"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Day")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Day"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text"
  }, [_vm._v(_vm._s(_vm.labelGraphPeakCurrent[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.maxCurrent)) + " "), _c('span', {
    staticClass: "h4 text"
  }, [_vm._v("A")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x text-success"
  }), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png') ? _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphSaving[_vm.actualLanguage]))])]) : _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm._f("toCurrency")(_vm.sumCost)) + " "), _c('span', {
    staticClass: "h4 text-muted"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-download fa-3x text-success"
  }), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png') ? _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v("Production")])]) : _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphConsumption[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.sumKWH)) + " "), _c('span', {
    staticClass: "h4 text-muted"
  }, [_vm._v("kWh")])])])])])]), _vm._v(" "), (_vm.flagDisplayHistogramSection) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDataType),
      expression: "selectedDataType"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.constructHistogramData]
    }
  }, [_c('option', {
    attrs: {
      "value": "cost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCost[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kwh"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "peakPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPeakPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "peakCurrent"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPeakCurrent[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_vm._v(_vm._s(_vm.labelHistogramTypeDay[_vm.actualLanguage]) + "\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagDisplayHistogramHr),
      expression: "flagDisplayHistogramHr"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagDisplayHistogramHr) ? _vm._i(_vm.flagDisplayHistogramHr, null) > -1 : (_vm.flagDisplayHistogramHr)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.flagDisplayHistogramHr,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagDisplayHistogramHr = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagDisplayHistogramHr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagDisplayHistogramHr = $$c
        }
      }, _vm.constructHistogramData]
    }
  }), _c('span'), _vm._v(_vm._s(_vm.labelHistogramTypeHr[_vm.actualLanguage]) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.flagDisplayHistogramHr) ? _c('div', [_c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.histogramData
    }
  })], 1), _vm._v(" "), (_vm.flagHistogramDataComputed) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.histogramDataDownloadHour,
      "name": "ChannelHistogramHrData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.histogramDataDay
    }
  })], 1), _vm._v(" "), (_vm.flagHistogramDataComputed) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.histogramDataDownloadDay,
      "name": "ChannelHistogramDayData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "car-form__selects-list"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEvName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.carName),
      expression: "carModel.carName"
    }],
    attrs: {
      "disabled": _vm.savingCar,
      "type": "text"
    },
    domProps: {
      "value": (_vm.carModel.carName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carModel, "carName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.carModel.carName) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldManufacturer[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.manufacturer),
      expression: "carModel.manufacturer"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "manufacturer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onManufacturerChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.manufacturers), function(manufacturer) {
    return _c('option', {
      domProps: {
        "value": manufacturer
      }
    }, [_vm._v(_vm._s(manufacturer))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.evseFlag) ? [(_vm.filteredYears.length) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldLevel[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.year),
      expression: "carModel.year"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onYearChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filteredModels.length) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVSEBrand[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.model),
      expression: "carModel.model"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onModelChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredModels), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filteredColors.length) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVSEModel[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.color),
      expression: "carModel.color"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredColors), function(color) {
    return _c('option', {
      domProps: {
        "value": color
      }
    }, [_vm._v(_vm._s(color))])
  })], 2)]) : _vm._e()] : [(_vm.filteredYears.length) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVYear[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.year),
      expression: "carModel.year"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onYearChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filteredModels.length) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVModel[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.model),
      expression: "carModel.model"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onModelChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredModels), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filteredColors.length) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVColor[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.color),
      expression: "carModel.color"
    }],
    attrs: {
      "disabled": _vm.savingCar
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredColors), function(color) {
    return _c('option', {
      domProps: {
        "value": color
      }
    }, [_vm._v(_vm._s(color))])
  })], 2)]) : _vm._e()], _vm._v(" "), (_vm.carModel.color) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldLinkModule[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.linkedDevice),
      expression: "carModel.linkedDevice"
    }],
    staticClass: "device-select",
    attrs: {
      "disabled": _vm.savingCar,
      "id": "deviceSelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "linkedDevice", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return _c('option', {
      domProps: {
        "value": device.deviceId
      }
    }, [_vm._v(_vm._s(device.deviceId))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.carModel.linkedDevice) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldLinkPort[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.linkedPort),
      expression: "carModel.linkedPort"
    }],
    staticClass: "device-select",
    attrs: {
      "disabled": _vm.savingCar,
      "id": "deviceSelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.carModel, "linkedPort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5, 6]), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.carModel.averageWhPerKm) ? _c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carModel.averageWhPerKm),
      expression: "carModel.averageWhPerKm"
    }],
    attrs: {
      "disabled": _vm.savingCar,
      "type": "text"
    },
    domProps: {
      "value": (_vm.carModel.averageWhPerKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.carModel, "averageWhPerKm", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded btn-save",
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.savingCar) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.labelFieldButtonSave[_vm.actualLanguage]))])], 1), _vm._v(" "), (_vm.car !== undefined) ? _c('button', {
    staticClass: "btn btn-danger btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.showConfirmationModal
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonDelete[_vm.actualLanguage]))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagSessionsDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "large"
    }
  }) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDataType),
      expression: "selectedDataType"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setSessionsChartData]
    }
  }, [_c('option', {
    attrs: {
      "value": "kwh"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorEnergy[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCost[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "duration"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorDuration[_vm.actualLanguage]))])])])])])]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.channelSessionsGraphData
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (true) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.sessionsData,
      "name": "ChannelSessionsData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.sectionLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stringToFind),
      expression: "stringToFind"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Rechercher/Search"
    },
    domProps: {
      "value": (_vm.stringToFind)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stringToFind = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.findElement()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelAddComment[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "placeholder": "Commentaire/Comment"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelCommentLog()
      }
    }
  }, [(_vm.commentIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-comment fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "push-50-t"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (!_vm.registerSuccess) ? _c('form', {
    staticClass: "simple_form form-horizontal push-50-t"
  }, [_c('div', {
    staticClass: "form-inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.lastName),
      expression: "userInfos.lastName"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_lastName"
    },
    domProps: {
      "value": (_vm.userInfos.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_lastName"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldName[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.name),
      expression: "userInfos.name"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_name"
    },
    domProps: {
      "value": (_vm.userInfos.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_name"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldFirstName[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.email),
      expression: "userInfos.email"
    }],
    staticClass: "form-control string email optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "type": "email",
      "value": "",
      "id": "user_email"
    },
    domProps: {
      "value": (_vm.userInfos.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_email"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.password),
      expression: "userInfos.password"
    }],
    staticClass: "form-control password optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "type": "password",
      "name": "user[password]",
      "id": "user_password"
    },
    domProps: {
      "value": (_vm.userInfos.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_password"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldPW[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.repassword),
      expression: "userInfos.repassword"
    }],
    staticClass: "form-control password optional form-control",
    attrs: {
      "disabled": _vm.isRegistering,
      "type": "password",
      "name": "user[password]",
      "id": "user_repassword"
    },
    domProps: {
      "value": (_vm.userInfos.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "repassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_repassword"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldConfirmPW[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isRegistering) ? _c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonSubscribe[_vm.actualLanguage]))]) : _c('spinner')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.labelFieldAlready[_vm.actualLanguage]) + "\n                "), _c('router-link', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.labelFieldButtonLogIn[_vm.actualLanguage]) + "\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [_c('button', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLanguage
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonLanguage[_vm.actualLanguage]))])])])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("  \n" + _vm._s(_vm.tile) + "\n        "), _vm._l((_vm.tile.colorConditions), function(condition, index) {
    return _c('div', [(_vm.tile.value >= condition.minValue & _vm.tile.value < condition.maxValue) ? _c('div', [(_vm.tile.width == 'Small') ? _c('div', {
      staticClass: "col-lg-2"
    }, [_c('a', {
      staticClass: "block block-link-hover3"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('i', {
      staticClass: "fa-2x text-white pull-right",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('span', {
      staticClass: "h6 font-w700 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.value))]), _vm._v(" "), _c('span', {
      staticClass: "h6 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.label))])])])]) : _vm._e(), _vm._v(" "), (_vm.tile.width == 'Medium') ? _c('div', {
      staticClass: "col-lg-3"
    }, [_c('a', {
      staticClass: "block block-link-hover3"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('i', {
      staticClass: "fa-2x text-white pull-right",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('span', {
      staticClass: "h6 font-w700 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.value))]), _vm._v(" "), _c('span', {
      staticClass: "h6 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.label))])])])]) : _vm._e(), _vm._v(" "), (_vm.tile.width == 'Large') ? _c('div', {
      staticClass: "col-lg-4"
    }, [_c('a', {
      staticClass: "block block-link-hover2 text-center"
    }, [_c('div', {
      staticClass: "block-content block-content-full",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('div', {
      staticClass: "font-w600 text-white-op push-5-t"
    }, [_vm._v(_vm._s(_vm.tile.label))]), _vm._v(" "), _c('i', {
      staticClass: "fa-2x text-white",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('div', {
      staticClass: "h4 text-white"
    }, [_vm._v(_vm._s(_vm.tile.value) + " " + _vm._s(_vm.tile.valueSufix))])])])]) : _vm._e(), _vm._v(" "), (_vm.tile.width == 'Full') ? _c('div', {
      staticClass: "col-lg-12"
    }, [_c('a', {
      staticClass: "block block-link-hover3"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: condition.colorBackground
      })
    }, [_c('i', {
      staticClass: "fa-2x text-white pull-right",
      class: _vm.tile.favIcon
    }), _vm._v(" "), _c('span', {
      staticClass: "h6 font-w700 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.value))]), _vm._v(" "), _c('span', {
      staticClass: "h6 text-white-op"
    }, [_vm._v(_vm._s(_vm.tile.label))])])])]) : _vm._e()]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('h2', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldTitleAddGroup[_vm.actualLanguage]))]), _vm._v(" "), _c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.actualGroup.group_name))])]), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldGroupName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupInfo.newGroupName),
      expression: "groupInfo.newGroupName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.groupInfo.newGroupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.groupInfo, "newGroupName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.groupInfo.newGroupName) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.createSubGroup
    }
  }, [_vm._v(_vm._s(_vm.labelButtonConfirmed[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (_vm.displayMessage) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('h3', {
    staticClass: "font-w300 push-8"
  }, [_c('i', {
    staticClass: "fa fa-check fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.textDisplayMessage[_vm.actualLanguage]))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphData.title[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])])])])]), _vm._v(" "), (_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTraceIndex),
      expression: "selectedTraceIndex"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTraceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateChartData]
    }
  }, _vm._l((_vm.graphData.traces), function(trace, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(trace.label[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.crunchedData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-rounded push"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: " form-group row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('button', {
    staticClass: "btn  btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startMeasurement
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.buttonLabelStartAcquisition[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagDisplayLiveData),
      expression: "flagDisplayLiveData"
    }],
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.flagDisplayMessageHowToUse) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('h2', {
    staticClass: "block-title align-center"
  }, [_vm._v(_vm._s(_vm.messageHowToUse[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.channelList), function(channel, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 align-center"
    }, [_c('span', {
      staticClass: "h3 text-black-op",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(channel.channelName))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 align-center"
    }, [_c('a', {
      staticClass: "block block-link-hover block-rounded"
    }, [_c('div', {
      staticClass: "block-content block-content-full clearfix",
      style: ({
        backgroundColor: channel.color
      })
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('span', {
      staticClass: "h3 text-white-op",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.tileTotalPower[_vm.actualLanguage]) + " : " + _vm._s(channel.lastTotalPower) + " W")])]), _vm._v(" "), _vm._l((channel.devicePorts), function(port, index2) {
      return _c('div', {
        staticClass: "col-xs-12"
      }, [_c('span', {
        staticClass: "h4 text-white-op",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(_vm.tileSensor[_vm.actualLanguage]) + " " + _vm._s(index2 + 1) + ": " + _vm._s(channel.lastPower[index2]) + " W / " + _vm._s(channel.lastCurrent[index2]) + " A")])])
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('h4', {
      staticClass: "h5 text-center"
    }, [_vm._v(_vm._s(_vm.labelDisplayGraph[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (channel.flagDisplayGraph),
        expression: "channel.flagDisplayGraph"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(channel.flagDisplayGraph) ? _vm._i(channel.flagDisplayGraph, null) > -1 : (channel.flagDisplayGraph)
      },
      on: {
        "change": function($event) {
          var $$a = channel.flagDisplayGraph,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(channel, "flagDisplayGraph", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(channel, "flagDisplayGraph", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(channel, "flagDisplayGraph", $$c)
          }
        }
      }
    }), _c('span')])])]), _vm._v(" "), (channel.flagDisplayGraph) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('h5', {
      staticClass: "h5 text-center"
    }, [_vm._v(_vm._s(_vm.labelDisplayCurrent[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (channel.flagDisplayCurrent),
        expression: "channel.flagDisplayCurrent"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(channel.flagDisplayCurrent) ? _vm._i(channel.flagDisplayCurrent, null) > -1 : (channel.flagDisplayCurrent)
      },
      on: {
        "change": [function($event) {
          var $$a = channel.flagDisplayCurrent,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(channel, "flagDisplayCurrent", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(channel, "flagDisplayCurrent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(channel, "flagDisplayCurrent", $$c)
          }
        }, function($event) {
          return _vm.updateGraphData(index)
        }]
      }
    }), _c('span')])])]) : _vm._e(), _vm._v(" "), (channel.flagDisplayGraph) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      attrs: {
        "id": "chart"
      }
    }, [_c('apexchart', {
      attrs: {
        "type": "area",
        "height": "300",
        "options": _vm.chartOptions,
        "series": _vm.chartDataSeries[index]
      }
    })], 1)]) : _vm._e()])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('button', {
    staticClass: "btn  btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopMeasurement
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.buttonClose[_vm.actualLanguage]))])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayDataTable),
      expression: "displayDataTable"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.displayDataTable) ? _vm._i(_vm.displayDataTable, null) > -1 : (_vm.displayDataTable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.displayDataTable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayDataTable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.displayDataTable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayDataTable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.labelTableTop[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.displayDataTable) ? _c('div', [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayAvrPowerColumn),
      expression: "displayAvrPowerColumn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxAvrPow"
    },
    domProps: {
      "checked": Array.isArray(_vm.displayAvrPowerColumn) ? _vm._i(_vm.displayAvrPowerColumn, null) > -1 : (_vm.displayAvrPowerColumn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.displayAvrPowerColumn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayAvrPowerColumn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.displayAvrPowerColumn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayAvrPowerColumn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxAvrPow"
    }
  }, [_vm._v(_vm._s(_vm.labelTableColAvrPower[_vm.actualLanguage]) + "  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayPeakColumn),
      expression: "displayPeakColumn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxPeak"
    },
    domProps: {
      "checked": Array.isArray(_vm.displayPeakColumn) ? _vm._i(_vm.displayPeakColumn, null) > -1 : (_vm.displayPeakColumn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.displayPeakColumn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayPeakColumn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.displayPeakColumn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayPeakColumn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxPeak"
    }
  }, [_vm._v(_vm._s(_vm.labelTableColPeakPower[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayKwrColumn),
      expression: "displayKwrColumn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxKwr"
    },
    domProps: {
      "checked": Array.isArray(_vm.displayKwrColumn) ? _vm._i(_vm.displayKwrColumn, null) > -1 : (_vm.displayKwrColumn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.displayKwrColumn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayKwrColumn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.displayKwrColumn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayKwrColumn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxKwr"
    }
  }, [_vm._v(_vm._s(_vm.labelTableColConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayCostColumn),
      expression: "displayCostColumn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkboxCost"
    },
    domProps: {
      "checked": Array.isArray(_vm.displayCostColumn) ? _vm._i(_vm.displayCostColumn, null) > -1 : (_vm.displayCostColumn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.displayCostColumn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayCostColumn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.displayCostColumn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayCostColumn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkboxCost"
    }
  }, [_vm._v(_vm._s(_vm.labelTableColCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('table', {
    staticClass: "table remove-margin-b font-s13"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.labelTableColTime[_vm.actualLanguage]))]), _vm._v(" "), (_vm.displayAvrPowerColumn) ? _c('th', [_vm._v(_vm._s(_vm.labelTableColAvrPower[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.displayPeakColumn) ? _c('th', [_vm._v(_vm._s(_vm.labelTableColPeakPower[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.displayKwrColumn) ? _c('th', [_vm._v(_vm._s(_vm.labelTableColConsumption[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.displayCostColumn) ? _c('th', [_vm._v(_vm._s(_vm.labelTableColCost[_vm.actualLanguage]))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((this.tableData), function(dataLine) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(dataLine.timestamp))]), _vm._v(" "), (_vm.displayAvrPowerColumn) ? _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(dataLine.avrPower)))]) : _vm._e(), _vm._v(" "), (_vm.displayPeakColumn) ? _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(dataLine.peak)))]) : _vm._e(), _vm._v(" "), (_vm.displayKwrColumn) ? _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(dataLine.kwr)))]) : _vm._e(), _vm._v(" "), (_vm.displayCostColumn) ? _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(dataLine.cost)))]) : _vm._e()])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateNewPicture[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagSaveNewPicture) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.textDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelPictureReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceName),
      expression: "referenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Refeference name"
    },
    domProps: {
      "value": (_vm.referenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelFileType[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileType),
      expression: "fileType"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "jpg"
    }
  }, [_vm._v("JPEG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "png"
    }
  }, [_vm._v("PNG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bmp"
    }
  }, [_vm._v("BMP")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-md btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewPicture()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonCreatePicture[_vm.actualLanguage]))])])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h4', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.textPictureCreated[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.messageTransmitFile[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.newFileName))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.pictureList.length > 0) ? _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.overlayParameters.pictureType === 'channel') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelTableChannel[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.pictureType === 'device') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelTableDevice[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pictureList), function(Picture) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Picture.pictureReferenceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Picture.fileName))])])
  }), 0)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Nom reference / Reference Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Nom fichier / Filename")])])])
}]}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "push-50-t"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "link-effect",
    attrs: {
      "type": "button",
      "to": {
        name: 'login'
      }
    }
  }, [_c('h5', {
    staticClass: "font-w700 push"
  }, [_vm._v(_vm._s(_vm.labelFieldGoHome[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.notif) ? _c('div', {
    staticClass: "alert push-30-t alert-success alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.notif))])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "simple_form form-horizontal push-50-t",
    attrs: {
      "novalidate": "novalidate",
      "id": "new_user",
      "action": "/lobby/connexion",
      "accept-charset": "UTF-8",
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "name": "utf8",
      "type": "hidden",
      "value": "✓"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "authenticity_token",
      "value": "Ahic++4LN7D6ofsViOL59IWMgE7/qyXEiqG8ApI4fBU+CXupmcktQPQ19HxfIKmW2lGSWB4L+DcKWi9eQQPY/g=="
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control string email optional form-control",
    attrs: {
      "disabled": _vm.isWorking,
      "autofocus": "autofocus",
      "type": "email",
      "value": "",
      "name": "user[email]",
      "id": "user_email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_email"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEmail[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-actions push"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push"
  }, [(!_vm.isWorking) ? _c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forgotPasswordStep01
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.labelFieldButtonSendCode[_vm.actualLanguage]) + "\n                ")]) : _c('spinner')], 1)])]), _vm._v(" "), (_vm.displayCodeInput) ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 push-30-t"
  }, [_c('h6', {
    staticClass: "font-w700 push-50-t"
  }, [_vm._v(_vm._s(_vm.emailSentMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 push-30-t"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmationCode),
      expression: "confirmationCode"
    }],
    staticClass: "form-control string email optional form-control",
    attrs: {
      "disabled": _vm.isWorking,
      "autofocus": "autofocus",
      "type": "email",
      "value": "",
      "name": "code",
      "id": "code"
    },
    domProps: {
      "value": (_vm.confirmationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldConfirmationCode[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('h6', {
    staticClass: "font-w700 push-50-t"
  }, [_vm._v(_vm._s(_vm.passwordConditionMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 push-30-t"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassWord),
      expression: "newPassWord"
    }],
    staticClass: "form-control password optional form-control",
    attrs: {
      "disabled": _vm.isWorking,
      "autofocus": "autofocus",
      "type": "password",
      "value": "",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.newPassWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v(_vm._s(_vm.labelNewPW[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isWorking) ? _c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forgotPasswordStep02
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.labelBtnApplyNewPW[_vm.actualLanguage]) + "\n                  ")]) : _c('spinner')], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.labelFieldTextFirstTime[_vm.actualLanguage]) + "\n              "), _c('router-link', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.labelFieldButtonSubscribe[_vm.actualLanguage]) + "\n              ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isWorking) ? _c('button', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLanguage
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonLanguage[_vm.actualLanguage]) + "\n            ")]) : _vm._e()])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelTitleSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v("Sélection de l'organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrganizationId),
      expression: "selectedOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOrganizationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getTransactionHistory()
      }]
    }
  }, _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      domProps: {
        "value": organization.OrganizationId
      }
    }, [_vm._v(_vm._s(organization.OrganizationName) + "       [" + _vm._s(organization.OrganizationId) + "]")])
  }), 0)]), _vm._v(" "), (_vm.flagDisplaySectionTransactions) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.transactions), function(transaction, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleDisplayTransaction(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dollar"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayTransaction(index)
        }
      }
    }, [_vm._v(_vm._s(transaction.subscription) + ":" + _vm._s(transaction.timestamp))])]), _vm._v(" "), (_vm.transactionOpenFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "table-responsive push-50"
    }, [_c('table', {
      staticClass: "table table-bordered table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.textLabelProduct[[_vm.actualLanguage]]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceQuantity[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceUnitPrice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.InvoicePrice[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_vm._l((transaction.detailLines), function(transactionLine, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('p', {
        staticClass: "font-w600 push-10"
      }, [_vm._v(_vm._s(transactionLine.description[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "badge badge-primary"
      }, [_vm._v(_vm._s(transactionLine.quantity))])]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(transactionLine.unitPrice))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(transactionLine.unitPrice * transactionLine.quantity))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceSubTotal[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.subTotal))])]), _vm._v(" "), (transaction.tps > 0) ? _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("TPS (5%)")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.tps))])]) : _vm._e(), _vm._v(" "), (transaction.tvq > 0) ? _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("TVQ (9.975%)")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.tvq))])]) : _vm._e(), _vm._v(" "), _vm._l((transaction.taxesList), function(taxLine, index2) {
      return _c('tr', [_c('td', {
        staticClass: "font-w600 text-right",
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(taxLine.Label[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(taxLine.Amount))])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "active"
    }, [_c('td', {
      staticClass: "font-w700 text-uppercase text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
      staticClass: "font-w700 text-right"
    }, [_vm._v("$ " + _vm._s(transaction.total))])])], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-12 align-left push"
    }, [_c('h6', {
      staticClass: "block-title text-left"
    }, [_vm._v(_vm._s(_vm.CardInfoPaidBy[_vm.actualLanguage]) + _vm._s(transaction.cardData.CardType))]), _vm._v(" "), _c('h6', {
      staticClass: "block-title text-left"
    }, [_vm._v(_vm._s(_vm.CardInfoLast4[_vm.actualLanguage]) + _vm._s(transaction.cardData.CardLast4))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-12 align-right push"
    }, [_c('h2', {
      staticClass: "block-title push"
    }, [_vm._v("Information paiement")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('h5', {
      staticClass: "push"
    }, [_vm._v("Information facturation manuelle")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('h6', [_vm._v("Numéro de facture Quickbook")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (transaction.manualInvoice.referenceNumber),
        expression: "transaction.manualInvoice.referenceNumber"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (transaction.manualInvoice.referenceNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(transaction.manualInvoice, "referenceNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-3"
    }, [_c('h6', [_vm._v("Facture transmise au client")]), _vm._v(" "), _c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (transaction.manualInvoice.transmitted),
        expression: "transaction.manualInvoice.transmitted"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(transaction.manualInvoice.transmitted) ? _vm._i(transaction.manualInvoice.transmitted, null) > -1 : (transaction.manualInvoice.transmitted)
      },
      on: {
        "change": function($event) {
          var $$a = transaction.manualInvoice.transmitted,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(transaction.manualInvoice, "transmitted", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(transaction.manualInvoice, "transmitted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(transaction.manualInvoice, "transmitted", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-3 push"
    }, [_c('h6', [_vm._v("Paiement reçu")]), _vm._v(" "), _c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (transaction.paymentReceived),
        expression: "transaction.paymentReceived"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(transaction.paymentReceived) ? _vm._i(transaction.paymentReceived, null) > -1 : (transaction.paymentReceived)
      },
      on: {
        "change": function($event) {
          var $$a = transaction.paymentReceived,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(transaction, "paymentReceived", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(transaction, "paymentReceived", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(transaction, "paymentReceived", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12 align-center"
    }, [_c('button', {
      staticClass: "btn btn-xs align-center",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.saveTransactionPaymentInformation(index)
        }
      }
    }, [(_vm.transactionIsSaving) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-floppy-o fa-1x push-5-r "
    }), _vm._v("Enregistrer les informations de paiement ")])], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-12 align-right push"
    }, [_c('h2', {
      staticClass: "block-title push"
    }, [_vm._v("Comissions integrateurs")]), _vm._v(" "), _vm._l((transaction.integratorCommissions), function(commission, index) {
      return _c('div', {
        staticClass: "col-sm-12 col-lg-12 align-right push"
      }, [_vm._v("\r\n                                            " + _vm._s(commission) + "\r\n                                          ")])
    })], 2)])]) : _vm._e()])
  }), 0) : _vm._e()])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("404")])])
}]}

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.descriptionTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.description01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.description02[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayPanes) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: _vm.tabTitleClass[0]
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.switchPane(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.onglet01[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: _vm.tabTitleClass[1]
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.switchPane(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.onglet02[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: _vm.tabContentClass[0]
  }, _vm._l((_vm.dashboardData.tabs), function(tab, indexTab) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('h2', {
      staticClass: "font-w300 push-15"
    }, [_vm._v(" " + _vm._s(_vm.labelTab[_vm.actualLanguage]) + " " + _vm._s(indexTab + 1))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6 push"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTabName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dashboardData.tabs[indexTab].tabName),
        expression: "dashboardData.tabs[indexTab].tabName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom Onglet/Tab name"
      },
      domProps: {
        "value": (_vm.dashboardData.tabs[indexTab].tabName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dashboardData.tabs[indexTab], "tabName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._l((_vm.dashboardData.tabs[indexTab].sections), function(section, indexSection) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "block block-bordered"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "block-content"
      }, [_c('h3', {
        staticClass: "font-w300 push-15"
      }, [_vm._v(" " + _vm._s(_vm.labelTab[_vm.actualLanguage]) + " " + _vm._s(indexTab + 1) + " : Section " + _vm._s(indexSection + 1))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelSectionSize[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (section.size),
          expression: "section.size"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(section, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "Small"
        }
      }, [_vm._v("Small (1/3)")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Medium"
        }
      }, [_vm._v("Medium (1/2)")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Large"
        }
      }, [_vm._v("Large")])])])]), _vm._v(" "), _c('h4', {
        staticClass: "font-w300 push-15"
      }, [_vm._v(_vm._s(_vm.titleTile[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, _vm._l((section.tiles), function(tile, indexTile) {
        return _c('div', {
          staticClass: "col-xs-12 col-md-12"
        }, [_c('div', {
          staticClass: "block block-bordered block-themed block-content"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('h4', {
          staticClass: "font-w300 push-15"
        }, [_vm._v(" " + _vm._s(_vm.titleTile[_vm.actualLanguage]) + " " + _vm._s(indexTile + 1))]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelTileLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.label),
            expression: "tile.label"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "placeholder": "Nom/Name"
          },
          domProps: {
            "value": (tile.label)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(tile, "label", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelTileAgregation[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.agregation),
            expression: "tile.agregation"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(tile, "agregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "Sum"
          }
        }, [_vm._v("Somme/Sum")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Min"
          }
        }, [_vm._v("Minimum")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Max"
          }
        }, [_vm._v("Maximum")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Avr"
          }
        }, [_vm._v("Moyenne/Average")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Last"
          }
        }, [_vm._v("Dernière mesure/Last measure")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelTileIcon[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.icon),
            expression: "tile.icon"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(tile, "icon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, [_vm._m(0, true), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Medium"
          }
        }, [_vm._v("Medium (1/2)")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Large"
          }
        }, [_vm._v("Large")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-6 push"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelTileLabelIcon[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (tile.favIcon),
            expression: "tile.favIcon"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(tile, "favIcon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.faIconList), function(icon) {
          return _c('option', {
            domProps: {
              "value": icon.favIcon
            }
          }, [_vm._v(_vm._s(icon.label))])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('h4', {
          staticClass: "font-w300 push-15"
        }, [_vm._v(" " + _vm._s(_vm.titleTile[_vm.actualLanguage]) + " " + _vm._s(indexTile + 1))])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('custom-dashboard-tile', {
          attrs: {
            "tile": tile
          }
        })], 1)])])])])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-critical align-left",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addTileToSection(indexTab, indexSection)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-plus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.labelButtonAddTile[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('h4', {
        staticClass: "font-w300 push-15"
      }, [_vm._v(_vm._s(_vm.titleGraph[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-critical align-left",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addGraphToSection(indexTab, indexSection)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-plus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.labelButtonAddGraph[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-3"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-danger align-left",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteThisSection(indexTab, indexSection)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-trash fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.labelButtonDeleteSection[_vm.actualLanguage]))])])])])])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-12 push"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-left",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addSectionToDashboard(indexTab)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonAddSection[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-12"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-danger align-left",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTabToDashboard(indexTab)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteTab[_vm.actualLanguage]))])])])])], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addTabToDashboard()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddTab[_vm.actualLanguage]))])])])]), _vm._v("\n\n" + _vm._s(_vm.dashboardData) + "\n\n                    "), _c('div', {
    class: _vm.tabContentClass[1]
  }, [_c('h3', {
    staticClass: "font-w300 push-15"
  }, [_vm._v(" Preview")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option', {
    attrs: {
      "value": "fa fa-plus"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  })])
}]}

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [(_vm.channelSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelRefrenceName[_vm.actualLanguage]) + " (ID: " + _vm._s(_vm.channelIDLast4) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName),
      expression: "tempoBundle.channels[channelIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.channelConfigViewFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName),
      expression: "tempoBundle.channels[channelIndex].ChannelData.channelInfo.channelName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo, "channelName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description),
      expression: "tempoBundle.channels[channelIndex].ChannelData.channelInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group appliance-list-wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200px",
      "src": _vm._f("s3Image")(("organization_img/" + (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile)))
    }
  })])])]), _vm._v(" "), (_vm.channelConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayDevicePortConfig) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedModule[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.channelsAttributes.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceTags[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tempoBundle.channels[_vm.channelIndex].Attributes[index]),
        expression: "tempoBundle.channels[channelIndex].Attributes[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-select",
        "name": "example-select",
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].Attributes, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.channelConfigDeleteFlag) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "name": "buttonDeletePlanItem2"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveChannel()
      }
    }
  }, [(_vm.channelIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteDevice[_vm.actualLanguage]))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [(_vm.channelConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelModifications()
      }
    }
  }, [(_vm.channelIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSaveDevice[_vm.actualLanguage]))])], 1) : _vm._e()])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId != 'TBD' & _vm.channelConfigEditFlag & _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId != 'Aucun/None') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(_vm._s(_vm.sectionLabelDeviceAlert[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.actualBundle.alerts), function(alert, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [(alert.AlertData.linked_channel[0] === _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelId) ? _c('div', {
      staticClass: "block-content"
    }, [_c('config-alert', {
      attrs: {
        "alertIndex": index
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.alertShowAddButton) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [(_vm.channelConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.openAlertAddMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-bell fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonAddAlert[_vm.actualLanguage]))]) : _vm._e()])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.alertShowAddButton = true
      }
    }
  }, [_c('i', {
    staticClass: "si si-plus"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelFieldButtonAddAlert[_vm.actualLanguage]) + " " + _vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelAlertSelect[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertToAddIndex),
      expression: "alertToAddIndex"
    }],
    staticClass: "js-select2",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alertToAddIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.alertsDefinitions), function(alert, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(alert.alertTitle[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("alerts/" + (_vm.alertsDefinitions[_vm.alertToAddIndex].icon[_vm.actualLanguage])))
    }
  })]), _vm._v(" "), (_vm.alertsDefinitions[_vm.alertToAddIndex].alertDescription) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.alertsDefinitions[_vm.alertToAddIndex].alertDescription[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAlertParameter[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAlertParameterValue[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.alertsDefinitions[_vm.alertToAddIndex].parameters), function(parameter, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(parameter.parameterTitle[_vm.actualLanguage]))]), _vm._v(" "), (parameter.dataType === 'Numeric') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "type": "test",
        "id": "lock1-password",
        "name": "lock1-password",
        "placeholder": "Entrez votre information"
      },
      domProps: {
        "value": (parameter.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'Boolean') ? _c('td', [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.value) ? _vm._i(parameter.value, null) > -1 : (parameter.value)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "value", $$c)
          }
        }
      }
    }), _c('span')])]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateMonth') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.monthOptions), function(month) {
      return _c('option', {
        domProps: {
          "value": month.value
        }
      }, [_vm._v(_vm._s(month.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateDay') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.dayOptions), function(day) {
      return _c('option', {
        domProps: {
          "value": day.value
        }
      }, [_vm._v(_vm._s(day.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateHour') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.hourOptions), function(hour) {
      return _c('option', {
        domProps: {
          "value": hour.value
        }
      }, [_vm._v(_vm._s(hour.text))])
    }), 0)]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": _vm.addAlertLine
    }
  }, [(_vm.alertIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmAddAlert[_vm.actualLanguage]))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        _vm.alertShowAddButton = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonCancelAddAlert[_vm.actualLanguage]))])])])])])])], 2) : _vm._e()])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
}]}

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelTitleSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', {
    staticClass: "block-title push",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v("Sélection de l'organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrganizationId),
      expression: "selectedOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOrganizationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getReportsHistory()
      }]
    }
  }, _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      domProps: {
        "value": organization.OrganizationId
      }
    }, [_vm._v(_vm._s(organization.OrganizationName) + "       [" + _vm._s(organization.OrganizationId) + "]")])
  }), 0)]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Options Integrateur")]), _vm._v(" "), (_vm.integratorOptionsIsReading == false) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Integrateur parent:" + _vm._s(_vm.integratorParent))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.integratorOptions.activationFlag),
      expression: "integratorOptions.activationFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.integratorOptions.activationFlag) ? _vm._i(_vm.integratorOptions.activationFlag, null) > -1 : (_vm.integratorOptions.activationFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.integratorOptions.activationFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.integratorOptions, "activationFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.integratorOptions, "activationFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.integratorOptions, "activationFlag", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" Activation\r\n                            ")])]), _vm._v(" "), (_vm.integratorOptions.activationFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v("Courriel de support")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.integratorOptions.supportEmail),
      expression: "integratorOptions.supportEmail"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.integratorOptions.supportEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.integratorOptions, "supportEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v("Organisation Clients")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "size": "4",
      "multiple": ""
    }
  }, _vm._l((_vm.integratorOptions.integratedOrganizations), function(subOrganization, index) {
    return _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(subOrganization.organizationName) + " [" + _vm._s(subOrganization.organizationId) + "]")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h6', [_vm._v("Commissions (%) par niveau (ne pas appliquer de décimales!)")]), _vm._v(" "), _vm._l((_vm.integratorOptions.commissions), function(commission, index2) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-2"
    }, [_c('h6', [_vm._v("Niveau " + _vm._s(index2 + 1))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.integratorOptions.commissions[index2]),
        expression: "integratorOptions.commissions[index2]"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.integratorOptions.commissions[index2])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.integratorOptions.commissions, index2, $event.target.value)
        }
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 align-center"
  }, [_c('button', {
    staticClass: "btn align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addCommissionLevel()
      }
    }
  }, [_vm._v("Ajouter un niveau")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 align-center"
  }, [_c('button', {
    staticClass: "btn align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeCommissionLevel()
      }
    }
  }, [_vm._v("Retirer un niveau")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 align-center"
  }, [_c('button', {
    staticClass: "btn align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveIntegratorOptions()
      }
    }
  }, [_vm._v("Enregistrer modifictions")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Rapports de commissions")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getReportsHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonReadHistory[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelHistoryLength[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historyLength),
      expression: "historyLength"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.historyLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.historyLength = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.reportsIsReading) ? _c('spinner') : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportsList), function(report, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(report.report_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, _vm._l((report.linked_commissions), function(transaction) {
      return _c('p', [_vm._v(_vm._s(transaction.transactionId))])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('h6', [_vm._v(_vm._s(_vm.labelInvoiceAmount[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.total_amount) + " $")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.invoice_reference_number))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      attrs: {
        "for": "example-checkbox1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.payment_done_by_evsens),
        expression: "report.payment_done_by_evsens"
      }],
      staticClass: "larger",
      attrs: {
        "type": "checkbox",
        "value": "option1"
      },
      domProps: {
        "checked": Array.isArray(report.payment_done_by_evsens) ? _vm._i(report.payment_done_by_evsens, "option1") > -1 : (report.payment_done_by_evsens)
      },
      on: {
        "change": function($event) {
          var $$a = report.payment_done_by_evsens,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "option1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "payment_done_by_evsens", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "payment_done_by_evsens", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "payment_done_by_evsens", $$c)
          }
        }
      }
    }), _vm._v("  Paiement fait\r\n                                            ")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.payment_reference_number),
        expression: "report.payment_reference_number"
      }],
      staticClass: "form-control align-center push",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (report.payment_reference_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(report, "payment_reference_number", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs align-center",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.saveReportReferenceNumber(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonInvoiceReferenceNumber[_vm.actualLanguage]))])])])
  }), 0)])])])], 1)])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphData.title[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])])])])]), _vm._v(" "), (_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [(_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('line-chart', {
    attrs: {
      "chartData": _vm.crunchedData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 align-center"
  }, _vm._l((_vm.graphData.traces), function(trace, index1) {
    return _c('div', {
      staticClass: "col-sm-3 col-md-12",
      attrs: {
        "align": "left"
      }
    }, [_c('label', {
      staticClass: "css-input css-checkbox css-checkbox-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                                ")])])
  }), 0)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.subService.reference_name))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagDisplayDetail === 0) ? _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleGraph[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 align-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelButton[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagReadByInvoiceData),
      expression: "flagReadByInvoiceData"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagReadByInvoiceData) ? _vm._i(_vm.flagReadByInvoiceData, null) > -1 : (_vm.flagReadByInvoiceData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagReadByInvoiceData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagReadByInvoiceData = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagReadByInvoiceData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagReadByInvoiceData = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.flagReadByInvoiceData) ? _c('h5', [_vm._v(_vm._s(_vm.lableActivated[_vm.actualLanguage]))]) : _c('h5', [_vm._v(_vm._s(_vm.lableNotActivated[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateStart),
      callback: function($$v) {
        _vm.visualisationDateStart = $$v
      },
      expression: "visualisationDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateEnd),
      callback: function($$v) {
        _vm.visualisationDateEnd = $$v
      },
      expression: "visualisationDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.readSubServiceGraphData()
      }
    }
  }, [_vm._v("\r\n                                  " + _vm._s(_vm.labelButtonReadGraph[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.flagGraphDataIsUpdating) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataSub1
    }
  })], 1) : _vm._e()])]) : _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfigClose[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Configuration service ID: " + _vm._s(_vm.subService.sub_service_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push-50"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelRefenrenceName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subService.reference_name),
      expression: "subService.reference_name"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.subService.reference_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subService, "reference_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelSectionTitleLinkedChannel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedChannel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelToAddIndex),
      expression: "channelToAddIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelToAddIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.actualBundle.channels), function(channel, channelIndex) {
    return _c('option', {
      domProps: {
        "value": channelIndex
      }
    }, [_vm._v(_vm._s(channel.ReferenceName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-xs align-left",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelToLinkedChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.channelAddButton[_vm.actualLanguage]))])])])])]), _vm._v(" "), (_vm.subService.linked_channel.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.channelTableColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.channelTableColumn02[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subService.linked_channel), function(channel, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(channel.referenceName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLinkedChannel(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveSubServiceModifications()
      }
    }
  }, [(_vm.serviceIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.subService.options), function(category, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12 push"
    }, [_c('h5', {}, [_c('u', [_vm._v(_vm._s(category.categoryTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
      staticClass: "push-30"
    }, [_vm._v(_vm._s(category.categoryDescription[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((category.options), function(Option, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [(Option.valueType == 'bool') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h5', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(Option.value) ? _vm._i(Option.value, null) > -1 : (Option.value)
        },
        on: {
          "change": function($event) {
            var $$a = Option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(Option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(Option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(Option, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span'), (Option.value) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'stringNumber') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control align-center",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (Option.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Option, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'listString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_vm._v("\r\n                                  " + _vm._s(Option) + "\r\n                                ")]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveSubServiceModifications()
      }
    }
  }, [(_vm.serviceIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "block-title align-center"
  }, [_vm._v(_vm._s(_vm.sectionTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayOrganization === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayOrganization) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.profileData.managed_organizations[_vm.organizationIndex].organizationName))])]), _vm._v(" "), (_vm.flagDisplayOrganization) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.organizationIsLoading) ? _c('spinner') : _c('div', [(_vm.flagDisplayIntegratorPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.labelTitleIntegratorTools[_vm.actualLanguage]))]), _vm._v(" "), (_vm.organizationModel.integrator_options.activationFlag) ? _c('button', {
    staticClass: "btn btn-success align-right push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleIntegratorPanel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.labelButtonCloseIntegratorPanel[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), _c('integrator-tab-menu', {
    attrs: {
      "organization": _vm.organizationModel
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.flagDisplayIntegratorPanel == false) && (_vm.planTransactionData.transactionStatusCode === '000')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "font-w400"
  }, [_vm._v("ID:" + _vm._s(_vm.organizationModel.organizationId.substring(5, 30)))])]), _vm._v(" "), (_vm.organizationModel.integrator_options.activationFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleIntegratorPanel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.labelButtonOpenIntegratorPanel[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxOrganizationName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.name),
      expression: "organizationModel.organizationInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxAdress[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.address),
      expression: "organizationModel.organizationInfo.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxCity[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.city),
      expression: "organizationModel.organizationInfo.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ville / City..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxProvince[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.province),
      expression: "organizationModel.organizationInfo.province"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Province / Province ..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "province", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxCountry[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.country),
      expression: "organizationModel.organizationInfo.country"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pays / Country ..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxPostalCode[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.postalCode),
      expression: "organizationModel.organizationInfo.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Code postal / Postal code..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxPhone[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.phoneNumber),
      expression: "organizationModel.organizationInfo.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "555-555-5555"
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "phoneNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "h2 font-w300"
  }, [_vm._v(_vm._s(_vm.sectionLabelOrganizationManager[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonFirstname[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonLastname[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonEmail[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonPhone[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelDeleteManager[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.organizationModel.managers), function(contact, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.firstName),
        expression: "contact.firstName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Prénom/Firstname"
      },
      domProps: {
        "value": (contact.firstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "firstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.lastName),
        expression: "contact.lastName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (contact.lastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "lastName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.email),
        expression: "contact.email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Courriel/Email"
      },
      domProps: {
        "value": (contact.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact.phoneNumber),
        expression: "contact.phoneNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Téléphone/Phone number"
      },
      domProps: {
        "value": (contact.phoneNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact, "phoneNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Retirer/Remove"
      },
      on: {
        "click": function($event) {
          return _vm.confirmRemoveManager(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addManager()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddOrganizationManager[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 push-20"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveOrganizationModifications()
      }
    }
  }, [(_vm.organizationIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonSaveModifications[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), (_vm.organizationModel.subscription.subscriptionId != 'NONE') ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 push-20"
  }, [(_vm.flagUserAsAdministratorLicence) ? _c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMySubscription === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMySubscription()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMySubscription) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMySubscription()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h2 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMySubscription()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelSubscriptionLicense[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMySubscription) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h2', {
    staticClass: "h1 font-w300 push"
  }, [_vm._v(_vm._s(_vm.organizationModel.subscription.data.organization_plan_description.planInfo.title[_vm.actualLanguage]))]), _vm._v(" "), (false) ? _c('h3', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.tileLabelConsumptionTitle[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-television fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.rights.rights.channelLimit.count) + "/" + _vm._s(_vm.organizationModel.rights.rights.channelLimit.max))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelDevice[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.rights.rights.emailMonthlyLimit.count) + "/" + _vm._s(_vm.organizationModel.rights.rights.emailMonthlyLimit.max))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-stack-exchange fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.rights.rights.smsMonthlyLimit.count) + "/" + _vm._s(_vm.organizationModel.rights.rights.smsMonthlyLimit.max))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelSMS[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.backendConsumption.totalCallsCount))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelCallsCount[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-download fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.backendConsumption.totalReadItems))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelItemsRead[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.organizationModel.backendConsumption.totalProcessTime))]), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.tileLabelProcessTime[_vm.actualLanguage]))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicenceOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "h2 block-title"
  }, [_vm._v(_vm._s(_vm.organizationModel.subscription.data.organization_licence.title[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_vm._v("Licence ID:" + _vm._s(_vm.organizationModel.subscription.subscriptionId.substring(11, 30)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-6 push"
  }, [_c('h3', {
    staticClass: "h2 align-right"
  }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(_vm.organizationModel.subscription.data.organization_licence.price) + " $")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.organizationModel.subscription.data.organization_licence.customizedOptions.length > 0) ? _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.organizationModel.subscription.data.organization_licence.customizedOptions), function(licenceOption, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
      staticClass: "text-center"
    }, [_c('h6', {
      staticClass: "h6 font-w700 push-10"
    }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (licenceOption.value)
      },
      on: {
        "change": function($event) {
          return _vm.computeCost()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(licenceOption, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
      },
      on: {
        "change": [function($event) {
          var $$a = licenceOption.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(licenceOption, "value", $$c)
          }
        }, function($event) {
          return _vm.computeCost()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" Activation\n                                                            ")])]) : _vm._e()])
  }), 0)]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicence[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.displayUserLicenceSectionFLag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, _vm._l((_vm.organizationModel.subscription.data.organization_user_licences), function(userLicence, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "h3 block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayUserLicenceFlag(index)
        }
      }
    }, [_vm._v(_vm._s(userLicence.title[_vm.actualLanguage]) + " ID: " + _vm._s(userLicence.licenceId.substring(11, 30)))])]), _vm._v(" "), (_vm.displayUserLicenceFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-12 col-lg-12 "
    }, [_c('h3', {
      staticClass: "h3 align-right"
    }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(userLicence.price) + " $")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-lg-6 "
    }, [(userLicence.linkedProfile.email != 'NONE') ? _c('h3', {
      staticClass: "h3 align-left"
    }, [_vm._v(_vm._s(_vm.tableLicenceUser[_vm.actualLanguage]) + " : " + _vm._s(userLicence.linkedProfile.email))]) : _c('h3', {
      staticClass: "h3 align-left"
    }, [_vm._v("Disponible/Available")])]), _vm._v(" "), (userLicence.linkedProfile.email != 'NONE') ? _c('div', {
      staticClass: "col-sm-6 col-lg-6 align-right"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-right",
      attrs: {
        "type": "button",
        "title": "Retirer/Release"
      },
      on: {
        "click": function($event) {
          return _vm.releaseLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelRemoveLicence[_vm.actualLanguage]))])]) : _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-lg-6 "
    }, [_c('button', {
      staticClass: "btn btn-md btn-success align-right",
      attrs: {
        "type": "button",
        "title": "Allouer/Attribute"
      },
      on: {
        "click": function($event) {
          return _vm.attributeLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelAllocate[_vm.actualLanguage]))])])]), _vm._v(" "), (userLicence.linkedProfile.email == 'NONE' && index >= _vm.organizationModel.subscription.data.organization_plan_description.planInfo.includedLicence) ? _c('div', {
      staticClass: "col-sm-12 col-lg-12"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-right",
      attrs: {
        "type": "button",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelDeleteLicence[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [(userLicence.customizedOptions.length > 0) ? _c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((userLicence.customizedOptions), function(licenceOption, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
        staticClass: "text-center"
      }, [_c('h6', {
        staticClass: "h6 font-w700 push-10"
      }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        staticClass: "form-control text-center",
        attrs: {
          "placeholder": "Valeur/Value"
        },
        domProps: {
          "value": (licenceOption.value)
        },
        on: {
          "change": function($event) {
            return _vm.computeCost()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(licenceOption, "value", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
        staticClass: "text-center"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
        },
        on: {
          "change": [function($event) {
            var $$a = licenceOption.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(licenceOption, "value", $$c)
            }
          }, function($event) {
            return _vm.computeCost()
          }]
        }
      }), _vm._v(" "), _c('span'), _vm._v(" Activation\n                                                            ")])]) : _vm._e()])
    }), 0)])]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.organizationModel.subscription.data.organization_plan_description.planInfo.maximumLicenceCount > 1) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12 push"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button",
      "title": "Ajouter/Add"
    },
    on: {
      "click": function($event) {
        return _vm.addUserLicence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelAddUserLicence[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveLicenceOptionsModifications()
      }
    }
  }, [(_vm.licenceOptionsIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.buttonSaveLicenceOptions[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "h2 font-w300"
  }, [_vm._v(_vm._s(_vm.sectionLabelSubscriptionFees[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success clearfix"
  }, [_c('i', {
    staticClass: "fa fa-money fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 text-white-op"
  }, [_vm._v(_vm._s(_vm.actualMensualityLabel[_vm.actualLanguage]) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.sumFinalCost) + "$")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v(_vm._s(_vm.actualmensualityDescripCol1[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.actualmensualityDescripCol2[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Somme des frais de base")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.sumBaseCost) + " $")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Rabais de volume")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("-" + _vm._s(_vm.sumRebate) + " $")])]), _vm._v(" "), (_vm.specialRebate > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.specialRebateString))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("-" + _vm._s(_vm.specialRebate) + " $")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Estimation des frais mensuel")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.sumFinalCost) + " $")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "h2 font-w300"
  }, [_vm._v(_vm._s(_vm.sectionLabelPaymentInfo[_vm.actualLanguage]))]), _vm._v(" "), _c('organization-payment-info', {
    attrs: {
      "organizationData": _vm.organizationModel
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.subscribeToAdminPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelModifyMyPackage[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12 push-20"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.textMessageUserDoNotHaveLicenceToEditOrganization[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.organizationModel.subscription.subscriptionId === 'NONE') ? _c('div', [_c('h5', {
    staticClass: "push-10"
  }, [_vm._v(_vm._s(_vm.textMessageToAccessMenager[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.subscribeToAdminPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelSubcribeToPackage[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('organization-payment-history', {
    attrs: {
      "organizationData": _vm.organizationModel
    }
  })], 1), _vm._v(" "), (_vm.organizationModel.apiManagement.apiActivationFlag) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('organization-api-management', {
    attrs: {
      "organizationData": _vm.organizationModel
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '055' || _vm.planTransactionData.transactionStatusCode === '065' || _vm.planTransactionData.transactionStatusCode === '105') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])])]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleServicePlanOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('admin-plan-table')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '999') ? _c('div', {
    staticClass: "row"
  }, [(_vm.planTransactionData.postAction === 'NewSubscription') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelSubscriptionRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.postAction === 'NewAdminSubscription') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelAdminSubscriptionRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.postAction === 'ModifyCreditCard') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelNewCreditCardRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])])]) : _vm._e()])], 1) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text"
  }, [_vm._v(_vm._s(_vm.labelGraphPeakCurrent[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm.maxCurrent) + " "), _c('span', {
    staticClass: "h4 text"
  }, [_vm._v("A")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x text-success"
  }), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png') ? _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphSaving[_vm.actualLanguage]))])]) : _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm.sumCost) + "$ "), _c('span', {
    staticClass: "h4 text-muted"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-download fa-3x text-success"
  }), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png') ? _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v("Production")])]) : _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphConsumption[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm.sumKWH) + " "), _c('span', {
    staticClass: "h4 text-muted"
  }, [_vm._v("kWh")])])])])])]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [(_vm.flagDisplayOldGraphVersion) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDataType),
      expression: "selectedDataType"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeDataForGraph]
    }
  }, [_c('option', {
    attrs: {
      "value": "avrPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorAvrPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "peak"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPeakPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kwh"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCost[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cumSumKwh"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cumSumCost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('line-chart', {
    attrs: {
      "chartData": _vm.crunchedPowerCall
    }
  })], 1), _vm._v(" "), (_vm.profileData.rights.rights.logWeatherFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showWeatherSelector) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWeatherType),
      expression: "selectedWeatherType"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedWeatherType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeDataForWeatherGraph]
    }
  }, [(_vm.selectedWeatherType === 'none') ? _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorSelectWeather[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.showWeatherGraph) ? _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorUnSelectWeather[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temperature"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorTemperature[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "humidity"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorHumidity[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cloud"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCloud[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "wind"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorWind[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.showWeatherGraph) ? _c('line-chart', {
    attrs: {
      "chartData": _vm.crunchedWeatherCall
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.sliderChange()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.sliderChange()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-9"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-3 align-center"
  }, [_c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAvrPower),
      expression: "selectAvrPower"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAvrPower) ? _vm._i(_vm.selectAvrPower, null) > -1 : (_vm.selectAvrPower)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAvrPower,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAvrPower = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAvrPower = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAvrPower = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorAvrPowerKW[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectPeakPower),
      expression: "selectPeakPower"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectPeakPower) ? _vm._i(_vm.selectPeakPower, null) > -1 : (_vm.selectPeakPower)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectPeakPower,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectPeakPower = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectPeakPower = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectPeakPower = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorPeakPowerKW[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectKWH),
      expression: "selectKWH"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectKWH) ? _vm._i(_vm.selectKWH, null) > -1 : (_vm.selectKWH)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectKWH,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectKWH = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectKWH = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectKWH = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorKWHShort[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectCost),
      expression: "selectCost"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectCost) ? _vm._i(_vm.selectCost, null) > -1 : (_vm.selectCost)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectCost,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectCost = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectCost = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectCost = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorCostShort[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectCumSumKwh),
      expression: "selectCumSumKwh"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectCumSumKwh) ? _vm._i(_vm.selectCumSumKwh, null) > -1 : (_vm.selectCumSumKwh)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectCumSumKwh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectCumSumKwh = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectCumSumKwh = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectCumSumKwh = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorCumSumKWHShort[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectCumSumCost),
      expression: "selectCumSumCost"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectCumSumCost) ? _vm._i(_vm.selectCumSumCost, null) > -1 : (_vm.selectCumSumCost)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectCumSumCost,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectCumSumCost = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectCumSumCost = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectCumSumCost = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorCumSumCostShort[_vm.actualLanguage]) + "\n              ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.portData.slice(_vm.graphStartIndex, _vm.graphLastIndex),
      "name": "ChannelMeasurementData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "block-content text-left"
  }, [(_vm.profileData.rights.rights.dashboardDataTableFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.textSectionTableau[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('data-table', {
    attrs: {
      "tableData": _vm.portData.slice(_vm.graphStartIndex, _vm.graphLastIndex)
    }
  })], 1)])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphData.title[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])])])])]), _vm._v(" "), (_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [(_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.crunchedData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 align-center"
  }, _vm._l((_vm.graphData.traces), function(trace, index1) {
    return _c('div', {
      staticClass: "col-sm-3 col-md-12",
      attrs: {
        "align": "left"
      }
    }, [(index1 % 5 === 0) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 1) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-danger"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 2) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-primary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 3) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-default"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index1 % 5 === 4) ? _c('label', {
      staticClass: "css-input css-checkbox css-checkbox-warning"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.displayTraceFlag[index1]),
        expression: "displayTraceFlag[index1]"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.displayTraceFlag[index1]) ? _vm._i(_vm.displayTraceFlag[index1], null) > -1 : (_vm.displayTraceFlag[index1])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.displayTraceFlag[index1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.displayTraceFlag, index1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.displayTraceFlag, index1, $$c)
          }
        }, function($event) {
          return _vm.updateChartData()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(trace.label[_vm.actualLanguage]) + "\n                            ")]) : _vm._e()])
  }), 0)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.bundleConfigViewFlag) ? _c('div', {
    staticClass: "row"
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelBundleID[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualBundle.bundle_id.split("::").pop()))]), _vm._v(" "), (_vm.flagDisplayCompleteBundleName) ? _c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelBundleID[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualBundle.bundle_id))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "h3 btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewBundleName()
      }
    }
  }, [(_vm.newBundleIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.buttonLabelModifySystemName[_vm.actualLanguage]))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.flagDisplayDeleteBundle) ? _c('button', {
    staticClass: "h3 btn btn-block btn-danger align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBundle()
      }
    }
  }, [(_vm.bundleIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(false) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.bundleConfigEditFlag) ? _c('button', {
    staticClass: "h3 btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewBundleInGroup()
      }
    }
  }, [(_vm.addBundleIsSaving2) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateSameLevelSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.bundleConfigEditFlag) ? _c('button', {
    staticClass: "h3 btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewSubBundle()
      }
    }
  }, [(_vm.addBundleIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateSubSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bundleSharingEnableFlag) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocTitleSharing[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.bundleSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareSystem[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualBundle.bundle_name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSharingDetail[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h4', {
    staticClass: "push-5-r "
  }, [_vm._v(_vm._s(_vm.blocTitleSharingList[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Bundle'
      }
    }
  })], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayAttributes === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAttributes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAttributes) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAttributes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAttributes()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tags fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelTags[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayAttributes) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textDescriptionTags[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addAttributeCategorie()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddTagCategory[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.channelAttributeSelect[index]),
        expression: "channelAttributeSelect[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-multiple-select",
        "name": "example-multiple-select",
        "size": "5"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.channelAttributeSelect, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": index2
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)]), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.addAttributeElement(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonLabelAddTag[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAttributeElement(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonLabelDeleteTag[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCategoryList(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonLabelDeleteTagCategory[_vm.actualLanguage]))]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "attributesDisplayFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "attributesDisplayFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "attributesDisplayFlag", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelShowTags[_vm.actualLanguage]) + "\n                ")])]) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayPieChart === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPieChart()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPieChart) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPieChart()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPieChart()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelPieCharts[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayPieChart) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textConfigPieChart[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "pieChartDisplayFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "pieChartDisplayFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "pieChartDisplayFlag", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayPieChart[_vm.actualLanguage]) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "displayChannelLocalizationFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "displayChannelLocalizationFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions, "displayChannelLocalizationFlag", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayChannelLocalisation[_vm.actualLanguage]) + "\n                ")])])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayChannelAverage === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannelAverage) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelMovingAverage[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayChannelAverage) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "h3 font-w200"
  }, [_vm._v(_vm._s(_vm.textConfigMovingAverage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayEnable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayEnable", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayMA[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayActual", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayActual", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayActual", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayActual[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA001H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA001H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA001H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 1 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA004H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA004H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA004H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 4 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA006H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA006H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA006H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 6 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA012H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA012H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA012H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 12 hr\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA024H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA024H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA024H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 1 " + _vm._s(_vm.buttonLabelMA_Day[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA072H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA072H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA072H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 3 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA168H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA168H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA168H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 7 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA336H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA336H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA336H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 14 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "h4 css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H),
      expression: "actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _vm._i(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H, null) > -1 : (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA720H", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA720H", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions, "flagDisplayMA720H", $$c)
        }
      }, _vm.saveNewBundleConfiguration]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_DisplayHr[_vm.actualLanguage]) + " 30 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                    ")])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "example-select",
      "name": "example-select",
      "size": "1"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sélectionner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Résidentiel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Commercial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Industriel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v("Nombre d'occupant")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "example-select",
      "name": "example-select",
      "size": "1"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sélectionner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v("Sélection Multiple")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "example-multiple-select",
      "name": "example-multiple-select",
      "size": "5",
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option #1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option #2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Option #3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Option #4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Option #5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Option #6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Option #7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Option #8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Option #9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Option #10")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('hr')])
}]}

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.channelIndex + 1) + ":" + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.actualBundle.channels[_vm.channelIndex].Attributes), function(attribute, index) {
    return _c('div', [(_vm.actualBundle.channels[_vm.channelIndex].Attributes[index] != 'ND') ? _c('div', {
      staticClass: "col-xm-6 col-sm-4 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-tag fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.actualBundle.channels[_vm.channelIndex].Attributes[index]))])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagChannelDataIsLoading) ? _c('spinner') : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [(true) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h3', {
    staticClass: "font-w300 push measurement-graph-row__title"
  }, [_c('img', {
    staticClass: "measurement-graph-row__icon",
    attrs: {
      "width": "120px",
      "src": _vm._f("s3Image")(("organization_img/" + (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile))),
      "alt": ""
    }
  }), _vm._v("\n                              " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                  " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description) + "\n                                ")])]), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelAddress[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                  " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.address) + "\n                                ")])]) : _vm._e()]), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false & false) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": 8,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "label": marker.label,
        "draggable": false
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "row measurement-graph-row push"
  }, [(_vm.flagDisplayChannelJournal) ? _c('div', {
    staticClass: "row"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('api-device-panes-v1p00', {
    attrs: {
      "panes": _vm.actualBundle.channels[_vm.channelIndex].ChannelData.Readings.detailPanes
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('channel-journal', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelHideJournal[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('api-device-panes-v1p00', {
    attrs: {
      "panes": _vm.actualBundle.channels[_vm.channelIndex].ChannelData.Readings.detailPanes
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelShowJournal[_vm.actualLanguage]))])])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])])])], 1) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBundle === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBundle) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.bundleIndex].bundle_name))])]), _vm._v(" "), (_vm.flagDisplayBundle) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h1', {
    staticClass: "page-heading"
  }, [_vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.bundleIndex].bundle_id))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-narrow"
  }, [_c('h1', {
    staticClass: "page-heading"
  }, [_vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.bundleIndex].bundle_id))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveMyProfile()
      }
    }
  }, [_vm._v("New Button")])])])])])])]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayGraphBlock) ? _c('div', {
    staticClass: "block"
  }, [(_vm.btnTimeLineSelected) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm disabled",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelTimeSeries[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectTimeLine()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelTimeSeries[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.btnHistogramSelected) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm disabled",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelHistogram[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectHistogram()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelHistogram[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.btnMovingAverageSelected) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm disabled",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.btnMovingAverageSelected = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelMovingAverage[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectMovingAverage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelMovingAverage[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.btnSessionsSelected) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm disabled",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-1x"
  }), _vm._v(" Sessions")])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-sm",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectSession()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-1x"
  }), _vm._v(" Sessions")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content text-right"
  }, [(_vm.btnTimeLineSelected) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('port-graph', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.btnMovingAverageSelected) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('moving-average-graph', {
    attrs: {
      "channel_id": _vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.btnHistogramSelected) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('histogram-graph', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.btnSessionsSelected) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('sessions-graph', {
    attrs: {
      "channel_id": _vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelId
    }
  })], 1) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelSharingList[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [(_vm.ListOfSharings.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleSharingName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleRecipient[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleStatus[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAction[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ListOfSharings), function(sharing, index) {
    return _c('tr', [(sharing.sharedEntity.entityType == _vm.sharingListData.sharingType) ? _c('td', {
      staticClass: "text-center"
    }, [(sharing.sharedEntity.entityType === 'Channel') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Device') ? _c('i', {
      staticClass: "fa fa-server fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Bundle') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Group') ? _c('i', {
      staticClass: "fa fa-users fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Car') ? _c('i', {
      staticClass: "fa fa-car fa-2x push-5-r "
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType == _vm.sharingListData.sharingType) ? _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.sharedEntity.entityReferenceName))])]) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType == _vm.sharingListData.sharingType) ? _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.sharingReferenceName))])]) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType == _vm.sharingListData.sharingType) ? _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.guessEmail))])]) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType == _vm.sharingListData.sharingType) ? _c('td', {
      staticClass: "text-center"
    }, [(sharing.sharingStatus == 'Activated') ? _c('button', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusActivated[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'Rejected') ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusRejected[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'Pending') ? _c('button', {
      staticClass: "btn btn-xs btn-info",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusOnHold[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'OnHold') ? _c('button', {
      staticClass: "btn btn-xs btn-warning",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v("Pause")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType == _vm.sharingListData.sharingType) ? _c('td', {
      staticClass: "text-center"
    }, [(_vm.bundleConfigEditFlag) ? _c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editSharingRulePermissions(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (sharing.sharingStatus == 'Activated') ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Pause"
      },
      on: {
        "click": function($event) {
          return _vm.saveSharingStatus(index, 'OnHold')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pause"
    })]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'OnHold') ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Activer/Enable"
      },
      on: {
        "click": function($event) {
          return _vm.saveSharingStatus(index, 'Activated')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSharing(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()]) : _vm._e()])
  }), 0)]) : _vm._e()])])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("mmmmm something went wrong")])])
}]}

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [(_vm.displayFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "font-w300 align-center push-10"
  }, [_vm._v(_vm._s(_vm.actualNews.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualNews.sections), function(section, index) {
    return _c('div', [_c('h3', {
      staticClass: "font-w300 align-center push-10"
    }, [_vm._v(_vm._s(section.subTitle[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((section.lines), function(line, index) {
      return _c('div', [_c('p', {
        staticClass: "font-w300 align-center push-10"
      }, [_vm._v(_vm._s(line[_vm.actualLanguage]))])])
    }), _vm._v(" "), (section.picture.length > 2) ? _c('div', {
      staticClass: "col-xs-12 col-md-12 align-center"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "width": "125px",
        "src": _vm._f("s3Image")(("news/" + (section.picture)))
      }
    })])])]) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 align-center"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "example-checkbox1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dontShowAgainFlag),
      expression: "dontShowAgainFlag"
    }],
    staticClass: "larger",
    attrs: {
      "type": "checkbox",
      "id": "example-checkbox1",
      "name": "example-checkbox1",
      "value": "option1"
    },
    domProps: {
      "checked": Array.isArray(_vm.dontShowAgainFlag) ? _vm._i(_vm.dontShowAgainFlag, "option1") > -1 : (_vm.dontShowAgainFlag)
    },
    on: {
      "click": _vm.toggleDontShowAgain,
      "change": function($event) {
        var $$a = _vm.dontShowAgainFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "option1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dontShowAgainFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.dontShowAgainFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dontShowAgainFlag = $$c
        }
      }
    }
  }), _vm._v(_vm._s(_vm.labelDontShowAgain[_vm.actualLanguage]) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 align-center push"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.closeModalWindow
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labelButtonClose[_vm.actualLanguage]))])])])], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 align-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelButton[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagReadByInvoiceData),
      expression: "flagReadByInvoiceData"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagReadByInvoiceData) ? _vm._i(_vm.flagReadByInvoiceData, null) > -1 : (_vm.flagReadByInvoiceData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagReadByInvoiceData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagReadByInvoiceData = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagReadByInvoiceData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagReadByInvoiceData = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.flagReadByInvoiceData) ? _c('h5', [_vm._v(_vm._s(_vm.lableActivated[_vm.actualLanguage]))]) : _c('h5', [_vm._v(_vm._s(_vm.lableNotActivated[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.flagReadByInvoiceData) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSelectInvoicePeriod[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedInvoiceIndex),
      expression: "selectedInvoiceIndex"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.applyInvoiceDate()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedInvoiceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.mainService.service_invoices), function(invoice, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(invoice.dateStartStr) + "   <--->   " + _vm._s(invoice.dateEndStr))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateStart),
      callback: function($$v) {
        _vm.visualisationDateStart = $$v
      },
      expression: "visualisationDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateEnd),
      callback: function($$v) {
        _vm.visualisationDateEnd = $$v
      },
      expression: "visualisationDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.readMainServiceGraphData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonReadGraph[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.flagGraphDataIsUpdating) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.summaryTableColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.summaryTableColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.summaryTableColumn03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.summary.subServices), function(sousService, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                              " + _vm._s(sousService.referenceName) + "\r\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                              " + _vm._s(sousService.pourcentage) + " %\r\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                              " + _vm._s(sousService.sumCost) + " $\r\n                            ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 align-right"
  }, [_c('h5', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.periodCost[_vm.actualLanguage]) + " $")]), _vm._v(" "), _c('h1', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.summary.sumCosts) + " $")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-pies', {
    attrs: {
      "GraphData": _vm.pieChartData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataMain1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataSub1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataSub2
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showModal) ? _c('div', [(_vm.largeSize == true) ? _c('div', {
    staticClass: "ix-modal__large"
  }, [_c('button', {
    staticClass: "ix-modal__close",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ix-modal__content"
  }, [_c(_vm.currentModalView, {
    tag: "component"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mobile == true & _vm.largeSize == false) ? _c('div', {
    staticClass: "ix-modal__small"
  }, [_c('button', {
    staticClass: "ix-modal__close",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ix-modal__content"
  }, [_c(_vm.currentModalView, {
    tag: "component"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mobile == false & _vm.largeSize == false) ? _c('div', {
    staticClass: "ix-modal"
  }, [_c('button', {
    staticClass: "ix-modal__close",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ix-modal__content"
  }, [_c(_vm.currentModalView, {
    tag: "component"
  })], 1)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.carSharingEnableFlag) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "h1 fa fa-share-alt fa-2x push-15-r "
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayCar === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayCar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayCar) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayCar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayCar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-car fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.cars[_vm.carIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayCar) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelRefrenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].ReferenceName),
      expression: "tempoBundle.cars[carIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information\\Write your information"
    },
    domProps: {
      "value": (_vm.tempoBundle.cars[_vm.carIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.carConfigViewFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.carName),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.carName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.carName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "carName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.carName) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldManufacturer[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.manufacturer),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.manufacturer"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "manufacturer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onManufacturerChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.manufacturers), function(manufacturer) {
    return _c('option', {
      domProps: {
        "value": manufacturer
      }
    }, [_vm._v(_vm._s(manufacturer))])
  })], 2)]) : _vm._e()])]), _vm._v(" "), (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.carPictureFile) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "200px",
      "src": _vm._f("s3Image")(("cars/" + (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.carPictureFile)))
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.evseFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-3"
  }, [(_vm.filteredYears.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldLevel[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.year),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.year"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onYearChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-3"
  }, [(_vm.filteredModels.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVSEBrand[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.model),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.model"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onModelChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredModels), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4 col-lg-3"
  }, [(_vm.filteredColors.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVSEModel[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.color),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.color"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onColorChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredColors), function(color) {
    return _c('option', {
      domProps: {
        "value": color
      }
    }, [_vm._v(_vm._s(color))])
  })], 2)]) : _vm._e()])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-3"
  }, [(_vm.filteredYears.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVYear[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.year),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.year"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onYearChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-3"
  }, [(_vm.filteredModels.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVModel[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.model),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.model"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onModelChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredModels), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-3"
  }, [(_vm.filteredColors.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVColor[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.color),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.color"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onColorChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filteredColors), function(color) {
    return _c('option', {
      domProps: {
        "value": color
      }
    }, [_vm._v(_vm._s(color))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-3"
  }, [(_vm.filteredColors.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEVConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.averageWhPerKm),
      expression: "tempoBundle.cars[carIndex].CarData.carInfo.averageWhPerKm"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.averageWhPerKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo, "averageWhPerKm", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.filteredColors.length) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayDevicePortConfig) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.textLabelDevicePort[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-6"
  }, [(_vm.tempoBundle.cars[_vm.carIndex].CarData.carInfo.color) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldLinkModule[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.linkedDevice),
      expression: "tempoBundle.cars[carIndex].CarData.linkedDevice"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData, "linkedDevice", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.tempoBundle.devices), function(device) {
    return _c('option', {
      domProps: {
        "value": device.DeviceData.deviceId
      }
    }, [_vm._v(_vm._s(device.DeviceData.deviceId))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-6"
  }, [(_vm.tempoBundle.cars[_vm.carIndex].CarData.linkedDevice) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldLinkPort[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.linkedPort),
      expression: "tempoBundle.cars[carIndex].CarData.linkedPort"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData, "linkedPort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSelect[_vm.actualLanguage]))]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5, 6]), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayDevicePortConfig) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.textLabelChargeDetectionRange[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-6"
  }, [(_vm.tempoBundle.cars[_vm.carIndex].CarData.linkedDevice) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSessDetecMinThld[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.sessionDetectionParam[0].minPower),
      expression: "tempoBundle.cars[carIndex].CarData.sessionDetectionParam[0].minPower"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.tempoBundle.cars[_vm.carIndex].CarData.sessionDetectionParam[0].minPower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.sessionDetectionParam[0], "minPower", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-6"
  }, [(_vm.tempoBundle.cars[_vm.carIndex].CarData.linkedDevice) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "deviceSelect"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldSessDetecMaxThld[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.cars[_vm.carIndex].CarData.sessionDetectionParam[0].maxPower),
      expression: "tempoBundle.cars[carIndex].CarData.sessionDetectionParam[0].maxPower"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.tempoBundle.cars[_vm.carIndex].CarData.sessionDetectionParam[0].maxPower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.cars[_vm.carIndex].CarData.sessionDetectionParam[0], "maxPower", $event.target.value)
      }
    }
  })]) : _vm._e()])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "name": "buttonDeletePlanItem2"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveCar()
      }
    }
  }, [(_vm.carIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDelete[_vm.actualLanguage]))])], 1)]), _vm._v(" "), (_vm.tempoBundle.cars[_vm.carIndex].CarData.linkedPort) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [(_vm.carConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveCarModifications()
      }
    }
  }, [(_vm.carIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSaveModification[_vm.actualLanguage]))])], 1) : _vm._e()])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Configuration")])
}]}

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [(_vm.dashboardFlags['evsensAdminFlag']) ? _c('div', {
    staticClass: "sidebar-l sidebar-o header-navbar-fixed",
    class: {
      'sidebar-o-xs': _vm.sidebarIsActive
    },
    attrs: {
      "id": "page-container"
    }
  }, [_c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar-scroll"
    }
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "side-header side-content bg-white-op"
  }, [_c('button', {
    staticClass: "btn btn-link text-gray pull-right hidden-md hidden-lg",
    attrs: {
      "type": "button",
      "data-toggle": "layout",
      "data-action": "sidebar_close"
    },
    on: {
      "click": function($event) {
        return _vm.displaySidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('a', {
    staticClass: "h5 text-white"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w600 sidebar-mini-hide"
  }, [_vm._v(_vm._s(_vm.profileData.licences[0].licenceLabel[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.actualiserArborescence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelRefresh[_vm.actualLanguage]) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goHomeGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home fa-2x pull-left"
  }), _c('font', {
    attrs: {
      "size": "3",
      "color": "white"
    }
  }, [_vm._v("Home")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagArborescenceIsLoading == false) ? _c('ul', {
    staticClass: "nav-main"
  }, [_c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', {
    staticClass: "sidebar-mini-hide"
  }, [_c('font', {
    attrs: {
      "size": "3"
    }
  }, [_vm._v(_vm._s(_vm.menuLabelGroup[_vm.actualLanguage]))])], 1)]), _vm._v(" "), (_vm.flagGroupSelectedByBundle === false) ? _c('div', _vm._l((_vm.groupParentTempo), function(group, index) {
    return _c('div', [(group.sub_group.length) ? _c('div', [(_vm.flagGroupInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1), _vm._v(" "), (group.sub_group.length) ? _c('ul', _vm._l((group.sub_group), function(subGroup, index2) {
      return _c('div', [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.selectSecondLevelGroup(index2)
          }
        }
      }, [_vm._v(_vm._s(subGroup.group_name))])])])
    }), 0) : _vm._e()])]) : _c('div', [_c('li', [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1)])])]) : _c('div', [(_vm.flagGroupInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      staticClass: "active",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      staticClass: "active",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1)])]) : _c('div', [_c('li', [(group.group_id.includes('DefaultGroup', 1)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(group.group_name))])], 1)])])])])
  }), 0) : _c('div', [_c('div', {
    staticClass: "block-content"
  }, [(_vm.flagPersonalGroupSelected) ? _c('button', {
    staticClass: "btn btn-block btn-default",
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-2x pull-left"
  }), _c('font', {
    attrs: {
      "size": "2",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.actualGroup.group_name))])], 1) : _c('button', {
    staticClass: "btn btn-block btn-default",
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-users fa-2x pull-left"
  }), _c('font', {
    attrs: {
      "size": "2",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.actualGroup.group_name))])], 1)])]), _vm._v(" "), (_vm.flagGroupSelected) ? _c('div', [_c('div', {
    staticClass: "block-content push-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content push-10"
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', {
    staticClass: "sidebar-mini-hide"
  }, [_c('font', {
    attrs: {
      "size": "3"
    }
  }, [_vm._v(_vm._s(_vm.menuLabelSystem[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _vm._l((_vm.bundleParentTempo.bundles), function(bundle, index) {
    return _c('div', [(bundle.sub_bundle.length) ? _c('div', [(_vm.flagBundleInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [_c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1), _vm._v(" "), (bundle.sub_bundle.length) ? _c('ul', _vm._l((bundle.sub_bundle), function(subBundle, index2) {
      return _c('div', [_c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.selectSecondLevelBundle(index2)
          }
        }
      }, [_vm._v(_vm._s(subBundle.ReferenceName))])])])
    }), 0) : _vm._e()])]) : _c('div', [_c('li', [_c('a', {
      staticClass: "nav-submenu",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1)])])]) : _c('div', [(_vm.flagBundleInParentSelect[index]) ? _c('div', [_c('li', {
      staticClass: "open"
    }, [_c('a', {
      staticClass: "active",
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1)])]) : _c('div', [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.selectFirstLevelBundle(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }), _c('font', {
      attrs: {
        "size": "2"
      }
    }, [_vm._v(_vm._s(bundle.bundle_name))])], 1)])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content push-10"
  }), _vm._v(" "), (_vm.flagGroupSelectedByBundle) ? _c('div', {
    staticClass: "block-content"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSelectedBundle()
      }
    }
  }, [(_vm.flagBundleIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-cloud-download pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelReadSystem[_vm.actualLanguage]))])], 1)]) : _vm._e()], 2) : _vm._e()]) : _c('spinner')], 1)])])]), _vm._v(" "), _c('header', {
    staticClass: "content-mini content-mini-full",
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed"
  }, [_c('ul', {
    staticClass: "nav-header pull-left"
  }, [_c('li', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "layout",
      "data-action": "sidebar_toggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.displaySidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "nav-header pull-right"
  }, [(_vm.mobile == false && _vm.displayElIot) ? _c('li', [_c('h3', {
    staticClass: "h3 block-title"
  }, [_vm._v(_vm._s(_vm.messageAcceuil[_vm.actualLanguage]) + " " + _vm._s(_vm.profileData.profileInfo.firstName) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.displayHeadMenuShowHideButton && _vm.mobile == false) ? _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleShowHideHead()
      }
    }
  }, [(_vm.displayHeadMenu) ? _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.displayHideHeadMenuClose[_vm.actualLanguage]))]) : _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.displayHideHeadMenuOpen[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLanguage()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "si si-settings"
  }), _vm._v(" " + _vm._s(_vm.actualLanguage))])])]) : _c('li', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLanguage()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.actualLanguage))])])]), _vm._v(" "), (_vm.mobile == false) ? _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "si si-power"
  })])]) : _c('li', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "si si-power"
  })])])])])]), _vm._v(" "), (_vm.displayHeadMenu) ? _c('div', {
    staticClass: "row"
  }, [(_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('hr'), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb push-10-t"
  }, [_c('li', [_c('a', {
    staticClass: "link-effect",
    on: {
      "click": function($event) {
        return _vm.goHomeGroup()
      }
    }
  }, [_c('font', {
    attrs: {
      "size": "3"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Home")])], 1)]), _vm._v(" "), _vm._l((_vm.navBarLink), function(navItem, index) {
    return _c('li', [_c('a', {
      staticClass: "link-effect",
      on: {
        "click": function($event) {
          return _vm.goBackNav(index)
        }
      }
    }, [(navItem.Type === 'GU') ? _c('i', {
      staticClass: "fa fa-users fa-1x push-5-r "
    }) : _vm._e(), (navItem.Type === 'GS') ? _c('i', {
      staticClass: "fa fa-usb fa-1x push-5-r "
    }) : _vm._e(), _c('font', {
      attrs: {
        "size": "3"
      }
    }, [_vm._v(_vm._s(navItem.Name))])], 1)])
  })], 2), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.flagGroupSelected) ? _c('div', [(_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('h3', [(_vm.flagPersonalGroupSelected == false) ? _c('i', {
    staticClass: "fa fa-industry push-5-r"
  }) : _vm._e(), _vm._v(_vm._s(_vm.actualGroup.rightsProviderName) + "\n            ")]), _vm._v(" "), _c('hr')]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.flagBundleIsLoaded) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-darker navbar-collapse remove-padding collapse",
    attrs: {
      "id": "sub-header-nav"
    }
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sub-header push"
  }, [(false) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 1
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelProfileButton[_vm.actualLanguage]) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length && _vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 2
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'ports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-car push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelPortButton[_vm.actualLanguage]) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 3
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'measurements'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelMesElcButton[_vm.actualLanguage]) + "\n                    ")])], 1), _vm._v(" "), (_vm.flagDisplayCostSplittingMenu) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 4
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'cost-splitting'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelSplitCostButton[_vm.actualLanguage]) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 5
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'configuration'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders push-5-r"
  }), _vm._v(" Configuration\n                    ")])], 1), _vm._v(" "), (_vm.profileData.sharingInvitations.length > 0) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 6
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'sharing'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt push-5-r fa-1x"
  }), _vm._v(" " + _vm._s(_vm.labelSharingButton[_vm.actualLanguage]) + " "), _c('i', {
    staticClass: "fa fa-exclamation-circle push-5-r fa-1x"
  })])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 7
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'help'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelHelpButton[_vm.actualLanguage]) + "\n                    ")])], 1), _vm._v(" "), (_vm.dashboardFlags.evsensMasterFlag) ? _c('li', {
    staticClass: "btnmenu",
    on: {
      "click": function($event) {
        _vm.headerMenuSelectedTab = 8
      }
    }
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'evsensadmin'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-server push-5-r"
  }), _vm._v(" EV Sens Admin\n                    ")])], 1) : _vm._e()])])])])])]) : _vm._e()])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), (_vm.flagBundleIsLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 align-center push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.messageLoading[_vm.actualLanguage]))]), _vm._v(" "), _c('spinner')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.mobile == false) ? _c('div', {
    staticClass: "col-md-12 push"
  }) : _vm._e(), _vm._v(" "), (_vm.flagBundleIsLoaded) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.mobile) ? _c('div', [(_vm.headerMenuSelectedTab == 3 || _vm.headerMenuSelectedTab == 4) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSelectedBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download pull-left"
  }), _c('i', {
    staticClass: "fa fa-refresh pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelReadRefreshSystem[_vm.actualLanguage]) + "\n                ")])]) : _vm._e()]) : _c('div', [(_vm.headerMenuSelectedTab == 3 || _vm.headerMenuSelectedTab == 4) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSelectedBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download pull-left"
  }), _c('i', {
    staticClass: "fa fa-refresh pull-left"
  }), _vm._v(_vm._s(_vm.buttonLabelReadRefreshSystem[_vm.actualLanguage]) + " : " + _vm._s(_vm.bundleTempo.bundle_name) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('router-view')], 1)]) : _c('div', [(_vm.flagDisplayHome) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayHomeTab) ? _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuProfile[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-industry"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuOrganizations[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuFirstLevelGroup[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuResearch[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.homeTabMenuSelector[4] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleHomeTabMenuSelector(4)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuHelp[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[0] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('profile-view')], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[1] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.profileData.managed_organizations.length > 0) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelOrganization[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profileData.managed_organizations), function(organization, index) {
    return _c('div', [_c('organization-display', {
      attrs: {
        "organizationIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button",
      "data-toggle": "popover",
      "title": this.massageOrganizationRequired[this.actualLanguage]
    },
    on: {
      "click": function($event) {
        return _vm.showModal('organization-add-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateOrganization[_vm.actualLanguage]))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMultiGroupDocumentation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-1x push-10-r "
  }), _vm._v(_vm._s(_vm.buttonHelpManagerVersionDocumentation[_vm.actualLanguage]))])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[2] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.userAcessLevel2Flag && _vm.profileData.managed_organizations.length > 0 && _vm.mobile == false) ? _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textLabelCreateFirstLevelGroup[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v(_vm._s(_vm.textIndicationCreateFirstLevelGroup[_vm.actualLanguage]) + " :  " + _vm._s(_vm.profileData.managed_organizations[_vm.actualOrganizationIndex].organizationName))])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelSelectGroup[_vm.actualLanguage]) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualOrganizationIndex),
      expression: "actualOrganizationIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualOrganizationIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.profileData.managed_organizations), function(organization, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                                              " + _vm._s(organization.organizationName) + "\n                                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewGroupInOrganization()
      }
    }
  }, [(_vm.groupInOrganizationIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-users fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateFirstLevelGroup[_vm.actualLanguage]))])], 1)])])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[3] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "content content-boxed push"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.findElementSectionLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stringToFind),
      expression: "stringToFind"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Rechercher/Search"
    },
    domProps: {
      "value": (_vm.stringToFind)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.researchInProfile()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stringToFind = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.researchInProfile()
      }
    }
  }, [(_vm.researchInProgress) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('i', {
    staticClass: "fa fa-search"
  })], 1)])])]), _vm._v(" "), (_vm.searchDoneFlag) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.researchResults.length > 0) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitlePath[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleRefName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.researchTableTitleAction[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.researchResults), function(findItem, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center-bold"
    }, [(findItem.EntityType === 'Channel') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Device') ? _c('i', {
      staticClass: "fa fa-server fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Bundle') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Group') ? _c('i', {
      staticClass: "fa fa-users fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (findItem.EntityType === 'Car') ? _c('i', {
      staticClass: "fa fa-car fa-2x push-5-r "
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      on: {
        "click": function($event) {
          return _vm.researchResultGoToPath(index)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(findItem.EntityPath))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(findItem.EntityName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(findItem.EntityReferenceName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Aller à/ Go to"
      },
      on: {
        "click": function($event) {
          return _vm.researchResultGoToPath(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-folder-open"
    })])])])
  }), 0)])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.findElementNoResults[_vm.actualLanguage]))])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.homeTabMenuSelector[4] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('help-section')], 1)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', {
    staticClass: "row push"
  }, _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', {
      staticClass: "row push"
    }, [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Group') ? _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.groupConfigEditFlag) ? _c('div', {
      staticClass: "content content-boxed"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textYouReceiveGroupSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1)]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), (_vm.flagBundleSelected === false) ? _c('div', [(_vm.groupConfigViewFlag && _vm.flagPersonalGroupSelected == false) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h2', {
    staticClass: "font-w300 push-30"
  }, [_vm._v(_vm._s(_vm.textIndicationSelectAddGroupOrSystem[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textIndicationAddOrModifyGroup[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-group fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.actualGroup.group_name))])])]), _vm._v(" "), (_vm.flagShowCustomerSupportSection) ? _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_vm._m(3), _vm._v(" "), (_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-lg-12 push"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewUserProfile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-user fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v("Create customer profile for pre-configuration")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 push"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addDefaultBundleOfExistingUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v("Add an existing customer profile bundle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 push"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeSpecifiedSystem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v("Remove specific system from this group")])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelAddComponentToGroupe[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewGroupInGroup()
      }
    }
  }, [(_vm.groupInGroupIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-users fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddSubGroup[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewBundleInGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelAddSystemToGroup[_vm.actualLanguage]) + " ")])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row push"
  }, [(_vm.groupSharingEnableFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareActualGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareThisGroup[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.groupConfigDeleteFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteActualGroup()
      }
    }
  }, [(_vm.groupIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteGroup[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-sliders fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.blocLabelConfigGroup[_vm.actualLanguage]))])]), _vm._v(" "), _c('config-group')], 1)])]), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', {
    staticClass: "row push"
  }, _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', {
      staticClass: "row push"
    }, [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Group') ? _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.groupConfigEditFlag) ? _c('div', {
      staticClass: "content content-boxed"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textYouReceiveGroupSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1)]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', {
    staticClass: "row push"
  }, _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', {
      staticClass: "row push"
    }, [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Bundle') ? _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.groupConfigEditFlag) ? _c('div', {
      staticClass: "content content-boxed"
    }, [_c('div', {
      staticClass: "block-content"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textYouReceiveSystemSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1)]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textIndicationSelectGroupOrSystem[_vm.actualLanguage]))])])])])])]) : _c('div', {
    staticClass: "content content-boxed"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textMessageSelectAndPressReadSystem[_vm.actualLanguage]))])])])])])])]), _vm._v(" "), _vm._m(7)]) : _c('div', {
    staticClass: "sidebar-l side-scroll header-navbar-fixed",
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "page-container"
    }
  }, [_c('header', {
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed"
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "nav-header pull-right"
  }, [(_vm.mobile == false) ? _c('li', [_c('h3', {
    staticClass: "h3 block-title"
  }, [_vm._v(_vm._s(_vm.messageAcceuil[_vm.actualLanguage]) + " " + _vm._s(_vm.profileData.profileInfo.firstName) + " ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLanguage()
      }
    }
  }, [_c('i', {
    staticClass: "si si-settings"
  }), _vm._v(" " + _vm._s(_vm.actualLanguage) + "\n              ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "si si-power"
  })])])])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-darker navbar-collapse remove-padding collapse",
    attrs: {
      "id": "sub-header-nav"
    }
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sub-header push"
  }, [_c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelProfileButton[_vm.actualLanguage]) + "\n                ")])], 1), _vm._v(" "), (_vm.profileData.rights.rights.dashboardEvLogFlag && _vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'ports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-car push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelPortButton[_vm.actualLanguage]) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'measurements'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flash push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelMesElcButton[_vm.actualLanguage]) + "\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'configuration'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders push-5-r"
  }), _vm._v(" Configuration\n                ")])], 1), _vm._v(" "), (_vm.profileData.sharingInvitations.length > 0) ? _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'sharing'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt push-5-r fa-1x"
  }), _vm._v(" " + _vm._s(_vm.labelSharingButton[_vm.actualLanguage]) + " "), _c('i', {
    staticClass: "fa fa-exclamation-circle push-5-r fa-1x"
  })])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'help'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question push-5-r"
  }), _vm._v(" " + _vm._s(_vm.labelHelpButton[_vm.actualLanguage]) + "\n                ")])], 1), _vm._v(" "), (_vm.dashboardFlags.evsensMasterFlag) ? _c('li', {
    staticClass: "btnmenu"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        name: 'evsensadmin'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-server push-5-r"
  }), _vm._v(" EV Sens Admin\n                ")])], 1) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-container"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push 50"
  }), _vm._v(" "), (_vm.profileData.profileInfo.policyAgreement.agreeFlag) ? _c('div', [(_vm.profileDataReceivedFlag && _vm.flagBundleIsLoaded) ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagBundleIsLoading == false) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelSession[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success btn-lg push-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelSessionBtn[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]) : _c('div', {
    staticClass: "col-md-12 align-center push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.messageLoading[_vm.actualLanguage]))]), _vm._v(" "), _c('spinner')], 1)])]) : _c('div', {
    staticClass: "block-content"
  }, [_c('policy-agreement')], 1)]), _vm._v(" "), _vm._m(11)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header-content"
  }, [_c('a', {
    staticClass: "h4 main-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(435)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-lighter visible-xs"
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default visible-xs push collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#sub-header-nav",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon push-5-r"
  }), _vm._v("Menu\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 push"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-user fa-1x push-5-r "
  }), _vm._v("EV Sens Customer support")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Use this button to create a non existing user profile and add its system in this group.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Use this button to add the default system of an existing user profile email. Note the added system will have a generic name. Don't add two generic name system at same time in the group.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v("Use this button to remove a specific system from this group.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "content-mini content-mini-full font-s12 bg-gray-lighter clearfix",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "https://evsens.ca",
      "target": "_blank"
    }
  }, [_vm._v("Energisys  technologie")]), _vm._v(" © "), _c('span', {
    staticClass: "js-year-copy"
  }, [_vm._v("2026")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-header pull-left"
  }, [_c('li', {
    staticClass: "header-content"
  }, [_c('a', {
    staticClass: "h5 main-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(435)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-lighter visible-xs"
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default visible-xs push collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#sub-header-nav",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon push-5-r"
  }), _vm._v("Menu\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr'), _vm._v(" "), _c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "content-mini content-mini-full font-s12 bg-gray-lighter clearfix",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "https://evsens.ca",
      "target": "_blank"
    }
  }, [_vm._v("EV Sens ")]), _vm._v(" © "), _c('span', {
    staticClass: "js-year-copy"
  }, [_vm._v("2020")])])])
}]}

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateSignalsSet[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelTemplateId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateId),
      expression: "templateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant de gabarit / Template ID"
    },
    domProps: {
      "value": (_vm.templateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateId = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleVariables[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.deviceSignals), function(signal, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.signalName),
        expression: "signal.signalName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (signal.signalName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(signal, "signalName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.signalLabel.FR),
        expression: "signal.signalLabel.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (signal.signalLabel.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(signal.signalLabel, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.signalLabel.EN),
        expression: "signal.signalLabel.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (signal.signalLabel.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(signal.signalLabel, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableDataFormat[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.dataFormat),
        expression: "signal.dataFormat"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(signal, "dataFormat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Single"
      }
    }, [_vm._v("Simple / Single")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Array"
      }
    }, [_vm._v("Vecteur (liste) / Array")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableDataType[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.dataType),
        expression: "signal.dataType"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(signal, "dataType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Numeric"
      }
    }, [_vm._v("Numerique / Numeric")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Bool"
      }
    }, [_vm._v("Booléen / Boolean")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addDeviceSignal()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddSignal[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.deviceSignals.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDeviceSignal()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteSignal[_vm.actualLanguage]))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleControlParameter[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription02[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.controlParameters), function(parameter, index3) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.parameterLabel.FR),
        expression: "parameter.parameterLabel.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (parameter.parameterLabel.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter.parameterLabel, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.parameterLabel.EN),
        expression: "parameter.parameterLabel.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (parameter.parameterLabel.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter.parameterLabel, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.parameterName),
        expression: "parameter.parameterName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (parameter.parameterName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "parameterName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterDataType[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataType),
        expression: "parameter.dataType"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "dataType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeDataType(index3)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "Numeric"
      }
    }, [_vm._v("Numerique / Numeric")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "String"
      }
    }, [_vm._v("Chaîne caractère / String")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Bool"
      }
    }, [_vm._v("Booléen / Boolean")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagVisibleByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagViewByCustomer),
        expression: "parameter.flagViewByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagViewByCustomer) ? _vm._i(parameter.flagViewByCustomer, null) > -1 : (parameter.flagViewByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagViewByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagViewByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagViewByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagViewByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagEditByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagEditByCustomer),
        expression: "parameter.flagEditByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagEditByCustomer) ? _vm._i(parameter.flagEditByCustomer, null) > -1 : (parameter.flagEditByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagEditByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagEditByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagEditByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagEditByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addDeviceControlParameter()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddParameter[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.controlParameters.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDeviceControlParameter()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteParameter[_vm.actualLanguage]))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.deviceSignals.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectApiKey[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApiKey),
      expression: "selectedApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApiKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.overlayParameters.organizationApiKeys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.key
      }
    }, [_vm._v(_vm._s(key.referenceName) + " : " + _vm._s(key.key))])
  }), 0)]), _vm._v(" "), (_vm.selectedApiKey.length > 0) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSignalSetTemplate()
      }
    }
  }, [(_vm.templateIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n    " + _vm._s(_vm.channelDisplayFlag) + "\n    "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textSectionActualMeasurement[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedMaxCurrent
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-w300 push"
  }, [_c('i', {
    staticClass: "fa fa-users fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.actualGroup.group_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.actualGroupLevel === 1) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.displayAddGroupToUser = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v("Ajouter un groupe de Niveau 1")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-handshake-o fa-1x push-5-r "
  }), _vm._v("Accepter une invitation de partage")])])])]), _vm._v(" "), (_vm.displayAddGroupToUser) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('create-group-form', {
    attrs: {
      "componentState": "01"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDisplayAddGroupToUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v("Fermer")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), (_vm.actualGroup.permissions.GrpLinkedProfileRead[0]) ? _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-striped remove-margin-b font-s16"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.linked_profile), function(profile) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(profile.email))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(profile.rule.rule_id === 'Full Access') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Plein Accèes")]) : _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Personalisé")])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [(profile.rule.rule_id === 'Full Access') ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Créer un accèes personalisé"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    })]) : _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier les accèes"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _vm._m(2, true)])])])
  }), 0)]), _vm._v(" "), (_vm.actualGroup.permissions.GrpSharingEnable[0]) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v("Inviter un usager au groupe")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.actualGroup.permissions.GrpSubGroupRead[0]) ? _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table table-striped remove-margin-b font-s14"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.sub_group), function(group) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(group.group_name))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(group.sub_group.length))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(group.bundles.length))])])
  }), 0)]), _vm._v(" "), (_vm.actualGroup.permissions.GrpSubGroupWrite[0]) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.displayAddSubGroupToGroup = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v("Ajouter un sous-groupe usagers")])]) : _vm._e(), _vm._v(" "), (_vm.displayAddSubGroupToGroup) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('create-sub-group-form', {
    attrs: {
      "componentState": "01"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDisplayAddSubGroupToGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v("Fermer")])])], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.actualGroup.permissions.GrpBundleRead[0]) ? _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table table-striped remove-margin-b font-s14"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.bundles), function(bundle) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.bundle_name))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.bundle_type))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.devices.length))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(bundle.channels.length))])])
  }), 0)]), _vm._v(" "), (_vm.actualGroup.permissions.GrpSubGroupWrite[0]) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v("Ajouter un groupe système")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm._m(7)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-user fa-2x push-5-r "
  }), _vm._v("Usagers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Usager")]), _vm._v(" "), _c('th', [_vm._v("Type d'accès")]), _vm._v(" "), _c('th', [_vm._v("Accès")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Retirer l'usager"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-users fa-2x push-5-r "
  }), _vm._v("Sous groupes d'usagers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Groupes")]), _vm._v(" "), _c('th', [_vm._v("#Sous Groupes")]), _vm._v(" "), _c('th', [_vm._v("#Groupes Système")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-database fa-2x push-5-r "
  }), _vm._v("Groupes système")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Groupes système")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("#Device")]), _vm._v(" "), _c('th', [_vm._v("#Canaux")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  })])])
}]}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.flagRuleIsLoading) ? _c('spinner') : _c('div', {
    staticClass: "block-content"
  }, [(_vm.sharingTransmittedFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 align-center"
  }, [_c('i', {
    staticClass: "fa fa-check align-center fa-3x"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "font-w300 align-center push-10"
  }, [_vm._v(_vm._s(_vm.textSharingTransmitted[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 align-center push-10"
  }, [_vm._v(_vm._s(_vm.textSharingTransmitted2[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h2', {
    staticClass: "font-w300 push-10 align-center"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-15-r "
  }), _vm._v(_vm._s(_vm.overlayParameters.sharingReferenceName))]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.overlayParameters.sharingGuessEmail))]), _vm._v(" "), (_vm.displayUserOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionUser[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.user), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.user[index1].value),
        expression: "ruleTemplate.permissions.user[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.user[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.user[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.user[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.user[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.user[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.user[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.user[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.displayGroupOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-users push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionGroup[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.group), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.group[index1].value),
        expression: "ruleTemplate.permissions.group[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.group[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.group[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.group[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.group[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.group[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.group[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.group[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.displayBundleOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-usb push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionBundle[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.bundle), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.bundle[index1].value),
        expression: "ruleTemplate.permissions.bundle[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.bundle[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.bundle[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.bundle[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.bundle[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.bundle[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.bundle[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.bundle[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.displayDeviceOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-server push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionDevice[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.device), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.device[index1].value),
        expression: "ruleTemplate.permissions.device[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.device[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.device[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.device[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.device[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.device[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.device[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.device[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.displayChannelOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-television push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionChannel[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.channel), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.channel[index1].value),
        expression: "ruleTemplate.permissions.channel[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.channel[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.channel[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.channel[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.channel[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.channel[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.channel[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.channel[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.displayAlertOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-bell push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionAlert[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.alert), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.alert[index1].value),
        expression: "ruleTemplate.permissions.alert[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.alert[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.alert[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.alert[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.alert[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.alert[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.alert[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.alert[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.displayCarOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-car push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionCar[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.car), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.car[index1].value),
        expression: "ruleTemplate.permissions.car[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.car[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.car[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.car[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.car[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.car[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.car[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.car[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSharingPermissions()
      }
    }
  }, [(_vm.commentIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonShare[_vm.actualLanguage]))])], 1)])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelComponentTop[_vm.actualLanguage]))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '999') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.PaymentSuccess[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.CloseThisWindow[_vm.actualLanguage]))]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  })])])]) : _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "error red center-align white-text"
  }, [_vm._v("\n                " + _vm._s(_vm.stripeValidationError) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.purchase()
      }
    }
  }, [(_vm.processingTransaction) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.Pay[_vm.actualLanguage]))])], 1), _vm._v("\n        " + _vm._s(_vm.transactionMessage) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  })])])
}]}

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "push-50-t"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "push-30-t"
  }, [_vm._v(_vm._s(_vm.labelFieldMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('form', {
    staticClass: "simple_form form-horizontal push-50-t"
  }, [_c('div', {
    staticClass: "form-inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.email),
      expression: "userInfos.email"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_email"
    },
    domProps: {
      "value": (_vm.userInfos.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_email"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.verifyCode),
      expression: "userInfos.verifyCode"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_verifyCode"
    },
    domProps: {
      "value": (_vm.userInfos.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "verifyCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_verifyCode"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldConfirmationCode[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isVerifying) ? _c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitVerification
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonVerify[_vm.actualLanguage]))]) : _c('spinner')], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.labelFieldAlready[_vm.actualLanguage]) + "\n        "), _c('router-link', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labelFieldButtonLogIn[_vm.actualLanguage]) + "\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.actualBundle.cars.length == 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.textNoEVCarRegistered[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelTimeSelectorTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('range-picker', {
    on: {
      "refresh": _vm.refreshData
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCar),
      expression: "selectedCar"
    }],
    staticClass: "push",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.actualBundle.cars), function(charge, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(_vm.actualBundle.cars[index].ReferenceName))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "280px",
      "src": _vm._f("s3Image")(("cars/" + (_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.carPictureFile)))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('div', {
    staticClass: "block block-rounded block-bordered"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success text-center push"
  }, [_c('div', {
    staticClass: "font-w400 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm.labelCarTotalSavings[_vm.actualLanguage]))]), _vm._v(" "), _c('span', {
    staticClass: "h2 font-w600 font-s30 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm._f("toCurrency")(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.lifeTimeMoneySavings)))])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted animated fadeIn text-center"
  }, [_c('small', [_c('i', {
    staticClass: "si si-calendar"
  }), _vm._v(" " + _vm._s(_vm.labelCarTotalSavingsStartDate[_vm.actualLanguage]) + " " + _vm._s(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.startingDate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('div', {
    staticClass: "block block-rounded block-bordered"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success text-center push"
  }, [_c('div', {
    staticClass: "font-w400 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm.labelCarTotalGreenSavings[_vm.actualLanguage]))]), _vm._v(" "), _c('span', {
    staticClass: "h2 font-w600 font-s30 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.lifeTimeGreenGazSavings)) + " T CO2")])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted animated fadeIn text-center"
  }, [_c('small', [_c('i', {
    staticClass: "si si-calendar"
  }), _vm._v(" " + _vm._s(_vm.labelCarTotalSavingsStartDate[_vm.actualLanguage]) + " " + _vm._s(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.startingDate))])])])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', {
    staticClass: "content-heading"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryTitle[_vm.actualLanguage]) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm._f("formatDate")(_vm.startDate)) + " " + _vm._s(_vm.labelPeriodSummaryTitle2[_vm.actualLanguage]) + " " + _vm._s(_vm._f("formatDate")(_vm.endDate)) + ")")])])])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row-flex row-flex__5 dashboar-month-data"
  }, [_c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryChargeCosts[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.totalCost)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  }, [_vm._v("$")])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryChargeTime[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("toMinutes")(_vm.totalChargeTime)))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-download fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryPower[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.totalEnergy)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  }, [_vm._v("kWh")])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGazSaving[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("toCurrency")(_vm.totalMoneySaving)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  })])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-leaf fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGreenGazSaving[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.totalgreenGazSaving)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  }, [_vm._v(" T CO2")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGraphCharge[_vm.actualLanguage]) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm._f("formatDate")(_vm.startDate)) + " au " + _vm._s(_vm._f("formatDate")(_vm.endDate)) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [(_vm.chargeMonthChartData) ? _c('bar-chart', {
    attrs: {
      "chartData": _vm.chargeMonthChartData
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGraphCosts[_vm.actualLanguage]) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm._f("formatDate")(_vm.startDate)) + " au " + _vm._s(_vm._f("formatDate")(_vm.endDate)) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [(_vm.costMonthChartData) ? _c('bar-chart', {
    attrs: {
      "chartData": _vm.costMonthChartData
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryTableTitle[_vm.actualLanguage]) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table remove-margin-b font-s13"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColStart[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColEnd[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColEnergy[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColCost[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColSaving[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColGreenSaving[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.carChargeList), function(charge) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(charge.startTime))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs text-muted "
    }, [_vm._v(_vm._s(charge.endTime))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.energy)))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.cost)))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.moneySaving)))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.greenGazSaving)))])])
  }), 0)])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w200 push-10"
  }, [_vm._v(_vm._s(_vm.labelResultFilter[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((this.tableTitle), function(columnTitle, index) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', [_vm._v(_vm._s(columnTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterSelectedOption[index]),
        expression: "filterSelectedOption[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-multiple-select",
        "name": "example-multiple-select",
        "size": "4",
        "multiple": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filterSelectedOption, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "None"
      }
    }, [_vm._v(_vm._s(_vm.labelNone[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.filterOptionList[index]), function(filterOption) {
      return _c('option', {
        domProps: {
          "value": filterOption
        }
      }, [_vm._v(_vm._s(filterOption))])
    })], 2), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.applyFilter2(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.labelApplyFilter[_vm.actualLanguage]))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelResetFilter[_vm.actualLanguage]))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w200 push-10"
  }, [_vm._v(_vm._s(_vm.resultsCount) + " " + _vm._s(_vm.labelResults[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayHistogramSection) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w200 push-10"
  }, [_vm._v(_vm._s(_vm.labelHistogramTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagDisplayHistogram),
      expression: "flagDisplayHistogram"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagDisplayHistogram) ? _vm._i(_vm.flagDisplayHistogram, null) > -1 : (_vm.flagDisplayHistogram)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagDisplayHistogram,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagDisplayHistogram = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagDisplayHistogram = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagDisplayHistogram = $$c
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.labelHistogramActivate[_vm.actualLanguage]) + "\n            ")]), _vm._v(" "), (_vm.flagDisplayHistogram) ? _c('div', [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelHistogramPerHour[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.histogramData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelHistogramPerDay[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('bar-chart', {
    attrs: {
      "chartData": _vm.histogramDataDay
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table remove-margin-b font-s13"
  }, [_c('thead', [_c('tr', _vm._l((this.tableTitle), function(columnTitle) {
    return _c('th', [_vm._v(_vm._s(columnTitle[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((this.tableData2), function(dataLine) {
    return _c('tr', _vm._l((dataLine), function(data) {
      return _c('td', {
        staticClass: "font-w600 text-muted"
      }, [_vm._v(_vm._s(data))])
    }), 0)
  }), 0)])])])])])
},staticRenderFns: []}

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.profileData.rights.displayName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelOptionEnabled[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelOptionSeeButton[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v(_vm._s(_vm.labelEnabledColumn[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Option")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Detail")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.historicDataAccessDays > 350) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionDataHistory1Y[_vm.actualLanguage]))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.historicDataAccessDays > 700) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionDataHistory2Y[_vm.actualLanguage]))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.historicDataAccessDays > 1000) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionDataHistory3Y[_vm.actualLanguage]))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.historicDataAccessDays > 10000) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionDataHistoryIll[_vm.actualLanguage]))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.dashboardEvLogFlag) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionEV_Platform[_vm.actualLanguage]))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.alertLimitPerBundle.max > 0) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionAlert[_vm.actualLanguage]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.planOptionAlertMax[_vm.actualLanguage]) + " : " + _vm._s(_vm.availableAlertCountString))])]), _vm._v(" "), (_vm.profileData.rights.rights.alertLimitPerBundle.max > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.alertLimitPerBundle.max > 0) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionAlertEmail[_vm.actualLanguage]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lblThisMonth[_vm.actualLanguage]) + " : " + _vm._s(_vm.profileData.rights.rights.emailMonthlyLimit.count) + " / " + _vm._s(_vm.profileData.rights.rights.emailMonthlyLimit.max))])]) : _vm._e(), _vm._v(" "), (_vm.profileData.rights.rights.alertLimitPerBundle.max > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.alertLimitPerBundle.max > 0) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionAlertSMS[_vm.actualLanguage]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lblThisMonth[_vm.actualLanguage]) + " : " + _vm._s(_vm.profileData.rights.rights.smsMonthlyLimit.count) + " / " + _vm._s(_vm.profileData.rights.rights.smsMonthlyLimit.max))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.logWeatherFlag) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionWeather[_vm.actualLanguage]))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [(_vm.profileData.rights.rights.unlimitedMaterialWarranty) ? _c('i', {
    staticClass: "fa fa-check fa-2x text-success"
  }) : _c('i', {
    staticClass: "fa fa-times fa-2x text-danger"
  })]), _vm._v(" "), _c('td', {
    staticClass: "font-w600"
  }, [_vm._v(_vm._s(_vm.planOptionUnlimitedMaterialWarranty[_vm.actualLanguage]))]), _vm._v(" "), _c('td')])])])]), _vm._v(" "), _c('h6', [_vm._v("*" + _vm._s(_vm.planOptionUnlimitedMaterialWarrantyCondition[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelCounterRenewal[_vm.actualLanguage]) + _vm._s(_vm.profileData.rights.countRenewalDate))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelSubscriptionRenewal[_vm.actualLanguage]) + _vm._s(_vm.profileData.profile_subscription.data.renewalDate))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getReportsHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonReadHistory[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelHistoryLength[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historyLength),
      expression: "historyLength"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.historyLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.historyLength = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.reportsIsReading) ? _c('spinner') : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportsList), function(report, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(report.report_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, _vm._l((report.linked_commissions), function(transaction) {
      return _c('p', [_vm._v(_vm._s(transaction.transactionId))])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('h6', [_vm._v(_vm._s(_vm.labelInvoiceAmount[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.total_amount) + " $")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.invoice_reference_number),
        expression: "report.invoice_reference_number"
      }],
      staticClass: "form-control align-center push",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (report.invoice_reference_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(report, "invoice_reference_number", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs align-center",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.saveReportReferenceNumber(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonInvoiceReferenceNumber[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(report.payment_done_by_evsens) ? _c('i', {
      staticClass: "fa fa-check-square"
    }) : _c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.payment_reference_number))])])])
  }), 0)])])])], 1)])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading == 'loading' || _vm.loading == 'completed') ? _c('div', [_c('div', {
    staticClass: "loading-bar-container"
  }, [_c('span', {
    class: ['loading-bar', _vm.loading]
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 align-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelButton[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagReadByInvoiceData),
      expression: "flagReadByInvoiceData"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagReadByInvoiceData) ? _vm._i(_vm.flagReadByInvoiceData, null) > -1 : (_vm.flagReadByInvoiceData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagReadByInvoiceData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagReadByInvoiceData = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagReadByInvoiceData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagReadByInvoiceData = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.flagReadByInvoiceData) ? _c('h5', [_vm._v(_vm._s(_vm.lableActivated[_vm.actualLanguage]))]) : _c('h5', [_vm._v(_vm._s(_vm.lableNotActivated[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateStart),
      callback: function($$v) {
        _vm.visualisationDateStart = $$v
      },
      expression: "visualisationDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateEnd),
      callback: function($$v) {
        _vm.visualisationDateEnd = $$v
      },
      expression: "visualisationDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.readUnitsGraphData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonReadGraph[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 align-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelFiltreSection[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelTagSelect[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTag),
      expression: "selectedTag"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTag = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.applyUnitFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Tous/All")]), _vm._v(" "), _vm._l((_vm.tagsList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.tagId
      }
    }, [_vm._v(_vm._s(type.tagName))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelSpecType[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedType),
      expression: "selectedType"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.applyUnitFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Tous/All")]), _vm._v(" "), _vm._l((_vm.specTypeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.list_id
      }
    }, [_vm._v(_vm._s(type.description[_vm.actualLanguage]))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelSpecArea[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedArea),
      expression: "selectedArea"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedArea = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.applyUnitFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Tous/All")]), _vm._v(" "), _vm._l((_vm.specAreaList), function(area) {
    return _c('option', {
      domProps: {
        "value": area.list_id
      }
    }, [_vm._v(_vm._s(area.description[_vm.actualLanguage]))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelSpecYearOfConstruction[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedYearOfConstruction),
      expression: "selectedYearOfConstruction"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedYearOfConstruction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.applyUnitFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Tous/All")]), _vm._v(" "), _vm._l((_vm.specYearOfConstructList), function(yearOfConstruct) {
    return _c('option', {
      domProps: {
        "value": yearOfConstruct.list_id
      }
    }, [_vm._v(_vm._s(yearOfConstruct.description[_vm.actualLanguage]))])
  })], 2)])])])])]), _vm._v(" "), (_vm.flagGraphDataIsUpdating) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayStatTable) ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayGraph = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonCloseChart[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "400",
      "options": _vm.unitGraphOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 align-center"
  }, [_c('span', {
    staticClass: "badge badge-success"
  }, [_c('h5', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.averageCost[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.averageCostValue) + " $")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.statTableColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.statTableColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.statTableColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.statTableColumn04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.statTableColumn05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.statTableColumn06[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unitsDataFiltered), function(unit, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                                                " + _vm._s(unit.UnitName) + "\r\n                                              ")]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, _vm._l((unit.tags), function(tag) {
      return _c('p', {
        staticClass: "font-w600 push-10"
      }, [_c('span', {
        staticClass: "badge badge-success"
      }, [_vm._v(_vm._s(tag))])])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(unit.type))]), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(unit.area))]), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(unit.yoc))])]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                                                " + _vm._s(unit.Occupant) + "\r\n                                              ")]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [(unit.CostVsAverage > 125) ? _c('h3', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(unit.SumCost) + " $")]) : _c('h5', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(unit.SumCost) + " $")])]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [(unit.CostVsAverage > 125) ? _c('h3', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(unit.CostVsAverage) + " %")]) : _c('h5', {
      staticClass: "align-center"
    }, [_vm._v(_vm._s(unit.CostVsAverage) + " %")])]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.displayUnitGraph(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bar-chart"
    })])])])])
  }), 0)])])])]) : _vm._e()])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSection[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayAddOrganization) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.flagDisplayTable) ? _c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddOrganization[_vm.actualLanguage]))]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddOrganization()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelOrganizationToAddId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationToAddId),
      expression: "organizationToAddId"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": "XXXXX"
    },
    domProps: {
      "value": (_vm.organizationToAddId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationToAddId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelOrganizationToPhoneNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationToAddPhoneNumber),
      expression: "organizationToAddPhoneNumber"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": "XXX-XXX-XXXX"
    },
    domProps: {
      "value": (_vm.organizationToAddPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationToAddPhoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewOrganisation()
      }
    }
  }, [(_vm.organizationIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAdd[_vm.actualLanguage]))])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.organizationListIsLoading) ? _c('spinner', {
    attrs: {
      "size": "normal"
    }
  }) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [(_vm.flagDisplayTable) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn1[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn2[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn3[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labelOrganizationTableColumn4[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.managedOrganizations), function(subOrganization, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v("\r\n                        " + _vm._s(subOrganization.organizationName) + " [" + _vm._s(subOrganization.organizationId) + "]\r\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\r\n                        " + _vm._s(subOrganization.subscriptionTitle[_vm.actualLanguage]) + "\r\n                      ")]), _vm._v(" "), (subOrganization.subscriptionActive) ? _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-block  btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip"
      },
      on: {
        "click": function($event) {
          return _vm.openApplyPlanToSubOrganization(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" " + _vm._s(_vm.labelTableApplyPlan[_vm.actualLanguage]))]), _vm._v(" "), (subOrganization.subscriptionActive) ? _c('button', {
      staticClass: "btn btn-block btn-default btn-block",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip"
      },
      on: {
        "click": function($event) {
          return _vm.openModifyPlanToSubOrganization(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(_vm.labelTableModifyPlan[_vm.actualLanguage]))]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAddPlan) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAddModifyPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labelApplyPlanTo[_vm.actualLanguage]) + " " + _vm._s(_vm.managedOrganizations[_vm.selectedOrganizationIndex].organizationName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelActualPlan[_vm.actualLanguage]) + " " + _vm._s(_vm.managedOrganizations[_vm.selectedOrganizationIndex].subscriptionTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlanSortKey),
      expression: "selectedPlanSortKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.readSelectedPlanDetail()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPlanSortKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.planDescription), function(plan) {
    return _c('option', {
      domProps: {
        "value": plan.sort_key
      }
    }, [_vm._v(_vm._s(plan.planInfo.title[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), (_vm.selectedPlanSortKey.length > 3 & _vm.planSelectedFlag) ? _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('div', {
    staticClass: "col-xm-12 col-md-12"
  }, [_c('a', {
    staticClass: "block block-bordered block-link-hover3 text-center"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.planInfo.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.selectedPlanDetail.planInfo.description), function(descriptionLine, index) {
    return _c('div', {
      staticClass: "col-xm-12 col-md-12"
    }, [_c('h6', {
      staticClass: "font-w200 text-center push"
    }, [_vm._v(_vm._s(descriptionLine[_vm.actualLanguage]))])])
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionOrgLicenceSection[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.organizationLicenceData.licenceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.organizationLicenceData.priceDescription[_vm.actualLanguage]) + " : ")]), _vm._v(" "), _c('h5', {
    staticClass: "h1 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.organizationLicenceData.price) + " $ ")]), _vm._v(" "), (_vm.selectedPlanDetail.organizationLicenceData.options.length > 100) ? _c('div', [_c('h5', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionLicenceOptionSection[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.selectedPlanDetail.organizationLicenceData.options), function(optionLine, optionIndex) {
    return _c('div', {
      key: optionIndex,
      staticClass: "col-xm-12 col-md-12"
    }, [_c('h5', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine.title[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine.priceDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "h3 font-w700 push-10"
    }, [_vm._v(_vm._s(optionLine.price) + " $ ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), (parseFloat(_vm.selectedPlanDetail.planInfo.maximumLicenceCount) > parseFloat(_vm.selectedPlanDetail.planInfo.includedLicence)) ? _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionUserLicenceSection[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.userLicenceData.licenceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.userLicenceData.priceDescription[_vm.actualLanguage]) + " : ")]), _vm._v(" "), _c('h5', {
    staticClass: "h1 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.selectedPlanDetail.userLicenceData.price) + " $ ")]), _vm._v(" "), (_vm.selectedPlanDetail.userLicenceData.options.length > 100) ? _c('div', [_c('h5', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionLicenceOptionSection[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.selectedPlanDetail.userLicenceData.options), function(optionLine2, optionIndex2) {
    return _c('div', {
      key: optionIndex2,
      staticClass: "col-xm-12 col-md-12"
    }, [_c('h5', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine2.title[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine2.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(optionLine2.priceDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "h3 font-w700 push-10"
    }, [_vm._v(_vm._s(optionLine2.price) + " $ ")])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textRebateTableTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.textRebateTableSubTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.textRebateTableColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.textRebateTableColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.textRebateTableColumn03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedPlanDetail.rebateChartData.chart), function(rebateSlice) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(rebateSlice.priceSliceMin) + " $")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(rebateSlice.priceSliceMax) + " $")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(rebateSlice.pourcentageReduction) + " %")])])
  }), 0)])])], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyPlanToSelectedOrganization()
      }
    }
  }, [(_vm.planIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonActualPlan[_vm.actualLanguage]))])], 1)]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayModifyPlan) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelModifyOrganizationPlan[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.managedOrganizations[_vm.selectedOrganizationIndex].organizationName))]), _vm._v(" "), (_vm.subscriptionIsLoading) ? _c('spinner', {
    attrs: {
      "size": "normal"
    }
  }) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAddModifyPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicenceOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.subOrganizationSubscription.organization_licence.title[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-6"
  }, [_c('h4', [_vm._v("Licence ID:" + _vm._s(_vm.subOrganizationSubscription.subscription_id.substring(11, 30)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-6 "
  }, [_c('h3', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(_vm.subOrganizationSubscription.organization_licence.price) + " $")])]), _vm._v(" "), (_vm.subOrganizationSubscription.organization_licence.customizedOptions.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subOrganizationSubscription.organization_licence.customizedOptions), function(licenceOption, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
      staticClass: "text-center"
    }, [_c('h6', {
      staticClass: "h6 font-w700 push-10"
    }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (licenceOption.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(licenceOption, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (licenceOption.value),
        expression: "licenceOption.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
      },
      on: {
        "change": function($event) {
          var $$a = licenceOption.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(licenceOption, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" Activation\r\n                                            ")])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labelOtherCostSection[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.subOrganizationSubscription.subscription_other_fees.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.otherFeeColumnTitle04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subOrganizationSubscription.subscription_other_fees), function(fee, indexFee) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fee.quantity),
        expression: "fee.quantity"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (fee.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fee, "quantity", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(fee.description[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fee.unitCost),
        expression: "fee.unitCost"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (fee.unitCost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(fee, "unitCost", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-center",
      attrs: {
        "type": "button",
        "title": "Retirer/Release"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFeeLine(indexFee)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagAddOtherFeeSection == false) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right push",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openAddOtherFee()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAddOtherFees[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFeeToAdd),
      expression: "selectedFeeToAdd"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFeeToAdd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.otherFeesList), function(fee) {
    return _c('option', {
      domProps: {
        "value": fee.data
      }
    }, [_vm._v(_vm._s(fee.data.description[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), (_vm.selectedFeeToAdd.quantity) ? _c('p', [_c('button', {
    staticClass: "btn btn-success align-right push",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addSelectedFee()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAddSelectedFees[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-danger align-right push",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeAddOtherFee()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAddOtherFeesCancel[_vm.actualLanguage]))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSubscriptionModification()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonSaveSupscription[_vm.actualLanguage]))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.sectionLabelLicence[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.displayUserLicenceSectionFLag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, _vm._l((_vm.subOrganizationSubscription.organization_user_licences), function(userLicence, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayUserLicenceFlag(index)
        }
      }
    }, [_vm._v(_vm._s(userLicence.title[_vm.actualLanguage]) + " ID: " + _vm._s(userLicence.licenceId.substring(11, 30)))])]), _vm._v(" "), (_vm.displayUserLicenceFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-lg-12 "
    }, [_c('h3', {
      staticClass: "align-right"
    }, [_vm._v(_vm._s(_vm.baseCostLabel[_vm.actualLanguage]) + " : " + _vm._s(userLicence.price) + " $")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-lg-12 push"
    }, [_c('div', {
      staticClass: "col-sm-6 col-lg-6 "
    }, [(userLicence.linkedProfile.email != 'NONE') ? _c('h3', {
      staticClass: "align-left"
    }, [_vm._v(_vm._s(_vm.tableLicenceUser[_vm.actualLanguage]) + " : " + _vm._s(userLicence.linkedProfile.email))]) : _c('h3', {
      staticClass: "align-left"
    }, [_vm._v("Disponible/Available")])])]), _vm._v(" "), (userLicence.linkedProfile.email == 'NONE' && index >= _vm.subOrganizationSubscription.organization_plan_description.planInfo.includedLicence) ? _c('div', {
      staticClass: "col-sm-12 col-lg-12"
    }, [_c('button', {
      staticClass: "btn btn-md btn-danger align-right",
      attrs: {
        "type": "button",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLicence(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" " + _vm._s(_vm.buttonLabelDeleteLicence[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [(userLicence.customizedOptions.length > 0) ? _c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((userLicence.customizedOptions), function(licenceOption, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.title[_vm.actualLanguage]) + ".  " + _vm._s(licenceOption.priceDescription[_vm.actualLanguage]) + ":" + _vm._s(licenceOption.price) + " $ ")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(licenceOption.description[_vm.actualLanguage]))]), _vm._v(" "), (licenceOption.valueType == 'NUMERIC') ? _c('td', {
        staticClass: "text-center"
      }, [_c('h6', {
        staticClass: "h6 font-w700 push-10"
      }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        staticClass: "form-control text-center",
        attrs: {
          "placeholder": "Valeur/Value"
        },
        domProps: {
          "value": (licenceOption.value)
        },
        on: {
          "change": function($event) {
            return _vm.computeCost()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(licenceOption, "value", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (licenceOption.valueType == 'BOOL') ? _c('td', {
        staticClass: "text-center"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (licenceOption.value),
          expression: "licenceOption.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(licenceOption.value) ? _vm._i(licenceOption.value, null) > -1 : (licenceOption.value)
        },
        on: {
          "change": [function($event) {
            var $$a = licenceOption.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(licenceOption, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(licenceOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(licenceOption, "value", $$c)
            }
          }, function($event) {
            return _vm.computeCost()
          }]
        }
      }), _vm._v(" "), _c('span'), _vm._v(" Activation\r\n                                            ")])]) : _vm._e()])
    }), 0)])]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Date dernier renouvellement / Last renewal date :   " + _vm._s(_vm.subOrganizationSubscription.renewal_last_date))]), _vm._v(" "), _c('h5', {
    staticClass: "push"
  }, [_vm._v("Date prochain renouvellement / Next renewal date :   " + _vm._s(_vm.subOrganizationSubscription.renewal_date))]), _vm._v(" "), _c('h5', [_vm._v("Type de paiement / Paiement type :   " + _vm._s(_vm.subOrganizationSubscription.payment_type))])])])], 1) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.occupant.completeName))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagDisplayDetail === 0) ? _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Detail")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfigClose[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Configuration " + _vm._s(_vm.labelOccupant[_vm.actualLanguage]) + " ID: " + _vm._s(_vm.occupant.occupant_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelFirstName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.firstname),
      expression: "occupant.firstname"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.occupant.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelLastName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.lastname),
      expression: "occupant.lastname"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.occupant.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelEmail[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.email),
      expression: "occupant.email"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.occupant.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelMobile[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupant.mobile_phone_number),
      expression: "occupant.mobile_phone_number"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": "999 999-9999"
    },
    domProps: {
      "value": (_vm.occupant.mobile_phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occupant, "mobile_phone_number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantModifications()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSectionUnitAttribution[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayAttributionTable) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.attributionColumn04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.occupant.unit_attributions), function(attribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v("\r\n                                            " + _vm._s(attribution.unit_reference_name) + "\r\n                                          ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (attribution.dateStart),
        callback: function($$v) {
          _vm.$set(attribution, "dateStart", $$v)
        },
        expression: "attribution.dateStart"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (attribution.dateEnd),
        callback: function($$v) {
          _vm.$set(attribution, "dateEnd", $$v)
        },
        expression: "attribution.dateEnd"
      }
    })], 1)])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOccupantAttribution(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.flagAddAttribution) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelUnit[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoUnit),
      expression: "tempoUnit"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempoUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.unitList), function(unit) {
    return _c('option', {
      domProps: {
        "value": unit.unit_id
      }
    }, [_vm._v(_vm._s(unit.reference_name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelDateStart[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.tempoUnitDateStart),
      callback: function($$v) {
        _vm.tempoUnitDateStart = $$v
      },
      expression: "tempoUnitDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelDateEnd[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.tempoUnitDateEnd),
      callback: function($$v) {
        _vm.tempoUnitDateEnd = $$v
      },
      expression: "tempoUnitDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantAttribution()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveAttribution[_vm.actualLanguage]))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAddAttribution()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAddAttribution()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAjouterAttribution[_vm.actualLanguage]))])]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSectionFixCosts[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "push-30"
  }, [_vm._v(_vm._s(_vm.labelFixCostExplanation[_vm.actualLanguage]))]), _vm._v(" "), (_vm.occupant.fix_costs.length > 0) ? _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.occupant.fix_costs), function(cost, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.yearlyFlag),
        expression: "cost.yearlyFlag"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(cost.yearlyFlag) ? _vm._i(cost.yearlyFlag, null) > -1 : (cost.yearlyFlag)
      },
      on: {
        "change": function($event) {
          var $$a = cost.yearlyFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(cost, "yearlyFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(cost, "yearlyFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(cost, "yearlyFlag", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.description),
        expression: "cost.description"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.cost),
        expression: "cost.cost"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.cost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "cost", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFixCost(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addFixCostLine()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddFixCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantModifications()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.occupant.options), function(category, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12 push"
    }, [_c('h5', {
      staticClass: "push"
    }, [_vm._v(_vm._s(category.categoryTitle[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((category.options), function(Option, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [(Option.valueType == 'bool') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h5', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(Option.value) ? _vm._i(Option.value, null) > -1 : (Option.value)
        },
        on: {
          "change": function($event) {
            var $$a = Option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(Option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(Option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(Option, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span'), (Option.value) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'stringNumber') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control align-center",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (Option.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Option, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'listString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_vm._v("\r\n                                  " + _vm._s(Option) + "\r\n                                ")]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveOccupantModifications()
      }
    }
  }, [(_vm.occupantIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("Section qui affiche le détail du consommateur")])])
}]}

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.componentListIndicators), function(indicator, index) {
    return _c('div', _vm._l((indicator.colorConditions), function(condition, index) {
      return _c('div', [(indicator.value >= condition.minValue & indicator.value < condition.maxValue) ? _c('div', [(indicator.width == 'Small') ? _c('div', {
        staticClass: "col-lg-2"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (indicator.width == 'Medium') ? _c('div', {
        staticClass: "col-lg-3"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (indicator.width == 'Large') ? _c('div', {
        staticClass: "col-lg-4"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (indicator.width == 'Full') ? _c('div', {
        staticClass: "col-lg-12"
      }, [_c('a', {
        staticClass: "block block-link-hover3"
      }, [_c('div', {
        staticClass: "block-content block-content-full clearfix",
        style: ({
          backgroundColor: condition.colorBackground
        })
      }, [_c('i', {
        staticClass: "fa-2x text-white pull-right",
        class: indicator.favIcon
      }), _vm._v(" "), _c('span', {
        staticClass: "h6 font-w700 text-white-op"
      }, [_vm._v(_vm._s(indicator.value))]), _vm._v(" "), _c('span', {
        staticClass: "h6 text-white-op"
      }, [_vm._v(_vm._s(indicator.label[_vm.actualLanguage]))])])])]) : _vm._e()]) : _vm._e()])
    }), 0)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dashboardFlags.evsensAdminFlag === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayFilter === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayFilter) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelFilters[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayFilter === -1) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_c('i', {
      staticClass: "fa fa-tags fa-1x push-5-r "
    }), _vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attributesFiltersChoice[index]),
        expression: "attributesFiltersChoice[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-multiple-select",
        "name": "example-multiple-select",
        "size": "4",
        "multiple": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.attributesFiltersChoice, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.attributesFilters[index]), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetDisplayFlag()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelEraseFilter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonApplyFilters[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPie()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonPieChartRefresh[_vm.actualLanguage]))])])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMap === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMap) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelDeviceLocalisation[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMap === -1) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.showListOfChannel) ? _c('div', {
    staticClass: "row"
  }, [_c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": 8,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "label": marker.label,
        "draggable": false
      }
    })
  }), 1)], 1) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [(_vm.showPieChart && _vm.crunchedCost.datasets[0].data.length > 0 && _vm.actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag) ? _c('div', {
    staticClass: "block-content push"
  }, [(_vm.flagDisplayOldGraph) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelPieConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedCunsumption
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayOldGraph) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelPieCost[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedCost
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayOldGraph) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelPieMaximumCurrent[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedMaxCurrent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-6"
  }, [_c('h3', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelPieConsumption[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "options": _vm.pieChartOptionsKWH,
      "series": _vm.pieChartDataSeriesKWH
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-6"
  }, [_c('h3', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelPieCost[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "options": _vm.pieChartOptionsCost,
      "series": _vm.pieChartDataSeriesCost
    }
  })], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.displayAsTableFlag) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push align-center"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-1x push-5-r "
  }), _vm._v(" " + _vm._s(_vm.buttonLabelDisplayDetail[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.EvSenschannelCounter > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGraphCurve),
      expression: "selectedGraphCurve"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.updatePieChartData()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGraphCurve = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AvrPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorAvrPowerKW[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PeakPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPeakPowerKW[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KWH_PerSample"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorKWHShort[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cost_PerSample"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCostShort[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CumSumKWH"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CumSumCost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumCost[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  })]) : _vm._e(), _vm._v(" "), (_vm.EvSenschannelCounter > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push align-center"
  }, [_c('h6', {
    staticClass: "font-w200 align-center push"
  }, [_vm._v(_vm._s(_vm.textLabelRequireDeviceSelect[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table remove-margin-b font-s12"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelDevice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelOnline[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelMaxCurrent[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.tableLabelCunsumption[_vm.actualLanguage]))]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelLastReading[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_1Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_4Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_6Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_12Hr[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_1Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_3Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_7Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_14Day[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('th', [_vm._v(_vm._s(_vm.tableLabelMA_30Day[_vm.actualLanguage]))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.subBundleDisplayFlag), function(flag, index) {
    return _c('tr', [(flag) ? _c('td', {
      staticClass: "font-w600"
    }, [(_vm.actualBundle.sub_bundle[index].subBundleData.bundle_icon == 'Undefined.png') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _c('img', {
      staticClass: "measurement-graph-row__icon",
      attrs: {
        "width": "50px",
        "src": _vm._f("s3Image")(("systems_icons/" + (_vm.actualBundle.sub_bundle[index].subBundleData.bundle_icon))),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (flag) ? _c('td', [_vm._v("X")]) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(index + 1) + " : " + _vm._s(_vm.actualBundle.sub_bundle[index].ReferenceName))]) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }) : _vm._e(), _vm._v(" "), (flag) ? _c('td', {
      staticClass: "font-w600"
    }) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': '5min'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_001H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_004H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_006H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_012H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_024H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_072H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_168H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_336H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'BDL',
          'index': index,
          'MAType': 'MA_720H'
        }
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index) {
    return _c('tr', [(flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600"
    }, [(_vm.actualBundle.channels[index].ChannelData.channelInfo.iconFile == 'Undefined.png') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _c('img', {
      staticClass: "measurement-graph-row__icon",
      attrs: {
        "width": "50px",
        "src": _vm._f("s3Image")(("appliances/" + (_vm.actualBundle.channels[index].ChannelData.channelInfo.iconFile))),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600",
      on: {
        "click": function($event) {
          return _vm.toggleChannelDisplayFlag(index)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag),
        expression: "actualBundle.channels[index].ChannelData.DisplayOpenFlag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag) ? _vm._i(_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag, null) > -1 : (_vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.actualBundle.channels[index].ChannelData, "DisplayOpenFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.actualBundle.channels[index].ChannelData, "DisplayOpenFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.actualBundle.channels[index].ChannelData, "DisplayOpenFlag", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(index + 1) + " : " + _vm._s(_vm.actualBundle.channels[index].ReferenceName))]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index]) ? _c('td', {
      staticClass: "font-w600"
    }, [(_vm.actualBundle.channels[index].ChannelData.deviceOnline) ? _c('i', {
      staticClass: "fa fa-toggle-on fa-2x"
    }) : _c('i', {
      staticClass: "fa fa-toggle-off fa-2x"
    })]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(_vm._f("round")(_vm.actualBundle.channels[index].ChannelData.peakCurrent)) + " A")]) : (flag) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.channels[index].ChannelData.DisplayOpenFlag) ? _c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(_vm._f("round")(_vm.actualBundle.channels[index].ChannelData.sumKwh)) + " kWh/ " + _vm._s(_vm._f("toCurrency")(_vm.actualBundle.channels[index].ChannelData.sumCost)))]) : (flag) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': '5min'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_001H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_004H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_006H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_012H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_024H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_072H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_168H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_336H'
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (flag && _vm.flagChannelIsEvsensChannel[index] && (_vm.channelDisplayTemplate[index] == 'EVA_V1P00') && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('relative-power-bar-mini', {
      attrs: {
        "barParameters": {
          'type': 'CHN',
          'index': index,
          'MAType': 'MA_720H'
        }
      }
    })], 1) : _vm._e()])
  })], 2)])])]), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index2) {
    return _c('div', [(flag && _vm.actualBundle.channels[index2].FrontendTemplates.componentChannelDisplay == 'ApiDevice_V1P00') ? _c('div', [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-xs-4 col-sm-3"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [(flag) ? _c('td', {
      staticClass: "font-w600"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag),
        expression: "actualBundle.channels[index2].ChannelData.DisplayOpenFlag"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag) ? _vm._i(_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag, null) > -1 : (_vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.actualBundle.channels[index2].ChannelData.DisplayOpenFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.actualBundle.channels[index2].ChannelData, "DisplayOpenFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.actualBundle.channels[index2].ChannelData, "DisplayOpenFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.actualBundle.channels[index2].ChannelData, "DisplayOpenFlag", $$c)
          }
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('h5', {
      staticClass: "font-w300 push measurement-graph-row__title"
    }, [_c('img', {
      staticClass: "measurement-graph-row__icon",
      attrs: {
        "width": "60px",
        "src": _vm._f("s3Image")(("organization_img/" + (_vm.actualBundle.channels[index2].ChannelData.channelInfo.iconFile))),
        "alt": ""
      }
    }), _vm._v("\n              " + _vm._s(_vm.actualBundle.channels[index2].ReferenceName) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-9"
    }, [_c('api-device-list-indicator-v1p00', {
      attrs: {
        "componentListIndicators": _vm.actualBundle.channels[index2].ChannelData.Readings.listIndicators
      }
    })], 1)])]) : _vm._e()])
  })], 2) : _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 push align-center"
  }, [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDisplayList[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.showListOfChannel) ? _c('div', [(_vm.actualBundle['sub_bundle'].length) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelSubSystem[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.subBundleDisplayFlag), function(flag, index) {
    return _c('div', [(flag) ? _c('display-sub-bundle', {
      attrs: {
        "subBundleIndex": index
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.actualBundle['channels'].length) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelSubDevice[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index) {
    return _c('div', [(flag && _vm.actualBundle.channels[index].FrontendTemplates.componentChannelDisplay == 'EVA_V1P00') ? _c('display-channel', {
      attrs: {
        "channelIndex": index
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.channelDisplayFlag), function(flag, index2) {
    return _c('div', [(flag && _vm.actualBundle.channels[index2].FrontendTemplates.componentChannelDisplay == 'ApiDevice_V1P00') ? _c('api-display-channel-v1p00', {
      attrs: {
        "channelIndex": index2
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(false) ? _c('spinner') : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "font-w300 push-10 align-center"
  }, [_c('i', {
    staticClass: "fa fa-cloud-download fa-1x push-15-r "
  }), _vm._v("Cloud Live Monitor")]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.GraphTitle))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.overlayParameters.liveType == 'Device') ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDeviceDataType),
      expression: "selectedDeviceDataType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDeviceDataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "current_RMS"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCurrentRMS[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "power"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "input_VRMS"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorInputVRMS[_vm.actualLanguage]))])])]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('line-chart', {
    attrs: {
      "chartData": _vm.graphData
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.testGetLiveCloud()
      }
    }
  }, [(_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownload[_vm.actualLanguage]))])], 1)])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateChannelTemplate[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelTemplateId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateId),
      expression: "templateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant de gabarit / Template ID"
    },
    domProps: {
      "value": (_vm.templateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelChannelName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelName),
      expression: "channelName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant d'appareil / Device identifier"
    },
    domProps: {
      "value": (_vm.channelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelChannelType[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelType),
      expression: "channelType"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type d'appareil / Device type"
    },
    domProps: {
      "value": (_vm.channelType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelType = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelChannelDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelDescription),
      expression: "channelDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.channelDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelIconFile[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelIconFile),
      expression: "channelIconFile"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelIconFile = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pictureList), function(picture) {
    return _c('option', {
      domProps: {
        "value": picture.fileName
      }
    }, [_vm._v(_vm._s(picture.pictureReferenceName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "50px",
      "src": _vm._f("s3Image")(("organization_img/" + _vm.channelIconFile))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelSignalSet[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signalSetIndex),
      expression: "signalSetIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signalSetIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetListIndicatorsAndPanes()
      }]
    }
  }, _vm._l((_vm.signalsSetTemplates), function(signalSet, indexSignalSet) {
    return _c('option', {
      domProps: {
        "value": indexSignalSet
      }
    }, [_vm._v(_vm._s(signalSet.signalSetId))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelFrontEndComponent[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frontendChannelComponent),
      expression: "frontendChannelComponent"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.frontendChannelComponent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "MultiPanes_V1P00"
    }
  }, [_vm._v("Multi Panes version 1")])])])])]), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleListIndicator[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.componentListIndicators), function(componentListIndicator, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('h5', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.labelIndicator[_vm.actualLanguage]) + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.varName),
        expression: "componentListIndicator.varName"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "varName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.selectListIndicatorSignal(index)
        }]
      }
    }, _vm._l((_vm.signalsSetTemplates[_vm.signalSetIndex].deviceSignals), function(signal, indexSignal) {
      return _c('option', {
        domProps: {
          "value": signal.signalName
        }
      }, [_vm._v(_vm._s(signal.signalName))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.label.FR),
        expression: "componentListIndicator.label.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (componentListIndicator.label.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator.label, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.label.EN),
        expression: "componentListIndicator.label.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (componentListIndicator.label.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator.label, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelListIndicatorAgregation[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.agregation),
        expression: "componentListIndicator.agregation"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "agregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Sum"
      }
    }, [_vm._v("Somme/Sum")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Min"
      }
    }, [_vm._v("Minimum")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Max"
      }
    }, [_vm._v("Maximum")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Avr"
      }
    }, [_vm._v("Moyenne/Average")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Last"
      }
    }, [_vm._v("Dernière mesure/Last measure")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-2"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelTileSize[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.width),
        expression: "componentListIndicator.width"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "width", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Small"
      }
    }, [_vm._v("Small")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Medium"
      }
    }, [_vm._v("Medium")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Large"
      }
    }, [_vm._v("Large")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Full"
      }
    }, [_vm._v("Full")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-2"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v("Decimal")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.decimal),
        expression: "componentListIndicator.decimal"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "decimal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("0")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("1")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("2")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("3")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("4")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "5"
      }
    }, [_vm._v("5")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "6"
      }
    }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTileLabelIcon[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.favIcon),
        expression: "componentListIndicator.favIcon"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(componentListIndicator, "favIcon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.faFavIconList), function(icon) {
      return _c('option', {
        domProps: {
          "value": icon
        }
      }, [_vm._v(_vm._s(icon))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTileLabelIcon2[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.favIcon),
        expression: "componentListIndicator.favIcon"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (componentListIndicator.favIcon)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator, "favIcon", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-2"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelIndicatorTestValue[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentListIndicator.value),
        expression: "componentListIndicator.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (componentListIndicator.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentListIndicator, "value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('h5', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.labelIndicatorColorCondition[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((componentListIndicator.colorConditions), function(condition, index2) {
      return _c('div', {
        staticClass: "col-xs-12"
      }, [(condition.customColorFlag == false) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileColor[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (condition.colorBackground),
          expression: "condition.colorBackground"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(condition, "colorBackground", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "#46c37b"
        }
      }, [_vm._v("Vert std/Green std")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#0000ff"
        }
      }, [_vm._v("Bleu/Blue")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#00ff00"
        }
      }, [_vm._v("Vert/Green")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#e1e100"
        }
      }, [_vm._v("Jaune/Yellow")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "#ff0000"
        }
      }, [_vm._v("Rouge/Red")])])]) : _vm._e(), _vm._v(" "), (condition.customColorFlag == false) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.buttonSetCustomColor[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.switchCustomColor(index, index2, true)
          }
        }
      }, [_vm._m(0, true)])])]) : _vm._e(), _vm._v(" "), (condition.customColorFlag) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.buttonSetCustomColor[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model:value",
          value: (_vm.componentListIndicators[index].colorConditions[index2].colorBackground),
          expression: "componentListIndicators[index].colorConditions[index2].colorBackground",
          arg: "value"
        }],
        attrs: {
          "type": "color",
          "id": "head",
          "name": "head"
        },
        domProps: {
          "value": (_vm.componentListIndicators[index].colorConditions[index2].colorBackground)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.componentListIndicators[index].colorConditions[index2], "colorBackground", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (condition.customColorFlag) ? _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.buttonSetCustomColor[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.switchCustomColor(index, index2, false)
          }
        }
      }, [_vm._m(1, true)])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-2"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelIndicatorMinValue[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (condition.minValue),
          expression: "condition.minValue"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Variable"
        },
        domProps: {
          "value": (condition.minValue)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(condition, "minValue", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-2"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelIndicatorMaxValue[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (condition.maxValue),
          expression: "condition.maxValue"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Variable"
        },
        domProps: {
          "value": (condition.maxValue)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(condition, "maxValue", $event.target.value)
          }
        }
      })])])
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 align-center"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-xs btn-default push-5-r push-10",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addConditionalColor(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonAddColorCondition[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentListIndicator.colorConditions.length > 1) ? _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-xs btn-default push-5-r push-10",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteConditionalColor(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-minus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonDeleteColorCondition[_vm.actualLanguage]))])])])]) : _vm._e()])])], 2)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addListIndicator()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddListIndicator[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.componentListIndicators.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteListIndicator()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteListIndicator[_vm.actualLanguage]))])])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.labelListIndicatorPreview[_vm.actualLanguage]))]), _vm._v(" "), _c('api-device-list-indicator-v1p00', {
    attrs: {
      "componentListIndicators": _vm.componentListIndicators
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitlePanes[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.componentDetailPanes), function(componentDetailPane, index) {
    return _c('div', [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 col-lg-12"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textTitlePanes[_vm.actualLanguage]) + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneButtonLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.buttonLabel.FR),
        expression: "componentDetailPane.buttonLabel.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Étiquette/Label"
      },
      domProps: {
        "value": (componentDetailPane.buttonLabel.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.buttonLabel, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneButtonLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.buttonLabel.EN),
        expression: "componentDetailPane.buttonLabel.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Étiquette/Label"
      },
      domProps: {
        "value": (componentDetailPane.buttonLabel.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.buttonLabel, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneTitleFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.title.FR),
        expression: "componentDetailPane.title.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Titre/Title"
      },
      domProps: {
        "value": (componentDetailPane.title.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.title, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6 push"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelPaneTitleEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (componentDetailPane.title.EN),
        expression: "componentDetailPane.title.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Titre/Title"
      },
      domProps: {
        "value": (componentDetailPane.title.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(componentDetailPane.title, "EN", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 col-lg-12"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textTileSection[_vm.actualLanguage]) + ":" + _vm._s(index + 1))])]), _vm._v(" "), _vm._l((componentDetailPane.tilesIndicator), function(tile, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "block block-bordered block-themed block-content"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('h5', {
        staticClass: "font-w300 push-10"
      }, [_vm._v(_vm._s(_vm.textTile[_vm.actualLanguage]) + ":" + _vm._s(index2 + 1))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.varName),
          expression: "tile.varName"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "varName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.selectTileSignal(index, index2)
          }]
        }
      }, _vm._l((_vm.signalsSetTemplates[_vm.signalSetIndex].deviceSignals), function(signal, indexSignal) {
        return _c('option', {
          domProps: {
            "value": signal.signalName
          }
        }, [_vm._v(_vm._s(signal.signalName))])
      }), 0)]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.label.FR),
          expression: "tile.label.FR"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (tile.label.FR)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile.label, "FR", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.label.EN),
          expression: "tile.label.EN"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (tile.label.EN)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile.label, "EN", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-3"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileAgregation[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.agregation),
          expression: "tile.agregation"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "agregation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "Sum"
        }
      }, [_vm._v("Somme/Sum")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Min"
        }
      }, [_vm._v("Minimum")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Max"
        }
      }, [_vm._v("Maximum")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "Avr"
        }
      }, [_vm._v("Moyenne/Average")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v(_vm._s(_vm.labelTileColor[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.colorBackground),
          expression: "tile.colorBackground"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "colorBackground", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "bg-primary"
        }
      }, [_vm._v("Bleu/Blue")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-success"
        }
      }, [_vm._v("Vert/Green")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-danger"
        }
      }, [_vm._v("Rouge/Red")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-primary-dark"
        }
      }, [_vm._v("Foncé/Dark")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-modern"
        }
      }, [_vm._v("Bleu pale/Light Blue")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-amethyst"
        }
      }, [_vm._v("Violet/Purple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "bg-city"
        }
      }, [_vm._v("Rouge Pale/Light Red")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileValueSufix[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.valueSufix),
          expression: "tile.valueSufix"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "$, %, C ..."
        },
        domProps: {
          "value": (tile.valueSufix)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile, "valueSufix", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v("Decimal")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.decimal),
          expression: "tile.decimal"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "decimal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "0"
        }
      }, [_vm._v("0")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "1"
        }
      }, [_vm._v("1")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "2"
        }
      }, [_vm._v("2")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "3"
        }
      }, [_vm._v("3")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "4"
        }
      }, [_vm._v("4")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "5"
        }
      }, [_vm._v("5")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "6"
        }
      }, [_vm._v("6")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6 push"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelIcon[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.favIcon),
          expression: "tile.favIcon"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(tile, "favIcon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.faFavIconList), function(icon) {
        return _c('option', {
          domProps: {
            "value": icon
          }
        }, [_vm._v(_vm._s(icon))])
      }), 0), _vm._v(" "), _c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelTileLabelIcon2[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tile.favIcon),
          expression: "tile.favIcon"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Variable"
        },
        domProps: {
          "value": (tile.favIcon)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tile, "favIcon", $event.target.value)
          }
        }
      })])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addTile(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonAddTile[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentDetailPane.tilesIndicator.length > 0) ? _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLastTile(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-minus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonDeleteLastTile[_vm.actualLanguage]))])])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-12 col-lg-12"
    }, [_c('h4', {
      staticClass: "font-w300 push-10"
    }, [_vm._v(_vm._s(_vm.textGraphsSection[_vm.actualLanguage]) + ":" + _vm._s(index + 1))])]), _vm._v(" "), _vm._l((componentDetailPane.graphs), function(graph, index3) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "block block-bordered block-themed block-content"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('h5', {
        staticClass: "font-w300 push-10"
      }, [_vm._v(_vm._s(_vm.textGraph[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12 col-lg-12 push"
      }, [_c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelGraphTitleFR[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (graph.title.FR),
          expression: "graph.title.FR"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (graph.title.FR)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(graph.title, "FR", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('label', {
        attrs: {
          "for": "register4-firstname"
        }
      }, [_vm._v(_vm._s(_vm.labelGraphTitleEN[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (graph.title.EN),
          expression: "graph.title.EN"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "Étiquette/Label"
        },
        domProps: {
          "value": (graph.title.EN)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(graph.title, "EN", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6 col-lg-6"
      }, [_c('label', {
        attrs: {
          "for": "example-multiple-select"
        }
      }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (graph.type),
          expression: "graph.type"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(graph, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "LineSingle"
        }
      }, [_vm._v("Ligne simple / Line single")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "LineMultiple"
        }
      }, [_vm._v("Ligne multiples / Line multiple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "BarSingle"
        }
      }, [_vm._v("Barre simple / Bar single")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "BarMultiple"
        }
      }, [_vm._v("Barre multiples / Bar multiple")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-12 col-lg-12"
      }, [_c('h5', {
        staticClass: "font-w300 push-10"
      }, [_vm._v(_vm._s(_vm.textGraphTraceSection[_vm.actualLanguage]) + ":" + _vm._s(index3 + 1))])]), _vm._v(" "), _vm._l((graph.traces), function(trace, index4) {
        return _c('div', {
          staticClass: "col-xs-12 col-md-12"
        }, [_c('div', {
          staticClass: "col-sm-12 col-md-12 col-lg-12"
        }, [_c('h5', {
          staticClass: "font-w300 push-10"
        }, [_vm._v("Trace:" + _vm._s(index4 + 1))])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelTileVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.yVarName),
            expression: "trace.yVarName"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "1"
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(trace, "yVarName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, function($event) {
              return _vm.selectGraphTraceSignal(index, index3, index4)
            }]
          }
        }, _vm._l((_vm.signalsSetTemplates[_vm.signalSetIndex].deviceSignals), function(signal, indexSignal) {
          return _c('option', {
            domProps: {
              "value": signal.signalName
            }
          }, [_vm._v(_vm._s(signal.signalName))])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelGraphTraceFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.label.FR),
            expression: "trace.label.FR"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "placeholder": "Étiquette/Label"
          },
          domProps: {
            "value": (trace.label.FR)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(trace.label, "FR", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3"
        }, [_c('label', {
          attrs: {
            "for": "register4-firstname"
          }
        }, [_vm._v(_vm._s(_vm.labelGraphTraceEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.label.EN),
            expression: "trace.label.EN"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "placeholder": "Étiquette/Label"
          },
          domProps: {
            "value": (trace.label.EN)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(trace.label, "EN", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12 col-md-6 col-lg-3 push"
        }, [_c('label', {
          attrs: {
            "for": "example-multiple-select"
          }
        }, [_vm._v(_vm._s(_vm.labelHrDayTraces[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (trace.hourDayTraces),
            expression: "trace.hourDayTraces"
          }],
          staticClass: "form-control",
          attrs: {
            "size": "4",
            "multiple": ""
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(trace, "hourDayTraces", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "Min"
          }
        }, [_vm._v("Min")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Max"
          }
        }, [_vm._v("Max")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Avr"
          }
        }, [_vm._v("Moyenne/Average")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "Sum"
          }
        }, [_vm._v("Sum")])])])])
      }), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-sm btn-success",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addGraphTrace(index, index3)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-plus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.buttonAddGraphTrace[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentDetailPane.graphs.length > 0) ? _c('div', {
        staticClass: "col-sm-12 col-md-6"
      }, [_c('p', [_c('button', {
        staticClass: "btn btn-sm btn-danger",
        attrs: {
          "type": "button",
          "name": "button"
        },
        on: {
          "click": function($event) {
            return _vm.deleteLastGraphTrace(index, index3)
          }
        }
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-minus fa-1x push-5-r "
      }), _vm._v(_vm._s(_vm.buttonDeleteLastGraphTrace[_vm.actualLanguage]))])])])]) : _vm._e()], 2)])])
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addGraph(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonAddGraph[_vm.actualLanguage]))])])])]), _vm._v(" "), (componentDetailPane.graphs.length > 0) ? _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLastGraph(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-minus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.buttonDeleteLastGraph[_vm.actualLanguage]))])])])]) : _vm._e()], 2)])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-md btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addPane()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddPane[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.componentDetailPanes.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-md btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteLastPane()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteLastPane[_vm.actualLanguage]))])])])]) : _vm._e()])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.labePanePreview[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.componentDetailPanes.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 align-center"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPane()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonPaneRefresh[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPreview) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('api-device-panes-v1p00', {
    attrs: {
      "panes": _vm.componentDetailPanes
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.componentDetailPanes.length > 0 & _vm.componentListIndicators.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectApiKey[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApiKey),
      expression: "selectedApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApiKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.overlayParameters.organizationApiKeys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.key
      }
    }, [_vm._v(_vm._s(key.referenceName) + " : " + _vm._s(key.key))])
  }), 0)]), _vm._v(" "), (_vm.selectedApiKey.length > 0) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelTemplate()
      }
    }
  }, [(_vm.templateIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-pencil fa-1x push-5-r "
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  })])
}]}

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("500")])])
}]}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelFieldTitleAddDevice[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelFieldTitleSticker[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldModuleId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceModel.deviceId),
      expression: "deviceModel.deviceId"
    }],
    attrs: {
      "disabled": _vm.savingCar,
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceModel.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceModel, "deviceId", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.displayKey) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldModuleKey[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceModel.deviceKey),
      expression: "deviceModel.deviceKey"
    }],
    attrs: {
      "disabled": _vm.savingCar,
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceModel.deviceKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceModel, "deviceKey", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "font-w200 push-10"
  }, [_vm._v(_vm._s(_vm.displayMessage))])])]), _vm._v(" "), (_vm.deviceModel.deviceKey) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.deviceModel.deviceKey) ? _c('button', {
    staticClass: "btn btn-success btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.testKey
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonCheck[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.codeConfirmed) ? _c('button', {
    staticClass: "btn btn-success btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.saveDevice
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonAdd[_vm.actualLanguage]))]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateMasterApiKey[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelApiKeyReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceName),
      expression: "referenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Reference"
    },
    domProps: {
      "value": (_vm.referenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxMaxCost[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumMonthlyCost),
      expression: "maximumMonthlyCost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.maximumMonthlyCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumMonthlyCost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveOrganization()
      }
    }
  }, [(_vm.keyIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h2', {
    staticClass: "block-title",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.selectThisSubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.subBundleIndex + 1) + ":" + _vm._s(_vm.actualBundle.sub_bundle[_vm.subBundleIndex].ReferenceName))]), _vm._v(" "), (_vm.flagDisplayPowerBar && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable) ? _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarData5Min
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_001H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_004H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_006H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_012H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_024H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_072H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_168H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_336H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_720H
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.actualBundle.sub_bundle[_vm.subBundleIndex].Attributes), function(attribute, index) {
    return _c('div', [(_vm.actualBundle.sub_bundle[_vm.subBundleIndex].Attributes[index] != 'ND') ? _c('div', {
      staticClass: "col-xm-6 col-sm-4 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.subBundleIndex].Attributes[index]))])]) : _vm._e()])
  }), 0)]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [(_vm.flagDisplayPanes) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt",
    attrs: {
      "data-toggle": "tabs"
    }
  }, _vm._l((_vm.panes), function(pane, index) {
    return _c('li', {
      class: _vm.tabTitleClass[index]
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.switchPane(index)
        }
      }
    }, [_vm._v(_vm._s(pane.buttonLabel[_vm.actualLanguage]))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, _vm._l((_vm.panes), function(pane, index1) {
    return _c('div', {
      class: _vm.tabContentClass[index1]
    }, [_c('h3', {
      staticClass: "font-w300 push-15"
    }, [_vm._v(" " + _vm._s(pane.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((pane.tilesIndicator), function(tile) {
      return _c('div', {
        staticClass: "col-xs-6 col-sm-4 col-lg-3"
      }, [_c('a', {
        staticClass: "block block-link-hover2 text-center"
      }, [_c('div', {
        staticClass: "block-content block-content-full",
        class: tile.colorBackground
      }, [_c('div', {
        staticClass: "font-w600 text-white-op push-5-t"
      }, [_vm._v(_vm._s(tile.label[_vm.actualLanguage]))]), _vm._v(" "), _c('i', {
        staticClass: "fa-2x text-white",
        class: tile.favIcon
      }), _vm._v(" "), _c('div', {
        staticClass: "h4 text-white"
      }, [_vm._v(_vm._s(tile.value) + " " + _vm._s(tile.valueSufix))])])])])
    }), _vm._v(" "), _vm._l((pane.graphs), function(graph) {
      return _c('div', [(graph.type == 'LineSingle') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-line-single-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e(), _vm._v(" "), (graph.type == 'LineMultiple') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-line-multiple-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e(), _vm._v(" "), (graph.type == 'BarSingle') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-bar-single-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e(), _vm._v(" "), (graph.type == 'BarMultiple') ? _c('div', {
        staticClass: "row"
      }, [_c('api-device-graph-bar-multiple-v1p00', {
        attrs: {
          "graphData": graph
        }
      })], 1) : _vm._e()])
    })], 2)
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySectionTransactions === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTransactions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySectionTransactions) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTransactions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayTransactions()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelTransactions[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionTransactions) ? _c('div', {
    staticClass: "block-content"
  }, _vm._l((_vm.transactions), function(transaction, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleDisplayTransaction(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dollar"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayTransaction(index)
        }
      }
    }, [_vm._v(_vm._s(transaction.subscription) + ":" + _vm._s(transaction.timestamp))])]), _vm._v(" "), (_vm.transactionOpenFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "table-responsive push-50"
    }, [_c('table', {
      staticClass: "table table-bordered table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.textLabelProduct[[_vm.actualLanguage]]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceQuantity[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceUnitPrice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-right",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.InvoicePrice[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_vm._l((transaction.detailLines), function(transactionLine, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('p', {
        staticClass: "font-w600 push-10"
      }, [_vm._v(_vm._s(transactionLine.description[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "badge badge-primary"
      }, [_vm._v(_vm._s(transactionLine.quantity))])]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(transactionLine.unitPrice))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(transactionLine.unitPrice * transactionLine.quantity))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(_vm.InvoiceSubTotal[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.subTotal))])]), _vm._v(" "), (transaction.tps > 0) ? _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("TPS (5%)")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.tps))])]) : _vm._e(), _vm._v(" "), (transaction.tvq > 0) ? _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("TVQ (9.975%)")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(transaction.tvq))])]) : _vm._e(), _vm._v(" "), _vm._l((transaction.taxesList), function(taxLine, index2) {
      return _c('tr', [_c('td', {
        staticClass: "font-w600 text-right",
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(taxLine.Label[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v("$ " + _vm._s(taxLine.Amount))])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "active"
    }, [_c('td', {
      staticClass: "font-w700 text-uppercase text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
      staticClass: "font-w700 text-right"
    }, [_vm._v("$ " + _vm._s(transaction.total))])])], 2)]), _vm._v(" "), _c('div', [_c('h6', {
      staticClass: "block-title text-left"
    }, [_vm._v(_vm._s(_vm.CardInfoPaidBy[_vm.actualLanguage]) + _vm._s(transaction.cardData.CardType))]), _vm._v(" "), _c('h6', {
      staticClass: "block-title text-left"
    }, [_vm._v(_vm._s(_vm.CardInfoLast4[_vm.actualLanguage]) + _vm._s(transaction.cardData.CardLast4))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col-lg-6 align-right"
    }, [_c('button', {
      staticClass: "btn btn-md btn-success align-right",
      attrs: {
        "type": "button",
        "title": "Download PDF"
      },
      on: {
        "click": function($event) {
          return _vm.generatePdfInvoice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download PDF Invoice")])])])]) : _vm._e()])
  }), 0) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.planTransactionData.transactionStatusCode === '050' & _vm.flagShowPlanList) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('h3', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription02[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription03[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription04[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription05[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription06[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "align-center push"
  }, [_vm._v(_vm._s(_vm.subscriptionOptionDescription07[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelPaymentToggle[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white"
  }, [_c('section', {
    staticClass: "content content-boxed overflow-hidden"
  }, [_c('div', {
    staticClass: "row push-20-t push-20"
  }, _vm._l((_vm.planDescription), function(planLine, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm-12 col-lg-12 push"
    }, [(planLine['DisplayPlan'][_vm.monthYearPaymentToggle]) ? _c('div', [_c('a', {
      staticClass: "block block-bordered block-link-hover3 text-center",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('div', {
      staticClass: "block-header"
    }, [_c('h3', {
      staticClass: "block-title"
    }, [_vm._v(_vm._s(planLine['Title'][_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "block-content block-content-full bg-gray-lighter"
    }, [_c('div', {
      staticClass: "h1 font-w700 push-10"
    }, [_vm._v("$" + _vm._s(planLine['PlanPricing'][_vm.monthYearPaymentToggle]))]), _vm._v(" "), (planLine['DisplayButton'][_vm.monthYearPaymentToggle]) ? _c('div', [(_vm.monthYearPaymentToggle) ? _c('div', {
      staticClass: "h5 font-w300 text-muted"
    }, [_vm._v(_vm._s(_vm.labelPriceYearly[_vm.actualLanguage]))]) : _c('div', {
      staticClass: "h5 font-w300 text-muted"
    }, [_vm._v(_vm._s(_vm.labelPriceMonthly[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "block-content"
    }, [_c('table', {
      staticClass: "table table-borderless table-condensed"
    }, [_c('tbody', _vm._l((planLine['Description']), function(descrip) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(descrip['text1'][_vm.actualLanguage]) + " "), _c('strong', [_vm._v(_vm._s(descrip['text2'][_vm.actualLanguage]))]), _vm._v(" " + _vm._s(descrip['text3'][_vm.actualLanguage]))])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "block-content"
    }, _vm._l((planLine.options), function(option, index2) {
      return _c('div', {
        key: index,
        staticClass: "col-sm-12 push"
      }, [(option.valueType == 'BOOL') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-12"
      }, [_c('h5', [_vm._v("Option : " + _vm._s(option.title[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(option.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(option.priceDescription[_vm.actualLanguage]) + " : " + _vm._s(option.unitPrice) + " $")])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-12"
      }, [_vm._v(_vm._s(_vm.optionSelectLabel[_vm.actualLanguage]) + "\n                            "), _c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (option.flagOptionEnabled),
          expression: "option.flagOptionEnabled"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(option.flagOptionEnabled) ? _vm._i(option.flagOptionEnabled, null) > -1 : (option.flagOptionEnabled)
        },
        on: {
          "change": function($event) {
            var $$a = option.flagOptionEnabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(option, "flagOptionEnabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(option, "flagOptionEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(option, "flagOptionEnabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span')])])]) : _vm._e()])
    }), 0), _vm._v(" "), (planLine['DisplayButton'][_vm.monthYearPaymentToggle]) ? _c('div', {
      staticClass: "block-content block-content-mini block-content-full bg-gray-lighter"
    }, [_c('h3', [_vm._v(_vm._s(_vm.contactEVSensForSubscribe[_vm.actualLanguage]))])]) : _vm._e()])]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '060') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText01[_vm.actualLanguage]) + " " + _vm._s(_vm.planTransactionData.planName))])]), _vm._v(" "), (_vm.monthYearPaymentToggle) ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText02[_vm.actualLanguage]) + " " + _vm._s(_vm.sousTotal1) + " $")])]) : _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText03[_vm.actualLanguage]) + " " + _vm._s(_vm.sousTotal1) + " $")])]), _vm._v(" "), (_vm.planTransactionData.firstPaymentRebate > 0) ? _c('div', {
    staticClass: "row align-center"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText04[_vm.actualLanguage]) + " " + _vm._s(_vm.planTransactionData.firstPaymentRebate) + " " + _vm._s(_vm.SelectPlanText05[_vm.actualLanguage]) + "\n          ")]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '060') ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row align-center"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText06[_vm.actualLanguage]))]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_vm._v(_vm._s(_vm.SelectPlanText08[_vm.actualLanguage]) + "\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planTransactionData.automaticRenewFlag),
      expression: "planTransactionData.automaticRenewFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.planTransactionData.automaticRenewFlag) ? _vm._i(_vm.planTransactionData.automaticRenewFlag, null) > -1 : (_vm.planTransactionData.automaticRenewFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.planTransactionData.automaticRenewFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.planTransactionData, "automaticRenewFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.planTransactionData, "automaticRenewFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.planTransactionData, "automaticRenewFlag", $$c)
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.SelectPlanText07[_vm.actualLanguage]) + "\n              ")]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), (_vm.planTransactionData.automaticRenewFlag) ? _c('div', [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText09A[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText09B[_vm.actualLanguage]))]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText09C[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText09D[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText09E[_vm.actualLanguage]))])]) : _c('div', [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText10A[_vm.actualLanguage]))]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText10B[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText10C[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText10D[_vm.actualLanguage]))])]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row align-center"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block block-transparent"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.SelectPlanText11[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.politiqueAchatPlan[_vm.actualLanguage]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row align-center push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptConditionFlag),
      expression: "acceptConditionFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptConditionFlag) ? _vm._i(_vm.acceptConditionFlag, null) > -1 : (_vm.acceptConditionFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptConditionFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptConditionFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptConditionFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptConditionFlag = $$c
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.SelectPlanText12[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.validateLocalisation[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectMyCountry[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualCountryIndex),
      expression: "actualCountryIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.selectActualCountry()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualCountryIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countryStateTaxRates), function(country, countryIndex) {
    return _c('option', {
      domProps: {
        "value": countryIndex
      }
    }, [_vm._v(_vm._s(country.StateTaxData.CountryName[_vm.actualLanguage]))])
  }), 0)])])]), _vm._v(" "), (_vm.actualCountryIndex >= 0) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectMyState[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualStateIndex),
      expression: "actualStateIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.selectActualState()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualStateIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countryStateTaxRates[_vm.actualCountryIndex].StateTaxData.StateList), function(state, stateIndex) {
    return _c('option', {
      domProps: {
        "value": stateIndex
      }
    }, [_vm._v(_vm._s(state.Name[_vm.actualLanguage]))])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '060') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-danger align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSelection()
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonCancelSelection[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.acceptConditionFlag) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonProceedOrder[_vm.actualLanguage]))])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '100') ? _c('div', {
    staticClass: "row"
  }, [(_vm.planTransactionData.firstPaymentRebate > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.InvoiceHeaderFirst[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.InvoiceHeader[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Produit")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceQuantity[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceUnitPrice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.InvoicePrice[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-w600 push-10"
  }, [_vm._v(_vm._s(_vm.InvoiceEVSensServicePlan[_vm.actualLanguage]) + " " + _vm._s(_vm.planTransactionData.planName))]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.titlePlanTable[_vm.actualLanguage][_vm.monthYearPaymentToggle]))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(this.planTransactionData.renewalPrice))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(this.planTransactionData.renewalPrice))])]), _vm._v(" "), _vm._l((this.planTransactionData.options), function(option, index3) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index3 + 2))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(option.billingDescription[_vm.actualLanguage]))])]), _vm._v(" "), (option.flagOptionEnabled) ? _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(option.quantity))])]) : _c('td', {
      staticClass: "text-right"
    }, [_vm._v("0")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(option.unitPrice))]), _vm._v(" "), (option.flagOptionEnabled) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(option.unitPrice))]) : _c('td', {
      staticClass: "text-right"
    }, [_vm._v("0")])])
  }), _vm._v(" "), (_vm.planTransactionData.firstPaymentRebate > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-w600 push-10"
  }, [_vm._v(_vm._s(_vm.InvoiceSubscriptionCredit[_vm.actualLanguage]))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ -" + _vm._s(this.planTransactionData.firstPaymentRebate))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ -" + _vm._s(this.planTransactionData.firstPaymentRebate))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "font-w600 text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceSubTotal[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(_vm.sousTotal1))])]), _vm._v(" "), _vm._l((_vm.actualTaxes01), function(taxLine, index2) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(taxLine.Label[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(taxLine.Amount))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "active"
  }, [_c('td', {
    staticClass: "font-w700 text-uppercase text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "font-w700 text-right"
  }, [_vm._v("$ " + _vm._s(_vm.total1))])])], 2)])]), _vm._v(" "), (_vm.planTransactionData.firstPaymentRebate > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.InvoiceHeaderNext[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.firstPaymentRebate > 0) ? _c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Produit")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceQuantity[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceUnitPrice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.InvoicePrice[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-w600 push-10"
  }, [_vm._v(_vm._s(_vm.InvoiceEVSensServicePlan[_vm.actualLanguage]) + " " + _vm._s(_vm.planTransactionData.planName))]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.titlePlanTable[_vm.actualLanguage][_vm.monthYearPaymentToggle]))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(this.planTransactionData.renewalPrice))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(this.planTransactionData.renewalPrice))])]), _vm._v(" "), _vm._l((this.planTransactionData.options), function(option, index3) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index3 + 2))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(option.billingDescription[_vm.actualLanguage]))])]), _vm._v(" "), (option.flagOptionEnabled) ? _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(option.quantity))])]) : _c('td', {
      staticClass: "text-right"
    }, [_vm._v("0")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(option.unitPrice))]), _vm._v(" "), (option.flagOptionEnabled) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(option.unitPrice))]) : _c('td', {
      staticClass: "text-right"
    }, [_vm._v("0")])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "font-w600 text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceSubTotal[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(_vm.sousTotal2))])]), _vm._v(" "), _vm._l((_vm.actualTaxes02), function(taxLine, index3) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(taxLine.Label[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(taxLine.Amount))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "active"
  }, [_c('td', {
    staticClass: "font-w700 text-uppercase text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "font-w700 text-right"
  }, [_vm._v("$ " + _vm._s(_vm.total2))])])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-danger align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSelection()
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonCancelSelection[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('stripe-paiement')
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonProceedPayment[_vm.actualLanguage]))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v("1")])])
}]}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.displayTab) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" " + _vm._s(_vm.tabLabelMainService[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" " + _vm._s(_vm.tabLabelUnits[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.tabLabelOccupants[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" " + _vm._s(_vm.tabLabelComplement[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[0] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.mainServiceListIsLoading) ? _c('spinner') : _c('div', _vm._l((_vm.MainServiceList), function(mainService, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('main-service-display', {
      attrs: {
        "mainService": mainService
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMainService(index)
        }
      }
    }, [(_vm.serviceIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  }), 0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addMainService
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddMainService[_vm.actualLanguage]))])])], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[1] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.unitListIsLoading) ? _c('spinner') : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('unit-display-stats', {
    attrs: {
      "unitList": _vm.UnitList
    }
  })], 1), _vm._v(" "), _vm._l((_vm.UnitList), function(unit, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('unit-display', {
      attrs: {
        "unit": unit
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteUnit(index)
        }
      }
    }, [(_vm.unitIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  })], 2), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addUnit
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddUnit[_vm.actualLanguage]))])])], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [(_vm.occupantListIsLoading) ? _c('spinner') : _c('div', _vm._l((_vm.occupantsList), function(occupant, index) {
    return _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('occupant-display', {
      attrs: {
        "occupant": occupant
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOccupant(index)
        }
      }
    }, [(_vm.occupantIsDeleting) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('span', [_c('i', {
      staticClass: "fa fa-trash-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteService[_vm.actualLanguage]))])], 1)])], 1)])
  }), 0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addOccupant
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddOccupant[_vm.actualLanguage]))])])], 1), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[3] == true
    }
  }, [_c('comp-unit-tags-display'), _vm._v(" "), _c('comp-compare-level-message-display')], 1)])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "block-title align-center"
  }, [_vm._v(_vm._s(_vm.GraphData.ChartTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "options": _vm.pieChartOptions,
      "series": _vm.pieChartDataSeries
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', {
    staticClass: "bg-image img-rounded overflow-hidden push tesla-bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage[_vm.actualLanguage]))]), _vm._v(" "), (_vm.actualBundle.permissions.bundle[0].value) ? _c('div', {
    staticClass: "block block-rounded"
  }, [(_vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h4 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelSharing[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', [_c('p', [(_vm.bundleSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareMyDefaultBundle()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareMyDefaultBundle[_vm.actualLanguage]))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSharingDetail[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', [_c('p', [(_vm.bundleSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.readGroupSharings()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelRefreshListSharing[_vm.actualLanguage]))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [(_vm.ListOfSharings.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSharingName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelRecipient[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelStatus[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ListOfSharings), function(sharing, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [(sharing.sharedEntity.entityType === 'Channel') ? _c('i', {
      staticClass: "fa fa-television fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Device') ? _c('i', {
      staticClass: "fa fa-server fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Bundle') ? _c('i', {
      staticClass: "fa fa-usb fa-2x push-5-r "
    }) : _vm._e(), _vm._v(" "), (sharing.sharedEntity.entityType === 'Group') ? _c('i', {
      staticClass: "fa fa-users fa-2x push-5-r "
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.sharedEntity.entityReferenceName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.sharingReferenceName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(sharing.guessEmail))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(sharing.sharingStatus == 'Activated') ? _c('button', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelActivated[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'Rejected') ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelRejected[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'Pending') ? _c('button', {
      staticClass: "btn btn-xs btn-info",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelWaiting[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'OnHold') ? _c('button', {
      staticClass: "btn btn-xs btn-warning",
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v(_vm._s(_vm.tableStatusLabelPause[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editSharingRulePermissions(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (sharing.sharingStatus == 'Activated') ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Pause"
      },
      on: {
        "click": function($event) {
          return _vm.saveSharingStatus(index, 'OnHold')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pause"
    })]) : _vm._e(), _vm._v(" "), (sharing.sharingStatus == 'OnHold') ? _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Activer/Enable"
      },
      on: {
        "click": function($event) {
          return _vm.saveSharingStatus(index, 'Activated')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSharing(index, 'Deleted')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)]) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-server"
  }), _vm._v(" " + _vm._s(_vm.tabLabelModule[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-television"
  }), _vm._v(" " + _vm._s(_vm.tabLabelDevice[_vm.actualLanguage]))])]), _vm._v(" "), (false) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[4] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(4)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" " + _vm._s(_vm.tabLabelAlert[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[5] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(5)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" " + _vm._s(_vm.tabLabelEV[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.flagConfigCustomDashboard) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[6] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(6)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" " + _vm._s(_vm.tabLabelCustomDashboard[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [_vm._l((_vm.actualBundle.devices), function(device, index) {
    return _c('div', [(device.DeviceData.frontendComponents.componentDeviceConfig === 'EVA_V1P00') ? _c('config-device', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (device.DeviceData.frontendComponents.componentDeviceConfig === 'ApiDevice_V1P00') ? _c('config-device-api-dev-v1p00', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('add-device-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-server fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddDevice[_vm.actualLanguage]))])])], 2), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[3] == true
    }
  }, [(_vm.displayChannelList === true) ? _c('div', [_c('config-channel-list')], 1) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelToBundle()
      }
    }
  }, [(_vm.channelIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddChannel[_vm.actualLanguage]))])], 1)])])]), _vm._v(" "), (false) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[4] == true
    }
  }, [_c('h4', {
    staticClass: "font-w300 push-15"
  }, [_vm._v("Alertes")]), _vm._v(" "), _c('p', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[5] == true
    }
  }, [_vm._l((_vm.actualBundle.cars), function(car, index) {
    return _c('div', [_c('config-car', {
      attrs: {
        "carIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addCarToBundle()
      }
    }
  }, [(_vm.carIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-car fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddCar[_vm.actualLanguage]))])], 1)])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[6] == true
    }
  }, [_c('config-custom-dashboard')], 1)])])])]) : _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [(_vm.actualBundleIsDefaultBundle == false) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.tabLabelGroup[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-usb"
  }), _vm._v(" " + _vm._s(_vm.tabLabelSystem[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.actualBundle.sub_bundle.length) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[2] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(2)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-usb"
  }), _vm._v(" " + _vm._s(_vm.tabLabelSubSystem[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[3] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(3)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-server"
  }), _vm._v(" " + _vm._s(_vm.tabLabelModule[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[4] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(4)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-television"
  }), _vm._v(" " + _vm._s(_vm.tabLabelDevice[_vm.actualLanguage]))])]), _vm._v(" "), (false) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[5] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(5)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" " + _vm._s(_vm.tabLabelAlert[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('li', {
    class: {
      'active': _vm.tabMenuSelector[6] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(6)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" " + _vm._s(_vm.tabLabelEV[_vm.actualLanguage]))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [(_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[0] == true
    }
  }, [_c('config-group')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[1] == true
    }
  }, [_c('config-bundle')], 1), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[2] == true
    }
  }, [_vm._l((_vm.actualBundle.sub_bundle), function(subBundle, index) {
    return _c('div', [_c('config-sub-bundle', {
      attrs: {
        "subBundleIndex": index
      }
    })], 1)
  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[3] == true
    }
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Device'
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.actualBundle.devices), function(device, index) {
    return _c('div', [(device.DeviceData.frontendComponents.componentDeviceConfig === 'EVA_V1P00') ? _c('config-device', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (device.DeviceData.frontendComponents.componentDeviceConfig === 'ApiDevice_V1P00') ? _c('config-device-api-dev-v1p00', {
      attrs: {
        "deviceIndex": index
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn  btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('add-device-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-server fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddDevice[_vm.actualLanguage]))])])], 2), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[4] == true
    }
  }, [(_vm.displayChannelList === true) ? _c('div', [_c('config-channel-list')], 1) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelToBundle()
      }
    }
  }, [(_vm.channelIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddChannel[_vm.actualLanguage]))])], 1)])])]), _vm._v(" "), (false) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[5] == true
    }
  }, [_c('h4', {
    staticClass: "font-w300 push-15"
  }, [_vm._v("Alertes")]), _vm._v(" "), _c('p', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.profileData.profileConfig.displayEvConfig.value) ? _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[6] == true
    }
  }, [(_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Car'
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.actualBundle.cars), function(car, index) {
    return _c('div', [_c('config-car', {
      attrs: {
        "carIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addCarToBundle()
      }
    }
  }, [(_vm.carIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-car fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddCar[_vm.actualLanguage]))])], 1)])])], 2) : _vm._e()])])])])]) : _vm._e()])]), _vm._v(" "), _c('h6', {
    staticClass: "font-w300 push-15"
  }, [_c('font', {
    attrs: {
      "size": "2",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.test))])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
}]}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-themed block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphData.title[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])])])])]), _vm._v(" "), (_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTraceIndex),
      expression: "selectedTraceIndex"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTraceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateChartData]
    }
  }, _vm._l((_vm.graphData.traces), function(trace, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(trace.label[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('line-chart', {
    attrs: {
      "chartData": _vm.crunchedData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.updateChartData()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.sumAlertActualChannel > 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    staticClass: "h3 text-white"
  }, [_vm._v(_vm._s(_vm.sumAlertActualChannel))]), _vm._v(" "), _c('i', {
    staticClass: "h1 fa fa-bell fa-2x push-15-r "
  })])]) : _vm._e(), _vm._v(" "), _c('li', [(_vm.channelSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "h1 fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelRefrenceName[_vm.actualLanguage]) + " (ID: " + _vm._s(_vm.channelIDLast4) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName),
      expression: "tempoBundle.channels[channelIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.channelConfigViewFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_c('i', {
    staticClass: "fa fa-gear push"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-md-8 push"
  }, [_c('label', {
    staticClass: "h4 col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName),
      expression: "tempoBundle.channels[channelIndex].ChannelData.channelInfo.channelName"
    }],
    staticClass: "h4 form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo, "channelName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "h4 col-xs-12"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description),
      expression: "tempoBundle.channels[channelIndex].ChannelData.channelInfo.description"
    }],
    staticClass: "h4 form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group appliance-list-wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "100px",
      "src": _vm._f("s3Image")(("appliances/" + (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile)))
    },
    on: {
      "click": function($event) {
        _vm.showApplianceList = !_vm.showApplianceList
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-big btn-primary btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showApplianceList = !_vm.showApplianceList
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.showApplianceList) ? _c('appliance-list', {
    staticClass: "appliance-list",
    on: {
      "onSelect": _vm.onApplianceSelect
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.channelConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayDevicePortConfig) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedModule[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId),
      expression: "tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.validateIfChannelDeviceInDeviceList()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Aucun/None"
    }
  }, [_vm._v("Aucun/None")]), _vm._v(" "), _vm._l((_vm.tempoBundle.devices), function(device) {
    return _c('option', {
      domProps: {
        "value": device.DeviceData.deviceId
      }
    }, [_vm._v(_vm._s(device.ReferenceName))])
  })], 2)])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 align-center push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.messageLinkedModuleNotInSystem[_vm.actualLanguage]))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        _vm.displayDevicePortConfig = true
      }
    }
  }, [_vm._v(_vm._s(_vm.messageModifyForModuleInSystem[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.thisChannelDeviceIndex >= 0) ? _c('div', [(_vm.displayDevicePortConfig & _vm.thisChannelDeviceIndex >= 0 & _vm.tempoBundle.devices[_vm.thisChannelDeviceIndex].DeviceData.frontendComponents.componentChannelConfig == 'EVA_V1P00') ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedPort[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.ports),
      expression: "tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.ports"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "4",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts, "ports", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Port 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Port 2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Port 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Port 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Port 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Port 6")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 push",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textSelectMultiplePort[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.titleLivePanel[_vm.actualLanguage]))])]), _vm._v(" "), _c('span', [(_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('h5', {
    staticClass: "h4 font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.addThisChannelToLivePanel[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "col-xs-12 col-sm-3 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled),
      expression: "tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled) ? _vm._i(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled, null) > -1 : (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "enabled", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "enabled", $$c)
        }
      }
    }
  }), _c('span')])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "h4 font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.realTimeMeasurementPanelNotAvailable[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('span', [(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 col-xs-12 col-sm-9"
  }, [_vm._v(_vm._s(_vm.warningLevelLivePanel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel),
      expression: "tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "powerWarningLevel", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 col-xs-12 col-sm-9"
  }, [_vm._v(_vm._s(_vm.limitLevelLivePanel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel),
      expression: "tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "powerLimitLevel", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e()])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.channelsAttributes.length > 0 & false) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceTags[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tempoBundle.channels[_vm.channelIndex].Attributes[index]),
        expression: "tempoBundle.channels[channelIndex].Attributes[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-select",
        "name": "example-select",
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].Attributes, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.channelConfigDeleteFlag) ? _c('button', {
    staticClass: "h4 btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "name": "buttonDeletePlanItem2"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveChannel()
      }
    }
  }, [(_vm.channelIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteDevice[_vm.actualLanguage]))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [(_vm.channelConfigEditFlag) ? _c('button', {
    staticClass: "h4 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelModifications()
      }
    }
  }, [(_vm.channelIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSaveDevice[_vm.actualLanguage]))])], 1) : _vm._e()])])]), _vm._v(" "), (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId != 'TBD' & _vm.channelConfigEditFlag & _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId != 'Aucun/None') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceAlert[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.actualBundle.alerts), function(alert, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [(alert.AlertData.linked_channel[0] === _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelId) ? _c('div', {
      staticClass: "block-content"
    }, [_c('config-alert', {
      attrs: {
        "alertIndex": index
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.alertShowAddButton) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.flagDisplayAlertConfig) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [(_vm.channelConfigEditFlag) ? _c('button', {
    staticClass: "h4 btn btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.openAlertAddMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-bell fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonAddAlert[_vm.actualLanguage]))]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h5', {
    staticClass: "h4"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.labelUserMustSubscribeToConfigAlert[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.alertShowAddButton = true
      }
    }
  }, [_c('i', {
    staticClass: "si si-plus"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelFieldButtonAddAlert[_vm.actualLanguage]) + " " + _vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelAlertSelect[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertToAddIndex),
      expression: "alertToAddIndex"
    }],
    staticClass: "js-select2",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alertToAddIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.alertsDefinitions), function(alert, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(alert.alertTitle[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("alerts/" + (_vm.alertsDefinitions[_vm.alertToAddIndex].icon[_vm.actualLanguage])))
    }
  })]), _vm._v(" "), (_vm.alertsDefinitions[_vm.alertToAddIndex].alertDescription) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.alertsDefinitions[_vm.alertToAddIndex].alertDescription[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAlertParameter[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAlertParameterValue[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.alertsDefinitions[_vm.alertToAddIndex].parameters), function(parameter, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(parameter.parameterTitle[_vm.actualLanguage]))]), _vm._v(" "), (parameter.dataType === 'Numeric') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "type": "test",
        "id": "lock1-password",
        "name": "lock1-password",
        "placeholder": "Entrez votre information"
      },
      domProps: {
        "value": (parameter.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'Boolean') ? _c('td', [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.value) ? _vm._i(parameter.value, null) > -1 : (parameter.value)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "value", $$c)
          }
        }
      }
    }), _c('span')])]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateMonth') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.monthOptions), function(month) {
      return _c('option', {
        domProps: {
          "value": month.value
        }
      }, [_vm._v(_vm._s(month.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateDay') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.dayOptions), function(day) {
      return _c('option', {
        domProps: {
          "value": day.value
        }
      }, [_vm._v(_vm._s(day.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateHour') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.hourOptions), function(hour) {
      return _c('option', {
        domProps: {
          "value": hour.value
        }
      }, [_vm._v(_vm._s(hour.text))])
    }), 0)]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "h4 btn btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": _vm.addAlertLine
    }
  }, [(_vm.alertIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmAddAlert[_vm.actualLanguage]))])], 1), _vm._v(" "), _c('button', {
    staticClass: "h4 btn btn-danger",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        _vm.alertShowAddButton = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonCancelAddAlert[_vm.actualLanguage]))])])])])])], 2) : _vm._e()])])]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.systemsList) ? _c('ul', _vm._l((_vm.systemsList), function(system) {
    return _c('li', {
      key: system.iconFile,
      on: {
        "click": function($event) {
          return _vm.selectItem(system)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "70px",
        "src": _vm._f("s3Image")(("systems_icons/" + (system.iconFile))),
        "alt": ""
      }
    }), _vm._v("\n      " + _vm._s(system.name) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [(_vm.organizationData.subscription) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.textLabelLastPaimentDate[_vm.actualLanguage]) + _vm._s(_vm.organizationData.subscription.data.renewalLastDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 push"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.textLabelNextPaimentDate[_vm.actualLanguage]) + _vm._s(_vm.organizationData.subscription.data.renewalDate))]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationData.subscription.data.automaticRenewFlag),
      expression: "organizationData.subscription.data.automaticRenewFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.organizationData.subscription.data.automaticRenewFlag) ? _vm._i(_vm.organizationData.subscription.data.automaticRenewFlag, null) > -1 : (_vm.organizationData.subscription.data.automaticRenewFlag)
    },
    on: {
      "click": function($event) {
        return _vm.automaticRenewButtonSwitch()
      },
      "change": function($event) {
        var $$a = _vm.organizationData.subscription.data.automaticRenewFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.organizationData.subscription.data, "automaticRenewFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.organizationData.subscription.data, "automaticRenewFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.organizationData.subscription.data, "automaticRenewFlag", $$c)
        }
      }
    }
  }), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "h5 font-w400"
  }, [_vm._v(_vm._s(_vm.buttonLabelAutomaticRenewal[_vm.actualLanguage]))])]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationData.subscription.data.preAuthorizedPaymentFlag),
      expression: "organizationData.subscription.data.preAuthorizedPaymentFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.organizationData.subscription.data.preAuthorizedPaymentFlag) ? _vm._i(_vm.organizationData.subscription.data.preAuthorizedPaymentFlag, null) > -1 : (_vm.organizationData.subscription.data.preAuthorizedPaymentFlag)
    },
    on: {
      "click": function($event) {
        return _vm.automaticRenewButtonSwitch()
      },
      "change": function($event) {
        var $$a = _vm.organizationData.subscription.data.preAuthorizedPaymentFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.organizationData.subscription.data, "preAuthorizedPaymentFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.organizationData.subscription.data, "preAuthorizedPaymentFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.organizationData.subscription.data, "preAuthorizedPaymentFlag", $$c)
        }
      }
    }
  }), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "h5 font-w400"
  }, [_vm._v(_vm._s(_vm.buttonLabelAutomaticPreAuthorizedPaiement[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.renewFlagModified) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modifyMyAutomaticRenew()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelSaveModification[_vm.actualLanguage]))])])]) : _vm._e()]), _vm._v(" "), ((_vm.organizationData.subscription.data.preAuthorizedPaymentFlag) && (_vm.organizationData.subscription.data.automaticRenewFlag)) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [((_vm.organizationData.subscription.data.paymentType == 'CreditCardStripe')) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreditCard[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3 col-lg-3"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-2x"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v(_vm._s(_vm.organizationData.subscription.data.creditCardBrand))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3 col-lg-3"
  }, [_c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v(_vm._s(_vm.textLabelCardLastDigit[_vm.actualLanguage]) + _vm._s(_vm.organizationData.subscription.data.creditCardLastDigit))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3 col-lg-3"
  }, [_c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v("Expire:" + _vm._s(_vm.organizationData.subscription.data.creditCardExpMonth) + "/" + _vm._s(_vm.organizationData.subscription.data.creditCardExpYear))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])]) : _vm._e(), _vm._v(" "), ((_vm.organizationData.subscription.data.preAuthorizedPaymentFlag) & (_vm.organizationData.subscription.data.paymentType == 'ManuallyBilled')) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v(_vm._s(_vm.textYouMustRegisterCreditCard[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyCreditCard()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelApplyCard[_vm.actualLanguage]))])])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.apiManagementSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-9 col-lg-9 push"
  }, [_c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v(_vm._s(_vm.apiManagementSectionText1[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 col-lg-3 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationData.apiManagement.apiActivationFlag),
      expression: "organizationData.apiManagement.apiActivationFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.organizationData.apiManagement.apiActivationFlag) ? _vm._i(_vm.organizationData.apiManagement.apiActivationFlag, null) > -1 : (_vm.organizationData.apiManagement.apiActivationFlag)
    },
    on: {
      "click": function($event) {
        return _vm.apiActivationChange()
      },
      "change": function($event) {
        var $$a = _vm.organizationData.apiManagement.apiActivationFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.organizationData.apiManagement, "apiActivationFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.organizationData.apiManagement, "apiActivationFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.organizationData.apiManagement, "apiActivationFlag", $$c)
        }
      }
    }
  }), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "h5 font-w400"
  }, [_vm._v(_vm._s(_vm.apiManagementActivationButton[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.apiConfirmButtonDisplay) ? _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.apiActivationButtonSwitch()
      }
    }
  }, [_vm._v(_vm._s(_vm.apiManagementActivationConfirmeButton[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [_c('span', {
    staticClass: "h6 font-w400"
  }, [_vm._v(_vm._s(_vm.apiManagementSectionText2[_vm.actualLanguage]))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.organizationData.subscription.data.automaticRenewFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.messageSubscriptionEnding[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.organizationData.subscription.data.automaticRenewFlag && !_vm.organizationData.subscription.data.preAuthorizedPaymentFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [(_vm.organizationData.subscription.data.paymentType == 'ManuallyBilled') ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.manuallyBilledTitle[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h3', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.activateManuallyBilledOptionMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.activateManuallyBilledOptionMessage2[_vm.actualLanguage]))])])]) : _vm._e()]) : _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.labelFreeService[_vm.actualLanguage]))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.flagRuleIsLoading) ? _c('spinner') : _c('div', {
    staticClass: "block-content"
  }, [(_vm.sharingTransmittedFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 align-center"
  }, [_c('i', {
    staticClass: "fa fa-check align-center fa-3x"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "font-w300 align-center push-10"
  }, [_vm._v(_vm._s(_vm.textSharingTransmitted[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 align-center push-10"
  }, [_vm._v(_vm._s(_vm.textSharingTransmitted2[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h2', {
    staticClass: "font-w300 push-10 align-center"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-15-r "
  }), _vm._v(_vm._s(_vm.overlayParameters.modalTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.overlayParameters.entityReferenceName))]), _vm._v(" "), (_vm.overlayParameters.displayUserOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionUser[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.user), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.user[index1].value),
        expression: "ruleTemplate.permissions.user[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.user[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.user[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.user[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.user[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.user[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.user[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.user[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.displayGroupOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-users push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionGroup[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.group), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.group[index1].value),
        expression: "ruleTemplate.permissions.group[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.group[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.group[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.group[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.group[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.group[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.group[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.group[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.displayBundleOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-usb push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionBundle[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.bundle), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.bundle[index1].value),
        expression: "ruleTemplate.permissions.bundle[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.bundle[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.bundle[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.bundle[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.bundle[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.bundle[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.bundle[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.bundle[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.displayDeviceOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-server push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionDevice[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.device), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.device[index1].value),
        expression: "ruleTemplate.permissions.device[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.device[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.device[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.device[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.device[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.device[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.device[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.device[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.displayChannelOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-television push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionChannel[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.channel), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.channel[index1].value),
        expression: "ruleTemplate.permissions.channel[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.channel[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.channel[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.channel[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.channel[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.channel[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.channel[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.channel[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.displayAlertOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-bell push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionAlert[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.alert), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.alert[index1].value),
        expression: "ruleTemplate.permissions.alert[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.alert[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.alert[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.alert[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.alert[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.alert[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.alert[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.alert[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.overlayParameters.displayCarOptions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-car push-5-r"
  }), _vm._v(_vm._s(_vm.labelSectionCar[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.ruleTemplate.permissions.car), function(permission, index1) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleTemplate.permissions.car[index1].value),
        expression: "ruleTemplate.permissions.car[index1].value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(_vm.ruleTemplate.permissions.car[index1].value) ? _vm._i(_vm.ruleTemplate.permissions.car[index1].value, null) > -1 : (_vm.ruleTemplate.permissions.car[index1].value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.ruleTemplate.permissions.car[index1].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.ruleTemplate.permissions.car[index1], "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.ruleTemplate.permissions.car[index1], "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.ruleTemplate.permissions.car[index1], "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(permission.label[_vm.actualLanguage]) + "\n                ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelUserRecipient[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                    " + _vm._s(_vm.textDescriptionToDo[_vm.actualLanguage]) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharingUserRecipient),
      expression: "sharingUserRecipient"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "courriel / email"
    },
    domProps: {
      "value": (_vm.sharingUserRecipient)
    },
    on: {
      "change": function($event) {
        return _vm.validateUserExist()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharingUserRecipient = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.userExistsFlag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelReferenceName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharingReferenceName),
      expression: "sharingReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Reference"
    },
    domProps: {
      "value": (_vm.sharingReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharingReferenceName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelMessage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharingMessage),
      expression: "sharingMessage"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.sharingMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharingMessage = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewSharing()
      }
    }
  }, [(_vm.commentIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonShare[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelExplanation[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelExplanation1[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelExplanation2[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelExplanation3[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelAddTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelListName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listName),
      expression: "listName"
    }],
    staticClass: "form-control align-left ",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.listName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.listName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelListDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listDescription),
      expression: "listDescription"
    }],
    staticClass: "form-control align-left",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.listDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.listDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default margin-bottom",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addMessageList()
      }
    }
  }, [(_vm.listIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddList[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labellistListTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplaySectionMessageList) ? _c('div', {
    staticClass: "block-content"
  }, _vm._l((_vm.listList), function(messageList, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleDisplayMessageList(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })])])]), _vm._v(" "), _c('h3', {
      staticClass: "block-title",
      on: {
        "click": function($event) {
          return _vm.toggleDisplayMessageList(index)
        }
      }
    }, [_vm._v(_vm._s(messageList.referenceName))])]), _vm._v(" "), (_vm.messageListOpenFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('h6', {
      staticClass: "push"
    }, [_vm._v(_vm._s(messageList.description))]), _vm._v(" "), _vm._l((messageList.compareLevelList), function(level, index2) {
      return _c('div', {
        staticClass: "row push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-2"
      }, [_c('h6', [_vm._v(_vm._s(_vm.labelRangeStart[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (level.rangeStart),
          expression: "level.rangeStart"
        }],
        staticClass: "form-control align-left ",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (level.rangeStart)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(level, "rangeStart", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-2"
      }, [_c('h6', [_vm._v(_vm._s(_vm.labelRangeEnd[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (level.rangeEnd),
          expression: "level.rangeEnd"
        }],
        staticClass: "form-control align-left ",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (level.rangeEnd)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(level, "rangeEnd", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-6"
      }, [_c('h6', [_vm._v(_vm._s(_vm.labelRangeMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (level.message),
          expression: "level.message"
        }],
        staticClass: "form-control align-left ",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (level.message)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(level, "message", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-2"
      }, [_c('h6', {
        staticStyle: {
          "color": "white"
        }
      }, [_vm._v("-")]), _vm._v(" "), _c('div', {
        staticClass: "btn-group"
      }, [_c('button', {
        staticClass: "btn btn-default",
        attrs: {
          "type": "button",
          "data-toggle": "tooltip",
          "title": "Supprimer/Delete"
        },
        on: {
          "click": function($event) {
            return _vm.deleteMessageLine(index, index2)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('button', {
      staticClass: "btn btn-xs align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.addMessageLine(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonAddLine[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('button', {
      staticClass: "btn btn-danger align-left",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMessageList(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonDeleteThisList[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6 push"
    }, [_c('button', {
      staticClass: "btn btn-default align-right",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.saveMessageListModifications(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])])])], 2) : _vm._e()])
  }), 0) : _vm._e()])])])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.planTransactionData.transactionStatusCode === '055') ? _c('div', {
    staticClass: "block"
  }, [(_vm.processState === 'ViewPlanList') ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText01[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText02[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText03[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText04[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText05[_vm.actualLanguage]))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText11[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionText12[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', {
    staticClass: "content-heading align-center"
  }, [_vm._v(_vm._s(_vm.textSubscriptionDescriptionTitle03[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openAdministratorDocumentation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-1x push-10-r "
  }), _vm._v(" " + _vm._s(_vm.buttonLabelPlatformDucumentationExplanation[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.flagShowPlanList) ? _c('div', _vm._l((_vm.planDescription), function(planLine, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xm-12 col-md-12"
    }, [_c('a', {
      staticClass: "block block-bordered block-link-hover3 text-center",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('div', {
      staticClass: "block-header"
    }, [_c('h2', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(planLine.planInfo.title[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((planLine.planInfo.description), function(descriptionLine, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xm-12 col-md-12"
      }, [_c('h6', {
        staticClass: "font-w200 text-center push"
      }, [_vm._v(_vm._s(descriptionLine[_vm.actualLanguage]))])])
    }), _vm._v(" "), _c('hr', {
      attrs: {
        "size": "50"
      }
    }), _vm._v(" "), _c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(_vm.textSubscriptionOrgLicenceSection[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center push"
    }, [_vm._v(_vm._s(planLine.organizationLicenceData.licenceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(planLine.organizationLicenceData.priceDescription[_vm.actualLanguage]) + " : ")]), _vm._v(" "), _c('h5', {
      staticClass: "h1 font-w700 push-10"
    }, [_vm._v(_vm._s(planLine.organizationLicenceData.price) + " $ ")]), _vm._v(" "), (planLine.organizationLicenceData.options.length > 100) ? _c('div', [_c('h5', {
      staticClass: "content-heading align-center"
    }, [_vm._v(_vm._s(_vm.textSubscriptionLicenceOptionSection[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((planLine.organizationLicenceData.options), function(optionLine, optionIndex) {
      return _c('div', {
        key: optionIndex,
        staticClass: "col-xm-12 col-md-12"
      }, [_c('h5', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(optionLine.title[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(optionLine.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(optionLine.priceDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
        staticClass: "h3 font-w700 push-10"
      }, [_vm._v(_vm._s(optionLine.price) + " $ ")])])
    })], 2) : _vm._e(), _vm._v(" "), _c('hr', {
      attrs: {
        "size": "50"
      }
    }), _vm._v(" "), (parseFloat(planLine.planInfo.maximumLicenceCount) > parseFloat(planLine.planInfo.includedLicence)) ? _c('div', {
      staticClass: "col-sm-12 push"
    }, [_c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(_vm.textSubscriptionUserLicenceSection[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center push"
    }, [_vm._v(_vm._s(planLine.userLicenceData.licenceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(planLine.userLicenceData.priceDescription[_vm.actualLanguage]) + " : ")]), _vm._v(" "), _c('h5', {
      staticClass: "h1 font-w700 push-10"
    }, [_vm._v(_vm._s(planLine.userLicenceData.price) + " $ ")]), _vm._v(" "), (planLine.userLicenceData.options.length > 100) ? _c('div', [_c('h5', {
      staticClass: "content-heading align-center"
    }, [_vm._v(_vm._s(_vm.textSubscriptionLicenceOptionSection[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((planLine.userLicenceData.options), function(optionLine2, optionIndex2) {
      return _c('div', {
        key: optionIndex2,
        staticClass: "col-xm-12 col-md-12"
      }, [_c('h5', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(optionLine2.title[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(optionLine2.description[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(optionLine2.priceDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
        staticClass: "h3 font-w700 push-10"
      }, [_vm._v(_vm._s(optionLine2.price) + " $ ")])])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
      attrs: {
        "size": "50"
      }
    }), _vm._v(" "), (planLine.rebateChartData.chart.length > 0) ? _c('div', {
      staticClass: "col-sm-12 push"
    }, [_c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(_vm.textRebateTableTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(_vm.textRebateTableSubTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(_vm.textRebateTableColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(_vm.textRebateTableColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(_vm.textRebateTableColumn03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((planLine.rebateChartData.chart), function(rebateSlice) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(rebateSlice.priceSliceMin) + " $")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(rebateSlice.priceSliceMax) + " $")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(rebateSlice.pourcentageReduction) + " %")])])
    }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((planLine.specialRebate), function(specialRebate) {
      return _c('div', {
        staticClass: "col-sm-12 push"
      }, [(specialRebate.RebateType == 'Pourcentage') ? _c('div', {
        staticClass: "col-sm-12"
      }, [_c('h3', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(specialRebate.RebateBillingDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(specialRebate.RebateAmount) + "%")]), _vm._v(" "), _c('h4', {
        staticClass: "font-w200 text-center"
      }, [_vm._v("Expire: " + _vm._s(specialRebate.ExpiringDate))])]) : _c('div', {
        staticClass: "col-sm-12"
      }, [_c('h3', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(specialRebate.RebateBillingDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(specialRebate.RebateAmount) + "$")]), _vm._v(" "), _c('h4', {
        staticClass: "font-w200 text-center"
      }, [_vm._v("Expire: " + _vm._s(specialRebate.ExpiringDate))])])])
    }), _vm._v(" "), _c('div', [_c('h3', [_vm._v(_vm._s(_vm.contactEVSensForSubscribe[_vm.actualLanguage]))])])], 2)])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.processState === 'ViewSelectedPlan') ? _c('div', {
    staticClass: "block"
  }, [_c('a', {
    staticClass: "block block-bordered block-link-hover3 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-flat clearfix"
  }, [_c('i', {
    staticClass: "fa fa-key fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h2 text-white-op"
  }, [_vm._v(_vm._s(_vm.selectedPlan.planInfo.title[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.selectedPlanLicenceConfigurationTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('h5', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.tableLicenceBaseCostDescription[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("---")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.customizedOrganizationLicence.price) + " $")])]), _vm._v(" "), _vm._l((_vm.customizedOrganizationLicence.options), function(option) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('h5', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(option.title[_vm.actualLanguage]))]), _vm._v(_vm._s(option.description[_vm.actualLanguage]))]), _vm._v(" "), (option.valueType == 'NUMERIC') ? _c('td', {
      staticClass: "text-center"
    }, [_c('h6', {
      staticClass: "h6 font-w700 push-10"
    }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.value),
        expression: "option.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (option.value)
      },
      on: {
        "change": function($event) {
          return _vm.computeCost()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(option, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (option.valueType == 'BOOL') ? _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.value),
        expression: "option.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(option.value) ? _vm._i(option.value, null) > -1 : (option.value)
      },
      on: {
        "change": [function($event) {
          var $$a = option.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(option, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(option, "value", $$c)
          }
        }, function($event) {
          return _vm.computeCost()
        }]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" Activation\n                            ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(option.priceDescription[_vm.actualLanguage]) + " : " + _vm._s(option.price) + " $")])])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.customizedUserLicences), function(userLicence, licenceIndex) {
    return _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "block-header"
    }, [_c('h3', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(_vm.selectedPlanUserLicenceConfigurationTitle[_vm.actualLanguage]) + " : " + _vm._s(licenceIndex + 1))])]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.selectPlanOptionColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('h5', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(_vm.tableUserLicenceBaseCostDescription[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("---")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(userLicence.price) + " $")])]), _vm._v(" "), _vm._l((userLicence.options), function(option) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_c('h5', {
        staticClass: "font-w200 text-center"
      }, [_vm._v(_vm._s(option.title[_vm.actualLanguage]))]), _vm._v(_vm._s(option.description[_vm.actualLanguage]))]), _vm._v(" "), (option.valueType == 'NUMERIC') ? _c('td', {
        staticClass: "text-center"
      }, [_c('h6', {
        staticClass: "h6 font-w700 push-10"
      }, [_vm._v(_vm._s(_vm.maxValueLabel[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (option.value),
          expression: "option.value"
        }],
        staticClass: "form-control text-center",
        attrs: {
          "placeholder": "Valeur/Value"
        },
        domProps: {
          "value": (option.value)
        },
        on: {
          "change": function($event) {
            return _vm.computeCost()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(option, "value", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (option.valueType == 'BOOL') ? _c('td', {
        staticClass: "text-center"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (option.value),
          expression: "option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(option.value) ? _vm._i(option.value, null) > -1 : (option.value)
        },
        on: {
          "change": [function($event) {
            var $$a = option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(option, "value", $$c)
            }
          }, function($event) {
            return _vm.computeCost()
          }]
        }
      }), _vm._v(" "), _c('span'), _vm._v(" Activation\n                            ")])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(option.priceDescription[_vm.actualLanguage]) + " : " + _vm._s(option.price) + " $")])])
    })], 2)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "block-header"
  }, [_c('div', {
    staticClass: "col-sm-12 push"
  }, [(_vm.customizedUserLicences.length < parseFloat(_vm.selectedPlan.planInfo.maximumLicenceCount)) ? _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('span', {
    staticClass: "btn btn-default"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addUserLicence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up push-5-r"
  }), _vm._v(_vm._s(_vm.labelBtnAddUserLicence[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.customizedUserLicences.length > parseFloat(_vm.selectedPlan.planInfo.includedLicence)) ? _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('span', {
    staticClass: "btn btn-default"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeUserLicence()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up push-5-r"
  }), _vm._v(_vm._s(_vm.labelBtnRemoveUserLicence[_vm.actualLanguage]))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block-header"
  }, _vm._l((_vm.selectedPlan.specialRebate), function(specialRebate) {
    return _c('div', {
      staticClass: "col-sm-12 push"
    }, [(specialRebate.RebateType == 'Pourcentage') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('h3', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(specialRebate.RebateBillingDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(specialRebate.RebateAmount) + "%")]), _vm._v(" "), _c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v("Expire: " + _vm._s(specialRebate.ExpiringDate))])]) : _c('div', {
      staticClass: "col-sm-12"
    }, [_c('h3', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(specialRebate.RebateBillingDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v(_vm._s(specialRebate.RebateAmount) + "$")]), _vm._v(" "), _c('h4', {
      staticClass: "font-w200 text-center"
    }, [_vm._v("Expire: " + _vm._s(specialRebate.ExpiringDate))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-flat clearfix"
  }, [_c('i', {
    staticClass: "fa fa-dollar fa-2x text-white pull-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "h2 text-white-op"
  }, [_vm._v(_vm._s(_vm.textCostSimulationTitle01[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-6 push"
  }, [_c('h4', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.actualCostTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.actualCostDescriptionNoDevice[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "h5 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelBaseCost[_vm.actualLanguage]) + " " + _vm._s(_vm.sumBaseCostNoDevice) + " $ ")]), _vm._v(" "), _c('h6', {
    staticClass: "h5 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelCostRebate[_vm.actualLanguage]) + _vm._s(_vm.sumRebateNoDevice) + " $ ")]), _vm._v(" "), _c('h6', {
    staticClass: "h3 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelMonthlyCostNoDevice[_vm.actualLanguage]) + _vm._s(_vm.sumFinalCostNoDevice) + " $ ")]), _vm._v(" "), (_vm.specialRabateNoDevice > 0) ? _c('h6', {
    staticClass: "h3 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelCostSpecialRebate[_vm.actualLanguage]) + _vm._s(_vm.specialRabateNoDevice) + " $ ")]) : _vm._e(), _vm._v(" "), (_vm.specialRabateNoDevice > 0) ? _c('h6', {
    staticClass: "h3 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelMonthlyCostNoDeviceSpecialRebate[_vm.actualLanguage]) + _vm._s(_vm.sumFinalCostWithSpecialRebateNoDevice) + " $ ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-6 push"
  }, [_c('h4', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.actualCostTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.actualCostDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', {
    staticClass: "h5 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelBaseCost[_vm.actualLanguage]) + " " + _vm._s(_vm.sumBaseCost) + " $ ")]), _vm._v(" "), _c('h6', {
    staticClass: "h5 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelCostRebate[_vm.actualLanguage]) + _vm._s(_vm.sumRebate) + " $ ")]), _vm._v(" "), _c('h6', {
    staticClass: "h3 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelMonthlyCost[_vm.actualLanguage]) + _vm._s(_vm.sumFinalCost) + " $ ")]), _vm._v(" "), (_vm.specialRabateNoDevice > 0) ? _c('h6', {
    staticClass: "h3 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelCostSpecialRebate[_vm.actualLanguage]) + _vm._s(_vm.specialRabate) + " $ ")]) : _vm._e(), _vm._v(" "), (_vm.specialRabateNoDevice > 0) ? _c('h6', {
    staticClass: "h3 font-w700 push-10"
  }, [_vm._v(_vm._s(_vm.labelMonthlyCostSpecialRebate[_vm.actualLanguage]) + _vm._s(_vm.sumFinalCostWithSpecialRebate) + " $ ")]) : _vm._e()])]), _vm._v(" "), (_vm.flagDisplayApplyPromoCodeButton == true) ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyPromoCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonApplyPromoCode[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.validateLocalisation[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectMyCountry[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualCountryIndex),
      expression: "actualCountryIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.selectActualCountry()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualCountryIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countryStateTaxRates), function(country, countryIndex) {
    return _c('option', {
      domProps: {
        "value": countryIndex
      }
    }, [_vm._v(_vm._s(country.StateTaxData.CountryName[_vm.actualLanguage]))])
  }), 0)])])]), _vm._v(" "), (_vm.actualCountryIndex >= 0) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectMyState[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualStateIndex),
      expression: "actualStateIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.selectActualState()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualStateIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countryStateTaxRates[_vm.actualCountryIndex].StateTaxData.StateList), function(state, stateIndex) {
    return _c('option', {
      domProps: {
        "value": stateIndex
      }
    }, [_vm._v(_vm._s(state.Name[_vm.actualLanguage]))])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonProceedOrder[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "btn btn-default"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.unSelectPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up push-5-r"
  }), _vm._v(_vm._s(_vm.labelBtnUnSelectThisPlan[_vm.actualLanguage]))])])])], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '105') ? _c('div', {
    staticClass: "row"
  }, [(_vm.planTransactionData.firstPaymentRebate > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.InvoiceHeaderFirst[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.InvoiceHeader[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Produit")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceQuantity[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceUnitPrice[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.InvoicePrice[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-w600 push-10"
  }, [_vm._v(_vm._s(_vm.InvoiceEVSensServicePlan[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.selectedPlan.planInfo.title[_vm.actualLanguage]) + " (" + _vm._s(_vm.InvoiceOrgLicenceText[_vm.actualLanguage]) + " " + _vm._s(_vm.customizedUserLicences.length) + " " + _vm._s(_vm.InvoiceOrgUserText[_vm.actualLanguage]) + ")")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(_vm.customizedOrganizationLicence.price))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(_vm.customizedOrganizationLicence.price))])]), _vm._v(" "), (_vm.specialRabateNoDevice > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-w600 push-10"
  }, [_vm._v(_vm._s(_vm.InvoiceSpecialRebate[_vm.actualLanguage]))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ -" + _vm._s(this.specialRabateNoDevice))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ -" + _vm._s(this.specialRabateNoDevice))])]) : _vm._e(), _vm._v(" "), (_vm.selectedPlan.transactionCredit > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-w600 push-10"
  }, [_vm._v(_vm._s(_vm.InvoiceSubscriptionCredit[_vm.actualLanguage]))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ -" + _vm._s(this.selectedPlan.transactionCredit))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ -" + _vm._s(this.selectedPlan.transactionCredit))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "font-w600 text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.InvoiceSubTotal[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("$ " + _vm._s(_vm.sousTotal1))])]), _vm._v(" "), _vm._l((_vm.actualTaxes01), function(taxLine, index2) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-right",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v(_vm._s(taxLine.Label[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("$ " + _vm._s(taxLine.Amount))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "active"
  }, [_c('td', {
    staticClass: "font-w700 text-uppercase text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "font-w700 text-right"
  }, [_vm._v("$ " + _vm._s(_vm.total1))])])], 2)]), _vm._v(" "), _c('div', [_c('h6', {
    staticClass: "block-title text-center"
  }, [_vm._v(_vm._s(_vm.InvoiceMonthlyFeesCondition[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-danger align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSelection()
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonCancelSelection[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('stripe-paiement')
      }
    }
  }, [_vm._v(_vm._s(_vm.ButtonProceedPayment[_vm.actualLanguage]))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v("1")])])
}]}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-container"
  }, [_c('div', {
    class: ['half-circle-spinner', _vm.size]
  }, [_c('div', {
    staticClass: "circle circle-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2"
  })]), _vm._v(" "), (_vm.message) ? _c('span', {
    staticClass: "spinner-message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [(_vm.deviceSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayDevice === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDevice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayDevice) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDevice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDevice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-server fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.devices[_vm.deviceIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayDevice) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].ReferenceName),
      expression: "tempoBundle.devices[deviceIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (true) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12 col-md-12"
  }, [_vm._v(_vm._s(_vm.textLabelModuleName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.name),
      expression: "tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelModuleID[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelModuleSN[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.serialNumber))])])]), _vm._v(" "), (_vm.displayCloudLiveButton & _vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "form-group align-center"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.loadCloudLive()
      }
    }
  }, [(_vm.flagCloudLiveIsActivating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('i', {
    staticClass: "fa fa-cloud-download fa-1x push-15-r "
  }), _vm._v("Cloud Live")], 1)])]) : _vm._e(), _vm._v(" "), (_vm.displayLiveButton) ? _c('div', {
    staticClass: "form-group align-left"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.loadLiveMonitor()
      }
    }
  }, [_vm._v("Live monitor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.liveMonitorMessage[_vm.actualLanguage]))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "150px",
      "src": _vm._f("s3Image")(("devices/" + (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.deviceInfo.devicePicture)))
    }
  })])])])]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), (_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.frontendComponents.componentDeviceConfig == 'EVA_V1P00') ? _c('div', [(_vm.deviceConfigViewFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayPortCfg === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePortCfg()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPortCfg) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePortCfg()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.togglePortCfg()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelPortConfiguration[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayPortCfg) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Port")]), _vm._v(" "), _c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSensorFactor[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelCircuitVoltage[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelAvrPowerFactor[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tempoBundle.devices[_vm.deviceIndex].DeviceData.portsConfig), function(port, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(port.portId))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (port.sensorFactor),
        expression: "port.sensorFactor"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": "Entrez votre information"
      },
      domProps: {
        "value": (port.sensorFactor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(port, "sensorFactor", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (port.portVoltage),
        expression: "port.portVoltage"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": "Entrez votre information"
      },
      domProps: {
        "value": (port.portVoltage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(port, "portVoltage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (port.powerFactor),
        expression: "port.powerFactor"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": "Entrez votre information"
      },
      domProps: {
        "value": (port.powerFactor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(port, "powerFactor", $event.target.value)
        }
      }
    })])])
  }), 0)])])])])]) : _vm._e()])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMap === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMap) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePlanMap()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.togglePlanMap()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelLocalisation[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMap) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "h4 col-xs-12"
  }, [_c('div', {
    staticClass: "h4 form-material col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelFieldDeviceAddress[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "h4 form-material"
  }, [_c('gmap-autocomplete', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "5px"
    },
    attrs: {
      "placeholder": _vm.locationString
    },
    on: {
      "place_changed": _vm.usePlace
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h4 col-xs-12"
  }, [_c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "zoom": 7,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "draggable": true
      }
    })
  }), 1)], 1)])])]) : _vm._e()])])])]), _vm._v(" "), (_vm.deviceConfigViewFlag) ? _c('div', {
    staticClass: "block"
  }, [_c('config-device-plan', {
    attrs: {
      "deviceIndex": _vm.deviceIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.deviceConfigViewFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayListOfChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleListOfChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayListOfChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleListOfChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleListOfChannel()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelLinkedChannel[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayListOfChannel) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.deviceLinkedChannelIsReading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLinkedChannelChannelName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLinkedChannelUserOrg[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLinkedChannelBundle[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "h5 text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.tableLinkedChannelPort[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deviceListOfLinkedChannel), function(channel, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(channel.ChannelName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(channel.ParentBundleOwner))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(channel.ParentBundle))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(channel.Port))])])
  }), 0)])])])])], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.bundleConfigEditFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "h4 btn btn-danger align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveDevice()
      }
    }
  }, [(_vm.deviceIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmDeleteDevice[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), (_vm.deviceConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "h4 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDeviceModifications()
      }
    }
  }, [(_vm.deviceIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmSaveDevice[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
}]}

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayTab) ? _c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-tabs-alt nav-justified",
    attrs: {
      "data-toggle": "tabs"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tabMenuSelector[0] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(0)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-industry"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tabMenuSelector[1] == true
    },
    on: {
      "click": function($event) {
        return _vm.toggleTabMenuSelector(1)
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" " + _vm._s(_vm.homeTabMenuPayment[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content tab-content"
  }, [_c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[0] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('integrator-sub-organization', {
    attrs: {
      "organization": _vm.organization
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: {
      'tab-pane': true, 'active': _vm.tabMenuSelector[1] == true
    }
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('integrator-customer-payment-history', {
    attrs: {
      "organization": _vm.organization
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('integrator-commissions-reports', {
    attrs: {
      "organization": _vm.organization
    }
  })], 1)])])]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayAlert === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAlert()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAlert) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAlert()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAlert()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.alerts[_vm.alertIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayAlert) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.alert_title[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.alertConfigViewFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("alerts/" + (_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.icon[_vm.actualLanguage])))
    }
  })]), _vm._v(" "), (_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.alert_description) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push-50"
  }, [_c('h6', [_vm._v(_vm._s(_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.alert_description[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelAlertDescription[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.description),
      expression: "tempoBundle.alerts[alertIndex].AlertData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.alerts[_vm.alertIndex].AlertData, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.labelAlertMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.message),
      expression: "tempoBundle.alerts[alertIndex].AlertData.message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.alerts[_vm.alertIndex].AlertData, "message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleParameter[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleValue[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.parameters), function(variableLine, index2) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(variableLine.parameterTitle[_vm.actualLanguage]))]), _vm._v(" "), (variableLine.dataType === 'Numeric') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variableLine.value),
        expression: "variableLine.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "type": "test",
        "id": "lock1-password",
        "name": "lock1-password",
        "placeholder": "Valeur/Value"
      },
      domProps: {
        "value": (variableLine.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(variableLine, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (variableLine.dataType === 'Boolean') ? _c('td', [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variableLine.value),
        expression: "variableLine.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(variableLine.value) ? _vm._i(variableLine.value, null) > -1 : (variableLine.value)
      },
      on: {
        "change": function($event) {
          var $$a = variableLine.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(variableLine, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(variableLine, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(variableLine, "value", $$c)
          }
        }
      }
    }), _c('span')])]) : _vm._e(), _vm._v(" "), (variableLine.dataType === 'DateMonth') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variableLine.value),
        expression: "variableLine.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(variableLine, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.monthOptions), function(month) {
      return _c('option', {
        domProps: {
          "value": month.value
        }
      }, [_vm._v(_vm._s(month.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (variableLine.dataType === 'DateDay') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variableLine.value),
        expression: "variableLine.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(variableLine, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.dayOptions), function(day) {
      return _c('option', {
        domProps: {
          "value": day.value
        }
      }, [_vm._v(_vm._s(day.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (variableLine.dataType === 'DateHour') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variableLine.value),
        expression: "variableLine.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(variableLine, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.hourOptions), function(hour) {
      return _c('option', {
        domProps: {
          "value": hour.value
        }
      }, [_vm._v(_vm._s(hour.text))])
    }), 0)]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.variables), function(variableLine, index2) {
    return _c('div', {
      key: index2
    }, [(variableLine.displayFlag) ? _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(variableLine.variableTitle[_vm.actualLanguage]) + " : " + _vm._s(variableLine.value))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.buttons), function(button, index4) {
    return _c('div', {
      key: index4
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default align-left",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": ""
      },
      on: {
        "click": function($event) {
          return _vm.alertButtonAction(index4)
        }
      }
    }, [_vm._v(_vm._s(button.buttonLabel[_vm.actualLanguage]))])])])])
  }), 0), _vm._v(" "), (_vm.profileData.rights.rights.emailMultipleRecipientFlag) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelRecipientList[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelRecipientEmailEnable[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelRecipientSMSEnable[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelRecipientDelete[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tempoBundle.alerts[_vm.alertIndex].AlertData.users_recipient), function(userLine, index5) {
    return _c('tr', {
      key: index5
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index5 + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(userLine.email))]), _vm._v(" "), _c('td', [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (userLine.emailEnableFlag),
        expression: "userLine.emailEnableFlag"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(userLine.emailEnableFlag) ? _vm._i(userLine.emailEnableFlag, null) > -1 : (userLine.emailEnableFlag)
      },
      on: {
        "change": function($event) {
          var $$a = userLine.emailEnableFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(userLine, "emailEnableFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(userLine, "emailEnableFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(userLine, "emailEnableFlag", $$c)
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [(_vm.profileData.rights.rights.smsFlag) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (userLine.smsEnableFlag),
        expression: "userLine.smsEnableFlag"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(userLine.smsEnableFlag) ? _vm._i(userLine.smsEnableFlag, null) > -1 : (userLine.smsEnableFlag)
      },
      on: {
        "change": function($event) {
          var $$a = userLine.smsEnableFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(userLine, "smsEnableFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(userLine, "smsEnableFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(userLine, "smsEnableFlag", $$c)
          }
        }
      }
    })]) : _c('div', [_vm._v("\n                                                " + _vm._s(_vm.labelRecipientSMSNotAvailable[_vm.actualLanguage]) + "\n                                              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Retirer/Remove"
      },
      on: {
        "click": function($event) {
          return _vm.confirmRemoveEmail(index5)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])])
  }), 0)])]), _vm._v(" "), (_vm.alertConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addEmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonAddRecipient[_vm.actualLanguage]))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.actualGroupIsDefaultGroup == false) ? _c('div', {
    staticClass: "col-sm-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transmitEmailToActualGroupMember),
      expression: "transmitEmailToActualGroupMember"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.transmitEmailToActualGroupMember) ? _vm._i(_vm.transmitEmailToActualGroupMember, null) > -1 : (_vm.transmitEmailToActualGroupMember)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.transmitEmailToActualGroupMember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.transmitEmailToActualGroupMember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.transmitEmailToActualGroupMember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.transmitEmailToActualGroupMember = $$c
        }
      }, _vm.modifyActualGroupInGroupRecipient]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelTransmitEmailToGroup[_vm.actualLanguage]) + " " + _vm._s(_vm.actualGroup.group_name) + "\n                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.alertConfigDeleteFlag) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveAlertLine()
      }
    }
  }, [(_vm.alertIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonDelete[_vm.actualLanguage]))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.alertConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveAlertModifications()
      }
    }
  }, [(_vm.alertIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonSave[_vm.actualLanguage]))])], 1) : _vm._e()])])])]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelGroupID[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualGroup.group_id.split("::").pop()))]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.textLabelLinkedOrganization[_vm.actualLanguage]) + " : " + _vm._s(_vm.actualGroup.rightsProviderName))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [(_vm.navIndex.GS.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('h5', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSectionToAddGroupA[_vm.actualLanguage])), _c('i', {
    staticClass: "fa fa-users fa-1x "
  }), _vm._v(_vm._s(_vm.textSectionToAddGroupB[_vm.actualLanguage]))])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayConfig === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayConfig) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayConfig()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelConfig[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayConfig) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.subSectionGroupOptionsConfig[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, _vm._l((_vm.actualGroup.group_options), function(groupOption, index) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (groupOption.value),
        expression: "groupOption.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(groupOption.value) ? _vm._i(groupOption.value, null) > -1 : (groupOption.value)
      },
      on: {
        "change": [function($event) {
          var $$a = groupOption.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(groupOption, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(groupOption, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(groupOption, "value", $$c)
          }
        }, _vm.updateGroupOptions]
      }
    }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(groupOption.displayLabel[_vm.actualLanguage]) + "\n                    ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', [_c('p', [(_vm.groupConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewGroupName()
      }
    }
  }, [(_vm.newGroupNameIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.buttonLabelModifyGroupName[_vm.actualLanguage]))])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [(_vm.flagActualGroupDefault == false) ? _c('div', [_c('p', [(_vm.groupConfigDeleteFlag) ? _c('button', {
    staticClass: "btn btn-block btn-danger align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteGroup()
      }
    }
  }, [(_vm.groupIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteGroup[_vm.actualLanguage]))])], 1) : _vm._e()])]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySharing === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySharing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelSharing[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySharing) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textSharingMessage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.groupSharingEnableFlag) ? _c('button', {
    staticClass: "btn btn-block btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelShareThisGroup[_vm.actualLanguage]) + _vm._s(_vm.actualGroup.group_name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Group'
      }
    }
  })], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.groupConfigViewFlag & (_vm.flagActualGroupDefault == false)) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayGroupMembers === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayGroupMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGroupMembers) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayGroupMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayGroupMembers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-group fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelGroupMembers[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayGroupMembers) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h6', {
    staticClass: "font-w200"
  }, [_vm._v(_vm._s(_vm.textGroupMembersMessage[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnOrganisation[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnEmail[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnEmailEnabled[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnSMSEnabled[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.groupMembersTableColumnRemove[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.actualGroup.group_members), function(groupMember, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(groupMember.organization))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(groupMember.firstName) + " " + _vm._s(groupMember.LastName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v(_vm._s(groupMember.email))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (groupMember.memberOptions.emailEnabled),
        expression: "groupMember.memberOptions.emailEnabled"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(groupMember.memberOptions.emailEnabled) ? _vm._i(groupMember.memberOptions.emailEnabled, null) > -1 : (groupMember.memberOptions.emailEnabled)
      },
      on: {
        "change": [function($event) {
          var $$a = groupMember.memberOptions.emailEnabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(groupMember.memberOptions, "emailEnabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(groupMember.memberOptions, "emailEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(groupMember.memberOptions, "emailEnabled", $$c)
          }
        }, function($event) {
          return _vm.updateGroupMemberOptions(index)
        }]
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (groupMember.memberOptions.smsEnabled),
        expression: "groupMember.memberOptions.smsEnabled"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(groupMember.memberOptions.smsEnabled) ? _vm._i(groupMember.memberOptions.smsEnabled, null) > -1 : (groupMember.memberOptions.smsEnabled)
      },
      on: {
        "change": [function($event) {
          var $$a = groupMember.memberOptions.smsEnabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(groupMember.memberOptions, "smsEnabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(groupMember.memberOptions, "smsEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(groupMember.memberOptions, "smsEnabled", $$c)
          }
        }, function($event) {
          return _vm.updateGroupMemberOptions(index)
        }]
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Retirer/Remove"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGroupMember(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]), _vm._v(" "), (_vm.groupConfigEditFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addMySelfAsMember()
      }
    }
  }, [(_vm.addMySelfToGroup) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonGroupAddMySelfAsMember[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addOtherProfileAsMember()
      }
    }
  }, [(_vm.addAnotherUserToGroup) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonGroupOtherUserAsMember[_vm.actualLanguage]))])], 1)])])]) : _vm._e()])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.labelTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-rounded btn-default align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('add-device-form')
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton01[_vm.actualLanguage]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-default",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getCode
    }
  }, [(_vm.gettingCode) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.labelButton02[_vm.actualLanguage]))])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagMovingAverageDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "large"
    }
  }) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Automatic"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Automatic")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Automatic"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]) + "\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Hour"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Hour")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Hour"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]) + "\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline",
    attrs: {
      "for": "example-inline-radio3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    attrs: {
      "type": "radio",
      "value": "Day"
    },
    domProps: {
      "checked": _vm._q(_vm.dataSamplingSelect, "Day")
    },
    on: {
      "change": function($event) {
        _vm.dataSamplingSelect = "Day"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]) + "\n                              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])]), _vm._v(" "), (_vm.flagMovingAverageDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', {
    staticClass: "row"
  }, [(_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.graphTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 align-center"
  }, [(_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display001H),
      expression: "display001H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display001H) ? _vm._i(_vm.display001H, null) > -1 : (_vm.display001H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display001H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display001H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display001H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display001H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 1 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display004H),
      expression: "display004H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display004H) ? _vm._i(_vm.display004H, null) > -1 : (_vm.display004H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display004H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display004H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display004H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display004H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 4 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display006H),
      expression: "display006H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display006H) ? _vm._i(_vm.display006H, null) > -1 : (_vm.display006H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display006H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display006H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display006H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display006H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 6 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display012H),
      expression: "display012H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display012H) ? _vm._i(_vm.display012H, null) > -1 : (_vm.display012H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display012H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display012H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display012H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display012H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 12 hr\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display024H),
      expression: "display024H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display024H) ? _vm._i(_vm.display024H, null) > -1 : (_vm.display024H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display024H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display024H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display024H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display024H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 1 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display072H),
      expression: "display072H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display072H) ? _vm._i(_vm.display072H, null) > -1 : (_vm.display072H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display072H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display072H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display072H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display072H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 3 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display168H),
      expression: "display168H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display168H) ? _vm._i(_vm.display168H, null) > -1 : (_vm.display168H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display168H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display168H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display168H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display168H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 7 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display336H),
      expression: "display336H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display336H) ? _vm._i(_vm.display336H, null) > -1 : (_vm.display336H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display336H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display336H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display336H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display336H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 14 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('div', {
    staticClass: "col-sm-3 col-md-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display720H),
      expression: "display720H"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.display720H) ? _vm._i(_vm.display720H, null) > -1 : (_vm.display720H)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.display720H,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.display720H = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.display720H = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.display720H = $$c
        }
      }, _vm.updateChartData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA[_vm.actualLanguage]) + " 30 " + _vm._s(_vm.buttonLabelMA_Days[_vm.actualLanguage]) + "\n                      ")])]) : _vm._e()])]), _vm._v(" "), (_vm.flagMovingAverageDataAvailable) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.histogramDataDownloadDay,
      "name": "ChannelHistogramDayData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelTopDatePicker[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('range-picker', {
    on: {
      "refresh": _vm.refreshData
    }
  })], 1)])])]), _vm._v(" "), (_vm.displayAlertTronquedResults) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('a', {
    staticClass: "block block-link-hover2"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-city clearfix"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-2x text-white pull-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w700 text-white"
  }, [_vm._v(_vm._s(_vm.alertTronquedResultMessage[_vm.actualLanguage]))])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayAddService === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddService()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAddService) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddService()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddService()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelAlertList[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayAddService) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.loadingAlertData) ? _c('div', [_c('spinner', {
    attrs: {
      "message": _vm.labelSpinner[_vm.actualLanguage]
    }
  })], 1) : _c('div', [_c('dynamic-table', {
    attrs: {
      "tableDataObj": _vm.tableData
    }
  })], 1)])])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayAddService === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddService()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAddService) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddService()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddService()
      }
    }
  }, [_vm._v("Enregistrement de plan pre-enregistré")])]), _vm._v(" "), (_vm.flagDisplayAddService) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v("Sélectionner un type de plan / Select plan type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transmitDataModel.subscriptionTemplate),
      expression: "transmitDataModel.subscriptionTemplate"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.transmitDataModel, "subscriptionTemplate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.planDescription), function(plan) {
    return _c('option', {
      domProps: {
        "value": plan.PlanTemplate
      }
    }, [_vm._v(_vm._s(plan.Title[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), (_vm.transmitDataModel.subscriptionTemplate != 'ND') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v("Duréé gratuit (mois)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transmitDataModel.monthFree),
      expression: "transmitDataModel.monthFree"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.transmitDataModel.monthFree)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.transmitDataModel, "monthFree", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.generatePreRegisteredPlan()
      }
    }
  }, [_vm._v("Génerer le plan / Generate plan")])])])]) : _vm._e(), _vm._v(" "), (_vm.flagPlanCodeReceived) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("Code du plan / Plan code:      " + _vm._s(_vm.PlanCode))]), _vm._v(" "), _c('h4', [_vm._v("Code de validation / Validation code:      " + _vm._s(_vm.ValidationCode))])]) : _vm._e()])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('view-edit-manual-invoice', {
    attrs: {
      "inputData": _vm.tableData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('view-edit-integrator-data', {
    attrs: {
      "inputData": _vm.tableData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayReadEventLog === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayReadEventLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayReadEventLog) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayReadEventLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayReadEventLog()
      }
    }
  }, [_vm._v("Lecture des Event Log")])]), _vm._v(" "), (_vm.flagDisplayReadEventLog) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.readEventLogDataModel.profileid),
      expression: "readEventLogDataModel.profileid"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.readEventLogDataModel.profileid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.readEventLogDataModel, "profileid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v("Date de début")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.readEventLogDataModel.startDate),
      expression: "readEventLogDataModel.startDate"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.readEventLogDataModel.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.readEventLogDataModel, "startDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getUserEventLogs()
      }
    }
  }, [_vm._v("Lire Log")])])])]), _vm._v(" "), _c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.loadingData) ? _c('div', [_c('spinner', {
    attrs: {
      "message": "Téléchargement des données"
    }
  })], 1) : _c('div', [_c('dynamic-table', {
    attrs: {
      "tableDataObj": _vm.tableData
    }
  })], 1)])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.testCall()
      }
    }
  }, [_vm._v("BOUTON TEST")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "row push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.DocumentTableTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.DocumentListIsReading) ? _c('spinner', {
    attrs: {
      "size": "large"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.DocumentListIsReading == false) ? _c('div', {
    staticClass: "block-content"
  }, [_c('p', {
    staticClass: "push-30"
  }, [_vm._v(_vm._s(_vm.DocumentTableDetail[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.DocumentTableContain), function(Document) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Document.Document[_vm.actualLanguage]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Document.Detail[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Ouvrir/Open"
      },
      on: {
        "click": function($event) {
          return _vm.openDocumentInTable(Document.FileLink[_vm.actualLanguage])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    })])])])])
  }), 0)])])]) : _vm._e()], 1), _vm._v(" "), _c('h3', {
    staticClass: "h4 font-w600 push-50-t push"
  }, [_vm._v(_vm._s(_vm.labelText01[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayAddFaq === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddFaq()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayAddFaq) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddFaq()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayAddFaq()
      }
    }
  }, [_vm._v("FAQ")])]), _vm._v(" "), (_vm.flagDisplayAddFaq) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h3', {
    staticClass: "h4 font-w600  push"
  }, [_vm._v(_vm._s(_vm.labelText010[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.faqItems), function(faqItem, index1) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('h3', {
      staticClass: "h3 font-w600 push-30-t push"
    }, [_vm._v(_vm._s(faqItem.subjectTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "panel-group",
      attrs: {
        "id": _vm.faqId[index1]
      }
    }, _vm._l((faqItem.issues), function(faqIssue, index2) {
      return _c('div', {
        staticClass: "panel panel-default"
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('h3', {
        staticClass: "panel-title"
      }, [_c('a', {
        staticClass: "accordion-toggle",
        attrs: {
          "data-toggle": "collapse",
          "data-parent": _vm.faqIdTag[index1],
          "href": _vm.faqSubIdTag[index1][index2]
        }
      }, [_vm._v(_vm._s(faqIssue.issueTitle[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-collapse collapse",
        attrs: {
          "id": _vm.faqSubId[index1][index2]
        }
      }, [_c('div', {
        staticClass: "panel-body"
      }, [_c('p', [_vm._v(_vm._s(faqIssue.issueSolution[_vm.actualLanguage]))])])])])
    }), 0)])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('h3', {
    staticClass: "h4 font-w600 push-50-t push"
  }, [_vm._v(_vm._s(_vm.labelText02[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-sm-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.showModal('transmit-help-request-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" " + _vm._s(_vm.labelButtonSendMessage[_vm.actualLanguage]))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Document")])])])
}]}

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateOrganisation[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxOrganisation[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.name),
      expression: "organizationModel.organizationInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Organisation / Organization..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxAdress[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.address),
      expression: "organizationModel.organizationInfo.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxCity[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.city),
      expression: "organizationModel.organizationInfo.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ville / City..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxProvince[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.province),
      expression: "organizationModel.organizationInfo.province"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Province / State ..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.province)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "province", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxCountry[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.country),
      expression: "organizationModel.organizationInfo.country"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pays / Country ..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxPostalCode[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.postalCode),
      expression: "organizationModel.organizationInfo.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Code postal / Postal code..."
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxPhone[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.organizationInfo.phoneNumber),
      expression: "organizationModel.organizationInfo.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "555-555-5555"
    },
    domProps: {
      "value": (_vm.organizationModel.organizationInfo.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.organizationInfo, "phoneNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelSectionContactPerson[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonFirstname[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.managers[0].firstName),
      expression: "organizationModel.managers[0].firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Prénom/first name.."
    },
    domProps: {
      "value": (_vm.organizationModel.managers[0].firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.managers[0], "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-lastname"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonLastname[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.managers[0].lastName),
      expression: "organizationModel.managers[0].lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nom/last name.."
    },
    domProps: {
      "value": (_vm.organizationModel.managers[0].lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.managers[0], "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonEmail[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.managers[0].email),
      expression: "organizationModel.managers[0].email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Courriel/email"
    },
    domProps: {
      "value": (_vm.organizationModel.managers[0].email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.managers[0], "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-lastname"
    }
  }, [_vm._v(_vm._s(_vm.labelSectionContactPersonPhone[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationModel.managers[0].phoneNumber),
      expression: "organizationModel.managers[0].phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "555-555-5555"
    },
    domProps: {
      "value": (_vm.organizationModel.managers[0].phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organizationModel.managers[0], "phoneNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveOrganization()
      }
    }
  }, [(_vm.organizationIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('button', {
    attrs: {
      "type": "button",
      "data-toggle": "block-option",
      "data-action": "refresh_toggle",
      "data-action-mode": "demo"
    },
    on: {
      "click": function($event) {
        return _vm.readJournalReadings()
      }
    }
  }, [_c('i', {
    staticClass: "si si-refresh"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelLogBook[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "400px"
    }
  }, [(_vm.totalWorkingTime > 0) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-wrench fa-1x text-warning"
  }), _vm._v(" " + _vm._s(_vm.textLableTotalMaintenance[_vm.actualLanguage]) + " " + _vm._s(_vm.totalWorkingTime) + " Hr")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('ul', {
    staticClass: "list list-activity push"
  }, _vm._l((_vm.journalItems), function(logItem, index) {
    return _c('li', [(logItem.event_type === 'Alert') ? _c('i', {
      staticClass: "fa fa-bell text-danger"
    }) : _vm._e(), _vm._v(" "), (logItem.event_type === 'comment') ? _c('i', {
      staticClass: "fa fa-comment text-info"
    }) : _vm._e(), _vm._v(" "), (logItem.event_type === 'maintenance') ? _c('i', {
      staticClass: "fa fa-wrench text-warning"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(logItem.timestamp_local.substr(0, 16)))]), _vm._v(" "), _c('div', [_c('a', [_vm._v(_vm._s(logItem.event_info.postedBy))])]), _vm._v(" "), (logItem.event_type === 'comment') ? _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(logItem.event_info.comment))])]) : _vm._e(), _vm._v(" "), (logItem.event_type === 'maintenance') ? _c('div', {
      staticClass: "font-w600"
    }, [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Travail: " + _vm._s(logItem.event_info.workTime) + " Hr")])]) : _vm._e(), _vm._v(" "), (logItem.event_type === 'maintenance') ? _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(logItem.event_info.description))])]) : _vm._e(), _vm._v(" "), (logItem.event_type === 'Alert') ? _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(logItem.event_info.description))])]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelCommentLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddComment[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelMaintenanceLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddMaintenance[_vm.actualLanguage]))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    attrs: {
      "type": "button",
      "data-toggle": "block-option",
      "data-action": "fullscreen_toggle"
    }
  })])
}]}

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading-bar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('modal'), _vm._v(" "), _c('div', {
    staticClass: "notifications-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "p"
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('span', {
      key: notification.type,
      class: ['list-item ', 'alert', ("alert-" + (notification.type))]
    }, [_vm._v("\n        " + _vm._s(notification.text) + "\n      ")])
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.appliancesList) ? _c('ul', _vm._l((_vm.appliancesList), function(appliance) {
    return _c('li', {
      key: appliance.iconFile,
      on: {
        "click": function($event) {
          return _vm.selectItem(appliance)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "70px",
        "src": _vm._f("s3Image")(("appliances/" + (appliance.iconFile))),
        "alt": ""
      }
    }), _vm._v("\n      " + _vm._s(appliance.name) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.bundleConfigEditFlag & _vm.dashboardFlags.evsensAdminFlag === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('config-sharing-list', {
    attrs: {
      "sharingListData": {
        sharingType: 'Channel'
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.dashboardFlags.evsensAdminFlag === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayFilter === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayFilter) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.sectionLabelDeviceFilter[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayFilter === -1) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row items-push"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_c('i', {
      staticClass: "fa fa-tags fa-1x push-5-r "
    }), _vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attributesFiltersChoice[index]),
        expression: "attributesFiltersChoice[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-multiple-select",
        "name": "example-multiple-select",
        "size": "4",
        "multiple": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.attributesFiltersChoice, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.attributesFilters[index]), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetDisplayFlag()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelEraseFilter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelApplyFilter[_vm.actualLanguage]))])])])])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showListOfChannel) ? _c('div', _vm._l((_vm.channelDisplayFlag), function(flag, index) {
    return _c('div', [(flag) ? _c('div', {
      staticClass: "col-xs-12"
    }, [(_vm.actualBundle.channels[index].FrontendTemplates.componentChannelConfig === 'EVA_V1P00') ? _c('config-channel', {
      attrs: {
        "channelIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.actualBundle.channels[index].FrontendTemplates.componentChannelConfig === 'ApiDevice_V1P00') ? _c('config-channel-api-dev-v1p00', {
      attrs: {
        "channelIndex": index
      }
    }) : _vm._e()], 1) : _vm._e()])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.actualBundleLoadedFlag) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "bg-image img-rounded overflow-hidden push tesla-bg"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage1[_vm.actualLanguage]))]), _vm._v(" "), (_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('power-live-monitor') : _c('div', {
    staticClass: "block block-rounded push"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: " form-group row"
  }, [_c('div', {
    staticClass: "col-xs-12 align-center"
  }, [_c('h1', {
    staticClass: "h4 font-w300 push"
  }, [_vm._v(_vm._s(_vm.realTimeMeasurementPanelNotAvailable[_vm.actualLanguage]))])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelTopDatePicker[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('range-picker', {
    on: {
      "refresh": _vm.refreshData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('display-channel-list')], 1)])])]) : _c('div', [_c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-muted"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building fa-1x push-5-r"
  }), _vm._v("  " + _vm._s(_vm.unit.reference_name))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.flagDisplayDetail === 0) ? _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Detail")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 align-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelButton[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagReadByInvoiceData),
      expression: "flagReadByInvoiceData"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagReadByInvoiceData) ? _vm._i(_vm.flagReadByInvoiceData, null) > -1 : (_vm.flagReadByInvoiceData)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagReadByInvoiceData,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagReadByInvoiceData = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagReadByInvoiceData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagReadByInvoiceData = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateStart),
      callback: function($$v) {
        _vm.visualisationDateStart = $$v
      },
      expression: "visualisationDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.visualisationDateEnd),
      callback: function($$v) {
        _vm.visualisationDateEnd = $$v
      },
      expression: "visualisationDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.readUnitGraphData()
      }
    }
  }, [_vm._v("\r\n                                  " + _vm._s(_vm.labelButtonReadGraph[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push"
  }, [(_vm.flagGraphDataIsUpdating) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('graph-apex-pies', {
    attrs: {
      "GraphData": _vm.pieChartData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('h4', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.labelSumCost[_vm.actualLanguage]) + " : " + _vm._s(_vm.sumPeriodCosts) + " $")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.labelCost[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pieChartData.Data), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                                                    " + _vm._s(_vm.pieChartData.Labels[index]) + "\r\n                                                  ")]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-center"
    }, [_vm._v("\r\n                                                    " + _vm._s(data) + " $\r\n                                                  ")])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataUnit1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('graph-apex-bars', {
    attrs: {
      "GraphData": _vm.barChartDataUnit2
    }
  })], 1) : _vm._e()])])]) : _c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleConfigView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonConfigClose[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Configuration " + _vm._s(_vm.labelUnit[_vm.actualLanguage]) + " ID: " + _vm._s(_vm.unit.unit_id))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelRefenrenceName[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.reference_name),
      expression: "unit.reference_name"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.unit.reference_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "reference_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelUnitTags[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelUnitTagsHelp[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelUnitTagsHelp2[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.unit_tags),
      expression: "unit.unit_tags"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "4",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "unit_tags", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Aucun/None"
    }
  }, [_vm._v("Aucun/None")]), _vm._v(" "), _vm._l((_vm.tagsList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.tagId
      }
    }, [_vm._v(_vm._s(type.tagName))])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelSpecificationSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecType[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_type_id),
      expression: "unit.spec_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "spec_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.specTypeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.list_id
      }
    }, [_vm._v(_vm._s(type.description[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecArea[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_area_id),
      expression: "unit.spec_area_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "spec_area_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.specAreaList), function(area) {
    return _c('option', {
      domProps: {
        "value": area.list_id
      }
    }, [_vm._v(_vm._s(area.description[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecYearOfConstruction[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_building_construction_year_id),
      expression: "unit.spec_building_construction_year_id"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "spec_building_construction_year_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.specYearOfConstructList), function(yearOfConstruct) {
    return _c('option', {
      domProps: {
        "value": yearOfConstruct.list_id
      }
    }, [_vm._v(_vm._s(yearOfConstruct.description[_vm.actualLanguage]))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecHeatingIncluded[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_heating_included),
      expression: "unit.spec_heating_included"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.unit.spec_heating_included) ? _vm._i(_vm.unit.spec_heating_included, null) > -1 : (_vm.unit.spec_heating_included)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.unit.spec_heating_included,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.unit, "spec_heating_included", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.unit, "spec_heating_included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.unit, "spec_heating_included", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.unit.spec_heating_included) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelSpecHotIncludedIncluded[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.spec_hot_water_included),
      expression: "unit.spec_hot_water_included"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.unit.spec_hot_water_included) ? _vm._i(_vm.unit.spec_hot_water_included, null) > -1 : (_vm.unit.spec_hot_water_included)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.unit.spec_hot_water_included,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.unit, "spec_hot_water_included", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.unit, "spec_hot_water_included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.unit, "spec_hot_water_included", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.unit.spec_hot_water_included) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])])]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelUnitServiceAttributions[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.labelAddAttributionSection[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.bundleServiceIsLoading == false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoService),
      expression: "tempoService"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempoService = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.bundleServiceList), function(service) {
    return _c('option', {
      domProps: {
        "value": service
      }
    }, [_vm._v(_vm._s(service.reference_name))])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoAttribution),
      expression: "tempoAttribution"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tempoAttribution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempoAttribution = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addAttribution()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tableAttributionsAdd[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.tableAttributionsColumnTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableAttributionsColumnTitle02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableAttributionsColumnTitle03[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unit.service_attributions), function(attribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(attribution.reference_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(attribution.attribution))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAttribution(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelTitleSectionFixCosts[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "push-30"
  }, [_vm._v(_vm._s(_vm.labelFixCostExplanation[_vm.actualLanguage]))]), _vm._v(" "), (_vm.unit.fix_costs.length > 0) ? _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.fixCostColumn06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unit.fix_costs), function(cost, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.yearlyFlag),
        expression: "cost.yearlyFlag"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(cost.yearlyFlag) ? _vm._i(cost.yearlyFlag, null) > -1 : (cost.yearlyFlag)
      },
      on: {
        "change": function($event) {
          var $$a = cost.yearlyFlag,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(cost, "yearlyFlag", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(cost, "yearlyFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(cost, "yearlyFlag", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodStart),
        callback: function($$v) {
          _vm.$set(cost, "periodStart", $$v)
        },
        expression: "cost.periodStart"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [(cost.yearlyFlag == false) ? _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "yy-MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)]) : _c('div', {
      staticClass: "input-daterange form-group row"
    }, [_c('div', {
      staticClass: "input-date-time-picker"
    }, [_c('date-picker', {
      staticClass: "el-input__inner form-control",
      attrs: {
        "type": "date",
        "placeholder": "",
        "clear-icon": "",
        "format": "MM-dd",
        "value-format": "timestamp"
      },
      model: {
        value: (cost.periodEnd),
        callback: function($$v) {
          _vm.$set(cost, "periodEnd", $$v)
        },
        expression: "cost.periodEnd"
      }
    })], 1)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.description),
        expression: "cost.description"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12 col-sm-12 push"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cost.cost),
        expression: "cost.cost"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (cost.cost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cost, "cost", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Supprimer/Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFixCost(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-xs align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addFixCostLine()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddFixCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "block-title push"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, _vm._l((_vm.unit.options), function(category, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12 push"
    }, [_c('h5', {}, [_c('u', [_vm._v(_vm._s(category.categoryTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
      staticClass: "push-30"
    }, [_vm._v(_vm._s(category.categoryDescription[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((category.options), function(Option, index2) {
      return _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [(Option.valueType == 'bool') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h5', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('label', {
        staticClass: "css-input switch switch-success"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        domProps: {
          "checked": Array.isArray(Option.value) ? _vm._i(Option.value, null) > -1 : (Option.value)
        },
        on: {
          "change": function($event) {
            var $$a = Option.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(Option, "value", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(Option, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(Option, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span'), _vm._v(" "), (Option.value) ? _c('p', [_vm._v(_vm._s(_vm.labelActivated[_vm.actualLanguage]))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'stringNumber') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control align-center",
        attrs: {
          "type": "test",
          "placeholder": ""
        },
        domProps: {
          "value": (Option.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(Option, "value", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'compilationPeriodicity') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(Option, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.periodicityOptions), function(option) {
        return _c('option', {
          domProps: {
            "value": option.value
          }
        }, [_vm._v(_vm._s(option.displayText[_vm.actualLanguage]))])
      }), 0)])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'dayInMonthString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(Option, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.listDaysInMonth), function(day) {
        return _c('option', {
          domProps: {
            "value": day
          }
        }, [_vm._v(_vm._s(day))])
      }), 0)])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'compareLevelMessageList') ? _c('div', {
        staticClass: "col-xs-12 col-md-12 push"
      }, [_c('div', {
        staticClass: "col-xs-12 col-sm-9"
      }, [_c('h6', [_vm._v(_vm._s(Option.optionLabel[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 col-sm-3"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (Option.value),
          expression: "Option.value"
        }],
        staticClass: "form-control",
        attrs: {
          "size": "1"
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(Option, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.messageList), function(list) {
        return _c('option', {
          domProps: {
            "value": list.complement_id
          }
        }, [_vm._v(_vm._s(list.referenceName))])
      }), 0)])]) : _vm._e(), _vm._v(" "), (Option.valueType == 'listString') ? _c('div', {
        staticClass: "col-xs-12 col-md-12"
      }, [_vm._v("\r\n                                  " + _vm._s(Option) + "\r\n                                ")]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitModifications()
      }
    }
  }, [(_vm.unitIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveModifications[_vm.actualLanguage]))])], 1)])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('h6', [_vm._v("Attribution(%)")])])
}]}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flagDisplayBar) ? _c('div', [_c('h6', {
    staticClass: "text-black text-center",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText))]), _vm._v(" "), (_vm.buttonDisplayColor == 1) ? _c('div', [_c('div', {
    staticClass: "progress progress-mini"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisplayColor == 2) ? _c('div', [_c('div', {
    staticClass: "progress progress-mini"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-warning",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisplayColor == 3) ? _c('div', [_c('div', {
    staticClass: "progress progress-mini"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "block-title align-center"
  }, [_vm._v(_vm._s(_vm.sectionTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12"
  }, [(_vm.profileData.profile_subscription.data.creditCardBrand) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("Précédente date de renouvellement : " + _vm._s(_vm.profileData.profile_subscription.data.renewalLastDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v("Prochaine date de renouvellement : " + _vm._s(_vm.profileData.profile_subscription.data.renewalDate))]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profile_subscription.data.automaticRenewFlag),
      expression: "profileData.profile_subscription.data.automaticRenewFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.profileData.profile_subscription.data.automaticRenewFlag) ? _vm._i(_vm.profileData.profile_subscription.data.automaticRenewFlag, null) > -1 : (_vm.profileData.profile_subscription.data.automaticRenewFlag)
    },
    on: {
      "click": function($event) {
        return _vm.automaticRenewButtonSwitch()
      },
      "change": function($event) {
        var $$a = _vm.profileData.profile_subscription.data.automaticRenewFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profileData.profile_subscription.data, "automaticRenewFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profileData.profile_subscription.data, "automaticRenewFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profileData.profile_subscription.data, "automaticRenewFlag", $$c)
        }
      }
    }
  }), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "h5 font-w400"
  }, [_vm._v(_vm._s(_vm.buttonLabelAutomaticRenewal[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.renewFlagModified) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modifyMyAutomaticRenew()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelSaveModification[_vm.actualLanguage]))])])]) : _vm._e()]), _vm._v(" "), (_vm.profileData.profile_subscription.data.automaticRenewFlag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreditCard[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3 col-lg-3"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-2x"
  }), _vm._v(" "), _c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v(_vm._s(_vm.profileData.profile_subscription.data.creditCardBrand))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3 col-lg-3"
  }, [_c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v(_vm._s(_vm.textLabelCardLastDigit[_vm.actualLanguage]) + _vm._s(_vm.profileData.profile_subscription.data.creditCardLastDigit))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3 col-lg-3"
  }, [_c('span', {
    staticClass: "h4 font-w400"
  }, [_vm._v("Expire:" + _vm._s(_vm.profileData.profile_subscription.data.creditCardExpMonth) + "/" + _vm._s(_vm.profileData.profile_subscription.data.creditCardExpYear))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modifyMyCreditCard()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelModifyCard[_vm.actualLanguage]))])])])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.labelFreeService[_vm.actualLanguage]))])])])])])
},staticRenderFns: []}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "bg-primary-dark"
  }, [_c('section', {
    staticClass: "content content-full content-boxed"
  }, [_c('div', {
    staticClass: "push-10-t push-10 text-center"
  }, [_c('h1', {
    staticClass: "h2 text-white push-10",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "h3 text-white push-10",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle02[_vm.actualLanguage]) + " " + _vm._s(_vm.policyEndPoint))]), _vm._v(" "), _c('h2', {
    staticClass: "h5 text-white-op",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle03[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "h5 text-white-op",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle04[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "push-10-t push-10 text-center"
  }, [_c('h4', {
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopFilePreview[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("politicsPreview/" + (_vm.policyConditionUtilizationPreviewImg[_vm.actualLanguage])))
    },
    on: {
      "click": function($event) {
        return _vm.openUtilizationConditions()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("politicsPreview/" + (_vm.policyConfidentialPoliticsPreviewImg[_vm.actualLanguage])))
    },
    on: {
      "click": function($event) {
        return _vm.openConfidentialityPolitics()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-12"
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-lg css-checkbox-success align-center"
  }, [_c('div', {
    staticClass: "col-ms-6"
  }, [_c('h3', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptConditionFlag),
      expression: "acceptConditionFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptConditionFlag) ? _vm._i(_vm.acceptConditionFlag, null) > -1 : (_vm.acceptConditionFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptConditionFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptConditionFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptConditionFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptConditionFlag = $$c
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.labelConfirmCheckBox[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.acceptConditionFlag) ? _c('div', {
    staticClass: "col-ms-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', {
    staticClass: "h5 font-w600 text-uppercase push-10"
  }, [_vm._v(_vm._s(_vm.labelCookiesTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelConfirmCookiesConditions[_vm.actualLanguage]))]), _vm._v(" "), _c('label', {
    staticClass: "css-input css-checkbox css-checkbox-lg css-checkbox-success align-center"
  }, [_c('div', {
    staticClass: "col-ms-6"
  }, [_c('h3', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptCookieFlag),
      expression: "acceptCookieFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptCookieFlag) ? _vm._i(_vm.acceptCookieFlag, null) > -1 : (_vm.acceptCookieFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptCookieFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptCookieFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptCookieFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptCookieFlag = $$c
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.labelConfirmCookiesCheckBox[_vm.actualLanguage]))])])])])]) : _vm._e(), _vm._v(" "), (_vm.acceptCookieFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveMyAgreement()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAcceptCondition[_vm.actualLanguage]))])])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [(_vm.bundleSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplaySubBundle === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySubBundle) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplaySubBundle) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].ReferenceName),
      expression: "tempoBundle.sub_bundle[subBundleIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 push"
  }, [_c('p', [_vm._v(_vm._s(_vm.sectionTitleDisplayMA[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue),
      expression: "tempoBundle.sub_bundle[subBundleIndex].computeSumOfMovingAverageValue"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue) ? _vm._i(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue, null) > -1 : (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "computeSumOfMovingAverageValue", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "computeSumOfMovingAverageValue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "computeSumOfMovingAverageValue", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_Option[_vm.actualLanguage]) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group appliance-list-wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "100px",
      "src": _vm._f("s3Image")(("systems_icons/" + (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData.bundle_icon)))
    },
    on: {
      "click": function($event) {
        _vm.showSystemsList = !_vm.showSystemsList
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-big btn-primary btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showSystemsList = !_vm.showSystemsList
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.showSystemsList) ? _c('systems-list', {
    staticClass: "systems-list",
    on: {
      "onSelect": _vm.onSystemSelect
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.actualBundle.channelsAttributes.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.sectionLabelSubSystemTag[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].Attributes[index]),
        expression: "tempoBundle.sub_bundle[subBundleIndex].Attributes[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-select",
        "name": "example-select",
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].Attributes, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.bundleConfigViewFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelSectionSubSystemConfiguration[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelSubSystemName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData.bundle_name),
      expression: "tempoBundle.sub_bundle[subBundleIndex].subBundleData.bundle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData.bundle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData, "bundle_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.bundleConfigDeleteFlag) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "name": "buttonDeletePlanItem2"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveSubBundle()
      }
    }
  }, [(_vm.subBundleIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteSystem[_vm.actualLanguage]))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [(_vm.bundleConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSubBundleModifications()
      }
    }
  }, [(_vm.subBundleIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonSaveThisSubSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])])]) : _vm._e()])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('hr')])
}]}

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), (_vm.profileData.sharingInvitations.length == 0) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.messageNoMoreSharing[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.messageNoMoreSharing2[_vm.actualLanguage]))])]) : _c('div', [(_vm.defaultGroupSelectedFlag) ? _c('div', [(_vm.displayListSharingFlag) ? _c('div', _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Channel') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Car') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.displayListSharingFlag) ? _c('div', _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', [(invitation.InvitationStatus == 'Pending' & invitation.SharedEntityType == 'Device') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1) : _vm._e()])
  }), 0) : _vm._e()]) : _c('div', [(_vm.displayListSharingFlag) ? _c('div', _vm._l((_vm.profileData.sharingInvitations), function(invitation, index) {
    return _c('div', [(invitation.InvitationStatus == 'Pending') ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('sharing-item', {
      attrs: {
        "index": index
      }
    })], 1) : _vm._e()])
  }), 0) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.messageRequestIsSending) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', [(_vm.actualStatus === '01') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "contact-msg"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userMessage),
      expression: "userMessage"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contact-msg",
      "name": "contact-msg",
      "rows": "7",
      "placeholder": _vm.labelInFieldMessage[_vm.actualLanguage]
    },
    domProps: {
      "value": (_vm.userMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userMessage = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-sm-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.sendSupportRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonSendMessage[_vm.actualLanguage]))])])])]) : _vm._e()]), _vm._v(" "), (_vm.actualStatus === 'MessageTransmitOk') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "contact-msg"
    }
  }, [_vm._v(_vm._s(_vm.messageTransmitOk[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.actualStatus === 'MessageTransmitFail') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "contact-msg"
    }
  }, [_vm._v(_vm._s(_vm.messageTransmitFail[_vm.actualLanguage]))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.planTransactionData.transactionStatusCode == '000') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 push-50"
  }), _vm._v(" "), _c('h3', {
    staticClass: "h1 font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelMyProfile[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayProfile === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayProfile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayProfile) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayProfile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayProfile()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleProfileInfo[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayProfile) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h1', {
    staticClass: "page-heading"
  }, [_vm._v(_vm._s(_vm.profileData.profileInfo.email))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-narrow"
  }, [_c('form', {
    staticClass: "form-horizontal push-10-t",
    attrs: {
      "action": "base_forms_elements.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profileInfo.firstName),
      expression: "profileData.profileInfo.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Prénom/First Name"
    },
    domProps: {
      "value": (_vm.profileData.profileInfo.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.profileInfo, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "material-text"
    }
  }, [_vm._v(_vm._s(_vm.labelTitleProfileInfoFirstName[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profileInfo.lastName),
      expression: "profileData.profileInfo.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nom/Last Name"
    },
    domProps: {
      "value": (_vm.profileData.profileInfo.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.profileInfo, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "material-text"
    }
  }, [_vm._v(_vm._s(_vm.labelTitleProfileInfoLastName[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profileInfo.mobilePhoneNumber),
      expression: "profileData.profileInfo.mobilePhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Mobile"
    },
    domProps: {
      "value": (_vm.profileData.profileInfo.mobilePhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.profileInfo, "mobilePhoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "material-text"
    }
  }, [_vm._v(_vm._s(_vm.labelTitleProfileMobilePhone[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.profileData.licences.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profileInfo.transmitAlert.email),
      expression: "profileData.profileInfo.transmitAlert.email"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.profileData.profileInfo.transmitAlert.email) ? _vm._i(_vm.profileData.profileInfo.transmitAlert.email, null) > -1 : (_vm.profileData.profileInfo.transmitAlert.email)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profileData.profileInfo.transmitAlert.email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profileData.profileInfo.transmitAlert, "email", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profileData.profileInfo.transmitAlert, "email", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profileData.profileInfo.transmitAlert, "email", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelOptionAlertEnableEmail[_vm.actualLanguage]) + "\r\n                                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profileInfo.transmitAlert.SMS),
      expression: "profileData.profileInfo.transmitAlert.SMS"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.profileData.profileInfo.transmitAlert.SMS) ? _vm._i(_vm.profileData.profileInfo.transmitAlert.SMS, null) > -1 : (_vm.profileData.profileInfo.transmitAlert.SMS)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profileData.profileInfo.transmitAlert.SMS,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profileData.profileInfo.transmitAlert, "SMS", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profileData.profileInfo.transmitAlert, "SMS", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profileData.profileInfo.transmitAlert, "SMS", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelOptionAlertEnableSMS[_vm.actualLanguage]) + "\r\n                                          ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('h5', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.profileData.profileConfig.displayEvConfig.label[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.profileConfig.displayEvConfig.value),
      expression: "profileData.profileConfig.displayEvConfig.value"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.profileData.profileConfig.displayEvConfig.value) ? _vm._i(_vm.profileData.profileConfig.displayEvConfig.value, null) > -1 : (_vm.profileData.profileConfig.displayEvConfig.value)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profileData.profileConfig.displayEvConfig.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profileData.profileConfig.displayEvConfig, "value", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profileData.profileConfig.displayEvConfig, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profileData.profileConfig.displayEvConfig, "value", $$c)
        }
      }
    }
  }), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveMyProfile()
      }
    }
  }, [(_vm.profileIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelSaveMyProfileBtn[_vm.actualLanguage]))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h5', {
    staticClass: "font-w200 text-left"
  }, [_vm._v(_vm._s(_vm.labelMyProfileLicence[_vm.actualLanguage]))]), _vm._v(" "), (_vm.profileData.licences.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.labelOrganisation[_vm.actualLanguage]) + " : " + _vm._s(_vm.profileData.licences[0].licenceFromName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelLicenceType[_vm.actualLanguage]) + " : " + _vm._s(_vm.profileData.licences[0].licenceLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.releaseLicence()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabelReleaseLicence[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.labelNoLicence[_vm.actualLanguage]))])])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '000') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMyPlan === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMyPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMyPlan) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMyPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMyPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleServiceMyPlan[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMyPlan) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('my-plan-display')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modifyMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelModifyMyPlanBtn[_vm.actualLanguage]))])])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '000') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayMyPayment === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMyPayment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayMyPayment) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMyPayment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMyPayment()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleServiceMyPayment[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMyPayment) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('my-payment-info')], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '000') ? _c('div', {
    staticClass: "row"
  }, [_c('my-payment-history')], 1) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '000' & _vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', {
    staticClass: "row"
  }, [(_vm.profileData.managed_organizations.length > 0) ? _c('div', [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelOrganization[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "push-10"
  }, [_vm._v(_vm._s(_vm.organizationExplanation01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "push-10"
  }, [_vm._v(_vm._s(_vm.organizationExplanation02[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: " push-10"
  }, [_vm._v(_vm._s(_vm.organizationExplanation03[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.profileData.managed_organizations), function(organization, index) {
    return _c('div', [_c('organization-display', {
      attrs: {
        "organizationIndex": index
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button",
      "data-toggle": "popover",
      "title": this.massageOrganizationRequired[this.actualLanguage]
    },
    on: {
      "click": function($event) {
        return _vm.showModal('organization-add-form')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-industry fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateOrganization[_vm.actualLanguage]))])])])], 2) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '000') ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '050' || _vm.planTransactionData.transactionStatusCode === '060' || _vm.planTransactionData.transactionStatusCode === '100') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayPlan === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayPlan) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPlan()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleServicePlan[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayPlan) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.planTransactionData.transactionStatusCode === '050') ? _c('div', {
    staticClass: "row align-center push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h2', {
    staticClass: "page-heading push"
  }, [_vm._v(_vm._s(_vm.freePlanSectionTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.freePlanCodeLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freePlanCode),
      expression: "freePlanCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "freePlanCode",
      "name": "plaCode",
      "placeholder": "Code du plan/Plan code"
    },
    domProps: {
      "value": (_vm.freePlanCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freePlanCode = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.freePlanModuleIDLabel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freePlanDeviceId),
      expression: "freePlanDeviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "freePlanCode",
      "name": "module ID",
      "placeholder": "Code de validation / Validation code"
    },
    domProps: {
      "value": (_vm.freePlanDeviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freePlanDeviceId = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push-30"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyFreePlan()
      }
    }
  }, [(_vm.freePlanIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.labelFreePlanBtn[_vm.actualLanguage]))])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('user-plan-table')], 1)])]) : _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_vm._v("\r\n              " + _vm._s(_vm.labelRefreshMessage[_vm.actualLanguage]) + "\r\n              "), _c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.reloadPage()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelRefreshPageBtn[_vm.actualLanguage]))])])])])]), _vm._v(" "), (_vm.flagDisplayPlan) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '055' || _vm.planTransactionData.transactionStatusCode === '065' || _vm.planTransactionData.transactionStatusCode === '105') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayPlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleServicePlanOrganization[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('admin-plan-table')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.transactionStatusCode === '999') ? _c('div', {
    staticClass: "row"
  }, [(_vm.planTransactionData.postAction === 'NewSubscription') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelSubscriptionRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.postAction === 'NewAdminSubscription') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelAdminSubscriptionRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.planTransactionData.postAction === 'ModifyCreditCard') ? _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.labelNewCreditCardRecorded[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "h2 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.returnToMyServicePlan()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelReturnToMyProfileBtn[_vm.actualLanguage]))])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])])])
}]}

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateDeviceTemplate[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelTemplateId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateId),
      expression: "templateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant de gabarit / Template ID"
    },
    domProps: {
      "value": (_vm.templateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelDevicePicture[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devicePicture),
      expression: "devicePicture"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.devicePicture = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pictureList), function(picture) {
    return _c('option', {
      domProps: {
        "value": picture.fileName
      }
    }, [_vm._v(_vm._s(picture.pictureReferenceName))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "150px",
      "src": _vm._f("s3Image")(("organization_img/" + _vm.devicePicture))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelDeviceModel[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceModel),
      expression: "deviceModel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.deviceModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceModel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelDeviceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceName),
      expression: "deviceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.deviceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelDataTtlSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelDataTtlRaw[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataTTL.raw),
      expression: "dataTTL.raw"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.dataTTL.raw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataTTL, "raw", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelDataTtlHr[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataTTL.hr),
      expression: "dataTTL.hr"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.dataTTL.hr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataTTL, "hr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelDataTtlDay[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataTTL.day),
      expression: "dataTTL.day"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.dataTTL.day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataTTL, "day", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelSignalSet[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signalSetIndex),
      expression: "signalSetIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signalSetIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.applyNewSignalSet()
      }]
    }
  }, _vm._l((_vm.signalsSetTemplates), function(signalSet, indexSignalSet) {
    return _c('option', {
      domProps: {
        "value": indexSignalSet
      }
    }, [_vm._v(_vm._s(signalSet.signalSetId))])
  }), 0)])]), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleVariables[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableDataFormat[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.labelVariableDataType[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deviceSignals), function(signal, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.signalName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.signalLabel.FR))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.signalLabel.EN))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.dataFormat))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(signal.dataType))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.signalSetIndex >= 0) ? _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleControlParameter[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription02[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.controlParameters), function(parameter, index3) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.parameterName))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.parameterLabel.FR))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.parameterLabel.EN))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterDataType[_vm.actualLanguage]))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(parameter.dataType))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [(parameter.dataType === 'Bool') ? _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterValue[_vm.actualLanguage]) + " : On/Off")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValue),
        expression: "parameter.dataValue"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.dataValue) ? _vm._i(parameter.dataValue, null) > -1 : (parameter.dataValue)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.dataValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "dataValue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "dataValue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "dataValue", $$c)
          }
        }
      }
    }), _c('span')])])]) : _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterValue[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataValue),
        expression: "parameter.dataValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Value"
      },
      domProps: {
        "value": (parameter.dataValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "dataValue", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagVisibleByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagViewByCustomer),
        expression: "parameter.flagViewByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagViewByCustomer) ? _vm._i(parameter.flagViewByCustomer, null) > -1 : (parameter.flagViewByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagViewByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagViewByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagViewByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagViewByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagEditByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagEditByCustomer),
        expression: "parameter.flagEditByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagEditByCustomer) ? _vm._i(parameter.flagEditByCustomer, null) > -1 : (parameter.flagEditByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagEditByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagEditByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagEditByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagEditByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])])])])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.deviceSignals.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.labelChannelToCreate[_vm.actualLanguage]))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.labelChannelToCreate2[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelsToCreate),
      expression: "channelsToCreate"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "3",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelsToCreate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.compatibleChannelTemplateList), function(template) {
    return _c('option', {
      domProps: {
        "value": template.channelTemplateId
      }
    }, [_vm._v(_vm._s(template.channelName))])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.channelsToCreate.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectApiKey[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApiKey),
      expression: "selectedApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApiKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.overlayParameters.organizationApiKeys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.key
      }
    }, [_vm._v(_vm._s(key.referenceName) + " : " + _vm._s(key.key))])
  }), 0)]), _vm._v(" "), (_vm.selectedApiKey.length > 0) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDeviceTemplate()
      }
    }
  }, [(_vm.templateIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [(_vm.invitation.SharedEntityType == 'Channel') ? _c('h3', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x"
  }), _vm._v(" " + _vm._s(_vm.titleSharingChannel[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Device') ? _c('h3', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x"
  }), _vm._v(" " + _vm._s(_vm.titleSharingDevice[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Bundle') ? _c('h3', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x"
  }), _vm._v(" " + _vm._s(_vm.titleSharingBundle[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Group') ? _c('h3', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x"
  }), _vm._v(" " + _vm._s(_vm.titleSharingGroup[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3 align-center"
  }, [(_vm.invitation.SharedEntityType == 'Channel') ? _c('i', {
    staticClass: "fa fa-television fa-3x"
  }) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Device') ? _c('i', {
    staticClass: "fa fa-server fa-3x"
  }) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Bundle') ? _c('i', {
    staticClass: "fa fa-usb fa-3x"
  }) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Group') ? _c('i', {
    staticClass: "fa fa-group fa-3x"
  }) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Car') ? _c('i', {
    staticClass: "fa fa-car fa-3x"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('h4', {
    staticClass: "block-title"
  }, [_vm._v("Invitation de : " + _vm._s(_vm.invitation.HostEmail))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.invitation.SharingInfo.referenceName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.invitation.SharingInfo.sharingMessage))]), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Bundle') ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [(_vm.actualBundle.bundle_id == '!!NONE!!') ? _c('p', [_vm._v(_vm._s(_vm.messageBundleReceptionRacine[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_id != '!!NONE!!') ? _c('p', [_vm._v(_vm._s(_vm.messageBundleReception[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_id != '!!NONE!!') ? _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagSaveBundleAtSameLevel),
      expression: "flagSaveBundleAtSameLevel"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagSaveBundleAtSameLevel) ? _vm._i(_vm.flagSaveBundleAtSameLevel, null) > -1 : (_vm.flagSaveBundleAtSameLevel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagSaveBundleAtSameLevel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagSaveBundleAtSameLevel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagSaveBundleAtSameLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagSaveBundleAtSameLevel = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelCheckBoxBundle[_vm.actualLanguage]) + "\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Group') ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [(_vm.actualGroup.group_id == '!!NONE!!') ? _c('p', [_vm._v(_vm._s(_vm.messageGroupReceptionRacine[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.actualGroup.group_id != '!!NONE!!') ? _c('p', [_vm._v(_vm._s(_vm.messageGroupReception[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flagSaveGroupAtFirstLevel),
      expression: "flagSaveGroupAtFirstLevel"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.flagSaveGroupAtFirstLevel) ? _vm._i(_vm.flagSaveGroupAtFirstLevel, null) > -1 : (_vm.flagSaveGroupAtFirstLevel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flagSaveGroupAtFirstLevel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flagSaveGroupAtFirstLevel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flagSaveGroupAtFirstLevel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flagSaveGroupAtFirstLevel = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelCheckBoxGroup[_vm.actualLanguage]) + "\n                        ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 align-center push"
  }, [(_vm.invitation.SharedEntityType == 'Group') ? _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [(_vm.defaultGroupSelectedFlag & _vm.flagSaveGroupAtFirstLevel == false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.mustSelectGroupNotDefaultGroup[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success push",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Accept"
    },
    on: {
      "click": function($event) {
        return _vm.acceptSharing(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.labelButtonAccept[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Bundle') ? _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [(_vm.defaultGroupSelectedFlag) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.mustSelectGroupNotDefaultBundle[_vm.actualLanguage]))])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success push",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Accept"
    },
    on: {
      "click": function($event) {
        return _vm.acceptSharing(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.labelButtonAccept[_vm.actualLanguage]))])])]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Device') ? _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success push",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Accept"
    },
    on: {
      "click": function($event) {
        return _vm.acceptSharing(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.labelButtonAccept[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Channel') ? _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success push",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Accept"
    },
    on: {
      "click": function($event) {
        return _vm.acceptSharing(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.labelButtonAccept[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.invitation.SharedEntityType == 'Car') ? _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-success push",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Accept"
    },
    on: {
      "click": function($event) {
        return _vm.acceptSharing(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.labelButtonAccept[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-danger push",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Reject"
    },
    on: {
      "click": function($event) {
        return _vm.rejectSharing(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" " + _vm._s(_vm.labelButtonReject[_vm.actualLanguage]))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sharingBottomMessage[_vm.actualLanguage]))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flagDisplayBar) ? _c('div', [_c('h6', {
    staticClass: "text-gray",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.barData.Label))]), _vm._v(" "), (_vm.buttonDisplayColor == 1) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisplayColor == 2) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-warning",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisplayColor == 3) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText) + " ")])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('h2', {
    staticClass: "font-w300 push-10"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldTitleAddGroup[_vm.actualLanguage]))]), _vm._v(" "), _c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.profileData.profileInfo.email))])]), _vm._v(" "), _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldGroupName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupInfo.groupName),
      expression: "groupInfo.groupName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.groupInfo.groupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.groupInfo, "groupName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.groupInfo.groupName) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-rounded btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.createGroup
    }
  }, [_vm._v(_vm._s(_vm.labelButtonConfirmed[_vm.actualLanguage]))])])])]) : _vm._e(), _vm._v(" "), (_vm.displayMessage) ? _c('div', {
    staticClass: "presets-container form-group row text-center"
  }, [_c('h3', {
    staticClass: "font-w300 push-8"
  }, [_c('i', {
    staticClass: "fa fa-check fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.textDisplayMessage[_vm.actualLanguage]))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [(_vm.mainService.service_invoices.length > 0) ? _c('div', {
    staticClass: "table-responsive push"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.invoiceColumn01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.invoiceColumn02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.invoiceColumn03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.invoiceColumn04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.invoiceColumn05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.invoiceColumn06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mainService.service_invoices), function(invoice, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v("\r\n                          " + _vm._s(invoice.referenceNumber) + "\r\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v("\r\n                            " + _vm._s(invoice.dateStartStr) + "               \r\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v("\r\n                            " + _vm._s(invoice.dateEndStr) + "              \r\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v("\r\n                            " + _vm._s(invoice.amount) + "\r\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v("\r\n                            " + _vm._s(invoice.tax) + "\r\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v("\r\n                            " + _vm._s(invoice.total) + "\r\n                        ")])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), (_vm.flagAddInvoice) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelAddInvoiceTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelReference[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoInvoiceReferenceNumber),
      expression: "tempoInvoiceReferenceNumber"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tempoInvoiceReferenceNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempoInvoiceReferenceNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelDateStart[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.tempoInvoiceDateStart),
      callback: function($$v) {
        _vm.tempoInvoiceDateStart = $$v
      },
      expression: "tempoInvoiceDateStart"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelDateEnd[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.tempoInvoiceDateEnd),
      callback: function($$v) {
        _vm.tempoInvoiceDateEnd = $$v
      },
      expression: "tempoInvoiceDateEnd"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelAmount[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoAmount),
      expression: "tempoAmount"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tempoAmount)
    },
    on: {
      "click": function($event) {
        return _vm.computeAmountTotal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempoAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelTax[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoTax),
      expression: "tempoTax"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.tempoTax)
    },
    on: {
      "click": function($event) {
        return _vm.computeAmountTotal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempoTax = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelTotal[_vm.actualLanguage]))]), _vm._v("\r\n                  " + _vm._s(_vm.tempoAmountWithTax) + "\r\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default align-right push",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.addInvoiceStep01()
      }
    }
  }, [(_vm.invoiceIsSaving01) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveInvoice[_vm.actualLanguage]))])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default align-left",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAddInvoice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonCancel[_vm.actualLanguage]))])])])])])])]) : _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('button', {
    staticClass: "btn btn-default align-right",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAddInvoice()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonAddInvoice[_vm.actualLanguage]))])])])
},staticRenderFns: []}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.channelIndex + 1) + ":" + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ReferenceName))]), _vm._v(" "), (_vm.flagDisplayPowerBar && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable && _vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarData5Min
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_001H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_004H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_006H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_012H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_024H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_072H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_168H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_336H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_720H
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.actualBundle.channels[_vm.channelIndex].Attributes), function(attribute, index) {
    return _c('div', [(_vm.actualBundle.channels[_vm.channelIndex].Attributes[index] != 'ND') ? _c('div', {
      staticClass: "col-xm-6 col-sm-4 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-tag fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.actualBundle.channels[_vm.channelIndex].Attributes[index]))])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagChannelDataIsLoading) ? _c('spinner') : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [(true) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h3', {
    staticClass: "font-w300 push measurement-graph-row__title"
  }, [_c('img', {
    staticClass: "measurement-graph-row__icon",
    attrs: {
      "width": "80px",
      "src": _vm._f("s3Image")(("appliances/" + (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile))),
      "alt": ""
    }
  }), _vm._v("\n                              " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "form-group align-right"
  }, [_c('label', [_vm._v("Online")]), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.deviceOnline) ? _c('i', {
    staticClass: "fa fa-toggle-on fa-2x"
  }) : _c('i', {
    staticClass: "fa fa-toggle-off fa-2x"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group align-right"
  }, [(_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.loadCloudLive()
      }
    }
  }, [(_vm.flagCloudLiveIsActivating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('i', {
    staticClass: "fa fa-cloud-download fa-1x push-15-r "
  }), _vm._v("Cloud Live")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                  " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description) + "\n                                ")])]), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelAddress[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                  " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.address) + "\n                                ")])]) : _vm._e()]), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false && _vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": 8,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "label": marker.label,
        "draggable": false
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "row measurement-graph-row push"
  }, [(_vm.flagDisplayChannelJournal) ? _c('div', {
    staticClass: "row"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('multiple-graph', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('channel-journal', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelHideJournal[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('multiple-graph', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelShowJournal[_vm.actualLanguage]))])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  })]) : _vm._e()])])])], 1) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySectionApi === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayApi()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySectionApi) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayApi()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayApi()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelApiManagement[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionApi) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDocument()
      }
    }
  }, [_vm._v(_vm._s(_vm.DocumentTableTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayDocument) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.DocumentTableContain), function(Document) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Document.Document[_vm.actualLanguage]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Document.Detail[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Ouvrir/Open"
      },
      on: {
        "click": function($event) {
          return _vm.openDocumentInTable(Document.FileLink[_vm.actualLanguage])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    })])])])])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStepSectionTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep01p1[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep02[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep03[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep04[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep05[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMasterApiKey()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateApiMasterKey[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMasterApiKey) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.sectionTextCreateApiMasterKey[_vm.actualLanguage]))]), _vm._v(" "), (_vm.createNewApiMasterKey === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateNewMasterKey()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateApiMasterKey[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateMasterApiKey[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelApiKeyReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceName),
      expression: "referenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Reference"
    },
    domProps: {
      "value": (_vm.referenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxMaxCost[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumMonthlyCost),
      expression: "maximumMonthlyCost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.maximumMonthlyCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumMonthlyCost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-danger align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCreateNewMasterKey()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCancelCreateApiMasterKey[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createConfirmNewMasterKey()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelConfirmCreateApiMasterKey[_vm.actualLanguage]))])])])])])]), _vm._v(" "), (_vm.displayMasterAPIKeysListFlag) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.labelMasterKeyList[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.organizationApiKey), function(apiKey, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleDisplayApiKey(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])]), _vm._v(" "), (_vm.organizationApiKeyIsLoagingFlag[index]) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('h6', {
      on: {
        "click": function($event) {
          return _vm.toggleDisplayApiKey(index)
        }
      }
    }, [_vm._v(_vm._s(apiKey.referenceName) + "  :  " + _vm._s(apiKey.key))])], 1), _vm._v(" "), (_vm.organizationApiKeyOpenFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v("Date Émission/Emission date : " + _vm._s(_vm.organizationApiKeyData[index].emissionDate))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v("Statut/Status : " + _vm._s(_vm.organizationApiKeyData[index].status))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTextBoxMaxCost[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.organizationApiKeyData[index].keyInfo.maximumMonthlyCost),
        expression: "organizationApiKeyData[index].keyInfo.maximumMonthlyCost"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Adresse / Address..."
      },
      domProps: {
        "value": (_vm.organizationApiKeyData[index].keyInfo.maximumMonthlyCost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.organizationApiKeyData[index].keyInfo, "maximumMonthlyCost", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.modifyMasterKey()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Enregistrer modifications / Save modifications")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-danger align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNewMasterKey()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Supprimer la clef / Delete this key")])])]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-12 push"
    }, [_c('h3', {
      staticClass: "font-w300"
    }, [_vm._v(_vm._s(_vm.labelMasterKeyDeviceList[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.organizationApiKeyCreateDeviceFlag[index]) ? _c('div', {
      staticClass: "col-sm-12 col-md-12"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelCreateDeviceSerialNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newDeviceSerialNumber),
        expression: "newDeviceSerialNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Numero série / Sérial number"
      },
      domProps: {
        "value": (_vm.newDeviceSerialNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newDeviceSerialNumber = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6 push"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelCreateDeviceTemplateToUse[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newDeviceTemplateToUse),
        expression: "newDeviceTemplateToUse"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.newDeviceTemplateToUse = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.deviceTemplates), function(Template) {
      return _c('option', {
        domProps: {
          "value": Template.deviceTemplateId
        }
      }, [_vm._v(_vm._s(Template.deviceTemplateId))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.confirmCreateDevice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Créer l'appareil / Create device")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-danger align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.cancelCreateDevice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Annuler / Cancel")])])])])]) : _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.createDevice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Créer un appareil / Create device")])])]), _vm._v(" "), (_vm.lastCreatedDevice.deviceId.length > 0) ? _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('h4', {
      staticClass: "font-w300 push"
    }, [_vm._v("Appareil créé / Created device")]), _vm._v(" "), _c('h5', {
      staticClass: "font-w300"
    }, [_vm._v("Device ID: " + _vm._s(_vm.lastCreatedDevice.deviceId))]), _vm._v(" "), _c('h5', {
      staticClass: "font-w300"
    }, [_vm._v("Binding key: " + _vm._s(_vm.lastCreatedDevice.deviceBindingKey))]), _vm._v(" "), _c('h5', {
      staticClass: "font-w300"
    }, [_vm._v("API key: " + _vm._s(_vm.lastCreatedDevice.deviceApiKey))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('h4', [_vm._v(_vm._s(_vm.labelDeviceKeyList[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-striped table-vcenter"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((_vm.organizationApiKeySubKeyData[index]), function(SubKeyDetail, index) {
      return _c('tr', [_c('td', {
        staticClass: "font-w600"
      }, [_vm._v(_vm._s(SubKeyDetail.linkedEntity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.info.bindingKey))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.keyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.info.deviceSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.info.linkedProfile))])])
    }), 0)])])])])]) : _vm._e()])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySignalsSet()
      }
    }
  }, [_vm._v(_vm._s(_vm.SignalSetSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionSignalsSet) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createSignalsSet()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSignalsSetCreate[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSignalsSetID[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSgnalsSetEdit[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.signalsSetTemplates), function(Template, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Template.signalSetId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editSignalSetTemplate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })])])])])
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelTemplate()
      }
    }
  }, [_vm._v(_vm._s(_vm.ChannelTemplateSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionChannelTemplate) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createChannelTemplate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonChannelTemplateCreate[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewPicture('channel')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveNewPictureChannel[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateID[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateEdit[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.channelTemplates), function(Template, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Template.channelTemplateId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.channelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.channelType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editChannelTemplate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })])])])])
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDeviceTemplate()
      }
    }
  }, [_vm._v(_vm._s(_vm.DeviceTemplateSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionDeviceTemplate) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createDeviceTemplate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDeviceTemplateCreate[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewPicture('device')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveNewPictureDevice[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateID[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateEdit[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deviceTemplates), function(Template, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Template.deviceTemplateId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.deviceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.deviceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editDeviceTemplate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })])])])])
  }), 0)])])])]) : _vm._e()])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Document")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Device ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Binding Key")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("API key")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Serial Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Binded to")])])])
}]}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5Min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" " + _vm._s(_vm.labelButtonObserve[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPresets(14400, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton4Hour[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPresets(43200, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton12Hour[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPresets(1, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonToday[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPresets(4, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton3Days[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPresets(8, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton7Days[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPresets(29, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButton4Weeks[_vm.actualLanguage]))])])])])])
},staticRenderFns: []}

/***/ })
],[1064]);


// WEBPACK FOOTER //
// static/js/app.3da4118880d01be79157.js